
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8661"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8661"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("0qVX1", function(module, exports) {

$parcel$export(module.exports, "fT", () => qg);
$parcel$export(module.exports, "gv", () => _d);
$parcel$export(module.exports, "b", () => C);
$parcel$export(module.exports, "X", () => Pe);
$parcel$export(module.exports, "d", () => $t);
$parcel$export(module.exports, "P", () => Hl);
$parcel$export(module.exports, "k", () => X);
$parcel$export(module.exports, "j", () => XC);
$parcel$export(module.exports, "a6", () => Se);
$parcel$export(module.exports, "F", () => vr);
$parcel$export(module.exports, "cC", () => kn);
$parcel$export(module.exports, "w", () => is);
$parcel$export(module.exports, "e$", () => Ci);
$parcel$export(module.exports, "g5", () => BC);
$parcel$export(module.exports, "as", () => F);
$parcel$export(module.exports, "g1", () => ab);
$parcel$export(module.exports, "fb", () => Ul);
$parcel$export(module.exports, "fc", () => vi);
$parcel$export(module.exports, "fd", () => Si);
$parcel$export(module.exports, "fi", () => Sr);
$parcel$export(module.exports, "A", () => qd);
$parcel$export(module.exports, "fj", () => th);
$parcel$export(module.exports, "fk", () => eh);
$parcel$export(module.exports, "fl", () => Yl);
$parcel$export(module.exports, "fm", () => Ql);
$parcel$export(module.exports, "fn", () => ki);
$parcel$export(module.exports, "fo", () => Ti);
$parcel$export(module.exports, "fp", () => Ni);
$parcel$export(module.exports, "fr", () => Ri);
$parcel$export(module.exports, "fq", () => $i);
$parcel$export(module.exports, "fs", () => Jl);
$parcel$export(module.exports, "fv", () => nh);
$parcel$export(module.exports, "ft", () => jl);
$parcel$export(module.exports, "fu", () => sh);
$parcel$export(module.exports, "fw", () => ql);
$parcel$export(module.exports, "fx", () => tc);
$parcel$export(module.exports, "fy", () => oh);
$parcel$export(module.exports, "B", () => rh);
$parcel$export(module.exports, "fz", () => JC);
$parcel$export(module.exports, "i", () => cb);
$parcel$export(module.exports, "fB", () => Gi);
$parcel$export(module.exports, "fC", () => Ei);
$parcel$export(module.exports, "fD", () => Li);
$parcel$export(module.exports, "fE", () => ih);
$parcel$export(module.exports, "fF", () => ec);
$parcel$export(module.exports, "fG", () => nc);
$parcel$export(module.exports, "fH", () => sc);
$parcel$export(module.exports, "fI", () => ah);
$parcel$export(module.exports, "fJ", () => oc);
$parcel$export(module.exports, "fK", () => rc);
$parcel$export(module.exports, "fL", () => lh);
$parcel$export(module.exports, "fM", () => ch);
$parcel$export(module.exports, "fN", () => Mi);
$parcel$export(module.exports, "fO", () => Wi);
$parcel$export(module.exports, "fQ", () => uh);
$parcel$export(module.exports, "fR", () => ic);
$parcel$export(module.exports, "fP", () => dh);
$parcel$export(module.exports, "fU", () => hh);
$parcel$export(module.exports, "fV", () => ph);
$parcel$export(module.exports, "fW", () => ac);
$parcel$export(module.exports, "fX", () => fh);
$parcel$export(module.exports, "fY", () => mh);
$parcel$export(module.exports, "D", () => ub);
$parcel$export(module.exports, "fZ", () => lc);
$parcel$export(module.exports, "f$", () => ad);
$parcel$export(module.exports, "f_", () => ld);
$parcel$export(module.exports, "g0", () => gh);
$parcel$export(module.exports, "hh", () => Di);
$parcel$export(module.exports, "g2", () => bh);
$parcel$export(module.exports, "g3", () => Fi);
$parcel$export(module.exports, "g4", () => xh);
$parcel$export(module.exports, "g7", () => Vi);
$parcel$export(module.exports, "g6", () => cc);
$parcel$export(module.exports, "g8", () => zi);
$parcel$export(module.exports, "g9", () => uc);
$parcel$export(module.exports, "ga", () => Pi);
$parcel$export(module.exports, "gb", () => yh);
$parcel$export(module.exports, "gc", () => wh);
$parcel$export(module.exports, "gd", () => Ih);
$parcel$export(module.exports, "ge", () => Ai);
$parcel$export(module.exports, "gf", () => Oi);
$parcel$export(module.exports, "gh", () => dc);
$parcel$export(module.exports, "gk", () => hc);
$parcel$export(module.exports, "a5", () => db);
$parcel$export(module.exports, "gl", () => pc);
$parcel$export(module.exports, "gm", () => Xi);
$parcel$export(module.exports, "gp", () => Ki);
$parcel$export(module.exports, "go", () => Ch);
$parcel$export(module.exports, "gq", () => vh);
$parcel$export(module.exports, "gs", () => Zi);
$parcel$export(module.exports, "gt", () => Bi);
$parcel$export(module.exports, "gu", () => Hi);
$parcel$export(module.exports, "gz", () => fc);
$parcel$export(module.exports, "gA", () => mc);
$parcel$export(module.exports, "gB", () => gc);
$parcel$export(module.exports, "L", () => hb);
$parcel$export(module.exports, "gC", () => _i);
$parcel$export(module.exports, "gD", () => Ui);
$parcel$export(module.exports, "gF", () => bc);
$parcel$export(module.exports, "gG", () => xc);
$parcel$export(module.exports, "gH", () => yc);
$parcel$export(module.exports, "gI", () => XY);
$parcel$export(module.exports, "gE", () => jC);
$parcel$export(module.exports, "gJ", () => KY);
$parcel$export(module.exports, "gw", () => wc);
$parcel$export(module.exports, "gx", () => Sh);
$parcel$export(module.exports, "gM", () => ZY);
$parcel$export(module.exports, "gN", () => Ic);
$parcel$export(module.exports, "gS", () => Yi);
$parcel$export(module.exports, "gO", () => Cc);
$parcel$export(module.exports, "gR", () => kh);
$parcel$export(module.exports, "gP", () => vc);
$parcel$export(module.exports, "gQ", () => Th);
$parcel$export(module.exports, "M", () => pb);
$parcel$export(module.exports, "gT", () => Sc);
$parcel$export(module.exports, "gU", () => kc);
$parcel$export(module.exports, "gV", () => Qi);
$parcel$export(module.exports, "gW", () => Tc);
$parcel$export(module.exports, "gX", () => Ji);
$parcel$export(module.exports, "p", () => fb);
$parcel$export(module.exports, "gZ", () => ji);
$parcel$export(module.exports, "g_", () => Nc);
$parcel$export(module.exports, "h2", () => Rc);
$parcel$export(module.exports, "g$", () => Nh);
$parcel$export(module.exports, "h0", () => Rh);
$parcel$export(module.exports, "h1", () => $h);
$parcel$export(module.exports, "h4", () => $c);
$parcel$export(module.exports, "h3", () => Gc);
$parcel$export(module.exports, "h7", () => Ec);
$parcel$export(module.exports, "h8", () => Lc);
$parcel$export(module.exports, "h9", () => BY);
$parcel$export(module.exports, "ha", () => qi);
$parcel$export(module.exports, "hb", () => Mc);
$parcel$export(module.exports, "hc", () => Wc);
$parcel$export(module.exports, "R", () => mb);
$parcel$export(module.exports, "u", () => gb);
$parcel$export(module.exports, "v", () => bb);
$parcel$export(module.exports, "he", () => Gh);
$parcel$export(module.exports, "hg", () => Eh);
$parcel$export(module.exports, "hi", () => ta);
$parcel$export(module.exports, "hk", () => ea);
$parcel$export(module.exports, "hm", () => Dc);
$parcel$export(module.exports, "hp", () => Fc);
$parcel$export(module.exports, "hq", () => Lh);
$parcel$export(module.exports, "hn", () => Vc);
$parcel$export(module.exports, "ho", () => Mh);
$parcel$export(module.exports, "hl", () => na);
$parcel$export(module.exports, "hr", () => zc);
$parcel$export(module.exports, "ht", () => sa);
$parcel$export(module.exports, "hu", () => oa);
$parcel$export(module.exports, "a3", () => xb);
$parcel$export(module.exports, "V", () => yb);
$parcel$export(module.exports, "S", () => wb);
$parcel$export(module.exports, "hw", () => Pc);
$parcel$export(module.exports, "hx", () => ra);
$parcel$export(module.exports, "hC", () => Ac);
$parcel$export(module.exports, "hA", () => ia);
$parcel$export(module.exports, "hB", () => aa);
$parcel$export(module.exports, "hz", () => la);
$parcel$export(module.exports, "hy", () => ca);
$parcel$export(module.exports, "hE", () => ua);
$parcel$export(module.exports, "hL", () => da);
$parcel$export(module.exports, "hV", () => Oc);
$parcel$export(module.exports, "hF", () => Xc);
$parcel$export(module.exports, "hK", () => Kc);
$parcel$export(module.exports, "hD", () => Zc);
$parcel$export(module.exports, "hG", () => Wh);
$parcel$export(module.exports, "hH", () => Dh);
$parcel$export(module.exports, "hI", () => Fh);
$parcel$export(module.exports, "hJ", () => Vh);
$parcel$export(module.exports, "a4", () => Ib);
$parcel$export(module.exports, "hN", () => ha);
$parcel$export(module.exports, "hM", () => zh);
$parcel$export(module.exports, "hO", () => Bc);
$parcel$export(module.exports, "hQ", () => Ph);
$parcel$export(module.exports, "hR", () => Ah);
$parcel$export(module.exports, "hS", () => Oh);
$parcel$export(module.exports, "hT", () => Xh);
$parcel$export(module.exports, "hU", () => pa);
$parcel$export(module.exports, "hX", () => fa);
$parcel$export(module.exports, "hY", () => ma);
$parcel$export(module.exports, "hZ", () => ga);
$parcel$export(module.exports, "h_", () => Kh);
$parcel$export(module.exports, "h$", () => Zh);
$parcel$export(module.exports, "i0", () => ar);
$parcel$export(module.exports, "i1", () => Bh);
$parcel$export(module.exports, "i2", () => Hc);
$parcel$export(module.exports, "i3", () => _c);
$parcel$export(module.exports, "i4", () => HY);
$parcel$export(module.exports, "i6", () => Uc);
$parcel$export(module.exports, "hP", () => ba);
$parcel$export(module.exports, "gg", () => cd);
$parcel$export(module.exports, "hs", () => Hh);
$parcel$export(module.exports, "i7", () => ml);
$parcel$export(module.exports, "gi", () => gl);
$parcel$export(module.exports, "ah", () => Cb);
$parcel$export(module.exports, "is", () => bl);
$parcel$export(module.exports, "ir", () => dm);
$parcel$export(module.exports, "it", () => ud);
$parcel$export(module.exports, "iE", () => sn);
$parcel$export(module.exports, "iD", () => t2);
$parcel$export(module.exports, "iS", () => _Y);
$parcel$export(module.exports, "iR", () => UY);
$parcel$export(module.exports, "ic", () => YY);
$parcel$export(module.exports, "G", () => ms);
$parcel$export(module.exports, "z", () => Ks);
$parcel$export(module.exports, "f5", () => u2);
$parcel$export(module.exports, "x", () => qe);
$parcel$export(module.exports, "iU", () => QY);
$parcel$export(module.exports, "O", () => ve);
$parcel$export(module.exports, "T", () => Mt);
$parcel$export(module.exports, "i5", () => yl);
$parcel$export(module.exports, "hf", () => ym);
$parcel$export(module.exports, "iT", () => tn);
$parcel$export(module.exports, "iN", () => Yh);
$parcel$export(module.exports, "ae", () => se);
$parcel$export(module.exports, "_", () => I2);
$parcel$export(module.exports, "iO", () => JY);
$parcel$export(module.exports, "E", () => $);
$parcel$export(module.exports, "ie", () => jY);
$parcel$export(module.exports, "y", () => ya);
$parcel$export(module.exports, "c", () => T);
$parcel$export(module.exports, "n", () => jh);
$parcel$export(module.exports, "cF", () => N2);
$parcel$export(module.exports, "o", () => L);
$parcel$export(module.exports, "d1", () => vo);
$parcel$export(module.exports, "Q", () => wa);
$parcel$export(module.exports, "a7", () => $e);
$parcel$export(module.exports, "at", () => Cs);
$parcel$export(module.exports, "ij", () => qY);
$parcel$export(module.exports, "ii", () => tQ);
$parcel$export(module.exports, "ig", () => eQ);
$parcel$export(module.exports, "id", () => nQ);
$parcel$export(module.exports, "ih", () => sQ);
$parcel$export(module.exports, "ik", () => Ot);
$parcel$export(module.exports, "iy", () => wl);
$parcel$export(module.exports, "iA", () => oQ);
$parcel$export(module.exports, "e_", () => D);
$parcel$export(module.exports, "f0", () => xt);
$parcel$export(module.exports, "eZ", () => hn);
$parcel$export(module.exports, "iP", () => rQ);
$parcel$export(module.exports, "iI", () => iQ);
$parcel$export(module.exports, "iB", () => aQ);
$parcel$export(module.exports, "iq", () => G2);
$parcel$export(module.exports, "iF", () => lQ);
$parcel$export(module.exports, "il", () => cQ);
$parcel$export(module.exports, "im", () => uQ);
$parcel$export(module.exports, "iC", () => Pb);
$parcel$export(module.exports, "i8", () => ps);
$parcel$export(module.exports, "iJ", () => dQ);
$parcel$export(module.exports, "aB", () => Cm);
$parcel$export(module.exports, "az", () => Ab);
$parcel$export(module.exports, "aA", () => hQ);
$parcel$export(module.exports, "ax", () => F2);
$parcel$export(module.exports, "ar", () => pQ);
$parcel$export(module.exports, "au", () => V2);
$parcel$export(module.exports, "aD", () => z2);
$parcel$export(module.exports, "aq", () => P2);
$parcel$export(module.exports, "av", () => tp);
$parcel$export(module.exports, "aF", () => km);
$parcel$export(module.exports, "ap", () => ee);
$parcel$export(module.exports, "aM", () => fQ);
$parcel$export(module.exports, "aL", () => mQ);
$parcel$export(module.exports, "aE", () => Z2);
$parcel$export(module.exports, "aC", () => B2);
$parcel$export(module.exports, "aI", () => gQ);
$parcel$export(module.exports, "aN", () => bQ);
$parcel$export(module.exports, "ay", () => xQ);
$parcel$export(module.exports, "aK", () => yQ);
$parcel$export(module.exports, "I", () => vt);
$parcel$export(module.exports, "aQ", () => tt);
$parcel$export(module.exports, "cD", () => yo);
$parcel$export(module.exports, "ed", () => lv);
$parcel$export(module.exports, "f", () => U);
$parcel$export(module.exports, "dA", () => Yb);
$parcel$export(module.exports, "a1", () => ut);
$parcel$export(module.exports, "g", () => G);
$parcel$export(module.exports, "cG", () => me);
$parcel$export(module.exports, "cH", () => gv);
$parcel$export(module.exports, "cI", () => xv);
$parcel$export(module.exports, "cJ", () => Qb);
$parcel$export(module.exports, "cK", () => Id);
$parcel$export(module.exports, "cL", () => ai);
$parcel$export(module.exports, "cM", () => vv);
$parcel$export(module.exports, "cN", () => kv);
$parcel$export(module.exports, "cO", () => Nv);
$parcel$export(module.exports, "cP", () => $v);
$parcel$export(module.exports, "cQ", () => Ev);
$parcel$export(module.exports, "cR", () => Mv);
$parcel$export(module.exports, "ad", () => Te);
$parcel$export(module.exports, "ai", () => No);
$parcel$export(module.exports, "ab", () => Le);
$parcel$export(module.exports, "ac", () => Ue);
$parcel$export(module.exports, "r", () => W);
$parcel$export(module.exports, "cS", () => np);
$parcel$export(module.exports, "cT", () => Ov);
$parcel$export(module.exports, "e", () => Ge);
$parcel$export(module.exports, "m", () => Gt);
$parcel$export(module.exports, "h", () => kr);
$parcel$export(module.exports, "s", () => Ft);
$parcel$export(module.exports, "t", () => sp);
$parcel$export(module.exports, "cY", () => op);
$parcel$export(module.exports, "cU", () => Qc);
$parcel$export(module.exports, "cV", () => Jv);
$parcel$export(module.exports, "cW", () => qv);
$parcel$export(module.exports, "cX", () => eS);
$parcel$export(module.exports, "cZ", () => sS);
$parcel$export(module.exports, "c_", () => ni);
$parcel$export(module.exports, "c$", () => iS);
$parcel$export(module.exports, "dy", () => Ca);
$parcel$export(module.exports, "d0", () => fn);
$parcel$export(module.exports, "d2", () => cS);
$parcel$export(module.exports, "d3", () => dS);
$parcel$export(module.exports, "d4", () => pS);
$parcel$export(module.exports, "d5", () => mS);
$parcel$export(module.exports, "d7", () => $o);
$parcel$export(module.exports, "d6", () => Jb);
$parcel$export(module.exports, "d8", () => jb);
$parcel$export(module.exports, "d9", () => IS);
$parcel$export(module.exports, "da", () => SS);
$parcel$export(module.exports, "db", () => ip);
$parcel$export(module.exports, "dc", () => t0);
$parcel$export(module.exports, "de", () => vd);
$parcel$export(module.exports, "df", () => e0);
$parcel$export(module.exports, "dg", () => Tm);
$parcel$export(module.exports, "dh", () => ES);
$parcel$export(module.exports, "a9", () => ap);
$parcel$export(module.exports, "di", () => WS);
$parcel$export(module.exports, "af", () => bt);
$parcel$export(module.exports, "ia", () => wQ);
$parcel$export(module.exports, "dq", () => Tn);
$parcel$export(module.exports, "eW", () => Ee);
$parcel$export(module.exports, "eY", () => Tt);
$parcel$export(module.exports, "dj", () => PS);
$parcel$export(module.exports, "dk", () => OS);
$parcel$export(module.exports, "dm", () => Or);
$parcel$export(module.exports, "dn", () => Jc);
$parcel$export(module.exports, "dr", () => BS);
$parcel$export(module.exports, "dZ", () => Pn);
$parcel$export(module.exports, "e2", () => Il);
$parcel$export(module.exports, "a2", () => gr);
$parcel$export(module.exports, "$", () => gt);
$parcel$export(module.exports, "eD", () => Ve);
$parcel$export(module.exports, "eE", () => Kt);
$parcel$export(module.exports, "eK", () => at);
$parcel$export(module.exports, "e8", () => jc);
$parcel$export(module.exports, "ds", () => tk);
$parcel$export(module.exports, "dt", () => mn);
$parcel$export(module.exports, "du", () => Oe);
$parcel$export(module.exports, "dv", () => ok);
$parcel$export(module.exports, "eP", () => Vn);
$parcel$export(module.exports, "dw", () => o0);
$parcel$export(module.exports, "dz", () => qc);
$parcel$export(module.exports, "Z", () => cp);
$parcel$export(module.exports, "dB", () => rn);
$parcel$export(module.exports, "dC", () => Bo);
$parcel$export(module.exports, "dE", () => up);
$parcel$export(module.exports, "dH", () => pk);
$parcel$export(module.exports, "dI", () => mk);
$parcel$export(module.exports, "dJ", () => bk);
$parcel$export(module.exports, "dK", () => dp);
$parcel$export(module.exports, "dL", () => Cl);
$parcel$export(module.exports, "dM", () => Tr);
$parcel$export(module.exports, "dO", () => Ck);
$parcel$export(module.exports, "dP", () => Nn);
$parcel$export(module.exports, "dQ", () => hp);
$parcel$export(module.exports, "iv", () => IQ);
$parcel$export(module.exports, "iw", () => CQ);
$parcel$export(module.exports, "iV", () => vQ);
$parcel$export(module.exports, "iW", () => SQ);
$parcel$export(module.exports, "iX", () => kk);
$parcel$export(module.exports, "ag", () => Eo);
$parcel$export(module.exports, "e7", () => Yt);
$parcel$export(module.exports, "ey", () => va);
$parcel$export(module.exports, "dR", () => $k);
$parcel$export(module.exports, "a0", () => it);
$parcel$export(module.exports, "dS", () => r0);
$parcel$export(module.exports, "dT", () => pp);
$parcel$export(module.exports, "dU", () => ss);
$parcel$export(module.exports, "dV", () => fp);
$parcel$export(module.exports, "dW", () => i0);
$parcel$export(module.exports, "dX", () => Vk);
$parcel$export(module.exports, "d_", () => mp);
$parcel$export(module.exports, "d$", () => Ak);
$parcel$export(module.exports, "e0", () => qs);
$parcel$export(module.exports, "e1", () => oe);
$parcel$export(module.exports, "eX", () => be);
$parcel$export(module.exports, "l", () => ks);
$parcel$export(module.exports, "e3", () => br);
$parcel$export(module.exports, "e4", () => Bk);
$parcel$export(module.exports, "e5", () => _k);
$parcel$export(module.exports, "e6", () => gp);
$parcel$export(module.exports, "e9", () => ui);
$parcel$export(module.exports, "aP", () => a0);
$parcel$export(module.exports, "ea", () => Rn);
$parcel$export(module.exports, "q", () => bp);
$parcel$export(module.exports, "ez", () => xp);
$parcel$export(module.exports, "eb", () => sT);
$parcel$export(module.exports, "ec", () => yp);
$parcel$export(module.exports, "ee", () => iT);
$parcel$export(module.exports, "H", () => kQ);
$parcel$export(module.exports, "J", () => kT);
$parcel$export(module.exports, "K", () => Sa);
$parcel$export(module.exports, "ef", () => di);
$parcel$export(module.exports, "eg", () => vl);
$parcel$export(module.exports, "eh", () => $T);
$parcel$export(module.exports, "ei", () => Ts);
$parcel$export(module.exports, "ej", () => c0);
$parcel$export(module.exports, "N", () => Lo);
$parcel$export(module.exports, "el", () => u0);
$parcel$export(module.exports, "em", () => d0);
$parcel$export(module.exports, "en", () => h0);
$parcel$export(module.exports, "eo", () => p0);
$parcel$export(module.exports, "ep", () => zT);
$parcel$export(module.exports, "er", () => f0);
$parcel$export(module.exports, "es", () => m0);
$parcel$export(module.exports, "et", () => Np);
$parcel$export(module.exports, "eu", () => g0);
$parcel$export(module.exports, "ev", () => Rp);
$parcel$export(module.exports, "ew", () => Sl);
$parcel$export(module.exports, "ex", () => $p);
$parcel$export(module.exports, "dx", () => Gp);
$parcel$export(module.exports, "dD", () => kl);
$parcel$export(module.exports, "dG", () => b0);
$parcel$export(module.exports, "eC", () => pn);
$parcel$export(module.exports, "ek", () => Ep);
$parcel$export(module.exports, "eF", () => x0);
$parcel$export(module.exports, "Y", () => ka);
$parcel$export(module.exports, "eG", () => Xn);
$parcel$export(module.exports, "eH", () => Ta);
$parcel$export(module.exports, "eI", () => nN);
$parcel$export(module.exports, "eL", () => oN);
$parcel$export(module.exports, "eM", () => Ze);
$parcel$export(module.exports, "eN", () => il);
$parcel$export(module.exports, "eO", () => rN);
$parcel$export(module.exports, "U", () => y0);
$parcel$export(module.exports, "iG", () => TQ);
$parcel$export(module.exports, "eQ", () => aN);
$parcel$export(module.exports, "eR", () => w0);
$parcel$export(module.exports, "eS", () => uN);
$parcel$export(module.exports, "eT", () => I0);
$parcel$export(module.exports, "eU", () => Mo);
$parcel$export(module.exports, "eV", () => pN);
$parcel$export(module.exports, "W", () => C0);
$parcel$export(module.exports, "aR", () => kt);
$parcel$export(module.exports, "dl", () => bN);
$parcel$export(module.exports, "dp", () => xN);
$parcel$export(module.exports, "dd", () => v0);
$parcel$export(module.exports, "aj", () => Wp);
$parcel$export(module.exports, "am", () => Dp);
$parcel$export(module.exports, "aa", () => Fp);
$parcel$export(module.exports, "a8", () => Vp);
$parcel$export(module.exports, "an", () => IN);
$parcel$export(module.exports, "al", () => vN);
$parcel$export(module.exports, "ak", () => kN);
$parcel$export(module.exports, "ao", () => Nm);
$parcel$export(module.exports, "aS", () => zp);
$parcel$export(module.exports, "aT", () => Pp);
$parcel$export(module.exports, "aU", () => Ap);
$parcel$export(module.exports, "hj", () => Ke);
$parcel$export(module.exports, "eB", () => NQ);
$parcel$export(module.exports, "eq", () => RQ);
$parcel$export(module.exports, "dF", () => fs);
$parcel$export(module.exports, "dN", () => e$);
$parcel$export(module.exports, "dY", () => $Q);
$parcel$export(module.exports, "eA", () => GQ);
$parcel$export(module.exports, "eJ", () => EQ);
$parcel$export(module.exports, "iH", () => LQ);
$parcel$export(module.exports, "h5", () => eo);
$parcel$export(module.exports, "fe", () => R0);
$parcel$export(module.exports, "ff", () => $0);
$parcel$export(module.exports, "fg", () => G0);
$parcel$export(module.exports, "fh", () => E0);
$parcel$export(module.exports, "hv", () => Xp);
$parcel$export(module.exports, "gY", () => L0);
$parcel$export(module.exports, "hd", () => M0);
$parcel$export(module.exports, "aJ", () => a$);
$parcel$export(module.exports, "aO", () => l$);
$parcel$export(module.exports, "aH", () => Em);
$parcel$export(module.exports, "aG", () => F0);
$parcel$export(module.exports, "aw", () => h$);
$parcel$export(module.exports, "f3", () => P0);
$parcel$export(module.exports, "ib", () => MQ);
$parcel$export(module.exports, "ip", () => WQ);
$parcel$export(module.exports, "iM", () => k$);
$parcel$export(module.exports, "h6", () => T$);
$parcel$export(module.exports, "iQ", () => tr);
$parcel$export(module.exports, "iz", () => su);
$parcel$export(module.exports, "i9", () => E$);
$parcel$export(module.exports, "cA", () => yt);
$parcel$export(module.exports, "aZ", () => Gx);
$parcel$export(module.exports, "a_", () => yf);
$parcel$export(module.exports, "a$", () => Ex);
$parcel$export(module.exports, "b0", () => Lx);
$parcel$export(module.exports, "b1", () => Mx);
$parcel$export(module.exports, "b2", () => Wx);
$parcel$export(module.exports, "b3", () => Dx);
$parcel$export(module.exports, "b4", () => en);
$parcel$export(module.exports, "b5", () => wf);
$parcel$export(module.exports, "b6", () => If);
$parcel$export(module.exports, "b7", () => Cf);
$parcel$export(module.exports, "b8", () => vf);
$parcel$export(module.exports, "b9", () => Sf);
$parcel$export(module.exports, "ba", () => kf);
$parcel$export(module.exports, "bb", () => Fx);
$parcel$export(module.exports, "gy", () => iL);
$parcel$export(module.exports, "gr", () => de);
$parcel$export(module.exports, "hW", () => os);
$parcel$export(module.exports, "ci", () => St);
$parcel$export(module.exports, "bg", () => Wa);
$parcel$export(module.exports, "be", () => fL);
$parcel$export(module.exports, "aV", () => zx);
$parcel$export(module.exports, "aW", () => Px);
$parcel$export(module.exports, "aX", () => Ax);
$parcel$export(module.exports, "aY", () => Ox);
$parcel$export(module.exports, "cB", () => ao);
$parcel$export(module.exports, "cz", () => hi);
$parcel$export(module.exports, "fA", () => CL);
$parcel$export(module.exports, "gn", () => SL);
$parcel$export(module.exports, "fS", () => kL);
$parcel$export(module.exports, "bf", () => wn);
$parcel$export(module.exports, "cu", () => uu);
$parcel$export(module.exports, "cs", () => Rf);
$parcel$export(module.exports, "ct", () => $f);
$parcel$export(module.exports, "cr", () => Bx);
$parcel$export(module.exports, "ck", () => Hx);
$parcel$export(module.exports, "cn", () => _x);
$parcel$export(module.exports, "cp", () => FL);
$parcel$export(module.exports, "cq", () => DQ);
$parcel$export(module.exports, "cl", () => VL);
$parcel$export(module.exports, "cm", () => zL);
$parcel$export(module.exports, "co", () => Yx);
$parcel$export(module.exports, "fa", () => jx);
$parcel$export(module.exports, "bc", () => ur);
$parcel$export(module.exports, "cv", () => FQ);
$parcel$export(module.exports, "ix", () => VQ);
$parcel$export(module.exports, "bd", () => mi);
$parcel$export(module.exports, "cw", () => hu);
$parcel$export(module.exports, "cx", () => AQ);
$parcel$export(module.exports, "cy", () => OQ);
$parcel$export(module.exports, "bi", () => xy);
$parcel$export(module.exports, "bj", () => yy);
$parcel$export(module.exports, "bk", () => wy);
$parcel$export(module.exports, "bh", () => Iy);
$parcel$export(module.exports, "bm", () => Cy);
$parcel$export(module.exports, "bl", () => vy);
$parcel$export(module.exports, "bo", () => Fa);
$parcel$export(module.exports, "bq", () => Va);
$parcel$export(module.exports, "bp", () => ky);
$parcel$export(module.exports, "br", () => Ty);
$parcel$export(module.exports, "bs", () => Ry);
$parcel$export(module.exports, "bn", () => fu);
$parcel$export(module.exports, "bt", () => $y);
$parcel$export(module.exports, "bu", () => Gy);
$parcel$export(module.exports, "bv", () => Ey);
$parcel$export(module.exports, "c5", () => no);
$parcel$export(module.exports, "c6", () => Df);
$parcel$export(module.exports, "cj", () => mu);
$parcel$export(module.exports, "c2", () => Mf);
$parcel$export(module.exports, "c1", () => Wy);
$parcel$export(module.exports, "b_", () => Wf);
$parcel$export(module.exports, "bZ", () => Dy);
$parcel$export(module.exports, "c0", () => gu);
$parcel$export(module.exports, "b$", () => Fy);
$parcel$export(module.exports, "c4", () => Ff);
$parcel$export(module.exports, "c3", () => zy);
$parcel$export(module.exports, "by", () => Vf);
$parcel$export(module.exports, "bz", () => Py);
$parcel$export(module.exports, "bx", () => Ay);
$parcel$export(module.exports, "bA", () => Oy);
$parcel$export(module.exports, "bw", () => Xy);
$parcel$export(module.exports, "bB", () => Ky);
$parcel$export(module.exports, "bC", () => Zy);
$parcel$export(module.exports, "bD", () => By);
$parcel$export(module.exports, "cc", () => Hy);
$parcel$export(module.exports, "bE", () => _y);
$parcel$export(module.exports, "bF", () => Uy);
$parcel$export(module.exports, "bK", () => Yy);
$parcel$export(module.exports, "bG", () => Qy);
$parcel$export(module.exports, "bI", () => Jy);
$parcel$export(module.exports, "bJ", () => jy);
$parcel$export(module.exports, "bH", () => qy);
$parcel$export(module.exports, "bL", () => t1);
$parcel$export(module.exports, "c9", () => e1);
$parcel$export(module.exports, "ca", () => n1);
$parcel$export(module.exports, "cb", () => s1);
$parcel$export(module.exports, "bM", () => o1);
$parcel$export(module.exports, "bN", () => r1);
$parcel$export(module.exports, "bO", () => i1);
$parcel$export(module.exports, "bW", () => c1);
$parcel$export(module.exports, "bP", () => u1);
$parcel$export(module.exports, "bX", () => h1);
$parcel$export(module.exports, "bQ", () => p1);
$parcel$export(module.exports, "bY", () => m1);
$parcel$export(module.exports, "bR", () => g1);
$parcel$export(module.exports, "bS", () => x1);
$parcel$export(module.exports, "bU", () => y1);
$parcel$export(module.exports, "bT", () => I1);
$parcel$export(module.exports, "bV", () => C1);
$parcel$export(module.exports, "c8", () => S1);
$parcel$export(module.exports, "c7", () => k1);
$parcel$export(module.exports, "cd", () => T1);
$parcel$export(module.exports, "ce", () => N1);
$parcel$export(module.exports, "cg", () => R1);
$parcel$export(module.exports, "cf", () => $1);
$parcel$export(module.exports, "ch", () => L1);
$parcel$export(module.exports, "cE", () => ug);
$parcel$export(module.exports, "f6", () => z3);
$parcel$export(module.exports, "f2", () => He);
$parcel$export(module.exports, "f4", () => Q3);
$parcel$export(module.exports, "f1", () => zf);
$parcel$export(module.exports, "f7", () => yn);
$parcel$export(module.exports, "f8", () => BQ);
$parcel$export(module.exports, "f9", () => HQ);
$parcel$export(module.exports, "gK", () => yu);
$parcel$export(module.exports, "iL", () => fW);
$parcel$export(module.exports, "iK", () => EP);
$parcel$export(module.exports, "iZ", () => _Q);
$parcel$export(module.exports, "iu", () => UQ);
$parcel$export(module.exports, "gj", () => Au);
$parcel$export(module.exports, "gL", () => Cu);
$parcel$export(module.exports, "io", () => sX);
$parcel$export(module.exports, "iY", () => YQ);
$parcel$export(module.exports, "C", () => QQ);

var $4azF7 = parcelRequire("4azF7");

var $6ZWSX = parcelRequire("6ZWSX");
var $0014e4ac1090533d$require$Buffer = $6ZWSX.Buffer;

var $hPtJY = parcelRequire("hPtJY");
function DC(n, t) {
    for(var e = 0; e < t.length; e++){
        const s = t[e];
        if (typeof s != "string" && !Array.isArray(s)) {
            for(const o in s)if (o !== "default" && !(o in n)) {
                const r = Object.getOwnPropertyDescriptor(s, o);
                r && Object.defineProperty(n, o, r.get ? r : {
                    enumerable: !0,
                    get: ()=>s[o]
                });
            }
        }
    }
    return Object.freeze(Object.defineProperty(n, Symbol.toStringTag, {
        value: "Module"
    }));
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const FC = 1e-7, VC = 1e-4;
class qg {
    constructor(t, e){
        this.backend = t, this.dataMover = e, this.data = /* @__PURE__ */ new WeakMap(), this.dataIdsCount = 0;
    }
    get(t) {
        return this.data.has(t) || this.dataMover.moveData(this.backend, t), this.data.get(t);
    }
    set(t, e) {
        this.dataIdsCount++, this.data.set(t, e);
    }
    has(t) {
        return this.data.has(t);
    }
    delete(t) {
        return this.dataIdsCount--, this.data.delete(t);
    }
    numDataIds() {
        return this.dataIdsCount;
    }
}
class _d {
    refCount(t) {
        return Qe("refCount");
    }
    incRef(t) {
        return Qe("incRef");
    }
    timerAvailable() {
        return !0;
    }
    time(t) {
        return Qe("time");
    }
    read(t) {
        return Qe("read");
    }
    readSync(t) {
        return Qe("readSync");
    }
    readToGPU(t, e) {
        return Qe("readToGPU");
    }
    numDataIds() {
        return Qe("numDataIds");
    }
    disposeData(t, e) {
        return Qe("disposeData");
    }
    write(t, e, s) {
        return Qe("write");
    }
    move(t, e, s, o, r) {
        return Qe("move");
    }
    createTensorFromGPUData(t, e, s) {
        return Qe("createTensorFromGPUData");
    }
    memory() {
        return Qe("memory");
    }
    /** Returns the highest precision for floats in bits (e.g. 16 or 32) */ floatPrecision() {
        return Qe("floatPrecision");
    }
    /** Returns the smallest representable number.  */ epsilon() {
        return this.floatPrecision() === 32 ? FC : VC;
    }
    dispose() {
        return Qe("dispose");
    }
}
function Qe(n) {
    throw new Error(`'${n}' not yet implemented or not found in the registry. This kernel may not be supported by the tfjs backend you have chosen`);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Ud(n) {
    let t = n.length, e = 0;
    for(; t > 0;)e = Math.random() * t | 0, t--, ds(n, t, e);
}
function zC(n, t) {
    if (n.length !== t.length) throw new Error(`Array sizes must match to be shuffled together First array length was ${n.length}Second array length was ${t.length}`);
    let e = n.length, s = 0;
    for(; e > 0;)s = Math.random() * e | 0, e--, ds(n, e, s), ds(t, e, s);
}
function Os(n, t, e) {
    return Math.max(n, Math.min(t, e));
}
function Bl(n) {
    return n % 2 === 0 ? n : n + 1;
}
function ds(n, t, e) {
    const s = n[t];
    n[t] = n[e], n[e] = s;
}
function tb(n) {
    let t = 0;
    for(let e = 0; e < n.length; e++)t += n[e];
    return t;
}
function PC(n, t) {
    const e = Math.random();
    return t * e + (1 - e) * n;
}
function AC(n, t) {
    let e = 0;
    for(let s = 0; s < n.length; s++){
        const o = Number(n[s]) - Number(t[s]);
        e += o * o;
    }
    return e;
}
function C(n, t) {
    if (!n) throw new Error(typeof t == "string" ? t : t());
}
function Pe(n, t, e = "") {
    C($t(n, t), ()=>e + ` Shapes ${n} and ${t} must match`);
}
function Hl(n) {
    C(n != null, ()=>"The input to the tensor constructor must be a non-null value.");
}
function X(n) {
    if (n.length === 0) return 1;
    let t = n[0];
    for(let e = 1; e < n.length; e++)t *= n[e];
    return t;
}
function OC(n) {
    return n.length === 0;
}
function XC(n, t) {
    if (n === t) return !0;
    if (n == null || t == null || n.length !== t.length) return !1;
    for(let e = 0; e < n.length; e++)if (n[e] !== null && t[e] !== null && n[e] !== t[e]) return !1;
    return !0;
}
function $t(n, t) {
    if (n === t) return !0;
    if (n == null || t == null || n.length !== t.length) return !1;
    for(let e = 0; e < n.length; e++)if (n[e] !== t[e]) return !1;
    return !0;
}
function Co(n) {
    return n % 1 === 0;
}
function KC(n) {
    if (Math.tanh != null) return Math.tanh(n);
    if (n === 1 / 0) return 1;
    if (n === -1 / 0) return -1;
    {
        const t = Math.exp(2 * n);
        return (t - 1) / (t + 1);
    }
}
function hl(n) {
    const t = Math.ceil(Math.sqrt(n));
    return [
        t,
        Math.ceil(n / t)
    ];
}
function ZC(n) {
    const t = new Uint32Array(n);
    for(let e = 0; e < n; ++e)t[e] = e;
    return Ud(t), t;
}
function xo(n, t) {
    return t <= n.length ? n : n + " ".repeat(t - n.length);
}
function id(n, t = (o)=>0, e, s) {
    return new Promise((o, r)=>{
        let i = 0;
        const a = ()=>{
            if (n()) {
                o();
                return;
            }
            i++;
            const l = t(i);
            if (e != null && i >= e) {
                r();
                return;
            }
            s != null ? s(a, l) : setTimeout(a, l);
        };
        a();
    });
}
function Yd(n, t) {
    let e = 1, s = -1;
    for(let r = 0; r < n.length; ++r)if (n[r] >= 0) e *= n[r];
    else if (n[r] === -1) {
        if (s !== -1) throw Error(`Shapes can only have 1 implicit size. Found -1 at dim ${s} and dim ${r}`);
        s = r;
    } else if (n[r] < 0) throw Error(`Shapes can not be < 0. Found ${n[r]} at dim ${r}`);
    if (s === -1) {
        if (t > 0 && t !== e) throw Error(`Size(${t}) must match the product of shape ${n}`);
        return n;
    }
    if (e === 0) throw Error(`Cannot infer the missing size in [${n}] when there are 0 elements`);
    if (t % e !== 0) throw Error(`The implicit shape can't be a fractional number. Got ${t} / ${e}`);
    const o = n.slice();
    return o[s] = t / e, o;
}
function Ct(n, t) {
    const e = t.length;
    return n = n == null ? t.map((s, o)=>o) : [].concat(n), C(n.every((s)=>s >= -e && s < e), ()=>`All values in axis param must be in range [-${e}, ${e}) but got axis ${n}`), C(n.every((s)=>Co(s)), ()=>`All values in axis param must be integers but got axis ${n}`), n.map((s)=>s < 0 ? e + s : s);
}
function ws(n, t) {
    const e = [], s = [], o = t != null && Array.isArray(t) && t.length === 0, r = t == null || o ? null : Ct(t, n).sort();
    let i = 0;
    for(let a = 0; a < n.length; ++a){
        if (r != null) {
            if (r[i] === a && n[a] !== 1) throw new Error(`Can't squeeze axis ${a} since its dim '${n[a]}' is not 1`);
            (r[i] == null || r[i] > a) && n[a] === 1 && (e.push(n[a]), s.push(a)), r[i] <= a && i++;
        }
        n[a] !== 1 && (e.push(n[a]), s.push(a));
    }
    return {
        newShape: e,
        keptDims: s
    };
}
function Se(n, t) {
    return ne(n, t);
}
function ne(n, t) {
    let e = null;
    if (n == null || n === "float32") e = new Float32Array(t);
    else if (n === "int32") e = new Int32Array(t);
    else if (n === "bool") e = new Uint8Array(t);
    else if (n === "string") e = new Array(t);
    else throw new Error(`Unknown data type ${n}`);
    return e;
}
function eb(n, t) {
    for(let e = 0; e < n.length; e++){
        const s = n[e];
        if (isNaN(s) || !isFinite(s)) throw Error(`A tensor of type ${t} being uploaded contains ${s}.`);
    }
}
function nb(n) {
    return n === "bool" || n === "complex64" || n === "float32" || n === "int32" || n === "string";
}
function Qd(n, t) {
    return !(t === "complex64" || t === "float32" && n !== "complex64" || t === "int32" && n !== "float32" && n !== "complex64" || t === "bool" && n === "bool");
}
function ri(n) {
    if (n === "float32" || n === "int32") return 4;
    if (n === "complex64") return 8;
    if (n === "bool") return 1;
    throw new Error(`Unknown dtype ${n}`);
}
function sb(n) {
    if (n == null) return 0;
    let t = 0;
    return n.forEach((e)=>t += e.length), t;
}
function vr(n) {
    return typeof n == "string" || n instanceof String;
}
function ob(n) {
    return typeof n == "boolean";
}
function pl(n) {
    return typeof n == "number";
}
function Oo(n) {
    return Array.isArray(n) ? Oo(n[0]) : n instanceof Float32Array ? "float32" : n instanceof Int32Array || n instanceof Uint8Array || n instanceof Uint8ClampedArray ? "int32" : pl(n) ? "float32" : vr(n) ? "string" : ob(n) ? "bool" : "float32";
}
function Xs(n) {
    return !!(n && n.constructor && n.call && n.apply);
}
function fl(n, t) {
    for(let e = t; e < n; ++e)if (n % e === 0) return e;
    return n;
}
function dt(n) {
    const t = n.length;
    if (t < 2) return [];
    const e = new Array(t - 1);
    e[t - 2] = n[t - 1];
    for(let s = t - 3; s >= 0; --s)e[s] = e[s + 1] * n[s + 1];
    return e;
}
function rb(n, t, e, s = !1) {
    const o = new Array();
    if (t.length === 1) {
        const r = t[0] * (s ? 2 : 1);
        for(let i = 0; i < r; i++)o[i] = e[n + i];
    } else {
        const r = t[0], i = t.slice(1), a = i.reduce((l, c)=>l * c) * (s ? 2 : 1);
        for(let l = 0; l < r; l++)o[l] = rb(n + l * a, i, e, s);
    }
    return o;
}
function kn(n, t, e = !1) {
    if (n.length === 0) return t[0];
    const s = n.reduce((o, r)=>o * r) * (e ? 2 : 1);
    if (s === 0) return [];
    if (s !== t.length) throw new Error(`[${n}] does not match the input size ${t.length}${e ? " for a complex tensor" : ""}.`);
    return rb(0, n, t, e);
}
function ib(n, t) {
    if (Array.isArray(n)) return n;
    if (t === "float32") return n instanceof Float32Array ? n : new Float32Array(n);
    if (t === "int32") return n instanceof Int32Array ? n : new Int32Array(n);
    if (t === "bool" || t === "string") return Uint8Array.from(new Int32Array(n));
    throw new Error(`Unknown dtype ${t}`);
}
function _l(n, t) {
    const e = ke(n, t);
    for(let s = 0; s < e.length; s++)e[s] = 1;
    return e;
}
function ke(n, t) {
    if (t == null || t === "float32" || t === "complex64") return new Float32Array(n);
    if (t === "int32") return new Int32Array(n);
    if (t === "bool") return new Uint8Array(n);
    throw new Error(`Unknown data type ${t}`);
}
function Jd(n, t) {
    const e = n.reduce((s, o)=>s * o, 1);
    if (t == null || t === "float32") return kn(n, new Float32Array(e));
    if (t === "int32") return kn(n, new Int32Array(e));
    if (t === "bool") return kn(n, new Uint8Array(e));
    throw new Error(`Unknown data type ${t}`);
}
function is(n) {
    n.forEach((t)=>{
        C(Number.isInteger(t) && t >= 0, ()=>`Tensor must have a shape comprised of positive integers but got shape [${n}].`);
    });
}
function zn(n, t, e) {
    if (t === 0) return 0;
    if (t === 1) return n[0];
    let s = n[n.length - 1];
    for(let o = 0; o < n.length - 1; ++o)s += e[o] * n[o];
    return s;
}
function Xo(n, t, e) {
    if (t === 0) return [];
    if (t === 1) return [
        n
    ];
    const s = new Array(t);
    for(let o = 0; o < s.length - 1; ++o)s[o] = Math.floor(n / e[o]), n -= s[o] * e[o];
    return s[s.length - 1] = n, s;
}
function Ci(n) {
    return n && n.then && typeof n.then == "function";
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const um = "tfjsflags";
class BC {
    // tslint:disable-next-line: no-any
    constructor(t){
        this.global = t, this.flags = {}, this.flagRegistry = {}, this.urlFlags = {}, this.getQueryParams = HC, this.populateURLFlags();
    }
    setPlatform(t, e) {
        this.platform != null && (F().getBool("IS_TEST") || F().getBool("PROD") || console.warn(`Platform ${this.platformName} has already been set. Overwriting the platform with ${t}.`)), this.platformName = t, this.platform = e;
    }
    registerFlag(t, e, s) {
        if (this.flagRegistry[t] = {
            evaluationFn: e,
            setHook: s
        }, this.urlFlags[t] != null) {
            const o = this.urlFlags[t];
            F().getBool("IS_TEST") || F().getBool("PROD") || console.warn(`Setting feature override from URL ${t}: ${o}.`), this.set(t, o);
        }
    }
    async getAsync(t) {
        return t in this.flags ? this.flags[t] : (this.flags[t] = await this.evaluateFlag(t), this.flags[t]);
    }
    get(t) {
        if (t in this.flags) return this.flags[t];
        const e = this.evaluateFlag(t);
        if (Ci(e)) throw new Error(`Flag ${t} cannot be synchronously evaluated. Please use getAsync() instead.`);
        return this.flags[t] = e, this.flags[t];
    }
    getNumber(t) {
        return this.get(t);
    }
    getBool(t) {
        return this.get(t);
    }
    getString(t) {
        return this.get(t);
    }
    getFlags() {
        return this.flags;
    }
    // For backwards compatibility.
    get features() {
        return this.flags;
    }
    set(t, e) {
        if (this.flagRegistry[t] == null) throw new Error(`Cannot set flag ${t} as it has not been registered.`);
        this.flags[t] = e, this.flagRegistry[t].setHook != null && this.flagRegistry[t].setHook(e);
    }
    evaluateFlag(t) {
        if (this.flagRegistry[t] == null) throw new Error(`Cannot evaluate flag '${t}': no evaluation function found.`);
        return this.flagRegistry[t].evaluationFn();
    }
    setFlags(t) {
        this.flags = Object.assign({}, t);
    }
    reset() {
        this.flags = {}, this.urlFlags = {}, this.populateURLFlags();
    }
    populateURLFlags() {
        if (typeof this.global > "u" || typeof this.global.location > "u" || typeof this.global.location.search > "u") return;
        const t = this.getQueryParams(this.global.location.search);
        um in t && t[um].split(",").forEach((s)=>{
            const [o, r] = s.split(":");
            this.urlFlags[o] = UC(o, r);
        });
    }
}
function HC(n) {
    const t = {};
    return n.replace(/[?&]([^=?&]+)(?:=([^&]*))?/g, (e, ...s)=>(_C(t, s[0], s[1]), s.join("="))), t;
}
function _C(n, t, e) {
    n[decodeURIComponent(t)] = decodeURIComponent(e || "");
}
function UC(n, t) {
    const e = t.toLowerCase();
    return e === "true" || e === "false" ? e === "true" : `${+e}` === e ? +e : t;
}
function F() {
    return ab;
}
let ab = null;
function YC(n) {
    ab = n;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ let $u;
function lb() {
    if ($u == null) {
        let n;
        if (typeof window < "u") n = window;
        else if (typeof $parcel$global < "u") n = $parcel$global;
        else {
            if (typeof self < "u") n = self;
            else throw new Error("Could not find a global object");
        }
        $u = n;
    }
    return $u;
}
function QC() {
    const n = lb();
    return n._tfGlobals == null && (n._tfGlobals = /* @__PURE__ */ new Map()), n._tfGlobals;
}
function jd(n, t) {
    const e = QC();
    if (e.has(n)) return e.get(n);
    {
        const s = t();
        return e.set(n, s), e.get(n);
    }
}
const Ul = "Abs", vi = "Acos", Si = "Acosh", Sr = "Add", qd = "AddN", th = "All", eh = "Any", Yl = "ArgMax", Ql = "ArgMin", ki = "Asin", Ti = "Asinh", Ni = "Atan", Ri = "Atanh", $i = "Atan2", Jl = "AvgPool", nh = "AvgPoolGrad", jl = "AvgPool3D", sh = "AvgPool3DGrad", ql = "BatchMatMul", tc = "BatchToSpaceND", oh = "Bincount", rh = "BitwiseAnd", JC = "BroadcastTo", cb = "BroadcastArgs", Gi = "Cast", Ei = "Ceil", Li = "ClipByValue", ih = "Complex", ec = "ComplexAbs", nc = "Concat", sc = "Conv2D", ah = "Conv2DBackpropFilter", oc = "Conv2DBackpropInput", rc = "Conv3D", lh = "Conv3DBackpropFilterV2", ch = "Conv3DBackpropInputV2", Mi = "Cos", Wi = "Cosh", uh = "Cumprod", ic = "Cumsum", dh = "CropAndResize", hh = "DenseBincount", ph = "DepthToSpace", ac = "DepthwiseConv2dNative", fh = "DepthwiseConv2dNativeBackpropFilter", mh = "DepthwiseConv2dNativeBackpropInput", ub = "Diag", lc = "Dilation2D", ad = "Dilation2DBackpropInput", ld = "Dilation2DBackpropFilter", gh = "Draw", Di = "RealDiv", bh = "Einsum", Fi = "Elu", xh = "EluGrad", Vi = "Erf", cc = "Equal", zi = "Exp", uc = "ExpandDims", Pi = "Expm1", yh = "FFT", wh = "Fill", Ih = "FlipLeftRight", Ai = "Floor", Oi = "FloorDiv", dc = "FusedBatchNorm", hc = "GatherV2", db = "GatherNd", pc = "Greater", Xi = "GreaterEqual", Ki = "Identity", Ch = "IFFT", vh = "Imag", Zi = "IsFinite", Bi = "IsInf", Hi = "IsNan", fc = "LeakyRelu", mc = "Less", gc = "LessEqual", hb = "LinSpace", _i = "Log", Ui = "Log1p", bc = "LogicalAnd", xc = "LogicalNot", yc = "LogicalOr", XY = "LogicalXor", jC = "LogSoftmax", KY = "LowerBound", wc = "LRN", Sh = "LRNGrad", ZY = "MatrixBandPart", Ic = "Max", Yi = "Maximum", Cc = "MaxPool", kh = "MaxPoolGrad", vc = "MaxPool3D", Th = "MaxPool3DGrad", pb = "MaxPoolWithArgmax", Sc = "Mean", kc = "Min", Qi = "Minimum", Tc = "MirrorPad", Ji = "Mod", fb = "Multinomial", ji = "Multiply", Nc = "Neg", Rc = "NotEqual", Nh = "NonMaxSuppressionV3", Rh = "NonMaxSuppressionV4", $h = "NonMaxSuppressionV5", $c = "OnesLike", Gc = "OneHot", Ec = "Pack", Lc = "PadV2", BY = "Pool", qi = "Pow", Mc = "Prelu", Wc = "Prod", mb = "RaggedGather", gb = "RaggedRange", bb = "RaggedTensorToTensor", Gh = "Range", Eh = "Real", ta = "Reciprocal", ea = "Relu", Dc = "Reshape", Fc = "ResizeNearestNeighbor", Lh = "ResizeNearestNeighborGrad", Vc = "ResizeBilinear", Mh = "ResizeBilinearGrad", na = "Relu6", zc = "Reverse", sa = "Round", oa = "Rsqrt", xb = "ScatterNd", yb = "TensorScatterUpdate", wb = "SearchSorted", Pc = "Select", ra = "Selu", Ac = "Slice", ia = "Sin", aa = "Sinh", la = "Sign", ca = "Sigmoid", ua = "Softplus", da = "Sqrt", Oc = "Sum", Xc = "SpaceToBatchND", Kc = "SplitV", Zc = "Softmax", Wh = "SparseFillEmptyRows", Dh = "SparseReshape", Fh = "SparseSegmentMean", Vh = "SparseSegmentSum", Ib = "SparseToDense", ha = "SquaredDifference", zh = "Square", Bc = "StaticRegexReplace", Ph = "StridedSlice", Ah = "StringNGrams", Oh = "StringSplit", Xh = "StringToHashBucketFast", pa = "Sub", fa = "Tan", ma = "Tanh", ga = "Tile", Kh = "TopK", Zh = "Transform", ar = "Transpose", Bh = "Unique", Hc = "Unpack", _c = "UnsortedSegmentSum", HY = "UpperBound", Uc = "ZerosLike", ba = "Step", cd = "FromPixels", Hh = "RotateWithOffset", ml = "_FusedMatMul", gl = "FusedConv2D", Cb = "FusedDepthwiseConv2D";
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ln(...n) {
    F().getBool("IS_TEST") || F().getBool("PROD") || console.warn(...n);
}
function qC(...n) {
    F().getBool("IS_TEST") || F().getBool("PROD") || console.log(...n);
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const pr = jd("kernelRegistry", ()=>/* @__PURE__ */ new Map()), ii = jd("gradRegistry", ()=>/* @__PURE__ */ new Map());
function bl(n, t) {
    const e = _h(n, t);
    return pr.get(e);
}
function dm(n) {
    return ii.get(n);
}
function ud(n) {
    const t = pr.entries(), e = [];
    for(;;){
        const { done: s, value: o } = t.next();
        if (s) break;
        const [r, i] = o, [a] = r.split("_");
        a === n && e.push(i);
    }
    return e;
}
function sn(n) {
    const { kernelName: t, backendName: e } = n, s = _h(t, e);
    pr.has(s) && ln(`The kernel '${t}' for backend '${e}' is already registered`), pr.set(s, n);
}
function t2(n) {
    const { kernelName: t } = n;
    ii.has(t) && F().getBool("DEBUG") && ln(`Overriding the gradient for '${t}'`), ii.set(t, n);
}
function _Y(n, t) {
    const e = _h(n, t);
    if (!pr.has(e)) throw new Error(`The kernel '${n}' for backend '${t}' is not registered`);
    pr.delete(e);
}
function UY(n) {
    if (!ii.has(n)) throw new Error(`The gradient '${n}' for backend is not registered`);
    ii.delete(n);
}
function YY(n, t) {
    ud(n).forEach((s)=>{
        const o = Object.assign({}, s, {
            backendName: t
        });
        sn(o);
    });
}
function _h(n, t) {
    return `${t}_${n}`;
}
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function vb(n) {
    return n instanceof Float32Array || n instanceof Int32Array || n instanceof Uint8Array || n instanceof Uint8ClampedArray;
}
var Ko = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function e2(n) {
    return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function n2(n) {
    if (n.__esModule) return n;
    var t = n.default;
    if (typeof t == "function") {
        var e = function s() {
            return this instanceof s ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
        };
        e.prototype = t.prototype;
    } else e = {};
    return Object.defineProperty(e, "__esModule", {
        value: !0
    }), Object.keys(n).forEach(function(s) {
        var o = Object.getOwnPropertyDescriptor(n, s);
        Object.defineProperty(e, s, o.get ? o : {
            enumerable: !0,
            get: function() {
                return n[s];
            }
        });
    }), e;
}
var Sb = Bt, In = null;
try {
    In = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        13,
        2,
        96,
        0,
        1,
        127,
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        3,
        7,
        6,
        0,
        1,
        1,
        1,
        1,
        1,
        6,
        6,
        1,
        127,
        1,
        65,
        0,
        11,
        7,
        50,
        6,
        3,
        109,
        117,
        108,
        0,
        1,
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        10,
        191,
        1,
        6,
        4,
        0,
        35,
        0,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
    ])), {}).exports;
} catch  {}
function Bt(n, t, e) {
    this.low = n | 0, this.high = t | 0, this.unsigned = !!e;
}
Bt.prototype.__isLong__;
Object.defineProperty(Bt.prototype, "__isLong__", {
    value: !0
});
function on(n) {
    return (n && n.__isLong__) === !0;
}
Bt.isLong = on;
var hm = {}, pm = {};
function Zo(n, t) {
    var e, s, o;
    return t ? (n >>>= 0, (o = 0 <= n && n < 256) && (s = pm[n], s) ? s : (e = Ht(n, (n | 0) < 0 ? -1 : 0, !0), o && (pm[n] = e), e)) : (n |= 0, (o = -128 <= n && n < 128) && (s = hm[n], s) ? s : (e = Ht(n, n < 0 ? -1 : 0, !1), o && (hm[n] = e), e));
}
Bt.fromInt = Zo;
function Cn(n, t) {
    if (isNaN(n)) return t ? mo : vn;
    if (t) {
        if (n < 0) return mo;
        if (n >= kb) return Rb;
    } else {
        if (n <= -mm) return je;
        if (n + 1 >= mm) return Nb;
    }
    return n < 0 ? Cn(-n, t).neg() : Ht(n % fr | 0, n / fr | 0, t);
}
Bt.fromNumber = Cn;
function Ht(n, t, e) {
    return new Bt(n, t, e);
}
Bt.fromBits = Ht;
var xl = Math.pow;
function Uh(n, t, e) {
    if (n.length === 0) throw Error("empty string");
    if (n === "NaN" || n === "Infinity" || n === "+Infinity" || n === "-Infinity") return vn;
    if (typeof t == "number" ? (e = t, t = !1) : t = !!t, e = e || 10, e < 2 || 36 < e) throw RangeError("radix");
    var s;
    if ((s = n.indexOf("-")) > 0) throw Error("interior hyphen");
    if (s === 0) return Uh(n.substring(1), t, e).neg();
    for(var o = Cn(xl(e, 8)), r = vn, i = 0; i < n.length; i += 8){
        var a = Math.min(8, n.length - i), l = parseInt(n.substring(i, i + a), e);
        if (a < 8) {
            var c = Cn(xl(e, a));
            r = r.mul(c).add(Cn(l));
        } else r = r.mul(o), r = r.add(Cn(l));
    }
    return r.unsigned = t, r;
}
Bt.fromString = Uh;
function Hn(n, t) {
    return typeof n == "number" ? Cn(n, t) : typeof n == "string" ? Uh(n, t) : Ht(n.low, n.high, typeof t == "boolean" ? t : n.unsigned);
}
Bt.fromValue = Hn;
var fm = 65536, s2 = 16777216, fr = fm * fm, kb = fr * fr, mm = kb / 2, gm = Zo(s2), vn = Zo(0);
Bt.ZERO = vn;
var mo = Zo(0, !0);
Bt.UZERO = mo;
var ir = Zo(1);
Bt.ONE = ir;
var Tb = Zo(1, !0);
Bt.UONE = Tb;
var dd = Zo(-1);
Bt.NEG_ONE = dd;
var Nb = Ht(-1, 2147483647, !1);
Bt.MAX_VALUE = Nb;
var Rb = Ht(-1, -1, !0);
Bt.MAX_UNSIGNED_VALUE = Rb;
var je = Ht(0, -2147483648, !1);
Bt.MIN_VALUE = je;
var st = Bt.prototype;
st.toInt = function() {
    return this.unsigned ? this.low >>> 0 : this.low;
};
st.toNumber = function() {
    return this.unsigned ? (this.high >>> 0) * fr + (this.low >>> 0) : this.high * fr + (this.low >>> 0);
};
st.toString = function(t) {
    if (t = t || 10, t < 2 || 36 < t) throw RangeError("radix");
    if (this.isZero()) return "0";
    if (this.isNegative()) {
        if (this.eq(je)) {
            var e = Cn(t), s = this.div(e), o = s.mul(e).sub(this);
            return s.toString(t) + o.toInt().toString(t);
        } else return "-" + this.neg().toString(t);
    }
    for(var r = Cn(xl(t, 6), this.unsigned), i = this, a = "";;){
        var l = i.div(r), c = i.sub(l.mul(r)).toInt() >>> 0, u = c.toString(t);
        if (i = l, i.isZero()) return u + a;
        for(; u.length < 6;)u = "0" + u;
        a = "" + u + a;
    }
};
st.getHighBits = function() {
    return this.high;
};
st.getHighBitsUnsigned = function() {
    return this.high >>> 0;
};
st.getLowBits = function() {
    return this.low;
};
st.getLowBitsUnsigned = function() {
    return this.low >>> 0;
};
st.getNumBitsAbs = function() {
    if (this.isNegative()) return this.eq(je) ? 64 : this.neg().getNumBitsAbs();
    for(var t = this.high != 0 ? this.high : this.low, e = 31; e > 0 && !(t & 1 << e); e--);
    return this.high != 0 ? e + 33 : e + 1;
};
st.isZero = function() {
    return this.high === 0 && this.low === 0;
};
st.eqz = st.isZero;
st.isNegative = function() {
    return !this.unsigned && this.high < 0;
};
st.isPositive = function() {
    return this.unsigned || this.high >= 0;
};
st.isOdd = function() {
    return (this.low & 1) === 1;
};
st.isEven = function() {
    return (this.low & 1) === 0;
};
st.equals = function(t) {
    return on(t) || (t = Hn(t)), this.unsigned !== t.unsigned && this.high >>> 31 === 1 && t.high >>> 31 === 1 ? !1 : this.high === t.high && this.low === t.low;
};
st.eq = st.equals;
st.notEquals = function(t) {
    return !this.eq(/* validates */ t);
};
st.neq = st.notEquals;
st.ne = st.notEquals;
st.lessThan = function(t) {
    return this.comp(/* validates */ t) < 0;
};
st.lt = st.lessThan;
st.lessThanOrEqual = function(t) {
    return this.comp(/* validates */ t) <= 0;
};
st.lte = st.lessThanOrEqual;
st.le = st.lessThanOrEqual;
st.greaterThan = function(t) {
    return this.comp(/* validates */ t) > 0;
};
st.gt = st.greaterThan;
st.greaterThanOrEqual = function(t) {
    return this.comp(/* validates */ t) >= 0;
};
st.gte = st.greaterThanOrEqual;
st.ge = st.greaterThanOrEqual;
st.compare = function(t) {
    if (on(t) || (t = Hn(t)), this.eq(t)) return 0;
    var e = this.isNegative(), s = t.isNegative();
    return e && !s ? -1 : !e && s ? 1 : this.unsigned ? t.high >>> 0 > this.high >>> 0 || t.high === this.high && t.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(t).isNegative() ? -1 : 1;
};
st.comp = st.compare;
st.negate = function() {
    return !this.unsigned && this.eq(je) ? je : this.not().add(ir);
};
st.neg = st.negate;
st.add = function(t) {
    on(t) || (t = Hn(t));
    var e = this.high >>> 16, s = this.high & 65535, o = this.low >>> 16, r = this.low & 65535, i = t.high >>> 16, a = t.high & 65535, l = t.low >>> 16, c = t.low & 65535, u = 0, d = 0, h = 0, p = 0;
    return p += r + c, h += p >>> 16, p &= 65535, h += o + l, d += h >>> 16, h &= 65535, d += s + a, u += d >>> 16, d &= 65535, u += e + i, u &= 65535, Ht(h << 16 | p, u << 16 | d, this.unsigned);
};
st.subtract = function(t) {
    return on(t) || (t = Hn(t)), this.add(t.neg());
};
st.sub = st.subtract;
st.multiply = function(t) {
    if (this.isZero()) return vn;
    if (on(t) || (t = Hn(t)), In) {
        var e = In.mul(this.low, this.high, t.low, t.high);
        return Ht(e, In.get_high(), this.unsigned);
    }
    if (t.isZero()) return vn;
    if (this.eq(je)) return t.isOdd() ? je : vn;
    if (t.eq(je)) return this.isOdd() ? je : vn;
    if (this.isNegative()) return t.isNegative() ? this.neg().mul(t.neg()) : this.neg().mul(t).neg();
    if (t.isNegative()) return this.mul(t.neg()).neg();
    if (this.lt(gm) && t.lt(gm)) return Cn(this.toNumber() * t.toNumber(), this.unsigned);
    var s = this.high >>> 16, o = this.high & 65535, r = this.low >>> 16, i = this.low & 65535, a = t.high >>> 16, l = t.high & 65535, c = t.low >>> 16, u = t.low & 65535, d = 0, h = 0, p = 0, f = 0;
    return f += i * u, p += f >>> 16, f &= 65535, p += r * u, h += p >>> 16, p &= 65535, p += i * c, h += p >>> 16, p &= 65535, h += o * u, d += h >>> 16, h &= 65535, h += r * c, d += h >>> 16, h &= 65535, h += i * l, d += h >>> 16, h &= 65535, d += s * u + o * c + r * l + i * a, d &= 65535, Ht(p << 16 | f, d << 16 | h, this.unsigned);
};
st.mul = st.multiply;
st.divide = function(t) {
    if (on(t) || (t = Hn(t)), t.isZero()) throw Error("division by zero");
    if (In) {
        if (!this.unsigned && this.high === -2147483648 && t.low === -1 && t.high === -1) return this;
        var e = (this.unsigned ? In.div_u : In.div_s)(this.low, this.high, t.low, t.high);
        return Ht(e, In.get_high(), this.unsigned);
    }
    if (this.isZero()) return this.unsigned ? mo : vn;
    var s, o, r;
    if (this.unsigned) {
        if (t.unsigned || (t = t.toUnsigned()), t.gt(this)) return mo;
        if (t.gt(this.shru(1))) return Tb;
        r = mo;
    } else {
        if (this.eq(je)) {
            if (t.eq(ir) || t.eq(dd)) return je;
            if (t.eq(je)) return ir;
            var i = this.shr(1);
            return s = i.div(t).shl(1), s.eq(vn) ? t.isNegative() ? ir : dd : (o = this.sub(t.mul(s)), r = s.add(o.div(t)), r);
        } else if (t.eq(je)) return this.unsigned ? mo : vn;
        if (this.isNegative()) return t.isNegative() ? this.neg().div(t.neg()) : this.neg().div(t).neg();
        if (t.isNegative()) return this.div(t.neg()).neg();
        r = vn;
    }
    for(o = this; o.gte(t);){
        s = Math.max(1, Math.floor(o.toNumber() / t.toNumber()));
        for(var a = Math.ceil(Math.log(s) / Math.LN2), l = a <= 48 ? 1 : xl(2, a - 48), c = Cn(s), u = c.mul(t); u.isNegative() || u.gt(o);)s -= l, c = Cn(s, this.unsigned), u = c.mul(t);
        c.isZero() && (c = ir), r = r.add(c), o = o.sub(u);
    }
    return r;
};
st.div = st.divide;
st.modulo = function(t) {
    if (on(t) || (t = Hn(t)), In) {
        var e = (this.unsigned ? In.rem_u : In.rem_s)(this.low, this.high, t.low, t.high);
        return Ht(e, In.get_high(), this.unsigned);
    }
    return this.sub(this.div(t).mul(t));
};
st.mod = st.modulo;
st.rem = st.modulo;
st.not = function() {
    return Ht(~this.low, ~this.high, this.unsigned);
};
st.and = function(t) {
    return on(t) || (t = Hn(t)), Ht(this.low & t.low, this.high & t.high, this.unsigned);
};
st.or = function(t) {
    return on(t) || (t = Hn(t)), Ht(this.low | t.low, this.high | t.high, this.unsigned);
};
st.xor = function(t) {
    return on(t) || (t = Hn(t)), Ht(this.low ^ t.low, this.high ^ t.high, this.unsigned);
};
st.shiftLeft = function(t) {
    return on(t) && (t = t.toInt()), (t &= 63) === 0 ? this : t < 32 ? Ht(this.low << t, this.high << t | this.low >>> 32 - t, this.unsigned) : Ht(0, this.low << t - 32, this.unsigned);
};
st.shl = st.shiftLeft;
st.shiftRight = function(t) {
    return on(t) && (t = t.toInt()), (t &= 63) === 0 ? this : t < 32 ? Ht(this.low >>> t | this.high << 32 - t, this.high >> t, this.unsigned) : Ht(this.high >> t - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
st.shr = st.shiftRight;
st.shiftRightUnsigned = function(t) {
    if (on(t) && (t = t.toInt()), t &= 63, t === 0) return this;
    var e = this.high;
    if (t < 32) {
        var s = this.low;
        return Ht(s >>> t | e << 32 - t, e >>> t, this.unsigned);
    } else return t === 32 ? Ht(e, 0, this.unsigned) : Ht(e >>> t - 32, 0, this.unsigned);
};
st.shru = st.shiftRightUnsigned;
st.shr_u = st.shiftRightUnsigned;
st.toSigned = function() {
    return this.unsigned ? Ht(this.low, this.high, !1) : this;
};
st.toUnsigned = function() {
    return this.unsigned ? this : Ht(this.low, this.high, !0);
};
st.toBytes = function(t) {
    return t ? this.toBytesLE() : this.toBytesBE();
};
st.toBytesLE = function() {
    var t = this.high, e = this.low;
    return [
        e & 255,
        e >>> 8 & 255,
        e >>> 16 & 255,
        e >>> 24,
        t & 255,
        t >>> 8 & 255,
        t >>> 16 & 255,
        t >>> 24
    ];
};
st.toBytesBE = function() {
    var t = this.high, e = this.low;
    return [
        t >>> 24,
        t >>> 16 & 255,
        t >>> 8 & 255,
        t & 255,
        e >>> 24,
        e >>> 16 & 255,
        e >>> 8 & 255,
        e & 255
    ];
};
Bt.fromBytes = function(t, e, s) {
    return s ? Bt.fromBytesLE(t, e) : Bt.fromBytesBE(t, e);
};
Bt.fromBytesLE = function(t, e) {
    return new Bt(t[0] | t[1] << 8 | t[2] << 16 | t[3] << 24, t[4] | t[5] << 8 | t[6] << 16 | t[7] << 24, e);
};
Bt.fromBytesBE = function(t, e) {
    return new Bt(t[4] << 24 | t[5] << 16 | t[6] << 8 | t[7], t[0] << 24 | t[1] << 16 | t[2] << 8 | t[3], e);
};
const $b = /* @__PURE__ */ e2(Sb), o2 = /* @__PURE__ */ DC({
    __proto__: null,
    default: $b
}, [
    Sb
]);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const uo = // tslint:disable-next-line
$b || o2;
function xa(n) {
    return uo.fromString(n, !0, 16);
}
const Gb = xa("c3a5c85c97cb3127"), co = xa("b492b66fbe98f273"), De = xa("9ae16a3b2f90404f");
function hd(n) {
    return n.xor(n.shru(47));
}
function Eb(n, t, e) {
    const s = n.slice(t, t + e);
    return uo.fromBytes(Array.from(s), !0, !0);
}
function Xt(n, t) {
    return Eb(n, t, 8);
}
function bm(n, t) {
    return Eb(n, t, 4);
}
function ge(n, t) {
    return t === 0 ? n : n.shru(t).or(n.shl(64 - t));
}
function zs(n, t, e = xa("9ddfea08eb382d69")) {
    let s = n.xor(t).mul(e);
    s = s.xor(s.shru(47));
    let o = t.xor(s).mul(e);
    return o = o.xor(o.shru(47)), o = o.mul(e), o;
}
function r2(n, t, e, s, o, r) {
    o = o.add(n), r = ge(r.add(o).add(s), 21);
    const i = o;
    return o = o.add(t), o = o.add(e), r = r.add(ge(o, 44)), [
        o.add(s),
        r.add(i)
    ];
}
function Za(n, t, e, s) {
    return r2(Xt(n, t), Xt(n, t + 8), Xt(n, t + 16), Xt(n, t + 24), e, s);
}
function i2(n, t = n.length) {
    if (t >= 8) {
        const e = De.add(t * 2), s = Xt(n, 0).add(De), o = Xt(n, t - 8), r = ge(o, 37).mul(e).add(s), i = ge(s, 25).add(o).mul(e);
        return zs(r, i, e);
    }
    if (t >= 4) {
        const e = De.add(t * 2), s = bm(n, 0);
        return zs(s.shl(3).add(t), bm(n, t - 4), e);
    }
    if (t > 0) {
        const e = n[0], s = n[t >> 1], o = n[t - 1], r = e + (s << 8), i = t + (o << 2);
        return hd(De.mul(r).xor(Gb.mul(i))).mul(De);
    }
    return De;
}
function a2(n, t = n.length) {
    const e = De.add(t * 2), s = Xt(n, 0).mul(co), o = Xt(n, 8), r = Xt(n, t - 8).mul(e), i = Xt(n, t - 16).mul(De);
    return zs(ge(s.add(o), 43).add(ge(r, 30)).add(i), s.add(ge(o.add(De), 18)).add(r), e);
}
function l2(n, t = n.length) {
    const e = De.add(t * 2), s = Xt(n, 0).mul(De), o = Xt(n, 8), r = Xt(n, t - 8).mul(e), i = Xt(n, t - 16).mul(De), a = ge(s.add(o), 43).add(ge(r, 30)).add(i), l = zs(a, s.add(ge(o.add(De), 18)).add(r), e), c = Xt(n, 16).mul(e), u = Xt(n, 24), d = a.add(Xt(n, t - 32)).mul(e), h = l.add(Xt(n, t - 24)).mul(e);
    return zs(ge(c.add(u), 43).add(ge(d, 30)).add(h), c.add(ge(u.add(s), 18)).add(d), e);
}
function Lb(n, t = n.length) {
    const e = uo.fromNumber(81, !0);
    if (t <= 32) return t <= 16 ? i2(n, t) : a2(n, t);
    if (t <= 64) return l2(n, t);
    let s = e, o = e.mul(co).add(113), r = hd(o.mul(De).add(113)).mul(De), i = [
        uo.UZERO,
        uo.UZERO
    ], a = [
        uo.UZERO,
        uo.UZERO
    ];
    s = s.mul(De).add(Xt(n, 0));
    let l = 0;
    const c = (t - 1 >> 6) * 64, u = c + (t - 1 & 63) - 63;
    do s = ge(s.add(o).add(i[0]).add(Xt(n, l + 8)), 37).mul(co), o = ge(o.add(i[1]).add(Xt(n, l + 48)), 42).mul(co), s = s.xor(a[1]), o = o.add(i[0]).add(Xt(n, l + 40)), r = ge(r.add(a[0]), 33).mul(co), i = Za(n, l, i[1].mul(co), s.add(a[0])), a = Za(n, l + 32, r.add(a[1]), o.add(Xt(n, l + 16))), [r, s] = [
        s,
        r
    ], l += 64;
    while (l !== c);
    const d = co.add(r.and(255).shl(1));
    return l = u, a[0] = a[0].add(t - 1 & 63), i[0] = i[0].add(a[0]), a[0] = a[0].add(i[0]), s = ge(s.add(o).add(i[0]).add(Xt(n, l + 8)), 37).mul(d), o = ge(o.add(i[1]).add(Xt(n, l + 48)), 42).mul(d), s = s.xor(a[1].mul(9)), o = o.add(i[0].mul(9).add(Xt(n, l + 40))), r = ge(r.add(a[0]), 33).mul(d), i = Za(n, l, i[1].mul(d), s.add(a[0])), a = Za(n, l + 32, r.add(a[1]), o.add(Xt(n, l + 16))), [r, s] = [
        s,
        r
    ], zs(zs(i[0], a[0], d).add(hd(o).mul(Gb)).add(r), zs(i[1], a[1], d).add(s), d);
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Is(n, t) {
    return t === "string" ? ms(n) : Qs([
        n
    ], t);
}
function c2(n, t) {
    return n instanceof Float32Array && t === "float32" || n instanceof Int32Array && t === "int32" || n instanceof Uint8Array && t === "bool";
}
function Qs(n, t) {
    if (t === "string") throw new Error("Cannot convert a string[] to a TypedArray");
    if (Array.isArray(n) && (n = Ks(n)), F().getBool("DEBUG") && eb(n, t), c2(n, t)) return n;
    if (t == null || t === "float32" || t === "complex64") return new Float32Array(n);
    if (t === "int32") return new Int32Array(n);
    if (t === "bool") {
        const e = new Uint8Array(n.length);
        for(let s = 0; s < e.length; ++s)Math.round(n[s]) !== 0 && (e[s] = 1);
        return e;
    } else throw new Error(`Unknown data type ${t}`);
}
function Ie() {
    return F().platform.now();
}
function u2(n, t) {
    return F().platform.fetch(n, t);
}
function ms(n, t = "utf-8") {
    return t = t || "utf-8", F().platform.encode(n, t);
}
function gs(n, t = "utf-8") {
    return t = t || "utf-8", F().platform.decode(n, t);
}
function qe(n) {
    return F().platform.isTypedArray != null ? F().platform.isTypedArray(n) : vb(n);
}
function Ks(n, t = [], e = !1) {
    if (t == null && (t = []), typeof n == "boolean" || typeof n == "number" || typeof n == "string" || Ci(n) || n == null || qe(n) && e) t.push(n);
    else if (Array.isArray(n) || qe(n)) for(let s = 0; s < n.length; ++s)Ks(n[s], t, e);
    else {
        let s = -1;
        for (const o of Object.keys(n))/^([1-9]+[0-9]*|0)$/.test(o) && (s = Math.max(s, Number(o)));
        for(let o = 0; o <= s; o++)Ks(n[o], t, e);
    }
    return t;
}
const QY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    arraysEqual: $t,
    arraysEqualWithNull: XC,
    assert: C,
    assertNonNegativeIntegerDimensions: is,
    assertNonNull: Hl,
    assertShapesMatch: Pe,
    bytesFromStringArray: sb,
    bytesPerElement: ri,
    checkConversionForErrors: eb,
    clamp: Os,
    computeStrides: dt,
    convertBackendValuesAndArrayBuffer: ib,
    createScalarValue: Is,
    createShuffledIndices: ZC,
    decodeString: gs,
    distSquared: AC,
    encodeString: ms,
    fetch: u2,
    fingerPrint64: Lb,
    flatten: Ks,
    getArrayFromDType: ne,
    getTypedArrayFromDType: Se,
    hasEncodingLoss: Qd,
    hexToLong: xa,
    indexToLoc: Xo,
    inferDtype: Oo,
    inferFromImplicitShape: Yd,
    isBoolean: ob,
    isFunction: Xs,
    isInt: Co,
    isNumber: pl,
    isPromise: Ci,
    isScalarShape: OC,
    isString: vr,
    isTypedArray: qe,
    isValidDtype: nb,
    locToIndex: zn,
    makeOnesTypedArray: _l,
    makeZerosNestedTypedArray: Jd,
    makeZerosTypedArray: ke,
    nearestDivisor: fl,
    nearestLargerEven: Bl,
    now: Ie,
    parseAxisParam: Ct,
    randUniform: PC,
    repeatedTry: id,
    rightPad: xo,
    shuffle: Ud,
    shuffleCombo: zC,
    sizeFromShape: X,
    sizeToSquarishShape: hl,
    squeezeShape: ws,
    sum: tb,
    swap: ds,
    tanh: KC,
    toNestedArray: kn,
    toTypedArray: Qs
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class d2 {
    constructor(t, e){
        this.backendTimer = t, this.logger = e, e == null && (this.logger = new p2());
    }
    profileKernel(t, e, s) {
        let o;
        const r = ()=>{
            o = s();
        };
        let i;
        const a = Ie();
        if (this.backendTimer.timerAvailable()) i = this.backendTimer.time(r);
        else {
            r();
            for (const c of o)c.dataSync();
            i = Promise.resolve({
                kernelMs: Ie() - a
            });
        }
        if (F().getBool("CHECK_COMPUTATION_FOR_ERRORS")) for(let c = 0; c < o.length; c++){
            const u = o[c];
            u.data().then((d)=>{
                h2(d, u.dtype, t);
            });
        }
        return {
            kernelName: t,
            outputs: o,
            inputs: e,
            timeMs: i.then((c)=>c.kernelMs),
            extraInfo: i.then((c)=>c.getExtraProfileInfo != null ? c.getExtraProfileInfo() : "")
        };
    }
    logKernelProfile(t) {
        const { kernelName: e, outputs: s, timeMs: o, inputs: r, extraInfo: i } = t;
        s.forEach((a)=>{
            Promise.all([
                a.data(),
                o,
                i
            ]).then((l)=>{
                this.logger.logKernelProfile(e, a, l[0], l[1], r, l[2]);
            });
        });
    }
}
function h2(n, t, e) {
    if (t !== "float32") return !1;
    for(let s = 0; s < n.length; s++){
        const o = n[s];
        if (isNaN(o) || !isFinite(o)) return console.warn(`Found ${o} in the result of '${e}'`), !0;
    }
    return !1;
}
class p2 {
    logKernelProfile(t, e, s, o, r, i) {
        const a = typeof o == "number" ? xo(`${o}ms`, 9) : o.error, l = xo(t, 25), c = e.rank, u = e.size, d = xo(e.shape.toString(), 14);
        let h = "";
        for(const p in r){
            const f = r[p];
            if (f != null) {
                const m = f.shape || e.shape, g = m.length;
                h += `${p}: ${g}D ${g > 0 ? m : ""} `;
            }
        }
        console.log(`%c${l}	%c${a}	%c${c}D ${d}	%c${u}	%c${h}	%c${i}`, "font-weight:bold", "color:red", "color:blue", "color: orange", "color: green", "color: steelblue");
    }
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function f2(n, t, e) {
    const s = {}, o = {};
    for(let l = 0; l < t.length; l++)s[t[l].id] = !0;
    for(let l = 0; l < n.length; l++){
        const c = n[l], u = c.inputs;
        for(const d in u){
            const h = u[d];
            let p = !1;
            for(let f = 0; f < t.length; f++)if (s[h.id]) {
                c.outputs.forEach((m)=>s[m.id] = !0), p = !0, o[c.id] = !0;
                break;
            }
            if (p) break;
        }
    }
    const r = {};
    r[e.id] = !0;
    const i = {};
    for(let l = n.length - 1; l >= 0; l--){
        const c = n[l], u = c.inputs;
        for(let d = 0; d < c.outputs.length; d++)if (r[c.outputs[d].id]) {
            for(const h in u)r[u[h].id] = !0, i[c.id] = !0;
            break;
        }
    }
    const a = [];
    for(let l = 0; l < n.length; l++){
        const c = n[l];
        if (o[c.id] && i[c.id]) {
            const u = {};
            for(const h in c.inputs){
                const p = c.inputs[h];
                s[p.id] && (u[h] = p);
            }
            const d = Object.assign({}, c);
            d.inputs = u, d.outputs = c.outputs, a.push(d);
        }
    }
    return a;
}
function m2(n, t, e, s) {
    for(let o = t.length - 1; o >= 0; o--){
        const r = t[o], i = [];
        if (r.outputs.forEach((l)=>{
            const c = n[l.id];
            c != null ? i.push(c) : i.push(null);
        }), r.gradient == null) throw new Error(`Cannot compute gradient: gradient function not found for ${r.kernelName}.`);
        const a = r.gradient(i);
        for(const l in r.inputs){
            if (!(l in a)) throw new Error(`Cannot backprop through input ${l}. Available gradients found: ${Object.keys(a)}.`);
            const c = e(()=>a[l]());
            if (c.dtype !== "float32") throw new Error(`Error in gradient for op ${r.kernelName}. The gradient of input ${l} must have 'float32' dtype, but has '${c.dtype}'`);
            const u = r.inputs[l];
            if (!$t(c.shape, u.shape)) throw new Error(`Error in gradient for op ${r.kernelName}. The gradient of input '${l}' has shape '${c.shape}', which does not match the shape of the input '${u.shape}'`);
            if (n[u.id] == null) n[u.id] = c;
            else {
                const d = n[u.id];
                n[u.id] = s(d, c), d.dispose();
            }
        }
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const xm = 20, Ar = 3, Gu = 7;
function g2(n, t, e, s) {
    const o = dt(t), r = b2(n, t, e, o), i = t.length, a = ol(n, t, e, o, r), l = [
        "Tensor"
    ];
    return s && (l.push(`  dtype: ${e}`), l.push(`  rank: ${i}`), l.push(`  shape: [${t}]`), l.push("  values:")), l.push(a.map((c)=>"    " + c).join(`
`)), l.join(`
`);
}
function b2(n, t, e, s) {
    const o = X(t), r = s[s.length - 1], i = new Array(r).fill(0), a = t.length, l = e === "complex64" ? Ur(n) : n;
    if (a > 1) for(let c = 0; c < o / r; c++){
        const u = c * r;
        for(let d = 0; d < r; d++)i[d] = Math.max(i[d], _r(l[u + d], 0, e).length);
    }
    return i;
}
function _r(n, t, e) {
    let s;
    return Array.isArray(n) ? s = `${parseFloat(n[0].toFixed(Gu))} + ${parseFloat(n[1].toFixed(Gu))}j` : vr(n) ? s = `'${n}'` : e === "bool" ? s = Mb(n) : s = parseFloat(n.toFixed(Gu)).toString(), xo(s, t);
}
function Mb(n) {
    return n === 0 ? "false" : "true";
}
function ol(n, t, e, s, o, r = !0) {
    const i = e === "complex64" ? 2 : 1, a = t[0], l = t.length;
    if (l === 0) {
        if (e === "complex64") {
            const m = Ur(n);
            return [
                _r(m[0], 0, e)
            ];
        }
        return e === "bool" ? [
            Mb(n[0])
        ] : [
            n[0].toString()
        ];
    }
    if (l === 1) {
        if (a > xm) {
            const g = Ar * i;
            let b = Array.from(n.slice(0, g)), x = Array.from(n.slice((a - Ar) * i, a * i));
            return e === "complex64" && (b = Ur(b), x = Ur(x)), [
                "[" + b.map((w, y)=>_r(w, o[y], e)).join(", ") + ", ..., " + x.map((w, y)=>_r(w, o[a - Ar + y], e)).join(", ") + "]"
            ];
        }
        return [
            "[" + (e === "complex64" ? Ur(n) : Array.from(n)).map((g, b)=>_r(g, o[b], e)).join(", ") + "]"
        ];
    }
    const c = t.slice(1), u = s.slice(1), d = s[0] * i, h = [];
    if (a > xm) {
        for(let m = 0; m < Ar; m++){
            const g = m * d, b = g + d;
            h.push(...ol(n.slice(g, b), c, e, u, o, !1));
        }
        h.push("...");
        for(let m = a - Ar; m < a; m++){
            const g = m * d, b = g + d;
            h.push(...ol(n.slice(g, b), c, e, u, o, m === a - 1));
        }
    } else for(let m = 0; m < a; m++){
        const g = m * d, b = g + d;
        h.push(...ol(n.slice(g, b), c, e, u, o, m === a - 1));
    }
    const p = l === 2 ? "," : "";
    h[0] = "[" + (a > 0 ? h[0] + p : "");
    for(let m = 1; m < h.length - 1; m++)h[m] = " " + h[m] + p;
    let f = `,
`;
    for(let m = 2; m < l; m++)f += `
`;
    return h[h.length - 1] = " " + h[h.length - 1] + "]" + (r ? "" : f), h;
}
function Ur(n) {
    const t = [];
    for(let e = 0; e < n.length; e += 2)t.push([
        n[e],
        n[e + 1]
    ]);
    return t;
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class ve {
    constructor(t, e, s){
        if (this.dtype = e, this.shape = t.slice(), this.size = X(t), s != null) {
            const o = s.length;
            C(o === this.size, ()=>`Length of values '${o}' does not match the size inferred by the shape '${this.size}'.`);
        }
        if (e === "complex64") throw new Error("complex64 dtype TensorBuffers are not supported. Please create a TensorBuffer for the real and imaginary parts separately and call tf.complex(real, imag).");
        this.values = s || ne(e, this.size), this.strides = dt(t);
    }
    /**
   * Sets a value in the buffer at a given location.
   *
   * @param value The value to set.
   * @param locs  The location indices.
   *
   * @doc {heading: 'Tensors', subheading: 'Creation'}
   */ set(t, ...e) {
        e.length === 0 && (e = [
            0
        ]), C(e.length === this.rank, ()=>`The number of provided coordinates (${e.length}) must match the rank (${this.rank})`);
        const s = this.locToIndex(e);
        this.values[s] = t;
    }
    /**
   * Returns the value in the buffer at the provided location.
   *
   * @param locs The location indices.
   *
   * @doc {heading: 'Tensors', subheading: 'Creation'}
   */ get(...t) {
        t.length === 0 && (t = [
            0
        ]);
        let e = 0;
        for (const o of t){
            if (o < 0 || o >= this.shape[e]) {
                const r = `Requested out of range element at ${t}.   Buffer shape=${this.shape}`;
                throw new Error(r);
            }
            e++;
        }
        let s = t[t.length - 1];
        for(let o = 0; o < t.length - 1; ++o)s += this.strides[o] * t[o];
        return this.values[s];
    }
    locToIndex(t) {
        if (this.rank === 0) return 0;
        if (this.rank === 1) return t[0];
        let e = t[t.length - 1];
        for(let s = 0; s < t.length - 1; ++s)e += this.strides[s] * t[s];
        return e;
    }
    indexToLoc(t) {
        if (this.rank === 0) return [];
        if (this.rank === 1) return [
            t
        ];
        const e = new Array(this.shape.length);
        for(let s = 0; s < e.length - 1; ++s)e[s] = Math.floor(t / this.strides[s]), t -= e[s] * this.strides[s];
        return e[e.length - 1] = t, e;
    }
    get rank() {
        return this.shape.length;
    }
    /**
   * Creates an immutable `tf.Tensor` object from the buffer.
   *
   * @doc {heading: 'Tensors', subheading: 'Creation'}
   */ toTensor() {
        return Dn().makeTensor(this.values, this.shape, this.dtype);
    }
}
let Dn = null, or = null;
function x2(n) {
    Dn = n;
}
function y2(n) {
    or = n;
}
class Mt {
    constructor(t, e, s, o){
        this.kept = !1, this.isDisposedInternal = !1, this.shape = t.slice(), this.dtype = e || "float32", this.size = X(t), this.strides = dt(t), this.dataId = s, this.id = o, this.rankType = this.rank < 5 ? this.rank.toString() : "higher";
    }
    get rank() {
        return this.shape.length;
    }
    /**
   * Returns a promise of `tf.TensorBuffer` that holds the underlying data.
   *
   * @doc {heading: 'Tensors', subheading: 'Classes'}
   */ async buffer() {
        const t = await this.data();
        return or.buffer(this.shape, this.dtype, t);
    }
    /**
   * Returns a `tf.TensorBuffer` that holds the underlying data.
   * @doc {heading: 'Tensors', subheading: 'Classes'}
   */ bufferSync() {
        return or.buffer(this.shape, this.dtype, this.dataSync());
    }
    /**
   * Returns the tensor data as a nested array. The transfer of data is done
   * asynchronously.
   *
   * @doc {heading: 'Tensors', subheading: 'Classes'}
   */ async array() {
        const t = await this.data();
        return kn(this.shape, t, this.dtype === "complex64");
    }
    /**
   * Returns the tensor data as a nested array. The transfer of data is done
   * synchronously.
   *
   * @doc {heading: 'Tensors', subheading: 'Classes'}
   */ arraySync() {
        return kn(this.shape, this.dataSync(), this.dtype === "complex64");
    }
    /**
   * Asynchronously downloads the values from the `tf.Tensor`. Returns a
   * promise of `TypedArray` that resolves when the computation has finished.
   *
   * @doc {heading: 'Tensors', subheading: 'Classes'}
   */ async data() {
        this.throwIfDisposed();
        const t = Dn().read(this.dataId);
        if (this.dtype === "string") {
            const e = await t;
            try {
                return e.map((s)=>gs(s));
            } catch  {
                throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
            }
        }
        return t;
    }
    /**
   * Copy the tensor's data to a new GPU resource. Comparing to the `dataSync()`
   * and `data()`, this method prevents data from being downloaded to CPU.
   *
   * For WebGL backend, the data will be stored on a densely packed texture.
   * This means that the texture will use the RGBA channels to store value.
   *
   * For WebGPU backend, the data will be stored on a buffer. There is no
   * parameter, so can not use a user-defined size to create the buffer.
   *
   * @param options:
   *     For WebGL,
   *         - customTexShape: Optional. If set, will use the user defined
   *     texture shape to create the texture.
   *
   * @returns For WebGL backend, a GPUData contains the new texture and
   *     its information.
   *     {
   *        tensorRef: The tensor that is associated with this texture,
   *        texture: WebGLTexture,
   *        texShape: [number, number] // [height, width]
   *     }
   *
   *     For WebGPU backend, a GPUData contains the new buffer.
   *     {
   *        tensorRef: The tensor that is associated with this buffer,
   *        buffer: GPUBuffer,
   *     }
   *
   *     Remember to dispose the GPUData after it is used by
   *     `res.tensorRef.dispose()`.
   *
   * @doc {heading: 'Tensors', subheading: 'Classes'}
   */ dataToGPU(t) {
        return this.throwIfDisposed(), Dn().readToGPU(this.dataId, t);
    }
    /**
   * Synchronously downloads the values from the `tf.Tensor`. This blocks the
   * UI thread until the values are ready, which can cause performance issues.
   *
   * @doc {heading: 'Tensors', subheading: 'Classes'}
   */ dataSync() {
        this.throwIfDisposed();
        const t = Dn().readSync(this.dataId);
        if (this.dtype === "string") try {
            return t.map((e)=>gs(e));
        } catch  {
            throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
        }
        return t;
    }
    /** Returns the underlying bytes of the tensor's data. */ async bytes() {
        this.throwIfDisposed();
        const t = await Dn().read(this.dataId);
        return this.dtype === "string" ? t : new Uint8Array(t.buffer);
    }
    /**
   * Disposes `tf.Tensor` from memory.
   *
   * @doc {heading: 'Tensors', subheading: 'Classes'}
   */ dispose() {
        this.isDisposed || (this.kerasMask && this.kerasMask.dispose(), Dn().disposeTensor(this), this.isDisposedInternal = !0);
    }
    get isDisposed() {
        return this.isDisposedInternal;
    }
    throwIfDisposed() {
        if (this.isDisposed) throw new Error("Tensor is disposed.");
    }
    /**
   * Prints the `tf.Tensor`. See `tf.print` for details.
   *
   * @param verbose Whether to print verbose information about the tensor,
   *    including dtype and size.
   *
   * @doc {heading: 'Tensors', subheading: 'Classes'}
   */ print(t = !1) {
        return or.print(this, t);
    }
    /**
   * Returns a copy of the tensor. See `tf.clone` for details.
   * @doc {heading: 'Tensors', subheading: 'Classes'}
   */ clone() {
        return this.throwIfDisposed(), or.clone(this);
    }
    /**
   * Returns a human-readable description of the tensor. Useful for logging.
   *
   * @doc {heading: 'Tensors', subheading: 'Classes'}
   */ toString(t = !1) {
        const e = this.dataSync();
        return g2(e, this.shape, this.dtype, t);
    }
    cast(t) {
        return this.throwIfDisposed(), or.cast(this, t);
    }
    variable(t = !0, e, s) {
        return this.throwIfDisposed(), Dn().makeVariable(this, t, e, s);
    }
}
Object.defineProperty(Mt, Symbol.hasInstance, {
    value: (n)=>!!n && n.data != null && n.dataSync != null && n.throwIfDisposed != null
});
function K() {
    return jd("Tensor", ()=>Mt);
}
K();
class yl extends Mt {
    constructor(t, e, s, o){
        super(t.shape, t.dtype, t.dataId, o), this.trainable = e, this.name = s;
    }
    /**
   * Assign a new `tf.Tensor` to this variable. The new `tf.Tensor` must have
   * the same shape and dtype as the old `tf.Tensor`.
   *
   * @param newValue New tensor to be assigned to this variable.
   *
   * @doc {heading: 'Tensors', subheading: 'Classes'}
   */ assign(t) {
        if (t.dtype !== this.dtype) throw new Error(`dtype of the new value (${t.dtype}) and previous value (${this.dtype}) must match`);
        if (!$t(t.shape, this.shape)) throw new Error(`shape of the new value (${t.shape}) and previous value (${this.shape}) must match`);
        Dn().disposeTensor(this), this.dataId = t.dataId, Dn().incRef(this, null);
    }
    dispose() {
        Dn().disposeVariable(this), this.isDisposedInternal = !0;
    }
}
Object.defineProperty(yl, Symbol.hasInstance, {
    value: (n)=>n instanceof Mt && n.assign != null && n.assign instanceof Function
});
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var ym;
(function(n) {
    n.R0 = "R0", n.R1 = "R1", n.R2 = "R2", n.R3 = "R3", n.R4 = "R4", n.R5 = "R5", n.R6 = "R6";
})(ym || (ym = {}));
var pd;
(function(n) {
    n.float32 = "float32", n.int32 = "int32", n.bool = "int32", n.complex64 = "complex64";
})(pd || (pd = {}));
var fd;
(function(n) {
    n.float32 = "float32", n.int32 = "int32", n.bool = "bool", n.complex64 = "complex64";
})(fd || (fd = {}));
var md;
(function(n) {
    n.float32 = "float32", n.int32 = "float32", n.bool = "float32", n.complex64 = "complex64";
})(md || (md = {}));
var gd;
(function(n) {
    n.float32 = "complex64", n.int32 = "complex64", n.bool = "complex64", n.complex64 = "complex64";
})(gd || (gd = {}));
const w2 = {
    float32: md,
    int32: pd,
    bool: fd,
    complex64: gd
};
function tn(n, t) {
    if (n === "string" || t === "string") {
        if (n === "string" && t === "string") return "string";
        throw new Error(`Can not upcast ${n} with ${t}`);
    }
    return w2[n][t];
}
function Yh(n) {
    return tn(n, "int32");
}
function Wb(n) {
    return n != null && typeof n == "object" && "texture" in n && n.texture instanceof WebGLTexture;
}
function Db(n) {
    return typeof GPUBuffer < "u" && n != null && typeof n == "object" && "buffer" in n && n.buffer instanceof GPUBuffer;
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function se(n, t) {
    if (n.dtype === t.dtype) return [
        n,
        t
    ];
    const e = tn(n.dtype, t.dtype);
    return [
        n.cast(e),
        t.cast(e)
    ];
}
function I2(n, t) {
    C(n.dtype === t.dtype, ()=>`The dtypes of the first(${n.dtype}) and second(${t.dtype}) input must match`);
}
function Yc(n, t) {
    return t.some((e)=>e.id === n.id);
}
function bs(n) {
    const t = [];
    return Fb(n, t, /* @__PURE__ */ new Set()), t;
}
function Fb(n, t, e) {
    if (n == null) return;
    if (n instanceof Mt) {
        t.push(n);
        return;
    }
    if (!C2(n)) return;
    const s = n;
    for(const o in s){
        const r = s[o];
        e.has(r) || (e.add(r), Fb(r, t, e));
    }
}
function C2(n) {
    return Array.isArray(n) || typeof n == "object";
}
const JY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    assertTypesMatch: I2,
    getTensorsInContainer: bs,
    isTensorInList: Yc,
    makeTypesMatch: se
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Eu(n) {
    return n.kernelName != null;
}
class wm {
    constructor(){
        this.registeredVariables = {}, this.nextTapeNodeId = 0, this.numBytes = 0, this.numTensors = 0, this.numStringTensors = 0, this.numDataBuffers = 0, this.gradientDepth = 0, this.kernelDepth = 0, this.scopeStack = [], this.numDataMovesStack = [], this.nextScopeId = 0, this.tensorInfo = /* @__PURE__ */ new WeakMap(), this.profiling = !1, this.activeProfile = {
            newBytes: 0,
            newTensors: 0,
            peakBytes: 0,
            kernels: [],
            result: null,
            get kernelNames () {
                return Array.from(new Set(this.kernels.map((t)=>t.name)));
            }
        };
    }
    dispose() {
        for(const t in this.registeredVariables)this.registeredVariables[t].dispose();
    }
}
class mr {
    constructor(t){
        this.ENV = t, this.registry = {}, this.registryFactory = {}, this.pendingBackendInitId = 0, this.state = new wm();
    }
    async ready() {
        if (this.pendingBackendInit != null) return this.pendingBackendInit.then(()=>{});
        if (this.backendInstance != null) return;
        const t = this.getSortedBackends();
        for(let e = 0; e < t.length; e++){
            const s = t[e];
            if (await this.initializeBackend(s).success) {
                await this.setBackend(s);
                return;
            }
        }
        throw new Error("Could not initialize any backends, all backend initializations failed.");
    }
    get backend() {
        if (this.pendingBackendInit != null) throw new Error(`Backend '${this.backendName}' has not yet been initialized. Make sure to await tf.ready() or await tf.setBackend() before calling other methods`);
        if (this.backendInstance == null) {
            const { name: t, asyncInit: e } = this.initializeBackendsAndReturnBest();
            if (e) throw new Error(`The highest priority backend '${t}' has not yet been initialized. Make sure to await tf.ready() or await tf.setBackend() before calling other methods`);
            this.setBackend(t);
        }
        return this.backendInstance;
    }
    backendNames() {
        return Object.keys(this.registryFactory);
    }
    findBackend(t) {
        if (!(t in this.registry)) {
            if (t in this.registryFactory) {
                const { asyncInit: e } = this.initializeBackend(t);
                if (e) return null;
            } else return null;
        }
        return this.registry[t];
    }
    findBackendFactory(t) {
        return t in this.registryFactory ? this.registryFactory[t].factory : null;
    }
    registerBackend(t, e, s = 1) {
        return t in this.registryFactory ? (ln(`${t} backend was already registered. Reusing existing backend factory.`), !1) : (this.registryFactory[t] = {
            factory: e,
            priority: s
        }, !0);
    }
    async setBackend(t) {
        if (this.registryFactory[t] == null) throw new Error(`Backend name '${t}' not found in registry`);
        if (this.backendName = t, this.registry[t] == null) {
            this.backendInstance = null;
            const { success: e, asyncInit: s } = this.initializeBackend(t);
            if (!(s ? await e : e)) return !1;
        }
        return this.backendInstance = this.registry[t], this.setupRegisteredKernels(), this.profiler = new d2(this.backendInstance), !0;
    }
    setupRegisteredKernels() {
        ud(this.backendName).forEach((e)=>{
            e.setupFunc != null && e.setupFunc(this.backendInstance);
        });
    }
    disposeRegisteredKernels(t) {
        ud(t).forEach((s)=>{
            s.disposeFunc != null && s.disposeFunc(this.registry[t]);
        });
    }
    /**
   * Initializes a backend by looking up the backend name in the factory
   * registry and calling the factory method. Returns a boolean representing
   * whether the initialization of the backend suceeded. Throws an error if
   * there is no backend in the factory registry.
   */ initializeBackend(t) {
        const e = this.registryFactory[t];
        if (e == null) throw new Error(`Cannot initialize backend ${t}, no registration found.`);
        try {
            const s = e.factory();
            if (s && !(s instanceof _d) && typeof s.then == "function") {
                const o = ++this.pendingBackendInitId, r = s.then((i)=>o < this.pendingBackendInitId ? !1 : (this.registry[t] = i, this.pendingBackendInit = null, !0)).catch((i)=>(o < this.pendingBackendInitId || (this.pendingBackendInit = null, ln(`Initialization of backend ${t} failed`), ln(i.stack || i.message)), !1));
                return this.pendingBackendInit = r, {
                    success: r,
                    asyncInit: !0
                };
            } else return this.registry[t] = s, {
                success: !0,
                asyncInit: !1
            };
        } catch (s) {
            return ln(`Initialization of backend ${t} failed`), ln(s.stack || s.message), {
                success: !1,
                asyncInit: !1
            };
        }
    }
    removeBackend(t) {
        if (!(t in this.registryFactory)) throw new Error(`${t} backend not found in registry`);
        this.backendName === t && this.pendingBackendInit != null && this.pendingBackendInitId++, t in this.registry && (this.disposeRegisteredKernels(t), this.registry[t].dispose(), delete this.registry[t]), delete this.registryFactory[t], this.backendName === t && (this.pendingBackendInit = null, this.backendName = null, this.backendInstance = null);
    }
    getSortedBackends() {
        if (Object.keys(this.registryFactory).length === 0) throw new Error("No backend found in registry.");
        return Object.keys(this.registryFactory).sort((t, e)=>this.registryFactory[e].priority - this.registryFactory[t].priority);
    }
    initializeBackendsAndReturnBest() {
        const t = this.getSortedBackends();
        for(let e = 0; e < t.length; e++){
            const s = t[e], { success: o, asyncInit: r } = this.initializeBackend(s);
            if (r || o) return {
                name: s,
                asyncInit: r
            };
        }
        throw new Error("Could not initialize any backends, all backend initializations failed.");
    }
    moveData(t, e) {
        const s = this.state.tensorInfo.get(e), o = s.backend, r = this.readSync(e), i = o.refCount(e);
        o.disposeData(e, !0), s.backend = t, t.move(e, r, s.shape, s.dtype, i), this.shouldCheckForMemLeaks() && this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1]++;
    }
    tidy(t, e) {
        let s = null;
        if (e == null) {
            if (typeof t != "function") throw new Error("Please provide a function to tidy()");
            e = t;
        } else {
            if (typeof t != "string" && !(t instanceof String)) throw new Error("When calling with two arguments, the first argument to tidy() must be a string");
            if (typeof e != "function") throw new Error("When calling with two arguments, the 2nd argument to tidy() must be a function");
            s = t;
        }
        let o;
        return this.scopedRun(()=>this.startScope(s), ()=>this.endScope(o), ()=>(o = e(), o instanceof Promise && console.error("Cannot return a Promise inside of tidy."), o));
    }
    scopedRun(t, e, s) {
        t();
        try {
            const o = s();
            return e(), o;
        } catch (o) {
            throw e(), o;
        }
    }
    nextTensorId() {
        return mr.nextTensorId++;
    }
    nextVariableId() {
        return mr.nextVariableId++;
    }
    /**
   * This method is called instead of the public-facing tensor.clone() when
   * saving a tensor for backwards pass. It makes sure to add the clone
   * operation to the tape regardless of being called inside a kernel
   * execution.
   */ clone(t) {
        const e = $.runKernel(Ki, {
            x: t
        }), s = {
            x: t
        }, o = (i)=>({
                x: ()=>{
                    const a = "float32", l = {
                        x: i
                    }, c = {
                        dtype: a
                    };
                    return $.runKernel(Gi, l, // tslint:disable-next-line: no-unnecessary-type-assertion
                    c);
                }
            }), r = [];
        return this.addTapeNode(this.state.activeScope.name, s, [
            e
        ], o, r, {}), e;
    }
    /**
   * Execute a kernel with the given name and return the output tensor.
   *
   * @param kernelName The name of the kernel to execute.
   * @param inputs A map of input names to tensors.
   * @param attrs A map of attribute names to their values. An attribute is a
   *     primitive (non-tensor) input to the kernel.
   * @param inputsToSave A list of tensors, inputs to save for the backprop
   *     computation.
   * @param outputsToSave A list of booleans, specifying which output to save
   *     for the backprop computation. These are booleans since the output
   * tensors are not visible to the user.
   */ runKernel(t, e, s) {
        if (this.backendName == null && this.backend, !(bl(t, this.backendName) != null)) throw new Error(`Kernel '${t}' not registered for backend '${this.backendName}'`);
        return this.runKernelFunc({
            kernelName: t,
            inputs: e,
            attrs: s
        });
    }
    shouldCheckForMemLeaks() {
        return this.ENV.getBool("IS_TEST");
    }
    checkKernelForMemLeak(t, e, s) {
        const o = this.backend.numDataIds();
        let r = 0;
        s.forEach((l)=>{
            r += l.dtype === "complex64" ? 3 : 1;
        });
        const i = this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1], a = o - e - r - i;
        if (a > 0) throw new Error(`Backend '${this.backendName}' has an internal memory leak (${a} data ids) after running '${t}'`);
    }
    /**
   * Internal helper method to execute a kernel Func
   *
   * Use `runKernel` to execute kernels from outside of engine.
   */ runKernelFunc(t) {
        let e, s = [];
        const o = this.isTapeOn(), r = this.state.numBytes, i = this.state.numTensors;
        this.shouldCheckForMemLeaks() && this.state.numDataMovesStack.push(0);
        let a;
        this.backendName == null && this.backend;
        let l;
        const c = Eu(t) ? t.kernelName : this.state.activeScope != null ? this.state.activeScope.name : "";
        if (Eu(t)) {
            const { kernelName: f, inputs: m, attrs: g } = t;
            this.backendName == null && this.backend;
            const b = bl(f, this.backendName);
            C(b != null, ()=>`Cannot find registered kernel '${f}' for backend '${this.backendName}'`), a = ()=>{
                const x = this.backend.numDataIds();
                l = b.kernelFunc({
                    inputs: m,
                    attrs: g,
                    backend: this.backend
                });
                const w = Array.isArray(l) ? l : [
                    l
                ];
                this.shouldCheckForMemLeaks() && this.checkKernelForMemLeak(f, x, w);
                const y = w.map((I)=>I.rank != null ? I : this.makeTensorFromTensorInfo(I));
                if (o) {
                    const I = this.getTensorsForGradient(f, m, y);
                    s = this.saveTensorsForBackwardMode(I);
                }
                return y;
            };
        } else {
            const { forwardFunc: f } = t, m = (g)=>{
                o && (s = g.map((b)=>this.keep(this.clone(b))));
            };
            a = ()=>{
                const g = this.backend.numDataIds();
                l = this.tidy(()=>f(this.backend, m));
                const b = Array.isArray(l) ? l : [
                    l
                ];
                return this.shouldCheckForMemLeaks() && this.checkKernelForMemLeak(c, g, b), b;
            };
        }
        const { inputs: u, attrs: d } = t, h = Eu(t) ? null : t.backwardsFunc;
        let p;
        return this.scopedRun(// Stop recording to a tape when running a kernel.
        ()=>this.state.kernelDepth++, ()=>this.state.kernelDepth--, ()=>{
            !this.ENV.getBool("DEBUG") && !this.state.profiling ? e = a() : (p = this.profiler.profileKernel(c, u, ()=>a()), this.ENV.getBool("DEBUG") && this.profiler.logKernelProfile(p), e = p.outputs);
        }), o && this.addTapeNode(c, u, e, h, s, d), this.state.profiling && this.state.activeProfile.kernels.push({
            name: c,
            bytesAdded: this.state.numBytes - r,
            totalBytesSnapshot: this.state.numBytes,
            tensorsAdded: this.state.numTensors - i,
            totalTensorsSnapshot: this.state.numTensors,
            inputShapes: Object.keys(u).map((f)=>u[f] != null ? u[f].shape : null),
            outputShapes: e.map((f)=>f.shape),
            kernelTimeMs: p.timeMs,
            extraInfo: p.extraInfo
        }), Array.isArray(l) ? e : e[0];
    }
    /**
   * Saves tensors used in forward mode for use in backward mode.
   *
   * @param tensors the list of tensors to save.
   */ saveTensorsForBackwardMode(t) {
        return t.map((s)=>this.keep(this.clone(s)));
    }
    /**
   * Returns a list of tensors to save for a given gradient calculation.
   *
   * @param kernelName name of kernel to look up gradient for.
   * @param inputs a map of input tensors.
   * @param outputs an array of output tensors from forward mode of kernel.
   */ getTensorsForGradient(t, e, s) {
        const o = dm(t);
        if (o != null) {
            const r = o.inputsToSave || [], i = o.outputsToSave || [];
            let a;
            o.saveAllInputs ? (C(Array.isArray(e), ()=>"saveAllInputs is true, expected inputs to be an array."), a = Object.keys(e).map((c)=>e[c])) : a = r.map((c)=>e[c]);
            const l = s.filter((c, u)=>i[u]);
            return a.concat(l);
        }
        return [];
    }
    /**
   * Internal method used by public APIs for tensor creation. Makes a new
   * tensor with the provided shape, dtype and values. It always
   * creates a new data id and writes the values to the underlying backend.
   */ makeTensor(t, e, s, o) {
        if (t == null) throw new Error("Values passed to engine.makeTensor() are null");
        s = s || "float32", o = o || this.backend;
        let r = t;
        s === "string" && vr(t[0]) && (r = t.map((l)=>ms(l)));
        const i = o.write(r, e, s), a = new Mt(e, s, i, this.nextTensorId());
        if (this.trackTensor(a, o), s === "string") {
            const l = this.state.tensorInfo.get(i), c = sb(r);
            this.state.numBytes += c - l.bytes, l.bytes = c;
        }
        return a;
    }
    /**
   * Internal method used by backends. Makes a new tensor
   * that is a wrapper around an existing data id. It doesn't create
   * a new data id, only increments the ref count used in memory tracking.
   * @deprecated
   */ makeTensorFromDataId(t, e, s, o) {
        s = s || "float32";
        const r = {
            dataId: t,
            shape: e,
            dtype: s
        };
        return this.makeTensorFromTensorInfo(r, o);
    }
    /**
   * Internal method used by backends. Makes a new tensor that is a wrapper
   * around an existing data id in TensorInfo. It doesn't create a new data id,
   * only increments the ref count used in memory tracking.
   */ makeTensorFromTensorInfo(t, e) {
        const { dataId: s, shape: o, dtype: r } = t, i = new Mt(o, r, s, this.nextTensorId());
        return this.trackTensor(i, e), i;
    }
    makeVariable(t, e = !0, s, o) {
        s = s || this.nextVariableId().toString(), o != null && o !== t.dtype && (t = t.cast(o));
        const r = new yl(t, e, s, this.nextTensorId());
        if (this.state.registeredVariables[r.name] != null) throw new Error(`Variable with name ${r.name} was already registered`);
        return this.state.registeredVariables[r.name] = r, this.incRef(r, this.backend), r;
    }
    trackTensor(t, e) {
        this.state.numTensors++, t.dtype === "string" && this.state.numStringTensors++;
        let s = 0;
        t.dtype !== "complex64" && t.dtype !== "string" && (s = t.size * ri(t.dtype)), this.state.numBytes += s, this.state.tensorInfo.has(t.dataId) || (this.state.numDataBuffers++, this.state.tensorInfo.set(t.dataId, {
            backend: e || this.backend,
            dtype: t.dtype,
            shape: t.shape,
            bytes: s
        })), t instanceof yl || this.track(t);
    }
    // Track the tensor by dataId and increase the refCount for the dataId in the
    // backend.
    // TODO(pyu10055): This is currently used by makeVariable method, to increase
    // refCount on the backend for the dataId. It can potentially be replaced with
    // Identity op indead of calling backend directly.
    incRef(t, e) {
        this.trackTensor(t, e), this.backend.incRef(t.dataId);
    }
    removeDataId(t, e) {
        this.state.tensorInfo.has(t) && this.state.tensorInfo.get(t).backend === e && (this.state.tensorInfo.delete(t), this.state.numDataBuffers--);
    }
    disposeTensor(t) {
        if (!this.state.tensorInfo.has(t.dataId)) return;
        const e = this.state.tensorInfo.get(t.dataId);
        if (this.state.numTensors--, t.dtype === "string" && (this.state.numStringTensors--, this.state.numBytes -= e.bytes), t.dtype !== "complex64" && t.dtype !== "string") {
            const s = t.size * ri(t.dtype);
            this.state.numBytes -= s;
        }
        e.backend.disposeData(t.dataId) && this.removeDataId(t.dataId, e.backend);
    }
    disposeVariables() {
        for(const t in this.state.registeredVariables){
            const e = this.state.registeredVariables[t];
            this.disposeVariable(e);
        }
    }
    disposeVariable(t) {
        this.disposeTensor(t), this.state.registeredVariables[t.name] != null && delete this.state.registeredVariables[t.name];
    }
    memory() {
        const t = this.backend.memory();
        return t.numTensors = this.state.numTensors, t.numDataBuffers = this.state.numDataBuffers, t.numBytes = this.state.numBytes, this.state.numStringTensors > 0 && (t.unreliable = !0, t.reasons == null && (t.reasons = []), t.reasons.push("Memory usage by string tensors is approximate (2 bytes per character)")), t;
    }
    async profile(t) {
        this.state.profiling = !0;
        const e = this.state.numBytes, s = this.state.numTensors;
        this.state.activeProfile.kernels = [], this.state.activeProfile.result = await t(), this.state.profiling = !1, this.state.activeProfile.peakBytes = Math.max(...this.state.activeProfile.kernels.map((o)=>o.totalBytesSnapshot)), this.state.activeProfile.newBytes = this.state.numBytes - e, this.state.activeProfile.newTensors = this.state.numTensors - s;
        for (const o of this.state.activeProfile.kernels)o.kernelTimeMs = await o.kernelTimeMs, o.extraInfo = await o.extraInfo;
        return this.state.activeProfile;
    }
    isTapeOn() {
        return this.state.gradientDepth > 0 && this.state.kernelDepth === 0;
    }
    addTapeNode(t, e, s, o, r, i) {
        const a = {
            id: this.state.nextTapeNodeId++,
            kernelName: t,
            inputs: e,
            outputs: s,
            saved: r
        }, l = dm(t);
        l != null && (o = l.gradFunc), o != null && (a.gradient = (c)=>(c = c.map((u, d)=>{
                if (u == null) {
                    const h = s[d], p = ke(h.size, h.dtype);
                    return this.makeTensor(p, h.shape, h.dtype);
                }
                return u;
            }), o(c.length > 1 ? c : c[0], r, i))), this.state.activeTape.push(a);
    }
    keep(t) {
        return t.kept = !0, t;
    }
    startTape() {
        this.state.gradientDepth === 0 && (this.state.activeTape = []), this.state.gradientDepth++;
    }
    endTape() {
        this.state.gradientDepth--;
    }
    /**
   * Start a scope. Use this with endScope() to achieve the same functionality
   * as scope() without the need for a function closure.
   */ startScope(t) {
        const e = {
            track: [],
            name: "unnamed scope",
            id: this.state.nextScopeId++
        };
        t && (e.name = t), this.state.scopeStack.push(e), this.state.activeScope = e;
    }
    /**
   * End a scope. Use this with startScope() to achieve the same functionality
   * as scope() without the need for a function closure.
   */ endScope(t) {
        const e = bs(t), s = new Set(e.map((r)=>r.id));
        for(let r = 0; r < this.state.activeScope.track.length; r++){
            const i = this.state.activeScope.track[r];
            !i.kept && !s.has(i.id) && i.dispose();
        }
        const o = this.state.scopeStack.pop();
        this.state.activeScope = this.state.scopeStack.length === 0 ? null : this.state.scopeStack[this.state.scopeStack.length - 1], e.forEach((r)=>{
            !r.kept && r.scopeId === o.id && this.track(r);
        });
    }
    /**
   * Returns gradients of `f` with respect to each of the `xs`. The gradients
   * returned are of the same length as `xs`, but some might be null if `f`
   * was not a function of that `x`. It also takes optional dy to multiply the
   * gradient, which defaults to `1`.
   */ gradients(t, e, s, o = !1) {
        if (C(e.length > 0, ()=>"gradients() received an empty list of xs."), s != null && s.dtype !== "float32") throw new Error(`dy must have 'float32' dtype, but has '${s.dtype}'`);
        const r = this.scopedRun(()=>this.startTape(), ()=>this.endTape(), ()=>this.tidy("forward", t));
        C(r instanceof Mt, ()=>"The result y returned by f() must be a tensor.");
        const i = f2(this.state.activeTape, e, r);
        if (!o && i.length === 0 && e.length > 0) throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that the f you passed encloses all operations that lead from x to y.");
        return this.tidy("backward", ()=>{
            const a = {};
            a[r.id] = s ?? v2(r.shape), m2(a, i, // Pass the tidy function to avoid circular dep with `tape.ts`.
            (c)=>this.tidy(c), // Pass an add function to avoide a circular dep with `tape.ts`.
            S2);
            const l = e.map((c)=>a[c.id]);
            return this.state.gradientDepth === 0 && (this.state.activeTape.forEach((c)=>{
                for (const u of c.saved)u.dispose();
            }), this.state.activeTape = null), {
                value: r,
                grads: l
            };
        });
    }
    customGrad(t) {
        return C(Xs(t), ()=>"The f passed in customGrad(f) must be a function."), (...e)=>{
            C(e.every((a)=>a instanceof Mt), ()=>"The args passed in customGrad(f)(x1, x2,...) must all be tensors");
            let s;
            const o = {};
            e.forEach((a, l)=>{
                o[l] = a;
            });
            const r = (a, l)=>(s = t(...e, l), C(s.value instanceof Mt, ()=>"The function f passed in customGrad(f) must return an object where `obj.value` is a tensor"), C(Xs(s.gradFunc), ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function."), s.value), i = (a, l)=>{
                const c = s.gradFunc(a, l), u = Array.isArray(c) ? c : [
                    c
                ];
                C(u.length === e.length, ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns the same number of tensors as inputs passed to f(...)."), C(u.every((h)=>h instanceof Mt), ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns a list of only tensors.");
                const d = {};
                return u.forEach((h, p)=>{
                    d[p] = ()=>h;
                }), d;
            };
            return this.runKernelFunc({
                forwardFunc: r,
                backwardsFunc: i,
                inputs: o
            });
        };
    }
    readSync(t) {
        return this.state.tensorInfo.get(t).backend.readSync(t);
    }
    read(t) {
        return this.state.tensorInfo.get(t).backend.read(t);
    }
    readToGPU(t, e) {
        return this.state.tensorInfo.get(t).backend.readToGPU(t, e);
    }
    async time(t) {
        const e = Ie(), s = await this.backend.time(t);
        return s.wallMs = Ie() - e, s;
    }
    /**
   * Tracks a Tensor in the current scope to be automatically cleaned up
   * when the current scope ends, and returns the value.
   *
   * @param result The Tensor to track in the current scope.
   */ track(t) {
        return this.state.activeScope != null && (t.scopeId = this.state.activeScope.id, this.state.activeScope.track.push(t)), t;
    }
    get registeredVariables() {
        return this.state.registeredVariables;
    }
    /**
   * Resets the engine state. Removes all backends but does not remove
   * registered backend factories.
   */ reset() {
        this.pendingBackendInitId++, this.state.dispose(), this.ENV.reset(), this.state = new wm();
        for(const t in this.registry)this.disposeRegisteredKernels(t), this.registry[t].dispose(), delete this.registry[t];
        this.backendName = null, this.backendInstance = null, this.pendingBackendInit = null;
    }
}
mr.nextTensorId = 0;
mr.nextVariableId = 0;
function v2(n) {
    const t = _l(X(n), "float32");
    return $.makeTensor(t, n, "float32");
}
function Vb() {
    const n = lb();
    if (n._tfengine == null) {
        const t = new BC(n);
        n._tfengine = new mr(t);
    }
    return YC(n._tfengine.ENV), x2(()=>n._tfengine), n._tfengine;
}
const $ = Vb();
function S2(n, t) {
    const e = {
        a: n,
        b: t
    };
    return $.runKernel(Sr, e);
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function k2() {
    return typeof navigator < "u" && navigator != null;
}
let bd;
function T2(n) {
    bd = n;
}
function Qh(n) {
    if (bd !== void 0) return bd;
    if (n || k2()) {
        if (n || (n = navigator), n.product === "ReactNative") return !0;
        const t = n.userAgent || n.vendor || // tslint:disable-next-line:no-any
        (typeof window < "u" ? window.opera : "");
        if (!t) {
            const e = n;
            return e.userAgentData && e.userAgentData.mobile;
        }
        return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t) || // tslint:disable-next-line:max-line-length
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4));
    }
    return !1;
}
function Jh() {
    return typeof window < "u" && window.document != null || //@ts-ignore
    typeof WorkerGlobalScope < "u";
}
const jY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    isBrowser: Jh,
    isMobile: Qh,
    mockIsMobile: T2
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Be = F();
Be.registerFlag("DEBUG", ()=>!1, (n)=>{
    n && console.warn("Debugging mode is ON. The output of every math call will be downloaded to CPU and checked for NaNs. This significantly impacts performance.");
});
Be.registerFlag("IS_BROWSER", ()=>Jh());
Be.registerFlag("IS_NODE", ()=>false);
Be.registerFlag("IS_CHROME", ()=>typeof navigator < "u" && navigator != null && navigator.userAgent != null && /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor));
Be.registerFlag("IS_SAFARI", ()=>typeof navigator < "u" && navigator != null && navigator.userAgent != null && /Safari/.test(navigator.userAgent) && /Apple/.test(navigator.vendor));
Be.registerFlag("PROD", ()=>!1);
Be.registerFlag("TENSORLIKE_CHECK_SHAPE_CONSISTENCY", ()=>Be.getBool("DEBUG"));
Be.registerFlag("DEPRECATION_WARNINGS_ENABLED", ()=>!0);
Be.registerFlag("IS_TEST", ()=>!1);
Be.registerFlag("CHECK_COMPUTATION_FOR_ERRORS", ()=>Be.getBool("DEBUG"));
Be.registerFlag("WRAP_TO_IMAGEBITMAP", ()=>!1);
Be.registerFlag("CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU", ()=>!1);
Be.registerFlag("USE_SETTIMEOUTCUSTOM", ()=>!1);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ya(n, t) {
    let e = n;
    if (qe(n)) return t === "string" ? [] : [
        n.length
    ];
    if (Wb(n)) {
        const o = n.channels || "RGBA";
        return [
            n.height,
            n.width * o.length
        ];
    } else if (Db(n)) return [
        n.buffer.size / (t == null ? 4 : ri(t))
    ];
    if (!Array.isArray(n)) return [];
    const s = [];
    for(; Array.isArray(e) || qe(e) && t !== "string";)s.push(e.length), e = e[0];
    return Array.isArray(n) && F().getBool("TENSORLIKE_CHECK_SHAPE_CONSISTENCY") && zb(n, s, []), s;
}
function zb(n, t, e) {
    if (e = e || [], !Array.isArray(n) && !qe(n)) {
        C(t.length === 0, ()=>`Element arr[${e.join("][")}] is a primitive, but should be an array/TypedArray of ${t[0]} elements`);
        return;
    }
    C(t.length > 0, ()=>`Element arr[${e.join("][")}] should be a primitive, but is an array of ${n.length} elements`), C(n.length === t[0], ()=>`Element arr[${e.join("][")}] should have ${t[0]} elements, but has ${n.length} elements`);
    const s = t.slice(1);
    for(let o = 0; o < n.length; ++o)zb(n[o], s, e.concat(o));
}
function Im(n, t, e, s) {
    if (n !== "string_or_numeric") {
        if (n == null) throw new Error("Expected dtype cannot be null.");
        if (n !== "numeric" && n !== t || n === "numeric" && t === "string") throw new Error(`Argument '${e}' passed to '${s}' must be ${n} tensor, but got ${t} tensor`);
    }
}
function T(n, t, e, s = "numeric") {
    if (n instanceof K()) return Im(s, n.dtype, t, e), n;
    let o = Oo(n);
    if (o !== "string" && [
        "bool",
        "int32",
        "float32"
    ].indexOf(s) >= 0 && (o = s), Im(s, o, t, e), n == null || !qe(n) && !Array.isArray(n) && typeof n != "number" && typeof n != "boolean" && typeof n != "string") {
        const l = n == null ? "null" : n.constructor.name;
        throw new Error(`Argument '${t}' passed to '${e}' must be a Tensor or TensorLike, but got '${l}'`);
    }
    const r = ya(n, o);
    !qe(n) && !Array.isArray(n) && (n = [
        n
    ]);
    const a = o !== "string" ? Qs(n, o) : Ks(n, [], !0);
    return $.makeTensor(a, r, o);
}
function jh(n, t, e, s = "numeric") {
    if (!Array.isArray(n)) throw new Error(`Argument ${t} passed to ${e} must be a \`Tensor[]\` or \`TensorLike[]\``);
    return n.map((r, i)=>T(r, `${t}[${i}]`, e, s));
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const N2 = "__op";
function L(n) {
    const t = Object.keys(n);
    if (t.length !== 1) throw new Error(`Please provide an object with a single key (operation name) mapping to a function. Got an object with ${t.length} keys.`);
    let e = t[0];
    const s = n[e];
    e.endsWith("_") && (e = e.substring(0, e.length - 1)), e = e + N2;
    const o = (...r)=>{
        $.startScope(e);
        try {
            const i = s(...r);
            return Ci(i) && console.error("Cannot return a Promise inside of tidy."), $.endScope(i), i;
        } catch (i) {
            throw $.endScope(null), i;
        }
    };
    return Object.defineProperty(o, "name", {
        value: e,
        configurable: !0
    }), o;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function R2(n, t) {
    const e = T(n, "real", "complex"), s = T(t, "imag", "complex");
    Pe(e.shape, s.shape, `real and imag shapes, ${e.shape} and ${s.shape}, must match in call to tf.complex().`);
    const o = {
        real: e,
        imag: s
    };
    return $.runKernel(ih, o);
}
const vo = /* @__PURE__ */ L({
    complex_: R2
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function wa(n, t, e, s) {
    if (s == null) s = Oo(n);
    else if (s === "complex64") throw new Error("Cannot construct a complex64 tensor directly. Please use tf.complex(real, imag).");
    if (Db(n) || Wb(n)) {
        if (s !== "float32" && s !== "int32") throw new Error(`Creating tensor from GPU data only supports 'float32'|'int32' dtype, while the dtype is ${s}.`);
        return $.backend.createTensorFromGPUData(n, t || e, s);
    }
    if (!qe(n) && !Array.isArray(n) && typeof n != "number" && typeof n != "boolean" && typeof n != "string") throw new Error("values passed to tensor(values) must be a number/boolean/string or an array of numbers/booleans/strings, or a TypedArray");
    if (t != null) {
        is(t);
        const o = X(t), r = X(e);
        C(o === r, ()=>`Based on the provided shape, [${t}], the tensor should have ${o} values but has ${r}`);
        for(let i = 0; i < e.length; ++i){
            const a = e[i], l = i === e.length - 1 ? a !== X(t.slice(i)) : !0;
            C(e[i] === t[i] || !l, ()=>`Error creating a new Tensor. Inferred shape (${e}) does not match the provided shape (${t}). `);
        }
    }
    return !qe(n) && !Array.isArray(n) && (n = [
        n
    ]), t = t || e, n = s !== "string" ? Qs(n, s) : Ks(n, [], !0), $.makeTensor(n, t, s);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $e(n, t, e) {
    const s = ya(n, e);
    return wa(n, t, s, e);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const So = {
    float32: 4,
    float16: 2,
    int32: 4,
    uint16: 2,
    uint8: 1,
    bool: 1,
    complex64: 8
};
class Cs {
    /**
   * Concatenate a number of ArrayBuffers into one.
   *
   * @param buffers An array of ArrayBuffers to concatenate, or a single
   *     ArrayBuffer.
   * @returns Result of concatenating `buffers` in order.
   */ static join(t) {
        return new Cs(t).slice();
    }
    constructor(t){
        if (this.shards = [], this.previousShardIndex = 0, t == null || (t instanceof Array || (t = [
            t
        ]), t = t.map((s)=>qe(s) ? s.buffer : s), t.length === 0)) return;
        this.bufferUniformSize = t[0].byteLength;
        let e = 0;
        for(let s = 0; s < t.length; s++){
            const o = t[s];
            s !== t.length - 1 && o.byteLength !== this.bufferUniformSize && (this.bufferUniformSize = void 0);
            const r = e + o.byteLength;
            this.shards.push({
                buffer: o,
                start: e,
                end: r
            }), e = r;
        }
        this.shards.length === 0 && (this.byteLength = 0), this.byteLength = this.shards[this.shards.length - 1].end;
    }
    slice(t = 0, e = this.byteLength) {
        if (this.shards.length === 0) return new ArrayBuffer(0);
        if (t = isNaN(Number(t)) ? 0 : t, e = isNaN(Number(e)) ? 0 : e, t = Math.max(0, t), e = Math.min(this.byteLength, e), e <= t) return new ArrayBuffer(0);
        const s = this.findShardForByte(t);
        if (s === -1) throw new Error(`Could not find start shard for byte ${t}`);
        const o = e - t, r = new ArrayBuffer(o), i = new Uint8Array(r);
        let a = 0;
        for(let l = s; l < this.shards.length; l++){
            const c = this.shards[l], d = t + a - c.start, h = a, f = Math.min(e, c.end) - c.start, m = new Uint8Array(c.buffer, d, f - d);
            if (i.set(m, h), a += m.length, e < c.end) break;
        }
        return r;
    }
    /**
   * Get the index of the shard that contains the byte at `byteIndex`.
   */ findShardForByte(t) {
        if (this.shards.length === 0 || t < 0 || t >= this.byteLength) return -1;
        if (this.bufferUniformSize != null) return this.previousShardIndex = Math.floor(t / this.bufferUniformSize), this.previousShardIndex;
        function e(o) {
            return t < o.start ? -1 : t >= o.end ? 1 : 0;
        }
        if (e(this.shards[this.previousShardIndex]) === 0) return this.previousShardIndex;
        const s = $2(this.shards, e);
        return s === -1 ? -1 : (this.previousShardIndex = s, this.previousShardIndex);
    }
}
function $2(n, t) {
    let e = 0, s = n.length;
    for(; e <= s;){
        const o = Math.floor((s - e) / 2) + e, r = t(n[o]);
        if (r === 0) return o;
        r < 0 ? s = o : e = o + 1;
    }
    return -1;
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function qY() {
    F().set("PROD", !0);
}
function tQ() {
    F().set("DEBUG", !0);
}
function eQ() {
    F().set("DEPRECATION_WARNINGS_ENABLED", !1), console.warn("TensorFlow.js deprecation warnings have been disabled.");
}
function nQ(n) {
    F().getBool("DEPRECATION_WARNINGS_ENABLED") && console.warn(n + " You can disable deprecation warnings with tf.disableDeprecationWarnings().");
}
function sQ() {
    $.disposeVariables();
}
function Ot() {
    return $;
}
function wl() {
    return $.memory();
}
function oQ(n) {
    return $.profile(n);
}
function D(n, t) {
    return $.tidy(n, t);
}
function xt(n) {
    bs(n).forEach((e)=>e.dispose());
}
function hn(n) {
    return $.keep(n);
}
function rQ(n) {
    return $.time(n);
}
function iQ(n) {
    return $.setBackend(n);
}
function aQ() {
    return $.ready();
}
function G2() {
    return $.backendName;
}
function lQ(n) {
    $.removeBackend(n);
}
function cQ(n) {
    return $.findBackend(n);
}
function uQ(n) {
    return $.findBackendFactory(n);
}
function Pb(n, t, e = 1) {
    return $.registerBackend(n, t, e);
}
function ps() {
    return $.backend;
}
function dQ(n, t) {
    F().setPlatform(n, t);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Zs = 4;
async function Cm(n, t) {
    const e = [], s = [], o = Array.isArray(n) ? n.map((i)=>i.name) : Object.keys(n);
    for(let i = 0; i < o.length; ++i){
        const a = o[i], l = Array.isArray(n) ? n[i].tensor : n[a];
        if (l.dtype !== "float32" && l.dtype !== "int32" && l.dtype !== "bool" && l.dtype !== "string" && l.dtype !== "complex64") throw new Error(`Unsupported dtype in weight '${a}': ${l.dtype}`);
        const c = {
            name: a,
            shape: l.shape,
            dtype: l.dtype
        };
        if (l.dtype === "string") {
            const u = new Promise(async (d)=>{
                const h = await l.bytes(), p = h.reduce((g, b)=>g + b.length, 0) + Zs * h.length, f = new Uint8Array(p);
                let m = 0;
                for(let g = 0; g < h.length; g++){
                    const b = h[g], x = new Uint8Array(new Uint32Array([
                        b.length
                    ]).buffer);
                    f.set(x, m), m += Zs, f.set(b, m), m += b.length;
                }
                d(f);
            });
            s.push(u);
        } else s.push(l.data());
        t != null && (c.group = t), e.push(c);
    }
    const r = await Promise.all(s);
    return {
        data: M2(r),
        specs: e
    };
}
function Ab(n, t) {
    const e = new Cs(n), s = {};
    let o = 0;
    for (const r of t){
        const i = E2(r, (a, l)=>e.slice(o + a, o + l));
        s[r.name] = Ob(r, e.slice(o, o + i)), o += i;
    }
    return s;
}
function E2(n, t) {
    const e = X(n.shape);
    let s;
    if ("quantization" in n) {
        const o = n.quantization;
        s = So[o.dtype];
    } else if (n.dtype === "string") {
        let o = 0;
        for(let r = 0; r < e; r++)o += Zs + new Uint32Array(t(o, o + Zs))[0];
        return o;
    } else s = So[n.dtype];
    return e * s;
}
async function L2(n, t) {
    const e = X(n.shape);
    let s;
    if ("quantization" in n) {
        const o = n.quantization;
        s = So[o.dtype];
    } else if (n.dtype === "string") {
        let o = 0;
        for(let r = 0; r < e; r++)o += Zs + new Uint32Array(await t(o, o + Zs))[0];
        return o;
    } else s = So[n.dtype];
    return e * s;
}
function Ob(n, t) {
    const e = n.name, s = n.dtype, o = n.shape, r = X(o);
    let i, a = 0;
    if ("quantization" in n) {
        const l = n.quantization;
        if (l.dtype === "uint8" || l.dtype === "uint16") {
            if (!("min" in l && "scale" in l)) throw new Error(`Weight ${n.name} with quantization ${l.dtype} doesn't have corresponding metadata min and scale.`);
        } else if (l.dtype === "float16") {
            if (s !== "float32") throw new Error(`Weight ${n.name} is quantized with ${l.dtype} which only supports weights of type float32 not ${s}.`);
        } else throw new Error(`Weight ${n.name} has unknown quantization dtype ${l.dtype}. Supported quantization dtypes are: 'uint8', 'uint16', and 'float16'.`);
        const c = So[l.dtype], u = l.dtype === "uint8" ? new Uint8Array(t) : new Uint16Array(t);
        if (s === "float32") {
            if (l.dtype === "uint8" || l.dtype === "uint16") {
                i = new Float32Array(u.length);
                for(let d = 0; d < u.length; d++){
                    const h = u[d];
                    i[d] = h * l.scale + l.min;
                }
            } else if (l.dtype === "float16") i = K2()(u);
            else throw new Error(`Unsupported quantization type ${l.dtype} for weight type float32.`);
        } else if (s === "int32") {
            if (l.dtype !== "uint8" && l.dtype !== "uint16") throw new Error(`Unsupported quantization type ${l.dtype} for weight type int32.`);
            i = new Int32Array(u.length);
            for(let d = 0; d < u.length; d++){
                const h = u[d];
                i[d] = Math.round(h * l.scale + l.min);
            }
        } else throw new Error(`Unsupported dtype in weight '${e}': ${s}`);
        a += r * c;
    } else if (s === "string") {
        const l = X(n.shape);
        i = [];
        for(let c = 0; c < l; c++){
            const u = new Uint32Array(t.slice(a, a + Zs))[0];
            a += Zs;
            const d = new Uint8Array(t.slice(a, a + u));
            i.push(d), a += u;
        }
    } else {
        const l = So[s];
        if (s === "float32") i = new Float32Array(t);
        else if (s === "int32") i = new Int32Array(t);
        else if (s === "bool") i = new Uint8Array(t);
        else if (s === "complex64") {
            i = new Float32Array(t);
            const c = new Float32Array(i.length / 2), u = new Float32Array(i.length / 2);
            for(let f = 0; f < c.length; f++)c[f] = i[f * 2], u[f] = i[f * 2 + 1];
            const d = $e(c, o, "float32"), h = $e(u, o, "float32"), p = vo(d, h);
            return d.dispose(), h.dispose(), p;
        } else throw new Error(`Unsupported dtype in weight '${e}': ${s}`);
        a += r * l;
    }
    return $e(i, o, s);
}
async function vm(n, t, e) {
    let s = new Uint8Array(t);
    for(; s.byteLength < e;){
        const { done: o, value: r } = await n.read();
        if (o && r == null) {
            const a = e - s.byteLength;
            throw new Error(`Reader is done but ${a} bytes are still expected`);
        }
        const i = new Uint8Array(s.length + r.byteLength);
        i.set(s, 0), i.set(new Uint8Array(r), s.length), s = i;
    }
    return s.buffer;
}
async function hQ(n, t) {
    const e = {}, s = n.getReader();
    let o = new ArrayBuffer(0);
    for (const r of t){
        const i = await L2(r, async (c, u)=>(o = await vm(s, o, u), o.slice(c, u)));
        o = await vm(s, o, i);
        const a = o.slice(0, i);
        o = o.slice(i);
        const l = Ob(r, a);
        if (e[r.name] = l, G2() === "webgpu") {
            const c = ps();
            "uploadToGPU" in c && X(l.shape) >= F().get("WEBGPU_CPU_HANDOFF_SIZE_THRESHOLD") && c.uploadToGPU(l.dataId);
        }
    }
    return e;
}
function M2(n) {
    if (n === null) throw new Error(`Invalid input value: ${JSON.stringify(n)}`);
    let t = 0;
    const e = [];
    n.forEach((r)=>{
        if (t += r.byteLength, e.push(r.byteLength === r.buffer.byteLength ? r : new r.constructor(r)), !(r instanceof Float32Array || r instanceof Int32Array || r instanceof Uint8Array)) throw new Error(`Unsupported TypedArray subtype: ${r.constructor.name}`);
    });
    const s = new Uint8Array(t);
    let o = 0;
    return e.forEach((r)=>{
        s.set(new Uint8Array(r.buffer), o), o += r.byteLength;
    }), s.buffer;
}
const qh = typeof $0014e4ac1090533d$require$Buffer < "u" && (typeof Blob > "u" || typeof atob > "u" || typeof btoa > "u");
function Sm(n) {
    return qh ? $0014e4ac1090533d$require$Buffer.byteLength(n, "utf8") : new Blob([
        n
    ]).size;
}
function W2(n) {
    if (qh) return $0014e4ac1090533d$require$Buffer.from(n).toString("base64");
    const t = new Uint8Array(n);
    let e = "";
    for(let s = 0, o = t.length; s < o; s++)e += String.fromCharCode(t[s]);
    return btoa(e);
}
function D2(n) {
    if (qh) {
        const s = $0014e4ac1090533d$require$Buffer.from(n, "base64");
        return s.buffer.slice(s.byteOffset, s.byteOffset + s.byteLength);
    }
    const t = atob(n), e = new Uint8Array(t.length);
    for(let s = 0; s < t.length; ++s)e.set([
        t.charCodeAt(s)
    ], s);
    return e.buffer;
}
function F2(n) {
    return Cs.join(n);
}
function pQ(n) {
    const t = "/";
    for(n = n.trim(); n.endsWith(t);)n = n.slice(0, n.length - 1);
    const e = n.split(t);
    return e[e.length - 1];
}
function V2(n, t) {
    const e = {
        modelTopology: n.modelTopology,
        format: n.format,
        generatedBy: n.generatedBy,
        convertedBy: n.convertedBy,
        weightsManifest: t
    };
    return n.signature != null && (e.signature = n.signature), n.userDefinedMetadata != null && (e.userDefinedMetadata = n.userDefinedMetadata), n.modelInitializer != null && (e.modelInitializer = n.modelInitializer), n.initializerSignature != null && (e.initializerSignature = n.initializerSignature), n.trainingConfig != null && (e.trainingConfig = n.trainingConfig), e;
}
function z2(n, t, e) {
    const s = {
        modelTopology: n.modelTopology,
        format: n.format,
        generatedBy: n.generatedBy,
        convertedBy: n.convertedBy
    };
    if (n.trainingConfig != null && (s.trainingConfig = n.trainingConfig), n.weightsManifest != null) {
        if (!t) throw new Error("modelJSON has weightsManifest but weightSpecs is null");
        if (!e) throw new Error("modelJSON has weightsManifest but weightData is null");
        s.weightSpecs = t, s.weightData = e;
    }
    return n.signature != null && (s.signature = n.signature), n.userDefinedMetadata != null && (s.userDefinedMetadata = n.userDefinedMetadata), n.modelInitializer != null && (s.modelInitializer = n.modelInitializer), n.initializerSignature != null && (s.initializerSignature = n.initializerSignature), s;
}
async function P2(n, t) {
    let e, s;
    return n.weightsManifest != null && ([e, s] = await t(n.weightsManifest)), z2(n, e, s);
}
function tp(n) {
    if (n.modelTopology instanceof ArrayBuffer) throw new Error("Expected JSON model topology, received ArrayBuffer.");
    return {
        dateSaved: /* @__PURE__ */ new Date(),
        modelTopologyType: "JSON",
        modelTopologyBytes: n.modelTopology == null ? 0 : Sm(JSON.stringify(n.modelTopology)),
        weightSpecsBytes: n.weightSpecs == null ? 0 : Sm(JSON.stringify(n.weightSpecs)),
        weightDataBytes: n.weightData == null ? 0 : new Cs(n.weightData).byteLength
    };
}
function km(n) {
    const t = [];
    for (const e of n)t.push(...e.weights);
    return t;
}
function A2() {
    const n = (e)=>{
        let s = e << 13, o = 0;
        for(; !(s & 8388608);)o -= 8388608, s <<= 1;
        return s &= -8388609, o += 947912704, s | o;
    }, t = new Uint32Array(2048);
    t[0] = 0;
    for(let e = 1; e < 1024; e++)t[e] = n(e);
    for(let e = 1024; e < 2048; e++)t[e] = 939524096 + (e - 1024 << 13);
    return t;
}
function O2() {
    const n = new Uint32Array(64);
    n[0] = 0, n[31] = 1199570944, n[32] = 2147483648, n[63] = 3347054592;
    for(let t = 1; t < 31; t++)n[t] = t << 23;
    for(let t = 33; t < 63; t++)n[t] = 2147483648 + (t - 32 << 23);
    return n;
}
function X2() {
    const n = new Uint32Array(64);
    for(let t = 0; t < 64; t++)n[t] = 1024;
    return n[0] = n[32] = 0, n;
}
function K2() {
    const n = A2(), t = O2(), e = X2();
    return (s)=>{
        const o = new ArrayBuffer(4 * s.length), r = new Uint32Array(o);
        for(let i = 0; i < s.length; i++){
            const a = s[i], l = n[e[a >> 10] + (a & 1023)] + t[a >> 10];
            r[i] = l;
        }
        return new Float32Array(o);
    };
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class ee {
    constructor(){
        this.saveRouters = [], this.loadRouters = [];
    }
    static getInstance() {
        return ee.instance == null && (ee.instance = new ee()), ee.instance;
    }
    /**
   * Register a save-handler router.
   *
   * @param saveRouter A function that maps a URL-like string onto an instance
   * of `IOHandler` with the `save` method defined or `null`.
   */ static registerSaveRouter(t) {
        ee.getInstance().saveRouters.push(t);
    }
    /**
   * Register a load-handler router.
   *
   * @param loadRouter A function that maps a URL-like string onto an instance
   * of `IOHandler` with the `load` method defined or `null`.
   */ static registerLoadRouter(t) {
        ee.getInstance().loadRouters.push(t);
    }
    /**
   * Look up IOHandler for saving, given a URL-like string.
   *
   * @param url
   * @returns If only one match is found, an instance of IOHandler with the
   * `save` method defined. If no match is found, `null`.
   * @throws Error, if more than one match is found.
   */ static getSaveHandlers(t) {
        return ee.getHandlers(t, "save");
    }
    /**
   * Look up IOHandler for loading, given a URL-like string.
   *
   * @param url
   * @param loadOptions Optional, custom load options.
   * @returns All valid handlers for `url`, given the currently registered
   *   handler routers.
   */ static getLoadHandlers(t, e) {
        return ee.getHandlers(t, "load", e);
    }
    static getHandlers(t, e, s) {
        const o = [];
        return (e === "load" ? ee.getInstance().loadRouters : ee.getInstance().saveRouters).forEach((i)=>{
            const a = i(t, s);
            a !== null && o.push(a);
        }), o;
    }
}
const fQ = (n)=>ee.registerSaveRouter(n), mQ = (n)=>ee.registerLoadRouter(n), Z2 = (n)=>ee.getSaveHandlers(n), B2 = (n, t)=>ee.getLoadHandlers(n, t);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const xd = "tensorflowjs", yd = 1, go = "models_store", Ws = "model_info_store";
function Xb() {
    if (!F().getBool("IS_BROWSER")) throw new Error("Failed to obtain IndexedDB factory because the current environmentis not a web browser.");
    const n = typeof window > "u" ? self : window, t = n.indexedDB || n.mozIndexedDB || n.webkitIndexedDB || n.msIndexedDB || n.shimIndexedDB;
    if (t == null) throw new Error("The current browser does not appear to support IndexedDB.");
    return t;
}
function wd(n) {
    const t = n.result;
    t.createObjectStore(go, {
        keyPath: "modelPath"
    }), t.createObjectStore(Ws, {
        keyPath: "modelPath"
    });
}
class ko {
    constructor(t){
        if (this.indexedDB = Xb(), t == null || !t) throw new Error("For IndexedDB, modelPath must not be null, undefined or empty.");
        this.modelPath = t;
    }
    async save(t) {
        if (t.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
        return this.databaseAction(this.modelPath, t);
    }
    async load() {
        return this.databaseAction(this.modelPath);
    }
    /**
   * Perform database action to put model artifacts into or read model artifacts
   * from IndexedDB object store.
   *
   * Whether the action is put or get depends on whether `modelArtifacts` is
   * specified. If it is specified, the action will be put; otherwise the action
   * will be get.
   *
   * @param modelPath A unique string path for the model.
   * @param modelArtifacts If specified, it will be the model artifacts to be
   *   stored in IndexedDB.
   * @returns A `Promise` of `SaveResult`, if the action is put, or a `Promise`
   *   of `ModelArtifacts`, if the action is get.
   */ databaseAction(t, e) {
        return new Promise((s, o)=>{
            const r = this.indexedDB.open(xd, yd);
            r.onupgradeneeded = ()=>wd(r), r.onsuccess = ()=>{
                const i = r.result;
                if (e == null) {
                    const a = i.transaction(go, "readonly"), c = a.objectStore(go).get(this.modelPath);
                    c.onsuccess = ()=>{
                        if (c.result == null) return i.close(), o(new Error(`Cannot find model with path '${this.modelPath}' in IndexedDB.`));
                        s(c.result.modelArtifacts);
                    }, c.onerror = (u)=>(i.close(), o(c.error)), a.oncomplete = ()=>i.close();
                } else {
                    e.weightData = Cs.join(e.weightData);
                    const a = tp(e), l = i.transaction(Ws, "readwrite");
                    let c = l.objectStore(Ws), u;
                    try {
                        u = c.put({
                            modelPath: this.modelPath,
                            modelArtifactsInfo: a
                        });
                    } catch (h) {
                        return o(h);
                    }
                    let d;
                    u.onsuccess = ()=>{
                        d = i.transaction(go, "readwrite");
                        const h = d.objectStore(go);
                        let p;
                        try {
                            p = h.put({
                                modelPath: this.modelPath,
                                modelArtifacts: e,
                                modelArtifactsInfo: a
                            });
                        } catch (f) {
                            return o(f);
                        }
                        p.onsuccess = ()=>s({
                                modelArtifactsInfo: a
                            }), p.onerror = (f)=>{
                            c = l.objectStore(Ws);
                            const m = c.delete(this.modelPath);
                            m.onsuccess = ()=>(i.close(), o(p.error)), m.onerror = (g)=>(i.close(), o(p.error));
                        };
                    }, u.onerror = (h)=>(i.close(), o(u.error)), l.oncomplete = ()=>{
                        d == null ? i.close() : d.oncomplete = ()=>i.close();
                    };
                }
            }, r.onerror = (i)=>o(r.error);
        });
    }
}
ko.URL_SCHEME = "indexeddb://";
const Kb = (n)=>F().getBool("IS_BROWSER") && !Array.isArray(n) && n.startsWith(ko.URL_SCHEME) ? H2(n.slice(ko.URL_SCHEME.length)) : null;
ee.registerSaveRouter(Kb);
ee.registerLoadRouter(Kb);
function H2(n) {
    return new ko(n);
}
function _2(n) {
    return n.startsWith(ko.URL_SCHEME) ? n.slice(ko.URL_SCHEME.length) : n;
}
class U2 {
    constructor(){
        this.indexedDB = Xb();
    }
    async listModels() {
        return new Promise((t, e)=>{
            const s = this.indexedDB.open(xd, yd);
            s.onupgradeneeded = ()=>wd(s), s.onsuccess = ()=>{
                const o = s.result, r = o.transaction(Ws, "readonly"), a = r.objectStore(Ws).getAll();
                a.onsuccess = ()=>{
                    const l = {};
                    for (const c of a.result)l[c.modelPath] = c.modelArtifactsInfo;
                    t(l);
                }, a.onerror = (l)=>(o.close(), e(a.error)), r.oncomplete = ()=>o.close();
            }, s.onerror = (o)=>e(s.error);
        });
    }
    async removeModel(t) {
        return t = _2(t), new Promise((e, s)=>{
            const o = this.indexedDB.open(xd, yd);
            o.onupgradeneeded = ()=>wd(o), o.onsuccess = ()=>{
                const r = o.result, i = r.transaction(Ws, "readwrite"), a = i.objectStore(Ws), l = a.get(t);
                let c;
                l.onsuccess = ()=>{
                    if (l.result == null) return r.close(), s(new Error(`Cannot find model with path '${t}' in IndexedDB.`));
                    {
                        const u = a.delete(t), d = ()=>{
                            c = r.transaction(go, "readwrite");
                            const p = c.objectStore(go).delete(t);
                            p.onsuccess = ()=>e(l.result.modelArtifactsInfo), p.onerror = (f)=>s(l.error);
                        };
                        u.onsuccess = d, u.onerror = (h)=>(d(), r.close(), s(l.error));
                    }
                }, l.onerror = (u)=>(r.close(), s(l.error)), i.oncomplete = ()=>{
                    c == null ? r.close() : c.oncomplete = ()=>r.close();
                };
            }, o.onerror = (r)=>s(o.error);
        });
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const hs = "/", rr = "tensorflowjs_models", Zb = "info", Y2 = "model_topology", Q2 = "weight_specs", J2 = "weight_data", j2 = "model_metadata";
function Bb(n) {
    return {
        info: [
            rr,
            n,
            Zb
        ].join(hs),
        topology: [
            rr,
            n,
            Y2
        ].join(hs),
        weightSpecs: [
            rr,
            n,
            Q2
        ].join(hs),
        weightData: [
            rr,
            n,
            J2
        ].join(hs),
        modelMetadata: [
            rr,
            n,
            j2
        ].join(hs)
    };
}
function Hb(n) {
    for (const t of Object.values(n))window.localStorage.removeItem(t);
}
function q2(n) {
    const t = n.split(hs);
    if (t.length < 3) throw new Error(`Invalid key format: ${n}`);
    return t.slice(1, t.length - 1).join(hs);
}
function tv(n) {
    return n.startsWith(To.URL_SCHEME) ? n.slice(To.URL_SCHEME.length) : n;
}
class To {
    constructor(t){
        if (!F().getBool("IS_BROWSER") || typeof window > "u" || typeof window.localStorage > "u") throw new Error("The current environment does not support local storage.");
        if (this.LS = window.localStorage, t == null || !t) throw new Error("For local storage, modelPath must not be null, undefined or empty.");
        this.modelPath = t, this.keys = Bb(this.modelPath);
    }
    /**
   * Save model artifacts to browser local storage.
   *
   * See the documentation to `browserLocalStorage` for details on the saved
   * artifacts.
   *
   * @param modelArtifacts The model artifacts to be stored.
   * @returns An instance of SaveResult.
   */ async save(t) {
        if (t.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
        {
            const e = JSON.stringify(t.modelTopology), s = JSON.stringify(t.weightSpecs), o = tp(t), r = Cs.join(t.weightData);
            try {
                this.LS.setItem(this.keys.info, JSON.stringify(o)), this.LS.setItem(this.keys.topology, e), this.LS.setItem(this.keys.weightSpecs, s), this.LS.setItem(this.keys.weightData, W2(r));
                const i = {
                    format: t.format,
                    generatedBy: t.generatedBy,
                    convertedBy: t.convertedBy,
                    signature: t.signature != null ? t.signature : void 0,
                    userDefinedMetadata: t.userDefinedMetadata != null ? t.userDefinedMetadata : void 0,
                    modelInitializer: t.modelInitializer != null ? t.modelInitializer : void 0,
                    initializerSignature: t.initializerSignature != null ? t.initializerSignature : void 0,
                    trainingConfig: t.trainingConfig != null ? t.trainingConfig : void 0
                };
                return this.LS.setItem(this.keys.modelMetadata, JSON.stringify(i)), {
                    modelArtifactsInfo: o
                };
            } catch  {
                throw Hb(this.keys), new Error(`Failed to save model '${this.modelPath}' to local storage: size quota being exceeded is a possible cause of this failure: modelTopologyBytes=${o.modelTopologyBytes}, weightSpecsBytes=${o.weightSpecsBytes}, weightDataBytes=${o.weightDataBytes}.`);
            }
        }
    }
    /**
   * Load a model from local storage.
   *
   * See the documentation to `browserLocalStorage` for details on the saved
   * artifacts.
   *
   * @returns The loaded model (if loading succeeds).
   */ async load() {
        const t = JSON.parse(this.LS.getItem(this.keys.info));
        if (t == null) throw new Error(`In local storage, there is no model with name '${this.modelPath}'`);
        if (t.modelTopologyType !== "JSON") throw new Error("BrowserLocalStorage does not support loading non-JSON model topology yet.");
        const e = {}, s = JSON.parse(this.LS.getItem(this.keys.topology));
        if (s == null) throw new Error(`In local storage, the topology of model '${this.modelPath}' is missing.`);
        e.modelTopology = s;
        const o = JSON.parse(this.LS.getItem(this.keys.weightSpecs));
        if (o == null) throw new Error(`In local storage, the weight specs of model '${this.modelPath}' are missing.`);
        e.weightSpecs = o;
        const r = this.LS.getItem(this.keys.modelMetadata);
        if (r != null) {
            const a = JSON.parse(r);
            e.format = a.format, e.generatedBy = a.generatedBy, e.convertedBy = a.convertedBy, a.signature != null && (e.signature = a.signature), a.userDefinedMetadata != null && (e.userDefinedMetadata = a.userDefinedMetadata), a.modelInitializer != null && (e.modelInitializer = a.modelInitializer), a.initializerSignature != null && (e.initializerSignature = a.initializerSignature), a.trainingConfig != null && (e.trainingConfig = a.trainingConfig);
        }
        const i = this.LS.getItem(this.keys.weightData);
        if (i == null) throw new Error(`In local storage, the binary weight values of model '${this.modelPath}' are missing.`);
        return e.weightData = D2(i), e;
    }
}
To.URL_SCHEME = "localstorage://";
const _b = (n)=>F().getBool("IS_BROWSER") && !Array.isArray(n) && n.startsWith(To.URL_SCHEME) ? ev(n.slice(To.URL_SCHEME.length)) : null;
ee.registerSaveRouter(_b);
ee.registerLoadRouter(_b);
function ev(n) {
    return new To(n);
}
class nv {
    constructor(){
        C(F().getBool("IS_BROWSER"), ()=>"Current environment is not a web browser"), C(typeof window > "u" || typeof window.localStorage < "u", ()=>"Current browser does not appear to support localStorage"), this.LS = window.localStorage;
    }
    async listModels() {
        const t = {}, e = rr + hs, s = hs + Zb;
        for(let o = 0; o < this.LS.length; ++o){
            const r = this.LS.key(o);
            if (r.startsWith(e) && r.endsWith(s)) {
                const i = q2(r);
                t[i] = JSON.parse(this.LS.getItem(r));
            }
        }
        return t;
    }
    async removeModel(t) {
        t = tv(t);
        const e = Bb(t);
        if (this.LS.getItem(e.info) == null) throw new Error(`Cannot find model at path '${t}'`);
        const s = JSON.parse(this.LS.getItem(e.info));
        return Hb(e), s;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const lr = "://";
class We {
    constructor(){
        this.managers = {};
    }
    static getInstance() {
        return We.instance == null && (We.instance = new We()), We.instance;
    }
    /**
   * Register a save-handler router.
   *
   * @param saveRouter A function that maps a URL-like string onto an instance
   * of `IOHandler` with the `save` method defined or `null`.
   */ static registerManager(t, e) {
        C(t != null, ()=>"scheme must not be undefined or null."), t.endsWith(lr) && (t = t.slice(0, t.indexOf(lr))), C(t.length > 0, ()=>"scheme must not be an empty string.");
        const s = We.getInstance();
        C(s.managers[t] == null, ()=>`A model store manager is already registered for scheme '${t}'.`), s.managers[t] = e;
    }
    static getManager(t) {
        const e = We.getInstance().managers[t];
        if (e == null) throw new Error(`Cannot find model manager for scheme '${t}'`);
        return e;
    }
    static getSchemes() {
        return Object.keys(We.getInstance().managers);
    }
}
function rl(n) {
    if (n.indexOf(lr) === -1) throw new Error(`The url string provided does not contain a scheme. Supported schemes are: ${We.getSchemes().join(",")}`);
    return {
        scheme: n.split(lr)[0],
        path: n.split(lr)[1]
    };
}
async function Ub(n, t, e = !1) {
    C(n !== t, ()=>`Old path and new path are the same: '${n}'`);
    const s = ee.getLoadHandlers(n);
    C(s.length > 0, ()=>`Copying failed because no load handler is found for source URL ${n}.`), C(s.length < 2, ()=>`Copying failed because more than one (${s.length}) load handlers for source URL ${n}.`);
    const o = s[0], r = ee.getSaveHandlers(t);
    C(r.length > 0, ()=>`Copying failed because no save handler is found for destination URL ${t}.`), C(r.length < 2, ()=>`Copying failed because more than one (${s.length}) save handlers for destination URL ${t}.`);
    const i = r[0], a = rl(n).scheme, l = rl(n).path, c = a === rl(n).scheme, u = await o.load();
    e && c && await We.getManager(a).removeModel(l);
    const d = await i.save(u);
    return e && !c && await We.getManager(a).removeModel(l), d.modelArtifactsInfo;
}
async function gQ() {
    const n = We.getSchemes(), t = {};
    for (const e of n){
        const s = await We.getManager(e).listModels();
        for(const o in s){
            const r = e + lr + o;
            t[r] = s[o];
        }
    }
    return t;
}
async function bQ(n) {
    const t = rl(n);
    return We.getManager(t.scheme).removeModel(t.path);
}
async function xQ(n, t) {
    return Ub(n, t, !1);
}
async function yQ(n, t) {
    return Ub(n, t, !0);
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class sv {
    constructor(){
        this.messageName = "setTimeoutCustom", this.functionRefs = [], this.handledMessageCount = 0, this.hasEventListener = !1;
    }
    fetch(t, e) {
        return fetch(t, e);
    }
    now() {
        return performance.now();
    }
    encode(t, e) {
        if (e !== "utf-8" && e !== "utf8") throw new Error(`Browser's encoder only supports utf-8, but got ${e}`);
        return this.textEncoder == null && (this.textEncoder = new TextEncoder()), this.textEncoder.encode(t);
    }
    decode(t, e) {
        return new TextDecoder(e).decode(t);
    }
    // If the setTimeout nesting level is greater than 5 and timeout is less
    // than 4ms, timeout will be clamped to 4ms, which hurts the perf.
    // Interleaving window.postMessage and setTimeout will trick the browser and
    // avoid the clamp.
    setTimeoutCustom(t, e) {
        if (typeof window > "u" || !F().getBool("USE_SETTIMEOUTCUSTOM")) {
            setTimeout(t, e);
            return;
        }
        this.functionRefs.push(t), setTimeout(()=>{
            window.postMessage({
                name: this.messageName,
                index: this.functionRefs.length - 1
            }, "*");
        }, e), this.hasEventListener || (this.hasEventListener = !0, window.addEventListener("message", (s)=>{
            if (s.source === window && s.data.name === this.messageName) {
                s.stopPropagation();
                const o = this.functionRefs[s.data.index];
                o(), this.handledMessageCount++, this.handledMessageCount === this.functionRefs.length && (this.functionRefs = [], this.handledMessageCount = 0);
            }
        }, !0));
    }
    isTypedArray(t) {
        return vb(t);
    }
}
if (F().get("IS_BROWSER")) {
    F().setPlatform("browser", new sv());
    try {
        We.registerManager(To.URL_SCHEME, new nv());
    } catch  {}
    try {
        We.registerManager(ko.URL_SCHEME, new U2());
    } catch  {}
}

/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const ov = {
    // tslint:disable-next-line:no-require-imports
    importFetch: ()=>(parcelRequire("fLVpN"))
};
let Lu;

class rv {
    constructor(){
        this.util = (parcelRequire("N7Lcz")), this.textEncoder = new this.util.TextEncoder();
    }
    fetch(t, e) {
        return F().global.fetch != null ? F().global.fetch(t, e) : (Lu == null && (Lu = ov.importFetch()), Lu(t, e));
    }
    now() {
        const t = $hPtJY.hrtime();
        return t[0] * 1e3 + t[1] / 1e6;
    }
    encode(t, e) {
        if (e !== "utf-8" && e !== "utf8") throw new Error(`Node built-in encoder only supports utf-8, but got ${e}`);
        return this.textEncoder.encode(t);
    }
    decode(t, e) {
        return t.length === 0 ? "" : new this.util.TextDecoder(e).decode(t);
    }
    isTypedArray(t) {
        return this.util.types.isFloat32Array(t) || this.util.types.isInt32Array(t) || this.util.types.isUint8Array(t) || this.util.types.isUint8ClampedArray(t);
    }
}
F().get("IS_NODE") && !F().get("IS_BROWSER") && F().setPlatform("node", new rv());
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function vt(n, t = "float32", e) {
    return t = t || "float32", is(n), new ve(n, t, e);
}
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function iv(n, t) {
    const e = T(n, "x", "cast");
    if (!nb(t)) throw new Error(`Failed to cast to unknown dtype ${t}`);
    if (t === "string" && e.dtype !== "string" || t !== "string" && e.dtype === "string") throw new Error("Only strings can be casted to strings");
    const s = {
        x: e
    }, o = {
        dtype: t
    };
    return $.runKernel(Gi, s, o);
}
const tt = /* @__PURE__ */ L({
    cast_: iv
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function av(n) {
    const e = {
        x: T(n, "x", "clone", "string_or_numeric")
    };
    return $.runKernel(Ki, e);
}
const yo = /* @__PURE__ */ L({
    clone_: av
});
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function lv(n, t = !1) {
    console.log(n.toString(t));
}
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ Vb();
const cv = {
    buffer: vt,
    cast: tt,
    clone: yo,
    print: lv
};
y2(cv);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function uv(n, t) {
    let e = T(n, "a", "add"), s = T(t, "b", "add");
    [e, s] = se(e, s);
    const o = {
        a: e,
        b: s
    };
    return $.runKernel(Sr, o);
}
const U = /* @__PURE__ */ L({
    add_: uv
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function dv(n, t) {
    let e = T(n, "a", "floorDiv"), s = T(t, "b", "floorDiv");
    [e, s] = se(e, s);
    const o = {
        a: e,
        b: s
    };
    return $.runKernel(Oi, o);
}
const Yb = /* @__PURE__ */ L({
    floorDiv_: dv
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function hv(n, t) {
    let e = T(n, "a", "div"), s = T(t, "b", "div");
    if ([e, s] = se(e, s), e.dtype === "int32" && s.dtype === "int32") return Yb(e, s);
    const o = {
        a: e,
        b: s
    }, r = {};
    return $.runKernel(Di, o, r);
}
const ut = /* @__PURE__ */ L({
    div_: hv
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function pv(n, t) {
    let e = T(n, "a", "mul"), s = T(t, "b", "mul");
    [e, s] = se(e, s);
    const o = {
        a: e,
        b: s
    };
    return $.runKernel(ji, o);
}
const G = /* @__PURE__ */ L({
    mul_: pv
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function fv(n) {
    const t = T(n, "x", "abs");
    if (t.dtype === "complex64") {
        const e = {
            x: t
        };
        return $.runKernel(ec, e);
    } else {
        const e = {
            x: t
        };
        return $.runKernel(Ul, e);
    }
}
const me = /* @__PURE__ */ L({
    abs_: fv
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function mv(n) {
    const e = {
        x: T(n, "x", "acos")
    };
    return $.runKernel(vi, e);
}
const gv = /* @__PURE__ */ L({
    acos_: mv
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function bv(n) {
    const e = {
        x: T(n, "x", "acosh")
    };
    return $.runKernel(Si, e);
}
const xv = /* @__PURE__ */ L({
    acosh_: bv
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function yv(n, t = null, e = !1) {
    const o = {
        x: T(n, "x", "all", "bool")
    }, r = {
        axis: t,
        keepDims: e
    };
    return $.runKernel(th, o, r);
}
const Qb = /* @__PURE__ */ L({
    all_: yv
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function wv(n, t = null, e = !1) {
    const o = {
        x: T(n, "x", "any", "bool")
    }, r = {
        axis: t,
        keepDims: e
    };
    return $.runKernel(eh, o, r);
}
const Id = /* @__PURE__ */ L({
    any_: wv
});
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Iv(n, t = 0) {
    const s = {
        x: T(n, "x", "argMax")
    }, o = {
        axis: t
    };
    return $.runKernel(Yl, s, o);
}
const ai = /* @__PURE__ */ L({
    argMax_: Iv
});
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Cv(n, t = 0) {
    const s = {
        x: T(n, "x", "argMin")
    }, o = {
        axis: t
    };
    return $.runKernel(Ql, s, o);
}
const vv = /* @__PURE__ */ L({
    argMin_: Cv
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Sv(n) {
    const e = {
        x: T(n, "x", "asin")
    };
    return $.runKernel(ki, e);
}
const kv = /* @__PURE__ */ L({
    asin_: Sv
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Tv(n) {
    const e = {
        x: T(n, "x", "asinh")
    };
    return $.runKernel(Ti, e);
}
const Nv = /* @__PURE__ */ L({
    asinh_: Tv
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Rv(n) {
    const e = {
        x: T(n, "x", "atan")
    };
    return $.runKernel(Ni, e);
}
const $v = /* @__PURE__ */ L({
    atan_: Rv
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Gv(n, t) {
    let e = T(n, "a", "atan2"), s = T(t, "b", "atan2");
    [e, s] = se(e, s);
    const o = {
        a: e,
        b: s
    };
    return $.runKernel($i, o);
}
const Ev = /* @__PURE__ */ L({
    atan2_: Gv
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Lv(n) {
    const e = {
        x: T(n, "x", "atanh")
    };
    return $.runKernel(Ri, e);
}
const Mv = /* @__PURE__ */ L({
    atanh_: Lv
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Ia(n, t, e, s, o = "NHWC", r) {
    const i = n[3], a = [
        ...t,
        i
    ], l = Ss(o);
    return Te(n, a, e, r, s, null, null, l);
}
function $n(n, t, e, s, o, r, i = "channelsLast") {
    const [a, l] = li(t);
    let c;
    if (i === "channelsLast") c = [
        a,
        l,
        n[3],
        n[3]
    ];
    else if (i === "channelsFirst") c = [
        a,
        l,
        n[1],
        n[1]
    ];
    else throw new Error(`Unknown dataFormat ${i}`);
    return Te(n, c, e, s, o, r, !1, i);
}
function vs(n, t, e, s, o, r, i = "NDHWC") {
    const [a, l, c] = Cd(t);
    let u, d;
    if (i === "NDHWC") d = "channelsLast", u = [
        a,
        l,
        c,
        n[4],
        n[4]
    ];
    else if (i === "NCDHW") d = "channelsFirst", u = [
        a,
        l,
        c,
        n[1],
        n[1]
    ];
    else throw new Error(`Unknown dataFormat ${i}`);
    return Js(n, u, e, s, o, !1, d, r);
}
function Te(n, t, e, s, o, r, i = !1, a = "channelsLast") {
    let [l, c, u, d] = [
        -1,
        -1,
        -1,
        -1
    ];
    if (a === "channelsLast") [l, c, u, d] = n;
    else if (a === "channelsFirst") [l, d, c, u] = n;
    else throw new Error(`Unknown dataFormat ${a}`);
    const [h, p, , f] = t, [m, g] = li(e), [b, x] = li(s), w = cr(h, b), y = cr(p, x), { padInfo: I, outHeight: v, outWidth: k } = Fv(o, c, u, m, g, w, y, r, a), S = i ? f * d : f;
    let N;
    return a === "channelsFirst" ? N = [
        l,
        S,
        v,
        k
    ] : a === "channelsLast" && (N = [
        l,
        v,
        k,
        S
    ]), {
        batchSize: l,
        dataFormat: a,
        inHeight: c,
        inWidth: u,
        inChannels: d,
        outHeight: v,
        outWidth: k,
        outChannels: S,
        padInfo: I,
        strideHeight: m,
        strideWidth: g,
        filterHeight: h,
        filterWidth: p,
        effectiveFilterHeight: w,
        effectiveFilterWidth: y,
        dilationHeight: b,
        dilationWidth: x,
        inShape: n,
        outShape: N,
        filterShape: t
    };
}
function Js(n, t, e, s, o, r = !1, i = "channelsLast", a) {
    let [l, c, u, d, h] = [
        -1,
        -1,
        -1,
        -1,
        -1
    ];
    if (i === "channelsLast") [l, c, u, d, h] = n;
    else if (i === "channelsFirst") [l, h, c, u, d] = n;
    else throw new Error(`Unknown dataFormat ${i}`);
    const [p, f, m, , g] = t, [b, x, w] = Cd(e), [y, I, v] = Cd(s), k = cr(p, y), S = cr(f, I), N = cr(m, v), { padInfo: R, outDepth: M, outHeight: V, outWidth: z } = Vv(o, c, u, d, b, x, w, k, S, N, a), P = r ? g * h : g;
    let A;
    return i === "channelsFirst" ? A = [
        l,
        P,
        M,
        V,
        z
    ] : i === "channelsLast" && (A = [
        l,
        M,
        V,
        z,
        P
    ]), {
        batchSize: l,
        dataFormat: i,
        inDepth: c,
        inHeight: u,
        inWidth: d,
        inChannels: h,
        outDepth: M,
        outHeight: V,
        outWidth: z,
        outChannels: P,
        padInfo: R,
        strideDepth: b,
        strideHeight: x,
        strideWidth: w,
        filterDepth: p,
        filterHeight: f,
        filterWidth: m,
        effectiveFilterDepth: k,
        effectiveFilterHeight: S,
        effectiveFilterWidth: N,
        dilationDepth: y,
        dilationHeight: I,
        dilationWidth: v,
        inShape: n,
        outShape: A,
        filterShape: t
    };
}
function Wv(n, t, e, s, o) {
    s == null && (s = ep(n, t, e));
    const r = n[0], i = n[1], a = ci((r - t + 2 * s) / e + 1, o), l = ci((i - t + 2 * s) / e + 1, o);
    return [
        a,
        l
    ];
}
function Dv(n, t, e, s, o, r) {
    o == null && (o = ep(n, t[0], s[0]));
    const i = [
        0,
        0,
        0,
        e
    ];
    for(let a = 0; a < 3; a++)n[a] + 2 * o >= t[a] && (i[a] = ci((n[a] - t[a] + 2 * o) / s[a] + 1, r));
    return i;
}
function ep(n, t, e, s = 1) {
    const o = cr(t, s);
    return Math.floor((n[0] * (e - 1) - e + o) / 2);
}
function li(n) {
    return typeof n == "number" ? [
        n,
        n,
        n
    ] : n.length === 2 ? [
        n[0],
        n[1],
        1
    ] : n;
}
function Cd(n) {
    return typeof n == "number" ? [
        n,
        n,
        n
    ] : n;
}
function cr(n, t) {
    return t <= 1 ? n : n + (n - 1) * (t - 1);
}
function Fv(n, t, e, s, o, r, i, a, l) {
    let c, u, d;
    if (typeof n == "number") {
        c = {
            top: n,
            bottom: n,
            left: n,
            right: n,
            type: n === 0 ? "VALID" : "NUMBER"
        };
        const p = Wv([
            t,
            e
        ], r, s, n, a);
        u = p[0], d = p[1];
    } else if (n === "same") {
        u = Math.ceil(t / s), d = Math.ceil(e / o);
        const h = Math.max(0, (u - 1) * s + r - t), p = Math.max(0, (d - 1) * o + i - e), f = Math.floor(h / 2), m = h - f, g = Math.floor(p / 2), b = p - g;
        c = {
            top: f,
            bottom: m,
            left: g,
            right: b,
            type: "SAME"
        };
    } else if (n === "valid") c = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        type: "VALID"
    }, u = Math.ceil((t - r + 1) / s), d = Math.ceil((e - i + 1) / o);
    else if (typeof n == "object") {
        const h = l === "channelsLast" ? n[1][0] : n[2][0], p = l === "channelsLast" ? n[1][1] : n[2][1], f = l === "channelsLast" ? n[2][0] : n[3][0], m = l === "channelsLast" ? n[2][1] : n[3][1];
        c = {
            top: h,
            bottom: p,
            left: f,
            right: m,
            type: h === 0 && p === 0 && f === 0 && m === 0 ? "VALID" : "EXPLICIT"
        }, u = ci((t - r + h + p) / s + 1, a), d = ci((e - i + f + m) / o + 1, a);
    } else throw Error(`Unknown padding parameter: ${n}`);
    return {
        padInfo: c,
        outHeight: u,
        outWidth: d
    };
}
function Vv(n, t, e, s, o, r, i, a, l, c, u) {
    let d, h, p, f;
    if (n === "valid" && (n = 0), typeof n == "number") {
        d = {
            top: n,
            bottom: n,
            left: n,
            right: n,
            front: n,
            back: n,
            type: n === 0 ? "VALID" : "NUMBER"
        };
        const g = Dv([
            t,
            e,
            s,
            1
        ], [
            a,
            l,
            c
        ], 1, [
            o,
            r,
            i
        ], n, u);
        h = g[0], p = g[1], f = g[2];
    } else if (n === "same") {
        h = Math.ceil(t / o), p = Math.ceil(e / r), f = Math.ceil(s / i);
        const m = (h - 1) * o + a - t, g = (p - 1) * r + l - e, b = (f - 1) * i + c - s, x = Math.floor(m / 2), w = m - x, y = Math.floor(g / 2), I = g - y, v = Math.floor(b / 2), k = b - v;
        d = {
            top: y,
            bottom: I,
            left: v,
            right: k,
            front: x,
            back: w,
            type: "SAME"
        };
    } else throw Error(`Unknown padding parameter: ${n}`);
    return {
        padInfo: d,
        outDepth: h,
        outHeight: p,
        outWidth: f
    };
}
function ci(n, t) {
    if (!t) return Math.trunc(n);
    switch(t){
        case "round":
            return Math.round(n);
        case "ceil":
            return Math.ceil(n);
        case "floor":
            return Math.floor(n);
        default:
            throw new Error(`Unknown roundingMode ${t}`);
    }
}
function No(n) {
    const [t, e, s] = li(n);
    return t === 1 && e === 1 && s === 1;
}
function Le(n, t) {
    return No(n) || No(t);
}
function Ro(n) {
    return li(n).every((t)=>t > 0);
}
function Ss(n) {
    if (n === "NHWC") return "channelsLast";
    if (n === "NCHW") return "channelsFirst";
    throw new Error(`Unknown dataFormat ${n}`);
}
function Ue(n, t, e) {
    if (e != null) {
        if (typeof t == "string") throw Error(`Error in ${n}: pad must be an integer when using dimRoundingMode ${e} but got pad ${t}.`);
        if (typeof t == "number") C(Co(t), ()=>`Error in ${n}: pad must be an integer when using dimRoundingMode ${e} but got pad ${t}.`);
        else if (typeof t == "object") t.forEach((s)=>{
            s.forEach((o)=>{
                C(Co(o), ()=>`Error in ${n}: pad must be an integer when using dimRoundingMode ${e} but got pad ${o}.`);
            });
        });
        else throw Error(`Error in ${n}: Unknown padding parameter: ${t}`);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function zv(n, t) {
    const s = {
        x: T(n, "x", "reshape", "string_or_numeric")
    }, o = {
        shape: t
    };
    return $.runKernel(Dc, s, o);
}
const W = /* @__PURE__ */ L({
    reshape_: zv
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Pv(n, t, e, s, o) {
    const r = T(n, "x", "avgPool", "float32"), i = 1;
    C(Le(e, i), ()=>`Error in avgPool: Either strides or dilations must be 1. Got strides ${e} and dilations '${i}'`);
    let a = r, l = !1;
    r.rank === 3 && (l = !0, a = W(r, [
        1,
        r.shape[0],
        r.shape[1],
        r.shape[2]
    ])), C(a.rank === 4, ()=>`Error in avgPool: x must be rank 4 but got rank ${a.rank}.`), Ue("avgPool", s, o);
    const c = {
        x: a
    }, u = {
        filterSize: t,
        strides: e,
        pad: s,
        dimRoundingMode: o
    };
    let d = $.runKernel(Jl, c, u);
    return d = tt(d, r.dtype), l ? W(d, [
        d.shape[1],
        d.shape[2],
        d.shape[3]
    ]) : d;
}
const np = /* @__PURE__ */ L({
    avgPool_: Pv
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Av(n, t, e, s, o, r = "NDHWC") {
    const i = T(n, "x", "avgPool3d", "float32");
    let a = i, l = !1;
    i.rank === 4 && (l = !0, a = W(i, [
        1,
        i.shape[0],
        i.shape[1],
        i.shape[2],
        i.shape[3]
    ])), C(a.rank === 5, ()=>`Error in avgPool3d: x must be rank 5 but got rank ${a.rank}.`), C(r === "NDHWC", ()=>`Error in avgPool3d: Only NDHWC is currently supported, but got dataFormat of ${r}`), C(typeof e == "number" && e > 0 || Array.isArray(e) && e[0] > 0 && e[1] > 0 && e[2] > 0, ()=>`Error in avgPool3d: Stride must be > 0, but got '${e}'`), Ue("avgPool3d", s, o);
    const c = {
        x: a
    }, u = {
        filterSize: t,
        strides: e,
        pad: s,
        dimRoundingMode: o,
        dataFormat: r
    };
    let d = $.runKernel(jl, c, u);
    return d = tt(d, a.dtype), l ? W(d, [
        d.shape[1],
        d.shape[2],
        d.shape[3],
        d.shape[4]
    ]) : d;
}
const Ov = /* @__PURE__ */ L({
    avgPool3d_: Av
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Xv(n, t = 0) {
    C(n.length >= 1, ()=>"Pass at least one tensor to concat");
    const e = jh(n, "tensors", "concat", "string_or_numeric");
    if (e[0].dtype === "complex64" && e.forEach((r)=>{
        if (r.dtype !== "complex64") throw new Error(`Cannot concatenate complex64 tensors with a tensor
          with dtype ${r.dtype}. `);
    }), e.length === 1) return yo(e[0]);
    const s = e, o = {
        axis: t
    };
    return $.runKernel(nc, s, o);
}
const Ge = /* @__PURE__ */ L({
    concat_: Xv
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Kv(n, t, e = !1, s = !1) {
    let o = T(n, "a", "matMul"), r = T(t, "b", "matMul");
    [o, r] = se(o, r);
    const i = {
        a: o,
        b: r
    }, a = {
        transposeA: e,
        transposeB: s
    };
    return $.runKernel(ql, i, a);
}
const Gt = /* @__PURE__ */ L({
    matMul_: Kv
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Zv(n) {
    const e = {
        x: T(n, "x", "sigmoid", "float32")
    };
    return $.runKernel(ca, e);
}
const kr = /* @__PURE__ */ L({
    sigmoid_: Zv
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Bv(n, t, e) {
    const s = T(n, "x", "slice", "string_or_numeric");
    if (s.rank === 0) throw new Error("Slicing scalar is not possible");
    const o = {
        x: s
    }, r = {
        begin: t,
        size: e
    };
    return $.runKernel(Ac, o, r);
}
const Ft = /* @__PURE__ */ L({
    slice_: Bv
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Hv(n) {
    const e = {
        x: T(n, "x", "tanh", "float32")
    };
    return $.runKernel(ma, e);
}
const sp = /* @__PURE__ */ L({
    tanh_: Hv
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function _v(n, t, e) {
    const s = T(n, "x", "batchToSpaceND"), o = t.reduce((a, l)=>a * l);
    C(s.rank >= 1 + t.length, ()=>`input rank is ${s.rank} but should be > than blockShape.length ${t.length}`), C(e.length === t.length, ()=>`crops.length is ${e.length} but should be equal to blockShape.length  ${t.length}`), C(s.shape[0] % o === 0, ()=>`input tensor batch is ${s.shape[0]} but is not divisible by the product of the elements of blockShape ${t.join(" * ")} === ${o}`);
    const r = {
        x: s
    }, i = {
        blockShape: t,
        crops: e
    };
    return $.runKernel(tc, r, i);
}
const op = /* @__PURE__ */ L({
    batchToSpaceND_: _v
});
function Uv(n) {
    let t;
    return n.rank === 0 || n.rank === 1 ? t = W(n, [
        1,
        1,
        1,
        n.size
    ]) : n.rank === 2 ? t = W(n, [
        1,
        1,
        n.shape[0],
        n.shape[1]
    ]) : n.rank === 3 ? t = W(n, [
        1,
        n.shape[0],
        n.shape[1],
        n.shape[2]
    ]) : t = n, t;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Yv(n, t, e, s, o, r) {
    r == null && (r = 1e-3);
    const i = T(n, "x", "batchNorm"), a = T(t, "mean", "batchNorm"), l = T(e, "variance", "batchNorm");
    let c;
    o != null && (c = T(o, "scale", "batchNorm"));
    let u;
    s != null && (u = T(s, "offset", "batchNorm")), C(a.rank === l.rank, ()=>"Batch normalization gradient requires mean and variance to have equal ranks."), C(u == null || a.rank === u.rank, ()=>"Batch normalization gradient requires mean and offset to have equal ranks."), C(c == null || a.rank === c.rank, ()=>"Batch normalization gradient requires mean and scale to have equal ranks.");
    const h = {
        x: Uv(i),
        scale: c,
        offset: u,
        mean: a,
        variance: l
    }, p = {
        varianceEpsilon: r
    }, f = $.runKernel(dc, h, p);
    return W(f, i.shape);
}
const Qc = /* @__PURE__ */ L({
    batchNorm_: Yv
});
function Qv(n, t, e, s, o, r) {
    const i = T(n, "x", "batchNorm"), a = T(t, "mean", "batchNorm"), l = T(e, "variance", "batchNorm");
    let c;
    o != null && (c = T(o, "scale", "batchNorm"));
    let u;
    return s != null && (u = T(s, "offset", "batchNorm")), C(i.rank === 2, ()=>`Error in batchNorm2D: x must be rank 2 but got rank ${i.rank}.`), C(a.rank === 2 || a.rank === 1, ()=>`Error in batchNorm2D: mean must be rank 2 or rank 1 but got rank ${a.rank}.`), C(l.rank === 2 || l.rank === 1, ()=>`Error in batchNorm2D: variance must be rank 2 or rank 1 but got rank ${l.rank}.`), c != null && C(c.rank === 2 || c.rank === 1, ()=>`Error in batchNorm2D: scale must be rank 2 or rank 1 but got rank ${c.rank}.`), u != null && C(u.rank === 2 || u.rank === 1, ()=>`Error in batchNorm2D: offset must be rank 2 or rank 1 but got rank ${u.rank}.`), Qc(i, a, l, u, c, r);
}
const Jv = /* @__PURE__ */ L({
    batchNorm2d_: Qv
});
function jv(n, t, e, s, o, r) {
    const i = T(n, "x", "batchNorm"), a = T(t, "mean", "batchNorm"), l = T(e, "variance", "batchNorm");
    let c;
    o != null && (c = T(o, "scale", "batchNorm"));
    let u;
    return s != null && (u = T(s, "offset", "batchNorm")), C(i.rank === 3, ()=>`Error in batchNorm3D: x must be rank 3 but got rank ${i.rank}.`), C(a.rank === 3 || a.rank === 1, ()=>`Error in batchNorm3D: mean must be rank 3 or rank 1 but got rank ${a.rank}.`), C(l.rank === 3 || l.rank === 1, ()=>`Error in batchNorm3D: variance must be rank 3 or rank 1 but got rank ${l.rank}.`), c != null && C(c.rank === 3 || c.rank === 1, ()=>`Error in batchNorm3D: scale must be rank 3 or rank 1 but got rank ${c.rank}.`), u != null && C(u.rank === 3 || u.rank === 1, ()=>`Error in batchNorm3D: offset must be rank 3 or rank 1 but got rank ${u.rank}.`), Qc(i, a, l, u, c, r);
}
const qv = /* @__PURE__ */ L({
    batchNorm3d_: jv
});
function tS(n, t, e, s, o, r) {
    const i = T(n, "x", "batchNorm"), a = T(t, "mean", "batchNorm"), l = T(e, "variance", "batchNorm");
    let c;
    o != null && (c = T(o, "scale", "batchNorm"));
    let u;
    return s != null && (u = T(s, "offset", "batchNorm")), C(i.rank === 4, ()=>`Error in batchNorm4D: x must be rank 4 but got rank ${i.rank}.`), C(a.rank === 4 || a.rank === 1, ()=>`Error in batchNorm4D: mean must be rank 4 or rank 1 but got rank ${a.rank}.`), C(l.rank === 4 || l.rank === 1, ()=>`Error in batchNorm4D: variance must be rank 4 or rank 1 but got rank ${l.rank}.`), c != null && C(c.rank === 4 || c.rank === 1, ()=>`Error in batchNorm4D: scale must be rank 4 or rank 1 but got rank ${c.rank}.`), u != null && C(u.rank === 4 || u.rank === 1, ()=>`Error in batchNorm4D: offset must be rank 4 or rank 1 but got rank ${u.rank}.`), Qc(i, a, l, u, c, r);
}
const eS = /* @__PURE__ */ L({
    batchNorm4d_: tS
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function nS(n, t, e) {
    const s = T(n, "x", "bincount"), o = T(t, "weights", "bincount");
    C(s.dtype === "int32", ()=>`Error in bincount: input dtype must be int32, but got ${s.dtype}`), C(e >= 0, ()=>`size must be non-negative, but got ${e}.`), C(o.size === s.size || o.size === 0, ()=>`Error in bincount: weights must have the same size as input or0-length, but got input shape: ${s.shape}, weights shape: ${o.shape}.`);
    const r = {
        x: s,
        weights: o
    }, i = {
        size: e
    };
    return $.runKernel(oh, r, i);
}
const sS = /* @__PURE__ */ L({
    bincount_: nS
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function oS(n, t) {
    let e = T(n, "broadcastTo", "x");
    const s = e.shape;
    if (is(t), t.length < e.rank) throw new Error(`broadcastTo(): shape.length=${t.length} < input.rank=${e.rank}.`);
    if (t.length > e.rank) {
        const c = e.shape.slice();
        for(; c.length < t.length;)c.unshift(1);
        e = W(e, c);
    }
    const o = e.shape, r = Array.from(t);
    for(let c = t.length - 1; c >= 0; c--)if (o[c] === t[c]) r[c] = 1;
    else if (e.shape[c] !== 1) throw new Error(`broadcastTo(): [${s}] cannot be broadcast to [${t}].`);
    if (r.map((c, u)=>c > 1 ? u : -1).filter((c)=>c >= 0).length === 0) return yo(e);
    const a = {
        x: e
    }, l = {
        reps: r
    };
    return $.runKernel(ga, a, l);
}
const ni = /* @__PURE__ */ L({
    broadcastTo_: oS
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function rS(n) {
    const e = {
        x: T(n, "x", "ceil", "float32")
    };
    return $.runKernel(Ei, e);
}
const iS = /* @__PURE__ */ L({
    ceil_: rS
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Ca(n, t, e) {
    is(n), e = e || Oo(t);
    const s = {
        shape: n,
        value: t,
        dtype: e
    };
    return $.runKernel(wh, {}, s);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function aS(n, t, e) {
    const s = T(n, "x", "clipByValue");
    if (C(t <= e, ()=>`Error in clip: min (${t}) must be less than or equal to max (${e}).`), t === e) return Ca(s.shape, t, s.dtype);
    const o = {
        x: s
    }, r = {
        clipValueMin: t,
        clipValueMax: e
    };
    return $.runKernel(Li, o, r);
}
const fn = /* @__PURE__ */ L({
    clipByValue_: aS
});
function lS(n) {
    return Ge(n, 0);
}
const cS = /* @__PURE__ */ L({
    concat1d_: lS
});
function uS(n, t) {
    return Ge(n, t);
}
const dS = /* @__PURE__ */ L({
    concat2d_: uS
});
function hS(n, t) {
    return Ge(n, t);
}
const pS = /* @__PURE__ */ L({
    concat3d_: hS
});
function fS(n, t) {
    return Ge(n, t);
}
const mS = /* @__PURE__ */ L({
    concat4d_: fS
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function gS(n, t, e, s, o = "NHWC", r = [
    1,
    1
], i) {
    const a = T(n, "x", "conv2d", "float32"), l = T(t, "filter", "conv2d", "float32");
    let c = a, u = !1;
    a.rank === 3 && (u = !0, c = W(a, [
        1,
        a.shape[0],
        a.shape[1],
        a.shape[2]
    ])), C(c.rank === 4, ()=>`Error in conv2d: input must be rank 4, but got rank ${c.rank}.`), C(l.rank === 4, ()=>`Error in conv2d: filter must be rank 4, but got rank ${l.rank}.`), Ue("conv2d", s, i);
    const d = o === "NHWC" ? c.shape[3] : c.shape[1];
    C(d === l.shape[2], ()=>`Error in conv2d: depth of input (${d}) must match input depth for filter ${l.shape[2]}.`), C(Le(e, r), ()=>`Error in conv2D: Either strides or dilations must be 1. Got strides ${e} and dilations '${r}'`), C(Ro(r), ()=>"Error in conv2D: Dilated rates should be larger than 0."), C(Ro(e), ()=>"Error in conv2D: Strides should be larger than 0.");
    const h = {
        x: c,
        filter: l
    }, p = {
        strides: e,
        pad: s,
        dataFormat: o,
        dilations: r,
        dimRoundingMode: i
    }, f = $.runKernel(sc, h, p);
    return u ? W(f, [
        f.shape[1],
        f.shape[2],
        f.shape[3]
    ]) : f;
}
const $o = /* @__PURE__ */ L({
    conv2d_: gS
});
function bS(n, t, e, s, o = "NWC", r = 1, i) {
    const a = T(n, "x", "conv1d"), l = T(t, "filter", "conv1d");
    let c = a, u = !1;
    a.rank === 2 && (u = !0, c = W(a, [
        1,
        a.shape[0],
        a.shape[1]
    ])), C(c.rank === 3, ()=>`Error in conv1d: input must be rank 3, but got rank ${c.rank}.`), C(l.rank === 3, ()=>`Error in conv1d: filter must be rank 3, but got rank ${l.rank}.`), Ue("conv1d", s, i), C(c.shape[2] === l.shape[1], ()=>`Error in conv1d: depth of input (${c.shape[2]}) must match input depth for filter ${l.shape[1]}.`), C(Le(e, r), ()=>`Error in conv1D: Either stride or dilation must be 1. Got stride ${e} and dilation '${r}'`), C(Ro(r), ()=>"Error in conv1D: Dilated rates should be larger than 0."), C(Ro(e), ()=>"Error in conv1D: Stride should be larger than 0."), C(o === "NWC", ()=>`Error in conv1d: got dataFormat of ${o} but only NWC is currently supported.`);
    const d = W(l, [
        1,
        l.shape[0],
        l.shape[1],
        l.shape[2]
    ]), h = W(c, [
        c.shape[0],
        1,
        c.shape[1],
        c.shape[2]
    ]), g = $o(h, d, [
        1,
        e
    ], s, "NHWC", [
        1,
        r
    ], i);
    return u ? W(g, [
        g.shape[2],
        g.shape[3]
    ]) : W(g, [
        g.shape[0],
        g.shape[2],
        g.shape[3]
    ]);
}
const Jb = /* @__PURE__ */ L({
    conv1d_: bS
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function xS(n, t, e, s, o, r = "NHWC", i) {
    C(n.length === t.rank, ()=>`Length of inShape (${n.length}) and rank of dy (${t.rank}) must match`);
    let a = n, l = t, c = !1;
    t.rank === 3 && (c = !0, l = W(t, [
        1,
        t.shape[0],
        t.shape[1],
        t.shape[2]
    ]), a = [
        1,
        n[0],
        n[1],
        n[2]
    ]), C(a.length === 4, ()=>`Error in conv2dDerInput: inShape must be length 4, but got length ${a.length}.`), C(l.rank === 4, ()=>`Error in conv2dDerInput: dy must be rank 4, but got rank ${l.rank}`), C(e.rank === 4, ()=>`Error in conv2dDerInput: filter must be rank 4, but got rank ${e.rank}`);
    const u = r === "NHWC" ? a[3] : a[1], d = r === "NHWC" ? l.shape[3] : l.shape[1];
    C(u === e.shape[2], ()=>`Error in conv2dDerInput: depth of input (${u}) must match input depth for filter ${e.shape[2]}.`), C(d === e.shape[3], ()=>`Error in conv2dDerInput: depth of output (${d}) must match output depth for filter ${e.shape[3]}.`), Ue("conv2dDerInput", o, i);
    const h = {
        dy: l,
        filter: e
    }, p = {
        strides: s,
        pad: o,
        dataFormat: r,
        dimRoundingMode: i,
        inputShape: a
    }, f = $.runKernel(oc, h, p);
    return c ? W(f, [
        f.shape[1],
        f.shape[2],
        f.shape[3]
    ]) : f;
}
const rp = /* @__PURE__ */ L({
    conv2DBackpropInput_: xS
});
function yS(n, t, e, s, o, r) {
    const i = T(n, "x", "conv2dTranspose"), a = T(t, "filter", "conv2dTranspose");
    return rp(e, i, a, s, o, "NHWC", r);
}
const jb = /* @__PURE__ */ L({
    conv2dTranspose_: yS
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function wS(n, t, e, s, o = "NDHWC", r = [
    1,
    1,
    1
]) {
    const i = T(n, "x", "conv3d"), a = T(t, "filter", "conv3d");
    let l = i, c = !1;
    i.rank === 4 && (c = !0, l = W(i, [
        1,
        i.shape[0],
        i.shape[1],
        i.shape[2],
        i.shape[3]
    ])), C(l.rank === 5, ()=>`Error in conv3d: input must be rank 5, but got rank ${l.rank}.`), C(a.rank === 5, ()=>`Error in conv3d: filter must be rank 5, but got rank ${a.rank}.`), C(l.shape[4] === a.shape[3], ()=>`Error in conv3d: depth of input (${l.shape[4]}) must match input depth for filter ${a.shape[3]}.`), C(Le(e, r), ()=>`Error in conv3D: Either strides or dilations must be 1. Got strides ${e} and dilations '${r}'`), C(o === "NDHWC", ()=>`Error in conv3d: got dataFormat of ${o} but only NDHWC is currently supported.`), C(Ro(r), ()=>"Error in conv3D: Dilated rates should be larger than 0."), C(Ro(e), ()=>"Error in conv3D: Strides should be larger than 0.");
    const u = {
        x: l,
        filter: a
    }, d = {
        strides: e,
        pad: s,
        dataFormat: o,
        dilations: r
    }, h = $.runKernel(rc, u, d);
    return c ? W(h, [
        h.shape[1],
        h.shape[2],
        h.shape[3],
        h.shape[4]
    ]) : h;
}
const IS = /* @__PURE__ */ L({
    conv3d_: wS
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function CS(n, t, e, s, o) {
    C(n.length === t.rank, ()=>`Length of inShape (${n.length}) and rank of dy (${t.rank}) must match`);
    let r = n, i = t, a = !1;
    t.rank === 4 && (a = !0, i = W(t, [
        1,
        t.shape[0],
        t.shape[1],
        t.shape[2],
        t.shape[3]
    ]), r = [
        1,
        n[0],
        n[1],
        n[2],
        n[3]
    ]);
    const l = r[4], c = i.shape[4];
    C(r.length === 5, ()=>`Error in conv3dDerInput: inShape must be length 5, but got length ${r.length}.`), C(i.rank === 5, ()=>`Error in conv3dDerInput: dy must be rank 5, but got rank ${i.rank}`), C(e.rank === 5, ()=>`Error in conv3dDerInput: filter must be rank 5, but got rank ${e.rank}`), C(l === e.shape[3], ()=>`Error in conv3dDerInput: depth of input (${l}) must match input depth for filter ${e.shape[3]}.`), C(c === e.shape[4], ()=>`Error in conv3dDerInput: depth of output (${c}) must match output depth for filter ${e.shape[4]}.`);
    const u = {
        dy: i,
        filter: e
    }, d = {
        pad: o,
        strides: s,
        inputShape: r
    }, h = $.runKernel(ch, u, d);
    return a ? W(h, [
        h.shape[1],
        h.shape[2],
        h.shape[3],
        h.shape[4]
    ]) : h;
}
const qb = /* @__PURE__ */ L({
    conv3DBackpropInput_: CS
});
function vS(n, t, e, s, o) {
    const r = T(n, "x", "conv3dTranspose"), i = T(t, "filter", "conv3dTranspose");
    return qb(e, r, i, s, o);
}
const SS = /* @__PURE__ */ L({
    conv3dTranspose_: vS
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function kS(n) {
    const e = {
        x: T(n, "x", "cos", "float32")
    };
    return $.runKernel(Mi, e);
}
const ip = /* @__PURE__ */ L({
    cos_: kS
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function TS(n) {
    const e = {
        x: T(n, "x", "cosh", "float32")
    };
    return $.runKernel(Wi, e);
}
const t0 = /* @__PURE__ */ L({
    cosh_: TS
});
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function NS(n, t = 0, e = !1, s = !1) {
    const r = {
        x: T(n, "x", "cumprod")
    }, i = {
        axis: t,
        exclusive: e,
        reverse: s
    };
    return $.runKernel(uh, r, i);
}
const vd = /* @__PURE__ */ L({
    cumprod_: NS
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function RS(n, t = 0, e = !1, s = !1) {
    const r = {
        x: T(n, "x", "cumsum")
    }, i = {
        axis: t,
        exclusive: e,
        reverse: s
    };
    return $.runKernel(ic, r, i);
}
const e0 = /* @__PURE__ */ L({
    cumsum_: RS
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $S(n, t, e, s = !1) {
    const o = T(n, "x", "denseBincount"), r = T(t, "weights", "denseBincount");
    C(o.dtype === "int32", ()=>`Error in denseBincount: input dtype must be int32, but got ${o.dtype}`), C(o.rank <= 2, ()=>`Error in denseBincount: input must be at most rank 2, but got rank ${o.rank}.`), C(e >= 0, ()=>`size must be non-negative, but got ${e}.`), C(r.size === o.size || r.size === 0, ()=>`Error in denseBincount: weights must have the same shape as x or 0-length, but got x shape: ${o.shape}, weights shape: ${r.shape}.`);
    const i = {
        x: o,
        weights: r
    }, a = {
        size: e,
        binaryOutput: s
    };
    return $.runKernel(hh, i, a);
}
const Tm = /* @__PURE__ */ L({
    denseBincount_: $S
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function GS(n, t, e = "NHWC") {
    const s = T(n, "x", "depthToSpace", "float32"), o = e === "NHWC" ? s.shape[1] : s.shape[2], r = e === "NHWC" ? s.shape[2] : s.shape[3], i = e === "NHWC" ? s.shape[3] : s.shape[1];
    C(t > 1, ()=>`blockSize should be > 1 for depthToSpace, but was: ${t}`), C(o * t >= 0, ()=>`Negative dimension size caused by overflow when multiplying
    ${o} and ${t}  for depthToSpace with input shape
    ${s.shape}`), C(r * t >= 0, ()=>`Negative dimension size caused by overflow when multiplying
    ${r} and ${t} for depthToSpace with input shape
        ${s.shape}`), C(i % (t * t) === 0, ()=>`Dimension size must be evenly divisible by ${t * t} but is ${i} for depthToSpace with input shape ${s.shape}`);
    const a = {
        x: s
    }, l = {
        blockSize: t,
        dataFormat: e
    };
    return $.runKernel(ph, a, l);
}
const ES = /* @__PURE__ */ L({
    depthToSpace_: GS
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function LS(n, t, e, s, o = "NHWC", r = [
    1,
    1
], i) {
    const a = T(n, "x", "depthwiseConv2d", "float32"), l = T(t, "filter", "depthwiseConv2d", "float32");
    let c = a, u = !1;
    a.rank === 3 && (u = !0, c = W(a, [
        1,
        a.shape[0],
        a.shape[1],
        a.shape[2]
    ])), C(c.rank === 4, ()=>`Error in depthwiseConv2d: input must be rank 4, but got rank ${c.rank}.`), C(l.rank === 4, ()=>`Error in depthwiseConv2d: filter must be rank 4, but got rank ${l.rank}.`);
    const d = o === "NHWC" ? c.shape[3] : c.shape[1];
    C(d === l.shape[2], ()=>`Error in depthwiseConv2d: number of input channels (${d}) must match the inChannels dimension in filter ${l.shape[2]}.`), Ue("depthwiseConv2d", s, i);
    const h = {
        x: c,
        filter: l
    }, p = {
        strides: e,
        pad: s,
        dataFormat: o,
        dilations: r,
        dimRoundingMode: i
    }, f = $.runKernel(ac, h, p);
    return u ? W(f, [
        f.shape[1],
        f.shape[2],
        f.shape[3]
    ]) : f;
}
const ap = /* @__PURE__ */ L({
    depthwiseConv2d_: LS
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function MS(n, t, e, s, o = [
    1,
    1
], r = "NHWC") {
    const i = T(n, "x", "dilation2d"), a = T(t, "filter", "dilation2d");
    C(i.rank === 3 || i.rank === 4, ()=>`Error in dilation2d: input must be rank 3 or 4, but got rank ${i.rank}.`), C(a.rank === 3, ()=>`Error in dilation2d: filter must be rank 3, but got rank ${a.rank}.`), C(r === "NHWC", ()=>`Error in dilation2d: Only NHWC is currently supported, but got dataFormat of ${r}`);
    let l = i, c = !1;
    i.rank === 3 && (l = W(i, [
        1,
        i.shape[0],
        i.shape[1],
        i.shape[2]
    ]), c = !0), C(l.shape[3] === a.shape[2], ()=>`Error in dilation2d:  input and filter must have the same depth: ${l.shape[3]} vs ${a.shape[2]}`);
    const u = {
        x: l,
        filter: a
    }, d = {
        strides: e,
        pad: s,
        dilations: o
    }, h = $.runKernel(lc, u, d);
    return c ? W(h, [
        h.shape[1],
        h.shape[2],
        h.shape[3]
    ]) : h;
}
const WS = /* @__PURE__ */ L({
    dilation2d_: MS
});
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Go(n, t) {
    const e = n.length, s = [];
    for(let o = 0; o < e; o++){
        const r = e - 1 - o, i = n[r] || 1;
        (t[t.length - 1 - o] || 1) > 1 && i === 1 && s.unshift(r);
    }
    return s;
}
function ce(n, t) {
    const e = [];
    for(let s = 0; s < t.length; s++){
        const o = n[n.length - s - 1], r = t.length - s - 1, i = t[r];
        (o == null || o === 1 && i > 1) && e.unshift(r);
    }
    return e;
}
function bt(n, t) {
    const e = Math.max(n.length, t.length), s = new Array(e);
    for(let o = 0; o < e; o++){
        let r = n[n.length - o - 1];
        r == null && (r = 1);
        let i = t[t.length - o - 1];
        if (i == null && (i = 1), r === 1) s[e - o - 1] = i;
        else if (i === 1) s[e - o - 1] = r;
        else if (r !== i) {
            const a = `Operands could not be broadcast together with shapes ${n} and ${t}.`;
            throw Error(a);
        } else s[e - o - 1] = r;
    }
    return s;
}
const wQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    assertAndGetBroadcastShape: bt,
    getBroadcastDims: Go,
    getReductionAxes: ce
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function DS(n, t) {
    let e = T(n, "a", "equal", "string_or_numeric"), s = T(t, "b", "equal", "string_or_numeric");
    [e, s] = se(e, s), bt(e.shape, s.shape);
    const o = {
        a: e,
        b: s
    };
    return $.runKernel(cc, o);
}
const Tn = /* @__PURE__ */ L({
    equal_: DS
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function FS(n, t, e) {
    const s = T(t, "a", "where"), o = T(e, "b", "where"), r = T(n, "condition", "where", "bool"), i = bt(bt(r.shape, s.shape), o.shape), a = ni(r, i), l = ni(s, i), c = ni(o, i), u = {
        condition: a,
        t: l,
        e: c
    };
    return $.runKernel(Pc, u);
}
const Ee = /* @__PURE__ */ L({
    where_: FS
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function VS(n) {
    const e = {
        x: T(n, "x", "zerosLike")
    };
    return $.runKernel(Uc, e);
}
const Tt = /* @__PURE__ */ L({
    zerosLike_: VS
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function zS(n, t) {
    let e = T(n, "a", "div"), s = T(t, "b", "div");
    [e, s] = se(e, s);
    const o = ut(e, s), r = Tt(o), i = Tn(s, r);
    return Ee(i, r, o);
}
const PS = /* @__PURE__ */ L({
    divNoNan_: zS
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function AS(n, t) {
    const e = T(n, "t1", "dot"), s = T(t, "t2", "dot");
    C((e.rank === 1 || e.rank === 2) && (s.rank === 1 || s.rank === 2), ()=>`Error in dot: inputs must all be rank 1 or 2, but got ranks ${e.rank} and ${s.rank}.`);
    const o = e.rank === 1 ? e.size : e.shape[1], r = s.rank === 1 ? s.size : s.shape[0];
    if (C(o === r, ()=>`Error in dot: inner dimensions of inputs must match, but got ${o} and ${r}.`), e.rank === 1 && s.rank === 1) {
        const i = W(e, [
            1,
            -1
        ]), a = W(s, [
            -1,
            1
        ]), l = Gt(i, a);
        return W(l, []);
    } else if (e.rank === 1 && s.rank === 2) {
        const i = W(e, [
            1,
            -1
        ]), a = W(s, [
            s.shape[0],
            s.shape[1]
        ]), l = Gt(i, a);
        return W(l, [
            l.size
        ]);
    } else if (e.rank === 2 && s.rank === 1) {
        const i = W(s, [
            -1,
            1
        ]), a = Gt(e, i);
        return W(a, [
            a.size
        ]);
    } else {
        const i = W(s, [
            s.shape[0],
            s.shape[1]
        ]);
        return Gt(e, i);
    }
}
const OS = /* @__PURE__ */ L({
    dot_: AS
});
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function XS(n, ...t) {
    const e = t.map((o, r)=>T(o, `tensors${r}`, "einsum")), s = {
        equation: n
    };
    return $.runKernel(bh, e, s);
}
const Or = /* @__PURE__ */ L({
    einsum_: XS
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function KS(n) {
    const e = {
        x: T(n, "x", "elu", "float32")
    };
    return $.runKernel(Fi, e);
}
const Jc = /* @__PURE__ */ L({
    elu_: KS
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ZS(n) {
    let t = T(n, "x", "erf");
    C(t.dtype === "int32" || t.dtype === "float32", ()=>"Input dtype must be `int32` or `float32`."), t.dtype === "int32" && (t = tt(t, "float32"));
    const e = {
        x: t
    };
    return $.runKernel(Vi, e);
}
const BS = /* @__PURE__ */ L({
    erf_: ZS
});
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function lp(n, t) {
    for(let e = 0; e < n.length; ++e)if (n[n.length - e - 1] !== t - 1 - e) return !1;
    return !0;
}
function n0(n, t, e) {
    const s = n.length + t.length, o = [];
    let r = 0, i = 0;
    for(let a = 0; a < s; a++)e.indexOf(a) === -1 ? o.push(n[r++]) : o.push(t[i++]);
    return o;
}
function ye(n, t) {
    const e = [], s = n.length;
    for(let r = 0; r < s; r++)t.indexOf(r) === -1 && e.push(n[r]);
    const o = t.map((r)=>n[r]);
    return [
        e,
        o
    ];
}
function re(n, t) {
    const e = t.map((s)=>1);
    return n0(n, e, t);
}
function Ne(n, t, e) {
    C(lp(t, e), ()=>`${n} supports only inner-most axes for now. Got axes ${t} and rank-${e} input.`);
}
function qt(n, t) {
    if (lp(n, t)) return null;
    const e = [];
    for(let s = 0; s < t; ++s)n.indexOf(s) === -1 && e.push(s);
    return n.forEach((s)=>e.push(s)), e;
}
function js(n) {
    return n.map((t, e)=>[
            e,
            t
        ]).sort((t, e)=>t[1] - e[1]).map((t)=>t[0]);
}
function ie(n, t) {
    const e = [];
    for(let s = t - n; s < t; ++s)e.push(s);
    return e;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function HS(n, t = null, e = !1) {
    const o = {
        x: T(n, "x", "max")
    }, r = {
        reductionIndices: t,
        keepDims: e
    };
    return $.runKernel(Ic, o, r);
}
const Pn = /* @__PURE__ */ L({
    max_: HS
});
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function _S(n, t = null, e = !1) {
    const o = {
        x: T(n, "x", "min")
    }, r = {
        axis: t,
        keepDims: e
    };
    return $.runKernel(kc, o, r);
}
const Il = /* @__PURE__ */ L({
    min_: _S
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function US(n, t) {
    let e = T(n, "base", "pow"), s = T(t, "exp", "pow");
    [e, s] = se(e, s);
    const o = {
        a: e,
        b: s
    };
    return $.runKernel(qi, o);
}
const gr = /* @__PURE__ */ L({
    pow_: US
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function gt(n, t) {
    if ((qe(n) && t !== "string" || Array.isArray(n)) && t !== "complex64") throw new Error("Error creating a new Scalar: value must be a primitive (number|boolean|string)");
    if (t === "string" && qe(n) && !(n instanceof Uint8Array)) throw new Error("When making a scalar from encoded string, the value must be `Uint8Array`.");
    return wa(n, [], [], t);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function YS(n) {
    const e = {
        x: T(n, "x", "sqrt", "float32")
    };
    return $.runKernel(da, e);
}
const Ve = /* @__PURE__ */ L({
    sqrt_: YS
});
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function QS(n) {
    const t = T(n, "x", "square"), e = {};
    return $.runKernel("Square", {
        x: t
    }, e);
}
const Kt = /* @__PURE__ */ L({
    square_: QS
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function JS(n, t = null, e = !1) {
    let s = T(n, "x", "sum");
    s.dtype === "bool" && (s = tt(s, "int32"));
    const o = {
        x: s
    }, r = {
        axis: t,
        keepDims: e
    };
    return $.runKernel(Oc, o, r);
}
const at = /* @__PURE__ */ L({
    sum_: JS
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function jS(n, t = "euclidean", e = null, s = !1) {
    n = T(n, "x", "norm");
    const o = s0(n, t, e);
    let r = o.shape;
    if (s) {
        const i = Ct(e, n.shape);
        r = re(o.shape, i);
    }
    return W(o, r);
}
function s0(n, t, e = null) {
    if (n.rank === 0) return me(n);
    if (n.rank !== 1 && e === null) return s0(W(n, [
        -1
    ]), t, e);
    if (n.rank === 1 || typeof e == "number" || Array.isArray(e) && e.length === 1) {
        if (t === 1) return at(me(n), e);
        if (t === 1 / 0) return Pn(me(n), e);
        if (t === -1 / 0) return Il(me(n), e);
        if (t === "euclidean" || t === 2) return Ve(at(gr(me(n), gt(2, "int32")), e));
        throw new Error(`Error in norm: invalid ord value: ${t}`);
    }
    if (Array.isArray(e) && e.length === 2) {
        if (t === 1) return Pn(at(me(n), e[0]), e[1] - 1);
        if (t === 1 / 0) return Pn(at(me(n), e[1]), e[0]);
        if (t === -1 / 0) return Il(at(me(n), e[1]), e[0]);
        if (t === "fro" || t === "euclidean") return Ve(at(Kt(n), e));
        throw new Error(`Error in norm: invalid ord value: ${t}`);
    }
    throw new Error(`Error in norm: invalid axis: ${e}`);
}
const jc = /* @__PURE__ */ L({
    norm_: jS
});
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function qS(n, t = null, e = !1) {
    return jc(n, "euclidean", t, e);
}
const tk = /* @__PURE__ */ L({
    euclideanNorm_: qS
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ek(n) {
    const e = {
        x: T(n, "x", "exp")
    };
    return $.runKernel(zi, e);
}
const mn = /* @__PURE__ */ L({
    exp_: ek
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function nk(n, t = 0) {
    const e = T(n, "x", "expandDims", "string_or_numeric");
    C(t <= e.rank, ()=>"Axis must be <= rank of the tensor");
    const s = {
        input: e
    }, o = {
        dim: t
    };
    return $.runKernel(uc, s, o);
}
const Oe = /* @__PURE__ */ L({
    expandDims_: nk
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function sk(n) {
    const e = {
        x: T(n, "x", "expm1")
    };
    return $.runKernel(Pi, e);
}
const ok = /* @__PURE__ */ L({
    expm1_: sk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function rk(n, t) {
    const e = T(n, "x", "tile", "string_or_numeric");
    C(e.rank === t.length, ()=>`Error in transpose: rank of input ${e.rank} must match length of reps ${t}.`);
    const s = {
        x: e
    }, o = {
        reps: t
    };
    return $.runKernel(ga, s, o);
}
const Vn = /* @__PURE__ */ L({
    tile_: rk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ik(n, t, e, s = "float32") {
    t == null && (t = n);
    const o = vt([
        n,
        t
    ], s), r = n <= t ? n : t;
    for(let a = 0; a < r; ++a)o.set(1, a, a);
    const i = W(o.toTensor(), [
        n,
        t
    ]);
    if (e == null) return i;
    if (e.length === 1) return Vn(Oe(i, 0), [
        e[0],
        1,
        1
    ]);
    if (e.length === 2) return Vn(Oe(Oe(i, 0), 0), [
        e[0],
        e[1],
        1,
        1
    ]);
    if (e.length === 3) return Vn(Oe(Oe(Oe(i, 0), 0), 0), [
        e[0],
        e[1],
        e[2],
        1,
        1
    ]);
    throw new Error(`eye() currently supports only 1D and 2D batchShapes, but received ${e.length}D.`);
}
const o0 = /* @__PURE__ */ L({
    eye_: ik
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ak(n) {
    const e = {
        x: T(n, "x", "floor", "float32")
    };
    return $.runKernel(Ai, e);
}
const qc = /* @__PURE__ */ L({
    floor_: ak
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function lk(n, t, e = 0, s = 0) {
    const o = T(n, "x", "gather"), r = T(t, "indices", "gather", "int32"), i = {
        x: o,
        indices: r
    }, a = {
        axis: e,
        batchDims: s
    };
    return $.runKernel(hc, i, a);
}
const cp = /* @__PURE__ */ L({
    gather_: lk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ck(n, t) {
    let e = T(n, "a", "greater", "string_or_numeric"), s = T(t, "b", "greater", "string_or_numeric");
    [e, s] = se(e, s), bt(e.shape, s.shape);
    const o = {
        a: e,
        b: s
    };
    return $.runKernel(pc, o);
}
const rn = /* @__PURE__ */ L({
    greater_: ck
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function uk(n, t) {
    let e = T(n, "a", "greaterEqual", "string_or_numeric"), s = T(t, "b", "greaterEqual", "string_or_numeric");
    [e, s] = se(e, s), bt(e.shape, s.shape);
    const o = {
        a: e,
        b: s
    };
    return $.runKernel(Xi, o);
}
const Bo = /* @__PURE__ */ L({
    greaterEqual_: uk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function dk(n) {
    const e = {
        input: T(n, "input", "imag")
    };
    return $.runKernel(vh, e);
}
const up = /* @__PURE__ */ L({
    imag_: dk
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function hk(n) {
    const e = {
        x: T(n, "x", "isFinite")
    };
    return $.runKernel(Zi, e);
}
const pk = /* @__PURE__ */ L({
    isFinite_: hk
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function fk(n) {
    const e = {
        x: T(n, "x", "isInf")
    };
    return $.runKernel(Bi, e);
}
const mk = /* @__PURE__ */ L({
    isInf_: fk
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function gk(n) {
    const e = {
        x: T(n, "x", "isNaN")
    };
    return $.runKernel(Hi, e);
}
const bk = /* @__PURE__ */ L({
    isNaN_: gk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function xk(n, t = 0.2) {
    const s = {
        x: T(n, "x", "leakyRelu")
    }, o = {
        alpha: t
    };
    return $.runKernel(fc, s, o);
}
const dp = /* @__PURE__ */ L({
    leakyRelu_: xk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function yk(n, t) {
    let e = T(n, "a", "less", "string_or_numeric"), s = T(t, "b", "less", "string_or_numeric");
    [e, s] = se(e, s), bt(e.shape, s.shape);
    const o = {
        a: e,
        b: s
    };
    return $.runKernel(mc, o);
}
const Cl = /* @__PURE__ */ L({
    less_: yk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function wk(n, t) {
    let e = T(n, "a", "lessEqual", "string_or_numeric"), s = T(t, "b", "lessEqual", "string_or_numeric");
    [e, s] = se(e, s), bt(e.shape, s.shape);
    const o = {
        a: e,
        b: s
    };
    return $.runKernel(gc, o);
}
const Tr = /* @__PURE__ */ L({
    lessEqual_: wk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Ik(n, t = 5, e = 1, s = 1, o = 0.5) {
    const r = T(n, "x", "localResponseNormalization");
    C(r.rank === 4 || r.rank === 3, ()=>`Error in localResponseNormalization: x must be rank 3 or 4 but got
               rank ${r.rank}.`), C(Co(t), ()=>`Error in localResponseNormalization: depthRadius must be an integer but got depthRadius ${t}.`);
    let i = r, a = !1;
    r.rank === 3 && (a = !0, i = W(r, [
        1,
        r.shape[0],
        r.shape[1],
        r.shape[2]
    ]));
    const l = {
        x: i
    }, c = {
        depthRadius: t,
        bias: e,
        alpha: s,
        beta: o
    }, u = $.runKernel(wc, l, c);
    return a ? W(u, [
        u.shape[1],
        u.shape[2],
        u.shape[3]
    ]) : u;
}
const Ck = /* @__PURE__ */ L({
    localResponseNormalization_: Ik
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function vk(n) {
    const e = {
        x: T(n, "x", "log", "float32")
    };
    return $.runKernel(_i, e);
}
const Nn = /* @__PURE__ */ L({
    log_: vk
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Sk(n) {
    const e = {
        x: T(n, "x", "log1p")
    };
    return $.runKernel(Ui, e);
}
const hp = /* @__PURE__ */ L({
    log1p_: Sk
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function IQ(n) {
    return C(Xs(n), ()=>"The f passed in grad(f) must be a function"), (t, e)=>{
        const s = T(t, "x", "tf.grad", "string_or_numeric"), o = e != null ? T(e, "dy", "tf.grad") : null;
        return $.tidy(()=>{
            const { value: r, grads: i } = $.gradients(()=>n(s), [
                s
            ], o);
            return o != null && Pe(r.shape, o.shape, "The shape of dy passed in grad(f)(x, dy) must match the shape returned by f(x)"), tu(i), i[0];
        });
    };
}
function CQ(n) {
    return C(Xs(n), ()=>"The f passed in grads(f) must be a function"), (t, e)=>{
        C(Array.isArray(t), ()=>"The args passed in grads(f)(args) must be an array of `Tensor`s or `TensorLike`s");
        const s = jh(t, "args", "tf.grads", "string_or_numeric"), o = e != null ? T(e, "dy", "tf.grads") : null;
        return $.tidy(()=>{
            const { value: r, grads: i } = $.gradients(()=>n(...s), s, o);
            return o != null && Pe(r.shape, o.shape, "The shape of dy passed in grads(f)([x1,...], dy) must match the shape returned by f([x1,...])"), tu(i), i;
        });
    };
}
function vQ(n) {
    return C(Xs(n), ()=>"The f passed in valueAndGrad(f) must be a function"), (t, e)=>{
        C(t instanceof Mt, ()=>"The x passed in valueAndGrad(f)(x) must be a tensor"), C(e == null || e instanceof Mt, ()=>"The dy passed in valueAndGrad(f)(x, dy) must be a tensor");
        const { grads: s, value: o } = $.gradients(()=>n(t), [
            t
        ], e);
        return tu(s), {
            grad: s[0],
            value: o
        };
    };
}
function SQ(n) {
    return C(Xs(n), ()=>"The f passed in valueAndGrads(f) must be a function"), (t, e)=>{
        C(Array.isArray(t) && t.every((o)=>o instanceof Mt), ()=>"The args passed in valueAndGrads(f)(args) must be array of tensors"), C(e == null || e instanceof Mt, ()=>"The dy passed in valueAndGrads(f)(args, dy) must be a tensor");
        const s = $.gradients(()=>n(...t), t, e);
        return e != null && Pe(s.value.shape, e.shape, "The shape of dy passed in valueAndGrads(f)([x1,...], dy) must match the shape returned by f([x1,...])"), tu(s.grads), s;
    };
}
function kk(n, t) {
    C(Xs(n), ()=>"The f passed in variableGrads(f) must be a function"), C(t == null || Array.isArray(t) && t.every((c)=>c instanceof yl), ()=>"The varList passed in variableGrads(f, varList) must be an array of variables");
    const e = t != null;
    if (!e) {
        t = [];
        for(const c in $.registeredVariables)t.push($.registeredVariables[c]);
    }
    const s = e ? t.filter((c)=>!c.trainable) : null, o = t.length;
    t = t.filter((c)=>c.trainable), C(t.length > 0, ()=>`variableGrads() expects at least one of the input variables to be trainable, but none of the ${o} variables is trainable.`);
    const r = !0, { value: i, grads: a } = $.gradients(n, t, null, r);
    C(a.some((c)=>c != null), ()=>"Cannot find a connection between any variable and the result of the loss function y=f(x). Please make sure the operations that use variables are inside the function f passed to minimize()."), C(i.rank === 0, ()=>`The f passed in variableGrads(f) must return a scalar, but it returned a rank-${i.rank} tensor`);
    const l = {};
    return t.forEach((c, u)=>{
        a[u] != null && (l[c.name] = a[u]);
    }), s != null && s.forEach((c)=>l[c.name] = null), {
        value: i,
        grads: l
    };
}
function Eo(n) {
    return $.customGrad(n);
}
function tu(n) {
    if (n.filter((e)=>e == null).length > 0) throw new Error(`Cannot compute gradient of y=f(x) with respect to x. Make sure that
    the f you passed encloses all operations that lead from x to y.`);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Tk(n) {
    const e = {
        x: T(n, "x", "neg")
    };
    return $.runKernel(Nc, e);
}
const Yt = /* @__PURE__ */ L({
    neg_: Tk
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Nk(n) {
    const e = {
        x: T(n, "x", "softplus")
    };
    return $.runKernel(ua, e);
}
const va = /* @__PURE__ */ L({
    softplus_: Nk
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Rk(n) {
    const t = T(n, "x", "logSigmoid");
    return Eo((s)=>({
            value: Yt(va(Yt(s))),
            gradFunc: (i)=>G(i, kr(Yt(s)))
        }))(t);
}
const $k = /* @__PURE__ */ L({
    logSigmoid_: Rk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Gk(n, t) {
    let e = T(n, "a", "sub"), s = T(t, "b", "sub");
    [e, s] = se(e, s);
    const o = {
        a: e,
        b: s
    };
    return $.runKernel(pa, o);
}
const it = /* @__PURE__ */ L({
    sub_: Gk
});
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Ek(n, t = -1) {
    const e = T(n, "logits", "logSoftmax");
    if (t === -1 && (t = e.rank - 1), t !== e.rank - 1) throw Error(`Log Softmax along a non-last dimension is not yet supported. Logits was rank ${e.rank} and axis was ${t}`);
    return Eo((o, r)=>{
        const a = Pn(o, t, !0), l = it(o, a), c = it(tt(l, "float32"), Nn(at(mn(l), t, !0)));
        return r([
            c
        ]), {
            value: c,
            gradFunc: (d, h)=>{
                const [p] = h, f = !0, m = mn(p);
                return it(d, G(at(d, t, f), m));
            }
        };
    })(e);
}
const r0 = /* @__PURE__ */ L({
    logSoftmax_: Ek
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Lk(n, t = null, e = !1) {
    const s = T(n, "x", "logSumExp"), o = Ct(t, s.shape), r = Pn(s, o, !0), i = it(s, r), a = mn(i), l = at(a, o), c = Nn(l), u = U(W(r, c.shape), c);
    if (e) {
        const d = re(u.shape, o);
        return W(u, d);
    }
    return u;
}
const pp = /* @__PURE__ */ L({
    logSumExp_: Lk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Mk(n, t) {
    const e = T(n, "a", "logicalAnd", "bool"), s = T(t, "b", "logicalAnd", "bool");
    bt(e.shape, s.shape);
    const o = {
        a: e,
        b: s
    };
    return $.runKernel(bc, o);
}
const ss = /* @__PURE__ */ L({
    logicalAnd_: Mk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Wk(n) {
    const e = {
        x: T(n, "x", "logicalNot", "bool")
    };
    return $.runKernel(xc, e);
}
const fp = /* @__PURE__ */ L({
    logicalNot_: Wk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Dk(n, t) {
    const e = T(n, "a", "logicalOr", "bool"), s = T(t, "b", "logicalOr", "bool");
    bt(e.shape, s.shape);
    const o = {
        a: e,
        b: s
    };
    return $.runKernel(yc, o);
}
const i0 = /* @__PURE__ */ L({
    logicalOr_: Dk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Fk(n, t) {
    const e = T(n, "a", "logicalXor", "bool"), s = T(t, "b", "logicalXor", "bool");
    return bt(e.shape, s.shape), ss(i0(n, t), fp(ss(n, t)));
}
const Vk = /* @__PURE__ */ L({
    logicalXor_: Fk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function zk(n, t, e, s, o) {
    const r = T(n, "x", "maxPool"), i = 1;
    let a = r, l = !1;
    r.rank === 3 && (l = !0, a = W(r, [
        1,
        r.shape[0],
        r.shape[1],
        r.shape[2]
    ])), C(a.rank === 4, ()=>`Error in maxPool: input must be rank 4 but got rank ${a.rank}.`), C(Le(e, i), ()=>`Error in maxPool: Either strides or dilations must be 1. Got strides ${e} and dilations '${i}'`), Ue("maxPool", s, o);
    const c = {
        x: a
    }, u = {
        filterSize: t,
        strides: e,
        pad: s,
        dimRoundingMode: o
    }, d = $.runKernel(Cc, c, u);
    return l ? W(d, [
        d.shape[1],
        d.shape[2],
        d.shape[3]
    ]) : d;
}
const mp = /* @__PURE__ */ L({
    maxPool_: zk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Pk(n, t = [
    1,
    1,
    1
], e, s, o, r = "NDHWC") {
    const i = T(n, "x", "maxPool3d");
    let a = i, l = !1;
    i.rank === 4 && (l = !0, a = W(i, [
        1,
        i.shape[0],
        i.shape[1],
        i.shape[2],
        i.shape[3]
    ])), C(a.rank === 5, ()=>`Error in maxPool3d: x must be rank 5 but got rank ${a.rank}.`), C(r === "NDHWC", ()=>`Error in maxPool3d: Only NDHWC is currently supported, but got dataFormat of ${r}`), Ue("maxPool3d", s, o);
    const c = {
        x: a
    }, u = {
        filterSize: t,
        strides: e,
        pad: s,
        dimRoundingMode: o,
        dataFormat: r
    }, d = $.runKernel(vc, c, u);
    return l ? W(d, [
        d.shape[1],
        d.shape[2],
        d.shape[3],
        d.shape[4]
    ]) : d;
}
const Ak = /* @__PURE__ */ L({
    maxPool3d_: Pk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Ok(n, t) {
    let e = T(n, "a", "maximum"), s = T(t, "b", "maximum");
    [e, s] = se(e, s), e.dtype === "bool" && (e = tt(e, "int32"), s = tt(s, "int32")), bt(e.shape, s.shape);
    const o = {
        a: e,
        b: s
    };
    return $.runKernel(Yi, o);
}
const qs = /* @__PURE__ */ L({
    maximum_: Ok
});
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Xk(n, t = null, e = !1) {
    const o = {
        x: T(n, "x", "mean")
    }, r = {
        axis: t,
        keepDims: e
    };
    return $.runKernel(Sc, o, r);
}
const oe = /* @__PURE__ */ L({
    mean_: Xk
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function be(n, t = "float32") {
    if (is(n), t === "complex64") {
        const s = be(n, "float32"), o = be(n, "float32");
        return vo(s, o);
    }
    const e = ke(X(n), t);
    return $.makeTensor(e, n, t);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ks(n, t = "float32") {
    if (is(n), t === "complex64") {
        const s = ks(n, "float32"), o = be(n, "float32");
        return vo(s, o);
    }
    const e = _l(X(n), t);
    return $.makeTensor(e, n, t);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Kk(n, t) {
    let e = T(n, "a", "minimum"), s = T(t, "b", "minimum");
    [e, s] = se(e, s), e.dtype === "bool" && (e = tt(e, "int32"), s = tt(s, "int32")), bt(e.shape, s.shape);
    const o = {
        a: e,
        b: s
    };
    return $.runKernel(Qi, o);
}
const br = /* @__PURE__ */ L({
    minimum_: Kk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Zk(n, t, e) {
    C(e === "reflect" || e === "symmetric", ()=>`Invalid mode. Mode must be either reflect or symmetric. Got ${e}.`);
    const s = T(n, "x", "mirrorPad");
    if (s.rank === 0) throw new Error("mirrorPad(scalar) is not defined. Pass non-scalar to mirrorPad");
    C(t.length === s.rank, ()=>`Padding doesn't match input. Must be ${s.rank}. Got ${t.length}.`);
    const o = e === "reflect" ? 1 : 0;
    for(let a = 0; a < s.rank; a++)C(t[a].length === 2, ()=>"Invalid number of paddings. Must be length of 2 each."), C(t[a][0] >= 0 && t[a][0] <= s.shape[a] - o && t[a][1] >= 0 && t[a][1] <= s.shape[a] - o, ()=>`Padding in dimension ${a} cannot be greater than or equal to ${s.shape[a] - o} or less than 0 for input of shape ${s.shape}`);
    const r = {
        paddings: t,
        mode: e
    }, i = {
        x: s
    };
    return $.runKernel(Tc, i, r);
}
const Bk = /* @__PURE__ */ L({
    mirrorPad_: Zk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Hk(n, t) {
    let e = T(n, "a", "mod"), s = T(t, "b", "mod");
    [e, s] = se(e, s);
    const o = {
        a: e,
        b: s
    };
    return $.runKernel(Ji, o);
}
const _k = /* @__PURE__ */ L({
    mod_: Hk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Uk(n, t = null, e = !1) {
    n = T(n, "x", "moments");
    const s = Ct(t, n.shape), o = oe(n, s, e);
    let r = o.shape;
    e || (r = re(o.shape, s));
    const i = Kt(it(tt(n, "float32"), W(o, r))), a = oe(i, s, e);
    return {
        mean: o,
        variance: a
    };
}
const gp = /* @__PURE__ */ L({
    moments_: Uk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Yk(n, t) {
    let e = T(n, "a", "notEqual", "string_or_numeric"), s = T(t, "b", "notEqual", "string_or_numeric");
    [e, s] = se(e, s), bt(e.shape, s.shape);
    const o = {
        a: e,
        b: s
    };
    return $.runKernel(Rc, o);
}
const ui = /* @__PURE__ */ L({
    notEqual_: Yk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Qk(n, t, e = 1, s = 0, o = "int32") {
    if (t < 2) throw new Error(`Error in oneHot: depth must be >=2, but it is ${t}`);
    const i = {
        indices: T(n, "indices", "oneHot", "int32")
    }, a = {
        dtype: o,
        depth: t,
        onValue: e,
        offValue: s
    };
    return $.runKernel(Gc, i, a);
}
const a0 = /* @__PURE__ */ L({
    oneHot_: Qk
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Jk(n) {
    const e = {
        x: T(n, "x", "onesLike")
    };
    return $.runKernel($c, e);
}
const Rn = /* @__PURE__ */ L({
    onesLike_: Jk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function jk(n, t, e = 0) {
    const s = T(n, "x", "pad");
    if (s.rank === 0) throw new Error("pad(scalar) is not defined. Pass non-scalar to pad");
    const o = {
        paddings: t,
        constantValue: e
    }, r = {
        x: s
    };
    return $.runKernel(Lc, r, o);
}
const bp = /* @__PURE__ */ L({
    pad_: jk
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function qk(n, t, e) {
    const s = T(n, "x", "spaceToBatchND");
    C(s.rank >= 1 + t.length, ()=>`input rank ${s.rank} should be > than [blockShape] ${t.length}`), C(e.length === t.length, ()=>`paddings.shape[0] ${e.length} must be equal to [blockShape] ${t.length}`), C(s.shape.reduce((i, a, l)=>l > 0 && l <= t.length ? i && (a + e[l - 1][0] + e[l - 1][1]) % t[l - 1] === 0 : i, !0), ()=>`input spatial dimensions ${s.shape.slice(1)} with paddings ${e.toString()} must be divisible by blockShapes ${t.toString()}`);
    const o = {
        x: s
    }, r = {
        blockShape: t,
        paddings: e
    };
    return $.runKernel(Xc, o, r);
}
const xp = /* @__PURE__ */ L({
    spaceToBatchND_: qk
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function tT(n, t, e, s, o, r, i) {
    o == null && (o = [
        1,
        1
    ]), r == null && (r = 1), s === 0 && (s = "valid");
    const a = T(n, "x", "maxPool");
    let l = a, c = !1;
    a.rank === 3 && (c = !0, l = W(a, [
        1,
        a.shape[0],
        a.shape[1],
        a.shape[2]
    ])), C(Le(r, o), ()=>`Error in pool: Either strides or dilations must be 1. Got strides ${r} and dilations '${o}'`);
    const u = $n(l.shape, t, r, o, s), d = [
        u.dilationHeight,
        u.dilationWidth
    ];
    let h;
    s === "same" ? h = nT([
        u.filterHeight,
        u.filterWidth
    ], d) : h = [
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    const p = d[0] === 1 && d[1] === 1, [f, m] = eT([
        u.inHeight,
        u.inWidth
    ], d, h), g = p ? s : "valid", b = p ? l : xp(l, d, f), w = (e === "avg" ? ()=>np(b, t, r, g, i) : ()=>mp(b, t, r, g, i))(), y = p ? w : op(w, d, m);
    return c ? W(y, [
        y.shape[1],
        y.shape[2],
        y.shape[3]
    ]) : y;
}
function eT(n, t, e) {
    const s = e.map((u)=>u[0]), o = e.map((u)=>u[1]), r = n.concat(s, o), i = t.map((u, d)=>(u - r[d] % u) % u), a = o.map((u, d)=>u + i[d]), l = t.map((u, d)=>[
            s[d],
            a[d]
        ]), c = t.map((u, d)=>[
            0,
            i[d]
        ]);
    return [
        l,
        c
    ];
}
function nT(n, t) {
    const s = n.map((i, a)=>i + (i - 1) * (t[a] - 1)).map((i)=>i - 1), o = s.map((i)=>Math.floor(i / 2)), r = s.map((i, a)=>i - o[a]);
    return s.map((i, a)=>[
            o[a],
            r[a]
        ]);
}
const sT = /* @__PURE__ */ L({
    pool_: tT
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function oT(n, t) {
    const e = T(n, "x", "prelu"), s = T(t, "alpha", "prelu"), o = {
        x: e,
        alpha: s
    };
    return $.runKernel(Mc, o);
}
const yp = /* @__PURE__ */ L({
    prelu_: oT
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function rT(n, t = null, e = !1) {
    let s = T(n, "x", "prod");
    s.dtype === "bool" && (s = tt(s, "int32"));
    const o = {
        x: s
    }, r = {
        axis: t,
        keepDims: e
    };
    return $.runKernel(Wc, o, r);
}
const iT = /* @__PURE__ */ L({
    prod_: rT
});
var wp = {
    exports: {}
};
wp.exports;
(function(n) {
    (function(t, e, s) {
        function o(l) {
            var c = this, u = a();
            c.next = function() {
                var d = 2091639 * c.s0 + c.c * 23283064365386963e-26;
                return c.s0 = c.s1, c.s1 = c.s2, c.s2 = d - (c.c = d | 0);
            }, c.c = 1, c.s0 = u(" "), c.s1 = u(" "), c.s2 = u(" "), c.s0 -= u(l), c.s0 < 0 && (c.s0 += 1), c.s1 -= u(l), c.s1 < 0 && (c.s1 += 1), c.s2 -= u(l), c.s2 < 0 && (c.s2 += 1), u = null;
        }
        function r(l, c) {
            return c.c = l.c, c.s0 = l.s0, c.s1 = l.s1, c.s2 = l.s2, c;
        }
        function i(l, c) {
            var u = new o(l), d = c && c.state, h = u.next;
            return h.int32 = function() {
                return u.next() * 4294967296 | 0;
            }, h.double = function() {
                return h() + (h() * 2097152 | 0) * 11102230246251565e-32;
            }, h.quick = h, d && (typeof d == "object" && r(d, u), h.state = function() {
                return r(u, {});
            }), h;
        }
        function a() {
            var l = 4022871197, c = function(u) {
                u = String(u);
                for(var d = 0; d < u.length; d++){
                    l += u.charCodeAt(d);
                    var h = 0.02519603282416938 * l;
                    l = h >>> 0, h -= l, h *= l, l = h >>> 0, h -= l, l += h * 4294967296;
                }
                return (l >>> 0) * 23283064365386963e-26;
            };
            return c;
        }
        e && e.exports ? e.exports = i : s && s.amd ? s(function() {
            return i;
        }) : this.alea = i;
    })(Ko, n, // present in node.js
    !1);
})(wp);
var aT = wp.exports, Ip = {
    exports: {}
};
Ip.exports;
(function(n) {
    (function(t, e, s) {
        function o(a) {
            var l = this, c = "";
            l.x = 0, l.y = 0, l.z = 0, l.w = 0, l.next = function() {
                var d = l.x ^ l.x << 11;
                return l.x = l.y, l.y = l.z, l.z = l.w, l.w ^= l.w >>> 19 ^ d ^ d >>> 8;
            }, a === (a | 0) ? l.x = a : c += a;
            for(var u = 0; u < c.length + 64; u++)l.x ^= c.charCodeAt(u) | 0, l.next();
        }
        function r(a, l) {
            return l.x = a.x, l.y = a.y, l.z = a.z, l.w = a.w, l;
        }
        function i(a, l) {
            var c = new o(a), u = l && l.state, d = function() {
                return (c.next() >>> 0) / 4294967296;
            };
            return d.double = function() {
                do var h = c.next() >>> 11, p = (c.next() >>> 0) / 4294967296, f = (h + p) / 2097152;
                while (f === 0);
                return f;
            }, d.int32 = c.next, d.quick = d, u && (typeof u == "object" && r(u, c), d.state = function() {
                return r(c, {});
            }), d;
        }
        e && e.exports ? e.exports = i : s && s.amd ? s(function() {
            return i;
        }) : this.xor128 = i;
    })(Ko, n, // present in node.js
    !1);
})(Ip);
var lT = Ip.exports, Cp = {
    exports: {}
};
Cp.exports;
(function(n) {
    (function(t, e, s) {
        function o(a) {
            var l = this, c = "";
            l.next = function() {
                var d = l.x ^ l.x >>> 2;
                return l.x = l.y, l.y = l.z, l.z = l.w, l.w = l.v, (l.d = l.d + 362437 | 0) + (l.v = l.v ^ l.v << 4 ^ (d ^ d << 1)) | 0;
            }, l.x = 0, l.y = 0, l.z = 0, l.w = 0, l.v = 0, a === (a | 0) ? l.x = a : c += a;
            for(var u = 0; u < c.length + 64; u++)l.x ^= c.charCodeAt(u) | 0, u == c.length && (l.d = l.x << 10 ^ l.x >>> 4), l.next();
        }
        function r(a, l) {
            return l.x = a.x, l.y = a.y, l.z = a.z, l.w = a.w, l.v = a.v, l.d = a.d, l;
        }
        function i(a, l) {
            var c = new o(a), u = l && l.state, d = function() {
                return (c.next() >>> 0) / 4294967296;
            };
            return d.double = function() {
                do var h = c.next() >>> 11, p = (c.next() >>> 0) / 4294967296, f = (h + p) / 2097152;
                while (f === 0);
                return f;
            }, d.int32 = c.next, d.quick = d, u && (typeof u == "object" && r(u, c), d.state = function() {
                return r(c, {});
            }), d;
        }
        e && e.exports ? e.exports = i : s && s.amd ? s(function() {
            return i;
        }) : this.xorwow = i;
    })(Ko, n, // present in node.js
    !1);
})(Cp);
var cT = Cp.exports, vp = {
    exports: {}
};
vp.exports;
(function(n) {
    (function(t, e, s) {
        function o(a) {
            var l = this;
            l.next = function() {
                var u = l.x, d = l.i, h, p;
                return h = u[d], h ^= h >>> 7, p = h ^ h << 24, h = u[d + 1 & 7], p ^= h ^ h >>> 10, h = u[d + 3 & 7], p ^= h ^ h >>> 3, h = u[d + 4 & 7], p ^= h ^ h << 7, h = u[d + 7 & 7], h = h ^ h << 13, p ^= h ^ h << 9, u[d] = p, l.i = d + 1 & 7, p;
            };
            function c(u, d) {
                var h, p = [];
                if (d === (d | 0)) p[0] = d;
                else for(d = "" + d, h = 0; h < d.length; ++h)p[h & 7] = p[h & 7] << 15 ^ d.charCodeAt(h) + p[h + 1 & 7] << 13;
                for(; p.length < 8;)p.push(0);
                for(h = 0; h < 8 && p[h] === 0; ++h);
                for(h == 8 ? p[7] = -1 : p[h], u.x = p, u.i = 0, h = 256; h > 0; --h)u.next();
            }
            c(l, a);
        }
        function r(a, l) {
            return l.x = a.x.slice(), l.i = a.i, l;
        }
        function i(a, l) {
            a == null && (a = +/* @__PURE__ */ new Date());
            var c = new o(a), u = l && l.state, d = function() {
                return (c.next() >>> 0) / 4294967296;
            };
            return d.double = function() {
                do var h = c.next() >>> 11, p = (c.next() >>> 0) / 4294967296, f = (h + p) / 2097152;
                while (f === 0);
                return f;
            }, d.int32 = c.next, d.quick = d, u && (u.x && r(u, c), d.state = function() {
                return r(c, {});
            }), d;
        }
        e && e.exports ? e.exports = i : s && s.amd ? s(function() {
            return i;
        }) : this.xorshift7 = i;
    })(Ko, n, // present in node.js
    !1);
})(vp);
var uT = vp.exports, Sp = {
    exports: {}
};
Sp.exports;
(function(n) {
    (function(t, e, s) {
        function o(a) {
            var l = this;
            l.next = function() {
                var u = l.w, d = l.X, h = l.i, p, f;
                return l.w = u = u + 1640531527 | 0, f = d[h + 34 & 127], p = d[h = h + 1 & 127], f ^= f << 13, p ^= p << 17, f ^= f >>> 15, p ^= p >>> 12, f = d[h] = f ^ p, l.i = h, f + (u ^ u >>> 16) | 0;
            };
            function c(u, d) {
                var h, p, f, m, g, b = [], x = 128;
                for(d === (d | 0) ? (p = d, d = null) : (d = d + "\0", p = 0, x = Math.max(x, d.length)), f = 0, m = -32; m < x; ++m)d && (p ^= d.charCodeAt((m + 32) % d.length)), m === 0 && (g = p), p ^= p << 10, p ^= p >>> 15, p ^= p << 4, p ^= p >>> 13, m >= 0 && (g = g + 1640531527 | 0, h = b[m & 127] ^= p + g, f = h == 0 ? f + 1 : 0);
                for(f >= 128 && (b[(d && d.length || 0) & 127] = -1), f = 127, m = 512; m > 0; --m)p = b[f + 34 & 127], h = b[f = f + 1 & 127], p ^= p << 13, h ^= h << 17, p ^= p >>> 15, h ^= h >>> 12, b[f] = p ^ h;
                u.w = g, u.X = b, u.i = f;
            }
            c(l, a);
        }
        function r(a, l) {
            return l.i = a.i, l.w = a.w, l.X = a.X.slice(), l;
        }
        function i(a, l) {
            a == null && (a = +/* @__PURE__ */ new Date());
            var c = new o(a), u = l && l.state, d = function() {
                return (c.next() >>> 0) / 4294967296;
            };
            return d.double = function() {
                do var h = c.next() >>> 11, p = (c.next() >>> 0) / 4294967296, f = (h + p) / 2097152;
                while (f === 0);
                return f;
            }, d.int32 = c.next, d.quick = d, u && (u.X && r(u, c), d.state = function() {
                return r(c, {});
            }), d;
        }
        e && e.exports ? e.exports = i : s && s.amd ? s(function() {
            return i;
        }) : this.xor4096 = i;
    })(Ko, // window object or global
    n, // present in node.js
    !1);
})(Sp);
var dT = Sp.exports, kp = {
    exports: {}
};
kp.exports;
(function(n) {
    (function(t, e, s) {
        function o(a) {
            var l = this, c = "";
            l.next = function() {
                var d = l.b, h = l.c, p = l.d, f = l.a;
                return d = d << 25 ^ d >>> 7 ^ h, h = h - p | 0, p = p << 24 ^ p >>> 8 ^ f, f = f - d | 0, l.b = d = d << 20 ^ d >>> 12 ^ h, l.c = h = h - p | 0, l.d = p << 16 ^ h >>> 16 ^ f, l.a = f - d | 0;
            }, l.a = 0, l.b = 0, l.c = -1640531527, l.d = 1367130551, a === Math.floor(a) ? (l.a = a / 4294967296 | 0, l.b = a | 0) : c += a;
            for(var u = 0; u < c.length + 20; u++)l.b ^= c.charCodeAt(u) | 0, l.next();
        }
        function r(a, l) {
            return l.a = a.a, l.b = a.b, l.c = a.c, l.d = a.d, l;
        }
        function i(a, l) {
            var c = new o(a), u = l && l.state, d = function() {
                return (c.next() >>> 0) / 4294967296;
            };
            return d.double = function() {
                do var h = c.next() >>> 11, p = (c.next() >>> 0) / 4294967296, f = (h + p) / 2097152;
                while (f === 0);
                return f;
            }, d.int32 = c.next, d.quick = d, u && (typeof u == "object" && r(u, c), d.state = function() {
                return r(c, {});
            }), d;
        }
        e && e.exports ? e.exports = i : s && s.amd ? s(function() {
            return i;
        }) : this.tychei = i;
    })(Ko, n, // present in node.js
    !1);
})(kp);
var hT = kp.exports, l0 = {
    exports: {}
};
const pT = {}, fT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: pT
}, Symbol.toStringTag, {
    value: "Module"
})), mT = /* @__PURE__ */ n2(fT);
(function(n) {
    (function(t, e, s) {
        var o = 256, r = 6, i = 52, a = "random", l = s.pow(o, r), c = s.pow(2, i), u = c * 2, d = o - 1, h;
        function p(y, I, v) {
            var k = [];
            I = I == !0 ? {
                entropy: !0
            } : I || {};
            var S = b(g(I.entropy ? [
                y,
                w(e)
            ] : y ?? x(), 3), k), N = new f(k), R = function() {
                for(var M = N.g(r), V = l, z = 0; M < c;)M = (M + z) * o, V *= o, z = N.g(1);
                for(; M >= u;)M /= 2, V /= 2, z >>>= 1;
                return (M + z) / V;
            };
            return R.int32 = function() {
                return N.g(4) | 0;
            }, R.quick = function() {
                return N.g(4) / 4294967296;
            }, R.double = R, b(w(N.S), e), (I.pass || v || function(M, V, z, P) {
                return P && (P.S && m(P, N), M.state = function() {
                    return m(N, {});
                }), z ? (s[a] = M, V) : M;
            })(R, S, "global" in I ? I.global : this == s, I.state);
        }
        function f(y) {
            var I, v = y.length, k = this, S = 0, N = k.i = k.j = 0, R = k.S = [];
            for(v || (y = [
                v++
            ]); S < o;)R[S] = S++;
            for(S = 0; S < o; S++)R[S] = R[N = d & N + y[S % v] + (I = R[S])], R[N] = I;
            (k.g = function(M) {
                for(var V, z = 0, P = k.i, A = k.j, O = k.S; M--;)V = O[P = d & P + 1], z = z * o + O[d & (O[P] = O[A = d & A + V]) + (O[A] = V)];
                return k.i = P, k.j = A, z;
            })(o);
        }
        function m(y, I) {
            return I.i = y.i, I.j = y.j, I.S = y.S.slice(), I;
        }
        function g(y, I) {
            var v = [], k = typeof y, S;
            if (I && k == "object") for(S in y)try {
                v.push(g(y[S], I - 1));
            } catch  {}
            return v.length ? v : k == "string" ? y : y + "\0";
        }
        function b(y, I) {
            for(var v = y + "", k, S = 0; S < v.length;)I[d & S] = d & (k ^= I[d & S] * 19) + v.charCodeAt(S++);
            return w(I);
        }
        function x() {
            try {
                var y;
                return h && (y = h.randomBytes) ? y = y(o) : (y = new Uint8Array(o), (t.crypto || t.msCrypto).getRandomValues(y)), w(y);
            } catch  {
                var I = t.navigator, v = I && I.plugins;
                return [
                    +/* @__PURE__ */ new Date(),
                    t,
                    v,
                    t.screen,
                    w(e)
                ];
            }
        }
        function w(y) {
            return String.fromCharCode.apply(0, y);
        }
        if (b(s.random(), e), n.exports) {
            n.exports = p;
            try {
                h = mT;
            } catch  {}
        } else s["seed" + a] = p;
    })(// global: `self` in browsers (including strict mode and web workers),
    // otherwise `this` in Node and other environments
    typeof self < "u" ? self : Ko, [], // pool: entropy pool starts empty
    Math);
})(l0);
var gT = l0.exports, bT = aT, xT = lT, yT = cT, wT = uT, IT = dT, CT = hT, Ho = gT;
Ho.alea = bT;
Ho.xor128 = xT;
Ho.xorwow = yT;
Ho.xorshift7 = wT;
Ho.xor4096 = IT;
Ho.tychei = CT;
var Nr = Ho;
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class Tp {
    constructor(t, e, s, o, r){
        this.mean = t, this.stdDev = e, this.dtype = s, this.nextVal = NaN, this.truncated = o, this.truncated && (this.upper = this.mean + this.stdDev * 2, this.lower = this.mean - this.stdDev * 2);
        const i = r || Math.random();
        this.random = Nr.alea(i.toString());
    }
    /** Returns next sample from a Gaussian distribution. */ nextValue() {
        if (!isNaN(this.nextVal)) {
            const o = this.nextVal;
            return this.nextVal = NaN, o;
        }
        let t, e, s = !1;
        for(; !s;){
            let o, r, i;
            do o = 2 * this.random() - 1, r = 2 * this.random() - 1, i = o * o + r * r;
            while (i >= 1 || i === 0);
            const a = Math.sqrt(-2 * Math.log(i) / i);
            t = this.mean + this.stdDev * o * a, e = this.mean + this.stdDev * r * a, (!this.truncated || this.isValidTruncated(t)) && (s = !0);
        }
        return (!this.truncated || this.isValidTruncated(e)) && (this.nextVal = this.convertValue(e)), this.convertValue(t);
    }
    /** Handles proper rounding for non-floating-point numbers. */ convertValue(t) {
        return this.dtype == null || this.dtype === "float32" ? t : Math.round(t);
    }
    /** Returns true if less than 2-standard-deviations from the mean. */ isValidTruncated(t) {
        return t <= this.upper && t >= this.lower;
    }
}
class kQ {
    constructor(t, e, s, o){
        this.alpha = t, this.beta = 1 / e, this.dtype = s;
        const r = o || Math.random();
        this.randu = Nr.alea(r.toString()), this.randn = new Tp(0, 1, s, !1, this.randu()), t < 1 ? this.d = t + 2 / 3 : this.d = t - 1 / 3, this.c = 1 / Math.sqrt(9 * this.d);
    }
    /** Returns next sample from a gamma distribution. */ nextValue() {
        let t, e, s, o, r, i;
        for(;;){
            do o = this.randn.nextValue(), i = 1 + this.c * o;
            while (i <= 0);
            if (i *= i * i, t = o * o, e = 1 - 0.331 * t * t, s = 0.5 * t + this.d * (1 - i + Math.log(i)), r = this.randu(), r < e || Math.log(r) < s) break;
        }
        return i = 1 / this.beta * this.d * i, this.alpha < 1 && (i *= Math.pow(this.randu(), 1 / this.alpha)), this.convertValue(i);
    }
    /** Handles proper rounding for non-floating-point numbers. */ convertValue(t) {
        return this.dtype === "float32" ? t : Math.round(t);
    }
}
class vT {
    constructor(t = 0, e = 1, s, o){
        if (this.canReturnFloat = ()=>this.dtype == null || this.dtype === "float32", this.min = t, this.range = e - t, this.dtype = s, o == null && (o = Math.random()), typeof o == "number" && (o = o.toString()), !this.canReturnFloat() && this.range <= 1) throw new Error(`The difference between ${t} - ${e} <= 1 and dtype is not float`);
        this.random = Nr.alea(o);
    }
    convertValue(t) {
        return this.canReturnFloat() ? t : Math.round(t);
    }
    nextValue() {
        return this.convertValue(this.min + this.range * this.random());
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ST(n, t = 0, e = 1, s, o) {
    if (is(n), s != null && s === "bool") throw new Error(`Unsupported data type ${s}`);
    const r = new Tp(t, e, s, !1, o), i = vt(n, s);
    for(let a = 0; a < i.values.length; a++)i.values[a] = r.nextValue();
    return i.toTensor();
}
const kT = /* @__PURE__ */ L({
    randomNormal_: ST
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function TT(n, t = 0, e = 1, s = "float32", o) {
    is(n);
    const r = vt(n, s), i = new vT(t, e, null, o);
    for(let a = 0; a < r.values.length; a++)r.values[a] = i.nextValue();
    return r.toTensor();
}
const Sa = /* @__PURE__ */ L({
    randomUniform_: TT
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function di(n, t, e = 1, s = "float32") {
    if (e === 0) throw new Error("Cannot have a step of zero");
    const o = {
        start: n,
        stop: t,
        step: e,
        dtype: s
    };
    return $.runKernel(Gh, {}, o);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function NT(n) {
    const e = {
        input: T(n, "input", "real")
    };
    return $.runKernel(Eh, e);
}
const vl = /* @__PURE__ */ L({
    real_: NT
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function RT(n) {
    const e = {
        x: T(n, "x", "reciprocal")
    };
    return $.runKernel(ta, e);
}
const $T = /* @__PURE__ */ L({
    reciprocal_: RT
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function GT(n) {
    const e = {
        x: T(n, "x", "relu")
    };
    return $.runKernel(ea, e);
}
const Ts = /* @__PURE__ */ L({
    relu_: GT
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ET(n) {
    const e = {
        x: T(n, "x", "relu6")
    };
    return $.runKernel(na, e);
}
const c0 = /* @__PURE__ */ L({
    relu6_: ET
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function LT(n, t) {
    const s = {
        x: T(n, "x", "reverse")
    }, o = {
        dims: t
    };
    return $.runKernel(zc, s, o);
}
const Lo = /* @__PURE__ */ L({
    reverse_: LT
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function MT(n) {
    const e = {
        x: T(n, "x", "round")
    };
    return $.runKernel(sa, e);
}
const u0 = /* @__PURE__ */ L({
    round_: MT
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function WT(n) {
    const e = {
        x: T(n, "x", "rsqrt", "float32")
    };
    return $.runKernel(oa, e);
}
const d0 = /* @__PURE__ */ L({
    rsqrt_: WT
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function DT(n) {
    const e = {
        x: T(n, "x", "selu")
    };
    return $.runKernel(ra, e);
}
const h0 = /* @__PURE__ */ L({
    selu_: DT
});
function FT(n, t, e, s, o, r = [
    1,
    1
], i = "NHWC") {
    const a = T(n, "x", "separableConv2d"), l = T(t, "depthwiseFilter", "separableConv2d"), c = T(e, "pointwiseFilter", "separableConv2d");
    let u = a, d = !1;
    if (a.rank === 3 && (d = !0, u = W(a, [
        1,
        a.shape[0],
        a.shape[1],
        a.shape[2]
    ])), i === "NCHW") throw new Error("separableConv2d currently does not support dataFormat NCHW; only NHWC is supported");
    C(u.rank === 4, ()=>`Error in separableConv2d: input must be rank 4, but got rank ${u.rank}.`), C(l.rank === 4, ()=>`Error in separableConv2d: depthwise filter must be rank 4, but got rank ${l.rank}.`), C(c.rank === 4, ()=>`Error in separableConv2d: pointwise filter must be rank 4, but got rank ${l.rank}.`), C(c.shape[0] === 1, ()=>`Error in separableConv2d: the first dimension of pointwise filter  must be 1, but got ${c.shape[0]}.`), C(c.shape[1] === 1, ()=>`Error in separableConv2d: the second dimension of pointwise filter must be 1, but got ${c.shape[1]}.`);
    const h = l.shape[2], p = l.shape[3];
    C(c.shape[2] === h * p, ()=>`Error in separableConv2d: the third dimension of pointwise filter must be ${h * p}, but got ${c.shape[2]}.`);
    const f = ap(u, l, s, o, i, r), g = $o(f, c, 1, "valid", i);
    return d ? W(g, [
        g.shape[1],
        g.shape[2],
        g.shape[3]
    ]) : g;
}
const p0 = /* @__PURE__ */ L({
    separableConv2d_: FT
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function VT(n) {
    const e = {
        x: T(n, "x", "sign")
    };
    return $.runKernel(la, e);
}
const zT = /* @__PURE__ */ L({
    sign_: VT
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function PT(n) {
    const e = {
        x: T(n, "x", "sin", "float32")
    };
    return $.runKernel(ia, e);
}
const f0 = /* @__PURE__ */ L({
    sin_: PT
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function AT(n) {
    const e = {
        x: T(n, "x", "sinh")
    };
    return $.runKernel(aa, e);
}
const m0 = /* @__PURE__ */ L({
    sinh_: AT
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function OT(n, t, e) {
    const s = T(n, "x", "slice1d");
    return C(s.rank === 1, ()=>`slice1d expects a rank-1 tensor, but got a rank-${s.rank} tensor`), Ft(s, [
        t
    ], [
        e
    ]);
}
const Np = /* @__PURE__ */ L({
    slice1d_: OT
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function XT(n, t, e) {
    const s = T(n, "x", "slice2d");
    return C(s.rank === 2, ()=>`slice2d expects a rank-2 tensor, but got a rank-${s.rank} tensor`), Ft(s, t, e);
}
const g0 = /* @__PURE__ */ L({
    slice2d_: XT
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function KT(n, t, e) {
    const s = T(n, "x", "slice3d");
    return C(s.rank === 3, ()=>`slice3d expects a rank-3 tensor, but got a rank-${s.rank} tensor`), Ft(s, t, e);
}
const Rp = /* @__PURE__ */ L({
    slice3d_: KT
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ZT(n, t, e) {
    const s = T(n, "x", "slice4d");
    return C(s.rank === 4, ()=>`slice4d expects a rank-4 tensor, but got a rank-${s.rank} tensor`), Ft(s, t, e);
}
const Sl = /* @__PURE__ */ L({
    slice4d_: ZT
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function BT(n, t = -1) {
    const e = T(n, "logits", "softmax", "float32");
    if (t === -1 && (t = e.rank - 1), t !== e.rank - 1) throw Error(`Softmax along a non-last dimension is not yet supported. Logits was rank ${e.rank} and dim was ${t}`);
    const s = {
        logits: e
    }, o = {
        dim: t
    };
    return $.runKernel(Zc, s, o);
}
const $p = /* @__PURE__ */ L({
    softmax_: BT
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function HT(n) {
    C(n.dtype === "complex64", ()=>`The dtype for tf.spectral.fft() must be complex64 but got ${n.dtype}.`);
    const t = {
        input: n
    };
    return $.runKernel(yh, t);
}
const Gp = /* @__PURE__ */ L({
    fft_: HT
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function _T(n) {
    C(n.dtype === "complex64", ()=>`The dtype for tf.spectral.ifft() must be complex64 but got ${n.dtype}.`);
    const t = {
        input: n
    };
    return $.runKernel(Ch, t);
}
const kl = /* @__PURE__ */ L({
    ifft_: _T
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function UT(n) {
    const t = n.shape[n.shape.length - 1], e = n.size / t;
    let s;
    if (t <= 2) {
        const o = W(n, [
            e,
            t
        ]);
        s = kl(o);
    } else {
        const o = [
            e,
            2 * (t - 1)
        ], r = W(vl(n), [
            e,
            t
        ]), i = W(up(n), [
            e,
            t
        ]), a = Lo(Ft(r, [
            0,
            1
        ], [
            e,
            t - 2
        ]), 1), l = G(Lo(Ft(i, [
            0,
            1
        ], [
            e,
            t - 2
        ]), 1), gt(-1)), c = Ge([
            r,
            a
        ], 1), u = Ge([
            i,
            l
        ], 1), d = W(vo(c, u), [
            o[0],
            o[1]
        ]);
        s = kl(d);
    }
    if (s = vl(s), n.rank === 3 && n.shape[0] !== 0) {
        const o = s, r = n.shape[0];
        s = W(s, [
            r,
            s.shape[0] / r,
            s.shape[1]
        ]), o.dispose();
    }
    return s;
}
const b0 = /* @__PURE__ */ L({
    irfft_: UT
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function YT(n, t, e = 0) {
    const o = {
        x: T(n, "x", "split")
    }, r = {
        numOrSizeSplits: t,
        axis: e
    };
    return $.runKernel(Kc, o, r);
}
const pn = /* @__PURE__ */ L({
    split_: YT
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function QT(n, t) {
    C(n.dtype === "float32", ()=>`The dtype for rfft() must be real value but got ${n.dtype}`);
    let e = n.shape[n.shape.length - 1];
    const s = n.size / e;
    let o;
    if (t != null && t < e) {
        const f = n.shape.map((g)=>0), m = n.shape.map((g)=>g);
        m[n.shape.length - 1] = t, o = Ft(n, f, m), e = t;
    } else if (t != null && t > e) {
        const f = n.shape.map((m)=>m);
        f[n.shape.length - 1] = t - e, o = Ge([
            n,
            be(f)
        ], n.shape.length - 1), e = t;
    } else o = n;
    const r = Tt(o), i = W(vo(o, r), [
        s,
        e
    ]), a = Gp(i), l = Math.floor(e / 2) + 1, c = vl(a), u = up(a), d = pn(c, [
        l,
        e - l
    ], c.shape.length - 1), h = pn(u, [
        l,
        e - l
    ], u.shape.length - 1), p = o.shape.slice();
    return p[o.shape.length - 1] = l, W(vo(d[0], h[0]), p);
}
const Ep = /* @__PURE__ */ L({
    rfft_: QT
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function JT(n, t) {
    let e = T(n, "a", "squaredDifference"), s = T(t, "b", "squaredDifference");
    [e, s] = se(e, s), bt(e.shape, s.shape);
    const o = {
        a: e,
        b: s
    }, r = {};
    return $.runKernel(ha, o, r);
}
const x0 = /* @__PURE__ */ L({
    squaredDifference_: JT
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function jT(n, t) {
    const e = T(n, "x", "squeeze", "string_or_numeric");
    return W(e, ws(e.shape, t).newShape);
}
const ka = /* @__PURE__ */ L({
    squeeze_: jT
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function qT(n, t = 0) {
    const e = jh(n, "tensors", "stack", "string_or_numeric");
    C(e.length >= 1, ()=>"Pass at least one tensor to tf.stack"), e.length > 0 && C(t <= e[0].rank, ()=>"Axis must be <= rank of the tensor");
    const s = e, o = {
        axis: t
    };
    return $.runKernel(Ec, s, o);
}
const Xn = /* @__PURE__ */ L({
    stack_: qT
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function tN(n, t = 0) {
    const s = {
        x: T(n, "x", "step")
    }, o = {
        alpha: t
    };
    return $.runKernel(ba, s, o);
}
const Ta = /* @__PURE__ */ L({
    step_: tN
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function eN(n, t, e, s, o = 0, r = 0, i = 0, a = 0, l = 0) {
    const u = {
        x: T(n, "x", "stridedSlice", "string_or_numeric")
    }, d = {
        begin: t,
        end: e,
        strides: s,
        beginMask: o,
        endMask: r,
        ellipsisMask: i,
        newAxisMask: a,
        shrinkAxisMask: l
    };
    return $.runKernel(Ph, u, d);
}
const nN = /* @__PURE__ */ L({
    stridedSlice_: eN
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function sN(n) {
    const e = {
        x: T(n, "x", "tan", "float32")
    };
    return $.runKernel(fa, e);
}
const oN = /* @__PURE__ */ L({
    tan_: sN
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Ze(n, t) {
    Hl(n);
    const e = ya(n, t);
    if (e.length !== 1) throw new Error("tensor1d() requires values to be a flat/TypedArray");
    return wa(n, null, e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function il(n, t, e) {
    if (Hl(n), t != null && t.length !== 2) throw new Error("tensor2d() requires shape to have two numbers");
    const s = ya(n, e);
    if (s.length !== 2 && s.length !== 1) throw new Error("tensor2d() requires values to be number[][] or flat/TypedArray");
    if (s.length === 1 && t == null) throw new Error("tensor2d() requires shape to be provided when `values` are a flat/TypedArray");
    return wa(n, t, s, e);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function rN(n, t, e) {
    if (Hl(n), t != null && t.length !== 3) throw new Error("tensor3d() requires shape to have three numbers");
    const s = ya(n, e);
    if (s.length !== 3 && s.length !== 1) throw new Error("tensor3d() requires values to be number[][][] or flat/TypedArray");
    if (s.length === 1 && t == null) throw new Error("tensor3d() requires shape to be provided when `values` are a flat array");
    return wa(n, t, s, e);
}
function Lp(n, t, e) {
    const s = t.rank > 1 ? t.shape[t.rank - 1] : 1, o = t.rank > 1 ? t.rank - 1 : 1, r = `Must have updates.shape = indices.shape[:batchDim] + shape[sliceDim:], got updates.shape: ${e.shape}, indices.shape: ${t.shape}, shape: ${n}, sliceDim: ${s}, and batchDim: ${o}.`;
    if (e.rank < o) throw new Error(r + ` update.rank < ${o}. `);
    if (n.length < s + (e.rank - o)) throw new Error(r + ` Output shape length < ${s + (e.rank - o)}`);
    if (e.rank !== o + n.length - s) throw new Error(r + ` update.rank != ${o + n.length - s}`);
    for(let i = 0; i < o; ++i)if (e.shape[i] !== t.shape[i]) throw new Error(r + ` updates.shape[${i}] (${e.shape[i]}) != indices.shape[${i}] (${t.shape[i]}).`);
    for(let i = 0; i < e.rank - o; ++i)if (e.shape[i + o] !== n[i + s]) throw new Error(r + ` updates.shape[${i + o}] (${e.shape[i + o]}) != shape[${i + o}] (${n[i + o]})`);
}
function y0(n, t, e) {
    if (t.rank < 1) throw new Error(`tf.scatterND() expects the indices to be rank 1 or higher, but the rank was ${t.rank}.`);
    if (n.rank < 1) throw new Error(`tf.scatterND() expects the updates to be rank 1 or higher, but the rank was ${n.rank}.`);
    if (t.dtype !== "int32") throw new Error(`The dtype of 'indices' should be int32, but got dtype: ${t.dtype}`);
    if (e.length < 1) throw new Error(`Output rank must be greater or equal to 1, but got shape: ${e}`);
    if (e.length === 0) {
        if (t.size === 0) throw new Error(`Indices specified for empty output. indices shape: ${t.shape}`);
        if (n.size === 0) throw new Error(`Updates specified for empty output. updates shape: ${n.shape}`);
    }
    Lp(e, t, n);
}
function to(n, t, e) {
    const s = t.shape.length, o = s > 1 ? t.shape[s - 1] : 1, r = e.length;
    let i = 1;
    for(let d = o; d < r; ++d)i *= e[d];
    const a = o < 1 ? 1 : o, l = X(t.shape) / a, c = [
        ...dt(e.slice(0, o)),
        1
    ], u = X(e);
    return {
        sliceRank: o,
        numUpdates: l,
        sliceSize: i,
        strides: c,
        outputSize: u
    };
}
const TQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    calculateShapes: to,
    validateInput: y0,
    validateUpdateShape: Lp
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function iN(n, t = 1, e = !0) {
    const s = T(n, "x", "topk");
    if (s.rank === 0) throw new Error("topk() expects the input to be of rank 1 or higher");
    const o = s.shape[s.shape.length - 1];
    if (t < 0) throw new Error(`'k' passed to topk() must be >= 0 but got ${t}`);
    if (t > o) throw new Error(`'k' passed to topk() must be <= the last dimension (${o}) but got ${t}`);
    const r = {
        x: s
    }, i = {
        k: t,
        sorted: e
    }, [a, l] = $.runKernel(Kh, r, i);
    return {
        values: a,
        indices: l
    };
}
const aN = /* @__PURE__ */ L({
    topk_: iN
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function lN(n, t = 0, e = 1, s, o) {
    if (is(n), s != null && s === "bool") throw new Error("Unsupported data type $ { dtype }");
    const r = new Tp(t, e, s, !0, o), i = vt(n, s);
    for(let a = 0; a < i.values.length; a++)i.values[a] = r.nextValue();
    return i.toTensor();
}
const w0 = /* @__PURE__ */ L({
    truncatedNormal_: lN
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function cN(n, t = 0) {
    const e = T(n, "x", "unique", "string_or_numeric");
    C(e.rank > 0, ()=>"The input tensor must be at least 1D");
    const s = {
        x: e
    }, o = {
        axis: t
    }, [r, i] = $.runKernel(Bh, s, o);
    return {
        values: r,
        indices: i
    };
}
const uN = /* @__PURE__ */ L({
    unique_: cN
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function dN(n, t, e) {
    const s = T(n, "x", "unsortedSegmentSum"), o = T(t, "segmentIds", "unsortedSegmentSum", "int32");
    C(Co(e), ()=>"numSegments must be of dtype int");
    const r = {
        x: s,
        segmentIds: o
    }, i = {
        numSegments: e
    };
    return $.runKernel(_c, r, i);
}
const I0 = /* @__PURE__ */ L({
    unsortedSegmentSum_: dN
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function hN(n, t = 0) {
    const e = T(n, "x", "unstack", "string_or_numeric");
    C(t >= -e.shape.length && t < e.shape.length, ()=>`Axis = ${t} is not in [-${e.shape.length}, ${e.shape.length})`);
    const s = {
        value: e
    }, o = {
        axis: t
    };
    return $.runKernel(Hc, s, o);
}
const Mo = /* @__PURE__ */ L({
    unstack_: hN
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function pN(n, t = !0, e, s) {
    return $.makeVariable(n, t, e, s);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function C0(n, t) {
    const e = [];
    for(let r = 0; r < t.length; r++)t[r] && e.push(r);
    const s = vt(n, "int32"), o = vt([
        e.length,
        n.length
    ], "int32");
    for(let r = 0; r < e.length; r++){
        const i = s.indexToLoc(e[r]), a = r * n.length;
        o.values.set(i, a);
    }
    return o.toTensor();
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function fN(n, t, e) {
    const s = T(n, "x", "transpose");
    if (t == null && (t = s.shape.map((i, a)=>a).reverse()), C(s.rank === t.length, ()=>`Error in transpose: rank of input ${s.rank} must match length of perm ${t}.`), t.forEach((i)=>{
        C(i >= 0 && i < s.rank, ()=>`All entries in 'perm' must be between 0 and ${s.rank - 1} but got ${t}`);
    }), s.rank <= 1) return s.clone();
    const o = {
        x: s
    }, r = {
        perm: t
    };
    return s.dtype === "complex64" ? D(()=>{
        let i = vl(s), a = up(s);
        return i = $.runKernel(ar, {
            x: i
        }, r), a = $.runKernel(ar, {
            x: a
        }, r), e && (a = Yt(a)), vo(i, a);
    }) : $.runKernel(ar, o, r);
}
const kt = /* @__PURE__ */ L({
    transpose_: fN
});
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function mN(n, t) {
    if (t == null) return n.shape.slice();
    if ($t(n.shape, t)) return t;
    if (n.shape.length === t.length) {
        const e = [];
        for(let s = 0; s < n.shape.length; s++)t[s] == null && n.shape[s] != null ? e.push(n.shape[s]) : e.push(t[s]);
        return e;
    }
    return t;
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function gN(n, t, e, s) {
    const o = T(n, "x", "dropout");
    if (C(o.dtype === "float32", ()=>`x has to be a floating point tensor since it's going to be scaled, but got a ${o.dtype} tensor instead.`), C(t >= 0 && t < 1, ()=>`rate must be a float in the range [0, 1), but got ${t}.`), t === 0) return n instanceof Mt ? o.clone() : o;
    const r = mN(o, e), i = 1 - t, a = ut(qc(U(Sa(r, 0, 1, "float32", s), i)), i);
    return G(o, a);
}
const bN = /* @__PURE__ */ L({
    dropout_: gN
});
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function xN(n) {
    return Math.floor(Math.pow(2, Math.ceil(Math.log(n) / Math.log(2))));
}
function v0(n, t, e) {
    const s = 1 - n % 2, o = new Float32Array(n);
    for(let r = 0; r < n; ++r){
        const i = 2 * Math.PI * r / (n + s - 1);
        o[r] = t - e * Math.cos(i);
    }
    return Ze(o, "float32");
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function yN(n, t, e, s, o, r = "NHWC", i) {
    let a = n;
    n.rank === 3 && (a = W(n, [
        1,
        n.shape[0],
        n.shape[1],
        n.shape[2]
    ]));
    let l = t;
    l.rank === 3 && (l = W(t, [
        1,
        t.shape[0],
        t.shape[1],
        t.shape[2]
    ])), C(a.rank === 4, ()=>`Error in conv2dDerFilter: input must be rank 4, but got shape ${a.shape}.`), C(l.rank === 4, ()=>`Error in conv2dDerFilter: dy must be rank 4, but got shape ${l.shape}.`), C(e.length === 4, ()=>`Error in conv2dDerFilter: filterShape must be length 4, but got ${e}.`);
    const c = r === "NHWC" ? a.shape[3] : a.shape[1], u = r === "NHWC" ? l.shape[3] : l.shape[1];
    C(c === e[2], ()=>`Error in conv2dDerFilter: depth of input ${c}) must match input depth in filter (${e[2]}.`), C(u === e[3], ()=>`Error in conv2dDerFilter: depth of dy (${u}) must match output depth for filter (${e[3]}).`), Ue("conv2dDerFilter", o, i);
    const d = {
        x: a,
        dy: l
    }, h = {
        strides: s,
        pad: o,
        dataFormat: r,
        dimRoundingMode: i,
        filterShape: e
    };
    return $.runKernel(ah, d, h);
}
const Mp = /* @__PURE__ */ L({
    conv2DBackpropFilter_: yN
});
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Wp(n, t, e) {
    if (e == null || e === "linear") return n;
    if (e === "relu") return G(n, Ta(t));
    throw new Error(`Cannot compute gradient for fused activation ${e}.`);
}
function Dp(n, t) {
    let e = t;
    const s = ce(n.shape, t.shape);
    return s.length > 0 && (e = at(e, s)), W(e, n.shape);
}
function Fp(n, t, e, s) {
    if (t === "linear") return n;
    if (t === "relu") return Ts(n);
    if (t === "elu") return Jc(n);
    if (t === "relu6") return c0(n);
    if (t === "prelu") return yp(n, e);
    if (t === "leakyrelu") return dp(n, s);
    if (t === "sigmoid") return kr(n);
    throw new Error(`Unknown fused activation ${t}.`);
}
const Vp = (n, t)=>!(n > 0) || t === "linear";
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function wN({ x: n, filter: t, strides: e, pad: s, dataFormat: o = "NHWC", dilations: r = [
    1,
    1
], dimRoundingMode: i, bias: a, activation: l = "linear", preluActivationWeights: c, leakyreluAlpha: u }) {
    if (l = l || "linear", Vp($.state.gradientDepth, l) === !1) {
        C(o === "NHWC", ()=>`Error in fused conv2d: got dataFormat of ${o} but only NHWC is currently supported for the case of gradient depth is 0 and the activation is not linear.`);
        let v = $o(n, t, e, s, o, r, i);
        return a != null && (v = U(v, a)), Fp(v, l, c, u);
    }
    const d = T(n, "x", "conv2d", "float32"), h = T(t, "filter", "conv2d", "float32");
    let p = d, f = !1;
    d.rank === 3 && (f = !0, p = W(d, [
        1,
        d.shape[0],
        d.shape[1],
        d.shape[2]
    ])), C(p.rank === 4, ()=>`Error in fused conv2d: input must be rank 4, but got rank ${p.rank}.`), C(h.rank === 4, ()=>`Error in fused conv2d: filter must be rank 4, but got rank ${h.rank}.`), Ue("fused conv2d", s, i);
    const m = o === "NHWC" ? p.shape[3] : p.shape[1];
    C(h.shape[2] === m, ()=>`Error in conv2d: depth of input (${m}) must match input depth for filter ${h.shape[2]}.`), C(Le(e, r), ()=>`Error in conv2D: Either strides or dilations must be 1. Got strides ${e} and dilations '${r}'`);
    const g = Te(p.shape, h.shape, e, r, s, i);
    let b;
    a != null && (b = T(a, "bias", "fused conv2d"), [b] = se(b, d), o === "NHWC" ? bt(g.outShape, b.shape) : (C(b.shape.length <= 1, ()=>`Error in fused conv2d: only supports scalar or 1-D Tensor bias for NCHW format but got the bias of rank-${b.shape.length}.`), C(b.shape.length === 0 || b.shape[0] === g.outChannels || b.shape[0] === 1, ()=>`Error in fused conv2d: bias shape (${b.shape}) is not compatible with the number of output channels (${g.outChannels})`)));
    let x;
    if (c != null) {
        const v = c.shape;
        if (C(v.length <= 1 || v.length === 3, ()=>`Error in fused conv2d: only supports scalar, 1-D Tensor or 3-D Tensor PReLU activation weights but got a tensor of rank-${v.length}.`), v.length === 1) C(v[0] === 1 || v[0] === g.outChannels, ()=>`Error in fused conv2d: PReLU activation weights (${v}) is not compatible with the number of output channels (${g.outChannels}).`);
        else if (v.length === 3) try {
            bt(v, g.outShape);
        } catch  {
            const S = `Error in fused conv2d: PReLU activation weights (${v}) is not compatible with the output shape of the conv2d (${g.outShape}).`;
            throw Error(S);
        }
        x = T(c, "prelu weights", "fused conv2d");
    }
    const w = (v, k)=>{
        C(o === "NHWC", ()=>`Error in gradient of fused conv2D: got dataFormat of ${o} but only NHWC is currently supported.`);
        const [S, N, R, M] = k, V = Wp(v, R, l);
        C(No(r), ()=>`Error in gradient of fused conv2D: dilation rates greater than 1 are not yet supported in gradients. Got dilations '${r}'`);
        const z = rp(N.shape, V, S, e, s), P = Mp(N, V, S.shape, e, s), A = [
            z,
            P
        ];
        if (M != null) {
            const O = Dp(M, V);
            A.push(O);
        }
        return A;
    }, y = {
        x: p,
        filter: h,
        bias: b,
        preluActivationWeights: x
    }, I = {
        strides: e,
        pad: s,
        dataFormat: o,
        dilations: r,
        dimRoundingMode: i,
        activation: l,
        leakyreluAlpha: u
    };
    return a == null ? Eo((k, S, N)=>{
        let R = // tslint:disable-next-line: no-unnecessary-type-assertion
        $.runKernel(gl, y, I);
        return N([
            S,
            k,
            R
        ]), f && (R = W(R, [
            R.shape[1],
            R.shape[2],
            R.shape[3]
        ])), {
            value: R,
            gradFunc: w
        };
    })(p, h) : Eo((k, S, N, R)=>{
        let M = $.runKernel(gl, y, I);
        return R([
            S,
            k,
            M,
            N
        ]), f && (M = W(M, [
            M.shape[1],
            M.shape[2],
            M.shape[3]
        ])), {
            value: M,
            gradFunc: w
        };
    })(p, h, b);
}
const IN = /* @__PURE__ */ L({
    fusedConv2d_: wN
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function CN(n, t, e, s, o, r = [
    1,
    1
], i) {
    let a = n;
    n.rank === 3 && (a = W(n, [
        1,
        n.shape[0],
        n.shape[1],
        n.shape[2]
    ]));
    let l = t;
    l.rank === 3 && (l = W(t, [
        1,
        t.shape[0],
        t.shape[1],
        t.shape[2]
    ]));
    const c = {
        x: a,
        dy: l
    }, u = {
        strides: s,
        pad: o,
        dimRoundingMode: i,
        dilations: r,
        filterShape: e
    };
    return $.runKernel(fh, c, u);
}
const vN = L({
    depthwiseConv2dNativeBackpropFilter_: CN
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function SN(n, t, e, s, o, r = [
    1,
    1
], i) {
    let a = t, l = !1;
    t.rank === 3 && (l = !0, a = W(t, [
        1,
        t.shape[0],
        t.shape[1],
        t.shape[2]
    ]));
    const c = {
        dy: a,
        filter: e
    }, u = {
        strides: s,
        pad: o,
        dimRoundingMode: i,
        dilations: r,
        inputShape: n
    }, d = // tslint:disable-next-line: no-unnecessary-type-assertion
    $.runKernel(mh, c, u);
    return l ? W(d, [
        d.shape[1],
        d.shape[2],
        d.shape[3]
    ]) : d;
}
const kN = L({
    depthwiseConv2dNativeBackpropInput_: SN
});
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function TN({ a: n, b: t, transposeA: e = !1, transposeB: s = !1, bias: o, activation: r = "linear", preluActivationWeights: i, leakyreluAlpha: a = 0.2 }) {
    if (Vp($.state.gradientDepth, r) === !1) {
        let M = Gt(n, t, e, s);
        return o != null && (M = U(M, o)), Fp(M, r, i, a);
    }
    let l = T(n, "a", "fused matMul"), c = T(t, "b", "fused matMul");
    [l, c] = se(l, c);
    const u = e ? l.shape[l.rank - 2] : l.shape[l.rank - 1], d = s ? c.shape[c.rank - 1] : c.shape[c.rank - 2], h = e ? l.shape[l.rank - 1] : l.shape[l.rank - 2], p = s ? c.shape[c.rank - 2] : c.shape[c.rank - 1], f = l.shape.slice(0, -2), m = c.shape.slice(0, -2), g = X(f), b = X(m);
    C(u === d, ()=>`Error in fused matMul: inner shapes (${u}) and (${d}) of Tensors with shapes ${l.shape} and ${c.shape} and transposeA=${e} and transposeB=${s} must match.`);
    const w = bt(l.shape.slice(0, -2), c.shape.slice(0, -2)).concat([
        h,
        p
    ]), y = e ? W(l, [
        g,
        u,
        h
    ]) : W(l, [
        g,
        h,
        u
    ]), I = s ? W(c, [
        b,
        p,
        d
    ]) : W(c, [
        b,
        d,
        p
    ]);
    let v;
    o != null && (v = T(o, "bias", "fused matMul"), [v] = se(v, l), bt(w, v.shape));
    let k;
    i != null && (k = T(i, "prelu weights", "fused matMul"));
    const S = (M, V)=>{
        const [z, P, A, O] = V, B = Wp(W(M, A.shape), A, r);
        let Z, H;
        if (!e && !s ? (Z = Gt(B, P, !1, !0), H = Gt(z, B, !0, !1)) : !e && s ? (Z = Gt(B, P, !1, !1), H = Gt(B, z, !0, !1)) : e && !s ? (Z = Gt(P, B, !1, !0), H = Gt(z, B, !1, !1)) : (Z = Gt(P, B, !0, !0), H = Gt(B, z, !0, !0)), o != null) {
            const Y = Dp(O, B);
            return [
                Z,
                H,
                Y
            ];
        } else return [
            Z,
            H
        ];
    }, N = {
        a: y,
        b: I,
        bias: v,
        preluActivationWeights: k
    }, R = {
        transposeA: e,
        transposeB: s,
        activation: r,
        leakyreluAlpha: a
    };
    return o == null ? Eo((V, z, P)=>{
        const A = // tslint:disable-next-line: no-unnecessary-type-assertion
        $.runKernel(ml, N, R);
        return P([
            V,
            z,
            A
        ]), {
            value: W(A, w),
            gradFunc: S
        };
    })(y, I) : Eo((V, z, P, A)=>{
        const O = // tslint:disable-next-line: no-unnecessary-type-assertion
        $.runKernel(ml, N, R);
        return A([
            V,
            z,
            O,
            P
        ]), {
            value: W(O, w),
            gradFunc: S
        };
    })(y, I, v);
}
const Nm = /* @__PURE__ */ L({
    fusedMatMul_: TN
});
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function NN(n) {
    return v0(n, 0.54, 0.46);
}
const RN = /* @__PURE__ */ L({
    hammingWindow_: NN
});
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $N(n) {
    return v0(n, 0.5, 0.5);
}
const S0 = /* @__PURE__ */ L({
    hannWindow_: $N
});
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function GN(n, t, e, s = !1, o = 0) {
    let r = 0;
    const i = [];
    for(; r + t <= n.size;)i.push(Ft(n, r, t)), r += e;
    if (s) for(; r < n.size;){
        const a = r + t - n.size, l = Ge([
            Ft(n, r, t - a),
            Ca([
                a
            ], o)
        ]);
        i.push(l), r += e;
    }
    return i.length === 0 ? il([], [
        0,
        t
    ]) : W(Ge(i), [
        i.length,
        t
    ]);
}
const k0 = /* @__PURE__ */ L({
    frame_: GN
});
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function EN(n, t, e, s, o = S0) {
    s == null && (s = xN(t));
    const r = k0(n, t, e), i = G(r, o(t));
    return Ep(i, s);
}
const LN = /* @__PURE__ */ L({
    stft_: EN
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function MN(n, t, e, s, o = "bilinear", r = 0) {
    const i = T(n, "image", "cropAndResize"), a = T(t, "boxes", "cropAndResize", "float32"), l = T(e, "boxInd", "cropAndResize", "int32"), c = a.shape[0];
    C(i.rank === 4, ()=>`Error in cropAndResize: image must be rank 4,but got rank ${i.rank}.`), C(a.rank === 2 && a.shape[1] === 4, ()=>`Error in cropAndResize: boxes must be have size [${c},4] but had shape ${a.shape}.`), C(l.rank === 1 && l.shape[0] === c, ()=>`Error in cropAndResize: boxInd must be have size [${c}] but had shape ${a.shape}.`), C(s.length === 2, ()=>`Error in cropAndResize: cropSize must be of length 2, but got length ${s.length}.`), C(s[0] >= 1 && s[1] >= 1, ()=>`cropSize must be atleast [1,1], but was ${s}`), C(o === "bilinear" || o === "nearest", ()=>`method must be bilinear or nearest, but was ${o}`);
    const u = {
        image: i,
        boxes: a,
        boxInd: l
    }, d = {
        method: o,
        extrapolationValue: r,
        cropSize: s
    };
    return $.runKernel(dh, u, d);
}
const WN = /* @__PURE__ */ L({
    cropAndResize_: MN
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function DN(n) {
    const t = T(n, "image", "flipLeftRight", "float32");
    C(t.rank === 4, ()=>`Error in flipLeftRight: image must be rank 4,but got rank ${t.rank}.`);
    const e = {
        image: t
    };
    return $.runKernel(Ih, e, {});
}
const FN = /* @__PURE__ */ L({
    flipLeftRight_: DN
});
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function VN(n) {
    const t = T(n, "image", "grayscaleToRGB"), e = t.rank - 1, s = t.shape[e];
    C(t.rank >= 2, ()=>`Error in grayscaleToRGB: images must be at least rank 2, but got rank ${t.rank}.`), C(s === 1, ()=>`Error in grayscaleToRGB: last dimension of a grayscale image should be size 1, but got size ${s}.`);
    const o = new Array(t.rank);
    return o.fill(1, 0, e), o[e] = 3, Vn(t, o);
}
const zN = /* @__PURE__ */ L({
    grayscaleToRGB_: VN
});
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function PN(n) {
    const t = T(n, "image", "RGBToGrayscale"), e = t.rank - 1, s = t.shape[e];
    C(t.rank >= 2, ()=>`Error in RGBToGrayscale: images must be at least rank 2, but got rank ${t.rank}.`), C(s === 3, ()=>`Error in RGBToGrayscale: last dimension of an RGB image should be size 3, but got size ${s}.`);
    const o = t.dtype, r = tt(t, "float32"), i = Ze([
        0.2989,
        0.587,
        0.114
    ]);
    let a;
    switch(t.rank){
        case 2:
            a = Or("ij,j->i", r, i);
            break;
        case 3:
            a = Or("ijk,k->ij", r, i);
            break;
        case 4:
            a = Or("ijkl,l->ijk", r, i);
            break;
        case 5:
            a = Or("ijklm,m->ijkl", r, i);
            break;
        case 6:
            a = Or("ijklmn,n->ijklm", r, i);
            break;
        default:
            throw new Error("Not a valid tensor rank.");
    }
    return a = Oe(a, -1), tt(a, o);
}
const AN = /* @__PURE__ */ L({
    rgbToGrayscale_: PN
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ON(n, t, e = 0, s = 0.5) {
    const o = T(n, "image", "rotateWithOffset", "float32");
    C(o.rank === 4, ()=>`Error in rotateWithOffset: image must be rank 4,but got rank ${o.rank}.`);
    const r = {
        image: o
    }, i = {
        radians: t,
        fillValue: e,
        center: s
    };
    return $.runKernel(Hh, r, i);
}
const XN = /* @__PURE__ */ L({
    rotateWithOffset_: ON
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Rr(n, t, e, s, o, r) {
    s == null && (s = 0.5), o == null && (o = Number.NEGATIVE_INFINITY), r == null && (r = 0);
    const i = n.shape[0];
    return e = Math.min(e, i), C(0 <= s && s <= 1, ()=>`iouThreshold must be in [0, 1], but was '${s}'`), C(n.rank === 2, ()=>`boxes must be a 2D tensor, but was of rank '${n.rank}'`), C(n.shape[1] === 4, ()=>`boxes must have 4 columns, but 2nd dimension was ${n.shape[1]}`), C(t.rank === 1, ()=>"scores must be a 1D tensor"), C(t.shape[0] === i, ()=>`scores has incompatible shape with boxes. Expected ${i}, but was ${t.shape[0]}`), C(0 <= r && r <= 1, ()=>`softNmsSigma must be in [0, 1], but was '${r}'`), {
        maxOutputSize: e,
        iouThreshold: s,
        scoreThreshold: o,
        softNmsSigma: r
    };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function KN(n, t, e, s = 0.5, o = Number.NEGATIVE_INFINITY) {
    const r = T(n, "boxes", "nonMaxSuppression", "float32"), i = T(t, "scores", "nonMaxSuppression", "float32"), a = Rr(r, i, e, s, o);
    e = a.maxOutputSize, s = a.iouThreshold, o = a.scoreThreshold;
    const l = {
        maxOutputSize: e,
        iouThreshold: s,
        scoreThreshold: o
    };
    return $.runKernel(Nh, {
        boxes: r,
        scores: i
    }, l);
}
const ZN = /* @__PURE__ */ L({
    nonMaxSuppression_: KN
});
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function BN(n, t, e) {
    const s = HN(n, t, e), o = s < 0 ? -(s + 1) : s;
    n.splice(o, 0, t);
}
function HN(n, t, e) {
    return UN(n, t, e || _N);
}
function _N(n, t) {
    return n > t ? 1 : n < t ? -1 : 0;
}
function UN(n, t, e) {
    let s = 0, o = n.length, r = 0, i = !1;
    for(; s < o;){
        r = s + (o - s >>> 1);
        const a = e(t, n[r]);
        a > 0 ? s = r + 1 : (o = r, i = !a);
    }
    return i ? s : -s - 1;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function zp(n, t, e, s, o) {
    return Op(n, t, e, s, o, 0);
}
function Pp(n, t, e, s, o, r) {
    return Op(n, t, e, s, o, 0, !1, r, !0);
}
function Ap(n, t, e, s, o, r) {
    return Op(n, t, e, s, o, r, !0);
}
function Op(n, t, e, s, o, r, i = !1, a = !1, l = !1) {
    const c = [];
    for(let g = 0; g < t.length; g++)t[g] > o && c.push({
        score: t[g],
        boxIndex: g,
        suppressBeginIndex: 0
    });
    c.sort(Rm);
    const u = r > 0 ? -0.5 / r : 0, d = [], h = [];
    for(; d.length < e && c.length > 0;){
        const g = c.pop(), { score: b, boxIndex: x, suppressBeginIndex: w } = g;
        if (b < o) break;
        let y = !1;
        for(let I = d.length - 1; I >= w; --I){
            const v = YN(n, x, d[I]);
            if (v >= s) {
                y = !0;
                break;
            }
            if (g.score = g.score * QN(s, u, v), g.score <= o) break;
        }
        g.suppressBeginIndex = d.length, y || (g.score === b ? (d.push(x), h.push(g.score)) : g.score > o && BN(c, g, Rm));
    }
    const p = d.length, f = e - p;
    a && f > 0 && (d.push(...new Array(f).fill(0)), h.push(...new Array(f).fill(0)));
    const m = {
        selectedIndices: d
    };
    return i && (m.selectedScores = h), l && (m.validOutputs = p), m;
}
function YN(n, t, e) {
    const s = n.subarray(t * 4, t * 4 + 4), o = n.subarray(e * 4, e * 4 + 4), r = Math.min(s[0], s[2]), i = Math.min(s[1], s[3]), a = Math.max(s[0], s[2]), l = Math.max(s[1], s[3]), c = Math.min(o[0], o[2]), u = Math.min(o[1], o[3]), d = Math.max(o[0], o[2]), h = Math.max(o[1], o[3]), p = (a - r) * (l - i), f = (d - c) * (h - u);
    if (p <= 0 || f <= 0) return 0;
    const m = Math.max(r, c), g = Math.max(i, u), b = Math.min(a, d), x = Math.min(l, h), w = Math.max(b - m, 0) * Math.max(x - g, 0);
    return w / (p + f - w);
}
function QN(n, t, e) {
    const s = Math.exp(t * e * e);
    return e <= n ? s : 0;
}
function Rm(n, t) {
    return n.score - t.score || n.score === t.score && t.boxIndex - n.boxIndex;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ async function JN(n, t, e, s = 0.5, o = Number.NEGATIVE_INFINITY) {
    const r = T(n, "boxes", "nonMaxSuppressionAsync"), i = T(t, "scores", "nonMaxSuppressionAsync"), a = Rr(r, i, e, s, o);
    e = a.maxOutputSize, s = a.iouThreshold, o = a.scoreThreshold;
    const l = await Promise.all([
        r.data(),
        i.data()
    ]), c = l[0], u = l[1], { selectedIndices: d } = zp(c, u, e, s, o);
    return r !== n && r.dispose(), i !== t && i.dispose(), Ze(d, "int32");
}
const jN = JN;
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function qN(n, t, e, s = 0.5, o = Number.NEGATIVE_INFINITY, r = 0) {
    const i = T(n, "boxes", "nonMaxSuppression"), a = T(t, "scores", "nonMaxSuppression"), l = Rr(i, a, e, s, o, r);
    e = l.maxOutputSize, s = l.iouThreshold, o = l.scoreThreshold, r = l.softNmsSigma;
    const c = {
        boxes: i,
        scores: a
    }, u = {
        maxOutputSize: e,
        iouThreshold: s,
        scoreThreshold: o,
        softNmsSigma: r
    }, d = $.runKernel($h, c, u);
    return {
        selectedIndices: d[0],
        selectedScores: d[1]
    };
}
const tR = /* @__PURE__ */ L({
    nonMaxSuppressionWithScore_: qN
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ async function eR(n, t, e, s = 0.5, o = Number.NEGATIVE_INFINITY, r = 0) {
    const i = T(n, "boxes", "nonMaxSuppressionAsync"), a = T(t, "scores", "nonMaxSuppressionAsync"), l = Rr(i, a, e, s, o, r);
    e = l.maxOutputSize, s = l.iouThreshold, o = l.scoreThreshold, r = l.softNmsSigma;
    const c = await Promise.all([
        i.data(),
        a.data()
    ]), u = c[0], d = c[1], { selectedIndices: h, selectedScores: p } = Ap(u, d, e, s, o, r);
    return i !== n && i.dispose(), a !== t && a.dispose(), {
        selectedIndices: Ze(h, "int32"),
        selectedScores: Ze(p)
    };
}
const nR = eR;
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function sR(n, t, e, s = 0.5, o = Number.NEGATIVE_INFINITY, r = !1) {
    const i = T(n, "boxes", "nonMaxSuppression"), a = T(t, "scores", "nonMaxSuppression"), l = Rr(i, a, e, s, o, null), c = l.maxOutputSize, u = l.iouThreshold, d = l.scoreThreshold, h = {
        boxes: i,
        scores: a
    }, p = {
        maxOutputSize: c,
        iouThreshold: u,
        scoreThreshold: d,
        padToMaxOutputSize: r
    }, f = $.runKernel(Rh, h, p);
    return {
        selectedIndices: f[0],
        validOutputs: f[1]
    };
}
const oR = /* @__PURE__ */ L({
    nonMaxSuppressionPadded_: sR
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ async function rR(n, t, e, s = 0.5, o = Number.NEGATIVE_INFINITY, r = !1) {
    const i = T(n, "boxes", "nonMaxSuppressionAsync"), a = T(t, "scores", "nonMaxSuppressionAsync"), l = Rr(i, a, e, s, o, null), c = l.maxOutputSize, u = l.iouThreshold, d = l.scoreThreshold, [h, p] = await Promise.all([
        i.data(),
        a.data()
    ]), { selectedIndices: f, validOutputs: m } = Pp(h, p, c, u, d, r);
    return i !== n && i.dispose(), a !== t && a.dispose(), {
        selectedIndices: Ze(f, "int32"),
        validOutputs: gt(m, "int32")
    };
}
const iR = rR;
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function aR(n, t, e = !1, s = !1) {
    const o = T(n, "images", "resizeBilinear");
    C(o.rank === 3 || o.rank === 4, ()=>`Error in resizeBilinear: x must be rank 3 or 4, but got rank ${o.rank}.`), C(t.length === 2, ()=>`Error in resizeBilinear: new shape must 2D, but got shape ${t}.`), C(s === !1 || e === !1, ()=>"Error in resizeBilinear: If halfPixelCenters is true, alignCorners must be false.");
    let r = o, i = !1;
    o.rank === 3 && (i = !0, r = W(o, [
        1,
        o.shape[0],
        o.shape[1],
        o.shape[2]
    ]));
    const a = {
        images: r
    }, l = {
        alignCorners: e,
        halfPixelCenters: s,
        size: t
    }, c = $.runKernel(Vc, a, l);
    return i ? W(c, [
        c.shape[1],
        c.shape[2],
        c.shape[3]
    ]) : c;
}
const T0 = /* @__PURE__ */ L({
    resizeBilinear_: aR
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function lR(n, t, e = !1, s = !1) {
    const o = T(n, "images", "resizeNearestNeighbor");
    C(o.rank === 3 || o.rank === 4, ()=>`Error in resizeNearestNeighbor: x must be rank 3 or 4, but got rank ${o.rank}.`), C(t.length === 2, ()=>`Error in resizeNearestNeighbor: new shape must 2D, but got shape ${t}.`), C(o.dtype === "float32" || o.dtype === "int32", ()=>"`images` must have `int32` or `float32` as dtype"), C(s === !1 || e === !1, ()=>"Error in resizeNearestNeighbor: If halfPixelCenters is true, alignCorners must be false.");
    let r = o, i = !1;
    o.rank === 3 && (i = !0, r = W(o, [
        1,
        o.shape[0],
        o.shape[1],
        o.shape[2]
    ]));
    const a = {
        images: r
    }, l = {
        alignCorners: e,
        halfPixelCenters: s,
        size: t
    }, c = $.runKernel(Fc, a, l);
    return i ? W(c, [
        c.shape[1],
        c.shape[2],
        c.shape[3]
    ]) : c;
}
const N0 = /* @__PURE__ */ L({
    resizeNearestNeighbor_: lR
});
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function cR(n, t = "binary", e = !1, s = 0.5) {
    const o = T(n, "image", "threshold"), r = 0.2989, i = 0.587, a = 0.114, l = o.shape[0] * o.shape[1];
    let c = G(Ze([
        s
    ]), 255), u, d, h, p;
    if (C(o.rank === 3, ()=>`Error in threshold: image must be rank 3,but got rank ${o.rank}.`), C(o.shape[2] === 3 || o.shape[2] === 1, ()=>`Error in threshold: image color channel must be equal to 3 or 1but got ${o.shape[2]}.`), C(o.dtype === "int32" || o.dtype === "float32", ()=>`Error in dtype: image dtype must be int32 or float32,but got dtype ${o.dtype}.`), C(t === "otsu" || t === "binary", ()=>`Method must be binary or otsu, but was ${t}`), o.shape[2] === 3) {
        [u, d, h] = pn(o, [
            1,
            1,
            1
        ], -1);
        const g = G(u, r), b = G(d, i), x = G(h, a);
        p = U(U(g, b), x);
    } else p = n;
    if (t === "otsu") {
        const g = sS(tt(u0(p), "int32"), $e([]), 256);
        c = uR(g, l);
    }
    const f = e ? Tr(p, c) : rn(p, c);
    return tt(G(f, 255), "int32");
}
function uR(n, t) {
    let e = Ze([
        -1
    ]), s = Ze([
        0
    ]), o = Ze([
        0
    ]), r, i, a, l, c, u;
    for(let d = 0; d < n.size - 1; d++){
        r = Ft(n, 0, d + 1), i = Ft(n, d + 1), c = ut(at(r), t), u = ut(at(i), t);
        const h = at(G(r, di(0, r.size)));
        a = ut(h, at(r));
        const p = Ca(i.shape, r.size), f = U(di(0, i.size), p), m = G(i, f);
        l = ut(at(m), at(i));
        const g = it(a, l), b = it(a, l), x = G(c, u);
        o = G(G(x, g), b);
        const w = rn(o, s);
        s = Ee(w, o, s), e = Ee(w, Ze([
            d
        ]), e);
    }
    return e;
}
const dR = /* @__PURE__ */ L({
    threshold_: cR
});
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function hR(n, t, e = "nearest", s = "constant", o = 0, r) {
    const i = T(n, "image", "transform", "float32"), a = T(t, "transforms", "transform", "float32");
    C(i.rank === 4, ()=>`Error in transform: image must be rank 4,but got rank ${i.rank}.`), C(a.rank === 2 && (a.shape[0] === i.shape[0] || a.shape[0] === 1) && a.shape[1] === 8, ()=>"Error in transform: Input transform should be batch x 8 or 1 x 8"), C(r == null || r.length === 2, ()=>`Error in transform: outputShape must be [height, width] or null, but got ${r}.`);
    const l = {
        image: i,
        transforms: a
    }, c = {
        interpolation: e,
        fillMode: s,
        fillValue: o,
        outputShape: r
    };
    return $.runKernel(Zh, l, c);
}
const pR = /* @__PURE__ */ L({
    transform_: hR
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function fR(n, t, e) {
    const s = T(n, "a", "bandPart");
    C(s.rank >= 2, ()=>`bandPart(): Rank must be at least 2, got ${s.rank}.`);
    const o = s.shape, [r, i] = s.shape.slice(-2);
    let a, l;
    typeof t == "number" ? (C(t % 1 === 0, ()=>`bandPart(): numLower must be an integer, got ${t}.`), C(t <= r, ()=>`bandPart(): numLower (${t}) must not be greater than the number of rows (${r}).`), a = T(t < 0 ? r : t, "numLower", "bandPart")) : (C(t.dtype === "int32", ()=>"bandPart(): numLower's dtype must be an int32."), a = Ee(Cl(t, 0), r, br(t, r))), typeof e == "number" ? (C(e % 1 === 0, ()=>`bandPart(): numUpper must be an integer, got ${e}.`), C(e <= i, ()=>`bandPart(): numUpper (${e}) must not be greater than the number of columns (${i}).`), l = T(e < 0 ? i : e, "numUpper", "bandPart")) : (C(e.dtype === "int32", ()=>"bandPart(): numUpper's dtype must be an int32."), l = Ee(Cl(e, 0), i, br(e, i)));
    const c = W(di(0, r, 1, "int32"), [
        -1,
        1
    ]), u = di(0, i, 1, "int32"), d = it(c, u), h = ss(Tr(d, a), Bo(d, Yt(l))), p = be([
        r,
        i
    ], s.dtype);
    return W(Xn(Mo(W(s, [
        -1,
        r,
        i
    ])).map((f)=>Ee(h, f, p))), o);
}
const mR = /* @__PURE__ */ L({
    bandPart_: fR
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function gR(n) {
    let t;
    if (Array.isArray(n)) {
        t = !1, C(n != null && n.length > 0, ()=>"Gram-Schmidt process: input must not be null, undefined, or empty");
        const o = n[0].shape[0];
        for(let r = 1; r < n.length; ++r)C(n[r].shape[0] === o, ()=>`Gram-Schmidt: Non-unique lengths found in the input vectors: (${n[r].shape[0]} vs. ${o})`);
    } else t = !0, n = pn(n, n.shape[0], 0).map((o)=>ka(o, [
            0
        ]));
    C(n.length <= n[0].shape[0], ()=>`Gram-Schmidt: Number of vectors (${n.length}) exceeds number of dimensions (${n[0].shape[0]}).`);
    const e = [], s = n;
    for(let o = 0; o < n.length; ++o)e.push($.tidy(()=>{
        let r = s[o];
        if (o > 0) for(let i = 0; i < o; ++i){
            const a = G(at(G(e[i], r)), e[i]);
            r = it(r, a);
        }
        return ut(r, jc(r, "euclidean"));
    }));
    return t ? Xn(e, 0) : e;
}
const bR = /* @__PURE__ */ L({
    gramSchmidt_: gR
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function xR(n, t = !1) {
    if (C(n.rank >= 2, ()=>`qr() requires input tensor to have a rank >= 2, but got rank ${n.rank}`), n.rank === 2) return $m(n, t);
    {
        const e = n.shape.slice(0, n.shape.length - 2).reduce((l, c)=>l * c), s = Mo(W(n, [
            e,
            n.shape[n.shape.length - 2],
            n.shape[n.shape.length - 1]
        ]), 0), o = [], r = [];
        s.forEach((l)=>{
            const [c, u] = $m(l, t);
            o.push(c), r.push(u);
        });
        const i = W(Xn(o, 0), n.shape), a = W(Xn(r, 0), n.shape);
        return [
            i,
            a
        ];
    }
}
function $m(n, t = !1) {
    return $.tidy(()=>{
        C(n.shape.length === 2, ()=>`qr2d() requires a 2D Tensor, but got a ${n.shape.length}D Tensor.`);
        const e = n.shape[0], s = n.shape[1];
        let o = o0(e), r = yo(n);
        const i = il([
            [
                1
            ]
        ], [
            1,
            1
        ]);
        let a = yo(i);
        const l = e >= s ? s : e;
        for(let c = 0; c < l; ++c){
            const u = r, d = a, h = o;
            [a, r, o] = $.tidy(()=>{
                const p = Ft(r, [
                    c,
                    c
                ], [
                    e - c,
                    1
                ]), f = jc(p), m = Ft(r, [
                    c,
                    c
                ], [
                    1,
                    1
                ]), g = Ee(rn(m, 0), il([
                    [
                        -1
                    ]
                ]), il([
                    [
                        1
                    ]
                ])), b = it(m, G(g, f)), x = ut(p, b);
                x.shape[0] === 1 ? a = yo(i) : a = Ge([
                    i,
                    Ft(x, [
                        1,
                        0
                    ], [
                        x.shape[0] - 1,
                        x.shape[1]
                    ])
                ], 0);
                const w = Yt(ut(Gt(g, b), f)), y = Ft(r, [
                    c,
                    0
                ], [
                    e - c,
                    s
                ]), I = G(w, a), v = kt(a);
                if (c === 0) r = it(y, Gt(I, Gt(v, y)));
                else {
                    const N = it(y, Gt(I, Gt(v, y)));
                    r = Ge([
                        Ft(r, [
                            0,
                            0
                        ], [
                            c,
                            s
                        ]),
                        N
                    ], 0);
                }
                const k = kt(I), S = Ft(o, [
                    0,
                    c
                ], [
                    e,
                    o.shape[1] - c
                ]);
                if (c === 0) o = it(S, Gt(Gt(S, a), k));
                else {
                    const N = it(S, Gt(Gt(S, a), k));
                    o = Ge([
                        Ft(o, [
                            0,
                            0
                        ], [
                            e,
                            c
                        ]),
                        N
                    ], 1);
                }
                return [
                    a,
                    r,
                    o
                ];
            }), xt([
                u,
                d,
                h
            ]);
        }
        return !t && e > s && (o = Ft(o, [
            0,
            0
        ], [
            e,
            s
        ]), r = Ft(r, [
            0,
            0
        ], [
            s,
            s
        ])), [
            o,
            r
        ];
    });
}
const yR = /* @__PURE__ */ L({
    qr_: xR
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var Ke;
(function(n) {
    n[n.NONE = 0] = "NONE", n[n.MEAN = 1] = "MEAN", n[n.SUM = 2] = "SUM", n[n.SUM_BY_NONZERO_WEIGHTS = 3] = "SUM_BY_NONZERO_WEIGHTS";
})(Ke || (Ke = {}));
function wR(n, t, e = Ke.SUM_BY_NONZERO_WEIGHTS) {
    const s = T(n, "losses", "computeWeightedLoss");
    let o = null;
    t != null && (o = T(t, "weights", "computeWeightedLoss"));
    const r = o == null ? s : G(s, o);
    if (e === Ke.NONE) return r;
    if (e === Ke.SUM) return at(r);
    if (e === Ke.MEAN) {
        if (o == null) return oe(r);
        {
            const i = s.size / o.size, a = ut(at(r), at(o));
            return i > 1 ? ut(a, gt(i)) : a;
        }
    }
    if (e === Ke.SUM_BY_NONZERO_WEIGHTS) {
        if (o == null) return ut(at(r), gt(s.size));
        {
            const i = G(o, ks(s.shape)), a = tt(at(ui(i, gt(0))), "float32");
            return ut(at(r), a);
        }
    }
    throw Error(`Unknown reduction: ${e}`);
}
const Ns = /* @__PURE__ */ L({
    computeWeightedLoss_: wR
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function IR(n, t, e, s = Ke.SUM_BY_NONZERO_WEIGHTS) {
    const o = T(n, "labels", "absoluteDifference"), r = T(t, "predictions", "absoluteDifference");
    let i = null;
    e != null && (i = T(e, "weights", "absoluteDifference")), Pe(o.shape, r.shape, "Error in absoluteDifference: ");
    const a = me(it(o, r));
    return Ns(a, i, s);
}
const CR = /* @__PURE__ */ L({
    absoluteDifference_: IR
});
function vR(n, t, e, s, o = Ke.SUM_BY_NONZERO_WEIGHTS) {
    const r = T(n, "labels", "cosineDistance"), i = T(t, "predictions", "cosineDistance");
    let a = null;
    s != null && (a = T(s, "weights", "cosineDistance")), Pe(r.shape, i.shape, "Error in cosineDistance: ");
    const l = gt(1), c = it(l, at(G(r, i), e, !0));
    return Ns(c, a, o);
}
const SR = /* @__PURE__ */ L({
    cosineDistance_: vR
});
function kR(n, t, e, s = Ke.SUM_BY_NONZERO_WEIGHTS) {
    let o = T(n, "labels", "hingeLoss");
    const r = T(t, "predictions", "hingeLoss");
    let i = null;
    e != null && (i = T(e, "weights", "hingeLoss")), Pe(o.shape, r.shape, "Error in hingeLoss: ");
    const a = gt(1);
    o = it(G(gt(2), o), a);
    const l = Ts(it(a, G(o, r)));
    return Ns(l, i, s);
}
const TR = /* @__PURE__ */ L({
    hingeLoss_: kR
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function NR(n, t, e, s = 1, o = Ke.SUM_BY_NONZERO_WEIGHTS) {
    const r = T(n, "labels", "huberLoss"), i = T(t, "predictions", "huberLoss");
    let a = null;
    e != null && (a = T(e, "weights", "huberLoss")), Pe(r.shape, i.shape, "Error in huberLoss: ");
    const l = gt(s), c = me(it(i, r)), u = br(c, l), d = it(c, u), h = U(G(gt(0.5), Kt(u)), G(l, d));
    return Ns(h, a, o);
}
const RR = /* @__PURE__ */ L({
    huberLoss_: NR
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $R(n, t, e, s = 1e-7, o = Ke.SUM_BY_NONZERO_WEIGHTS) {
    const r = T(n, "labels", "logLoss"), i = T(t, "predictions", "logLoss");
    let a = null;
    e != null && (a = T(e, "weights", "logLoss")), Pe(r.shape, i.shape, "Error in logLoss: ");
    const l = gt(1), c = gt(s), u = Yt(G(r, Nn(U(i, c)))), d = G(it(l, r), Nn(U(it(l, i), c))), h = it(u, d);
    return Ns(h, a, o);
}
const GR = /* @__PURE__ */ L({
    logLoss_: $R
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ER(n, t, e, s = Ke.SUM_BY_NONZERO_WEIGHTS) {
    const o = T(n, "labels", "meanSquaredError"), r = T(t, "predictions", "meanSquaredError");
    let i = null;
    e != null && (i = T(e, "weights", "meanSquaredError")), Pe(o.shape, r.shape, "Error in meanSquaredError: ");
    const a = x0(o, r);
    return Ns(a, i, s);
}
const LR = /* @__PURE__ */ L({
    meanSquaredError_: ER
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function MR(n, t) {
    const e = T(n, "labels", "sigmoidCrossEntropyWithLogits"), s = T(t, "logits", "sigmoidCrossEntropyWithLogits");
    Pe(e.shape, s.shape, "Error in sigmoidCrossEntropyWithLogits: ");
    const o = Ts(s), r = G(s, e), i = hp(mn(Yt(me(s))));
    return U(it(o, r), i);
}
function WR(n, t, e, s = 0, o = Ke.SUM_BY_NONZERO_WEIGHTS) {
    let r = T(n, "multiClassLabels", "sigmoidCrossEntropy");
    const i = T(t, "logits", "sigmoidCrossEntropy");
    let a = null;
    if (e != null && (a = T(e, "weights", "sigmoidCrossEntropy")), Pe(r.shape, i.shape, "Error in sigmoidCrossEntropy: "), s > 0) {
        const c = gt(s), u = gt(1), d = gt(0.5);
        r = U(G(r, it(u, c)), G(d, c));
    }
    const l = MR(r, i);
    return Ns(l, a, o);
}
const DR = /* @__PURE__ */ L({
    sigmoidCrossEntropy_: WR
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function FR(n, t, e = -1) {
    if (e === -1 && (e = t.rank - 1), e !== t.rank - 1) throw Error(`Softmax cross entropy along a non-last dimension is not yet supported. Labels / logits was rank ${t.rank} and dim was ${e}`);
    return Eo((o, r, i)=>{
        const l = pp(r, [
            e
        ], !0), c = it(tt(r, "float32"), l);
        i([
            o,
            c
        ]);
        const u = Yt(G(c, o));
        return {
            value: at(u, [
                e
            ]),
            gradFunc: (p, f)=>{
                const [m, g] = f, b = re(p.shape, [
                    e
                ]);
                return [
                    G(W(p, b), it(tt(m, "float32"), mn(g))),
                    G(W(p, b), it(mn(g), tt(m, "float32")))
                ];
            }
        };
    })(n, t);
}
function VR(n, t, e, s = 0, o = Ke.SUM_BY_NONZERO_WEIGHTS) {
    let r = T(n, "onehotLabels", "softmaxCrossEntropy");
    const i = T(t, "logits", "softmaxCrossEntropy");
    let a = null;
    if (e != null && (a = T(e, "weights", "softmaxCrossEntropy")), Pe(r.shape, i.shape, "Error in softmaxCrossEntropy: "), s > 0) {
        const c = gt(s), u = gt(1), d = gt(r.shape[1]);
        r = U(G(r, it(u, c)), ut(c, d));
    }
    const l = FR(r, i);
    return Ns(l, a, o);
}
const zR = /* @__PURE__ */ L({
    softmaxCrossEntropy_: VR
});
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function PR(n, t, e, s) {
    const o = T(n, "indices", "sparseFillEmptyRows", "int32"), r = T(t, "values", "sparseFillEmptyRows"), i = T(e, "denseShape", "sparseFillEmptyRows", "int32"), a = T(s, "defaultValue", "sparseFillEmptyRows", r.dtype);
    if (o.rank !== 2) throw new Error(`Indices should be Tensor2D but received shape
        ${o.shape}`);
    if (r.rank !== 1) throw new Error(`Values should be Tensor1D but received shape ${r.shape}`);
    if (i.rank !== 1) throw new Error(`Dense shape should be Tensor1D but received shape ${i.shape}`);
    if (a.rank !== 0) throw new Error(`Default value should be a scalar but received shape ${a.shape}`);
    const l = {
        indices: o,
        values: r,
        denseShape: i,
        defaultValue: a
    }, c = $.runKernel(Wh, l);
    return {
        outputIndices: c[0],
        outputValues: c[1],
        emptyRowIndicator: c[2],
        reverseIndexMap: c[3]
    };
}
const AR = /* @__PURE__ */ L({
    sparseFillEmptyRows_: PR
});
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function OR(n, t, e) {
    const s = T(n, "inputIndices", "sparseReshape", "int32"), o = T(t, "inputShape", "sparseReshape", "int32"), r = T(e, "newShape", "sparseReshape", "int32");
    if (s.rank !== 2) throw new Error(`Input indices should be Tensor2D but received shape
        ${s.shape}`);
    if (o.rank !== 1) throw new Error(`Input shape should be Tensor1D but received shape ${o.shape}`);
    if (r.rank !== 1) throw new Error(`New shape should be Tensor1D but received shape ${r.shape}`);
    const i = {
        inputIndices: s,
        inputShape: o,
        newShape: r
    }, a = $.runKernel(Dh, i);
    return {
        outputIndices: a[0],
        outputShape: a[1]
    };
}
const XR = /* @__PURE__ */ L({
    sparseReshape_: OR
});
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function KR(n, t, e) {
    const s = T(n, "data", "sparseSegmentMean"), o = T(t, "indices", "sparseSegmentMean", "int32"), r = T(e, "segmentIds", "sparseSegmentMean", "int32");
    if (s.rank < 1) throw new Error("Data should be at least 1 dimensional but received scalar");
    if (o.rank !== 1) throw new Error(`Indices should be Tensor1D but received shape
          ${o.shape}`);
    if (r.rank !== 1) throw new Error(`Segment ids should be Tensor1D but received shape
          ${r.shape}`);
    const i = {
        data: s,
        indices: o,
        segmentIds: r
    };
    return $.runKernel(Fh, i);
}
const ZR = /* @__PURE__ */ L({
    sparseSegmentMean_: KR
});
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function BR(n, t, e) {
    const s = T(n, "data", "sparseSegmentSum"), o = T(t, "indices", "sparseSegmentSum", "int32"), r = T(e, "segmentIds", "sparseSegmentSum", "int32");
    if (s.rank < 1) throw new Error("Data should be at least 1 dimensional but received scalar");
    if (o.rank !== 1) throw new Error(`Indices should be Tensor1D but received shape
         ${o.shape}`);
    if (r.rank !== 1) throw new Error(`Segment ids should be Tensor1D but received shape
         ${r.shape}`);
    const i = {
        data: s,
        indices: o,
        segmentIds: r
    };
    return $.runKernel(Vh, i);
}
const HR = /* @__PURE__ */ L({
    sparseSegmentSum_: BR
});
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function _R(n, t, e, s, o, r, i, a) {
    const l = T(n, "data", "stringNGrams", "string");
    if (l.dtype !== "string") throw new Error("Data must be of datatype string");
    if (l.shape.length !== 1) throw new Error(`Data must be a vector, saw: ${l.shape}`);
    const c = T(t, "dataSplits", "stringNGrams");
    if (c.dtype !== "int32") throw new Error("Data splits must be of datatype int32");
    const u = {
        separator: e,
        nGramWidths: s,
        leftPad: o,
        rightPad: r,
        padWidth: i,
        preserveShortSequences: a
    }, d = {
        data: l,
        dataSplits: c
    }, h = $.runKernel(Ah, d, u);
    return {
        nGrams: h[0],
        nGramsSplits: h[1]
    };
}
const UR = /* @__PURE__ */ L({
    stringNGrams_: _R
});
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function YR(n, t, e = !0) {
    const s = T(n, "input", "stringSplit", "string"), o = T(t, "delimiter", "stringSplit", "string");
    if (s.rank !== 1) throw new Error(`Input should be Tensor1D but received shape ${s.shape}`);
    if (o.rank !== 0) throw new Error(`Delimiter should be a scalar but received shape ${o.shape}`);
    const r = {
        skipEmpty: e
    }, i = {
        input: s,
        delimiter: o
    }, a = $.runKernel(Oh, i, r);
    return {
        indices: a[0],
        values: a[1],
        shape: a[2]
    };
}
const QR = /* @__PURE__ */ L({
    stringSplit_: YR
});
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function JR(n, t) {
    const e = T(n, "input", "stringToHashBucketFast", "string"), s = {
        numBuckets: t
    };
    if (t <= 0) throw new Error("Number of buckets must be at least 1");
    const o = {
        input: e
    };
    return $.runKernel(Xh, o, s);
}
const jR = /* @__PURE__ */ L({
    stringToHashBucketFast_: JR
});
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function qR(n, t, e, s = !0) {
    const o = T(n, "input", "staticRegexReplace", "string"), r = {
        pattern: t,
        rewrite: e,
        replaceGlobal: s
    };
    return $.runKernel(Bc, {
        x: o
    }, r);
}
const t$ = /* @__PURE__ */ L({
    staticRegexReplace_: qR
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const NQ = {
    fft: Gp,
    ifft: kl,
    rfft: Ep,
    irfft: b0
}, RQ = {
    hammingWindow: RN,
    hannWindow: S0,
    frame: k0,
    stft: LN
}, fs = {
    flipLeftRight: FN,
    grayscaleToRGB: zN,
    resizeNearestNeighbor: N0,
    resizeBilinear: T0,
    rgbToGrayscale: AN,
    rotateWithOffset: XN,
    cropAndResize: WN,
    nonMaxSuppression: ZN,
    nonMaxSuppressionAsync: jN,
    nonMaxSuppressionWithScore: tR,
    nonMaxSuppressionWithScoreAsync: nR,
    nonMaxSuppressionPadded: oR,
    nonMaxSuppressionPaddedAsync: iR,
    threshold: dR,
    transform: pR
}, e$ = {
    bandPart: mR,
    gramSchmidt: bR,
    qr: yR
}, $Q = {
    absoluteDifference: CR,
    computeWeightedLoss: Ns,
    cosineDistance: SR,
    hingeLoss: TR,
    huberLoss: RR,
    logLoss: GR,
    meanSquaredError: LR,
    sigmoidCrossEntropy: DR,
    softmaxCrossEntropy: zR
}, GQ = {
    sparseFillEmptyRows: AR,
    sparseReshape: XR,
    sparseSegmentMean: ZR,
    sparseSegmentSum: HR
}, EQ = {
    stringNGrams: UR,
    stringSplit: QR,
    stringToHashBucketFast: jR,
    staticRegexReplace: t$
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const n$ = /* @__PURE__ */ new Map(), Sd = /* @__PURE__ */ new Map();
class _o {
    /**
   * Return the class name for this class to use in serialization contexts.
   *
   * Generally speaking this will be the same thing that constructor.name
   * would have returned.  However, the class name needs to be robust
   * against minification for serialization/deserialization to work properly.
   *
   * There's also places such as initializers.VarianceScaling, where
   * implementation details between different languages led to different
   * class hierarchies and a non-leaf node is used for serialization purposes.
   */ getClassName() {
        return this.constructor.className;
    }
    /**
   * Creates an instance of T from a ConfigDict.
   *
   * This works for most descendants of serializable.  A few need to
   * provide special handling.
   * @param cls A Constructor for the class to instantiate.
   * @param config The Configuration for the object.
   */ /** @nocollapse */ static fromConfig(t, e) {
        return new t(e);
    }
}
class cn {
    constructor(){
        this.classNameMap = {};
    }
    /**
   * Returns the singleton instance of the map.
   */ static getMap() {
        return cn.instance == null && (cn.instance = new cn()), cn.instance;
    }
    /**
   * Registers the class as serializable.
   */ static register(t) {
        cn.getMap().classNameMap[t.className] = [
            t,
            t.fromConfig
        ];
    }
}
function _(n, t, e) {
    C(n.className != null, ()=>"Class being registered does not have the static className property defined."), C(typeof n.className == "string", ()=>"className is required to be a string, but got type " + typeof n.className), C(n.className.length > 0, ()=>"Class being registered has an empty-string as its className, which is disallowed."), typeof t > "u" && (t = "Custom"), typeof e > "u" && (e = n.className);
    const s = e, o = t + ">" + s;
    return cn.register(n), n$.set(o, n), Sd.set(n, o), n;
}
function s$(n) {
    return Sd.has(n) ? Sd.get(n) : n.className;
}
const LQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    Serializable: _o,
    SerializationMap: cn,
    getRegisteredName: s$,
    registerClass: _
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class eo extends _o {
    /**
   * Executes `f()` and minimizes the scalar output of `f()` by computing
   * gradients of y with respect to the list of trainable variables provided by
   * `varList`. If no list is provided, it defaults to all trainable variables.
   *
   * @param f The function to execute and whose output to minimize.
   * @param returnCost Whether to return the scalar cost value produced by
   * executing `f()`.
   * @param varList An optional list of variables to update. If specified, only
   * the trainable variables in varList will be updated by minimize. Defaults to
   * all trainable variables.
   *
   * @doc {heading: 'Training', subheading: 'Optimizers'}
   */ minimize(t, e = !1, s) {
        const { value: o, grads: r } = this.computeGradients(t, s);
        if (s != null) {
            const i = s.map((a)=>({
                    name: a.name,
                    tensor: r[a.name]
                }));
            this.applyGradients(i);
        } else this.applyGradients(r);
        return xt(r), e ? o : (o.dispose(), null);
    }
    /**
   * The number of iterations that this optimizer instance has been invoked for.
   */ get iterations() {
        return this.iterations_ == null && (this.iterations_ = 0), this.iterations_;
    }
    incrementIterations() {
        this.iterations_ = this.iterations + 1;
    }
    /**
   * Executes f() and computes the gradient of the scalar output of f() with
   * respect to the list of trainable variables provided by `varList`. If no
   * list is provided, it defaults to all trainable variables.
   *
   * @param f The function to execute and whose output to use for computing
   * gradients with respect to variables.
   * @param varList An optional list of variables to compute gradients with
   * respect to. If specified, only the trainable variables in varList will have
   * gradients computed with respect to. Defaults to all trainable variables.
   *
   * @doc {heading: 'Training', subheading: 'Optimizers'}
   */ computeGradients(t, e) {
        return kk(t, e);
    }
    /**
   * Dispose the variables (if any) owned by this optimizer instance.
   */ dispose() {
        this.iterations_ != null && xt(this.iterations_);
    }
    async saveIterations() {
        return this.iterations_ == null && (this.iterations_ = 0), {
            name: "iter",
            // TODO(cais): Use 'int64' type when available.
            tensor: gt(this.iterations_, "int32")
        };
    }
    async getWeights() {
        throw new Error("getWeights() is not implemented for this optimizer yet.");
    }
    async setWeights(t) {
        throw new Error(`setWeights() is not implemented for this optimizer class ${this.getClassName()}`);
    }
    /**
   * Extract the first element of the weight values and set it
   * as the iterations counter variable of this instance of optimizer.
   *
   * @param weightValues
   * @returns Weight values with the first element consumed and excluded.
   */ async extractIterations(t) {
        return this.iterations_ = (await t[0].tensor.data())[0], t.slice(1);
    }
}
Object.defineProperty(eo, Symbol.hasInstance, {
    value: (n)=>n.minimize != null && n.computeGradients != null && n.applyGradients != null
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class R0 extends eo {
    /** @nocollapse */ static get className() {
        return "Adadelta";
    }
    constructor(t, e, s = null){
        super(), this.learningRate = t, this.rho = e, this.epsilon = s, this.accumulatedGrads = [], this.accumulatedUpdates = [], s == null && (this.epsilon = $.backend.epsilon());
    }
    applyGradients(t) {
        (Array.isArray(t) ? t.map((s)=>s.name) : Object.keys(t)).forEach((s, o)=>{
            const r = $.registeredVariables[s], i = !1;
            this.accumulatedGrads[o] == null && (this.accumulatedGrads[o] = {
                originalName: `${s}/accum_grad`,
                variable: D(()=>Tt(r).variable(i))
            }), this.accumulatedUpdates[o] == null && (this.accumulatedUpdates[o] = {
                originalName: `${s}/accum_var`,
                variable: D(()=>Tt(r).variable(i))
            });
            const a = Array.isArray(t) ? t[o].tensor : t[s];
            if (a == null) return;
            const l = this.accumulatedGrads[o].variable, c = this.accumulatedUpdates[o].variable;
            D(()=>{
                const u = U(G(l, this.rho), G(Kt(a), 1 - this.rho)), d = G(ut(Ve(U(c, this.epsilon)), Ve(U(l, this.epsilon))), a), h = U(G(c, this.rho), G(Kt(d), 1 - this.rho));
                l.assign(u), c.assign(h);
                const p = U(G(d, -this.learningRate), r);
                r.assign(p);
            });
        }), this.incrementIterations();
    }
    dispose() {
        this.accumulatedUpdates != null && (xt(this.accumulatedGrads.map((t)=>t.variable)), xt(this.accumulatedUpdates.map((t)=>t.variable)));
    }
    async getWeights() {
        const t = [
            ...this.accumulatedGrads,
            ...this.accumulatedUpdates
        ];
        return [
            await this.saveIterations()
        ].concat(t.map((e)=>({
                name: e.originalName,
                tensor: e.variable
            })));
    }
    async setWeights(t) {
        t = await this.extractIterations(t);
        const e = t.length / 2, s = !1;
        this.accumulatedGrads = t.slice(0, e).map((o)=>({
                originalName: o.name,
                variable: o.tensor.variable(s)
            })), this.accumulatedUpdates = t.slice(e, e * 2).map((o)=>({
                originalName: o.name,
                variable: o.tensor.variable(s)
            }));
    }
    getConfig() {
        return {
            learningRate: this.learningRate,
            rho: this.rho,
            epsilon: this.epsilon
        };
    }
    /** @nocollapse */ static fromConfig(t, e) {
        return new t(e.learningRate, e.rho, e.epsilon);
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $0 extends eo {
    /** @nocollapse */ static get className() {
        return "Adagrad";
    }
    constructor(t, e = 0.1){
        super(), this.learningRate = t, this.initialAccumulatorValue = e, this.accumulatedGrads = [];
    }
    applyGradients(t) {
        (Array.isArray(t) ? t.map((s)=>s.name) : Object.keys(t)).forEach((s, o)=>{
            const r = $.registeredVariables[s];
            this.accumulatedGrads[o] == null && (this.accumulatedGrads[o] = {
                originalName: `${s}/accumulator`,
                variable: D(()=>Ca(r.shape, this.initialAccumulatorValue).variable(!1))
            });
            const i = Array.isArray(t) ? t[o].tensor : t[s];
            if (i == null) return;
            const a = this.accumulatedGrads[o].variable;
            D(()=>{
                const l = U(a, Kt(i));
                a.assign(l);
                const c = U(G(ut(i, Ve(U(l, $.backend.epsilon()))), -this.learningRate), r);
                r.assign(c);
            });
        }), this.incrementIterations();
    }
    dispose() {
        this.accumulatedGrads != null && xt(this.accumulatedGrads.map((t)=>t.variable));
    }
    async getWeights() {
        return [
            await this.saveIterations()
        ].concat(this.accumulatedGrads.map((t)=>({
                name: t.originalName,
                tensor: t.variable
            })));
    }
    async setWeights(t) {
        t = await this.extractIterations(t);
        const e = !1;
        this.accumulatedGrads = t.map((s)=>({
                originalName: s.name,
                variable: s.tensor.variable(e)
            }));
    }
    getConfig() {
        return {
            learningRate: this.learningRate,
            initialAccumulatorValue: this.initialAccumulatorValue
        };
    }
    /** @nocollapse */ static fromConfig(t, e) {
        return new t(e.learningRate, e.initialAccumulatorValue);
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class G0 extends eo {
    /** @nocollapse */ static get className() {
        return "Adam";
    }
    constructor(t, e, s, o = null){
        super(), this.learningRate = t, this.beta1 = e, this.beta2 = s, this.epsilon = o, this.accumulatedFirstMoment = [], this.accumulatedSecondMoment = [], D(()=>{
            this.accBeta1 = gt(e).variable(), this.accBeta2 = gt(s).variable();
        }), o == null && (this.epsilon = $.backend.epsilon());
    }
    applyGradients(t) {
        const e = Array.isArray(t) ? t.map((s)=>s.name) : Object.keys(t);
        D(()=>{
            const s = it(1, this.accBeta1), o = it(1, this.accBeta2);
            e.forEach((r, i)=>{
                const a = $.registeredVariables[r], l = !1;
                this.accumulatedFirstMoment[i] == null && (this.accumulatedFirstMoment[i] = {
                    originalName: `${r}/m`,
                    variable: D(()=>Tt(a).variable(l))
                }), this.accumulatedSecondMoment[i] == null && (this.accumulatedSecondMoment[i] = {
                    originalName: `${r}/v`,
                    variable: D(()=>Tt(a).variable(l))
                });
                const c = Array.isArray(t) ? t[i].tensor : t[r];
                if (c == null) return;
                const u = this.accumulatedFirstMoment[i].variable, d = this.accumulatedSecondMoment[i].variable, h = U(G(u, this.beta1), G(c, 1 - this.beta1)), p = U(G(d, this.beta2), G(Kt(c), 1 - this.beta2)), f = ut(h, s), m = ut(p, o);
                u.assign(h), d.assign(p);
                const g = U(G(ut(f, U(Ve(m), this.epsilon)), -this.learningRate), a);
                a.assign(g);
            }), this.accBeta1.assign(G(this.accBeta1, this.beta1)), this.accBeta2.assign(G(this.accBeta2, this.beta2));
        }), this.incrementIterations();
    }
    dispose() {
        this.accBeta1.dispose(), this.accBeta2.dispose(), this.accumulatedFirstMoment != null && xt(this.accumulatedFirstMoment.map((t)=>t.variable)), this.accumulatedSecondMoment != null && xt(this.accumulatedSecondMoment.map((t)=>t.variable));
    }
    async getWeights() {
        const t = [
            ...this.accumulatedFirstMoment,
            ...this.accumulatedSecondMoment
        ];
        return [
            await this.saveIterations()
        ].concat(t.map((e)=>({
                name: e.originalName,
                tensor: e.variable
            })));
    }
    async setWeights(t) {
        t = await this.extractIterations(t), D(()=>{
            this.accBeta1.assign(gr(this.beta1, this.iterations_ + 1)), this.accBeta2.assign(gr(this.beta2, this.iterations_ + 1));
        });
        const e = t.length / 2, s = !1;
        this.accumulatedFirstMoment = t.slice(0, e).map((o)=>({
                originalName: o.name,
                variable: o.tensor.variable(s)
            })), this.accumulatedSecondMoment = t.slice(e, e * 2).map((o)=>({
                originalName: o.name,
                variable: o.tensor.variable(s)
            }));
    }
    getConfig() {
        return {
            learningRate: this.learningRate,
            beta1: this.beta1,
            beta2: this.beta2,
            epsilon: this.epsilon
        };
    }
    /** @nocollapse */ static fromConfig(t, e) {
        return new t(e.learningRate, e.beta1, e.beta2, e.epsilon);
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class E0 extends eo {
    /** @nocollapse */ static get className() {
        return "Adamax";
    }
    constructor(t, e, s, o = null, r = 0){
        super(), this.learningRate = t, this.beta1 = e, this.beta2 = s, this.epsilon = o, this.decay = r, this.accumulatedFirstMoment = [], this.accumulatedWeightedInfNorm = [], D(()=>{
            this.iteration = gt(0).variable(), this.accBeta1 = gt(e).variable();
        }), o == null && (this.epsilon = $.backend.epsilon());
    }
    applyGradients(t) {
        const e = Array.isArray(t) ? t.map((s)=>s.name) : Object.keys(t);
        D(()=>{
            const s = it(1, this.accBeta1), o = ut(-this.learningRate, U(G(this.iteration, this.decay), 1));
            e.forEach((r, i)=>{
                const a = $.registeredVariables[r], l = !1;
                this.accumulatedFirstMoment[i] == null && (this.accumulatedFirstMoment[i] = {
                    originalName: `${r}/m`,
                    variable: Tt(a).variable(l)
                }), this.accumulatedWeightedInfNorm[i] == null && (this.accumulatedWeightedInfNorm[i] = {
                    originalName: `${r}/v`,
                    variable: Tt(a).variable(l)
                });
                const c = Array.isArray(t) ? t[i].tensor : t[r];
                if (c == null) return;
                const u = this.accumulatedFirstMoment[i].variable, d = this.accumulatedWeightedInfNorm[i].variable, h = U(G(u, this.beta1), G(c, 1 - this.beta1)), p = G(d, this.beta2), f = me(c), m = qs(p, f);
                u.assign(h), d.assign(m);
                const g = U(G(ut(o, s), ut(h, U(m, this.epsilon))), a);
                a.assign(g);
            }), this.iteration.assign(U(this.iteration, 1)), this.accBeta1.assign(G(this.accBeta1, this.beta1));
        }), this.incrementIterations();
    }
    dispose() {
        this.accBeta1.dispose(), this.iteration.dispose(), this.accumulatedFirstMoment != null && xt(this.accumulatedFirstMoment.map((t)=>t.variable)), this.accumulatedWeightedInfNorm != null && xt(this.accumulatedWeightedInfNorm.map((t)=>t.variable));
    }
    async getWeights() {
        throw new Error("getWeights() is not implemented for Adamax yet.");
    }
    async setWeights(t) {
        throw new Error("setWeights() is not implemented for Adamax yet.");
    }
    getConfig() {
        return {
            learningRate: this.learningRate,
            beta1: this.beta1,
            beta2: this.beta2,
            epsilon: this.epsilon,
            decay: this.decay
        };
    }
    /** @nocollapse */ static fromConfig(t, e) {
        return new t(e.learningRate, e.beta1, e.beta2, e.epsilon, e.decay);
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class Xp extends eo {
    /** @nocollapse */ static get className() {
        return "SGD";
    }
    constructor(t){
        super(), this.learningRate = t, this.setLearningRate(t);
    }
    applyGradients(t) {
        (Array.isArray(t) ? t.map((s)=>s.name) : Object.keys(t)).forEach((s, o)=>{
            const r = Array.isArray(t) ? t[o].tensor : t[s];
            if (r == null) return;
            const i = $.registeredVariables[s];
            D(()=>{
                const a = U(G(this.c, r), i);
                i.assign(a);
            });
        }), this.incrementIterations();
    }
    /**
   * Sets the learning rate of the optimizer.
   */ setLearningRate(t) {
        this.learningRate = t, this.c != null && this.c.dispose(), this.c = hn(gt(-t));
    }
    dispose() {
        this.c.dispose();
    }
    async getWeights() {
        return [
            await this.saveIterations()
        ];
    }
    async setWeights(t) {
        if (t = await this.extractIterations(t), t.length !== 0) throw new Error("SGD optimizer does not have settable weights.");
    }
    getConfig() {
        return {
            learningRate: this.learningRate
        };
    }
    /** @nocollapse */ static fromConfig(t, e) {
        return new t(e.learningRate);
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class L0 extends Xp {
    /** @nocollapse */ // Name matters for Python compatibility.
    static get className() {
        return "Momentum";
    }
    constructor(t, e, s = !1){
        super(t), this.learningRate = t, this.momentum = e, this.useNesterov = s, this.accumulations = [], this.m = gt(this.momentum);
    }
    applyGradients(t) {
        (Array.isArray(t) ? t.map((s)=>s.name) : Object.keys(t)).forEach((s, o)=>{
            const r = $.registeredVariables[s];
            this.accumulations[o] == null && (this.accumulations[o] = {
                originalName: `${s}/momentum`,
                variable: D(()=>Tt(r).variable(!1))
            });
            const i = this.accumulations[o].variable, a = Array.isArray(t) ? t[o].tensor : t[s];
            a != null && D(()=>{
                let l;
                const c = U(G(this.m, i), a);
                this.useNesterov ? l = U(G(this.c, U(a, G(c, this.m))), r) : l = U(G(this.c, c), r), i.assign(c), r.assign(l);
            });
        }), this.incrementIterations();
    }
    dispose() {
        this.m.dispose(), this.accumulations != null && xt(this.accumulations.map((t)=>t.variable));
    }
    /**
   * Sets the momentum of the optimizer.
   *
   * @param momentum
   */ setMomentum(t) {
        this.momentum = t;
    }
    async getWeights() {
        return [
            await this.saveIterations()
        ].concat(this.accumulations.map((t)=>({
                name: t.originalName,
                tensor: t.variable
            })));
    }
    async setWeights(t) {
        t = await this.extractIterations(t);
        const e = !1;
        this.accumulations = t.map((s)=>({
                originalName: s.name,
                variable: s.tensor.variable(e)
            }));
    }
    getConfig() {
        return {
            learningRate: this.learningRate,
            momentum: this.momentum,
            useNesterov: this.useNesterov
        };
    }
    /** @nocollapse */ static fromConfig(t, e) {
        return new t(e.learningRate, e.momentum, e.useNesterov);
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class M0 extends eo {
    /** @nocollapse */ static get className() {
        return "RMSProp";
    }
    constructor(t, e = 0.9, s = 0, o = null, r = !1){
        if (super(), this.learningRate = t, this.decay = e, this.momentum = s, this.epsilon = o, this.accumulatedMeanSquares = [], this.accumulatedMoments = [], this.accumulatedMeanGrads = [], this.centered = r, o == null && (this.epsilon = $.backend.epsilon()), t == null) throw new Error("learningRate for RMSPropOptimizer must be defined.");
    }
    applyGradients(t) {
        (Array.isArray(t) ? t.map((s)=>s.name) : Object.keys(t)).forEach((s, o)=>{
            const r = $.registeredVariables[s], i = !1;
            this.accumulatedMeanSquares[o] == null && (this.accumulatedMeanSquares[o] = {
                originalName: `${s}/rms`,
                variable: D(()=>Tt(r).variable(i))
            }), this.accumulatedMoments[o] == null && (this.accumulatedMoments[o] = {
                originalName: `${s}/momentum`,
                variable: D(()=>Tt(r).variable(i))
            }), this.accumulatedMeanGrads[o] == null && this.centered && (this.accumulatedMeanGrads[o] = {
                originalName: `${s}/mg`,
                variable: D(()=>Tt(r).variable(i))
            });
            const a = Array.isArray(t) ? t[o].tensor : t[s];
            if (a == null) return;
            const l = this.accumulatedMeanSquares[o].variable, c = this.accumulatedMoments[o].variable;
            D(()=>{
                const u = U(G(l, this.decay), G(Kt(a), 1 - this.decay));
                if (this.centered) {
                    const d = this.accumulatedMeanGrads[o].variable, h = U(G(d, this.decay), G(a, 1 - this.decay)), p = ut(G(a, this.learningRate), Ve(it(u, U(Kt(h), this.epsilon)))), f = U(G(c, this.momentum), p);
                    l.assign(u), d.assign(h), c.assign(f);
                    const m = it(r, f);
                    r.assign(m);
                } else {
                    const d = U(G(l, this.decay), G(Kt(a), 1 - this.decay)), h = U(G(c, this.momentum), ut(G(a, this.learningRate), Ve(U(d, this.epsilon))));
                    l.assign(d), c.assign(h);
                    const p = it(r, h);
                    r.assign(p);
                }
            });
        }), this.incrementIterations();
    }
    dispose() {
        this.accumulatedMeanSquares != null && xt(this.accumulatedMeanSquares.map((t)=>t.variable)), this.accumulatedMeanGrads != null && this.centered && xt(this.accumulatedMeanGrads.map((t)=>t.variable)), this.accumulatedMoments != null && xt(this.accumulatedMoments.map((t)=>t.variable));
    }
    async getWeights() {
        const t = [
            ...this.accumulatedMeanSquares,
            ...this.accumulatedMoments
        ];
        return this.centered && t.push(...this.accumulatedMeanGrads), [
            await this.saveIterations()
        ].concat(t.map((e)=>({
                name: e.originalName,
                tensor: e.variable
            })));
    }
    async setWeights(t) {
        t = await this.extractIterations(t);
        const e = this.centered ? t.length / 3 : t.length / 2, s = !1;
        this.accumulatedMeanSquares = t.slice(0, e).map((o)=>({
                originalName: o.name,
                variable: o.tensor.variable(s)
            })), this.accumulatedMoments = t.slice(e, e * 2).map((o)=>({
                originalName: o.name,
                variable: o.tensor.variable(s)
            })), this.centered && (this.accumulatedMeanGrads = t.slice(e * 2, e * 3).map((o)=>({
                originalName: o.name,
                variable: o.tensor.variable(s)
            })));
    }
    getConfig() {
        return {
            learningRate: this.learningRate,
            decay: this.decay,
            momentum: this.momentum,
            epsilon: this.epsilon,
            centered: this.centered
        };
    }
    /** @nocollapse */ static fromConfig(t, e) {
        return new t(e.learningRate, e.decay, e.momentum, e.epsilon, e.centered);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const o$ = [
    R0,
    $0,
    G0,
    E0,
    L0,
    M0,
    Xp
];
function r$() {
    for (const n of o$)_(n);
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Gm(n, t, e, s) {
    i(n), e = e ?? 0, s = s ?? 1, a(e, s);
    let o = 0;
    const r = (l)=>(l.then((c)=>{
            const u = e + ++o / n.length * (s - e);
            return t(u), c;
        }), l);
    function i(l) {
        C(l != null && Array.isArray(l) && l.length > 0, ()=>"promises must be a none empty array");
    }
    function a(l, c) {
        C(l >= 0 && l <= 1, ()=>`Progress fraction must be in range [0, 1], but got startFraction ${l}`), C(c >= 0 && c <= 1, ()=>`Progress fraction must be in range [0, 1], but got endFraction ${c}`), C(c >= l, ()=>`startFraction must be no more than endFraction, but got startFraction ${l} and endFraction ${c}`);
    }
    return Promise.all(n.map(r));
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ async function W0(n, t) {
    t == null && (t = {});
    const e = t.fetchFunc == null ? F().platform.fetch : t.fetchFunc, s = n.map((d)=>e(d, t.requestInit, {
            isBinary: !0
        })), a = (t.onProgress == null ? await Promise.all(s) : await Gm(s, t.onProgress, 0, 0.5)).map((d)=>d.arrayBuffer());
    return t.onProgress == null ? await Promise.all(a) : await Gm(a, t.onProgress, 0.5, 1);
}
function i$(n, t) {
    var e;
    const s = t.fetchFunc == null ? F().platform.fetch : t.fetchFunc;
    let o = 0, r;
    return (e = t.onProgress) === null || e === void 0 || e.call(t, 0), new ReadableStream({
        pull: async (i)=>{
            for(var a; o < n.length;){
                r || (r = (await s(n[o], t.requestInit, {
                    isBinary: !0
                })).body.getReader());
                const { done: l, value: c } = await r.read();
                if (l) {
                    o++, r = void 0, (a = t.onProgress) === null || a === void 0 || a.call(t, o / n.length);
                    continue;
                }
                i.enqueue(c);
                return;
            }
            i.close();
        }
    });
}
async function a$(n, t = "", e, s) {
    return l$((i)=>W0(i, {
            requestInit: s
        }))(n, t, e);
}
function l$(n) {
    return async (t, e = "", s)=>{
        const o = t.map(()=>!1), r = {}, i = s != null ? s.map(()=>!1) : [], a = [];
        if (t.forEach((p, f)=>{
            let m = 0;
            p.weights.forEach((g)=>{
                const b = "quantization" in g ? g.quantization.dtype : g.dtype, x = So[b] * X(g.shape), w = ()=>{
                    o[f] = !0, r[f] == null && (r[f] = []), r[f].push({
                        manifestEntry: g,
                        groupOffset: m,
                        sizeBytes: x
                    });
                };
                s != null ? s.forEach((y, I)=>{
                    y === g.name && (w(), i[I] = !0);
                }) : w(), a.push(g.name), m += x;
            });
        }), !i.every((p)=>p)) {
            const p = s.filter((f, m)=>!i[m]);
            throw new Error(`Could not find weights in manifest with names: ${p.join(", ")}. 
Manifest JSON has weights with names: ${a.join(", ")}.`);
        }
        const l = o.reduce((p, f, m)=>(f && p.push(m), p), []), c = [];
        l.forEach((p)=>{
            t[p].paths.forEach((f)=>{
                const m = e + (e.endsWith("/") ? "" : "/") + f;
                c.push(m);
            });
        });
        const u = await n(c), d = {};
        let h = 0;
        return l.forEach((p)=>{
            const f = t[p].paths.length, m = new Cs(u.slice(h, h + f));
            r[p].forEach((b)=>{
                const x = m.slice(b.groupOffset, b.groupOffset + b.sizeBytes), w = Ab(x, [
                    b.manifestEntry
                ]);
                for(const y in w)d[y] = w[y];
            }), h += f;
        }), d;
    };
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const c$ = "application/octet-stream", u$ = "application/json";
class Kp {
    constructor(t, e){
        if (this.DEFAULT_METHOD = "POST", e == null && (e = {}), this.weightPathPrefix = e.weightPathPrefix, this.weightUrlConverter = e.weightUrlConverter, e.fetchFunc != null ? (C(typeof e.fetchFunc == "function", ()=>"Must pass a function that matches the signature of `fetch` (see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API)"), this.fetch = e.fetchFunc) : this.fetch = F().platform.fetch, C(t != null && t.length > 0, ()=>"URL path for http must not be null, undefined or empty."), Array.isArray(t) && C(t.length === 2, ()=>`URL paths for http must have a length of 2, (actual length is ${t.length}).`), this.path = t, e.requestInit != null && e.requestInit.body != null) throw new Error("requestInit is expected to have no pre-existing body, but has one.");
        this.requestInit = e.requestInit || {}, this.loadOptions = e;
    }
    async save(t) {
        if (t.modelTopology instanceof ArrayBuffer) throw new Error("BrowserHTTPRequest.save() does not support saving model topology in binary formats yet.");
        const e = Object.assign({
            method: this.DEFAULT_METHOD
        }, this.requestInit);
        e.body = new FormData();
        const s = [
            {
                paths: [
                    "./model.weights.bin"
                ],
                weights: t.weightSpecs
            }
        ], o = V2(t, s);
        if (e.body.append("model.json", new Blob([
            JSON.stringify(o)
        ], {
            type: u$
        }), "model.json"), t.weightData != null) {
            const i = Cs.join(t.weightData);
            e.body.append("model.weights.bin", new Blob([
                i
            ], {
                type: c$
            }), "model.weights.bin");
        }
        const r = await this.fetch(this.path, e);
        if (r.ok) return {
            modelArtifactsInfo: tp(t),
            responses: [
                r
            ]
        };
        throw new Error(`BrowserHTTPRequest.save() failed due to HTTP response status ${r.status}.`);
    }
    async loadModelJSON() {
        const t = await this.fetch(this.path, this.requestInit);
        if (!t.ok) throw new Error(`Request to ${this.path} failed with status code ${t.status}. Please verify this URL points to the model JSON of the model to load.`);
        let e;
        try {
            e = await t.json();
        } catch  {
            let i = `Failed to parse model JSON of response from ${this.path}.`;
            throw this.path.endsWith(".pb") ? i += " Your path contains a .pb file extension. Support for .pb models have been removed in TensorFlow.js 1.0 in favor of .json models. You can re-convert your Python TensorFlow model using the TensorFlow.js 1.0 conversion scripts or you can convert your.pb models with the 'pb2json'NPM script in the tensorflow/tfjs-converter repository." : i += " Please make sure the server is serving valid JSON for this request.", new Error(i);
        }
        const s = e.modelTopology, o = e.weightsManifest;
        if (s == null && o == null) throw new Error(`The JSON from HTTP path ${this.path} contains neither model topology or manifest for weights.`);
        return e;
    }
    /**
   * Load model artifacts via HTTP request(s).
   *
   * See the documentation to `tf.io.http` for details on the saved
   * artifacts.
   *
   * @returns The loaded model artifacts (if loading succeeds).
   */ async load() {
        if (this.loadOptions.streamWeights) return this.loadStream();
        const t = await this.loadModelJSON();
        return P2(t, (e)=>this.loadWeights(e));
    }
    async loadStream() {
        const t = await this.loadModelJSON(), e = await this.getWeightUrls(t.weightsManifest), s = km(t.weightsManifest), o = ()=>i$(e, this.loadOptions);
        return Object.assign(Object.assign({}, t), {
            weightSpecs: s,
            getWeightStream: o
        });
    }
    async getWeightUrls(t) {
        const e = Array.isArray(this.path) ? this.path[1] : this.path, [s, o] = d$(e), r = this.weightPathPrefix || s, i = [], a = [];
        for (const l of t)for (const c of l.paths)this.weightUrlConverter != null ? a.push(this.weightUrlConverter(c)) : i.push(r + c + o);
        return this.weightUrlConverter && i.push(...await Promise.all(a)), i;
    }
    async loadWeights(t) {
        const e = await this.getWeightUrls(t), s = km(t), o = await W0(e, this.loadOptions);
        return [
            s,
            o
        ];
    }
}
Kp.URL_SCHEME_REGEX = /^https?:\/\//;
function d$(n) {
    const t = n.lastIndexOf("/"), e = n.lastIndexOf("?"), s = n.substring(0, t), o = e > t ? n.substring(e) : "";
    return [
        s + "/",
        o
    ];
}
function Em(n) {
    return n.match(Kp.URL_SCHEME_REGEX) != null;
}
const D0 = (n, t)=>{
    if (typeof fetch > "u" && (t == null || t.fetchFunc == null)) return null;
    {
        let e = !0;
        if (Array.isArray(n) ? e = n.every((s)=>Em(s)) : e = Em(n), e) return F0(n, t);
    }
    return null;
};
ee.registerSaveRouter(D0);
ee.registerLoadRouter(D0);
function F0(n, t) {
    return new Kp(n, t);
}
function h$(n, t) {
    return F0(n, t);
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ let io, Lm = !1;
function V0(n, t = 3) {
    if (t > 4) throw new Error("Cannot construct Tensor with more than 4 channels from pixels.");
    if (n == null) throw new Error("pixels passed to tf.browser.fromPixels() can not be null");
    let e = !1, s = !1, o = !1, r = !1, i = !1, a = !1;
    if (n.data instanceof Uint8Array) e = !0;
    else if (typeof ImageData < "u" && n instanceof ImageData) s = !0;
    else if (typeof HTMLVideoElement < "u" && n instanceof HTMLVideoElement) o = !0;
    else if (typeof HTMLImageElement < "u" && n instanceof HTMLImageElement) r = !0;
    else if (n.getContext != null) i = !0;
    else if (typeof ImageBitmap < "u" && n instanceof ImageBitmap) a = !0;
    else throw new Error(`pixels passed to tf.browser.fromPixels() must be either an HTMLVideoElement, HTMLImageElement, HTMLCanvasElement, ImageData in browser, or OffscreenCanvas, ImageData in webworker or {data: Uint32Array, width: number, height: number}, but was ${n.constructor.name}`);
    if (bl(cd, $.backendName) != null) {
        const f = {
            pixels: n
        }, m = {
            numChannels: t
        };
        return $.runKernel(cd, f, m);
    }
    const [c, u] = o ? [
        n.videoWidth,
        n.videoHeight
    ] : [
        n.width,
        n.height
    ];
    let d;
    if (i) d = n.getContext("2d").getImageData(0, 0, c, u).data;
    else if (s || e) d = n.data;
    else if (r || o || a) {
        if (io == null) {
            if (typeof document > "u") {
                if (typeof OffscreenCanvas < "u" && typeof OffscreenCanvasRenderingContext2D < "u") io = new OffscreenCanvas(1, 1).getContext("2d");
                else throw new Error("Cannot parse input in current context. Reason: OffscreenCanvas Context2D rendering is not supported.");
            } else io = document.createElement("canvas").getContext("2d", {
                willReadFrequently: !0
            });
        }
        io.canvas.width = c, io.canvas.height = u, io.drawImage(n, 0, 0, c, u), d = io.getImageData(0, 0, c, u).data;
    }
    let h;
    if (t === 4) h = new Int32Array(d);
    else {
        const f = c * u;
        h = new Int32Array(f * t);
        for(let m = 0; m < f; m++)for(let g = 0; g < t; ++g)h[m * t + g] = d[m * 4 + g];
    }
    return rN(h, [
        u,
        c,
        t
    ], "int32");
}
function p$(n) {
    return n != null && n.data instanceof Uint8Array;
}
function f$() {
    return typeof window < "u" && typeof ImageBitmap < "u" && window.hasOwnProperty("createImageBitmap");
}
function m$(n) {
    return n != null && n.width !== 0 && n.height !== 0;
}
function g$(n) {
    return f$() && !(n instanceof ImageBitmap) && m$(n) && !p$(n);
}
async function b$(n, t = 3) {
    let e = null;
    if (F().getBool("WRAP_TO_IMAGEBITMAP") && g$(n)) {
        let s;
        try {
            s = await createImageBitmap(n, {
                premultiplyAlpha: "none"
            });
        } catch  {
            s = null;
        }
        s != null && s.width === n.width && s.height === n.height ? e = s : e = n;
    } else e = n;
    return V0(e, t);
}
function z0(n) {
    if (n.rank !== 2 && n.rank !== 3) throw new Error(`toPixels only supports rank 2 or 3 tensors, got rank ${n.rank}.`);
    const t = n.rank === 2 ? 1 : n.shape[2];
    if (t > 4 || t === 2) throw new Error(`toPixels only supports depth of size 1, 3 or 4 but got ${t}`);
    if (n.dtype !== "float32" && n.dtype !== "int32") throw new Error(`Unsupported type for toPixels: ${n.dtype}. Please use float32 or int32 tensors.`);
}
function x$(n) {
    const t = (n == null ? void 0 : n.alpha) || 1;
    if (t > 1 || t < 0) throw new Error(`Alpha value ${t} is suppoed to be in range [0 - 1].`);
}
async function y$(n, t) {
    let e = T(n, "img", "toPixels");
    if (!(n instanceof Mt)) {
        const c = e;
        e = tt(c, "int32"), c.dispose();
    }
    z0(e);
    const [s, o] = e.shape.slice(0, 2), r = e.rank === 2 ? 1 : e.shape[2], i = await e.data(), a = e.dtype === "float32" ? 255 : 1, l = new Uint8ClampedArray(o * s * 4);
    for(let c = 0; c < s * o; ++c){
        const u = [
            0,
            0,
            0,
            255
        ];
        for(let h = 0; h < r; h++){
            const p = i[c * r + h];
            if (e.dtype === "float32") {
                if (p < 0 || p > 1) throw new Error(`Tensor values for a float32 Tensor must be in the range [0 - 1] but encountered ${p}.`);
            } else if (e.dtype === "int32" && (p < 0 || p > 255)) throw new Error(`Tensor values for a int32 Tensor must be in the range [0 - 255] but encountered ${p}.`);
            r === 1 ? (u[0] = p * a, u[1] = p * a, u[2] = p * a) : u[h] = p * a;
        }
        const d = c * 4;
        l[d + 0] = Math.round(u[0]), l[d + 1] = Math.round(u[1]), l[d + 2] = Math.round(u[2]), l[d + 3] = Math.round(u[3]);
    }
    if (t != null) {
        Lm || bl(gh, $.backendName) != null && (console.warn("tf.browser.toPixels is not efficient to draw tensor on canvas. Please try tf.browser.draw instead."), Lm = !0), t.width = o, t.height = s;
        const c = t.getContext("2d"), u = new ImageData(l, o, s);
        c.putImageData(u, 0, 0);
    }
    return e !== n && e.dispose(), l;
}
function w$(n, t, e) {
    let s = T(n, "img", "draw");
    if (!(n instanceof Mt)) {
        const i = s;
        s = tt(i, "int32"), i.dispose();
    }
    z0(s), x$(e == null ? void 0 : e.imageOptions);
    const o = {
        image: s
    }, r = {
        canvas: t,
        options: e
    };
    $.runKernel(gh, o, r);
}
const P0 = /* @__PURE__ */ L({
    fromPixels_: V0
}), MQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    draw: w$,
    fromPixels: P0,
    fromPixelsAsync: b$,
    toPixels: y$
}, Symbol.toStringTag, {
    value: "Module"
}));
function eu(n, t) {
    const e = n.shape.length, s = t.shape.length;
    if (e < 1) throw new Error(`tf.gatherND() expects the input to be rank 1 or higher, but the rank was ${e}.`);
    if (s < 1) throw new Error(`tf.gatherND() expects the indices to be rank 1 or higher, but the rank was ${s}.`);
    if (t.dtype !== "int32") throw new Error(`tf.gatherND() expects the indices to be int32 type, but the dtype was ${t.dtype}.`);
    if (t.shape[s - 1] > e) throw new Error(`index innermost dimension length must be <= tensor rank; saw: ${t.shape[s - 1]} vs. ${e}`);
    if (X(n.shape) === 0) throw new Error(`Requested more than 0 entries, but input is empty. Input shape: ${n.shape}.`);
    const o = t.shape, r = o[o.length - 1];
    let i = 1;
    for(let d = 0; d < o.length - 1; ++d)i *= o[d];
    const a = n.shape, l = o.slice();
    l.pop();
    let c = 1;
    for(let d = r; d < e; ++d)c *= a[d], l.push(a[d]);
    const u = [
        ...dt(n.shape).map((d)=>d / c),
        1
    ].slice(0, r);
    return [
        l,
        i,
        c,
        u
    ];
}
const WQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    prepareAndValidate: eu
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const kd = -2, I$ = -1;
function Zp(n, t, e) {
    const s = n.shape.length;
    C(s === t.length, ()=>`Error in slice${s}D: Length of begin ${t} must match the rank of the array (${s}).`), C(s === e.length, ()=>`Error in slice${s}D: Length of size ${e} must match the rank of the array (${s}).`);
    for(let o = 0; o < s; ++o)C(t[o] + e[o] <= n.shape[o], ()=>`Error in slice${s}D: begin[${o}] + size[${o}] (${t[o] + e[o]}) would overflow input.shape[${o}] (${n.shape[o]})`);
}
function C$(n) {
    const t = [];
    let e = 0;
    for(; n > 0;)n & 1 && t.push(e), n /= 2, e++;
    return t;
}
function Bp(n, t, e) {
    const s = [];
    for(let o = 0; o < n.length; o++)s[o] = Math.ceil((t[o] - n[o]) / e[o]);
    return s;
}
function A0(n, t, e, s) {
    const o = [
        ...n
    ];
    for(let r = o.length; r < s.length; r++)o.push(1);
    for(let r = 0; r < e; r++)r === 0 ? o[t] = 1 : (o.splice(t, 0, 1), o.pop());
    return o;
}
function O0(n, t, e) {
    return e <= n ? e : e - (t - 1);
}
function X0(n, t) {
    const e = [];
    for(let s = 0; s < n; s++)e.push(t + s);
    return e;
}
function v$(n, t, e, s, o, r, i, a, l) {
    const c = n.length;
    let u = new Array(c), d = new Array(c), h = new Array(c);
    if (t.length && e > 0) {
        const p = t[0], f = e + 1;
        u = K0(i, p, f, s, n), d = Z0(a, p, f, o, n), h = A0(r, p, f, n);
    } else for(let p = 0; p < c; p++)u[p] = H0(i, s, r, n, p, l), d[p] = _0(a, o, r, n, p, l), h[p] = B0(r, p, l);
    return {
        begin: u,
        end: d,
        strides: h
    };
}
function K0(n, t, e, s, o) {
    const r = [
        ...o
    ], i = X0(e, t);
    for(let a = 0; a < r.length; a++)if (i.indexOf(a) > -1) r[a] = 0;
    else {
        const l = O0(t, e, a);
        let c = s[l];
        n & 1 << l && (c = 0), r[a] = c;
    }
    return r;
}
function Z0(n, t, e, s, o) {
    const r = [
        ...o
    ], i = X0(e, t);
    for(let a = 0; a < r.length; a++)if (i.indexOf(a) > -1) r[a] = Number.MAX_SAFE_INTEGER;
    else {
        const l = O0(t, e, a);
        let c = s[l];
        n & 1 << l && (c = Number.MAX_SAFE_INTEGER), r[a] = c;
    }
    for(let a = 0; a < r.length; a++){
        const l = o[a];
        r[a] < 0 && (r[a] += l), r[a] = Os(0, r[a], o[a]);
    }
    return r;
}
function B0(n, t, e) {
    let s = n[t];
    return (e & 1 << t || s == null) && (s = 1), s;
}
function H0(n, t, e, s, o, r) {
    let i = t[o];
    const a = e[o] || 1;
    (n & 1 << o || r & 1 << o || i == null) && (a > 0 ? i = Number.MIN_SAFE_INTEGER : i = Number.MAX_SAFE_INTEGER);
    const l = s[o];
    return i < 0 && (i += l), i = Os(0, i, l - 1), i;
}
function _0(n, t, e, s, o, r) {
    let i = t[o];
    const a = e[o] || 1;
    (n & 1 << o || r & 1 << o || i == null) && (a > 0 ? i = Number.MAX_SAFE_INTEGER : i = Number.MIN_SAFE_INTEGER);
    const l = s[o];
    return i < 0 && (i += l), a > 0 ? i = Os(0, i, l) : i = Os(-1, i, l - 1), i;
}
function Hp(n, t, e) {
    let s = e.length;
    for(let o = 0; o < e.length; o++)if (e[o] > 1) {
        s = o;
        break;
    }
    for(let o = s + 1; o < e.length; o++)if (t[o] > 0 || e[o] !== n[o]) return !1;
    return !0;
}
function _p(n, t) {
    let e = n.length > 0 ? n[n.length - 1] : 1;
    for(let s = 0; s < n.length - 1; s++)e += n[s] * t[s];
    return e;
}
function nu(n, t, e) {
    let s;
    const o = n.shape.length;
    typeof t == "number" ? s = [
        t,
        ...new Array(o - 1).fill(0)
    ] : t.length < o ? s = t.concat(new Array(o - t.length).fill(0)) : s = t.slice(), s.forEach((i)=>{
        C(i !== -1, ()=>"slice() does not support negative begin indexing.");
    });
    let r;
    return e == null ? r = new Array(o).fill(-1) : typeof e == "number" ? r = [
        e,
        ...new Array(o - 1).fill(-1)
    ] : e.length < o ? r = e.concat(new Array(o - e.length).fill(-1)) : r = e, r = r.map((i, a)=>i >= 0 ? i : (C(i === -1, ()=>`Negative size values should be exactly -1 but got ${i} for the slice() size at index ${a}.`), n.shape[a] - s[a])), [
        s,
        r
    ];
}
function Up(n, t, e, s, o, r, i, a, l) {
    let c;
    if (s == null ? (c = new Array(t.length), c.fill(1)) : c = s, i != null && i & i - 1) throw new Error("Multiple ellipses in slice is not allowed.");
    let u = !1;
    const d = {
        dims: c.length,
        numAddAxisAfterEllipsis: 0,
        begin: t.slice(),
        end: e.slice(),
        strides: c.slice(),
        beginMask: o,
        endMask: r,
        ellipsisMask: i,
        newAxisMask: a,
        shrinkAxisMask: l
    };
    for(let w = 0; w < d.dims; w++)u && 1 << w & a && d.numAddAxisAfterEllipsis++, 1 << w & i && (u = !0);
    u || (d.ellipsisMask |= 1 << d.dims, d.dims++);
    const h = {
        dims: n.length,
        beginMask: 0,
        endMask: 0,
        beginValid: !1,
        endValid: !1
    };
    S$(d, h);
    let p = !0, f = !0, m = !0;
    const g = [], b = [];
    for(let w = 0; w < n.length; ++w){
        if (h.strides[w] === 0) throw Error(`strides[${w}] must be non-zero`);
        const y = !!(h.shrinkAxisMask & 1 << w), I = n[w];
        if (I === -1) {
            g.push(y ? 1 : -1);
            continue;
        }
        const v = [
            h.beginMask & 1 << w,
            h.endMask & 1 << w
        ], k = [
            h.strides[w] > 0 ? 0 : -1,
            h.strides[w] > 0 ? I : I - 1
        ];
        if (y && h.strides[w] <= 0) throw Error("only stride 1 allowed on non-range indexing.");
        m = m && h.strides[w] === 1;
        const S = !!(h.beginMask & 1 << w && h.endMask & 1 << w);
        if (h.beginValid && h.endValid) {
            if (y) {
                const V = h.begin[w] < 0 ? I + h.begin[w] : h.begin[w];
                if (h.begin[w] = V, h.end[w] = h.begin[w] + 1, V < 0 || V >= I) throw Error(`slice index ${h.begin[w]} of dimension ${w} out of bounds.`);
            } else h.begin[w] = Mm(h.begin[w], 0, h.strides[w], I, v, k), h.end[w] = Mm(h.end[w], 1, h.strides[w], I, v, k);
            const M = h.strides[w] === 1 && h.begin[w] === 0 && h.end[w] === I;
            p = p && M, f = f && (w === 0 && h.strides[w] === 1 || M);
        } else p = p && h.strides[w] === 1 && S, f = f && (w === 0 && h.strides[w] === 1 || S);
        let N, R = !1;
        if (h.beginValid && h.endValid ? (N = h.end[w] - h.begin[w], R = !0) : y ? (N = 1, R = !0) : S && I >= 0 && (h.strides[w] < 0 ? N = -I : N = I, R = !0), R) {
            let M;
            N === 0 || N < 0 != h.strides[w] < 0 ? M = 0 : M = Math.trunc(N / h.strides[w]) + (N % h.strides[w] !== 0 ? 1 : 0), g.push(M);
        } else g.push(-1);
    }
    for(let w = 0; w < h.finalShapeGatherIndices.length; ++w){
        const y = h.finalShapeGatherIndices[w];
        y >= 0 ? b.push(g[y]) : y === kd && b.push(1);
    }
    return {
        finalShapeSparse: b.filter((w, y)=>h.finalShapeGatherIndices[y] !== kd),
        finalShape: b,
        isIdentity: p,
        sliceDim0: f,
        isSimpleSlice: m,
        begin: h.begin,
        end: h.end,
        strides: h.strides
    };
}
function S$(n, t) {
    t.beginMask = 0, t.endMask = 0, t.shrinkAxisMask = 0;
    let e = 0;
    t.beginValid = n.begin != null, t.endValid = n.end != null, t.begin = new Array(t.dims), t.end = new Array(t.dims), t.strides = new Array(t.dims), t.finalShapeGatherIndices = [], t.finalShapeGatherIndicesSparse = [], t.inputShapeGatherIndicesSparse = new Array(t.dims);
    for(let s = 0; s < n.dims; s++)if (1 << s & n.ellipsisMask) {
        const o = Math.min(t.dims - (n.dims - s) + 1 + n.numAddAxisAfterEllipsis, t.dims);
        for(; e < o; e++)t.begin[e] = 0, t.end[e] = 0, t.strides[e] = 1, t.beginMask |= 1 << e, t.endMask |= 1 << e, t.finalShapeGatherIndices.push(e), t.finalShapeGatherIndicesSparse.push(-1), t.inputShapeGatherIndicesSparse[e] = s;
    } else if (1 << s & n.newAxisMask) t.finalShapeGatherIndices.push(kd), t.finalShapeGatherIndicesSparse.push(-1);
    else {
        if (e === t.begin.length) throw Error(`Index out of range using input dim ${e}; input has only ${t.dims} dims, ${t.begin.length}.`);
        n.begin != null && (t.begin[e] = n.begin[s]), n.end != null && (t.end[e] = n.end[s]), t.strides[e] = n.strides[s], n.beginMask & 1 << s && (t.beginMask |= 1 << e), n.endMask & 1 << s && (t.endMask |= 1 << e), n.shrinkAxisMask & 1 << s ? (t.finalShapeGatherIndices.push(I$), t.finalShapeGatherIndicesSparse.push(-1), t.shrinkAxisMask |= 1 << e) : (t.finalShapeGatherIndices.push(e), t.finalShapeGatherIndicesSparse.push(s)), t.inputShapeGatherIndicesSparse[e] = s, e++;
    }
}
function Mm(n, t, e, s, o, r) {
    if (o[t]) return e > 0 ? r[t] : r[t + 1 & 1];
    {
        const i = n < 0 ? s + n : n;
        return i < r[0] ? r[0] : i > r[1] ? r[1] : i;
    }
}
const k$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    assertParamsValid: Zp,
    computeFlatOffset: _p,
    computeOutShape: Bp,
    getNormalizedAxes: v$,
    isSliceContinous: Hp,
    maskToAxes: C$,
    parseSliceParams: nu,
    sliceInfo: Up,
    startForAxis: H0,
    startIndicesWithElidedDims: K0,
    stopForAxis: _0,
    stopIndicesWithElidedDims: Z0,
    stridesForAxis: B0,
    stridesWithElidedDims: A0
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class T$ {
    /**
   * Constructs a `tf.SGDOptimizer` that uses stochastic gradient descent.
   *
   * ```js
   * // Fit a quadratic function by learning the coefficients a, b, c.
   * const xs = tf.tensor1d([0, 1, 2, 3]);
   * const ys = tf.tensor1d([1.1, 5.9, 16.8, 33.9]);
   *
   * const a = tf.scalar(Math.random()).variable();
   * const b = tf.scalar(Math.random()).variable();
   * const c = tf.scalar(Math.random()).variable();
   *
   * // y = a * x^2 + b * x + c.
   * const f = x => a.mul(x.square()).add(b.mul(x)).add(c);
   * const loss = (pred, label) => pred.sub(label).square().mean();
   *
   * const learningRate = 0.01;
   * const optimizer = tf.train.sgd(learningRate);
   *
   * // Train the model.
   * for (let i = 0; i < 10; i++) {
   *   optimizer.minimize(() => loss(f(xs), ys));
   * }
   *
   * // Make predictions.
   * console.log(
   *     `a: ${a.dataSync()}, b: ${b.dataSync()}, c: ${c.dataSync()}`);
   * const preds = f(xs).dataSync();
   * preds.forEach((pred, i) => {
   *   console.log(`x: ${i}, pred: ${pred}`);
   * });
   * ```
   *
   * @param learningRate The learning rate to use for the SGD algorithm.
   *
   * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
   */ static sgd(t) {
        return new Xp(t);
    }
    /**
   * Constructs a `tf.MomentumOptimizer` that uses momentum gradient
   * descent.
   *
   * See
   * [http://proceedings.mlr.press/v28/sutskever13.pdf](
   * http://proceedings.mlr.press/v28/sutskever13.pdf)
   *
   * @param learningRate The learning rate to use for the Momentum gradient
   * descent algorithm.
   * @param momentum The momentum to use for the momentum gradient descent
   * algorithm.
   *
   * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
   */ static momentum(t, e, s = !1) {
        return new L0(t, e, s);
    }
    /**
   * Constructs a `tf.RMSPropOptimizer` that uses RMSProp gradient
   * descent. This implementation uses plain momentum and is not centered
   * version of RMSProp.
   *
   * See
   * [http://www.cs.toronto.edu/~tijmen/csc321/slides/lecture_slides_lec6.pdf](
   * http://www.cs.toronto.edu/~tijmen/csc321/slides/lecture_slides_lec6.pdf)
   *
   * @param learningRate The learning rate to use for the RMSProp gradient
   * descent algorithm.
   * @param decay The discounting factor for the history/coming gradient.
   * @param momentum The momentum to use for the RMSProp gradient descent
   * algorithm.
   * @param epsilon Small value to avoid zero denominator.
   * @param centered If true, gradients are normalized by the estimated
   * variance of the gradient.
   *
   * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
   */ static rmsprop(t, e = 0.9, s = 0, o = null, r = !1) {
        return new M0(t, e, s, o, r);
    }
    /**
   * Constructs a `tf.AdamOptimizer` that uses the Adam algorithm.
   * See [https://arxiv.org/abs/1412.6980](https://arxiv.org/abs/1412.6980)
   *
   * @param learningRate The learning rate to use for the Adam gradient
   * descent algorithm.
   * @param beta1 The exponential decay rate for the 1st moment estimates.
   * @param beta2 The exponential decay rate for the 2nd moment estimates.
   * @param epsilon A small constant for numerical stability.
   *
   * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
   */ static adam(t = 1e-3, e = 0.9, s = 0.999, o = null) {
        return new G0(t, e, s, o);
    }
    /**
   * Constructs a `tf.AdadeltaOptimizer` that uses the Adadelta algorithm.
   * See [https://arxiv.org/abs/1212.5701](https://arxiv.org/abs/1212.5701)
   *
   * @param learningRate The learning rate to use for the Adadelta gradient
   * descent algorithm.
   * @param rho The learning rate decay over each update.
   * @param epsilon A constant epsilon used to better condition the grad
   * update.
   *
   * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
   */ static adadelta(t = 1e-3, e = 0.95, s = null) {
        return new R0(t, e, s);
    }
    /**
   * Constructs a `tf.AdamaxOptimizer` that uses the Adamax algorithm.
   * See [https://arxiv.org/abs/1412.6980](https://arxiv.org/abs/1412.6980)
   *
   * @param learningRate The learning rate to use for the Adamax gradient
   * descent algorithm.
   * @param beta1 The exponential decay rate for the 1st moment estimates.
   * @param beta2 The exponential decay rate for the 2nd moment estimates.
   * @param epsilon A small constant for numerical stability.
   * @param decay The learning rate decay over each update.
   *
   * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
   */ static adamax(t = 2e-3, e = 0.9, s = 0.999, o = null, r = 0) {
        return new E0(t, e, s, o, r);
    }
    /**
   * Constructs a `tf.AdagradOptimizer` that uses the Adagrad algorithm.
   * See
   * [http://www.jmlr.org/papers/volume12/duchi11a/duchi11a.pdf](
   * http://www.jmlr.org/papers/volume12/duchi11a/duchi11a.pdf)
   * or
   * [http://ruder.io/optimizing-gradient-descent/index.html#adagrad](
   * http://ruder.io/optimizing-gradient-descent/index.html#adagrad)
   *
   * @param learningRate The learning rate to use for the Adagrad gradient
   * descent algorithm.
   * @param initialAccumulatorValue Starting value for the accumulators, must be
   * positive.
   *
   * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
   */ static adagrad(t, e = 0.1) {
        return new $0(t, e);
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const tr = T$;
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const N$ = typeof requestAnimationFrame < "u" ? requestAnimationFrame : typeof setImmediate < "u" ? setImmediate : (n)=>n();
function su() {
    return new Promise((n)=>N$(()=>n()));
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Yp(n, t) {
    const e = n[0].length;
    n.forEach((o, r)=>{
        C(o.length === e, ()=>`Error in concat${e}D: rank of tensors[${r}] must be the same as the rank of the rest (${e})`);
    }), C(t >= 0 && t < e, ()=>`Error in concat${e}D: axis must be between 0 and ${e - 1}.`);
    const s = n[0];
    n.forEach((o, r)=>{
        for(let i = 0; i < e; i++)C(i === t || o[i] === s[i], ()=>`Error in concat${e}D: Shape of tensors[${r}] (${o}) does not match the shape of the rest (${s}) along the non-concatenated axis ${r}.`);
    });
}
function ts(n, t) {
    const e = n[0].slice();
    for(let s = 1; s < n.length; s++)e[t] += n[s][t];
    return e;
}
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var Fn;
(function(n) {
    n[n.FIRST_DIM_SIZE = 0] = "FIRST_DIM_SIZE", n[n.VALUE_ROWIDS = 1] = "VALUE_ROWIDS", n[n.ROW_LENGTHS = 2] = "ROW_LENGTHS", n[n.ROW_SPLITS = 3] = "ROW_SPLITS", n[n.ROW_LIMITS = 4] = "ROW_LIMITS", n[n.ROW_STARTS = 5] = "ROW_STARTS";
})(Fn || (Fn = {}));
function U0(n, t, e) {
    let s = new Array();
    if (e == null && t == null) return s;
    if (t == null) for(; s.length < n + e.length;)s.push(-1);
    else s = t.slice();
    if (e == null) return s;
    if (n + e.length !== s.length) throw new Error(`rt input.shape and shape=${t} are incompatible: rt input.rank = ${n + e.length}, but shape.rank = ${s.length}`);
    for(let o = 1; o < e.length; ++o){
        const r = e[o], i = s[s.length - e.length + o], a = s[i];
        if (r >= 0) {
            if (a >= 0) {
                if (a !== r) throw new Error(`rt input.shape and shape=${t} are incompatible: rt input.shape[${o + n}] = ${r} but shape[${o + n}] = ${a}`);
            } else s[i] = r;
        }
    }
    return s;
}
function Y0(n) {
    const t = {
        FIRST_DIM_SIZE: Fn.FIRST_DIM_SIZE,
        VALUE_ROWIDS: Fn.VALUE_ROWIDS,
        ROW_LENGTHS: Fn.ROW_LENGTHS,
        ROW_SPLITS: Fn.ROW_SPLITS,
        ROW_LIMITS: Fn.ROW_LIMITS,
        ROW_STARTS: Fn.ROW_STARTS
    }, e = [];
    for (const s of n)if (s in t) e.push(t[s]);
    else break;
    return e;
}
function Q0(n) {
    return n.length === 0 ? 0 : n[0] === Fn.FIRST_DIM_SIZE ? n.length - 1 : n.length;
}
function J0(n, t) {
    if (n == null || t == null) return;
    const e = n.length, s = t.length;
    if (e >= s) throw new Error(`defaultValue.shape=${n} and ragged tensor flatValues.shape=${t}, are incompatible: defaultValue.rank = ${e} must be less than ragged tensor input flatValues.rank = ${s})`);
    for(let o = 0; o < Math.min(e, s - 1); ++o){
        const r = n[o], i = t[o + 1];
        if (r >= 0 && i >= 0 && r !== 1 && r !== i) throw new Error(`defaultValue.shape=${n}, and ragged tensor input flatValues.shape=${t} are incompatible: defaultValue.shape[${o - n.length}] = ${r} but ragged tensor input.flatValues.shape[${o - n.length}] = ${i}`);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Qp = 30;
function ou(n) {
    return n <= Qp ? n : fl(n, Math.floor(Math.sqrt(n)));
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Jp(n, t, e) {
    const s = e * (typeof n == "number" ? n : n[0]), o = t * (typeof n == "number" ? n : n[1]);
    return [
        s,
        o
    ];
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Na(n, t, e, s = !0) {
    let o = [];
    if (s) o = o.concat(t.slice(0)), o.push(n[0] / e), o = o.concat(n.slice(1));
    else {
        o = o.concat(n[0]);
        const r = t.length;
        for(let i = 0; i < r; ++i)o = o.concat([
            n[i + 1] / t[i],
            t[i]
        ]);
        o = o.concat(n.slice(r + 1));
    }
    return o;
}
function Ra(n, t, e = !0) {
    const s = [];
    if (e) {
        s.push(t);
        for(let o = t + 1; o < n; ++o)o <= 2 * t ? (s.push(o), s.push(o - (t + 1))) : s.push(o);
    } else {
        const o = [], r = [];
        for(let i = 1; i < n; ++i)i >= t * 2 + 1 || i % 2 === 1 ? r.push(i) : o.push(i);
        s.push(...o), s.push(0), s.push(...r);
    }
    return s;
}
function $a(n, t, e, s = !0) {
    const o = [];
    s ? o.push(n[0] / e) : o.push(n[0] * e);
    for(let r = 1; r < n.length; ++r)r <= t.length ? s ? o.push(t[r - 1] * n[r]) : o.push(n[r] / t[r - 1]) : o.push(n[r]);
    return o;
}
function jp(n, t) {
    const e = [
        0
    ];
    for(let s = 0; s < t; ++s)e.push(n[s][0]);
    return e;
}
function qp(n, t, e) {
    const s = n.slice(0, 1);
    for(let o = 0; o < e; ++o)s.push(n[o + 1] - t[o][0] - t[o][1]);
    return s;
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const ru = 1.7580993408473768, iu = 1.0507009873554805;
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const tf = 0.3275911, ef = 0.254829592, nf = -0.284496736, sf = 1.421413741, of = -1.453152027, rf = 1.061405429;
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function xs(n, t) {
    if (n.length !== t.length) throw new Error(`Cannot merge real and imag arrays of different lengths. real:${n.length}, imag: ${t.length}.`);
    const e = new Float32Array(n.length * 2);
    for(let s = 0; s < e.length; s += 2)e[s] = n[s / 2], e[s + 1] = t[s / 2];
    return e;
}
function j0(n) {
    const t = new Float32Array(n.length / 2), e = new Float32Array(n.length / 2);
    for(let s = 0; s < n.length; s += 2)t[s / 2] = n[s], e[s / 2] = n[s + 1];
    return {
        real: t,
        imag: e
    };
}
function q0(n) {
    const t = Math.ceil(n.length / 4), e = new Float32Array(t), s = new Float32Array(t);
    for(let o = 0; o < n.length; o += 4)e[Math.floor(o / 4)] = n[o], s[Math.floor(o / 4)] = n[o + 1];
    return {
        real: e,
        imag: s
    };
}
function tx(n) {
    const t = Math.floor(n.length / 4), e = new Float32Array(t), s = new Float32Array(t);
    for(let o = 2; o < n.length; o += 4)e[Math.floor(o / 4)] = n[o], s[Math.floor(o / 4)] = n[o + 1];
    return {
        real: e,
        imag: s
    };
}
function af(n, t) {
    const e = n[t * 2], s = n[t * 2 + 1];
    return {
        real: e,
        imag: s
    };
}
function ex(n, t, e, s) {
    n[s * 2] = t, n[s * 2 + 1] = e;
}
function nx(n, t) {
    const e = new Float32Array(n / 2), s = new Float32Array(n / 2);
    for(let o = 0; o < Math.ceil(n / 2); o++){
        const r = (t ? 2 : -2) * Math.PI * (o / n);
        e[o] = Math.cos(r), s[o] = Math.sin(r);
    }
    return {
        real: e,
        imag: s
    };
}
function sx(n, t, e) {
    const s = (e ? 2 : -2) * Math.PI * (n / t), o = Math.cos(s), r = Math.sin(s);
    return {
        real: o,
        imag: r
    };
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Mu = "->", R$ = /->/g, Wm = ",", Dm = "...";
function lf(n, t) {
    n = n.replace(/\s/g, "");
    const e = (n.length - n.replace(R$, "").length) / Mu.length;
    if (e < 1) throw new Error("Equations without an arrow are not supported.");
    if (e > 1) throw new Error(`Equation must contain exactly one arrow ("${Mu}").`);
    const [s, o] = n.split(Mu);
    C(s.indexOf(Dm) === -1, ()=>`The ellipsis notation ("${Dm}") is not supported yet.`);
    const r = s.split(Wm), i = r.length;
    if (t !== i) throw new Error(`Expected ${i} input tensors, received ${t}`);
    if (i > 2) throw new Error("Support for more than 2 input tensors is not implemented yet.");
    const a = [];
    for(let h = 0; h < o.length; ++h){
        const p = o[h];
        if (!r.some((f)=>f.indexOf(p) !== -1)) throw new Error(`Output subscripts contain the label ${p} not present in the input subscripts.`);
        a.indexOf(p) === -1 && a.push(p);
    }
    for(let h = 0; h < s.length; ++h){
        const p = s[h];
        a.indexOf(p) === -1 && p !== Wm && a.push(p);
    }
    const l = new Array(r.length);
    for(let h = 0; h < i; ++h){
        if (new Set(r[h].split("")).size !== r[h].length) throw new Error(`Found duplicate axes in input component ${r[h]}. Support for duplicate axes in input is not implemented yet.`);
        l[h] = [];
        for(let p = 0; p < r[h].length; ++p)l[h].push(a.indexOf(r[h][p]));
    }
    const c = a.length, u = o.length, d = [];
    for(let h = u; h < c; ++h)d.push(h);
    return {
        allDims: a,
        summedDims: d,
        idDims: l
    };
}
function cf(n, t) {
    let e = new Array(n);
    e.fill(-1);
    for(let o = 0; o < t.length; ++o)e[t[o]] = o;
    const s = [];
    for(let o = 0; o < n; ++o)e[o] === -1 && s.push(o);
    return e = e.filter((o)=>o !== -1), {
        permutationIndices: e,
        expandDims: s
    };
}
function uf(n, t, e) {
    const s = new Array(n);
    for(let o = 0; o < e.length; ++o){
        const r = e[o].shape;
        for(let i = 0; i < t[o].length; ++i)s[t[o][i]] === void 0 ? s[t[o][i]] = r[i] : C(s[t[o][i]] === r[i], ()=>`Expected dimension ${s[t[o][i]]} at axis ${i} of input shaped ${JSON.stringify(r)}, but got dimension ${r[i]}`);
    }
}
function df(n, t) {
    const e = n, s = [];
    let o = 0;
    n.length === 0 && e.push(-1), o = n.length + 1;
    for(let i = 0; i < o; ++i)s.push([]);
    const r = [];
    for(let i = 0; i < e.length; ++i){
        const a = e[i], l = $$(t, a);
        for (const c of l)r.indexOf(c) === -1 && (s[i].push(c), r.push(c));
    }
    return {
        path: e,
        steps: s
    };
}
function hf(n) {
    return n.every((t, e)=>t === e);
}
function $$(n, t) {
    const e = [];
    for(let s = 0; s < n.length; ++s)(n[s].length === 0 || n[s].indexOf(t) !== -1 || t === -1) && e.push(s);
    return e;
}
function pf(n, t, e = 0) {
    let s = [];
    if (typeof t == "number") C(n.shape[e] % t === 0, ()=>"Number of splits must evenly divide the axis."), s = new Array(t).fill(n.shape[e] / t);
    else {
        const o = t.reduce((i, a)=>(a === -1 && (i += 1), i), 0);
        C(o <= 1, ()=>"There should be only one negative value in split array.");
        const r = t.indexOf(-1);
        if (r !== -1) {
            const i = t.reduce((a, l)=>l > 0 ? a + l : a);
            t[r] = n.shape[e] - i;
        }
        C(n.shape[e] === t.reduce((i, a)=>i + a), ()=>"The sum of sizes must match the size of the axis dimension."), s = t;
    }
    return s;
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ox(n) {
    return `Received SparseTensor with denseShape[0] = 0 but
  indices.shape[0] = ${n}`;
}
function rx(n, t) {
    return `indices(${n}, 0) is invalid: ${t} < 0`;
}
function ix(n, t, e) {
    return `indices(${n}, 0) is invalid: ${t} >= ${e}`;
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ax(n, t) {
    return `only one output dimension may be -1, not both ${n} and ${t}`;
}
function lx(n, t) {
    return `size ${n} must be non-negative, not ${t}`;
}
function cx() {
    return "reshape cannot infer the missing input size for an empty tensor unless all specified input sizes are non-zero";
}
function ux(n, t) {
    const e = X(n), s = X(t);
    return `Input to reshape is a SparseTensor with ${e}
  dense values, but the requested shape requires a multiple of ${s}. inputShape=${n} outputShape= ${t}`;
}
function dx(n, t) {
    const e = X(n), s = X(t);
    return `Input to reshape is a tensor with ${e} dense values, but the requested shape has ${s}. inputShape=${n} outputShape=${t}`;
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Td() {
    return "segment ids must be >= 0";
}
function hx() {
    return "segment ids are not increasing";
}
function px(n, t) {
    return `Segment id ${n} out of range [0, ${t}), possibly because segmentIds input is not sorted.`;
}
function fx(n, t, e) {
    return `Bad: indices[${n}] == ${t} out of range [0, ${e})`;
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function mx(n, t) {
    let e = !1, s;
    for(n <= Qp ? (s = n, e = !0) : s = fl(n, Math.floor(Math.sqrt(n))); !e;)s > t || s === n ? e = !0 : s = fl(n, s + 1);
    return s;
}
function gx(n, t, e) {
    const s = [], o = n.length;
    for(let r = 0; r < o; r++)r !== t ? s.push(n[r]) : s.push(e);
    return s;
}
function ff(n, t, e, s) {
    const o = t.shape.length, r = n.shape.length;
    if (s !== 0 && (s < -o || s > o)) throw new Error(`Expect batchDims in the range of [-${o}, ${o}], but got ${s}`);
    if (s < 0 && (s += o), s > r) throw new Error(`batchDims (${s}) must be less than rank(x) (
    ${r}).`);
    if (e < s) throw new Error(`batchDims (${s}) must be less than or equal to axis (${e}).`);
    for(let d = 0; d < s; ++d)if (n.shape[d] !== t.shape[d]) throw new Error(`x.shape[${d}]: ${n.shape[d]} should be equal to indices.shape[${d}]: ${t.shape[d]}.`);
    const i = n.shape[e], a = [];
    let l = 1, c = 1, u = 1;
    for(let d = 0; d < s; ++d)a.push(n.shape[d]), l *= n.shape[d];
    for(let d = s; d < e; d++)a.push(n.shape[d]), c *= n.shape[d];
    for(let d = s; d < o; d++)a.push(t.shape[d]);
    for(let d = e + 1; d < r; d++)a.push(n.shape[d]), u *= n.shape[d];
    return {
        batchSize: l,
        sliceSize: u,
        outerSize: c,
        dimSize: i,
        outputShape: a
    };
}
const G$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    collectGatherOpShapeInfo: ff,
    computeOutShape: gx,
    segOpComputeOptimalWindowSize: mx
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ys(n) {
    try {
        return n.map((t)=>gs(t));
    } catch (t) {
        throw new Error(`Failed to decode encoded string bytes into utf-8, error: ${t}`);
    }
}
function bx(n) {
    return n.map((t)=>ms(t));
}
const E$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    ERF_A1: ef,
    ERF_A2: nf,
    ERF_A3: sf,
    ERF_A4: of,
    ERF_A5: rf,
    ERF_P: tf,
    PARALLELIZE_THRESHOLD: Qp,
    get RowPartitionType () {
        return Fn;
    },
    SELU_SCALE: iu,
    SELU_SCALEALPHA: ru,
    applyActivation: Fp,
    assertAndGetBroadcastShape: bt,
    assertAxesAreInnerMostDims: Ne,
    assertParamsConsistent: Yp,
    assignToTypedArray: ex,
    axesAreInnerMostDims: lp,
    calculateShapes: to,
    checkEinsumDimSizes: uf,
    checkPadOnDimRoundingMode: Ue,
    combineLocations: n0,
    combineRaggedTensorToTensorShapes: U0,
    complexWithEvenIndex: q0,
    complexWithOddIndex: tx,
    computeConv2DInfo: Te,
    computeConv3DInfo: Js,
    computeDefaultPad: ep,
    computeDilation2DInfo: Ia,
    computeOptimalWindowSize: ou,
    computeOutAndReduceShapes: ye,
    computeOutShape: ts,
    computePool2DInfo: $n,
    computePool3DInfo: vs,
    convertConv2DDataFormat: Ss,
    decodeEinsumEquation: lf,
    eitherStridesOrDilationsAreOne: Le,
    expandShapeToKeepDim: re,
    exponent: sx,
    exponents: nx,
    fromStringArrayToUint8: bx,
    fromUint8ToStringArray: ys,
    getAxesPermutation: qt,
    getBroadcastDims: Go,
    getComplexWithIndex: af,
    getEinsumComputePath: df,
    getEinsumPermutation: cf,
    getFusedBiasGradient: Dp,
    getFusedDyActivation: Wp,
    getImageCenter: Jp,
    getInnerMostAxes: ie,
    getPermuted: Ra,
    getRaggedRank: Q0,
    getReductionAxes: ce,
    getReshaped: Na,
    getReshapedPermuted: $a,
    getRowPartitionTypesHelper: Y0,
    getSliceBeginCoords: jp,
    getSliceSize: qp,
    getSparseFillEmptyRowsIndicesDenseShapeMismatch: ox,
    getSparseFillEmptyRowsNegativeIndexErrorMessage: rx,
    getSparseFillEmptyRowsOutOfRangeIndexErrorMessage: ix,
    getSparseReshapeEmptyTensorZeroOutputDimErrorMessage: cx,
    getSparseReshapeInputOutputMismatchErrorMessage: dx,
    getSparseReshapeInputOutputMultipleErrorMessage: ux,
    getSparseReshapeMultipleNegativeOneOutputDimErrorMessage: ax,
    getSparseReshapeNegativeOutputDimErrorMessage: lx,
    getSparseSegmentReductionIndicesOutOfRangeErrorMessage: fx,
    getSparseSegmentReductionNegativeSegmentIdsErrorMessage: Td,
    getSparseSegmentReductionNonIncreasingSegmentIdsErrorMessage: hx,
    getSparseSegmentReductionSegmentIdOutOfRangeErrorMessage: px,
    getUndoAxesPermutation: js,
    isIdentityPermutation: hf,
    log: qC,
    mergeRealAndImagArrays: xs,
    prepareAndValidate: eu,
    prepareSplitSize: pf,
    segment_util: G$,
    shouldFuse: Vp,
    slice_util: k$,
    splitRealAndImagArrays: j0,
    stridesOrDilationsArePositive: Ro,
    tupleValuesAreOne: No,
    upcastType: tn,
    validateDefaultValueShape: J0,
    validateInput: y0,
    validateUpdateShape: Lp,
    warn: ln
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ r$();
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const xx = {
    kernelName: Ul,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>G(n, Ta(tt(e, "float32"), -1))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const L$ = {
    kernelName: vi,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>{
                const s = Kt(tt(e, "float32")), o = Ve(it(gt(1), s));
                return Yt(ut(n, o));
            }
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const M$ = {
    kernelName: Si,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>{
                const s = Ve(it(Kt(tt(e, "float32")), 1));
                return ut(n, s);
            }
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const W$ = {
    kernelName: Sr,
    inputsToSave: [
        "a",
        "b"
    ],
    gradFunc: (n, t)=>{
        const [e, s] = t, o = bt(e.shape, s.shape);
        return {
            a: ()=>{
                let a = n;
                const l = ce(e.shape, o);
                return l.length > 0 && (a = at(a, l)), W(a, e.shape);
            },
            b: ()=>{
                let a = n;
                const l = ce(s.shape, o);
                return l.length > 0 && (a = at(a, l)), W(a, s.shape);
            }
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const D$ = {
    kernelName: qd,
    saveAllInputs: !0,
    gradFunc: (n, t)=>{
        const e = {};
        return t.forEach((s, o)=>{
            e[o] = ()=>n.clone();
        }), e;
    }
};
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const F$ = {
    kernelName: Yl,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>Tt(e)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const V$ = {
    kernelName: Ql,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>Tt(e)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const z$ = {
    kernelName: ki,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>ut(n, Ve(it(gt(1), Kt(tt(e, "float32")))))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const P$ = {
    kernelName: Ti,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>{
                const s = Ve(U(gt(1), Kt(tt(e, "float32"))));
                return ut(n, s);
            }
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const A$ = {
    kernelName: $i,
    inputsToSave: [
        "a",
        "b"
    ],
    gradFunc: (n, t)=>{
        const [e, s] = t, o = bt(e.shape, s.shape);
        return {
            a: ()=>{
                const a = U(Kt(e), Kt(s));
                let l = G(n, ut(s, a));
                const c = ce(e.shape, o);
                return c.length > 0 && (l = at(l, c)), W(l, e.shape);
            },
            b: ()=>{
                const a = U(Kt(e), Kt(s));
                let l = Yt(G(n, ut(e, a)));
                const c = ce(s.shape, o);
                return c.length > 0 && (l = at(l, c)), W(l, s.shape);
            }
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const O$ = {
    kernelName: Ni,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>ut(n, U(Kt(tt(e, "float32")), 1))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const X$ = {
    kernelName: Ri,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>ut(n, it(gt(1), Kt(tt(e, "float32"))))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function K$(n, t, e, s, o, r) {
    const i = T(n, "dy", "avgPool3dGrad"), a = T(t, "input", "avgPool3dGrad");
    let l = i, c = a, u = !1;
    a.rank === 4 && (u = !0, l = W(i, [
        1,
        i.shape[0],
        i.shape[1],
        i.shape[2],
        i.shape[3]
    ]), c = W(a, [
        1,
        a.shape[0],
        a.shape[1],
        a.shape[2],
        a.shape[3]
    ])), C(l.rank === 5, ()=>`Error in avgPool3dGrad: dy must be rank 5 but got rank ${l.rank}.`), C(c.rank === 5, ()=>`Error in avgPool3dGrad: input must be rank 5 but got rank ${c.rank}.`), Ue("avgPool3dGrad", o, r);
    const d = {
        dy: l,
        input: c
    }, h = {
        filterSize: e,
        strides: s,
        pad: o,
        dimRoundingMode: r
    }, p = $.runKernel(sh, d, h);
    return u ? W(p, [
        p.shape[1],
        p.shape[2],
        p.shape[3],
        p.shape[4]
    ]) : p;
}
const Z$ = /* @__PURE__ */ L({
    avgPool3dGrad_: K$
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const B$ = {
    kernelName: jl,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t, e)=>{
        const [s] = t, { filterSize: o, strides: r, pad: i, dimRoundingMode: a } = e;
        return {
            x: ()=>Z$(n, s, o, r, i, a)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function H$(n, t, e, s, o) {
    const r = T(n, "dy", "avgPoolGrad"), i = T(t, "input", "avgPoolGrad");
    C(i.rank === r.rank, ()=>`Rank of input (${i.rank}) does not match rank of dy (${r.rank})`);
    let a = i, l = r, c = !1;
    i.rank === 3 && (c = !0, a = W(i, [
        1,
        i.shape[0],
        i.shape[1],
        i.shape[2]
    ]), l = W(r, [
        1,
        r.shape[0],
        r.shape[1],
        r.shape[2]
    ])), C(l.rank === 4, ()=>`Error in avgPoolGrad: dy must be rank 4 but got rank ${l.rank}.`), C(a.rank === 4, ()=>`Error in avgPoolGrad: input must be rank 4 but got rank ${a.rank}.`);
    const u = {
        dy: l,
        input: a
    }, d = {
        filterSize: e,
        strides: s,
        pad: o
    }, h = $.runKernel(nh, u, d);
    return c ? W(h, [
        h.shape[1],
        h.shape[2],
        h.shape[3]
    ]) : h;
}
const _$ = /* @__PURE__ */ L({
    avgPoolGrad_: H$
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const U$ = {
    kernelName: Jl,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t, e)=>{
        const [s] = t, { filterSize: o, strides: r, pad: i } = e;
        return {
            x: ()=>_$(n, s, o, r, i)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Y$ = {
    kernelName: ql,
    inputsToSave: [
        "a",
        "b"
    ],
    gradFunc: (n, t, e)=>{
        const [s, o] = t, { transposeA: r, transposeB: i } = e;
        return !r && !i ? {
            a: ()=>Gt(n, o, !1, !0),
            b: ()=>Gt(s, n, !0, !1)
        } : !r && i ? {
            a: ()=>Gt(n, o, !1, !1),
            b: ()=>Gt(n, s, !0, !1)
        } : r && !i ? {
            a: ()=>Gt(o, n, !1, !0),
            b: ()=>Gt(s, n, !1, !1)
        } : {
            a: ()=>Gt(o, n, !0, !0),
            b: ()=>Gt(n, s, !0, !0)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Q$ = {
    kernelName: tc,
    gradFunc: (n, t, e)=>{
        const { blockShape: s, crops: o } = e;
        return {
            x: ()=>xp(n, s, o)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const J$ = {
    kernelName: JC,
    gradFunc: (n, t, e)=>{
        const s = e, o = s.inputShape, r = s.shape, i = Array.from(r);
        for(let l = o.length - 1; l >= 0; l--)if (o[l] === r[l]) i[l] = 1;
        else if (o[l] !== 1) throw new Error(`broadcastTo(): [${o}] cannot be broadcast to [${r}].`);
        const a = [];
        for(let l = 0; l < i.length; l++)i[l] > 1 && a.push(l);
        return {
            x: ()=>at(n, a, !0)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const j$ = {
    kernelName: Gi,
    gradFunc: (n)=>({
            x: ()=>n.clone()
        })
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const q$ = {
    kernelName: Ei,
    gradFunc: (n)=>({
            x: ()=>Tt(n)
        })
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const tG = {
    kernelName: Li,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t, e)=>{
        const [s] = t, { clipValueMin: o, clipValueMax: r } = e;
        return {
            x: ()=>Ee(ss(Bo(s, o), Tr(s, r)), n, Tt(n))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const eG = {
    kernelName: ec,
    inputsToSave: [
        "x"
    ],
    gradFunc: xx.gradFunc
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const nG = {
    kernelName: nc,
    saveAllInputs: !0,
    gradFunc: (n, t, e)=>{
        const s = t.map((l)=>l.shape), { axis: o } = e, r = Ct(o, t[0].shape)[0], i = s.map((l)=>l[r]);
        return pn(n, i, r).map((l)=>()=>l);
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const sG = {
    kernelName: sc,
    inputsToSave: [
        "x",
        "filter"
    ],
    gradFunc: (n, t, e)=>{
        const [s, o] = t, { dilations: r, strides: i, pad: a, dataFormat: l } = e;
        return C(No(r), ()=>`Error in gradient of conv2D: dilation rates greater than 1 are not yet supported in gradients. Got dilations '${r}'`), {
            x: ()=>rp(s.shape, n, o, i, a, l),
            filter: ()=>Mp(s, n, o.shape, i, a, l)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const oG = {
    kernelName: oc,
    inputsToSave: [
        "dy",
        "filter"
    ],
    gradFunc: (n, t, e)=>{
        const [s, o] = t, { strides: r, pad: i, dataFormat: a, dimRoundingMode: l } = e;
        return {
            dy: ()=>$o(n, o, r, i, a, 1, l),
            filter: ()=>Mp(n, s, o.shape, r, i, a, l)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function rG(n, t, e, s, o) {
    let r = n;
    n.rank === 4 && (r = W(n, [
        1,
        n.shape[0],
        n.shape[1],
        n.shape[2],
        n.shape[3]
    ]));
    let i = t;
    i.rank === 4 && (i = W(t, [
        1,
        t.shape[0],
        t.shape[1],
        t.shape[2],
        t.shape[3]
    ])), C(r.rank === 5, ()=>`Error in conv3dDerFilter: input must be rank 5, but got shape ${r.shape}.`), C(i.rank === 5, ()=>`Error in conv3dDerFilter: dy must be rank 5, but got shape ${i.shape}.`), C(e.length === 5, ()=>`Error in conv3dDerFilter: filterShape must be length 5, but got ${e}.`), C(r.shape[4] === e[3], ()=>`Error in conv3dDerFilter: depth of input ${r.shape[4]}) must match input depth in filter (${e[3]}.`), C(i.shape[4] === e[4], ()=>`Error in conv3dDerFilter: depth of dy (${i.shape[4]}) must match output depth for filter (${e[4]}).`);
    const a = {
        x: r,
        dy: i
    }, l = {
        strides: s,
        pad: o,
        filterShape: e
    };
    return $.runKernel(lh, a, l);
}
const iG = /* @__PURE__ */ L({
    conv3DBackpropFilter_: rG
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const aG = {
    kernelName: rc,
    inputsToSave: [
        "x",
        "filter"
    ],
    gradFunc: (n, t, e)=>{
        const { dilations: s, strides: o, pad: r } = e;
        C(No(s), ()=>`Error in gradient of conv3D: dilation rates greater than 1 are not yet supported in gradients. Got dilations '${s}'`);
        const [i, a] = t;
        return {
            x: ()=>qb(i.shape, n, a, o, r),
            filter: ()=>iG(i, n, a.shape, o, r)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const lG = {
    kernelName: Mi,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>G(Yt(f0(tt(e, "float32"))), n)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const cG = {
    kernelName: Wi,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>G(m0(tt(e, "float32")), n)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const uG = {
    kernelName: ic,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t, e)=>{
        const [s] = t, { axis: o, exclusive: r, reverse: i } = e;
        return {
            x: ()=>{
                const a = qt([
                    o
                ], s.rank);
                let l = e0(n, o, r, !i);
                return a != null && (l = kt(l, a)), l;
            }
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const dG = {
    kernelName: ac,
    inputsToSave: [
        "x",
        "filter"
    ],
    gradFunc: (n, t, e)=>{
        const { dilations: s, strides: o, pad: r, dimRoundingMode: i } = e, a = s ?? [
            1,
            1
        ];
        C(No(a), ()=>`Error in gradient of depthwiseConv2dNative: dilation rates greater than 1 are not yet supported. Got dilations '${a}'`);
        const [l, c] = t;
        return C(l.rank === 4, ()=>`Error in gradient of depthwiseConv2dNative: input must be rank 4, but got rank ${l.rank}.`), C(c.rank === 4, ()=>`Error in gradient of depthwiseConv2dNative: filter must be rank 4, but got rank ${c.rank}.`), C(l.shape[3] === c.shape[2], ()=>`Error in gradient of depthwiseConv2d: number of input channels (${l.shape[3]}) must match the inChannels dimension in filter ${c.shape[2]}.`), C(Le(o, a), ()=>`Error in gradient of depthwiseConv2d: Either strides or dilations must be  1. Got strides ${o} and dilations '${a}'.`), Ue("depthwiseConv2d", r, i), {
            x: ()=>kN(l.shape, n, c, o, r, a, i),
            filter: ()=>vN(l, n, c.shape, o, r, a, i)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const hG = {
    kernelName: lc,
    inputsToSave: [
        "x",
        "filter"
    ],
    gradFunc: (n, t, e)=>{
        const [s, o] = t, r = {
            x: s,
            filter: o,
            dy: n
        }, i = {
            x: s,
            filter: o,
            dy: n
        };
        return {
            x: ()=>$.runKernel(ad, r, e),
            filter: ()=>$.runKernel(ld, i, e)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const pG = {
    kernelName: Fi,
    outputsToSave: [
        !0
    ],
    gradFunc: (n, t)=>{
        const [e] = t, s = {
            dy: n,
            y: e
        };
        return {
            x: ()=>$.runKernel(xh, s)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const fG = {
    kernelName: Vi,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t, s = G(mn(Yt(Kt(e))), 2 / Math.sqrt(Math.PI));
        return {
            x: ()=>G(n, s)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const mG = {
    kernelName: zi,
    outputsToSave: [
        !0
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>G(n, e)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const gG = {
    kernelName: uc,
    inputsToSave: [
        "input"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            input: ()=>W(n, e.shape)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const bG = {
    kernelName: Pi,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>G(n, mn(e))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const xG = {
    kernelName: Ai,
    gradFunc: (n)=>({
            x: ()=>Tt(n)
        })
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const yG = {
    kernelName: Oi,
    inputsToSave: [
        "a",
        "b"
    ],
    gradFunc: (n, t)=>{
        const [e, s] = t, o = bt(e.shape, s.shape);
        return {
            a: ()=>{
                const a = ut(n, tt(s, "float32")), l = ce(e.shape, o);
                return l.length > 0 ? W(at(a, l), e.shape) : a;
            },
            b: ()=>{
                let a = G(n, tt(e, "float32"));
                const l = ce(s.shape, o);
                l.length > 0 && (a = W(at(a, l), s.shape));
                const c = Kt(s);
                return Yt(ut(a, tt(c, "float32")));
            }
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const wG = {
    kernelName: dc,
    inputsToSave: [
        "x",
        "mean",
        "variance",
        "scale"
    ],
    gradFunc: (n, t, e)=>{
        const { varianceEpsilon: s } = e, [o, r, i, a] = t, l = a ?? gt(1), c = ce(r.shape, o.shape), u = [];
        if (r.rank === 1) {
            for(let y = 0; y < o.shape.length - 1; ++y)u.push(o.shape[y]);
            u.push(1);
        }
        const d = it(o, r), h = G(n, l), p = d0(U(i, gt(s))), f = G(G(G(p, p), p), gt(-0.5));
        return {
            x: ()=>r.rank === 1 ? W(G(G(n, Vn(W(p, [
                    1,
                    1,
                    1,
                    r.shape[0]
                ]), u)), l), o.shape) : W(G(G(n, p), l), o.shape),
            mean: ()=>{
                let y = G(G(p, gt(-1)), h);
                return r.rank === 1 && (y = at(y, c)), W(y, r.shape);
            },
            variance: ()=>{
                let y = G(G(f, d), h);
                return r.rank === 1 && (y = at(y, c)), W(y, r.shape);
            },
            scale: ()=>{
                const y = G(d, p);
                let I = G(n, y);
                return r.rank === 1 && (I = at(I, c)), W(I, r.shape);
            },
            offset: ()=>{
                let y = n;
                return r.rank === 1 && (y = at(y, c)), W(y, r.shape);
            }
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const IG = {
    kernelName: hc,
    inputsToSave: [
        "x",
        "indices"
    ],
    gradFunc: (n, t, e)=>{
        const [s, o] = t, { axis: r, batchDims: i } = e, a = Ct(r, s.shape)[0], l = (c, u, d)=>()=>{
                const h = c.shape, p = u.size, f = h.slice(0, a), m = f.length, g = h.slice(r, h.length).slice(1), b = g.length, x = Fm(0, m), w = Fm(m + 1, m + 1 + b), y = Vm([
                    f,
                    [
                        p
                    ],
                    g
                ]), I = W(d, y), v = W(u, [
                    p
                ]), k = Vm([
                    [
                        m
                    ],
                    x,
                    w
                ]), S = kt(I, k);
                let N = I0(S, v, c.shape[a]);
                const R = js(k);
                return N = kt(N, R), N;
            };
        if (i === 1) {
            const c = s.shape[0], u = s.split(c, 0);
            return {
                x: ()=>Xn(u.map((p, f)=>l(p, o.slice(f, 1), n.slice(f, 1))())).reshape(s.shape),
                indices: ()=>o
            };
        } else return {
            x: l(s, o, n),
            indices: ()=>o
        };
    }
};
function Fm(n, t) {
    const e = [];
    for(let s = n; s < t; ++s)e.push(s);
    return e;
}
function Vm(n) {
    const t = [];
    for(let e = 0; e < n.length; ++e)for(let s = 0; s < n[e].length; ++s)t.push(n[e][s]);
    return t;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const CG = {
    kernelName: Xi,
    inputsToSave: [
        "a",
        "b"
    ],
    gradFunc: (n, t)=>{
        const [e, s] = t;
        return {
            a: ()=>Tt(e),
            b: ()=>Tt(s)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const vG = {
    kernelName: Ki,
    gradFunc: (n)=>({
            x: ()=>tt(n, "float32")
        })
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const SG = {
    kernelName: Zi,
    gradFunc: (n)=>({
            x: ()=>Tt(n)
        })
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const kG = {
    kernelName: Bi,
    gradFunc: (n)=>({
            x: ()=>Tt(n)
        })
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const TG = {
    kernelName: Hi,
    gradFunc: (n)=>({
            x: ()=>Tt(n)
        })
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const NG = {
    kernelName: fc,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t, e)=>{
        const [s] = t, { alpha: o } = e, r = rn(s, 0);
        return {
            x: ()=>Ee(r, n, G(n, o))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const RG = {
    kernelName: Ui,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>ut(n, U(e, 1))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $G = {
    kernelName: _i,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>ut(n, tt(e, "float32"))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const GG = {
    kernelName: jC,
    inputsToSave: [],
    outputsToSave: [
        !0
    ],
    gradFunc: (n, t, e)=>{
        const [s] = t, { axis: o } = e;
        return {
            logits: ()=>{
                const i = mn(s);
                return it(n, G(at(n, o, !0), i));
            }
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function EG(n, t, e, s = 5, o = 1, r = 1, i = 0.5) {
    const a = {
        x: n,
        y: t,
        dy: e
    }, l = {
        depthRadius: s,
        bias: o,
        alpha: r,
        beta: i
    };
    return $.runKernel(Sh, a, l);
}
const LG = L({
    localResponseNormalizationBackprop_: EG
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const MG = {
    kernelName: wc,
    inputsToSave: [
        "x"
    ],
    outputsToSave: [
        !0
    ],
    gradFunc: (n, t, e)=>{
        const [s, o] = t, { depthRadius: r, bias: i, alpha: a, beta: l } = e;
        return {
            x: ()=>LG(s, o, n, r, i, a, l)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function yx(n, t, e, s) {
    return t.rank < e.rank && (t = W(t, re(t.shape, s))), n.rank < e.rank && (n = W(n, re(n.shape, s))), {
        x: ()=>G(n, tt(Tn(e, t), n.dtype))
    };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const zm = {
    kernelName: Ic,
    inputsToSave: [
        "x"
    ],
    outputsToSave: [
        !0
    ],
    gradFunc: (n, t, e)=>{
        const s = e, { reductionIndices: o } = s, r = t[0], i = t[1], a = Ct(o, r.shape), l = yx(n, i, r, a);
        return {
            x: ()=>l.x()
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const WG = {
    kernelName: Yi,
    inputsToSave: [
        "a",
        "b"
    ],
    gradFunc: (n, t)=>{
        const [e, s] = t;
        return {
            a: ()=>G(n, tt(Bo(e, s), "float32")),
            b: ()=>G(n, tt(Cl(e, s), "float32"))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function DG(n, t, e, s, o, r, i) {
    const a = T(n, "dy", "maxPool3dGrad"), l = T(t, "input", "maxPool3dGrad"), c = T(e, "output", "maxPool3dGrad");
    let u = a, d = l, h = c, p = !1;
    l.rank === 4 && (p = !0, u = W(a, [
        1,
        a.shape[0],
        a.shape[1],
        a.shape[2],
        a.shape[3]
    ]), d = W(l, [
        1,
        l.shape[0],
        l.shape[1],
        l.shape[2],
        l.shape[3]
    ]), h = W(c, [
        1,
        c.shape[0],
        c.shape[1],
        c.shape[2],
        c.shape[3]
    ])), C(u.rank === 5, ()=>`Error in maxPool3dGrad: dy must be rank 5 but got rank ${u.rank}.`), C(d.rank === 5, ()=>`Error in maxPool3dGrad: input must be rank 5 but got rank ${d.rank}.`), C(h.rank === 5, ()=>`Error in maxPool3dGrad: output must be rank 5 but got rank ${h.rank}.`), Ue("maxPool3dGrad", r, i);
    const f = {
        dy: u,
        input: d,
        output: h
    }, m = {
        filterSize: s,
        strides: o,
        pad: r,
        dimRoundingMode: i
    }, g = $.runKernel(Th, f, m);
    return p ? W(g, [
        g.shape[1],
        g.shape[2],
        g.shape[3],
        g.shape[4]
    ]) : g;
}
const FG = /* @__PURE__ */ L({
    maxPool3dGrad_: DG
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const VG = {
    kernelName: vc,
    inputsToSave: [
        "x"
    ],
    outputsToSave: [
        !0
    ],
    gradFunc: (n, t, e)=>{
        const [s, o] = t, { filterSize: r, strides: i, pad: a, dimRoundingMode: l } = e;
        return {
            x: ()=>FG(n, s, o, r, i, a, l)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function zG(n, t, e, s, o, r, i) {
    const a = T(n, "dy", "maxPoolGrad"), l = T(t, "input", "maxPoolGrad"), c = T(e, "output", "maxPoolGrad");
    C(l.rank === a.rank, ()=>`Rank of input (${l.rank}) does not match rank of dy (${a.rank})`), C(a.rank === 4, ()=>`Error in maxPoolGrad: dy must be rank 4 but got rank ${a.rank}.`), C(l.rank === 4, ()=>`Error in maxPoolGrad: input must be rank 4 but got rank ${l.rank}.`), Ue("maxPoolGrad", r, i);
    const u = {
        dy: a,
        input: l,
        output: c
    }, d = {
        filterSize: s,
        strides: o,
        pad: r,
        dimRoundingMode: i
    };
    return $.runKernel(kh, u, d);
}
const PG = /* @__PURE__ */ L({
    maxPoolGrad_: zG
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const AG = {
    kernelName: Cc,
    inputsToSave: [
        "x"
    ],
    outputsToSave: [
        !0
    ],
    gradFunc: (n, t, e)=>{
        const [s, o] = t, { filterSize: r, strides: i, pad: a } = e;
        return {
            x: ()=>PG(n, s, o, r, i, a)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const OG = {
    kernelName: Sc,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t, e)=>{
        const [s] = t, { axis: o } = e, r = Ct(o, s.shape), a = ye(s.shape, r)[1], l = X(a);
        return {
            x: ()=>{
                const u = s.shape.slice();
                r.forEach((p)=>{
                    u[p] = 1;
                });
                const d = W(n, u);
                return ut(G(d, ks(s.shape, "float32")), l);
            }
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const XG = {
    kernelName: kc,
    inputsToSave: [
        "x"
    ],
    outputsToSave: [
        !0
    ],
    gradFunc: (n, t, e)=>{
        const s = e, { axis: o } = s, [r, i] = t, a = Ct(o, r.shape), l = yx(n, i, r, a);
        return {
            x: ()=>l.x()
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const KG = {
    kernelName: Qi,
    inputsToSave: [
        "a",
        "b"
    ],
    gradFunc: (n, t)=>{
        const [e, s] = t;
        return {
            a: ()=>G(n, tt(Tr(e, s), "float32")),
            b: ()=>G(n, tt(rn(e, s), "float32"))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const ZG = {
    kernelName: Tc,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t, e)=>{
        const s = t[0], { paddings: o } = e, r = o.map((i)=>i[0]);
        return {
            x: ()=>Ft(n, r, s.shape)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const BG = {
    kernelName: Ji,
    inputsToSave: [
        "a",
        "b"
    ],
    gradFunc: (n, t)=>{
        const [e, s] = t, o = bt(e.shape, s.shape);
        return {
            a: ()=>{
                const a = ce(e.shape, o);
                return a.length > 0 ? W(at(n, a), e.shape) : n;
            },
            b: ()=>{
                const a = G(n, Yt(qc(ut(e, s)))), l = ce(s.shape, o);
                return l.length > 0 ? W(at(a, l), s.shape) : a;
            }
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const HG = {
    kernelName: ji,
    inputsToSave: [
        "a",
        "b"
    ],
    gradFunc: (n, t)=>{
        const [e, s] = t, o = bt(e.shape, s.shape);
        return {
            a: ()=>{
                const a = G(n, tt(s, "float32")), l = ce(e.shape, o);
                return l.length > 0 ? W(at(a, l), e.shape) : a;
            },
            b: ()=>{
                const a = G(n, tt(e, "float32")), l = ce(s.shape, o);
                return l.length > 0 ? W(at(a, l), s.shape) : a;
            }
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const _G = {
    kernelName: Nc,
    gradFunc: (n)=>({
            x: ()=>Yt(n)
        })
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const UG = {
    kernelName: Gc,
    inputsToSave: [
        "indices"
    ],
    gradFunc: (n, t)=>{
        const e = t[0];
        return {
            indices: ()=>be(e.shape, "float32")
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const YG = {
    kernelName: $c,
    gradFunc: (n)=>({
            x: ()=>Tt(n)
        })
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const QG = {
    kernelName: Ec,
    saveAllInputs: !0,
    gradFunc: (n, t, e)=>{
        const { axis: s } = e;
        return Mo(n, s).map((r)=>()=>r);
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Pm = {
    kernelName: Lc,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t, e)=>{
        const s = t[0], { paddings: o } = e, r = o.map((i)=>i[0]);
        return {
            x: ()=>Ft(n, r, s.shape)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const JG = {
    kernelName: qi,
    inputsToSave: [
        "a",
        "b"
    ],
    outputsToSave: [
        !0
    ],
    gradFunc: (n, t)=>{
        const [e, s, o] = t, r = e, i = s, a = bt(r.shape, i.shape);
        return {
            a: ()=>{
                const u = tt(i, "float32");
                let d = G(n, G(u, gr(r, it(u, gt(1)))));
                const h = ce(r.shape, a);
                return h.length > 0 && (d = at(d, h)), W(d, r.shape);
            },
            b: ()=>{
                const u = rn(r, 0), d = Ee(u, Nn(r), Tt(r));
                let h = G(n, G(o, d));
                const p = ce(i.shape, a);
                return p.length > 0 && (h = at(h, p)), W(h, i.shape);
            }
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const jG = {
    kernelName: Mc,
    inputsToSave: [
        "x",
        "alpha"
    ],
    gradFunc: (n, t)=>{
        const [e, s] = t, o = rn(e, 0);
        return {
            x: ()=>Ee(o, n, G(n, s)),
            alpha: ()=>{
                let r = Ee(o, Tt(n), G(n, e));
                const i = ce(s.shape, n.shape);
                return i.length > 0 && (r = at(r, i)), W(r, s.shape);
            }
        };
    }
};
/**
 * @license
 * Copyright 2022 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function qG(n, t, e) {
    const s = n.shape.slice();
    s[e] = 1;
    const o = W(t, s), r = vd(n, e, !0, !1), i = vd(n, e, !0, !0), a = G(r, i);
    return G(o, a);
}
function tE(n, t, e) {
    const s = n.shape.length, o = s - e.length, r = qt(e, s);
    let i = n;
    r != null && (i = kt(n, r));
    const a = i.shape.slice(), c = a.splice(s - e.length, e.length).reduce((h, p)=>h * p, 1);
    a.push(c);
    const u = i.reshape(a);
    let d = qG(u, t, o);
    if (d = d.reshape(i.shape), r != null) {
        const h = js(r);
        d = kt(d, h);
    }
    return d;
}
const eE = {
    kernelName: Wc,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t, e)=>{
        const [s] = t, { axis: o } = e;
        let r = [];
        return o == null ? r = s.shape.map((i, a)=>a) : typeof o == "number" ? r = [
            o
        ] : r = o, {
            x: ()=>tE(s, n, r)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const nE = {
    kernelName: Di,
    inputsToSave: [
        "a",
        "b"
    ],
    gradFunc: (n, t)=>{
        const [e, s] = t, o = bt(e.shape, s.shape);
        return {
            a: ()=>{
                const a = ut(n, tt(s, "float32")), l = ce(e.shape, o);
                return l.length > 0 ? W(at(a, l), e.shape) : a;
            },
            b: ()=>{
                let a = G(n, tt(e, "float32"));
                const l = ce(s.shape, o);
                l.length > 0 && (a = W(at(a, l), s.shape));
                const c = Kt(s);
                return Yt(ut(a, tt(c, "float32")));
            }
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const sE = {
    kernelName: ta,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>ut(n, Yt(Kt(e)))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const oE = {
    kernelName: na,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t, s = G(Tr(e, 6), Ta(e));
        return {
            x: ()=>G(n, tt(s, "float32"))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const rE = {
    kernelName: ea,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>G(n, tt(Ta(e), "float32"))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const iE = {
    kernelName: Dc,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>W(n, e.shape)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const aE = {
    kernelName: Vc,
    inputsToSave: [
        "images"
    ],
    gradFunc: (n, t, e)=>{
        const [s] = t, o = {
            dy: n,
            images: s
        };
        return {
            images: ()=>// tslint:disable-next-line: no-unnecessary-type-assertion
                $.runKernel(Mh, o, e)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const lE = {
    kernelName: Fc,
    inputsToSave: [
        "images"
    ],
    gradFunc: (n, t, e)=>{
        const [s] = t, o = {
            dy: n,
            images: s
        };
        return {
            images: ()=>// tslint:disable-next-line: no-unnecessary-type-assertion
                $.runKernel(Lh, o, e)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const cE = {
    kernelName: zc,
    gradFunc: (n, t, e)=>{
        const { dims: s } = e, o = Ct(s, n.shape);
        return {
            x: ()=>Lo(n, o)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const uE = {
    kernelName: sa,
    gradFunc: (n)=>({
            x: ()=>Tt(n)
        })
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const dE = {
    kernelName: oa,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>Yt(ut(n, G(gr(e, 1.5), 2)))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const hE = {
    kernelName: Pc,
    inputsToSave: [
        "condition"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            // TODO(julianoks): Return null for condition gradient
            // when backprop supports it.
            condition: ()=>tt(Tt(e), "float32"),
            t: ()=>G(n, tt(e, n.dtype)),
            e: ()=>G(n, tt(fp(e), n.dtype))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const pE = {
    kernelName: ra,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>{
                const s = rn(e, gt(0)), o = gt(ru), r = gt(iu), i = G(n, r), a = G(G(n, o), mn(tt(e, "float32")));
                return Ee(s, i, a);
            }
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const fE = {
    kernelName: ca,
    outputsToSave: [
        !0
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>G(n, G(e, it(gt(1), e)))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const mE = {
    kernelName: la,
    gradFunc: (n)=>({
            x: ()=>Tt(n)
        })
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const gE = {
    kernelName: ia,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>G(ip(tt(e, "float32")), n)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const bE = {
    kernelName: aa,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>G(t0(tt(e, "float32")), n)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const xE = {
    kernelName: Ac,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t, e)=>{
        const [s] = t, { begin: o, size: r } = e, i = s.shape, [a, l] = nu(s, o, r), c = [];
        for(let u = 0; u < n.rank; u++)c.push([
            a[u],
            i[u] - a[u] - l[u]
        ]);
        return {
            x: ()=>bp(n, c)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const yE = {
    kernelName: Zc,
    outputsToSave: [
        !0
    ],
    gradFunc: (n, t, e)=>{
        const [s] = t, { dim: o } = e, r = !0, i = G(n, s);
        return {
            logits: ()=>it(i, G(at(i, [
                    o
                ], r), s))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const wE = {
    kernelName: ua,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>G(n, kr(e))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Am = {
    kernelName: Xc,
    gradFunc: (n, t, e)=>{
        const { blockShape: s, paddings: o } = e;
        return {
            x: ()=>op(n, s, o)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Om = {
    kernelName: Kc,
    gradFunc: (n, t, e)=>{
        const { axis: s } = e;
        return {
            x: ()=>Ge(n, s)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const IE = {
    kernelName: da,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>ut(n, G(Ve(tt(e, "float32")), 2))
        };
    }
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const CE = {
    kernelName: zh,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>G(n, G(tt(e, "float32"), 2))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const vE = {
    kernelName: ha,
    inputsToSave: [
        "a",
        "b"
    ],
    gradFunc: (n, t)=>{
        const [e, s] = t, o = gt(2);
        return {
            a: ()=>G(n, G(o, it(e, s))),
            b: ()=>G(n, G(o, it(s, e)))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const SE = {
    kernelName: ba,
    gradFunc: (n)=>({
            x: ()=>Tt(n)
        })
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const kE = {
    kernelName: pa,
    inputsToSave: [
        "a",
        "b"
    ],
    gradFunc: (n, t)=>{
        const [e, s] = t, o = bt(e.shape, s.shape);
        return {
            a: ()=>{
                let a = n;
                const l = ce(e.shape, o);
                return l.length > 0 && (a = at(a, l)), W(a, e.shape);
            },
            b: ()=>{
                let a = n;
                const l = ce(s.shape, o);
                return l.length > 0 && (a = at(a, l)), W(Yt(a), s.shape);
            }
        };
    }
};
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const TE = {
    kernelName: Oc,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t, e)=>{
        const [s] = t, o = s.shape.slice(), { axis: r } = e;
        Ct(r, s.shape).forEach((c)=>{
            o[c] = 1;
        });
        const a = W(n, o), l = G(a, ks(s.shape, "float32"));
        return {
            x: ()=>l
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const NE = {
    kernelName: fa,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>ut(n, Kt(ip(e)))
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const RE = {
    kernelName: ma,
    outputsToSave: [
        !0
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>G(it(gt(1), Kt(e)), n)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $E = {
    kernelName: ga,
    inputsToSave: [
        "x"
    ],
    gradFunc: (n, t, e)=>{
        const [s] = t, { reps: o } = e;
        return {
            x: ()=>{
                let i = Tt(s);
                if (s.rank === 1) for(let a = 0; a < o[0]; ++a)i = U(i, Ft(n, [
                    a * s.shape[0]
                ], [
                    s.shape[0]
                ]));
                else if (s.rank === 2) for(let a = 0; a < o[0]; ++a)for(let l = 0; l < o[1]; ++l)i = U(i, Ft(n, [
                    a * s.shape[0],
                    l * s.shape[1]
                ], [
                    s.shape[0],
                    s.shape[1]
                ]));
                else if (s.rank === 3) for(let a = 0; a < o[0]; ++a)for(let l = 0; l < o[1]; ++l)for(let c = 0; c < o[2]; ++c)i = U(i, Ft(n, [
                    a * s.shape[0],
                    l * s.shape[1],
                    c * s.shape[2]
                ], [
                    s.shape[0],
                    s.shape[1],
                    s.shape[2]
                ]));
                else if (s.rank === 4) for(let a = 0; a < o[0]; ++a)for(let l = 0; l < o[1]; ++l)for(let c = 0; c < o[2]; ++c)for(let u = 0; u < o[3]; ++u)i = U(i, Ft(n, [
                    a * s.shape[0],
                    l * s.shape[1],
                    c * s.shape[2],
                    u * s.shape[3]
                ], [
                    s.shape[0],
                    s.shape[1],
                    s.shape[2],
                    s.shape[3]
                ]));
                else throw new Error(`Gradient for tile operation is not implemented for rank-${s.rank} tensors yet.`);
                return i;
            }
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const GE = {
    kernelName: ar,
    gradFunc: (n, t, e)=>{
        const s = e, { perm: o } = s, r = js(o);
        return {
            x: ()=>kt(n, r)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const EE = {
    kernelName: Hc,
    gradFunc: (n, t, e)=>{
        const s = e, { axis: o } = s;
        return {
            value: ()=>Xn(n, o)
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const LE = {
    kernelName: _c,
    inputsToSave: [
        "segmentIds"
    ],
    gradFunc: (n, t)=>{
        const [e] = t;
        return {
            x: ()=>ME(n, e)
        };
    }
};
function ME(n, t) {
    const e = qs(t, Tt(t)), s = cp(n, e);
    let o = Bo(t, gt(0, "int32"));
    const r = s.rank - o.rank;
    for(let a = 0; a < r; ++a)o = Oe(o, a + 1);
    o = ss(o, ks(s.shape, "bool"));
    const i = Tt(s);
    return Ee(o, s, i);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const WE = {
    kernelName: Uc,
    gradFunc: (n)=>({
            x: ()=>Tt(n)
        })
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const DE = [
    xx,
    L$,
    M$,
    W$,
    D$,
    F$,
    V$,
    z$,
    P$,
    A$,
    O$,
    X$,
    B$,
    U$,
    Y$,
    Q$,
    J$,
    j$,
    q$,
    tG,
    eG,
    nG,
    oG,
    sG,
    aG,
    lG,
    cG,
    uG,
    dG,
    hG,
    nE,
    pG,
    fG,
    mG,
    gG,
    bG,
    yG,
    xG,
    wG,
    IG,
    CG,
    vG,
    SG,
    kG,
    TG,
    NG,
    RG,
    $G,
    GG,
    MG,
    zm,
    zm,
    WG,
    VG,
    AG,
    OG,
    XG,
    KG,
    ZG,
    BG,
    HG,
    _G,
    UG,
    YG,
    QG,
    Pm,
    Pm,
    JG,
    jG,
    eE,
    sE,
    oE,
    rE,
    iE,
    aE,
    lE,
    cE,
    uE,
    dE,
    hE,
    pE,
    fE,
    mE,
    gE,
    bE,
    xE,
    yE,
    wE,
    Am,
    Am,
    Om,
    Om,
    IE,
    vE,
    CE,
    SE,
    kE,
    TE,
    NE,
    RE,
    $E,
    GE,
    EE,
    LE,
    WE
];
for (const n of DE)t2(n);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.abs = function() {
    return this.throwIfDisposed(), me(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.acos = function() {
    return this.throwIfDisposed(), gv(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.acosh = function() {
    return this.throwIfDisposed(), xv(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.add = function(n) {
    return this.throwIfDisposed(), U(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.all = function(n, t) {
    return this.throwIfDisposed(), Qb(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.any = function(n, t) {
    return this.throwIfDisposed(), Id(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.argMax = function(n) {
    return this.throwIfDisposed(), ai(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.argMin = function(n) {
    return this.throwIfDisposed(), vv(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.asScalar = function() {
    return this.throwIfDisposed(), C(this.size === 1, ()=>"The array must have only 1 element."), W(this, []);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.asType = function(n) {
    return this.throwIfDisposed(), tt(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.as1D = function() {
    return this.throwIfDisposed(), W(this, [
        this.size
    ]);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.as2D = function(n, t) {
    return this.throwIfDisposed(), W(this, [
        n,
        t
    ]);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.as3D = function(n, t, e) {
    return this.throwIfDisposed(), W(this, [
        n,
        t,
        e
    ]);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.as4D = function(n, t, e, s) {
    return this.throwIfDisposed(), W(this, [
        n,
        t,
        e,
        s
    ]);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.as5D = function(n, t, e, s, o) {
    return this.throwIfDisposed(), W(this, [
        n,
        t,
        e,
        s,
        o
    ]);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.asin = function() {
    return this.throwIfDisposed(), kv(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.asinh = function() {
    return this.throwIfDisposed(), Nv(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.atan = function() {
    return this.throwIfDisposed(), $v(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.atan2 = function(n) {
    return this.throwIfDisposed(), Ev(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.atanh = function() {
    return this.throwIfDisposed(), Mv(this);
};
K().prototype.avgPool = function(n, t, e, s) {
    return this.throwIfDisposed(), np(this, n, t, e, s);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.batchToSpaceND = function(n, t) {
    return this.throwIfDisposed(), op(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.batchNorm = function(n, t, e, s, o) {
    return this.throwIfDisposed(), Qc(this, n, t, e, s, o);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.broadcastTo = function(n) {
    return this.throwIfDisposed(), ni(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.cast = function(n) {
    return this.throwIfDisposed(), tt(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.ceil = function() {
    return this.throwIfDisposed(), iS(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.clipByValue = function(n, t) {
    return this.throwIfDisposed(), fn(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.concat = function(n, t) {
    return this.throwIfDisposed(), n instanceof Mt && (n = [
        n
    ]), Ge([
        this,
        ...n
    ], t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.conv1d = function(n, t, e, s, o, r) {
    return this.throwIfDisposed(), Jb(this, n, t, e, s, o, r);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.conv2dTranspose = function(n, t, e, s, o) {
    return this.throwIfDisposed(), jb(this, n, t, e, s, o);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.conv2d = function(n, t, e, s, o, r) {
    return this.throwIfDisposed(), $o(this, n, t, e, s, o, r);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.cos = function() {
    return this.throwIfDisposed(), ip(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.cosh = function() {
    return this.throwIfDisposed(), t0(this);
};
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.cumprod = function(n, t, e) {
    return this.throwIfDisposed(), vd(this, n, t, e);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.cumsum = function(n, t, e) {
    return this.throwIfDisposed(), e0(this, n, t, e);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.depthToSpace = function(n, t) {
    return this.throwIfDisposed(), ES(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.depthwiseConv2d = function(n, t, e, s, o, r) {
    return this.throwIfDisposed(), ap(this, n, t, e, s, o, r);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.dilation2d = function(n, t, e, s, o) {
    return this.throwIfDisposed(), WS(this, n, t, e, s, o);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.divNoNan = function(n) {
    return this.throwIfDisposed(), PS(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.div = function(n) {
    return this.throwIfDisposed(), ut(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.dot = function(n) {
    return this.throwIfDisposed(), OS(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.elu = function() {
    return this.throwIfDisposed(), Jc(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.equal = function(n) {
    return this.throwIfDisposed(), Tn(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.erf = function() {
    return this.throwIfDisposed(), BS(this);
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.euclideanNorm = function(n, t) {
    return this.throwIfDisposed(), tk(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.exp = function() {
    return this.throwIfDisposed(), mn(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.expandDims = function(n) {
    return this.throwIfDisposed(), Oe(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.expm1 = function() {
    return this.throwIfDisposed(), ok(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.fft = function() {
    return this.throwIfDisposed(), Gp(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.flatten = function() {
    return this.throwIfDisposed(), W(this, [
        this.size
    ]);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.floor = function() {
    return this.throwIfDisposed(), qc(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.floorDiv = function(n) {
    return this.throwIfDisposed(), Yb(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.gather = function(n, t, e) {
    return this.throwIfDisposed(), cp(this, n, t, e);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.greaterEqual = function(n) {
    return this.throwIfDisposed(), Bo(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.greater = function(n) {
    return this.throwIfDisposed(), rn(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.ifft = function() {
    return this.throwIfDisposed(), kl(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.irfft = function() {
    return this.throwIfDisposed(), b0(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.isFinite = function() {
    return this.throwIfDisposed(), pk(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.isInf = function() {
    return this.throwIfDisposed(), mk(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.isNaN = function() {
    return this.throwIfDisposed(), bk(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.leakyRelu = function(n) {
    return this.throwIfDisposed(), dp(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.lessEqual = function(n) {
    return this.throwIfDisposed(), Tr(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.less = function(n) {
    return this.throwIfDisposed(), Cl(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.localResponseNormalization = function(n, t, e, s) {
    return this.throwIfDisposed(), Ck(this, n, t, e, s);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.logSigmoid = function() {
    return this.throwIfDisposed(), $k(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.logSoftmax = function(n) {
    return this.throwIfDisposed(), r0(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.logSumExp = function(n, t) {
    return this.throwIfDisposed(), pp(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.log = function() {
    return this.throwIfDisposed(), Nn(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.log1p = function() {
    return this.throwIfDisposed(), hp(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.logicalAnd = function(n) {
    return this.throwIfDisposed(), ss(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.logicalNot = function() {
    return this.throwIfDisposed(), fp(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.logicalOr = function(n) {
    return this.throwIfDisposed(), i0(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.logicalXor = function(n) {
    return this.throwIfDisposed(), Vk(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.matMul = function(n, t, e) {
    return this.throwIfDisposed(), Gt(this, n, t, e);
};
K().prototype.maxPool = function(n, t, e, s) {
    return this.throwIfDisposed(), mp(this, n, t, e, s);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.max = function(n, t) {
    return this.throwIfDisposed(), Pn(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.maximum = function(n) {
    return this.throwIfDisposed(), qs(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.mean = function(n, t) {
    return this.throwIfDisposed(), oe(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.min = function(n, t) {
    return this.throwIfDisposed(), Il(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.minimum = function(n) {
    return this.throwIfDisposed(), br(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.mirrorPad = function(n, t) {
    return this.throwIfDisposed(), Bk(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.mod = function(n) {
    return this.throwIfDisposed(), _k(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.mul = function(n) {
    return this.throwIfDisposed(), G(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.neg = function() {
    return this.throwIfDisposed(), Yt(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.norm = function(n, t, e) {
    return this.throwIfDisposed(), jc(this, n, t, e);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.notEqual = function(n) {
    return this.throwIfDisposed(), ui(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.oneHot = function(n, t = 1, e = 0) {
    return this.throwIfDisposed(), a0(this, n, t, e);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.onesLike = function() {
    return this.throwIfDisposed(), Rn(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.pad = function(n, t) {
    return this.throwIfDisposed(), bp(this, n, t);
};
K().prototype.pool = function(n, t, e, s, o, r) {
    return this.throwIfDisposed(), sT(this, n, t, e, s, o, r);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.pow = function(n) {
    return this.throwIfDisposed(), gr(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.prelu = function(n) {
    return this.throwIfDisposed(), yp(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.prod = function(n, t) {
    return this.throwIfDisposed(), iT(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.reciprocal = function() {
    return this.throwIfDisposed(), $T(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.relu = function() {
    return this.throwIfDisposed(), Ts(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.relu6 = function() {
    return this.throwIfDisposed(), c0(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.reshapeAs = function(n) {
    return this.throwIfDisposed(), W(this, n.shape);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.reshape = function(n) {
    return this.throwIfDisposed(), W(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.resizeBilinear = function(n, t, e) {
    return this.throwIfDisposed(), T0(this, n, t, e);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.resizeNearestNeighbor = function(n, t, e) {
    return this.throwIfDisposed(), N0(this, n, t, e);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.reverse = function(n) {
    return this.throwIfDisposed(), Lo(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.rfft = function() {
    return this.throwIfDisposed(), Ep(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.round = function() {
    return this.throwIfDisposed(), u0(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.rsqrt = function() {
    return this.throwIfDisposed(), d0(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.selu = function() {
    return this.throwIfDisposed(), h0(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.separableConv2d = function(n, t, e, s, o, r) {
    return this.throwIfDisposed(), p0(this, n, t, e, s, o, r);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.sigmoid = function() {
    return this.throwIfDisposed(), kr(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.sign = function() {
    return this.throwIfDisposed(), zT(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.sin = function() {
    return this.throwIfDisposed(), f0(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.sinh = function() {
    return this.throwIfDisposed(), m0(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.slice = function(n, t) {
    return this.throwIfDisposed(), Ft(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.softmax = function(n) {
    return this.throwIfDisposed(), $p(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.softplus = function() {
    return this.throwIfDisposed(), va(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.spaceToBatchND = function(n, t) {
    return this.throwIfDisposed(), xp(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.split = function(n, t) {
    return this.throwIfDisposed(), pn(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.sqrt = function() {
    return this.throwIfDisposed(), Ve(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.square = function() {
    return this.throwIfDisposed(), Kt(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.squaredDifference = function(n) {
    return this.throwIfDisposed(), x0(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.squeeze = function(n) {
    return this.throwIfDisposed(), ka(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.stack = function(n, t) {
    this.throwIfDisposed();
    const e = n instanceof Mt ? [
        this,
        n
    ] : [
        this,
        ...n
    ];
    return Xn(e, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.step = function(n) {
    return this.throwIfDisposed(), Ta(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.stridedSlice = function(n, t, e, s, o, r, i, a) {
    return this.throwIfDisposed(), nN(this, n, t, e, s, o, r, i, a);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.sub = function(n) {
    return this.throwIfDisposed(), it(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.sum = function(n, t) {
    return this.throwIfDisposed(), at(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.tan = function() {
    return this.throwIfDisposed(), oN(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.tanh = function() {
    return this.throwIfDisposed(), sp(this);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.tile = function(n) {
    return this.throwIfDisposed(), Vn(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.toBool = function() {
    return this.throwIfDisposed(), tt(this, "bool");
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.toFloat = function() {
    return this.throwIfDisposed(), tt(this, "float32");
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.toInt = function() {
    return this.throwIfDisposed(), tt(this, "int32");
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.topk = function(n, t) {
    return this.throwIfDisposed(), aN(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.transpose = function(n) {
    return this.throwIfDisposed(), kt(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.unique = function(n) {
    return this.throwIfDisposed(), uN(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.unsortedSegmentSum = function(n, t) {
    return this.throwIfDisposed(), I0(this, n, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.unstack = function(n) {
    return this.throwIfDisposed(), Mo(this, n);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.where = function(n, t) {
    return this.throwIfDisposed(), Ee(n, this, t);
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ K().prototype.zerosLike = function() {
    return this.throwIfDisposed(), Tt(this);
};
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ class Qn extends Error {
    constructor(t){
        super(t), Object.setPrototypeOf(this, Qn.prototype);
    }
}
class Sn extends Error {
    constructor(t){
        super(t), Object.setPrototypeOf(this, Sn.prototype);
    }
}
class E extends Error {
    constructor(t){
        super(t), Object.setPrototypeOf(this, E.prototype);
    }
}
class yt extends Error {
    constructor(t){
        super(t), Object.setPrototypeOf(this, yt.prototype);
    }
}
class mf extends Error {
    constructor(t){
        super(t), Object.setPrototypeOf(this, mf.prototype);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ class wx {
    constructor(t){
        this.maxEntries = t || 100, this.cache = /* @__PURE__ */ new Map();
    }
    /**
   * Get the entry for the key and mark it as used recently.
   */ get(t) {
        let e;
        return this.cache.has(t) && (e = this.cache.get(t), this.cache.delete(t), this.cache.set(t, e)), e;
    }
    /**
   * Put the entry into the cache. If the key already existed, mark the key as
   * used recently.
   */ put(t, e) {
        if (this.cache.has(t)) this.cache.delete(t);
        else if (this.cache.size >= this.maxEntries) {
            const s = this.cache.keys().next().value;
            this.cache.delete(s);
        }
        this.cache.set(t, e);
    }
    /**
   * Get the MaxEntries of the cache.
   */ getMaxEntries() {
        return this.maxEntries;
    }
    /**
   * Set the MaxEntries of the cache. If the maxEntries is decreased, reduce
   * entries in the cache.
   */ setMaxEntries(t) {
        if (t < 0) throw new Error(`The maxEntries of LRU caches must be at least 0, but got ${t}.`);
        if (this.maxEntries > t) for(let e = 0; e < this.maxEntries - t; e++){
            const s = this.cache.keys().next().value;
            this.cache.delete(s);
        }
        this.maxEntries = t;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function Wo(n, t) {
    if (Array.isArray(n)) {
        let e = [];
        for(let s = 0; s < t; s++)e = e.concat(n);
        return e;
    } else {
        const e = new Array(t);
        return e.fill(n), e;
    }
}
function Jn(n, t) {
    if (!n) throw new mf(t);
}
function Xm(n, t) {
    let e = 0;
    for (const s of n)s === t && e++;
    return e;
}
function Xe(n) {
    return n.length === 1 ? n[0] : n;
}
function Lt(n) {
    return Array.isArray(n) ? n : [
        n
    ];
}
function us(n) {
    const e = n.replace(/(.)([A-Z][a-z0-9]+)/g, "$1_$2").replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
    return e[0] !== "_" ? e : "private" + e;
}
function ho(n) {
    return n.length <= 1 || n.indexOf("_") === -1 ? n : n.replace(/[_]+(\w|$)/g, (t, e)=>e.toUpperCase());
}
let bn = {};
function gf(n) {
    if (n == null) return null;
    const t = {};
    return t.className = n.getClassName(), t.config = n.getConfig(), t;
}
function Nd(n) {
    if (!(n == null || typeof n != "object")) {
        if (Array.isArray(n)) n.forEach((t)=>Nd(t));
        else {
            const t = Object.keys(n);
            for (const e of t){
                const s = n[e];
                s != null && typeof s == "object" && (!Array.isArray(s) && s.type === "ndarray" && typeof s.value == "number" ? n[e] = s.value : Nd(s));
            }
        }
    }
}
function Ga(n, t = {}, e = {}, s = "object", o = !1) {
    if (typeof n == "string") {
        const r = n;
        let i;
        if (r in e) i = e[r];
        else if (r in bn) i = bn[r];
        else if (i = t[r], i == null) throw new E(`Unknown ${s}: ${n}. This may be due to one of the following reasons:
1. The ${s} is defined in Python, in which case it needs to be ported to TensorFlow.js or your JavaScript code.
2. The custom ${s} is defined in JavaScript, but is not registered properly with tf.serialization.registerClass().`);
        return i;
    } else {
        const r = n;
        if (r.className == null || r.config == null) throw new E(`${s}: Improper config format: ${JSON.stringify(r)}.
'className' and 'config' must set.`);
        const i = r.className;
        let a, l;
        if (i in e ? [a, l] = e[i] : i in bn ? [a, l] = bn.className : i in t && ([a, l] = t[i]), a == null) throw new E(`Unknown ${s}: ${i}. This may be due to one of the following reasons:
1. The ${s} is defined in Python, in which case it needs to be ported to TensorFlow.js or your JavaScript code.
2. The custom ${s} is defined in JavaScript, but is not registered properly with tf.serialization.registerClass().`);
        if (l != null) {
            const c = {};
            for (const p of Object.keys(bn))c[p] = bn[p];
            for (const p of Object.keys(e))c[p] = e[p];
            const u = r.config;
            u.customObjects = c;
            const d = Object.assign({}, bn);
            for (const p of Object.keys(e))bn[p] = e[p];
            Nd(r.config);
            const h = l(a, r.config, e, o);
            return bn = Object.assign({}, d), h;
        } else {
            const c = Object.assign({}, bn);
            for (const d of Object.keys(e))bn[d] = e[d];
            const u = new a(r.config);
            return bn = Object.assign({}, c), u;
        }
    }
}
function FE(n, t) {
    return n < t ? -1 : n > t ? 1 : 0;
}
function Ba(n, t) {
    return -1 * FE(n, t);
}
function Ps(n) {
    if (n == null) return n;
    const t = [];
    for (const e of n)t.indexOf(e) === -1 && t.push(e);
    return t;
}
function VE(n) {
    if (n == null) throw new E(`Invalid value in obj: ${JSON.stringify(n)}`);
    for(const t in n)if (n.hasOwnProperty(t)) return !1;
    return !0;
}
function Uo(n, t, e) {
    if (e != null && n.indexOf(e) < 0) throw new E(`${e} is not a valid ${t}.  Valid values are ${n} or null/undefined.`);
}
function bf(n, t, e = 0, s = 1 / 0) {
    return Jn(e >= 0), Jn(s >= e), Array.isArray(n) && n.length >= e && n.length <= s && n.every((o)=>typeof o === t);
}
function xe(n, t) {
    Array.isArray(n) ? (C(n.length > 0, ()=>`${t} is unexpectedly an empty array.`), n.forEach((e, s)=>xe(e, `element ${s + 1} of ${t}`))) : C(Number.isInteger(n) && n > 0, ()=>`Expected ${t} to be a positive integer, but got ${Ix(n)}.`);
}
function Ix(n) {
    return n === null ? "null" : Array.isArray(n) ? "[" + n.map((t)=>Ix(t)).join(",") + "]" : typeof n == "string" ? `"${n}"` : `${n}`;
}
function zE(n, t, e) {
    let s = e != null ? e() : Ie(), o;
    return (...i)=>{
        const a = e != null ? e() : Ie();
        return a - s < t || (s = a, o = n(...i)), o;
    };
}
function Cx(n) {
    return n === "relu" ? "relu" : n === "linear" ? "linear" : n === "elu" ? "elu" : null;
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ let PE = 0;
function vx() {
    return PE++;
}
const Ha = {};
function au(n = "") {
    return n in Ha || (Ha[n] = 0), Ha[n] += 1, n + Ha[n].toString();
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ const AE = [
    "channelsFirst",
    "channelsLast"
], OE = [
    "nearest",
    "bilinear"
], XE = [
    "valid",
    "same",
    "causal"
], KE = [
    "max",
    "avg"
], ZE = [
    "sum",
    "mul",
    "concat",
    "ave"
];
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ const er = /* @__PURE__ */ new Map();
function ae(n) {
    Uo(AE, "DataFormat", n);
}
function BE(n) {
    Uo(OE, "InterpolationFormat", n);
}
function gn(n) {
    Uo(XE, "PaddingMode", n);
}
function Sx(n) {
    Uo(KE, "PoolMode", n);
}
const si = [], Km = "/";
function wo(n, t) {
    si.push(n);
    try {
        const e = t();
        return si.pop(), e;
    } catch (e) {
        throw si.pop(), e;
    }
}
function HE() {
    return si.length === 0 ? "" : si.join(Km) + Km;
}
function kx(n) {
    if (!Nx(n)) throw new Error("Not a valid tensor name: '" + n + "'");
    return HE() + n;
}
function Tx(n) {
    if (!Nx(n)) throw new Error("Not a valid tensor name: '" + n + "'");
    er.has(n) || er.set(n, 0);
    const t = er.get(n);
    if (er.set(n, er.get(n) + 1), t > 0) {
        const e = `${n}_${t}`;
        return er.set(e, 1), e;
    } else return n;
}
const _E = new RegExp(/^[A-Za-z0-9][-A-Za-z0-9\._\/]*$/);
function Nx(n) {
    return !!n.match(_E);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function UE(n) {
    return n === parseInt(n.toString(), 10);
}
function As(n, t, e) {
    t == null && (t = 0), e == null && (e = n.length);
    let s = 1;
    for(let o = t; o < e; ++o)s *= n[o];
    return s;
}
function xr(n) {
    if (n.length === 0) return Number.NaN;
    let t = Number.POSITIVE_INFINITY;
    for(let e = 0; e < n.length; e++){
        const s = n[e];
        s < t && (t = s);
    }
    return t;
}
function Bs(n) {
    if (n.length === 0) return Number.NaN;
    let t = Number.NEGATIVE_INFINITY;
    for(let e = 0; e < n.length; e++){
        const s = n[e];
        s > t && (t = s);
    }
    return t;
}
function Kn(n, t) {
    if (t < n) throw new E(`end (${t}) < begin (${n}) is forbidden.`);
    const e = [];
    for(let s = n; s < t; ++s)e.push(s);
    return e;
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ let Wu;
function ue() {
    return Wu == null && (Wu = ps().epsilon()), Wu;
}
function Zn() {
    return "channelsLast";
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function es(n, t) {
    return tt(n, t);
}
function Ea(n, t = -1) {
    const e = n.shape.slice();
    return t < 0 && (t = e.length + t + 1), e.splice(t, 0, 1), W(n, e);
}
function YE(n, t) {
    return D(()=>{
        if (n.shape.length !== 2) throw new E(`repeat() expects a rank-2 tensor, but received a rank-${n.shape.length} tensor.`);
        const e = Ea(n, 1);
        return Rd(e, [
            1,
            t,
            1
        ]);
    });
}
function QE(n) {
    const t = [
        As(n.shape)
    ];
    return W(n, t);
}
function JE(n) {
    if (n.rank <= 1) throw new E(`batchFlatten requires a minimum rank of 2. Got rank: ${n.rank}.`);
    const t = [
        n.shape[0],
        As(n.shape, 1)
    ];
    return W(n, t);
}
function Io(n, t, e) {
    return D(()=>{
        switch(n.rank){
            case 1:
                return Np(n, t, e);
            case 2:
                return g0(n, [
                    t,
                    0
                ], [
                    e,
                    n.shape[1]
                ]);
            case 3:
                return Rp(n, [
                    t,
                    0,
                    0
                ], [
                    e,
                    n.shape[1],
                    n.shape[2]
                ]);
            case 4:
                return Sl(n, [
                    t,
                    0,
                    0,
                    0
                ], [
                    e,
                    n.shape[1],
                    n.shape[2],
                    n.shape[3]
                ]);
            case 5:
                return Ft(n, [
                    t,
                    0,
                    0,
                    0,
                    0
                ], [
                    e,
                    n.shape[1],
                    n.shape[2],
                    n.shape[3],
                    n.shape[4]
                ]);
            case 6:
                return Ft(n, [
                    t,
                    0,
                    0,
                    0,
                    0,
                    0
                ], [
                    e,
                    n.shape[1],
                    n.shape[2],
                    n.shape[3],
                    n.shape[4],
                    n.shape[5]
                ]);
            default:
                throw new E(`sliceAlongFirstAxis() received an unsupported tensor rank: ${n.rank}`);
        }
    });
}
function Du(n, t, e) {
    return D(()=>{
        switch(n.rank){
            case 1:
                return Np(n, t, e);
            case 2:
                return g0(n, [
                    0,
                    t
                ], [
                    n.shape[0],
                    e
                ]);
            case 3:
                return Rp(n, [
                    0,
                    0,
                    t
                ], [
                    n.shape[0],
                    n.shape[1],
                    e
                ]);
            case 4:
                return Sl(n, [
                    0,
                    0,
                    0,
                    t
                ], [
                    n.shape[0],
                    n.shape[1],
                    n.shape[2],
                    e
                ]);
            default:
                throw new E(`sliceAlongLastAxis() received an unsupported tensor rank: ${n.rank}`);
        }
    });
}
function _a(n, t, e, s) {
    return D(()=>{
        switch(n.rank){
            case 1:
                return Np(n, t, e);
            case 2:
                switch(s){
                    case 1:
                        return Io(n, t, e);
                    case 2:
                        return Du(n, t, e);
                    default:
                        throw new E(`The axis is not within the rank of the tensor ${s}`);
                }
            case 3:
                switch(s){
                    case 1:
                        return Io(n, t, e);
                    case 2:
                        return Rp(n, [
                            0,
                            t,
                            0
                        ], [
                            n.shape[0],
                            e,
                            n.shape[2]
                        ]);
                    case 3:
                        return Du(n, t, e);
                    default:
                        throw new E(`The axis is not within the rank of the tensor ${s}`);
                }
            case 4:
                switch(s){
                    case 1:
                        return Io(n, t, e);
                    case 2:
                        return Sl(n, [
                            0,
                            t,
                            0,
                            0
                        ], [
                            n.shape[0],
                            e,
                            n.shape[2],
                            n.shape[3]
                        ]);
                    case 3:
                        return Sl(n, [
                            0,
                            0,
                            t,
                            0
                        ], [
                            n.shape[0],
                            n.shape[1],
                            e,
                            n.shape[3]
                        ]);
                    case 4:
                        return Du(n, t, e);
                    default:
                        throw new E(`The axis is not within the rank of the tensor ${s}`);
                }
            default:
                throw new E(`sliceAlongLastAxis() received an unsupported tensor rank: ${n.rank}`);
        }
    });
}
function xf(n, t = -1) {
    let e;
    return t < 0 && (e = n[0].rank, e !== 0 ? t = e : t = 0), t === n[0].rank && (t = -1), Ge(n, t);
}
function Zm(n, t) {
    switch(n.rank){
        case 1:
            return cS([
                n,
                t
            ]);
        case 2:
            return dS([
                n,
                t
            ], 0);
        case 3:
            return pS([
                n,
                t
            ], 0);
        case 4:
            return mS([
                n,
                t
            ], 0);
        default:
            throw new E(`concatAlongFirstAxis() received an unsupported tensor rank: ${n.rank}`);
    }
}
function Rd(n, t) {
    if (Array.isArray(t) || (t = [
        t
    ]), n.rank !== t.length) throw new E(`The length of input n (${t.length}) does not match the number of dimensions in input x (${n.rank})`);
    return Vn(n, t);
}
function lu(n, t = 0, e = 1, s, o) {
    return kT(n, t, e, s, o);
}
function ns(n, t, e, s) {
    if (n.rank < 2 || t.rank < 2) throw new yt(`dot requires both inputs to be rank >= 2 but got x shape = ${n.shape} and y shape = ${t.shape}`);
    if (t.rank >= 3) {
        const o = n.shape.slice(-1)[0], r = t.shape.slice(-2)[0];
        if (o !== r) throw new yt(`If rank y >= 3, then the second last dim of y must equal the last dim of x but got x shape = ${n.shape} and  y shape = ${t.shape}`);
    }
    if (n.rank === 2 && t.rank === 2) return Nm({
        a: n,
        b: t,
        transposeA: !1,
        transposeB: !1,
        bias: s ? $d(n.rank, s, Zn()) : null,
        activation: e
    });
    {
        const o = n.shape.slice(), r = o.pop();
        n = W(n, [
            -1,
            r
        ]);
        const i = t.shape.slice(), a = i.pop(), l = i.pop(), c = [
            ...i,
            a
        ], u = Array.from({
            length: t.rank
        }, (f, m)=>m === 0 ? t.rank - 2 : m <= t.rank - 2 ? m - 1 : m);
        t = W(kt(t, u), [
            l,
            -1
        ]);
        const d = [
            ...o,
            ...c
        ];
        return W(Nm({
            a: n,
            b: t,
            transposeA: !1,
            transposeB: !1,
            bias: s ? $d(n.rank, s, Zn()) : null,
            activation: e
        }), d);
    }
}
function Rx(n, t, e) {
    return D(()=>(Array.isArray(t) ? t = Ze(t, "int32") : t = tt(t, "int32"), cp(n, t, e)));
}
function La(n) {
    return G(n, n);
}
function $d(n, t, e) {
    const s = t.shape;
    if (t.rank !== 1 && t.rank !== n) throw new E(`Unexpected bias dimensions: ${t.rank}; expected it to be 1 or ${n}`);
    if (n === 5) {
        if (e === "channelsFirst") return s.length === 1 ? W(t, [
            1,
            s[0],
            1,
            1,
            1
        ]) : W(t, [
            1,
            s[3],
            s[0],
            s[1],
            s[2]
        ]);
        if (e === "channelsLast") return s.length === 1 ? W(t, [
            1,
            1,
            1,
            1,
            s[0]
        ]) : W(t, [
            1
        ].concat(s));
    } else if (n === 4) {
        if (e === "channelsFirst") return s.length === 1 ? W(t, [
            1,
            s[0],
            1,
            1
        ]) : W(t, [
            1,
            s[2],
            s[0],
            s[1]
        ]);
        if (e === "channelsLast") return s.length === 1 ? W(t, [
            1,
            1,
            1,
            s[0]
        ]) : W(t, [
            1
        ].concat(s));
    } else if (n === 3) {
        if (e === "channelsFirst") return s.length === 1 ? W(t, [
            1,
            s[0],
            1
        ]) : W(t, [
            1,
            s[1],
            s[0]
        ]);
        if (e === "channelsLast") return s.length === 1 ? W(t, [
            1,
            1,
            s[0]
        ]) : W(t, [
            1
        ].concat(s));
    } else if (n < 3) return t;
    throw new E(`Unsupported input rank by biasAdd: ${t.rank}`);
}
function _n(n, t, e) {
    return D(()=>(e == null && (e = Zn()), ae(e), U(n, $d(n.rank, t, e))));
}
function jE(n, t = 1) {
    if (t !== 1) throw new yt(`Support for alpha values other than 1 (${t}) is not implemented yet.`);
    return Jc(n);
}
function qE(n) {
    return D(()=>ut(n, U(me(n), 1)));
}
function $x(n, t, e, s) {
    return D(()=>bN(n, t, e, s));
}
function tL(n) {
    return D(()=>{
        const t = U(0.5, G(0.2, n));
        return fn(t, 0, 1);
    });
}
function Ma(n, t, e = !1) {
    return e ? n() : t();
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ const eL = [
    "fanIn",
    "fanOut",
    "fanAvg"
], nL = [
    "normal",
    "uniform",
    "truncatedNormal"
];
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function sL(n) {
    Uo(eL, "FanMode", n);
}
function oL(n) {
    Uo(nL, "Distribution", n);
}
class Gn extends _o {
    fromConfigUsesCustomObjects() {
        return !1;
    }
    getConfig() {
        return {};
    }
}
class Gx extends Gn {
    apply(t, e) {
        return be(t, e);
    }
}
Gx.className = "Zeros";
_(Gx);
class yf extends Gn {
    apply(t, e) {
        return ks(t, e);
    }
}
yf.className = "Ones";
_(yf);
class Ex extends Gn {
    constructor(t){
        if (super(), typeof t != "object") throw new E(`Expected argument of type ConstantConfig but got ${t}`);
        if (t.value === void 0) throw new E(`config must have value set but got ${t}`);
        this.value = t.value;
    }
    apply(t, e) {
        return D(()=>G(gt(this.value), ks(t, e)));
    }
    getConfig() {
        return {
            value: this.value
        };
    }
}
Ex.className = "Constant";
_(Ex);
class Lx extends Gn {
    constructor(t){
        super(), this.DEFAULT_MINVAL = -0.05, this.DEFAULT_MAXVAL = 0.05, this.minval = t.minval || this.DEFAULT_MINVAL, this.maxval = t.maxval || this.DEFAULT_MAXVAL, this.seed = t.seed;
    }
    apply(t, e) {
        return Sa(t, this.minval, this.maxval, e, this.seed);
    }
    getConfig() {
        return {
            minval: this.minval,
            maxval: this.maxval,
            seed: this.seed
        };
    }
}
Lx.className = "RandomUniform";
_(Lx);
class Mx extends Gn {
    constructor(t){
        super(), this.DEFAULT_MEAN = 0, this.DEFAULT_STDDEV = 0.05, this.mean = t.mean || this.DEFAULT_MEAN, this.stddev = t.stddev || this.DEFAULT_STDDEV, this.seed = t.seed;
    }
    apply(t, e) {
        if (e = e || "float32", e !== "float32" && e !== "int32") throw new yt(`randomNormal does not support dType ${e}.`);
        return lu(t, this.mean, this.stddev, e, this.seed);
    }
    getConfig() {
        return {
            mean: this.mean,
            stddev: this.stddev,
            seed: this.seed
        };
    }
}
Mx.className = "RandomNormal";
_(Mx);
class Wx extends Gn {
    constructor(t){
        super(), this.DEFAULT_MEAN = 0, this.DEFAULT_STDDEV = 0.05, this.mean = t.mean || this.DEFAULT_MEAN, this.stddev = t.stddev || this.DEFAULT_STDDEV, this.seed = t.seed;
    }
    apply(t, e) {
        if (e = e || "float32", e !== "float32" && e !== "int32") throw new yt(`truncatedNormal does not support dType ${e}.`);
        return w0(t, this.mean, this.stddev, e, this.seed);
    }
    getConfig() {
        return {
            mean: this.mean,
            stddev: this.stddev,
            seed: this.seed
        };
    }
}
Wx.className = "TruncatedNormal";
_(Wx);
class Dx extends Gn {
    constructor(t){
        super(), this.gain = t.gain != null ? t.gain : 1;
    }
    apply(t, e) {
        return D(()=>{
            if (t.length !== 2 || t[0] !== t[1]) throw new E("Identity matrix initializer can only be used for 2D square matrices.");
            return G(this.gain, o0(t[0]));
        });
    }
    getConfig() {
        return {
            gain: this.gain
        };
    }
}
Dx.className = "Identity";
_(Dx);
function rL(n, t = "channelsLast") {
    let e, s;
    if (ae(t), n.length === 2) e = n[0], s = n[1];
    else if ([
        3,
        4,
        5
    ].indexOf(n.length) !== -1) {
        if (t === "channelsFirst") {
            const o = As(n, 2);
            e = n[1] * o, s = n[0] * o;
        } else if (t === "channelsLast") {
            const o = As(n, 0, n.length - 2);
            e = n[n.length - 2] * o, s = n[n.length - 1] * o;
        }
    } else {
        const o = As(n);
        e = Math.sqrt(o), s = Math.sqrt(o);
    }
    return [
        e,
        s
    ];
}
class en extends Gn {
    /**
   * Constructor of VarianceScaling.
   * @throws ValueError for invalid value in scale.
   */ constructor(t){
        if (super(), t.scale < 0) throw new E(`scale must be a positive float. Got: ${t.scale}`);
        this.scale = t.scale == null ? 1 : t.scale, this.mode = t.mode == null ? "fanIn" : t.mode, sL(this.mode), this.distribution = t.distribution == null ? "normal" : t.distribution, oL(this.distribution), this.seed = t.seed;
    }
    apply(t, e) {
        const s = rL(t), o = s[0], r = s[1];
        let i = this.scale;
        if (this.mode === "fanIn" ? i /= Math.max(1, o) : this.mode === "fanOut" ? i /= Math.max(1, r) : i /= Math.max(1, (o + r) / 2), this.distribution === "normal") {
            const a = Math.sqrt(i);
            if (e = e || "float32", e !== "float32" && e !== "int32") throw new yt(`${this.getClassName()} does not support dType ${e}.`);
            return w0(t, 0, a, e, this.seed);
        } else {
            const a = Math.sqrt(3 * i);
            return Sa(t, -a, a, e, this.seed);
        }
    }
    getConfig() {
        return {
            scale: this.scale,
            mode: this.mode,
            distribution: this.distribution,
            seed: this.seed
        };
    }
}
en.className = "VarianceScaling";
_(en);
class wf extends en {
    /**
   * Constructor of GlorotUniform
   * @param scale
   * @param mode
   * @param distribution
   * @param seed
   */ constructor(t){
        super({
            scale: 1,
            mode: "fanAvg",
            distribution: "uniform",
            seed: t == null ? null : t.seed
        });
    }
    getClassName() {
        return en.className;
    }
}
wf.className = "GlorotUniform";
_(wf);
class If extends en {
    /**
   * Constructor of GlorotNormal.
   * @param scale
   * @param mode
   * @param distribution
   * @param seed
   */ constructor(t){
        super({
            scale: 1,
            mode: "fanAvg",
            distribution: "normal",
            seed: t == null ? null : t.seed
        });
    }
    getClassName() {
        return en.className;
    }
}
If.className = "GlorotNormal";
_(If);
class Cf extends en {
    constructor(t){
        super({
            scale: 2,
            mode: "fanIn",
            distribution: "normal",
            seed: t == null ? null : t.seed
        });
    }
    getClassName() {
        return en.className;
    }
}
Cf.className = "HeNormal";
_(Cf);
class vf extends en {
    constructor(t){
        super({
            scale: 2,
            mode: "fanIn",
            distribution: "uniform",
            seed: t == null ? null : t.seed
        });
    }
    getClassName() {
        return en.className;
    }
}
vf.className = "HeUniform";
_(vf);
class Sf extends en {
    constructor(t){
        super({
            scale: 1,
            mode: "fanIn",
            distribution: "normal",
            seed: t == null ? null : t.seed
        });
    }
    getClassName() {
        return en.className;
    }
}
Sf.className = "LeCunNormal";
_(Sf);
class kf extends en {
    constructor(t){
        super({
            scale: 1,
            mode: "fanIn",
            distribution: "uniform",
            seed: t == null ? null : t.seed
        });
    }
    getClassName() {
        return en.className;
    }
}
kf.className = "LeCunUniform";
_(kf);
class Fx extends Gn {
    constructor(t){
        super(), this.DEFAULT_GAIN = 1, this.ELEMENTS_WARN_SLOW = 2e3, this.gain = t.gain == null ? this.DEFAULT_GAIN : t.gain, this.seed = t.seed;
    }
    apply(t, e) {
        return D(()=>{
            if (t.length < 2) throw new yt("Shape must be at least 2D.");
            if (e !== "int32" && e !== "float32" && e !== void 0) throw new TypeError(`Unsupported data type ${e}.`);
            e;
            const s = X(t.slice(0, -1)), o = t[t.length - 1], r = s * o;
            r > this.ELEMENTS_WARN_SLOW && console.warn(`Orthogonal initializer is being called on a matrix with more than ${this.ELEMENTS_WARN_SLOW} (${r}) elements: Slowness may result.`);
            const i = [
                Math.max(o, s),
                Math.min(o, s)
            ], a = lu(i, 0, 1, e, this.seed), l = e$.qr(a, !1);
            let c = l[0];
            const d = l[1].flatten().stridedSlice([
                0
            ], [
                Math.min(o, s) * Math.min(o, s)
            ], [
                Math.min(o, s) + 1
            ]);
            return c = G(c, d.sign()), s < o && (c = c.transpose()), G(gt(this.gain), c.reshape(t));
        });
    }
    getConfig() {
        return {
            gain: this.gain,
            seed: this.seed
        };
    }
}
Fx.className = "Orthogonal";
_(Fx);
const Bm = {
    constant: "Constant",
    glorotNormal: "GlorotNormal",
    glorotUniform: "GlorotUniform",
    heNormal: "HeNormal",
    heUniform: "HeUniform",
    identity: "Identity",
    leCunNormal: "LeCunNormal",
    leCunUniform: "LeCunUniform",
    ones: "Ones",
    orthogonal: "Orthogonal",
    randomNormal: "RandomNormal",
    randomUniform: "RandomUniform",
    truncatedNormal: "TruncatedNormal",
    varianceScaling: "VarianceScaling",
    zeros: "Zeros"
};
function Hm(n, t = {}) {
    return Ga(n, cn.getMap().classNameMap, t, "initializer");
}
function jt(n) {
    return gf(n);
}
function Ut(n) {
    if (typeof n == "string") {
        const t = n in Bm ? Bm[n] : n;
        if (t === "GlorotNormal") return new If();
        if (t === "GlorotUniform") return new wf();
        if (t === "HeNormal") return new Cf();
        if (t === "HeUniform") return new vf();
        if (t === "LeCunNormal") return new Sf();
        if (t === "LeCunUniform") return new kf();
        {
            const e = {};
            return e.className = t, e.config = {}, Hm(e);
        }
    } else return n instanceof Gn ? n : Hm(n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function Gd(n) {
    return Array.isArray(n) && Array.isArray(n[0]);
}
function Tl(n) {
    return n.length === 0 ? [] : Array.isArray(n[0]) ? n : [
        n
    ];
}
function mt(n) {
    let t;
    if (Array.isArray(n)) {
        if (n.length !== 1) throw new E(`Expected Tensor length to be 1; got ${n.length}`);
        t = n[0];
    } else t = n;
    return t;
}
function Rt(n) {
    if (Array.isArray(n) && Array.isArray(n[0])) {
        if (n.length === 1) return n, n[0];
        throw new E(`Expected exactly 1 Shape; got ${n.length}`);
    } else return n;
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function Nl(n) {
    let t = 0;
    for (const e of n)e.shape.length === 0 ? t += 1 : t += e.shape.reduce((s, o)=>s * o);
    return t;
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ const _m = "Variable";
class iL {
    /**
   * Construct Variable from a `tf.Tensor`.
   *
   * If not explicitly named, the Variable will be given a name with the
   * prefix 'Variable'. Variable names are unique. In the case of name
   * collision, suffixies '_<num>' will be added to the name.
   *
   * @param val Initial value of the Variable.
   * @param name Name of the variable. If `null` or `undefined` is provided, it
   *   will default a name with the prefix 'Variable'.
   * @param constraint Optional, projection function to be applied to the
   * variable after optimize updates
   * @throws ValueError if `name` is `null` or `undefined`.
   */ constructor(t, e = "float32", s = _m, o = !0, r = null){
        this.dtype = e ?? "float32", this.shape = t.shape, this.id = vx(), s = s ?? _m, this.originalName = kx(s), this.name = Tx(this.originalName), this.trainable_ = o, this.constraint = r, this.val = pN(t, this.trainable_, this.name, this.dtype);
    }
    /**
   * Get a snapshot of the Variable's value.
   *
   * The returned value is a snapshot of the Variable's value at the time of
   * the invocation. Future mutations in the value of the tensor will only
   * be reflected by future calls to this method.
   */ read() {
        return this.assertNotDisposed(), this.val;
    }
    /**
   * Update the value of the Variable.
   *
   * @param newVal: The new value to update to. Must be consistent with the
   *   dtype and shape of the Variable.
   * @return This Variable.
   */ write(t) {
        return this.assertNotDisposed(), aL(this.val, t), this.val.id !== t.id && (this.val.assign(t), this.constraint != null && this.val.assign(this.constraint.apply(this.val))), this;
    }
    /**
   * Dispose this LayersVariable instance from memory.
   */ dispose() {
        this.assertNotDisposed(), this.val.dispose();
    }
    assertNotDisposed() {
        if (this.val.isDisposed) throw new Error(`LayersVariable ${this.name} is already disposed.`);
    }
    get trainable() {
        return this.trainable_;
    }
    set trainable(t) {
        this.trainable_ = t, this.val.trainable = t;
    }
}
function aL(n, t) {
    if (n.shape.toString() !== t.shape.toString()) throw new Error("Shape mismatch: " + JSON.stringify(n.shape) + " vs. " + JSON.stringify(t.shape));
}
function Ed(n) {
    return n.map((t)=>t.read());
}
function Tf(n) {
    n.forEach((t)=>{
        t[0].write(t[1]);
    });
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ class de {
    constructor(t){
        this.dtype = t.dtype, this.shape = t.shape, t.shape != null ? this.ndim = t.shape.length : this.ndim = t.ndim, this.maxNDim = t.maxNDim, this.minNDim = t.minNDim, this.axes = t.axes || {};
    }
}
class os {
    /**
   *
   * @param dtype
   * @param shape
   * @param sourceLayer The Layer that produced this symbolic tensor.
   * @param inputs The inputs passed to sourceLayer's __call__() method.
   * @param nodeIndex
   * @param tensorIndex
   * @param callArgs The keyword arguments passed to the __call__() method.
   * @param name
   * @param outputTensorIndex The index of this tensor in the list of outputs
   *   returned by apply().
   */ constructor(t, e, s, o, r, i, a){
        this.dtype = t, this.shape = e, this.sourceLayer = s, this.inputs = o, this.callArgs = r, this.outputTensorIndex = a, this.id = vx(), i != null && (this.originalName = kx(i), this.name = Tx(this.originalName)), this.rank = e.length;
    }
}
let lL = 0;
class cu {
    constructor(t, e){
        this.callArgs = e, this.id = lL++, this.outboundLayer = t.outboundLayer, this.inboundLayers = t.inboundLayers, this.nodeIndices = t.nodeIndices, this.tensorIndices = t.tensorIndices, this.inputTensors = t.inputTensors, this.outputTensors = t.outputTensors, this.inputMasks = t.inputMasks, this.outputMasks = t.outputMasks, this.inputShapes = t.inputShapes, this.outputShapes = t.outputShapes;
        for (const s of t.inboundLayers)s != null && s.outboundNodes.push(this);
        t.outboundLayer.inboundNodes.push(this);
    }
    getConfig() {
        const t = [];
        for (const e of this.inboundLayers)e != null ? t.push(e.name) : t.push(null);
        return {
            outboundLayer: this.outboundLayer ? this.outboundLayer.name : null,
            inboundLayers: t,
            nodeIndices: this.nodeIndices,
            tensorIndices: this.tensorIndices
        };
    }
}
let cL = 0;
class St extends _o {
    constructor(t = {}){
        super(), this._callHook = null, this._addedWeightNames = [], this._stateful = !1, this.id = cL++, this.activityRegularizer = null, this.inputSpec = null, this.supportsMasking = !1, this._trainableWeights = [], this._nonTrainableWeights = [], this._losses = [], this._updates = [], this._built = !1, this.inboundNodes = [], this.outboundNodes = [];
        let e = t.name;
        if (!e) {
            const s = this.getClassName();
            e = us(s) + "_" + au(s);
        }
        if (this.name = e, this.trainable_ = t.trainable == null ? !0 : t.trainable, t.inputShape != null || t.batchInputShape != null) {
            let s;
            if (t.batchInputShape != null) s = t.batchInputShape;
            else if (t.inputShape != null) {
                let r = null;
                t.batchSize != null && (r = t.batchSize), s = [
                    r
                ].concat(t.inputShape);
            }
            this.batchInputShape = s;
            let o = t.dtype;
            o == null && (o = t.inputDType), o == null && (o = "float32"), this.dtype = o;
        }
        t.weights != null ? this.initialWeights = t.weights : this.initialWeights = null, this._refCount = null, this.fastWeightInitDuringBuild = !1;
    }
    /**
   * Converts a layer and its index to a unique (immutable type) name.
   * This function is used internally with `this.containerNodes`.
   * @param layer The layer.
   * @param nodeIndex The layer's position (e.g. via enumerate) in a list of
   *   nodes.
   *
   * @returns The unique name.
   */ static nodeKey(t, e) {
        return t.name + "_ib-" + e.toString();
    }
    /**
   * Returns this.inboundNode at index nodeIndex.
   *
   * Porting note: This is a replacement for _get_node_attribute_at_index()
   * @param nodeIndex
   * @param attrName The name of the attribute related to request for this node.
   */ getNodeAtIndex(t, e) {
        if (this.inboundNodes.length === 0) throw new Sn(`The layer has never been called and thus has no defined ${e}.`);
        if (this.inboundNodes.length <= t) throw new E(`Asked to get ${e} at node ${t}, but the layer has only ${this.inboundNodes.length} inbound nodes.`);
        return this.inboundNodes[t];
    }
    /**
   * Retrieves the input tensor(s) of a layer at a given node.
   *
   * @param nodeIndex Integer, index of the node from which to retrieve the
   *   attribute. E.g. `nodeIndex=0` will correspond to the first time the layer
   *   was called.
   *
   * @return A tensor (or list of tensors if the layer has multiple inputs).
   */ getInputAt(t) {
        return Xe(this.getNodeAtIndex(t, "input").inputTensors);
    }
    /**
   * Retrieves the output tensor(s) of a layer at a given node.
   *
   * @param nodeIndex Integer, index of the node from which to retrieve the
   *   attribute. E.g. `nodeIndex=0` will correspond to the first time the layer
   *   was called.
   *
   * @return A tensor (or list of tensors if the layer has multiple outputs).
   */ getOutputAt(t) {
        return Xe(this.getNodeAtIndex(t, "output").outputTensors);
    }
    // Properties
    /**
   * Retrieves the input tensor(s) of a layer.
   *
   * Only applicable if the layer has exactly one inbound node,
   * i.e. if it is connected to one incoming layer.
   *
   * @return Input tensor or list of input tensors.
   *
   * @exception AttributeError if the layer is connected to more than one
   *   incoming layers.
   */ get input() {
        if (this.inboundNodes.length > 1) throw new Qn(`Layer ${this.name} has multiple inbound nodes, hence the notion of "layer input" is ill-defined. Use \`getInputAt(nodeIndex)\` instead.`);
        if (this.inboundNodes.length === 0) throw new Qn(`Layer ${this.name} is not connected, no input to return.`);
        return Xe(this.getNodeAtIndex(0, "input").inputTensors);
    }
    /**
   * Retrieves the output tensor(s) of a layer.
   *
   * Only applicable if the layer has exactly one inbound node,
   * i.e. if it is connected to one incoming layer.
   *
   * @return Output tensor or list of output tensors.
   *
   * @exception AttributeError if the layer is connected to more than one
   *   incoming layers.
   */ get output() {
        if (this.inboundNodes.length === 0) throw new Qn(`Layer ${this.name} has no inbound nodes.`);
        if (this.inboundNodes.length > 1) throw new Qn(`Layer ${this.name} has multiple inbound nodes, hence the notion of "layer output" is ill-defined. Use \`getOutputAt(nodeIndex)\` instead.`);
        return Xe(this.getNodeAtIndex(0, "output").outputTensors);
    }
    get losses() {
        return this._losses;
    }
    /**
   * Retrieves the Layer's current loss values.
   *
   * Used for regularizers during training.
   */ calculateLosses() {
        return this.losses.map((t)=>t());
    }
    get updates() {
        return this._updates;
    }
    get built() {
        return this._built;
    }
    set built(t) {
        this._built = t;
    }
    get trainable() {
        return this.trainable_;
    }
    set trainable(t) {
        this._trainableWeights.forEach((e)=>e.trainable = t), this.trainable_ = t;
    }
    get trainableWeights() {
        return this.trainable_ ? this._trainableWeights.filter((t)=>t.trainable) : [];
    }
    set trainableWeights(t) {
        this._trainableWeights = t;
    }
    get nonTrainableWeights() {
        return this.trainable ? this._trainableWeights.filter((t)=>!t.trainable).concat(this._nonTrainableWeights) : this._trainableWeights.concat(this._nonTrainableWeights);
    }
    set nonTrainableWeights(t) {
        this._nonTrainableWeights = t;
    }
    /**
   * The concatenation of the lists trainableWeights and nonTrainableWeights
   * (in this order).
   */ get weights() {
        return this.trainableWeights.concat(this.nonTrainableWeights);
    }
    get stateful() {
        return this._stateful;
    }
    /**
   * Reset the states of the layer.
   *
   * This method of the base Layer class is essentially a no-op.
   * Subclasses that are stateful (e.g., stateful RNNs) should override this
   * method.
   */ resetStates() {
        if (!this.stateful) throw new Error("Cannot call the resetStates() method of a non-stateful Layer object.");
    }
    /**
   * Checks compatibility between the layer and provided inputs.
   *
   * This checks that the tensor(s) `input`
   * verify the input assumptions of the layer
   * (if any). If not, exceptions are raised.
   *
   * @param inputs Input tensor or list of input tensors.
   *
   * @exception ValueError in case of mismatch between
   *   the provided inputs and the expectations of the layer.
   */ assertInputCompatibility(t) {
        const e = Lt(t);
        if (this.inputSpec == null || this.inputSpec.length === 0) return;
        const s = Lt(this.inputSpec);
        if (e.length !== s.length) throw new E(`Layer ${this.name} expects ${s.length} inputs, but it received ${e.length} input tensors. Input received: ${t}`);
        for(let o = 0; o < e.length; o++){
            const r = e[o], i = s[o];
            if (i == null) continue;
            const a = r.rank;
            if (i.ndim != null && a !== i.ndim) throw new E(`Input ${o} is incompatible with layer ${this.name}: expected ndim=${i.ndim}, found ndim=${a}`);
            if (i.maxNDim != null && a > i.maxNDim) throw new E(`Input ${o} is incompatible with layer ${this.name}: expected max_ndim=${i.maxNDim}, found ndim=${a}`);
            if (i.minNDim != null && a < i.minNDim) throw new E(`Input ${o} is incompatible with layer ${this.name}: expected min_ndim=${i.minNDim}, found ndim=${a}.`);
            if (i.dtype != null && r.dtype !== i.dtype) throw new E(`Input ${o} is incompatible with layer ${this.name} : expected dtype=${i.dtype}, found dtype=${r.dtype}.`);
            if (i.axes) {
                const l = r.shape;
                for(const c in i.axes){
                    const u = Number(c), d = i.axes[c], h = u >= 0 ? l[u] : l[l.length + u];
                    if (d != null && [
                        d,
                        null
                    ].indexOf(h) === -1) throw new E(`Input ${o} is incompatible with layer ${this.name}: expected axis ${u} of input shape to have value ${d} but got shape ${l}.`);
                }
            }
            if (i.shape != null) for(let l = 0; l < i.shape.length; ++l){
                const c = i.shape[l], u = r.shape[l];
                if (c != null && u != null && c !== u) throw new E(`Input ${o} is incompatible with layer ${this.name}: expected shape=${i.shape}, found shape=${r.shape}.`);
            }
        }
    }
    /**
   * This is where the layer's logic lives.
   *
   * @param inputs Input tensor, or list/tuple of input tensors.
   * @param kwargs Additional keyword arguments.
   *
   * @return A tensor or list/tuple of tensors.
   */ call(t, e) {
        return t;
    }
    invokeCallHook(t, e) {
        this._callHook != null && this._callHook(t, e);
    }
    /**
   * Set call hook.
   * This is currently used for testing only.
   * @param callHook
   */ setCallHook(t) {
        this._callHook = t;
    }
    /**
   * Clear call hook.
   * This is currently used for testing only.
   */ clearCallHook() {
        this._callHook = null;
    }
    /**
   * Builds or executes a `Layer`'s logic.
   *
   * When called with `tf.Tensor`(s), execute the `Layer`'s computation and
   * return Tensor(s). For example:
   *
   * ```js
   * const denseLayer = tf.layers.dense({
   *   units: 1,
   *   kernelInitializer: 'zeros',
   *   useBias: false
   * });
   *
   * // Invoke the layer's apply() method with a `tf.Tensor` (with concrete
   * // numeric values).
   * const input = tf.ones([2, 2]);
   * const output = denseLayer.apply(input);
   *
   * // The output's value is expected to be [[0], [0]], due to the fact that
   * // the dense layer has a kernel initialized to all-zeros and does not have
   * // a bias.
   * output.print();
   * ```
   *
   * When called with `tf.SymbolicTensor`(s), this will prepare the layer for
   * future execution.  This entails internal book-keeping on shapes of
   * expected Tensors, wiring layers together, and initializing weights.
   *
   * Calling `apply` with `tf.SymbolicTensor`s are typically used during the
   * building of non-`tf.Sequential` models. For example:
   *
   * ```js
   * const flattenLayer = tf.layers.flatten();
   * const denseLayer = tf.layers.dense({units: 1});
   *
   * // Use tf.layers.input() to obtain a SymbolicTensor as input to apply().
   * const input = tf.input({shape: [2, 2]});
   * const output1 = flattenLayer.apply(input);
   *
   * // output1.shape is [null, 4]. The first dimension is the undetermined
   * // batch size. The second dimension comes from flattening the [2, 2]
   * // shape.
   * console.log(JSON.stringify(output1.shape));
   *
   * // The output SymbolicTensor of the flatten layer can be used to call
   * // the apply() of the dense layer:
   * const output2 = denseLayer.apply(output1);
   *
   * // output2.shape is [null, 1]. The first dimension is the undetermined
   * // batch size. The second dimension matches the number of units of the
   * // dense layer.
   * console.log(JSON.stringify(output2.shape));
   *
   * // The input and output can be used to construct a model that consists
   * // of the flatten and dense layers.
   * const model = tf.model({inputs: input, outputs: output2});
   * ```
   *
   * @param inputs a `tf.Tensor` or `tf.SymbolicTensor` or an Array of them.
   * @param kwargs Additional keyword arguments to be passed to `call()`.
   *
   * @return Output of the layer's `call` method.
   *
   * @exception ValueError error in case the layer is missing shape information
   *   for its `build` call.
   *
   * @doc {heading: 'Models', 'subheading': 'Classes'}
   */ // Porting Note: This is a replacement for __call__() in Python.
    apply(t, e) {
        e = e || {}, this.assertNotDisposed();
        const s = Lt(t), o = hL(t), r = pL(t);
        if (o === r) throw new E("Arguments to apply() must be all SymbolicTensors or all Tensors");
        return wo(this.name, ()=>{
            if (!this.built) {
                this.assertInputCompatibility(t);
                const i = [];
                for (const a of Lt(t))i.push(a.shape);
                this.build(Xe(i)), this.built = !0, this.initialWeights && this.setWeights(this.initialWeights), this._refCount === null && r && (this._refCount = 1);
            }
            if (this.assertInputCompatibility(t), r) {
                let i = this.call(t, e);
                this.supportsMasking && this.setMaskMetadata(t, i);
                const a = Lt(i), l = [];
                for (let c of a)s.indexOf(c) !== -1 && (c = c.clone()), l.push(c);
                if (i = Xe(l), this.activityRegularizer != null) throw new yt("Layer invocation in the presence of activity regularizer(s) is not supported yet.");
                return i;
            } else {
                const i = uL(t), a = this.computeOutputShape(i);
                let l;
                const c = dL(t);
                if (this.warnOnIncompatibleInputShape(Array.isArray(t) ? i[0] : i), a != null && a.length > 0 && Array.isArray(a[0]) ? l = a.map((u, d)=>new os(c, u, this, Lt(t), e, this.name, d)) : l = new os(c, a, this, Lt(t), e, this.name), this.addInboundNode(t, l, null, null, i, a, e), this._refCount++, this.activityRegularizer != null) throw new yt("Layer invocation in the presence of activity regularizer(s) is not supported yet.");
                return l;
            }
        });
    }
    /**
   * Check compatibility between input shape and this layer's batchInputShape.
   *
   * Print warning if any incompatibility is found.
   *
   * @param inputShape Input shape to be checked.
   */ warnOnIncompatibleInputShape(t) {
        if (this.batchInputShape != null) {
            if (t.length !== this.batchInputShape.length) console.warn(`The rank of the input tensor provided (shape: ${JSON.stringify(t)}) does not match that of the batchInputShape (${JSON.stringify(this.batchInputShape)}) of the layer ${this.name}`);
            else {
                let e = !1;
                this.batchInputShape.forEach((s, o)=>{
                    s != null && t[o] != null && t[o] !== s && (e = !0);
                }), e && console.warn(`The shape of the input tensor (${JSON.stringify(t)}) does not match the expectation of layer ${this.name}: ${JSON.stringify(this.batchInputShape)}`);
            }
        }
    }
    /**
   * Retrieves the output shape(s) of a layer.
   *
   * Only applicable if the layer has only one inbound node, or if all inbound
   * nodes have the same output shape.
   *
   * @returns Output shape or shapes.
   * @throws AttributeError: if the layer is connected to more than one incoming
   *   nodes.
   *
   * @doc {heading: 'Models', 'subheading': 'Classes'}
   */ get outputShape() {
        if (this.inboundNodes == null || this.inboundNodes.length === 0) throw new Qn(`The layer ${this.name} has never been called and thus has no defined output shape.`);
        const t = [];
        for (const e of this.inboundNodes){
            const s = JSON.stringify(e.outputShapes);
            t.indexOf(s) === -1 && t.push(s);
        }
        if (t.length === 1) {
            const e = this.inboundNodes[0].outputShapes;
            return Array.isArray(e) && Array.isArray(e[0]) && e.length === 1 ? e[0] : e;
        } else throw new Qn(`The layer ${this.name} has multiple inbound nodes with different output shapes. Hence the notion of "output shape" is ill-defined for the layer.`);
    }
    /**
   * Counts the total number of numbers (e.g., float32, int32) in the
   * weights.
   *
   * @returns An integer count.
   * @throws RuntimeError: If the layer is not built yet (in which case its
   *   weights are not defined yet.)
   *
   * @doc {heading: 'Models', 'subheading': 'Classes'}
   */ countParams() {
        if (!this.built) throw new Sn(`You tried to call countParams() on ${this.name}, but the layer is not built yet. Build it first by calling build(batchInputShape).`);
        return Nl(this.weights);
    }
    /**
   * Creates the layer weights.
   *
   * Must be implemented on all layers that have weights.
   *
   * Called when apply() is called to construct the weights.
   *
   * @param inputShape A `Shape` or array of `Shape` (unused).
   *
   * @doc {heading: 'Models', 'subheading': 'Classes'}
   */ build(t) {
        this.built = !0;
    }
    /**
   * Returns the current values of the weights of the layer.
   *
   * @param trainableOnly Whether to get the values of only trainable weights.
   * @returns Weight values as an `Array` of `tf.Tensor`s.
   *
   * @doc {heading: 'Models', 'subheading': 'Classes'}
   */ getWeights(t = !1) {
        return Ed(t ? this.trainableWeights : this.weights);
    }
    /**
   * Sets the weights of the layer, from Tensors.
   *
   * @param weights a list of Tensors. The number of arrays and their shape
   *   must match number of the dimensions of the weights of the layer (i.e.
   *   it should match the output of `getWeights`).
   *
   * @exception ValueError If the provided weights list does not match the
   *   layer's specifications.
   *
   * @doc {heading: 'Models', 'subheading': 'Classes'}
   */ setWeights(t) {
        D(()=>{
            const e = this.weights;
            if (e.length !== t.length) throw new E(`You called setWeights(weights) on layer "${this.name}" with a weight list of length ${t.length}, but the layer was expecting ${e.length} weights. Provided weights: ${t}...`);
            if (e.length === 0) return;
            const s = [], o = Ed(e);
            for(let r = 0; r < o.length; ++r){
                const i = o[r], a = e[r], l = t[r];
                if (!$t(i.shape, l.shape)) throw new E(`Layer weight shape ${i.shape} not compatible with provided weight shape ${l.shape}`);
                s.push([
                    a,
                    l
                ]);
            }
            Tf(s);
        });
    }
    /**
   * Adds a weight variable to the layer.
   *
   * @param name Name of the new weight variable.
   * @param shape The shape of the weight.
   * @param dtype The dtype of the weight.
   * @param initializer An initializer instance.
   * @param regularizer A regularizer instance.
   * @param trainable Whether the weight should be trained via backprop or not
   *   (assuming that the layer itself is also trainable).
   * @param constraint An optional trainable.
   * @return The created weight variable.
   *
   * @doc {heading: 'Models', 'subheading': 'Classes'}
   */ addWeight(t, e, s, o, r, i, a, l) {
        if (this._addedWeightNames.indexOf(t) !== -1) throw new E(`Duplicate weight name ${t} for layer ${this.name}`);
        this._addedWeightNames.push(t), s == null && (s = "float32"), this.fastWeightInitDuringBuild && (o = l != null ? l() : Ut("zeros"));
        const c = o.apply(e, s), u = new iL(c, s, t, i, a);
        return c.dispose(), r != null && this.addLoss(()=>r.apply(u.read())), i == null && (i = !0), i ? this._trainableWeights.push(u) : this._nonTrainableWeights.push(u), u;
    }
    /**
   * Set the fast-weight-initialization flag.
   *
   * In cases where the initialized weight values will be immediately
   * overwritten by loaded weight values during model loading, setting
   * the flag to `true` saves unnecessary calls to potentially expensive
   * initializers and speeds up the loading process.
   *
   * @param value Target value of the flag.
   */ setFastWeightInitDuringBuild(t) {
        this.fastWeightInitDuringBuild = t;
    }
    /**
   * Add losses to the layer.
   *
   * The loss may potentially be conditional on some inputs tensors,
   * for instance activity losses are conditional on the layer's inputs.
   *
   * @doc {heading: 'Models', 'subheading': 'Classes'}
   */ addLoss(t) {
        t == null || Array.isArray(t) && t.length === 0 || (t = Lt(t), this._losses !== void 0 && this._losses !== null && this.losses.push(...t));
    }
    /**
   * Computes the output shape of the layer.
   *
   * Assumes that the layer will be built to match that input shape provided.
   *
   * @param inputShape A shape (tuple of integers) or a list of shape tuples
   *   (one per output tensor of the layer). Shape tuples can include null for
   *   free dimensions, instead of an integer.
   *
   * @doc {heading: 'Models', 'subheading': 'Classes'}
   */ computeOutputShape(t) {
        return t;
    }
    /**
   * Computes an output mask tensor.
   *
   * @param inputs Tensor or list of tensors.
   * @param mask Tensor or list of tensors.
   *
   * @return null or a tensor (or list of tensors, one per output tensor of the
   * layer).
   */ computeMask(t, e) {
        if (!this.supportsMasking) {
            if (e != null) {
                if (Array.isArray(e)) e.forEach((s)=>{
                    if (s != null) throw new TypeError(`Layer ${this.name} does not support masking, but was passed an inputMask.`);
                });
                else throw new TypeError(`Layer ${this.name} does not support masking, but was passed an inputMask.`);
            }
            return null;
        }
        return e;
    }
    setMaskMetadata(t, e, s) {
        if (!this.supportsMasking) return;
        const o = this.computeMask(t, s), r = Lt(e), i = Lt(o);
        if (r.length !== i.length) throw new Error(`${this.name} outputs ${r.length} tensors but ${r.length} masks for those tensors`);
        for(let a = 0; a < r.length; a++)r[a].kerasMask = i[a];
    }
    /**
   * Internal method to create an inbound node for the layer.
   *
   * @param inputTensors List of input tensors.
   * @param outputTensors List of output tensors.
   * @param inputMasks List of input masks (a mask can be a tensor, or null).
   * @param outputMasks List of output masks (a mask can be a tensor, or null).
   * @param inputShapes List of input shape tuples.
   * @param outputShapes List of output shape tuples.
   * @param kwargs Dictionary of keyword arguments that were passed to the
   *   `call` method of the layer at the call that created the node.
   */ addInboundNode(t, e, s, o, r, i, a = null) {
        const l = Lt(t);
        e = Lt(e), s = Lt(s), o = Lt(o), r = Tl(r), i = Tl(i);
        const c = [], u = [], d = [];
        for (const h of l)c.push(h.sourceLayer), u.push(h.nodeIndex), d.push(h.tensorIndex);
        new cu({
            outboundLayer: this,
            inboundLayers: c,
            nodeIndices: u,
            tensorIndices: d,
            inputTensors: l,
            outputTensors: e,
            inputMasks: s,
            outputMasks: o,
            inputShapes: r,
            outputShapes: i
        }, a);
        for(let h = 0; h < e.length; h++)e[h].sourceLayer = this, e[h].nodeIndex = this.inboundNodes.length - 1, e[h].tensorIndex = h;
    }
    /**
   * Returns the config of the layer.
   *
   * A layer config is a TS dictionary (serializable)
   * containing the configuration of a layer.
   * The same layer can be reinstantiated later
   * (without its trained weights) from this configuration.
   *
   * The config of a layer does not include connectivity
   * information, nor the layer class name.  These are handled
   * by 'Container' (one layer of abstraction above).
   *
   * Porting Note: The TS dictionary follows TS naming standards for
   * keys, and uses tfjs-layers type-safe Enums.  Serialization methods
   * should use a helper function to convert to the pythonic storage
   * standard. (see serialization_utils.convertTsToPythonic)
   *
   * @returns TS dictionary of configuration.
   *
   * @doc {heading: 'Models', 'subheading': 'Classes'}
   */ getConfig() {
        const t = {
            name: this.name,
            trainable: this.trainable
        };
        return this.batchInputShape != null && (t.batchInputShape = this.batchInputShape), this.dtype != null && (t.dtype = this.dtype), t;
    }
    /**
   * Dispose the weight variables that this Layer instance holds.
   *
   * @returns {number} Number of disposed variables.
   */ disposeWeights() {
        return this.weights.forEach((t)=>t.dispose()), this.weights.length;
    }
    assertNotDisposed() {
        if (this._refCount === 0) throw new Error(`Layer '${this.name}' is already disposed.`);
    }
    /**
   * Attempt to dispose layer's weights.
   *
   * This method decreases the reference count of the Layer object by 1.
   *
   * A Layer is reference-counted. Its reference count is incremented by 1
   * the first item its `apply()` method is called and when it becomes a part
   * of a new `Node` (through calling the `apply()` method on a
   * `tf.SymbolicTensor`).
   *
   * If the reference count of a Layer becomes 0, all the weights will be
   * disposed and the underlying memory (e.g., the textures allocated in WebGL)
   * will be freed.
   *
   * Note: If the reference count is greater than 0 after the decrement, the
   * weights of the Layer will *not* be disposed.
   *
   * After a Layer is disposed, it cannot be used in calls such as `apply()`,
   * `getWeights()` or `setWeights()` anymore.
   *
   * @returns A DisposeResult Object with the following fields:
   *   - refCountAfterDispose: The reference count of the Container after this
   *     `dispose()` call.
   *   - numDisposedVariables: Number of `tf.Variable`s (i.e., weights) disposed
   *     during this `dispose()` call.
   * @throws {Error} If the layer is not built yet, or if the layer has already
   *   been disposed.
   *
   * @doc {heading: 'Models', 'subheading': 'Classes'}
   */ dispose() {
        if (!this.built) throw new Error(`Cannot dispose Layer ${this.name} because it has not been built yet.`);
        if (this._refCount === null) throw new Error(`Cannot dispose Layer ${this.name} because it has not been used yet.`);
        this.assertNotDisposed();
        let t = 0;
        return --this._refCount === 0 && (t = this.disposeWeights()), {
            refCountAfterDispose: this._refCount,
            numDisposedVariables: t
        };
    }
}
function uL(n) {
    n = Lt(n);
    const t = [];
    for (const e of n)t.push(e.shape);
    return Xe(t);
}
function dL(n) {
    return "float32";
}
function Vx(n, t, e) {
    if ((t == null || e != null && e > 0) && (t = n.sourceLayer, e = n.nodeIndex), t.inboundNodes.length === 0) return [
        n
    ];
    {
        const s = t.inboundNodes[e];
        if (s.inboundLayers.length === 0) return s.inputTensors;
        {
            const o = [];
            for(let r = 0; r < s.inboundLayers.length; r++){
                const i = s.inputTensors[r], a = s.inboundLayers[r], l = s.nodeIndices[r], c = Vx(i, a, l);
                for (const u of c)o.indexOf(u) === -1 && o.push(u);
            }
            return o;
        }
    }
}
function hL(n) {
    let t = !0;
    for (const e of Lt(n))if (!(e instanceof os)) {
        t = !1;
        break;
    }
    return t;
}
function pL(n) {
    let t = !0;
    for (const e of Lt(n))if (e instanceof os) {
        t = !1;
        break;
    }
    return t;
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ class Wa extends St {
    constructor(t){
        if (super({
            dtype: t.dtype,
            name: t.name != null ? t.name : au("input").toString()
        }), t.batchSize == null && (t.batchSize = null), t.sparse == null && (t.sparse = !1), this.trainable = !1, this.built = !0, this.sparse = t.sparse, t.inputShape != null && t.batchInputShape != null) throw new E("Only provide the inputShape OR batchInputShape argument to inputLayer, not both at the same time.");
        let e = t.batchInputShape;
        if (e == null) {
            if (t.inputShape == null) throw new E("An InputLayer should be passed either a `batchInputShape` or an `inputShape`.");
            e = [
                t.batchSize
            ].concat(t.inputShape);
        } else if (t.batchSize != null) throw new E("Cannot specify batchSize if batchInputShape is specified when creating an InputLayer.");
        const s = t.dtype || "float32";
        this.batchInputShape = e, this.dtype = s, this.inputSpec = [
            {
                shape: e
            }
        ];
        const o = new os(this.dtype, this.batchInputShape, this, [], {}, this.name);
        o.nodeIndex = 0, o.tensorIndex = 0, new cu({
            outboundLayer: this,
            inboundLayers: [],
            nodeIndices: [],
            tensorIndices: [],
            inputTensors: [
                o
            ],
            outputTensors: [
                o
            ],
            inputMasks: [
                null
            ],
            outputMasks: [
                null
            ],
            inputShapes: [
                e
            ],
            outputShapes: [
                e
            ]
        });
    }
    apply(t, e) {
        throw new E(`Cannot pass any input to an InputLayer's apply() method. InputLayer name: ${this.name}`);
    }
    dispose() {
        return {
            refCountAfterDispose: this._refCount,
            numDisposedVariables: 0
        };
    }
    getConfig() {
        return {
            batchInputShape: this.batchInputShape,
            dtype: this.dtype,
            sparse: this.sparse,
            name: this.name
        };
    }
}
Wa.className = "InputLayer";
_(Wa);
function fL(n) {
    if (n.batchShape == null && n.shape == null) throw new Error("Please provide to Input either a `shape` or a `batchShape` argument. Note that `shape` does not include the batch dimension.");
    if (n.batchShape != null && n.shape != null) throw new E("Please provide either a `shape` or `batchShape` argument to Input, but not both.");
    let t = n.batchShape;
    n.shape != null && t == null && (t = [
        null
    ].concat(n.shape));
    let e = n.dtype;
    return e == null && (e = "float32"), new Wa({
        batchInputShape: t,
        name: n.name,
        dtype: e,
        sparse: n.sparse
    }).inboundNodes[0].outputTensors[0];
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function mL(n, t) {
    if (n.dtype == null || n.dtype === t.dtype) return t;
    try {
        return tt(t, n.dtype);
    } catch  {
        throw new E(`The dtype of the feed (${t.dtype}) can not be cast to the dtype of the key '${n.name}' (${n.dtype}).`);
    }
}
class Ds {
    /**
   * Constructor, optionally does copy-construction.
   * @param feeds An Array of `Feed`s, or another `FeedDict`, in which case
   *   copy-construction will be performed.
   */ constructor(t){
        if (this.id2Value = {}, this.id2Mask = {}, this.name2Id = {}, t instanceof Ds) for(const e in t.id2Value)this.id2Value[e] = t.id2Value[e], e in t.id2Mask && (this.id2Mask[e] = t.id2Mask[e]);
        else {
            if (t == null) return;
            for (const e of t)this.add(e.key, e.value);
        }
    }
    /**
   * Add a key-value pair to the FeedDict.
   *
   * @param key The key of the feed.
   * @param value The value of the tensor feed.
   * @param mask The value of the mask feed (optional).
   * @returns This `FeedDict`.
   * @throws ValueError: If the key `SymbolicTensor` already exists in the
   *   `FeedDict`.
   */ add(t, e, s) {
        if (this.id2Value[t.id] == null) this.id2Value[t.id] = mL(t, e), this.name2Id[t.name] = t.id, s != null && (this.id2Mask[t.id] = s);
        else throw new E(`Duplicate key: name=${t.name}, id=${t.id}`);
        return this;
    }
    /**
   * Add a Feed to the FeedDict.
   * @param feed The new `Feed` to add.
   * @returns This `FeedDict`.
   */ addFeed(t) {
        this.add(t.key, t.value);
    }
    /**
   * Probe whether a key already exists in the FeedDict.
   * @param key
   */ hasKey(t) {
        return this.id2Value[t.id] != null;
    }
    /**
   * Get all the SymbolicTensor available in this FeedDict.
   */ names() {
        return Object.keys(this.name2Id);
    }
    /**
   * Get the feed value for given key.
   * @param key The SymbolicTensor, or its name (as a string), of which the
   *     value is sought.
   * @returns If `key` exists, the corresponding feed value.
   * @throws ValueError: If `key` does not exist in this `FeedDict`.
   */ getValue(t) {
        if (t instanceof os) {
            if (this.id2Value[t.id] == null) throw new E(`Nonexistent key: ${t.name}`);
            return this.id2Value[t.id];
        } else {
            const e = this.name2Id[t];
            if (e == null) throw new E(`Feed dict has no SymbolicTensor name: ${t}`);
            return this.id2Value[e];
        }
    }
    /**
   * Get the feed mask for given key.
   * @param key The SymbolicTensor, or its name (as a string), of which the
   *     value is sought.
   * @returns If `key` exists, the corresponding feed mask.
   * @throws ValueError: If `key` does not exist in this `FeedDict`.
   */ getMask(t) {
        if (t instanceof os) {
            if (this.id2Value[t.id] == null) throw new E(`Nonexistent key: ${t.name}`);
            return this.id2Mask[t.id];
        } else {
            const e = this.name2Id[t];
            if (e == null) throw new E(`Feed dict has no SymbolicTensor name: ${t}`);
            return this.id2Mask[e];
        }
    }
    /** Dispose all mask Tensors held by this object. */ disposeMasks() {
        this.id2Mask != null && xt(this.id2Mask);
    }
}
const Rl = new wx(), $l = new wx();
function gL(n) {
    Rl != null && Rl.setMaxEntries(n), $l != null && $l.setMaxEntries(n);
}
function Yr(n, t, e, s) {
    const o = e == null ? !1 : e.training, r = Array.isArray(n), i = r ? n : [
        n
    ], a = i.map((f)=>f.name), l = [], c = t.names();
    for (const f of a)c.indexOf(f) !== -1 ? l.push(t.getValue(f)) : l.push(null);
    s != null && (s.maxNumTensors = -1 / 0, s.minNumTensors = 1 / 0);
    const u = a.join(",") + "|" + t.names().sort().join(",");
    let d = Rl.get(u), h;
    if (d == null) {
        const f = bL(i, t);
        d = f.sorted, h = f.recipientCounts, Rl.put(u, d), $l.put(u, h);
    }
    h = {}, o || Object.assign(h, $l.get(u));
    const p = new Ds(t);
    for(let f = 0; f < d.length; ++f){
        if (s != null) {
            const N = wl().numTensors;
            N > s.maxNumTensors && (s.maxNumTensors = N), N < s.minNumTensors && (s.minNumTensors = N);
        }
        const m = d[f], g = m.sourceLayer;
        if (g instanceof Wa) continue;
        const b = [], x = [], w = [];
        let y = !1;
        for (const N of m.inputs){
            const R = p.getValue(N), M = p.getMask(N);
            b.push(R), x.push(M), M != null && (y = !0), o || (h[N.name]--, h[N.name] === 0 && !t.hasKey(N) && a.indexOf(N.name) === -1 && !R.isDisposed && N.sourceLayer.stateful !== !0 && w.push(R));
        }
        y && (e = e || {}, e.mask = x[0]);
        const I = Lt(g.apply(b, e));
        let v = null;
        g.supportsMasking && (v = g.computeMask(b, x));
        const k = yL(m), S = Array.isArray(k) ? k : [
            k
        ];
        for(let N = 0; N < S.length; ++N){
            p.hasKey(S[N]) || p.add(S[N], I[N], Array.isArray(v) ? v[0] : v);
            const R = a.indexOf(S[N].name);
            R !== -1 && (l[R] = I[N]);
        }
        o || xt(w);
    }
    return p.disposeMasks(), r ? l : l[0];
}
function bL(n, t) {
    C(n != null && n.length > 0, ()=>"Expected at least one fetch, got none");
    let e = [], s = {};
    if (n.length === 1) {
        const o = Um(n[0], t);
        e = o.sorted, s = o.recipientMap;
    } else {
        const o = /* @__PURE__ */ new Set();
        for (const r of n){
            const { sorted: i, recipientMap: a } = Um(r, t);
            for (const l of i)o.has(l.name) || (e.push(l), o.add(l.name));
            for(const l in a)s[l] == null && (s[l] = /* @__PURE__ */ new Set()), a[l].forEach((c)=>s[l].add(c));
        }
    }
    return {
        sorted: e,
        recipientCounts: xL(s)
    };
}
function xL(n) {
    const t = {};
    for(const e in n)t[e] = n[e].size;
    return t;
}
function Um(n, t) {
    const e = /* @__PURE__ */ new Set(), s = [], o = {};
    for (const a of t.names())e.add(a);
    const r = [], i = [];
    for(r.push(n); r.length > 0;){
        const a = r[r.length - 1];
        if (e.has(a.name)) {
            r.pop();
            continue;
        }
        const l = i[i.length - 1] === r.length - 1;
        if (a.inputs.length === 0 || l) r.pop(), s.push(a), e.add(a.name), l && i.pop();
        else {
            i.push(r.length - 1);
            for (const c of a.inputs)o[c.name] == null && (o[c.name] = /* @__PURE__ */ new Set()), o[c.name].add(a.name), !e.has(c.name) && r.push(c);
        }
    }
    return {
        sorted: s,
        recipientMap: o
    };
}
function yL(n) {
    let t;
    if (n.sourceLayer.inboundNodes.length === 1) t = n.sourceLayer.output;
    else {
        let e = null;
        for(let s = 0; s < n.sourceLayer.inboundNodes.length; ++s)for (const o of n.sourceLayer.inboundNodes[s].outputTensors)if (o.id === n.id) {
            e = s;
            break;
        }
        t = n.sourceLayer.getOutputAt(e);
    }
    return t;
}
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const wL = F();
wL.registerFlag("TOPOLOGICAL_SORT_CACHE_MAX_ENTRIES", ()=>100, gL);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function Nf(n, t) {
    return D(()=>Ve(at(G(n, n), t, !0)));
}
class Da extends _o {
    getConfig() {
        return {};
    }
}
class zx extends Da {
    constructor(t){
        super(), this.defaultMaxValue = 2, this.defaultAxis = 0, this.maxValue = t.maxValue != null ? t.maxValue : this.defaultMaxValue, this.axis = t.axis != null ? t.axis : this.defaultAxis;
    }
    apply(t) {
        return D(()=>{
            const e = Nf(t, this.axis), s = fn(e, 0, this.maxValue);
            return G(t, ut(s, U(ue(), e)));
        });
    }
    getConfig() {
        return {
            maxValue: this.maxValue,
            axis: this.axis
        };
    }
}
zx.className = "MaxNorm";
_(zx);
class Px extends Da {
    constructor(t){
        super(), this.defaultAxis = 0, this.axis = t.axis != null ? t.axis : this.defaultAxis;
    }
    apply(t) {
        return D(()=>ut(t, U(ue(), Nf(t, this.axis))));
    }
    getConfig() {
        return {
            axis: this.axis
        };
    }
}
Px.className = "UnitNorm";
_(Px);
class Ax extends Da {
    apply(t) {
        return Ts(t);
    }
}
Ax.className = "NonNeg";
_(Ax);
class Ox extends Da {
    constructor(t){
        super(), this.defaultMinValue = 0, this.defaultMaxValue = 1, this.defaultRate = 1, this.defaultAxis = 0, this.minValue = t.minValue != null ? t.minValue : this.defaultMinValue, this.maxValue = t.maxValue != null ? t.maxValue : this.defaultMaxValue, this.rate = t.rate != null ? t.rate : this.defaultRate, this.axis = t.axis != null ? t.axis : this.defaultAxis;
    }
    apply(t) {
        return D(()=>{
            const e = Nf(t, this.axis), s = U(G(this.rate, fn(e, this.minValue, this.maxValue)), G(1 - this.rate, e));
            return G(t, ut(s, U(ue(), e)));
        });
    }
    getConfig() {
        return {
            minValue: this.minValue,
            maxValue: this.maxValue,
            rate: this.rate,
            axis: this.axis
        };
    }
}
Ox.className = "MinMaxNorm";
_(Ox);
const Ym = {
    maxNorm: "MaxNorm",
    minMaxNorm: "MinMaxNorm",
    nonNeg: "NonNeg",
    unitNorm: "UnitNorm"
};
function he(n) {
    return gf(n);
}
function Qm(n, t = {}) {
    return Ga(n, cn.getMap().classNameMap, t, "constraint");
}
function pe(n) {
    if (n == null) return null;
    if (typeof n == "string") {
        const e = {
            className: n in Ym ? Ym[n] : n,
            config: {}
        };
        return Qm(e);
    } else return n instanceof Da ? n : Qm(n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ async function ao(n) {
    if (n == null) return;
    const t = [], e = [], s = [];
    for(const o in n){
        const r = n[o];
        if (typeof r != "number") {
            const i = r;
            t.push(i.data()), e.push(o), s.push(i);
        }
    }
    if (t.length > 0) {
        const o = await Promise.all(t);
        for(let r = 0; r < o.length; ++r)n[e[r]] = o[r][0];
        xt(s);
    }
}
function Xx(n) {
    if (n != null) for(const t in n){
        const e = n[t];
        typeof e != "number" && e.dispose();
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ var Jm;
(function(n) {
    n[n.SILENT = 0] = "SILENT", n[n.VERBOSE = 1] = "VERBOSE";
})(Jm || (Jm = {}));
const IL = 125;
class hi {
    constructor(){
        this.validationData = null;
    }
    setParams(t) {
        this.params = t;
    }
    async onEpochBegin(t, e) {}
    async onEpochEnd(t, e) {}
    async onBatchBegin(t, e) {}
    async onBatchEnd(t, e) {}
    async onTrainBegin(t) {}
    async onTrainEnd(t) {}
    // LayersModel needs to call Callback.setModel(), but cannot actually depend
    // on Callback because that creates a cyclic dependency.  Providing this no-op
    // method on BaseCallback breaks the cycle: this way LayersModel can depend on
    // BaseCallback but not on Callback.  The argument is typed as `Container`
    // (the superclass of LayersModel) to avoid recapitulating the cycle. Callback
    // overrides this method and enforces that the argument is really a
    // LayersModel.
    setModel(t) {}
}
class CL {
    // TODO(cais): When the need arises, uncomment the following lines and
    // implement the queue for time values.
    // private deltaTBatch: number;
    // private deltaTsBatchBegin: Array<number>;
    // private deltaTsBatchEnd: Array<number>;
    /**
   * Constructor of CallbackList.
   * @param callbacks Array of `Callback` instances.
   * @param queueLength Queue length for keeping running statistics over
   *   callback execution time.
   */ constructor(t, e = 10){
        t == null && (t = []), this.callbacks = t, this.queueLength = e;
    }
    append(t) {
        this.callbacks.push(t);
    }
    setParams(t) {
        for (const e of this.callbacks)e.setParams(t);
    }
    setModel(t) {
        for (const e of this.callbacks)e.setModel(t);
    }
    /**
   * Called at the start of an epoch.
   * @param epoch Index of epoch.
   * @param logs Dictionary of logs.
   */ async onEpochBegin(t, e) {
        e == null && (e = {});
        for (const s of this.callbacks)await s.onEpochBegin(t, e);
    }
    /**
   * Called at the end of an epoch.
   * @param epoch Index of epoch.
   * @param logs Dictionary of logs.
   */ async onEpochEnd(t, e) {
        e == null && (e = {});
        for (const s of this.callbacks)await s.onEpochEnd(t, e);
    }
    /**
   * Called  right before processing a batch.
   * @param batch Index of batch within the current epoch.
   * @param logs Dictionary of logs.
   */ async onBatchBegin(t, e) {
        e == null && (e = {});
        for (const s of this.callbacks)await s.onBatchBegin(t, e);
    }
    /**
   * Called at the end of a batch.
   * @param batch Index of batch within the current epoch.
   * @param logs Dictionary of logs.
   */ async onBatchEnd(t, e) {
        e == null && (e = {});
        for (const s of this.callbacks)await s.onBatchEnd(t, e);
    }
    /**
   * Called at the beginning of training.
   * @param logs Dictionary of logs.
   */ async onTrainBegin(t) {
        t == null && (t = {});
        for (const e of this.callbacks)await e.onTrainBegin(t);
    }
    /**
   * Called at the end of training.
   * @param logs Dictionary of logs.
   */ async onTrainEnd(t) {
        t == null && (t = {});
        for (const e of this.callbacks)await e.onTrainEnd(t);
    }
}
class vL extends hi {
    constructor(){
        super();
    }
    async onEpochBegin(t) {
        this.seen = 0, this.totals = {};
    }
    async onBatchEnd(t, e) {
        e == null && (e = {});
        const s = e.size == null ? 0 : e.size;
        this.seen += s;
        for(const o in e){
            const r = e[o];
            if (typeof r == "number") this.totals.hasOwnProperty(o) || (this.totals[o] = 0), this.totals[o] = this.totals[o] + r * s;
            else {
                let i;
                o in this.totals ? i = this.totals[o] : this.totals[o] = 0;
                const a = D(()=>U(this.totals[o], G(r, s)));
                this.totals[o] = a, i != null && i.dispose();
            }
        }
    }
    async onEpochEnd(t, e) {
        if (e != null) for (const s of this.params.metrics)this.totals[s] != null && (typeof this.totals[s] == "number" ? e[s] = this.totals[s] / this.seen : D(()=>{
            const o = G(ut(1, this.seen), this.totals[s]);
            e[s] = o, this.totals[s].dispose(), hn(e[s]);
        }));
    }
}
class SL extends hi {
    async onTrainBegin(t) {
        this.epoch = [], this.history = {};
    }
    async onEpochEnd(t, e) {
        e == null && (e = {}), this.epoch.push(t);
        for(const s in e)this.history[s] == null && (this.history[s] = []), this.history[s].push(e[s]);
    }
    /**
   * Await the values of all losses and metrics.
   */ async syncData() {
        const t = [], e = [], s = [];
        for(const r in this.history){
            const i = this.history[r];
            for(let a = 0; a < i.length; ++a)if (typeof i[a] != "number") {
                const l = i[a];
                t.push(l.data()), e.push(r), s.push(a);
            }
        }
        const o = await Promise.all(t);
        for(let r = 0; r < o.length; ++r)this.history[e[r]][s[r]].dispose(), this.history[e[r]][s[r]] = o[r][0];
    }
}
class kL extends hi {
    constructor(t, e){
        if (super(), this.currentEpoch = 0, this.nowFunc = t.nowFunc, this.nextFrameFunc = t.nextFrameFunc || su, this.yieldEvery = e || "auto", this.yieldEvery === "auto" && (this.yieldEvery = IL), this.yieldEvery === "never" && t.onYield != null) throw new Error("yieldEvery is `never` but you provided an `onYield` callback. Either change `yieldEvery` or remove the callback");
        pl(this.yieldEvery) && (this.maybeWait = zE(this.maybeWait.bind(this), this.yieldEvery, this.nowFunc)), this.trainBegin = t.onTrainBegin, this.trainEnd = t.onTrainEnd, this.epochBegin = t.onEpochBegin, this.epochEnd = t.onEpochEnd, this.batchBegin = t.onBatchBegin, this.batchEnd = t.onBatchEnd, this.yield = t.onYield;
    }
    async maybeWait(t, e, s) {
        const o = [];
        this.yield != null && (await ao(s), o.push(this.yield(t, e, s))), o.push(this.nextFrameFunc()), await Promise.all(o);
    }
    async onEpochBegin(t, e) {
        this.currentEpoch = t, this.epochBegin != null && (await ao(e), await this.epochBegin(t, e));
    }
    async onEpochEnd(t, e) {
        const s = [];
        this.epochEnd != null && (await ao(e), s.push(this.epochEnd(t, e))), this.yieldEvery === "epoch" && s.push(this.nextFrameFunc()), await Promise.all(s);
    }
    async onBatchBegin(t, e) {
        this.batchBegin != null && (await ao(e), await this.batchBegin(t, e));
    }
    async onBatchEnd(t, e) {
        const s = [];
        this.batchEnd != null && (await ao(e), s.push(this.batchEnd(t, e))), this.yieldEvery === "batch" ? s.push(this.nextFrameFunc()) : pl(this.yieldEvery) && s.push(this.maybeWait(this.currentEpoch, t, e)), await Promise.all(s);
    }
    async onTrainBegin(t) {
        this.trainBegin != null && (await ao(t), await this.trainBegin(t));
    }
    async onTrainEnd(t) {
        this.trainEnd != null && (await ao(t), await this.trainEnd(t));
    }
}
function Kx(n, t) {
    return n == null && (n = {}), n instanceof hi ? [
        n
    ] : Array.isArray(n) && n[0] instanceof hi ? n : Lt(n).map((s)=>new kL(s, t));
}
class wn {
    /**
   * Blocks public access to constructor.
   */ constructor(){}
    /**
   * Register a tf.LayersModel.fit() callback constructor.
   *
   * The registered callback constructor will be used to instantiate
   * callbacks for every tf.LayersModel.fit() call afterwards.
   *
   * @param verbosityLevel Level of verbosity at which the `callbackConstructor`
   *   is to be reigstered.
   * @param callbackConstructor A no-arg constructor for `tf.Callback`.
   * @throws Error, if the same callbackConstructor has been registered before,
   *   either at the same or a different `verbosityLevel`.
   */ static registerCallbackConstructor(t, e) {
        C(t >= 0 && Number.isInteger(t), ()=>`Verbosity level is expected to be an integer >= 0, but got ${t}`), wn.checkForDuplicate(e), wn.constructors[t] == null && (wn.constructors[t] = []), wn.constructors[t].push(e);
    }
    static checkForDuplicate(t) {
        for(const e in wn.constructors)wn.constructors[+e].forEach((o)=>{
            if (o === t) throw new E("Duplicate callback constructor.");
        });
    }
    /**
   * Clear all registered callback constructors.
   */ static clear() {
        wn.constructors = {};
    }
    /**
   * Create callbacks using the registered callback constructors.
   *
   * Given `verbosityLevel`, all constructors registered at that level or above
   * will be called and the instantiated callbacks will be used.
   *
   * @param verbosityLevel: Level of verbosity.
   */ static createCallbacks(t) {
        const e = [];
        for(const s in wn.constructors){
            const o = +s;
            t >= o && e.push(...wn.constructors[o]);
        }
        return e.map((s)=>new s());
    }
}
wn.constructors = {};
function Zx(n, t, e, s, o, r, i, a, l) {
    const c = new SL(), u = [
        new vL(),
        ...wn.createCallbacks(t)
    ];
    n != null && u.push(...n), u.push(c);
    const d = new CL(u);
    return d.setParams({
        epochs: e,
        initialEpoch: s,
        samples: o,
        steps: r,
        batchSize: i,
        verbose: t,
        doValidation: a,
        metrics: l
    }), {
        callbackList: d,
        history: c
    };
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function An(n, t = {}, e = !1) {
    return Ga(n, cn.getMap().classNameMap, t, "layer", e);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function Gl(n, t) {
    return D(()=>{
        n.dtype !== "float32" && (n = tt(n, "float32"));
        const e = at(La(n), t, !0), s = Ca(e.shape, ue()), o = Ve(qs(e, s));
        return ut(n, o);
    });
}
function uu(n, t) {
    return D(()=>oe(La(it(t, n)), -1));
}
function Rf(n, t) {
    return D(()=>oe(me(it(t, n)), -1));
}
function $f(n, t) {
    return D(()=>{
        const e = it(n, t), s = fn(me(n), ue(), Number.MAX_VALUE), o = me(ut(e, s));
        return G(100, oe(o, -1));
    });
}
function TL(n, t) {
    return D(()=>{
        const e = fn(t, ue(), Number.MAX_VALUE), s = Nn(U(1, e)), o = fn(n, ue(), Number.MAX_VALUE), r = Nn(U(1, o));
        return oe(La(it(s, r)), -1);
    });
}
function NL(n, t) {
    return D(()=>{
        const e = qs(0, it(1, G(n, t)));
        return oe(La(e), -1);
    });
}
function RL(n, t) {
    return D(()=>{
        const e = qs(0, it(1, G(n, t)));
        return oe(e, -1);
    });
}
function $L(n, t) {
    return D(()=>{
        const e = at(G(n, t), -1), s = Pn(G(it(1, n), t), -1);
        return qs(0, U(1, it(s, e)));
    });
}
function GL(n, t) {
    return D(()=>{
        const e = Math.log(2), s = it(t, n), o = it(U(s, va(G(-2, s))), e);
        return oe(o, -1);
    });
}
function pi(n, t, e = !1) {
    return D(()=>{
        if (e) t = $p(t);
        else {
            const s = at(t, t.shape.length - 1, !0);
            t = ut(t, s);
        }
        return t = fn(t, ue(), 1 - ue()), Yt(at(G(tt(n, "float32"), Nn(t)), t.shape.length - 1));
    });
}
function El(n, t, e = !1) {
    return D(()=>{
        const s = tt(qc(QE(n)), "int32");
        t = fn(t, ue(), 1 - ue());
        const o = t.shape, r = W(a0(s, o[o.length - 1]), o);
        return pi(r, t, e);
    });
}
function EL(n, t) {
    if (!$t(n.shape, t.shape)) throw new E(`logits and labels must have the same shape, but got shapes ${JSON.stringify(n.shape)} and ${JSON.stringify(t.shape)}`);
    return D(()=>{
        const e = Ts(t), s = Yt(me(t));
        return U(it(e, G(t, n)), hp(mn(s)));
    });
}
function du(n, t) {
    return D(()=>{
        let e;
        return e = fn(t, ue(), 1 - ue()), e = Nn(ut(e, it(1, e))), oe(EL(n, e), -1);
    });
}
function LL(n, t) {
    return D(()=>{
        const e = fn(n, ue(), 1), s = fn(t, ue(), 1);
        return at(G(n, Nn(ut(e, s))), -1);
    });
}
function ML(n, t) {
    return D(()=>{
        const e = Nn(U(ue(), t));
        return oe(it(t, G(n, e)), -1);
    });
}
function Bx(n, t) {
    return D(()=>{
        const e = Gl(n, -1), s = Gl(t, -1), o = G(e, s);
        return Yt(at(o, -1));
    });
}
const Ll = {
    meanSquaredError: uu,
    meanAbsoluteError: Rf,
    meanAbsolutePercentageError: $f,
    meanSquaredLogarithmicError: TL,
    squaredHinge: NL,
    hinge: RL,
    categoricalHinge: $L,
    logcosh: GL,
    categoricalCrossentropy: pi,
    sparseCategoricalCrossentropy: El,
    binaryCrossentropy: du,
    kullbackLeiblerDivergence: LL,
    poisson: ML,
    cosineProximity: Bx
};
function Fu(n) {
    if (typeof n == "string") {
        if (n in Ll) return Ll[n];
        let t = `Unknown loss ${n}`;
        throw n.toLowerCase().includes("softmaxcrossentropy") && (t = `Unknown loss ${n}. Use "categoricalCrossentropy" as the string name for tf.losses.softmaxCrossEntropy`), new E(t);
    } else return n;
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function Hx(n, t) {
    return D(()=>{
        const e = G(0.5, Rn(t)), s = es(rn(t, e), n.dtype);
        return oe(Tn(n, s), -1);
    });
}
function _x(n, t) {
    return D(()=>es(Tn(ai(n, -1), ai(t, -1)), "float32"));
}
function Ux(n, t) {
    return D(()=>tt(at(ss(Tn(n, 1), Tn(t, 1))), "float32"));
}
function WL(n, t) {
    return D(()=>tt(at(ss(Tn(n, 1), Tn(t, 0))), "float32"));
}
function DL(n, t) {
    return D(()=>tt(at(ss(Tn(n, 0), Tn(t, 1))), "float32"));
}
function FL(n, t) {
    return D(()=>{
        const e = Ux(n, t), s = DL(n, t), o = U(e, s);
        return tt(Ee(rn(o, 0), ut(e, o), 0), "float32");
    });
}
function DQ(n, t) {
    return D(()=>{
        const e = Ux(n, t), s = WL(n, t), o = U(e, s);
        return tt(Ee(rn(o, 0), ut(e, o), 0), "float32");
    });
}
function VL(n, t) {
    return du(n, t);
}
function zL(n, t) {
    return n.rank === t.rank && (n = ka(n, [
        n.rank - 1
    ])), t = ai(t, -1), t.dtype !== n.dtype && (t = tt(t, n.dtype)), tt(Tn(n, t), "float32");
}
const PL = uu, AL = uu, OL = Rf, XL = Rf, KL = $f, ZL = $f, Yx = pi, BL = Bx, Qx = El, Ml = {
    binaryAccuracy: Hx,
    categoricalAccuracy: _x,
    precision: FL,
    categoricalCrossentropy: Yx,
    sparseCategoricalCrossentropy: Qx,
    mse: PL,
    MSE: AL,
    mae: OL,
    MAE: XL,
    mape: KL,
    MAPE: ZL,
    cosine: BL
};
function HL(n) {
    if (typeof n == "string" && n in Ml) return Ml[n];
    if (typeof n != "string" && n != null) return n;
    throw new E(`Unknown metric ${n}`);
}
function Ua(n) {
    if (Jn(n !== null, `Unknown LossOrMetricFn ${n}`), typeof n == "string") return n;
    {
        let t;
        for (const e of Object.keys(Ll))if (Ll[e] === n) {
            t = e;
            break;
        }
        if (t !== void 0) return t;
        for (const e of Object.keys(Ml))if (Ml[e] === n) {
            t = e;
            break;
        }
        return t !== void 0 ? t : n.name;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function _L(n) {
    const t = {
        Adagrad: ()=>tr.adagrad(0.01),
        Adadelta: ()=>tr.adadelta(1, 0.95, ue()),
        Adam: ()=>tr.adam(1e-3, 0.9, 0.999, ue()),
        Adamax: ()=>tr.adamax(2e-3, 0.9, 0.999, ue(), 0),
        RMSProp: ()=>tr.rmsprop(1e-3, 0.9, 0, ue()),
        SGD: ()=>tr.sgd(0.01)
    };
    if (t.adagrad = t.Adagrad, t.adadelta = t.Adadelta, t.adam = t.Adam, t.adamax = t.Adamax, t.rmsprop = t.RMSProp, t.sgd = t.SGD, n in t) return t[n]();
    throw new E(`Unknown Optimizer ${n}`);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ const jm = 1048576;
function qm(n, t, e = !1) {
    if (n == null || typeof n != "object" || Object.getPrototypeOf(n) !== Object.prototype || !Ld(n)) throw new Error("User-defined metadata is expected to be a JSON object, but is not.");
    if (e) {
        const s = JSON.stringify(n);
        s.length > jm && console.warn(`User-defined metadata of model "${t}" is too large in size (length=${s.length} when serialized). It is not recommended to store such large objects in user-defined metadata. Please make sure its serialized length is <= ${jm}.`);
    }
}
function Ld(n) {
    if (n === null) return !0;
    if (typeof n == "object") {
        if (Object.getPrototypeOf(n) === Object.prototype) {
            const t = Object.keys(n);
            for (const e of t)if (typeof e != "string" || !Ld(n[e])) return !1;
            return !0;
        } else if (Array.isArray(n)) {
            for (const t of n)if (!Ld(t)) return !1;
            return !0;
        } else return !1;
    } else {
        const t = typeof n;
        return t === "string" || t === "number" || t === "boolean";
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function UL(n, t, e, s = console.log) {
    const o = QL(n), r = [
        "Layer (type)",
        "Input Shape",
        "Output shape",
        "Param #"
    ];
    o ? (t = t || 90, e = e || [
        0.32,
        0.61,
        0.89,
        1
    ]) : (t = t || 115, e = e || [
        0.24,
        0.48,
        0.7,
        0.8,
        1
    ]), e[e.length - 1] <= 1 && (e = e.map((u)=>Math.floor(t * u)));
    let i;
    if (!o) {
        r.push("Receives inputs"), i = [];
        for(const u in n.nodesByDepth)i.push(...n.nodesByDepth[u]);
    }
    s("_".repeat(t)), Wl(r, e, s), s("=".repeat(t));
    const a = n.layers;
    for(let u = 0; u < a.length; ++u)o ? JL(a[u], e, s) : jL(a[u], e, i, s), s((u === a.length - 1 ? "=" : "_").repeat(t));
    n.checkTrainableWeightsConsistency();
    const l = YL(n), c = Nl(n.nonTrainableWeights);
    s(`Total params: ${l + c}`), s(`Trainable params: ${l}`), s(`Non-trainable params: ${c}`), s("_".repeat(t));
}
function YL(n) {
    let t;
    return n.collectedTrainableWeights != null ? t = Nl(n.collectedTrainableWeights) : t = Nl(n.trainableWeights), t;
}
function QL(n) {
    let t = !0;
    const e = [], s = [];
    for(const o in n.nodesByDepth)e.push(n.nodesByDepth[o]);
    for (const o of e){
        if (o.length > 1 || o.length === 1 && o[0].inboundLayers.length > 1) {
            t = !1;
            break;
        }
        s.push(...o);
    }
    if (t) for (const o of n.layers){
        let r = !1;
        for (const i of o.inboundNodes)if (s.indexOf(i) !== -1) {
            if (r) {
                t = !1;
                break;
            } else r = !0;
        }
        if (!t) break;
    }
    return t;
}
function Wl(n, t, e = console.log) {
    let s = "";
    for(let o = 0; o < n.length; ++o)o > 0 && (s = s.slice(0, s.length - 1) + " "), s += n[o], s = s.slice(0, t[o]), s += " ".repeat(t[o] - s.length);
    e(s);
}
function JL(n, t, e) {
    let s, o;
    try {
        o = n.inboundNodes.map((l)=>JSON.stringify(l.inputShapes)).join(",");
    } catch  {
        o = "multiple";
    }
    try {
        s = JSON.stringify(n.outputShape);
    } catch  {
        s = "multiple";
    }
    const r = n.name, i = n.getClassName(), a = [
        `${r} (${i})`,
        o,
        s,
        n.countParams().toString()
    ];
    Wl(a, t, e);
}
function jL(n, t, e, s) {
    let o, r;
    try {
        r = n.inboundNodes.map((d)=>JSON.stringify(d.inputShapes)).join(",");
    } catch  {
        r = "multiple";
    }
    try {
        o = JSON.stringify(n.outputShape);
    } catch  {
        o = "multiple";
    }
    const i = [];
    for (const d of n.inboundNodes)if (!(e != null && e.length > 0 && e.indexOf(d) === -1)) for(let h = 0; h < d.inboundLayers.length; ++h){
        const p = d.inboundLayers[h].name, f = d.nodeIndices[h], m = d.tensorIndices[h];
        i.push(`${p}[${f}][${m}]`);
    }
    const a = n.name, l = n.getClassName(), c = i.length === 0 ? "" : i[0], u = [
        `${a} (${l})`,
        r,
        o,
        n.countParams().toString(),
        c
    ];
    Wl(u, t, s);
    for(let d = 1; d < i.length; ++d)Wl([
        "",
        "",
        "",
        "",
        i[d]
    ], t, s);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function Jx(n, t, e) {
    return (n === "inboundNodes" || n === "outputLayers" || n === "inputLayers") && t === 0 && typeof e == "string";
}
function fi(n, t) {
    if (n === null) return null;
    if (typeof n == "string") return ho(n);
    if (typeof n == "number" || typeof n == "boolean") return n;
    if (n instanceof Array) {
        const e = [], s = n.length;
        for(let o = 0; o < s; ++o){
            const r = n[o];
            Jx(t, o, r) ? e.push(r) : e.push(fi(r, t));
        }
        return e;
    } else {
        const e = {};
        for (const s of Object.keys(n)){
            const o = n[s];
            if (s === "name" && typeof o == "string") e[s] = o;
            else {
                const r = ho(s);
                e[r] = fi(o, r);
            }
        }
        return e;
    }
}
function Md(n, t) {
    if (n == null) return null;
    if (typeof n == "string") return us(n);
    if (typeof n == "number" || typeof n == "boolean") return n;
    if (n instanceof Array) {
        const e = [], s = n.length;
        for(let o = 0; o < s; ++o){
            const r = n[o];
            Jx(t, o, r) ? e.push(r) : e.push(Md(r, t));
        }
        return e;
    } else {
        const e = {};
        for (const s of Object.keys(n)){
            const o = n[s], r = us(s);
            (s === "name" || s === "className") && typeof o == "string" ? e[r] = o : e[r] = Md(o, s);
        }
        return e;
    }
}
/** @license See the LICENSE file. */ const jx = "4.16.0";
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ const qL = (n)=>{
    const t = Object.keys(n);
    if (t.length === 0) return !1;
    const e = t[0].split("/");
    return !isNaN(parseInt(e[e.length - 1], 10));
};
class Wn extends St {
    constructor(t){
        if (super({}), this.containerNodes = /* @__PURE__ */ new Set(), this.name = t.name, this.name == null) {
            const x = this.getClassName().toLowerCase();
            this.name = au(x);
        }
        if (this.supportsMasking = !1, this.trainable_ = !0, Array.isArray(t.inputs) ? this.inputs = t.inputs.slice() : this.inputs = [
            t.inputs
        ], Array.isArray(t.outputs) ? this.outputs = t.outputs.slice() : this.outputs = [
            t.outputs
        ], Ps(this.inputs).length !== this.inputs.length) throw new E(`The list of inputs passed to the model is redundant. All inputs should only appear once. Found: ${this.inputs.map((x)=>x.name)}`);
        Ps(this.outputs).length !== this.outputs.length && console.warn(`The list of outputs passed to the model is redundant. All outputs should only appear once. Found: ${this.outputs.map((x)=>x.name)}`), this.inputLayers = [], this.inputLayersNodeIndices = [], this.inputLayersTensorIndices = [], this.outputLayers = [], this.outputLayersNodeIndices = [], this.outputLayersTensorIndices = [], this.layers = [], this.internalContainerRefs = [];
        for (const x of this.outputs){
            const w = x.sourceLayer, y = x.nodeIndex, I = x.tensorIndex;
            this.outputLayers.push(w), this.outputLayersNodeIndices.push(y), this.outputLayersTensorIndices.push(I);
        }
        for (const x of this.inputs){
            const w = x.sourceLayer, y = x.nodeIndex, I = x.tensorIndex;
            Jn(y === 0, "input layer has >1 nodes"), Jn(I === 0, "input layer has >1 tensors"), this.inputLayers.push(w), this.inputLayersNodeIndices.push(y), this.inputLayersTensorIndices.push(I);
        }
        this.inputNames = [], this.outputNames = [], this.feedInputShapes = [], this.feedInputNames = [], this.feedOutputNames = [];
        for(let x = 0; x < this.inputLayers.length; x++){
            const w = this.inputLayers[x];
            if (!(w instanceof Wa)) throw new TypeError(`Input layers to a LayersModel must be InputLayer objects. Received inputs: ${t.inputs}. Input ${x} (0-based) originates from layer type ${w.getClassName()}.`);
            this.inputNames.push(w.name), this.feedInputShapes.push(w.batchInputShape), this.feedInputNames.push(w.name);
        }
        for (const x of this.outputLayers)this.outputNames.push(x.name);
        this.internalInputShapes = this.inputs.map((x)=>x.shape), this.internalOutputShapes = this.outputs.map((x)=>x.shape);
        const e = {}, s = {}, o = {}, r = {}, i = {}, a = [], l = (x, w, y, I, v, k)=>{
            (I == null || v == null || k == null) && (I = x.sourceLayer, v = x.nodeIndex, k = x.tensorIndex);
            const S = I.inboundNodes[v];
            if (y.indexOf(S) !== -1) throw new Sn(`The tensor ${x.name} at layer "${I.name}" is part of a cycle.`);
            if (w.indexOf(S) !== -1) return;
            this.containerNodes.add(Wn.nodeKey(I, v)), I.id in i || (i[I.id] = Object.keys(i).length), y.indexOf(S) === -1 && y.push(S);
            const N = S.inboundLayers.length;
            for(let R = 0; R < N; R++){
                const M = S.inputTensors[R], V = S.inboundLayers[R], z = S.nodeIndices[R], P = S.tensorIndices[R];
                l(M, w, y, V, z, P);
            }
            for(w.push(S); y.indexOf(S) >= 0;)y.splice(y.indexOf(S), 1);
            a.push(S);
        }, c = [], u = [];
        for (const x of this.outputs)l(x, c, u);
        const d = a.slice().reverse();
        for (const x of d){
            s[x.id] = x, x.id in e || (e[x.id] = 0);
            let w = e[x.id];
            const y = o[x.outboundLayer.id] == null ? 0 : o[x.outboundLayer.id];
            w = Math.max(w, y), o[x.outboundLayer.id] = w, r[x.outboundLayer.id] = x.outboundLayer, e[x.id] = w;
            for(let I = 0; I < x.inboundLayers.length; I++){
                const v = x.inboundLayers[I], k = x.nodeIndices[I], S = v.inboundNodes[k], N = e[S.id] == null ? 0 : e[S.id];
                e[S.id] = Math.max(w + 1, N), s[S.id] = S;
            }
        }
        const h = {};
        for(const x in e){
            const w = e[x];
            w in h || (h[w] = []), h[w].push(s[x]);
        }
        const p = {};
        for(const x in o){
            const w = o[x];
            w in p || (p[w] = []), p[w].push(r[x]);
        }
        let f = Object.keys(p).map((x)=>parseInt(x, 10)).sort(Ba);
        this.layers = [];
        for (const x of f){
            const w = p[x];
            w.sort((y, I)=>{
                const v = i[y.id], k = i[I.id];
                return v < k ? -1 : v > k ? 1 : 0;
            });
            for (const y of w)y instanceof Wn && this.internalContainerRefs.push(y), this.layers.push(y);
        }
        this.layersByDepth = p, f = Object.keys(h).map((x)=>parseInt(x, 10)).sort(Ba);
        const m = this.inputs.slice(), g = [];
        for (const x of f)for (const w of h[x]){
            const y = w.outboundLayer;
            if (y != null) {
                for (const I of w.inputTensors)if (m.indexOf(I) === -1) throw new Sn(`Graph disconnected: cannot obtain value for tensor ${I} at layer "${y.name}". The following previous layers were accessed without issue: ${g}`);
                for (const I of w.outputTensors)m.push(I);
                g.push(y.name);
            }
        }
        this.nodesByDepth = h;
        const b = this.layers.map((x)=>x.name);
        for (const x of b){
            const w = b.filter((y)=>y === x).length;
            if (w !== 1) throw new Sn(`The name "${x}" is used ${w} times in the model. All layer names should be unique. Layer names: ` + JSON.stringify(b));
        }
        this.outboundNodes = [], this.inboundNodes = [], new cu({
            outboundLayer: this,
            inboundLayers: [],
            nodeIndices: [],
            tensorIndices: [],
            inputTensors: this.inputs,
            outputTensors: this.outputs,
            inputMasks: this.inputs.map((x)=>null),
            outputMasks: this.outputs.map((x)=>null),
            inputShapes: this.inputs.map((x)=>x.shape),
            outputShapes: this.outputs.map((x)=>x.shape)
        }), this.built = !0, this._refCount = 1;
    }
    assertNotDisposed() {
        if (this._refCount === 0) throw new Error(`Container '${this.name}' is already disposed.`);
    }
    /**
   * Attempt to dispose a LayersModel's weights.
   *
   * This method decrease the reference count of the LayersModel object by 1.
   *
   * A LayersModel is reference-counted. Its reference count is incremented by 1
   * when it is first constructed and when it is used as a Layer of another
   * LayersModel.
   *
   * If the reference count of a LayersModel becomes 0, the `dispose` method of
   * all its constituent `Layer`s will be called.
   *
   * Note: If the reference count is greater than 0 after the decrement, the
   * `dispose` method of its constituent `Layer`s will *not* be called.
   *
   * After a LayersModel is disposed, it cannot be used in calls such as
   * 'predict`, `evaluate` or `fit` anymore.
   *
   * @returns A DisposeResult Object with the following fields:
   *   - refCountAfterDispose: The reference count of the LayersModel after this
   *     `dispose()` call.
   *   - numDisposedVariables: Number of `tf.Variable`s (i.e., weights) disposed
   *     during this `dispose()` call.
   * @throws {Error} If the layer is not built yet, or if the LayersModel has
   *   already been disposed.
   */ dispose() {
        this.assertNotDisposed();
        const t = {
            refCountAfterDispose: null,
            numDisposedVariables: 0
        };
        if (--this._refCount === 0) {
            for (const e of this.layers)t.numDisposedVariables += e.dispose().numDisposedVariables;
            for (const e of this.internalContainerRefs)t.numDisposedVariables += e.dispose().numDisposedVariables;
        }
        return t.refCountAfterDispose = this._refCount, t;
    }
    get trainable() {
        return this.trainable_;
    }
    set trainable(t) {
        this.layers.forEach((e)=>{
            e._trainableWeights.forEach((s)=>s.trainable = t);
        }), this.trainable_ = t;
    }
    get trainableWeights() {
        if (this._trainableWeights.length > 0) throw new E("Container instance unexpectedly contains _trainableWeights.The trainable weights of a Container are a union of the trainable weights of its consituent Layers. Its own _trainableWeights must remain an empty Array.");
        if (!this.trainable) return [];
        let t = [];
        for (const e of this.layers)t = t.concat(e.trainableWeights);
        return t;
    }
    get nonTrainableWeights() {
        const t = [];
        for (const e of this.layers)t.push(...e.nonTrainableWeights);
        if (!this.trainable) {
            const e = [];
            for (const s of this.layers)e.push(...s.trainableWeights);
            return e.concat(t);
        }
        return t;
    }
    get weights() {
        return this.trainableWeights.concat(this.nonTrainableWeights);
    }
    /**
   * Loads all layer weights from a JSON object.
   *
   * Porting Note: HDF5 weight files cannot be directly loaded in JavaScript /
   *   TypeScript. The utility script at `scripts/pykeras.py` offers means
   *   to convert them into JSON strings compatible with this method.
   * Porting Note: TensorFlow.js Layers supports only loading by name currently.
   *
   * @param weights A JSON mapping weight names to weight values as nested
   *   arrays of numbers, or a `NamedTensorMap`, i.e., a JSON mapping weight
   *   names to `tf.Tensor` objects.
   * @param strict Require that the provided weights exactly match those
   *   required by the container.  Default: `true`.  Passing `false` means that
   *   extra weights and missing weights will be silently ignored.
   */ loadWeights(t, e = !0) {
        const s = {};
        let o = 0;
        const r = qL(t);
        r && this.parseWeights(t);
        for (const a of this.layers)for (const [l, c] of a.weights.entries()){
            const u = r ? `${c.name.split("/").slice(0, -1).join("/") + "/"}${l}` : c.originalName;
            if (s[u] != null) throw new E(`Duplicate weight name: ${u}`);
            s[u] = c, o++;
        }
        const i = [];
        for(const a in t){
            let l = a;
            if (s[a] == null) {
                const c = a.split("/");
                l = c.slice(0, -2).concat([
                    c[c.length - 1]
                ]).join("/");
            }
            if (s[l] != null) i.push([
                s[l],
                t[a]
            ]);
            else if (e) throw new E(`Provided weight data has no target variable: ${a}`);
            delete s[l];
        }
        if (e) {
            const a = [];
            for(const l in s)a.push(l);
            if (a.length > 0) throw new E(`${a.length} of ${o} weights are not set: ${a}`);
        }
        Tf(i);
    }
    parseWeights(t) {
        for(const e in Object.keys(t)){
            const s = e.split("/"), o = [
                "vars",
                "layer_checkpoint_dependencies"
            ], r = s.map((i)=>i.startsWith("_") ? i.slice(1) : i).filter((i)=>!o.includes(i)).join("/");
            r !== e && (t[r] = t[e], delete t[e]);
        }
    }
    /**
   * Util shared between different serialization methods.
   * @returns LayersModel config with Keras version information added.
   */ updatedConfig() {
        const t = this.getConfig(), e = {};
        return e.className = this.getClassName(), e.config = t, e.kerasVersion = `tfjs-layers ${jx}`, e.backend = "TensorFlow.js", e;
    }
    /**
   * Returns a JSON string containing the network configuration.
   *
   * To load a network from a JSON save file, use
   * models.modelFromJSON(jsonString);
   * @param extraJsonArgs Unused in tfjs-layers, maintained for PyKeras
   * @param returnString Whether the return value should be stringified
   *    (default: `true`).
   * @returns a JSON string if `returnString` (default), or a JSON object if
   *   `!returnString`.
   */ // tslint:disable-next-line:no-any
    toJSON(t, e = !0) {
        const s = Md(this.updatedConfig());
        return e ? JSON.stringify(s) : s;
    }
    /**
   * Call the model on new inputs.
   *
   * In this case `call` just reapplies all ops in the graph to the new inputs
   * (e.g. build a new computational graph from the provided inputs).
   *
   * @param inputs A tensor or list of tensors.
   * @param mask A mask or list of masks. A mask can be either a tensor or null
   *   (no mask).
   *
   * @return A tensor if there is a single output, or a list of tensors if there
   *   are more than one outputs.
   */ call(t, e) {
        return D(()=>{
            t = Lt(t);
            const s = new Ds();
            for(let o = 0; o < this.inputs.length; ++o)s.add(this.inputs[o], t[o]);
            return Yr(this.outputs, s, e);
        });
    }
    /**
   * Computes an output mask tensor.
   *
   * @param inputs Tensor or list of tensors.
   * @param mask Tensor or list of tensors.
   *
   * @return null or a tensor (or list of tensors, one per output tensor of the
   * layer).
   */ computeMask(t, e) {
        return D(()=>{
            t = Lt(t);
            let s;
            return e == null ? s = Wo(null, t.length) : s = Lt(e), this.runInternalGraph(t, s)[1];
        });
    }
    /**
   * Computes the output shape of the layer.
   *
   * Assumes that the layer will be built to match that input shape provided.
   *
   * @param inputShape A shape (tuple of integers) or a list of shape tuples
   *   (one per output tensor of the layer). Shape tuples can include null for
   *   free dimensions, instead of an integer.
   */ computeOutputShape(t) {
        const e = Tl(t);
        if (e.length !== this.inputLayers.length) throw new E(`Invalid inputShape argument ${t}: model has ${this.inputLayers.length} tensor inputs.`);
        const s = {};
        for(let a = 0; a < e.length; a++){
            const l = this.inputLayers[a], c = e[a], u = l.name + "_0_0";
            s[u] = c;
        }
        const o = Object.keys(this.nodesByDepth).map((a)=>parseInt(a, 10)).sort(Ba);
        if (o.length > 1) for (const a of o){
            const l = this.nodesByDepth[a];
            for (const c of l){
                const u = c.outboundLayer;
                if (this.inputLayers.map((m)=>m.id).indexOf(u.id) !== -1) continue;
                const d = [];
                for(let m = 0; m < c.inboundLayers.length; m++){
                    const g = c.inboundLayers[m], b = c.nodeIndices[m], x = c.tensorIndices[m], w = `${g.name}_${b}_${x}`, y = s[w];
                    d.push(y);
                }
                const h = u.computeOutputShape(Xe(d)), p = Tl(h), f = u.inboundNodes.indexOf(c);
                for(let m = 0; m < p.length; m++){
                    const g = `${u.name}_${f}_${m}`;
                    s[g] = p[m];
                }
            }
        }
        const r = [], i = [];
        for(let a = 0; a < this.outputLayers.length; a++){
            const l = this.outputLayers[a], c = this.outputLayersNodeIndices[a], u = this.outputLayersTensorIndices[a], d = `${l.name}_${c}_${u}`;
            i.push(d);
        }
        for(let a = 0; a < i.length; a++){
            const l = i[a];
            Jn(l in s), r.push(s[l]);
        }
        return Xe(r);
    }
    /**
   * Computes output tensors for new inputs.
   *
   * Note:
   *   - Expects `inputs` to be a list (potentially with 1 element).
   *
   * @param inputs List of tensors
   * @param masks List of masks (tensors or null).
   * @return Three lists: outputTensors, outputMasks, outputShapes
   */ runInternalGraph(t, e) {
        e == null && (e = Wo(null, t.length));
        const s = {};
        for(let l = 0; l < this.inputs.length; ++l){
            const c = this.inputs[l], u = t[l], d = e[l];
            s[c.id] = [
                u,
                d
            ];
        }
        const o = Object.keys(this.nodesByDepth).map((l)=>parseInt(l, 10)).sort(Ba);
        for (const l of o){
            const c = this.nodesByDepth[l];
            for (const u of c){
                const d = u.outboundLayer, h = u.inputTensors, p = u.outputTensors, f = new Array();
                for (const m of h)m.id in s && f.push(s[m.id]);
                if (f.length === h.length) {
                    let m = {}, g, b, x, w;
                    if (u.callArgs != null && (m = u.callArgs), f.length === 1) {
                        const [y, I] = f[0];
                        m.mask == null && (m.mask = I), x = Lt(d.call(y, m)), w = Lt(d.computeMask(y, I)), g = [
                            y
                        ], b = [
                            I
                        ];
                    } else g = f.map((y)=>y[0]), b = f.map((y)=>y[1]), m.mask == null && (m.mask = b), x = Lt(d.call(g, m)), w = Lt(d.computeMask(g, b));
                    if (d.activityRegularizer) throw new yt("LayersModel invocation with concrete Tensor value(s) in the presence of activity regularizer(s) is not supported yet.");
                    for(let y = 0; y < p.length; ++y){
                        const I = p[y], v = x[y], k = w[y];
                        s[I.id] = [
                            v,
                            k
                        ];
                    }
                }
            }
        }
        const r = [], i = [], a = [];
        for (const l of this.outputs){
            Jn(l.id in s, `Could not compute output ${l.name} : ${l.id}`);
            const [c, u] = s[l.id];
            a.push(c.shape), r.push(c), i.push(u);
        }
        return [
            r,
            i,
            a
        ];
    }
    /**
   * Builds a map of internal node keys to node ordering.
   * Used in serializaion a node orderings may change as unused nodes are
   * dropped. Porting Note:  This helper method was pulled out of getConfig to
   * improve readability.
   * @param layers An array of Layers in the model.
   * @returns Map of Node Keys to index order within the layer.
   */ buildNodeConversionMap(t) {
        const e = {};
        let s;
        for (const o of this.layers){
            s = o instanceof Wn ? 1 : 0;
            for(let r = 0; r < o.inboundNodes.length; r++){
                const i = Wn.nodeKey(o, r);
                this.containerNodes.has(i) && (e[i] = s, s += 1);
            }
        }
        return e;
    }
    getLayer(t, e) {
        if (e != null) return this.findLayer(e);
        if (t == null) throw new E("Provide either a layer name or layer index");
        if (typeof t == "number") return this.findLayer(t);
        for (const s of this.layers)if (s.name === t) return s;
        throw new E(`No such layer: ${t}`);
    }
    findLayer(t) {
        if (this.layers.length <= t) throw new E(`Was asked to retrieve layer at index ${t}, but model only has ${this.layers.length} layer(s).`);
        return this.layers[t];
    }
    /**
   * Retrieves the Container's current loss values.
   *
   * Used for regularizers during training.
   */ calculateLosses() {
        return D(()=>{
            const t = [];
            for (const e of this.layers)for(let s = 0; s < e.inboundNodes.length; ++s){
                const o = Wn.nodeKey(e, s);
                this.containerNodes.has(o) && t.push(...e.calculateLosses());
            }
            return t;
        });
    }
    getConfig() {
        const t = {
            name: this.name
        }, e = this.buildNodeConversionMap(this.layers), s = [];
        for (const i of this.layers){
            const a = i.getClassName(), l = i.getConfig(), c = [];
            for(let d = 0; d < i.inboundNodes.length; d++){
                const h = i.inboundNodes[d], p = Wn.nodeKey(i, d);
                let f = {};
                if (this.containerNodes.has(p)) {
                    if (h.callArgs) try {
                        JSON.stringify(h.callArgs), f = h.callArgs;
                    } catch  {
                        console.warn(`Layer ${i.name} was passed non-serializable keyword arguments: ${h.callArgs}. They will not be included in the serialized model (and thus will be missing at deserialization time).`), f = {};
                    }
                    if (h.inboundLayers.length > 0) {
                        const m = [];
                        for(let g = 0; g < h.inboundLayers.length; g++){
                            const b = h.inboundLayers[g], x = h.nodeIndices[g], w = h.tensorIndices[g], y = Wn.nodeKey(b, x);
                            let I = e[y];
                            I == null && (I = 0), m.push([
                                b.name,
                                I,
                                w,
                                f
                            ]);
                        }
                        c.push(m);
                    }
                }
            }
            const u = {};
            u.name = i.name, u.className = a, u.config = l, u.inboundNodes = c, s.push(u);
        }
        t.layers = s;
        const o = [];
        for(let i = 0; i < this.inputLayers.length; i++){
            const a = this.inputLayers[i], l = this.inputLayersNodeIndices[i], c = Wn.nodeKey(a, l);
            if (!this.containerNodes.has(c)) continue;
            let u = e[c];
            u == null && (u = 0);
            const d = this.inputLayersTensorIndices[i];
            o.push([
                a.name,
                u,
                d
            ]);
        }
        t.inputLayers = o;
        const r = [];
        for(let i = 0; i < this.outputLayers.length; i++){
            const a = this.outputLayers[i], l = this.outputLayersNodeIndices[i], c = Wn.nodeKey(a, l);
            if (!this.containerNodes.has(c)) continue;
            let u = e[c];
            u == null && (u = 0);
            const d = this.outputLayersTensorIndices[i];
            r.push([
                a.name,
                u,
                d
            ]);
        }
        return t.outputLayers = r, t;
    }
    /**
   * Instantiates a LayersModel from its config (output of `get_config()`).
   * @param cls the class to create
   * @param config LayersModel config dictionary.
   * @param customObjects An optional dictionary of custom objects.
   * @param fastWeightInit Optional flag to use fast weight initialization
   *   during deserialization. This is applicable to cases in which
   *   the initialization will be immediately overwritten by loaded weight
   *   values. Default: `false`.
   * @returns A LayersModel instance.
   * @throws ValueError: In case of improperly formatted config dict.
   */ /** @nocollapse */ static fromConfig(t, e, s = {}, o = !1) {
        const r = {}, i = {};
        function a(g, b) {
            g.name in i ? i[g.name].push(b) : i[g.name] = [
                b
            ];
        }
        function l(g, b) {
            const x = [];
            let w;
            for (const y of b){
                const I = y[0], v = y[1], k = y[2];
                if (w = y[3] == null ? {} : y[3], !(I in r)) {
                    a(g, b);
                    return;
                }
                const S = r[I];
                if (S.inboundNodes.length <= v) {
                    a(g, b);
                    return;
                }
                const N = S.inboundNodes[v];
                x.push(N.outputTensors[k]);
            }
            x.length > 0 && g.apply(Xe(x), w);
        }
        function c(g) {
            const b = g.name, x = An(g, e.customObjects != null ? e.customObjects : {});
            x.setFastWeightInitDuringBuild(o), r[b] = x, g.inboundNodes.forEach((y)=>{
                if (!(y instanceof Array)) throw new E(`Corrupted configuration, expected array for nodeData: ${y}`);
                a(x, y);
            });
        }
        const u = e.name, d = e.layers;
        for (const g of d)c(g);
        for(; !VE(i);)for (const g of d){
            const b = r[g.name];
            if (b.name in i) {
                const x = i[b.name];
                delete i[b.name];
                for (const w of x)l(b, w);
            }
        }
        const h = [], p = [], f = e.inputLayers;
        for (const g of f){
            const b = g[0], x = g[1], w = g[2];
            Jn(b in r);
            const I = r[b].inboundNodes[x].outputTensors;
            h.push(I[w]);
        }
        const m = e.outputLayers;
        for (const g of m){
            const b = g[0], x = g[1], w = g[2];
            Jn(b in r);
            const I = r[b].inboundNodes[x].outputTensors;
            p.push(I[w]);
        }
        return new t({
            inputs: h,
            outputs: p,
            name: u
        });
    }
    /**
   * Determine whether the container is stateful.
   *
   * Porting Note: this is the equivalent of the stateful @property of
   *   the Container class in PyKeras.
   */ get stateful() {
        if (this._stateful) throw new E("Container instance unexpectedly has _stateful = true. The statefulness of a Container is determined by the Layers it contains. Its _stateful property must remain the default false.");
        for (const t of this.layers)if (t.stateful) return !0;
        return !1;
    }
    /**
   * Reset the state of all stateful constituent layers (if any).
   *
   * Examples of stateful layers include RNN layers whose `stateful` property
   * is set as `true`.
   */ resetStates() {
        D(()=>{
            this.layers.forEach((t)=>{
                t.stateful && t.resetStates();
            });
        });
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function t3(n, t, e) {
    const s = t.length;
    if (n == null || Array.isArray(n) && n.length === 0) return t.map((o)=>null);
    if (s === 1) return Array.isArray(n) && n.length === 1 ? n : typeof n == "object" && t[0] in n ? [
        n[t[0]]
    ] : [
        n
    ];
    if (Array.isArray(n)) {
        if (n.length !== s) throw new Error(`Provided ${e} is an array of ${n.length} element(s), but the model has ${s} outputs. Make sure a set of weights is provided for each model output.`);
        return n;
    } else if (typeof n == "object" && Object.keys(n).length > 0 && typeof n[Object.keys(n)[0]] == "object") {
        const o = [];
        return t.forEach((r)=>{
            r in n ? o.push(n[r]) : o.push(null);
        }), o;
    } else throw new Error(`The model has multiple (${s}) outputs, so ${e} must be either an array with ${s} elements or an object with ${t} keys. Provided ${e} not understood: ${JSON.stringify(n)}`);
}
function qx(n, t) {
    return t3(n, t, "classWeight");
}
async function ty(n, t, e, s) {
    if (t != null || s != null) throw new Error("Support sampleWeight is not implemented yet");
    if (e != null) {
        const o = D(()=>{
            if (n.shape.length === 1) return yo(n);
            if (n.shape.length === 2) {
                if (n.shape[1] > 1) return ai(n, 1);
                if (n.shape[1] === 1) return W(n, [
                    n.shape[0]
                ]);
                throw new Error(`Encountered unexpected last-dimension size (${n.shape[1]}) during handling of class weights. The size is expected to be >= 1.`);
            } else throw new Error(`Unexpected rank of target (y) tensor (${n.rank}) during handling of class weights. The rank is expected to be 1 or 2.`);
        }), r = Array.from(await o.data());
        xt(o);
        const i = [];
        return r.forEach((a)=>{
            if (e[a] == null) throw new Error(`classWeight must contain all classes in the training data. The class ${a} exists in the data but not in classWeight`);
            i.push(e[a]);
        }), Ze(i, "float32");
    } else return null;
}
function e3(n, t) {
    return G(n, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ const n3 = 32;
function ey(n, t) {
    let e, s;
    const o = t;
    e = o.xs, s = o.ys, C(e != null && s != null, ()=>`A Dataset iterator for fitDataset() is expected to generate objects of the form \`{xs: xVal, ys: yVal}\`, where the two values may be \`tf.Tensor\`, an array of Tensors, or a map of string to Tensor.  The provided Dataset instead generates ${t}`);
    const r = tg("input", n.inputNames, e), i = tg("output", n.outputNames, s), a = r[0].shape[0];
    C(r.length === n.inputs.length, ()=>`LayersModel has ${n.inputs.length} inputs, but the dataset provides ${r.length} inputs.  (Expected input keys: ${JSON.stringify(n.inputNames)})`), C(i.length === n.outputs.length, ()=>`LayersModel has ${n.outputs.length} outputs, but the dataset provides ${i.length} outputs.  (Expected output keys: ${JSON.stringify(n.outputNames)})`);
    for(let l = 0; l < r.length; l++)C(r[l].shape[0] === a, ()=>`Batch size mismatch: input ${n.inputNames[l]} has ${r[l].shape[0]}; expected  ${a} based on input ${n.inputNames[0]}.`);
    for(let l = 0; l < i.length; l++)C(i[l].shape[0] === a, ()=>`Batch size mismatch: output ${n.outputNames[l]} has ${i[l].shape[0]}; expected  ${a} based on input ${n.inputNames[0]}.`);
    return {
        xs: r,
        ys: i
    };
}
function tg(n, t, e) {
    if (e instanceof Mt) return [
        e
    ];
    if (Array.isArray(e)) return C(e.length === t.length, ()=>`Received an array of ${e.length} Tensors, but expected ${t.length} to match the ${n} keys ${t}.`), e;
    {
        const s = [];
        for (const o of t){
            if (e[o] == null) throw new E(`The feature data generated by the dataset lacks the required ${n} key '${o}'.`);
            s.push(e[o]);
        }
        return s;
    }
}
function s3(n) {
    if (n.length === 3) throw new yt("Validation with sample weights is not implemented yet.");
    return {
        xs: n[0],
        ys: n[1]
    };
}
async function o3(n, t, e) {
    const s = e.batchesPerEpoch != null;
    if (C(n.optimizer != null, ()=>"You must compile a model before training/testing. Use LayersModel.compile(modelCompileConfig)."), C(e != null, ()=>"For fitDataset(), the 2nd argument (config) is required, but it is not provided in this call."), C(e.epochs != null && e.epochs > 0 && Number.isInteger(e.epochs), ()=>`For fitDataset(), config.epochs is expected to be a positive integer, but got ${e.epochs}`), C(!s || e.batchesPerEpoch > 0 && Number.isInteger(e.batchesPerEpoch), ()=>`For fitDataset(), config.batchesPerEpoch is expected to be a positive integer if specified, but got ${e.batchesPerEpoch}`), C(// tslint:disable-next-line:no-any
    e.validationSplit == null, ()=>"`validationSplit` is not supported by `fitDataset()`. Use validationData instead."), n.isTraining) throw new Error("Cannot start training because another fit() call is ongoing.");
    n.isTraining = !0;
    try {
        const o = e.validationData != null;
        let r, i;
        if (o) {
            if (eg(e.validationData)) C(e.validationBatches == null || e.validationBatches > 0 && Number.isInteger(e.validationBatches), ()=>`For fitDataset() with dataset-based validation, config.validationBatches is expected not to be provided, or to be a positive integer, but got ${e.validationBatches}`);
            else {
                const g = s3(e.validationData);
                r = g.xs, i = g.ys;
            }
        }
        const a = n.makeTrainFunction(), l = n.getDedupedMetricsNames();
        let c;
        o ? c = l.slice().concat(l.map((g)=>"val_" + g)) : c = l.slice();
        const u = Kx(e.callbacks, e.yieldEvery), d = e.verbose == null ? 1 : e.verbose, { callbackList: h, history: p } = Zx(u, d, e.epochs, null, null, r3(t, e), null, // Batch size determined by the dataset itself.
        o, c);
        h.setModel(n), n.history = p, await h.onTrainBegin(), n.stopTraining_ = !1;
        let f = e.initialEpoch == null ? 0 : e.initialEpoch, m = await t.iterator();
        for(; f < e.epochs;){
            const g = {};
            await h.onEpochBegin(f);
            let b = 0, x = 0;
            for(s || (m = await t.iterator()); !s || b < e.batchesPerEpoch;){
                const w = await m.next();
                if (s && w.done) {
                    console.warn(`You provided \`batchesPerEpoch\` as ${e.batchesPerEpoch}, but your dataset iterator ran out of data after ${b} batches; interrupting training. Make sure that your dataset can generate at least \`batchesPerEpoch * epochs\` batches (in this case, ${e.batchesPerEpoch * e.epochs} batches). You may need to use the repeat() function when building your dataset.`);
                    break;
                }
                if (w.value != null) {
                    const { xs: y, ys: I } = ey(n, w.value), v = {};
                    v.batch = x, v.size = y[0].shape[0], await h.onBatchBegin(x, v);
                    const k = [];
                    if (e.classWeight != null) {
                        const R = qx(e.classWeight, n.outputNames);
                        for(let M = 0; M < R.length; ++M)k.push(await ty(I[M], null, R[M]));
                    }
                    const S = y.concat(I).concat(k), N = a(S);
                    xt(S);
                    for(let R = 0; R < l.length; ++R){
                        const M = l[R], V = N[R];
                        v[M] = V, hn(V);
                    }
                    await h.onBatchEnd(x, v), Xx(v), x++, b++;
                }
                if (s ? b >= e.batchesPerEpoch : w.done) {
                    if (o) {
                        let y;
                        eg(e.validationData) ? y = Lt(await n.evaluateDataset(e.validationData, {
                            batches: e.validationBatches
                        })) : y = Lt(n.evaluate(r, i, {
                            batchSize: e.validationBatchSize == null ? n3 : e.validationBatchSize,
                            verbose: 0
                        }));
                        for(let I = 0; I < n.metricsNames.length; ++I)g[`val_${n.metricsNames[I]}`] = y[I];
                    }
                    break;
                }
                if (n.stopTraining_) break;
            }
            if (await h.onEpochEnd(f, g), f++, n.stopTraining_) break;
        }
        return await h.onTrainEnd(), await n.history.syncData(), n.history;
    } finally{
        n.isTraining = !1;
    }
}
function r3(n, t) {
    let e = null;
    return t.batchesPerEpoch != null ? e = t.batchesPerEpoch : Number.isFinite(n.size) && (e = n.size), e;
}
function eg(n) {
    return typeof n.iterator == "function";
}
function i3(n) {
    return typeof n.next == "function";
}
async function a3(n, t, e) {
    e = e || {};
    const s = e.batches != null, o = n.testFunction;
    let r = [];
    if (e.verbose > 0) throw new yt("Verbose mode is not implemented yet.");
    C(!s || e.batches > 0 && Number.isInteger(e.batches), ()=>`Test loop expects \`batches\` to be a positive integer, but received ${JSON.stringify(e.batches)}`);
    const i = i3(t) ? t : await t.iterator();
    let a = 0, l = 0;
    for(; !s || l < e.batches;){
        const c = await i.next();
        if (r = D(()=>{
            if (c.value) {
                const { xs: u, ys: d } = ey(n, c.value), h = u.concat(d), p = D(()=>o(h));
                if (xt(h), l === 0) for(let m = 0; m < p.length; ++m)r.push(gt(0));
                const f = h[0].shape[0];
                for(let m = 0; m < p.length; ++m){
                    const g = p[m], b = r[m];
                    r[m] = D(()=>U(r[m], G(f, g))), l > 0 && xt(b);
                }
                xt(p), a += f, ++l;
            }
            return r;
        }), c.done) {
            s && console.warn(`Your dataset iterator ran out of data during evaluateDataset(). Interrupting evalution. Make sure that your dataset can generate at least \`batches\` batches (in this case, ${e.batches} batches). You may need to use the repeat() function when building your dataset.`);
            break;
        }
    }
    for(let c = 0; c < r.length; ++c){
        const u = r[c];
        r[c] = ut(r[c], a), xt(u);
    }
    return Xe(r);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function Vu(n) {
    C(n > 0 && Number.isInteger(n), ()=>`batchSize is required to be a positive integer, but got ${n}`);
}
function Xr(n, t, e) {
    return n == null ? [
        null
    ] : Array.isArray(n) ? n.map((s)=>Io(s, t, e - t)) : Io(n, t, e - t);
}
function Wd(n, t) {
    return D(()=>n == null ? null : Array.isArray(n) ? n.map((e)=>Wd(e, t)) : Rx(n, t.dtype === "int32" ? t : tt(t, "int32")));
}
function zu(n, t) {
    const e = [];
    let s = 0, o = null;
    for(; s < n;)o = s + t, o >= n && (o = n), e.push([
        s,
        o
    ]), s = o;
    return e;
}
function ny(n) {
    const t = [];
    n instanceof Mt && (n = [
        n
    ]);
    for(let e = 0; e < n.length; ++e){
        const s = n[e];
        if (s.rank === 1) t.push(Ea(s, 1));
        else {
            if (s.rank === 0) throw new Error("Expected tensor to be at least 1D, but received a 0D tensor (scalar).");
            t.push(s);
        }
    }
    return t;
}
function Mn(n, t) {
    if (n == null) return;
    const e = [];
    if (t instanceof Mt) e.push(t.id);
    else if (Array.isArray(t)) t.forEach((o)=>e.push(o.id));
    else if (t != null) for(const o in t){
        const r = t[o];
        e.push(r.id);
    }
    const s = [];
    if (n instanceof Mt) e.indexOf(n.id) === -1 && s.push(n);
    else if (Array.isArray(n)) n.forEach((o)=>{
        e.indexOf(o.id) === -1 && s.push(o);
    });
    else if (n != null) for(const o in n){
        const r = n[o];
        e.indexOf(r.id) === -1 && s.push(r);
    }
    s.forEach((o)=>{
        o.isDisposed || o.dispose();
    });
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function l3(n) {
    return n instanceof Mt;
}
function Dd(n) {
    return Array.isArray(n);
}
function ng(n) {
    return !l3(n) && !Dd(n);
}
function sg(n, t, e, s = !0, o = "") {
    if (t == null || t.length === 0) {
        if (n != null) {
            let i = !1;
            if (Dd(n) && n.length > 0) i = !0;
            else if (ng(n)) {
                for(const a in n)if (n.hasOwnProperty(a)) {
                    i = !0;
                    break;
                }
            } else i = !0;
            if (i) throw new E(`Error when checking model ${o} expected no data, but got ${n}`);
        }
        return [];
    }
    if (n == null) return t.map((i)=>null);
    let r;
    if (ng(n)) {
        n, r = [];
        for (const i of t){
            if (n[i] == null) throw new E(`No data provided for "${i}". Need data for each key in: ${t}`);
            r.push(n[i]);
        }
    } else if (Dd(n)) {
        if (n, n.length !== t.length) throw new E(`Error when checking model ${o}: the Array of Tensors that you are passing to your model is not the size the model expected. Expected to see ${t.length} Tensor(s), but instead got the following list of Tensor(s): ${n}`);
        r = n;
    } else {
        if (n, t.length > 1) throw new E(`The model ${o} expects ${t.length} Tensor(s), but only received one Tensor. Found: Tensor with shape ${n.shape}`);
        r = [
            n
        ];
    }
    if (r = ny(r), e != null) for(let i = 0; i < t.length; ++i){
        if (e[i] == null) continue;
        const a = r[i];
        if (a.shape.length !== e[i].length) throw new E(`Error when checking ${o}: expected ${t[i]} to have ${e[i].length} dimension(s). but got array with shape ${a.shape}`);
        for(let l = 0; l < e[i].length; ++l){
            if (l === 0 && !s) continue;
            const c = a.shape[l], u = e[i][l];
            if (u != null && u >= 0 && c !== u) throw new E(`${o} expected a batch of elements where each example has shape [${e[i].slice(1, e[i].length)}] (i.e.,tensor shape [*,${e[i].slice(1, e[i].length)}]) but the ${o} received an input with ${a.shape[0]} examples, each with shape [${a.shape.slice(1, a.shape.length)}] (tensor shape [${a.shape}])`);
        }
    }
    return r;
}
function c3(n, t, e) {
    const s = Ps(n.map((r)=>r.shape[0]));
    s.sort();
    const o = Ps(t.map((r)=>r.shape[0]));
    if (o.sort(), s.length > 1) throw new E(`All input Tensors (x) should have the same number of samples. Got array shapes: ${JSON.stringify(n.map((r)=>r.shape))}`);
    if (o.length > 1) throw new E(`All target Tensors (y) should have the same number of samples. Got array shapes: ${JSON.stringify(t.map((r)=>r.shape))}`);
    if (s.length > 0 && o.length > 0 && !$t(s, o)) throw new E(`Input Tensors should have the same number of samples as target Tensors. Found ${s[0]} input sample(s) and ${o[0]} target sample(s).`);
}
function u3(n, t, e) {
    const s = [
        uu,
        du,
        pi
    ];
    for(let o = 0; o < n.length; ++o){
        const r = n[o], i = t[o], a = e[o];
        if (i != null) {
            if (i === pi && r.shape[r.shape.length - 1] === 1) throw new E(`You are passing a target array of shape ${r.shape} while using a loss 'categorical_crossentropy'. 'categorical_crossentropy'expects targets to be binary matrices (1s and 0s) of shape [samples, classes].`);
            if (s.indexOf(i) !== -1) {
                const l = r.shape.slice(1), c = a.slice(1);
                for(let u = 0; u < l.length; ++u){
                    const d = l[u], h = c[u];
                    if (h != null && d !== h) throw new E(`A target Tensor with shape ${r.shape} was passed for an output of shape ${a}, while using a loss function that expects targets to have the same shape as the output.`);
                }
            }
        }
    }
}
function og(n, t, e, s = !0, o = "") {
    let r;
    if (Array.isArray(n)) {
        if (n.length !== t.length) throw new E(`Error when checking model ${o}: the Array of Tensors that you are passing to your model is not the size the the model expected. Expected to see ${t.length} Tensor(s), but instead got ${n.length} Tensors(s).`);
        r = n;
    } else {
        if (t.length > 1) throw new E(`The model expects ${t.length} ${o} Tensors, but only received one Tensor. Found: array with shape ${JSON.stringify(n.shape)}.`);
        r = [
            n
        ];
    }
    if (e != null) for(let i = 0; i < t.length; ++i){
        if (e[i] == null) continue;
        const a = r[i];
        if (a.shape.length !== e[i].length) throw new E(`Error when checking ${o}: expected ${t[i]} to have ${e[i].length} dimension(s), but got array with shape ${JSON.stringify(a.shape)}`);
        for(let l = 0; l < e[i].length; ++l){
            if (l === 0 && !s) continue;
            const c = a.shape[l], u = e[i][l];
            if (u != null && u !== c) throw new E(`Error when checking ${o}: expected ${t[i]} to have shape ${JSON.stringify(e[i])} but got array with shape ${JSON.stringify(a.shape)}.`);
        }
    }
}
function d3(n, t) {
    if (n == null || Array.isArray(n) && n.length === 0) return t.map((s)=>[]);
    let e;
    if (typeof n == "string" || typeof n == "function") e = [
        n
    ];
    else if (Array.isArray(n) || typeof n == "object") e = n;
    else throw new TypeError(`Type of metrics argument not understood. Expected an string,function, Array, or Object, found: ${n}`);
    if (Array.isArray(e)) return t.map((s)=>e);
    {
        const s = [];
        for (const o of t){
            let r = e.hasOwnProperty(o) ? e[o] : [];
            Array.isArray(r) || (r = [
                r
            ]), s.push(r);
        }
        return s;
    }
}
const h3 = "layers-model";
class ur extends Wn {
    constructor(t){
        super(t), this.isTraining = !1;
    }
    /**
   * Print a text summary of the model's layers.
   *
   * The summary includes
   * - Name and type of all layers that comprise the model.
   * - Output shape(s) of the layers
   * - Number of weight parameters of each layer
   * - If the model has non-sequential-like topology, the inputs each layer
   *   receives
   * - The total number of trainable and non-trainable parameters of the model.
   *
   * ```js
   * const input1 = tf.input({shape: [10]});
   * const input2 = tf.input({shape: [20]});
   * const dense1 = tf.layers.dense({units: 4}).apply(input1);
   * const dense2 = tf.layers.dense({units: 8}).apply(input2);
   * const concat = tf.layers.concatenate().apply([dense1, dense2]);
   * const output =
   *     tf.layers.dense({units: 3, activation: 'softmax'}).apply(concat);
   *
   * const model = tf.model({inputs: [input1, input2], outputs: output});
   * model.summary();
   * ```
   *
   * @param lineLength Custom line length, in number of characters.
   * @param positions Custom widths of each of the columns, as either
   *   fractions of `lineLength` (e.g., `[0.5, 0.75, 1]`) or absolute number
   *   of characters (e.g., `[30, 50, 65]`). Each number corresponds to
   *   right-most (i.e., ending) position of a column.
   * @param printFn Custom print function. Can be used to replace the default
   *   `console.log`. For example, you can use `x => {}` to mute the printed
   *   messages in the console.
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ summary(t, e, s = console.log) {
        if (!this.built) throw new E("This model has never been called, thus its weights have not been created yet. So no summary can be displayed. Build the model first (e.g., by calling it on some test data).");
        UL(this, t, e, s);
    }
    /**
   * Configures and prepares the model for training and evaluation.  Compiling
   * outfits the model with an optimizer, loss, and/or metrics.  Calling `fit`
   * or `evaluate` on an un-compiled model will throw an error.
   *
   * @param args a `ModelCompileArgs` specifying the loss, optimizer, and
   * metrics to be used for fitting and evaluating this model.
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ compile(t) {
        if (t.loss == null && (t.loss = []), this.loss = t.loss, typeof t.optimizer == "string") this.optimizer_ = _L(t.optimizer), this.isOptimizerOwned = !0;
        else {
            if (!(t.optimizer instanceof eo)) throw new E("User-defined optimizer must be an instance of tf.Optimizer.");
            this.optimizer_ = t.optimizer, this.isOptimizerOwned = !1;
        }
        let e = [];
        if (!Array.isArray(t.loss) && typeof t.loss != "string" && typeof t.loss != "function") {
            t.loss = t.loss;
            for(const i in t.loss)if (this.outputNames.indexOf(i) === -1) throw new E(`Unknown entry in loss dictionary: "${i}". Only expected the following keys: ${this.outputNames}`);
            for (const i of this.outputNames)t.loss[i] == null && console.warn(`Output "${i}" is missing from loss dictionary. We assume this was done on purpose, and we will not be expecting data to be passed to ${i} during training`), e.push(Fu(t.loss[i]));
        } else if (Array.isArray(t.loss)) {
            if (t.loss.length !== this.outputs.length) throw new E(`When passing an Array as loss, it should have one entry per model output. The model has ${this.outputs.length} output(s), but you passed loss=${t.loss}.`);
            e = t.loss.map((a)=>Fu(a));
        } else {
            const i = Fu(t.loss);
            this.outputs.forEach((a)=>{
                e.push(i);
            });
        }
        this.lossFunctions = e, this.feedOutputNames = [], this.feedOutputShapes = [], this.feedLossFns = [];
        for(let i = 0; i < this.outputs.length; ++i){
            const a = this.internalOutputShapes[i], l = this.outputNames[i];
            this.feedOutputNames.push(l), this.feedOutputShapes.push(a), this.feedLossFns.push(this.lossFunctions[i]);
        }
        const s = [];
        this.metrics = t.metrics, this.metricsNames = [
            "loss"
        ], this.metricsTensors = [], wo("loss", ()=>{
            for(let i = 0; i < this.outputs.length; ++i){
                if (s.indexOf(i) !== -1) continue;
                const a = this.lossFunctions[i];
                this.outputs.length > 1 && (this.metricsTensors.push([
                    a,
                    i
                ]), this.metricsNames.push(this.outputNames[i] + "_loss"));
            }
        });
        const o = d3(t.metrics, this.outputNames), r = (i, a, l)=>{
            this.outputNames.length > 1 && (a = this.outputNames[i] + "_" + a), this.metricsNames.push(a), this.metricsTensors.push([
                l,
                i
            ]);
        };
        wo("metric", ()=>{
            for(let i = 0; i < this.outputs.length; ++i){
                if (s.indexOf(i) !== -1) continue;
                const a = o[i];
                ((c)=>{
                    const u = "";
                    let d, h, p;
                    for (const f of c){
                        if (typeof f == "string" && [
                            "accuracy",
                            "acc",
                            "crossentropy",
                            "ce"
                        ].indexOf(f) !== -1) {
                            const g = this.internalOutputShapes[i];
                            g[g.length - 1] === 1 || this.lossFunctions[i] === du ? [
                                "accuracy",
                                "acc"
                            ].indexOf(f) !== -1 ? h = Hx : [
                                "crossentropy",
                                "ce"
                            ].indexOf(f) !== -1 && (h = VL) : this.lossFunctions[i] === El ? [
                                "accuracy",
                                "acc"
                            ].indexOf(f) !== -1 ? h = zL : [
                                "crossentropy",
                                "ce"
                            ].indexOf(f) !== -1 && (h = Qx) : [
                                "accuracy",
                                "acc"
                            ].indexOf(f) !== -1 ? h = _x : [
                                "crossentropy",
                                "ce"
                            ].indexOf(f) !== -1 && (h = Yx);
                            let b;
                            [
                                "accuracy",
                                "acc"
                            ].indexOf(f) !== -1 ? b = "acc" : [
                                "crossentropy",
                                "ce"
                            ].indexOf(f) !== -1 && (b = "ce"), p = h, d = u + b;
                        } else p = HL(f), d = u + Ua(f);
                        let m;
                        wo(d, ()=>{
                            m = p;
                        }), r(i, d, m);
                    }
                })(a);
            }
        }), this.collectedTrainableWeights = this.trainableWeights;
    }
    /**
   * Check trainable weights count consistency.
   *
   * This will raise a warning if `this.trainableWeights` and
   * `this.collectedTrainableWeights` are inconsistent (i.e., have different
   * numbers of parameters).
   * Inconsistency will typically arise when one modifies `model.trainable`
   * without calling `model.compile()` again.
   */ checkTrainableWeightsConsistency() {
        this.collectedTrainableWeights != null && this.trainableWeights.length !== this.collectedTrainableWeights.length && console.warn("Discrepancy between trainableweights and collected trainable weights. Did you set `model.trainable` without calling `model.compile()` afterwards?");
    }
    /**
   * Returns the loss value & metrics values for the model in test mode.
   *
   * Loss and metrics are specified during `compile()`, which needs to happen
   * before calls to `evaluate()`.
   *
   * Computation is done in batches.
   *
   * ```js
   * const model = tf.sequential({
   *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
   * });
   * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
   * const result = model.evaluate(
   *     tf.ones([8, 10]), tf.ones([8, 1]), {batchSize: 4});
   * result.print();
   * ```
   *
   * @param x `tf.Tensor` of test data, or an `Array` of `tf.Tensor`s if the
   * model has multiple inputs.
   * @param y `tf.Tensor` of target data, or an `Array` of `tf.Tensor`s if the
   * model has multiple outputs.
   * @param args A `ModelEvaluateArgs`, containing optional fields.
   *
   * @return `Scalar` test loss (if the model has a single output and no
   *   metrics) or `Array` of `Scalar`s (if the model has multiple outputs
   *   and/or metrics). The attribute `model.metricsNames`
   *   will give you the display labels for the scalar outputs.
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ evaluate(t, e, s = {}) {
        const o = s.batchSize == null ? 32 : s.batchSize;
        Vu(o);
        const i = this.standardizeUserDataXY(t, e, !0, o);
        try {
            const a = i[0].concat(i[1]);
            this.makeTestFunction();
            const l = this.testFunction, c = this.testLoop(l, a, o, s.verbose, s.steps);
            return Xe(c);
        } finally{
            Mn(i[0], t), Mn(i[1], e);
        }
    }
    // TODO(cais): Add code snippet below once real dataset objects are
    //   available.
    /**
   * Evaluate model using a dataset object.
   *
   * Note: Unlike `evaluate()`, this method is asynchronous (`async`).
   *
   * @param dataset A dataset object. Its `iterator()` method is expected
   *   to generate a dataset iterator object, the `next()` method of which
   *   is expected to produce data batches for evaluation. The return value
   *   of the `next()` call ought to contain a boolean `done` field and a
   *   `value` field. The `value` field is expected to be an array of two
   *   `tf.Tensor`s or an array of two nested `tf.Tensor` structures. The former
   *   case is for models with exactly one input and one output (e.g.
   *   a sequential model). The latter case is for models with multiple
   *   inputs and/or multiple outputs. Of the two items in the array, the
   *   first is the input feature(s) and the second is the output target(s).
   * @param args A configuration object for the dataset-based evaluation.
   * @returns Loss and metric values as an Array of `Scalar` objects.
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ async evaluateDataset(t, e) {
        return this.makeTestFunction(), a3(this, t, e);
    }
    /**
   * Get number of samples provided for training, evaluation or prediction.
   *
   * @param ins Input `tf.Tensor`.
   * @param batchSize Integer batch size, optional.
   * @param steps Total number of steps (batches of samples) before
   * declaring loop finished. Optional.
   * @param stepsName The public API's parameter name for `steps`.
   * @returns Number of samples provided.
   */ checkNumSamples(t, e, s, o = "steps") {
        let r;
        if (s != null) {
            if (r = null, e != null) throw new E(`If ${o} is set, batchSize must be null or undefined.Got batchSize = ${e}`);
        } else if (t != null) Array.isArray(t) ? r = t[0].shape[0] : r = t.shape[0];
        else throw new E(`Either the input data should have a defined shape, or ${o} shoud be specified.`);
        return r;
    }
    /**
   * Execute internal tensors of the model with input data feed.
   * @param inputs Input data feed. Must match the inputs of the model.
   * @param outputs Names of the output tensors to be fetched. Must match
   *   names of the SymbolicTensors that belong to the graph.
   * @returns Fetched values for `outputs`.
   */ execute(t, e) {
        if (Array.isArray(e) && e.length === 0) throw new E("`outputs` is an empty Array, which is not allowed.");
        const s = Array.isArray(e), o = s ? e : [
            e
        ], r = this.retrieveSymbolicTensors(o), i = new Ds();
        if (t instanceof Mt && (t = [
            t
        ]), Array.isArray(t)) {
            if (t.length !== this.inputs.length) throw new E(`The number of inputs provided (${t.length}) does not match the number of inputs of this model (${this.inputs.length}).`);
            for(let l = 0; l < this.inputs.length; ++l)i.add(this.inputs[l], t[l]);
        } else for (const l of this.inputs){
            const c = t[l.name];
            if (c == null) throw new E(`No value is provided for the model's input ${l.name}`);
            i.add(l, c);
        }
        const a = Yr(r, i);
        return s ? a : a[0];
    }
    /**
   * Retrieve the model's internal symbolic tensors from symbolic-tensor names.
   */ retrieveSymbolicTensors(t) {
        const e = Wo(null, t.length);
        let s = t.length;
        for (const o of this.layers){
            const r = Array.isArray(o.output) ? o.output : [
                o.output
            ], i = r.map((a)=>a.name);
            for(let a = 0; a < t.length; ++a){
                const l = i.indexOf(t[a]);
                if (l !== -1 && (e[a] = r[l], s--), s === 0) break;
            }
            if (s === 0) break;
        }
        if (s > 0) {
            const o = [];
            throw e.forEach((r, i)=>{
                r == null && o.push(t[i]);
            }), new E(`Cannot find SymbolicTensors for output name(s): ${JSON.stringify(o)}`);
        }
        return e;
    }
    /**
   * Helper method to loop over some data in batches.
   *
   * Porting Note: Not using the functional approach in the Python equivalent
   *   due to the imperative backend.
   * Porting Note: Does not support step mode currently.
   *
   * @param ins: input data
   * @param batchSize: integer batch size.
   * @param verbose: verbosity model
   * @returns: Predictions as `tf.Tensor` (if a single output) or an `Array` of
   *   `tf.Tensor` (if multipe outputs).
   */ predictLoop(t, e = 32, s = !1) {
        return D(()=>{
            const o = this.checkNumSamples(t);
            if (s) throw new yt("Verbose predictLoop() is not implemented yet.");
            const r = zu(o, e), i = this.outputs.map((a)=>[]);
            for(let a = 0; a < r.length; ++a)D(()=>{
                const c = r[a][0], u = r[a][1], d = Xr(t, c, u), h = [];
                if (Array.isArray(d)) for(let f = 0; f < d.length; ++f)h.push({
                    key: this.inputs[f],
                    value: d[f]
                });
                else h.push({
                    key: this.inputs[0],
                    value: d
                });
                const p = new Ds(h);
                return Yr(this.outputs, p);
            }).forEach((c, u)=>i[u].push(c));
            return Xe(i.map((a)=>Ge(a, 0)));
        });
    }
    /**
   * Generates output predictions for the input samples.
   *
   * Computation is done in batches.
   *
   * Note: the "step" mode of predict() is currently not supported.
   *   This is because the TensorFlow.js core backend is imperative only.
   *
   * ```js
   * const model = tf.sequential({
   *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
   * });
   * model.predict(tf.ones([8, 10]), {batchSize: 4}).print();
   * ```
   *
   * @param x The input data, as a Tensor, or an `Array` of `tf.Tensor`s if
   *   the model has multiple inputs.
   * @param args A `ModelPredictArgs` object containing optional fields.
   *
   * @return Prediction results as a `tf.Tensor`(s).
   *
   * @exception ValueError In case of mismatch between the provided input data
   *   and the model's expectations, or in case a stateful model receives a
   *   number of samples that is not a multiple of the batch size.
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ predict(t, e = {}) {
        const s = ny(t);
        og(s, this.inputNames, this.feedInputShapes, !1);
        try {
            const o = e.batchSize == null ? 32 : e.batchSize;
            return Vu(o), this.predictLoop(s, o);
        } finally{
            Mn(s, t);
        }
    }
    /**
   * Returns predictions for a single batch of samples.
   *
   * ```js
   * const model = tf.sequential({
   *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
   * });
   * model.predictOnBatch(tf.ones([8, 10])).print();
   * ```
   * @param x: Input samples, as a Tensor (for models with exactly one
   *   input) or an array of Tensors (for models with more than one input).
   * @return Tensor(s) of predictions
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ predictOnBatch(t) {
        og(t, this.inputNames, this.feedInputShapes, !0);
        const e = (Array.isArray(t) ? t[0] : t).shape[0];
        return this.predictLoop(t, e);
    }
    standardizeUserDataXY(t, e, s = !0, o) {
        if (this.optimizer_ == null) throw new Sn("You must compile a model before training/testing. Use LayersModel.compile(modelCompileArgs).");
        const r = [];
        for(let i = 0; i < this.feedOutputShapes.length; ++i){
            const a = this.feedOutputShapes[i];
            this.feedLossFns[i] === El ? r.push(a.slice(0, a.length - 1).concat([
                1
            ])) : r.push(a);
        }
        if (t = sg(t, this.feedInputNames, this.feedInputShapes, !1, "input"), e = sg(e, this.feedOutputNames, r, !1, "target"), c3(t, e), u3(e, this.feedLossFns, this.feedOutputShapes), this.stateful && o != null && o > 0 && t[0].shape[0] % o !== 0) throw new E(`In a stateful network, you should only pass inputs with a number of samples that is divisible by the batch size ${o}. Found: ${t[0].shape[0]} sample(s).`);
        return [
            t,
            e
        ];
    }
    async standardizeUserData(t, e, s, o, r = !0, i) {
        const [a, l] = this.standardizeUserDataXY(t, e, r, i);
        if (s != null) throw new Error("sample weight is not supported yet.");
        let c = null;
        if (o != null) {
            const u = qx(o, this.outputNames);
            c = [];
            for(let d = 0; d < u.length; ++d)c.push(await ty(l[d], null, u[d]));
        }
        return [
            a,
            l,
            c
        ];
    }
    /**
   * Loop over some test data in batches.
   * @param f A Function returning a list of tensors.
   * @param ins Array of tensors to be fed to `f`.
   * @param batchSize Integer batch size or `null` / `undefined`.
   * @param verbose verbosity mode.
   * @param steps Total number of steps (batches of samples) before
   * declaring test finished. Ignored with the default value of `null` /
   * `undefined`.
   * @returns Array of Scalars.
   */ testLoop(t, e, s, o = 0, r) {
        return D(()=>{
            const i = this.checkNumSamples(e, s, r, "steps"), a = [];
            if (o > 0) throw new yt("Verbose mode is not implemented yet.");
            if (r != null) throw new yt("steps mode in testLoop() is not implemented yet");
            {
                const l = zu(i, s), c = Ze(Kn(0, i));
                for(let u = 0; u < l.length; ++u){
                    const d = l[u][0], h = l[u][1], p = Io(c, d, h - d), f = Wd(e, p), m = t(f);
                    if (u === 0) for(let g = 0; g < m.length; ++g)a.push(gt(0));
                    for(let g = 0; g < m.length; ++g){
                        const b = m[g];
                        a[g] = U(a[g], G(h - d, b));
                    }
                }
                for(let u = 0; u < a.length; ++u)a[u] = ut(a[u], i);
            }
            return a;
        });
    }
    getDedupedMetricsNames() {
        const t = this.metricsNames, e = [];
        for(let s = 0; s < t.length; ++s){
            const o = t[s];
            let r = o;
            if (Xm(t, o) > 1) {
                const i = Xm(t.slice(0, s), o);
                r += `_${i}`;
            }
            e.push(r);
        }
        return e;
    }
    /**
   * Creates a function that performs the following actions:
   *
   * 1. computes the losses
   * 2. sums them to get the total loss
   * 3. call the optimizer computes the gradients of the LayersModel's
   *    trainable weights w.r.t. the total loss and update the variables
   * 4. calculates the metrics
   * 5. returns the values of the losses and metrics.
   */ makeTrainFunction() {
        return (t)=>{
            const e = [], s = t.slice(0, this.inputs.length), o = t.slice(this.inputs.length, this.inputs.length + this.outputs.length), r = t.slice(this.inputs.length + this.outputs.length, this.inputs.length + this.outputs.length * 2), i = [], a = ()=>{
                const d = [];
                for(let m = 0; m < this.inputs.length; ++m)d.push({
                    key: this.inputs[m],
                    value: s[m]
                });
                const h = new Ds(d), p = Yr(this.outputs, h, {
                    training: !0
                });
                let f;
                for(let m = 0; m < this.lossFunctions.length; ++m){
                    const g = this.lossFunctions[m];
                    let b = g(o[m], p[m]);
                    r[m] != null && (b = e3(b, r[m]));
                    const x = oe(b);
                    e.push(x), m === 0 ? f = b : f = U(f, b);
                }
                for(let m = 0; m < this.metricsTensors.length; ++m){
                    let g;
                    if (this.outputs.length > 1 && m < this.outputs.length) g = e[m];
                    else {
                        const b = this.metricsTensors[m][0], x = this.metricsTensors[m][1];
                        g = oe(b(o[x], p[x]));
                    }
                    hn(g), i.push(g);
                }
                return f = oe(f), this.calculateLosses().forEach((m)=>{
                    f = U(f, m);
                }), f;
            }, l = this.collectedTrainableWeights.map((d)=>d.read());
            return [
                this.optimizer_.minimize(a, !0, l)
            ].concat(i);
        };
    }
    /**
   * Create a function which, when invoked with an array of `tf.Tensor`s as a
   * batch of inputs, returns the prespecified loss and metrics of the model
   * under the batch of input data.
   */ makeTestFunction() {
        this.testFunction = (t)=>D(()=>{
                const e = [];
                let s;
                const o = t.slice(0, this.inputs.length), r = t.slice(this.inputs.length, this.inputs.length + this.outputs.length), i = [];
                for(let c = 0; c < this.inputs.length; ++c)i.push({
                    key: this.inputs[c],
                    value: o[c]
                });
                const a = new Ds(i), l = Yr(this.outputs, a);
                for(let c = 0; c < this.lossFunctions.length; ++c){
                    const u = this.lossFunctions[c], d = oe(u(r[c], l[c]));
                    c === 0 ? s = d : s = U(s, d), e.push(s);
                }
                for(let c = 0; c < this.metricsTensors.length; ++c){
                    const u = this.metricsTensors[c][0], d = this.metricsTensors[c][1], h = oe(u(r[d], l[d]));
                    e.push(h);
                }
                return e;
            });
    }
    /**
   * Trains the model for a fixed number of epochs (iterations on a
   * dataset).
   *
   * ```js
   * const model = tf.sequential({
   *     layers: [tf.layers.dense({units: 1, inputShape: [10]})]
   * });
   * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
   * for (let i = 1; i < 5 ; ++i) {
   *   const h = await model.fit(tf.ones([8, 10]), tf.ones([8, 1]), {
   *       batchSize: 4,
   *       epochs: 3
   *   });
   *   console.log("Loss after Epoch " + i + " : " + h.history.loss[0]);
   * }
   * ```
   *
   * @param x `tf.Tensor` of training data, or an array of `tf.Tensor`s if the
   * model has multiple inputs. If all inputs in the model are named, you
   * can also pass a dictionary mapping input names to `tf.Tensor`s.
   * @param y `tf.Tensor` of target (label) data, or an array of `tf.Tensor`s if
   * the model has multiple outputs. If all outputs in the model are named,
   * you can also pass a dictionary mapping output names to `tf.Tensor`s.
   * @param args A `ModelFitArgs`, containing optional fields.
   *
   * @return A `History` instance. Its `history` attribute contains all
   *   information collected during training.
   *
   * @exception ValueError In case of mismatch between the provided input
   * data and what the model expects.
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ async fit(t, e, s = {}) {
        if (this.isTraining) throw new Error("Cannot start training because another fit() call is ongoing.");
        this.isTraining = !0;
        let o, r, i, a, l, c, u, d, h;
        try {
            const p = s.batchSize == null ? 32 : s.batchSize;
            Vu(p);
            const m = await this.standardizeUserData(t, e, s.sampleWeight, s.classWeight, !1, p);
            o = m[0], r = m[1], h = m[2];
            let g = !1, b;
            if (s.validationData != null && s.validationData.length > 0) {
                if (g = !0, s.validationData.length === 2) l = s.validationData[0], c = s.validationData[1];
                else throw s.validationData.length === 3 ? new yt("validationData including sample weights is not supported yet.") : new E(`When passing validation data, it must contain 2 (valX, valY) or 3 (valX, valY, valSampleWeight) items; ${s.validationData} is invalid.`);
                const R = await this.standardizeUserData(l, c, null, /** Unused sample weights. */ null, !0, p);
                u = R[0], d = R[1], b = u.concat(d);
            } else if (s.validationSplit != null && s.validationSplit > 0 && s.validationSplit < 1) {
                g = !0;
                const N = Math.floor(o[0].shape[0] * (1 - s.validationSplit)), R = o[0].shape[0];
                u = Xr(o, N, R), i = o, o = Xr(o, 0, N), d = Xr(r, N, R), a = r, r = Xr(r, 0, N), b = u.concat(d);
            } else s.validationSteps != null && (g = !0);
            const x = o.concat(r).concat(h);
            this.checkTrainableWeightsConsistency();
            const w = this.makeTrainFunction(), y = this.getDedupedMetricsNames();
            let I, v;
            g ? (this.makeTestFunction(), I = this.testFunction, v = y.slice().concat(y.map((N)=>"val_" + N))) : (I = null, b = [], v = y.slice());
            const k = Kx(s.callbacks, s.yieldEvery);
            return await this.fitLoop(w, x, y, p, s.epochs, s.verbose, k, I, b, s.shuffle, v, s.initialEpoch, null, null);
        } finally{
            this.isTraining = !1, Mn(o, t), Mn(r, e), Mn(i, t), Mn(a, e), Mn(u, l), Mn(d, c), h != null && xt(h);
        }
    }
    /**
   * Abstract fit function for `f(ins)`.
   * @param f A Function returning a list of tensors. For training, this
   *   function is expected to perform the updates to the variables.
   * @param ins List of tensors to be fed to `f`.
   * @param outLabels List of strings, display names of the outputs of `f`.
   * @param batchSize Integer batch size or `== null` if unknown. Default : 32.
   * @param epochs Number of times to iterate over the data. Default : 1.
   * @param verbose Verbosity mode: 0, 1, or 2. Default: 1.
   * @param callbacks List of callbacks to be called during training.
   * @param valF Function to call for validation.
   * @param valIns List of tensors to be fed to `valF`.
   * @param shuffle Whether to shuffle the data at the beginning of every
   * epoch. Default : true.
   * @param callbackMetrics List of strings, the display names of the metrics
   *   passed to the callbacks. They should be the concatenation of the
   *   display names of the outputs of `f` and the list of display names
   *   of the outputs of `valF`.
   * @param initialEpoch Epoch at which to start training (useful for
   *   resuming a previous training run). Default : 0.
   * @param stepsPerEpoch Total number of steps (batches on samples) before
   *   declaring one epoch finished and starting the next epoch. Ignored with
   *   the default value of `undefined` or `null`.
   * @param validationSteps Number of steps to run validation for (only if
   *   doing validation from data tensors). Not applicable for tfjs-layers.
   * @returns A `History` object.
   */ async fitLoop(t, e, s, o, r, i, a, l, c, u, d, h, p, f) {
        o == null && (o = 32), r == null && (r = 1), u == null && (u = !0), h == null && (h = 0);
        let m = !1;
        if (l != null && c != null && (m = !0), f != null && (m = !0, p == null)) throw new E("Can only use `validationSteps` when doing step-wise training, i.e., `stepsPerEpoch` must be set.");
        const g = this.checkNumSamples(e, o, p, "steps_per_epoch");
        let b;
        g != null && (b = Kn(0, g)), i == null && (i = 1);
        const { callbackList: x, history: w } = Zx(a, i, r, h, g, p, o, m, d);
        x.setModel(this), this.history = w, await x.onTrainBegin(), this.stopTraining_ = !1;
        for(let y = h; y < r; ++y){
            await x.onEpochBegin(y);
            const I = {};
            if (p != null) throw new yt("stepsPerEpoch mode is not implemented yet.");
            {
                if (u === "batch") throw new yt("batch shuffling is not implemneted yet");
                u && Ud(b);
                const v = Ze(b), k = zu(g, o);
                for(let S = 0; S < k.length; ++S){
                    const N = {};
                    if (await x.onBatchBegin(S, N), D(()=>{
                        const R = k[S][0], M = k[S][1], V = Io(v, R, M - R);
                        N.batch = S, N.size = M - R;
                        const z = Wd(e, V), P = t(z);
                        for(let A = 0; A < s.length; ++A){
                            const O = s[A], B = P[A];
                            N[O] = B, hn(B);
                        }
                        if (S === k.length - 1 && m) {
                            const A = this.testLoop(l, c, o);
                            for(let O = 0; O < s.length; ++O){
                                const B = s[O], Z = A[O];
                                hn(Z), I["val_" + B] = Z;
                            }
                        }
                    }), await x.onBatchEnd(S, N), Xx(N), this.stopTraining_) break;
                }
                v.dispose();
            }
            if (await x.onEpochEnd(y, I), this.stopTraining_) break;
        }
        return await x.onTrainEnd(), await this.history.syncData(), this.history;
    }
    // TODO(cais): Add code snippet below when it's possible to instantiate
    //   actual dataset objects.
    /**
   * Trains the model using a dataset object.
   *
   * @param dataset A dataset object. Its `iterator()` method is expected
   *   to generate a dataset iterator object, the `next()` method of which
   *   is expected to produce data batches for training. The return value
   *   of the `next()` call ought to contain a boolean `done` field and a
   *   `value` field. The `value` field is expected to be an array of two
   *   `tf.Tensor`s or an array of two nested `tf.Tensor` structures. The former
   *   case is for models with exactly one input and one output (e.g.
   *   a sequential model). The latter case is for models with multiple
   *   inputs and/or multiple outputs.
   *   Of the two items in the array, the first is the input feature(s) and
   *   the second is the output target(s).
   * @param args A `ModelFitDatasetArgs`, containing optional fields.
   *
   * @return A `History` instance. Its `history` attribute contains all
   *   information collected during training.
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ async fitDataset(t, e) {
        return o3(this, t, e);
    }
    /**
   * Runs a single gradient update on a single batch of data.
   *
   * This method differs from `fit()` and `fitDataset()` in the following
   * regards:
   *   - It operates on exactly one batch of data.
   *   - It returns only the loss and metric values, instead of
   *     returning the batch-by-batch loss and metric values.
   *   - It doesn't support fine-grained options such as verbosity and
   *     callbacks.
   *
   * @param x Input data. It could be one of the following:
   *   - A `tf.Tensor`, or an Array of `tf.Tensor`s (in case the model has
   *     multiple inputs).
   *   - An Object mapping input names to corresponding `tf.Tensor` (if the
   *     model has named inputs).
   * @param y Target data. It could be either a `tf.Tensor` or multiple
   *   `tf.Tensor`s. It should be consistent with `x`.
   * @returns Training loss or losses (in case the model has
   *   multiple outputs), along with metrics (if any), as numbers.
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ async trainOnBatch(t, e) {
        const s = await this.standardizeUserData(t, e), o = s[0], r = s[1], a = this.makeTrainFunction()(o.concat(r)), l = [];
        for (const c of a){
            const u = await c.data();
            l.push(u[0]);
        }
        return xt(a), Mn(s[0], t), Mn(s[1], e), Xe(l);
    }
    /**
   * Extract weight values of the model.
   *
   * @param config: An instance of `io.SaveConfig`, which specifies
   * model-saving options such as whether only trainable weights are to be
   * saved.
   * @returns A `NamedTensorMap` mapping original weight names (i.e.,
   *   non-uniqueified weight names) to their values.
   */ getNamedWeights(t) {
        const e = [], s = t != null && t.trainableOnly, o = s ? this.trainableWeights : this.weights, r = this.getWeights(s);
        for(let i = 0; i < o.length; ++i)s && !o[i].trainable || e.push({
            name: o[i].originalName,
            tensor: r[i]
        });
        return e;
    }
    /**
   * Setter used for force stopping of LayersModel.fit() (i.e., training).
   *
   * Example:
   *
   * ```js
   * const input = tf.input({shape: [10]});
   * const output = tf.layers.dense({units: 1}).apply(input);
   * const model = tf.model({inputs: [input], outputs: [output]});
   * model.compile({loss: 'meanSquaredError', optimizer: 'sgd'});
   * const xs = tf.ones([8, 10]);
   * const ys = tf.zeros([8, 1]);
   *
   * const history = await model.fit(xs, ys, {
   *   epochs: 10,
   *   callbacks: {
   *     onEpochEnd: async (epoch, logs) => {
   *       if (epoch === 2) {
   *         model.stopTraining = true;
   *       }
   *     }
   *   }
   * });
   *
   * // There should be only 3 values in the loss array, instead of 10
   * values,
   * // due to the stopping after 3 epochs.
   * console.log(history.history.loss);
   * ```
   */ set stopTraining(t) {
        this.stopTraining_ = t;
    }
    get stopTraining() {
        return this.stopTraining_;
    }
    get optimizer() {
        return this.optimizer_;
    }
    set optimizer(t) {
        this.optimizer_ !== t && (this.optimizer_ = t, this.isOptimizerOwned = !1);
    }
    dispose() {
        const t = super.dispose();
        if (t.refCountAfterDispose === 0 && this.optimizer != null && this.isOptimizerOwned) {
            const e = wl().numTensors;
            this.optimizer_.dispose(), t.numDisposedVariables += e - wl().numTensors;
        }
        return t;
    }
    getLossIdentifiers() {
        let t;
        if (typeof this.loss == "string") t = us(this.loss);
        else if (Array.isArray(this.loss)) {
            for (const e of this.loss)if (typeof e != "string") throw new Error("Serialization of non-string loss is not supported.");
            t = this.loss.map((e)=>us(e));
        } else {
            const e = Object.keys(this.loss);
            t = {};
            const s = this.loss;
            for (const o of e)if (typeof s[o] == "string") t[o] = us(s[o]);
            else throw new Error("Serialization of non-string loss is not supported.");
        }
        return t;
    }
    getMetricIdentifiers() {
        if (typeof this.metrics == "string" || typeof this.metrics == "function") return [
            us(Ua(this.metrics))
        ];
        if (Array.isArray(this.metrics)) return this.metrics.map((t)=>us(Ua(t)));
        {
            const t = {};
            for(const e in this.metrics)t[e] = us(Ua(this.metrics[e]));
            return t;
        }
    }
    getTrainingConfig() {
        return {
            loss: this.getLossIdentifiers(),
            metrics: this.getMetricIdentifiers(),
            optimizer_config: {
                class_name: this.optimizer.getClassName(),
                config: this.optimizer.getConfig()
            }
        };
    }
    loadTrainingConfig(t) {
        if (t.weighted_metrics != null) throw new Error("Loading weight_metrics is not supported yet.");
        if (t.loss_weights != null) throw new Error("Loading loss_weights is not supported yet.");
        if (t.sample_weight_mode != null) throw new Error("Loading sample_weight_mode is not supported yet.");
        const e = fi(t.optimizer_config), s = An(e);
        let o;
        if (typeof t.loss == "string") o = ho(t.loss);
        else if (Array.isArray(t.loss)) o = t.loss.map((i)=>ho(i));
        else if (t.loss != null) {
            o = {};
            for(const i in t.loss)o[i] = ho(t.loss[i]);
        }
        let r;
        if (Array.isArray(t.metrics)) r = t.metrics.map((i)=>ho(i));
        else if (t.metrics != null) {
            r = {};
            for(const i in t.metrics)r[i] = ho(t.metrics[i]);
        }
        this.compile({
            loss: o,
            metrics: r,
            optimizer: s
        });
    }
    /**
   * Save the configuration and/or weights of the LayersModel.
   *
   * An `IOHandler` is an object that has a `save` method of the proper
   * signature defined. The `save` method manages the storing or
   * transmission of serialized data ("artifacts") that represent the
   * model's topology and weights onto or via a specific medium, such as
   * file downloads, local storage, IndexedDB in the web browser and HTTP
   * requests to a server. TensorFlow.js provides `IOHandler`
   * implementations for a number of frequently used saving mediums, such as
   * `tf.io.browserDownloads` and `tf.io.browserLocalStorage`. See `tf.io`
   * for more details.
   *
   * This method also allows you to refer to certain types of `IOHandler`s
   * as URL-like string shortcuts, such as 'localstorage://' and
   * 'indexeddb://'.
   *
   * Example 1: Save `model`'s topology and weights to browser [local
   * storage](https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage);
   * then load it back.
   *
   * ```js
   * const model = tf.sequential(
   *     {layers: [tf.layers.dense({units: 1, inputShape: [3]})]});
   * console.log('Prediction from original model:');
   * model.predict(tf.ones([1, 3])).print();
   *
   * const saveResults = await model.save('localstorage://my-model-1');
   *
   * const loadedModel = await tf.loadLayersModel('localstorage://my-model-1');
   * console.log('Prediction from loaded model:');
   * loadedModel.predict(tf.ones([1, 3])).print();
   * ```
   *
   * Example 2. Saving `model`'s topology and weights to browser
   * [IndexedDB](https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API);
   * then load it back.
   *
   * ```js
   * const model = tf.sequential(
   *     {layers: [tf.layers.dense({units: 1, inputShape: [3]})]});
   * console.log('Prediction from original model:');
   * model.predict(tf.ones([1, 3])).print();
   *
   * const saveResults = await model.save('indexeddb://my-model-1');
   *
   * const loadedModel = await tf.loadLayersModel('indexeddb://my-model-1');
   * console.log('Prediction from loaded model:');
   * loadedModel.predict(tf.ones([1, 3])).print();
   * ```
   *
   * Example 3. Saving `model`'s topology and weights as two files
   * (`my-model-1.json` and `my-model-1.weights.bin`) downloaded from
   * browser.
   *
   * ```js
   * const model = tf.sequential(
   *     {layers: [tf.layers.dense({units: 1, inputShape: [3]})]});
   * const saveResults = await model.save('downloads://my-model-1');
   * ```
   *
   * Example 4. Send  `model`'s topology and weights to an HTTP server.
   * See the documentation of `tf.io.http` for more details
   * including specifying request parameters and implementation of the
   * server.
   *
   * ```js
   * const model = tf.sequential(
   *     {layers: [tf.layers.dense({units: 1, inputShape: [3]})]});
   * const saveResults = await model.save('http://my-server/model/upload');
   * ```
   *
   * @param handlerOrURL An instance of `IOHandler` or a URL-like,
   * scheme-based string shortcut for `IOHandler`.
   * @param config Options for saving the model.
   * @returns A `Promise` of `SaveResult`, which summarizes the result of
   * the saving, such as byte sizes of the saved artifacts for the model's
   *   topology and weight values.
   *
   * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
   */ async save(t, e) {
        if (typeof t == "string") {
            const c = Z2(t);
            if (c.length === 0) throw new E(`Cannot find any save handlers for URL '${t}'`);
            if (c.length > 1) throw new E(`Found more than one (${c.length}) save handlers for URL '${t}'`);
            t = c[0];
        }
        if (t.save == null) throw new E("LayersModel.save() cannot proceed because the IOHandler provided does not have the `save` attribute defined.");
        const s = await Cm(this.getNamedWeights(e)), a = {
            modelTopology: this.toJSON(null, !1),
            format: h3,
            generatedBy: `TensorFlow.js tfjs-layers v${jx}`,
            convertedBy: null
        };
        if ((e == null ? !1 : e.includeOptimizer) && this.optimizer != null) {
            a.trainingConfig = this.getTrainingConfig();
            const c = "optimizer", { data: u, specs: d } = await Cm(await this.optimizer.getWeights(), c);
            s.specs.push(...d), s.data = F2([
                s.data,
                u
            ]);
        }
        return this.userDefinedMetadata != null && (qm(this.userDefinedMetadata, this.name, !0), a.userDefinedMetadata = this.userDefinedMetadata), a.weightData = s.data, a.weightSpecs = s.specs, t.save(a);
    }
    /**
   * Set user-defined metadata.
   *
   * The set metadata will be serialized together with the topology
   * and weights of the model during `save()` calls.
   *
   * @param setUserDefinedMetadata
   */ setUserDefinedMetadata(t) {
        qm(t, this.name), this.userDefinedMetadata = t;
    }
    /**
   * Get user-defined metadata.
   *
   * The metadata is supplied via one of the two routes:
   *   1. By calling `setUserDefinedMetadata()`.
   *   2. Loaded during model loading (if the model is constructed
   *      via `tf.loadLayersModel()`.)
   *
   * If no user-defined metadata is available from either of the
   * two routes, this function will return `undefined`.
   */ getUserDefinedMetadata() {
        return this.userDefinedMetadata;
    }
}
ur.className = "Model";
_(ur);
class sy extends ur {
}
sy.className = "Functional";
_(sy);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ async function FQ(n, t) {
    "modelTopology" in n || (n = {
        modelTopology: n
    }), n;
    let e = n.modelTopology;
    e.model_config != null && (e = e.model_config);
    const s = fi(e), o = An(s, t);
    if (n.weightsManifest != null) {
        const r = await a$(n.weightsManifest, n.pathPrefix, o.weights.map((a)=>a.originalName)), i = {};
        for (const a of o.weights)i[a.originalName] = r[a.originalName];
        o.loadWeights(i), xt(r);
    }
    return o;
}
async function VQ(n, t) {
    if (t == null && (t = {}), typeof n == "string") {
        const e = B2(n, t);
        if (e.length === 0) e.push(h$(n, t));
        else if (e.length > 1) throw new E(`Found more than one (${e.length}) load handlers for URL '${n}'`);
        n = e[0];
    }
    return p3(n, void 0, t);
}
async function p3(n, t, e) {
    if (e == null && (e = {}), n.load == null) throw new E("Cannot proceed with model loading because the IOHandler provided does not have the `load` method implemented.");
    const s = await n.load();
    let o = s.modelTopology;
    o.model_config != null && (o = o.model_config);
    const r = e.strict == null ? !0 : e.strict, i = s.weightData != null && s.weightSpecs != null && r, a = An(fi(o), t, i), l = s.trainingConfig;
    if (l != null && a.loadTrainingConfig(l), s.userDefinedMetadata != null && a.setUserDefinedMetadata(s.userDefinedMetadata), s.weightData != null) {
        if (s.weightSpecs == null) throw new E("LayersModel artifacts contains weight data, but not weight specs. Therefore loading of weights cannot proceed.");
        const { modelWeights: c, optimizerWeights: u } = f3(s.weightData, s.weightSpecs);
        a.loadWeights(c, r), a.optimizer != null && u.length > 0 && await a.optimizer.setWeights(u), xt(c), xt(u.map((d)=>d.tensor));
    }
    return a;
}
function f3(n, t) {
    const e = Ab(n, t), s = {}, o = [];
    return t.forEach((r)=>{
        r.group === "optimizer" ? o.push({
            name: r.name,
            tensor: e[r.name]
        }) : s[r.name] = e[r.name];
    }), {
        modelWeights: s,
        optimizerWeights: o
    };
}
class mi extends ur {
    constructor(t){
        if (super({
            inputs: [],
            outputs: []
        }), t = t || {}, this.trainable = !0, this.built = !1, this.name = t.name != null ? t.name : au("sequential_"), t.layers != null) for (const e of t.layers)this.add(e);
    }
    // Helper function to Sequential.add  Throws if the new output shape will be
    // invalid.
    checkShape(t) {
        if (t.inboundNodes[0].outputTensors[0].shape.some((s)=>s < 0)) throw new E(`Negative dimension size caused by adding layer ${t.name} with input shape [${t.inboundNodes[0].inputTensors[0].shape}]`);
    }
    /**
   * Adds a layer instance on top of the layer stack.
   *
   * ```js
   *  const model = tf.sequential();
   *  model.add(tf.layers.dense({units: 8, inputShape: [1]}));
   *  model.add(tf.layers.dense({units: 4, activation: 'relu6'}));
   *  model.add(tf.layers.dense({units: 1, activation: 'relu6'}));
   *  // Note that the untrained model is random at this point.
   *  model.predict(tf.randomNormal([10, 1])).print();
   * ```
   * @param layer Layer instance.
   *
   * @exception ValueError In case the `layer` argument does not know its
   * input shape.
   * @exception ValueError In case the `layer` argument has multiple output
   *   tensors, or is already connected somewhere else (forbidden in
   *   `Sequential` models).
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ add(t) {
        const e = t instanceof mi || t instanceof ur;
        let s;
        if (e) {
            if (s = t, s.outputs.length !== 1) throw new E("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
            if (s.inputs.length !== 1) throw new E("All layers in a Sequential model should have a single input tensor. For multi-input layers, use the functional API.");
        }
        if (this.outputs.length === 0) {
            if (t.inboundNodes.length === 0) {
                if (t.batchInputShape == null) throw new E("The first layer in a Sequential model must get an `inputShape` or `batchInputShape` argument.");
                const o = fL({
                    batchShape: t.batchInputShape,
                    dtype: t.dtype,
                    name: t.name + "_input"
                });
                t.apply(o);
            }
            if (e) this.outputs = s.outputs, this.inputs = s.inputs;
            else {
                if (t.inboundNodes.length !== 1) throw new E(`A layer added to a Sequential model must not already be connected somewhere else. LayersModel received layer ${t.name} which has ${t.inboundNodes.length} pre-existing inbound connections.`);
                if (t.inboundNodes[0].outputTensors.length !== 1) throw new E("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
                this.checkShape(t), this.outputs = [
                    t.inboundNodes[0].outputTensors[0]
                ], this.inputs = Vx(this.outputs[0]);
            }
            this.inboundNodes = [], new cu({
                outboundLayer: this,
                inboundLayers: [],
                nodeIndices: [],
                tensorIndices: [],
                inputTensors: this.inputs,
                outputTensors: this.outputs,
                // no model-level masking for now
                inputMasks: Wo(null, this.inputs.length),
                outputMasks: [
                    null
                ],
                inputShapes: this.inputs.map((o)=>o.shape),
                outputShapes: this.outputs[0].shape
            });
        } else {
            const o = t.apply(this.outputs[0]);
            if (Array.isArray(o)) throw new TypeError("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
            this.checkShape(t), this.outputs = [
                o
            ], this.inboundNodes[0].outputTensors = this.outputs, this.inboundNodes[0].outputShapes = [
                this.outputs[0].shape
            ];
        }
        this.layers.push(t), this.built = !1;
    }
    /**
   * Removes the last layer in the model.
   *
   * @exception TypeError if there are no layers in the model.
   */ pop() {
        if (this.layers.length === 0) throw new TypeError("There are no layers in the model.");
        if (this.layers.pop(), this.layers.length === 0) this.outputs = [], this.inboundNodes = [], this.outboundNodes = [];
        else {
            const t = this.layers.length - 1;
            this.layers[t].outboundNodes = [], this.outputs = [
                this.layers[t].output
            ], this.inboundNodes[0].outputTensors = this.outputs, this.inboundNodes[0].outputShapes = [
                this.outputs[0].shape
            ];
        }
    }
    call(t, e) {
        return this.model == null && this.build(), this.model.call(t, e);
    }
    build(t) {
        if (Rt(t), this.inputs.length === 0 || this.outputs.length === 0) throw new TypeError("Sequential model cannot be built: model is empty. Add some layers first.");
        this.model = new ur({
            inputs: this.inputs,
            outputs: this.outputs[0],
            name: this.name + "_model"
        }), this.model.trainable = this.trainable, this.supportsMasking = this.model.supportsMasking, this.inputLayers = this.model.inputLayers, this.inputLayersNodeIndices = this.model.inputLayersNodeIndices, this.inputLayersTensorIndices = this.model.inputLayersTensorIndices, this.outputLayers = this.model.outputLayers, this.outputLayersNodeIndices = this.model.outputLayersNodeIndices, this.outputLayersTensorIndices = this.model.outputLayersTensorIndices, this.nodesByDepth = this.model.nodesByDepth, this.containerNodes = this.model.containerNodes, this.outputNames = this.model.outputNames, this.inputNames = this.model.inputNames, this.built = !0;
    }
    countParams() {
        return this.built || this.build(), super.countParams();
    }
    /**
   * Print a text summary of the Sequential model's layers.
   *
   * The summary includes
   * - Name and type of all layers that comprise the model.
   * - Output shape(s) of the layers
   * - Number of weight parameters of each layer
   * - The total number of trainable and non-trainable parameters of the
   * model.
   *
   * ```js
   * const model = tf.sequential();
   * model.add(
   *     tf.layers.dense({units: 100, inputShape: [10], activation: 'relu'}));
   * model.add(tf.layers.dense({units: 1, activation: 'sigmoid'}));
   *
   * model.summary();
   * ```
   *
   * @param lineLength Custom line length, in number of characters.
   * @param positions Custom widths of each of the columns, as either
   *   fractions of `lineLength` (e.g., `[0.5, 0.75, 1]`) or absolute number
   *   of characters (e.g., `[30, 50, 65]`). Each number corresponds to
   *   right-most (i.e., ending) position of a column.
   * @param printFn Custom print function. Can be used to replace the default
   *   `console.log`. For example, you can use `x => {}` to mute the printed
   *   messages in the console.
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ summary(t, e, s = console.log) {
        this.built || this.build(), super.summary(t, e, s);
    }
    /**
   * Sets the weights of the model.
   *
   * @param weights Should be a list of Tensors with shapes and types matching
   *   the output of `model.getWeights()`.
   */ setWeights(t) {
        this.model == null && this.build(), this.model.setWeights(t);
    }
    /**
   * Returns the loss value & metrics values for the model in test mode.
   *
   * Loss and metrics are specified during `compile()`, which needs to happen
   * before calls to `evaluate()`.
   *
   * Computation is done in batches.
   *
   * ```js
   * const model = tf.sequential({
   *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
   * });
   * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
   * const result = model.evaluate(tf.ones([8, 10]), tf.ones([8, 1]), {
   *   batchSize: 4,
   * });
   * result.print();
   * ```
   *
   * @param x `tf.Tensor` of test data, or an `Array` of `tf.Tensor`s if the
   * model has multiple inputs.
   * @param y `tf.Tensor` of target data, or an `Array` of `tf.Tensor`s if the
   * model has multiple outputs.
   * @param args A `ModelEvaluateConfig`, containing optional fields.
   *
   * @return `Scalar` test loss (if the model has a single output and no
   *   metrics) or `Array` of `Scalar`s (if the model has multiple outputs
   *   and/or metrics). The attribute `model.metricsNames`
   *   will give you the display labels for the scalar outputs.
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ evaluate(t, e, s = {}) {
        if (!this.built) throw new Sn("The model needs to be compiled before being used.");
        return this.model.evaluate(t, e, s);
    }
    // TODO(cais): Add code snippet below once real dataset objects are
    //   available.
    /**
   * Evaluate model using a dataset object.
   *
   * Note: Unlike `evaluate()`, this method is asynchronous (`async`).
   *
   * @param dataset A dataset object. Its `iterator()` method is expected
   *   to generate a dataset iterator object, the `next()` method of which
   *   is expected to produce data batches for evaluation. The return value
   *   of the `next()` call ought to contain a boolean `done` field and a
   *   `value` field. The `value` field is expected to be an array of two
   *   `tf.Tensor`s or an array of two nested `tf.Tensor` structures. The former
   *   case is for models with exactly one input and one output (e.g.
   *   a sequential model). The latter case is for models with multiple
   *   inputs and/or multiple outputs. Of the two items in the array, the
   *   first is the input feature(s) and the second is the output target(s).
   * @param args A configuration object for the dataset-based evaluation.
   * @returns Loss and metric values as an Array of `Scalar` objects.
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ async evaluateDataset(t, e) {
        if (!this.built) throw new Sn("The model needs to be compiled before being used.");
        return this.model.evaluateDataset(t, e);
    }
    /**
   * Generates output predictions for the input samples.
   *
   * Computation is done in batches.
   *
   * Note: the "step" mode of predict() is currently not supported.
   *   This is because the TensorFlow.js core backend is imperative only.
   *
   * ```js
   * const model = tf.sequential({
   *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
   * });
   * model.predict(tf.ones([2, 10])).print();
   * ```
   *
   * @param x The input data, as a Tensor, or an `Array` of `tf.Tensor`s if
   *   the model has multiple inputs.
   * @param conifg A `ModelPredictConfig` object containing optional fields.
   *
   * @return `tf.Tensor`(s) of predictions.
   *
   * @exception ValueError In case of mismatch between the provided input data
   *   and the model's expectations, or in case a stateful model receives a
   *   number of samples that is not a multiple of the batch size.
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ predict(t, e = {}) {
        return this.model == null && this.build(), this.model.predict(t, e);
    }
    /**
   * Returns predictions for a single batch of samples.
   *
   * @param x: Input samples, as a Tensor, or list of Tensors (if the model
   *   has multiple inputs).
   * @return Tensor(s) of predictions
   */ predictOnBatch(t) {
        return this.model == null && this.build(), this.model.predictOnBatch(t);
    }
    /**
   * See `LayersModel.compile`.
   *
   * @param args
   */ compile(t) {
        this.build(), this.model.compile(t), this.optimizer_ = this.model.optimizer, this.isOptimizerOwned = this.model.isOptimizerOwned, this.loss = this.model.loss, this.metrics = this.model.metrics, this.metricsTensors = this.model.metricsTensors, this.metricsNames = this.model.metricsNames;
    }
    get optimizer() {
        return this.model == null ? void 0 : this.model.optimizer;
    }
    set optimizer(t) {
        this.model.optimizer = t;
    }
    /**
   * Trains the model for a fixed number of epochs (iterations on a dataset).
   *
   * ```js
   * const model = tf.sequential({
   *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
   * });
   * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
   * const history = await model.fit(tf.ones([8, 10]), tf.ones([8, 1]), {
   *   batchSize: 4,
   *   epochs: 3
   * });
   * console.log(history.history.loss[0]);
   * ```
   *
   * @param x `tf.Tensor` of training data, or an array of `tf.Tensor`s if the
   * model has multiple inputs. If all inputs in the model are named, you can
   * also pass a dictionary mapping input names to `tf.Tensor`s.
   * @param y `tf.Tensor` of target (label) data, or an array of `tf.Tensor`s if
   * the model has multiple outputs. If all outputs in the model are named, you
   *  can also pass a dictionary mapping output names to `tf.Tensor`s.
   * @param args  A `ModelFitConfig`, containing optional fields.
   *
   * @return A `History` instance. Its `history` attribute contains all
   *   information collected during training.
   *
   * @exception ValueError In case of mismatch between the provided input data
   *   and what the model expects.
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ async fit(t, e, s = {}) {
        if (!this.built) throw new Sn("The model needs to be compiled before being used.");
        return this.model.fit(t, e, s);
    }
    /**
   * Trains the model using a dataset object.
   *
   * ```js
   * const xArray = [
   *   [1, 1, 1, 1, 1, 1, 1, 1, 1],
   *   [1, 1, 1, 1, 1, 1, 1, 1, 1],
   *   [1, 1, 1, 1, 1, 1, 1, 1, 1],
   *   [1, 1, 1, 1, 1, 1, 1, 1, 1],
   * ];
   * const yArray = [1, 1, 1, 1];
   * // Create a dataset from the JavaScript array.
   * const xDataset = tf.data.array(xArray);
   * const yDataset = tf.data.array(yArray);
   * // Zip combines the `x` and `y` Datasets into a single Dataset, the
   * // iterator of which will return an object containing of two tensors,
   * // corresponding to `x` and `y`.  The call to `batch(4)` will bundle
   * // four such samples into a single object, with the same keys now pointing
   * // to tensors that hold 4 examples, organized along the batch dimension.
   * // The call to `shuffle(4)` causes each iteration through the dataset to
   * // happen in a different order.  The size of the shuffle window is 4.
   * const xyDataset = tf.data.zip({xs: xDataset, ys: yDataset})
   *     .batch(4)
   *     .shuffle(4);
   * const model = tf.sequential({
   *   layers: [tf.layers.dense({units: 1, inputShape: [9]})]
   * });
   * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
   * const history = await model.fitDataset(xyDataset, {
   *   epochs: 4,
   *   callbacks: {onEpochEnd: (epoch, logs) => console.log(logs.loss)}
   * });
   * ```
   *
   * @param dataset A dataset object. Its `iterator()` method is expected to
   *   generate a dataset iterator object, the `next()` method of which is
   *   expected to produce data batches for evaluation. The return value of the
   *   `next()` call ought to contain a boolean `done` field and a `value`
   *   field.
   *
   *   The `value` field is expected to be an object of with fields
   *   `xs` and `ys`, which point to the feature tensor and the target tensor,
   *   respectively. This case is for models with exactly one input and one
   *   output (e.g. a sequential model). For example:
   *   ```js
   *   {value: {xs: xsTensor, ys: ysTensor}, done: false}
   *   ```
   *
   *   If the model has multiple inputs, the `xs` field of `value` should
   *   be an object mapping input names to their respective feature tensors.
   *   For example:
   *   ```js
   *   {
   *     value: {
   *       xs: {
   *         input_1: xsTensor1,
   *         input_2: xsTensor2
   *       },
   *       ys: ysTensor
   *     },
   *     done: false
   *   }
   *   ```
   *   If the model has multiple outputs, the `ys` field of `value` should
   *   be an object mapping output names to their respective target tensors.
   *   For example:
   *   ```js
   *   {
   *     value: {
   *       xs: xsTensor,
   *       ys: {
   *         output_1: ysTensor1,
   *         output_2: ysTensor2
   *       },
   *     },
   *     done: false
   *   }
   *   ```
   * @param args A `ModelFitDatasetArgs`, containing optional fields.
   *
   * @return A `History` instance. Its `history` attribute contains all
   *   information collected during training.
   *
   * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
   */ async fitDataset(t, e) {
        if (!this.built) throw new Sn("The model needs to be compiled before being used.");
        return this.model.fitDataset(t, e);
    }
    /**
   * Runs a single gradient update on a single batch of data.
   *
   * This method differs from `fit()` and `fitDataset()` in the following
   * regards:
   *   - It operates on exactly one batch of data.
   *   - It returns only the loss and metric values, instead of
   *     returning the batch-by-batch loss and metric values.
   *   - It doesn't support fine-grained options such as verbosity and
   *     callbacks.
   *
   * @param x Input data. It could be one of the following:
   *   - A `tf.Tensor`, or an Array of `tf.Tensor`s (in case the model has
   *     multiple inputs).
   *   - An Object mapping input names to corresponding `tf.Tensor` (if the
   *     model has named inputs).
   * @param y Target data. It could be either a `tf.Tensor` or multiple
   *   `tf.Tensor`s. It should be consistent with `x`.
   * @returns Training loss or losses (in case the model has
   *   multiple outputs), along with metrics (if any), as numbers.
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ async trainOnBatch(t, e) {
        return this.model.trainOnBatch(t, e);
    }
    /* See parent class for JsDoc */ /** @nocollapse */ static fromConfig(t, e, s = {}, o = !1) {
        let r, i = {};
        if (e instanceof Array) {
            if (e[0].className == null || e[0].className === "Merge") throw new E("Legacy serialization format not supported yet.");
            r = e;
        } else C(e.layers != null, ()=>"When the config data for a Sequential model is not an Array, it must be an Object that contains the 'layers' field."), r = e.layers, delete e.layers, i = e;
        const a = new t(i);
        if (!(a instanceof mi)) throw new yt(`Sequential.fromConfig called on non-Sequential input: ${a}`);
        for (const l of r){
            const u = An(l, void 0, o);
            o && u.setFastWeightInitDuringBuild(!0), a.add(u);
        }
        return a;
    }
    /**
   * Setter used for force stopping of LayersModel.fit() (i.e., training).
   *
   * Example:
   *
   * ```js
   * const model = tf.sequential();
   * model.add(tf.layers.dense({units: 1, inputShape: [10]}));
   * model.compile({loss: 'meanSquaredError', optimizer: 'sgd'});
   * const xs = tf.ones([8, 10]);
   * const ys = tf.zeros([8, 1]);
   *
   * const history = await model.fit(xs, ys, {
   *   epochs: 10,
   *   callbacks: {
   *     onEpochEnd: async (epoch, logs) => {
   *       if (epoch === 2) {
   *         model.stopTraining = true;
   *       }
   *     }
   *   }
   * });
   *
   * // There should be only 3 values in the loss array, instead of 10 values,
   * // due to the stopping after 3 epochs.
   * console.log(history.history.loss);
   * ```
   */ set stopTraining(t) {
        if (this.model == null) throw new E("Cannot set the stopTraining property of a sequential model before it is compiled.");
        this.model.stopTraining = t;
    }
    get stopTraining() {
        if (this.model == null) throw new E("Cannot get the stopTraining property of a sequential model before it is compiled.");
        return this.model.stopTraining;
    }
    // TODO(cais): Override get trainableWeights() here
    // tslint:disable-next-line:no-any
    getConfig() {
        const t = [];
        for (const e of this.layers){
            const s = {};
            s.className = e.getClassName(), s.config = e.getConfig(), t.push(s);
        }
        return {
            name: this.name,
            layers: t
        };
    }
}
mi.className = "Sequential";
_(mi);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ let Ye = class extends _o {
    getConfig() {
        return {};
    }
};
class oy extends Ye {
    /**
   * Calculate the activation function.
   *
   * @param x: Input.
   * @param alpha: Scaling factor the negative section.
   * @return Output of the ELU activation.
   */ apply(t, e = 1) {
        return jE(t, e);
    }
}
oy.className = "elu";
_(oy);
class ry extends Ye {
    apply(t) {
        return h0(t);
    }
}
ry.className = "selu";
_(ry);
class iy extends Ye {
    apply(t) {
        return Ts(t);
    }
}
iy.className = "relu";
_(iy);
class ay extends Ye {
    apply(t) {
        return D(()=>br(6, Ts(t)));
    }
}
ay.className = "relu6";
_(ay);
class ly extends Ye {
    apply(t) {
        return t;
    }
}
ly.className = "linear";
_(ly);
class cy extends Ye {
    apply(t) {
        return kr(t);
    }
}
cy.className = "sigmoid";
_(cy);
class uy extends Ye {
    apply(t) {
        return tL(t);
    }
}
uy.className = "hardSigmoid";
_(uy);
class dy extends Ye {
    apply(t) {
        return va(t);
    }
}
dy.className = "softplus";
_(dy);
class hy extends Ye {
    apply(t) {
        return qE(t);
    }
}
hy.className = "softsign";
_(hy);
class py extends Ye {
    apply(t) {
        return sp(t);
    }
}
py.className = "tanh";
_(py);
let Gf = class extends Ye {
    /**
   * Calculate the activation function.
   *
   * @param x Tensor.
   * @param axis Integer, axis along which the softmax normalization is applied.
   * Invalid if < 2, as softmax across 1 (the batch dimension) is assumed to be
   * an error.
   *
   * @returns a Tensor of the same shape as x
   *
   * @throws ValueError: In case `dim(x) < 2`.
   */ apply(t, e = -1) {
        return $p(t, e);
    }
};
Gf.className = "softmax";
_(Gf);
class fy extends Ye {
    /**
   * Calculate the activation function of log softmax:
   * log( exp(x_i) / sum(exp(x)) )
   *
   * @param x Tensor.
   * @param axis Integer, axis along which the softmax normalization is applied.
   * Invalid if < 2, as softmax across 1 (the batch dimension) is assumed to be
   * an error.
   *
   * @returns a Tensor of the same shape as x
   *
   * @throws ValueError: In case `dim(x) < 2`.
   */ apply(t, e = -1) {
        return r0(t, e);
    }
}
fy.className = "logSoftmax";
_(fy);
class my extends Ye {
    /**
   * Calculate the activation function.
   *
   * @param x Tensor.
   * @param alpha Scaling factor for the sigmoid function.
   * @returns a Tensor of the same shape as x
   */ apply(t, e = 1) {
        return D(()=>G(kr(G(t, e)), t));
    }
}
my.className = "swish";
_(my);
class gy extends Ye {
    /**
   * Calculate the activation function.
   *
   * @param x Tensor.
   * @returns a Tensor of the same shape as x
   */ apply(t) {
        return D(()=>G(t, sp(va(t))));
    }
}
gy.className = "mish";
_(gy);
function Hs(n) {
    return n.getClassName();
}
function Pu(n, t = {}) {
    return Ga(n, cn.getMap().classNameMap, t, "activation");
}
function _s(n) {
    if (n == null) {
        const t = {};
        return t.className = "linear", t.config = {}, Pu(t);
    }
    if (typeof n == "string") {
        const t = {};
        return t.className = n, t.config = {}, Pu(t);
    } else return n instanceof Ye ? n : Pu(n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function Ef(n) {
    if (n != null && typeof n != "object") throw new Error(`Argument to L1L2 regularizer's constructor is expected to be an object, but received: ${n}`);
}
class by extends _o {
}
class hu extends by {
    constructor(t){
        super(), Ef(t), this.l1 = t == null || t.l1 == null ? 0.01 : t.l1, this.l2 = t == null || t.l2 == null ? 0.01 : t.l2, this.hasL1 = this.l1 !== 0, this.hasL2 = this.l2 !== 0;
    }
    /**
   * Porting note: Renamed from __call__.
   * @param x Variable of which to calculate the regularization score.
   */ apply(t) {
        return D(()=>{
            let e = be([
                1
            ]);
            return this.hasL1 && (e = U(e, at(G(this.l1, me(t))))), this.hasL2 && (e = U(e, at(G(this.l2, La(t))))), W(e, []);
        });
    }
    getConfig() {
        return {
            l1: this.l1,
            l2: this.l2
        };
    }
    /** @nocollapse */ static fromConfig(t, e) {
        return new t({
            l1: e.l1,
            l2: e.l2
        });
    }
}
hu.className = "L1L2";
_(hu);
function AQ(n) {
    return Ef(n), new hu({
        l1: n != null ? n.l1 : null,
        l2: 0
    });
}
function OQ(n) {
    return Ef(n), new hu({
        l2: n != null ? n.l2 : null,
        l1: 0
    });
}
const rg = {
    l1l2: "L1L2"
};
function zt(n) {
    return gf(n);
}
function ig(n, t = {}) {
    return Ga(n, cn.getMap().classNameMap, t, "regularizer");
}
function Qt(n) {
    if (n == null) return null;
    if (typeof n == "string") {
        const e = {
            className: n in rg ? rg[n] : n,
            config: {}
        };
        return ig(e);
    } else return n instanceof by ? n : ig(n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ class xy extends St {
    constructor(t){
        super(t ?? {}), this.supportsMasking = !0, t != null && (this.maxValue = t.maxValue);
    }
    call(t, e) {
        t = mt(t);
        let s = Ts(t);
        return this.maxValue != null && (s = fn(s, 0, this.maxValue)), s;
    }
    computeOutputShape(t) {
        return t;
    }
    getConfig() {
        const t = {
            maxValue: this.maxValue
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
xy.className = "ReLU";
_(xy);
class yy extends St {
    constructor(t){
        super(t ?? {}), this.DEFAULT_ALPHA = 0.3, t == null && (t = {}), this.alpha = t.alpha == null ? this.DEFAULT_ALPHA : t.alpha;
    }
    call(t, e) {
        const s = mt(t);
        return dp(s, this.alpha);
    }
    computeOutputShape(t) {
        return t;
    }
    getConfig() {
        const t = {
            alpha: this.alpha
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
yy.className = "LeakyReLU";
_(yy);
class wy extends St {
    constructor(t){
        if (super(t ?? {}), this.DEFAULT_ALPHA_INITIALIZER = "zeros", t == null && (t = {}), this.supportsMasking = !0, this.alphaInitializer = Ut(t.alphaInitializer || this.DEFAULT_ALPHA_INITIALIZER), this.alphaRegularizer = Qt(t.alphaRegularizer), this.alphaConstraint = pe(t.alphaConstraint), t.sharedAxes == null) this.sharedAxes = null;
        else if (Array.isArray(t.sharedAxes)) this.sharedAxes = t.sharedAxes;
        else if (typeof t.sharedAxes == "number") this.sharedAxes = [
            t.sharedAxes
        ];
        else throw new E(`Expected sharedAxes to be a number or an array of numbers, but got ${t.sharedAxes}`);
    }
    build(t) {
        t = Rt(t);
        const e = t.slice(1);
        if (this.sharedAxes != null) for (const o of this.sharedAxes)e[o - 1] = 1;
        this.alpha = this.addWeight("alpha", e, "float32", this.alphaInitializer, this.alphaRegularizer, !0, this.alphaConstraint);
        const s = {};
        if (this.sharedAxes != null) for(let o = 1; o < t.length; ++o)s[o] = t[o];
        this.inputSpec = [
            new de({
                ndim: t.length,
                axes: s
            })
        ], this.built = !0;
    }
    call(t, e) {
        return t = mt(t), yp(t, this.alpha.read());
    }
    getConfig() {
        const t = {
            alphaInitializer: jt(this.alphaInitializer),
            alphaRegularizer: zt(this.alphaRegularizer),
            alphaConstraint: he(this.alphaConstraint),
            sharedAxes: this.sharedAxes
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
wy.className = "PReLU";
_(wy);
let Iy = class extends St {
    constructor(t){
        if (super(t ?? {}), this.DEFAULT_ALPHA = 1, t == null && (t = {}), t.alpha != null && t.alpha !== this.DEFAULT_ALPHA) throw new yt(`Non-default alpha value (${t.alpha}) is not supported by the ELU layer yet.`);
        this.alpha = t.alpha == null ? this.DEFAULT_ALPHA : t.alpha;
    }
    call(t, e) {
        const s = mt(t);
        return Jc(s);
    }
    computeOutputShape(t) {
        return t;
    }
    getConfig() {
        const t = {
            alpha: this.alpha
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
};
Iy.className = "ELU";
_(Iy);
class Cy extends St {
    constructor(t){
        super(t ?? {}), this.DEFAULT_THETA = 1, t == null && (t = {}), this.theta = t.theta == null ? this.DEFAULT_THETA : t.theta;
    }
    call(t, e) {
        const s = mt(t);
        return G(s, tt(rn(s, this.theta), "float32"));
    }
    computeOutputShape(t) {
        return t;
    }
    getConfig() {
        const t = {
            theta: this.theta
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
Cy.className = "ThresholdedReLU";
_(Cy);
class vy extends St {
    constructor(t){
        super(t ?? {}), this.DEFAULT_AXIS = 1, t == null && (t = {}), this.softmax = new Gf().apply, this.axis = t.axis == null ? this.DEFAULT_AXIS : t.axis;
    }
    call(t, e) {
        return D(()=>{
            let s = mt(t);
            const o = e.mask;
            if (o != null) {
                const r = G(it(ks(s.shape), tt(o, s.dtype)), gt(-1000000000));
                s = U(s, r);
            }
            return this.axis instanceof Array ? this.axis.length > 1 ? mn(it(s, pp(s, this.axis, !0))) : this.softmax(s, this.axis[0]) : this.softmax(s, this.axis);
        });
    }
    computeOutputShape(t) {
        return t;
    }
    getConfig() {
        const t = {
            axis: this.axis
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
vy.className = "Softmax";
_(vy);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function dr(n, t, e) {
    if (typeof n == "number") return Wo(n, t);
    if (n.length !== t) throw new E(`The ${e} argument must be an integer or tuple of ${t} integers. Received: ${n.length} elements.`);
    for(let s = 0; s < t; ++s){
        const o = n[s];
        if (!UE(o)) throw new E(`The ${e} argument must be an integer or tuple of ${t} integers. Received: ${JSON.stringify(n)} including a non-integer number ${o}`);
    }
    return n;
}
function On(n, t, e, s, o = 1) {
    if (n == null) return n;
    const r = t + (t - 1) * (o - 1);
    let i;
    return e === "same" ? i = n : i = n - r + 1, Math.floor((i + s - 1) / s);
}
function jn(n, t, e, s) {
    if (n == null) return null;
    if (s === "valid") n = n * t + Bs([
        e - t,
        0
    ]);
    else if (s === "same") n = n * t;
    else throw new E(`Unsupport padding mode: ${s}.`);
    return n;
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function Lf(n, t) {
    return D(()=>(ae(t), t === "channelsFirst" ? kt(n, [
            0,
            2,
            3,
            1
        ]) : n));
}
function Sy(n, t) {
    return D(()=>(ae(t), t === "channelsFirst" ? kt(n, [
            0,
            2,
            3,
            4,
            1
        ]) : n));
}
function m3(n, t, e, s = 1, o = "valid", r, i = 1) {
    return D(()=>{
        if (r == null && (r = Zn()), ae(r), n.shape.length !== 3) throw new E(`The input of a conv1dWithBias operation should be 3, but is ${n.shape.length} instead.`);
        if (t.shape.length !== 3) throw new E(`The kernel for a conv1dWithBias operation should be 3, but is ${t.shape.length} instead`);
        if (e != null && e.shape.length !== 1) throw new E(`The bias for a conv1dWithBias operation should be 1, but is ${t.shape.length} instead`);
        if (r === "channelsFirst" && (n = kt(n, [
            0,
            2,
            1
        ])), o === "causal") throw new yt("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");
        let a = Jb(n, t, s, o === "same" ? "same" : "valid", "NWC", i);
        return e != null && (a = _n(a, e)), a;
    });
}
function ag(n, t, e, s = [
    1,
    1
], o = "valid", r, i, a = null) {
    return D(()=>{
        if (r == null && (r = Zn()), ae(r), n.rank !== 3 && n.rank !== 4) throw new E(`conv2dWithBiasActivation expects input to be of rank 3 or 4, but received ${n.rank}.`);
        if (t.rank !== 3 && t.rank !== 4) throw new E(`conv2dWithBiasActivation expects kernel to be of rank 3 or 4, but received ${n.rank}.`);
        let l = Lf(n, r);
        if (o === "causal") throw new yt("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");
        return l = IN({
            x: l,
            filter: t,
            strides: s,
            pad: o === "same" ? "same" : "valid",
            dilations: i,
            dataFormat: "NHWC",
            bias: e,
            activation: a
        }), r === "channelsFirst" && (l = kt(l, [
            0,
            3,
            1,
            2
        ])), l;
    });
}
function g3(n, t, e, s = [
    1,
    1,
    1
], o = "valid", r, i) {
    return D(()=>{
        if (r == null && (r = Zn()), ae(r), n.rank !== 4 && n.rank !== 5) throw new E(`conv3dWithBias expects input to be of rank 4 or 5, but received ${n.rank}.`);
        if (t.rank !== 4 && t.rank !== 5) throw new E(`conv3dWithBias expects kernel to be of rank 4 or 5, but received ${n.rank}.`);
        let a = Sy(n, r);
        if (o === "causal") throw new yt("The support for CAUSAL padding mode in conv3dWithBias is not implemented yet.");
        return a = IS(a, t, s, o === "same" ? "same" : "valid", "NDHWC", i), e != null && (a = _n(a, e)), r === "channelsFirst" && (a = kt(a, [
            0,
            4,
            1,
            2,
            3
        ])), a;
    });
}
class pu extends St {
    constructor(t, e){
        if (super(e), this.bias = null, this.DEFAULT_KERNEL_INITIALIZER = "glorotNormal", this.DEFAULT_BIAS_INITIALIZER = "zeros", pu.verifyArgs(e), this.rank = t, xe(this.rank, "rank"), this.rank !== 1 && this.rank !== 2 && this.rank !== 3) throw new yt(`Convolution layer for rank other than 1, 2, or 3 (${this.rank}) is not implemented yet.`);
        if (this.kernelSize = dr(e.kernelSize, t, "kernelSize"), this.strides = dr(e.strides == null ? 1 : e.strides, t, "strides"), this.padding = e.padding == null ? "valid" : e.padding, gn(this.padding), this.dataFormat = e.dataFormat == null ? "channelsLast" : e.dataFormat, ae(this.dataFormat), this.activation = _s(e.activation), this.useBias = e.useBias == null ? !0 : e.useBias, this.biasInitializer = Ut(e.biasInitializer || this.DEFAULT_BIAS_INITIALIZER), this.biasConstraint = pe(e.biasConstraint), this.biasRegularizer = Qt(e.biasRegularizer), this.activityRegularizer = Qt(e.activityRegularizer), this.dilationRate = dr(e.dilationRate == null ? 1 : e.dilationRate, t, "dilationRate"), this.rank === 1 && Array.isArray(this.dilationRate) && this.dilationRate.length !== 1) throw new E(`dilationRate must be a number or an array of a single number for 1D convolution, but received ${JSON.stringify(this.dilationRate)}`);
        if (this.rank === 2) {
            if (typeof this.dilationRate == "number") this.dilationRate = [
                this.dilationRate,
                this.dilationRate
            ];
            else if (this.dilationRate.length !== 2) throw new E(`dilationRate must be a number or array of two numbers for 2D convolution, but received ${JSON.stringify(this.dilationRate)}`);
        } else if (this.rank === 3) {
            if (typeof this.dilationRate == "number") this.dilationRate = [
                this.dilationRate,
                this.dilationRate,
                this.dilationRate
            ];
            else if (this.dilationRate.length !== 3) throw new E(`dilationRate must be a number or array of three numbers for 3D convolution, but received ${JSON.stringify(this.dilationRate)}`);
        }
    }
    static verifyArgs(t) {
        if (Jn("kernelSize" in t, "required key 'kernelSize' not in config"), typeof t.kernelSize != "number" && !bf(t.kernelSize, "number", 1, 3)) throw new E(`BaseConv expects config.kernelSize to be number or number[] with length 1, 2, or 3, but received ${JSON.stringify(t.kernelSize)}.`);
    }
    getConfig() {
        const t = {
            kernelSize: this.kernelSize,
            strides: this.strides,
            padding: this.padding,
            dataFormat: this.dataFormat,
            dilationRate: this.dilationRate,
            activation: Hs(this.activation),
            useBias: this.useBias,
            biasInitializer: jt(this.biasInitializer),
            biasRegularizer: zt(this.biasRegularizer),
            activityRegularizer: zt(this.activityRegularizer),
            biasConstraint: he(this.biasConstraint)
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
class $r extends pu {
    constructor(t, e){
        super(t, e), this.kernel = null, $r.verifyArgs(e), this.filters = e.filters, xe(this.filters, "filters"), this.kernelInitializer = Ut(e.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER), this.kernelConstraint = pe(e.kernelConstraint), this.kernelRegularizer = Qt(e.kernelRegularizer);
    }
    build(t) {
        t = Rt(t);
        const e = this.dataFormat === "channelsFirst" ? 1 : t.length - 1;
        if (t[e] == null) throw new E(`The channel dimension of the input should be defined. Found ${t[e]}`);
        const s = t[e], o = this.kernelSize.concat([
            s,
            this.filters
        ]);
        this.kernel = this.addWeight("kernel", o, null, this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.useBias && (this.bias = this.addWeight("bias", [
            this.filters
        ], null, this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint)), this.inputSpec = [
            {
                ndim: this.rank + 2,
                axes: {
                    [e]: s
                }
            }
        ], this.built = !0;
    }
    call(t, e) {
        return D(()=>{
            t = mt(t);
            let s;
            const o = this.bias == null ? null : this.bias.read(), r = Cx(this.activation.getClassName());
            if (r != null && this.rank === 2) s = ag(t, this.kernel.read(), o, this.strides, this.padding, this.dataFormat, this.dilationRate, r);
            else {
                if (this.rank === 1) s = m3(t, this.kernel.read(), o, this.strides[0], this.padding, this.dataFormat, this.dilationRate[0]);
                else if (this.rank === 2) s = ag(t, this.kernel.read(), o, this.strides, this.padding, this.dataFormat, this.dilationRate);
                else if (this.rank === 3) s = g3(t, this.kernel.read(), o, this.strides, this.padding, this.dataFormat, this.dilationRate);
                else throw new yt("convolutions greater than 3D are not implemented yet.");
                this.activation != null && (s = this.activation.apply(s));
            }
            return s;
        });
    }
    computeOutputShape(t) {
        t = Rt(t);
        const e = [], s = this.dataFormat === "channelsLast" ? t.slice(1, t.length - 1) : t.slice(2);
        for(let r = 0; r < s.length; ++r){
            const i = On(s[r], this.kernelSize[r], this.padding, this.strides[r], typeof this.dilationRate == "number" ? this.dilationRate : this.dilationRate[r]);
            e.push(i);
        }
        let o = [
            t[0]
        ];
        return this.dataFormat === "channelsLast" ? (o = o.concat(e), o.push(this.filters)) : (o.push(this.filters), o = o.concat(e)), o;
    }
    getConfig() {
        const t = {
            filters: this.filters,
            kernelInitializer: jt(this.kernelInitializer),
            kernelRegularizer: zt(this.kernelRegularizer),
            kernelConstraint: he(this.kernelConstraint)
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
    static verifyArgs(t) {
        if (!("filters" in t) || typeof t.filters != "number" || t.filters < 1) throw new E(`Convolution layer expected config.filters to be a 'number' > 0 but got ${JSON.stringify(t.filters)}`);
    }
}
class Fa extends $r {
    constructor(t){
        super(2, t), Fa.verifyArgs(t);
    }
    getConfig() {
        const t = super.getConfig();
        return delete t.rank, t;
    }
    static verifyArgs(t) {
        if (typeof t.kernelSize != "number" && !bf(t.kernelSize, "number", 1, 2)) throw new E(`Conv2D expects config.kernelSize to be number or number[] with length 1 or 2, but received ${JSON.stringify(t.kernelSize)}.`);
    }
}
Fa.className = "Conv2D";
_(Fa);
class Va extends $r {
    constructor(t){
        super(3, t), Va.verifyArgs(t);
    }
    getConfig() {
        const t = super.getConfig();
        return delete t.rank, t;
    }
    static verifyArgs(t) {
        if (typeof t.kernelSize != "number" && !(Array.isArray(t.kernelSize) && (t.kernelSize.length === 1 || t.kernelSize.length === 3))) throw new E(`Conv3D expects config.kernelSize to be number or [number, number, number], but received ${JSON.stringify(t.kernelSize)}.`);
    }
}
Va.className = "Conv3D";
_(Va);
class ky extends Fa {
    constructor(t){
        if (super(t), this.inputSpec = [
            new de({
                ndim: 4
            })
        ], this.padding !== "same" && this.padding !== "valid") throw new E(`Conv2DTranspose currently supports only padding modes 'same' and 'valid', but received padding mode ${this.padding}`);
    }
    build(t) {
        if (t = Rt(t), t.length !== 4) throw new E("Input should have rank 4; Received input shape: " + JSON.stringify(t));
        const e = this.dataFormat === "channelsFirst" ? 1 : t.length - 1;
        if (t[e] == null) throw new E("The channel dimension of the inputs should be defined. Found `None`.");
        const s = t[e], o = this.kernelSize.concat([
            this.filters,
            s
        ]);
        this.kernel = this.addWeight("kernel", o, "float32", this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.useBias && (this.bias = this.addWeight("bias", [
            this.filters
        ], "float32", this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint)), this.inputSpec = [
            new de({
                ndim: 4,
                axes: {
                    [e]: s
                }
            })
        ], this.built = !0;
    }
    call(t, e) {
        return D(()=>{
            let s = mt(t);
            if (s.shape.length !== 4) throw new E(`Conv2DTranspose.call() expects input tensor to be rank-4, but received a tensor of rank-${s.shape.length}`);
            const o = s.shape, r = o[0];
            let i, a;
            this.dataFormat === "channelsFirst" ? (i = 2, a = 3) : (i = 1, a = 2);
            const l = o[i], c = o[a], u = this.kernelSize[0], d = this.kernelSize[1], h = this.strides[0], p = this.strides[1], f = jn(l, h, u, this.padding), m = jn(c, p, d, this.padding), g = [
                r,
                f,
                m,
                this.filters
            ];
            this.dataFormat !== "channelsLast" && (s = kt(s, [
                0,
                2,
                3,
                1
            ]));
            let b = jb(s, this.kernel.read(), g, this.strides, this.padding);
            return this.dataFormat !== "channelsLast" && (b = kt(b, [
                0,
                3,
                1,
                2
            ])), this.bias != null && (b = _n(b, this.bias.read(), this.dataFormat)), this.activation != null && (b = this.activation.apply(b)), b;
        });
    }
    computeOutputShape(t) {
        t = Rt(t);
        const e = t.slice();
        let s, o, r;
        this.dataFormat === "channelsFirst" ? (s = 1, o = 2, r = 3) : (s = 3, o = 1, r = 2);
        const i = this.kernelSize[0], a = this.kernelSize[1], l = this.strides[0], c = this.strides[1];
        return e[s] = this.filters, e[o] = jn(e[o], l, i, this.padding), e[r] = jn(e[r], c, a, this.padding), e;
    }
    getConfig() {
        const t = super.getConfig();
        return delete t.dilationRate, t;
    }
}
ky.className = "Conv2DTranspose";
_(ky);
class Ty extends Va {
    constructor(t){
        if (super(t), this.inputSpec = [
            new de({
                ndim: 5
            })
        ], this.padding !== "same" && this.padding !== "valid") throw new E(`Conv3DTranspose currently supports only padding modes 'same' and 'valid', but received padding mode ${this.padding}`);
    }
    build(t) {
        if (t = Rt(t), t.length !== 5) throw new E("Input should have rank 5; Received input shape: " + JSON.stringify(t));
        const e = this.dataFormat === "channelsFirst" ? 1 : t.length - 1;
        if (t[e] == null) throw new E("The channel dimension of the inputs should be defined. Found `None`.");
        const s = t[e], o = this.kernelSize.concat([
            this.filters,
            s
        ]);
        this.kernel = this.addWeight("kernel", o, "float32", this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.useBias && (this.bias = this.addWeight("bias", [
            this.filters
        ], "float32", this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint)), this.inputSpec = [
            new de({
                ndim: 5,
                axes: {
                    [e]: s
                }
            })
        ], this.built = !0;
    }
    call(t, e) {
        return D(()=>{
            let s = mt(t);
            if (s.shape.length !== 5) throw new E(`Conv3DTranspose.call() expects input tensor to be rank-4, but received a tensor of rank-${s.shape.length}`);
            const o = s.shape, r = o[0];
            let i, a, l;
            this.dataFormat === "channelsFirst" ? (l = 2, i = 3, a = 4) : (l = 1, i = 2, a = 3);
            const c = o[l], u = o[i], d = o[a], h = this.kernelSize[0], p = this.kernelSize[1], f = this.kernelSize[2], m = this.strides[0], g = this.strides[1], b = this.strides[2], x = jn(c, m, h, this.padding), w = jn(u, g, p, this.padding), y = jn(d, b, f, this.padding), I = [
                r,
                x,
                w,
                y,
                this.filters
            ];
            this.dataFormat !== "channelsLast" && (s = kt(s, [
                0,
                2,
                3,
                4,
                1
            ]));
            let v = SS(s, this.kernel.read(), I, this.strides, this.padding);
            return this.dataFormat !== "channelsLast" && (v = kt(v, [
                0,
                4,
                1,
                2,
                3
            ])), this.bias !== null && (v = _n(v, this.bias.read(), this.dataFormat)), this.activation !== null && (v = this.activation.apply(v)), v;
        });
    }
    computeOutputShape(t) {
        t = Rt(t);
        const e = t.slice();
        let s, o, r, i;
        this.dataFormat === "channelsFirst" ? (s = 1, o = 2, r = 3, i = 4) : (s = 4, o = 1, r = 2, i = 3);
        const a = this.kernelSize[0], l = this.kernelSize[1], c = this.kernelSize[2], u = this.strides[0], d = this.strides[1], h = this.strides[2];
        return e[s] = this.filters, e[o] = jn(e[o], u, a, this.padding), e[r] = jn(e[r], d, l, this.padding), e[i] = jn(e[i], h, c, this.padding), e;
    }
    getConfig() {
        const t = super.getConfig();
        return delete t.dilationRate, t;
    }
}
Ty.className = "Conv3DTranspose";
_(Ty);
class Ny extends $r {
    constructor(t, e){
        if (super(t, e), this.DEFAULT_DEPTHWISE_INITIALIZER = "glorotUniform", this.DEFAULT_POINTWISE_INITIALIZER = "glorotUniform", this.depthwiseKernel = null, this.pointwiseKernel = null, e.filters == null) throw new E("The `filters` configuration field is required by SeparableConv, but is unspecified.");
        if (e.kernelInitializer != null || e.kernelRegularizer != null || e.kernelConstraint != null) throw new E("Fields kernelInitializer, kernelRegularizer and kernelConstraint are invalid for SeparableConv2D. Use depthwiseInitializer, depthwiseRegularizer, depthwiseConstraint, pointwiseInitializer, pointwiseRegularizer and pointwiseConstraint instead.");
        if (e.padding != null && e.padding !== "same" && e.padding !== "valid") throw new E(`SeparableConv${this.rank}D supports only padding modes: 'same' and 'valid', but received ${JSON.stringify(e.padding)}`);
        this.depthMultiplier = e.depthMultiplier == null ? 1 : e.depthMultiplier, this.depthwiseInitializer = Ut(e.depthwiseInitializer || this.DEFAULT_DEPTHWISE_INITIALIZER), this.depthwiseRegularizer = Qt(e.depthwiseRegularizer), this.depthwiseConstraint = pe(e.depthwiseConstraint), this.pointwiseInitializer = Ut(e.depthwiseInitializer || this.DEFAULT_POINTWISE_INITIALIZER), this.pointwiseRegularizer = Qt(e.pointwiseRegularizer), this.pointwiseConstraint = pe(e.pointwiseConstraint);
    }
    build(t) {
        if (t = Rt(t), t.length < this.rank + 2) throw new E(`Inputs to SeparableConv${this.rank}D should have rank ${this.rank + 2}, but received input shape: ${JSON.stringify(t)}`);
        const e = this.dataFormat === "channelsFirst" ? 1 : t.length - 1;
        if (t[e] == null || t[e] < 0) throw new E(`The channel dimension of the inputs should be defined, but found ${JSON.stringify(t[e])}`);
        const s = t[e], o = this.kernelSize.concat([
            s,
            this.depthMultiplier
        ]), r = [];
        for(let a = 0; a < this.rank; ++a)r.push(1);
        r.push(s * this.depthMultiplier, this.filters);
        const i = !0;
        this.depthwiseKernel = this.addWeight("depthwise_kernel", o, "float32", this.depthwiseInitializer, this.depthwiseRegularizer, i, this.depthwiseConstraint), this.pointwiseKernel = this.addWeight("pointwise_kernel", r, "float32", this.pointwiseInitializer, this.pointwiseRegularizer, i, this.pointwiseConstraint), this.useBias ? this.bias = this.addWeight("bias", [
            this.filters
        ], "float32", this.biasInitializer, this.biasRegularizer, i, this.biasConstraint) : this.bias = null, this.inputSpec = [
            new de({
                ndim: this.rank + 2,
                axes: {
                    [e]: s
                }
            })
        ], this.built = !0;
    }
    call(t, e) {
        return D(()=>{
            t = mt(t);
            let s;
            if (this.rank === 1) throw new yt("1D separable convolution is not implemented yet.");
            return this.rank === 2 && (this.dataFormat === "channelsFirst" && (t = kt(t, [
                0,
                2,
                3,
                1
            ])), s = p0(t, this.depthwiseKernel.read(), this.pointwiseKernel.read(), this.strides, this.padding, this.dilationRate, "NHWC")), this.useBias && (s = _n(s, this.bias.read(), this.dataFormat)), this.activation != null && (s = this.activation.apply(s)), this.dataFormat === "channelsFirst" && (s = kt(s, [
                0,
                3,
                1,
                2
            ])), s;
        });
    }
    getConfig() {
        const t = super.getConfig();
        return delete t.rank, delete t.kernelInitializer, delete t.kernelRegularizer, delete t.kernelConstraint, t.depthwiseInitializer = jt(this.depthwiseInitializer), t.pointwiseInitializer = jt(this.pointwiseInitializer), t.depthwiseRegularizer = zt(this.depthwiseRegularizer), t.pointwiseRegularizer = zt(this.pointwiseRegularizer), t.depthwiseConstraint = he(this.depthwiseConstraint), t.pointwiseConstraint = he(this.pointwiseConstraint), t;
    }
}
Ny.className = "SeparableConv";
class Ry extends Ny {
    constructor(t){
        super(2, t);
    }
}
Ry.className = "SeparableConv2D";
_(Ry);
class fu extends $r {
    constructor(t){
        super(1, t), fu.verifyArgs(t), this.inputSpec = [
            {
                ndim: 3
            }
        ];
    }
    getConfig() {
        const t = super.getConfig();
        return delete t.rank, delete t.dataFormat, t;
    }
    static verifyArgs(t) {
        if (typeof t.kernelSize != "number" && !bf(t.kernelSize, "number", 1, 1)) throw new E(`Conv1D expects config.kernelSize to be number or number[] with length 1, but received ${JSON.stringify(t.kernelSize)}.`);
    }
}
fu.className = "Conv1D";
_(fu);
class $y extends St {
    constructor(t){
        super(t), typeof t.cropping == "number" ? this.cropping = [
            [
                t.cropping,
                t.cropping
            ],
            [
                t.cropping,
                t.cropping
            ]
        ] : typeof t.cropping[0] == "number" ? this.cropping = [
            [
                t.cropping[0],
                t.cropping[0]
            ],
            [
                t.cropping[1],
                t.cropping[1]
            ]
        ] : this.cropping = t.cropping, this.dataFormat = t.dataFormat === void 0 ? "channelsLast" : t.dataFormat, this.inputSpec = [
            {
                ndim: 4
            }
        ];
    }
    computeOutputShape(t) {
        return this.dataFormat === "channelsFirst" ? [
            t[0],
            t[1],
            t[2] - this.cropping[0][0] - this.cropping[0][1],
            t[3] - this.cropping[1][0] - this.cropping[1][1]
        ] : [
            t[0],
            t[1] - this.cropping[0][0] - this.cropping[0][1],
            t[2] - this.cropping[1][0] - this.cropping[1][1],
            t[3]
        ];
    }
    call(t, e) {
        return D(()=>{
            if (t = mt(t), this.dataFormat === "channelsLast") {
                const s = _a(t, this.cropping[0][0], t.shape[1] - this.cropping[0][0] - this.cropping[0][1], 2);
                return _a(s, this.cropping[1][0], t.shape[2] - this.cropping[1][1] - this.cropping[1][0], 3);
            } else {
                const s = _a(t, this.cropping[0][0], t.shape[2] - this.cropping[0][0] - this.cropping[0][1], 3);
                return _a(s, this.cropping[1][0], t.shape[3] - this.cropping[1][1] - this.cropping[1][0], 4);
            }
        });
    }
    getConfig() {
        const t = {
            cropping: this.cropping,
            dataFormat: this.dataFormat
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
$y.className = "Cropping2D";
_($y);
class Gy extends St {
    constructor(t){
        super(t), this.DEFAULT_SIZE = [
            2,
            2
        ], this.inputSpec = [
            {
                ndim: 4
            }
        ], this.size = t.size == null ? this.DEFAULT_SIZE : t.size, this.dataFormat = t.dataFormat == null ? "channelsLast" : t.dataFormat, ae(this.dataFormat), this.interpolation = t.interpolation == null ? "nearest" : t.interpolation, BE(this.interpolation);
    }
    computeOutputShape(t) {
        if (this.dataFormat === "channelsFirst") {
            const e = t[2] == null ? null : this.size[0] * t[2], s = t[3] == null ? null : this.size[1] * t[3];
            return [
                t[0],
                t[1],
                e,
                s
            ];
        } else {
            const e = t[1] == null ? null : this.size[0] * t[1], s = t[2] == null ? null : this.size[1] * t[2];
            return [
                t[0],
                e,
                s,
                t[3]
            ];
        }
    }
    call(t, e) {
        return D(()=>{
            let s = mt(t);
            const o = s.shape;
            if (this.dataFormat === "channelsFirst") {
                s = kt(s, [
                    0,
                    2,
                    3,
                    1
                ]);
                const r = this.size[0] * o[2], i = this.size[1] * o[3], a = this.interpolation === "nearest" ? fs.resizeNearestNeighbor(s, [
                    r,
                    i
                ]) : fs.resizeBilinear(s, [
                    r,
                    i
                ]);
                return kt(a, [
                    0,
                    3,
                    1,
                    2
                ]);
            } else {
                const r = this.size[0] * o[1], i = this.size[1] * o[2];
                return this.interpolation === "nearest" ? fs.resizeNearestNeighbor(s, [
                    r,
                    i
                ]) : fs.resizeBilinear(s, [
                    r,
                    i
                ]);
            }
        });
    }
    getConfig() {
        const t = {
            size: this.size,
            dataFormat: this.dataFormat,
            interpolation: this.interpolation
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
Gy.className = "UpSampling2D";
_(Gy);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function b3(n, t, e = [
    1,
    1
], s = "valid", o, r) {
    return D(()=>{
        o == null && (o = Zn()), ae(o);
        let i = Lf(n, o);
        if (n.rank !== 4) throw new E(`Input for depthwiseConv2d is required to be 4-D, but is instead ${n.rank}-D`);
        if (t.rank !== 4) throw new E(`depthwiseKernel is required to be 4-D, but is instead ${t.rank}-D`);
        return i = ap(i, t, e, s === "same" ? "same" : "valid", "NHWC", r), o === "channelsFirst" && (i = kt(i, [
            0,
            3,
            1,
            2
        ])), i;
    });
}
class Ey extends pu {
    constructor(t){
        super(2, t), this.depthwiseKernel = null, this.depthMultiplier = t.depthMultiplier == null ? 1 : t.depthMultiplier, this.depthwiseInitializer = Ut(t.depthwiseInitializer || this.DEFAULT_KERNEL_INITIALIZER), this.depthwiseConstraint = pe(t.depthwiseConstraint), this.depthwiseRegularizer = Qt(t.depthwiseRegularizer);
    }
    build(t) {
        if (t = Rt(t), t.length < 4) throw new E(`Inputs to DepthwiseConv2D should have rank 4. Received input shape: ${JSON.stringify(t)}.`);
        const e = this.dataFormat === "channelsFirst" ? 1 : 3;
        if (t[e] == null || t[e] < 0) throw new E(`The channel dimension of the inputs to DepthwiseConv2D should be defined, but is not (${t[e]}).`);
        const s = t[e], o = [
            this.kernelSize[0],
            this.kernelSize[1],
            s,
            this.depthMultiplier
        ];
        this.depthwiseKernel = this.addWeight("depthwise_kernel", o, null, this.depthwiseInitializer, this.depthwiseRegularizer, !0, this.depthwiseConstraint), this.useBias ? this.bias = this.addWeight("bias", [
            s * this.depthMultiplier
        ], null, this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint) : this.bias = null, this.built = !0;
    }
    call(t, e) {
        return D(()=>{
            t = mt(t);
            let s = b3(t, this.depthwiseKernel.read(), this.strides, this.padding, this.dataFormat, null);
            return this.useBias && (s = _n(s, this.bias.read(), this.dataFormat)), this.activation != null && (s = this.activation.apply(s)), s;
        });
    }
    computeOutputShape(t) {
        t = Rt(t);
        const e = this.dataFormat === "channelsFirst" ? t[2] : t[1], s = this.dataFormat === "channelsFirst" ? t[3] : t[2], o = this.dataFormat === "channelsFirst" ? t[1] * this.depthMultiplier : t[3] * this.depthMultiplier, r = On(e, this.kernelSize[0], this.padding, this.strides[0]), i = On(s, this.kernelSize[1], this.padding, this.strides[1]);
        return this.dataFormat === "channelsFirst" ? [
            t[0],
            o,
            r,
            i
        ] : [
            t[0],
            r,
            i,
            o
        ];
    }
    getConfig() {
        const t = super.getConfig();
        return t.depthMultiplier = this.depthMultiplier, t.depthwiseInitializer = jt(this.depthwiseInitializer), t.depthwiseRegularizer = zt(this.depthwiseRegularizer), t.depthwiseConstraint = he(this.depthwiseRegularizer), t;
    }
}
Ey.className = "DepthwiseConv2D";
_(Ey);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function Ly(n, t, e, s) {
    if (Array.isArray(n)) {
        if (t != null || e != null) throw new E("When inputs is an array, neither initialState or constants should be provided");
        s != null && (e = n.slice(n.length - s, n.length), n = n.slice(0, n.length - s)), n.length > 1 && (t = n.slice(1, n.length)), n = n[0];
    }
    function o(r) {
        return r == null || Array.isArray(r) ? r : [
            r
        ];
    }
    return t = o(t), e = o(e), {
        inputs: n,
        initialState: t,
        constants: e
    };
}
function My(n, t, e, s = !1, o, r, i = !1, a = !1) {
    return D(()=>{
        const l = t.shape.length;
        if (l < 3) throw new E(`Input should be at least 3D, but is ${l}D.`);
        const c = [
            1,
            0
        ].concat(Kn(2, l));
        if (t = kt(t, c), r != null) throw new yt("The rnn() functoin of the deeplearn.js backend does not support constants yet.");
        i && console.warn("Backend rnn(): the unroll = true option is not applicable to the imperative deeplearn.js backend."), o != null && (o = tt(tt(o, "bool"), "float32"), o.rank === l - 1 && (o = Oe(o, -1)), o = kt(o, c)), s && (t = Lo(t, 0), o != null && (o = Lo(o, 0)));
        const u = [];
        let d, h = e;
        const p = t.shape[0], f = Mo(t);
        let m;
        o != null && (m = Mo(o));
        for(let b = 0; b < p; ++b){
            const x = f[b], w = D(()=>n(x, h));
            if (o == null) d = w[0], h = w[1];
            else {
                const y = D(()=>{
                    const I = m[b], v = it(Rn(I), I), k = U(G(w[0], I), G(h[0], v)), S = h.map((N, R)=>U(G(w[1][R], I), G(N, v)));
                    return {
                        output: k,
                        newStates: S
                    };
                });
                d = y.output, h = y.newStates;
            }
            a && u.push(d);
        }
        let g;
        return a && (g = Xn(u, 1)), [
            d,
            g,
            h
        ];
    });
}
class no extends St {
    constructor(t){
        super(t);
        let e;
        if (t.cell == null) throw new E("cell property is missing for the constructor of RNN.");
        if (Array.isArray(t.cell) ? e = new Df({
            cells: t.cell
        }) : e = t.cell, e.stateSize == null) throw new E("The RNN cell should have an attribute `stateSize` (tuple of integers, one integer per RNN state).");
        this.cell = e, this.returnSequences = t.returnSequences == null ? !1 : t.returnSequences, this.returnState = t.returnState == null ? !1 : t.returnState, this.goBackwards = t.goBackwards == null ? !1 : t.goBackwards, this._stateful = t.stateful == null ? !1 : t.stateful, this.unroll = t.unroll == null ? !1 : t.unroll, this.supportsMasking = !0, this.inputSpec = [
            new de({
                ndim: 3
            })
        ], this.stateSpec = null, this.states_ = null, this.numConstants = null, this.keptStates = [];
    }
    // Porting Note: This is the equivalent of `RNN.states` property getter in
    //   PyKeras.
    getStates() {
        if (this.states_ == null) {
            const t = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1;
            return Kn(0, t).map((e)=>null);
        } else return this.states_;
    }
    // Porting Note: This is the equivalent of the `RNN.states` property setter in
    //   PyKeras.
    setStates(t) {
        this.states_ = t;
    }
    computeOutputShape(t) {
        Gd(t) && (t = t[0]), t;
        let e = this.cell.stateSize;
        Array.isArray(e) || (e = [
            e
        ]);
        const s = e[0];
        let o;
        if (this.returnSequences ? o = [
            t[0],
            t[1],
            s
        ] : o = [
            t[0],
            s
        ], this.returnState) {
            const r = [];
            for (const i of e)r.push([
                t[0],
                i
            ]);
            return [
                o
            ].concat(r);
        } else return o;
    }
    computeMask(t, e) {
        return D(()=>{
            Array.isArray(e) && (e = e[0]);
            const s = this.returnSequences ? e : null;
            if (this.returnState) {
                const o = this.states.map((r)=>null);
                return [
                    s
                ].concat(o);
            } else return s;
        });
    }
    /**
   * Get the current state tensors of the RNN.
   *
   * If the state hasn't been set, return an array of `null`s of the correct
   * length.
   */ get states() {
        if (this.states_ == null) {
            const t = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1, e = [];
            for(let s = 0; s < t; ++s)e.push(null);
            return e;
        } else return this.states_;
    }
    set states(t) {
        this.states_ = t;
    }
    build(t) {
        if (this.numConstants != null) throw new yt("Constants support is not implemented in RNN yet.");
        Gd(t) && (t = t[0]), t;
        const e = this.stateful ? t[0] : null, s = t.slice(2);
        this.inputSpec[0] = new de({
            shape: [
                e,
                null,
                ...s
            ]
        });
        const o = [
            t[0]
        ].concat(t.slice(2));
        this.cell.build(o);
        let r;
        if (Array.isArray(this.cell.stateSize) ? r = this.cell.stateSize : r = [
            this.cell.stateSize
        ], this.stateSpec != null) {
            if (!$t(this.stateSpec.map((i)=>i.shape[i.shape.length - 1]), r)) throw new E(`An initialState was passed that is not compatible with cell.stateSize. Received stateSpec=${this.stateSpec}; However cell.stateSize is ${this.cell.stateSize}`);
        } else this.stateSpec = r.map((i)=>new de({
                shape: [
                    null,
                    i
                ]
            }));
        this.stateful && this.resetStates();
    }
    /**
   * Reset the state tensors of the RNN.
   *
   * If the `states` argument is `undefined` or `null`, will set the
   * state tensor(s) of the RNN to all-zero tensors of the appropriate
   * shape(s).
   *
   * If `states` is provided, will set the state tensors of the RNN to its
   * value.
   *
   * @param states Optional externally-provided initial states.
   * @param training Whether this call is done during training. For stateful
   *   RNNs, this affects whether the old states are kept or discarded. In
   *   particular, if `training` is `true`, the old states will be kept so
   *   that subsequent backpropgataion through time (BPTT) may work properly.
   *   Else, the old states will be discarded.
   */ resetStates(t, e = !1) {
        D(()=>{
            if (!this.stateful) throw new Qn("Cannot call resetStates() on an RNN Layer that is not stateful.");
            const s = this.inputSpec[0].shape[0];
            if (s == null) throw new E("If an RNN is stateful, it needs to know its batch size. Specify the batch size of your input tensors: \n- If using a Sequential model, specify the batch size by passing a `batchInputShape` option to your first layer.\n- If using the functional API, specify the batch size by passing a `batchShape` option to your Input layer.");
            if (this.states_ == null) Array.isArray(this.cell.stateSize) ? this.states_ = this.cell.stateSize.map((o)=>be([
                    s,
                    o
                ])) : this.states_ = [
                be([
                    s,
                    this.cell.stateSize
                ])
            ];
            else if (t == null) xt(this.states_), this.keptStates != null && (xt(this.keptStates), this.keptStates = []), Array.isArray(this.cell.stateSize) ? this.states_ = this.cell.stateSize.map((o)=>be([
                    s,
                    o
                ])) : this.states_[0] = be([
                s,
                this.cell.stateSize
            ]);
            else {
                if (Array.isArray(t) || (t = [
                    t
                ]), t.length !== this.states_.length) throw new E(`Layer ${this.name} expects ${this.states_.length} state(s), but it received ${t.length} state value(s). Input received: ${t}`);
                e === !0 ? this.keptStates.push(this.states_.slice()) : xt(this.states_);
                for(let o = 0; o < this.states_.length; ++o){
                    const r = t[o], i = Array.isArray(this.cell.stateSize) ? this.cell.stateSize[o] : this.cell.stateSize, a = [
                        s,
                        i
                    ];
                    if (!$t(r.shape, a)) throw new E(`State ${o} is incompatible with layer ${this.name}: expected shape=${a}, received shape=${r.shape}`);
                    this.states_[o] = r;
                }
            }
            this.states_ = this.states_.map((o)=>hn(o.clone()));
        });
    }
    apply(t, e) {
        let s = e == null ? null : e.initialState, o = e == null ? null : e.constants;
        e == null && (e = {});
        const r = Ly(t, s, o, this.numConstants);
        t = r.inputs, s = r.initialState, o = r.constants;
        let i = [], a = [];
        if (s != null) {
            e.initialState = s, i = i.concat(s), this.stateSpec = [];
            for (const c of s)this.stateSpec.push(new de({
                shape: c.shape
            }));
            a = a.concat(this.stateSpec);
        }
        if (o != null && (e.constants = o, i = i.concat(o), this.numConstants = o.length), i[0] instanceof os) {
            const c = [
                t
            ].concat(i), u = this.inputSpec.concat(a), d = this.inputSpec;
            this.inputSpec = u;
            const h = super.apply(c, e);
            return this.inputSpec = d, h;
        } else return super.apply(t, e);
    }
    // tslint:disable-next-line:no-any
    call(t, e) {
        return D(()=>{
            const s = e == null ? null : e.mask, o = e == null ? null : e.training;
            let r = e == null ? null : e.initialState;
            t = mt(t), r == null && (this.stateful ? r = this.states_ : r = this.getInitialState(t));
            const i = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1;
            if (r.length !== i) throw new E(`RNN Layer has ${i} state(s) but was passed ${r.length} initial state(s).`);
            this.unroll && console.warn("Ignoring unroll = true for RNN layer, due to imperative backend.");
            const a = {
                training: o
            }, c = My((f, m)=>{
                const g = this.cell.call([
                    f
                ].concat(m), a);
                return [
                    g[0],
                    g.slice(1)
                ];
            }, t, r, this.goBackwards, s, null, this.unroll, this.returnSequences), u = c[0], d = c[1], h = c[2];
            this.stateful && this.resetStates(h, o);
            const p = this.returnSequences ? d : u;
            return this.returnState ? [
                p
            ].concat(h) : p;
        });
    }
    getInitialState(t) {
        return D(()=>{
            let e = be(t.shape);
            return e = at(e, [
                1,
                2
            ]), e = Ea(e), Array.isArray(this.cell.stateSize) ? this.cell.stateSize.map((s)=>s > 1 ? Rd(e, [
                    1,
                    s
                ]) : e) : this.cell.stateSize > 1 ? [
                Rd(e, [
                    1,
                    this.cell.stateSize
                ])
            ] : [
                e
            ];
        });
    }
    get trainableWeights() {
        return this.trainable ? this.cell.trainableWeights : [];
    }
    get nonTrainableWeights() {
        return this.trainable ? this.cell.nonTrainableWeights : this.cell.weights;
    }
    setFastWeightInitDuringBuild(t) {
        super.setFastWeightInitDuringBuild(t), this.cell != null && this.cell.setFastWeightInitDuringBuild(t);
    }
    getConfig() {
        const t = super.getConfig(), e = {
            returnSequences: this.returnSequences,
            returnState: this.returnState,
            goBackwards: this.goBackwards,
            stateful: this.stateful,
            unroll: this.unroll
        };
        this.numConstants != null && (e.numConstants = this.numConstants);
        const s = this.cell.getConfig();
        return this.getClassName() === no.className && (e.cell = {
            className: this.cell.getClassName(),
            config: s
        }), Object.assign(Object.assign(Object.assign({}, s), t), e);
    }
    /** @nocollapse */ static fromConfig(t, e, s = {}) {
        const o = e.cell, r = An(o, s);
        return new t(Object.assign(e, {
            cell: r
        }));
    }
}
no.className = "RNN";
_(no);
class mu extends St {
}
class Mf extends mu {
    constructor(t){
        super(t), this.DEFAULT_ACTIVATION = "tanh", this.DEFAULT_KERNEL_INITIALIZER = "glorotNormal", this.DEFAULT_RECURRENT_INITIALIZER = "orthogonal", this.DEFAULT_BIAS_INITIALIZER = "zeros", this.units = t.units, xe(this.units, "units"), this.activation = _s(t.activation == null ? this.DEFAULT_ACTIVATION : t.activation), this.useBias = t.useBias == null ? !0 : t.useBias, this.kernelInitializer = Ut(t.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER), this.recurrentInitializer = Ut(t.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER), this.biasInitializer = Ut(t.biasInitializer || this.DEFAULT_BIAS_INITIALIZER), this.kernelRegularizer = Qt(t.kernelRegularizer), this.recurrentRegularizer = Qt(t.recurrentRegularizer), this.biasRegularizer = Qt(t.biasRegularizer), this.kernelConstraint = pe(t.kernelConstraint), this.recurrentConstraint = pe(t.recurrentConstraint), this.biasConstraint = pe(t.biasConstraint), this.dropout = xr([
            1,
            Bs([
                0,
                t.dropout == null ? 0 : t.dropout
            ])
        ]), this.recurrentDropout = xr([
            1,
            Bs([
                0,
                t.recurrentDropout == null ? 0 : t.recurrentDropout
            ])
        ]), this.dropoutFunc = t.dropoutFunc, this.stateSize = this.units, this.dropoutMask = null, this.recurrentDropoutMask = null;
    }
    build(t) {
        t = Rt(t), this.kernel = this.addWeight("kernel", [
            t[t.length - 1],
            this.units
        ], null, this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.recurrentKernel = this.addWeight("recurrent_kernel", [
            this.units,
            this.units
        ], null, this.recurrentInitializer, this.recurrentRegularizer, !0, this.recurrentConstraint), this.useBias ? this.bias = this.addWeight("bias", [
            this.units
        ], null, this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint) : this.bias = null, this.built = !0;
    }
    // Porting Note: PyKeras' equivalent of this method takes two tensor inputs:
    //   `inputs` and `states`. Here, the two tensors are combined into an
    //   `Tensor[]` Array as the first input argument.
    //   Similarly, PyKeras' equivalent of this method returns two values:
    //    `output` and `[output]`. Here the two are combined into one length-2
    //    `Tensor[]`, consisting of `output` repeated.
    call(t, e) {
        return D(()=>{
            if (t, t.length !== 2) throw new E(`SimpleRNNCell expects 2 input Tensors, got ${t.length}.`);
            let s = t[1];
            t = t[0];
            const o = e.training == null ? !1 : e.training;
            0 < this.dropout && this.dropout < 1 && this.dropoutMask == null && (this.dropoutMask = Us({
                ones: ()=>Rn(t),
                rate: this.dropout,
                training: o,
                dropoutFunc: this.dropoutFunc
            })), 0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null && (this.recurrentDropoutMask = Us({
                ones: ()=>Rn(s),
                rate: this.recurrentDropout,
                training: o,
                dropoutFunc: this.dropoutFunc
            }));
            let r;
            const i = this.dropoutMask, a = this.recurrentDropoutMask;
            i != null ? r = ns(G(t, i), this.kernel.read()) : r = ns(t, this.kernel.read()), this.bias != null && (r = _n(r, this.bias.read())), a != null && (s = G(s, a));
            let l = U(r, ns(s, this.recurrentKernel.read()));
            return this.activation != null && (l = this.activation.apply(l)), [
                l,
                l
            ];
        });
    }
    getConfig() {
        const t = super.getConfig(), e = {
            units: this.units,
            activation: Hs(this.activation),
            useBias: this.useBias,
            kernelInitializer: jt(this.kernelInitializer),
            recurrentInitializer: jt(this.recurrentInitializer),
            biasInitializer: jt(this.biasInitializer),
            kernelRegularizer: zt(this.kernelRegularizer),
            recurrentRegularizer: zt(this.recurrentRegularizer),
            biasRegularizer: zt(this.biasRegularizer),
            activityRegularizer: zt(this.activityRegularizer),
            kernelConstraint: he(this.kernelConstraint),
            recurrentConstraint: he(this.recurrentConstraint),
            biasConstraint: he(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout
        };
        return Object.assign(Object.assign({}, t), e);
    }
}
Mf.className = "SimpleRNNCell";
_(Mf);
class Wy extends no {
    constructor(t){
        t.cell = new Mf(t), super(t);
    }
    call(t, e) {
        return D(()=>{
            this.cell.dropoutMask != null && (xt(this.cell.dropoutMask), this.cell.dropoutMask = null), this.cell.recurrentDropoutMask != null && (xt(this.cell.recurrentDropoutMask), this.cell.recurrentDropoutMask = null);
            const s = e == null ? null : e.mask, o = e == null ? null : e.training, r = e == null ? null : e.initialState;
            return super.call(t, {
                mask: s,
                training: o,
                initialState: r
            });
        });
    }
    /** @nocollapse */ static fromConfig(t, e) {
        return new t(e);
    }
}
Wy.className = "SimpleRNN";
_(Wy);
class Wf extends mu {
    constructor(t){
        if (super(t), this.DEFAULT_ACTIVATION = "tanh", this.DEFAULT_RECURRENT_ACTIVATION = "hardSigmoid", this.DEFAULT_KERNEL_INITIALIZER = "glorotNormal", this.DEFAULT_RECURRENT_INITIALIZER = "orthogonal", this.DEFAULT_BIAS_INITIALIZER = "zeros", t.resetAfter) throw new E("GRUCell does not support reset_after parameter set to true.");
        this.units = t.units, xe(this.units, "units"), this.activation = _s(t.activation === void 0 ? this.DEFAULT_ACTIVATION : t.activation), this.recurrentActivation = _s(t.recurrentActivation === void 0 ? this.DEFAULT_RECURRENT_ACTIVATION : t.recurrentActivation), this.useBias = t.useBias == null ? !0 : t.useBias, this.kernelInitializer = Ut(t.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER), this.recurrentInitializer = Ut(t.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER), this.biasInitializer = Ut(t.biasInitializer || this.DEFAULT_BIAS_INITIALIZER), this.kernelRegularizer = Qt(t.kernelRegularizer), this.recurrentRegularizer = Qt(t.recurrentRegularizer), this.biasRegularizer = Qt(t.biasRegularizer), this.kernelConstraint = pe(t.kernelConstraint), this.recurrentConstraint = pe(t.recurrentConstraint), this.biasConstraint = pe(t.biasConstraint), this.dropout = xr([
            1,
            Bs([
                0,
                t.dropout == null ? 0 : t.dropout
            ])
        ]), this.recurrentDropout = xr([
            1,
            Bs([
                0,
                t.recurrentDropout == null ? 0 : t.recurrentDropout
            ])
        ]), this.dropoutFunc = t.dropoutFunc, this.implementation = t.implementation, this.stateSize = this.units, this.dropoutMask = null, this.recurrentDropoutMask = null;
    }
    build(t) {
        t = Rt(t);
        const e = t[t.length - 1];
        this.kernel = this.addWeight("kernel", [
            e,
            this.units * 3
        ], null, this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.recurrentKernel = this.addWeight("recurrent_kernel", [
            this.units,
            this.units * 3
        ], null, this.recurrentInitializer, this.recurrentRegularizer, !0, this.recurrentConstraint), this.useBias ? this.bias = this.addWeight("bias", [
            this.units * 3
        ], null, this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint) : this.bias = null, this.built = !0;
    }
    call(t, e) {
        return D(()=>{
            if (t, t.length !== 2) throw new E(`GRUCell expects 2 input Tensors (inputs, h, c), got ${t.length}.`);
            const s = e.training == null ? !1 : e.training;
            let o = t[1];
            t = t[0], 0 < this.dropout && this.dropout < 1 && this.dropoutMask == null && (this.dropoutMask = Us({
                ones: ()=>Rn(t),
                rate: this.dropout,
                training: s,
                count: 3,
                dropoutFunc: this.dropoutFunc
            })), 0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null && (this.recurrentDropoutMask = Us({
                ones: ()=>Rn(o),
                rate: this.recurrentDropout,
                training: s,
                count: 3,
                dropoutFunc: this.dropoutFunc
            }));
            const r = this.dropoutMask, i = this.recurrentDropoutMask;
            let a, l, c;
            0 < this.dropout && this.dropout < 1 && (t = G(t, r[0]));
            let u = ns(t, this.kernel.read());
            this.useBias && (u = _n(u, this.bias.read())), 0 < this.recurrentDropout && this.recurrentDropout < 1 && (o = G(o, i[0]));
            const d = this.recurrentKernel.read(), [h, p] = pn(d, [
                2 * this.units,
                this.units
            ], d.rank - 1), f = ns(o, h), [m, g, b] = pn(u, 3, u.rank - 1), [x, w] = pn(f, 2, f.rank - 1);
            a = this.recurrentActivation.apply(U(m, x)), l = this.recurrentActivation.apply(U(g, w));
            const y = ns(G(l, o), p);
            c = this.activation.apply(U(b, y));
            const I = U(G(a, o), G(U(1, Yt(a)), c));
            return [
                I,
                I
            ];
        });
    }
    getConfig() {
        const t = super.getConfig(), e = {
            units: this.units,
            activation: Hs(this.activation),
            recurrentActivation: Hs(this.recurrentActivation),
            useBias: this.useBias,
            kernelInitializer: jt(this.kernelInitializer),
            recurrentInitializer: jt(this.recurrentInitializer),
            biasInitializer: jt(this.biasInitializer),
            kernelRegularizer: zt(this.kernelRegularizer),
            recurrentRegularizer: zt(this.recurrentRegularizer),
            biasRegularizer: zt(this.biasRegularizer),
            activityRegularizer: zt(this.activityRegularizer),
            kernelConstraint: he(this.kernelConstraint),
            recurrentConstraint: he(this.recurrentConstraint),
            biasConstraint: he(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout,
            implementation: this.implementation,
            resetAfter: !1
        };
        return Object.assign(Object.assign({}, t), e);
    }
}
Wf.className = "GRUCell";
_(Wf);
class Dy extends no {
    constructor(t){
        t.implementation === 0 && console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call."), t.cell = new Wf(t), super(t);
    }
    call(t, e) {
        return D(()=>{
            this.cell.dropoutMask != null && (xt(this.cell.dropoutMask), this.cell.dropoutMask = null), this.cell.recurrentDropoutMask != null && (xt(this.cell.recurrentDropoutMask), this.cell.recurrentDropoutMask = null);
            const s = e == null ? null : e.mask, o = e == null ? null : e.training, r = e == null ? null : e.initialState;
            return super.call(t, {
                mask: s,
                training: o,
                initialState: r
            });
        });
    }
    /** @nocollapse */ static fromConfig(t, e) {
        return e.implmentation === 0 && (e.implementation = 1), new t(e);
    }
}
Dy.className = "GRU";
_(Dy);
class gu extends mu {
    constructor(t){
        super(t), this.DEFAULT_ACTIVATION = "tanh", this.DEFAULT_RECURRENT_ACTIVATION = "hardSigmoid", this.DEFAULT_KERNEL_INITIALIZER = "glorotNormal", this.DEFAULT_RECURRENT_INITIALIZER = "orthogonal", this.DEFAULT_BIAS_INITIALIZER = "zeros", this.units = t.units, xe(this.units, "units"), this.activation = _s(t.activation === void 0 ? this.DEFAULT_ACTIVATION : t.activation), this.recurrentActivation = _s(t.recurrentActivation === void 0 ? this.DEFAULT_RECURRENT_ACTIVATION : t.recurrentActivation), this.useBias = t.useBias == null ? !0 : t.useBias, this.kernelInitializer = Ut(t.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER), this.recurrentInitializer = Ut(t.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER), this.biasInitializer = Ut(t.biasInitializer || this.DEFAULT_BIAS_INITIALIZER), this.unitForgetBias = t.unitForgetBias, this.kernelRegularizer = Qt(t.kernelRegularizer), this.recurrentRegularizer = Qt(t.recurrentRegularizer), this.biasRegularizer = Qt(t.biasRegularizer), this.kernelConstraint = pe(t.kernelConstraint), this.recurrentConstraint = pe(t.recurrentConstraint), this.biasConstraint = pe(t.biasConstraint), this.dropout = xr([
            1,
            Bs([
                0,
                t.dropout == null ? 0 : t.dropout
            ])
        ]), this.recurrentDropout = xr([
            1,
            Bs([
                0,
                t.recurrentDropout == null ? 0 : t.recurrentDropout
            ])
        ]), this.dropoutFunc = t.dropoutFunc, this.implementation = t.implementation, this.stateSize = [
            this.units,
            this.units
        ], this.dropoutMask = null, this.recurrentDropoutMask = null;
    }
    build(t) {
        var e;
        t = Rt(t);
        const s = t[t.length - 1];
        this.kernel = this.addWeight("kernel", [
            s,
            this.units * 4
        ], null, this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.recurrentKernel = this.addWeight("recurrent_kernel", [
            this.units,
            this.units * 4
        ], null, this.recurrentInitializer, this.recurrentRegularizer, !0, this.recurrentConstraint);
        let o;
        if (this.useBias) {
            if (this.unitForgetBias) {
                const r = this.biasInitializer, i = this.units;
                o = new (e = class extends Gn {
                    apply(l, c) {
                        const u = r.apply([
                            i
                        ]), d = new yf().apply([
                            i
                        ]), h = r.apply([
                            i * 2
                        ]);
                        return Zm(Zm(u, d), h);
                    }
                }, /** @nocollapse */ e.className = "CustomInit", e)();
            } else o = this.biasInitializer;
            this.bias = this.addWeight("bias", [
                this.units * 4
            ], null, o, this.biasRegularizer, !0, this.biasConstraint);
        } else this.bias = null;
        this.built = !0;
    }
    call(t, e) {
        return D(()=>{
            const s = e.training == null ? !1 : e.training;
            if (t, t.length !== 3) throw new E(`LSTMCell expects 3 input Tensors (inputs, h, c), got ${t.length}.`);
            let o = t[1];
            const r = t[2];
            t = t[0], 0 < this.dropout && this.dropout < 1 && this.dropoutMask == null && (this.dropoutMask = Us({
                ones: ()=>Rn(t),
                rate: this.dropout,
                training: s,
                count: 4,
                dropoutFunc: this.dropoutFunc
            })), 0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null && (this.recurrentDropoutMask = Us({
                ones: ()=>Rn(o),
                rate: this.recurrentDropout,
                training: s,
                count: 4,
                dropoutFunc: this.dropoutFunc
            }));
            const i = this.dropoutMask, a = this.recurrentDropoutMask;
            let l, c, u, d;
            0 < this.dropout && this.dropout < 1 && (t = G(t, i[0]));
            let h = ns(t, this.kernel.read());
            0 < this.recurrentDropout && this.recurrentDropout < 1 && (o = G(o, a[0])), h = U(h, ns(o, this.recurrentKernel.read())), this.useBias && (h = _n(h, this.bias.read()));
            const [p, f, m, g] = pn(h, 4, h.rank - 1);
            l = this.recurrentActivation.apply(p), c = this.recurrentActivation.apply(f), u = U(G(c, r), G(l, this.activation.apply(m))), d = this.recurrentActivation.apply(g);
            const b = G(d, this.activation.apply(u));
            return [
                b,
                b,
                u
            ];
        });
    }
    getConfig() {
        const t = super.getConfig(), e = {
            units: this.units,
            activation: Hs(this.activation),
            recurrentActivation: Hs(this.recurrentActivation),
            useBias: this.useBias,
            kernelInitializer: jt(this.kernelInitializer),
            recurrentInitializer: jt(this.recurrentInitializer),
            biasInitializer: jt(this.biasInitializer),
            unitForgetBias: this.unitForgetBias,
            kernelRegularizer: zt(this.kernelRegularizer),
            recurrentRegularizer: zt(this.recurrentRegularizer),
            biasRegularizer: zt(this.biasRegularizer),
            activityRegularizer: zt(this.activityRegularizer),
            kernelConstraint: he(this.kernelConstraint),
            recurrentConstraint: he(this.recurrentConstraint),
            biasConstraint: he(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout,
            implementation: this.implementation
        };
        return Object.assign(Object.assign({}, t), e);
    }
}
gu.className = "LSTMCell";
_(gu);
class Fy extends no {
    constructor(t){
        t.implementation === 0 && console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call."), t.cell = new gu(t), super(t);
    }
    call(t, e) {
        return D(()=>{
            this.cell.dropoutMask != null && (xt(this.cell.dropoutMask), this.cell.dropoutMask = null), this.cell.recurrentDropoutMask != null && (xt(this.cell.recurrentDropoutMask), this.cell.recurrentDropoutMask = null);
            const s = e == null ? null : e.mask, o = e == null ? null : e.training, r = e == null ? null : e.initialState;
            return super.call(t, {
                mask: s,
                training: o,
                initialState: r
            });
        });
    }
    /** @nocollapse */ static fromConfig(t, e) {
        return e.implmentation === 0 && (e.implementation = 1), new t(e);
    }
}
Fy.className = "LSTM";
_(Fy);
class Df extends mu {
    constructor(t){
        super(t), this.cells = t.cells;
    }
    get stateSize() {
        const t = [];
        for (const e of this.cells.slice().reverse())Array.isArray(e.stateSize) ? t.push(...e.stateSize) : t.push(e.stateSize);
        return t;
    }
    call(t, e) {
        return D(()=>{
            t;
            let s = t.slice(1);
            const o = [];
            for (const a of this.cells.slice().reverse())Array.isArray(a.stateSize) ? o.push(s.splice(0, a.stateSize.length)) : o.push(s.splice(0, 1));
            o.reverse();
            const r = [];
            let i;
            for(let a = 0; a < this.cells.length; ++a){
                const l = this.cells[a];
                s = o[a], a === 0 ? i = [
                    t[0]
                ].concat(s) : i = [
                    i[0]
                ].concat(s), i = l.call(i, e), r.push(i.slice(1));
            }
            s = [];
            for (const a of r.slice().reverse())s.push(...a);
            return [
                i[0]
            ].concat(s);
        });
    }
    build(t) {
        Gd(t) && (t = t[0]), t;
        let e;
        this.cells.forEach((s, o)=>{
            wo(`RNNCell_${o}`, ()=>{
                s.build(t), Array.isArray(s.stateSize) ? e = s.stateSize[0] : e = s.stateSize, t = [
                    t[0],
                    e
                ];
            });
        }), this.built = !0;
    }
    getConfig() {
        const t = super.getConfig(), e = (r)=>({
                className: r.getClassName(),
                config: r.getConfig()
            }), o = {
            cells: this.cells.map(e)
        };
        return Object.assign(Object.assign({}, t), o);
    }
    /** @nocollapse */ static fromConfig(t, e, s = {}) {
        const o = [];
        for (const r of e.cells)o.push(An(r, s));
        return new t({
            cells: o
        });
    }
    get trainableWeights() {
        if (!this.trainable) return [];
        const t = [];
        for (const e of this.cells)t.push(...e.trainableWeights);
        return t;
    }
    get nonTrainableWeights() {
        const t = [];
        for (const e of this.cells)t.push(...e.nonTrainableWeights);
        if (!this.trainable) {
            const e = [];
            for (const s of this.cells)e.push(...s.trainableWeights);
            return e.concat(t);
        }
        return t;
    }
    /**
   * Retrieve the weights of a the model.
   *
   * @returns A flat `Array` of `tf.Tensor`s.
   */ getWeights() {
        const t = [];
        for (const e of this.cells)t.push(...e.weights);
        return Ed(t);
    }
    /**
   * Set the weights of the model.
   *
   * @param weights An `Array` of `tf.Tensor`s with shapes and types matching
   *     the output of `getWeights()`.
   */ setWeights(t) {
        const e = [];
        for (const s of this.cells){
            const o = s.weights.length, r = t.splice(o);
            for(let i = 0; i < s.weights.length; ++i)e.push([
                s.weights[i],
                r[i]
            ]);
        }
        Tf(e);
    }
}
Df.className = "StackedRNNCells";
_(Df);
function Us(n) {
    const { ones: t, rate: e, training: s = !1, count: o = 1, dropoutFunc: r } = n, i = ()=>r != null ? r(t(), e) : $x(t(), e), a = ()=>Ma(i, t, s);
    return !o || o <= 1 ? hn(a().clone()) : Array(o).fill(void 0).map(a).map((c)=>hn(c.clone()));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ var x3 = function(n, t) {
    var e = {};
    for(var s in n)Object.prototype.hasOwnProperty.call(n, s) && t.indexOf(s) < 0 && (e[s] = n[s]);
    if (n != null && typeof Object.getOwnPropertySymbols == "function") for(var o = 0, s = Object.getOwnPropertySymbols(n); o < s.length; o++)t.indexOf(s[o]) < 0 && Object.prototype.propertyIsEnumerable.call(n, s[o]) && (e[s[o]] = n[s[o]]);
    return e;
};
class Vy extends no {
    constructor(t){
        if (t.unroll) throw new yt("Unrolling is not possible with convolutional RNNs.");
        if (Array.isArray(t.cell)) throw new yt("It is not possible at the moment to stack convolutional cells.");
        super(t), this.inputSpec = [
            new de({
                ndim: 5
            })
        ];
    }
    call(t, e) {
        return D(()=>{
            if (this.cell.dropoutMask != null && (xt(this.cell.dropoutMask), this.cell.dropoutMask = null), this.cell.recurrentDropoutMask != null && (xt(this.cell.recurrentDropoutMask), this.cell.recurrentDropoutMask = null), e && e.constants) throw new E("ConvRNN2D cell does not support constants");
            const s = e == null ? null : e.mask, o = e == null ? null : e.training, r = e == null ? null : e.initialState;
            return super.call(t, {
                mask: s,
                training: o,
                initialState: r
            });
        });
    }
    computeOutputShape(t) {
        let e = this.computeSingleOutputShape(t);
        return this.returnSequences || (e = [
            e[0],
            ...e.slice(2)
        ]), this.returnState && (e = [
            e,
            ...Array(2).fill([
                t[0],
                ...e.slice(-3)
            ])
        ]), e;
    }
    getInitialState(t) {
        return D(()=>{
            const { stateSize: e } = this.cell, s = t.shape, o = this.computeSingleOutputShape(s), r = [
                o[0],
                ...o.slice(2)
            ], i = be(r);
            return Array.isArray(e) ? Array(e.length).fill(i) : [
                i
            ];
        });
    }
    resetStates(t, e = !1) {
        D(()=>{
            if (!this.stateful) throw new Qn("Cannot call resetStates() on an RNN Layer that is not stateful.");
            const s = this.inputSpec[0].shape, o = this.computeSingleOutputShape(s), r = [
                o[0],
                ...o.slice(2)
            ];
            if (s[0] == null) throw new E("If an RNN is stateful, it needs to know its batch size. Specify the batch size of your input tensors: \n- If using a Sequential model, specify the batch size by passing a `batchInputShape` option to your first layer.\n- If using the functional API, specify the batch size by passing a `batchShape` option to your Input layer.");
            if (this.getStates() == null) Array.isArray(this.cell.stateSize) ? this.states_ = this.cell.stateSize.map(()=>be(r)) : this.states_ = [
                be(r)
            ];
            else if (t == null) xt(this.states_), this.keptStates != null && (xt(this.keptStates), this.keptStates = []), Array.isArray(this.cell.stateSize) ? this.states_ = this.cell.stateSize.map(()=>be(r)) : this.states_[0] = be(r);
            else {
                if (Array.isArray(t) || (t = [
                    t
                ]), t.length !== this.states_.length) throw new E(`Layer ${this.name} expects ${this.states_.length} state(s), but it received ${t.length} state value(s). Input received: ${t}`);
                e ? this.keptStates.push(this.states_.slice()) : xt(this.states_);
                for(let a = 0; a < this.states_.length; ++a){
                    const l = t[a], c = r;
                    if (!$t(l.shape, c)) throw new E(`State ${a} is incompatible with layer ${this.name}: expected shape=${c}, received shape=${l.shape}`);
                    this.states_[a] = l;
                }
            }
            this.states_ = this.states_.map((a)=>hn(a.clone()));
        });
    }
    computeSingleOutputShape(t) {
        const { dataFormat: e, filters: s, kernelSize: o, padding: r, strides: i, dilationRate: a } = this.cell, l = e === "channelsFirst", c = t[l ? 3 : 2], u = t[l ? 4 : 3], d = On(c, o[0], r, i[0], a[0]), h = On(u, o[1], r, i[1], a[1]);
        return [
            ...t.slice(0, 2),
            ...l ? [
                s,
                d,
                h
            ] : [
                d,
                h,
                s
            ]
        ];
    }
}
Vy.className = "ConvRNN2D";
class Ff extends gu {
    constructor(t){
        const { filters: e, kernelSize: s, strides: o, padding: r, dataFormat: i, dilationRate: a } = t;
        super(Object.assign(Object.assign({}, t), {
            units: e
        })), this.filters = e, xe(this.filters, "filters"), this.kernelSize = dr(s, 2, "kernelSize"), this.kernelSize.forEach((l)=>xe(l, "kernelSize")), this.strides = dr(o || 1, 2, "strides"), this.strides.forEach((l)=>xe(l, "strides")), this.padding = r || "valid", gn(this.padding), this.dataFormat = i || "channelsLast", ae(this.dataFormat), this.dilationRate = dr(a || 1, 2, "dilationRate"), this.dilationRate.forEach((l)=>xe(l, "dilationRate"));
    }
    build(t) {
        var e;
        t = Rt(t);
        const s = this.dataFormat === "channelsFirst" ? 1 : t.length - 1;
        if (t[s] == null) throw new E(`The channel dimension of the input should be defined. Found ${t[s]}`);
        const o = t[s], r = 4, i = this.kernelSize.concat([
            o,
            this.filters * r
        ]);
        this.kernel = this.addWeight("kernel", i, null, this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint);
        const a = this.kernelSize.concat([
            this.filters,
            this.filters * r
        ]);
        if (this.recurrentKernel = this.addWeight("recurrent_kernel", a, null, this.recurrentInitializer, this.recurrentRegularizer, !0, this.recurrentConstraint), this.useBias) {
            let l;
            if (this.unitForgetBias) {
                const c = this.biasInitializer, u = this.filters;
                l = new (e = class extends Gn {
                    apply(h, p) {
                        const f = c.apply([
                            u
                        ]), m = ks([
                            u
                        ]), g = c.apply([
                            u * 2
                        ]);
                        return xf([
                            f,
                            m,
                            g
                        ]);
                    }
                }, /** @nocollapse */ e.className = "CustomInit", e)();
            } else l = this.biasInitializer;
            this.bias = this.addWeight("bias", [
                this.filters * r
            ], null, l, this.biasRegularizer, !0, this.biasConstraint);
        }
        this.built = !0;
    }
    call(t, e) {
        return D(()=>{
            if (t.length !== 3) throw new E(`ConvLSTM2DCell expects 3 input Tensors (inputs, h, c), got ${t.length}.`);
            const s = e.training || !1, o = t[0], r = t[1], i = t[2], a = 4;
            0 < this.dropout && this.dropout < 1 && this.dropoutMask == null && (this.dropoutMask = Us({
                ones: ()=>Rn(o),
                rate: this.dropout,
                training: s,
                count: a,
                dropoutFunc: this.dropoutFunc
            }));
            const l = this.dropoutMask, c = (Y, Q, j)=>!Q || !Q[j] ? Y : G(Q[j], Y);
            let u = c(o, l, 0), d = c(o, l, 1), h = c(o, l, 2), p = c(o, l, 3);
            0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null && (this.recurrentDropoutMask = Us({
                ones: ()=>Rn(r),
                rate: this.recurrentDropout,
                training: s,
                count: a,
                dropoutFunc: this.dropoutFunc
            }));
            const f = this.recurrentDropoutMask;
            let m = c(r, f, 0), g = c(r, f, 1), b = c(r, f, 2), x = c(r, f, 3);
            const w = 3, [y, I, v, k] = pn(this.kernel.read(), a, w), [S, N, R, M] = this.useBias ? pn(this.bias.read(), a) : [
                null,
                null,
                null,
                null
            ];
            u = this.inputConv(u, y, S, this.padding), d = this.inputConv(d, I, N, this.padding), h = this.inputConv(h, v, R, this.padding), p = this.inputConv(p, k, M, this.padding);
            const [V, z, P, A] = pn(this.recurrentKernel.read(), a, w);
            m = this.recurrentConv(m, V), g = this.recurrentConv(g, z), b = this.recurrentConv(b, P), x = this.recurrentConv(x, A);
            const O = this.recurrentActivation.apply(U(u, m)), B = this.recurrentActivation.apply(U(d, g)), Z = U(G(B, i), G(O, this.activation.apply(U(h, b)))), H = G(this.recurrentActivation.apply(U(p, x)), this.activation.apply(Z));
            return [
                H,
                H,
                Z
            ];
        });
    }
    getConfig() {
        const t = super.getConfig(), e = x3(t, [
            "units"
        ]), s = {
            filters: this.filters,
            kernelSize: this.kernelSize,
            padding: this.padding,
            dataFormat: this.dataFormat,
            dilationRate: this.dilationRate,
            strides: this.strides
        };
        return Object.assign(Object.assign({}, e), s);
    }
    inputConv(t, e, s, o) {
        const r = $o(t, e, this.strides, o || "valid", this.dataFormat === "channelsFirst" ? "NCHW" : "NHWC", this.dilationRate);
        return s ? _n(r, s, this.dataFormat) : r;
    }
    recurrentConv(t, e) {
        return $o(t, e, 1, "same", this.dataFormat === "channelsFirst" ? "NCHW" : "NHWC");
    }
}
Ff.className = "ConvLSTM2DCell";
_(Ff);
class zy extends Vy {
    constructor(t){
        const e = new Ff(t);
        super(Object.assign(Object.assign({}, t), {
            cell: e
        }));
    }
    /** @nocollapse */ static fromConfig(t, e) {
        return new t(e);
    }
}
zy.className = "ConvLSTM2D";
_(zy);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ class Vf extends St {
    constructor(t){
        super(t), this.rate = Math.max(Math.min(t.rate, 1), 0), this.noiseShape = t.noiseShape, this.seed = t.seed, this.supportsMasking = !0;
    }
    getNoiseShape(t) {
        if (this.noiseShape == null) return this.noiseShape;
        const e = t.shape, s = [];
        for(let o = 0; o < this.noiseShape.length; ++o)s.push(this.noiseShape[o] == null ? e[o] : this.noiseShape[o]);
        return s;
    }
    call(t, e) {
        return D(()=>{
            this.invokeCallHook(t, e);
            const s = mt(t);
            if (0 < this.rate && this.rate < 1) {
                const o = e.training == null ? !1 : e.training, r = this.getNoiseShape(s);
                return Ma(()=>$x(s, this.rate, r, this.seed), ()=>s, o);
            }
            return t;
        });
    }
    getConfig() {
        const t = {
            rate: this.rate,
            noiseShape: this.noiseShape,
            seed: this.seed
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
    dispose() {
        return super.dispose();
    }
}
Vf.className = "Dropout";
_(Vf);
class Py extends Vf {
    constructor(t){
        super(t), this.inputSpec = [
            {
                ndim: 3
            }
        ];
    }
    getNoiseShape(t) {
        const e = t.shape;
        return [
            e[0],
            1,
            e[2]
        ];
    }
}
Py.className = "SpatialDropout1D";
_(Py);
class Ay extends St {
    constructor(t){
        if (super(t), this.activation = null, this.useBias = !0, this.kernel = null, this.bias = null, this.DEFAULT_KERNEL_INITIALIZER = "glorotNormal", this.DEFAULT_BIAS_INITIALIZER = "zeros", t.batchInputShape == null && t.inputShape == null && t.inputDim != null) {
            let e = null;
            t.batchSize != null && (e = t.batchSize), this.batchInputShape = [
                e,
                t.inputDim
            ];
        }
        this.units = t.units, xe(this.units, "units"), this.activation = _s(t.activation), t.useBias != null && (this.useBias = t.useBias), this.kernelInitializer = Ut(t.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER), this.biasInitializer = Ut(t.biasInitializer || this.DEFAULT_BIAS_INITIALIZER), this.kernelConstraint = pe(t.kernelConstraint), this.biasConstraint = pe(t.biasConstraint), this.kernelRegularizer = Qt(t.kernelRegularizer), this.biasRegularizer = Qt(t.biasRegularizer), this.activityRegularizer = Qt(t.activityRegularizer), this.supportsMasking = !0, this.inputSpec = [
            {
                minNDim: 2
            }
        ];
    }
    build(t) {
        t = Rt(t);
        const e = t[t.length - 1];
        this.kernel == null && (this.kernel = this.addWeight("kernel", [
            e,
            this.units
        ], null, this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.useBias && (this.bias = this.addWeight("bias", [
            this.units
        ], null, this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint))), this.inputSpec = [
            {
                minNDim: 2,
                axes: {
                    [-1]: e
                }
            }
        ], this.built = !0;
    }
    computeOutputShape(t) {
        t = Rt(t);
        const e = t.slice();
        return e[e.length - 1] = this.units, e;
    }
    call(t, e) {
        return D(()=>{
            this.invokeCallHook(t, e);
            const s = mt(t), o = Cx(this.activation.getClassName());
            let r;
            return o != null ? r = ns(s, this.kernel.read(), o, this.bias ? this.bias.read() : null) : (r = ns(s, this.kernel.read()), this.bias != null && (r = _n(r, this.bias.read())), this.activation != null && (r = this.activation.apply(r))), r;
        });
    }
    getConfig() {
        const t = {
            units: this.units,
            activation: Hs(this.activation),
            useBias: this.useBias,
            kernelInitializer: jt(this.kernelInitializer),
            biasInitializer: jt(this.biasInitializer),
            kernelRegularizer: zt(this.kernelRegularizer),
            biasRegularizer: zt(this.biasRegularizer),
            activityRegularizer: zt(this.activityRegularizer),
            kernelConstraint: he(this.kernelConstraint),
            biasConstraint: he(this.biasConstraint)
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
Ay.className = "Dense";
_(Ay);
class Oy extends St {
    constructor(t){
        t = t || {}, super(t), this.inputSpec = [
            {
                minNDim: 3
            }
        ], this.dataFormat = t.dataFormat;
    }
    computeOutputShape(t) {
        t = Rt(t);
        for (const e of t.slice(1))if (e == null) throw new E(`The shape of the input to "Flatten" is not fully defined (got ${t.slice(1)}). Make sure to pass a complete "input_shape" or "batch_input_shape" argument to the first layer in your model.`);
        return [
            t[0],
            As(t, 1)
        ];
    }
    call(t, e) {
        return D(()=>{
            this.invokeCallHook(t, e);
            let s = mt(t);
            if (this.dataFormat === "channelsFirst" && s.rank > 1) {
                const o = [
                    0
                ];
                for(let r = 2; r < s.rank; ++r)o.push(r);
                o.push(1), s = kt(s, o);
            }
            return JE(s);
        });
    }
    getConfig() {
        const t = {};
        this.dataFormat != null && (t.dataFormat = this.dataFormat);
        const e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
Oy.className = "Flatten";
_(Oy);
class Xy extends St {
    constructor(t){
        super(t), this.supportsMasking = !0, this.activation = _s(t.activation);
    }
    call(t, e) {
        return D(()=>{
            this.invokeCallHook(t, e);
            const s = mt(t);
            return this.activation.apply(s);
        });
    }
    getConfig() {
        const t = {
            activation: Hs(this.activation)
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
Xy.className = "Activation";
_(Xy);
class Ky extends St {
    constructor(t){
        super(t), this.n = t.n, this.inputSpec = [
            {
                ndim: 2
            }
        ];
    }
    computeOutputShape(t) {
        return [
            t[0],
            this.n,
            t[1]
        ];
    }
    call(t, e) {
        return D(()=>(t = mt(t), YE(t, this.n)));
    }
    getConfig() {
        const t = {
            n: this.n
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
Ky.className = "RepeatVector";
_(Ky);
class Zy extends St {
    constructor(t){
        super(t), this.targetShape = t.targetShape;
        for(let e = 0; e < this.targetShape.length; ++e)this.isUnknown(this.targetShape[e]) && (this.targetShape[e] = null);
    }
    isUnknown(t) {
        return t < 0 || t == null;
    }
    /**
   * Finds and replaces a missing dimension in output shape.
   *
   * This is a near direct port of the internal Numpy function
   * `_fix_unknown_dimension` in `numpy/core/src/multiarray/shape.c`.
   *
   * @param inputShape: Original shape of array begin reshape.
   * @param outputShape: Target shape of the array, with at most a single
   * `null` or negative number, which indicates an underdetermined dimension
   * that should be derived from `inputShape` and the known dimensions of
   *   `outputShape`.
   * @returns: The output shape with `null` replaced with its computed value.
   * @throws: ValueError: If `inputShape` and `outputShape` do not match.
   */ fixUnknownDimension(t, e) {
        const s = "Total size of new array must be unchanged.", o = e.slice();
        let r = 1, i = null;
        for(let l = 0; l < o.length; ++l){
            const c = o[l];
            if (this.isUnknown(c)) {
                if (i === null) i = l;
                else throw new E("Can only specifiy one unknown dimension.");
            } else r *= c;
        }
        const a = As(t);
        if (i !== null) {
            if (r === 0 || a % r !== 0) throw new E(s);
            o[i] = a / r;
        } else if (a !== r) throw new E(s);
        return o;
    }
    computeOutputShape(t) {
        let e = !1;
        for(let s = 0; s < t.length; ++s)if (this.isUnknown(t[s])) {
            e = !0;
            break;
        }
        return e ? t.slice(0, 1).concat(this.targetShape) : t.slice(0, 1).concat(this.fixUnknownDimension(t.slice(1), this.targetShape));
    }
    call(t, e) {
        return D(()=>{
            this.invokeCallHook(t, e);
            const s = mt(t), o = s.shape, r = o.slice(0, 1).concat(this.fixUnknownDimension(o.slice(1), this.targetShape));
            return W(s, r);
        });
    }
    getConfig() {
        const t = {
            targetShape: this.targetShape
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
Zy.className = "Reshape";
_(Zy);
class By extends St {
    constructor(t){
        if (super(t), t.dims == null) throw new Error("Required configuration field `dims` is missing during Permute constructor call.");
        if (!Array.isArray(t.dims)) throw new Error(`Permute constructor requires \`dims\` to be an Array, but received ${t.dims} instead.`);
        const e = Kn(1, t.dims.length + 1);
        if (!$t(t.dims.slice().sort(), e)) throw new Error("Invalid permutation `dims`: " + JSON.stringify(t.dims) + " `dims` must contain consecutive integers starting from 1.");
        this.dims = t.dims, this.dimsIncludingBatch = [
            0
        ].concat(this.dims), this.inputSpec = [
            new de({
                ndim: this.dims.length + 1
            })
        ];
    }
    computeOutputShape(t) {
        t = Rt(t);
        const e = t.slice();
        return this.dims.forEach((s, o)=>{
            e[o + 1] = t[s];
        }), e;
    }
    call(t, e) {
        return kt(mt(t), this.dimsIncludingBatch);
    }
    getConfig() {
        const t = {
            dims: this.dims
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
By.className = "Permute";
_(By);
class Hy extends St {
    constructor(t){
        super(t ?? {}), this.supportsMasking = !0, t != null ? this.maskValue = t.maskValue == null ? 0 : t.maskValue : this.maskValue = 0;
    }
    computeOutputShape(t) {
        return t;
    }
    getConfig() {
        const t = super.getConfig(), e = {
            maskValue: this.maskValue
        };
        return Object.assign(e, t), e;
    }
    computeMask(t, e) {
        const s = mt(t);
        return Id(ui(s, this.maskValue), -1);
    }
    call(t, e) {
        return D(()=>{
            this.invokeCallHook(t, e);
            const s = mt(t), i = Id(ui(s, this.maskValue), -1, !0);
            return G(s, tt(i, s.dtype));
        });
    }
}
Hy.className = "Masking";
_(Hy);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ class _y extends St {
    constructor(t){
        if (super(t), this.embeddings = null, this.DEFAULT_EMBEDDINGS_INITIALIZER = "randomUniform", t.batchInputShape == null && t.inputShape == null) {
            let e = null;
            t.batchSize != null && (e = t.batchSize), t.inputLength == null ? this.batchInputShape = [
                e,
                null
            ] : this.batchInputShape = [
                e
            ].concat(Lt(t.inputLength));
        }
        this.inputDim = t.inputDim, xe(this.inputDim, "inputDim"), this.outputDim = t.outputDim, xe(this.outputDim, "outputDim"), this.embeddingsInitializer = Ut(t.embeddingsInitializer || this.DEFAULT_EMBEDDINGS_INITIALIZER), this.embeddingsRegularizer = Qt(t.embeddingsRegularizer), this.activityRegularizer = Qt(t.activityRegularizer), this.embeddingsConstraint = pe(t.embeddingsConstraint), this.maskZero = t.maskZero, this.supportsMasking = t.maskZero, this.inputLength = t.inputLength;
    }
    build(t) {
        this.embeddings = this.addWeight("embeddings", [
            this.inputDim,
            this.outputDim
        ], this.dtype, this.embeddingsInitializer, this.embeddingsRegularizer, !0, this.embeddingsConstraint), this.built = !0;
    }
    // Override warnOnIncompatibleInputShape because an embedding layer allows
    // the input to have varying ranks.
    warnOnIncompatibleInputShape(t) {}
    computeMask(t, e) {
        return D(()=>this.maskZero ? (t = mt(t), ui(t, Tt(t))) : null);
    }
    computeOutputShape(t) {
        if (t = Rt(t), this.inputLength == null) return [
            ...t,
            this.outputDim
        ];
        const e = Lt(this.inputLength);
        if (e.length !== t.length - 1) throw new E(`"inputLength" is ${this.inputLength}, but received input shape has shape ${t}`);
        {
            let s = 0;
            for(let o = 0; o < e.length; ++o){
                const r = e[o], i = t[o + 1];
                if (r != null && i != null && r !== i) throw new E(`"inputLength" is ${this.inputLength}, but received input shape has shape ${t}`);
                r == null && (e[s] = i), s++;
            }
        }
        return [
            t[0],
            ...e,
            this.outputDim
        ];
    }
    call(t, e) {
        return D(()=>{
            this.invokeCallHook(t, e);
            let s = mt(t);
            s.dtype !== "int32" && (s = es(s, "int32"));
            const o = Rx(this.embeddings.read(), W(s, [
                s.size
            ]));
            return W(o, Rt(this.computeOutputShape(s.shape)));
        });
    }
    getConfig() {
        const t = {
            inputDim: this.inputDim,
            outputDim: this.outputDim,
            embeddingsInitializer: jt(this.embeddingsInitializer),
            embeddingsRegularizer: zt(this.embeddingsRegularizer),
            activityRegularizer: zt(this.activityRegularizer),
            embeddingsConstraint: he(this.embeddingsConstraint),
            maskZero: this.maskZero,
            inputLength: this.inputLength
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
_y.className = "Embedding";
_(_y);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ class Yo extends St {
    constructor(t){
        super(t || {}), this.supportsMasking = !0;
    }
    /**
   * Logic for merging multiple tensors, to be overridden by subclasses.
   * @param inputs
   */ mergeFunction(t) {
        throw new yt();
    }
    /**
   * Computes the shape of the result of an elementwise operation.
   *
   * @param shape1: Shape of the first tensor.
   * @param shape2: Shape of the second tensor.
   * @returns Expected output shape when an elementwise operation is carried
   *   out on 2 tensors with shapes `shape1` and `shape2`.
   * @throws ValueError: If `shape1` and `shape2` are not compatible for
   *   element-wise operations.
   */ computeElementwiseOpOutputShape(t, e) {
        if (t == null || e == null) return null;
        if (t.length < e.length) return this.computeElementwiseOpOutputShape(e, t);
        if (e.length === 0) return t;
        const s = t.slice(0, t.length - e.length);
        for(let o = 0; o < e.length; ++o){
            const r = t[t.length - e.length + o], i = e[o];
            if (r == null || i == null || r < 0 || i < 0) s.push(null);
            else if (r === 1) s.push(i);
            else if (i === 1) s.push(r);
            else {
                if (r !== i) throw new E("Operands could not be broadcast together with shapes " + JSON.stringify(t) + " " + JSON.stringify(e));
                s.push(r);
            }
        }
        return s;
    }
    build(t) {
        if (Array.isArray(t) && !Array.isArray(t[0]) && (t = [
            Rt(t)
        ]), t, t.length < 2) throw new E(`A merge layer should be called on an Array of at least 2 inputs. Got ${t.length} input(s).`);
        let e = [];
        for (const r of t)r != null && r[0] !== null && e.push(r[0]);
        if (e = Ps(e), e.length > 1) throw new E(`Can not merge tensors with different batch sizes. Got tensors with shapes: ${JSON.stringify(t)}.`);
        let s = t[0] == null ? null : t[0].slice(1);
        for(let r = 1; r < t.length; ++r){
            const i = t[r] == null ? null : t[r].slice(1);
            s = this.computeElementwiseOpOutputShape(s, i);
        }
        const o = t.map((r)=>r.length);
        t.indexOf(null) === -1 && Ps(o).length === 1 ? this.reshapeRequired = !1 : this.reshapeRequired = !0;
    }
    call(t, e) {
        return D(()=>{
            if (t, this.reshapeRequired) {
                const s = [], o = t.map((r)=>r.rank);
                if (o.indexOf(null) === -1) {
                    const r = Bs(o);
                    for (let i of t){
                        const a = i.rank;
                        for(let l = 0; l < r - a; ++l)i = Ea(i, 1);
                        s.push(i);
                    }
                    return this.mergeFunction(s);
                } else {
                    let r = !1;
                    for (const l of t){
                        const c = l.rank;
                        if (c == null) {
                            const u = l.shape, d = u[0], h = u.slice(1).concat([
                                d
                            ]);
                            let p = W(l, [
                                d
                            ].concat(As(u.slice(1))));
                            p = kt(p, [
                                1,
                                0
                            ]), p = W(p, h), s.push(p), r = !0;
                        } else if (c > 1) {
                            const u = Kn(1, c).concat([
                                0
                            ]);
                            s.push(kt(l, u)), r = !0;
                        } else s.push(l);
                    }
                    let i = this.mergeFunction(s);
                    const a = i.rank;
                    if (r) {
                        if (a == null) {
                            const l = i.shape, c = l.length, u = l[c - 1], d = [
                                u
                            ].concat(l.slice(0, l.length - 1));
                            i = W(kt(W(i, [
                                -1,
                                u
                            ]), [
                                1,
                                0
                            ]), d);
                        } else if (a > 1) {
                            const l = [
                                a - 1
                            ].concat(Kn(0, a - 1));
                            i = kt(i, l);
                        }
                    }
                    return i;
                }
            } else return this.mergeFunction(t);
        });
    }
    computeOutputShape(t) {
        t;
        let e;
        t[0] == null ? e = null : e = t[0].slice(1);
        for(let o = 1; o < t.length; ++o){
            const r = t[o] == null ? null : t[o].slice(1);
            e = this.computeElementwiseOpOutputShape(e, r);
        }
        let s = [];
        for (const o of t)o != null && o[0] !== null && s.push(o[0]);
        return s = Ps(s), s.length === 1 ? e = s.concat(e) : e = [
            null
        ].concat(e), e;
    }
    computeMask(t, e) {
        return D(()=>{
            if (e == null) return null;
            if (!Array.isArray(e)) throw new E("`mask` should be an Array");
            if (!Array.isArray(t)) throw new E("`inputs` should be an Array");
            if (e.length !== t.length) throw new E(`The Array 'inputs' and 'mask' are expected to have the same length, but have different lengths (${t.length} vs ${e.length})`);
            if (e.every((o)=>o == null)) return null;
            e = e.map((o)=>o == null ? o : Oe(o, 0));
            let s = e[0];
            for(let o = 1; o < e.length - 1; ++o)s = ss(s, e[o]);
            return s;
        });
    }
}
class Uy extends Yo {
    constructor(t){
        super(t);
    }
    mergeFunction(t) {
        return D(()=>{
            let e = t[0].clone();
            for(let s = 1; s < t.length; ++s)e = U(e, t[s]);
            return e;
        });
    }
}
Uy.className = "Add";
_(Uy);
class Yy extends Yo {
    constructor(t){
        super(t);
    }
    mergeFunction(t) {
        return D(()=>{
            let e = t[0].clone();
            for(let s = 1; s < t.length; ++s)e = G(e, t[s]);
            return e;
        });
    }
}
Yy.className = "Multiply";
_(Yy);
class Qy extends Yo {
    constructor(t){
        super(t);
    }
    mergeFunction(t) {
        return D(()=>{
            let e = t[0].clone();
            for(let s = 1; s < t.length; ++s)e = U(e, t[s]);
            return G(1 / t.length, e);
        });
    }
}
Qy.className = "Average";
_(Qy);
class Jy extends Yo {
    constructor(t){
        super(t);
    }
    mergeFunction(t) {
        return D(()=>{
            let e = t[0];
            for(let s = 1; s < t.length; ++s)e = qs(e, t[s]);
            return e;
        });
    }
}
Jy.className = "Maximum";
_(Jy);
class jy extends Yo {
    constructor(t){
        super(t);
    }
    mergeFunction(t) {
        return D(()=>{
            let e = t[0];
            for(let s = 1; s < t.length; ++s)e = br(e, t[s]);
            return e;
        });
    }
}
jy.className = "Minimum";
_(jy);
class qy extends Yo {
    constructor(t){
        super(t), this.DEFAULT_AXIS = -1, t == null && (t = {}), this.axis = t.axis == null ? this.DEFAULT_AXIS : t.axis, this.supportsMasking = !0, this.reshapeRequired = !1;
    }
    build(t) {
        if (!(Array.isArray(t) && Array.isArray(t[0])) || t.length === 1) throw new E("A `Concatenate` layer should be called on a list of at least 2 inputs");
        t;
        let e = !0;
        for (const o of t)if (o != null) {
            e = !1;
            break;
        }
        if (e) return;
        const s = [];
        for(let o = 0; o < t.length; ++o){
            const r = t[o].slice();
            r.splice(this.axis, 1);
            let i = !1;
            for (const a of s)if ($t(a, r)) {
                i = !0;
                break;
            }
            i || s.push(r);
        }
        if (s.length > 1) throw new E("A `Concatenate` layer requires inputs with matching shapes except for the concat axis. Got input shapes: " + JSON.stringify(t));
    }
    mergeFunction(t) {
        return D(()=>xf(t, this.axis));
    }
    computeOutputShape(t) {
        if (!(Array.isArray(t) && Array.isArray(t[0]))) throw new E("A `Concatenate` layer should be called on a list of inputs.");
        const e = t, s = e[0].slice(), o = this.axis < 0 ? s.length + this.axis : this.axis;
        for (const r of e.slice(1)){
            if (s[o] == null || r[o] == null) {
                s[o] = null;
                break;
            }
            s[o] += r[o];
        }
        return s;
    }
    computeMask(t, e) {
        if (e == null) return null;
        if (!Array.isArray(e)) throw new E("`mask` should be an array for Concatenate");
        if (!Array.isArray(t)) throw new E("`inputs` should be an array for Concatenate");
        if (e.length !== t.length) throw new E(`Mismatch in the length of mask (${e.length}) and the legnth of inputs (${t.length})`);
        return D(()=>{
            let s = !0;
            if (e.forEach((i)=>{
                if (i != null) {
                    s = !1;
                    return;
                }
            }), s) return null;
            const o = [];
            for(let i = 0; i < t.length; ++i)e[i] == null ? o.push(tt(Rn(t[i]), "bool")) : e[i].rank < t[i].rank ? o.push(Oe(e[i], -1)) : o.push(e[i]);
            const r = Ge(o, this.axis);
            return Qb(r, -1, !1);
        });
    }
    getConfig() {
        const t = {
            axis: this.axis
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
qy.className = "Concatenate";
_(qy);
function Kr(n, t) {
    for(; n < 0;)n += t;
    return n;
}
function y3(n, t, e) {
    if (n.shape.length > 3 || t.shape.length > 3) throw new yt("batchDot is not implemented for tensors of 4D or higher rank yet");
    if (C(n.shape.length >= 2, ()=>`batchDot requires the rank of x to be >= 2, but got ${n.shape.length}`), C(n.shape.length >= 2, ()=>`batchDot requires the rank of y to be >= 2, but got ${t.shape.length}`), typeof e == "number" && (e = [
        e,
        e
    ]), n.dtype === "complex64" || t.dtype === "complex64") throw new yt("batchDot is not implemented for complex64-type Tensors yet.");
    const s = n.shape.length, o = t.shape.length;
    e == null && (e = [
        s - 1,
        o - 2
    ]);
    const r = e;
    return D(()=>{
        let i;
        if (s > o) {
            i = s - o;
            const l = [];
            for(let c = 0; c < i; ++c)l.push(1);
            t = W(t, t.shape.concat(l));
        } else if (o > s) {
            i = o - s;
            const l = [];
            for(let c = 0; c < i; ++c)l.push(1);
            n = W(n, n.shape.concat(l));
        } else i = 0;
        let a;
        if (n.shape.length === 2 && t.shape.length === 2) r[0] === r[1] ? a = at(G(n, t), r[0]) : a = at(G(kt(n, [
            1,
            0
        ]), t), r[1]);
        else {
            const l = r[0] !== n.shape.length - 1, c = r[1] === t.shape.length - 1;
            a = Gt(n, t, l, c);
        }
        if (i > 0) {
            let l;
            s > o ? l = s + o - 3 : l = s - 1;
            const c = [];
            for(let u = l; u < l + i; ++u)c.push(u);
            a = ka(a, c);
        }
        return a.shape.length === 1 && (a = Oe(a, 1)), a;
    });
}
class t1 extends Yo {
    constructor(t){
        super(t), this.axes = t.axes, this.normalize = t.normalize == null ? !1 : t.normalize, this.supportsMasking = !0, this.reshapeRequired = !1;
    }
    build(t) {
        C(Array.isArray(t) && t.length === 2 && Array.isArray(t[0]) && Array.isArray(t[1]), ()=>"A `Dot` layer should be called on a list of exactly 2 inputs.");
        const e = t[0], s = t[1];
        if (e.length > 3 || s.length > 3) throw new yt("Dot layer does not support tensors of 4D or higher rank yet.");
        const o = this.interpretAxes(e, s);
        if (e[o[0]] !== s[o[1]]) throw new E(`Dimension incompatibility: ${e[o[0]]} !== ${s[o[1]]}`);
    }
    mergeFunction(t) {
        if (t.length !== 2) throw new E(`A \`Dot\` layer must be called on exactly 2 inputs, but received ${t.length} input(s).`);
        let e = t[0], s = t[1], o;
        return Array.isArray(this.axes) ? o = this.axes.map((r, i)=>Kr(r, t[i].shape.length)) : o = [
            Kr(this.axes, e.shape.length),
            Kr(this.axes, s.shape.length)
        ], this.normalize && (e = Gl(e, o[0]), s = Gl(s, o[1])), y3(e, s, o);
    }
    interpretAxes(t, e) {
        let s;
        return Array.isArray(this.axes) ? s = this.axes : s = [
            Kr(this.axes, t.length),
            Kr(this.axes, e.length)
        ], s;
    }
    computeOutputShape(t) {
        C(Array.isArray(t) && t.length === 2 && Array.isArray(t[0]) && Array.isArray(t[1]), ()=>"A `Dot` layer should be called on a list of exactly 2 inputs.");
        const e = t[0].slice(), s = t[1].slice();
        if (e.length > 3 || s.length > 3) throw new yt("Dot layer does not support tensors of 4D or higher rank yet.");
        const o = this.interpretAxes(e, s);
        e.splice(o[0], 1), s.splice(o[1], 1), s.splice(0, 1);
        const r = e.concat(s);
        return r.length === 1 && r.push(1), r;
    }
    computeMask(t, e) {
        return null;
    }
    getConfig() {
        const t = {
            axes: this.axes,
            normalize: this.normalize
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
t1.className = "Dot";
_(t1);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ class e1 extends St {
    constructor(t){
        super(t), this.supportsMasking = !0, this.stddev = t.stddev;
    }
    computeOutputShape(t) {
        return t;
    }
    getConfig() {
        const t = super.getConfig(), e = {
            stddev: this.stddev
        };
        return Object.assign(e, t), e;
    }
    call(t, e) {
        return D(()=>{
            this.invokeCallHook(t, e);
            const s = mt(t);
            return Ma(()=>U(lu(s.shape, 0, this.stddev), s), ()=>s, e.training || !1);
        });
    }
}
e1.className = "GaussianNoise";
_(e1);
class n1 extends St {
    constructor(t){
        super(t), this.supportsMasking = !0, this.rate = t.rate;
    }
    computeOutputShape(t) {
        return t;
    }
    getConfig() {
        const t = super.getConfig(), e = {
            rate: this.rate
        };
        return Object.assign(e, t), e;
    }
    call(t, e) {
        return D(()=>{
            this.invokeCallHook(t, e);
            const s = mt(t);
            return this.rate > 0 && this.rate < 1 ? Ma(()=>{
                const r = Math.sqrt(this.rate / (1 - this.rate));
                return G(s, lu(s.shape, 1, r));
            }, ()=>s, e.training || !1) : s;
        });
    }
}
n1.className = "GaussianDropout";
_(n1);
class s1 extends St {
    constructor(t){
        super(t), this.supportsMasking = !0, this.rate = t.rate, this.noiseShape = t.noiseShape;
    }
    _getNoiseShape(t) {
        return this.noiseShape || mt(t).shape;
    }
    computeOutputShape(t) {
        return t;
    }
    getConfig() {
        const t = super.getConfig(), e = {
            rate: this.rate
        };
        return Object.assign(e, t), e;
    }
    call(t, e) {
        return D(()=>{
            if (this.rate < 1 && this.rate > 0) {
                const s = this._getNoiseShape(t);
                return Ma(()=>{
                    const r = mt(t), l = -1.7580993408473766;
                    let c = Bo(Sa(s), this.rate);
                    c = es(c, "float32");
                    const u = ((1 - this.rate) * (1 + this.rate * l ** 2)) ** -0.5, d = -u * l * this.rate, h = U(G(r, c), G(U(c, -1), l));
                    return U(G(h, u), d);
                }, ()=>mt(t), e.training || !1);
            }
            return t;
        });
    }
}
s1.className = "AlphaDropout";
_(s1);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function gi(n, t, e, s, o, r = 1e-3) {
    let i;
    if (n.rank === 2) i = Jv(n, t, e, s, o, r);
    else if (n.rank === 3) i = qv(n, t, e, s, o, r);
    else if (n.rank === 4) i = eS(n, t, e, s, o, r);
    else throw new yt(`batchNormalization is not implemented for array of rank ${n.rank} yet`);
    return i;
}
function w3(n, t, e, s, o = 1e-3) {
    return D(()=>{
        const r = gp(n, s), i = r.mean, a = r.variance;
        return [
            gi(n, i, a, e, t, o),
            i,
            a
        ];
    });
}
function I3(n, t, e, s, o = 1e-3) {
    return D(()=>{
        const r = gp(n, s), i = r.mean, a = r.variance, l = [];
        for (const f of Kn(0, n.rank))s.indexOf(f) !== -1 ? l.push(1) : l.push(n.shape[f]);
        const c = W(i, l), u = W(a, l), d = t == null ? null : W(t, l), h = e == null ? null : W(e, l);
        return [
            gi(n, c, u, h, d, o),
            i,
            a
        ];
    });
}
function C3(n, t, e, s, o = 1e-3) {
    return $t(s.slice().sort(), Kn(0, n.rank - 1)) ? w3(n, t, e, s, o) : I3(n, t, e, s, o);
}
class o1 extends St {
    constructor(t){
        t == null && (t = {}), super(t), this.supportsMasking = !0, this.axis = t.axis == null ? -1 : t.axis, this.momentum = t.momentum == null ? 0.99 : t.momentum, this.epsilon = t.epsilon == null ? 1e-3 : t.epsilon, this.center = t.center == null ? !0 : t.center, this.scale = t.scale == null ? !0 : t.scale, this.betaInitializer = Ut(t.betaInitializer || "zeros"), this.gammaInitializer = Ut(t.gammaInitializer || "ones"), this.movingMeanInitializer = Ut(t.movingMeanInitializer || "zeros"), this.movingVarianceInitializer = Ut(t.movingVarianceInitializer || "ones"), this.betaConstraint = pe(t.betaConstraint), this.gammaConstraint = pe(t.gammaConstraint), this.betaRegularizer = Qt(t.betaRegularizer), this.gammaRegularizer = Qt(t.gammaRegularizer);
    }
    build(t) {
        t = Rt(t);
        const e = this.axis >= 0 ? this.axis : this.axis + t.length, s = t[e];
        if (s == null) throw new E(`Axis ${e} of input tensor should have a defined dimension but the layer received an input with shape ${JSON.stringify(t)}.`);
        this.inputSpec = [
            new de({
                ndim: t.length,
                axes: {
                    [e]: s
                }
            })
        ];
        const o = [
            s
        ];
        this.scale && (this.gamma = this.addWeight("gamma", o, null, this.gammaInitializer, this.gammaRegularizer, !0, this.gammaConstraint)), this.center && (this.beta = this.addWeight("beta", o, null, this.betaInitializer, this.betaRegularizer, !0, this.betaConstraint)), this.movingMean = this.addWeight("moving_mean", o, null, this.movingMeanInitializer, null, !1), this.movingVariance = this.addWeight("moving_variance", o, null, this.movingVarianceInitializer, null, !1), this.built = !0;
    }
    call(t, e) {
        return D(()=>{
            const s = e.training == null ? !1 : e.training, o = mt(t), r = o.shape, i = r.length, a = Kn(0, i), l = this.axis >= 0 ? this.axis : this.axis + i;
            a.splice(l, 1);
            const c = Wo(1, i);
            c[l] = r[l];
            const u = a.slice();
            u.sort();
            const d = !$t(u, Kn(0, i).slice(0, i - 1)), h = ()=>{
                if (d) {
                    const x = W(this.movingMean.read(), c), w = W(this.movingVariance.read(), c), y = this.center ? W(this.beta.read(), c) : null, I = this.scale ? W(this.gamma.read(), c) : null;
                    return gi(o, x, w, y, I, this.epsilon);
                } else return gi(o, this.movingMean.read(), this.movingVariance.read(), this.beta == null ? null : this.beta.read(), this.gamma == null ? null : this.gamma.read(), this.epsilon);
            };
            if (!s) return h();
            const [p, f, m] = C3(o, this.gamma.read(), this.beta.read(), a, this.epsilon), g = (x, w, y)=>{
                D(()=>{
                    const I = 1 - y, v = x.read(), k = G(it(v, w), I);
                    x.write(it(v, k));
                });
            };
            return (()=>{
                g(this.movingMean, f, this.momentum), g(this.movingVariance, m, this.momentum);
            })(), p;
        });
    }
    getConfig() {
        const t = {
            axis: this.axis,
            momentum: this.momentum,
            epsilon: this.epsilon,
            center: this.center,
            scale: this.scale,
            betaInitializer: jt(this.betaInitializer),
            gammaInitializer: jt(this.gammaInitializer),
            movingMeanInitializer: jt(this.movingMeanInitializer),
            movingVarianceInitializer: jt(this.movingVarianceInitializer),
            betaRegularizer: zt(this.betaRegularizer),
            gammaRegularizer: zt(this.gammaRegularizer),
            betaConstraint: he(this.betaConstraint),
            gammaConstraint: he(this.gammaConstraint)
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
o1.className = "BatchNormalization";
_(o1);
class r1 extends St {
    constructor(t){
        if (t == null && (t = {}), super(t), this.axis = t.axis == null ? -1 : t.axis, typeof this.axis == "number") {
            if (!Number.isInteger(this.axis)) throw new Error(`Expected axis to be an integer, but received ${this.axis}`);
        } else if (Array.isArray(this.axis)) {
            for (const e of this.axis)if (!Number.isInteger(e)) throw new Error(`Expected axis to be an array of integers, but received ${JSON.stringify(this.axis)}`);
        } else throw new Error(`Expected axis to be an integer or an array of integers, but received ${JSON.stringify(this.axis)}`);
        this.epsilon = t.epsilon == null ? 1e-3 : t.epsilon, this.center = t.center == null ? !0 : t.center, this.scale = t.scale == null ? !0 : t.scale, this.betaInitializer = Ut(t.betaInitializer || "zeros"), this.gammaInitializer = Ut(t.gammaInitializer || "ones"), this.betaRegularizer = Qt(t.betaRegularizer), this.gammaRegularizer = Qt(t.gammaRegularizer), this.supportsMasking = !0;
    }
    build(t) {
        t = Rt(t);
        const e = t.length;
        typeof this.axis == "number" && (this.axis = [
            this.axis
        ]);
        for(let r = 0; r < this.axis.length; ++r)this.axis[r] < 0 && (this.axis[r] += e);
        for (const r of this.axis)if (r < 0 || r >= e) throw new Error(`Invalid axis: ${r}`);
        if (this.axis.length !== Ps(this.axis).length) throw new Error(`Found duplicate axes in: ${this.axis}`);
        const s = this.axis.map((r)=>t[r]), o = !0;
        this.scale ? this.gamma = this.addWeight("gamma", s, "float32", this.gammaInitializer, this.gammaRegularizer, o) : this.gamma = null, this.center ? this.beta = this.addWeight("beta", s, "float32", this.betaInitializer, this.betaRegularizer, o) : this.beta = null, this.built = !0;
    }
    call(t, e) {
        const s = mt(t), o = s.shape, r = o.length;
        return D(()=>{
            let { mean: a, variance: l } = gp(s, this.axis, !0);
            const c = Wo(1, r);
            for (const m of this.axis)c[m] = o[m];
            const u = (m)=>m != null && m.shape.length !== r ? W(m, c) : m;
            let d = this.scale ? u(this.gamma.read()) : null, h = this.center ? u(this.beta.read()) : null;
            const p = [], f = [];
            for(let m = 0; m < r; ++m)this.axis.indexOf(m) !== -1 ? (p.push(o[m]), f.push(1)) : (p.push(1), f.push(o[m]));
            return a = Vn(a, p), l = Vn(l, p), d != null && (d = Vn(d, f)), h != null && (h = Vn(h, f)), gi(s, a, l, h, d, this.epsilon);
        });
    }
    getConfig() {
        const t = {
            axis: this.axis,
            epsilon: this.epsilon,
            center: this.center,
            scale: this.scale,
            betaInitializer: jt(this.betaInitializer),
            gammaInitializer: jt(this.gammaInitializer),
            betaRegularizer: zt(this.betaRegularizer),
            gammaRegularizer: zt(this.gammaRegularizer)
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
r1.className = "LayerNormalization";
_(r1);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function v3(n, t, e) {
    return D(()=>{
        if (n.rank !== 4) throw new E(`temporalPadding expects input tensor to be 4-D, but received a ${n.rank}-D tensor.`);
        if (t == null && (t = [
            [
                1,
                1
            ],
            [
                1,
                1
            ]
        ]), t.length !== 2 || t[0].length !== 2 || t[1].length !== 2) throw new E("spatial2dPadding expects `padding` to be an Array of two Arrays, each of which is an Array of two integers.");
        if (e == null && (e = Zn()), e !== "channelsLast" && e !== "channelsFirst") throw new E(`Unknown data format: ${e}. Supported data formats are 'channelsLast' and 'channelsFirst.`);
        let s;
        return e === "channelsFirst" ? s = [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            t[0],
            t[1]
        ] : s = [
            [
                0,
                0
            ],
            t[0],
            t[1],
            [
                0,
                0
            ]
        ], bp(n, s);
    });
}
class i1 extends St {
    constructor(t){
        if (t == null && (t = {}), super(t), this.dataFormat = t.dataFormat == null ? Zn() : t.dataFormat, t.padding == null) this.padding = [
            [
                1,
                1
            ],
            [
                1,
                1
            ]
        ];
        else if (typeof t.padding == "number") this.padding = [
            [
                t.padding,
                t.padding
            ],
            [
                t.padding,
                t.padding
            ]
        ];
        else {
            if (t.padding = t.padding, t.padding.length !== 2) throw new E(`ZeroPadding2D expects padding to be a length-2 array, but received a length-${t.padding.length} array.`);
            let e, s;
            if (typeof t.padding[0] == "number") e = [
                t.padding[0],
                t.padding[0]
            ], s = [
                t.padding[1],
                t.padding[1]
            ];
            else {
                if (t.padding = t.padding, t.padding[0].length !== 2) throw new E(`ZeroPadding2D expects height padding to be a length-2 array, but received a length-${t.padding[0].length} array.`);
                if (e = t.padding[0], t.padding[1].length !== 2) throw new E(`ZeroPadding2D expects width padding to be a length-2 array, but received a length-${t.padding[1].length} array.`);
                s = t.padding[1];
            }
            this.padding = [
                e,
                s
            ];
        }
        this.inputSpec = [
            new de({
                ndim: 4
            })
        ];
    }
    computeOutputShape(t) {
        t = Rt(t);
        let e, s;
        return this.dataFormat === "channelsFirst" ? (t[2] != null && t[2] >= 0 ? e = t[2] + this.padding[0][0] + this.padding[0][1] : e = null, t[3] != null && t[3] >= 0 ? s = t[3] + this.padding[1][0] + this.padding[1][1] : s = null, [
            t[0],
            t[1],
            e,
            s
        ]) : (t[1] != null && t[1] >= 0 ? e = t[1] + this.padding[0][0] + this.padding[0][1] : e = null, t[2] != null && t[2] >= 0 ? s = t[2] + this.padding[1][0] + this.padding[1][1] : s = null, [
            t[0],
            e,
            s,
            t[3]
        ]);
    }
    call(t, e) {
        return D(()=>v3(mt(t), this.padding, this.dataFormat));
    }
    getConfig() {
        const t = {
            padding: this.padding,
            dataFormat: this.dataFormat
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
i1.className = "ZeroPadding2D";
_(i1);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function bu(n, t, e, s, o, r) {
    return D(()=>{
        ae(o), Sx(r), gn(s), e == null && (e = [
            1,
            1
        ]), s == null && (s = "valid"), o == null && (o = Zn()), r == null && (r = "max"), n = Lf(n, o);
        let i;
        const a = s === "same" ? "same" : "valid";
        return r === "max" ? i = mp(n, t, e, a) : i = np(// TODO(cais): Rank check?
        n, t, e, a), o === "channelsFirst" && (i = kt(i, [
            0,
            3,
            1,
            2
        ])), i;
    });
}
function a1(n, t, e, s, o, r) {
    return D(()=>{
        ae(o), Sx(r), gn(s), e == null && (e = [
            1,
            1,
            1
        ]), s == null && (s = "valid"), o == null && (o = Zn()), r == null && (r = "max"), n = Sy(n, o);
        let i;
        const a = s === "same" ? "same" : "valid";
        return r === "max" ? i = Ak(n, t, e, a) : i = Ov(n, t, e, a), o === "channelsFirst" && (i = kt(i, [
            0,
            4,
            1,
            2,
            3
        ])), i;
    });
}
class l1 extends St {
    /**
   *
   * @param args Parameters for the Pooling layer.
   *
   * config.poolSize defaults to 2.
   */ constructor(t){
        if (t.poolSize == null && (t.poolSize = 2), super(t), typeof t.poolSize == "number") this.poolSize = [
            t.poolSize
        ];
        else if (Array.isArray(t.poolSize) && t.poolSize.length === 1 && typeof t.poolSize[0] == "number") this.poolSize = t.poolSize;
        else throw new E(`poolSize for 1D convolutional layer must be a number or an Array of a single number, but received ${JSON.stringify(t.poolSize)}`);
        if (xe(this.poolSize, "poolSize"), t.strides == null) this.strides = this.poolSize;
        else if (typeof t.strides == "number") this.strides = [
            t.strides
        ];
        else if (Array.isArray(t.strides) && t.strides.length === 1 && typeof t.strides[0] == "number") this.strides = t.strides;
        else throw new E(`strides for 1D convolutional layer must be a number or an Array of a single number, but received ${JSON.stringify(t.strides)}`);
        xe(this.strides, "strides"), this.padding = t.padding == null ? "valid" : t.padding, gn(this.padding), this.inputSpec = [
            new de({
                ndim: 3
            })
        ];
    }
    computeOutputShape(t) {
        t = Rt(t);
        const e = On(t[1], this.poolSize[0], this.padding, this.strides[0]);
        return [
            t[0],
            e,
            t[2]
        ];
    }
    call(t, e) {
        return D(()=>{
            this.invokeCallHook(t, e), t = Ea(mt(t), 2);
            const s = this.poolingFunction(mt(t), [
                this.poolSize[0],
                1
            ], [
                this.strides[0],
                1
            ], this.padding, "channelsLast");
            return ka(s, [
                2
            ]);
        });
    }
    getConfig() {
        const t = {
            poolSize: this.poolSize,
            padding: this.padding,
            strides: this.strides
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
class c1 extends l1 {
    constructor(t){
        super(t);
    }
    poolingFunction(t, e, s, o, r) {
        return ae(r), gn(o), bu(t, e, s, o, r, "max");
    }
}
c1.className = "MaxPooling1D";
_(c1);
class u1 extends l1 {
    constructor(t){
        super(t);
    }
    poolingFunction(t, e, s, o, r) {
        return ae(r), gn(o), bu(t, e, s, o, r, "avg");
    }
}
u1.className = "AveragePooling1D";
_(u1);
class d1 extends St {
    constructor(t){
        if (t.poolSize == null && (t.poolSize = [
            2,
            2
        ]), super(t), this.poolSize = Array.isArray(t.poolSize) ? t.poolSize : [
            t.poolSize,
            t.poolSize
        ], t.strides == null) this.strides = this.poolSize;
        else if (Array.isArray(t.strides)) {
            if (t.strides.length !== 2) throw new E(`If the strides property of a 2D pooling layer is an Array, it is expected to have a length of 2, but received length ${t.strides.length}.`);
            this.strides = t.strides;
        } else this.strides = [
            t.strides,
            t.strides
        ];
        xe(this.poolSize, "poolSize"), xe(this.strides, "strides"), this.padding = t.padding == null ? "valid" : t.padding, this.dataFormat = t.dataFormat == null ? "channelsLast" : t.dataFormat, ae(this.dataFormat), gn(this.padding), this.inputSpec = [
            new de({
                ndim: 4
            })
        ];
    }
    computeOutputShape(t) {
        t = Rt(t);
        let e = this.dataFormat === "channelsFirst" ? t[2] : t[1], s = this.dataFormat === "channelsFirst" ? t[3] : t[2];
        return e = On(e, this.poolSize[0], this.padding, this.strides[0]), s = On(s, this.poolSize[1], this.padding, this.strides[1]), this.dataFormat === "channelsFirst" ? [
            t[0],
            t[1],
            e,
            s
        ] : [
            t[0],
            e,
            s,
            t[3]
        ];
    }
    call(t, e) {
        return D(()=>(this.invokeCallHook(t, e), this.poolingFunction(mt(t), this.poolSize, this.strides, this.padding, this.dataFormat)));
    }
    getConfig() {
        const t = {
            poolSize: this.poolSize,
            padding: this.padding,
            strides: this.strides,
            dataFormat: this.dataFormat
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
class h1 extends d1 {
    constructor(t){
        super(t);
    }
    poolingFunction(t, e, s, o, r) {
        return ae(r), gn(o), bu(t, e, s, o, r, "max");
    }
}
h1.className = "MaxPooling2D";
_(h1);
class p1 extends d1 {
    constructor(t){
        super(t);
    }
    poolingFunction(t, e, s, o, r) {
        return ae(r), gn(o), bu(t, e, s, o, r, "avg");
    }
}
p1.className = "AveragePooling2D";
_(p1);
class f1 extends St {
    constructor(t){
        if (t.poolSize == null && (t.poolSize = [
            2,
            2,
            2
        ]), super(t), this.poolSize = Array.isArray(t.poolSize) ? t.poolSize : [
            t.poolSize,
            t.poolSize,
            t.poolSize
        ], t.strides == null) this.strides = this.poolSize;
        else if (Array.isArray(t.strides)) {
            if (t.strides.length !== 3) throw new E(`If the strides property of a 3D pooling layer is an Array, it is expected to have a length of 3, but received length ${t.strides.length}.`);
            this.strides = t.strides;
        } else this.strides = [
            t.strides,
            t.strides,
            t.strides
        ];
        xe(this.poolSize, "poolSize"), xe(this.strides, "strides"), this.padding = t.padding == null ? "valid" : t.padding, this.dataFormat = t.dataFormat == null ? "channelsLast" : t.dataFormat, ae(this.dataFormat), gn(this.padding), this.inputSpec = [
            new de({
                ndim: 5
            })
        ];
    }
    computeOutputShape(t) {
        t = Rt(t);
        let e = this.dataFormat === "channelsFirst" ? t[2] : t[1], s = this.dataFormat === "channelsFirst" ? t[3] : t[2], o = this.dataFormat === "channelsFirst" ? t[4] : t[3];
        return e = On(e, this.poolSize[0], this.padding, this.strides[0]), s = On(s, this.poolSize[1], this.padding, this.strides[1]), o = On(o, this.poolSize[2], this.padding, this.strides[2]), this.dataFormat === "channelsFirst" ? [
            t[0],
            t[1],
            e,
            s,
            o
        ] : [
            t[0],
            e,
            s,
            o,
            t[4]
        ];
    }
    call(t, e) {
        return D(()=>(this.invokeCallHook(t, e), this.poolingFunction(mt(t), this.poolSize, this.strides, this.padding, this.dataFormat)));
    }
    getConfig() {
        const t = {
            poolSize: this.poolSize,
            padding: this.padding,
            strides: this.strides,
            dataFormat: this.dataFormat
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
class m1 extends f1 {
    constructor(t){
        super(t);
    }
    poolingFunction(t, e, s, o, r) {
        return ae(r), gn(o), a1(t, e, s, o, r, "max");
    }
}
m1.className = "MaxPooling3D";
_(m1);
class g1 extends f1 {
    constructor(t){
        super(t);
    }
    poolingFunction(t, e, s, o, r) {
        return ae(r), gn(o), a1(t, e, s, o, r, "avg");
    }
}
g1.className = "AveragePooling3D";
_(g1);
class b1 extends St {
    constructor(t){
        super(t), this.inputSpec = [
            new de({
                ndim: 3
            })
        ];
    }
    computeOutputShape(t) {
        return [
            t[0],
            t[2]
        ];
    }
    call(t, e) {
        throw new yt();
    }
}
class x1 extends b1 {
    constructor(t){
        super(t || {});
    }
    call(t, e) {
        return D(()=>{
            const s = mt(t);
            return oe(s, 1);
        });
    }
}
x1.className = "GlobalAveragePooling1D";
_(x1);
class y1 extends b1 {
    constructor(t){
        super(t || {});
    }
    call(t, e) {
        return D(()=>{
            const s = mt(t);
            return Pn(s, 1);
        });
    }
}
y1.className = "GlobalMaxPooling1D";
_(y1);
class w1 extends St {
    constructor(t){
        super(t), this.dataFormat = t.dataFormat == null ? "channelsLast" : t.dataFormat, ae(this.dataFormat), this.inputSpec = [
            new de({
                ndim: 4
            })
        ];
    }
    computeOutputShape(t) {
        return t, this.dataFormat === "channelsLast" ? [
            t[0],
            t[3]
        ] : [
            t[0],
            t[1]
        ];
    }
    call(t, e) {
        throw new yt();
    }
    getConfig() {
        const t = {
            dataFormat: this.dataFormat
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
class I1 extends w1 {
    call(t, e) {
        return D(()=>{
            const s = mt(t);
            return this.dataFormat === "channelsLast" ? oe(s, [
                1,
                2
            ]) : oe(s, [
                2,
                3
            ]);
        });
    }
}
I1.className = "GlobalAveragePooling2D";
_(I1);
class C1 extends w1 {
    call(t, e) {
        return D(()=>{
            const s = mt(t);
            return this.dataFormat === "channelsLast" ? Pn(s, [
                1,
                2
            ]) : Pn(s, [
                2,
                3
            ]);
        });
    }
}
C1.className = "GlobalMaxPooling2D";
_(C1);
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ class v1 extends St {
    constructor(t){
        super(t), this.layer = t.layer;
    }
    build(t) {
        this.built = !0;
    }
    // TODO(cais): Implement activityRegularizer getter.
    get trainable() {
        return this.layer != null ? this.layer.trainable : !1;
    }
    set trainable(t) {
        this.layer != null && (this.layer.trainable = t);
    }
    get trainableWeights() {
        return this.layer.trainableWeights;
    }
    // TODO(cais): Implement setter for trainableWeights.
    get nonTrainableWeights() {
        return this.layer.nonTrainableWeights;
    }
    // TODO(cais): Implement setter for nonTrainableWeights.
    get updates() {
        return this.layer._updates;
    }
    // TODO(cais): Implement getUpdatesFor().
    get losses() {
        return this.layer.losses;
    }
    // TODO(cais): Implement getLossesFor().
    getWeights() {
        return this.layer.getWeights();
    }
    setWeights(t) {
        this.layer.setWeights(t);
    }
    getConfig() {
        const t = {
            layer: {
                className: this.layer.getClassName(),
                config: this.layer.getConfig()
            }
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
    setFastWeightInitDuringBuild(t) {
        super.setFastWeightInitDuringBuild(t), this.layer != null && this.layer.setFastWeightInitDuringBuild(t);
    }
    /** @nocollapse */ static fromConfig(t, e, s = {}) {
        const o = e.layer, r = An(o, s);
        delete e.layer;
        const i = {
            layer: r
        };
        return Object.assign(i, e), new t(i);
    }
}
class S1 extends v1 {
    constructor(t){
        super(t), this.supportsMasking = !0;
    }
    build(t) {
        if (t = Rt(t), t.length < 3) throw new E(`TimeDistributed layer expects an input shape >= 3D, but received input shape ${JSON.stringify(t)}`);
        this.inputSpec = [
            {
                shape: t
            }
        ];
        const e = [
            t[0]
        ].concat(t.slice(2));
        this.layer.built || (this.layer.build(e), this.layer.built = !0), super.build(t);
    }
    computeOutputShape(t) {
        t = Rt(t);
        const e = [
            t[0]
        ].concat(t.slice(2)), s = this.layer.computeOutputShape(e), o = t[1];
        return [
            s[0],
            o
        ].concat(s.slice(1));
    }
    call(t, e) {
        return D(()=>(t = mt(t), My((i, a)=>[
                    mt(this.layer.call(i, e)),
                    []
                ], t, [], !1, null, null, !1, !0)[1]));
    }
}
S1.className = "TimeDistributed";
_(S1);
function S3(n) {
    Uo(ZE, "BidirectionalMergeMode", n);
}
const k3 = "concat";
class k1 extends v1 {
    constructor(t){
        super(t);
        const e = t.layer.getConfig(), s = {};
        s.className = t.layer.getClassName(), s.config = e, this.forwardLayer = An(s), e.goBackwards = e.goBackwards !== !0;
        const o = {};
        if (o.className = t.layer.getClassName(), o.config = e, this.backwardLayer = An(o), this.forwardLayer.name = "forward_" + this.forwardLayer.name, this.backwardLayer.name = "backward_" + this.backwardLayer.name, this.mergeMode = t.mergeMode === void 0 ? k3 : t.mergeMode, S3(this.mergeMode), t.weights) throw new yt("weights support is not implemented for Bidirectional layer yet.");
        this._stateful = t.layer.stateful, this.returnSequences = t.layer.returnSequences, this.returnState = t.layer.returnState, this.supportsMasking = !0, this._trainable = !0, this.inputSpec = t.layer.inputSpec, this.numConstants = null;
    }
    get trainable() {
        return this._trainable;
    }
    set trainable(t) {
        this._trainable = t, this.forwardLayer != null && (this.forwardLayer.trainable = t), this.backwardLayer != null && (this.backwardLayer.trainable = t);
    }
    getWeights() {
        return this.forwardLayer.getWeights().concat(this.backwardLayer.getWeights());
    }
    setWeights(t) {
        const e = t.length, s = Math.floor(e / 2);
        this.forwardLayer.setWeights(t.slice(0, s)), this.backwardLayer.setWeights(t.slice(s));
    }
    computeOutputShape(t) {
        let e = this.forwardLayer.computeOutputShape(t);
        Array.isArray(e) && Array.isArray(e[0]) || (e = [
            e
        ]), e;
        let s, o, r;
        return this.returnState && (r = e.slice(1)), s = e[0], s, this.mergeMode === "concat" ? (s[s.length - 1] *= 2, o = [
            s
        ]) : this.mergeMode == null ? o = [
            s,
            s.slice()
        ] : o = [
            s
        ], this.returnState ? this.mergeMode == null ? o.concat(r).concat(r.slice()) : [
            s
        ].concat(r).concat(r.slice()) : Xe(o);
    }
    apply(t, e) {
        let s = e == null ? null : e.initialState, o = e == null ? null : e.constants;
        e == null && (e = {});
        const r = Ly(t, s, o, this.numConstants);
        if (t = r.inputs, s = r.initialState, o = r.constants, Array.isArray(t) && (s = t.slice(1), t = t[0]), (s == null || s.length === 0) && o == null) return super.apply(t, e);
        const i = [], a = [];
        if (s != null) {
            const c = s.length;
            if (c % 2 > 0) throw new E("When passing `initialState` to a Bidrectional RNN, the state should be an Array containing the states of the underlying RNNs.");
            e.initialState = s, i.push(...s);
            const u = s.map((d)=>new de({
                    shape: d.shape
                }));
            this.forwardLayer.stateSpec = u.slice(0, c / 2), this.backwardLayer.stateSpec = u.slice(c / 2), a.push(...u);
        }
        if (o != null) throw new yt("Support for constants in Bidirectional layers is not implemented yet.");
        const l = i[0] instanceof os;
        for (const c of i)if (c instanceof os !== l) throw new E("The initial state of a Bidirectional layer cannot be specified as a mix of symbolic and non-symbolic tensors");
        if (l) {
            const c = [
                t
            ].concat(i), u = this.inputSpec.concat(a), d = this.inputSpec;
            this.inputSpec = u;
            const h = super.apply(c, e);
            return this.inputSpec = d, h;
        } else return super.apply(t, e);
    }
    call(t, e) {
        return D(()=>{
            const s = e.initialState;
            let o, r;
            if (s == null) o = this.forwardLayer.call(t, e), r = this.backwardLayer.call(t, e);
            else {
                const l = s.slice(0, s.length / 2), c = s.slice(s.length / 2);
                o = this.forwardLayer.call(t, Object.assign(e, {
                    initialState: l
                })), r = this.backwardLayer.call(t, Object.assign(e, {
                    initialState: c
                }));
            }
            let i;
            this.returnState && (Array.isArray(o) && (i = o.slice(1).concat(r.slice(1))), o = o[0], r = r[0]), this.returnSequences && (r = Lo(r, 1));
            let a;
            return this.mergeMode === "concat" ? a = xf([
                o,
                r
            ]) : this.mergeMode === "sum" ? a = U(o, r) : this.mergeMode === "ave" ? a = G(0.5, U(o, r)) : this.mergeMode === "mul" ? a = G(o, r) : this.mergeMode == null && (a = [
                o,
                r
            ]), this.returnState ? this.mergeMode == null ? a.concat(i) : [
                a
            ].concat(i) : a;
        });
    }
    resetStates(t) {
        this.forwardLayer.resetStates(), this.backwardLayer.resetStates();
    }
    build(t) {
        wo(this.forwardLayer.name, ()=>{
            this.forwardLayer.build(t);
        }), wo(this.backwardLayer.name, ()=>{
            this.backwardLayer.build(t);
        }), this.built = !0;
    }
    computeMask(t, e) {
        Array.isArray(e) && (e = e[0]);
        let s;
        if (this.returnSequences ? this.mergeMode == null ? s = [
            e,
            e
        ] : s = e : this.mergeMode == null ? s = [
            null,
            null
        ] : s = null, this.returnState) {
            const r = this.forwardLayer.states.map((i)=>null);
            return Array.isArray(s) ? s.concat(r).concat(r) : [
                s
            ].concat(r).concat(r);
        } else return s;
    }
    get trainableWeights() {
        return this.forwardLayer.trainableWeights.concat(this.backwardLayer.trainableWeights);
    }
    get nonTrainableWeights() {
        return this.forwardLayer.nonTrainableWeights.concat(this.backwardLayer.nonTrainableWeights);
    }
    // TODO(cais): Implement constraints().
    setFastWeightInitDuringBuild(t) {
        super.setFastWeightInitDuringBuild(t), this.forwardLayer != null && this.forwardLayer.setFastWeightInitDuringBuild(t), this.backwardLayer != null && this.backwardLayer.setFastWeightInitDuringBuild(t);
    }
    getConfig() {
        const t = {
            mergeMode: this.mergeMode
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
    /** @nocollapse */ static fromConfig(t, e) {
        const s = An(e.layer);
        if (delete e.layer, e.numConstants != null) throw new yt("Deserialization of a Bidirectional layer with numConstants present is not supported yet.");
        const o = e;
        return o.layer = s, new t(o);
    }
}
k1.className = "Bidirectional";
_(k1);
/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ class T1 extends St {
    constructor(t){
        super(t), this.scale = t.scale, t.offset ? this.offset = t.offset : this.offset = 0;
    }
    getConfig() {
        const t = {
            scale: this.scale,
            offset: this.offset
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
    call(t, e) {
        return D(()=>(t = mt(t), t.dtype !== "float32" && (t = es(t, "float32")), U(G(t, this.scale), this.offset)));
    }
}
T1.className = "Rescaling";
_(T1);
/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ const { resizeBilinear: T3, cropAndResize: N3 } = fs;
class N1 extends St {
    constructor(t){
        super(t), this.height = t.height, this.width = t.width;
    }
    centerCrop(t, e, s, o, r, i, a, l) {
        return D(()=>{
            let c, u = !1;
            const d = e / i, h = s / a, p = (o + e) / i, f = (r + s) / a, m = [
                d,
                h,
                p,
                f
            ], g = [];
            t.rank === 3 ? (u = !0, c = Xn([
                t
            ])) : c = t;
            for(let I = 0; I < c.shape[0]; I++)g.push(m);
            const b = $e(g, [
                g.length,
                4
            ]), x = di(0, g.length, 1, "int32"), y = N3(c, b, x, [
                o,
                r
            ], "nearest");
            return es(u ? mt(Mo(y)) : y, l);
        });
    }
    upsize(t, e, s, o) {
        return D(()=>{
            const r = T3(t, [
                e,
                s
            ]);
            return es(r, o);
        });
    }
    call(t, e) {
        return D(()=>{
            const s = mt(t), o = s.dtype, r = s.shape, i = r[r.length - 3], a = r[r.length - 2];
            let l = 0;
            i !== this.height && (l = Math.floor((i - this.height) / 2));
            let c = 0;
            return a !== this.width && (c = Math.floor((a - this.width) / 2), c === 0 && (c = 1)), l >= 0 && c >= 0 ? this.centerCrop(s, l, c, this.height, this.width, i, a, o) : this.upsize(t, this.height, this.width, o);
        });
    }
    getConfig() {
        const t = {
            height: this.height,
            width: this.width
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
    computeOutputShape(t) {
        t = Rt(t);
        const e = t.length - 3, s = t.length - 2;
        return t[e] = this.height, t[s] = this.width, t;
    }
}
N1.className = "CenterCrop";
_(N1);
/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function R3(n, t, e, s) {
    let o = mt(n);
    if (o.dtype !== "int32" && (o = es(o, "int32")), t === "int") return o;
    const r = o.shape;
    if (o.rank === 0 && (o = Oe(o, -1)), t === "oneHot" && o.shape[o.shape.length - 1] !== 1 && (o = Oe(o, -1)), o.rank > 2) throw new E(`When outputMode is not int, maximum output rank is 2 Received outputMode ${t} and input shape ${r} which would result in output rank ${o.rank}.`);
    const i = [
        "multiHot",
        "oneHot"
    ].includes(t), a = o;
    let l;
    if (typeof s < "u" && t === "count" ? l = Tm(a, s, e, i) : l = Tm(a, [], e, i), t !== "tfIdf") return l;
    if (s) return G(l, s);
    throw new E("When outputMode is 'tfIdf', weights must be provided.");
}
/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ class R1 extends St {
    constructor(t){
        super(t), this.numTokens = t.numTokens, t.outputMode ? this.outputMode = t.outputMode : this.outputMode = "multiHot";
    }
    getConfig() {
        const t = {
            numTokens: this.numTokens,
            outputMode: this.outputMode
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
    computeOutputShape(t) {
        return t = Rt(t), t == null ? [
            this.numTokens
        ] : this.outputMode === "oneHot" && t[t.length - 1] !== 1 ? (t.push(this.numTokens), t) : (t[t.length - 1] = this.numTokens, t);
    }
    call(t, e) {
        return D(()=>{
            t = mt(t), t.dtype !== "int32" && (t = es(t, "int32"));
            let s;
            if (typeof e.countWeights < "u") {
                if (this.outputMode !== "count") throw new E(`countWeights is not used when outputMode !== count.
              Received countWeights=${e.countWeights}`);
                s = mt(e.countWeights);
            }
            const o = Pn(t), r = Il(t), i = rn(this.numTokens, o).bufferSync().get(0), a = Bo(r, 0).bufferSync().get(0);
            if (!(i && a)) throw new E(`Input values must be between 0 < values <= numTokens with numTokens=${this.numTokens}`);
            return R3(t, this.outputMode, this.numTokens, s);
        });
    }
}
R1.className = "CategoryEncoding";
_(R1);
/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ const $3 = [
    "bilinear",
    "nearest"
], lg = new Set($3);
class $1 extends St {
    constructor(t){
        if (super(t), this.height = t.height, this.width = t.width, t.interpolation) {
            if (lg.has(t.interpolation)) this.interpolation = t.interpolation;
            else throw new E(`Invalid interpolation parameter: ${t.interpolation} is not implemented`);
        } else this.interpolation = "bilinear";
        this.cropToAspectRatio = !!t.cropToAspectRatio;
    }
    computeOutputShape(t) {
        t = Rt(t);
        const e = t[2];
        return [
            this.height,
            this.width,
            e
        ];
    }
    getConfig() {
        const t = {
            height: this.height,
            width: this.width,
            interpolation: this.interpolation,
            cropToAspectRatio: this.cropToAspectRatio
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
    call(t, e) {
        return D(()=>{
            const s = [
                this.height,
                this.width
            ];
            if (this.interpolation === "bilinear") return fs.resizeBilinear(t, s, !this.cropToAspectRatio);
            if (this.interpolation === "nearest") return fs.resizeNearestNeighbor(t, s, !this.cropToAspectRatio);
            throw new Error(`Interpolation is ${this.interpolation} but only ${[
                ...lg
            ]} are supported`);
        });
    }
}
$1.className = "Resizing";
_($1);
/**
 * @license
 * Copyright 2023 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ class G1 {
    constructor(t){
        this.seed = t;
    }
    next() {
        if (this.seed !== void 0) return this.seed++;
    }
}
G1.className = "RandomSeed";
/**
 * @license
 * Copyright 2023 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ class E1 extends St {
    constructor(t){
        super(t), this.randomGenerator = new G1(t.seed);
    }
    getConfig() {
        const t = {
            seed: this.randomGenerator.seed
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
}
E1.className = "BaseRandomLayer";
/**
 * @license
 * Copyright 2023 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ const G3 = [
    "bilinear",
    "nearest"
], cg = new Set(G3);
class L1 extends E1 {
    constructor(t){
        super(t);
        const { factor: e, interpolation: s = "bilinear" } = t;
        if (this.factor = e, Array.isArray(this.factor) && this.factor.length === 2) this.widthLower = this.factor[0], this.widthUpper = this.factor[1];
        else if (!Array.isArray(this.factor) && this.factor > 0) this.widthLower = -this.factor, this.widthUpper = this.factor;
        else throw new E(`Invalid factor: ${this.factor}. Must be positive number or tuple of 2 numbers`);
        if (this.widthLower < -1 || this.widthUpper < -1) throw new E(`factor must have values larger than -1. Got: ${this.factor}`);
        if (this.widthUpper < this.widthLower) throw new E(`factor cannot have upper bound less than lower bound.
        Got upper bound: ${this.widthUpper}.
        Got lower bound: ${this.widthLower}
      `);
        if (s) {
            if (cg.has(s)) this.interpolation = s;
            else throw new E(`Invalid interpolation parameter: ${s} is not implemented`);
        }
    }
    getConfig() {
        const t = {
            factor: this.factor,
            interpolation: this.interpolation
        }, e = super.getConfig();
        return Object.assign(t, e), t;
    }
    computeOutputShape(t) {
        t = Rt(t);
        const e = t[2];
        return [
            this.imgHeight,
            -1,
            e
        ];
    }
    call(t, e) {
        return D(()=>{
            const s = mt(t);
            this.imgHeight = s.shape[s.shape.length - 3];
            const o = s.shape[s.shape.length - 2];
            this.widthFactor = Sa([
                1
            ], 1 + this.widthLower, 1 + this.widthUpper, "float32", this.randomGenerator.next());
            let r = this.widthFactor.dataSync()[0] * o;
            r = Math.round(r);
            const i = [
                this.imgHeight,
                r
            ];
            switch(this.interpolation){
                case "bilinear":
                    return fs.resizeBilinear(t, i);
                case "nearest":
                    return fs.resizeNearestNeighbor(t, i);
                default:
                    throw new Error(`Interpolation is ${this.interpolation}
          but only ${[
                        ...cg
                    ]} are supported`);
            }
        });
    }
}
L1.className = "RandomWidth";
_(L1);
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const E3 = F();
E3.registerFlag("KEEP_INTERMEDIATE_TENSORS", ()=>!1, (n)=>{
    n && console.warn("Keep intermediate tensors is ON. This will print the values of all intermediate tensors during model inference. Not all models support this mode. For details, check e2e/benchmarks/ model_config.js. This significantly impacts performance.");
});
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ var ug;
(function(n) {
    n[n.DT_INVALID = 0] = "DT_INVALID", n[n.DT_FLOAT = 1] = "DT_FLOAT", n[n.DT_DOUBLE = 2] = "DT_DOUBLE", n[n.DT_INT32 = 3] = "DT_INT32", n[n.DT_UINT8 = 4] = "DT_UINT8", n[n.DT_INT16 = 5] = "DT_INT16", n[n.DT_INT8 = 6] = "DT_INT8", n[n.DT_STRING = 7] = "DT_STRING", n[n.DT_COMPLEX64 = 8] = "DT_COMPLEX64", n[n.DT_INT64 = 9] = "DT_INT64", n[n.DT_BOOL = 10] = "DT_BOOL", n[n.DT_QINT8 = 11] = "DT_QINT8", n[n.DT_QUINT8 = 12] = "DT_QUINT8", n[n.DT_QINT32 = 13] = "DT_QINT32", n[n.DT_BFLOAT16 = 14] = "DT_BFLOAT16", n[n.DT_QINT16 = 15] = "DT_QINT16", n[n.DT_QUINT16 = 16] = "DT_QUINT16", n[n.DT_UINT16 = 17] = "DT_UINT16", n[n.DT_COMPLEX128 = 18] = "DT_COMPLEX128", n[n.DT_HALF = 19] = "DT_HALF", n[n.DT_RESOURCE = 20] = "DT_RESOURCE", n[n.DT_VARIANT = 21] = "DT_VARIANT", n[n.DT_UINT32 = 22] = "DT_UINT32", n[n.DT_UINT64 = 23] = "DT_UINT64", n[n.DT_FLOAT_REF = 101] = "DT_FLOAT_REF", n[n.DT_DOUBLE_REF = 102] = "DT_DOUBLE_REF", n[n.DT_INT32_REF = 103] = "DT_INT32_REF", n[n.DT_UINT8_REF = 104] = "DT_UINT8_REF", n[n.DT_INT16_REF = 105] = "DT_INT16_REF", n[n.DT_INT8_REF = 106] = "DT_INT8_REF", n[n.DT_STRING_REF = 107] = "DT_STRING_REF", n[n.DT_COMPLEX64_REF = 108] = "DT_COMPLEX64_REF", n[n.DT_INT64_REF = 109] = "DT_INT64_REF", n[n.DT_BOOL_REF = 110] = "DT_BOOL_REF", n[n.DT_QINT8_REF = 111] = "DT_QINT8_REF", n[n.DT_QUINT8_REF = 112] = "DT_QUINT8_REF", n[n.DT_QINT32_REF = 113] = "DT_QINT32_REF", n[n.DT_BFLOAT16_REF = 114] = "DT_BFLOAT16_REF", n[n.DT_QINT16_REF = 115] = "DT_QINT16_REF", n[n.DT_QUINT16_REF = 116] = "DT_QUINT16_REF", n[n.DT_UINT16_REF = 117] = "DT_UINT16_REF", n[n.DT_COMPLEX128_REF = 118] = "DT_COMPLEX128_REF", n[n.DT_HALF_REF = 119] = "DT_HALF_REF", n[n.DT_RESOURCE_REF = 120] = "DT_RESOURCE_REF", n[n.DT_VARIANT_REF = 121] = "DT_VARIANT_REF", n[n.DT_UINT32_REF = 122] = "DT_UINT32_REF", n[n.DT_UINT64_REF = 123] = "DT_UINT64_REF";
})(ug || (ug = {}));
var dg;
(function(n) {
    (function(t) {
        t[t.LEGACY = 0] = "LEGACY", t[t.V1 = 1] = "V1", t[t.V2 = 2] = "V2";
    })(n.CheckpointFormatVersion || (n.CheckpointFormatVersion = {}));
})(dg || (dg = {}));
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ function L3(n, t) {
    return Dl(n, t);
}
function Dl(n, t, e = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Set()) {
    if (n == null) return null;
    if (typeof Blob == "function" && n instanceof Blob) return n.slice();
    if (s.has(n)) throw new Error("Circular references are not supported.");
    if (e.has(n)) return e.get(n);
    const o = t(n);
    if (o.recurse && o.value !== null) throw new Error("A deep map function may not return both a value and recurse=true.");
    if (o.recurse) {
        if (yr(n)) {
            const r = Array.isArray(n) ? [] : {};
            s.add(n);
            for(const i in n){
                const a = n[i], l = Dl(a, t, e, s);
                r[i] = l;
            }
            return s.delete(n), n.__proto__ && (r.__proto__ = n.__proto__), r;
        } else throw new Error(`Can't recurse into non-iterable type: ${n}`);
    } else return e.set(n, o.value), o.value;
}
function M3(n, t = W1) {
    return M1(n, t);
}
function M1(n, t, e = /* @__PURE__ */ new Set()) {
    const s = n[0];
    if (e.has(s)) throw new Error("Circular references are not supported.");
    const o = t(n);
    if (o.recurse && o.value !== null) throw new Error("A deep zip function may not return both a value and recurse=true.");
    if (o.recurse) {
        if (yr(s)) {
            const r = Array.isArray(s) ? [] : {};
            e.add(s);
            for(const i in s){
                const a = n.map((c)=>c[i]), l = M1(a, t, e);
                r[i] = l;
            }
            return e.delete(s), r;
        } else throw new Error(`Can't recurse into non-iterable type: ${s}`);
    } else return o.value;
}
function W1(n) {
    return n === null ? null : yr(n[0]) ? {
        value: null,
        recurse: !0
    } : {
        value: n,
        recurse: !1
    };
}
async function D1(n, t) {
    const e = /* @__PURE__ */ new Map();
    Dl(n, t, e);
    for (const o of Array.from(e.keys())){
        const r = e.get(o);
        if (Ci(r)) {
            const i = await r;
            e.set(o, i);
        }
    }
    return Dl(n, t, e);
}

function yr(n) {
    let t = !1;
    if (F().get("IS_BROWSER")) t = n instanceof TextDecoder;
    else {
        const { StringDecoder: e } = (parcelRequire("eNRCS"));
        t = n instanceof e;
    }
    return n != null && !ArrayBuffer.isView(n) && (Array.isArray(n) || typeof n == "object" && !(n instanceof Mt) && !(n instanceof Promise) && !t);
}
function W3(n) {
    return n == null || D3(n) || Array.isArray(n) || typeof n == "object" && n instanceof Mt || qe(n);
}
function D3(n) {
    return n === null || typeof n != "object" && typeof n != "function";
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ function F3(n) {
    return L3(n, V3);
}
function V3(n) {
    return n instanceof Mt ? {
        value: n.clone(),
        recurse: !1
    } : yr(n) ? {
        value: null,
        recurse: !0
    } : {
        value: n,
        recurse: !1
    };
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ class F1 {
    /**
   * Constructs a `RingBuffer`.
   * @param capacity The number of items that the buffer can accomodate.
   */ constructor(t){
        if (this.capacity = t, this.begin = 0, this.end = 0, t == null) throw new RangeError("Can't create a ring buffer of unknown capacity.");
        if (t < 1) throw new RangeError("Can't create ring buffer of capacity < 1.");
        this.data = new Array(t), this.doubledCapacity = 2 * t;
    }
    /**
   * Map any index into the range 0 <= index < 2*capacity.
   */ wrap(t) {
        for(; t < 0;)t += this.doubledCapacity;
        return t % this.doubledCapacity;
    }
    get(t) {
        if (t < 0) throw new RangeError("Can't get item at a negative index.");
        return this.data[t % this.capacity];
    }
    set(t, e) {
        if (t < 0) throw new RangeError("Can't set item at a negative index.");
        this.data[t % this.capacity] = e;
    }
    /**
   * Returns the current number of items in the buffer.
   */ length() {
        let t = this.end - this.begin;
        return t < 0 && (t = this.doubledCapacity + t), t;
    }
    /**
   * Reports whether the buffer is full.
   * @returns true if the number of items in the buffer equals its capacity, and
   *   false otherwise.
   */ isFull() {
        return this.length() === this.capacity;
    }
    /**
   * Reports whether the buffer is empty.
   * @returns true if the number of items in the buffer equals zero, and
   *   false otherwise.
   */ isEmpty() {
        return this.length() === 0;
    }
    /**
   * Adds an item to the end of the buffer.
   */ push(t) {
        if (this.isFull()) throw new RangeError("Ring buffer is full.");
        this.set(this.end, t), this.end = this.wrap(this.end + 1);
    }
    /**
   * Adds many items to the end of the buffer, in order.
   */ pushAll(t) {
        for (const e of t)this.push(e);
    }
    /**
   * Removes and returns the last item in the buffer.
   */ pop() {
        if (this.isEmpty()) throw new RangeError("Ring buffer is empty.");
        this.end = this.wrap(this.end - 1);
        const t = this.get(this.end);
        return this.set(this.end, void 0), t;
    }
    /**
   * Adds an item to the beginning of the buffer.
   */ unshift(t) {
        if (this.isFull()) throw new RangeError("Ring buffer is full.");
        this.begin = this.wrap(this.begin - 1), this.set(this.begin, t);
    }
    /**
   * Removes and returns the first item in the buffer.
   */ shift() {
        if (this.isEmpty()) throw new RangeError("Ring buffer is empty.");
        const t = this.get(this.begin);
        return this.set(this.begin, void 0), this.begin = this.wrap(this.begin + 1), t;
    }
    /**
   * Removes and returns a specific item in the buffer, and moves the last item
   * to the vacated slot.  This is useful for implementing a shuffling stream.
   * Note that this operation necessarily scrambles the original order.
   *
   * @param relativeIndex: the index of the item to remove, relative to the
   *   first item in the buffer (e.g., hiding the ring nature of the underlying
   *   storage).
   */ shuffleExcise(t) {
        if (this.isEmpty()) throw new RangeError("Ring buffer is empty.");
        const e = this.wrap(this.begin + t), s = this.get(e);
        return this.set(e, this.pop()), s;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ class xu extends F1 {
    /**
   * Constructs a `GrowingRingBuffer`.
   */ constructor(){
        super(xu.INITIAL_CAPACITY);
    }
    isFull() {
        return !1;
    }
    push(t) {
        super.isFull() && this.expand(), super.push(t);
    }
    unshift(t) {
        super.isFull() && this.expand(), super.unshift(t);
    }
    /**
   * Doubles the capacity of the buffer.
   */ expand() {
        const t = this.capacity * 2, e = new Array(t), s = this.length();
        for(let o = 0; o < s; o++)e[o] = this.get(this.wrap(this.begin + o));
        this.data = e, this.capacity = t, this.doubledCapacity = 2 * this.capacity, this.begin = 0, this.end = s;
    }
}
xu.INITIAL_CAPACITY = 32;
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ function V1(n) {
    return new O3(n);
}
function z3(n) {
    return new X3(n);
}
function P3(n, t) {
    return new z1(n, t);
}
function A3(n, t = Fs.FAIL) {
    return new j3(n, t);
}
class He {
    /**
   * Collect all remaining elements of a bounded stream into an array.
   * Obviously this will succeed only for small streams that fit in memory.
   * Useful for testing.
   *
   * @returns A Promise for an array of stream elements, which will resolve
   *   when the stream is exhausted.
   */ async toArray() {
        const t = [];
        let e = await this.next();
        for(; !e.done;)t.push(e.value), e = await this.next();
        return t;
    }
    /**
   * Collect all elements of this dataset into an array with prefetching 100
   * elements. This is useful for testing, because the prefetch changes the
   * order in which the Promises are resolved along the processing pipeline.
   * This may help expose bugs where results are dependent on the order of
   * Promise resolution rather than on the logical order of the stream (i.e.,
   * due to hidden mutable state).
   *
   * @returns A Promise for an array of stream elements, which will resolve
   *   when the stream is exhausted.
   */ async toArrayForTest() {
        const t = this.prefetch(100), e = [];
        let s = await t.next();
        for(; !s.done;)e.push(s.value), s = await t.next();
        return e;
    }
    /**
   * Draw items from the stream until it is exhausted.
   *
   * This can be useful when the stream has side effects but no output.  In
   * that case, calling this function guarantees that the stream will be
   * fully processed.
   */ async resolveFully() {
        let t = await this.next();
        for(; !t.done;)t = await this.next();
    }
    /**
   * Draw items from the stream until it is exhausted, or a predicate fails.
   *
   * This can be useful when the stream has side effects but no output.  In
   * that case, calling this function guarantees that the stream will be
   * fully processed.
   */ async resolveWhile(t) {
        let e = await this.next(), s = t(e.value);
        for(; !e.done && s;)e = await this.next(), s = t(e.value);
    }
    /**
   * Handles errors thrown on this stream using a provided handler function.
   *
   * @param handler A function that handles any `Error` thrown during a `next()`
   *   call and returns true if the stream should continue (dropping the failed
   *   call) or false if the stream should quietly terminate.  If the handler
   *   itself throws (or rethrows) an `Error`, that will be propagated.
   *
   * @returns A `LazyIterator` of elements passed through from upstream,
   *   possibly filtering or terminating on upstream `next()` calls that
   *   throw an `Error`.
   */ handleErrors(t) {
        return new Y3(this, t);
    }
    // TODO(soergel): Implement reduce() etc.
    /**
   * Filters this stream according to `predicate`.
   *
   * @param predicate A function mapping a stream element to a boolean or a
   * `Promise` for one.
   *
   * @returns A `LazyIterator` of elements for which the predicate was true.
   */ filter(t) {
        return new _3(this, t);
    }
    /**
   * Maps this stream through a 1-to-1 transform.
   *
   * @param transform A function mapping a stream element to a transformed
   *   element.
   *
   * @returns A `LazyIterator` of transformed elements.
   */ map(t) {
        return new U3(this, t);
    }
    /**
   * Maps this stream through an async 1-to-1 transform.
   *
   * @param transform A function mapping a stream element to a `Promise` for a
   *   transformed stream element.
   *
   * @returns A `LazyIterator` of transformed elements.
   */ mapAsync(t) {
        return new hg(this, t);
    }
    /**
   * Maps this stream through a 1-to-1 transform, forcing serial execution.
   *
   * @param transform A function mapping a stream element to a transformed
   *   element.
   *
   * @returns A `LazyIterator` of transformed elements.
   */ serialMapAsync(t) {
        return new hg(this, t).serial();
    }
    /**
   * Maps this stream through a 1-to-many transform.
   *
   * @param transform A function mapping a stream element to an array of
   *   transformed elements.
   *
   * @returns A `DataStream` of transformed elements.
   */ flatmap(t) {
        return new J3(this, t);
    }
    /**
   * Apply a function to every element of the stream.
   *
   * @param f A function to apply to each stream element.
   */ async forEachAsync(t) {
        return this.map(t).resolveFully();
    }
    /**
   * Apply a function to every element of the stream, forcing serial execution.
   *
   * @param f A function to apply to each stream element.  Should return 'true'
   *   to indicate that the stream should continue, or 'false' to cause it to
   *   terminate.
   */ async serialForEach(t) {
        return this.serialMapAsync(t).resolveWhile((e)=>e === !0);
    }
    /**
   * Groups elements into batches, represented as arrays of elements.
   *
   * We can think of the elements of this iterator as 'rows' (even if they are
   * nested structures).  By the same token, consecutive values for a given
   * key within the elements form a 'column'.  This matches the usual sense of
   * 'row' and 'column' when processing tabular data (e.g., parsing a CSV).
   *
   * Thus, "Row-major" means that the resulting batch is simply a collection of
   * rows: `[row1, row2, row3, ...]`.  This is contrast to the column-major
   * form, which is needed for vectorized computation.
   *
   * @param batchSize The number of elements desired per batch.
   * @param smallLastBatch Whether to emit the final batch when it has fewer
   *   than batchSize elements. Default true.
   * @returns A `LazyIterator` of batches of elements, represented as arrays
   *   of the original element type.
   */ rowMajorBatch(t, e = !0) {
        return new H3(this, t, e);
    }
    /**
   * Groups elements into batches, represented in column-major form.
   *
   * We can think of the elements of this iterator as 'rows' (even if they are
   * nested structures).  By the same token, consecutive values for a given
   * key within the elements form a 'column'.  This matches the usual sense of
   * 'row' and 'column' when processing tabular data (e.g., parsing a CSV).
   *
   * Thus, "column-major" means that the resulting batch is a (potentially
   * nested) structure representing the columns.  Each column entry, then,
   * contains a collection of the values found in that column for a range of
   * input elements.  This representation allows for vectorized computation, in
   * contrast to the row-major form.
   *
   * The inputs should all have the same nested structure (i.e., of arrays and
   * dicts).  The result is a single object with the same nested structure,
   * where the leaves are arrays collecting the values of the inputs at that
   * location (or, optionally, the result of a custom function applied to those
   * arrays).
   *
   * @param batchSize The number of elements desired per batch.
   * @param smallLastBatch Whether to emit the final batch when it has fewer
   *   than batchSize elements. Default true.
   * @param zipFn: (optional) A function that expects an array of elements at a
   *   single node of the object tree, and returns a `DeepMapResult`.  The
   *   `DeepMapResult` either provides a result value for that node (i.e.,
   *   representing the subtree), or indicates that the node should be processed
   *   recursively.  The default zipFn recurses as far as possible and places
   *   arrays at the leaves.
   * @returns A `LazyIterator` of batches of elements, represented as an object
   *   with collections at the leaves.
   */ columnMajorBatch(t, e = !0, s = W1) {
        return this.rowMajorBatch(t, e).map((r)=>M3(r, s));
    }
    /**
   * Concatenate this `LazyIterator` with another.
   *
   * @param iterator A `LazyIterator` to be concatenated onto this one.
   * @param baseErrorHandler An optional function that can intercept `Error`s
   *   raised during a `next()` call on the base stream.  This function can
   *   decide whether the error should be propagated, whether the error should
   *   be ignored, or whether the base stream should be terminated.
   * @returns A `LazyIterator`.
   */ concatenate(t, e) {
        return new z1(V1([
            this,
            t
        ]), e);
    }
    /**
   * Limits this stream to return at most `count` items.
   *
   * @param count The maximum number of items to provide from the stream. If
   * a negative or undefined value is given, the entire stream is returned
   *   unaltered.
   */ take(t) {
        return t < 0 || t == null ? this : new B3(this, t);
    }
    /**
   * Skips the first `count` items in this stream.
   *
   * @param count The number of items to skip.  If a negative or undefined
   * value is given, the entire stream is returned unaltered.
   */ skip(t) {
        return t < 0 || t == null ? this : new Z3(this, t);
    }
    /**
   * Prefetch the first `bufferSize` items in this stream.
   *
   * Note this prefetches Promises, but makes no guarantees about when those
   * Promises resolve.
   *
   * @param bufferSize: An integer specifying the number of elements to be
   *   prefetched.
   */ prefetch(t) {
        return new P1(this, t);
    }
    // TODO(soergel): deep sharded shuffle, where supported
    /**
   * Randomly shuffles the elements of this stream.
   *
   * @param bufferSize: An integer specifying the number of elements from
   * this stream from which the new stream will sample.
   * @param seed: (Optional.) An integer specifying the random seed that
   * will be used to create the distribution.
   */ shuffle(t, e) {
        return new q3(this, t, e);
    }
    /**
   * Force an iterator to execute serially: each next() call will await the
   * prior one, so that they cannot execute concurrently.
   */ serial() {
        return new K3(this);
    }
}
class O3 extends He {
    constructor(t){
        super(), this.items = t, this.trav = 0;
    }
    summary() {
        return `Array of ${this.items.length} items`;
    }
    async next() {
        if (this.trav >= this.items.length) return {
            value: null,
            done: !0
        };
        const t = this.items[this.trav];
        return this.trav++, {
            value: F3(t),
            done: !1
        };
    }
}
class X3 extends He {
    constructor(t){
        super(), this.nextFn = t;
    }
    summary() {
        return "Function call";
    }
    async next() {
        try {
            return this.nextFn();
        } catch (t) {
            throw t.message = `Error thrown while iterating through a dataset: ${t.message}`, t;
        }
    }
}
class K3 extends He {
    constructor(t){
        super(), this.upstream = t, this.lastRead = Promise.resolve({
            value: null,
            done: !1
        });
    }
    summary() {
        return `${this.upstream.summary()} -> Serial`;
    }
    async next() {
        return this.lastRead = this.lastRead.then(()=>this.serialNext()), this.lastRead;
    }
    async serialNext() {
        return this.upstream.next();
    }
}
class Z3 extends He {
    constructor(t, e){
        super(), this.upstream = t, this.maxCount = e, this.count = 0, this.lastRead = Promise.resolve({
            value: null,
            done: !1
        });
    }
    summary() {
        return `${this.upstream.summary()} -> Skip`;
    }
    async next() {
        return this.lastRead = this.lastRead.then(()=>this.serialNext()), this.lastRead;
    }
    async serialNext() {
        for(; this.count++ < this.maxCount;){
            const t = await this.upstream.next();
            if (t.done) return t;
            xt(t.value);
        }
        return this.upstream.next();
    }
}
class B3 extends He {
    constructor(t, e){
        super(), this.upstream = t, this.maxCount = e, this.count = 0;
    }
    summary() {
        return `${this.upstream.summary()} -> Take`;
    }
    async next() {
        return this.count++ >= this.maxCount ? {
            value: null,
            done: !0
        } : this.upstream.next();
    }
}
class H3 extends He {
    constructor(t, e, s = !0){
        super(), this.upstream = t, this.batchSize = e, this.enableSmallLastBatch = s, this.lastRead = Promise.resolve({
            value: null,
            done: !1
        });
    }
    summary() {
        return `${this.upstream.summary()} -> RowMajorBatch`;
    }
    async next() {
        return this.lastRead = this.lastRead.then(()=>this.serialNext()), this.lastRead;
    }
    async serialNext() {
        const t = [];
        for(; t.length < this.batchSize;){
            const e = await this.upstream.next();
            if (e.done) return this.enableSmallLastBatch && t.length > 0 ? {
                value: t,
                done: !1
            } : {
                value: null,
                done: !0
            };
            t.push(e.value);
        }
        return {
            value: t,
            done: !1
        };
    }
}
class _3 extends He {
    constructor(t, e){
        super(), this.upstream = t, this.predicate = e, this.lastRead = Promise.resolve({
            value: null,
            done: !1
        });
    }
    summary() {
        return `${this.upstream.summary()} -> Filter`;
    }
    async next() {
        return this.lastRead = this.lastRead.then(()=>this.serialNext()), this.lastRead;
    }
    async serialNext() {
        for(;;){
            const t = await this.upstream.next();
            if (t.done || this.predicate(t.value)) return t;
            xt(t.value);
        }
    }
}
class U3 extends He {
    constructor(t, e){
        super(), this.upstream = t, this.transform = e;
    }
    summary() {
        return `${this.upstream.summary()} -> Map`;
    }
    async next() {
        const t = await this.upstream.next();
        if (t.done) return {
            value: null,
            done: !0
        };
        const e = bs(t.value), s = this.transform(t.value), o = bs(s);
        for (const r of e)Yc(r, o) || r.dispose();
        return {
            value: s,
            done: !1
        };
    }
}
class Y3 extends He {
    constructor(t, e){
        super(), this.upstream = t, this.handler = e, this.count = 0, this.lastRead = Promise.resolve({
            value: null,
            done: !1
        });
    }
    summary() {
        return `${this.upstream.summary()} -> handleErrors`;
    }
    async next() {
        return this.lastRead = this.lastRead.then(()=>this.serialNext()), this.lastRead;
    }
    async serialNext() {
        for(;;)try {
            return await this.upstream.next();
        } catch (t) {
            if (!this.handler(t)) return {
                value: null,
                done: !0
            };
        }
    }
}
class hg extends He {
    constructor(t, e){
        super(), this.upstream = t, this.transform = e;
    }
    summary() {
        return `${this.upstream.summary()} -> AsyncMap`;
    }
    async next() {
        const t = await this.upstream.next();
        if (t.done) return {
            value: null,
            done: !0
        };
        const e = bs(t.value), s = await this.transform(t.value), o = bs(s);
        for (const r of e)Yc(r, o) || r.dispose();
        return {
            value: s,
            done: !1
        };
    }
}
class Q3 extends He {
    constructor(){
        super(), this.outputQueue = new xu(), this.lastRead = Promise.resolve({
            value: null,
            done: !1
        });
    }
    async next() {
        return this.lastRead = this.lastRead.then(()=>this.serialNext()), this.lastRead;
    }
    async serialNext() {
        for(; this.outputQueue.length() === 0;)if (!await this.pump()) return {
            value: null,
            done: !0
        };
        return {
            value: this.outputQueue.shift(),
            done: !1
        };
    }
}
class J3 extends Q3 {
    constructor(t, e){
        super(), this.upstream = t, this.transform = e;
    }
    summary() {
        return `${this.upstream.summary()} -> Flatmap`;
    }
    async pump() {
        const t = await this.upstream.next();
        if (t.done) return !1;
        const e = bs(t.value), s = this.transform(t.value), o = bs(s);
        this.outputQueue.pushAll(s);
        for (const r of e)Yc(r, o) || r.dispose();
        return !0;
    }
}
class z1 extends He {
    constructor(t, e){
        super(), this.baseErrorHandler = e, this.lastRead = null, this.iterator = null, this.moreIterators = t;
    }
    summary() {
        return "TODO: fill in upstream of chained summaries -> Chained";
    }
    async next() {
        return this.lastRead = this.readFromChain(this.lastRead), this.lastRead;
    }
    async readFromChain(t) {
        if (await t, this.iterator == null) {
            const s = await this.moreIterators.next();
            if (s.done) return {
                value: null,
                done: !0
            };
            this.iterator = s.value, this.baseErrorHandler != null && (this.iterator = this.iterator.handleErrors(this.baseErrorHandler));
        }
        const e = await this.iterator.next();
        return e.done ? (this.iterator = null, this.readFromChain(t)) : e;
    }
}
var Fs;
(function(n) {
    n[n.FAIL = 0] = "FAIL", n[n.SHORTEST = 1] = "SHORTEST", n[n.LONGEST = 2] = "LONGEST";
})(Fs || (Fs = {}));
class j3 extends He {
    constructor(t, e = Fs.FAIL){
        super(), this.iterators = t, this.mismatchMode = e, this.count = 0, this.currentPromise = null;
    }
    summary() {
        return "{TODO: fill in upstream of zip summaries} -> Zip";
    }
    async nextState(t) {
        await t;
        let e = 0, s = 0;
        function o(i) {
            return i instanceof He ? {
                value: i.next().then((l)=>(e++, l.done && s++, l.value)),
                recurse: !1
            } : {
                value: null,
                recurse: !0
            };
        }
        const r = await D1(this.iterators, o);
        if (e === s) return {
            value: null,
            done: !0
        };
        if (s > 0) switch(this.mismatchMode){
            case Fs.FAIL:
                throw new Error(`Zipped streams should have the same length. Mismatched at element ${this.count}.`);
            case Fs.SHORTEST:
                return {
                    value: null,
                    done: !0
                };
            case Fs.LONGEST:
        }
        return this.count++, {
            value: r,
            done: !1
        };
    }
    async next() {
        return this.currentPromise = this.nextState(this.currentPromise), this.currentPromise;
    }
}
class P1 extends He {
    constructor(t, e){
        super(), this.upstream = t, this.bufferSize = e, this.buffer = new F1(e);
    }
    summary() {
        return `${this.upstream.summary()} -> Prefetch`;
    }
    /**
   * Refill the prefetch buffer.  Returns only after the buffer is full, or
   * the upstream source is exhausted.
   */ refill() {
        for(; !this.buffer.isFull();){
            const t = this.upstream.next();
            this.buffer.push(t);
        }
    }
    next() {
        return this.refill(), this.buffer.shift();
    }
}
class q3 extends P1 {
    constructor(t, e, s){
        super(t, e), this.upstream = t, this.windowSize = e, this.upstreamExhausted = !1, this.random = Nr.alea(s || Ie().toString()), this.lastRead = Promise.resolve({
            value: null,
            done: !1
        });
    }
    async next() {
        return this.lastRead = this.lastRead.then(()=>this.serialNext()), this.lastRead;
    }
    randomInt(t) {
        return Math.floor(this.random() * t);
    }
    chooseIndex() {
        return this.randomInt(this.buffer.length());
    }
    async serialNext() {
        for(this.upstreamExhausted || this.refill(); !this.buffer.isEmpty();){
            const t = this.chooseIndex(), e = await this.buffer.shuffleExcise(t);
            if (e.done) this.upstreamExhausted = !0;
            else return this.refill(), e;
        }
        return {
            value: null,
            done: !0
        };
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ class zf {
    constructor(){
        this.size = null;
    }
    // TODO(soergel): Make Datasets report whether repeated iterator() calls
    // produce the same result (e.g., reading from a file) or different results
    // (e.g., from the webcam).  Currently we don't make this distinction but it
    // could be important for the user to know.
    // abstract isDeterministic(): boolean;
    /**
   * Groups elements into batches.
   *
   * It is assumed that each of the incoming dataset elements has the same
   * structure -- i.e. the same set of keys at each location in an object
   * hierarchy.  For each key, the resulting `Dataset` provides a batched
   * element collecting all of the incoming values for that key.
   *
   *  * Incoming primitives are grouped into a 1-D Tensor.
   *  * Incoming Tensors are grouped into a new Tensor where the 0th axis is
   *    the batch dimension.
   *  * Incoming arrays are converted to Tensor and then batched.
   *  * A nested array is interpreted as an n-D Tensor, so the batched result
   *    has n+1 dimensions.
   *  * An array that cannot be converted to Tensor produces an error.
   *
   * If an array should not be batched as a unit, it should first be converted
   * to an object with integer keys.
   *
   * Here are a few examples:
   *
   * Batch a dataset of numbers:
   * ```js
   * const a = tf.data.array([1, 2, 3, 4, 5, 6, 7, 8]).batch(4);
   * await a.forEachAsync(e => e.print());
   * ```
   *
   * Batch a dataset of arrays:
   * ```js
   * const b = tf.data.array([[1], [2], [3], [4], [5], [6], [7], [8]]).batch(4);
   * await b.forEachAsync(e => e.print());
   * ```
   *
   * Batch a dataset of objects:
   * ```js
   * const c = tf.data.array([{a: 1, b: 11}, {a: 2, b: 12}, {a: 3, b: 13},
   *   {a: 4, b: 14}, {a: 5, b: 15}, {a: 6, b: 16}, {a: 7, b: 17},
   *   {a: 8, b: 18}]).batch(4);
   * await c.forEachAsync(e => {
   *   console.log('{');
   *   for(var key in e) {
   *     console.log(key+':');
   *     e[key].print();
   *   }
   *   console.log('}');
   * })
   * ```
   *
   * @param batchSize The number of elements desired per batch.
   * @param smallLastBatch Whether to emit the final batch when it has fewer
   *   than batchSize elements. Default true.
   * @returns A `Dataset`, from which a stream of batches can be obtained.
   *
   * @doc {heading: 'Data', subheading: 'Classes'}
   */ batch(t, e = !0) {
        const s = this;
        C(t > 0, ()=>`batchSize needs to be positive, but it is
      ${t}`);
        let o;
        return this.size === 1 / 0 || this.size == null ? o = this.size : e ? o = Math.ceil(this.size / t) : o = Math.floor(this.size / t), yn(async ()=>(await s.iterator()).columnMajorBatch(t, e, tM), o);
    }
    /**
   * Concatenates this `Dataset` with another.
   *
   * ```js
   * const a = tf.data.array([1, 2, 3]);
   * const b = tf.data.array([4, 5, 6]);
   * const c = a.concatenate(b);
   * await c.forEachAsync(e => console.log(e));
   * ```
   *
   * @param dataset A `Dataset` to be concatenated onto this one.
   * @returns A `Dataset`.
   *
   * @doc {heading: 'Data', subheading: 'Classes'}
   */ concatenate(t) {
        const e = this;
        let s;
        return this.size === 1 / 0 || t.size === 1 / 0 ? s = 1 / 0 : this.size != null && t.size != null ? s = this.size + t.size : s = null, yn(async ()=>(await e.iterator()).concatenate(await t.iterator()), s);
    }
    /**
   * Filters this dataset according to `predicate`.
   *
   * ```js
   * const a = tf.data.array([1, 2, 3, 4, 5, 6, 7, 8, 9, 10])
   *   .filter(x => x%2 === 0);
   * await a.forEachAsync(e => console.log(e));
   * ```
   *
   * @param predicate A function mapping a dataset element to a boolean or a
   * `Promise` for one.
   *
   * @returns A `Dataset` of elements for which the predicate was true.
   *
   * @doc {heading: 'Data', subheading: 'Classes'}
   */ filter(t) {
        const e = this;
        let s;
        return this.size === 1 / 0 ? s = 1 / 0 : s = null, yn(async ()=>(await e.iterator()).filter((o)=>D(()=>t(o))), s);
    }
    /**
   * Apply a function to every element of the dataset.
   *
   * After the function is applied to a dataset element, any Tensors contained
   * within that element are disposed.
   *
   * ```js
   * const a = tf.data.array([1, 2, 3]);
   * await a.forEachAsync(e => console.log(e));
   * ```
   *
   * @param f A function to apply to each dataset element.
   * @returns A `Promise` that resolves after all elements have been processed.
   *
   * @doc {heading: 'Data', subheading: 'Classes'}
   */ async forEachAsync(t) {
        return (await this.iterator()).forEachAsync(t);
    }
    /**
   * Maps this dataset through a 1-to-1 transform.
   *
   * ```js
   * const a = tf.data.array([1, 2, 3]).map(x => x*x);
   * await a.forEachAsync(e => console.log(e));
   * ```
   *
   * @param transform A function mapping a dataset element to a transformed
   *   dataset element.
   *
   * @returns A `Dataset` of transformed elements.
   *
   * @doc {heading: 'Data', subheading: 'Classes'}
   */ map(t) {
        const e = this;
        return yn(async ()=>(await e.iterator()).map((s)=>D(()=>t(s))), this.size);
    }
    /**
   * Maps this dataset through an async 1-to-1 transform.
   *
   * ```js
   * const a =
   *  tf.data.array([1, 2, 3]).mapAsync(x => new Promise(function(resolve){
   *    setTimeout(() => {
   *      resolve(x * x);
   *    }, Math.random()*1000 + 500);
   *  }));
   * console.log(await a.toArray());
   * ```
   *
   * @param transform A function mapping a dataset element to a `Promise` for a
   *   transformed dataset element.  This transform is responsible for disposing
   *   any intermediate `Tensor`s, i.e. by wrapping its computation in
   *   `tf.tidy()`; that cannot be automated here (as it is in the synchronous
   *   `map()` case).
   *
   * @returns A `Dataset` of transformed elements.
   *
   * @doc {heading: 'Data', subheading: 'Classes'}
   */ mapAsync(t) {
        const e = this;
        return yn(async ()=>(await e.iterator()).mapAsync(t), this.size);
    }
    /**
   *  Creates a `Dataset` that prefetches elements from this dataset.
   *
   * @param bufferSize: An integer specifying the number of elements to be
   *   prefetched.
   * @returns A `Dataset`.
   *
   * @doc {heading: 'Data', subheading: 'Classes'}
   */ prefetch(t) {
        if (t == null) throw new RangeError("`Dataset.prefetch()` requires bufferSize to be specified.");
        const e = this;
        return yn(async ()=>(await e.iterator()).prefetch(t), this.size);
    }
    /**
   * Repeats this dataset `count` times.
   *
   * NOTE: If this dataset is a function of global state (e.g. a random number
   * generator), then different repetitions may produce different elements.
   *
   * ```js
   * const a = tf.data.array([1, 2, 3]).repeat(3);
   * await a.forEachAsync(e => console.log(e));
   * ```
   *
   * @param count: (Optional) An integer, representing the number of times
   *   the dataset should be repeated. The default behavior (if `count` is
   *   `undefined` or negative) is for the dataset be repeated indefinitely.
   * @returns A `Dataset`.
   *
   * @doc {heading: 'Data', subheading: 'Classes'}
   */ repeat(t) {
        const e = this;
        let s;
        return this.size != null && t > 0 ? s = this.size * t : t === 0 ? s = 0 : this.size != null && (t === void 0 || t < 0) ? s = 1 / 0 : s = null, yn(async ()=>{
            const o = z3(async ()=>({
                    value: await e.iterator(),
                    done: !1
                }));
            return P3(o.take(t));
        }, s);
    }
    /**
   * Creates a `Dataset` that skips `count` initial elements from this dataset.
   *
   * ```js
   * const a = tf.data.array([1, 2, 3, 4, 5, 6]).skip(3);
   * await a.forEachAsync(e => console.log(e));
   * ```
   *
   * @param count: The number of elements of this dataset that should be skipped
   *   to form the new dataset.  If `count` is greater than the size of this
   *   dataset, the new dataset will contain no elements.  If `count`
   *   is `undefined` or negative, skips the entire dataset.
   *
   * @returns A `Dataset`.
   *
   * @doc {heading: 'Data', subheading: 'Classes'}
   */ skip(t) {
        const e = this;
        let s;
        return this.size != null && t >= 0 && this.size >= t ? s = this.size - t : this.size != null && (this.size < t || t === void 0 || t < 0) ? s = 0 : s = null, yn(async ()=>(await e.iterator()).skip(t), s);
    }
    /**
   * Pseudorandomly shuffles the elements of this dataset. This is done in a
   * streaming manner, by sampling from a given number of prefetched elements.
   *
   * ```js
   * const a = tf.data.array([1, 2, 3, 4, 5, 6]).shuffle(3);
   * await a.forEachAsync(e => console.log(e));
   * ```
   *
   * @param bufferSize: An integer specifying the number of elements from this
   *   dataset from which the new dataset will sample.
   * @param seed: (Optional) An integer specifying the random seed that will
   *   be used to create the distribution.
   * @param reshuffleEachIteration: (Optional) A boolean, which if true
   *   indicates that the dataset should be pseudorandomly reshuffled each time
   *   it is iterated over. If false, elements will be returned in the same
   *   shuffled order on each iteration. (Defaults to `true`.)
   * @returns A `Dataset`.
   *
   * @doc {heading: 'Data', subheading: 'Classes'}
   */ shuffle(t, e, s = !0) {
        if (t == null || t < 0) throw this.size == null ? new RangeError("`Dataset.shuffle()` requires bufferSize to be specified.") : new RangeError(`\`Dataset.shuffle()\` requires bufferSize to be specified.  If your data fits in main memory (for regular JS objects), and/or GPU memory (for \`tf.Tensor\`s), consider setting bufferSize to the dataset size (${this.size} elements)`);
        const o = this, r = Nr.alea(e || Ie().toString());
        return yn(async ()=>{
            let i = r.int32();
            return s && (i += r.int32()), (await o.iterator()).shuffle(t, i.toString());
        }, this.size);
    }
    /**
   * Creates a `Dataset` with at most `count` initial elements from this
   * dataset.
   *
   * ```js
   * const a = tf.data.array([1, 2, 3, 4, 5, 6]).take(3);
   * await a.forEachAsync(e => console.log(e));
   * ```
   *
   * @param count: The number of elements of this dataset that should be taken
   *   to form the new dataset.  If `count` is `undefined` or negative, or if
   *   `count` is greater than the size of this dataset, the new dataset will
   *   contain all elements of this dataset.
   * @returns A `Dataset`.
   *
   * @doc {heading: 'Data', subheading: 'Classes'}
   */ take(t) {
        const e = this;
        let s;
        return this.size != null && this.size > t ? s = t : this.size != null && this.size <= t ? s = this.size : s = null, yn(async ()=>(await e.iterator()).take(t), s);
    }
    /**
   * Collect all elements of this dataset into an array.
   *
   * Obviously this will succeed only for small datasets that fit in memory.
   * Useful for testing and generally should be avoided if possible.
   *
   * ```js
   * const a = tf.data.array([1, 2, 3, 4, 5, 6]);
   * console.log(await a.toArray());
   * ```
   *
   * @returns A Promise for an array of elements, which will resolve
   *   when a new stream has been obtained and fully consumed.
   *
   * @doc {heading: 'Data', subheading: 'Classes'}
   */ async toArray() {
        if (this.size === 1 / 0) throw new Error("Can not convert infinite data stream to array.");
        return (await this.iterator()).toArray();
    }
    /**
   * Collect all elements of this dataset into an array with prefetching 100
   * elements. This is useful for testing, because the prefetch changes the
   * order in which the Promises are resolved along the processing pipeline.
   * This may help expose bugs where results are dependent on the order of
   * Promise resolution rather than on the logical order of the stream (i.e.,
   * due to hidden mutable state).
   *
   * @returns A Promise for an array of elements, which will resolve
   *   when a new stream has been obtained and fully consumed.
   */ async toArrayForTest() {
        if (this.size === 1 / 0) throw new Error("Can not convert infinite data stream to array.");
        return (await this.iterator()).toArrayForTest();
    }
}
zf.MAX_BUFFER_SIZE = 1e4;
function yn(n, t = null) {
    return new class extends zf {
        constructor(){
            super(...arguments), this.size = t;
        }
        /*
     * Provide a new stream of elements.  Note this will also start new streams
     * from any underlying `Dataset`s.
     */ async iterator() {
            return n();
        }
    }();
}
function BQ(n) {
    return yn(async ()=>V1(n), n.length);
}
function HQ(n) {
    if (!yr(n)) throw new Error("The argument to zip() must be an object or array.");
    let t;
    if (Array.isArray(n)) for(let e = 0; e < n.length; e++)t = t == null ? n[e].size : Math.min(t, n[e].size);
    else if (n instanceof Object) for(const e in n)t = t == null ? n[e].size : Math.min(t, n[e].size);
    return yn(async ()=>{
        const e = await D1(n, (s)=>{
            if (s instanceof zf) return {
                value: s.iterator(),
                recurse: !1
            };
            if (yr(s)) return {
                value: null,
                recurse: !0
            };
            throw new Error("Leaves of the structure passed to zip() must be Datasets, not primitives.");
        });
        return A3(e, Fs.SHORTEST);
    }, t);
}
function tM(n) {
    if (n === null) return null;
    const t = n[0];
    return W3(t) ? {
        value: eM(n),
        recurse: !1
    } : {
        value: null,
        recurse: !0
    };
}
function eM(n) {
    if (n.length === 0) throw new Error("Can't make a batch of zero elements.");
    return n[0] instanceof Mt ? Xn(n) : $e(n);
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function lt(n, t) {
    Array.isArray(n) || (n = [
        n
    ]), n.forEach((e)=>{
        e != null && C(e.dtype !== "complex64", ()=>`${t} does not support complex64 tensors in the CPU backend.`);
    });
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const nM = C0;
class yu extends _d {
    nextDataId() {
        return yu.nextDataId++;
    }
    constructor(){
        super(), this.blockSize = 48, this.firstUse = !0, this.data = new qg(this, Ot());
    }
    write(t, e, s) {
        this.firstUse && (this.firstUse = !1, F().get("IS_NODE") && ln(`
============================
Hi, looks like you are running TensorFlow.js in Node.js. To speed things up dramatically, install our node backend, visit https://github.com/tensorflow/tfjs-node for more details. 
============================`));
        const o = {
            id: this.nextDataId()
        };
        return this.data.set(o, {
            values: t,
            dtype: s,
            refCount: 1
        }), o;
    }
    /**
   * Create a data bucket in cpu backend.
   * @param shape Shape of the `TensorInfo`.
   * @param dtype DType of the `TensorInfo`.
   * @param values The value of the `TensorInfo` stored as a flattened array.
   */ makeTensorInfo(t, e, s) {
        let o;
        if (e === "string" && s != null && s.length > 0 && vr(s[0])) {
            const r = s.map((i)=>ms(i));
            o = this.write(r, t, e);
        } else o = this.write(s, t, e);
        return {
            dataId: o,
            shape: t,
            dtype: e
        };
    }
    /** Return refCount of a `TensorData`. */ refCount(t) {
        return this.data.has(t) ? this.data.get(t).refCount : 0;
    }
    /** Increase refCount of a `TensorData`. */ incRef(t) {
        const e = this.data.get(t);
        e.refCount++;
    }
    /** Decrease refCount of a `TensorData`. */ decRef(t) {
        if (this.data.has(t)) {
            const e = this.data.get(t);
            e.refCount--;
        }
    }
    move(t, e, s, o, r) {
        this.data.set(t, {
            values: e,
            dtype: o,
            refCount: r
        });
    }
    numDataIds() {
        return this.data.numDataIds();
    }
    async read(t) {
        return this.readSync(t);
    }
    readSync(t) {
        const { dtype: e, complexTensorInfos: s } = this.data.get(t);
        if (e === "complex64") {
            const o = this.readSync(s.real.dataId), r = this.readSync(s.imag.dataId);
            return xs(o, r);
        }
        return ib(this.data.get(t).values, e);
    }
    bufferSync(t) {
        const e = this.readSync(t.dataId);
        if (t.dtype === "string") try {
            const s = e.map((o)=>gs(o));
            return vt(t.shape, t.dtype, s);
        } catch  {
            throw new Error("Failed to decode encoded string bytes into utf-8");
        }
        return vt(t.shape, t.dtype, e);
    }
    makeOutput(t, e, s) {
        return Ot().makeTensorFromTensorInfo(this.makeTensorInfo(e, s, t), this);
    }
    /**
   * Dispose the memory if the dataId has 0 refCount. Return true if the memory
   * is released or memory is not managed in this backend, false if memory is
   * not cleared.
   * @param dataId
   * @oaram force Optional, remove the data regardless of refCount
   */ disposeData(t, e = !1) {
        if (this.data.has(t)) {
            if (this.data.get(t).refCount--, !e && this.data.get(t).refCount > 0) return !1;
            const { complexTensorInfos: s } = this.data.get(t);
            s != null && (this.disposeData(s.real.dataId, !0), this.disposeData(s.imag.dataId, !0)), this.data.delete(t);
        }
        return !0;
    }
    disposeIntermediateTensorInfo(t) {
        this.disposeData(t.dataId);
    }
    async time(t) {
        const e = Ie();
        return t(), {
            kernelMs: Ie() - e
        };
    }
    memory() {
        return {
            // Unreliable due to automatic gc. The numbers above are cumulative.
            unreliable: !0,
            reasons: [
                "The reported memory is an upper bound. Due to automatic garbage collection, the true allocated memory may be less."
            ]
        };
    }
    where(t) {
        lt([
            t
        ], "where");
        const e = this.readSync(t.dataId);
        return nM(t.shape, e);
    }
    dispose() {}
    floatPrecision() {
        return 32;
    }
    /** Returns the smallest representable number.  */ epsilon() {
        return super.epsilon();
    }
}
yu.nextDataId = 0;
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function A1(n) {
    const t = new Float32Array(n.length);
    for(let e = 0; e < n.length; ++e)t[e] = Math.abs(n[e]);
    return t;
}
const sM = (n)=>{
    const { x: t } = n.inputs, e = n.backend;
    lt(t, "abs");
    let s = new Float32Array(X(t.shape));
    const o = e.data.get(t.dataId).values;
    return s = A1(o), e.makeOutput(s, t.shape, t.dtype);
}, oM = {
    kernelName: Ul,
    backendName: "cpu",
    kernelFunc: sM
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function le(n) {
    return (t, e, s, o, r)=>{
        const i = bt(t, e), a = i.length, l = dt(i), c = X(i), u = Se(r, c), d = t.length, h = e.length, p = dt(t), f = dt(e), m = Go(t, i), g = Go(e, i);
        if (m.length + g.length === 0) for(let b = 0; b < u.length; ++b)u[b] = n(s[b % s.length], o[b % o.length]);
        else for(let b = 0; b < u.length; ++b){
            const x = Xo(b, a, l), w = x.slice(-d);
            m.forEach((k)=>w[k] = 0);
            const y = zn(w, d, p), I = x.slice(-h);
            g.forEach((k)=>I[k] = 0);
            const v = zn(I, h, f);
            u[b] = n(s[y], o[v]);
        }
        return [
            u,
            i
        ];
    };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Je(n) {
    const { inputs: t, backend: e } = n, { real: s, imag: o } = t, r = e.data.get(s.dataId).values, i = e.data.get(o.dataId).values, a = e.makeTensorInfo(s.shape, "complex64"), l = e.data.get(a.dataId);
    return l.complexTensorInfos = {
        real: e.makeTensorInfo(s.shape, "float32", r),
        imag: e.makeTensorInfo(o.shape, "float32", i)
    }, a;
}
const rM = {
    kernelName: ih,
    backendName: "cpu",
    kernelFunc: Je
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Fl(n, t, e = "float32") {
    if (e === "complex64") {
        const o = Fl(n, t, "float32"), r = Fl(n, t, "float32");
        return Je({
            inputs: {
                real: o,
                imag: r
            },
            backend: n
        });
    }
    const s = ke(X(t), e);
    return n.makeTensorInfo(t, e, s);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function rs(n) {
    const { inputs: t, backend: e } = n, { x: s } = t;
    return e.incRef(s.dataId), {
        dataId: s.dataId,
        shape: s.shape,
        dtype: s.dtype
    };
}
const iM = {
    kernelName: Ki,
    backendName: "cpu",
    kernelFunc: rs
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Do(n) {
    const { inputs: t, backend: e } = n, { input: s } = t, o = e.data.get(s.dataId).complexTensorInfos.real, r = e.data.get(o.dataId).values;
    return e.makeTensorInfo(o.shape, o.dtype, r);
}
const aM = {
    kernelName: Eh,
    backendName: "cpu",
    kernelFunc: Do
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function O1(n, t, e, s) {
    if (s === "int32") {
        const o = Int32Array.from(n);
        return [
            t,
            "int32",
            o
        ];
    }
    if (s === "bool") {
        const o = Qs([
            0
        ], e), [r, i] = le((a, l)=>a !== l ? 1 : 0)(t, [], n, o, "bool");
        return [
            i,
            "bool",
            r
        ];
    }
    throw new Error(`Error in Cast: failed to cast ${e} to ${s}`);
}
function Ys(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { dtype: r } = s;
    if (r === "complex64") {
        if (o.dtype === "complex64") return rs({
            inputs: {
                x: o
            },
            backend: e
        });
        const u = Fl(e, o.shape, o.dtype), d = Ys({
            inputs: {
                x: o
            },
            backend: e,
            attrs: {
                dtype: "float32"
            }
        }), h = Je({
            inputs: {
                real: d,
                imag: u
            },
            backend: e
        });
        return e.disposeIntermediateTensorInfo(u), e.disposeIntermediateTensorInfo(d), h;
    }
    if (o.dtype === "complex64") {
        const u = Do({
            inputs: {
                input: o
            },
            backend: e
        }), d = Ys({
            inputs: {
                x: u
            },
            backend: e,
            attrs: {
                dtype: r
            }
        });
        return e.disposeIntermediateTensorInfo(u), d;
    }
    if (!Qd(o.dtype, r)) {
        const u = rs({
            inputs: {
                x: o
            },
            backend: e
        });
        return {
            dataId: u.dataId,
            shape: u.shape,
            dtype: r
        };
    }
    const i = e.data.get(o.dataId).values, [a, l, c] = O1(i, o.shape, o.dtype, r);
    return e.makeTensorInfo(a, l, c);
}
const lM = {
    kernelName: Gi,
    backendName: "cpu",
    kernelFunc: Ys
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function fe(n, t, e, s) {
    return e == null ? ({ inputs: o, backend: r })=>{
        const { a: i, b: a } = o, l = r;
        lt([
            i,
            a
        ], n);
        const c = l.data.get(i.dataId).values, u = l.data.get(a.dataId).values, d = i.dtype === "string" ? // tslint:disable-next-line: no-any
        ys(c) : c, h = i.dtype === "string" ? // tslint:disable-next-line: no-any
        ys(u) : u, p = s || i.dtype, [f, m] = t(i.shape, a.shape, d, h, p);
        return l.makeTensorInfo(m, p, f);
    } : ({ inputs: o, backend: r })=>{
        const { a: i, b: a } = o, l = r;
        if (i.dtype === "complex64" || a.dtype === "complex64") {
            const c = Ys({
                inputs: {
                    x: i
                },
                backend: l,
                attrs: {
                    dtype: "complex64"
                }
            }), u = l.data.get(c.dataId), d = u.complexTensorInfos.real, h = u.complexTensorInfos.imag, p = l.data.get(d.dataId).values, f = l.data.get(h.dataId).values, m = Ys({
                inputs: {
                    x: a
                },
                backend: l,
                attrs: {
                    dtype: "complex64"
                }
            }), g = l.data.get(m.dataId), b = g.complexTensorInfos.real, x = g.complexTensorInfos.imag, w = l.data.get(b.dataId).values, y = l.data.get(x.dataId).values, [I, v, k] = e(i.shape, a.shape, p, f, w, y), S = l.makeTensorInfo(k, "float32", I), N = l.makeTensorInfo(k, "float32", v), R = Je({
                inputs: {
                    real: S,
                    imag: N
                },
                backend: l
            });
            return l.disposeIntermediateTensorInfo(c), l.disposeIntermediateTensorInfo(m), l.disposeIntermediateTensorInfo(S), l.disposeIntermediateTensorInfo(N), R;
        } else {
            const c = l.data.get(i.dataId).values, u = l.data.get(a.dataId).values, d = s || i.dtype, [h, p] = t(i.shape, a.shape, c, u, d);
            return l.makeTensorInfo(p, d, h);
        }
    };
}
function Pf(n) {
    return (t, e, s, o, r, i)=>{
        const a = bt(t, e), l = X(a), c = a.length, u = dt(a), d = Se("float32", l), h = Se("float32", l), p = Go(t, a), f = Go(e, a), m = xs(s, o), g = xs(r, i), b = t.length, x = dt(t), w = e.length, y = dt(e);
        if (p.length + f.length === 0) for(let I = 0; I < d.length; I++){
            const v = I % m.length, k = I % g.length, S = n(m[v * 2], m[v * 2 + 1], g[k * 2], g[k * 2 + 1]);
            d[I] = S.real, h[I] = S.imag;
        }
        else for(let I = 0; I < d.length; I++){
            const v = Xo(I, c, u), k = v.slice(-b);
            p.forEach((V)=>k[V] = 0);
            const S = zn(k, b, x), N = v.slice(-w);
            f.forEach((V)=>N[V] = 0);
            const R = zn(N, w, y), M = n(m[S * 2], m[S * 2 + 1], g[R * 2], g[R * 2 + 1]);
            d[I] = M.real, h[I] = M.imag;
        }
        return [
            d,
            h,
            a
        ];
    };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const X1 = le((n, t)=>n + t), cM = Pf((n, t, e, s)=>({
        real: n + e,
        imag: t + s
    })), wr = fe(Sr, X1, cM), uM = {
    kernelName: Sr,
    backendName: "cpu",
    kernelFunc: wr
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Af(n, t, e, s, o) {
    const r = X(s), i = ke(o, e);
    for(let a = 0; a < n.length; a++){
        const l = n[a];
        if (l < 0) throw new Error("Input x must be non-negative!");
        l >= o || (r > 0 ? i[l] += t[a] : i[l] += 1);
    }
    return i;
}
function K1(n, t, e, s = !1) {
    const o = n.shape[0], r = n.shape[1], i = vt([
        o,
        e
    ], t.dtype);
    for(let a = 0; a < o; a++)for(let l = 0; l < r; l++){
        const c = n.get(a, l);
        if (c < 0) throw new Error("Input x must be non-negative!");
        c >= e || (s ? i.set(1, a, c) : t.size > 0 ? i.set(i.get(a, c) + t.get(a, l), a, c) : i.set(i.get(a, c) + 1, a, c));
    }
    return i;
}
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Z1 = le((n, t)=>n & t), dM = fe(rh, Z1), hM = {
    kernelName: rh,
    backendName: "cpu",
    kernelFunc: dM
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function as(n) {
    return (t, e, s)=>{
        const o = ne(e, t.length);
        for(let r = 0; r < t.length; ++r)o[r] = n(t[r], s);
        return o;
    };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Wt(n, t, e) {
    const s = as(t);
    return so(n, s, e);
}
function so(n, t, e) {
    return ({ inputs: s, attrs: o, backend: r })=>{
        const { x: i } = s;
        lt(i, n);
        const a = r, l = a.data.get(i.dataId).values;
        let c;
        if (i.dtype === "string") {
            if (!Array.isArray(l)) throw new Error("String tensor's value was not an instance of Array");
            c = ys(l);
        } else c = l;
        const u = e || i.dtype, d = t(c, u, o);
        return a.makeTensorInfo(i.shape, u, d);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const B1 = as((n)=>Math.ceil(n)), pM = so(Ei, B1), fM = {
    kernelName: Ei,
    backendName: "cpu",
    kernelFunc: pM
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function H1(n, t, e, s) {
    const o = ne(e, X(t));
    if (s && e !== "string") {
        let r = 0;
        n.forEach((i)=>{
            const a = X(i.shape);
            o.set(i.vals, r), r += a;
        });
    } else {
        let r = 0;
        n.forEach((i)=>{
            const a = e === "string" ? ys(i.vals) : i.vals;
            let l = 0;
            for(let c = 0; c < i.shape[0]; ++c){
                const u = c * t[1] + r;
                for(let d = 0; d < i.shape[1]; ++d)o[u + d] = a[l++];
            }
            r += i.shape[1];
        });
    }
    return o;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const _1 = le((n, t)=>n === t ? 1 : 0), U1 = fe(cc, _1, null, "bool"), mM = {
    kernelName: cc,
    backendName: "cpu",
    kernelFunc: U1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Y1 = as((n)=>Math.exp(n)), Q1 = so(zi, Y1, "float32"), gM = {
    kernelName: zi,
    backendName: "cpu",
    kernelFunc: Q1
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const J1 = as((n)=>Math.expm1(n)), bM = so(Pi, J1), xM = {
    kernelName: Pi,
    backendName: "cpu",
    kernelFunc: bM
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const j1 = as((n)=>Math.floor(n)), yM = so(Ai, j1), wM = {
    kernelName: Ai,
    backendName: "cpu",
    kernelFunc: yM
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const q1 = le((n, t)=>Math.floor(n / t)), IM = fe(Oi, q1, null, "int32"), CM = {
    kernelName: Oi,
    backendName: "cpu",
    kernelFunc: IM
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function tw(n, t, e, s, o, r, i, a, l) {
    const c = vt([
        s,
        r
    ], e);
    for(let u = 0; u < s; u++){
        const d = [];
        let h = 0;
        for(let p = 0; p < o; p++){
            const f = n[u * o + p];
            h += f * i[p], d.push(f);
        }
        if (h < 0 || h >= l / r) throw new Error(`Invalid indices: ${d} does not index into ${a}`);
        for(let p = 0; p < r; p++)c.values[u * r + p] = t.get(...t.indexToLoc(h * r + p));
    }
    return c;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ew(n, t, e) {
    const s = vt(e, n.dtype);
    for(let o = 0; o < s.size; ++o){
        const i = s.indexToLoc(o).slice(), a = i[0], l = i[2], c = t.locToIndex([
            a,
            l
        ]);
        i[2] = t.values[c];
        const u = n.locToIndex(i);
        0 <= u && u < n.values.length && (s.values[o] = n.values[u]);
    }
    return s;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const nw = le((n, t)=>n > t ? 1 : 0), vM = fe(pc, nw, null, "bool"), SM = {
    kernelName: pc,
    backendName: "cpu",
    kernelFunc: vM
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const sw = le((n, t)=>n >= t ? 1 : 0), kM = fe(Xi, sw, null, "bool"), TM = {
    kernelName: Xi,
    backendName: "cpu",
    kernelFunc: kM
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const ow = le((n, t)=>n < t ? 1 : 0), NM = fe(mc, ow, null, "bool"), RM = {
    kernelName: mc,
    backendName: "cpu",
    kernelFunc: NM
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const rw = le((n, t)=>n <= t ? 1 : 0), $M = fe(gc, rw, null, "bool"), GM = {
    kernelName: gc,
    backendName: "cpu",
    kernelFunc: $M
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function iw(n, t, e) {
    const s = (t - n) / (e - 1), o = ke(e, "float32");
    o[0] = n;
    for(let r = 1; r < o.length; r++)o[r] = o[r - 1] + s;
    return o;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const aw = as((n)=>Math.log(n)), EM = so(_i, aw), LM = {
    kernelName: _i,
    backendName: "cpu",
    kernelFunc: EM
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function lw(n, t, e, s) {
    const o = Se(s, X(e));
    for(let r = 0; r < o.length; ++r){
        const i = r * t;
        let a = n[i];
        for(let l = 0; l < t; ++l){
            const c = n[i + l];
            (Number.isNaN(c) || c > a) && (a = c);
        }
        o[r] = a;
    }
    return o;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const cw = le((n, t)=>Math.max(n, t)), MM = fe(Yi, cw), WM = {
    kernelName: Yi,
    backendName: "cpu",
    kernelFunc: MM
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const uw = le((n, t)=>Math.min(n, t)), DM = fe(Qi, uw), FM = {
    kernelName: Qi,
    backendName: "cpu",
    kernelFunc: DM
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Of = le((n, t)=>n * t), VM = Pf((n, t, e, s)=>({
        real: n * e - t * s,
        imag: n * s + t * e
    })), wu = fe(ji, Of, VM), zM = {
    kernelName: ji,
    backendName: "cpu",
    kernelFunc: wu
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function dw(n, t, e) {
    const s = Is(-1, e);
    return Of([], t, s, n, e);
}
function PM(n) {
    const { inputs: t, backend: e } = n, { x: s } = t;
    lt(s, "neg");
    const o = e.data.get(s.dataId).values, [r, i] = dw(o, s.shape, s.dtype);
    return e.makeTensorInfo(i, s.dtype, r);
}
const AM = {
    kernelName: Nc,
    backendName: "cpu",
    kernelFunc: PM
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const hw = le((n, t)=>n !== t ? 1 : 0), OM = fe(Rc, hw, null, "bool"), XM = {
    kernelName: Rc,
    backendName: "cpu",
    kernelFunc: OM
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Xf(n, t, e, s, o) {
    const r = t.length, i = X(t), a = dt(t), l = dt(o), c = Se(e, X(o));
    for(let u = 0; u < i; ++u){
        const d = Xo(u, r, a), h = new Array(d.length);
        for(let f = 0; f < h.length; f++)h[f] = d[s[f]];
        const p = zn(h, r, l);
        c[p] = n[u];
    }
    return c;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function _e(n) {
    const { inputs: t, attrs: e, backend: s } = n, { x: o } = t, { perm: r } = e;
    lt(o, "transpose");
    const i = o.shape.length, a = new Array(i);
    for(let d = 0; d < a.length; d++)a[d] = o.shape[r[d]];
    const l = s.data.get(o.dataId).values, c = Xf(l, o.shape, o.dtype, r, a);
    return {
        dataId: s.write(c, a, o.dtype),
        shape: a,
        dtype: o.dtype
    };
}
const KM = {
    kernelName: ar,
    backendName: "cpu",
    kernelFunc: _e
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function pw(n, t, e, s) {
    const [o, r] = ye(n, s), i = tn(t, "int32"), a = ke(X(o), i), l = X(r);
    for(let c = 0; c < a.length; ++c){
        const u = c * l;
        let d = 1;
        for(let h = 0; h < l; ++h)d *= e[u + h];
        a[c] = d;
    }
    return {
        outVals: a,
        outShape: o,
        outDtype: i
    };
}
function ZM(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r, keepDims: i } = s;
    lt(o, "prod");
    const a = o.shape.length, l = Ct(r, o.shape), c = qt(l, a);
    let u = l, d = o;
    const h = [];
    c != null && (d = _e({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            perm: c
        }
    }), h.push(d), u = ie(u.length, a));
    const p = e.data.get(d.dataId).values, { outVals: f, outShape: m, outDtype: g } = pw(d.shape, d.dtype, p, u);
    let b = m;
    return i && (b = re(m, l)), h.forEach((x)=>e.disposeIntermediateTensorInfo(x)), e.makeTensorInfo(b, g, f);
}
const BM = {
    kernelName: Wc,
    backendName: "cpu",
    kernelFunc: ZM
};
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function HM(n, t, e) {
    n.forEach((s, o)=>{
        if (s < 0 || s >= e) {
            const r = Xo(o, t.length, dt(t)).join(",");
            throw new Error(`indices[${r}] = ${s} is not in [0, ${e})`);
        }
    });
}
function _M(n, t) {
    for(let e = 0; e < n.length; ++e){
        const s = n[e], o = e === n.length - 1 ? t : n[e + 1].length;
        if (s.length === 0) throw new Error("Ragged splits may not be empty");
        if (s[0] < 0) throw new Error("Ragged splits must be non-negative");
        if (s[s.length - 1] > o) throw new Error("Ragged splits must not point past values");
        for(let r = 1; r < s.length; ++r)if (s[r - 1] > s[r]) throw new Error("Ragged splits must be sorted in ascending order");
    }
}
function UM(n, t, e, s) {
    const o = [];
    let r = 0;
    const i = t.length - 1 + e.length, a = new Array(i).fill(null).map(()=>[
            0
        ]);
    _M(e, s);
    let l = 1;
    for(let c = 0; c < t.length - 1; ++c){
        l *= t[c];
        const u = t[c + 1];
        for(let d = 1; d < l + 1; ++d)a[c].push(d * u);
    }
    for(let c = 0; c < n.length; ++c){
        let u = n[c], d = n[c] + 1;
        for(let h = 0; h < e.length; ++h){
            const p = e[h], f = h + t.length - 1;
            if (f >= 0) {
                const m = a[f], g = m[m.length - 1] - p[u];
                for(let b = u; b < d; ++b)a[f].push(p[b + 1] + g);
            }
            u = p[u], d = p[d];
        }
        d !== u && (o.push([
            u,
            d
        ]), r += d - u);
    }
    return {
        outSplits: a,
        valueSlices: o,
        numValues: r
    };
}
function YM(n) {
    const t = [];
    for(let e = 0; e < n.length; ++e){
        const s = n[e].length, o = ne("int32", s);
        t.push(o), n[e].forEach((r, i)=>o[i] = r);
    }
    return t;
}
function pg(n, t) {
    const e = n.slice(0, t);
    for(; e.length < t;)e.push(1);
    for(let s = t; s < n.length; s++)e[t - 1] *= n[s];
    return e;
}
function QM(n, t, e, s, o, r) {
    const i = pg(t, 2)[1], a = pg(r, 2)[1];
    let l = 0;
    for (const c of e)for(let u = c[0]; u < c[1]; ++u){
        for(let d = 0; d < s; ++d)o[l * a + d] = n[u * i + d];
        ++l;
    }
}
function JM(n, t, e, s, o) {
    const r = t.slice();
    r[0] = o;
    const i = ne(e, X(r)), a = n.length, l = a === 0 ? 0 : a / t[0];
    return QM(n, t, s, l, i, r), [
        i,
        r
    ];
}
function fw(n, t, e, s, o, r, i, a) {
    if (n.length === 0) throw new Error("paramsNestedSplits must be non empty");
    if (t[0].length === 0) throw new Error("Split tensors must not be scalars");
    const l = t[0][0] - 1;
    if (HM(r, i, l), s.length === 0) throw new Error("params.rank must be nonzero");
    const c = s[0], { outSplits: u, valueSlices: d, numValues: h } = UM(r, i, n, c), p = YM(u), f = JM(e, s, o, d, h);
    return [
        p,
        f[0],
        f[1]
    ];
}
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const fg = 2147483647;
function mw(n, t, e, s, o, r, i) {
    if (t.length > 1) throw new Error("starts must be a scalar or vector");
    if (o.length > 1) throw new Error("limits must be a scalar or vector");
    if (i.length > 1) throw new Error("deltas must be a scalar or vector");
    const a = t.length === 0, l = o.length === 0, c = i.length === 0, u = [];
    a || u.push(t[0]), l || u.push(o[0]), c || u.push(i[0]);
    for(let g = 1; g < u.length; ++g)if (u[g] !== u[g - 1]) throw new Error("starts, limits, and deltas must have the same shape");
    const d = u.length === 0 ? 1 : u[0], h = ne("int32", d + 1);
    h[0] = 0;
    for(let g = 0; g < d; ++g){
        const b = a ? n[0] : n[g], x = l ? s[0] : s[g], w = c ? r[0] : r[g];
        if (w === 0) throw new Error("Requires delta != 0");
        let y;
        if (w > 0 && x < b || w < 0 && x > b) y = 0;
        else if (y = Math.ceil(Math.abs((x - b) / w)), y > fg) throw new Error(`Requires ((limit - start) / delta) <= ${fg}`);
        h[g + 1] = h[g] + y;
    }
    const p = h[d], f = ne(e, p);
    let m = 0;
    for(let g = 0; g < d; ++g){
        const b = h[g + 1] - h[g];
        let x = a ? n[0] : n[g];
        const w = c ? r[0] : r[g];
        for(let y = 0; y < b; ++y)f[m++] = x, x += w;
    }
    return [
        h,
        f
    ];
}
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var xn = Fn;
class Vl {
    constructor(t, e, s, o, r, i, a, l, c, u){
        this.shape = t, this.shapeShape = e, this.values = s, this.valuesShape = o, this.valuesDType = r, this.defaultValue = i, this.defaultValueShape = a, this.rowPartitionValues = l, this.rowPartitionValuesShapes = c, this.rowPartitionTypes = Y0(u), this.raggedRank = Q0(this.rowPartitionTypes);
    }
    getRowPartitionTypeByDimension(t) {
        return this.rowPartitionTypes[0] === xn.FIRST_DIM_SIZE ? this.rowPartitionTypes[t + 1] : this.rowPartitionTypes[t];
    }
    // Returns the relationship between dimension and dimension + 1.
    getRowPartitionTensor(t) {
        return this.rowPartitionTypes[0] === xn.FIRST_DIM_SIZE ? this.rowPartitionValues[t + 1] : this.rowPartitionValues[t];
    }
    getMaxWidth(t) {
        const e = this.getRowPartitionTensor(t - 1);
        switch(this.getRowPartitionTypeByDimension(t - 1)){
            case xn.VALUE_ROWIDS:
                return Vl.getMaxWidthValueRowID(e);
            case xn.ROW_SPLITS:
                return Vl.getMaxWidthRowSplit(e);
            default:
                throw new Error(`Cannot handle partition type ${xn[this.getRowPartitionTypeByDimension(t - 1)]}`);
        }
    }
    static getMaxWidthRowSplit(t) {
        const e = t.length;
        if (e === 0 || e === 1) return 0;
        let s = 0;
        for(let o = 0; o < e - 1; ++o){
            const r = t[o + 1] - t[o];
            r > s && (s = r);
        }
        return s;
    }
    static getMaxWidthValueRowID(t) {
        const e = t.length;
        if (e === 0) return 0;
        let s = 0, o = t[0], r = 0;
        for(let i = 1; i < e; ++i){
            const a = t[i];
            a !== o && (o = a, r = Math.max(i - s, r), s = i);
        }
        return Math.max(e - s, r);
    }
    tensorShapeFromTensor(t, e, s = !0) {
        if (e.length === 0) {
            if (t[0] === -1) return [];
            throw new Error("The only valid scalar shape tensor is the fully unknown shape specified as -1.");
        }
        return gg(t, s);
    }
    calculateOutputSize(t) {
        const e = this.valuesShape, s = this.defaultValueShape;
        J0(s, e);
        const o = this.tensorShapeFromTensor(this.shape, this.shapeShape), i = U0(this.raggedRank, o, e);
        i[0] < 0 && (i[0] = t);
        for(let a = 1; a <= this.raggedRank; ++a)i[a] < 0 && (i[a] = this.getMaxWidth(a));
        return i;
    }
    /**
   * The outputIndex represents the index in the output tensor
   * where the first element of a particular dimension would be written.
   * If it is -1, it indicates that the index is out of scope.
   * Example, given firstDimension = 10, firstDimensionOutput = 6,
   * and outputIndexMultiplier = 100:
   * result = [0 100 200 300 400 500 -1 -1 -1 -1]
   * If firstDimensionOutput = 11 instead, then:
   * result = [0 100 200 300 400 500 600 700 800 900]
   */ calculateFirstParentOutputIndex(t, e, s) {
        const o = Math.min(t, s), r = [];
        let i = 0;
        for(let a = 0; a < o; ++a, i += e)r.push(i);
        for(let a = o; a < t; ++a)r.push(-1);
        return C(r.length === t, ()=>"Final length of result must be equal to firstDimension."), r;
    }
    calculateOutputIndexRowSplit(t, e, s, o) {
        const r = t.length, i = [];
        for(let a = 0; a < r - 1; ++a){
            const l = t[a + 1] - t[a];
            let c = Math.min(o, l), u = e[a];
            u === -1 && (c = 0);
            for(let d = 0; d < c; ++d)i.push(u), u += s;
            for(let d = 0; d < l - c; ++d)i.push(-1);
        }
        if (r > 0 && i.length !== t[r - 1]) throw new Error("Invalid row split size.");
        return i;
    }
    // Calculate the output index of the first element of a list.
    // The parentOutputIndex is the same computation for the previous list.
    // -1 indicates an element or list that is out of range.
    // The outputIndexMultiplier is the number of output indices one moves
    // forward for each column.
    // E.g., given:
    // valueRowIds:[0 1 2 2 2 3 5 5 6]
    // parentOutputIndex:[1000 1100 2000 2100 -1 3000 4000]
    // outputIndexMultiplier: 10
    // outputSize: 2
    // You get:
    // result = [1000 1100 2000 2010 -1 2100 -1 -1 3000]
    // result[0] = parentOutputIndex[valueRowIds[0]]
    // result[1] = parentOutputIndex[valueRowIds[1]]
    // result[2] = parentOutputIndex[valueRowIds[2]]
    // result[3] = parentOutputIndex[valueRowIds[2] + 10]
    // result[4] = -1 because it is the third element the size is 2.
    // result[5] = parentOutputIndex[valueRowIds[3]]
    // result[6] = -1 because parentOutputIndex[valueRowIds[6]] == -1
    // result[7] = -1 because parentOutputIndex[valueRowIds[6]] == -1
    // result[8] = parentOutputIndex[valueRowIds[7]]
    calculateOutputIndexValueRowID(t, e, s, o) {
        const r = t.length, i = [];
        if (r === 0) return [];
        let a = 0, l = t[0];
        if (l >= e.length) throw new Error(`Got currentValueRowId=${l}, which is not less than ${e.length}`);
        let c = e[l];
        i.push(c);
        for(let u = 1; u < r; ++u){
            const d = t[u];
            if (d === l) c >= 0 && (++a, a < o ? c += s : c = -1);
            else {
                if (a = 0, l = d, d >= e.length) throw new Error(`Got nextValueRowId=${d} which is not less than ${e.length}`);
                c = e[d];
            }
            i.push(c);
        }
        if (i.length !== t.length) throw new Error("Invalid row ids.");
        return i;
    }
    calculateOutputIndex(t, e, s, o) {
        const r = this.getRowPartitionTensor(t), i = this.getRowPartitionTypeByDimension(t);
        switch(i){
            case xn.VALUE_ROWIDS:
                return this.calculateOutputIndexValueRowID(r, e, s, o);
            case xn.ROW_SPLITS:
                if (r.length - 1 > e.length) throw new Error(`Row partition size is greater than output size: ${r.length - 1} > ${e.length}`);
                return this.calculateOutputIndexRowSplit(r, e, s, o);
            default:
                throw new Error(`Unsupported partition type: ${xn[i]}`);
        }
    }
    getFirstDimensionSize() {
        const t = this.rowPartitionValues[0];
        if (this.rowPartitionTypes.length === 0) throw new Error("No row_partition_types given.");
        const e = this.rowPartitionTypes[0];
        switch(e){
            case xn.FIRST_DIM_SIZE:
                return t[0];
            case xn.VALUE_ROWIDS:
                throw new Error("Cannot handle VALUE_ROWIDS in first dimension.");
            case xn.ROW_SPLITS:
                return this.rowPartitionValuesShapes[0][0] - 1;
            default:
                throw new Error(`Cannot handle type ${xn[e]}`);
        }
    }
    compute() {
        if (this.rowPartitionValues[0].length <= 0) throw new Error("Invalid first partition input. Tensor requires at least one element.");
        const e = this.getFirstDimensionSize(), s = this.calculateOutputSize(e), o = new Array(this.raggedRank + 1);
        o[o.length - 1] = 1;
        for(let l = o.length - 2; l >= 0; --l)o[l] = o[l + 1] * s[l + 1];
        const r = gg(s, !1), i = ne(this.valuesDType, X(r));
        if (o[0] * s[0] > 0) {
            let l = this.calculateFirstParentOutputIndex(e, o[0], s[0]);
            for(let c = 1; c <= this.raggedRank; ++c)l = this.calculateOutputIndex(c - 1, l, o[c], s[c]);
            this.setOutput(this.raggedRank, l, i, r);
        }
        return [
            r,
            i
        ];
    }
    setOutput(t, e, s, o) {
        if (s.length === 0) return;
        const r = this.values, i = s;
        let a = o.slice();
        a = a.slice(t + 1);
        const l = X(a), c = e.length;
        let u = this.defaultValue;
        if (u.length !== l && u.length !== 1) {
            const f = this.defaultValueShape;
            D(()=>{
                const m = W(u, f);
                u = ni(m, a).dataSync();
            });
        }
        let d = 0, h = 0, p = 0;
        for(let f = 0; f <= c; ++f){
            let m = f < c ? e[f] : -1;
            if (m === p) {
                ++p;
                continue;
            }
            if (h < p) {
                const g = r.subarray(d * l), b = i.subarray(h * l), x = (p - h) * l;
                mg(b, g, x);
            }
            if (f >= c) {
                const g = s.length;
                m = Math.floor(g / l);
            }
            if (m > p) {
                if (this.defaultValue.length === 1) i.subarray(p * l, m * l).fill(this.defaultValue[0]), p = m;
                else for(; m > p;){
                    const g = i.slice(p * l);
                    mg(g, u, l), ++p;
                }
            }
            m < 0 ? (d = f + 1, h = p) : (d = f, h = p, p = h + 1);
        }
    }
}
function mg(n, t, e) {
    for(let s = 0; s < e; s++)n[s] = t[s];
}
function gg(n, t) {
    const e = [];
    for (let s of n){
        if (s < 0) {
            if (!t) throw new Error(`Dimension ${s} must be >= 0`);
            if (s < -1) throw new Error(`Dimension ${s} must be >= -1`);
            s = -1;
        }
        e.push(s);
    }
    return e;
}
function gw(n, t, e, s, o, r, i, a, l, c) {
    return new Vl(n, t, e, s, o, r, i, a, l, c).compute();
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function bw(n, t, e, s) {
    const o = n === t, r = n < t && e < 0, i = t < n && e > 1;
    if (o || r || i) return ke(0, s);
    const a = Math.abs(Math.ceil((t - n) / e)), l = ke(a, s);
    t < n && e === 1 && (e = -1), l[0] = n;
    for(let c = 1; c < l.length; c++)l[c] = l[c - 1] + e;
    return l;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const xw = as((n)=>1 / Math.sqrt(n)), jM = so(oa, xw), qM = {
    kernelName: oa,
    backendName: "cpu",
    kernelFunc: jM
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function bo(n, t, e, s, o, r, i, a, l, c) {
    const u = [
        s / o,
        o
    ], d = n.values, h = t.values;
    if (s === 0) return vt(e, t.dtype);
    const p = l instanceof ve ? l : vt(u, t.dtype);
    typeof l == "string" || typeof l == "number" ? p.values.fill(l) : typeof l == "boolean" && p.values.fill(+l);
    for(let f = 0; f < r; f++){
        const m = [];
        let g = 0;
        for(let b = 0; b < i; b++){
            const x = d[f * i + b];
            m.push(x), g += x * a[b];
        }
        if (g < 0 || g >= s / o) throw new Error(`Invalid indices: ${m} does not index into ${e}`);
        for(let b = 0; b < o; b++)c ? p.values[g * o + b] += h[f * o + b] : p.values[g * o + b] = t.rank === 0 ? h[0] : h[f * o + b];
    }
    return p;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const tW = as((n)=>1 / (1 + Math.exp(-n))), yw = Wt(ca, (n)=>1 / (1 + Math.exp(-n))), eW = {
    kernelName: ca,
    backendName: "cpu",
    kernelFunc: yw
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ww(n, t, e, s, o) {
    const r = Hp(s, t, e), i = X(e), a = dt(s);
    if (r) {
        const d = _p(t, a);
        return o === "string" ? n.slice(d, d + i) : n.subarray(d, d + i);
    }
    const l = o === "string" ? ys(n) : n, c = vt(s, o, l), u = vt(e, o);
    for(let d = 0; d < u.size; ++d){
        const h = u.indexToLoc(d), p = h.map((f, m)=>f + t[m]);
        u.set(c.get(...p), ...h);
    }
    return o === "string" ? bx(u.values) : u.values;
}
function Fo(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { begin: r, size: i } = s;
    lt(o, "slice");
    const [a, l] = nu(o, r, i);
    Zp(o, a, l);
    const c = e.data.get(o.dataId).values, u = ww(c, a, l, o.shape, o.dtype);
    return e.makeTensorInfo(l, o.dtype, u);
}
const nW = {
    kernelName: Ac,
    backendName: "cpu",
    kernelFunc: Fo
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Iw(n, t, e, s, o, r, i) {
    const a = t[0], l = r[0], c = new Array(l), u = new Array(a), d = t[1];
    if (l === 0) {
        if (a !== 0) throw new Error(ox(a));
        const g = ne(e, 0), b = ne(o, 0);
        return [
            g,
            [
                0,
                d
            ],
            b,
            c,
            u
        ];
    }
    let h = !0, p = 0;
    const f = new Array(l).fill(0);
    for(let g = 0; g < a; ++g){
        const b = n[g * d];
        if (b < 0) throw new Error(rx(g, b));
        if (b >= l) throw new Error(ix(g, b, l));
        ++f[b], h = h && b >= p, p = b;
    }
    let m = !0;
    for(let g = 0; g < l; ++g){
        const b = f[g] === 0;
        c[g] = b, m = m && !b, f[g] = Math.max(f[g], 1), g > 0 && (f[g] += f[g - 1]);
    }
    if (m && h) {
        const g = n, b = s;
        for(let x = 0; x < a; ++x)u[x] = x;
        return [
            g,
            [
                a,
                d
            ],
            b,
            c,
            u
        ];
    } else {
        const g = f[l - 1], b = ne(e, g * d), x = ne(o, g), w = new Array(l).fill(0);
        for(let y = 0; y < a; ++y){
            const I = n[y * d], v = w[I], k = (I === 0 ? 0 : f[I - 1]) + v;
            w[I]++;
            for(let S = 0; S < d; ++S)b[k * d + S] = n[y * d + S];
            x[k] = s[y], u[y] = k;
        }
        for(let y = 0; y < l; ++y)if (w[y] === 0) {
            const v = y === 0 ? 0 : f[y - 1];
            b[v * d + 0] = y;
            for(let k = 1; k < d; ++k)b[v * d + k] = 0;
            x[v] = i;
        }
        return [
            b,
            [
                g,
                d
            ],
            x,
            c,
            u
        ];
    }
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Cw(n, t, e, s, o) {
    const r = X(s), i = t[0], a = o.length, l = [];
    let c = 1, u = -1;
    for(let g = 0; g < a; ++g){
        const b = o[g];
        if (b === -1) {
            if (u !== -1) throw new Error(ax(u, g));
            u = g, l.push(1);
        } else {
            if (b < 0) throw new Error(lx(g, b));
            c *= b, l.push(b);
        }
    }
    if (u !== -1) {
        if (c <= 0) throw new Error(cx());
        const g = Math.trunc(r / c);
        if (c * g !== r) throw new Error(ux(s, l));
        l[u] = g;
    }
    if (X(l) !== r) throw new Error(dx(s, l));
    const h = s.length, p = [];
    if (h > 0) {
        p[h - 1] = 1;
        for(let g = h - 2; g >= 0; --g)p[g] = p[g + 1] * s[g + 1];
    }
    const f = [];
    if (a > 0) {
        f[a - 1] = 1;
        for(let g = a - 2; g >= 0; --g)f[g] = f[g + 1] * l[g + 1];
    }
    const m = ne(e, i * a);
    for(let g = 0; g < i; ++g){
        let b = 0;
        for(let x = 0; x < h; ++x)b += n[g * h + x] * p[x];
        for(let x = 0; x < a; ++x)m[g * a + x] = Math.trunc(b / f[x]), b %= f[x];
    }
    return [
        m,
        [
            i,
            a
        ],
        l
    ];
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Kf(n, t, e, s, o, r = !1, i = 0) {
    const a = s.length, l = [
        t[0],
        n.length / t[0]
    ], c = l[1], d = a > 0 ? o[a - 1] + 1 : 0;
    if (d < 0) throw new Error(Td());
    const h = t.slice();
    h[0] = d;
    const p = h.reduce((w, y)=>w * y, 1), f = ne(e, p);
    if (a === 0) return d > 0 && f.fill(i), [
        f,
        h
    ];
    if (d <= 0) throw new Error(Td());
    let m = 0, g = 1, b = 0, x = o[m];
    for(;;){
        let w = 0;
        if (g < a) {
            if (w = o[g], x === w) {
                ++g;
                continue;
            }
            if (x >= w) throw new Error(hx());
        }
        if (x < 0 || x >= d) throw new Error(px(x, d));
        x > b && f.fill(i, b * c, x * c);
        for(let y = m; y < g; ++y){
            const I = s[y];
            if (I < 0 || I >= l[0]) throw new Error(fx(y, s[y], l[0]));
            for(let v = 0; v < c; v++)f[x * c + v] += n[I * c + v];
        }
        if (r) for(let y = 0; y < c; y++)f[x * c + y] /= g - m;
        if (m = g, ++g, b = x + 1, x = w, g > a) break;
    }
    return b < d && f.fill(i, b * c, d * c), [
        f,
        h
    ];
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const sW = as((n)=>Math.sqrt(n)), oW = Wt(da, (n)=>Math.sqrt(n)), rW = {
    kernelName: da,
    backendName: "cpu",
    kernelFunc: oW
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const vw = le((n, t)=>{
    const e = n - t;
    return e * e;
}), iW = fe(ha, vw), aW = {
    kernelName: ha,
    backendName: "cpu",
    kernelFunc: iW
};
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Sw = as((n, t)=>{
    const { pattern: e, replaceGlobal: s, rewrite: o } = t;
    return n.replace(new RegExp(e, s ? "g" : ""), o);
}), lW = so(Bc, Sw), cW = {
    kernelName: Bc,
    backendName: "cpu",
    kernelFunc: lW
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function kw(n, t, e, s) {
    const o = vt(n, t.dtype);
    for(let r = 0; r < o.size; r++){
        const i = o.indexToLoc(r), a = new Array(i.length);
        for(let l = 0; l < a.length; l++)a[l] = i[l] * e[l] + s[l];
        o.set(t.get(...a), ...i);
    }
    return o;
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class uW {
    constructor(t, e, s, o, r, i){
        this.separator = ms(t), this.nGramWidths = e, this.leftPad = ms(s), this.rightPad = ms(o), this.padWidth = r, this.preserveShort = i;
    }
    getPadWidth(t) {
        return Math.min(this.padWidth < 0 ? t - 1 : this.padWidth, t - 1);
    }
    getNumNGrams(t, e) {
        const s = this.getPadWidth(e);
        return Math.max(0, t + 2 * s - e + 1);
    }
    createNGrams(t, e, s, o, r, i) {
        for(let a = 0; a < r; ++a){
            const l = this.getPadWidth(i), c = Math.max(0, l - a), u = Math.max(0, l - (r - (a + 1))), d = i - (c + u), h = e + (c > 0 ? 0 : a - l);
            let p = 0;
            p += c * this.leftPad.length;
            for(let x = 0; x < d; ++x)p += t[h + x].length;
            p += u * this.rightPad.length;
            const f = c + u + d - 1;
            p += f * this.separator.length, s[o + a] = new Uint8Array(p);
            const m = s[o + a];
            let g = 0;
            const b = (x)=>x.forEach((w)=>m[g++] = w);
            for(let x = 0; x < c; ++x)b(this.leftPad), b(this.separator);
            for(let x = 0; x < d - 1; ++x)b(t[h + x]), b(this.separator);
            if (d > 0) {
                b(t[h + d - 1]);
                for(let x = 0; x < u; ++x)b(this.separator), b(this.rightPad);
            } else {
                for(let x = 0; x < u - 1; ++x)b(this.rightPad), b(this.separator);
                b(this.rightPad);
            }
        }
    }
    // Data and splits together form the definition of the ragged tensor,
    // where data is 1 dimensional and contains the values of the tensor
    // and splits denotes the indices at which each row starts.
    compute(t, e) {
        const s = t.length, o = e.length;
        if (o > 0) {
            let l = e[0];
            if (l !== 0) throw new Error(`First split value must be 0, got ${l}`);
            for(let c = 1; c < o; ++c){
                let u = e[c] >= l;
                if (u = u && e[c] <= s, !u) throw new Error(`Invalid split value ${e[c]}, must be in [${l}, ${s}]`);
                l = e[c];
            }
            if (l !== s) throw new Error(`Last split value must be data size. Expected ${s}, got ${l}`);
        }
        const r = o - 1, i = ne("int32", o);
        if (s === 0 || o === 0) {
            const l = new Array(s);
            for(let c = 0; c <= r; ++c)i[c] = 0;
            return [
                l,
                i
            ];
        }
        i[0] = 0;
        for(let l = 1; l <= r; ++l){
            const c = e[l] - e[l - 1];
            let u = 0;
            this.nGramWidths.forEach((d)=>{
                u += this.getNumNGrams(c, d);
            }), this.preserveShort && c > 0 && u === 0 && (u = 1), i[l] = i[l - 1] + u;
        }
        const a = new Array(i[r]);
        for(let l = 0; l < r; ++l){
            const c = e[l];
            let u = i[l];
            if (this.nGramWidths.forEach((d)=>{
                const h = e[l + 1] - e[l], p = this.getNumNGrams(h, d);
                this.createNGrams(t, c, a, u, p, d), u += p;
            }), this.preserveShort && u === i[l]) {
                const d = e[l + 1] - e[l];
                if (d === 0) continue;
                const h = d + 2 * this.padWidth;
                this.createNGrams(t, c, a, u, 1, h);
            }
        }
        return [
            a,
            i
        ];
    }
}
function Tw(n, t, e, s, o, r, i, a) {
    return new uW(e, s, o, r, i, a).compute(n, t);
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function dW(n, t, e, s) {
    if (!n.length) return;
    if (t.length === 0) {
        for(let r = 0; r < n.length; ++r)s.push(n.subarray(r, r + 1));
        return;
    }
    if (t.length === 1) {
        const r = t[0];
        let i = n.indexOf(r);
        for(; i !== -1;){
            const a = n.subarray(0, i);
            (!e || a.length !== 0) && s.push(a), n = n.subarray(i + 1), i = n.indexOf(r);
        }
        (!e || n.length !== 0) && s.push(n);
        return;
    }
    let o = 0;
    for(let r = 0; r < n.length + 1; r++)if (r === n.length || t.indexOf(n[r]) !== -1) {
        const i = n.subarray(o, r);
        (!e || i.length !== 0) && s.push(i), o = r + 1;
    }
}
function Nw(n, t, e) {
    const s = n.length, o = [];
    let r = 0, i = 0;
    const a = new Array(s);
    for(let h = 0; h < s; ++h){
        const p = o.length;
        dW(n[h], t, e, o);
        const f = o.length - p;
        a[h] = f, r += f, i = Math.max(i, f);
    }
    const l = ne("int32", r * 2), c = new Array(r), u = [
        s,
        i
    ];
    let d = 0;
    for(let h = 0; h < s; ++h)for(let p = 0; p < a[h]; ++p)l[d * 2] = h, l[d * 2 + 1] = p, c[d] = o[d], ++d;
    return [
        l,
        c,
        u
    ];
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Rw(n, t) {
    const e = ne("int32", n.length);
    for(let s = 0; s < n.length; ++s)e[s] = Lb(n[s]).modulo(t).getLowBitsUnsigned();
    return e;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $w = le((n, t)=>n - t), hW = Pf((n, t, e, s)=>({
        real: n - e,
        imag: t - s
    })), Zf = fe(pa, $w, hW), pW = {
    kernelName: pa,
    backendName: "cpu",
    kernelFunc: Zf
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Gw(n, t) {
    const e = new Array(n.rank);
    for(let o = 0; o < e.length; o++)e[o] = n.shape[o] * t[o];
    const s = vt(e, n.dtype);
    for(let o = 0; o < s.values.length; ++o){
        const r = s.indexToLoc(o), i = new Array(n.rank);
        for(let l = 0; l < i.length; l++)i[l] = r[l] % n.shape[l];
        const a = n.locToIndex(i);
        s.values[o] = n.values[a];
    }
    return s;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Qr = (n, t)=>{
    const e = t.value - n.value;
    return e === 0 ? n.index - t.index : e;
};
function Ew(n, t, e = 0, s = n.length - 1) {
    for(; s > e;){
        if (s - e > 600) {
            const a = s - e + 1, l = t - e + 1, c = Math.log(a), u = 0.5 * Math.exp(2 * c / 3), d = 0.5 * Math.sqrt(c * u * (a - u) / a) * Math.sign(l - a / 2), h = Math.max(e, Math.floor(t - l * u / a + d)), p = Math.min(s, Math.floor(t + (a - l) * u / a + d));
            Ew(n, t, h, p);
        }
        const o = n[t];
        let r = e, i = s;
        for(ds(n, e, t), Qr(n[s], o) > 0 && ds(n, e, s); r < i;){
            for(ds(n, r, i), r++, i--; Qr(n[r], o) < 0;)r = r + 1;
            for(; Qr(n[i], o) > 0;)i = i - 1;
        }
        Qr(n[e], o) === 0 ? ds(n, e, i) : (i = i + 1, ds(n, i, s)), i <= t && (e = i + 1), t <= i && (s = i - 1);
    }
}
function Lw(n, t, e, s, o) {
    const r = t[t.length - 1], [i, a] = [
        n.length / r,
        r
    ], l = Se(e, i * s), c = Se("int32", i * s);
    for(let d = 0; d < i; d++){
        const h = d * a, p = n.subarray(h, h + a);
        let f = new Array(p.length);
        p.forEach((x, w)=>f[w] = {
                value: x,
                index: w
            }), s < f.length && (Ew(f, s), f = f.slice(0, s)), o && f.sort(Qr);
        const m = d * s, g = l.subarray(m, m + s), b = c.subarray(m, m + s);
        for(let x = 0; x < s; x++)g[x] = f[x].value, b[x] = f[x].index;
    }
    const u = t.slice();
    return u[u.length - 1] = s, [
        vt(u, e, l),
        vt(u, "int32", c)
    ];
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Mw(n, t, e, s) {
    const o = Ct(t, e)[0], r = [
        1,
        e[0],
        1
    ];
    for(let f = 0; f < o; f++)r[0] *= e[f];
    r[1] = e[o];
    for(let f = o + 1; f < e.length; f++)r[2] *= e[f];
    const i = /* @__PURE__ */ new Map(), a = new Int32Array(e[o]), l = new ve(r, s, n), c = [], u = r[0] === 1 && r[2] === 1;
    for(let f = 0; f < e[o]; f++){
        let m;
        if (u) m = n[f].toString();
        else {
            const b = [];
            for(let x = 0; x < r[0]; x++)for(let w = 0; w < r[2]; w++)b.push(l.get(x, f, w));
            m = b.join(",");
        }
        const g = i.get(m);
        if (g != null) a[f] = g;
        else {
            const b = i.size;
            i.set(m, b), a[f] = b, c.push(f);
        }
    }
    const d = r.slice();
    d[1] = i.size;
    const h = new ve(d, s);
    c.forEach((f, m)=>{
        for(let g = 0; g < r[0]; g++)for(let b = 0; b < r[2]; b++)h.set(l.get(g, f, b), g, m, b);
    });
    const p = e.slice();
    return p[o] = d[1], {
        outputValues: h.values,
        outputShape: p,
        indices: a
    };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const fW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    addImpl: X1,
    bincountImpl: Af,
    bincountReduceImpl: K1,
    bitwiseAndImpl: Z1,
    castImpl: O1,
    ceilImpl: B1,
    concatImpl: H1,
    equalImpl: _1,
    expImpl: Y1,
    expm1Impl: J1,
    floorDivImpl: q1,
    floorImpl: j1,
    gatherNdImpl: tw,
    gatherV2Impl: ew,
    greaterEqualImpl: sw,
    greaterImpl: nw,
    lessEqualImpl: rw,
    lessImpl: ow,
    linSpaceImpl: iw,
    logImpl: aw,
    maxImpl: lw,
    maximumImpl: cw,
    minimumImpl: uw,
    multiplyImpl: Of,
    negImpl: dw,
    notEqualImpl: hw,
    prodImpl: pw,
    raggedGatherImpl: fw,
    raggedRangeImpl: mw,
    raggedTensorToTensorImpl: gw,
    rangeImpl: bw,
    rsqrtImpl: xw,
    scatterImpl: bo,
    sigmoidImpl: tW,
    simpleAbsImpl: A1,
    sliceImpl: ww,
    sparseFillEmptyRowsImpl: Iw,
    sparseReshapeImpl: Cw,
    sparseSegmentReductionImpl: Kf,
    sqrtImpl: sW,
    squaredDifferenceImpl: vw,
    staticRegexReplaceImpl: Sw,
    stridedSliceImpl: kw,
    stringNGramsImpl: Tw,
    stringSplitImpl: Nw,
    stringToHashBucketFastImpl: Rw,
    subImpl: $w,
    tileImpl: Gw,
    topKImpl: Lw,
    transposeImpl: Xf,
    uniqueImpl: Mw
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ Pb("cpu", ()=>new yu(), 1);
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Ww = Wt(Fi, (n)=>n >= 0 ? n : Math.exp(n) - 1), mW = {
    kernelName: Fi,
    backendName: "cpu",
    kernelFunc: Ww
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Dw(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { alpha: r } = s;
    lt([
        o
    ], "leakyRelu");
    const i = X(o.shape), a = e.data.get(o.dataId).values, l = Se("float32", i);
    for(let c = 0; c < a.length; c++)l[c] = a[c] < 0 ? r * a[c] : a[c];
    return e.makeTensorInfo(o.shape, "float32", l);
}
const gW = {
    kernelName: fc,
    backendName: "cpu",
    kernelFunc: Dw
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const bW = le((n, t)=>n < 0 ? t * n : n);
function Fw(n) {
    const { inputs: t, backend: e } = n, { x: s, alpha: o } = t;
    lt([
        s,
        o
    ], "prelu");
    const r = e.data.get(s.dataId).values, i = e.data.get(o.dataId).values, [a, l] = bW(s.shape, o.shape, r, i, "float32");
    return e.makeTensorInfo(l, "float32", a);
}
const xW = {
    kernelName: Mc,
    backendName: "cpu",
    kernelFunc: Fw
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Vw = Wt(ea, (n)=>Math.max(0, n)), yW = {
    kernelName: ea,
    backendName: "cpu",
    kernelFunc: Vw
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const zw = Wt(na, (n)=>Math.min(Math.max(0, n), 6)), wW = {
    kernelName: na,
    backendName: "cpu",
    kernelFunc: zw
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function zl(n, t, e, s, o) {
    if (e === "linear") return rs({
        inputs: {
            x: t
        },
        backend: n
    });
    if (e === "relu") return Vw({
        inputs: {
            x: t
        },
        backend: n
    });
    if (e === "elu") return Ww({
        inputs: {
            x: t
        },
        backend: n
    });
    if (e === "relu6") return zw({
        inputs: {
            x: t
        },
        backend: n
    });
    if (e === "prelu") return Fw({
        inputs: {
            x: t,
            alpha: s
        },
        backend: n
    });
    if (e === "leakyrelu") return Dw({
        inputs: {
            x: t
        },
        backend: n,
        attrs: {
            alpha: o
        }
    });
    if (e === "sigmoid") return yw({
        inputs: {
            x: t
        },
        backend: n
    });
    throw new Error(`Activation ${e} has not been implemented for the CPU backend.`);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Zt(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { shape: r } = s, i = X(o.shape), a = Yd(r, i), l = X(a);
    C(i === l, ()=>`The new shape (${a}) has ${l} elements and the old shape (${o.shape}) has ${i} elements. The new shape and old shape must have the same number of elements.`), e.incRef(o.dataId);
    const c = e.data.get(o.dataId);
    if (c.complexTensorInfos != null) {
        const u = c.complexTensorInfos.real, d = c.complexTensorInfos.imag;
        u.shape = a, d.shape = a;
    }
    return {
        dataId: o.dataId,
        shape: a,
        dtype: o.dtype
    };
}
const IW = {
    kernelName: Dc,
    backendName: "cpu",
    kernelFunc: Zt
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Pw(n) {
    const { inputs: t, backend: e, attrs: s } = n, { a: o, b: r } = t, { transposeA: i, transposeB: a } = s;
    lt([
        o,
        r
    ], "matMul");
    const l = o.shape.length, c = r.shape.length, u = i ? o.shape[l - 2] : o.shape[l - 1], d = a ? r.shape[c - 1] : r.shape[c - 2], h = i ? o.shape[l - 1] : o.shape[l - 2], p = a ? r.shape[c - 2] : r.shape[c - 1], f = o.shape.slice(0, -2), m = r.shape.slice(0, -2), g = X(f), b = X(m), w = bt(o.shape.slice(0, -2), r.shape.slice(0, -2)).concat([
        h,
        p
    ]);
    C(u === d, ()=>`Error in matMul: inner shapes (${u}) and (${d}) of Tensors with shapes ${o.shape} and ${r.shape} and transposeA=${i} and transposeB=${a} must match.`);
    const y = i ? [
        g,
        u,
        h
    ] : [
        g,
        h,
        u
    ], I = a ? [
        b,
        p,
        d
    ] : [
        b,
        d,
        p
    ], v = Zt({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            shape: y
        }
    }), k = Zt({
        inputs: {
            x: r
        },
        backend: e,
        attrs: {
            shape: I
        }
    }), S = i ? v.shape[1] : v.shape[2], N = i ? v.shape[2] : v.shape[1], R = a ? k.shape[1] : k.shape[2], M = Math.max(g, b), V = e.data.get(v.dataId).values, z = e.data.get(k.dataId).values, P = dt(v.shape), A = dt(k.shape), [O, B, Z] = i ? [
        P[0],
        1,
        P[1]
    ] : [
        P[0],
        P[1],
        1
    ], [H, Y, Q] = a ? [
        1,
        A[1],
        A[0]
    ] : [
        A[1],
        1,
        A[0]
    ], j = N * R, J = vt([
        M,
        N,
        R
    ], v.dtype), ot = J.values, q = e.blockSize;
    for(let rt = 0; rt < M; rt++){
        const ht = rt % g, ft = rt % b;
        for(let pt = 0; pt < N; pt += q){
            const wt = Math.min(pt + q, N);
            for(let It = 0; It < R; It += q){
                const Et = Math.min(It + q, R);
                for(let Pt = 0; Pt < S; Pt += q){
                    const te = Math.min(Pt + q, S);
                    for(let At = pt; At < wt; At++)for(let Dt = It; Dt < Et; Dt++){
                        let Jt = 0;
                        for(let _t = Pt; _t < te; _t++){
                            const ls = // tslint:disable-next-line: max-line-length
                            V[ht * O + At * B + _t * Z], we = // tslint:disable-next-line: max-line-length
                            z[_t * H + Dt * Y + ft * Q];
                            Jt += ls * we;
                        }
                        ot[rt * j + (At * R + Dt)] += Jt;
                    }
                }
            }
        }
    }
    return e.disposeIntermediateTensorInfo(v), e.disposeIntermediateTensorInfo(k), e.makeTensorInfo(w, J.dtype, J.values);
}
const CW = {
    kernelName: ql,
    backendName: "cpu",
    kernelFunc: Pw
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function vW(n) {
    const { inputs: t, backend: e, attrs: s } = n, { a: o, b: r, bias: i, preluActivationWeights: a } = t, { transposeA: l, transposeB: c, activation: u, leakyreluAlpha: d } = s;
    let h, p, f;
    const m = [];
    h = Pw({
        inputs: {
            a: o,
            b: r
        },
        attrs: {
            transposeA: l,
            transposeB: c
        },
        backend: e
    }), i && (p = wr({
        inputs: {
            a: h,
            b: i
        },
        backend: e
    }), m.push(h), h = p), u && (f = zl(e, h, u, a, d), m.push(h), h = f);
    for (const b of m)e.disposeIntermediateTensorInfo(b);
    return h;
}
const SW = {
    kernelName: ml,
    backendName: "cpu",
    kernelFunc: vW
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const kW = Wt(vi, (n)=>Math.acos(n)), TW = {
    kernelName: vi,
    backendName: "cpu",
    kernelFunc: kW
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const NW = Wt(Si, (n)=>Math.acosh(n)), RW = {
    kernelName: Si,
    backendName: "cpu",
    kernelFunc: NW
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $W(n) {
    const { inputs: t, backend: e } = n, s = t;
    lt(t, "addN");
    const o = s.map((a)=>e.data.get(a.dataId).values), r = vt(s[0].shape, s[0].dtype), i = r.values;
    for(let a = 0; a < s.length; a++){
        const l = o[a];
        for(let c = 0; c < i.length; c++)i[c] += l[c];
    }
    return e.makeTensorInfo(r.shape, r.dtype, r.values);
}
const GW = {
    kernelName: qd,
    backendName: "cpu",
    kernelFunc: $W
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function EW(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r, keepDims: i } = s;
    lt(o, "all");
    const a = Ct(r, o.shape);
    let l = a;
    const c = qt(l, o.shape.length);
    let u = o;
    c != null && (u = _e({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            perm: c
        }
    }), l = ie(l.length, o.shape.length)), Ne("all", l, u.shape.length);
    const [d, h] = ye(u.shape, l), p = X(h), f = ke(X(d), u.dtype), m = e.data.get(u.dataId).values;
    for(let b = 0; b < f.length; ++b){
        const x = b * p;
        let w = m[x];
        for(let y = 0; y < p; ++y){
            const I = m[x + y];
            w = w && I;
        }
        f[b] = w;
    }
    c != null && e.disposeIntermediateTensorInfo(u);
    const g = e.makeTensorInfo(d, u.dtype, f);
    if (i) {
        const b = re(d, a), x = Zt({
            inputs: {
                x: g
            },
            backend: e,
            attrs: {
                shape: b
            }
        });
        return e.disposeIntermediateTensorInfo(g), x;
    }
    return g;
}
const LW = {
    kernelName: th,
    backendName: "cpu",
    kernelFunc: EW
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function MW(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r, keepDims: i } = s;
    lt(o, "any");
    const a = Ct(r, o.shape);
    let l = a;
    const c = qt(l, o.shape.length);
    let u = o;
    c != null && (u = _e({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            perm: c
        }
    }), l = ie(l.length, o.shape.length)), Ne("any", l, u.shape.length);
    const [d, h] = ye(u.shape, l), p = X(h), f = ke(X(d), u.dtype), m = e.data.get(u.dataId).values;
    for(let b = 0; b < f.length; ++b){
        const x = b * p;
        let w = m[x];
        for(let y = 0; y < p; ++y){
            const I = m[x + y];
            w = w || I;
        }
        f[b] = w;
    }
    c != null && e.disposeIntermediateTensorInfo(u);
    const g = e.makeTensorInfo(d, u.dtype, f);
    if (i) {
        const b = re(d, a), x = Zt({
            inputs: {
                x: g
            },
            backend: e,
            attrs: {
                shape: b
            }
        });
        return e.disposeIntermediateTensorInfo(g), x;
    }
    return g;
}
const WW = {
    kernelName: eh,
    backendName: "cpu",
    kernelFunc: MW
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function DW(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r } = s;
    lt(o, "argMax");
    let i = Ct(r, o.shape);
    const a = qt(i, o.shape.length);
    let l = o;
    const c = [];
    a != null && (l = _e({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            perm: a
        }
    }), c.push(l), i = ie(i.length, l.shape.length)), i = [
        i[0]
    ], Ne("argMax", i, l.shape.length);
    const [u, d] = ye(l.shape, i), h = X(u), p = ke(h, "int32"), f = X(d), m = e.data.get(l.dataId).values;
    for(let g = 0; g < p.length; ++g){
        const b = g * f;
        let x = m[b], w = 0;
        for(let y = 0; y < f; ++y){
            const I = m[b + y];
            I > x && (x = I, w = y);
        }
        p[g] = w;
    }
    return c.forEach((g)=>e.disposeIntermediateTensorInfo(g)), e.makeTensorInfo(u, "int32", p);
}
const FW = {
    kernelName: Yl,
    backendName: "cpu",
    kernelFunc: DW
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function VW(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r } = s;
    lt(o, "argMin");
    let i = Ct(r, o.shape);
    const a = qt(i, o.shape.length);
    let l = o;
    const c = [];
    a != null && (l = _e({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            perm: a
        }
    }), c.push(l), i = ie(i.length, l.shape.length)), i = [
        i[0]
    ], Ne("argMin", i, l.shape.length);
    const [u, d] = ye(l.shape, i), h = X(u), p = ke(h, "int32"), f = X(d), m = e.data.get(l.dataId).values;
    for(let g = 0; g < p.length; ++g){
        const b = g * f;
        let x = m[b], w = 0;
        for(let y = 0; y < f; ++y){
            const I = m[b + y];
            I < x && (x = I, w = y);
        }
        p[g] = w;
    }
    return c.forEach((g)=>e.disposeIntermediateTensorInfo(g)), e.makeTensorInfo(u, "int32", p);
}
const zW = {
    kernelName: Ql,
    backendName: "cpu",
    kernelFunc: VW
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const PW = Wt(ki, (n)=>Math.asin(n)), AW = {
    kernelName: ki,
    backendName: "cpu",
    kernelFunc: PW
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const OW = Wt(Ti, (n)=>Math.asinh(n)), XW = {
    kernelName: Ti,
    backendName: "cpu",
    kernelFunc: OW
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const KW = Wt(Ni, (n)=>Math.atan(n)), ZW = {
    kernelName: Ni,
    backendName: "cpu",
    kernelFunc: KW
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const BW = le((n, t)=>Math.atan2(n, t)), HW = fe($i, BW), _W = {
    kernelName: $i,
    backendName: "cpu",
    kernelFunc: HW
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const UW = Wt(Ri, (n)=>Math.atanh(n)), YW = {
    kernelName: Ri,
    backendName: "cpu",
    kernelFunc: UW
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Bf(n, t, e, s, o, r) {
    const i = o.strideHeight, a = o.strideWidth, l = o.dilationHeight, c = o.dilationWidth, u = o.effectiveFilterHeight, d = o.effectiveFilterWidth, h = o.padInfo.top, p = o.padInfo.left, f = r === "max" ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY, m = vt(o.outShape, e), g = m.values, b = o.outShape[1] * o.outShape[2] * o.outShape[3], x = o.outShape[2] * o.outShape[3], w = o.outShape[3];
    for(let y = 0; y < o.batchSize; ++y){
        const I = y * b, v = y * s[0];
        for(let k = 0; k < o.inChannels; ++k)for(let S = 0; S < o.outHeight; ++S){
            const N = S * i - h, R = Math.max(0, N), M = Math.min(o.inHeight, u + N), V = I + S * x;
            for(let z = 0; z < o.outWidth; ++z){
                const P = z * a - p, A = Math.max(0, P), O = Math.min(o.inWidth, d + P);
                let B = f, Z = 0, H = 0;
                for(let Q = R; Q < M; Q += l){
                    const j = v + Q * s[1];
                    for(let J = A; J < O; J += c){
                        const ot = j + J * s[2], q = n[ot + k];
                        r === "max" && q > B ? B = q : r === "avg" && (Z += q, H++);
                    }
                    if (isNaN(B)) break;
                }
                const Y = V + z * w + k;
                g[Y] = r === "avg" ? Z / H : B;
            }
        }
    }
    return m;
}
function Aw(n, t, e, s, o = !1, r = !1) {
    const i = vt(s.outShape, "int32"), a = s.strideHeight, l = s.strideWidth, c = s.dilationHeight, u = s.dilationWidth, d = s.effectiveFilterHeight, h = s.effectiveFilterWidth, p = s.padInfo.top, f = s.padInfo.left, m = vt(t, e, n);
    for(let g = 0; g < s.batchSize; ++g)for(let b = 0; b < s.inChannels; ++b)for(let x = 0; x < s.outHeight; ++x){
        const w = x * a - p;
        let y = w;
        for(; y < 0;)y += c;
        const I = Math.min(s.inHeight, d + w);
        for(let v = 0; v < s.outWidth; ++v){
            const k = v * l - f;
            let S = k;
            for(; S < 0;)S += u;
            const N = Math.min(s.inWidth, h + k);
            let R = Number.NEGATIVE_INFINITY, M = -1;
            for(let V = y; V < I; V += c){
                const z = V - w;
                for(let P = S; P < N; P += u){
                    const A = P - k, O = m.get(g, V, P, b);
                    O > R && (R = O, o ? M = r ? ((g * s.inHeight + V) * s.inWidth + P) * s.inChannels + b : (V * s.inWidth + P) * s.inChannels + b : M = z * h + A);
                }
            }
            i.set(M, g, x, v, b);
        }
    }
    return i;
}
function Ow(n, t, e, s, o, r) {
    const i = o.strideDepth, a = o.strideHeight, l = o.strideWidth, c = o.dilationDepth, u = o.dilationHeight, d = o.dilationWidth, h = o.effectiveFilterDepth, p = o.effectiveFilterHeight, f = o.effectiveFilterWidth, m = o.padInfo.front, g = o.padInfo.top, b = o.padInfo.left, x = r === "max" ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY, w = vt(o.outShape, e), y = w.values, I = o.outShape[1] * o.outShape[2] * o.outShape[3] * o.outShape[4], v = o.outShape[2] * o.outShape[3] * o.outShape[4], k = o.outShape[3] * o.outShape[4], S = o.outShape[4];
    for(let N = 0; N < o.batchSize; ++N){
        const R = N * I, M = N * s[0];
        for(let V = 0; V < o.inChannels; ++V)for(let z = 0; z < o.outDepth; ++z){
            const P = z * i - m;
            let A = P;
            for(; A < 0;)A += c;
            const O = Math.min(o.inDepth, h + P), B = R + z * v;
            for(let Z = 0; Z < o.outHeight; ++Z){
                const H = Z * a - g;
                let Y = H;
                for(; Y < 0;)Y += u;
                const Q = Math.min(o.inHeight, p + H), j = B + Z * k;
                for(let J = 0; J < o.outWidth; ++J){
                    const ot = J * l - b;
                    let q = ot;
                    for(; q < 0;)q += d;
                    const rt = Math.min(o.inWidth, f + ot), ht = j + J * S;
                    let ft = x, pt = 0, wt = 0;
                    for(let Et = A; Et < O; Et += c){
                        const Pt = M + Et * s[1];
                        for(let te = Y; te < Q; te += u){
                            const At = Pt + te * s[2];
                            for(let Dt = q; Dt < rt; Dt += d){
                                const Jt = At + Dt * s[3], _t = n[Jt + V];
                                if (r === "max" && _t > ft ? ft = _t : r === "avg" && (pt += _t, wt++), isNaN(ft)) break;
                            }
                            if (isNaN(ft)) break;
                        }
                        if (isNaN(ft)) break;
                    }
                    const It = ht + V;
                    y[It] = r === "avg" ? pt / Math.max(wt, 1) : ft;
                }
            }
        }
    }
    return w;
}
function QW(n, t) {
    const e = vt(t.outShape, "int32"), s = t.strideDepth, o = t.strideHeight, r = t.strideWidth, i = t.dilationDepth, a = t.dilationHeight, l = t.dilationWidth, c = t.effectiveFilterDepth, u = t.effectiveFilterHeight, d = t.effectiveFilterWidth, h = t.padInfo.front, p = t.padInfo.top, f = t.padInfo.left;
    for(let m = 0; m < t.batchSize; ++m)for(let g = 0; g < t.inChannels; ++g)for(let b = 0; b < t.outDepth; ++b){
        const x = b * s - h;
        let w = x;
        for(; w < 0;)w += i;
        const y = Math.min(t.inDepth, c + x);
        for(let I = 0; I < t.outHeight; ++I){
            const v = I * o - p;
            let k = v;
            for(; k < 0;)k += a;
            const S = Math.min(t.inHeight, u + v);
            for(let N = 0; N < t.outWidth; ++N){
                const R = N * r - f;
                let M = R;
                for(; M < 0;)M += l;
                const V = Math.min(t.inWidth, d + R);
                let z = Number.NEGATIVE_INFINITY, P = -1;
                for(let A = w; A < y; A += i){
                    const O = A - x;
                    for(let B = k; B < S; B += a){
                        const Z = B - v;
                        for(let H = M; H < V; H += l){
                            const Y = H - R, Q = n.get(m, A, B, H, g);
                            Q >= z && (z = Q, P = O * u * d + Z * u + Y);
                        }
                    }
                }
                e.set(P, m, b, I, N, g);
            }
        }
    }
    return e;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function JW(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t;
    lt(o, "avgPool");
    const { filterSize: r, strides: i, pad: a, dimRoundingMode: l } = s, c = 1;
    C(Le(i, c), ()=>`Error in avgPool: Either strides or dilations must be 1. Got strides ${i} and dilations '${c}'`);
    const u = $n(o.shape, r, i, c, a, l);
    let d;
    if (u.filterWidth === 1 && u.filterHeight === 1 && $t(u.inShape, u.outShape)) d = rs({
        inputs: {
            x: o
        },
        backend: e
    });
    else {
        const h = e.data.get(o.dataId).values, p = dt(o.shape), f = Bf(h, o.shape, o.dtype, p, u, "avg");
        d = e.makeTensorInfo(u.outShape, o.dtype, f.values);
    }
    return d;
}
const jW = {
    kernelName: Jl,
    backendName: "cpu",
    kernelFunc: JW
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function qW(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { filterSize: r, strides: i, pad: a, dimRoundingMode: l, dataFormat: c } = s;
    lt(o, "avgPool3d");
    const u = vs(o.shape, r, i, 1, a, l, c), d = e.data.get(o.dataId).values, h = Ow(d, o.shape, o.dtype, dt(o.shape), u, "avg");
    return e.makeTensorInfo(h.shape, "float32", h.values);
}
const tD = {
    kernelName: jl,
    backendName: "cpu",
    kernelFunc: qW
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function eD(n) {
    const { inputs: t, backend: e, attrs: s } = n, { dy: o, input: r } = t, { filterSize: i, strides: a, pad: l, dimRoundingMode: c } = s;
    lt([
        o,
        r
    ], "avgPool3DGrad");
    const u = vs(r.shape, i, a, 1, l, c), d = u.strideDepth, h = u.strideHeight, p = u.strideWidth, f = u.filterDepth, m = u.filterHeight, g = u.filterWidth, b = u.dilationDepth, x = u.dilationHeight, w = u.dilationWidth, y = u.effectiveFilterDepth, I = u.effectiveFilterHeight, v = u.effectiveFilterWidth, k = y - 1 - u.padInfo.front, S = v - 1 - u.padInfo.left, N = I - 1 - u.padInfo.top, R = vt(r.shape, "float32"), M = 1 / (f * m * g), V = e.bufferSync(o);
    for(let z = 0; z < u.batchSize; ++z)for(let P = 0; P < u.inChannels; ++P)for(let A = 0; A < u.inDepth; ++A)for(let O = 0; O < u.inHeight; ++O)for(let B = 0; B < u.inWidth; ++B){
        const Z = A - k, H = O - N, Y = B - S;
        let Q = 0;
        for(let j = 0; j < y; j += b){
            const J = (Z + j) / d;
            if (!(J < 0 || J >= u.outDepth || Math.floor(J) !== J)) for(let ot = 0; ot < I; ot += x){
                const q = (H + ot) / h;
                if (!(q < 0 || q >= u.outHeight || Math.floor(q) !== q)) for(let rt = 0; rt < v; rt += w){
                    const ht = (Y + rt) / p;
                    if (ht < 0 || ht >= u.outWidth || Math.floor(ht) !== ht) continue;
                    const ft = V.get(z, J, q, ht, P);
                    Q += ft;
                }
            }
        }
        R.set(Q * M, z, A, O, B, P);
    }
    return e.makeTensorInfo(R.shape, R.dtype, R.values);
}
const nD = {
    kernelName: sh,
    backendName: "cpu",
    kernelFunc: eD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function sD(n) {
    const { inputs: t, backend: e, attrs: s } = n, { dy: o, input: r } = t, i = r;
    lt([
        o,
        r
    ], "avgPoolGrad");
    const { filterSize: a, strides: l, pad: c } = s, u = $n(i.shape, a, l, 1, c), d = u.strideHeight, h = u.strideWidth, p = u.filterHeight, f = u.filterWidth, m = u.dilationHeight, g = u.dilationWidth, b = u.effectiveFilterHeight, x = u.effectiveFilterWidth, w = x - 1 - u.padInfo.left, y = b - 1 - u.padInfo.top, I = vt(i.shape, "float32"), v = 1 / (p * f), k = e.data.get(o.dataId).values, S = vt(o.shape, "float32", k);
    for(let N = 0; N < u.batchSize; ++N)for(let R = 0; R < u.inChannels; ++R)for(let M = 0; M < u.inHeight; ++M)for(let V = 0; V < u.inWidth; ++V){
        const z = M - y, P = V - w;
        let A = 0;
        for(let O = 0; O < b; O += m){
            const B = (z + O) / d;
            if (!(B < 0 || B >= u.outHeight || Math.floor(B) !== B)) for(let Z = 0; Z < x; Z += g){
                const H = (P + Z) / h;
                if (H < 0 || H >= u.outWidth || Math.floor(H) !== H) continue;
                const Y = S.get(N, B, H, R);
                A += Y;
            }
        }
        I.set(A * v, N, M, V, R);
    }
    return e.makeTensorInfo(I.shape, I.dtype, I.values);
}
const oD = {
    kernelName: nh,
    backendName: "cpu",
    kernelFunc: sD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function rD(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, scale: r, offset: i, mean: a, variance: l } = t;
    C(a.shape.length === l.shape.length, ()=>"Batch normalization gradient requires mean and variance to have equal ranks."), C(i == null || a.shape.length === i.shape.length, ()=>"Batch normalization gradient requires mean and offset to have equal ranks."), C(r == null || a.shape.length === r.shape.length, ()=>"Batch normalization gradient requires mean and scale to have equal ranks."), lt([
        o,
        a,
        l,
        r,
        i
    ], "batchNorm");
    let { varianceEpsilon: c } = s;
    c == null && (c = 1e-3);
    const u = e.data.get(o.dataId).values, d = e.data.get(a.dataId).values, h = e.data.get(l.dataId).values, p = r ? e.data.get(r.dataId).values : new Float32Array([
        1
    ]), f = i ? e.data.get(i.dataId).values : new Float32Array([
        0
    ]), m = new Float32Array(u.length), g = f.length, b = p.length, x = h.length, w = d.length;
    let y = 0, I = 0, v = 0, k = 0;
    for(let S = 0; S < u.length; ++S)m[S] = f[y++] + (u[S] - d[I++]) * p[v++] / Math.sqrt(h[k++] + c), y >= g && (y = 0), I >= w && (I = 0), v >= b && (v = 0), k >= x && (k = 0);
    return e.makeTensorInfo(o.shape, o.dtype, m);
}
const iD = {
    kernelName: dc,
    backendName: "cpu",
    kernelFunc: rD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function aD(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { blockShape: r, crops: i } = s;
    lt([
        o
    ], "batchToSpaceND");
    const a = r.reduce((b, x)=>b * x), l = Na(o.shape, r, a), c = Ra(l.length, r.length), u = $a(o.shape, r, a), d = jp(i, r.length), h = qp(u, i, r.length), p = Zt({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            shape: l
        }
    }), f = _e({
        inputs: {
            x: p
        },
        backend: e,
        attrs: {
            perm: c
        }
    }), m = Zt({
        inputs: {
            x: f
        },
        backend: e,
        attrs: {
            shape: u
        }
    }), g = Fo({
        inputs: {
            x: m
        },
        backend: e,
        attrs: {
            begin: d,
            size: h
        }
    });
    return e.disposeIntermediateTensorInfo(p), e.disposeIntermediateTensorInfo(f), e.disposeIntermediateTensorInfo(m), g;
}
const lD = {
    kernelName: tc,
    backendName: "cpu",
    kernelFunc: aD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function cD(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, weights: r } = t, { size: i } = s, a = e.data.get(o.dataId).values, l = e.data.get(r.dataId).values, c = Af(a, l, r.dtype, r.shape, i);
    return e.makeTensorInfo([
        i
    ], r.dtype, c);
}
const uD = {
    kernelName: oh,
    backendName: "cpu",
    kernelFunc: cD
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function dD(n) {
    const { inputs: t, backend: e } = n, { s0: s, s1: o } = t, r = e.data.get(s.dataId).values, i = e.data.get(o.dataId).values, a = bt(Array.from(r), Array.from(i));
    return e.makeTensorInfo([
        a.length
    ], "int32", Int32Array.from(a));
}
const hD = {
    kernelName: cb,
    backendName: "cpu",
    kernelFunc: dD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const pD = Wt(Li, (n, t)=>{
    const e = t;
    return n > e.clipValueMax ? e.clipValueMax : n < e.clipValueMin ? e.clipValueMin : n;
}), fD = {
    kernelName: Li,
    backendName: "cpu",
    kernelFunc: pD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const mD = (n)=>{
    const { x: t } = n.inputs, e = n.backend, s = new Float32Array(X(t.shape)), o = e.data.get(t.dataId), r = o.complexTensorInfos.real, i = o.complexTensorInfos.imag, a = e.data.get(r.dataId).values, l = e.data.get(i.dataId).values;
    for(let c = 0; c < a.length; c++){
        const u = a[c], d = l[c];
        s[c] = Math.hypot(u, d);
    }
    return e.makeOutput(s, t.shape, "float32");
}, gD = {
    kernelName: ec,
    backendName: "cpu",
    kernelFunc: mD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Ir(n) {
    const { inputs: t, backend: e } = n, { input: s } = t, o = e.data.get(s.dataId).complexTensorInfos.imag, r = e.data.get(o.dataId).values;
    return e.makeTensorInfo(o.shape, o.dtype, r);
}
const bD = {
    kernelName: vh,
    backendName: "cpu",
    kernelFunc: Ir
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Cr(n) {
    const { inputs: t, backend: e, attrs: s } = n, { axis: o } = s, r = Ct(o, t[0].shape)[0], i = t.map((m)=>m.shape);
    Yp(i, r);
    let a = ts(t.map((m)=>m.shape), r);
    if (X(a) === 0) return e.makeTensorInfo(a, t[0].dtype, []);
    const l = t.filter((m)=>X(m.shape) > 0);
    if (l.length === 1) return rs({
        inputs: {
            x: l[0]
        },
        backend: e
    });
    if (l[0].dtype === "complex64") {
        const m = l.map((y)=>Do({
                inputs: {
                    input: y
                },
                backend: e
            })), g = l.map((y)=>Ir({
                inputs: {
                    input: y
                },
                backend: e
            })), b = Cr({
            inputs: m,
            backend: e,
            attrs: {
                axis: r
            }
        }), x = Cr({
            inputs: g,
            backend: e,
            attrs: {
                axis: r
            }
        }), w = Je({
            inputs: {
                real: b,
                imag: x
            },
            backend: e
        });
        return m.forEach((y)=>e.disposeIntermediateTensorInfo(y)), g.forEach((y)=>e.disposeIntermediateTensorInfo(y)), e.disposeIntermediateTensorInfo(b), e.disposeIntermediateTensorInfo(x), w;
    }
    const c = l.map((m)=>{
        const b = [
            -1,
            X(m.shape.slice(r))
        ];
        return Zt({
            inputs: {
                x: m
            },
            backend: e,
            attrs: {
                shape: b
            }
        });
    }), u = c.map((m)=>({
            vals: e.data.get(m.dataId).values,
            shape: m.shape
        }));
    a = ts(c.map((m)=>m.shape), 1);
    const d = c[0].shape[0] === 1, h = H1(u, a, t[0].dtype, d), p = ts(l.map((m)=>m.shape), r), f = e.makeTensorInfo(p, t[0].dtype, h);
    return c.forEach((m)=>e.disposeIntermediateTensorInfo(m)), f;
}
const xD = {
    kernelName: nc,
    backendName: "cpu",
    kernelFunc: Cr
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Xw(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, filter: r } = t, { strides: i, pad: a, dataFormat: l, dilations: c, dimRoundingMode: u } = s;
    lt([
        o,
        r
    ], "conv2d");
    const d = Ss(l), h = Te(o.shape, r.shape, i, c, a, u, !1, d), p = h.filterHeight, f = h.filterWidth, m = h.dilationHeight, g = h.dilationWidth, b = h.padInfo.left, x = h.padInfo.top, w = h.dataFormat === "channelsLast", y = new ve(h.outShape, o.dtype), I = dt(o.shape), v = dt(r.shape), k = I[0], S = w ? I[1] : I[2], N = w ? I[2] : 1, R = w ? 1 : I[1], M = y.strides[0], V = w ? y.strides[1] : y.strides[2], z = w ? y.strides[2] : 1, P = w ? 1 : y.strides[1], A = e.data.get(o.dataId).values, O = e.data.get(r.dataId).values, B = y.values;
    for(let Z = 0; Z < h.batchSize; ++Z){
        const H = Z * k, Y = Z * M;
        for(let Q = 0; Q < h.outHeight; ++Q){
            const j = Y + Q * V, J = Q * h.strideHeight - x;
            for(let ot = 0; ot < p; ++ot){
                const q = J + ot * m;
                if (q < 0 || q >= h.inHeight) continue;
                const rt = ot * v[0], ht = H + q * S;
                for(let ft = 0; ft < h.outWidth; ++ft){
                    const pt = j + ft * z, wt = ft * h.strideWidth - b;
                    for(let It = 0; It < f; ++It){
                        const Et = wt + It * g;
                        if (Et < 0 || Et >= h.inWidth) continue;
                        const Pt = rt + It * v[1], te = ht + Et * N;
                        let At = Pt;
                        for(let Dt = 0; Dt < h.inChannels; ++Dt){
                            const Jt = A[te + Dt * R];
                            for(let _t = 0; _t < h.outChannels; ++_t)B[pt + _t * P] += Jt * O[At + _t];
                            At += h.outChannels;
                        }
                    }
                }
            }
        }
    }
    return e.makeTensorInfo(y.shape, y.dtype, B);
}
const yD = {
    kernelName: sc,
    backendName: "cpu",
    kernelFunc: Xw
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function wD(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, dy: r } = t, { strides: i, pad: a, dataFormat: l, dimRoundingMode: c, filterShape: u } = s;
    lt([
        o,
        r
    ], "conv2dBackpropFilter");
    const d = Ss(l), h = Te(o.shape, u, i, 1, a, c, !1, d), { strideHeight: p, strideWidth: f, filterHeight: m, filterWidth: g } = h, b = h.dataFormat === "channelsLast", x = new ve(h.filterShape, "float32"), w = h.padInfo.left, y = h.padInfo.top, I = e.data.get(o.dataId).values, v = e.data.get(r.dataId).values, k = new ve(o.shape, o.dtype, I), S = new ve(r.shape, r.dtype, v);
    for(let N = 0; N < m; ++N){
        const R = Math.max(0, Math.ceil((y - N) / p)), M = Math.min(h.outHeight, (h.inHeight + y - N) / p);
        for(let V = 0; V < g; ++V){
            const z = Math.max(0, Math.ceil((w - V) / f)), P = Math.min(h.outWidth, (h.inWidth + w - V) / f);
            for(let A = 0; A < h.inChannels; ++A)for(let O = 0; O < h.outChannels; ++O){
                let B = 0;
                for(let Z = 0; Z < h.batchSize; ++Z)for(let H = R; H < M; ++H){
                    const Y = N + H * p - y;
                    for(let Q = z; Q < P; ++Q){
                        const j = V + Q * f - w;
                        b ? B += k.get(Z, Y, j, A) * S.get(Z, H, Q, O) : B += k.get(Z, A, Y, j) * S.get(Z, O, H, Q);
                    }
                }
                x.set(B, N, V, A, O);
            }
        }
    }
    return e.makeTensorInfo(x.shape, x.dtype, x.values);
}
const ID = {
    kernelName: ah,
    backendName: "cpu",
    kernelFunc: wD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function CD(n) {
    const { inputs: t, backend: e, attrs: s } = n, { dy: o, filter: r } = t, { inputShape: i, strides: a, pad: l, dataFormat: c, dimRoundingMode: u } = s;
    lt([
        o,
        r
    ], "conv2dBackpropInput");
    const d = dt(r.shape), h = dt(o.shape);
    let p = Ss(c);
    const f = Te(i, r.shape, a, 1, l, u, !1, p), m = new ve(f.inShape, "float32"), g = m.values, b = e.data.get(o.dataId).values, x = e.data.get(r.dataId).values, [w, y, I] = d, { batchSize: v, filterHeight: k, filterWidth: S, inChannels: N, inHeight: R, inWidth: M, outChannels: V, outHeight: z, outWidth: P, strideHeight: A, strideWidth: O } = f;
    p = f.dataFormat;
    const B = k - 1 - f.padInfo.top, Z = S - 1 - f.padInfo.left, H = p === "channelsLast", Y = m.strides[0], Q = H ? m.strides[1] : m.strides[2], j = H ? m.strides[2] : 1, J = H ? 1 : m.strides[1], ot = h[0], q = H ? h[1] : h[2], rt = H ? h[2] : 1, ht = H ? 1 : h[1];
    for(let ft = 0; ft < v; ++ft)for(let pt = 0; pt < N; ++pt)for(let wt = 0; wt < R; ++wt){
        const It = wt - B, Et = Math.max(0, Math.ceil(It / A)), Pt = Math.min(z, (k + It) / A);
        for(let te = 0; te < M; ++te){
            const At = te - Z, Dt = Math.max(0, Math.ceil(At / O)), Jt = Math.min(P, (S + At) / O);
            let _t = 0;
            for(let we = Et; we < Pt; ++we){
                const $s = we * A - It;
                for(let an = Dt; an < Jt; ++an){
                    const ro = an * O - At, Ln = ot * ft + q * we + rt * an, cs = w * (k - 1 - $s) + y * (S - 1 - ro) + I * pt;
                    for(let Gs = 0; Gs < V; ++Gs){
                        const Es = b[Ln + ht * Gs], Ls = x[cs + Gs];
                        _t += Es * Ls;
                    }
                }
            }
            const ls = Y * ft + Q * wt + j * te + J * pt;
            g[ls] = _t;
        }
    }
    return e.makeTensorInfo(m.shape, m.dtype, m.values);
}
const vD = {
    kernelName: oc,
    backendName: "cpu",
    kernelFunc: CD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function SD(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, filter: r } = t, { strides: i, pad: a, dilations: l } = s;
    lt([
        o,
        r
    ], "conv3d");
    const c = Js(o.shape, r.shape, i, l, a), { filterDepth: u, filterHeight: d, filterWidth: h, dilationDepth: p, dilationHeight: f, dilationWidth: m, padInfo: g } = c, b = g.front, x = g.left, w = g.top, y = new ve(c.outShape, o.dtype), I = e.data.get(o.dataId).values, v = e.data.get(r.dataId).values, k = y.values, S = dt(o.shape), N = dt(r.shape);
    for(let R = 0; R < c.batchSize; ++R){
        const M = R * S[0], V = R * y.strides[0];
        for(let z = 0; z < c.outDepth; ++z){
            const P = V + z * y.strides[1], A = z * c.strideDepth - b;
            for(let O = 0; O < u; ++O){
                const B = A + O * p;
                if (B < 0 || B >= c.inDepth) continue;
                const Z = O * N[0], H = M + B * S[1];
                for(let Y = 0; Y < c.outHeight; ++Y){
                    const Q = P + Y * y.strides[2], j = Y * c.strideHeight - w;
                    for(let J = 0; J < d; ++J){
                        const ot = j + J * f;
                        if (ot < 0 || ot >= c.inHeight) continue;
                        const q = Z + J * N[1], rt = H + ot * S[2];
                        for(let ht = 0; ht < c.outWidth; ++ht){
                            const ft = Q + ht * c.outChannels, pt = ht * c.strideWidth - x;
                            for(let wt = 0; wt < h; ++wt){
                                const It = pt + wt * m;
                                if (It < 0 || It >= c.inWidth) continue;
                                const Et = q + wt * N[2], Pt = rt + It * c.inChannels;
                                let te = Et;
                                for(let At = 0; At < c.inChannels; ++At){
                                    const Dt = I[Pt + At];
                                    for(let Jt = 0; Jt < c.outChannels; ++Jt)k[ft + Jt] += Dt * v[te + Jt];
                                    te += c.outChannels;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return e.makeTensorInfo(y.shape, y.dtype, y.values);
}
const kD = {
    kernelName: rc,
    backendName: "cpu",
    kernelFunc: SD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function TD(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, dy: r } = t, { strides: i, pad: a, filterShape: l } = s;
    lt([
        o,
        r
    ], "conv3dBackpropFilterV2");
    const c = dt(o.shape), u = dt(r.shape), d = Js(o.shape, l, i, 1, a), h = d.strideDepth, p = d.strideHeight, f = d.strideWidth, m = d.filterDepth, g = d.filterHeight, b = d.filterWidth, x = new ve(d.filterShape, "float32"), w = x.values, [y, I, v, k] = x.strides, S = e.data.get(r.dataId).values, [N, R, M, V] = u, z = e.data.get(o.dataId).values, [P, A, O, B] = c, Z = d.padInfo.front, H = d.padInfo.left, Y = d.padInfo.top;
    for(let Q = 0; Q < m; ++Q){
        const j = Math.max(0, Math.ceil((Z - Q) / h)), J = Math.min(d.outDepth, (d.inDepth + Z - Q) / h), ot = Q * y;
        for(let q = 0; q < g; ++q){
            const rt = Math.max(0, Math.ceil((Y - q) / p)), ht = Math.min(d.outHeight, (d.inHeight + Y - q) / p), ft = q * I + ot;
            for(let pt = 0; pt < b; ++pt){
                const wt = Math.max(0, Math.ceil((H - pt) / f)), It = Math.min(d.outWidth, (d.inWidth + H - pt) / f), Et = pt * v + ft;
                for(let Pt = 0; Pt < d.inChannels; ++Pt){
                    const te = Pt * k + Et;
                    for(let At = 0; At < d.outChannels; ++At){
                        let Dt = 0;
                        for(let Jt = 0; Jt < d.batchSize; ++Jt){
                            const _t = Jt * P, ls = Jt * N;
                            for(let we = j; we < J; ++we){
                                const an = (Q + we * h - Z) * A + _t, ro = we * R + ls;
                                for(let Ln = rt; Ln < ht; ++Ln){
                                    const Gs = (q + Ln * p - Y) * O + an, Es = Ln * M + ro;
                                    for(let Ls = wt; Ls < It; ++Ls){
                                        const Nu = (pt + Ls * f - H) * B + Gs, Ru = Ls * V + Es;
                                        Dt += z[Nu + Pt] * S[Ru + At];
                                    }
                                }
                            }
                        }
                        w[te + At] = Dt;
                    }
                }
            }
        }
    }
    return e.makeTensorInfo(x.shape, x.dtype, x.values);
}
const ND = {
    kernelName: lh,
    backendName: "cpu",
    kernelFunc: TD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function RD(n) {
    const { inputs: t, backend: e, attrs: s } = n, { dy: o, filter: r } = t, { pad: i, strides: a, inputShape: l } = s;
    lt([
        o
    ], "conv3dBackpropInputV2");
    const c = dt(o.shape), u = dt(r.shape), d = Js(l, r.shape, a, 1, i), h = new ve(d.inShape, "float32"), p = h.values, [f, m, g, b] = h.strides, x = e.data.get(o.dataId).values, [w, y, I, v] = c, k = e.data.get(r.dataId).values, [S, N, R, M] = u, { batchSize: V, filterDepth: z, filterHeight: P, filterWidth: A, inChannels: O, inDepth: B, inHeight: Z, inWidth: H, outChannels: Y, outDepth: Q, outHeight: j, outWidth: J, strideDepth: ot, strideHeight: q, strideWidth: rt } = d, ht = z - 1 - d.padInfo.front, ft = P - 1 - d.padInfo.top, pt = A - 1 - d.padInfo.left;
    for(let wt = 0; wt < V; ++wt)for(let It = 0; It < O; ++It)for(let Et = 0; Et < B; ++Et){
        const Pt = Et - ht, te = Math.max(0, Math.ceil(Pt / ot)), At = Math.min(Q, (z + Pt) / ot);
        for(let Dt = 0; Dt < Z; ++Dt){
            const Jt = Dt - ft, _t = Math.max(0, Math.ceil(Jt / q)), ls = Math.min(j, (P + Jt) / q);
            for(let we = 0; we < H; ++we){
                const $s = we - pt, an = Math.max(0, Math.ceil($s / rt)), ro = Math.min(J, (A + $s) / rt);
                let Ln = 0;
                for(let cs = te; cs < At; ++cs){
                    const Gs = cs * ot - Pt;
                    for(let Es = _t; Es < ls; ++Es){
                        const Ls = Es * q - Jt;
                        for(let Pr = an; Pr < ro; ++Pr){
                            const Nu = Pr * rt - $s, Ru = w * wt + y * cs + I * Es + v * Pr, EC = S * (z - 1 - Gs) + N * (P - 1 - Ls) + R * (A - 1 - Nu) + M * It;
                            for(let Ka = 0; Ka < Y; ++Ka){
                                const LC = x[Ru + Ka], MC = k[EC + Ka];
                                Ln += LC * MC;
                            }
                        }
                    }
                }
                p[f * wt + m * Et + g * Dt + b * we + It] = Ln;
            }
        }
    }
    return e.makeTensorInfo(h.shape, h.dtype, h.values);
}
const $D = {
    kernelName: ch,
    backendName: "cpu",
    kernelFunc: RD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const GD = Wt(Mi, (n)=>Math.cos(n)), ED = {
    kernelName: Mi,
    backendName: "cpu",
    kernelFunc: GD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const LD = Wt(Wi, (n)=>Math.cosh(n)), MD = {
    kernelName: Wi,
    backendName: "cpu",
    kernelFunc: LD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function WD(n) {
    const { inputs: t, backend: e, attrs: s } = n, { image: o, boxes: r, boxInd: i } = t, { cropSize: a, method: l, extrapolationValue: c } = s, [u, d, h, p] = o.shape, f = r.shape[0], [m, g] = a, b = vt([
        f,
        m,
        g,
        p
    ], "float32"), x = e.data.get(r.dataId).values, w = e.data.get(i.dataId).values, y = e.data.get(o.dataId).values, I = dt(o.shape), v = dt(b.shape);
    for(let k = 0; k < f; k++){
        const S = k * 4, N = x[S], R = x[S + 1], M = x[S + 2], V = x[S + 3], z = w[k];
        if (z >= u) continue;
        const P = m > 1 ? (M - N) * (d - 1) / (m - 1) : 0, A = g > 1 ? (V - R) * (h - 1) / (g - 1) : 0;
        for(let O = 0; O < m; O++){
            const B = m > 1 ? N * (d - 1) + O * P : 0.5 * (N + M) * (d - 1);
            if (B < 0 || B > d - 1) {
                for(let Z = 0; Z < g; Z++)for(let H = 0; H < p; H++){
                    const Y = H + Z * v[2] + O * v[1] + k * v[0];
                    b.values[Y] = c;
                }
                continue;
            }
            if (l === "bilinear") {
                const Z = Math.floor(B), H = Math.ceil(B), Y = B - Z;
                for(let Q = 0; Q < g; Q++){
                    const j = g > 1 ? R * (h - 1) + Q * A : 0.5 * (R + V) * (h - 1);
                    if (j < 0 || j > h - 1) {
                        for(let rt = 0; rt < p; rt++){
                            const ht = rt + Q * v[2] + O * v[1] + k * v[0];
                            b.values[ht] = c;
                        }
                        continue;
                    }
                    const J = Math.floor(j), ot = Math.ceil(j), q = j - J;
                    for(let rt = 0; rt < p; rt++){
                        let ht = rt + J * I[2] + Z * I[1] + z * I[0];
                        const ft = y[ht];
                        ht = rt + ot * I[2] + Z * I[1] + z * I[0];
                        const pt = y[ht];
                        ht = rt + J * I[2] + H * I[1] + z * I[0];
                        const wt = y[ht];
                        ht = rt + ot * I[2] + H * I[1] + z * I[0];
                        const It = y[ht], Et = ft + (pt - ft) * q, Pt = wt + (It - wt) * q;
                        ht = rt + Q * v[2] + O * v[1] + k * v[0], b.values[ht] = Et + (Pt - Et) * Y;
                    }
                }
            } else for(let Z = 0; Z < g; ++Z){
                const H = g > 1 ? R * (h - 1) + Z * A : 0.5 * (R + V) * (h - 1);
                if (H < 0 || H > h - 1) {
                    for(let j = 0; j < p; j++){
                        const J = j + Z * v[2] + O * v[1] + k * v[0];
                        b.values[J] = c;
                    }
                    continue;
                }
                const Y = Math.round(H), Q = Math.round(B);
                for(let j = 0; j < p; j++){
                    const J = j + Y * I[2] + Q * I[1] + z * I[0], ot = j + Z * v[2] + O * v[1] + k * v[0];
                    b.values[ot] = y[J];
                }
            }
        }
    }
    return e.makeTensorInfo(b.shape, b.dtype, b.values);
}
const DD = {
    kernelName: dh,
    backendName: "cpu",
    kernelFunc: WD
};
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function FD(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r, exclusive: i, reverse: a } = s;
    lt(o, "cumprod");
    const l = qt([
        r
    ], o.shape.length);
    let c = o;
    l != null && (c = _e({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            perm: l
        }
    }));
    const u = ie(1, o.shape.length)[0];
    if (u !== c.shape.length - 1) throw new Error(`backend.cumprod in CPU expects an inner-most axis=${c.shape.length - 1} but got axis=${u}`);
    const d = tn(c.dtype, "int32"), h = _l(X(c.shape), d), p = e.data.get(c.dataId).values, f = c.shape[c.shape.length - 1], m = a ? (b, x)=>b + f - x - 1 : (b, x)=>b + x;
    for(let b = 0; b < p.length; b += f)for(let x = 0; x < f; x++){
        const w = m(b, x);
        if (x === 0) h[w] = i ? 1 : p[w];
        else {
            const y = m(b, x - 1);
            h[w] = i ? p[y] * h[y] : p[w] * h[y];
        }
    }
    const g = e.makeTensorInfo(c.shape, d, h);
    if (l != null) {
        const b = js(l), x = _e({
            inputs: {
                x: g
            },
            backend: e,
            attrs: {
                perm: b
            }
        });
        return e.disposeIntermediateTensorInfo(g), e.disposeIntermediateTensorInfo(c), x;
    }
    return g;
}
const VD = {
    kernelName: uh,
    backendName: "cpu",
    kernelFunc: FD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function zD(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r, exclusive: i, reverse: a } = s;
    lt(o, "cumsum");
    const l = qt([
        r
    ], o.shape.length);
    let c = o;
    l != null && (c = _e({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            perm: l
        }
    }));
    const u = ie(1, o.shape.length)[0];
    if (u !== c.shape.length - 1) throw new Error(`backend.cumsum in CPU expects an inner-most axis=${c.shape.length - 1} but got axis=${u}`);
    const d = tn(c.dtype, "int32"), h = ke(X(c.shape), d), p = e.data.get(c.dataId).values, f = c.shape[c.shape.length - 1], m = a ? (b, x)=>b + f - x - 1 : (b, x)=>b + x;
    for(let b = 0; b < p.length; b += f)for(let x = 0; x < f; x++){
        const w = m(b, x);
        if (x === 0) h[w] = i ? 0 : p[w];
        else {
            const y = m(b, x - 1);
            h[w] = i ? p[y] + h[y] : p[w] + h[y];
        }
    }
    const g = e.makeTensorInfo(c.shape, d, h);
    if (l != null) {
        const b = js(l), x = _e({
            inputs: {
                x: g
            },
            backend: e,
            attrs: {
                perm: b
            }
        });
        return e.disposeIntermediateTensorInfo(g), e.disposeIntermediateTensorInfo(c), x;
    }
    return g;
}
const PD = {
    kernelName: ic,
    backendName: "cpu",
    kernelFunc: zD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function AD(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, weights: r } = t, { size: i, binaryOutput: a } = s;
    if (o.shape.length === 1) {
        const l = e.data.get(o.dataId).values, c = e.data.get(r.dataId).values, u = Af(l, c, r.dtype, r.shape, i);
        return e.makeTensorInfo([
            i
        ], r.dtype, u);
    } else if (o.shape.length === 2) {
        const l = e.bufferSync(o), c = e.bufferSync(r), u = K1(l, c, i, a);
        return e.makeTensorInfo(u.shape, r.dtype, u.values);
    }
    throw new Error(`Error in denseBincount: input must be at most rank 2, but got rank${o.shape.length}.`);
}
const OD = {
    kernelName: hh,
    backendName: "cpu",
    kernelFunc: AD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function XD(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { blockSize: r, dataFormat: i } = s;
    C(i === "NHWC", ()=>`Only NHWC dataFormat supported on CPU for depthToSpace. Got ${i}`);
    const a = o.shape[0], l = o.shape[1], c = o.shape[2], u = o.shape[3], d = l * r, h = c * r, p = u / (r * r), f = e.data.get(o.dataId).values, m = new Float32Array(a * d * h * p);
    let g = 0;
    for(let b = 0; b < a; ++b)for(let x = 0; x < d; ++x){
        const w = Math.floor(x / r), y = x % r;
        for(let I = 0; I < h; ++I){
            const v = Math.floor(I / r), k = I % r, S = (y * r + k) * p;
            for(let N = 0; N < p; ++N){
                const M = N + S + u * (v + c * (w + l * b));
                m[g++] = f[M];
            }
        }
    }
    return e.makeTensorInfo([
        a,
        d,
        h,
        p
    ], o.dtype, m);
}
const KD = {
    kernelName: ph,
    backendName: "cpu",
    kernelFunc: XD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Kw(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, filter: r } = t, { strides: i, pad: a, dilations: l, dimRoundingMode: c } = s;
    lt([
        o,
        r
    ], "depthwiseConv2DNative");
    const u = dt(o.shape), d = dt(r.shape);
    let h = l;
    h == null && (h = [
        1,
        1
    ]), C(Le(i, h), ()=>`Error in depthwiseConv2d: Either strides or dilations must be 1. Got strides ${i} and dilations '${h}'`);
    const p = Te(o.shape, r.shape, i, h, a, c, !0), { filterHeight: f, filterWidth: m, dilationHeight: g, dilationWidth: b, padInfo: x } = p, w = x.left, y = x.top, I = p.outChannels / p.inChannels, v = new ve(p.outShape, o.dtype), k = e.data.get(o.dataId).values, S = e.data.get(r.dataId).values, N = v.values;
    for(let R = 0; R < p.batchSize; ++R){
        const M = R * u[0], V = R * v.strides[0];
        for(let z = 0; z < p.outHeight; ++z){
            const P = V + z * v.strides[1], A = z * p.strideHeight - y;
            for(let O = 0; O < f; ++O){
                const B = A + O * g;
                if (B < 0 || B >= p.inHeight) continue;
                const Z = O * d[0], H = M + B * u[1];
                for(let Y = 0; Y < p.outWidth; ++Y){
                    const Q = P + Y * v.strides[2], j = Y * p.strideWidth - w;
                    for(let J = 0; J < m; ++J){
                        const ot = j + J * b;
                        if (ot < 0 || ot >= p.inWidth) continue;
                        const q = Z + J * d[1], rt = H + ot * p.inChannels;
                        let ht = Q, ft = q;
                        for(let pt = 0; pt < p.inChannels; ++pt){
                            const wt = k[rt + pt];
                            for(let It = 0; It < I; ++It)N[ht + It] += wt * S[ft + It];
                            ht += I, ft += I;
                        }
                    }
                }
            }
        }
    }
    return e.makeTensorInfo(v.shape, v.dtype, v.values);
}
const ZD = {
    kernelName: ac,
    backendName: "cpu",
    kernelFunc: Kw
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function BD(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, dy: r } = t, { strides: i, dilations: a, pad: l, dimRoundingMode: c, filterShape: u } = s;
    lt([
        o,
        r
    ], "depthwiseConv2dNativeBackpropFilter");
    const d = Te(o.shape, u, i, a, l, c, !0), { strideHeight: h, strideWidth: p, filterHeight: f, filterWidth: m } = d, g = new ve(d.filterShape, "float32"), b = d.padInfo.left, x = d.padInfo.top, w = d.outChannels / d.inChannels, y = e.data.get(o.dataId).values, I = new ve(o.shape, o.dtype, y), v = e.data.get(r.dataId).values, k = new ve(r.shape, r.dtype, v);
    for(let S = 0; S < f; ++S){
        const N = Math.max(0, Math.ceil((x - S) / h)), R = Math.min(d.outHeight, (d.inHeight + x - S) / h);
        for(let M = 0; M < m; ++M){
            const V = Math.max(0, Math.ceil((b - M) / p)), z = Math.min(d.outWidth, (d.inWidth + b - M) / p);
            for(let P = 0; P < d.outChannels; ++P){
                const A = Math.trunc(P / w), O = P % w;
                let B = 0;
                for(let Z = 0; Z < d.batchSize; ++Z)for(let H = N; H < R; ++H){
                    const Y = S + H * h - x;
                    for(let Q = V; Q < z; ++Q){
                        const j = M + Q * p - b;
                        B += I.get(Z, Y, j, A) * k.get(Z, H, Q, P);
                    }
                }
                g.set(B, S, M, A, O);
            }
        }
    }
    return e.makeTensorInfo(g.shape, g.dtype, g.values);
}
const HD = {
    kernelName: fh,
    backendName: "cpu",
    kernelFunc: BD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function _D(n) {
    const { inputs: t, backend: e, attrs: s } = n, { dy: o, filter: r } = t, { strides: i, dilations: a, pad: l, dimRoundingMode: c, inputShape: u } = s;
    lt([
        o,
        r
    ], "depthwiseConv2DNativeBackpropInput");
    const d = dt(o.shape), h = dt(r.shape), p = Te(u, r.shape, i, a, l, c, !0), f = new ve(p.inShape, "float32"), m = f.values, [g, b, x] = f.strides, w = e.data.get(o.dataId).values, [y, I, v] = d, k = e.data.get(r.dataId).values, [S, N, R] = h, { batchSize: M, filterHeight: V, filterWidth: z, inChannels: P, inHeight: A, inWidth: O, outChannels: B, outHeight: Z, outWidth: H, strideHeight: Y, strideWidth: Q } = p, j = V - 1 - p.padInfo.top, J = z - 1 - p.padInfo.left, ot = B / P;
    for(let q = 0; q < M; ++q)for(let rt = 0; rt < P; ++rt)for(let ht = 0; ht < A; ++ht){
        const ft = ht - j, pt = Math.max(0, Math.ceil(ft / Y)), wt = Math.min(Z, (V + ft) / Y);
        for(let It = 0; It < O; ++It){
            const Et = It - J, Pt = Math.max(0, Math.ceil(Et / Q)), te = Math.min(H, (z + Et) / Q);
            let At = 0;
            for(let Dt = pt; Dt < wt; ++Dt){
                const Jt = Dt * Y - ft;
                for(let _t = Pt; _t < te; ++_t){
                    const ls = _t * Q - Et, we = y * q + I * Dt + v * _t, $s = S * (V - 1 - Jt) + N * (z - 1 - ls) + R * rt;
                    for(let an = 0; an < ot; ++an){
                        const ro = rt * ot + an, Ln = w[we + ro], cs = k[$s + an];
                        At += Ln * cs;
                    }
                }
            }
            m[g * q + b * ht + x * It + rt] = At;
        }
    }
    return e.makeTensorInfo(f.shape, f.dtype, f.values);
}
const UD = {
    kernelName: mh,
    backendName: "cpu",
    kernelFunc: _D
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function YD(n) {
    const { inputs: t, backend: e } = n, { x: s } = t, o = X(s.shape), r = e.data.get(s.dataId).values, i = vt([
        o,
        o
    ], s.dtype), a = i.values;
    for(let c = 0; c < r.length; c++)a[c * o + c] = r[c];
    const l = [
        ...s.shape,
        ...s.shape
    ];
    return e.makeTensorInfo(l, i.dtype, i.values);
}
const QD = {
    kernelName: ub,
    backendName: "cpu",
    kernelFunc: YD
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const JD = {
    kernelName: lc,
    backendName: "cpu",
    kernelFunc: ({ inputs: n, backend: t, attrs: e })=>{
        const { x: s, filter: o } = n, { strides: r, pad: i, dilations: a } = e, l = t, c = l.data.get(s.dataId).values, u = s.shape.length, d = l.data.get(o.dataId).values, h = o.shape.length, { batchSize: p, inHeight: f, inWidth: m, inChannels: g, outHeight: b, outWidth: x, padInfo: w, strideHeight: y, strideWidth: I, filterHeight: v, filterWidth: k, dilationHeight: S, dilationWidth: N, outShape: R } = Ia(s.shape, o.shape, r, i, "NHWC", a), M = X(R), V = R.length, z = ne(s.dtype, M);
        for(let A = 0; A < p; ++A)for(let O = 0; O < b; ++O){
            const B = O * y - w.top;
            for(let Z = 0; Z < x; ++Z){
                const H = Z * I - w.left;
                for(let Y = 0; Y < g; ++Y){
                    let Q = Number.MIN_SAFE_INTEGER;
                    for(let J = 0; J < v; ++J){
                        const ot = B + J * S;
                        if (ot >= 0 && ot < f) for(let q = 0; q < k; ++q){
                            const rt = H + q * N;
                            if (rt >= 0 && rt < m) {
                                const ht = zn([
                                    A,
                                    ot,
                                    rt,
                                    Y
                                ], u, dt(s.shape)), ft = zn([
                                    J,
                                    q,
                                    Y
                                ], h, dt(o.shape)), pt = c[ht] + d[ft];
                                pt > Q && (Q = pt);
                            }
                        }
                    }
                    const j = zn([
                        A,
                        O,
                        Z,
                        Y
                    ], V, dt(R));
                    z[j] = Q;
                }
            }
        }
        return {
            dataId: l.write(Qs(z, s.dtype), R, s.dtype),
            shape: R,
            dtype: s.dtype
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const jD = {
    kernelName: ld,
    backendName: "cpu",
    kernelFunc: ({ inputs: n, backend: t, attrs: e })=>{
        const { x: s, filter: o, dy: r } = n, { strides: i, pad: a, dilations: l } = e, c = t, u = kn(s.shape, c.data.get(s.dataId).values), d = kn(o.shape, c.data.get(o.dataId).values), { batchSize: h, inHeight: p, inWidth: f, inChannels: m, outHeight: g, outWidth: b, padInfo: x, strideHeight: w, strideWidth: y, filterHeight: I, filterWidth: v, dilationHeight: k, dilationWidth: S, outShape: N } = Ia(s.shape, o.shape, i, a, "NHWC", l);
        C(r.rank === N.length, ()=>`Error in ${ld}, dy must have the same rank as output ${N.length}, but got ${r.rank}`);
        const R = kn(N, c.data.get(r.dataId).values), M = Jd(o.shape, o.dtype);
        for(let z = 0; z < h; ++z)for(let P = 0; P < g; ++P){
            const A = P * w - x.top;
            for(let O = 0; O < b; ++O){
                const B = O * y - x.left;
                for(let Z = 0; Z < m; ++Z){
                    let H = Number.MIN_SAFE_INTEGER, Y = 0, Q = 0;
                    for(let j = 0; j < I; ++j){
                        const J = A + j * k;
                        if (J >= 0 && J < p) for(let ot = 0; ot < v; ++ot){
                            const q = B + ot * S;
                            if (q >= 0 && q < f) {
                                const rt = u[z][J][q][Z] + d[j][ot][Z];
                                rt > H && (H = rt, Y = j, Q = ot);
                            }
                        }
                    }
                    M[Y][Q][Z] += R[z][P][O][Z];
                }
            }
        }
        return {
            dataId: c.write(Qs(M, s.dtype), o.shape, o.dtype),
            shape: o.shape,
            dtype: o.dtype
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const qD = {
    kernelName: ad,
    backendName: "cpu",
    kernelFunc: ({ inputs: n, backend: t, attrs: e })=>{
        const { x: s, filter: o, dy: r } = n, { strides: i, pad: a, dilations: l } = e, c = t, u = kn(s.shape, c.data.get(s.dataId).values), d = kn(o.shape, c.data.get(o.dataId).values), { batchSize: h, inHeight: p, inWidth: f, inChannels: m, outHeight: g, outWidth: b, padInfo: x, strideHeight: w, strideWidth: y, filterHeight: I, filterWidth: v, dilationHeight: k, dilationWidth: S, outShape: N } = Ia(s.shape, o.shape, i, a, "NHWC", l);
        C(r.rank === N.length, ()=>`Error in ${ad}, dy must have the same rank as output ${N.length}, but got ${r.rank}`);
        const R = kn(N, c.data.get(r.dataId).values), M = Jd(s.shape, s.dtype);
        for(let z = 0; z < h; ++z)for(let P = 0; P < g; ++P){
            const A = P * w - x.top;
            for(let O = 0; O < b; ++O){
                const B = O * y - x.left;
                for(let Z = 0; Z < m; ++Z){
                    let H = Number.MIN_SAFE_INTEGER, Y = A < 0 ? 0 : A, Q = B < 0 ? 0 : B;
                    for(let j = 0; j < I; ++j){
                        const J = A + j * k;
                        if (J >= 0 && J < p) for(let ot = 0; ot < v; ++ot){
                            const q = B + ot * S;
                            if (q >= 0 && q < f) {
                                const rt = u[z][J][q][Z] + d[j][ot][Z];
                                rt > H && (H = rt, Y = J, Q = q);
                            }
                        }
                    }
                    M[z][Y][Q][Z] += R[z][P][O][Z];
                }
            }
        }
        return {
            dataId: c.write(Qs(M, s.dtype), s.shape, s.dtype),
            shape: s.shape,
            dtype: s.dtype
        };
    }
};
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function tF(n) {
    const { inputs: t, backend: e, attrs: s } = n, { image: o } = t, { canvas: r, options: i } = s, { contextOptions: a, imageOptions: l } = i || {}, c = (l == null ? void 0 : l.alpha) || 1, u = (a == null ? void 0 : a.contextType) || "2d";
    if (u !== "2d") throw new Error(`Context type ${a.contextType} is not supported by the CPU backend.`);
    const d = r.getContext(u, (a == null ? void 0 : a.contextAttributes) || {});
    if (d == null) throw new Error(`Could not get the context with ${u} type.`);
    const [h, p] = o.shape.slice(0, 2), f = o.shape.length === 2 ? 1 : o.shape[2], m = e.data.get(o.dataId).values, g = o.dtype === "float32" ? 255 : 1, b = new Uint8ClampedArray(p * h * 4);
    for(let w = 0; w < h * p; ++w){
        const y = [
            0,
            0,
            0,
            255 * c
        ];
        for(let v = 0; v < f; v++){
            const k = m[w * f + v];
            if (o.dtype === "float32") {
                if (k < 0 || k > 1) throw new Error(`Tensor values for a float32 Tensor must be in the range [0 - 1] but encountered ${k}.`);
            } else if (o.dtype === "int32" && (k < 0 || k > 255)) throw new Error(`Tensor values for a int32 Tensor must be in the range [0 - 255] but encountered ${k}.`);
            f === 1 ? (y[0] = k * g, y[1] = k * g, y[2] = k * g) : y[v] = k * g;
        }
        const I = w * 4;
        b[I + 0] = Math.round(y[0]), b[I + 1] = Math.round(y[1]), b[I + 2] = Math.round(y[2]), b[I + 3] = Math.round(y[3]);
    }
    r.width = p, r.height = h;
    const x = new ImageData(b, p, h);
    return d.putImageData(x, 0, 0), o;
}
const eF = {
    kernelName: gh,
    backendName: "cpu",
    kernelFunc: tF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function za(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r, keepDims: i } = s;
    lt(o, "sum");
    let a;
    o.dtype === "bool" ? a = Ys({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            dtype: "int32"
        }
    }) : a = rs({
        inputs: {
            x: o
        },
        backend: e
    });
    const l = a.shape.length, c = Ct(r, a.shape), u = qt(c, l);
    let d = c, h = a;
    u != null && (h = _e({
        inputs: {
            x: a
        },
        backend: e,
        attrs: {
            perm: u
        }
    }), d = ie(d.length, l)), Ne("sum", d, h.shape.length);
    const [p, f] = ye(h.shape, d), m = tn(h.dtype, "int32");
    let g = Fl(e, p, m);
    const b = X(f), x = e.data.get(g.dataId).values, w = e.data.get(h.dataId).values;
    for(let y = 0; y < x.length; ++y){
        const I = y * b;
        let v = 0;
        for(let k = 0; k < b; ++k)v += w[I + k];
        x[y] = v;
    }
    if (i) {
        const y = re(g.shape, c), I = g;
        g = Zt({
            inputs: {
                x: g
            },
            backend: e,
            attrs: {
                shape: y
            }
        }), e.disposeIntermediateTensorInfo(I);
    }
    return e.disposeIntermediateTensorInfo(a), u != null && e.disposeIntermediateTensorInfo(h), g;
}
const nF = {
    kernelName: Oc,
    backendName: "cpu",
    kernelFunc: za
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function sF(n) {
    const { inputs: t, backend: e, attrs: s } = n, { equation: o } = s, r = t, { allDims: i, summedDims: a, idDims: l } = lf(o, r.length);
    uf(i.length, l, r);
    const { path: c, steps: u } = df(a, l), d = u.length;
    let h = null, p = i.length;
    const f = [];
    for(let m = 0; m < d; ++m){
        for (const g of u[m]){
            const { permutationIndices: b, expandDims: x } = cf(p, l[g]);
            let w;
            hf(b) ? w = r[g] : (w = _e({
                inputs: {
                    x: r[g]
                },
                backend: e,
                attrs: {
                    perm: b
                }
            }), f.push(w));
            const y = w.shape.slice();
            for(let I = 0; I < x.length; ++I)y.splice(x[I], 0, 1);
            $t(w.shape, y) || (w = Zt({
                inputs: {
                    x: w
                },
                backend: e,
                attrs: {
                    shape: y
                }
            }), f.push(w)), h === null ? h = w : (h = wu({
                inputs: {
                    a: w,
                    b: h
                },
                backend: e
            }), f.push(h));
        }
        m < d - 1 && (c[m] >= 0 && (h = za({
            inputs: {
                x: h
            },
            backend: e,
            attrs: {
                axis: c[m] - (i.length - p),
                keepDims: !1
            }
        }), f.push(h)), p--);
    }
    for (const m of f)m !== h && e.disposeIntermediateTensorInfo(m);
    return h;
}
const oF = {
    kernelName: bh,
    backendName: "cpu",
    kernelFunc: sF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function rF(n) {
    const { inputs: t, backend: e } = n, { dy: s, y: o } = t;
    lt([
        s,
        o
    ], "eluGrad");
    const r = new Float32Array(X(o.shape)), i = e.data.get(o.dataId).values, a = e.data.get(s.dataId).values;
    for(let l = 0; l < i.length; ++l){
        const c = i[l];
        c >= 0 ? r[l] = a[l] : r[l] = a[l] * (c + 1);
    }
    return e.makeTensorInfo(o.shape, "float32", r);
}
const iF = {
    kernelName: xh,
    backendName: "cpu",
    kernelFunc: rF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const aF = tf, lF = ef, cF = nf, uF = sf, dF = of, hF = rf, pF = Wt(Vi, (n)=>{
    const t = Math.sign(n), e = Math.abs(n), s = 1 / (1 + aF * e);
    return t * (1 - ((((hF * s + dF) * s + uF) * s + cF) * s + lF) * s * Math.exp(-e * e));
}), fF = {
    kernelName: Vi,
    backendName: "cpu",
    kernelFunc: pF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Pl(n) {
    const { inputs: t, backend: e, attrs: s } = n, { input: o } = t, { dim: r } = s, i = o.shape.length, a = o.shape.slice();
    let l = r;
    return r < 0 && (C(-(i + 1) <= r, ()=>`Axis must be in the interval [${-(i + 1)}, ${i}]`), l = i + r + 1), a.splice(l, 0, 1), Zt({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            shape: a
        }
    });
}
const mF = {
    kernelName: uc,
    backendName: "cpu",
    kernelFunc: Pl
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const gF = le((n, t)=>n / t), Hf = fe(Di, gF), Fd = {
    kernelName: Di,
    backendName: "cpu",
    kernelFunc: Hf
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Zw(n, t, e) {
    const s = n.shape, o = s[0], r = s[1], i = e.data.get(n.dataId), a = i.complexTensorInfos.real, l = i.complexTensorInfos.imag, c = [
        o,
        r
    ], u = X(c), d = Se("float32", u), h = Se("float32", u);
    for(let g = 0; g < o; g++){
        const b = Fo({
            inputs: {
                x: a
            },
            backend: e,
            attrs: {
                begin: [
                    g,
                    0
                ],
                size: [
                    1,
                    r
                ]
            }
        }), x = Fo({
            inputs: {
                x: l
            },
            backend: e,
            attrs: {
                begin: [
                    g,
                    0
                ],
                size: [
                    1,
                    r
                ]
            }
        }), w = Je({
            inputs: {
                real: b,
                imag: x
            },
            backend: e
        }), { real: y, imag: I } = bF(w, t, e), v = xs(y, I);
        for(let k = 0; k < r; k++){
            const S = af(v, k);
            d[g * r + k] = S.real, h[g * r + k] = S.imag;
        }
        e.disposeIntermediateTensorInfo(b), e.disposeIntermediateTensorInfo(x), e.disposeIntermediateTensorInfo(w);
    }
    const p = e.makeTensorInfo(c, "float32", d), f = e.makeTensorInfo(c, "float32", h), m = Je({
        inputs: {
            real: p,
            imag: f
        },
        backend: e
    });
    return e.disposeIntermediateTensorInfo(p), e.disposeIntermediateTensorInfo(f), m;
}
function bF(n, t, e) {
    const s = X(n.shape), o = e.data.get(n.dataId), r = e.data.get(o.complexTensorInfos.real.dataId).values, i = e.data.get(o.complexTensorInfos.imag.dataId).values;
    if (xF(s)) {
        const a = Vd(r, i, s, t, e), l = [
            n.shape[0],
            n.shape[1]
        ];
        if (t) {
            const c = e.makeTensorInfo(l, "float32", a.real), u = e.makeTensorInfo(l, "float32", a.imag), d = e.makeTensorInfo([], "float32", Is(s, "float32")), h = rs({
                inputs: {
                    x: d
                },
                backend: e
            }), p = Fd.kernelFunc({
                inputs: {
                    a: c,
                    b: d
                },
                backend: e
            }), f = Fd.kernelFunc({
                inputs: {
                    a: u,
                    b: h
                },
                backend: e
            }), m = e.data.get(p.dataId).values, g = e.data.get(f.dataId).values;
            return e.disposeIntermediateTensorInfo(c), e.disposeIntermediateTensorInfo(u), e.disposeIntermediateTensorInfo(d), e.disposeIntermediateTensorInfo(h), e.disposeIntermediateTensorInfo(p), e.disposeIntermediateTensorInfo(f), {
                real: m,
                imag: g
            };
        }
        return a;
    } else {
        const a = xs(r, i), l = yF(a, s, t);
        return j0(l);
    }
}
function xF(n) {
    return (n & n - 1) === 0;
}
function Vd(n, t, e, s, o) {
    if (e === 1) return {
        real: n,
        imag: t
    };
    const r = xs(n, t), i = e / 2, a = q0(r), l = a.real, c = a.imag, u = [
        l.length
    ], d = o.makeTensorInfo(u, "float32", l), h = o.makeTensorInfo(u, "float32", c), p = Je({
        inputs: {
            real: d,
            imag: h
        },
        backend: o
    }), f = tx(r), m = f.real, g = f.imag, b = [
        m.length
    ], x = o.makeTensorInfo(b, "float32", m), w = o.makeTensorInfo(b, "float32", g), y = Je({
        inputs: {
            real: x,
            imag: w
        },
        backend: o
    }), I = Vd(l, c, i, s, o), v = I.real, k = I.imag, S = [
        v.length
    ], N = o.makeTensorInfo(S, "float32", v), R = o.makeTensorInfo(S, "float32", k), M = Je({
        inputs: {
            real: N,
            imag: R
        },
        backend: o
    }), V = Vd(m, g, i, s, o), z = V.real, P = V.imag, A = [
        z.length
    ], O = o.makeTensorInfo(A, "float32", z), B = o.makeTensorInfo(A, "float32", P), Z = Je({
        inputs: {
            real: O,
            imag: B
        },
        backend: o
    }), H = nx(e, s), Y = [
        H.real.length
    ], Q = o.makeTensorInfo(Y, "float32", H.real), j = o.makeTensorInfo(Y, "float32", H.imag), J = Je({
        inputs: {
            real: Q,
            imag: j
        },
        backend: o
    }), ot = wu({
        inputs: {
            a: J,
            b: Z
        },
        backend: o
    }), q = wr({
        inputs: {
            a: M,
            b: ot
        },
        backend: o
    }), rt = Zf({
        inputs: {
            a: M,
            b: ot
        },
        backend: o
    }), ht = Do({
        inputs: {
            input: q
        },
        backend: o
    }), ft = Do({
        inputs: {
            input: rt
        },
        backend: o
    }), pt = Ir({
        inputs: {
            input: q
        },
        backend: o
    }), wt = Ir({
        inputs: {
            input: rt
        },
        backend: o
    }), It = Cr({
        inputs: [
            ht,
            ft
        ],
        backend: o,
        attrs: {
            axis: 0
        }
    }), Et = Cr({
        inputs: [
            pt,
            wt
        ],
        backend: o,
        attrs: {
            axis: 0
        }
    }), Pt = o.data.get(It.dataId).values, te = o.data.get(Et.dataId).values;
    return o.disposeIntermediateTensorInfo(d), o.disposeIntermediateTensorInfo(h), o.disposeIntermediateTensorInfo(p), o.disposeIntermediateTensorInfo(x), o.disposeIntermediateTensorInfo(w), o.disposeIntermediateTensorInfo(y), o.disposeIntermediateTensorInfo(N), o.disposeIntermediateTensorInfo(R), o.disposeIntermediateTensorInfo(M), o.disposeIntermediateTensorInfo(O), o.disposeIntermediateTensorInfo(B), o.disposeIntermediateTensorInfo(Z), o.disposeIntermediateTensorInfo(Q), o.disposeIntermediateTensorInfo(j), o.disposeIntermediateTensorInfo(J), o.disposeIntermediateTensorInfo(ot), o.disposeIntermediateTensorInfo(q), o.disposeIntermediateTensorInfo(rt), o.disposeIntermediateTensorInfo(ht), o.disposeIntermediateTensorInfo(pt), o.disposeIntermediateTensorInfo(ft), o.disposeIntermediateTensorInfo(wt), o.disposeIntermediateTensorInfo(It), o.disposeIntermediateTensorInfo(Et), {
        real: Pt,
        imag: te
    };
}
function yF(n, t, e) {
    const s = new Float32Array(t * 2);
    for(let o = 0; o < t; o++){
        let r = 0, i = 0;
        for(let a = 0; a < t; a++){
            const l = sx(o * a, t, e), c = af(n, a);
            r += c.real * l.real - c.imag * l.imag, i += c.real * l.imag + c.imag * l.real;
        }
        e && (r /= t, i /= t), ex(s, r, i, o);
    }
    return s;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function wF(n) {
    const { inputs: t, backend: e } = n, { input: s } = t, o = X(s.shape), r = s.shape[s.shape.length - 1], i = o / r, a = Zt({
        inputs: {
            x: s
        },
        backend: e,
        attrs: {
            shape: [
                i,
                r
            ]
        }
    }), l = Zw(a, !1, e), c = Zt({
        inputs: {
            x: l
        },
        backend: e,
        attrs: {
            shape: s.shape
        }
    });
    return e.disposeIntermediateTensorInfo(a), e.disposeIntermediateTensorInfo(l), c;
}
const IF = {
    kernelName: yh,
    backendName: "cpu",
    kernelFunc: wF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function _f(n) {
    const { backend: t, attrs: e } = n, { shape: s, value: o, dtype: r } = e, i = r || Oo(o), a = ne(i, X(s));
    return vF(a, o, i), t.makeTensorInfo(s, i, a);
}
const CF = {
    kernelName: wh,
    backendName: "cpu",
    kernelFunc: _f
};
function vF(n, t, e) {
    n.fill(t);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const SF = {
    kernelName: Ih,
    backendName: "cpu",
    kernelFunc: ({ inputs: n, attrs: t, backend: e })=>{
        const { image: s } = n, o = e, r = Se(s.dtype, X(s.shape)), [i, a, l, c] = s.shape, u = o.data.get(s.dataId).values;
        for(let h = 0; h < i; h++){
            const p = h * l * a * c;
            for(let f = 0; f < a; f++){
                const m = f * (l * c);
                for(let g = 0; g < l; g++){
                    const b = g * c;
                    for(let x = 0; x < c; x++){
                        const w = Math.round(l - g - 1), y = p + m + b + x;
                        let I = u[y];
                        if (w >= 0 && w < l) {
                            const v = w * c, k = p + m + v + x;
                            I = u[k];
                        }
                        r[y] = I;
                    }
                }
            }
        }
        return {
            dataId: o.write(r, s.shape, s.dtype),
            shape: s.shape,
            dtype: s.dtype
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function kF(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, filter: r, bias: i, preluActivationWeights: a } = t, { strides: l, pad: c, dataFormat: u, dilations: d, dimRoundingMode: h, activation: p, leakyreluAlpha: f } = s;
    let m = Xw({
        inputs: {
            x: o,
            filter: r
        },
        backend: e,
        attrs: {
            strides: l,
            pad: c,
            dataFormat: u,
            dilations: d,
            dimRoundingMode: h
        }
    });
    if (i) {
        const g = m;
        if (u === "NCHW" && i.shape.length === 1 && i.shape[0] !== 1) {
            const b = Zt({
                inputs: {
                    x: i
                },
                backend: e,
                attrs: {
                    shape: [
                        i.shape[0],
                        1,
                        1
                    ]
                }
            });
            m = wr({
                inputs: {
                    a: m,
                    b: b
                },
                backend: e
            }), e.disposeIntermediateTensorInfo(b);
        } else m = wr({
            inputs: {
                a: m,
                b: i
            },
            backend: e
        });
        e.disposeIntermediateTensorInfo(g);
    }
    if (p) {
        const g = m;
        if (u === "NCHW" && p === "prelu" && a.shape.length === 1 && a.shape[0] !== 1) {
            const b = Zt({
                inputs: {
                    x: a
                },
                backend: e,
                attrs: {
                    shape: [
                        a.shape[0],
                        1,
                        1
                    ]
                }
            });
            m = zl(e, m, p, b, f), e.disposeIntermediateTensorInfo(b);
        } else m = zl(e, m, p, a, f);
        e.disposeIntermediateTensorInfo(g);
    }
    return m;
}
const TF = {
    kernelName: gl,
    backendName: "cpu",
    kernelFunc: kF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function NF(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, filter: r, bias: i, preluActivationWeights: a } = t, { strides: l, pad: c, dataFormat: u, dilations: d, dimRoundingMode: h, activation: p, leakyreluAlpha: f } = s;
    let m = Kw({
        inputs: {
            x: o,
            filter: r
        },
        backend: e,
        attrs: {
            strides: l,
            pad: c,
            dataFormat: u,
            dilations: d,
            dimRoundingMode: h
        }
    });
    if (i) {
        const g = m;
        m = wr({
            inputs: {
                a: m,
                b: i
            },
            backend: e
        }), e.disposeIntermediateTensorInfo(g);
    }
    if (p) {
        const g = m;
        m = zl(e, m, p, a, f), e.disposeIntermediateTensorInfo(g);
    }
    return m;
}
const RF = {
    kernelName: Cb,
    backendName: "cpu",
    kernelFunc: NF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $F(n) {
    const { inputs: t, backend: e } = n, { params: s, indices: o } = t, r = X(s.shape), i = o.shape, a = i[i.length - 1], [l, c, u, d] = eu(s, o);
    if (c === 0) return e.makeTensorInfo(l, s.dtype, []);
    const h = e.data.get(o.dataId).values, p = e.bufferSync(s), f = tw(h, p, s.dtype, c, a, u, d, s.shape, r);
    return e.makeTensorInfo(l, s.dtype, f.values);
}
const GF = {
    kernelName: db,
    backendName: "cpu",
    kernelFunc: $F
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function EF(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, indices: r } = t, { axis: i, batchDims: a } = s;
    lt([
        o,
        r
    ], "gatherV2");
    const l = Ct(i, o.shape)[0], c = e.data.get(r.dataId).values, u = o.shape[l];
    for(let y = 0; y < c.length; ++y){
        const I = c[y];
        C(I <= u - 1 && I >= 0, ()=>`GatherV2: the index value ${I} is not in [0, ${u - 1}]`);
    }
    let d = a;
    a == null && (d = 0);
    const h = X(r.shape), p = ff(o, r, l, d), f = Zt({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            shape: [
                p.batchSize,
                p.outerSize,
                p.dimSize,
                p.sliceSize
            ]
        }
    }), m = Zt({
        inputs: {
            x: r
        },
        backend: e,
        attrs: {
            shape: [
                p.batchSize,
                h / p.batchSize
            ]
        }
    }), g = [
        p.batchSize,
        p.outerSize,
        h / p.batchSize,
        p.sliceSize
    ], b = e.bufferSync(m), x = e.bufferSync(f), w = ew(x, b, g);
    return e.disposeIntermediateTensorInfo(f), e.disposeIntermediateTensorInfo(m), e.makeTensorInfo(p.outputShape, w.dtype, w.values);
}
const LF = {
    kernelName: hc,
    backendName: "cpu",
    kernelFunc: EF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function MF(n) {
    const { inputs: t, backend: e } = n, { input: s } = t, o = X(s.shape), r = s.shape[s.shape.length - 1], i = o / r, a = Zt({
        inputs: {
            x: s
        },
        backend: e,
        attrs: {
            shape: [
                i,
                r
            ]
        }
    }), l = Zw(a, !0, e), c = Zt({
        inputs: {
            x: l
        },
        backend: e,
        attrs: {
            shape: s.shape
        }
    });
    return e.disposeIntermediateTensorInfo(a), e.disposeIntermediateTensorInfo(l), c;
}
const WF = {
    kernelName: Ch,
    backendName: "cpu",
    kernelFunc: MF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const DF = Wt(Zi, (n)=>Number.isFinite(n) ? 1 : 0, "bool"), FF = {
    kernelName: Zi,
    backendName: "cpu",
    kernelFunc: DF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const VF = Wt(Bi, (n)=>Math.abs(n) === 1 / 0 ? 1 : 0, "bool"), zF = {
    kernelName: Bi,
    backendName: "cpu",
    kernelFunc: VF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const PF = Wt(Hi, (n)=>Number.isNaN(n) ? 1 : 0, "bool"), AF = {
    kernelName: Hi,
    backendName: "cpu",
    kernelFunc: PF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function OF(n) {
    const { backend: t, attrs: e } = n, { start: s, stop: o, num: r } = e, i = iw(s, o, r);
    return t.makeTensorInfo([
        i.length
    ], "float32", i);
}
const XF = {
    kernelName: hb,
    backendName: "cpu",
    kernelFunc: OF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const KF = Wt(Ui, (n)=>Math.log1p(n)), ZF = {
    kernelName: Ui,
    backendName: "cpu",
    kernelFunc: KF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const BF = le((n, t)=>n && t), HF = fe(bc, BF, null, "bool"), _F = {
    kernelName: bc,
    backendName: "cpu",
    kernelFunc: HF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const UF = Wt(xc, (n)=>n ? 0 : 1, "bool"), YF = {
    kernelName: xc,
    backendName: "cpu",
    kernelFunc: UF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const QF = le((n, t)=>n || t), JF = fe(yc, QF, null, "bool"), jF = {
    kernelName: yc,
    backendName: "cpu",
    kernelFunc: JF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function qF(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { depthRadius: r, bias: i, alpha: a, beta: l } = s;
    lt(o, "LRN");
    const c = o.shape[3], u = c - 1, d = e.data.get(o.dataId).values, h = X(o.shape), p = new Float32Array(h);
    function f(m) {
        const g = m % c;
        let b = m - g + Math.max(0, g - r);
        const x = m - g + Math.min(g + r, u);
        let w = 0;
        for(; b <= x; b++){
            const y = d[b];
            w += y * y;
        }
        return w;
    }
    for(let m = 0; m < h; m++){
        const g = f(m), b = d[m] * Math.pow(i + a * g, -l);
        p[m] = b;
    }
    return e.makeTensorInfo(o.shape, o.dtype, p);
}
const tV = {
    kernelName: wc,
    backendName: "cpu",
    kernelFunc: qF
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function eV(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, y: r, dy: i } = t, { depthRadius: a, bias: l, alpha: c, beta: u } = s;
    lt(i, "LRNGrad");
    const d = X(i.shape), h = i.shape[3], p = e.data.get(i.dataId).values, f = e.data.get(o.dataId).values, m = e.data.get(r.dataId).values, g = new Float32Array(d), b = d;
    for(let x = 0; x < b; x++){
        const w = x % h, y = x - w + Math.max(0, w - a), I = x - w + Math.min(h, w + a + 1);
        let v = 0;
        for(let k = y; k < I; k++)v += Math.pow(f[k], 2);
        v = c * v + l;
        for(let k = y; k < I; k++){
            let S = -2 * c * u * f[k] * m[x] / v;
            x === k && (S += Math.pow(v, -u)), S *= p[x], g[k] += S;
        }
    }
    return e.makeTensorInfo(i.shape, o.dtype, g);
}
const nV = {
    kernelName: Sh,
    backendName: "cpu",
    kernelFunc: eV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Bw(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { reductionIndices: r, keepDims: i } = s, a = e;
    let l = o.shape;
    const c = l.length, u = Ct(r, l);
    let d = u;
    const h = qt(d, c);
    let p = a.data.get(o.dataId).values;
    if (h != null) {
        const y = new Array(c);
        for(let I = 0; I < y.length; I++)y[I] = l[h[I]];
        p = Xf(p, l, o.dtype, h, y), d = ie(d.length, c), l = y;
    }
    lt(o, "max"), Ne("max", d, c);
    const [f, m] = ye(l, d), g = X(m), b = lw(p, g, f, o.dtype), x = a.write(b, f, o.dtype);
    let w = f;
    return i && (w = re(f, u)), {
        dataId: x,
        shape: w,
        dtype: o.dtype
    };
}
const sV = {
    kernelName: Ic,
    backendName: "cpu",
    kernelFunc: Bw
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function oV(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t;
    lt(o, "maxPool");
    const { filterSize: r, strides: i, pad: a, dimRoundingMode: l } = s, c = 1;
    C(Le(i, c), ()=>`Error in maxPool: Either strides or dilations must be 1. Got strides ${i} and dilations '${c}'`);
    const u = $n(o.shape, r, i, c, a, l);
    let d;
    if (u.filterWidth === 1 && u.filterHeight === 1 && $t(u.inShape, u.outShape)) d = rs({
        inputs: {
            x: o
        },
        backend: e
    });
    else {
        const h = e.data.get(o.dataId).values, p = dt(o.shape), f = Bf(h, o.shape, o.dtype, p, u, "max");
        d = e.makeTensorInfo(u.outShape, o.dtype, f.values);
    }
    return d;
}
const rV = {
    kernelName: Cc,
    backendName: "cpu",
    kernelFunc: oV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function iV(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { filterSize: r, strides: i, pad: a, dimRoundingMode: l, dataFormat: c } = s;
    lt(o, "maxPool3d");
    const u = vs(o.shape, r, i, 1, a, l, c), d = e.data.get(o.dataId).values, h = Ow(d, o.shape, o.dtype, dt(o.shape), u, "max");
    return e.makeTensorInfo(h.shape, "float32", h.values);
}
const aV = {
    kernelName: vc,
    backendName: "cpu",
    kernelFunc: iV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function lV(n) {
    const { inputs: t, backend: e, attrs: s } = n, { dy: o, input: r } = t, { filterSize: i, strides: a, pad: l, dimRoundingMode: c } = s;
    lt([
        o,
        r
    ], "maxPool3DGrad");
    const u = vs(r.shape, i, a, 1, l, c), d = e.bufferSync(r), h = QW(d, u), p = u.strideDepth, f = u.strideHeight, m = u.strideWidth, g = u.dilationDepth, b = u.dilationHeight, x = u.dilationWidth, w = u.effectiveFilterDepth, y = u.effectiveFilterHeight, I = u.effectiveFilterWidth, v = w - 1 - u.padInfo.front, k = I - 1 - u.padInfo.left, S = y - 1 - u.padInfo.top, N = vt(r.shape, "float32"), R = e.bufferSync(o);
    for(let M = 0; M < u.batchSize; ++M)for(let V = 0; V < u.inChannels; ++V)for(let z = 0; z < u.inDepth; ++z)for(let P = 0; P < u.inHeight; ++P)for(let A = 0; A < u.inWidth; ++A){
        const O = z - v, B = P - S, Z = A - k;
        let H = 0;
        for(let Y = 0; Y < w; Y += g){
            const Q = (O + Y) / p;
            if (!(Q < 0 || Q >= u.outDepth || Math.floor(Q) !== Q)) for(let j = 0; j < y; j += b){
                const J = (B + j) / f;
                if (!(J < 0 || J >= u.outHeight || Math.floor(J) !== J)) for(let ot = 0; ot < I; ot += x){
                    const q = (Z + ot) / m;
                    if (q < 0 || q >= u.outWidth || Math.floor(q) !== q) continue;
                    const rt = w * y * I - 1 - h.get(M, Q, J, q, V), ht = Y * y * I + j * I + ot, ft = rt === ht ? 1 : 0;
                    if (ft === 0) continue;
                    const pt = R.get(M, Q, J, q, V);
                    H += pt * ft;
                }
            }
        }
        N.set(H, M, z, P, A, V);
    }
    return e.makeTensorInfo(N.shape, N.dtype, N.values);
}
const cV = {
    kernelName: Th,
    backendName: "cpu",
    kernelFunc: lV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function uV(n) {
    const { inputs: t, backend: e, attrs: s } = n, { dy: o, input: r, output: i } = t, a = r;
    lt([
        r,
        i
    ], "maxPoolGrad");
    const { filterSize: l, strides: c, pad: u, dimRoundingMode: d } = s, h = $n(a.shape, l, c, 1, u, d), p = e.data.get(a.dataId).values, f = vt(h.outShape, a.dtype, Aw(p, a.shape, a.dtype, h).values), m = h.strideHeight, g = h.strideWidth, b = h.dilationHeight, x = h.dilationWidth, w = h.effectiveFilterHeight, y = h.effectiveFilterWidth, I = y - 1 - h.padInfo.left, v = w - 1 - h.padInfo.top, k = vt(a.shape, "float32"), S = e.data.get(o.dataId).values, N = vt(o.shape, "float32", S);
    for(let R = 0; R < h.batchSize; ++R)for(let M = 0; M < h.inChannels; ++M)for(let V = 0; V < h.inHeight; ++V)for(let z = 0; z < h.inWidth; ++z){
        const P = V - v, A = z - I;
        let O = 0;
        for(let B = 0; B < w; B += b){
            const Z = (P + B) / m;
            if (!(Z < 0 || Z >= h.outHeight || Math.floor(Z) !== Z)) for(let H = 0; H < y; H += x){
                const Y = (A + H) / g;
                if (Y < 0 || Y >= h.outWidth || Math.floor(Y) !== Y) continue;
                const Q = w * y - 1 - f.get(R, Z, Y, M), j = B * y + H, J = Q === j ? 1 : 0;
                if (J === 0) continue;
                const ot = N.get(R, Z, Y, M);
                O += ot * J;
            }
        }
        k.set(O, R, V, z, M);
    }
    return e.makeTensorInfo(k.shape, k.dtype, k.values);
}
const dV = {
    kernelName: kh,
    backendName: "cpu",
    kernelFunc: uV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function hV(n, t, e, s, o) {
    const r = dt(t), i = Bf(n, t, e, r, o, "max"), a = Aw(n, t, e, o, !0, s);
    return [
        i.values,
        a.values
    ];
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const pV = {
    kernelName: pb,
    backendName: "cpu",
    kernelFunc: ({ inputs: n, attrs: t, backend: e })=>{
        const { x: s } = n, { filterSize: o, strides: r, pad: i, includeBatchInIndex: a } = t, l = e;
        lt(s, "MaxPoolWithArgmax");
        const c = l.data.get(s.dataId).values, u = $n(s.shape, o, r, [
            1,
            1
        ], i), [d, h] = hV(c, s.shape, s.dtype, a, u), p = l.write(d, u.outShape, s.dtype), f = l.write(h, u.outShape, s.dtype);
        return [
            {
                dataId: p,
                shape: u.outShape,
                dtype: s.dtype
            },
            {
                dataId: f,
                shape: u.outShape,
                dtype: "int32"
            }
        ];
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function fV(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r, keepDims: i } = s, a = Ct(r, o.shape), c = ye(o.shape, a)[1], u = X(c), d = [], h = e.makeTensorInfo([], "float32", new Float32Array([
        u
    ]));
    d.push(h);
    const p = Ys({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            dtype: "float32"
        }
    });
    d.push(p);
    const f = Hf({
        inputs: {
            a: p,
            b: h
        },
        backend: e
    });
    d.push(f);
    const m = za({
        inputs: {
            x: f
        },
        backend: e,
        attrs: {
            axis: r,
            keepDims: i
        }
    });
    return d.forEach((g)=>e.disposeIntermediateTensorInfo(g)), m;
}
const mV = {
    kernelName: Sc,
    backendName: "cpu",
    kernelFunc: fV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function gV(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r, keepDims: i } = s;
    lt(o, "min");
    const a = Ct(r, o.shape);
    let l = a;
    const c = qt(l, o.shape.length);
    let u = o;
    c != null && (u = _e({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            perm: c
        }
    }), l = ie(l.length, o.shape.length)), Ne("min", l, u.shape.length);
    const [d, h] = ye(u.shape, l), p = X(h), f = ke(X(d), u.dtype), m = e.data.get(u.dataId).values;
    for(let b = 0; b < f.length; ++b){
        const x = b * p;
        let w = m[x];
        for(let y = 0; y < p; ++y){
            const I = m[x + y];
            (Number.isNaN(I) || I < w) && (w = I);
        }
        f[b] = w;
    }
    c != null && e.disposeIntermediateTensorInfo(u);
    const g = e.makeTensorInfo(d, u.dtype, f);
    if (i) {
        const b = re(d, a), x = Zt({
            inputs: {
                x: g
            },
            backend: e,
            attrs: {
                shape: b
            }
        });
        return e.disposeIntermediateTensorInfo(g), x;
    }
    return g;
}
const bV = {
    kernelName: kc,
    backendName: "cpu",
    kernelFunc: gV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function xV(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { paddings: r, mode: i } = s;
    lt(o, "mirrorPad");
    const a = r.map((w, y)=>w[0] + o.shape[y] + w[1]), l = r.map((w)=>w[0]), c = r.map((w, y)=>w[0] + o.shape[y]), u = i === "reflect" ? 0 : 1, d = e.data.get(o.dataId).values, h = o.shape.length, p = dt(o.shape), f = X(a), m = a.length, g = dt(a), b = Se(o.dtype, f);
    for(let w = 0; w < f; w++){
        let y = Xo(w, m, g);
        for(let v = 0; v < m; v++)y[v] < l[v] ? y[v] = l[v] * 2 - y[v] - u : y[v] >= c[v] && (y[v] = (c[v] - 1) * 2 - y[v] + u);
        y = y.map((v, k)=>v - l[k]);
        const I = zn(y, h, p);
        b[w] = d[I];
    }
    return {
        dataId: e.write(b, a, o.dtype),
        shape: a,
        dtype: o.dtype
    };
}
const yV = {
    kernelName: Tc,
    backendName: "cpu",
    kernelFunc: xV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const wV = le((n, t)=>{
    const e = n % t;
    return n < 0 && t < 0 || n >= 0 && t >= 0 ? e : (e + t) % t;
}), IV = fe(Ji, wV), CV = {
    kernelName: Ji,
    backendName: "cpu",
    kernelFunc: IV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Hw(n) {
    const { inputs: t, backend: e, attrs: s } = n, { logits: o } = t, { dim: r } = s, i = o.shape.length;
    let a = r;
    if (a === -1 && (a = i - 1), a !== i - 1) throw Error(`Softmax along a non-last dimension is not yet supported. Logits was rank ${i} and dim was ${a}`);
    const l = Ct([
        a
    ], o.shape), c = Bw({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            reductionIndices: l,
            keepDims: !1
        }
    }), u = re(c.shape, l), d = Zt({
        inputs: {
            x: c
        },
        backend: e,
        attrs: {
            shape: u
        }
    }), h = Zf({
        inputs: {
            a: o,
            b: d
        },
        backend: e
    }), p = Q1({
        inputs: {
            x: h
        },
        backend: e
    }), f = za({
        inputs: {
            x: p
        },
        backend: e,
        attrs: {
            axis: l,
            keepDims: !1
        }
    }), m = Zt({
        inputs: {
            x: f
        },
        backend: e,
        attrs: {
            shape: u
        }
    }), g = Hf({
        inputs: {
            a: p,
            b: m
        },
        backend: e
    });
    return e.disposeIntermediateTensorInfo(c), e.disposeIntermediateTensorInfo(d), e.disposeIntermediateTensorInfo(h), e.disposeIntermediateTensorInfo(p), e.disposeIntermediateTensorInfo(f), e.disposeIntermediateTensorInfo(m), g;
}
const vV = {
    kernelName: Zc,
    backendName: "cpu",
    kernelFunc: Hw
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function SV(n) {
    const { inputs: t, backend: e, attrs: s } = n, { logits: o } = t, { numSamples: r, seed: i, normalized: a } = s;
    lt(o, "multinomial");
    const l = a ? o : Hw({
        inputs: {
            logits: o
        },
        backend: e,
        attrs: {
            dim: -1
        }
    }), c = l.shape[0], u = l.shape[1], d = e.data.get(l.dataId).values, h = [
        c,
        r
    ], p = ke(X(h), "int32");
    for(let f = 0; f < c; ++f){
        const m = f * u, g = new Float32Array(u - 1);
        g[0] = d[m];
        for(let w = 1; w < g.length; ++w)g[w] = g[w - 1] + d[m + w];
        const b = Nr.alea(i.toString()), x = f * r;
        for(let w = 0; w < r; ++w){
            const y = b();
            p[x + w] = g.length;
            for(let I = 0; I < g.length; I++)if (y < g[I]) {
                p[x + w] = I;
                break;
            }
        }
    }
    return a || e.disposeIntermediateTensorInfo(l), e.makeTensorInfo(h, "int32", p);
}
const kV = {
    kernelName: fb,
    backendName: "cpu",
    kernelFunc: SV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const TV = zp;
function NV(n) {
    const { inputs: t, backend: e, attrs: s } = n, { boxes: o, scores: r } = t, { maxOutputSize: i, iouThreshold: a, scoreThreshold: l } = s;
    lt(o, "NonMaxSuppression");
    const c = e.data.get(o.dataId).values, u = e.data.get(r.dataId).values, { selectedIndices: d } = TV(c, u, i, a, l);
    return e.makeTensorInfo([
        d.length
    ], "int32", new Int32Array(d));
}
const RV = {
    kernelName: Nh,
    backendName: "cpu",
    kernelFunc: NV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $V = Pp;
function GV(n) {
    const { inputs: t, backend: e, attrs: s } = n, { boxes: o, scores: r } = t, { maxOutputSize: i, iouThreshold: a, scoreThreshold: l, padToMaxOutputSize: c } = s;
    lt(o, "NonMaxSuppressionPadded");
    const u = e.data.get(o.dataId).values, d = e.data.get(r.dataId).values, { selectedIndices: h, validOutputs: p } = $V(u, d, i, a, l, c);
    return [
        e.makeTensorInfo([
            h.length
        ], "int32", new Int32Array(h)),
        e.makeTensorInfo([], "int32", new Int32Array([
            p
        ]))
    ];
}
const EV = {
    kernelName: Rh,
    backendName: "cpu",
    kernelFunc: GV
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const LV = Ap;
function MV(n) {
    const { inputs: t, backend: e, attrs: s } = n, { boxes: o, scores: r } = t, { maxOutputSize: i, iouThreshold: a, scoreThreshold: l, softNmsSigma: c } = s;
    lt(o, "NonMaxSuppressionWithScore");
    const u = e.data.get(o.dataId).values, d = e.data.get(r.dataId).values, h = i, p = a, f = l, m = c, { selectedIndices: g, selectedScores: b } = LV(u, d, h, p, f, m);
    return [
        e.makeTensorInfo([
            g.length
        ], "int32", new Int32Array(g)),
        e.makeTensorInfo([
            b.length
        ], "float32", new Float32Array(b))
    ];
}
const WV = {
    kernelName: $h,
    backendName: "cpu",
    kernelFunc: MV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function DV(n) {
    const { inputs: t, backend: e, attrs: s } = n, { indices: o } = t, { dtype: r, depth: i, onValue: a, offValue: l } = s;
    lt(o, "oneHot");
    const c = X(o.shape), u = new Float32Array(c * i);
    u.fill(l);
    const d = e.data.get(o.dataId).values;
    for(let h = 0; h < c; ++h)d[h] >= 0 && d[h] < i && (u[h * i + d[h]] = a);
    return e.makeTensorInfo([
        ...o.shape,
        i
    ], r, u);
}
const FV = {
    kernelName: Gc,
    backendName: "cpu",
    kernelFunc: DV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Al(n) {
    const { inputs: t, backend: e } = n, { x: s } = t;
    if (s.dtype === "string") throw new Error("zerosLike is not supported for string tensors");
    if (s.dtype === "complex64") {
        const o = Do({
            inputs: {
                input: s
            },
            backend: e
        }), r = Al({
            inputs: {
                x: o
            },
            backend: e
        }), i = Ir({
            inputs: {
                input: s
            },
            backend: e
        }), a = Al({
            inputs: {
                x: i
            },
            backend: e
        }), l = Je({
            inputs: {
                real: r,
                imag: a
            },
            backend: e
        });
        return e.disposeIntermediateTensorInfo(o), e.disposeIntermediateTensorInfo(r), e.disposeIntermediateTensorInfo(i), e.disposeIntermediateTensorInfo(a), l;
    } else return _f({
        backend: e,
        attrs: {
            shape: s.shape,
            value: 0,
            dtype: s.dtype
        }
    });
}
const VV = {
    kernelName: Uc,
    backendName: "cpu",
    kernelFunc: Al
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function _w(n) {
    const { inputs: t, backend: e } = n, { x: s } = t;
    if (s.dtype === "string") throw new Error("onesLike is not supported for string tensors");
    if (s.dtype === "complex64") {
        const o = Do({
            inputs: {
                input: s
            },
            backend: e
        }), r = _w({
            inputs: {
                x: o
            },
            backend: e
        }), i = Ir({
            inputs: {
                input: s
            },
            backend: e
        }), a = Al({
            inputs: {
                x: i
            },
            backend: e
        }), l = Je({
            inputs: {
                real: r,
                imag: a
            },
            backend: e
        });
        return e.disposeIntermediateTensorInfo(o), e.disposeIntermediateTensorInfo(r), e.disposeIntermediateTensorInfo(i), e.disposeIntermediateTensorInfo(a), l;
    } else return _f({
        backend: e,
        attrs: {
            shape: s.shape,
            value: 1,
            dtype: s.dtype
        }
    });
}
const zV = {
    kernelName: $c,
    backendName: "cpu",
    kernelFunc: _w
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Uw(n) {
    const { inputs: t, backend: e, attrs: s } = n, { axis: o } = s;
    if (t.length === 1) return Pl({
        inputs: {
            input: t[0]
        },
        backend: e,
        attrs: {
            dim: o
        }
    });
    const r = t[0].shape, i = t[0].dtype;
    t.forEach((u)=>{
        Pe(r, u.shape, "All tensors passed to stack must have matching shapes"), C(i === u.dtype, ()=>"All tensors passed to stack must have matching dtypes");
    });
    const a = [], l = t.map((u)=>{
        const d = Pl({
            inputs: {
                input: u
            },
            backend: e,
            attrs: {
                dim: o
            }
        });
        return a.push(d), d;
    }), c = Cr({
        inputs: l,
        backend: e,
        attrs: {
            axis: o
        }
    });
    return a.forEach((u)=>e.disposeIntermediateTensorInfo(u)), c;
}
const PV = {
    kernelName: Ec,
    backendName: "cpu",
    kernelFunc: Uw
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function AV(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { paddings: r, constantValue: i } = s;
    lt(o, "pad");
    const a = r.map((x, w)=>x[0] + o.shape[w] + x[1]), l = r.map((x)=>x[0]), c = e.data.get(o.dataId).values, u = X(o.shape), d = o.shape.length, h = dt(o.shape), p = X(a), f = a.length, m = dt(a), g = Se(o.dtype, p);
    i !== 0 && g.fill(i);
    for(let x = 0; x < u; x++){
        const y = Xo(x, d, h).map((v, k)=>v + l[k]), I = zn(y, f, m);
        g[I] = c[x];
    }
    return {
        dataId: e.write(g, a, o.dtype),
        shape: a,
        dtype: o.dtype
    };
}
const Yw = {
    kernelName: Lc,
    backendName: "cpu",
    kernelFunc: AV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const OV = le((n, t)=>Math.pow(n, t)), XV = fe(qi, OV), KV = {
    kernelName: qi,
    backendName: "cpu",
    kernelFunc: XV
};
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ZV(n) {
    const { inputs: t, backend: e, attrs: s } = n, { paramsNestedSplits: o, paramsDenseValues: r, indices: i } = t, a = o.map((g)=>e.data.get(g.dataId).values), l = o.map((g)=>g.shape), c = e.data.get(r.dataId).values, u = e.data.get(i.dataId).values, [d, h, p] = fw(a, l, c, r.shape, r.dtype, u, i.shape), f = d.map((g)=>e.makeTensorInfo([
            g.length
        ], "int32", g)), m = e.makeTensorInfo(p, r.dtype, h);
    return f.concat([
        m
    ]);
}
const BV = {
    kernelName: mb,
    backendName: "cpu",
    kernelFunc: ZV
};
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function HV(n) {
    const { inputs: t, backend: e } = n, { starts: s, limits: o, deltas: r } = t, i = e.data.get(s.dataId).values, a = e.data.get(o.dataId).values, l = e.data.get(r.dataId).values, [c, u] = mw(i, s.shape, s.dtype, a, o.shape, l, r.shape), d = e.makeTensorInfo([
        c.length
    ], "int32", c), h = e.makeTensorInfo([
        u.length
    ], s.dtype, u);
    return [
        d,
        h
    ];
}
const _V = {
    kernelName: gb,
    backendName: "cpu",
    kernelFunc: HV
};
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function UV(n) {
    const { inputs: t, backend: e, attrs: s } = n, { shape: o, values: r, defaultValue: i, rowPartitionTensors: a } = t, { rowPartitionTypes: l } = s, c = e.data.get(o.dataId).values, u = e.data.get(r.dataId).values, d = e.data.get(i.dataId).values, h = a.map((g)=>e.data.get(g.dataId).values), p = a.map((g)=>g.shape), [f, m] = gw(c, o.shape, u, r.shape, r.dtype, d, i.shape, h, p, l);
    return e.makeTensorInfo(f, r.dtype, m);
}
const YV = {
    kernelName: bb,
    backendName: "cpu",
    kernelFunc: UV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function QV(n) {
    const { backend: t, attrs: e } = n, { start: s, stop: o, dtype: r, step: i } = e, a = bw(s, o, i, r);
    return t.makeTensorInfo([
        a.length
    ], r, a);
}
const JV = {
    kernelName: Gh,
    backendName: "cpu",
    kernelFunc: QV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const jV = Wt(ta, (n)=>1 / n), qV = {
    kernelName: ta,
    backendName: "cpu",
    kernelFunc: jV
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function tz(n) {
    const { inputs: t, backend: e, attrs: s } = n, { images: o } = t, { alignCorners: r, halfPixelCenters: i, size: a } = s;
    lt(o, "resizeBilinear");
    const l = dt(o.shape), [c, u] = a, [d, h, p, f] = o.shape, m = e.data.get(o.dataId).values, g = new Float32Array(X([
        d,
        c,
        u,
        f
    ])), b = [
        r && c > 1 ? h - 1 : h,
        r && u > 1 ? p - 1 : p
    ], x = [
        r && c > 1 ? c - 1 : c,
        r && u > 1 ? u - 1 : u
    ];
    let w = 0;
    const y = b[0] / x[0], I = b[1] / x[1];
    for(let v = 0; v < d; v++)for(let k = 0; k < c; k++){
        let S;
        i ? S = y * (k + 0.5) - 0.5 : S = y * k;
        const N = Math.max(0, Math.floor(S)), R = S - N, M = Math.min(h - 1, Math.ceil(S)), V = v * l[0] + N * l[1], z = v * l[0] + M * l[1];
        for(let P = 0; P < u; P++){
            let A;
            i ? A = I * (P + 0.5) - 0.5 : A = I * P;
            const O = Math.max(0, Math.floor(A)), B = A - O, Z = Math.min(p - 1, Math.ceil(A)), H = V + O * l[2], Y = z + O * l[2], Q = V + Z * l[2], j = z + Z * l[2];
            for(let J = 0; J < f; J++){
                const ot = m[H + J], q = m[Y + J], rt = m[Q + J], ht = m[j + J], ft = ot + (rt - ot) * B, pt = q + (ht - q) * B, wt = ft + (pt - ft) * R;
                g[w++] = wt;
            }
        }
    }
    return e.makeTensorInfo([
        d,
        c,
        u,
        f
    ], "float32", g);
}
const ez = {
    kernelName: Vc,
    backendName: "cpu",
    kernelFunc: tz
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function nz(n) {
    const { inputs: t, backend: e, attrs: s } = n, { images: o, dy: r } = t, { alignCorners: i } = s;
    lt([
        r,
        o
    ], "resizeBilinearGrad");
    const a = dt(o.shape), [l, c, u, d] = o.shape, [, h, p] = r.shape, f = new Float32Array(l * c * u * d), m = [
        i && h > 1 ? c - 1 : c,
        i && p > 1 ? u - 1 : u
    ], g = [
        i && h > 1 ? h - 1 : h,
        i && p > 1 ? p - 1 : p
    ], b = m[0] / g[0], x = m[1] / g[1], w = e.data.get(r.dataId).values;
    let y = 0;
    for(let I = 0; I < l; I++){
        const v = I * a[0];
        for(let k = 0; k < h; k++){
            const S = k * b, N = Math.floor(S), R = Math.min(Math.ceil(S), c - 1), M = v + N * a[1], V = v + R * a[1], z = S - N, P = 1 - z;
            for(let A = 0; A < p; A++){
                const O = A * x, B = Math.floor(O), Z = Math.min(Math.ceil(O), u - 1), H = O - B, Y = 1 - H, Q = M + B * a[2], j = M + Z * a[2], J = V + B * a[2], ot = V + Z * a[2], q = P * Y, rt = P * H, ht = z * Y, ft = z * H;
                for(let pt = 0; pt < d; pt++){
                    const wt = w[y++];
                    f[Q + pt] += wt * q, f[j + pt] += wt * rt, f[J + pt] += wt * ht, f[ot + pt] += wt * ft;
                }
            }
        }
    }
    return e.makeTensorInfo([
        l,
        u,
        c,
        d
    ], "float32", f);
}
const sz = {
    kernelName: Mh,
    backendName: "cpu",
    kernelFunc: nz
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function oz(n) {
    const { inputs: t, backend: e, attrs: s } = n, { images: o } = t, { alignCorners: r, halfPixelCenters: i, size: a } = s;
    lt(o, "resizeNearestNeighbor");
    const l = dt(o.shape), [c, u] = a, [d, h, p, f] = o.shape, m = e.data.get(o.dataId).values, g = new Float32Array(d * c * u * f), b = [
        r && c > 1 ? h - 1 : h,
        r && u > 1 ? p - 1 : p
    ], x = [
        r && c > 1 ? c - 1 : c,
        r && u > 1 ? u - 1 : u
    ], w = b[0] / x[0], y = b[1] / x[1];
    let I = 0;
    for(let v = 0; v < d; v++){
        const k = v * l[0];
        for(let S = 0; S < c; S++){
            const N = i ? w * (S + 0.5) : w * S;
            let R = Math.min(h - 1, r ? Math.round(N) : Math.floor(N));
            i && (R = Math.max(0, R));
            const M = k + R * l[1];
            for(let V = 0; V < u; V++){
                const z = i ? y * (V + 0.5) : y * V;
                let P = Math.min(p - 1, r ? Math.round(z) : Math.floor(z));
                i && (P = Math.max(0, P));
                const A = M + P * l[2];
                for(let O = 0; O < f; O++){
                    const B = m[A + O];
                    g[I++] = B;
                }
            }
        }
    }
    return e.makeTensorInfo([
        d,
        c,
        u,
        f
    ], o.dtype, g);
}
const rz = {
    kernelName: Fc,
    backendName: "cpu",
    kernelFunc: oz
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function iz(n) {
    const { inputs: t, backend: e, attrs: s } = n, { images: o, dy: r } = t, { alignCorners: i } = s;
    lt([
        r,
        o
    ], "resizeNearestNeighborGrad");
    const a = dt(o.shape), l = dt(r.shape), [c, u, d, h] = o.shape, [, p, f] = r.shape, m = new Float32Array(c * u * d * h), g = e.data.get(r.dataId).values, b = [
        i && p > 1 ? u - 1 : u,
        i && f > 1 ? d - 1 : d
    ], x = [
        i && p > 1 ? p - 1 : p,
        i && f > 1 ? f - 1 : f
    ], w = b[0] / x[0], y = b[1] / x[1], I = 1 / w, v = 1 / y, k = Math.ceil(I) * 2 + 2, S = Math.ceil(v) * 2 + 2;
    for(let N = 0; N < c; N++){
        const R = N * a[0];
        for(let M = 0; M < u; M++){
            const V = R + M * a[1], z = Math.floor(M * I), P = Math.floor(z - k / 2);
            for(let A = 0; A < d; A++){
                const O = V + A * a[2], B = Math.floor(A * v), Z = Math.floor(B - S / 2);
                for(let H = 0; H < h; H++){
                    let Y = 0;
                    for(let Q = 0; Q < k; Q++){
                        const j = Q + P;
                        if (j < 0 || j >= p) continue;
                        const J = R + j * l[1], ot = j * w, q = Math.min(u - 1, i ? Math.round(ot) : Math.floor(ot));
                        if (M === q) for(let rt = 0; rt < S; rt++){
                            const ht = rt + Z;
                            if (ht < 0 || ht >= f) continue;
                            const ft = J + ht * l[2], pt = ht * y, wt = Math.min(d - 1, i ? Math.round(pt) : Math.floor(pt));
                            A === wt && (Y += g[ft + H]);
                        }
                    }
                    m[O + H] = Y;
                }
            }
        }
    }
    return e.makeTensorInfo(o.shape, o.dtype, m);
}
const az = {
    kernelName: Lh,
    backendName: "cpu",
    kernelFunc: iz
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function lz(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { dims: r } = s;
    lt(o, "reverse");
    const i = o.shape.length, a = Ct(r, o.shape);
    if (i === 0) return rs({
        inputs: {
            x: o
        },
        backend: e
    });
    const l = new ve(o.shape, o.dtype), c = e.bufferSync(o);
    for(let u = 0; u < l.size; u++){
        const d = l.indexToLoc(u), h = d.slice();
        a.forEach((p)=>h[p] = o.shape[p] - 1 - h[p]), l.set(c.get(...h), ...d);
    }
    return e.makeTensorInfo(l.shape, l.dtype, l.values);
}
const cz = {
    kernelName: zc,
    backendName: "cpu",
    kernelFunc: lz
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const uz = {
    kernelName: Hh,
    backendName: "cpu",
    kernelFunc: ({ inputs: n, attrs: t, backend: e })=>{
        const { image: s } = n, { radians: o, fillValue: r, center: i } = t, a = e, l = Se(s.dtype, X(s.shape)), [c, u, d, h] = s.shape, [p, f] = Jp(i, u, d), m = 255, g = Math.sin(o), b = Math.cos(o), x = a.data.get(s.dataId).values;
        for(let y = 0; y < c; y++){
            const I = y * d * u * h;
            for(let v = 0; v < u; v++){
                const k = v * (d * h);
                for(let S = 0; S < d; S++){
                    const N = S * h;
                    for(let R = 0; R < h; R++){
                        const M = [
                            c,
                            v,
                            S,
                            R
                        ], V = M[2], z = M[1];
                        let P = (V - p) * b - (z - f) * g, A = (V - p) * g + (z - f) * b;
                        P = Math.round(P + p), A = Math.round(A + f);
                        let O = r;
                        if (typeof r != "number" && (R === 3 ? O = m : O = r[R]), P >= 0 && P < d && A >= 0 && A < u) {
                            const Z = A * (d * h), H = P * h, Y = I + Z + H + R;
                            O = x[Y];
                        }
                        const B = I + k + N + R;
                        l[B] = O;
                    }
                }
            }
        }
        return {
            dataId: a.write(l, s.shape, s.dtype),
            shape: s.shape,
            dtype: s.dtype
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const dz = Wt(sa, (n)=>{
    const t = Math.floor(n);
    return n - t < 0.5 ? Math.floor(n) : n - t > 0.5 ? Math.ceil(n) : t % 2 === 0 ? t : t + 1;
}), hz = {
    kernelName: sa,
    backendName: "cpu",
    kernelFunc: dz
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function pz(n) {
    const { inputs: t, backend: e, attrs: s } = n, { indices: o, updates: r } = t, { shape: i } = s, { sliceRank: a, numUpdates: l, sliceSize: c, strides: u, outputSize: d } = to(r, o, i), h = !0, p = e.bufferSync(o), f = e.bufferSync(r), m = bo(p, f, i, d, c, l, a, u, 0, h);
    return e.makeTensorInfo(i, m.dtype, m.values);
}
const fz = {
    kernelName: xb,
    backendName: "cpu",
    kernelFunc: pz
};
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function mz(n, t) {
    let e = 0, s = n.length, o = 0;
    for(; e < s;)o = Math.floor((e + s) / 2), n[o] < t ? e = o + 1 : s = o;
    return s;
}
function gz(n, t) {
    let e = 0, s = n.length, o = 0;
    for(; e < s;)o = Math.floor((e + s) / 2), n[o] <= t ? e = o + 1 : s = o;
    return s;
}
function bz(n, t, e, s, o, r) {
    const i = ne("int32", e * o);
    for(let a = 0; a < e; ++a){
        const l = n.slice(a * s, (a + 1) * s), c = a * o;
        for(let u = 0; u < o; ++u)i[c + u] = r === "left" ? mz(l, t[u + c]) : gz(l, t[u + c]);
    }
    return i;
}
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function xz(n) {
    const { inputs: t, backend: e, attrs: s } = n, { sortedSequence: o, values: r } = t, { side: i } = s, a = e.data.get(o.dataId).values, l = e.data.get(r.dataId).values, c = bz(a, l, o.shape[0], o.shape[1], r.shape[1], i);
    return e.makeTensorInfo(r.shape, "int32", c);
}
const yz = {
    kernelName: wb,
    backendName: "cpu",
    kernelFunc: xz
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function wz(n) {
    const { inputs: t, backend: e } = n, { condition: s, t: o, e: r } = t;
    lt([
        s,
        o,
        r
    ], "select");
    const i = s.shape.length, a = e.data.get(s.dataId).values, l = e.data.get(o.dataId).values, c = e.data.get(r.dataId).values, u = tn(o.dtype, r.dtype), d = ke(X(o.shape), u);
    let h = 0;
    const p = i === 0 || i > 1 || o.shape.length === 1 ? 1 : X(o.shape.slice(1));
    for(let f = 0; f < a.length; f++)for(let m = 0; m < p; m++)a[f] === 1 ? d[h++] = l[f] : d[h++] = c[f];
    return e.makeTensorInfo(o.shape, u, d);
}
const Iz = {
    kernelName: Pc,
    backendName: "cpu",
    kernelFunc: wz
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Cz = ru, vz = iu, Sz = Wt(ra, (n)=>n >= 0 ? vz * n : Cz * (Math.exp(n) - 1)), kz = {
    kernelName: ra,
    backendName: "cpu",
    kernelFunc: Sz
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Tz = Wt(la, (n)=>n < 0 ? -1 : n > 0 ? 1 : 0), Nz = {
    kernelName: la,
    backendName: "cpu",
    kernelFunc: Tz
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Rz = Wt(ia, (n)=>Math.sin(n)), $z = {
    kernelName: ia,
    backendName: "cpu",
    kernelFunc: Rz
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Gz = Wt(aa, (n)=>Math.sinh(n)), Ez = {
    kernelName: aa,
    backendName: "cpu",
    kernelFunc: Gz
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Lz = 11920928955078125e-23, bg = Math.log(Lz) + 2, Mz = Wt(ua, (n)=>{
    const t = n > -bg, e = n < bg, s = Math.exp(n);
    let o;
    return e ? o = s : t ? o = n : o = Math.log(1 + s), o;
}), Wz = {
    kernelName: ua,
    backendName: "cpu",
    kernelFunc: Mz
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Dz(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { blockShape: r, paddings: i } = s;
    lt([
        o
    ], "spaceToBatchND");
    const a = X(r), l = [
        [
            0,
            0
        ]
    ];
    l.push(...i);
    for(let v = 1 + r.length; v < o.shape.length; ++v)l.push([
        0,
        0
    ]);
    const c = Yw.kernelFunc({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            paddings: l,
            constantValue: 0
        }
    }), u = Na(c.shape, r, a, !1), d = Ra(u.length, r.length, !1), h = $a(c.shape, r, a, !1), m = Zt({
        inputs: {
            x: c
        },
        backend: e,
        attrs: {
            shape: u
        }
    }), x = _e({
        inputs: {
            x: m
        },
        backend: e,
        attrs: {
            perm: d
        }
    }), I = Zt({
        inputs: {
            x: x
        },
        backend: e,
        attrs: {
            shape: h
        }
    });
    return e.disposeIntermediateTensorInfo(c), e.disposeIntermediateTensorInfo(m), e.disposeIntermediateTensorInfo(x), I;
}
const Fz = {
    kernelName: Xc,
    backendName: "cpu",
    kernelFunc: Dz
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Vz(n) {
    const { inputs: t, backend: e } = n, { indices: s, values: o, denseShape: r, defaultValue: i } = t;
    if (r.shape.length !== 1) throw new Error(`Dense shape must be a vector, saw:
        ${r.shape}`);
    if (s.shape.length !== 2) throw new Error(`Indices must be a matrix, saw:
        ${s.shape}`);
    if (o.shape.length !== 1) throw new Error(`Values must be a vector, saw:
        ${o.shape}`);
    if (i.shape.length !== 0) throw new Error(`Default value must be a scalar, saw:
        ${i.shape}`);
    const a = e.data.get(s.dataId).values, l = e.data.get(o.dataId).values, c = e.data.get(r.dataId).values, u = e.data.get(i.dataId).values[0], [d, h, p, f, m] = Iw(a, s.shape, s.dtype, l, o.dtype, c, u);
    return [
        e.makeTensorInfo(h, s.dtype, d),
        e.makeTensorInfo([
            h[0]
        ], o.dtype, p),
        e.makeTensorInfo([
            f.length
        ], "bool", new Uint8Array(f.map((g)=>Number(g)))),
        e.makeTensorInfo([
            m.length
        ], s.dtype, new Int32Array(m))
    ];
}
const zz = {
    kernelName: Wh,
    backendName: "cpu",
    kernelFunc: Vz
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Pz(n) {
    const { inputs: t, backend: e } = n, { inputIndices: s, inputShape: o, newShape: r } = t;
    if (s.shape.length !== 2) throw new Error(`Input indices should be a matrix but received shape
        ${s.shape}`);
    if (o.shape.length !== 1) throw new Error(`Input shape should be a vector but received shape
        ${o.shape}`);
    if (r.shape.length !== 1) throw new Error(`Target shape should be a vector but received shape ${r.shape}`);
    const i = Array.from(e.data.get(o.dataId).values), a = e.data.get(s.dataId).values, l = Array.from(e.data.get(r.dataId).values), [c, u, d] = Cw(a, s.shape, s.dtype, i, l);
    return [
        e.makeTensorInfo(u, s.dtype, c),
        e.makeTensorInfo([
            d.length
        ], r.dtype, new Int32Array(d))
    ];
}
const Az = {
    kernelName: Dh,
    backendName: "cpu",
    kernelFunc: Pz
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Oz(n) {
    const { inputs: t, backend: e } = n, { data: s, indices: o, segmentIds: r } = t;
    if (s.shape.length < 1) throw new Error("Data should be at least 1 dimensional but received scalar");
    if (o.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
          ${o.shape}`);
    if (r.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
          ${r.shape}`);
    if (o.shape[0] !== r.shape[0]) throw new Error("segmentIds and indices should have same size.");
    const i = e.data.get(s.dataId).values, a = e.data.get(o.dataId).values, l = e.data.get(r.dataId).values, [c, u] = Kf(i, s.shape, s.dtype, a, l, !0);
    return e.makeTensorInfo(u, s.dtype, c);
}
const Xz = {
    kernelName: Fh,
    backendName: "cpu",
    kernelFunc: Oz
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Kz(n) {
    const { inputs: t, backend: e } = n, { data: s, indices: o, segmentIds: r } = t;
    if (s.shape.length < 1) throw new Error("Data should be at least 1 dimensional but received scalar");
    if (o.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
         ${o.shape}`);
    if (r.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
         ${r.shape}`);
    if (o.shape[0] !== r.shape[0]) throw new Error("segmentIds and indices should have same size.");
    const i = e.data.get(s.dataId).values, a = e.data.get(o.dataId).values, l = e.data.get(r.dataId).values, [c, u] = Kf(i, s.shape, s.dtype, a, l);
    return e.makeTensorInfo(u, s.dtype, c);
}
const Zz = {
    kernelName: Vh,
    backendName: "cpu",
    kernelFunc: Kz
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Bz(n) {
    const { inputs: t, backend: e, attrs: s } = n, { sparseIndices: o, sparseValues: r, defaultValue: i } = t, { outputShape: a } = s, { sliceRank: l, numUpdates: c, sliceSize: u, strides: d, outputSize: h } = to(r, o, a), p = !1, f = e.bufferSync(o);
    let m;
    switch(r.dtype){
        case "bool":
            {
                const g = e.bufferSync(r), b = !!e.data.get(i.dataId).values[0];
                m = bo(f, g, a, h, u, c, l, d, b, p);
                break;
            }
        case "float32":
            {
                const g = e.bufferSync(r), b = e.data.get(i.dataId).values[0];
                m = bo(f, g, a, h, u, c, l, d, b, p);
                break;
            }
        case "int32":
            {
                const g = e.bufferSync(r), b = e.data.get(i.dataId).values[0];
                m = bo(f, g, a, h, u, c, l, d, b, p);
                break;
            }
        case "string":
            {
                const g = e.bufferSync(r), b = gs(e.data.get(i.dataId).values[0]);
                m = bo(f, g, a, h, u, c, l, d, b, p);
                break;
            }
        default:
            throw new Error(`Unsupported type ${r.dtype}`);
    }
    return e.makeTensorInfo(a, m.dtype, m.values);
}
const Hz = {
    kernelName: Ib,
    backendName: "cpu",
    kernelFunc: Bz
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function _z(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { numOrSizeSplits: r, axis: i } = s, a = Ct(i, o.shape)[0], l = pf(o, r, a), c = new Array(o.shape.length).fill(0), u = o.shape.slice();
    return l.map((d)=>{
        const h = [
            ...u
        ];
        h[a] = d;
        const p = Fo({
            inputs: {
                x: o
            },
            backend: e,
            attrs: {
                begin: c,
                size: h
            }
        });
        return c[a] += d, p;
    });
}
const Uz = {
    kernelName: Kc,
    backendName: "cpu",
    kernelFunc: _z
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Yz = {
    kernelName: zh,
    backendName: "cpu",
    kernelFunc: ({ inputs: n, backend: t })=>{
        const { x: e } = n, s = t;
        lt(e, "square");
        const o = s.data.get(e.dataId).values, r = new Float32Array(o.length);
        for(let a = 0; a < o.length; ++a){
            const l = o[a];
            r[a] = l * l;
        }
        return {
            dataId: s.write(r, e.shape, e.dtype),
            shape: e.shape,
            dtype: e.dtype
        };
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Qz = Wt(ba, (n, t)=>{
    const e = t;
    return isNaN(n) ? NaN : n > 0 ? 1 : e.alpha;
}), Jz = {
    kernelName: ba,
    backendName: "cpu",
    kernelFunc: Qz
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function jz(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { begin: r, end: i, strides: a, beginMask: l, endMask: c, ellipsisMask: u, newAxisMask: d, shrinkAxisMask: h } = s;
    lt(o, "stridedSlice");
    const { finalShapeSparse: p, finalShape: f, isIdentity: m, sliceDim0: g, isSimpleSlice: b, begin: x, end: w, strides: y } = Up(o.shape, r, i, a, l, c, u, d, h);
    let I;
    if (m) I = Zt({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            shape: f
        }
    });
    else if (g || b) {
        C(o.shape.length >= 1, ()=>`Input must have rank at least 1, got: ${o.shape.length}`);
        const v = Bp(x, w, y), k = Fo({
            inputs: {
                x: o
            },
            backend: e,
            attrs: {
                begin: x,
                size: v
            }
        });
        I = Zt({
            inputs: {
                x: k
            },
            backend: e,
            attrs: {
                shape: f
            }
        }), e.disposeIntermediateTensorInfo(k);
    } else {
        const v = e.bufferSync(o), k = kw(p, v, y, x);
        I = e.makeTensorInfo(f, k.dtype, k.values);
    }
    return I;
}
const qz = {
    kernelName: Ph,
    backendName: "cpu",
    kernelFunc: jz
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function tP(n) {
    const { inputs: t, backend: e, attrs: s } = n, { separator: o, nGramWidths: r, leftPad: i, rightPad: a, padWidth: l, preserveShortSequences: c } = s, { data: u, dataSplits: d } = t, h = e.data.get(u.dataId).values, p = e.data.get(d.dataId).values, [f, m] = Tw(h, p, o, r, i, a, l, c);
    return [
        e.makeTensorInfo([
            f.length
        ], "string", f),
        e.makeTensorInfo(d.shape, "int32", m)
    ];
}
const eP = {
    kernelName: Ah,
    backendName: "cpu",
    kernelFunc: tP
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function nP(n) {
    const { inputs: t, backend: e, attrs: s } = n, { skipEmpty: o } = s, { input: r, delimiter: i } = t;
    if (r.dtype !== "string") throw new Error("Input must be of datatype string");
    if (r.shape.length !== 1) throw new Error(`Input must be a vector, got shape: ${r.shape}`);
    if (i.shape.length !== 0) throw new Error(`Delimiter must be a scalar, got shape: ${i.shape}`);
    const a = e.data.get(r.dataId).values, l = e.data.get(i.dataId).values[0], [c, u, d] = Nw(a, l, o), h = u.length;
    return [
        e.makeTensorInfo([
            h,
            2
        ], "int32", c),
        e.makeTensorInfo([
            h
        ], "string", u),
        e.makeTensorInfo([
            2
        ], "int32", new Int32Array(d))
    ];
}
const sP = {
    kernelName: Oh,
    backendName: "cpu",
    kernelFunc: nP
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function oP(n) {
    const { inputs: t, backend: e, attrs: s } = n, { numBuckets: o } = s, { input: r } = t;
    if (r.dtype !== "string") throw new Error("Input must be of datatype string");
    if (o <= 0) throw new Error("Number of buckets must be at least 1");
    const i = e.data.get(r.dataId).values, a = Rw(i, o);
    return e.makeTensorInfo(r.shape, "int32", a);
}
const rP = {
    kernelName: Xh,
    backendName: "cpu",
    kernelFunc: oP
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const iP = Wt(fa, (n)=>Math.tan(n)), aP = {
    kernelName: fa,
    backendName: "cpu",
    kernelFunc: iP
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const lP = Wt(ma, (n)=>Math.tanh(n)), cP = {
    kernelName: ma,
    backendName: "cpu",
    kernelFunc: lP
};
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function uP(n) {
    const { inputs: t, backend: e } = n, { tensor: s, indices: o, updates: r } = t, { sliceRank: i, numUpdates: a, sliceSize: l, strides: c, outputSize: u } = to(r, o, s.shape), d = !1, h = e.bufferSync(o), p = e.bufferSync(r), f = e.bufferSync(s), m = bo(h, p, s.shape, u, l, a, i, c, f, d);
    return e.makeTensorInfo(s.shape, m.dtype, m.values);
}
const dP = {
    kernelName: yb,
    backendName: "cpu",
    kernelFunc: uP
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function hP(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { reps: r } = s;
    lt(o, "tile");
    const i = Gw(e.bufferSync(o), r);
    return e.makeTensorInfo(i.shape, i.dtype, i.values);
}
const pP = {
    kernelName: ga,
    backendName: "cpu",
    kernelFunc: hP
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function fP(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { k: r, sorted: i } = s;
    lt(o, "topk");
    const a = e.data.get(o.dataId).values, [l, c] = Lw(a, o.shape, o.dtype, r, i);
    return [
        e.makeTensorInfo(l.shape, l.dtype, l.values),
        e.makeTensorInfo(c.shape, c.dtype, c.values)
    ];
}
const mP = {
    kernelName: Kh,
    backendName: "cpu",
    kernelFunc: fP
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function gP(n) {
    const { inputs: t, attrs: e, backend: s } = n, { image: o, transforms: r } = t, { interpolation: i, fillMode: a, fillValue: l, outputShape: c } = e, [u, d, h, p] = o.shape, [f, m] = c ?? [
        d,
        h
    ], g = [
        u,
        f,
        m,
        p
    ], b = dt(o.shape), x = b[0], w = b[1], y = b[2], I = dt(g), v = I[0], k = I[1], S = I[2], N = Se(o.dtype, X(g));
    N.fill(l);
    const R = s.data.get(o.dataId).values, M = s.data.get(r.dataId).values;
    for(let z = 0; z < u; ++z){
        const P = r.shape[0] === 1 ? M : M.subarray(z * 8, z * 8 + 8);
        for(let A = 0; A < f; ++A)for(let O = 0; O < m; ++O)for(let B = 0; B < p; ++B){
            let Z;
            const H = P[6] * O + P[7] * A + 1;
            if (H === 0) continue;
            const Y = (P[0] * O + P[1] * A + P[2]) / H, Q = (P[3] * O + P[4] * A + P[5]) / H, j = xg(Y, h, a), J = xg(Q, d, a);
            switch(i){
                case "nearest":
                    Z = CP(R, d, h, x, w, y, z, J, j, B, l);
                    break;
                case "bilinear":
                    Z = vP(R, d, h, x, w, y, z, J, j, B, l);
                    break;
                default:
                    throw new Error(`Error in Transform: Expect 'nearest' or 'bilinear', but got ${i}`);
            }
            const ot = z * v + A * k + O * S + B;
            N[ot] = Z;
        }
        return s.makeTensorInfo(g, o.dtype, N);
    }
    return {
        dataId: s.write(N, g, o.dtype),
        shape: o.shape,
        dtype: o.dtype
    };
}
const bP = {
    kernelName: Zh,
    backendName: "cpu",
    kernelFunc: gP
};
function xg(n, t, e) {
    switch(e){
        case "reflect":
            return xP(n, t);
        case "wrap":
            return yP(n, t);
        case "nearest":
            return IP(n, t);
        case "constant":
        default:
            return wP(n);
    }
}
function xP(n, t) {
    let e = n;
    if (e < 0) {
        if (t <= 1) e = 0;
        else {
            const s = 2 * t;
            e < s && (e = s * Math.trunc(-e / s) + e), e = e < -t ? e + s : -e - 1;
        }
    } else if (e > t - 1) {
        if (t <= 1) e = 0;
        else {
            const s = 2 * t;
            e -= s * Math.trunc(e / s), e >= t && (e = s - e - 1);
        }
    }
    return Os(0, e, t - 1);
}
function yP(n, t) {
    let e = n;
    if (e < 0) {
        if (t <= 1) e = 0;
        else {
            const s = t - 1;
            e += t * (Math.trunc(-e / s) + 1);
        }
    } else if (e > t - 1) {
        if (t <= 1) e = 0;
        else {
            const s = t - 1;
            e -= t * Math.trunc(e / s);
        }
    }
    return Os(0, e, t - 1);
}
function wP(n, t) {
    return n;
}
function IP(n, t) {
    return Os(0, n, t - 1);
}
function Jr(n, t, e, s, o, r, i, a, l, c, u) {
    const d = i * s + a * o + l * r + c;
    return 0 <= a && a < t && 0 <= l && l < e ? n[d] : u;
}
function CP(n, t, e, s, o, r, i, a, l, c, u) {
    const d = Math.round(a), h = Math.round(l);
    return Jr(n, t, e, s, o, r, i, d, h, c, u);
}
function vP(n, t, e, s, o, r, i, a, l, c, u) {
    const d = Math.floor(a), h = Math.floor(l), p = d + 1, f = h + 1, m = (f - l) * Jr(n, t, e, s, o, r, i, d, h, c, u) + (l - h) * Jr(n, t, e, s, o, r, i, d, f, c, u), g = (f - l) * Jr(n, t, e, s, o, r, i, p, h, c, u) + (l - h) * Jr(n, t, e, s, o, r, i, p, f, c, u);
    return (p - a) * m + (a - d) * g;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function SP(n) {
    const { inputs: t, attrs: e, backend: s } = n, { axis: o } = e, { x: r } = t;
    lt(r, "unique");
    const i = s.data.get(r.dataId).values, { outputValues: a, outputShape: l, indices: c } = Mw(i, o, r.shape, r.dtype);
    return [
        s.makeTensorInfo(l, r.dtype, a),
        s.makeTensorInfo([
            c.length
        ], "int32", c)
    ];
}
const kP = {
    kernelName: Bh,
    backendName: "cpu",
    kernelFunc: SP
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function TP(n) {
    const { inputs: t, backend: e, attrs: s } = n, { value: o } = t;
    let { axis: r } = s;
    r < 0 && (r += o.shape.length);
    const i = o.shape.length, a = o.shape[r], l = new Array(i - 1);
    let c = 0;
    for(let p = 0; p < i; p++)p !== r && (l[c++] = o.shape[p]);
    const u = new Array(i).fill(0), d = o.shape.slice();
    d[r] = 1;
    const h = new Array(a);
    for(let p = 0; p < h.length; p++){
        u[r] = p;
        const f = Fo({
            inputs: {
                x: o
            },
            backend: e,
            attrs: {
                begin: u,
                size: d
            }
        });
        h[p] = Zt({
            inputs: {
                x: f
            },
            backend: e,
            attrs: {
                shape: l
            }
        }), e.disposeIntermediateTensorInfo(f);
    }
    return h;
}
const NP = {
    kernelName: Hc,
    backendName: "cpu",
    kernelFunc: TP
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function RP(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, segmentIds: r } = t, { numSegments: i } = s;
    lt(o, "unsortedSegmentSum");
    const a = o.shape.length, l = r.shape.length, c = [], u = [], d = a - l;
    let h = r;
    for(let f = 0; f < d; ++f){
        const m = Pl({
            inputs: {
                input: h
            },
            backend: e,
            attrs: {
                dim: f + 1
            }
        });
        h = m, u.push(m);
    }
    for(let f = 0; f < i; ++f){
        const m = Is(f, "int32"), g = e.makeTensorInfo([], "int32", m), b = U1({
            inputs: {
                a: g,
                b: h
            },
            backend: e
        }), x = Ys({
            inputs: {
                x: b
            },
            backend: e,
            attrs: {
                dtype: "float32"
            }
        }), w = wu({
            inputs: {
                a: x,
                b: o
            },
            backend: e
        }), y = za({
            inputs: {
                x: w
            },
            backend: e,
            attrs: {
                axis: 0,
                keepDims: !1
            }
        });
        c.push(y), u.push(g), u.push(b), u.push(x), u.push(w), u.push(y);
    }
    const p = Uw({
        inputs: c,
        backend: e,
        attrs: {
            axis: 0
        }
    });
    return u.forEach((f)=>e.disposeIntermediateTensorInfo(f)), p;
}
const $P = {
    kernelName: _c,
    backendName: "cpu",
    kernelFunc: RP
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const GP = [
    SW,
    oM,
    TW,
    RW,
    uM,
    GW,
    LW,
    WW,
    FW,
    zW,
    AW,
    XW,
    ZW,
    _W,
    YW,
    jW,
    tD,
    nD,
    oD,
    CW,
    iD,
    lD,
    uD,
    hM,
    hD,
    lM,
    fM,
    fD,
    rM,
    gD,
    xD,
    yD,
    ID,
    vD,
    kD,
    ND,
    $D,
    ED,
    MD,
    DD,
    VD,
    PD,
    OD,
    KD,
    ZD,
    HD,
    UD,
    QD,
    JD,
    jD,
    qD,
    eF,
    oF,
    mW,
    iF,
    mM,
    fF,
    gM,
    mF,
    xM,
    IF,
    CF,
    SF,
    wM,
    CM,
    TF,
    RF,
    GF,
    LF,
    SM,
    TM,
    iM,
    WF,
    bD,
    FF,
    zF,
    AF,
    gW,
    RM,
    GM,
    XF,
    LM,
    ZF,
    _F,
    YF,
    jF,
    tV,
    nV,
    sV,
    WM,
    rV,
    aV,
    cV,
    dV,
    pV,
    mV,
    bV,
    FM,
    yV,
    CV,
    kV,
    zM,
    AM,
    RV,
    EV,
    WV,
    XM,
    FV,
    zV,
    PV,
    Yw,
    KV,
    xW,
    BM,
    BV,
    _V,
    YV,
    JV,
    aM,
    Fd,
    qV,
    yW,
    wW,
    IW,
    ez,
    sz,
    rz,
    az,
    cz,
    uz,
    hz,
    qM,
    fz,
    yz,
    Iz,
    kz,
    eW,
    Nz,
    $z,
    Ez,
    nW,
    vV,
    Wz,
    Fz,
    zz,
    Az,
    Xz,
    Zz,
    Hz,
    Uz,
    rW,
    Yz,
    aW,
    cW,
    Jz,
    qz,
    eP,
    sP,
    rP,
    pW,
    nF,
    aP,
    cP,
    dP,
    pP,
    mP,
    bP,
    KM,
    kP,
    NP,
    $P,
    VV
];
for (const n of GP)sn(n);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const po = {}, Ya = {
    alpha: !1,
    antialias: !1,
    premultipliedAlpha: !1,
    preserveDrawingBuffer: !1,
    depth: !1,
    stencil: !1,
    failIfMajorPerformanceCaveat: !0
};
function EP(n, t) {
    po[n] = t;
}
function Bn(n, t) {
    if (!(n in po) || t != null) {
        const s = MP(n, t);
        if (s !== null) po[n] = s;
        else return console.log("Could not get context for WebGL version", n), null;
    }
    const e = po[n];
    return e == null || e.isContextLost() ? (delete po[n], Bn(n)) : (e.disable(e.DEPTH_TEST), e.disable(e.STENCIL_TEST), e.disable(e.BLEND), e.disable(e.DITHER), e.disable(e.POLYGON_OFFSET_FILL), e.disable(e.SAMPLE_COVERAGE), e.enable(e.SCISSOR_TEST), e.enable(e.CULL_FACE), e.cullFace(e.BACK), po[n]);
}
function LP(n) {
    if (!F().getBool("IS_SAFARI") && typeof OffscreenCanvas < "u" && n === 2) return new OffscreenCanvas(300, 150);
    if (typeof document < "u") return document.createElement("canvas");
    throw new Error("Cannot create a canvas in this context");
}
function MP(n, t) {
    if (n !== 1 && n !== 2) throw new Error("Cannot get WebGL rendering context, WebGL is disabled.");
    const e = t ?? LP(n);
    return e.addEventListener("webglcontextlost", (s)=>{
        s.preventDefault(), delete po[n];
    }, !1), F().getBool("SOFTWARE_WEBGL_ENABLED") && (Ya.failIfMajorPerformanceCaveat = !1), n === 1 ? // tslint:disable-next-line
    e.getContext("webgl", Ya) || e.getContext("experimental-webgl", Ya) : e.getContext("webgl2", Ya);
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var bi;
(function(n) {
    n[n.DENSE = 0] = "DENSE", n[n.SHARED_BATCH = 1] = "SHARED_BATCH";
})(bi || (bi = {}));
var un;
(function(n) {
    n[n.RENDER = 0] = "RENDER", n[n.UPLOAD = 1] = "UPLOAD", n[n.PIXELS = 2] = "PIXELS", n[n.DOWNLOAD = 3] = "DOWNLOAD";
})(un || (un = {}));
var Ce;
(function(n) {
    n[n.UNPACKED_FLOAT16 = 0] = "UNPACKED_FLOAT16", n[n.UNPACKED_FLOAT32 = 1] = "UNPACKED_FLOAT32", n[n.PACKED_4X1_UNSIGNED_BYTE = 2] = "PACKED_4X1_UNSIGNED_BYTE", n[n.PACKED_2X2_FLOAT32 = 3] = "PACKED_2X2_FLOAT32", n[n.PACKED_2X2_FLOAT16 = 4] = "PACKED_2X2_FLOAT16";
})(Ce || (Ce = {}));
function Pa(n, t) {
    return [
        t,
        n
    ];
}
function WP(n, t) {
    return n * t;
}
function Qa(n) {
    const t = X(n), e = Math.ceil(t / 4);
    return hl(e);
}
function Gr(n, t) {
    return [
        Math.max(1, Math.ceil(t / 2)),
        Math.max(1, Math.ceil(n / 2))
    ];
}
function DP(n, t) {
    const [e, s] = Gr(n, t);
    return e * s * 4;
}
function Uf(n, t) {
    const e = n;
    let s, o, r, i, a, l, c, u, d, h;
    return F().getNumber("WEBGL_VERSION") === 2 ? (s = e.R32F, o = e.R16F, r = e.RGBA16F, i = e.RGBA32F, a = e.RED, c = 4, u = 1, d = e.HALF_FLOAT, h = e.FLOAT, l = e.RGBA8) : (s = n.RGBA, o = n.RGBA, r = n.RGBA, i = e.RGBA, a = n.RGBA, c = 4, u = 4, d = t != null ? t.HALF_FLOAT_OES : null, h = n.FLOAT, l = n.RGBA), {
        internalFormatFloat: s,
        internalFormatHalfFloat: o,
        internalFormatPackedHalfFloat: r,
        internalFormatPackedFloat: i,
        textureFormatFloat: a,
        downloadTextureFormat: l,
        downloadUnpackNumChannels: c,
        defaultNumChannels: u,
        textureTypeHalfFloat: d,
        textureTypeFloat: h
    };
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function nt(n, t) {
    const e = t();
    return F().getBool("DEBUG") && FP(n), e;
}
function FP(n) {
    const t = n.getError();
    if (t !== n.NO_ERROR) throw new Error("WebGL Error: " + Jw(n, t));
}
const VP = 596e-10, zP = 65504;
function Qw(n) {
    return !!(F().getBool("WEBGL_RENDER_FLOAT32_ENABLED") || n === 0 || VP < Math.abs(n) && Math.abs(n) < zP);
}
function Jw(n, t) {
    switch(t){
        case n.NO_ERROR:
            return "NO_ERROR";
        case n.INVALID_ENUM:
            return "INVALID_ENUM";
        case n.INVALID_VALUE:
            return "INVALID_VALUE";
        case n.INVALID_OPERATION:
            return "INVALID_OPERATION";
        case n.INVALID_FRAMEBUFFER_OPERATION:
            return "INVALID_FRAMEBUFFER_OPERATION";
        case n.OUT_OF_MEMORY:
            return "OUT_OF_MEMORY";
        case n.CONTEXT_LOST_WEBGL:
            return "CONTEXT_LOST_WEBGL";
        default:
            return `Unknown error code ${t}`;
    }
}
function jr(n, t) {
    return Rs(n, ()=>n.getExtension(t), 'Extension "' + t + '" not supported on this browser.');
}
function jw(n, t) {
    const e = Rs(n, ()=>n.createShader(n.VERTEX_SHADER), "Unable to create vertex WebGLShader.");
    if (nt(n, ()=>n.shaderSource(e, t)), nt(n, ()=>n.compileShader(e)), n.getShaderParameter(e, n.COMPILE_STATUS) === !1) throw console.log(n.getShaderInfoLog(e)), new Error("Failed to compile vertex shader.");
    return e;
}
function qw(n, t) {
    const e = Rs(n, ()=>n.createShader(n.FRAGMENT_SHADER), "Unable to create fragment WebGLShader.");
    if (nt(n, ()=>n.shaderSource(e, t)), nt(n, ()=>n.compileShader(e)), F().get("ENGINE_COMPILE_ONLY")) return e;
    if (n.getShaderParameter(e, n.COMPILE_STATUS) === !1) throw Yf(t, n.getShaderInfoLog(e)), new Error("Failed to compile fragment shader.");
    return e;
}
const PP = /ERROR: [0-9]+:([0-9]+):/g;
function Yf(n, t) {
    const e = PP.exec(t);
    if (e == null) {
        console.log(`Couldn't parse line number in error: ${t}`), console.log(n);
        return;
    }
    const s = +e[1], o = n.split(`
`), r = o.length.toString().length + 2, i = o.map((d, h)=>xo((h + 1).toString(), r) + d);
    let a = 0;
    for(let d = 0; d < i.length; d++)a = Math.max(i[d].length, a);
    const l = i.slice(0, s - 1), c = i.slice(s - 1, s), u = i.slice(s);
    console.log(l.join(`
`)), console.log(t.split(`
`)[0]), console.log(`%c ${xo(c[0], a)}`, "border:1px solid red; background-color:#e3d2d2; color:#a61717"), console.log(u.join(`
`));
}
function tI(n) {
    return Rs(n, ()=>n.createProgram(), "Unable to create WebGLProgram.");
}
function eI(n, t) {
    if (nt(n, ()=>n.linkProgram(t)), !F().get("ENGINE_COMPILE_ONLY") && n.getProgramParameter(t, n.LINK_STATUS) === !1) throw console.log(n.getProgramInfoLog(t)), new Error("Failed to link vertex and fragment shaders.");
}
function al(n, t) {
    if (nt(n, ()=>n.validateProgram(t)), n.getProgramParameter(t, n.VALIDATE_STATUS) === !1) throw console.log(n.getProgramInfoLog(t)), new Error("Shader program validation failed.");
}
function nI(n, t) {
    const e = Rs(n, ()=>n.createBuffer(), "Unable to create WebGLBuffer");
    return nt(n, ()=>n.bindBuffer(n.ARRAY_BUFFER, e)), nt(n, ()=>n.bufferData(n.ARRAY_BUFFER, t, n.STATIC_DRAW)), e;
}
function sI(n, t) {
    const e = Rs(n, ()=>n.createBuffer(), "Unable to create WebGLBuffer");
    return nt(n, ()=>n.bindBuffer(n.ELEMENT_ARRAY_BUFFER, e)), nt(n, ()=>n.bufferData(n.ELEMENT_ARRAY_BUFFER, t, n.STATIC_DRAW)), e;
}
function AP() {
    return F().getNumber("WEBGL_VERSION") === 2 ? 1 : 4;
}
function oI(n) {
    return Rs(n, ()=>n.createTexture(), "Unable to create WebGLTexture.");
}
function rI(n, t) {
    const e = F().getNumber("WEBGL_MAX_TEXTURE_SIZE");
    if (n <= 0 || t <= 0) {
        const s = `[${n}x${t}]`;
        throw new Error("Requested texture size " + s + " is invalid.");
    }
    if (n > e || t > e) {
        const s = `[${n}x${t}]`, o = `[${e}x${e}]`;
        throw new Error("Requested texture size " + s + " greater than WebGL maximum on this browser / GPU " + o + ".");
    }
}
function iI(n) {
    return Rs(n, ()=>n.createFramebuffer(), "Unable to create WebGLFramebuffer.");
}
function zd(n, t, e, s, o, r, i) {
    const a = n.getAttribLocation(t, e);
    return a === -1 ? !1 : (nt(n, ()=>n.bindBuffer(n.ARRAY_BUFFER, s)), nt(n, ()=>n.vertexAttribPointer(a, o, n.FLOAT, !1, r, i)), nt(n, ()=>n.enableVertexAttribArray(a)), !0);
}
function aI(n, t, e) {
    hI(n, e), nt(n, ()=>n.activeTexture(n.TEXTURE0 + e)), nt(n, ()=>n.bindTexture(n.TEXTURE_2D, t));
}
function OP(n, t) {
    hI(n, t), nt(n, ()=>n.activeTexture(n.TEXTURE0 + t)), nt(n, ()=>n.bindTexture(n.TEXTURE_2D, null));
}
function lI(n, t, e) {
    return Rs(n, ()=>n.getUniformLocation(t, e), 'uniform "' + e + '" not present in program.');
}
function cI(n, t, e) {
    return n.getUniformLocation(t, e);
}
function uI(n, t, e, s) {
    nt(n, ()=>aI(n, t, s)), nt(n, ()=>n.uniform1i(e, s));
}
function XP(n) {
    nt(n, ()=>n.bindFramebuffer(n.FRAMEBUFFER, null)), nt(n, ()=>n.viewport(0, 0, n.canvas.width, n.canvas.height)), nt(n, ()=>n.scissor(0, 0, n.canvas.width, n.canvas.height));
}
function ll(n, t, e) {
    nt(n, ()=>n.bindFramebuffer(n.FRAMEBUFFER, e)), nt(n, ()=>n.framebufferTexture2D(n.FRAMEBUFFER, n.COLOR_ATTACHMENT0, n.TEXTURE_2D, t, 0));
}
function Pd(n, t) {
    nt(n, ()=>n.bindFramebuffer(n.FRAMEBUFFER, t)), nt(n, ()=>n.framebufferTexture2D(n.FRAMEBUFFER, n.COLOR_ATTACHMENT0, n.TEXTURE_2D, null, 0));
}
function qr(n) {
    const t = n.checkFramebufferStatus(n.FRAMEBUFFER);
    if (t !== n.FRAMEBUFFER_COMPLETE) throw new Error("Error binding framebuffer: " + dI(n, t));
}
function dI(n, t) {
    switch(t){
        case n.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
            return "FRAMEBUFFER_INCOMPLETE_ATTACHMENT";
        case n.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
            return "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT";
        case n.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
            return "FRAMEBUFFER_INCOMPLETE_DIMENSIONS";
        case n.FRAMEBUFFER_UNSUPPORTED:
            return "FRAMEBUFFER_UNSUPPORTED";
        default:
            return `unknown error ${t}`;
    }
}
function Rs(n, t, e) {
    const s = nt(n, ()=>t());
    if (s == null) throw new Error(e);
    return s;
}
function hI(n, t) {
    const e = n.MAX_COMBINED_TEXTURE_IMAGE_UNITS - 1, s = t + n.TEXTURE0;
    if (s < n.TEXTURE0 || s > e) {
        const o = `[gl.TEXTURE0, gl.TEXTURE${e}]`;
        throw new Error(`textureUnit must be in ${o}.`);
    }
}
function Vo(n, t = 2) {
    return X(n.slice(0, n.length - t));
}
function zo(n) {
    if (n.length === 0) throw Error("Cannot get rows and columns of an empty shape array.");
    return [
        n.length > 1 ? n[n.length - 2] : 1,
        n[n.length - 1]
    ];
}
function ti(n) {
    let t = [
        1,
        1,
        1
    ];
    return n.length === 0 || n.length === 1 && n[0] === 1 || (t = [
        Vo(n),
        ...zo(n)
    ]), t;
}
function pI(n, t = !1) {
    let e = F().getNumber("WEBGL_MAX_TEXTURE_SIZE"), s = F().getNumber("WEBGL_MAX_SIZE_FOR_NARROW_TEXTURE");
    s === 1 / 0 && F().getBool("WEBGL_AUTO_SQUARIFY_NARROW_TEXTURE_SHAPE") && (s = e / 2), t && (e = e * 2, s = s * 2, n = n.map((a, l)=>l >= n.length - 2 ? Bl(n[l]) : n[l]), n.length === 1 && (n = [
        2,
        n[0]
    ])), n.length !== 2 && (n = ws(n).newShape);
    let o = X(n), r = null;
    n.length <= 1 && o <= e ? r = [
        1,
        o
    ] : n.length === 2 && n[0] <= e && n[1] <= e ? r = n : n.length === 3 && n[0] * n[1] <= e && n[2] <= e ? r = [
        n[0] * n[1],
        n[2]
    ] : n.length === 3 && n[0] <= e && n[1] * n[2] <= e ? r = [
        n[0],
        n[1] * n[2]
    ] : n.length === 4 && n[0] * n[1] * n[2] <= e && n[3] <= e ? r = [
        n[0] * n[1] * n[2],
        n[3]
    ] : n.length === 4 && n[0] <= e && n[1] * n[2] * n[3] <= e && (r = [
        n[0],
        n[1] * n[2] * n[3]
    ]);
    const i = r != null && Math.max(...r) > s && Math.min(...r) <= (t ? 2 : 1) && Math.min(...r) > 0;
    if (r == null || i) {
        if (t) {
            const a = Vo(n);
            let l = 2, c = 2;
            n.length && ([l, c] = zo(n)), o = a * (l / 2) * (c / 2), r = hl(o).map((u)=>u * 2);
        } else r = hl(o);
    }
    return r;
}
function Ja(n) {
    return n % 2 === 0;
}
function xi(n, t) {
    if (n = n.slice(-2), t = t.slice(-2), $t(n, t) || !n.length || !t.length || n[0] === 0 || n[1] === 0 || t[0] === 0 || t[1] === 0) return !0;
    if (n.length !== t.length) {
        const e = n[n.length - 1], s = t[t.length - 1];
        if (e === s || Ja(e) && Ja(s) && (n[0] === 1 || t[0] === 1)) return !0;
    }
    return n[1] === t[1] && Ja(n[0]) && Ja(t[0]);
}
let cl, ul;
function fI(n) {
    if (cl == null) {
        const t = Bn(n);
        cl = t.getParameter(t.MAX_TEXTURE_SIZE);
    }
    return cl;
}
function KP() {
    cl = null;
}
function ZP() {
    ul = null;
}
function mI(n) {
    if (ul == null) {
        const t = Bn(n);
        ul = t.getParameter(t.MAX_TEXTURE_IMAGE_UNITS);
    }
    return Math.min(16, ul);
}
function gI(n) {
    if (n === 0) return 0;
    let t;
    const e = Bn(n);
    return dn(e, "EXT_disjoint_timer_query_webgl2") && n === 2 ? t = 2 : dn(e, "EXT_disjoint_timer_query") ? t = 1 : t = 0, t;
}
function dn(n, t) {
    return n.getExtension(t) != null;
}
function Ad(n) {
    try {
        if (Bn(n) != null) return !0;
    } catch (t) {
        return console.log("Error when getting WebGL context: ", t), !1;
    }
    return !1;
}
function bI(n) {
    if (n === 0) return !1;
    const t = Bn(n);
    if (n === 1) {
        if (!dn(t, "OES_texture_float")) return !1;
    } else if (!dn(t, "EXT_color_buffer_float")) return !1;
    return Od(t);
}
function xI(n) {
    if (n === 0) return !1;
    const t = Bn(n);
    if (n === 1) {
        if (!dn(t, "OES_texture_float") || !dn(t, "WEBGL_color_buffer_float")) return !1;
    } else {
        if (dn(t, "EXT_color_buffer_float")) return Od(t);
        const s = "EXT_color_buffer_half_float";
        if (dn(t, s)) {
            const o = t.getExtension(s);
            return BP(t, o);
        }
        return !1;
    }
    return Od(t);
}
function Od(n) {
    const t = Uf(n), e = n.createTexture();
    n.bindTexture(n.TEXTURE_2D, e), n.texImage2D(n.TEXTURE_2D, 0, t.internalFormatFloat, 1, 1, 0, t.textureFormatFloat, t.textureTypeFloat, null);
    const r = n.createFramebuffer();
    n.bindFramebuffer(n.FRAMEBUFFER, r), n.framebufferTexture2D(n.FRAMEBUFFER, n.COLOR_ATTACHMENT0, n.TEXTURE_2D, e, 0);
    const i = n.checkFramebufferStatus(n.FRAMEBUFFER) === n.FRAMEBUFFER_COMPLETE;
    return n.bindTexture(n.TEXTURE_2D, null), n.bindFramebuffer(n.FRAMEBUFFER, null), n.deleteTexture(e), n.deleteFramebuffer(r), i;
}
function BP(n, t) {
    const e = Uf(n, t), s = n.createTexture();
    n.bindTexture(n.TEXTURE_2D, s), n.texImage2D(n.TEXTURE_2D, 0, e.internalFormatHalfFloat, 1, 1, 0, e.textureFormatFloat, e.textureTypeHalfFloat, null);
    const i = n.createFramebuffer();
    n.bindFramebuffer(n.FRAMEBUFFER, i), n.framebufferTexture2D(n.FRAMEBUFFER, n.COLOR_ATTACHMENT0, n.TEXTURE_2D, s, 0);
    const a = n.checkFramebufferStatus(n.FRAMEBUFFER) === n.FRAMEBUFFER_COMPLETE;
    return n.bindTexture(n.TEXTURE_2D, null), n.bindFramebuffer(n.FRAMEBUFFER, null), n.deleteTexture(s), n.deleteFramebuffer(i), a;
}
function yI(n) {
    return n !== 2 ? !1 : Bn(n).fenceSync != null;
}
function Er(n, t) {
    Array.isArray(n) || (n = [
        n
    ]), n.forEach((e)=>{
        e != null && C(e.dtype !== "complex64", ()=>`${t} does not support complex64 tensors in the WebGL backend.`);
    });
}
const _Q = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    assertNotComplex: Er,
    bindCanvasToFramebuffer: XP,
    bindColorTextureToFramebuffer: ll,
    bindTextureToProgramUniformSampler: uI,
    bindTextureUnit: aI,
    bindVertexBufferToProgramAttribute: zd,
    callAndCheck: nt,
    canBeRepresented: Qw,
    createFragmentShader: qw,
    createFramebuffer: iI,
    createProgram: tI,
    createStaticIndexBuffer: sI,
    createStaticVertexBuffer: nI,
    createTexture: oI,
    createVertexShader: jw,
    getBatchDim: Vo,
    getExtensionOrThrow: jr,
    getFramebufferErrorMessage: dI,
    getMaxTexturesInShader: mI,
    getNumChannels: AP,
    getProgramUniformLocation: cI,
    getProgramUniformLocationOrThrow: lI,
    getRowsCols: zo,
    getShapeAs3D: ti,
    getTextureShapeFromLogicalShape: pI,
    getWebGLDisjointQueryTimerVersion: gI,
    getWebGLErrorMessage: Jw,
    getWebGLMaxTextureSize: fI,
    hasExtension: dn,
    isCapableOfRenderingToFloatTexture: bI,
    isDownloadFloatTextureEnabled: xI,
    isReshapeFree: xi,
    isWebGLFenceEnabled: yI,
    isWebGLVersionEnabled: Ad,
    linkProgram: eI,
    logShaderSourceAndInfoLog: Yf,
    resetMaxTextureSize: KP,
    resetMaxTexturesInShader: ZP,
    unbindColorTextureFromFramebuffer: Pd,
    unbindTextureUnit: OP,
    validateFramebuffer: qr,
    validateProgram: al,
    validateTextureSize: rI
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const ct = F();
ct.registerFlag("HAS_WEBGL", ()=>ct.getNumber("WEBGL_VERSION") > 0);
ct.registerFlag("WEBGL_VERSION", ()=>Ad(2) ? 2 : Ad(1) ? 1 : 0);
ct.registerFlag("WEBGL_CHECK_NUMERICAL_PROBLEMS", ()=>!1);
ct.registerFlag("WEBGL_BUFFER_SUPPORTED", ()=>ct.get("WEBGL_VERSION") === 2);
ct.registerFlag("WEBGL_CPU_FORWARD", ()=>!0);
ct.registerFlag("WEBGL_FORCE_F16_TEXTURES", ()=>!1);
ct.registerFlag("WEBGL_PACK", ()=>ct.getBool("HAS_WEBGL"));
ct.registerFlag("WEBGL_PACK_NORMALIZATION", ()=>ct.getBool("WEBGL_PACK"));
ct.registerFlag("WEBGL_PACK_CLIP", ()=>ct.getBool("WEBGL_PACK"));
ct.registerFlag("WEBGL_PACK_DEPTHWISECONV", ()=>ct.getBool("WEBGL_PACK"));
ct.registerFlag("WEBGL_PACK_BINARY_OPERATIONS", ()=>ct.getBool("WEBGL_PACK"));
ct.registerFlag("WEBGL_PACK_UNARY_OPERATIONS", ()=>ct.getBool("WEBGL_PACK"));
ct.registerFlag("WEBGL_PACK_ARRAY_OPERATIONS", ()=>ct.getBool("WEBGL_PACK"));
ct.registerFlag("WEBGL_PACK_IMAGE_OPERATIONS", ()=>ct.getBool("WEBGL_PACK"));
ct.registerFlag("WEBGL_PACK_REDUCE", ()=>ct.getBool("WEBGL_PACK"));
ct.registerFlag("WEBGL_LAZILY_UNPACK", ()=>ct.getBool("WEBGL_PACK"));
ct.registerFlag("WEBGL_CONV_IM2COL", ()=>ct.getBool("WEBGL_PACK"));
ct.registerFlag("WEBGL_PACK_CONV2DTRANSPOSE", ()=>ct.getBool("WEBGL_PACK"));
ct.registerFlag("WEBGL_MAX_TEXTURE_SIZE", ()=>fI(ct.getNumber("WEBGL_VERSION")));
ct.registerFlag("WEBGL_MAX_TEXTURES_IN_SHADER", ()=>mI(ct.getNumber("WEBGL_VERSION")));
ct.registerFlag("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION", ()=>{
    const n = ct.getNumber("WEBGL_VERSION");
    return n === 0 ? 0 : gI(n);
});
ct.registerFlag("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE", ()=>ct.getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0 && !Qh());
ct.registerFlag("WEBGL_RENDER_FLOAT32_CAPABLE", ()=>bI(ct.getNumber("WEBGL_VERSION")));
ct.registerFlag("WEBGL_RENDER_FLOAT32_ENABLED", ()=>ct.getBool("WEBGL_FORCE_F16_TEXTURES") ? !1 : ct.getBool("WEBGL_RENDER_FLOAT32_CAPABLE"));
ct.registerFlag("WEBGL_DOWNLOAD_FLOAT_ENABLED", ()=>xI(ct.getNumber("WEBGL_VERSION")));
ct.registerFlag("WEBGL_FENCE_API_ENABLED", ()=>yI(ct.getNumber("WEBGL_VERSION")));
ct.registerFlag("WEBGL_SIZE_UPLOAD_UNIFORM", ()=>ct.getBool("WEBGL_RENDER_FLOAT32_ENABLED") ? 4 : 0);
ct.registerFlag("WEBGL_DELETE_TEXTURE_THRESHOLD", ()=>-1, (n)=>{
    if (typeof n != "number") throw new Error(`WEBGL_DELETE_TEXTURE_THRESHOLD must be a number but got ${n}.`);
    if (n < 0 && n !== -1) throw new Error(`WEBGL_DELETE_TEXTURE_THRESHOLD must be -1 (indicating never delete) or at least 0, but got ${n}.`);
});
ct.registerFlag("WEBGL_FLUSH_THRESHOLD", ()=>Qh() ? 1 : -1, (n)=>{
    if (typeof n != "number") throw new Error(`WEBGL_FLUSH_THRESHOLD must be a number but got ${n}.`);
    if (n < 0 && n !== -1) throw new Error(`WEBGL_FLUSH_THRESHOLD must be -1 (indicating never manual flush) or at least 0, but got ${n}.`);
});
ct.registerFlag("CPU_HANDOFF_SIZE_THRESHOLD", ()=>128);
ct.registerFlag("WEBGL_USE_SHAPES_UNIFORMS", ()=>!1);
ct.registerFlag("TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD", ()=>1e5);
ct.registerFlag("TOPK_K_CPU_HANDOFF_THRESHOLD", ()=>128);
ct.registerFlag("WEBGL_EXP_CONV", ()=>!1);
ct.registerFlag("SOFTWARE_WEBGL_ENABLED", ()=>ct.getBool("IS_TEST"));
ct.registerFlag("WEBGL_MAX_SIZE_FOR_NARROW_TEXTURE", ()=>1 / 0);
ct.registerFlag("WEBGL_AUTO_SQUARIFY_NARROW_TEXTURE_SHAPE", ()=>!1);
ct.registerFlag("WEBGL2_ISNAN_CUSTOM", ()=>!1);
ct.registerFlag("ENGINE_COMPILE_ONLY", ()=>!1);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Ae() {
    let n, t, e, s, o, r, i, a, l, c;
    return F().getNumber("WEBGL_VERSION") === 2 ? (n = "#version 300 es", t = "in", e = "out", s = "in", o = "texture", r = "outputColor", i = "out vec4 outputColor;", a = F().getBool("WEBGL2_ISNAN_CUSTOM") ? `
      bool isnan_custom(float val) {
        uint floatToUint = floatBitsToUint(val);
        return (floatToUint & 0x7fffffffu) > 0x7f800000u;
      }

      bvec4 isnan_custom(vec4 val) {
        return bvec4(isnan_custom(val.x),
          isnan_custom(val.y), isnan_custom(val.z), isnan_custom(val.w));
      }

      #define isnan(value) isnan_custom(value)
    ` : "", l = "", c = `
      #define round(value) newRound(value)
      int newRound(float value) {
        return int(floor(value + 0.5));
      }

      ivec4 newRound(vec4 value) {
        return ivec4(floor(value + vec4(0.5)));
      }
    `) : (n = "", t = "attribute", e = "varying", s = "varying", o = "texture2D", r = "gl_FragColor", i = "", a = `
      #define isnan(value) isnan_custom(value)
      bool isnan_custom(float val) {
        return (val > 0. || val < 1. || val == 0.) ? false : true;
      }
      bvec4 isnan_custom(vec4 val) {
        return bvec4(isnan(val.x), isnan(val.y), isnan(val.z), isnan(val.w));
      }
    `, l = `
      uniform float INFINITY;

      bool isinf(float val) {
        return abs(val) == INFINITY;
      }
      bvec4 isinf(vec4 val) {
        return equal(abs(val), vec4(INFINITY));
      }
    `, c = `
      int round(float value) {
        return int(floor(value + 0.5));
      }

      ivec4 round(vec4 value) {
        return ivec4(floor(value + vec4(0.5)));
      }
    `), {
        version: n,
        attribute: t,
        varyingVs: e,
        varyingFs: s,
        texture2D: o,
        output: r,
        defineOutput: i,
        defineSpecialNaN: a,
        defineSpecialInf: l,
        defineRound: c
    };
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Qo(n, t, e = "index") {
    const s = dt(t);
    return s.map((o, r)=>{
        const i = `int ${n[r]} = ${e} / ${o}`, a = r === s.length - 1 ? `int ${n[r + 1]} = ${e} - ${n[r]} * ${o}` : `index -= ${n[r]} * ${o}`;
        return `${i}; ${a};`;
    }).join("");
}
function Iu(n, t, e = "index") {
    const s = dt(t);
    return s.map((o, r)=>{
        const i = `int ${n[r]} = ${e} / outShapeStrides[${r}]`, a = r === s.length - 1 ? `int ${n[r + 1]} = ${e} - ${n[r]} * outShapeStrides[${r}]` : `index -= ${n[r]} * outShapeStrides[${r}]`;
        return `${i}; ${a};`;
    }).join("");
}
function HP(n, t) {
    const e = n.length, s = n.map((r)=>`${t}[${r}]`), o = new Array(e - 1);
    o[e - 2] = s[e - 1];
    for(let r = e - 3; r >= 0; --r)o[r] = `(${o[r + 1]} * ${s[r + 1]})`;
    return o;
}
function _P(n, t, e = "index") {
    const s = n.map((r, i)=>i), o = HP(s, t);
    return o.map((r, i)=>{
        const a = `int ${n[i]} = ${e} / ${o[i]}`, l = i === o.length - 1 ? `int ${n[i + 1]} = ${e} - ${n[i]} * ${o[i]}` : `index -= ${n[i]} * ${o[i]}`;
        return `${a}; ${l};`;
    }).join("");
}
function Qf(n) {
    const t = dt(n).map((e)=>e.toString());
    return `
  int getFlatIndex(ivec3 coords) {
    return coords.x * ${t[0]} + coords.y * ${t[1]} + coords.z;
  }
`;
}
function Jf() {
    return `
  int getFlatIndex(ivec3 coords) {
    return coords.x * outShapeStrides[0] + coords.y * outShapeStrides[1] + coords.z;
  }
`;
}
const wI = `
  const float FLOAT_MAX = 1.70141184e38;
  const float FLOAT_MIN = 1.17549435e-38;

  lowp vec4 encode_float(highp float v) {
    if (isnan(v)) {
      return vec4(255, 255, 255, 255);
    }

    highp float av = abs(v);

    if(av < FLOAT_MIN) {
      return vec4(0.0, 0.0, 0.0, 0.0);
    } else if(v > FLOAT_MAX) {
      return vec4(0.0, 0.0, 128.0, 127.0) / 255.0;
    } else if(v < -FLOAT_MAX) {
      return vec4(0.0, 0.0,  128.0, 255.0) / 255.0;
    }

    highp vec4 c = vec4(0,0,0,0);

    highp float e = floor(log2(av));
    highp float m = exp2(fract(log2(av))) - 1.0;

    c[2] = floor(128.0 * m);
    m -= c[2] / 128.0;
    c[1] = floor(32768.0 * m);
    m -= c[1] / 32768.0;
    c[0] = floor(8388608.0 * m);

    highp float ebias = e + 127.0;
    c[3] = floor(ebias / 2.0);
    ebias -= c[3] * 2.0;
    c[2] += floor(ebias) * 128.0;

    c[3] += 128.0 * step(0.0, -v);

    return c / 255.0;
  }
`;
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const { getBroadcastDims: II } = E$;
function UP(n, t, e) {
    const s = [];
    if (n.forEach((p)=>{
        const f = X(p.shapeInfo.logicalShape);
        if (p.shapeInfo.isUniform ? s.push(`uniform float ${p.name}${f > 1 ? `[${f}]` : ""};`) : (s.push(`uniform sampler2D ${p.name};`), s.push(`uniform int offset${p.name};`)), e.enableShapeUniforms) {
            const { uniformShape: m } = jf(e.packedInputs, p.shapeInfo.logicalShape, p.shapeInfo.texShape);
            switch(m.length){
                case 1:
                    s.push(`uniform int ${p.name}Shape;`);
                    break;
                case 2:
                    s.push(`uniform ivec2 ${p.name}Shape;`);
                    break;
                case 3:
                    s.push(`uniform ivec3 ${p.name}Shape;`);
                    break;
                case 4:
                    s.push(`uniform ivec4 ${p.name}Shape;`);
                    break;
            }
            s.push(`uniform ivec2 ${p.name}TexShape;`);
        }
    }), e.enableShapeUniforms) {
        switch(t.logicalShape.length){
            case 1:
                s.push("uniform int outShape;");
                break;
            case 2:
                s.push("uniform ivec2 outShape;"), s.push("uniform int outShapeStrides;");
                break;
            case 3:
                s.push("uniform ivec3 outShape;"), s.push("uniform ivec2 outShapeStrides;");
                break;
            case 4:
                s.push("uniform ivec4 outShape;"), s.push("uniform ivec3 outShapeStrides;");
                break;
        }
        s.push("uniform ivec2 outTexShape;");
    }
    e.customUniforms && e.customUniforms.forEach((p)=>{
        s.push(`uniform ${p.type} ${p.name}${p.arrayIndex ? `[${p.arrayIndex}]` : ""};`);
    });
    const o = s.join(`
`), r = n.map((p)=>YP(p, t, e.packedInputs, e.enableShapeUniforms)).join(`
`), i = t.texShape, a = Ae(), l = jP(a);
    let c, u, d = eA(a);
    return t.isPacked ? (c = QP(t.logicalShape, i, e.enableShapeUniforms), u = tA(a)) : (c = JP(t.logicalShape, i, e.enableShapeUniforms), u = qP(a)), e.packedInputs && (d += rA), [
        d,
        l,
        u,
        o,
        c,
        r,
        e.userCode
    ].join(`
`);
}
function Lr(n, t = !1) {
    const e = n.shapeInfo.logicalShape;
    switch(e.length){
        case 0:
            return bA(n, t);
        case 1:
            return yA(n, t);
        case 2:
            return IA(n, t);
        case 3:
            return vA(n, t);
        case 4:
            return kA(n, t);
        case 5:
            return TA(n);
        case 6:
            return NA(n);
        default:
            throw new Error(`${e.length}-D input sampling is not yet supported`);
    }
}
function CI(n, t) {
    switch(n.shapeInfo.logicalShape.length){
        case 0:
            return gA(n);
        case 1:
            return xA(n, t);
        case 2:
            return wA(n, t);
        case 3:
            return CA(n, t);
        default:
            return SA(n, t);
    }
}
function YP(n, t, e = !1, s) {
    let o = "";
    e ? o += CI(n, s) : o += Lr(n, s);
    const r = n.shapeInfo.logicalShape, i = t.logicalShape;
    return r.length <= i.length && (e ? o += RA(n, t) : o += $A(n, t)), o;
}
function QP(n, t, e) {
    switch(n.length){
        case 0:
            return vI();
        case 1:
            return iA(n, t, e);
        case 2:
            return fA(n, t, e);
        case 3:
            return lA(n, t, e);
        default:
            return uA(n, t, e);
    }
}
function JP(n, t, e) {
    switch(n.length){
        case 0:
            return vI();
        case 1:
            return aA(n, t, e);
        case 2:
            return mA(n, t, e);
        case 3:
            return cA(n, t, e);
        case 4:
            return dA(n, t, e);
        case 5:
            return hA(n, t);
        case 6:
            return pA(n, t);
        default:
            throw new Error(`${n.length}-D output sampling is not yet supported`);
    }
}
function jP(n) {
    return `
    float sampleTexture(sampler2D textureSampler, vec2 uv) {
      return ${n.texture2D}(textureSampler, uv).r;
    }
  `;
}
function qP(n) {
    return `
    void setOutput(float val) {
      ${n.output} = vec4(val, 0, 0, 0);
    }
  `;
}
function tA(n) {
    return `
    void setOutput(vec4 val) {
      ${n.output} = val;
    }
  `;
}
function eA(n) {
    return `${n.version}
    precision highp float;
    precision highp int;
    precision highp sampler2D;
    ${n.varyingFs} vec2 resultUV;
    ${n.defineOutput}
    const vec2 halfCR = vec2(0.5, 0.5);

    struct ivec5
    {
      int x;
      int y;
      int z;
      int w;
      int u;
    };

    struct ivec6
    {
      int x;
      int y;
      int z;
      int w;
      int u;
      int v;
    };

    uniform float NAN;
    ${n.defineSpecialNaN}
    ${n.defineSpecialInf}
    ${n.defineRound}

    int imod(int x, int y) {
      return x - y * (x / y);
    }

    int idiv(int a, int b, float sign) {
      int res = a / b;
      int mod = imod(a, b);
      if (sign < 0. && mod != 0) {
        res -= 1;
      }
      return res;
    }

    //Based on the work of Dave Hoskins
    //https://www.shadertoy.com/view/4djSRW
    #define HASHSCALE1 443.8975
    float random(float seed){
      vec2 p = resultUV * seed;
      vec3 p3  = fract(vec3(p.xyx) * HASHSCALE1);
      p3 += dot(p3, p3.yzx + 19.19);
      return fract((p3.x + p3.y) * p3.z);
    }

    ${nA}
    ${sA}
    ${oA}
  `;
}
const nA = `
vec2 uvFromFlat(int texNumR, int texNumC, int index) {
  int texR = index / texNumC;
  int texC = index - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
vec2 packedUVfrom1D(int texNumR, int texNumC, int index) {
  int texelIndex = index / 2;
  int texR = texelIndex / texNumC;
  int texC = texelIndex - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`, sA = `
vec2 packedUVfrom2D(int texelsInLogicalRow, int texNumR,
  int texNumC, int row, int col) {
  int texelIndex = (row / 2) * texelsInLogicalRow + (col / 2);
  int texR = texelIndex / texNumC;
  int texC = texelIndex - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`, oA = `
vec2 packedUVfrom3D(int texNumR, int texNumC,
    int texelsInBatch, int texelsInLogicalRow, int b,
    int row, int col) {
  int index = b * texelsInBatch + (row / 2) * texelsInLogicalRow + (col / 2);
  int texR = index / texNumC;
  int texC = index - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`, rA = `
  float getChannel(vec4 frag, vec2 innerDims) {
    vec2 modCoord = mod(innerDims, 2.);
    return modCoord.x == 0. ?
      (modCoord.y == 0. ? frag.r : frag.g) :
      (modCoord.y == 0. ? frag.b : frag.a);
  }
  float getChannel(vec4 frag, int dim) {
    float modCoord = mod(float(dim), 2.);
    return modCoord == 0. ? frag.r : frag.g;
  }
`;
function vI() {
    return `
    int getOutputCoords() {
      return 0;
    }
  `;
}
function iA(n, t, e) {
    const s = [
        Math.ceil(t[0] / 2),
        Math.ceil(t[1] / 2)
    ];
    return s[0] === 1 ? e ? `
      int getOutputCoords() {
        return 2 * int(resultUV.x * ceil(float(outTexShape[1]) / 2.0));
      }
    ` : `
      int getOutputCoords() {
        return 2 * int(resultUV.x * ${s[1]}.0);
      }
    ` : s[1] === 1 ? e ? `
      int getOutputCoords() {
        return 2 * int(resultUV.y * ceil(float(outTexShape[0]) / 2.0));
      }
    ` : `
      int getOutputCoords() {
        return 2 * int(resultUV.y * ${s[0]}.0);
      }
    ` : e ? `
    int getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      return 2 * (resTexRC.x * packedTexShape[1] + resTexRC.y);
    }
  ` : `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${s[0]}, ${s[1]}));
      return 2 * (resTexRC.x * ${s[1]} + resTexRC.y);
    }
  `;
}
function aA(n, t, e) {
    return t[0] === 1 ? e ? `
      int getOutputCoords() {
        return int(resultUV.x * float(outTexShape[1]));
      }
    ` : `
      int getOutputCoords() {
        return int(resultUV.x * ${t[1]}.0);
      }
    ` : t[1] === 1 ? e ? `
      int getOutputCoords() {
        return int(resultUV.y * float(outTexShape[0]));
      }
    ` : `
      int getOutputCoords() {
        return int(resultUV.y * ${t[0]}.0);
      }
    ` : e ? `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(outTexShape[0], outTexShape[1]));
      return resTexRC.x * outTexShape[1] + resTexRC.y;
    }
  ` : `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${t[0]}, ${t[1]}));
      return resTexRC.x * ${t[1]} + resTexRC.y;
    }
  `;
}
function lA(n, t, e) {
    if (e) return `
    ivec3 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      int texelsInLogicalRow = int(ceil(float(outShape[2]) / 2.0));
      int texelsInBatch = texelsInLogicalRow * int(ceil(float(outShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;

      int b = index / texelsInBatch;
      index -= b * texelsInBatch;

      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec3(b, r, c);
    }
  `;
    const s = [
        Math.ceil(t[0] / 2),
        Math.ceil(t[1] / 2)
    ], o = Math.ceil(n[2] / 2), r = o * Math.ceil(n[1] / 2);
    return `
    ivec3 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${s[0]}, ${s[1]}));
      int index = resTexRC.x * ${s[1]} + resTexRC.y;

      int b = index / ${r};
      index -= b * ${r};

      int r = 2 * (index / ${o});
      int c = imod(index, ${o}) * 2;

      return ivec3(b, r, c);
    }
  `;
}
function cA(n, t, e) {
    if (e) return `
  ivec3 getOutputCoords() {
    ivec2 resTexRC = ivec2(resultUV.yx *
                           vec2(outTexShape[0], outTexShape[1]));
    int index = resTexRC.x * outTexShape[1] + resTexRC.y;
    ${Iu([
        "r",
        "c",
        "d"
    ], n)}
    return ivec3(r, c, d);
  }
`;
    const s = Qo([
        "r",
        "c",
        "d"
    ], n);
    return `
    ivec3 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${t[0]}, ${t[1]}));
      int index = resTexRC.x * ${t[1]} + resTexRC.y;
      ${s}
      return ivec3(r, c, d);
    }
  `;
}
function uA(n, t, e) {
    if (e) return `
    ivec4 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;

      int texelsInLogicalRow = int(ceil(float(outShape[3]) / 2.0));
      int texelsInBatch = texelsInLogicalRow * int(ceil(float(outShape[2]) / 2.0));
      int texelsInBatchN = texelsInBatch * outShape[1];

      int b2 = index / texelsInBatchN;
      index -= b2 * texelsInBatchN;

      int b = index / texelsInBatch;
      index -= b * texelsInBatch;

      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec4(b2, b, r, c);
    }
  `;
    const s = [
        Math.ceil(t[0] / 2),
        Math.ceil(t[1] / 2)
    ], o = Math.ceil(n[n.length - 1] / 2), r = o * Math.ceil(n[n.length - 2] / 2);
    let i = r, a = "", l = "b, r, c";
    for(let c = 2; c < n.length - 1; c++)i *= n[n.length - c - 1], a = `
      int b${c} = index / ${i};
      index -= b${c} * ${i};
    ` + a, l = `b${c}, ` + l;
    return `
    ivec${n.length} getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${s[0]}, ${s[1]}));
      int index = resTexRC.x * ${s[1]} + resTexRC.y;

      ${a}

      int b = index / ${r};
      index -= b * ${r};

      int r = 2 * (index / ${o});
      int c = imod(index, ${o}) * 2;

      return ivec${n.length}(${l});
    }
  `;
}
function dA(n, t, e) {
    if (e) return `
    ivec4 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(outTexShape[0], outTexShape[1]));
      int index = resTexRC.x * outTexShape[1] + resTexRC.y;
      ${Iu([
        "r",
        "c",
        "d",
        "d2"
    ], n)}
      return ivec4(r, c, d, d2);
    }
  `;
    const s = Qo([
        "r",
        "c",
        "d",
        "d2"
    ], n);
    return `
    ivec4 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(${t[0]}, ${t[1]}));
      int index = resTexRC.x * ${t[1]} + resTexRC.y;
      ${s}
      return ivec4(r, c, d, d2);
    }
  `;
}
function hA(n, t) {
    const e = Qo([
        "r",
        "c",
        "d",
        "d2",
        "d3"
    ], n);
    return `
    ivec5 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx * vec2(${t[0]},
                             ${t[1]}));

      int index = resTexRC.x * ${t[1]} + resTexRC.y;

      ${e}

      ivec5 outShape = ivec5(r, c, d, d2, d3);
      return outShape;
    }
  `;
}
function pA(n, t) {
    const e = Qo([
        "r",
        "c",
        "d",
        "d2",
        "d3",
        "d4"
    ], n);
    return `
    ivec6 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(${t[0]}, ${t[1]}));
      int index = resTexRC.x * ${t[1]} + resTexRC.y;

      ${e}

      ivec6 result = ivec6(r, c, d, d2, d3, d4);
      return result;
    }
  `;
}
function fA(n, t, e) {
    const s = [
        Math.ceil(t[0] / 2),
        Math.ceil(t[1] / 2)
    ];
    if ($t(n, t)) return e ? `
      ivec2 getOutputCoords() {
        ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
        return 2 * ivec2(resultUV.yx * vec2(packedTexShape[0], packedTexShape[1]));
      }
    ` : `
      ivec2 getOutputCoords() {
        return 2 * ivec2(resultUV.yx * vec2(${s[0]}, ${s[1]}));
      }
    `;
    const o = Math.ceil(n[1] / 2);
    return e ? `
    ivec2 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      int texelsInLogicalRow = int(ceil(float(outShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));

      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;
      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec2(r, c);
    }
  ` : `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${s[0]}, ${s[1]}));

      int index = resTexRC.x * ${s[1]} + resTexRC.y;
      int r = 2 * (index / ${o});
      int c = imod(index, ${o}) * 2;

      return ivec2(r, c);
    }
  `;
}
function mA(n, t, e) {
    return $t(n, t) ? e ? `
      ivec2 getOutputCoords() {
        return ivec2(resultUV.yx * vec2(outTexShape[0], outTexShape[1]));
      }
    ` : `
      ivec2 getOutputCoords() {
        return ivec2(resultUV.yx * vec2(${t[0]}, ${t[1]}));
      }
    ` : n[1] === 1 ? e ? `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(outTexShape[0], outTexShape[1]));
        int index = resTexRC.x * outTexShape[1] + resTexRC.y;
        return ivec2(index, 0);
      }
    ` : `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(${t[0]}, ${t[1]}));
        int index = resTexRC.x * ${t[1]} + resTexRC.y;
        return ivec2(index, 0);
      }
    ` : n[0] === 1 ? e ? `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(outTexShape[0], outTexShape[1]));
        int index = resTexRC.x * outTexShape[1] + resTexRC.y;
        return ivec2(0, index);
      }
    ` : `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(${t[0]}, ${t[1]}));
        int index = resTexRC.x * ${t[1]} + resTexRC.y;
        return ivec2(0, index);
      }
    ` : e ? `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(outTexShape[0], outTexShape[1]));
      int index = resTexRC.x * outTexShape[1] + resTexRC.y;
      int r = index / outShape[1];
      int c = index - r * outShape[1];
      return ivec2(r, c);
    }
  ` : `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${t[0]}, ${t[1]}));
      int index = resTexRC.x * ${t[1]} + resTexRC.y;
      int r = index / ${n[1]};
      int c = index - r * ${n[1]};
      return ivec2(r, c);
    }
  `;
}
function Jo(n) {
    return `offset${n}`;
}
function gA(n) {
    const t = n.name, e = "get" + t.charAt(0).toUpperCase() + t.slice(1), s = Ae();
    return `
    vec4 ${e}() {
      return ${s.texture2D}(${t}, halfCR);
    }
  `;
}
function bA(n, t) {
    const e = n.name, s = "get" + e.charAt(0).toUpperCase() + e.slice(1);
    if (n.shapeInfo.isUniform) return `float ${s}() {return ${e};}`;
    const [o, r] = n.shapeInfo.texShape;
    if (o === 1 && r === 1) return `
      float ${s}() {
        return sampleTexture(${e}, halfCR);
      }
    `;
    const i = Jo(e);
    if (t) return `
    float ${s}() {
      vec2 uv = uvFromFlat(${e}TexShape[0], ${e}TexShape[1], ${i});
      return sampleTexture(${e}, uv);
    }
  `;
    const [a, l] = n.shapeInfo.texShape;
    return `
    float ${s}() {
      vec2 uv = uvFromFlat(${a}, ${l}, ${i});
      return sampleTexture(${e}, uv);
    }
  `;
}
function xA(n, t) {
    const e = n.name, s = "get" + e.charAt(0).toUpperCase() + e.slice(1), o = n.shapeInfo.texShape, r = Ae();
    if (t) return `
    vec4 ${s}(int index) {
      ivec2 packedTexShape = ivec2(ceil(float(${e}TexShape[0]) / 2.0), ceil(float(${e}TexShape[1]) / 2.0));
      vec2 uv = packedUVfrom1D(
        packedTexShape[0], packedTexShape[1], index);
      return ${r.texture2D}(${e}, uv);
    }
  `;
    const i = [
        Math.ceil(o[0] / 2),
        Math.ceil(o[1] / 2)
    ];
    return `
    vec4 ${s}(int index) {
      vec2 uv = packedUVfrom1D(
        ${i[0]}, ${i[1]}, index);
      return ${r.texture2D}(${e}, uv);
    }
  `;
}
function yA(n, t) {
    const e = n.name, s = "get" + e.charAt(0).toUpperCase() + e.slice(1);
    if (n.shapeInfo.isUniform) return `
      float ${s}(int index) {
        ${Mr(n)}
      }
    `;
    const o = n.shapeInfo.texShape, r = o[0], i = o[1];
    if (i === 1 && r === 1) return `
      float ${s}(int index) {
        return sampleTexture(${e}, halfCR);
      }
    `;
    const a = Jo(e);
    return i === 1 ? t ? `
      float ${s}(int index) {
        vec2 uv = vec2(0.5, (float(index + ${a}) + 0.5) / float(${e}TexShape[0]));
        return sampleTexture(${e}, uv);
      }
    ` : `
      float ${s}(int index) {
        vec2 uv = vec2(0.5, (float(index + ${a}) + 0.5) / ${r}.0);
        return sampleTexture(${e}, uv);
      }
    ` : r === 1 ? t ? `
      float ${s}(int index) {
        vec2 uv = vec2((float(index + ${a}) + 0.5) / float(${e}TexShape[1]), 0.5);
        return sampleTexture(${e}, uv);
      }
    ` : `
      float ${s}(int index) {
        vec2 uv = vec2((float(index + ${a}) + 0.5) / ${i}.0, 0.5);
        return sampleTexture(${e}, uv);
      }
    ` : t ? `
    float ${s}(int index) {
      vec2 uv = uvFromFlat(${e}TexShape[0], ${e}TexShape[1], index + ${a});
      return sampleTexture(${e}, uv);
    }
  ` : `
    float ${s}(int index) {
      vec2 uv = uvFromFlat(${r}, ${i}, index + ${a});
      return sampleTexture(${e}, uv);
    }
  `;
}
function wA(n, t) {
    const e = n.shapeInfo.logicalShape, s = n.name, o = "get" + s.charAt(0).toUpperCase() + s.slice(1), r = n.shapeInfo.texShape, i = r[0], a = r[1], l = Ae();
    if (r != null && $t(e, r)) return t ? `
      vec4 ${o}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${s}TexShape[1], ${s}TexShape[0]);

        return ${l.texture2D}(${s}, uv);
      }
    ` : `
      vec4 ${o}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${a}.0, ${i}.0);

        return ${l.texture2D}(${s}, uv);
      }
    `;
    if (t) return `
    vec4 ${o}(int row, int col) {
      ivec2 packedTexShape = ivec2(ceil(float(${s}TexShape[0]) / 2.0), ceil(float(${s}TexShape[1]) / 2.0));
      int valuesPerRow = int(ceil(float(${s}Shape[1]) / 2.0));
      vec2 uv = packedUVfrom2D(valuesPerRow, packedTexShape[0], packedTexShape[1], row, col);
      return ${l.texture2D}(${s}, uv);
    }
  `;
    const c = [
        Math.ceil(r[0] / 2),
        Math.ceil(r[1] / 2)
    ], u = Math.ceil(e[1] / 2);
    return `
    vec4 ${o}(int row, int col) {
      vec2 uv = packedUVfrom2D(${u}, ${c[0]}, ${c[1]}, row, col);
      return ${l.texture2D}(${s}, uv);
    }
  `;
}
function IA(n, t) {
    const e = n.shapeInfo.logicalShape, s = n.name, o = "get" + s.charAt(0).toUpperCase() + s.slice(1), r = n.shapeInfo.texShape;
    if (r != null && $t(e, r)) {
        if (t) return `
      float ${o}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${s}TexShape[1], ${s}TexShape[0]);
        return sampleTexture(${s}, uv);
      }
    `;
        const h = r[0], p = r[1];
        return `
    float ${o}(int row, int col) {
      vec2 uv = (vec2(col, row) + halfCR) / vec2(${p}.0, ${h}.0);
      return sampleTexture(${s}, uv);
    }
  `;
    }
    const { newShape: i, keptDims: a } = ws(e), l = i;
    if (l.length < e.length) {
        const h = Wr(n, l), p = [
            "row",
            "col"
        ];
        return `
      ${Lr(h, t)}
      float ${o}(int row, int col) {
        return ${o}(${Dr(p, a)});
      }
    `;
    }
    if (n.shapeInfo.isUniform) return `
      float ${o}(int row, int col) {
        int index = round(dot(vec2(row, col), vec2(${e[1]}, 1)));
        ${Mr(n)}
      }
    `;
    const c = r[0], u = r[1], d = Jo(s);
    return u === 1 ? t ? `
      float ${o}(int row, int col) {
        float index = dot(vec3(row, col, ${d}), vec3(${s}Shape[1], 1, 1));
        vec2 uv = vec2(0.5, (index + 0.5) / float(${s}TexShape[0]));
        return sampleTexture(${s}, uv);
      }
    ` : `
    float ${o}(int row, int col) {
      float index = dot(vec3(row, col, ${d}), vec3(${e[1]}, 1, 1));
      vec2 uv = vec2(0.5, (index + 0.5) / ${c}.0);
      return sampleTexture(${s}, uv);
    }
  ` : c === 1 ? t ? `
      float ${o}(int row, int col) {
        float index = dot(vec3(row, col, ${d}), vec3(${s}Shape[1], 1, 1));
        vec2 uv = vec2((index + 0.5) / float(${s}TexShape[1]), 0.5);
        return sampleTexture(${s}, uv);
      }
    ` : `
    float ${o}(int row, int col) {
      float index = dot(vec3(row, col, ${d}), vec3(${e[1]}, 1, 1));
      vec2 uv = vec2((index + 0.5) / ${u}.0, 0.5);
      return sampleTexture(${s}, uv);
    }
  ` : t ? `
      float ${o}(int row, int col) {
        // Explicitly use integer operations as dot() only works on floats.
        int index = row * ${s}Shape[1] + col + ${d};
        vec2 uv = uvFromFlat(${s}TexShape[0], ${s}TexShape[1], index);
        return sampleTexture(${s}, uv);
      }
    ` : `
  float ${o}(int row, int col) {
    // Explicitly use integer operations as dot() only works on floats.
    int index = row * ${e[1]} + col + ${d};
    vec2 uv = uvFromFlat(${c}, ${u}, index);
    return sampleTexture(${s}, uv);
  }
`;
}
function CA(n, t) {
    const e = n.shapeInfo.logicalShape, s = n.name, o = "get" + s.charAt(0).toUpperCase() + s.slice(1), r = n.shapeInfo.texShape, i = [
        Math.ceil(r[0] / 2),
        Math.ceil(r[1] / 2)
    ];
    if (e[0] === 1) {
        const h = e.slice(1), p = [
            1,
            2
        ], f = Wr(n, h), m = [
            "b",
            "row",
            "col"
        ];
        return `
        ${CI(f, t)}
        vec4 ${o}(int b, int row, int col) {
          return ${o}(${Dr(m, p)});
        }
      `;
    }
    const a = Ae();
    if (t) return `
    vec4 ${o}(int b, int row, int col) {
      ivec2 packedTexShape = ivec2(ceil(float(${s}TexShape[0]) / 2.0), ceil(float(${s}TexShape[1]) / 2.0));
      int valuesPerRow = int(ceil(float(${s}Shape[2]) / 2.0));
      int texelsInBatch = valuesPerRow * int(ceil(float(${s}Shape[1]) / 2.0));
      vec2 uv = packedUVfrom3D(
        packedTexShape[0], packedTexShape[1], texelsInBatch, valuesPerRow, b, row, col);
      return ${a.texture2D}(${s}, uv);
    }
  `;
    const l = i[0], c = i[1], u = Math.ceil(e[2] / 2), d = u * Math.ceil(e[1] / 2);
    return `
    vec4 ${o}(int b, int row, int col) {
      vec2 uv = packedUVfrom3D(
        ${l}, ${c}, ${d}, ${u}, b, row, col);
      return ${a.texture2D}(${s}, uv);
    }
  `;
}
function vA(n, t) {
    const e = n.shapeInfo.logicalShape, s = n.name, o = "get" + s.charAt(0).toUpperCase() + s.slice(1), r = e[1] * e[2], i = e[2], { newShape: a, keptDims: l } = ws(e), c = a;
    if (c.length < e.length) {
        const m = Wr(n, c), g = [
            "row",
            "col",
            "depth"
        ];
        return `
        ${Lr(m, t)}
        float ${o}(int row, int col, int depth) {
          return ${o}(${Dr(g, l)});
        }
      `;
    }
    if (n.shapeInfo.isUniform) return `
      float ${o}(int row, int col, int depth) {
        int index = round(dot(vec3(row, col, depth),
                          vec3(${r}, ${i}, 1)));
        ${Mr(n)}
      }
    `;
    const u = n.shapeInfo.texShape, d = u[0], h = u[1], p = n.shapeInfo.flatOffset;
    if (h === r && p == null) return t ? `
      float ${o}(int row, int col, int depth) {
        int stride1 = ${s}Shape[2];
        float texR = float(row);
        float texC = dot(vec2(col, depth), vec2(stride1, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${s}TexShape[1], ${s}TexShape[0]);
        return sampleTexture(${s}, uv);
      }
    ` : `
        float ${o}(int row, int col, int depth) {
          float texR = float(row);
          float texC = dot(vec2(col, depth), vec2(${i}, 1));
          vec2 uv = (vec2(texC, texR) + halfCR) /
                     vec2(${h}.0, ${d}.0);
          return sampleTexture(${s}, uv);
        }
      `;
    if (h === i && p == null) return t ? `
      float ${o}(int row, int col, int depth) {
        float texR = dot(vec2(row, col), vec2(${s}Shape[1], 1));
        float texC = float(depth);
        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${s}TexShape[1], ${s}TexShape[0]);
        return sampleTexture(${s}, uv);
      }
    ` : `
    float ${o}(int row, int col, int depth) {
      float texR = dot(vec2(row, col), vec2(${e[1]}, 1));
      float texC = float(depth);
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${h}.0, ${d}.0);
      return sampleTexture(${s}, uv);
    }
  `;
    const f = Jo(s);
    return t ? `
    float ${o}(int row, int col, int depth) {
      // Explicitly use integer operations as dot() only works on floats.
      int stride0 = ${s}Shape[1] * ${s}Shape[2];
      int stride1 = ${s}Shape[2];
      int index = row * stride0 + col * stride1 + depth + ${f};
      vec2 uv = uvFromFlat(${s}TexShape[0], ${s}TexShape[1], index);
      return sampleTexture(${s}, uv);
    }
    ` : `
      float ${o}(int row, int col, int depth) {
        // Explicitly use integer operations as dot() only works on floats.
        int index = row * ${r} + col * ${i} + depth + ${f};
        vec2 uv = uvFromFlat(${d}, ${h}, index);
        return sampleTexture(${s}, uv);
      }
  `;
}
function SA(n, t) {
    const e = n.name, s = "get" + e.charAt(0).toUpperCase() + e.slice(1), o = Ae();
    if (t) return `
    vec4 ${s}(int b2, int b, int row, int col) {
      int valuesPerRow = int(ceil(float(${e}Shape[3]) / 2.0));
      int texelsInBatch = valuesPerRow * int(ceil(float(${e}Shape[2]) / 2.0));
      int index = b * texelsInBatch + (row / 2) * valuesPerRow + (col / 2);
      texelsInBatch *= ${e}Shape[1];
      index = b2 * texelsInBatch + index;
      ivec2 packedTexShape = ivec2(ceil(float(${e}TexShape[0]) / 2.0), ceil(float(${e}TexShape[1]) / 2.0));
      int texR = index / packedTexShape[1];
      int texC = index - texR * packedTexShape[1];
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(packedTexShape[1], packedTexShape[0]); return ${o.texture2D}(${e}, uv);
    }
  `;
    const r = n.shapeInfo.logicalShape, i = r.length, a = n.shapeInfo.texShape, l = [
        Math.ceil(a[0] / 2),
        Math.ceil(a[1] / 2)
    ], c = l[0], u = l[1], d = Math.ceil(r[i - 1] / 2);
    let h = d * Math.ceil(r[i - 2] / 2), p = "int b, int row, int col", f = `b * ${h} + (row / 2) * ${d} + (col / 2)`;
    for(let m = 2; m < i - 1; m++)p = `int b${m}, ` + p, h *= r[i - m - 1], f = `b${m} * ${h} + ` + f;
    return `
    vec4 ${s}(${p}) {
      int index = ${f};
      int texR = index / ${u};
      int texC = index - texR * ${u};
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${u}, ${c});
      return ${o.texture2D}(${e}, uv);
    }
  `;
}
function kA(n, t) {
    const e = n.shapeInfo.logicalShape, s = n.name, o = "get" + s.charAt(0).toUpperCase() + s.slice(1), r = e[3], i = e[2] * r, a = e[1] * i, { newShape: l, keptDims: c } = ws(e);
    if (l.length < e.length) {
        const x = Wr(n, l), w = [
            "row",
            "col",
            "depth",
            "depth2"
        ];
        return `
      ${Lr(x, t)}
      float ${o}(int row, int col, int depth, int depth2) {
        return ${o}(${Dr(w, c)});
      }
    `;
    }
    if (n.shapeInfo.isUniform) return `
      float ${o}(int row, int col, int depth, int depth2) {
        int index = round(dot(vec4(row, col, depth, depth2),
                          vec4(${a}, ${i}, ${r}, 1)));
        ${Mr(n)}
      }
    `;
    const u = n.shapeInfo.flatOffset, d = n.shapeInfo.texShape, h = d[0], p = d[1], f = `int stride2 = ${s}Shape[3];`, m = `int stride1 = ${s}Shape[2] * stride2;`, g = `int stride0 = ${s}Shape[1] * stride1;`;
    if (p === a && u == null) return t ? `
      float ${o}(int row, int col, int depth, int depth2) {
        ${f}
        ${m}
        float texR = float(row);
        float texC =
            dot(vec3(col, depth, depth2),
                vec3(stride1, stride2, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${s}TexShape[1], ${s}TexShape[0]);
        return sampleTexture(${s}, uv);
      }
    ` : `
      float ${o}(int row, int col, int depth, int depth2) {
        float texR = float(row);
        float texC =
            dot(vec3(col, depth, depth2),
                vec3(${i}, ${r}, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${p}.0, ${h}.0);
        return sampleTexture(${s}, uv);
      }
    `;
    if (p === r && u == null) return t ? `
      float ${o}(int row, int col, int depth, int depth2) {
        float texR = dot(vec3(row, col, depth),
                         vec3(${s}Shape[1] * ${s}Shape[2], ${s}Shape[2], 1));
        float texC = float(depth2);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${s}TexShape[1], ${s}TexShape[0]);
        return sampleTexture(${s}, uv);
      }
    ` : `
      float ${o}(int row, int col, int depth, int depth2) {
        float texR = dot(vec3(row, col, depth),
                         vec3(${e[1] * e[2]}, ${e[2]}, 1));
        float texC = float(depth2);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${p}.0, ${h}.0);
        return sampleTexture(${s}, uv);
      }
    `;
    const b = Jo(s);
    return t ? `
    float ${o}(int row, int col, int depth, int depth2) {
      // Explicitly use integer operations as dot() only works on floats.
      ${f}
      ${m}
      ${g}
      int index = row * stride0 + col * stride1 +
          depth * stride2 + depth2;
      vec2 uv = uvFromFlat(${s}TexShape[0], ${s}TexShape[1], index + ${b});
      return sampleTexture(${s}, uv);
    }
  ` : `
    float ${o}(int row, int col, int depth, int depth2) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${a} + col * ${i} +
          depth * ${r} + depth2;
      vec2 uv = uvFromFlat(${h}, ${p}, index + ${b});
      return sampleTexture(${s}, uv);
    }
  `;
}
function TA(n) {
    const t = n.shapeInfo.logicalShape, e = n.name, s = "get" + e.charAt(0).toUpperCase() + e.slice(1), o = t[4], r = t[3] * o, i = t[2] * r, a = t[1] * i, { newShape: l, keptDims: c } = ws(t);
    if (l.length < t.length) {
        const m = Wr(n, l), g = [
            "row",
            "col",
            "depth",
            "depth2",
            "depth3"
        ];
        return `
      ${Lr(m)}
      float ${s}(int row, int col, int depth, int depth2, int depth3) {
        return ${s}(${Dr(g, c)});
      }
    `;
    }
    if (n.shapeInfo.isUniform) return `
      float ${s}(int row, int col, int depth, int depth2, int depth3) {
        float index = dot(
          vec4(row, col, depth, depth2),
          vec4(${a}, ${i}, ${r}, ${o})) +
          depth3;
        ${Mr(n)}
      }
    `;
    const u = n.shapeInfo.flatOffset, d = n.shapeInfo.texShape, h = d[0], p = d[1];
    if (p === a && u == null) return `
      float ${s}(int row, int col, int depth, int depth2, int depth3) {
        int texR = row;
        float texC = dot(vec4(col, depth, depth2, depth3),
                         vec4(${i}, ${r}, ${o}, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${p}.0, ${h}.0);
        return sampleTexture(${e}, uv);
      }
    `;
    if (p === o && u == null) return `
      float ${s}(int row, int col, int depth, int depth2, int depth3) {
        float texR = dot(
          vec4(row, col, depth, depth2),
          vec4(${t[1] * t[2] * t[3]},
               ${t[2] * t[3]}, ${t[3]}, 1));
        int texC = depth3;
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${p}.0, ${h}.0);
        return sampleTexture(${e}, uv);
      }
    `;
    const f = Jo(e);
    return `
    float ${s}(int row, int col, int depth, int depth2, int depth3) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${a} + col * ${i} + depth * ${r} +
          depth2 * ${o} + depth3 + ${f};
      vec2 uv = uvFromFlat(${h}, ${p}, index);
      return sampleTexture(${e}, uv);
    }
  `;
}
function NA(n) {
    const t = n.shapeInfo.logicalShape, e = n.name, s = "get" + e.charAt(0).toUpperCase() + e.slice(1), { newShape: o, keptDims: r } = ws(t);
    if (o.length < t.length) {
        const g = Wr(n, o), b = [
            "row",
            "col",
            "depth",
            "depth2",
            "depth3",
            "depth4"
        ];
        return `
      ${Lr(g)}
      float ${s}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        return ${s}(${Dr(b, r)});
      }
    `;
    }
    const i = t[5], a = t[4] * i, l = t[3] * a, c = t[2] * l, u = t[1] * c;
    if (n.shapeInfo.isUniform) return `
      float ${s}(int row, int col, int depth,
                  int depth2, int depth3, int depth4) {
        int index = round(dot(
          vec4(row, col, depth, depth2),
          vec4(${u}, ${c}, ${l}, ${a})) +
          dot(
            vec2(depth3, depth4),
            vec2(${i}, 1)));
        ${Mr(n)}
      }
    `;
    const d = n.shapeInfo.flatOffset, h = n.shapeInfo.texShape, p = h[0], f = h[1];
    if (f === u && d == null) return `
      float ${s}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        int texR = row;
        float texC = dot(vec4(col, depth, depth2, depth3),
          vec4(${c}, ${l}, ${a}, ${i})) +
               float(depth4);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${f}.0, ${p}.0);
        return sampleTexture(${e}, uv);
      }
    `;
    if (f === i && d == null) return `
      float ${s}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        float texR = dot(vec4(row, col, depth, depth2),
          vec4(${t[1] * t[2] * t[3] * t[4]},
               ${t[2] * t[3] * t[4]},
               ${t[3] * t[4]},
               ${t[4]})) + float(depth3);
        int texC = depth4;
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${f}.0, ${p}.0);
        return sampleTexture(${e}, uv);
      }
    `;
    const m = Jo(e);
    return `
    float ${s}(int row, int col, int depth,
                  int depth2, int depth3, int depth4) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${u} + col * ${c} + depth * ${l} +
          depth2 * ${a} + depth3 * ${i} + depth4 + ${m};
      vec2 uv = uvFromFlat(${p}, ${f}, index);
      return sampleTexture(${e}, uv);
    }
  `;
}
function Mr(n) {
    const t = n.name, e = X(n.shapeInfo.logicalShape);
    return e < 2 ? `return ${t};` : `
    for (int i = 0; i < ${e}; i++) {
      if (i == index) {
        return ${t}[i];
      }
    }
  `;
}
function RA(n, t) {
    const e = n.name, s = e.charAt(0).toUpperCase() + e.slice(1), o = "get" + s + "AtOutCoords", r = n.shapeInfo.logicalShape.length, i = t.logicalShape.length, a = II(n.shapeInfo.logicalShape, t.logicalShape), l = Vt(i), c = i - r;
    let u;
    const d = [
        "x",
        "y",
        "z",
        "w",
        "u",
        "v"
    ];
    r === 0 ? u = "" : i < 2 && a.length >= 1 ? u = "coords = 0;" : u = a.map((x)=>`coords.${d[x + c]} = 0;`).join(`
`);
    let h = "";
    i < 2 && r > 0 ? h = "coords" : h = n.shapeInfo.logicalShape.map((x, w)=>`coords.${d[w + c]}`).join(", ");
    let p = "return outputValue;";
    const m = X(n.shapeInfo.logicalShape) === 1, b = X(t.logicalShape) === 1;
    if (r === 1 && !m && !b) p = `
      return vec4(outputValue.xy, outputValue.xy);
    `;
    else if (m && !b) i === 1 ? p = `
        return vec4(outputValue.x, outputValue.x, 0., 0.);
      ` : p = `
        return vec4(outputValue.x);
      `;
    else if (a.length) {
        const x = r - 2, w = r - 1;
        a.indexOf(x) > -1 && a.indexOf(w) > -1 ? p = "return vec4(outputValue.x);" : a.indexOf(x) > -1 ? p = "return vec4(outputValue.x, outputValue.y, outputValue.x, outputValue.y);" : a.indexOf(w) > -1 && (p = "return vec4(outputValue.xx, outputValue.zz);");
    }
    return `
    vec4 ${o}() {
      ${l} coords = getOutputCoords();
      ${u}
      vec4 outputValue = get${s}(${h});
      ${p}
    }
  `;
}
function $A(n, t) {
    const e = n.name, s = e.charAt(0).toUpperCase() + e.slice(1), o = "get" + s + "AtOutCoords", r = t.texShape, i = n.shapeInfo.texShape, a = n.shapeInfo.logicalShape.length, l = t.logicalShape.length;
    if (!n.shapeInfo.isUniform && a === l && n.shapeInfo.flatOffset == null && $t(i, r)) return `
      float ${o}() {
        return sampleTexture(${e}, resultUV);
      }
    `;
    const c = Vt(l), u = II(n.shapeInfo.logicalShape, t.logicalShape), d = l - a;
    let h;
    const p = [
        "x",
        "y",
        "z",
        "w",
        "u",
        "v"
    ];
    a === 0 ? h = "" : l < 2 && u.length >= 1 ? h = "coords = 0;" : h = u.map((m)=>`coords.${p[m + d]} = 0;`).join(`
`);
    let f = "";
    return l < 2 && a > 0 ? f = "coords" : f = n.shapeInfo.logicalShape.map((m, g)=>`coords.${p[g + d]}`).join(", "), `
    float ${o}() {
      ${c} coords = getOutputCoords();
      ${h}
      return get${s}(${f});
    }
  `;
}
function Vt(n) {
    if (n <= 1) return "int";
    if (n === 2) return "ivec2";
    if (n === 3) return "ivec3";
    if (n === 4) return "ivec4";
    if (n === 5) return "ivec5";
    if (n === 6) return "ivec6";
    throw Error(`GPU for rank ${n} is not yet supported`);
}
function jf(n, t, e) {
    const { newShape: s, keptDims: o } = ws(t), r = t.length, i = n && r === 3 && t[0] === 1, a = i ? t.slice(1) : s, l = !n && r > 1 && !$t(t, e) && s.length < r || i;
    return {
        useSqueezeShape: l,
        uniformShape: l ? a : t,
        keptDims: o
    };
}
function Wr(n, t) {
    const e = JSON.parse(JSON.stringify(n));
    return e.shapeInfo.logicalShape = t, e;
}
function Dr(n, t) {
    return t.map((e)=>n[e]).join(", ");
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function GA(n, t, e, s) {
    const o = e.map((u, d)=>{
        const h = {
            logicalShape: u.shape,
            texShape: u.isUniform ? null : u.texData.texShape,
            isUniform: u.isUniform,
            isPacked: u.isUniform ? !1 : u.texData.isPacked,
            flatOffset: null
        };
        return u.texData != null && u.texData.slice != null && u.texData.slice.flatOffset > 0 && (h.flatOffset = u.texData.slice.flatOffset), {
            name: t.variableNames[d],
            shapeInfo: h
        };
    }), r = o.map((u)=>u.shapeInfo), i = {
        logicalShape: s.shape,
        texShape: s.texData.texShape,
        isUniform: !1,
        isPacked: s.texData.isPacked,
        flatOffset: null
    }, a = UP(o, i, t), l = qw(n.gl, a), c = n.createProgram(l);
    return F().get("ENGINE_COMPILE_ONLY") ? {
        program: t,
        fragmentShader: l,
        source: a,
        webGLProgram: c,
        inShapeInfos: r,
        outShapeInfo: i,
        variablesLocations: null,
        customUniformLocations: null,
        infLoc: null,
        nanLoc: null,
        outShapeLocation: null,
        outShapeStridesLocation: null,
        outTexShapeLocation: null
    } : (n.buildVao(c), Object.assign({
        program: t,
        fragmentShader: l,
        source: a,
        webGLProgram: c,
        inShapeInfos: r,
        outShapeInfo: i
    }, SI(n, t, c)));
}
function SI(n, t, e) {
    const s = [], o = [];
    let r, i, a, l = null, c = null;
    c = n.getUniformLocation(e, "NAN", !1), F().getNumber("WEBGL_VERSION") === 1 && (l = n.getUniformLocation(e, "INFINITY", !1));
    const u = !1;
    for (const d of t.variableNames){
        const h = {
            name: d,
            uniform: n.getUniformLocation(e, d, u),
            offset: n.getUniformLocation(e, `offset${d}`, u)
        };
        t.enableShapeUniforms && (h.shape = n.getUniformLocation(e, `${d}Shape`, u), h.texShape = n.getUniformLocation(e, `${d}TexShape`, u)), s.push(h);
    }
    if (t.enableShapeUniforms && (r = n.getUniformLocation(e, "outShape", u), a = n.getUniformLocation(e, "outShapeStrides", u), i = n.getUniformLocation(e, "outTexShape", u)), t.customUniforms) for (const d of t.customUniforms)o.push(n.getUniformLocation(e, d.name, u));
    return {
        variablesLocations: s,
        customUniformLocations: o,
        infLoc: l,
        nanLoc: c,
        outShapeLocation: r,
        outShapeStridesLocation: a,
        outTexShapeLocation: i
    };
}
function yg(n, t) {
    if (n.length !== t.length) throw Error(`Binary was compiled with ${n.length} inputs, but was executed with ${t.length} inputs`);
    n.forEach((e, s)=>{
        const o = e.logicalShape, r = t[s], i = r.shape;
        if (!$t(o, i)) throw Error(`Binary was compiled with different shapes than the current args. Shapes ${o} and ${i} must match`);
        if (e.isUniform && r.isUniform) return;
        const a = e.texShape, l = r.isUniform ? null : r.texData.texShape;
        if (!$t(a, l)) throw Error(`Binary was compiled with different texture shapes than the current args. Shape ${a} and ${l} must match`);
    });
}
function EA(n, t, e, s, o) {
    t.program.enableShapeUniforms || (yg(t.inShapeInfos, e), yg([
        t.outShapeInfo
    ], [
        s
    ]));
    const r = s.texData.texture, i = s.texData.texShape;
    s.texData.isPacked ? n.setOutputPackedMatrixTexture(r.texture, i[0], i[1]) : n.setOutputMatrixTexture(r.texture, i[0], i[1]), n.setProgram(t.webGLProgram), n.bindVertexArray(t.webGLProgram.vao), F().getNumber("WEBGL_VERSION") === 1 && t.infLoc !== null && n.gl.uniform1f(t.infLoc, 1 / 0), t.nanLoc !== null && n.gl.uniform1f(t.nanLoc, NaN);
    for(let l = 0; l < e.length; ++l){
        const c = e[l], { uniform: u, offset: d, shape: h, texShape: p } = t.variablesLocations[l];
        if (h) {
            const { uniformShape: f } = jf(t.program.packedInputs, c.shape, c.texData.texShape);
            switch(f.length){
                case 1:
                    n.gl.uniform1iv(h, new Int32Array(f));
                    break;
                case 2:
                    n.gl.uniform2iv(h, new Int32Array(f));
                    break;
                case 3:
                    n.gl.uniform3iv(h, new Int32Array(f));
                    break;
                case 4:
                    n.gl.uniform4iv(h, new Int32Array(f));
                    break;
            }
        }
        if (p && n.gl.uniform2i(p, c.texData.texShape[0], c.texData.texShape[1]), u != null) {
            if (c.isUniform) {
                if (X(c.shape) < 2) n.gl.uniform1f(u, c.uniformValues[0]);
                else {
                    let f = c.uniformValues;
                    f instanceof Float32Array || (f = new Float32Array(f)), n.gl.uniform1fv(u, f);
                }
                continue;
            }
            c.texData.slice != null && d != null && n.gl.uniform1i(d, c.texData.slice.flatOffset), n.setInputMatrixTexture(c.texData.texture.texture, u, l);
        }
    }
    const a = t.outShapeLocation;
    if (a) switch(s.shape.length){
        case 1:
            n.gl.uniform1iv(a, new Int32Array(s.shape));
            break;
        case 2:
            n.gl.uniform2iv(a, new Int32Array(s.shape));
            break;
        case 3:
            n.gl.uniform3iv(a, new Int32Array(s.shape));
            break;
        case 4:
            n.gl.uniform4iv(a, new Int32Array(s.shape));
            break;
    }
    if (t.outShapeStridesLocation) {
        const l = dt(s.shape);
        switch(s.shape.length){
            case 2:
                n.gl.uniform1iv(t.outShapeStridesLocation, new Int32Array(l));
                break;
            case 3:
                n.gl.uniform2iv(t.outShapeStridesLocation, new Int32Array(l));
                break;
            case 4:
                n.gl.uniform3iv(t.outShapeStridesLocation, new Int32Array(l));
                break;
        }
    }
    if (t.outTexShapeLocation && n.gl.uniform2i(t.outTexShapeLocation, s.texData.texShape[0], s.texData.texShape[1]), t.program.customUniforms && o) for(let l = 0; l < t.program.customUniforms.length; ++l){
        const c = t.program.customUniforms[l], u = t.customUniformLocations[l], d = o[l];
        if (c.type === "float") n.gl.uniform1fv(u, d);
        else if (c.type === "vec2") n.gl.uniform2fv(u, d);
        else if (c.type === "vec3") n.gl.uniform3fv(u, d);
        else if (c.type === "vec4") n.gl.uniform4fv(u, d);
        else if (c.type === "int") n.gl.uniform1iv(u, d);
        else if (c.type === "ivec2") n.gl.uniform2iv(u, d);
        else if (c.type === "ivec3") n.gl.uniform3iv(u, d);
        else if (c.type === "ivec4") n.gl.uniform4iv(u, d);
        else throw Error(`uniform type ${c.type} is not supported yet.`);
    }
    n.executeProgram();
}
function LA(n, t, e) {
    let s = "";
    t.concat(e).forEach((i)=>{
        const a = i.texData != null && i.texData.slice != null && i.texData.slice.flatOffset > 0;
        if (n.enableShapeUniforms && !i.isUniform) {
            const l = i.texData.texShape, { useSqueezeShape: c, uniformShape: u, keptDims: d } = jf(n.packedInputs, i.shape, l);
            let h = "", p = "", f = "";
            if (u.length === 1 && n.packedInputs) {
                const I = [
                    Math.ceil(l[0] / 2),
                    Math.ceil(l[1] / 2)
                ];
                h = `${I[0] > 1}_${I[1] > 1}`;
            } else if (u.length === 2 && !n.packedInputs) p = `${u[0] > 1}_${u[1] > 1}`;
            else if (u.length > 2 && !n.packedInputs) {
                const I = dt(u);
                f = `${I[0] === l[1]}_${I[I.length - 1] === l[1]}`;
            }
            const m = i.shape.length, g = u.length === 2 && $t(i.shape, l), b = X(i.shape) === 1, x = Go(i.shape, e.shape), w = !n.packedInputs && m === e.shape.length && $t(l, e.texData.texShape), y = n.packedInputs || u.length > 2 ? "" : `${l[0] > 1}_${l[1] > 1}`;
            s += `${m}_${w}_${c ? d : ""}_${u.length}_${b}_${x}_${g}_${h}_${p}_${f}_${y}_${a}`;
        } else {
            const l = i.isUniform ? "uniform" : i.texData.texShape;
            s += `${i.shape}_${l}_${a}`;
        }
    });
    const o = n.userCode;
    let r = n.constructor.name;
    return r += "_" + s + "_" + o + `${F().getNumber("WEBGL_VERSION")}`, r;
}
function Me(n) {
    return F().getBool("WEBGL_USE_SHAPES_UNIFORMS") && n <= 4;
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class MA {
    constructor(t){
        this.variableNames = [
            "A"
        ], this.packedInputs = !1, this.packedOutput = !0, this.outPackingScheme = bi.DENSE, this.customUniforms = [
            {
                name: "texShape",
                type: "ivec2"
            }
        ];
        const e = Ae();
        this.outputShape = t, this.enableShapeUniforms = Me(this.outputShape.length), this.userCode = `
      ivec3 outCoordsFromFlatIndex(int index) {
        ${this.enableShapeUniforms ? Iu([
            "r",
            "c",
            "d"
        ], t) : Qo([
            "r",
            "c",
            "d"
        ], t)}
        return ivec3(r, c, d);
      }

      void main() {
        ivec2 resTexRC = ivec2(resultUV.yx * vec2(texShape[0], texShape[1]));
        int index = 4 * (resTexRC.x * texShape[1] + resTexRC.y);

        vec4 result = vec4(0.);

        for (int i=0; i<4; i++) {
          int flatIndex = index + i;
          ivec3 rc = outCoordsFromFlatIndex(flatIndex);
          result[i] = getA(rc.x, rc.y, rc.z);
        }

        ${e.output} = result;
      }
    `;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class WA {
    constructor(t){
        this.variableNames = [
            "A"
        ], this.packedInputs = !0, this.packedOutput = !0, this.outPackingScheme = bi.DENSE, this.customUniforms = [
            {
                name: "texShape",
                type: "ivec2"
            }
        ];
        const e = Ae();
        this.outputShape = t, this.enableShapeUniforms = Me(this.outputShape.length), this.userCode = `
      ivec3 outCoordsFromFlatIndex(int index) {
        ${this.enableShapeUniforms ? Iu([
            "r",
            "c",
            "d"
        ], t) : Qo([
            "r",
            "c",
            "d"
        ], t)}
        return ivec3(r, c, d);
      }

      void main() {
        ivec2 resTexRC = ivec2(resultUV.yx * vec2(texShape[0], texShape[1]));
        int index = 4 * (resTexRC.x * texShape[1] + resTexRC.y);

        vec4 result = vec4(0.);

        for (int i=0; i<4; i++) {
          int flatIndex = index + i;
          ivec3 rc = outCoordsFromFlatIndex(flatIndex);
          result[i] = getChannel(getA(rc.x, rc.y, rc.z), vec2(rc.y, rc.z));
        }

        ${e.output} = result;
      }
    `;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class DA {
    constructor(t){
        this.variableNames = [
            "A"
        ], this.outTexUsage = un.DOWNLOAD;
        const e = Ae();
        this.outputShape = t, this.userCode = `
      ${wI}

      void main() {
        float x = getAAtOutCoords();
        ${e.output} = encode_float(x);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class FA {
    constructor(t){
        this.variableNames = [
            "A"
        ], this.packedInputs = !0, this.packedOutput = !1, this.outTexUsage = un.DOWNLOAD;
        const e = Ae();
        this.outputShape = t, this.userCode = `
      ${wI}

      void main() {
        ivec3 coords = getOutputCoords();
        float x = getChannel(getAAtOutCoords(), vec2(coords.y, coords.z));
        ${e.output} = encode_float(x);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const VA = {
    R: 0,
    G: 1,
    B: 2,
    A: 3
};
class wg {
    constructor(t, e = !1, s = "RGBA"){
        this.variableNames = [
            "A"
        ], this.customUniforms = [
            {
                name: "texShape",
                type: "ivec2"
            }
        ];
        const o = Ae();
        this.outputShape = t, this.enableShapeUniforms = Me(this.outputShape.length);
        let r = "result";
        e && (r = "floor(result * 255. + 0.5)");
        let i = "";
        for(let a = 0; a < s.length; a++){
            const l = s[a];
            i += `
          if(offset == ${a}) {
            result = values[${VA[l]}];
          }`;
        }
        this.userCode = `
      ${this.enableShapeUniforms ? Jf() : Qf(t)}

      void main() {
        ivec3 coords = getOutputCoords();
        int flatIndex = getFlatIndex(coords);
        float result = 0.;
        int offset = imod(flatIndex, ${s.length});

        flatIndex = idiv(flatIndex, ${s.length}, 1.);

        int r = flatIndex / texShape[1];
        if (r < texShape[0]) {
          int c = imod(flatIndex, texShape[1]);
          vec2 uv = (vec2(c, r) + halfCR) / vec2(texShape[1], texShape[0]);
          vec4 values = ${o.texture2D}(A, uv);
          ${i}
        }
        ${o.output} = vec4(${r}, 0., 0., 0.);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class zA {
    constructor(t, e = !1){
        this.variableNames = [
            "A"
        ], this.packedInputs = !1, this.packedOutput = !0, this.customUniforms = [
            {
                name: "texShape",
                type: "ivec2"
            }
        ];
        const s = Ae();
        this.outputShape = t, this.enableShapeUniforms = Me(this.outputShape.length);
        let o = "", r = "result";
        e && (r = "floor(result * 255. + 0.5)");
        for(let i = 0; i <= 1; i++)for(let a = 0; a <= 1; a++){
            const l = i * 2 + a;
            o += `
          localCoords = coords;
          if(localCoords[2] + ${a} < ${this.enableShapeUniforms ? "outShape[2]" : `${t[2]}`}) {
          localCoords[2] += ${a};
          if (localCoords[1] + ${i} < ${this.enableShapeUniforms ? "outShape[1]" : `${t[1]}`}) {
            localCoords[1] += ${i};

            flatIndex = getFlatIndex(localCoords);
            offset = imod(flatIndex, 4);

            flatIndex = idiv(flatIndex, 4, 1.);

            int r = flatIndex / texShape[1];
            int c = imod(flatIndex, texShape[1]);
            vec2 uv = (vec2(c, r) + halfCR) / vec2(texShape[1], texShape[0]);
            values = ${s.texture2D}(A, uv);

            if (offset == 0) {
              result[${l}] = values[0];
            } else if (offset == 1) {
              result[${l}] = values[1];
            } else if (offset == 2) {
              result[${l}] = values[2];
            } else {
              result[${l}] = values[3];
            }
          }
        }
        `;
        }
        this.userCode = `
        ${this.enableShapeUniforms ? Jf() : Qf(t)}

        void main() {
          ivec3 coords = getOutputCoords();

          vec4 result = vec4(0.);
          int flatIndex, r, c, offset;
          ivec3 localCoords;
          vec2 uv;
          vec4 values;

          ${o}

          ${s.output} = ${r};
        }
    `;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function kI(n) {
    const t = Ae(), e = `${t.version}
    precision highp float;
    ${t.attribute} vec3 clipSpacePos;
    ${t.attribute} vec2 uv;
    ${t.varyingVs} vec2 resultUV;

    void main() {
      gl_Position = vec4(clipSpacePos, 1);
      resultUV = uv;
    }`;
    return jw(n, e);
}
function TI(n) {
    const t = new Float32Array([
        -1,
        1,
        0,
        0,
        1,
        -1,
        -1,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        -1,
        0,
        1,
        0
    ]);
    return nI(n, t);
}
function NI(n) {
    const t = new Uint16Array([
        0,
        1,
        2,
        2,
        1,
        3
    ]);
    return sI(n, t);
}
function Aa(n, t, e, s, o, r) {
    rI(t, e);
    const i = oI(n), a = n.TEXTURE_2D;
    return nt(n, ()=>n.bindTexture(a, i)), nt(n, ()=>n.texParameteri(a, n.TEXTURE_WRAP_S, n.CLAMP_TO_EDGE)), nt(n, ()=>n.texParameteri(a, n.TEXTURE_WRAP_T, n.CLAMP_TO_EDGE)), nt(n, ()=>n.texParameteri(a, n.TEXTURE_MIN_FILTER, n.NEAREST)), nt(n, ()=>n.texParameteri(a, n.TEXTURE_MAG_FILTER, n.NEAREST)), F().getNumber("WEBGL_VERSION") === 1 ? nt(n, ()=>n.texImage2D(a, 0, s, t, e, 0, o, r, null)) : nt(n, ()=>n.texStorage2D(a, 1, s, t, e)), nt(n, ()=>n.bindTexture(n.TEXTURE_2D, null)), {
        texture: i,
        texShape: [
            e,
            t
        ]
    };
}
function qf(n) {
    return n.internalFormatFloat;
}
function RI(n, t, e, s) {
    const [o, r] = Pa(t, e);
    return Aa(n, o, r, qf(s), s.textureFormatFloat, n.FLOAT);
}
function tm(n) {
    return n.internalFormatHalfFloat;
}
function $I(n, t, e, s) {
    const [o, r] = Pa(t, e);
    return Aa(n, o, r, tm(s), s.textureFormatFloat, s.textureTypeHalfFloat);
}
function em(n) {
    return n.downloadTextureFormat;
}
function GI(n, t, e, s) {
    const [o, r] = Pa(t, e);
    return Aa(n, o, r, em(s), n.RGBA, n.UNSIGNED_BYTE);
}
function nm(n) {
    return n.internalFormatPackedFloat;
}
function EI(n, t, e, s) {
    const [o, r] = Gr(t, e);
    return Aa(n, o, r, nm(s), n.RGBA, n.FLOAT);
}
function sm(n) {
    return n.internalFormatPackedHalfFloat;
}
function LI(n, t, e, s) {
    const [o, r] = Gr(t, e);
    return Aa(n, o, r, sm(s), n.RGBA, s.textureTypeHalfFloat);
}
function MI(n, t, e) {
    return nt(n, ()=>n.bindBuffer(n.ARRAY_BUFFER, e)), zd(n, t, "clipSpacePos", e, 3, 20, 0) && zd(n, t, "uv", e, 2, 20, 12);
}
function WI(n, t, e, s, o, r) {
    nt(n, ()=>n.bindTexture(n.TEXTURE_2D, t));
    let i, a, l;
    o instanceof Uint8Array ? (i = new Uint8Array(e * s * 4), a = n.UNSIGNED_BYTE, l = n.RGBA) : (i = new Float32Array(e * s * 4), a = n.FLOAT, l = r.internalFormatPackedFloat), i.set(o), F().getNumber("WEBGL_VERSION") === 2 ? nt(n, ()=>n.texSubImage2D(n.TEXTURE_2D, 0, 0, 0, e, s, n.RGBA, a, i)) : nt(n, ()=>n.texImage2D(n.TEXTURE_2D, 0, l, e, s, 0, n.RGBA, a, i)), nt(n, ()=>n.bindTexture(n.TEXTURE_2D, null));
}
function DI(n, t, e) {
    nt(n, ()=>n.bindTexture(n.TEXTURE_2D, t)), e.data instanceof Uint8Array ? F().getNumber("WEBGL_VERSION") === 2 ? nt(n, ()=>n.texSubImage2D(n.TEXTURE_2D, 0, 0, 0, e.width, e.height, n.RGBA, n.UNSIGNED_BYTE, e.data)) : nt(n, ()=>n.texImage2D(n.TEXTURE_2D, 0, n.RGBA, e.width, e.height, 0, n.RGBA, n.UNSIGNED_BYTE, e.data)) : F().getNumber("WEBGL_VERSION") === 2 ? nt(n, ()=>n.texSubImage2D(n.TEXTURE_2D, 0, 0, 0, n.RGBA, n.UNSIGNED_BYTE, e)) : nt(n, ()=>n.texImage2D(n.TEXTURE_2D, 0, n.RGBA, n.RGBA, n.UNSIGNED_BYTE, e)), nt(n, ()=>n.bindTexture(n.TEXTURE_2D, null));
}
function FI(n, t, e, s) {
    const o = n.createBuffer();
    nt(n, ()=>n.bindBuffer(n.PIXEL_PACK_BUFFER, o));
    const a = 16 * t * e;
    return nt(n, ()=>n.bufferData(n.PIXEL_PACK_BUFFER, a, n.STREAM_READ)), nt(n, ()=>n.readPixels(0, 0, e, t, n.RGBA, n.FLOAT, 0)), nt(n, ()=>n.bindBuffer(n.PIXEL_PACK_BUFFER, null)), o;
}
function VI(n, t, e) {
    const s = n, o = new Float32Array(e);
    return s.bindBuffer(s.PIXEL_PACK_BUFFER, t), s.getBufferSubData(s.PIXEL_PACK_BUFFER, 0, o), s.bindBuffer(s.PIXEL_PACK_BUFFER, null), o;
}
function zI(n, t, e, s) {
    const [o, r] = Pa(t, e), i = 4, a = new Uint8Array(WP(t * e, i));
    return nt(n, ()=>n.readPixels(0, 0, o, r, s.downloadTextureFormat, n.UNSIGNED_BYTE, a)), new Float32Array(a.buffer);
}
function PI(n, t, e, s, o, r, i, a) {
    const l = n, c = new Float32Array(DP(r, i));
    return l.bindBuffer(l.PIXEL_PACK_BUFFER, t), l.getBufferSubData(l.PIXEL_PACK_BUFFER, 0, c), l.bindBuffer(l.PIXEL_PACK_BUFFER, null), c;
}
function AI(n, t, e) {
    const s = new Float32Array(t * e * 4);
    return nt(n, ()=>n.readPixels(0, 0, e, t, n.RGBA, n.FLOAT, s)), s;
}
const UQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    bindVertexProgramAttributeStreams: MI,
    createBufferFromOutputTexture: FI,
    createFloat16MatrixTexture: $I,
    createFloat16PackedMatrixTexture: LI,
    createFloat32MatrixTexture: RI,
    createIndexBuffer: NI,
    createPackedMatrixTexture: EI,
    createUnsignedBytesMatrixTexture: GI,
    createVertexBuffer: TI,
    createVertexShader: kI,
    downloadByteEncodedFloatMatrixFromOutputTexture: zI,
    downloadFloat32MatrixFromBuffer: VI,
    downloadMatrixFromPackedOutputTexture: AI,
    downloadPackedMatrixFromBuffer: PI,
    getInternalFormatForFloat16MatrixTexture: tm,
    getInternalFormatForFloat16PackedMatrixTexture: sm,
    getInternalFormatForFloat32MatrixTexture: qf,
    getInternalFormatForPackedMatrixTexture: nm,
    getInternalFormatForUnsignedBytesMatrixTexture: em,
    uploadDenseMatrixToTexture: WI,
    uploadPixelDataToTexture: DI
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class Au {
    constructor(t){
        this.outputTexture = null, this.program = null, this.disposed = !1, this.itemsToPoll = [];
        const e = F().getNumber("WEBGL_VERSION");
        if (t != null ? (this.gl = t, EP(e, t)) : this.gl = Bn(e), t = this.gl, F().getNumber("WEBGL_VERSION") === 2) {
            const r = t;
            this.createVertexArray = ()=>nt(r, ()=>r.createVertexArray()), this.bindVertexArray = (i)=>nt(r, ()=>r.bindVertexArray(i)), this.deleteVertexArray = (i)=>nt(r, ()=>r.deleteVertexArray(i)), this.getVertexArray = ()=>nt(r, ()=>r.getParameter(r.VERTEX_ARRAY_BINDING));
        } else if (t != null) {
            const r = t.getExtension("OES_vertex_array_object");
            if (r == null) throw new Error("All WebGL1 implementations are expected to offer OES_vertex_array_object.");
            this.createVertexArray = ()=>nt(t, ()=>r.createVertexArrayOES()), this.bindVertexArray = (i)=>nt(t, ()=>r.bindVertexArrayOES(i)), this.deleteVertexArray = (i)=>nt(t, ()=>r.deleteVertexArrayOES(i)), this.getVertexArray = ()=>nt(t, ()=>t.getParameter(r.VERTEX_ARRAY_BINDING_OES));
        }
        let s = "WEBGL_color_buffer_float";
        const o = "EXT_color_buffer_half_float";
        if (this.parallelCompilationExtension = this.gl.getExtension("KHR_parallel_shader_compile"), F().getNumber("WEBGL_VERSION") === 1) {
            const r = "OES_texture_float", i = "OES_texture_half_float";
            if (this.textureFloatExtension = jr(this.gl, r), dn(this.gl, i)) this.textureHalfFloatExtension = jr(this.gl, i);
            else if (F().get("WEBGL_FORCE_F16_TEXTURES")) throw new Error("GL context does not support half float textures, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.");
            if (this.colorBufferFloatExtension = this.gl.getExtension(s), dn(this.gl, o)) this.colorBufferHalfFloatExtension = jr(this.gl, o);
            else if (F().get("WEBGL_FORCE_F16_TEXTURES")) throw new Error("GL context does not support color renderable half floats, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.");
        } else if (s = "EXT_color_buffer_float", dn(this.gl, s)) this.colorBufferFloatExtension = this.gl.getExtension(s);
        else if (dn(this.gl, o)) this.colorBufferHalfFloatExtension = this.gl.getExtension(o);
        else throw new Error("GL context does not support color renderable floats");
        this.vertexBuffer = TI(this.gl), this.indexBuffer = NI(this.gl), this.framebuffer = iI(this.gl), this.textureConfig = Uf(this.gl, this.textureHalfFloatExtension);
    }
    get debug() {
        return F().getBool("DEBUG");
    }
    dispose() {
        if (this.disposed) return;
        this.program != null && console.warn("Disposing a GPGPUContext that still has a bound WebGLProgram. This is probably a resource leak, delete the program with GPGPUContext.deleteProgram before disposing."), this.outputTexture != null && console.warn("Disposing a GPGPUContext that still has a bound output matrix texture.  This is probably a resource leak, delete the output matrix texture with GPGPUContext.deleteMatrixTexture before disposing.");
        const t = this.gl;
        nt(t, ()=>t.finish()), nt(t, ()=>t.bindFramebuffer(t.FRAMEBUFFER, null)), nt(t, ()=>t.deleteFramebuffer(this.framebuffer)), nt(t, ()=>t.bindBuffer(t.ARRAY_BUFFER, null)), nt(t, ()=>t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, null)), nt(t, ()=>t.deleteBuffer(this.indexBuffer)), this.disposed = !0;
    }
    createFloat32MatrixTexture(t, e) {
        return this.throwIfDisposed(), RI(this.gl, t, e, this.textureConfig);
    }
    createFloat16MatrixTexture(t, e) {
        return this.throwIfDisposed(), $I(this.gl, t, e, this.textureConfig);
    }
    createUnsignedBytesMatrixTexture(t, e) {
        return this.throwIfDisposed(), GI(this.gl, t, e, this.textureConfig);
    }
    uploadPixelDataToTexture(t, e) {
        this.throwIfDisposed(), DI(this.gl, t, e);
    }
    uploadDenseMatrixToTexture(t, e, s, o) {
        this.throwIfDisposed(), WI(this.gl, t, e, s, o, this.textureConfig);
    }
    createFloat16PackedMatrixTexture(t, e) {
        return this.throwIfDisposed(), LI(this.gl, t, e, this.textureConfig);
    }
    createPackedMatrixTexture(t, e) {
        return this.throwIfDisposed(), EI(this.gl, t, e, this.textureConfig);
    }
    deleteMatrixTexture(t) {
        this.throwIfDisposed(), this.outputTexture === t && (Pd(this.gl, this.framebuffer), this.outputTexture = null), nt(this.gl, ()=>this.gl.deleteTexture(t));
    }
    downloadByteEncodedFloatMatrixFromOutputTexture(t, e, s) {
        return this.downloadMatrixDriver(t, ()=>zI(this.gl, e, s, this.textureConfig));
    }
    downloadPackedMatrixFromBuffer(t, e, s, o, r, i) {
        return PI(this.gl, t, e, s, o, r, i, this.textureConfig);
    }
    downloadFloat32MatrixFromBuffer(t, e) {
        return VI(this.gl, t, e);
    }
    createBufferFromTexture(t, e, s) {
        this.bindTextureToFrameBuffer(t);
        const o = FI(this.gl, e, s, this.textureConfig);
        return this.unbindTextureToFrameBuffer(), o;
    }
    createAndWaitForFence() {
        const t = this.createFence(this.gl);
        return this.pollFence(t);
    }
    createFence(t) {
        let e, s;
        if (F().getBool("WEBGL_FENCE_API_ENABLED")) {
            const o = t, r = o.fenceSync(o.SYNC_GPU_COMMANDS_COMPLETE, 0);
            t.flush(), s = ()=>{
                const i = o.clientWaitSync(r, 0, 0);
                return i === o.ALREADY_SIGNALED || i === o.CONDITION_SATISFIED;
            }, e = r;
        } else F().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0 ? (e = this.beginQuery(), this.endQuery(), s = ()=>this.isQueryAvailable(e, F().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"))) : s = ()=>!0;
        return {
            query: e,
            isFencePassed: s
        };
    }
    downloadMatrixFromPackedTexture(t, e, s) {
        return this.downloadMatrixDriver(t, ()=>AI(this.gl, e, s));
    }
    createProgram(t) {
        this.throwIfDisposed();
        const e = this.gl;
        this.vertexShader == null && (this.vertexShader = kI(e));
        const s = tI(e);
        nt(e, ()=>e.attachShader(s, this.vertexShader)), nt(e, ()=>e.attachShader(s, t)), eI(e, s);
        const o = Object.assign(s, {
            vao: this.createVertexArray()
        });
        return this.debug && al(e, o), o;
    }
    buildVao(t) {
        this.setProgram(t), this.bindVertexArray(t.vao);
        const e = this.gl;
        nt(e, ()=>e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, this.indexBuffer)), MI(e, t, this.vertexBuffer);
    }
    deleteProgram(t) {
        this.throwIfDisposed(), t === this.program && (this.program = null), t != null && (nt(this.gl, ()=>this.gl.deleteProgram(t)), this.deleteVertexArray(t.vao));
    }
    setProgram(t) {
        this.throwIfDisposed(), this.program = t, this.program != null && this.debug && al(this.gl, this.program), nt(this.gl, ()=>this.gl.useProgram(t));
    }
    getUniformLocation(t, e, s = !0) {
        return this.throwIfDisposed(), s ? lI(this.gl, t, e) : cI(this.gl, t, e);
    }
    getAttributeLocation(t, e) {
        return this.throwIfDisposed(), nt(this.gl, ()=>this.gl.getAttribLocation(t, e));
    }
    getUniformLocationNoThrow(t, e) {
        return this.throwIfDisposed(), this.gl.getUniformLocation(t, e);
    }
    setInputMatrixTexture(t, e, s) {
        this.throwIfDisposed(), this.throwIfNoProgram(), uI(this.gl, t, e, s);
    }
    setOutputMatrixTexture(t, e, s) {
        this.setOutputMatrixTextureDriver(t, s, e);
    }
    setOutputPackedMatrixTexture(t, e, s) {
        this.throwIfDisposed();
        const [o, r] = Gr(e, s);
        this.setOutputMatrixTextureDriver(t, o, r);
    }
    setOutputMatrixWriteRegion(t, e, s, o) {
        this.setOutputMatrixWriteRegionDriver(s, t, o, e);
    }
    setOutputPackedMatrixWriteRegion(t, e, s, o) {
        throw new Error("setOutputPackedMatrixWriteRegion not implemented.");
    }
    debugValidate() {
        this.program != null && al(this.gl, this.program), qr(this.gl);
    }
    executeProgram() {
        this.throwIfDisposed(), this.throwIfNoProgram();
        const t = this.gl;
        if (this.debug) {
            const e = this.getVertexArray();
            console.assert(e === this.program.vao, "VAO changed between setProgram and executeProgram!"), this.debugValidate();
        }
        nt(t, ()=>t.drawElements(t.TRIANGLES, 6, t.UNSIGNED_SHORT, 0));
    }
    blockUntilAllProgramsCompleted() {
        this.throwIfDisposed(), nt(this.gl, ()=>this.gl.finish());
    }
    getQueryTimerExtension() {
        return this.disjointQueryTimerExtension == null && (this.disjointQueryTimerExtension = jr(this.gl, F().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") === 2 ? "EXT_disjoint_timer_query_webgl2" : "EXT_disjoint_timer_query")), this.disjointQueryTimerExtension;
    }
    getQueryTimerExtensionWebGL2() {
        return this.getQueryTimerExtension();
    }
    getQueryTimerExtensionWebGL1() {
        return this.getQueryTimerExtension();
    }
    beginQuery() {
        if (F().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") === 2) {
            const s = this.gl, o = this.getQueryTimerExtensionWebGL2(), r = s.createQuery();
            return s.beginQuery(o.TIME_ELAPSED_EXT, r), r;
        }
        const t = this.getQueryTimerExtensionWebGL1(), e = t.createQueryEXT();
        return t.beginQueryEXT(t.TIME_ELAPSED_EXT, e), e;
    }
    endQuery() {
        if (F().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") === 2) {
            const e = this.gl, s = this.getQueryTimerExtensionWebGL2();
            e.endQuery(s.TIME_ELAPSED_EXT);
            return;
        }
        const t = this.getQueryTimerExtensionWebGL1();
        t.endQueryEXT(t.TIME_ELAPSED_EXT);
    }
    async waitForQueryAndGetTime(t) {
        return await id(()=>this.disposed || // while testing contexts are created / disposed
            // in rapid succession, so without this check we
            // may poll for the query timer indefinitely
            this.isQueryAvailable(t, F().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"))), this.getQueryTime(t, F().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"));
    }
    getQueryTime(t, e) {
        if (e === 0) return null;
        if (e === 2) {
            const s = this.gl;
            return s.getQueryParameter(t, s.QUERY_RESULT) / 1e6;
        } else {
            const s = this.getQueryTimerExtensionWebGL1();
            return s.getQueryObjectEXT(t, s.QUERY_RESULT_EXT) / 1e6;
        }
    }
    isQueryAvailable(t, e) {
        if (e === 0) return !0;
        if (e === 2) {
            const s = this.gl, o = this.getQueryTimerExtensionWebGL2(), r = s.getQueryParameter(t, s.QUERY_RESULT_AVAILABLE);
            return this.disjoint == null && (this.disjoint = this.gl.getParameter(o.GPU_DISJOINT_EXT)), r && !this.disjoint;
        } else {
            const s = this.getQueryTimerExtensionWebGL1(), o = s.getQueryObjectEXT(t, s.QUERY_RESULT_AVAILABLE_EXT);
            return this.disjoint == null && (this.disjoint = this.gl.getParameter(s.GPU_DISJOINT_EXT)), o && !this.disjoint;
        }
    }
    pollFence(t) {
        return new Promise((e)=>{
            this.addItemToPoll(()=>t.isFencePassed(), ()=>e());
        });
    }
    pollItems() {
        const t = PA(this.itemsToPoll.map((e)=>e.isDoneFn));
        for(let e = 0; e <= t; ++e){
            const { resolveFn: s } = this.itemsToPoll[e];
            s();
        }
        this.itemsToPoll = this.itemsToPoll.slice(t + 1);
    }
    addItemToPoll(t, e) {
        if (this.itemsToPoll.push({
            isDoneFn: t,
            resolveFn: e
        }), this.itemsToPoll.length > 1) return;
        let s;
        "setTimeoutCustom" in F().platform && (s = F().platform.setTimeoutCustom.bind(F().platform)), id(()=>(this.pollItems(), this.itemsToPoll.length === 0), ()=>0, null, s);
    }
    bindTextureToFrameBuffer(t) {
        this.throwIfDisposed(), ll(this.gl, t, this.framebuffer), this.debug && qr(this.gl);
    }
    unbindTextureToFrameBuffer() {
        this.outputTexture != null ? (ll(this.gl, this.outputTexture, this.framebuffer), this.debug && qr(this.gl)) : Pd(this.gl, this.framebuffer);
    }
    downloadMatrixDriver(t, e) {
        this.bindTextureToFrameBuffer(t);
        const s = e();
        return this.unbindTextureToFrameBuffer(), s;
    }
    setOutputMatrixTextureDriver(t, e, s) {
        this.throwIfDisposed();
        const o = this.gl;
        ll(o, t, this.framebuffer), this.debug && qr(o), this.outputTexture = t, nt(o, ()=>o.viewport(0, 0, e, s)), nt(o, ()=>o.scissor(0, 0, e, s));
    }
    setOutputMatrixWriteRegionDriver(t, e, s, o) {
        this.throwIfDisposed(), nt(this.gl, ()=>this.gl.scissor(t, e, s, o));
    }
    throwIfDisposed() {
        if (this.disposed) throw new Error("Attempted to use disposed GPGPUContext.");
    }
    throwIfNoProgram() {
        if (this.program == null) throw new Error("No GPU program is currently set.");
    }
}
function PA(n) {
    let t = 0;
    for(; t < n.length && n[t](); ++t);
    return t - 1;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const { addImpl: AA, bincountImpl: OI, bincountReduceImpl: OA, bitwiseAndImpl: XA, castImpl: KA, ceilImpl: ZA, concatImpl: BA, equalImpl: HA, expImpl: _A, expm1Impl: UA, floorImpl: YA, gatherNdImpl: QA, gatherV2Impl: JA, greaterImpl: jA, greaterEqualImpl: qA, lessImpl: tO, lessEqualImpl: eO, linSpaceImpl: nO, logImpl: sO, maxImpl: oO, maximumImpl: rO, minimumImpl: iO, multiplyImpl: aO, negImpl: lO, notEqualImpl: cO, prodImpl: uO, raggedGatherImpl: dO, raggedRangeImpl: hO, raggedTensorToTensorImpl: pO, rangeImpl: fO, rsqrtImpl: mO, scatterImpl: gO, sigmoidImpl: bO, simpleAbsImpl: XI, sliceImpl: xO, sparseFillEmptyRowsImpl: yO, sparseReshapeImpl: wO, sparseSegmentReductionImpl: KI, sqrtImpl: IO, staticRegexReplaceImpl: CO, stridedSliceImpl: vO, stringNGramsImpl: SO, stringSplitImpl: kO, stringToHashBucketFastImpl: TO, subImpl: NO, tileImpl: RO, topKImpl: $O, transposeImpl: om, uniqueImpl: GO } = fW;
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ZI(n, t) {
    return [
        "x",
        "y",
        "z",
        "w",
        "u",
        "v"
    ].slice(0, t).map((e)=>`${n}.${e}`);
}
function Fe(n, t) {
    return t === 1 ? [
        n
    ] : ZI(n, t);
}
function EO(n, t) {
    if (n === 1) return "rc";
    let e = "";
    for(let s = 0; s < n; s++)e += t[s], s < n - 1 && (e += ",");
    return e;
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class LO {
    constructor(t){
        if (this.variableNames = [
            "A"
        ], this.packedInputs = !1, this.packedOutput = !0, this.outputShape = t, this.rank = t.length, this.enableShapeUniforms = Me(this.outputShape.length), this.rank === 0) this.userCode = `
        void main() {
          setOutput(vec4(getA(), 0., 0., 0.));
        }
      `;
        else {
            const e = Fe("rc", this.rank), s = Vt(this.rank), o = this.getOutOfBoundsCondition(e), r = this.getSetup(e), i = this.getOutput(e);
            this.userCode = `
        void main() {
          ${s} rc = getOutputCoords();

          if(${o}) {
            setOutput(vec4(0));
          } else {
            ${r}

            setOutput(vec4(${i}));
          }
        }
      `;
        }
    }
    getSourceCoordsArr(t) {
        const e = [];
        for(let s = 0; s <= 1; s++)for(let o = 0; o <= 1; o++){
            let r = `${s === 0 ? "r" : "rp1"}, ${o === 0 ? "c" : "cp1"}`;
            for(let i = 2; i < this.rank; i++)r = `${t[t.length - 1 - i]},` + r;
            e.push(r);
        }
        return e;
    }
    getOutOfBoundsCondition(t) {
        if (this.rank === 1) return `rc > ${this.enableShapeUniforms ? "outShape" : this.outputShape[0]}`;
        let e = "";
        for(let s = this.rank - 2; s < this.rank; s++)e += `${t[s]} >= ${this.enableShapeUniforms ? `outShape[${s}]` : this.outputShape[s]}`, s < this.rank - 1 && (e += "||");
        return e;
    }
    getSetup(t) {
        if (this.rank === 1) return "";
        const e = t.slice(-2), s = this.enableShapeUniforms ? `outShape[${this.rank} - 1]` : this.outputShape[this.rank - 1], o = this.enableShapeUniforms ? `outShape[${this.rank} - 2]` : this.outputShape[this.rank - 2];
        return `
      int r = ${e[0]};
      int c = ${e[1]};
      int rp1 = r + 1;
      int cp1 = c + 1;

      bool cEdge = cp1 >= ${s};
      bool rEdge = rp1 >= ${o};
    `;
    }
    getOutput(t) {
        const e = this.getSourceCoordsArr(t);
        return this.rank === 1 ? `getA(rc), (rc + 1 >= ${this.enableShapeUniforms ? "outShape" : this.outputShape[0]} ? 0. : getA(rc + 1)), 0, 0` : `getA(${e[0]}),
            cEdge ? 0. : getA(${e[1]}),
            rEdge ? 0. : getA(${e[2]}),
            rEdge || cEdge ? 0. : getA(${e[3]})`;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class BI {
    constructor(t, e){
        this.variableNames = [
            "A"
        ], this.packedInputs = !0, this.packedOutput = !0, this.customUniforms = [
            {
                name: "inputShape",
                type: "ivec3"
            }
        ], this.outputShape = t, this.enableShapeUniforms = Me(this.outputShape.length);
        let s = "";
        for(let o = 0; o < 4; o++){
            let r = "thisRC = rc;";
            o % 2 === 1 && (r += "thisRC.z += 1;"), o > 1 && (r += "thisRC.y += 1;"), s += `
        ${r}
        ${o > 0 ? "if(thisRC.y < rows && thisRC.z < cols){" : ""}
          int flatIndex = getFlatIndex(thisRC);

          ivec3 inputRC = inputCoordsFromReshapedOutCoords(flatIndex);
          vec2 inputRCInnerDims = vec2(float(inputRC.y),float(inputRC.z));

          result[${o}] =
            getChannel(getA(inputRC.x, inputRC.y, inputRC.z), inputRCInnerDims);
        ${o > 0 ? "}" : ""}
      `;
        }
        this.userCode = `
      ${MO(e, this.enableShapeUniforms)}
      ${this.enableShapeUniforms ? Jf() : Qf(t)}

      void main() {
        ivec3 rc = getOutputCoords();

        vec4 result = vec4(0.);

        ivec3 thisRC;
        int rows = ${this.enableShapeUniforms ? "outShape[1]" : t[1]};
        int cols = ${this.enableShapeUniforms ? "outShape[2]" : t[2]};

        ${s}

        setOutput(result);
      }
    `;
    }
}
function MO(n, t) {
    return `
    ivec3 inputCoordsFromReshapedOutCoords(int index) {
      ${t ? _P([
        "r",
        "c",
        "d"
    ], "inputShape") : Qo([
        "r",
        "c",
        "d"
    ], n)}
      return ivec3(r, c, d);
    }
  `;
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class WO {
    constructor(t){
        this.gpgpu = t, this.numUsedTextures = 0, this.numFreeTextures = 0, this._numBytesAllocated = 0, this._numBytesFree = 0, this.freeTextures = {}, this.usedTextures = {}, this.logEnabled = !1;
    }
    acquireTexture(t, e, s) {
        const o = Cg(e, s), r = vg(t, o, s);
        r in this.freeTextures || (this.freeTextures[r] = []), r in this.usedTextures || (this.usedTextures[r] = []);
        const i = Ig(t, o, this.gpgpu.gl, this.gpgpu.textureConfig, s);
        if (this.freeTextures[r].length > 0) {
            this.numFreeTextures--, this.numUsedTextures++, this._numBytesFree -= i, this.log();
            const l = this.freeTextures[r].pop();
            return this.usedTextures[r].push(l), l;
        }
        let a;
        return o === Ce.PACKED_2X2_FLOAT32 ? a = this.gpgpu.createPackedMatrixTexture(t[0], t[1]) : o === Ce.PACKED_2X2_FLOAT16 ? a = this.gpgpu.createFloat16PackedMatrixTexture(t[0], t[1]) : o === Ce.UNPACKED_FLOAT32 ? a = this.gpgpu.createFloat32MatrixTexture(t[0], t[1]) : o === Ce.UNPACKED_FLOAT16 ? a = this.gpgpu.createFloat16MatrixTexture(t[0], t[1]) : o === Ce.PACKED_4X1_UNSIGNED_BYTE && (a = this.gpgpu.createUnsignedBytesMatrixTexture(t[0], t[1])), this.usedTextures[r].push(a), this.numUsedTextures++, this._numBytesAllocated += i, this.log(), a;
    }
    releaseTexture(t, e, s, o) {
        if (this.freeTextures == null) return;
        const r = Cg(s, o), i = vg(e, r, o);
        i in this.freeTextures || (this.freeTextures[i] = []);
        const a = Ig(e, r, this.gpgpu.gl, this.gpgpu.textureConfig, o), l = F().getNumber("WEBGL_DELETE_TEXTURE_THRESHOLD");
        l !== -1 && this._numBytesAllocated > l ? (this.gpgpu.deleteMatrixTexture(t.texture), this._numBytesAllocated -= a) : (this.freeTextures[i].push(t), this.numFreeTextures++, this._numBytesFree += a), this.numUsedTextures--;
        const c = this.usedTextures[i], u = c && c.indexOf(t);
        if (u == null || u < 0) throw new Error("Cannot release a texture that was never provided by this texture manager");
        c[u] = c[c.length - 1], c.pop(), this.log();
    }
    log() {
        if (!this.logEnabled) return;
        const t = this.numFreeTextures + this.numUsedTextures;
        console.log("Free/Used", `${this.numFreeTextures} / ${this.numUsedTextures}`, `(${t})`);
        const e = this._numBytesFree / this._numBytesAllocated;
        console.log(`Bytes allocated: ${this._numBytesAllocated}`), console.log(`Bytes unused: ${this._numBytesFree} (${Math.round(100 * e)}%)`);
    }
    get numBytesAllocated() {
        return this._numBytesAllocated;
    }
    get numBytesFree() {
        return this._numBytesFree;
    }
    getNumUsedTextures() {
        return this.numUsedTextures;
    }
    getNumFreeTextures() {
        return this.numFreeTextures;
    }
    dispose() {
        if (this.freeTextures != null) {
            for(const t in this.freeTextures)this.freeTextures[t].forEach((e)=>{
                this.gpgpu.deleteMatrixTexture(e.texture);
            });
            for(const t in this.usedTextures)this.usedTextures[t].forEach((e)=>{
                this.gpgpu.deleteMatrixTexture(e.texture);
            });
            this.freeTextures = null, this.usedTextures = null, this.numUsedTextures = 0, this.numFreeTextures = 0, this._numBytesAllocated = 0, this._numBytesFree = 0;
        }
    }
}
function DO(n, t) {
    const e = n;
    if (t === e.R32F) return 4;
    if (t === e.R16F) return 2;
    if (t === e.RGBA32F) return 16;
    if (t === n.RGBA) return 16;
    if (t === e.RGBA16F) return 8;
    if (t === e.RGBA8) return 4;
    throw new Error(`Unknown internal format ${t}`);
}
function Ig(n, t, e, s, o) {
    const r = FO(t, s);
    let i;
    if (o) {
        const [l, c] = Gr(n[0], n[1]);
        i = l * c;
    } else {
        const [l, c] = Pa(n[0], n[1]);
        i = l * c;
    }
    const a = DO(e, r);
    return i * a;
}
function FO(n, t) {
    switch(n){
        case Ce.PACKED_2X2_FLOAT32:
            return nm(t);
        case Ce.PACKED_2X2_FLOAT16:
            return sm(t);
        case Ce.UNPACKED_FLOAT32:
            return qf(t);
        case Ce.UNPACKED_FLOAT16:
            return tm(t);
        case Ce.PACKED_4X1_UNSIGNED_BYTE:
            return em(t);
        default:
            throw new Error(`Unknown physical texture type ${n}`);
    }
}
function VO(n) {
    return F().getBool("WEBGL_RENDER_FLOAT32_ENABLED") ? n ? Ce.PACKED_2X2_FLOAT32 : Ce.UNPACKED_FLOAT32 : n ? Ce.PACKED_2X2_FLOAT16 : Ce.UNPACKED_FLOAT16;
}
function Cg(n, t) {
    if (n === un.UPLOAD) return Ce.PACKED_2X2_FLOAT32;
    if (n === un.RENDER || n == null) return VO(t);
    if (n === un.DOWNLOAD || n === un.PIXELS) return Ce.PACKED_4X1_UNSIGNED_BYTE;
    throw new Error(`Unknown logical texture type ${n}`);
}
function vg(n, t, e) {
    return `${n[0]}_${n[1]}_${t}_${e}`;
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class qn {
    constructor(t, e){
        this.variableNames = [
            "A"
        ], this.outputShape = t, this.enableShapeUniforms = Me(this.outputShape.length), this.userCode = `
      float unaryOperation(float x) {
        ${e}
      }

      void main() {
        float x = getAAtOutCoords();
        float y = unaryOperation(x);

        setOutput(y);
      }
    `;
    }
}
const En = "if (isnan(x)) return x;", zO = "return x;", Sg = "return abs(x);", PO = "return (x >= 0.0) ? x : (exp(x) - 1.0);", AO = En + `
  return (x < 0.0) ? 0.0 : x;
`, OO = En + `
  return (x < 0.0) ? 0.0 : min(6.0, x);
`, Ms = "return x;", XO = "return 1.0 / (1.0 + exp(-1.0 * x));";
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const KO = "return x;", ZO = `
  vec4 result;

  result.r = (x.r >= 0.0) ? x.r : (exp(x.r) - 1.0);
  result.g = (x.g >= 0.0) ? x.g : (exp(x.g) - 1.0);
  result.b = (x.b >= 0.0) ? x.b : (exp(x.b) - 1.0);
  result.a = (x.a >= 0.0) ? x.a : (exp(x.a) - 1.0);

  return result;
`, BO = `
  vec4 result = x * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`, HO = `
  vec4 result = min(x, vec4(6.)) * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`, _O = "return 1.0 / (1.0 + exp(-1.0 * x));";
class Vs {
    constructor(t, e){
        this.variableNames = [
            "A"
        ], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = t, this.enableShapeUniforms = Me(this.outputShape.length), this.userCode = `
      vec4 unaryOperation(vec4 x) {
        ${e}
      }

      void main() {
        vec4 x = getAAtOutCoords();
        vec4 y = unaryOperation(x);

        setOutput(y);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class UO {
    constructor(t){
        this.variableNames = [
            "A"
        ], this.packedInputs = !0, this.packedOutput = !1, this.outputShape = t, this.enableShapeUniforms = Me(this.outputShape.length);
        const e = t.length, s = Fe("rc", e), o = Vt(e), r = EO(e, s), i = s.slice(-2), a = e <= 1 ? "rc" : `vec2(${i.join(",")})`;
        this.userCode = `
      void main() {
        ${o} rc = getOutputCoords();
        vec4 packedInput = getA(${r});

        setOutput(getChannel(packedInput, ${a}));
      }
    `;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const YO = C0, QO = 1e-7, JO = 1e-4, ja = {};
function jO(n) {
    return n in ja || (ja[n] = {}), ja[n];
}
const qO = F().getNumber("CPU_HANDOFF_SIZE_THRESHOLD"), tX = 600;
function eX() {
    return F().global.screen == null ? 1024 : F().global.screen.height * F().global.screen.width * window.devicePixelRatio * tX / 1024 / 1024;
}
class Cu extends _d {
    nextDataId() {
        return Cu.nextDataId++;
    }
    constructor(t){
        if (super(), this.pendingRead = /* @__PURE__ */ new WeakMap(), this.pendingDisposal = /* @__PURE__ */ new WeakSet(), this.dataRefCount = /* @__PURE__ */ new WeakMap(), this.numBytesInGPU = 0, this.uploadWaitMs = 0, this.downloadWaitMs = 0, this.lastGlFlushTime = 0, this.warnedAboutMemory = !1, this.pendingDeletes = 0, this.disposed = !1, !F().getBool("HAS_WEBGL")) throw new Error("WebGL is not supported on this device");
        let e;
        if (t != null) {
            if (t instanceof Au) e = t;
            else {
                const s = Bn(F().getNumber("WEBGL_VERSION"), t);
                e = new Au(s);
            }
            this.binaryCache = {}, this.gpgpuCreatedLocally = !1;
        } else {
            const s = Bn(F().getNumber("WEBGL_VERSION"));
            e = new Au(s), this.binaryCache = jO(F().getNumber("WEBGL_VERSION")), this.gpgpuCreatedLocally = !0;
        }
        this.gpgpu = e, this.canvas = this.gpgpu.gl.canvas, this.textureManager = new WO(this.gpgpu), this.numMBBeforeWarning = eX(), this.texData = new qg(this, Ot());
    }
    numDataIds() {
        return this.texData.numDataIds() - this.pendingDeletes;
    }
    // Writes a new entry to the data store with a WebGL texture, and registers it
    // to the texture manager.
    writeTexture(t, e, s, o, r, i) {
        const a = this.makeTensorInfo(e, s), l = this.texData.get(a.dataId);
        l.isPacked = !1, l.texture = {
            texture: t,
            texShape: [
                o,
                r
            ]
        }, l.texShape = [
            o,
            r
        ];
        const c = ti(e), u = new wg(c, !1, i), d = this.runWebGLProgram(u, [
            a
        ], s, [
            [
                o,
                r
            ]
        ]);
        return d.shape = e, l.texture = null, this.disposeIntermediateTensorInfo(a), d.dataId;
    }
    write(t, e, s) {
        if ((F().getBool("WEBGL_CHECK_NUMERICAL_PROBLEMS") || F().getBool("DEBUG")) && this.checkNumericalProblems(t), s === "complex64" && t != null) throw new Error("Cannot write to a complex64 dtype. Please use tf.complex(real, imag).");
        const o = {
            id: this.nextDataId()
        };
        return this.texData.set(o, {
            shape: e,
            dtype: s,
            values: t,
            usage: un.UPLOAD,
            refCount: 1
        }), o;
    }
    /** Return refCount of a `TensorData`. */ refCount(t) {
        return this.texData.has(t) ? this.texData.get(t).refCount : 0;
    }
    /** Increase refCount of a `TextureData`. */ incRef(t) {
        const e = this.texData.get(t);
        e.refCount++;
    }
    /** Decrease refCount of a `TextureData`. */ decRef(t) {
        if (this.texData.has(t)) {
            const e = this.texData.get(t);
            e.refCount--;
        }
    }
    move(t, e, s, o, r) {
        if (F().getBool("DEBUG") && this.checkNumericalProblems(e), o === "complex64") throw new Error("Cannot write to a complex64 dtype. Please use tf.complex(real, imag).");
        this.texData.set(t, {
            shape: s,
            dtype: o,
            values: e,
            usage: un.UPLOAD,
            refCount: r
        });
    }
    disposeIntermediateTensorInfo(t) {
        this.disposeData(t.dataId);
    }
    readSync(t) {
        const e = this.texData.get(t), { values: s, dtype: o, complexTensorInfos: r, slice: i, shape: a, isPacked: l } = e;
        if (i != null) {
            let h;
            l ? h = new Vs(a, Ms) : h = new qn(a, Ms);
            const p = this.runWebGLProgram(h, [
                {
                    dataId: t,
                    shape: a,
                    dtype: o
                }
            ], o), f = this.readSync(p.dataId);
            return this.disposeIntermediateTensorInfo(p), f;
        }
        if (s != null) return this.convertAndCacheOnCPU(t);
        if (o === "string") return s;
        const c = this.activeTimers != null;
        let u;
        c && (u = Ie());
        let d;
        if (o === "complex64") {
            const h = this.readSync(r.real.dataId), p = this.readSync(r.imag.dataId);
            d = xs(h, p);
        } else d = this.getValuesFromTexture(t);
        return c && (this.downloadWaitMs += Ie() - u), this.convertAndCacheOnCPU(t, d);
    }
    async read(t) {
        if (this.pendingRead.has(t)) {
            const f = this.pendingRead.get(t);
            return new Promise((m)=>f.push(m));
        }
        const e = this.texData.get(t), { values: s, shape: o, slice: r, dtype: i, complexTensorInfos: a, isPacked: l } = e;
        if (r != null) {
            let f;
            l ? f = new Vs(o, Ms) : f = new qn(o, Ms);
            const m = this.runWebGLProgram(f, [
                {
                    dataId: t,
                    shape: o,
                    dtype: i
                }
            ], i), g = this.read(m.dataId);
            return this.disposeIntermediateTensorInfo(m), g;
        }
        if (s != null) return this.convertAndCacheOnCPU(t);
        if (F().getBool("DEBUG") && !F().getBool("WEBGL_DOWNLOAD_FLOAT_ENABLED") && F().getNumber("WEBGL_VERSION") === 2) throw new Error("tensor.data() with WEBGL_DOWNLOAD_FLOAT_ENABLED=false and WEBGL_VERSION=2 not yet supported.");
        let c = null, u;
        if (i !== "complex64" && F().get("WEBGL_BUFFER_SUPPORTED")) {
            u = this.decode(t);
            const f = this.texData.get(u.dataId);
            c = this.gpgpu.createBufferFromTexture(f.texture.texture, ...Qa(o));
        }
        this.pendingRead.set(t, []), i !== "complex64" && await this.gpgpu.createAndWaitForFence();
        let d;
        if (i === "complex64") {
            const f = await Promise.all([
                this.read(a.real.dataId),
                this.read(a.imag.dataId)
            ]), m = f[0], g = f[1];
            d = xs(m, g);
        } else if (c == null) d = this.getValuesFromTexture(t);
        else {
            const f = X(o);
            d = this.gpgpu.downloadFloat32MatrixFromBuffer(c, f);
        }
        if (u != null && this.disposeIntermediateTensorInfo(u), c != null) {
            const f = this.gpgpu.gl;
            nt(f, ()=>f.deleteBuffer(c));
        }
        const h = this.convertAndCacheOnCPU(t, d), p = this.pendingRead.get(t);
        return this.pendingRead.delete(t), p.forEach((f)=>f(h)), this.pendingDisposal.has(t) && (this.pendingDisposal.delete(t), this.disposeData(t) && Ot().removeDataId(t, this), this.pendingDeletes--), h;
    }
    /**
   * Read tensor to a new texture that is densely packed for ease of use.
   * @param dataId The source tensor.
   * @param options
   *     customTexShape: Optional. If set, will use the user defined texture
   *     shape to create the texture.
   */ readToGPU(t, e = {}) {
        const s = this.texData.get(t), { values: o, shape: r, slice: i, dtype: a, isPacked: l, texture: c } = s;
        if (a === "complex64") throw new Error("Does not support reading texture for complex64 dtype.");
        if (i != null) {
            let p;
            l ? p = new Vs(r, Ms) : p = new qn(r, Ms);
            const f = this.runWebGLProgram(p, [
                {
                    dataId: t,
                    shape: r,
                    dtype: a
                }
            ], a), m = this.readToGPU(f, e);
            return this.disposeIntermediateTensorInfo(f), m;
        }
        if (c == null) throw o != null ? new Error("Data is not on GPU but on CPU.") : new Error("There is no data on GPU or CPU.");
        const u = this.decode(t, e.customTexShape), d = Ot().makeTensorFromTensorInfo(u), h = this.texData.get(u.dataId);
        return Object.assign({
            tensorRef: d
        }, h.texture);
    }
    bufferSync(t) {
        const e = this.readSync(t.dataId);
        if (t.dtype === "string") try {
            const s = e.map((o)=>gs(o));
            return vt(t.shape, t.dtype, s);
        } catch  {
            throw new Error("Failed to decode encoded string bytes into utf-8");
        }
        return vt(t.shape, t.dtype, e);
    }
    checkNumericalProblems(t) {
        if (t != null) for(let e = 0; e < t.length; e++){
            const s = t[e];
            if (!Qw(s)) throw F().getBool("WEBGL_RENDER_FLOAT32_CAPABLE") ? Error(`The value ${s} cannot be represented with your current settings. Consider enabling float32 rendering: 'tf.env().set('WEBGL_RENDER_FLOAT32_ENABLED', true);'`) : Error(`The value ${s} cannot be represented on this device.`);
        }
    }
    getValuesFromTexture(t) {
        const { shape: e, dtype: s, isPacked: o } = this.texData.get(t), r = X(e);
        if (F().getBool("WEBGL_DOWNLOAD_FLOAT_ENABLED")) {
            const h = this.decode(t), p = this.texData.get(h.dataId), f = this.gpgpu.downloadMatrixFromPackedTexture(p.texture.texture, ...Qa(e)).subarray(0, r);
            return this.disposeIntermediateTensorInfo(h), f;
        }
        const i = F().getBool("WEBGL_PACK") && o === !0, a = i ? ti(e) : e, l = i ? new FA(a) : new DA(a), c = this.runWebGLProgram(l, [
            {
                shape: a,
                dtype: s,
                dataId: t
            }
        ], "float32"), u = this.texData.get(c.dataId), d = this.gpgpu.downloadByteEncodedFloatMatrixFromOutputTexture(u.texture.texture, u.texShape[0], u.texShape[1]).subarray(0, r);
        return this.disposeIntermediateTensorInfo(c), d;
    }
    timerAvailable() {
        return F().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0;
    }
    time(t) {
        const e = this.activeTimers, s = [];
        let o = !1;
        this.programTimersStack == null ? (this.programTimersStack = s, o = !0) : this.activeTimers.push(s), this.activeTimers = s, t();
        const r = Ks(this.activeTimers.map((l)=>l.query)).filter((l)=>l != null), i = Ks(this.activeTimers.map((l)=>l.name)).filter((l)=>l != null);
        this.activeTimers = e, o && (this.programTimersStack = null);
        const a = {
            uploadWaitMs: this.uploadWaitMs,
            downloadWaitMs: this.downloadWaitMs,
            kernelMs: null,
            wallMs: null
        };
        return (async ()=>{
            if (F().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0) {
                const l = await Promise.all(r);
                a.kernelMs = tb(l), a.getExtraProfileInfo = ()=>l.map((c, u)=>({
                            name: i[u],
                            ms: c
                        })).map((c)=>`${c.name}: ${c.ms}`).join(", ");
            } else a.kernelMs = {
                error: "WebGL query timers are not supported in this environment."
            };
            return this.uploadWaitMs = 0, this.downloadWaitMs = 0, a;
        })();
    }
    memory() {
        return {
            unreliable: !1,
            numBytesInGPU: this.numBytesInGPU,
            numBytesInGPUAllocated: this.textureManager.numBytesAllocated,
            numBytesInGPUFree: this.textureManager.numBytesFree
        };
    }
    startTimer() {
        return F().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0 ? this.gpgpu.beginQuery() : {
            startMs: Ie(),
            endMs: null
        };
    }
    endTimer(t) {
        return F().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0 ? (this.gpgpu.endQuery(), t) : (t.endMs = Ie(), t);
    }
    async getQueryTime(t) {
        if (F().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0) return this.gpgpu.waitForQueryAndGetTime(t);
        const e = t;
        return e.endMs - e.startMs;
    }
    /**
   * Decrease the RefCount on the dataId and dispose the memory if the dataId
   * has 0 refCount. If there are pending read on the data, the disposal would
   * added to the pending delete queue. Return true if the dataId is removed
   * from backend or the backend does not contain the dataId, false if the
   * dataId is not removed. Memory may or may not be released even when dataId
   * is removed, which also depends on dataRefCount, see `releaseGPU`.
   * @param dataId
   * @oaram force Optional, remove the data regardless of refCount
   */ disposeData(t, e = !1) {
        if (this.pendingDisposal.has(t)) return !1;
        if (!this.texData.has(t)) return !0;
        if (e ? this.texData.get(t).refCount = 0 : this.texData.get(t).refCount--, !e && this.texData.get(t).refCount > 0) return !1;
        if (this.pendingRead.has(t)) return this.pendingDisposal.add(t), this.pendingDeletes++, !1;
        this.releaseGPUData(t);
        const { complexTensorInfos: s } = this.texData.get(t);
        return s != null && (this.disposeData(s.real.dataId, e), this.disposeData(s.imag.dataId, e)), this.texData.delete(t), !0;
    }
    releaseGPUData(t) {
        const { texture: e, dtype: s, texShape: o, usage: r, isPacked: i, slice: a } = this.texData.get(t), l = a && a.origDataId || t, c = this.dataRefCount.get(l);
        c > 1 ? this.dataRefCount.set(l, c - 1) : (this.dataRefCount.delete(l), e != null && (this.numBytesInGPU -= this.computeBytes(o, s), this.textureManager.releaseTexture(e, o, r, i)));
        const u = this.texData.get(t);
        u.texture = null, u.texShape = null, u.isPacked = !1, u.slice = null;
    }
    getTexture(t) {
        return this.uploadToGPU(t), this.texData.get(t).texture.texture;
    }
    /**
   * Returns internal information for the specific data bucket. Used in unit
   * tests.
   */ getDataInfo(t) {
        return this.texData.get(t);
    }
    /*
  Tests whether all the inputs to an op are small and on the CPU. This heuristic
  determines when it would be faster to execute a kernel on the CPU. WebGL
  kernels opt into running this check and forwarding when appropriate.
  TODO(https://github.com/tensorflow/tfjs/issues/872): Develop a more
  sustainable strategy for optimizing backend execution of ops.
   */ shouldExecuteOnCPU(t, e = qO) {
        return F().getBool("WEBGL_CPU_FORWARD") && t.every((s)=>this.texData.get(s.dataId).texture == null && X(s.shape) < e);
    }
    getGPGPUContext() {
        return this.gpgpu;
    }
    where(t) {
        ln("tf.where() in webgl locks the UI thread. Call tf.whereAsync() instead");
        const e = t.dataSync();
        return YO(t.shape, e);
    }
    packedUnaryOp(t, e, s) {
        const o = new Vs(t.shape, e), r = this.compileAndRun(o, [
            t
        ], s);
        return Ot().makeTensorFromTensorInfo(r);
    }
    // TODO(msoulanille) remove this once the backend has been modularized
    // a copy is needed here to break a circular dependency.
    // Also remove the op from unary_op.
    abs(t) {
        if (this.shouldExecuteOnCPU([
            t
        ]) && t.dtype !== "complex64") {
            const o = XI(this.texData.get(t.dataId).values);
            return this.makeOutput(t.shape, t.dtype, o);
        }
        if (F().getBool("WEBGL_PACK_UNARY_OPERATIONS")) return this.packedUnaryOp(t, Sg, t.dtype);
        const e = new qn(t.shape, Sg), s = this.compileAndRun(e, [
            t
        ]);
        return Ot().makeTensorFromTensorInfo(s);
    }
    makeTensorInfo(t, e, s) {
        let o;
        if (e === "string" && s != null && s.length > 0 && vr(s[0])) {
            const r = s.map((i)=>ms(i));
            o = this.write(r, t, e);
        } else o = this.write(s, t, e);
        return this.texData.get(o).usage = null, {
            dataId: o,
            shape: t,
            dtype: e
        };
    }
    makeOutput(t, e, s) {
        return Ot().makeTensorFromTensorInfo(this.makeTensorInfo(t, e, s), this);
    }
    unpackTensor(t) {
        const e = new UO(t.shape);
        return this.runWebGLProgram(e, [
            t
        ], t.dtype);
    }
    packTensor(t) {
        const e = new LO(t.shape);
        return this.runWebGLProgram(e, [
            t
        ], t.dtype, null, !0);
    }
    packedReshape(t, e) {
        const s = [
            Vo(t.shape),
            ...zo(t.shape)
        ], o = {
            dtype: t.dtype,
            shape: s,
            dataId: t.dataId
        }, r = [
            Vo(e),
            ...zo(e)
        ], i = new BI(r, s), a = !0, l = [
            s
        ], c = this.runWebGLProgram(i, [
            o
        ], t.dtype, l, a);
        return {
            dataId: c.dataId,
            shape: e,
            dtype: c.dtype
        };
    }
    decode(t, e) {
        const s = this.texData.get(t), { isPacked: o, shape: r, dtype: i } = s;
        if (e != null) {
            const h = X(r), p = e[0] * e[1] * 4;
            C(h <= p, ()=>"customTexShape is too small. Row * Column * 4 should be equal or larger than the size of the tensor data.");
        }
        const a = ti(r);
        let l;
        o ? l = new WA(a) : l = new MA(a);
        const c = !0, u = [
            e ?? Qa(a)
        ], d = this.runWebGLProgram(l, [
            {
                shape: a,
                dtype: i,
                dataId: t
            }
        ], i, u, c, e);
        return {
            dtype: i,
            shape: r,
            dataId: d.dataId
        };
    }
    runWebGLProgram(t, e, s, o, r = !1, i) {
        const a = this.makeTensorInfo(t.outputShape, s), l = this.texData.get(a.dataId);
        if (t.packedOutput && (l.isPacked = !0), t.outPackingScheme === bi.DENSE) {
            const b = i ?? Qa(t.outputShape);
            l.texShape = b.map((x)=>x * 2);
        }
        if (t.outTexUsage != null && (l.usage = t.outTexUsage), X(a.shape) === 0) return l.values = Se(a.dtype, 0), a;
        const c = [], u = e.map((b)=>{
            if (b.dtype === "complex64") throw new Error("GPGPUProgram does not support complex64 input. For complex64 dtypes, please separate the program into real and imaginary parts.");
            let x = this.texData.get(b.dataId);
            if (x.texture == null) {
                if (!t.packedInputs && X(b.shape) <= F().getNumber("WEBGL_SIZE_UPLOAD_UNIFORM")) return {
                    shape: b.shape,
                    texData: null,
                    isUniform: !0,
                    uniformValues: x.values
                };
                t.packedInputs && (x.isPacked = !0, x.shape = b.shape);
            }
            if (this.uploadToGPU(b.dataId), !!x.isPacked != !!t.packedInputs) b = x.isPacked ? this.unpackTensor(b) : this.packTensor(b), c.push(b), x = this.texData.get(b.dataId);
            else if (x.isPacked && !xi(x.shape, b.shape)) {
                const w = b, y = b.shape;
                b.shape = x.shape, b = this.packedReshape(b, y), c.push(b), x = this.texData.get(b.dataId), w.shape = y;
            }
            return {
                shape: b.shape,
                texData: x,
                isUniform: !1
            };
        });
        this.uploadToGPU(a.dataId);
        const d = {
            shape: a.shape,
            texData: l,
            isUniform: !1
        }, h = LA(t, u, d), p = this.getAndSaveBinary(h, ()=>GA(this.gpgpu, t, u, d)), f = this.activeTimers != null;
        let m;
        f && (m = this.startTimer()), F().get("ENGINE_COMPILE_ONLY") || EA(this.gpgpu, p, u, d, o), c.forEach((b)=>this.disposeIntermediateTensorInfo(b)), f && (m = this.endTimer(m), this.activeTimers.push({
            name: t.constructor.name,
            query: this.getQueryTime(m)
        }));
        const g = F().getNumber("WEBGL_FLUSH_THRESHOLD");
        if (g > 0) {
            const b = Ie();
            b - this.lastGlFlushTime > g && (this.gpgpu.gl.flush(), this.lastGlFlushTime = b);
        }
        if (!F().getBool("WEBGL_LAZILY_UNPACK") && l.isPacked && r === !1) {
            const b = this.unpackTensor(a);
            return this.disposeIntermediateTensorInfo(a), b;
        }
        return a;
    }
    compileAndRun(t, e, s, o, r = !1) {
        return s = s || e[0].dtype, this.runWebGLProgram(t, e, s, o, r);
    }
    getAndSaveBinary(t, e) {
        return t in this.binaryCache || (this.binaryCache[t] = e()), this.binaryCache[t];
    }
    getTextureManager() {
        return this.textureManager;
    }
    dispose() {
        this.disposed || (F().getBool("IS_TEST") || Object.keys(this.binaryCache).forEach((e)=>{
            this.gpgpu.deleteProgram(this.binaryCache[e].webGLProgram), delete this.binaryCache[e];
        }), this.textureManager.dispose(), this.canvas != null && typeof HTMLCanvasElement < "u" && this.canvas instanceof HTMLCanvasElement ? this.canvas.remove() : this.canvas = null, this.gpgpuCreatedLocally && (this.gpgpu.program = null, this.gpgpu.dispose()), this.disposed = !0);
    }
    floatPrecision() {
        return this.floatPrecisionValue == null && (this.floatPrecisionValue = D(()=>{
            if (!F().get("WEBGL_RENDER_FLOAT32_ENABLED")) {
                const t = F().getBool("DEBUG");
                F().set("DEBUG", !1);
                const e = this.abs(gt(1e-8)).dataSync()[0];
                if (F().set("DEBUG", t), e > 0) return 32;
            }
            return 16;
        })), this.floatPrecisionValue;
    }
    /** Returns the smallest representable number.  */ epsilon() {
        return this.floatPrecision() === 32 ? QO : JO;
    }
    uploadToGPU(t) {
        const e = this.texData.get(t), { shape: s, dtype: o, values: r, texture: i, usage: a, isPacked: l } = e;
        if (i != null) return;
        const c = this.activeTimers != null;
        let u;
        c && (u = Ie());
        let d = e.texShape;
        if (d == null && (d = pI(s, l), e.texShape = d), r != null) {
            const h = ti(s);
            let p, f = d[1], m = d[0];
            const g = r instanceof Uint8Array || r instanceof Uint8ClampedArray;
            (l || !g) && ([f, m] = Gr(d[0], d[1])), l ? p = new zA(h, g) : p = new wg(h, g);
            const b = g ? [
                m,
                f
            ] : d, x = this.makeTensorInfo(b, o), w = this.texData.get(x.dataId);
            g ? w.usage = un.PIXELS : w.usage = un.UPLOAD, w.texShape = b, this.gpgpu.uploadDenseMatrixToTexture(this.getTexture(x.dataId), f, m, r);
            const y = [
                [
                    m,
                    f
                ]
            ], v = this.runWebGLProgram(p, [
                x
            ], o, y, !0), k = this.texData.get(v.dataId);
            e.texShape = k.texShape, e.isPacked = k.isPacked, e.usage = k.usage, F().get("ENGINE_COMPILE_ONLY") ? this.disposeData(v.dataId) : (e.texture = k.texture, e.values = null, this.texData.delete(v.dataId)), this.disposeIntermediateTensorInfo(x), c && (this.uploadWaitMs += Ie() - u);
        } else {
            const h = this.acquireTexture(d, a, o, l);
            e.texture = h;
        }
    }
    convertAndCacheOnCPU(t, e) {
        const s = this.texData.get(t), { dtype: o } = s;
        return e != null && (s.values = nX(e, o)), s.values;
    }
    acquireTexture(t, e, s, o) {
        if (this.numBytesInGPU += this.computeBytes(t, s), !this.warnedAboutMemory && this.numBytesInGPU > this.numMBBeforeWarning * 1048576) {
            const r = (this.numBytesInGPU / 1024 / 1024).toFixed(2);
            this.warnedAboutMemory = !0, console.warn(`High memory usage in GPU: ${r} MB, most likely due to a memory leak`);
        }
        return this.textureManager.acquireTexture(t, e, o);
    }
    computeBytes(t, e) {
        return t[0] * t[1] * ri(e);
    }
    checkCompileCompletion() {
        for (const [, t] of Object.entries(this.binaryCache))this.checkCompletion_(t);
    }
    async checkCompileCompletionAsync() {
        const t = [];
        if (this.gpgpu.parallelCompilationExtension) {
            for (const [, e] of Object.entries(this.binaryCache))t.push(this.checkCompletionAsync_(e));
            return Promise.all(t);
        } else {
            for (const [, e] of Object.entries(this.binaryCache)){
                const s = new Promise((o)=>{
                    try {
                        this.checkCompletion_(e), o(!0);
                    } catch (r) {
                        throw r;
                    }
                });
                t.push(s);
            }
            return Promise.all(t);
        }
    }
    async checkCompletionAsync_(t) {
        return this.gpgpu.gl.getProgramParameter(t.webGLProgram, this.gpgpu.parallelCompilationExtension.COMPLETION_STATUS_KHR) ? this.checkCompletion_(t) : (await su(), this.checkCompletionAsync_(t));
    }
    checkCompletion_(t) {
        if (this.gpgpu.gl.getProgramParameter(t.webGLProgram, this.gpgpu.gl.LINK_STATUS) === !1) throw console.log(this.gpgpu.gl.getProgramInfoLog(t.webGLProgram)), this.gpgpu.gl.getShaderParameter(t.fragmentShader, this.gpgpu.gl.COMPILE_STATUS) === !1 ? (Yf(t.source, this.gpgpu.gl.getShaderInfoLog(t.fragmentShader)), new Error("Failed to compile fragment shader.")) : new Error("Failed to link vertex and fragment shaders.");
        return !0;
    }
    getUniformLocations() {
        for (const t of Object.values(this.binaryCache)){
            this.gpgpu.buildVao(t.webGLProgram);
            const { variablesLocations: e, customUniformLocations: s, infLoc: o, nanLoc: r, outShapeLocation: i, outShapeStridesLocation: a, outTexShapeLocation: l } = SI(this.gpgpu, t.program, t.webGLProgram);
            t.variablesLocations = e, t.customUniformLocations = s, t.infLoc = o, t.nanLoc = r, t.outShapeLocation = i, t.outShapeStridesLocation = a, t.outTexShapeLocation = l;
        }
    }
    /**
   * Create a TF.js tensor out of an existing WebGL texture. A new texture will
   * be created.
   */ createTensorFromGPUData(t, e, s) {
        t.channels = t.channels || "RGBA";
        const { texture: o, height: r, width: i, channels: a } = t, l = Ot().backend;
        if (!l.gpgpu.gl.isTexture(o)) throw new Error("The texture is invalid. Also, please make sure the texture and the TFJS WebGL backend are using the same canvas. If you want to use your own custom canvas, you have to create and use the custom TFJS WebGL backend created from the canvas through 'new tf.MathBackendWebGL(customCanvas)'.");
        const c = l.writeTexture(o, e, s, r, i, a);
        return Ot().makeTensorFromDataId(c, e, s, l);
    }
}
Cu.nextDataId = 0;
function nX(n, t) {
    if (t === "float32" || t === "complex64") return n;
    if (t === "int32" || t === "bool") {
        const e = t === "int32" ? new Int32Array(n.length) : new Uint8Array(n.length);
        for(let s = 0; s < e.length; ++s)e[s] = Math.round(n[s]);
        return e;
    } else throw new Error(`Unknown dtype ${t}`);
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function sX() {
    F().set("WEBGL_FORCE_F16_TEXTURES", !0);
}
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ Jh() && Pb("webgl", ()=>new Cu(), 2);
const YQ = {
    forceHalfFloat: sX
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const rm = `
  if (isnan(a)) return a;
  if (isnan(b)) return b;
`;
class Po {
    constructor(t, e, s){
        this.variableNames = [
            "A",
            "B"
        ], this.outputShape = bt(e, s), this.enableShapeUniforms = Me(this.outputShape.length), this.userCode = `
      float binaryOperation(float a, float b) {
        ${t}
      }

      void main() {
        float a = getAAtOutCoords();
        float b = getBAtOutCoords();
        setOutput(binaryOperation(a, b));
      }
    `;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const jo = `
  result.r = isNaN.r ? NAN : result.r;
  result.g = isNaN.g ? NAN : result.g;
  result.b = isNaN.b ? NAN : result.b;
  result.a = isNaN.a ? NAN : result.a;
`;
class Fr {
    constructor(t, e, s, o = !1){
        this.variableNames = [
            "A",
            "B"
        ], this.supportsBroadcasting = !0, this.packedInputs = !0, this.packedOutput = !0, this.outputShape = bt(e, s);
        const r = this.outputShape.length;
        this.enableShapeUniforms = Me(r);
        let i = "";
        if (o) {
            if (r === 0 || X(this.outputShape) === 1) i = `
          result.y = 0.;
          result.z = 0.;
          result.w = 0.;
        `;
            else if (i = `
          ${Vt(r)} coords = getOutputCoords();
        `, r === 1) this.enableShapeUniforms ? i += `
            result.y = (coords + 1) >= outShape ? 0. : result.y;
            result.z = 0.;
            result.w = 0.;
          ` : i += `
            result.y = (coords + 1) >= ${this.outputShape[0]} ? 0. : result.y;
            result.z = 0.;
            result.w = 0.;
          `;
            else {
                const l = Fe("coords", r);
                this.enableShapeUniforms ? i += `
            bool nextRowOutOfBounds =
              (${l[r - 2]} + 1) >= outShape[${r} - 2];
            bool nextColOutOfBounds =
              (${l[r - 1]} + 1) >= outShape[${r} - 1];
            result.y = nextColOutOfBounds ? 0. : result.y;
            result.z = nextRowOutOfBounds ? 0. : result.z;
            result.w = nextColOutOfBounds || nextRowOutOfBounds ? 0. : result.w;
          ` : i += `
            bool nextRowOutOfBounds =
              (${l[r - 2]} + 1) >= ${this.outputShape[r - 2]};
            bool nextColOutOfBounds =
              (${l[r - 1]} + 1) >= ${this.outputShape[r - 1]};
            result.y = nextColOutOfBounds ? 0. : result.y;
            result.z = nextRowOutOfBounds ? 0. : result.z;
            result.w = nextColOutOfBounds || nextRowOutOfBounds ? 0. : result.w;
          `;
            }
        }
        this.userCode = `
      vec4 binaryOperation(vec4 a, vec4 b) {
        ${t}
      }

      void main() {
        vec4 a = getAAtOutCoords();
        vec4 b = getBAtOutCoords();

        vec4 result = binaryOperation(a, b);
        ${i}

        setOutput(result);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function nn(n) {
    const { inputs: t, backend: e } = n, { x: s } = t;
    return e.incRef(s.dataId), {
        dataId: s.dataId,
        shape: s.shape,
        dtype: s.dtype
    };
}
const oX = {
    kernelName: Ki,
    backendName: "webgl",
    kernelFunc: nn
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function oo(n) {
    const { inputs: t, backend: e } = n, { real: s, imag: o } = t, r = e.makeTensorInfo(s.shape, "complex64"), i = e.texData.get(r.dataId), a = nn({
        inputs: {
            x: s
        },
        backend: e
    }), l = nn({
        inputs: {
            x: o
        },
        backend: e
    });
    return i.complexTensorInfos = {
        real: a,
        imag: l
    }, r;
}
const rX = {
    kernelName: ih,
    backendName: "webgl",
    kernelFunc: oo
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const HI = "return (a < 0.) ? b * a : a;", _I = `
  vec4 aLessThanZero = vec4(lessThan(a, vec4(0.)));
  return (aLessThanZero * (b * a)) + ((vec4(1.0) - aLessThanZero) * a);
`;
function iX(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { alpha: r } = s, i = e.makeTensorInfo([], "float32", Is(r, "float32")), a = F().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new Fr(_I, o.shape, i.shape) : new Po(HI, o.shape, i.shape), l = e.runWebGLProgram(a, [
        o,
        i
    ], "float32");
    return e.disposeIntermediateTensorInfo(i), l;
}
const aX = {
    kernelName: fc,
    backendName: "webgl",
    kernelFunc: iX
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const UI = "return (a < 0.) ? b * a : a;", YI = `
  vec4 aLessThanZero = vec4(lessThan(a, vec4(0.)));
  return (aLessThanZero * (b * a)) + ((vec4(1.0) - aLessThanZero) * a);
`;
function lX(n) {
    const { inputs: t, backend: e } = n, { x: s, alpha: o } = t, r = F().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new Fr(YI, s.shape, o.shape) : new Po(UI, s.shape, o.shape);
    return e.runWebGLProgram(r, [
        s,
        o
    ], "float32");
}
const cX = {
    kernelName: Mc,
    backendName: "webgl",
    kernelFunc: lX
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Vr = "if (isnan(x)) return x;";
function Nt({ opSnippet: n, packedOpSnippet: t, cpuKernelImpl: e, dtype: s }) {
    return ({ inputs: o, backend: r })=>{
        const { x: i } = o, a = r, l = s || i.dtype;
        if (a.shouldExecuteOnCPU([
            i
        ]) && e != null) {
            const d = a.texData.get(i.dataId), h = e(d.values, l);
            return a.makeTensorInfo(i.shape, l, h);
        }
        const c = F().getBool("WEBGL_PACK_UNARY_OPERATIONS") && t != null;
        let u;
        return c ? u = new Vs(i.shape, t) : u = new qn(i.shape, n), a.runWebGLProgram(u, [
            i
        ], l);
    };
}
function Re({ opSnippet: n, packedOpSnippet: t, checkOutOfBounds: e = !1, supportsComplex: s = !1, cpuKernelImpl: o, dtype: r }) {
    return ({ inputs: i, backend: a })=>{
        const { a: l, b: c } = i, u = a;
        if (s && l.dtype === "complex64") {
            const f = u.texData.get(l.dataId), m = u.texData.get(c.dataId), [g, b] = [
                [
                    f.complexTensorInfos.real,
                    m.complexTensorInfos.real
                ],
                [
                    f.complexTensorInfos.imag,
                    m.complexTensorInfos.imag
                ]
            ].map((w)=>{
                const [y, I] = w, v = {
                    dataId: y.dataId,
                    dtype: y.dtype,
                    shape: l.shape
                }, k = {
                    dataId: I.dataId,
                    dtype: I.dtype,
                    shape: c.shape
                }, S = new Po(n, l.shape, c.shape);
                return u.runWebGLProgram(S, [
                    v,
                    k
                ], tn(y.dtype, I.dtype));
            }), x = oo({
                inputs: {
                    real: g,
                    imag: b
                },
                backend: u
            });
            return u.disposeIntermediateTensorInfo(g), u.disposeIntermediateTensorInfo(b), x;
        }
        const d = r || tn(l.dtype, c.dtype);
        if ((l.dtype === "string" || c.dtype === "string" || u.shouldExecuteOnCPU([
            l,
            c
        ])) && o != null) {
            const f = u.texData.get(l.dataId).values, m = u.texData.get(c.dataId).values, g = l.dtype === "string" ? // tslint:disable-next-line: no-any
            ys(f) : f, b = l.dtype === "string" ? // tslint:disable-next-line: no-any
            ys(m) : m, [x, w] = o(l.shape, c.shape, g, b, d), y = u.makeTensorInfo(w, d), I = u.texData.get(y.dataId);
            return I.values = x, y;
        }
        const h = F().getBool("WEBGL_PACK_BINARY_OPERATIONS") && t != null;
        let p;
        return h ? p = new Fr(t, l.shape, c.shape, e) : p = new Po(n, l.shape, c.shape), u.runWebGLProgram(p, [
            l,
            c
        ], d);
    };
}
function yi(n, t = !1) {
    if (n === "linear") return t ? KO : zO;
    if (n === "relu") return t ? BO : AO;
    if (n === "elu") return t ? ZO : PO;
    if (n === "relu6") return t ? HO : OO;
    if (n === "prelu") return t ? YI : UI;
    if (n === "leakyrelu") return t ? _I : HI;
    if (n === "sigmoid") return t ? _O : XO;
    throw new Error(`Activation ${n} has not been implemented for the WebGL backend.`);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class QI {
    constructor(t, e, s, o = !1, r = !1, i = !1, a = null, l = !1, c = !1){
        this.variableNames = [
            "matrixA",
            "matrixB"
        ], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = s, this.enableShapeUniforms = Me(this.outputShape.length);
        const u = o ? t[1] : t[2], d = Math.ceil(u / 2), h = o ? "i * 2, rc.y" : "rc.y, i * 2", p = r ? "rc.z, i * 2" : "i * 2, rc.z", f = o ? [
            "a.xxyy",
            "a.zzww"
        ] : [
            "a.xxzz",
            "a.yyww"
        ], m = r ? [
            "b.xzxz",
            "b.ywyw"
        ] : [
            "b.xyxy",
            "b.zwzw"
        ];
        let g = "", b = "";
        a && (l ? g = `vec4 activation(vec4 a) {
          vec4 b = getPreluActivationWeightsAtOutCoords();
          ${a}
        }` : c ? g = `vec4 activation(vec4 a) {
          vec4 b = getLeakyreluAlphaAtOutCoords();
          ${a}
        }` : g = `vec4 activation(vec4 x) {
          ${a}
        }`, b = "result = activation(result);");
        const x = i ? "result += getBiasAtOutCoords();" : "";
        i && this.variableNames.push("bias"), l && this.variableNames.push("preluActivationWeights"), c && this.variableNames.push("leakyreluAlpha");
        let w = "rc.x", y = "rc.x";
        t[0] < e[0] ? w = `imod(rc.x, ${t[0]})` : e[0] < t[0] && (y = `imod(rc.x, ${e[0]})`), this.userCode = `
      ${g}
      // Don't use uniform for sharedDimensionPacked for performance.
      const float sharedDimension = ${d}.0;

      vec4 dot2x2ARowBCol(ivec3 rc) {
        vec4 result = vec4(0);
        int batchA = ${w};
        int batchB = ${y};
        for (int i = 0; i < ${d}; i++) {
          vec4 a = getMatrixA(batchA, ${h});
          vec4 b = getMatrixB(batchB, ${p});

          // These swizzled products need to be separately added.
          // See: https://github.com/tensorflow/tfjs/issues/1735
          result += (${f[0]} * ${m[0]});
          result += (${f[1]} * ${m[1]});
        }
        return result;
      }

      void main() {
        ivec3 rc = getOutputCoords();
        vec4 result = dot2x2ARowBCol(rc);

        ${x}

        ${b}

        setOutput(result);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const kg = {
    REAL: "return areal * breal - aimag * bimag;",
    IMAG: "return areal * bimag + aimag * breal;"
};
class Tg {
    constructor(t, e, s){
        this.variableNames = [
            "AReal",
            "AImag",
            "BReal",
            "BImag"
        ], this.outputShape = bt(e, s), this.userCode = `
      float binaryOpComplex(
          float areal, float aimag, float breal, float bimag) {
        ${t}
      }

      void main() {
        float areal = getARealAtOutCoords();
        float aimag = getAImagAtOutCoords();
        float breal = getBRealAtOutCoords();
        float bimag = getBImagAtOutCoords();
        setOutput(binaryOpComplex(areal, aimag, breal, bimag));
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Ng = "return a * b;";
function im(n) {
    const { inputs: t, backend: e } = n, { a: s, b: o } = t, r = tn(s.dtype, o.dtype);
    if (s.dtype === "complex64") {
        const a = e.texData.get(s.dataId), l = e.texData.get(o.dataId), c = new Tg(kg.REAL, s.shape, o.shape), u = new Tg(kg.IMAG, s.shape, o.shape), d = [
            {
                dataId: a.complexTensorInfos.real.dataId,
                dtype: a.complexTensorInfos.real.dtype,
                shape: s.shape
            },
            {
                dataId: a.complexTensorInfos.imag.dataId,
                dtype: a.complexTensorInfos.imag.dtype,
                shape: s.shape
            },
            {
                dataId: l.complexTensorInfos.real.dataId,
                dtype: l.complexTensorInfos.real.dtype,
                shape: o.shape
            },
            {
                dataId: l.complexTensorInfos.imag.dataId,
                dtype: l.complexTensorInfos.imag.dtype,
                shape: o.shape
            }
        ], h = e.runWebGLProgram(c, d, "float32"), p = e.runWebGLProgram(u, d, "float32"), f = oo({
            inputs: {
                real: h,
                imag: p
            },
            backend: e
        });
        return e.disposeIntermediateTensorInfo(h), e.disposeIntermediateTensorInfo(p), f;
    }
    if (e.shouldExecuteOnCPU([
        s,
        o
    ])) {
        const a = e.texData.get(s.dataId), l = e.texData.get(o.dataId), [c, u] = aO(s.shape, o.shape, a.values, l.values, r), d = e.makeTensorInfo(u, r), h = e.texData.get(d.dataId);
        return h.values = c, d;
    }
    let i;
    return F().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? i = new Fr(Ng, s.shape, o.shape) : i = new Po(Ng, s.shape, o.shape), e.runWebGLProgram(i, [
        s,
        o
    ], r);
}
const uX = {
    kernelName: ji,
    backendName: "webgl",
    kernelFunc: im
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function dX(n, t, e) {
    const s = [
        Vo(n.shape),
        ...zo(n.shape)
    ], o = {
        dtype: n.dtype,
        shape: s,
        dataId: n.dataId
    }, r = [
        Vo(t),
        ...zo(t)
    ], i = new BI(r, s), a = !0, l = [
        s
    ], c = e.runWebGLProgram(i, [
        o
    ], n.dtype, l, a);
    return {
        dataId: c.dataId,
        shape: t,
        dtype: c.dtype
    };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function et(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { shape: r } = s, i = e, a = X(o.shape), l = Yd(r, a), c = X(l);
    C(a === c, ()=>`The new shape (${l}) has ${c} elements and the old shape (${o.shape}) has ${a} elements. The new shape and old shape must have the same number of elements.`);
    const u = i.texData.get(o.dataId);
    return u.isPacked && !xi(o.shape, l) && !(u.texture !== null && xi(u.shape, l)) ? dX(o, l, i) : (i.incRef(o.dataId), {
        dataId: o.dataId,
        shape: l,
        dtype: o.dtype
    });
}
const hX = {
    kernelName: Dc,
    backendName: "webgl",
    kernelFunc: et
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class Rg {
    constructor(t, e){
        this.variableNames = [
            "x"
        ];
        const { windowSize: s, batchSize: o, inSize: r, outSize: i } = t;
        this.outputShape = [
            o,
            i
        ];
        const a = Math.floor(s / 4) * 4, l = s % 4;
        let c = "sumValue += dot(values, ones);";
        if (e != null) {
            const d = 1 / e;
            c = `sumValue += dot(values * ${Co(d) ? d.toPrecision(2) : d}, ones);`;
        }
        let u = "";
        r % s > 0 && (u = `
        if (inIdx < 0 || inIdx >= ${r}) {
          return 0.0;
        }
      `), this.userCode = `
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float getValue(int batch, int inIdx) {
        ${u}
        return getX(batch, inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${s};

        float sumValue = 0.0;

        for (int i = 0; i < ${a}; i += 4) {
          int inIdx = inOffset + i;
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          ${c}
        }

        int inIdx = inOffset + ${a};
        if (${l === 1}) {
          vec4 values = vec4(getValue(batch, inIdx), 0.0, 0.0, 0.0);

          ${c}
        } else if (${l === 2}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1), 0.0, 0.0);

          ${c}
        } else if (${l === 3}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2), 0.0);

          ${c}
        }
        setOutput(sumValue);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class pX {
    constructor(t, e){
        this.variableNames = [
            "x"
        ];
        const { windowSize: s, batchSize: o, inSize: r, outSize: i } = t;
        this.outputShape = [
            o,
            i
        ];
        let a = "0.0", l = "";
        e === "prod" ? a = "1.0" : e === "min" ? (a = "1.0 / 1e-20", l = "min") : e === "max" && (a = "-1.0 / 1e-20", l = "max");
        let c = `${e}(${e}(${e}(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])`;
        e === "sum" ? c = "sumValue" : e === "prod" ? c = "prodValue" : e === "all" ? c = "allValue" : e === "any" && (c = "anyValue");
        const u = Math.floor(s / 4) * 4, d = s % 4;
        let h = `
      if (${e === "sum"}) {
        sumValue += dot(values, ones);
      } else if (${e === "prod"}) {
        vec2 tmp = vec2(values[0], values[1]) * vec2(values[2], values[3]);
        prodValue *= tmp[0] * tmp[1];
      } else {
        minMaxValue = ${l}(values, minMaxValue);
        if (${e === "min"} || ${e === "max"}) {
          minMaxValue = ${l}(values, minMaxValue);
          bvec4 isNaN = isnan(values);
          if (isNaN.r || isNaN.g || isNaN.b || isNaN.a) {
            minMaxValue = vec4(NAN);
          }
        }
      }
    `, p = "vec4";
        e === "all" ? (a = "1.0", h = `
        bool reducedAllValue = all(values);
        float floatedReducedAllValue = float(reducedAllValue);
        allValue = float(allValue >= 1.0 && floatedReducedAllValue >= 1.0);
      `, p = "bvec4") : e === "any" && (a = "0.0", h = `
        bool reducedAnyValue = any(values);
        float floatedReducedAnyValue = float(reducedAnyValue);
        anyValue = float(anyValue >= 1.0 || floatedReducedAnyValue >= 1.0);
      `, p = "bvec4");
        let f = "";
        r % s > 0 && (f = `
        if (inIdx < 0 || inIdx >= ${r}) {
          return initializationValue;
        }
      `), this.userCode = `
      const float initializationValue = ${a};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float getValue(int batch, int inIdx) {
        ${f}
        return getX(batch, inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${s};

        vec4 minMaxValue = vec4(${a});
        float prodValue = 1.0;
        float sumValue = 0.0;
        float allValue = 1.0;
        float anyValue = 0.0;

        for (int i = 0; i < ${u}; i += 4) {
          int inIdx = inOffset + i;
          ${p} values = ${p}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          ${h}
        }

        int inIdx = inOffset + ${u};
        if (${d === 1}) {
          ${p} values = ${p}(
            getValue(batch, inIdx),
            initializationValue,
            initializationValue,
            initializationValue
          );

          ${h}
        } else if (${d === 2}) {
          ${p} values = ${p}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            initializationValue,
            initializationValue
          );

          ${h}
        } else if (${d === 3}) {
          ${p} values = ${p}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            initializationValue
          );

          ${h}
        }
        setOutput(${c});
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function fX(n) {
    const t = [];
    for(; t.length === 0 || t[t.length - 1].outSize !== 1;){
        const e = t.length ? t[t.length - 1].outSize : n[1], s = ou(e);
        t.push({
            inSize: e,
            windowSize: s,
            outSize: Math.ceil(e / s)
        });
    }
    return t;
}
function qo(n, t, e, s) {
    const o = fX(n.shape);
    let r = n;
    for(let i = 0; i < o.length; i++){
        const { inSize: a, windowSize: l, outSize: c } = o[i];
        let u, d;
        e === "mean" ? u = i === 0 ? new Rg({
            windowSize: l,
            inSize: a,
            batchSize: n.shape[0],
            outSize: c
        }, a) : new Rg({
            windowSize: l,
            inSize: a,
            batchSize: n.shape[0],
            outSize: c
        }) : u = new pX({
            windowSize: l,
            inSize: a,
            batchSize: n.shape[0],
            outSize: c
        }, e), d = r, r = s.runWebGLProgram(u, [
            r
        ], t), d.dataId !== n.dataId && s.disposeIntermediateTensorInfo(d);
    }
    return r;
}
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class mX {
    constructor(t, e){
        this.variableNames = [
            "A"
        ];
        const s = new Array(t.length);
        for(let i = 0; i < s.length; i++)s[i] = t[e[i]];
        this.outputShape = s, this.rank = s.length;
        const o = Vt(this.rank), r = gX(e);
        this.userCode = `
    void main() {
      ${o} resRC = getOutputCoords();
      setOutput(getA(${r}));
    }
    `;
    }
}
function gX(n) {
    const t = n.length;
    if (t > 6) throw Error(`Transpose for rank ${t} is not yet supported`);
    const e = [
        "resRC.x",
        "resRC.y",
        "resRC.z",
        "resRC.w",
        "resRC.u",
        "resRC.v"
    ], s = new Array(t);
    for(let o = 0; o < n.length; o++)s[n[o]] = e[o];
    return s.join();
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class bX {
    constructor(t, e){
        this.variableNames = [
            "A"
        ], this.packedInputs = !0, this.packedOutput = !0;
        const s = new Array(t.length);
        for(let u = 0; u < s.length; u++)s[u] = t[e[u]];
        if (this.outputShape = s, this.rank = s.length, this.rank > 6) throw Error(`Packed transpose for rank ${this.rank} is not yet supported.`);
        const o = Vt(this.rank), r = ZI("rc", this.rank), i = new Array(this.rank);
        for(let u = 0; u < e.length; u++)i[e[u]] = r[u];
        const a = `vec2(${i.slice(-2).join()})`, l = `++${r[this.rank - 1]} < ${s[this.rank - 1]}`, c = `getChannel(getA(${i.join()}), ${a})`;
        this.userCode = `
    void main() {
      ${o} rc = getOutputCoords();
      vec4 result = vec4(0.);
      result[0] = ${c};
      if(${l}) {
        result[1] = ${c};
      }
      --${r[this.rank - 1]};
      if(++${r[this.rank - 2]} < ${s[this.rank - 2]}) {
        result[2] = ${c};
        if(${l}) {
          result[3] = ${c};
        }
      }
      setOutput(result);
    }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function vu(n, t, e) {
    const s = F().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new bX(n.shape, t) : new mX(n.shape, t);
    return e.runWebGLProgram(s, [
        n
    ], n.dtype);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function xX(n, t, e, s) {
    const o = t, r = n.shape.length, i = Ct(o, n.shape);
    let a = i;
    const l = qt(a, r), c = l != null;
    let u = n;
    c && (u = vu(n, l, s), a = ie(a.length, r)), Ne("sum", a, r);
    const [d, h] = ye(u.shape, a);
    let p = d;
    e && (p = re(d, i));
    const f = X(h), g = X(n.shape) / f, b = et({
        inputs: {
            x: u
        },
        attrs: {
            shape: [
                g,
                f
            ]
        },
        backend: s
    }), x = Yh(n.dtype), w = qo(b, x, "sum", s), y = et({
        inputs: {
            x: w
        },
        attrs: {
            shape: p
        },
        backend: s
    });
    return s.disposeIntermediateTensorInfo(b), s.disposeIntermediateTensorInfo(w), c && s.disposeIntermediateTensorInfo(u), y;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Su(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r, keepDims: i } = s;
    return xX(o, r, i, e);
}
const yX = {
    kernelName: Oc,
    backendName: "webgl",
    kernelFunc: Su
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ze(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { perm: r } = s, i = e, a = o.shape.length, l = new Array(a);
    for(let u = 0; u < l.length; u++)l[u] = o.shape[r[u]];
    let c;
    if (i.shouldExecuteOnCPU([
        o
    ])) {
        const d = i.texData.get(o.dataId).values, h = om(d, o.shape, o.dtype, r, l);
        c = i.makeTensorInfo(l, o.dtype);
        const p = i.texData.get(c.dataId);
        p.values = h;
    } else c = vu(o, r, i);
    return c;
}
const wX = {
    kernelName: ar,
    backendName: "webgl",
    kernelFunc: ze
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const JI = 1e3;
function Ol({ a: n, b: t, transposeA: e, transposeB: s, backend: o, bias: r = null, preluActivationWeights: i = null, leakyreluAlpha: a = 0, activation: l = null }) {
    const c = n.shape.length, u = t.shape.length, d = e ? n.shape[c - 2] : n.shape[c - 1], h = s ? t.shape[u - 1] : t.shape[u - 2], p = e ? n.shape[c - 1] : n.shape[c - 2], f = s ? t.shape[u - 2] : t.shape[u - 1], m = n.shape.slice(0, -2), g = t.shape.slice(0, -2), b = X(m), x = X(g), y = bt(n.shape.slice(0, -2), t.shape.slice(0, -2)).concat([
        p,
        f
    ]);
    C(d === h, ()=>`Error in matMul: inner shapes (${d}) and (${h}) of Tensors with shapes ${n.shape} and ${t.shape} and transposeA=${e} and transposeB=${s} must match.`);
    const I = e ? [
        b,
        d,
        p
    ] : [
        b,
        p,
        d
    ], v = s ? [
        x,
        f,
        h
    ] : [
        x,
        h,
        f
    ], k = et({
        inputs: {
            x: n
        },
        backend: o,
        attrs: {
            shape: I
        }
    }), S = et({
        inputs: {
            x: t
        },
        backend: o,
        attrs: {
            shape: v
        }
    }), N = [
        k,
        S
    ], R = Math.max(b, x), M = e ? k.shape[1] : k.shape[2], V = r != null, z = i != null, P = l === "leakyrelu", A = l != null ? yi(l, !0) : null, O = V || z || P || A != null;
    let B;
    if ((p === 1 || f === 1) && M > JI && O === !1) {
        let H = k, Y = S;
        e && (H = ze({
            inputs: {
                x: k
            },
            backend: o,
            attrs: {
                perm: [
                    0,
                    2,
                    1
                ]
            }
        }), N.push(H)), s && (Y = ze({
            inputs: {
                x: S
            },
            backend: o,
            attrs: {
                perm: [
                    0,
                    2,
                    1
                ]
            }
        }), N.push(Y));
        const Q = f !== 1, j = f === 1;
        let J = H;
        Q && (J = et({
            inputs: {
                x: H
            },
            backend: o,
            attrs: {
                shape: [
                    R,
                    M,
                    1
                ]
            }
        }), N.push(J));
        const ot = f === 1 ? 2 : 1;
        let q = Y;
        j && (q = et({
            inputs: {
                x: Y
            },
            backend: o,
            attrs: {
                shape: [
                    R,
                    1,
                    M
                ]
            }
        }), N.push(q));
        const rt = im({
            inputs: {
                a: J,
                b: q
            },
            backend: o
        });
        B = Su({
            inputs: {
                x: rt
            },
            backend: o,
            attrs: {
                axis: ot,
                keepDims: !0
            }
        }), N.push(rt);
    } else {
        const H = tn(n.dtype, t.dtype), Y = new QI(I, v, [
            R,
            p,
            f
        ], e, s, V, A, z, P), Q = [
            k,
            S
        ];
        if (r != null && Q.push(r), z && Q.push(i), P) {
            const j = o.makeTensorInfo([], "float32", Is(a, "float32"));
            Q.push(j), N.push(j);
        }
        B = o.runWebGLProgram(Y, Q, H);
    }
    const Z = et({
        inputs: {
            x: B
        },
        backend: o,
        attrs: {
            shape: y
        }
    });
    N.push(B);
    for (const H of N)o.disposeIntermediateTensorInfo(H);
    return Z;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function IX(n) {
    const { inputs: t, backend: e, attrs: s } = n, { a: o, b: r, bias: i, preluActivationWeights: a } = t, { transposeA: l, transposeB: c, activation: u, leakyreluAlpha: d } = s;
    return Ol({
        a: o,
        b: r,
        transposeA: l,
        transposeB: c,
        backend: e,
        bias: i,
        preluActivationWeights: a,
        leakyreluAlpha: d,
        activation: u
    });
}
const CX = {
    kernelName: ml,
    backendName: "webgl",
    kernelFunc: IX
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $g = "return abs(x);";
function vX(n) {
    const { inputs: t, backend: e } = n, { x: s } = t;
    if (e.shouldExecuteOnCPU([
        s
    ]) && s.dtype !== "complex64") {
        const r = e.texData.get(s.dataId), i = XI(r.values);
        return e.makeTensorInfo(s.shape, s.dtype, i);
    }
    let o;
    return F().getBool("WEBGL_PACK_UNARY_OPERATIONS") ? o = new Vs(s.shape, $g) : o = new qn(s.shape, $g), e.runWebGLProgram(o, [
        s
    ], s.dtype);
}
const SX = {
    kernelName: Ul,
    backendName: "webgl",
    kernelFunc: vX
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const kX = En + `
  if (abs(x) > 1.) {
    return NAN;
  }
  return acos(x);
`, TX = Nt({
    opSnippet: kX
}), NX = {
    kernelName: vi,
    backendName: "webgl",
    kernelFunc: TX
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const RX = En + `
  if (x < 1.0) return NAN;
return log(x + sqrt(x * x - 1.0));`, $X = Nt({
    opSnippet: RX
}), GX = {
    kernelName: Si,
    backendName: "webgl",
    kernelFunc: $X
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Gg = "return a + b;", EX = Re({
    opSnippet: Gg,
    packedOpSnippet: Gg,
    supportsComplex: !0,
    cpuKernelImpl: AA
}), LX = {
    kernelName: Sr,
    backendName: "webgl",
    kernelFunc: EX
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class MX {
    constructor(t, e){
        this.outputShape = [], this.outputShape = t, this.variableNames = e.map((r, i)=>`T${i}`);
        const s = [];
        this.variableNames.forEach((r)=>{
            s.push(`float v${r} = get${r}AtOutCoords();`);
        });
        const o = this.variableNames.map((r)=>`v${r}`).join(" + ");
        this.userCode = `
      void main() {
        ${s.join(`
        `)}

        float result = ${o};
        setOutput(result);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class WX {
    constructor(t, e){
        this.outputShape = [], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = t, this.variableNames = e.map((r, i)=>`T${i}`);
        const s = [];
        this.variableNames.forEach((r)=>{
            s.push(`vec4 v${r} = get${r}AtOutCoords();`);
        });
        const o = this.variableNames.map((r)=>`v${r}`).join(" + ");
        this.userCode = `
      void main() {
        ${s.join(`
        `)}

        vec4 result = ${o};
        setOutput(result);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function dl(n) {
    const { inputs: t, backend: e } = n, s = t;
    if (s.length === 1) return nn({
        inputs: {
            x: s[0]
        },
        backend: e
    });
    if (s.length > F().getNumber("WEBGL_MAX_TEXTURES_IN_SHADER")) {
        const l = Math.floor(s.length / 2), c = dl({
            inputs: s.slice(0, l),
            backend: e
        }), u = dl({
            inputs: s.slice(l),
            backend: e
        });
        return dl({
            inputs: [
                c,
                u
            ],
            backend: e
        });
    }
    const o = s.map((l)=>l.dtype).reduce((l, c)=>tn(l, c)), r = s.map((l)=>l.shape), a = F().getBool("WEBGL_PACK") ? new WX(s[0].shape, r) : new MX(s[0].shape, r);
    return e.runWebGLProgram(a, s, o);
}
const DX = {
    kernelName: qd,
    backendName: "webgl",
    kernelFunc: dl
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function FX(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r, keepDims: i } = s, a = o.shape.length, l = Ct(r, o.shape);
    let c = l;
    const u = qt(c, a);
    let d = o;
    u != null && (d = ze({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            perm: u
        }
    }), c = ie(c.length, a)), Ne("all", c, a);
    const [h, p] = ye(d.shape, c), f = X(p), m = et({
        inputs: {
            x: d
        },
        backend: e,
        attrs: {
            shape: [
                -1,
                f
            ]
        }
    }), g = qo(m, m.dtype, "all", e);
    let b;
    if (i) {
        const x = re(h, l);
        b = et({
            inputs: {
                x: g
            },
            backend: e,
            attrs: {
                shape: x
            }
        });
    } else b = et({
        inputs: {
            x: g
        },
        backend: e,
        attrs: {
            shape: h
        }
    });
    return e.disposeIntermediateTensorInfo(m), e.disposeIntermediateTensorInfo(g), u != null && e.disposeIntermediateTensorInfo(d), b;
}
const VX = {
    kernelName: th,
    backendName: "webgl",
    kernelFunc: FX
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function zX(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r, keepDims: i } = s, a = o.shape.length, l = Ct(r, o.shape);
    let c = l;
    const u = qt(c, a);
    let d = o;
    u != null && (d = ze({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            perm: u
        }
    }), c = ie(c.length, a)), Ne("any", c, a);
    const [h, p] = ye(d.shape, c), f = X(p), m = et({
        inputs: {
            x: d
        },
        backend: e,
        attrs: {
            shape: [
                -1,
                f
            ]
        }
    }), g = qo(m, m.dtype, "any", e);
    let b;
    if (i) {
        const x = re(h, l);
        b = et({
            inputs: {
                x: g
            },
            backend: e,
            attrs: {
                shape: x
            }
        });
    } else b = et({
        inputs: {
            x: g
        },
        backend: e,
        attrs: {
            shape: h
        }
    });
    return e.disposeIntermediateTensorInfo(m), e.disposeIntermediateTensorInfo(g), u != null && e.disposeIntermediateTensorInfo(d), b;
}
const PX = {
    kernelName: eh,
    backendName: "webgl",
    kernelFunc: zX
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class AX {
    constructor(t, e, s){
        this.variableNames = [
            "A"
        ];
        const { windowSize: o, batchSize: r, outSize: i } = t;
        s || this.variableNames.push("bestIndicesA"), this.outputShape = [
            r,
            i
        ];
        const a = e === "max" ? ">" : "<", l = s ? "inOffset + i;" : "round(getBestIndicesA(batch, inOffset + i));";
        this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${o};

        int bestIndex = inOffset;
        float bestValue = getA(batch, bestIndex);

        for (int i = 0; i < ${o}; i++) {
          int inIdx = ${l};
          float candidate = getA(batch, inIdx);
          if (candidate ${a} bestValue) {
            bestValue = candidate;
            bestIndex = inIdx;
          }
        }
        setOutput(float(bestIndex));
      }
    `;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class OX {
    constructor(t, e, s, o){
        this.variableNames = [
            "A"
        ], this.packedInputs = !0, this.packedOutput = !0, C(t.length > 2, ()=>`Packed arg${s.charAt(0).toUpperCase() + s.slice(1)} supports only inputs with rank above 2.`);
        const r = t[t.length - 1], i = Math.ceil(r / e);
        this.outputShape = t.slice(0, -1), i > 1 && this.outputShape.push(i), o || this.variableNames.push("bestIndicesA");
        const a = this.outputShape, l = a.length, c = Vt(l), u = Fe("coords", l);
        let d, h;
        if (i === 1) {
            h = l + 1;
            const S = Vt(h);
            d = `
        ${S} sourceLocR = ${S}(${u.join()}, 0);
        ++${u[l - 1]};
        ${S} sourceLocG = ${S}(${u.join()}, 0);
        ++${u[l - 2]};
        ${S} sourceLocA = ${S}(${u.join()}, 0);
        --${u[l - 1]};
        ${S} sourceLocB = ${S}(${u.join()}, 0);
        --${u[l - 2]};`;
        } else h = l, d = `
        ${c} sourceLocR = coords;
        ++${u[l - 1]};
        ${c} sourceLocG = coords;
        ++${u[l - 2]};
        ${c} sourceLocA = coords;
        --${u[l - 1]};
        ${c} sourceLocB = coords;
        --${u[l - 2]};`;
        const p = [
            "x",
            "y",
            "z",
            "w",
            "u",
            "v"
        ].slice(0, h), f = "." + p[h - 1], m = p.map((S)=>"int " + S), g = Fe("sourceLocR", h - 1).concat("inIdx.r"), b = Fe("sourceLocG", h - 1).concat("inIdx.g"), x = Fe("sourceLocB", h - 1).concat("inIdx.b"), w = Fe("sourceLocA", h - 1).concat("inIdx.a"), y = s === "max" ? "greaterThan" : "lessThan", I = o ? "" : `
          inIdx = round(vec4(getBestIndicesAChannel(${g.join()}),
                             getBestIndicesAChannel(${b.join()}),
                             getBestIndicesAChannel(${x.join()}),
                             getBestIndicesAChannel(${w.join()})));`, v = `vec4(
            getAChannel(${g.join()}),
            hasNextCol ? getAChannel(${b.join()}) : 0.,
            hasNextRow ? getAChannel(${x.join()}) : 0.,
            hasNextRow && hasNextCol ? getAChannel(${w.join()}) : 0.)`, k = o ? "" : `
      float getBestIndicesAChannel(${m.join()}) {
        return getChannel(getBestIndicesA(${p.join()}),
                                          vec2(${p.slice(-2).join()}));
      }`;
        this.userCode = `
      float getAChannel(${m.join()}) {
        return getChannel(getA(${p.join()}),
                               vec2(${p.slice(-2).join()}));
      }
      ${k}
      void main() {
        ${c} coords = getOutputCoords();
        bool hasNextCol = ${u[l - 1]} < ${a[l - 1] - 1};
        bool hasNextRow = ${u[l - 2]} < ${a[l - 2] - 1};
        ${d}
        ivec4 srcIdx = ivec4(sourceLocR${f}, sourceLocG${f},
          sourceLocB${f}, sourceLocA${f}) * ${e};
        ivec4 inIdx = srcIdx;
        vec4 bestIndex = vec4(inIdx);
        vec4 bestValue = ${v};

        for (int i = 0; i < ${e}; i++) {
          inIdx = srcIdx;
          ${I}
          vec4 candidate = ${v};
          bvec4 nan = isnan(candidate);
          bvec4 replace = bvec4(
            vec4(${y}(candidate, bestValue)) * (vec4(1.0) - vec4(nan)));

          bestValue = vec4(replace.x  ? candidate.x : bestValue.x,
                           replace.y  ? candidate.y : bestValue.y,
                           replace.z  ? candidate.z : bestValue.z,
                           replace.w  ? candidate.w : bestValue.w);
          bestIndex = mix(bestIndex, vec4(inIdx), vec4(replace));
          srcIdx++;
        }
        setOutput(bestIndex);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function jI(n, t, e, s = null) {
    let o = t.shape[0], r = t.shape[1];
    s != null && (o = s.shape[0], r = s.shape[1]);
    const i = ou(r), a = {
        windowSize: i,
        inSize: r,
        batchSize: o,
        outSize: Math.ceil(r / i)
    }, l = new AX(a, e, s == null), c = [
        t
    ];
    s != null && c.push(s);
    const u = n.runWebGLProgram(l, c, "int32");
    if (u.shape[1] === 1) return u;
    const d = jI(n, t, e, u);
    return n.disposeIntermediateTensorInfo(u), d;
}
function qI(n, t, e, s = null) {
    const o = s != null ? s.shape : t.shape, r = o[o.length - 1], i = ou(r), a = new OX(o, i, e, s == null), l = s == null ? [
        t
    ] : [
        t,
        s
    ], c = n.runWebGLProgram(a, l, "int32");
    if (c.shape.length === t.shape.length) {
        const u = qI(n, t, e, c);
        return n.disposeIntermediateTensorInfo(c), u;
    }
    return c;
}
function tC(n, t, e, s) {
    const o = [
        e
    ];
    if (Ne("arg" + s.charAt(0).toUpperCase() + s.slice(1), o, t.shape.length), !F().getBool("WEBGL_PACK_REDUCE") || t.shape.length <= 2) {
        const r = [], i = n.texData.get(t.dataId), a = i !== null && i.isPacked;
        let l = t;
        a && (l = n.unpackTensor(t), r.push(l));
        const [c, u] = ye(l.shape, o), d = X(u), h = et({
            inputs: {
                x: l
            },
            backend: n,
            attrs: {
                shape: [
                    -1,
                    d
                ]
            }
        });
        r.push(h);
        const p = jI(n, h, s);
        r.push(p);
        const f = et({
            inputs: {
                x: p
            },
            backend: n,
            attrs: {
                shape: c
            }
        });
        return r.forEach((m)=>n.disposeIntermediateTensorInfo(m)), f;
    }
    return qI(n, t, s);
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function XX(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r } = s;
    let i = Ct(r, o.shape);
    const a = qt(i, o.shape.length);
    let l = o;
    const c = [];
    a != null && (l = ze({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            perm: a
        }
    }), c.push(l), i = ie(i.length, l.shape.length)), Ne("argMax", [
        i[0]
    ], l.shape.length);
    const u = tC(e, l, i[0], "max");
    return c.forEach((d)=>e.disposeIntermediateTensorInfo(d)), u;
}
const KX = {
    kernelName: Yl,
    backendName: "webgl",
    kernelFunc: XX
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ZX(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r } = s;
    let i = Ct(r, o.shape);
    const a = qt(i, o.shape.length);
    let l = o;
    const c = [];
    a != null && (l = ze({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            perm: a
        }
    }), c.push(l), i = ie(i.length, l.shape.length)), Ne("argMin", [
        i[0]
    ], l.shape.length);
    const u = tC(e, l, i[0], "min");
    return c.forEach((d)=>e.disposeIntermediateTensorInfo(d)), u;
}
const BX = {
    kernelName: Ql,
    backendName: "webgl",
    kernelFunc: ZX
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const HX = En + `
  if (abs(x) > 1.) {
    return NAN;
  }
  return asin(x);
`, _X = Nt({
    opSnippet: HX
}), UX = {
    kernelName: ki,
    backendName: "webgl",
    kernelFunc: _X
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const YX = En + "return log(x + sqrt(x * x + 1.0));", QX = Nt({
    opSnippet: YX
}), JX = {
    kernelName: Ti,
    backendName: "webgl",
    kernelFunc: QX
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const jX = En + `
  return atan(x);
`, qX = Nt({
    opSnippet: jX
}), tK = {
    kernelName: Ni,
    backendName: "webgl",
    kernelFunc: qX
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const eK = rm + `
  return atan(a, b);
`, nK = `
  vec4 result = atan(a, b);
  bvec4 isNaNA = isnan(a);
  bvec4 isNaNB = isnan(b);
  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);
  ` + jo + `
  return result;
`, sK = Re({
    opSnippet: eK,
    packedOpSnippet: nK
}), oK = {
    kernelName: $i,
    backendName: "webgl",
    kernelFunc: sK
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const rK = En + `
  if ((x < -1.0) || (x > 1.0)) return NAN;
return (log(1.0 + x) - log(1.0 - x)) / 2.0;`, iK = Nt({
    opSnippet: rK
}), aK = {
    kernelName: Ri,
    backendName: "webgl",
    kernelFunc: iK
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class wi {
    constructor(t, e, s, o = !1, r = !1){
        if (this.variableNames = [
            "x"
        ], e === "avg" && s) throw new Error("Cannot compute positions for average pool.");
        const i = t.filterWidth, a = t.strideHeight, l = t.strideWidth, c = t.dilationHeight, u = t.dilationWidth, d = t.effectiveFilterHeight, h = t.effectiveFilterWidth, p = t.padInfo.top, f = t.padInfo.left;
        this.outputShape = t.outShape;
        const m = e === "avg", g = `((batch  * ${t.inHeight} + xR) * ${t.inWidth} + xC) * ${t.inChannels} + d`, b = `(xR * ${t.inWidth} + xC) * ${t.inChannels} + d`;
        let x = "0.0";
        if (m || (x = "-1.0 / 1e-20"), s) {
            const S = ">=";
            this.userCode = `
        const ivec2 strides = ivec2(${a}, ${l});
        const ivec2 pads = ivec2(${p}, ${f});

        void main() {
          ivec4 coords = getOutputCoords();
          int batch = coords[0];
          int d = coords[3];

          ivec2 xRCCorner = coords.yz * strides - pads;
          int xRCorner = xRCCorner.x;
          int xCCorner = xRCCorner.y;

          // max/min x(?, ?, d) to get y(yR, yC, d).
          // ? = to be determined
          float minMaxValue = 0.0;
          float minMaxValueFound = 0.0;
          int minMaxPosition = 0;
          float avgValue = 0.0;

          for (int wR = 0; wR < ${d};
              wR += ${c}) {
            int xR = xRCorner + wR;

            if (xR < 0 || xR >= ${t.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${h};
                wC += ${u}) {
              int xC = xCCorner + wC;

              if (xC < 0 || xC >= ${t.inWidth}) {
                continue;
              }

              float value = getX(batch, xR, xC, d);

              // If a min / max value has already been found, use it. If not,
              // use the current value.
              float currMinMaxValue = mix(
                  value, minMaxValue, minMaxValueFound);
              if (value ${S} currMinMaxValue) {
                minMaxValue = value;
                minMaxValueFound = 1.0;
                minMaxPosition = ${o ? r ? g : b : `wR * ${h} + wC`};
              }
            }
          }
          setOutput(float(minMaxPosition));
        }
      `;
            return;
        }
        const w = "max";
        let y = `${e}(${e}(${e}(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])`;
        e === "avg" && (y = "avgValue / max(count, 1.0)");
        const I = Math.floor(i / 4) * 4, v = i % 4, k = `
      if (${m}) {
        avgValue += dot(values, ones);
      } else {
        minMaxValue = ${w}(values, minMaxValue);
      }
    `;
        this.userCode = `
      const ivec2 strides = ivec2(${a}, ${l});
      const ivec2 pads = ivec2(${p}, ${f});
      const float initializationValue = ${x};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float count = 0.0;

      float getValue(int batch, int xR, int xC, int d) {
        if (xC < 0 || xC >= ${t.inWidth}) {
          return initializationValue;
        }
        count += 1.0;
        return getX(batch, xR, xC, d);
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d = coords[3];

        ivec2 xRCCorner = coords.yz * strides - pads;
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // max/min x(?, ?, d) to get y(yR, yC, d).
        // ? = to be determined
        vec4 minMaxValue = vec4(${x});
        float avgValue = 0.0;
        count = 0.0;

        for (int wR = 0; wR < ${d};
            wR += ${c}) {
          int xR = xRCorner + wR;

          if (xR < 0 || xR >= ${t.inHeight}) {
            continue;
          }

          for (int wC = 0; wC < ${I}; wC += 4) {
            int xC = xCCorner + wC * ${u};

            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${u}, d),
              getValue(batch, xR, xC + 2 * ${u}, d),
              getValue(batch, xR, xC + 3 * ${u}, d)
            );

            ${k}
          }

          int xC = xCCorner + ${I};
          if (${v === 1}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              initializationValue,
              initializationValue,
              initializationValue
            );

            ${k}
          } else if (${v === 2}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${u}, d),
              initializationValue,
              initializationValue
            );

            ${k}
          } else if (${v === 3}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${u}, d),
              getValue(batch, xR, xC + 2 * ${u}, d),
              initializationValue
            );

            ${k}
          }
        }
        setOutput(${y});
      }
    `;
    }
}
class am {
    constructor(t, e, s, o = !1, r = !1){
        if (this.variableNames = [
            "x"
        ], e === "avg" && s) throw new Error("Cannot compute positions for average pool.");
        const i = t.filterWidth, a = t.strideDepth, l = t.strideHeight, c = t.strideWidth, u = t.dilationDepth, d = t.dilationHeight, h = t.dilationWidth, p = t.effectiveFilterDepth, f = t.effectiveFilterHeight, m = t.effectiveFilterWidth, g = t.padInfo.front, b = t.padInfo.top, x = t.padInfo.left;
        this.outputShape = t.outShape;
        const w = e === "avg";
        let y = "0.0";
        if (w || (y = "-1.0 / 1e-20"), s) {
            const R = ">=";
            this.userCode = `
        const ivec3 strides =
            ivec3(${a}, ${l}, ${c});
        const ivec3 pads = ivec3(${g}, ${b}, ${x});

        void main() {
          ivec5 coords = getOutputCoords();
          int batch = coords.x;
          int ch = coords.u;

          ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
          int xDCorner = xCorner.x;
          int xRCorner = xCorner.y;
          int xCCorner = xCorner.z;

          // max/min x(?, ?, ?, ch) to get y(yD, yR, yC, ch).
          // ? = to be determined
          float minMaxValue = 0.0;
          float minMaxValueFound = 0.0;
          int minMaxPosition = 0;

          for (int wD = 0; wD < ${p};
              wD += ${u}) {
            int xD = xDCorner + wD;

            if (xD < 0 || xD >= ${t.inDepth}) {
              continue;
            }

            for (int wR = 0; wR < ${f};
                wR += ${d}) {
              int xR = xRCorner + wR;

              if (xR < 0 || xR >= ${t.inHeight}) {
                continue;
              }

              for (int wC = 0; wC < ${m};
                  wC += ${h}) {
                int xC = xCCorner + wC;

                if (xC < 0 || xC >= ${t.inWidth}) {
                  continue;
                }

                float value = getX(batch, xD, xR, xC, ch);

                // If a min / max value has already been found, use it. If not,
                // use the current value.
                float currMinMaxValue = mix(
                    value, minMaxValue, minMaxValueFound);
                if (value ${R} currMinMaxValue) {
                  minMaxValue = value;
                  minMaxValueFound = 1.0;
                  minMaxPosition = ${o ? r ? `(((batch * ${t.inDepth} + xD) * ${t.inHeight} + xR) * ${t.inWidth} + xC) * ${t.inChannels} + ch` : `((xD * ${t.inHeight} + xR) * ${t.inWidth} + xC) * ${t.inChannels} + ch` : `wD * ${f} * ${m} +
                      wR * ${m} + wC`};
                }
              }
            }
          }
          setOutput(float(minMaxPosition));
        }
      `;
            return;
        }
        const I = "max";
        let v = `${e}(${e}(${e}(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])`;
        e === "avg" && (v = "avgValue / max(count, 1.0)");
        const k = Math.floor(i / 4) * 4, S = i % 4, N = `
      if (${w}) {
        avgValue += dot(values, ones);
      } else {
        minMaxValue = ${I}(values, minMaxValue);
      }
    `;
        this.userCode = `
      const ivec3 strides =
        ivec3(${a}, ${l}, ${c});
      const ivec3 pads = ivec3(${g}, ${b}, ${x});
      const float initializationValue = ${y};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float count = 0.0;

      float getValue(int batch, int xD, int xR, int xC, int ch) {
        if (xC < 0 || xC >= ${t.inWidth}) {
          return initializationValue;
        }
        count += 1.0;
        return getX(batch, xD, xR, xC, ch);
      }

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
        int xDCorner = xCorner.x;
        int xRCorner = xCorner.y;
        int xCCorner = xCorner.z;

        // max/min x(?, ?, ?, d) to get y(yD, yR, yC, ch).
        // ? = to be determined
        vec4 minMaxValue = vec4(${y});
        float avgValue = 0.0;
        count = 0.0;

        for (int wD = 0; wD < ${p};
            wD += ${u}) {
          int xD = xDCorner + wD;

          if (xD < 0 || xD >= ${t.inDepth}) {
            continue;
          }

          for (int wR = 0; wR < ${f};
            wR += ${d}) {
            int xR = xRCorner + wR;

            if (xR < 0 || xR >= ${t.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${k}; wC += 4) {
              int xC = xCCorner + wC * ${h};

              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${h}, ch),
                getValue(batch, xD, xR, xC + 2 * ${h}, ch),
                getValue(batch, xD, xR, xC + 3 * ${h}, ch)
              );

              ${N}
            }

            int xC = xCCorner + ${k};
            if (${S === 1}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                initializationValue,
                initializationValue,
                initializationValue
              );

              ${N}
            } else if (${S === 2}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${h}, ch),
                initializationValue,
                initializationValue
              );

              ${N}
            } else if (${S === 3}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${h}, ch),
                getValue(batch, xD, xR, xC + 2 * ${h}, ch),
                initializationValue
              );

              ${N}
            }
          }
        }
        setOutput(${v});
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function lK(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t;
    Er(o, "avgPool");
    const { filterSize: r, strides: i, pad: a, dimRoundingMode: l } = s, c = 1;
    C(Le(i, c), ()=>`Error in avgPool: Either strides or dilations must be 1. Got strides ${i} and dilations '${c}'`);
    const u = $n(o.shape, r, i, c, a, l);
    if (u.filterWidth === 1 && u.filterHeight === 1 && $t(u.inShape, u.outShape)) return nn({
        inputs: {
            x: o
        },
        backend: e
    });
    const d = new wi(u, "avg", !1);
    return e.runWebGLProgram(d, [
        o
    ], "float32");
}
const cK = {
    kernelName: Jl,
    backendName: "webgl",
    kernelFunc: lK
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function uK(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { filterSize: r, strides: i, pad: a, dimRoundingMode: l, dataFormat: c } = s, u = [
        1,
        1,
        1
    ], d = vs(o.shape, r, i, u, a, l, c), h = new am(d, "avg", !1);
    return e.runWebGLProgram(h, [
        o
    ], "float32");
}
const dK = {
    kernelName: jl,
    backendName: "webgl",
    kernelFunc: uK
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class hK {
    constructor(t){
        this.variableNames = [
            "dy"
        ], this.outputShape = t.inShape;
        const e = t.filterHeight, s = t.filterWidth, o = t.strideHeight, r = t.strideWidth, i = t.dilationHeight, a = t.dilationWidth, l = t.effectiveFilterHeight, c = t.effectiveFilterWidth, u = l - 1 - t.padInfo.top, d = c - 1 - t.padInfo.left, h = 1 / (e * s);
        this.userCode = `
      const ivec2 pads = ivec2(${u}, ${d});
      const float avgMultiplier = float(${h});

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];

        ivec2 dyRCCorner = coords.yz - pads;
        int dyRCorner = dyRCCorner.x;
        int dyCCorner = dyRCCorner.y;

        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${l};
            wR += ${i}) {
          float dyR = float(dyRCorner + wR) / ${o}.0;

          if (dyR < 0.0 || dyR >= ${t.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          for (int wC = 0; wC < ${c};
            wC+= ${a}) {
            float dyC = float(dyCCorner + wC) / ${r}.0;

            if (dyC < 0.0 || dyC >= ${t.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            float dyValue = getDy(b, idyR, idyC, d);

            dotProd += dyValue * avgMultiplier;
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class pK {
    constructor(t){
        this.variableNames = [
            "dy"
        ], this.outputShape = t.inShape;
        const e = t.filterDepth, s = t.filterHeight, o = t.filterWidth, r = t.strideDepth, i = t.strideHeight, a = t.strideWidth, l = t.dilationDepth, c = t.dilationHeight, u = t.dilationWidth, d = t.effectiveFilterDepth, h = t.effectiveFilterHeight, p = t.effectiveFilterWidth, f = d - 1 - t.padInfo.front, m = h - 1 - t.padInfo.top, g = p - 1 - t.padInfo.left, b = 1 / (e * s * o);
        this.userCode = `
      const ivec3 pads = ivec3(${f}, ${m}, ${g});
      const float avgMultiplier = float(${b});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyDCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        // Convolve dy(?, ?, ?, d) with pos mask(:, :, :, ch) to get
        // dx(xD, xR, xC, ch).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int wD = 0; wD < ${d};
            wD += ${l}) {
          float dyD = float(dyDCorner + wD) / ${r}.0;

          if (dyD < 0.0 || dyD >= ${t.outDepth}.0 || fract(dyD) > 0.0) {
            continue;
          }
          int idyD = int(dyD);

          for (int wR = 0; wR < ${h};
              wR += ${c}) {
            float dyR = float(dyRCorner + wR) / ${i}.0;

            if (dyR < 0.0 || dyR >= ${t.outHeight}.0 ||
                fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            for (int wC = 0; wC < ${p};
                wC += ${u}) {
              float dyC = float(dyCCorner + wC) / ${a}.0;

              if (dyC < 0.0 || dyC >= ${t.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              float dyValue = getDy(batch, idyD, idyR, idyC, ch);

              dotProd += dyValue * avgMultiplier;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function fK(n) {
    const { inputs: t, backend: e, attrs: s } = n, { dy: o, input: r } = t, i = r, { filterSize: a, strides: l, pad: c, dimRoundingMode: u } = s, d = [
        1,
        1,
        1
    ], h = vs(i.shape, a, l, d, c, u), p = new pK(h);
    return e.runWebGLProgram(p, [
        o
    ], i.dtype);
}
const mK = {
    kernelName: sh,
    backendName: "webgl",
    kernelFunc: fK
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function gK(n) {
    const { inputs: t, backend: e, attrs: s } = n, { dy: o, input: r } = t, i = r;
    Er([
        o,
        r
    ], "avgPoolGrad");
    const { filterSize: a, strides: l, pad: c } = s, u = $n(i.shape, a, l, 1, c), d = new hK(u);
    return e.runWebGLProgram(d, [
        o
    ], i.dtype);
}
const bK = {
    kernelName: nh,
    backendName: "webgl",
    kernelFunc: gK
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function xK(n) {
    const { inputs: t, backend: e, attrs: s } = n, { a: o, b: r } = t, { transposeA: i, transposeB: a } = s;
    return Ol({
        a: o,
        b: r,
        transposeA: i,
        transposeB: a,
        backend: e
    });
}
const yK = {
    kernelName: ql,
    backendName: "webgl",
    kernelFunc: xK
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class wK {
    constructor(t, e, s, o, r, i){
        this.outputShape = [], this.variableNames = [
            "x",
            "mean",
            "variance"
        ], bt(t, e), bt(t, s);
        let a = "0.0";
        o != null && (bt(t, o), this.variableNames.push("offset"), a = "getOffsetAtOutCoords()");
        let l = "1.0";
        r != null && (bt(t, r), this.variableNames.push("scale"), l = "getScaleAtOutCoords()"), this.outputShape = t, this.userCode = `
      void main() {
        float x = getXAtOutCoords();
        float mean = getMeanAtOutCoords();
        float variance = getVarianceAtOutCoords();
        float offset = ${a};
        float scale = ${l};
        float inv = scale * inversesqrt(variance + float(${i}));
        setOutput(dot(vec3(x, -mean, offset), vec3(inv, inv, 1)));
      }
    `;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class IK {
    constructor(t, e, s, o, r, i){
        this.packedInputs = !0, this.packedOutput = !0, this.variableNames = [
            "x",
            "mean",
            "variance"
        ], bt(t, e), bt(t, s);
        let a = "vec4(0.0)";
        o != null && (bt(t, o), this.variableNames.push("offset"), a = "getOffsetAtOutCoords()");
        let l = "vec4(1.0)";
        r != null && (bt(t, r), this.variableNames.push("scale"), l = "getScaleAtOutCoords()"), this.outputShape = t, this.userCode = `
      void main() {
        vec4 offset = ${a};
        vec4 scale = ${l};

        vec4 x = getXAtOutCoords();
        vec4 mean = getMeanAtOutCoords();
        vec4 variance = getVarianceAtOutCoords();

        vec4 inv = scale * inversesqrt(variance + vec4(${i}));

        setOutput((x - mean) * inv + offset);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const CK = ({ inputs: n, backend: t, attrs: e })=>{
    const { x: s, mean: o, variance: r, offset: i, scale: a } = n;
    C(o.shape.length === r.shape.length, ()=>"Batch normalization gradient requires mean and variance to have equal ranks."), C(i == null || o.shape.length === i.shape.length, ()=>"Batch normalization gradient requires mean and offset to have equal ranks."), C(a == null || o.shape.length === a.shape.length, ()=>"Batch normalization gradient requires mean and scale to have equal ranks.");
    let { varianceEpsilon: l } = e;
    l == null && (l = 1e-3);
    const c = [
        s,
        o,
        r
    ];
    let u = null;
    i != null && (u = i.shape, c.push(i));
    let d = null;
    a != null && (d = a.shape, c.push(a));
    const h = F().getBool("WEBGL_PACK_NORMALIZATION") ? new IK(s.shape, o.shape, r.shape, u, d, l) : new wK(s.shape, o.shape, r.shape, u, d, l);
    return t.runWebGLProgram(h, c, c[0].dtype);
}, vK = {
    kernelName: dc,
    backendName: "webgl",
    kernelFunc: CK
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class SK {
    constructor(t){
        this.variableNames = [
            "source"
        ], this.outputShape = t, this.rank = t.length;
        const e = Vt(this.rank);
        this.customUniforms = [
            {
                name: "start",
                arrayIndex: this.rank,
                type: "int"
            }
        ];
        const s = kK(this.rank);
        let o;
        const r = t.map((i, a)=>`sourceLoc.${Xd[a]} = start[${a}] + coords.${Xd[a]};`);
        o = `
        ${e} sourceLoc;
        ${e} coords = getOutputCoords();
        ${r.join(`
`)}
      `, this.userCode = `
      void main() {
        ${o}
        setOutput(getSource(${s}));
      }
    `;
    }
}
const Xd = [
    "x",
    "y",
    "z",
    "w",
    "u",
    "v"
];
function kK(n) {
    if (n === 1) return "sourceLoc";
    if (n <= 6) return Xd.slice(0, n).map((t)=>"sourceLoc." + t).join(",");
    throw Error(`Slicing for rank ${n} is not yet supported`);
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class TK {
    constructor(t){
        this.variableNames = [
            "source"
        ], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = t, this.rank = t.length, this.customUniforms = [
            {
                name: "start",
                arrayIndex: this.rank,
                type: "int"
            }
        ];
        const e = Vt(this.rank), s = Fe("coords", this.rank), o = Fe("sourceLoc", this.rank), r = this.rank === 1 ? "sourceLoc" : `vec2(${o.slice(-2).join()})`, i = `getChannel(getSource(${o.join()}), ${r})`, a = `
      result.x = ${i};
      if (++${s[this.rank - 1]} < ${t[this.rank - 1]}) {
        ++${o[this.rank - 1]};
        result.y = ${i};
        --${o[this.rank - 1]};
      }
    `, l = this.rank === 1 ? "" : `
      --${s[this.rank - 1]};
      if (++${s[this.rank - 2]} < ${t[this.rank - 2]}) {
        ++${o[this.rank - 2]};
        result.z = ${i};
        if (++${s[this.rank - 1]} < ${t[this.rank - 1]}) {
          ++${o[this.rank - 1]};
          result.w = ${i};
        }
      }
    `, c = this.rank <= 4 ? `sourceLoc = coords +
            ${e}(${t.map((u, d)=>`start[${d}]`).join()});` : t.map((u, d)=>`${o[d]} = ${s[d]} + start[${d}];`).join(`
`);
        this.userCode = `
      void main() {
        ${e} coords = getOutputCoords();
        ${e} sourceLoc;
        ${c}
        vec4 result = vec4(0.);
        ${a}
        ${l}
        setOutput(result);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function NK(n, t, e, s) {
    const o = s.texData.get(n.dataId), r = s.makeTensorInfo(e, n.dtype), i = s.texData.get(r.dataId);
    Object.assign(i, o), i.refCount = 1, i.shape = e, i.dtype = n.dtype;
    let a = _p(t, dt(n.shape));
    o.slice && (a += o.slice.flatOffset), i.slice = {
        flatOffset: a,
        // Point to the original dataId, which is used to do ref counting.
        origDataId: o.slice && o.slice.origDataId || n.dataId
    };
    const l = s.dataRefCount.get(i.slice.origDataId) || 1;
    return s.dataRefCount.set(i.slice.origDataId, l + 1), r;
}
function zr(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { begin: r, size: i } = s, [a, l] = nu(o, r, i);
    if (Zp(o, a, l), X(l) === 0) return e.makeTensorInfo(l, o.dtype, []);
    if (e.shouldExecuteOnCPU([
        o
    ]) || o.dtype === "string") {
        const d = e.texData.get(o.dataId), h = xO(d.values, a, l, o.shape, o.dtype);
        return e.makeTensorInfo(l, o.dtype, h);
    }
    const { isPacked: c } = e.texData.get(o.dataId), u = Hp(o.shape, a, l);
    if (c || !u) {
        const d = F().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new TK(l) : new SK(l), h = [
            a
        ];
        return e.runWebGLProgram(d, [
            o
        ], o.dtype, h);
    }
    return e.uploadToGPU(o.dataId), NK(o, a, l, e);
}
const RK = {
    kernelName: Ac,
    backendName: "webgl",
    kernelFunc: zr
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $K = (n)=>{
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { blockShape: r, crops: i } = s;
    C(o.shape.length <= 4, ()=>"batchToSpaceND for rank > 4 with a WebGL backend not implemented yet");
    const a = r.reduce((x, w)=>x * w), l = Na(o.shape, r, a), c = Ra(l.length, r.length), u = $a(o.shape, r, a), d = jp(i, r.length), h = qp(u, i, r.length), p = [], f = et({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            shape: l
        }
    }), m = ze({
        inputs: {
            x: f
        },
        backend: e,
        attrs: {
            perm: c
        }
    }), g = et({
        inputs: {
            x: m
        },
        backend: e,
        attrs: {
            shape: u
        }
    }), b = zr({
        inputs: {
            x: g
        },
        backend: e,
        attrs: {
            begin: d,
            size: h
        }
    });
    return p.push(f), p.push(m), p.push(g), p.forEach((x)=>e.disposeIntermediateTensorInfo(x)), b;
}, GK = {
    kernelName: tc,
    backendName: "webgl",
    kernelFunc: $K
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function EK(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, weights: r } = t, { size: i } = s, a = e.readSync(o.dataId), l = e.readSync(r.dataId), c = OI(a, l, r.dtype, r.shape, i);
    return e.makeTensorInfo([
        i
    ], r.dtype, c);
}
const LK = {
    kernelName: oh,
    backendName: "webgl",
    kernelFunc: EK
};
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const MK = `
  int r = int(a.r) & int(b.r);
  int g = int(a.g) & int(b.g);
  int rb = int(a.b) & int(b.b);
  int ra = int(a.a) & int(b.a);
  return vec4(r, g, rb, ra);
`, WK = `
  return float(int(a.r) & int(b.r));
`;
function DK(n) {
    const { inputs: t, backend: e } = n, { a: s, b: o } = t, r = F().getBool("WEBGL_PACK_BINARY_OPERATIONS"), i = F().getNumber("WEBGL_VERSION");
    if (e.shouldExecuteOnCPU([
        s,
        o
    ]) || i === 1) {
        const l = e.texData.get(s.dataId).values, c = e.texData.get(o.dataId).values, [u, d] = XA(s.shape, o.shape, l, c, s.dtype), h = e.makeTensorInfo(d, s.dtype), p = e.texData.get(h.dataId);
        return p.values = u, h;
    }
    let a;
    return r ? a = new Fr(MK, s.shape, o.shape, !1) : a = new Po(WK, s.shape, o.shape), e.runWebGLProgram(a, [
        s,
        o
    ], s.dtype);
}
const FK = {
    kernelName: rh,
    backendName: "webgl",
    kernelFunc: DK
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function VK(n) {
    const { inputs: t, backend: e } = n, { s0: s, s1: o } = t, r = e.readSync(s.dataId), i = e.readSync(o.dataId), a = bt(Array.from(r), Array.from(i));
    return e.makeTensorInfo([
        a.length
    ], "int32", Int32Array.from(a));
}
const zK = {
    kernelName: cb,
    backendName: "webgl",
    kernelFunc: VK
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const PK = "return float(a != b);", eC = Re({
    opSnippet: PK,
    cpuKernelImpl: cO,
    dtype: "bool"
}), AK = {
    kernelName: Rc,
    backendName: "webgl",
    kernelFunc: eC
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Oa(n) {
    const { inputs: t, backend: e } = n, { input: s } = t, o = e.texData.get(s.dataId);
    return nn({
        inputs: {
            x: o.complexTensorInfos.real
        },
        backend: e
    });
}
const OK = {
    kernelName: Eh,
    backendName: "webgl",
    kernelFunc: Oa
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const XK = "return float(int(x));";
function KK(n, t) {
    const e = new qn(n.shape, XK), s = t.runWebGLProgram(e, [
        n
    ], "int32");
    return {
        dataId: s.dataId,
        shape: s.shape,
        dtype: s.dtype
    };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Kd(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { dtype: r } = s;
    if (r === "complex64") {
        if (o.dtype === "complex64") return nn({
            inputs: {
                x: o
            },
            backend: e
        });
        const i = be(o.shape), a = Kd({
            inputs: {
                x: o
            },
            backend: e,
            attrs: {
                dtype: "float32"
            }
        }), l = oo({
            inputs: {
                real: a,
                imag: i
            },
            backend: e
        });
        return i.dispose(), e.disposeIntermediateTensorInfo(a), l;
    }
    if (o.dtype === "complex64") {
        const i = Oa({
            inputs: {
                input: o
            },
            backend: e
        }), a = Kd({
            inputs: {
                x: i
            },
            backend: e,
            attrs: {
                dtype: r
            }
        });
        return e.disposeIntermediateTensorInfo(i), a;
    }
    if (!Qd(o.dtype, r)) {
        const i = nn({
            inputs: {
                x: o
            },
            backend: e
        });
        return {
            dataId: i.dataId,
            shape: i.shape,
            dtype: r
        };
    }
    if (e.shouldExecuteOnCPU([
        o
    ])) {
        const i = e.texData.get(o.dataId).values, [a, l, c] = KA(i, o.shape, o.dtype, r);
        return e.makeTensorInfo(a, l, c);
    }
    if (r === "int32") return KK(o, e);
    if (r === "bool") {
        const i = e.makeTensorInfo([], "bool", Se("bool", 1)), l = eC({
            inputs: {
                a: o,
                b: i
            },
            backend: e
        });
        return e.disposeIntermediateTensorInfo(i), l;
    }
    throw new Error(`Error in Cast: failed to cast ${o.dtype} to ${r}`);
}
const ZK = {
    kernelName: Gi,
    backendName: "webgl",
    kernelFunc: Kd
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Eg = "return ceil(x);", BK = Nt({
    opSnippet: Eg,
    packedOpSnippet: Eg,
    cpuKernelImpl: ZA
}), HK = {
    kernelName: Ei,
    backendName: "webgl",
    kernelFunc: BK
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class _K {
    constructor(t){
        this.variableNames = [
            "A"
        ], this.customUniforms = [
            {
                name: "minVal",
                type: "float"
            },
            {
                name: "maxVal",
                type: "float"
            }
        ], this.outputShape = t, this.userCode = `

      void main() {
        float value = getAAtOutCoords();
        if (isnan(value)) {
          setOutput(value);
          return;
        }

        setOutput(clamp(value, minVal, maxVal));
      }
    `;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class UK {
    constructor(t){
        this.variableNames = [
            "A"
        ], this.packedInputs = !0, this.packedOutput = !0, this.customUniforms = [
            {
                name: "minVal",
                type: "float"
            },
            {
                name: "maxVal",
                type: "float"
            }
        ], this.outputShape = t, this.userCode = `
      void main() {
        vec4 value = getAAtOutCoords();

        if (any(isnan(value))) {
          setOutput(value);
          return;
        }

        setOutput(clamp(value, vec4(minVal), vec4(maxVal)));
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function YK(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { clipValueMin: r, clipValueMax: i } = s;
    let a;
    F().getBool("WEBGL_PACK_CLIP") ? a = new UK(o.shape) : a = new _K(o.shape);
    const l = [
        [
            r
        ],
        [
            i
        ]
    ];
    return e.runWebGLProgram(a, [
        o
    ], o.dtype, l);
}
const QK = {
    kernelName: Li,
    backendName: "webgl",
    kernelFunc: YK
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class JK {
    constructor(t){
        this.variableNames = [
            "real",
            "imag"
        ], this.outputShape = t, this.userCode = `
      void main() {
        float re = abs(getRealAtOutCoords());
        float im = abs(getImagAtOutCoords());
        float mx = max(re, im);

        // sadly the length function in glsl is not underflow-safe
        // (at least not on Intel GPUs). So the safe solution is
        // to ensure underflow-safety in all cases.
        setOutput(
          mx == 0.0 ? 0.0 : mx * length(vec2(1, min(re, im)/mx))
        );
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Lg(n, t) {
    return {
        dataId: t.dataId,
        dtype: t.dtype,
        shape: n.shape
    };
}
function jK(n) {
    const { inputs: t, backend: e } = n, { x: s } = t, o = e.texData.get(s.dataId), r = new JK(s.shape), i = [
        Lg(s, o.complexTensorInfos.real),
        Lg(s, o.complexTensorInfos.imag)
    ];
    return e.runWebGLProgram(r, i, i[0].dtype);
}
const qK = {
    kernelName: ec,
    backendName: "webgl",
    kernelFunc: jK
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class tZ {
    // Concats 2d tensors along axis=1. See comments in MathBackendWebGL.concat().
    constructor(t){
        this.outputShape = [], this.outputShape = ts(t, 1), this.variableNames = t.map((i, a)=>`T${a}`);
        const e = new Array(t.length - 1);
        e[0] = t[0][1];
        for(let i = 1; i < e.length; i++)e[i] = e[i - 1] + t[i][1];
        const s = [
            `if (yC < ${e[0]}) setOutput(getT0(yR, yC));`
        ];
        for(let i = 1; i < e.length; i++){
            const a = e[i - 1];
            s.push(`else if (yC < ${e[i]}) setOutput(getT${i}(yR, yC-${a}));`);
        }
        const o = e.length, r = e[e.length - 1];
        s.push(`else setOutput(getT${o}(yR, yC-${r}));`), this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int yR = coords.x;
        int yC = coords.y;

        ${s.join(`
        `)}
      }
    `;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class eZ {
    constructor(t, e){
        this.packedInputs = !0, this.packedOutput = !0, this.outputShape = [], this.outputShape = ts(t, e);
        const s = this.outputShape, o = s.length, r = Vt(o), i = Fe("coords", o), a = [
            "x",
            "y",
            "z",
            "w",
            "u",
            "v"
        ].slice(0, o);
        this.variableNames = t.map((m, g)=>`T${g}`);
        const l = new Array(t.length - 1);
        l[0] = t[0][e];
        for(let m = 1; m < l.length; m++)l[m] = l[m - 1] + t[m][e];
        const c = a[e], u = a.slice(-2), d = a.join();
        let h = `if (${c} < ${l[0]}) {
        return getChannel(
            getT0(${d}), vec2(${u.join()}));
        }`;
        for(let m = 1; m < l.length; m++){
            const g = l[m - 1];
            h += `
        if (${c} < ${l[m]}  && ${c} >= ${l[m - 1]}) {
          return getChannel(
            getT${m}(${qa(a, c, g)}),
            vec2(${qa(u, c, g)}));
        }`;
        }
        const p = l.length, f = l[l.length - 1];
        h += `
        return getChannel(
          getT${p}(${qa(a, c, f)}),
          vec2(${qa(u, c, f)}));`, this.userCode = `
      float getValue(${a.map((m)=>"int " + m)}) {
        ${h}
      }

      void main() {
        ${r} coords = getOutputCoords();
        vec4 result = vec4(getValue(${i}), 0., 0., 0.);

        ${i[o - 1]} = ${i[o - 1]} + 1;
        if (${i[o - 1]} < ${s[o - 1]}) {
          result.g = getValue(${i});
        }

        ${i[o - 2]} = ${i[o - 2]} + 1;
        if (${i[o - 2]} < ${s[o - 2]}) {
          result.a = getValue(${i});
        }

        ${i[o - 1]} = ${i[o - 1]} - 1;
        if (${i[o - 2]} < ${s[o - 2]} &&
            ${i[o - 1]} < ${s[o - 1]}) {
          result.b = getValue(${i});
        }
        setOutput(result);
      }
    `;
    }
}
function qa(n, t, e) {
    const s = n.indexOf(t);
    return n.map((r, i)=>i === s ? `${r} - ${e}` : r).join();
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ku(n) {
    const { inputs: t, backend: e } = n, { input: s } = t, o = e.texData.get(s.dataId);
    return nn({
        inputs: {
            x: o.complexTensorInfos.imag
        },
        backend: e
    });
}
const nZ = {
    kernelName: vh,
    backendName: "webgl",
    kernelFunc: ku
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ei(n, t, e) {
    const s = n[0].dtype;
    if (s === "complex64") {
        const p = n.map((x)=>Oa({
                inputs: {
                    input: x
                },
                backend: e
            })), f = n.map((x)=>ku({
                inputs: {
                    input: x
                },
                backend: e
            })), m = ei(p, t, e), g = ei(f, t, e), b = oo({
            inputs: {
                real: m,
                imag: g
            },
            backend: e
        });
        return p.forEach((x)=>e.disposeIntermediateTensorInfo(x)), f.forEach((x)=>e.disposeIntermediateTensorInfo(x)), e.disposeIntermediateTensorInfo(m), e.disposeIntermediateTensorInfo(g), b;
    }
    let o = e.shouldExecuteOnCPU(n);
    if (s === "string" && (o = !0), o) {
        const p = n.map((y)=>{
            const v = [
                -1,
                X(y.shape.slice(t))
            ];
            return et({
                inputs: {
                    x: y
                },
                backend: e,
                attrs: {
                    shape: v
                }
            });
        }), f = p.map((y)=>({
                vals: e.readSync(y.dataId),
                shape: y.shape
            })), m = ts(p.map((y)=>y.shape), 1), g = p[0].shape[0] === 1, b = BA(f, m, s, g), x = ts(n.map((y)=>y.shape), t), w = e.makeTensorInfo(x, s, b);
        return p.forEach((y)=>e.disposeIntermediateTensorInfo(y)), w;
    }
    const r = n.filter((p)=>X(p.shape) > 0), i = F().getBool("WEBGL_PACK_ARRAY_OPERATIONS") && r[0].shape.length > 1;
    if (r.length === 1) {
        const p = i ? new qn(n[0].shape, Ms) : new Vs(n[0].shape, Ms);
        return e.runWebGLProgram(p, n, s);
    }
    const a = F().getNumber("WEBGL_MAX_TEXTURES_IN_SHADER");
    if (r.length > a) {
        const p = [];
        for(let m = 0; m < r.length; m += a){
            const g = r.slice(m, m + a);
            p.push(ei(g, t, e));
        }
        const f = ei(p, t, e);
        for (const m of p)e.disposeIntermediateTensorInfo(m);
        return f;
    }
    if (i) {
        const p = new eZ(r.map((f)=>f.shape), t);
        return e.runWebGLProgram(p, r, s);
    }
    const { tensors2D: l, outShape: c } = sZ(r, t, e), u = new tZ(l.map((p)=>p.shape)), d = e.runWebGLProgram(u, l, s);
    l.forEach((p)=>e.disposeIntermediateTensorInfo(p));
    const h = et({
        inputs: {
            x: d
        },
        attrs: {
            shape: c
        },
        backend: e
    });
    return e.disposeIntermediateTensorInfo(d), h;
}
function sZ(n, t, e) {
    const s = ts(n.map((r)=>r.shape), t);
    return {
        tensors2D: n.map((r)=>et({
                inputs: {
                    x: r
                },
                attrs: {
                    shape: [
                        -1,
                        X(r.shape.slice(t))
                    ]
                },
                backend: e
            })),
        outShape: s
    };
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function nC(n) {
    const { inputs: t, backend: e, attrs: s } = n, { axis: o } = s, r = Ct(o, t[0].shape)[0], i = t.map((c)=>c.shape);
    Yp(i, r);
    const a = ts(t.map((c)=>c.shape), r);
    if (X(a) === 0) return e.makeTensorInfo(a, t[0].dtype, []);
    const l = t.filter((c)=>X(c.shape) > 0);
    return l.length === 1 ? nn({
        inputs: {
            x: l[0]
        },
        backend: e
    }) : ei(l, r, e);
}
const oZ = {
    kernelName: nc,
    backendName: "webgl",
    kernelFunc: nC
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class sC {
    constructor(t, e = !1, s = null, o = !1, r = !1){
        this.variableNames = [
            "x",
            "W"
        ], this.outputShape = t.outShape;
        const i = t.padInfo.top, a = t.padInfo.left, l = t.strideHeight, c = t.strideWidth, u = t.dilationHeight, d = t.dilationWidth, h = t.filterHeight, p = t.filterWidth, f = Math.floor(t.inChannels / 4) * 4, m = t.inChannels % 4, g = t.dataFormat === "channelsLast", b = g ? 1 : 2, x = g ? 2 : 3, w = g ? 3 : 1;
        let y = "", I = "";
        s && (o ? y = `float activation(float a) {
          float b = getPreluActivationWeightsAtOutCoords();
          ${s}
        }` : r ? y = `float activation(float a) {
          float b = getLeakyreluAlphaAtOutCoords();
          ${s}
        }` : y = `
          float activation(float x) {
            ${s}
          }
        `, I = "result = activation(result);");
        const v = e ? "result += getBiasAtOutCoords();" : "";
        e && this.variableNames.push("bias"), o && this.variableNames.push("preluActivationWeights"), r && this.variableNames.push("leakyreluAlpha"), this.userCode = `
      ${y}

      const ivec2 strides = ivec2(${l}, ${c});
      const ivec2 pads = ivec2(${i}, ${a});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d2 = coords[${w}];

        ivec2 xRCCorner =
            ivec2(coords[${b}], coords[${x}]) * strides - pads;
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // Convolve x(?, ?, d1) with w(:, :, d1, d2) to get y(yR, yC, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${h}; wR++) {
          int xR = xRCorner + wR * ${u};

          if (xR < 0 || xR >= ${t.inHeight}) {
            continue;
          }

          for (int wC = 0; wC < ${p}; wC++) {
            int xC = xCCorner + wC * ${d};

            if (xC < 0 || xC >= ${t.inWidth}) {
              continue;
            }

            for (int d1 = 0; d1 < ${f}; d1 += 4) {
              vec4 wValues = vec4(
                getW(wR, wC, d1, d2),
                getW(wR, wC, d1 + 1, d2),
                getW(wR, wC, d1 + 2, d2),
                getW(wR, wC, d1 + 3, d2)
              );

              if (${g}) {
                vec4 xValues = vec4(
                  getX(batch, xR, xC, d1),
                  getX(batch, xR, xC, d1 + 1),
                  getX(batch, xR, xC, d1 + 2),
                  getX(batch, xR, xC, d1 + 3)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec4 xValues = vec4(
                  getX(batch, d1, xR, xC),
                  getX(batch, d1 + 1, xR, xC),
                  getX(batch, d1 + 2, xR, xC),
                  getX(batch, d1 + 3, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }
            }

            if (${m === 1}) {

              if (${g}) {
                dotProd +=
                    getX(batch, xR, xC, ${f}) *
                    getW(wR, wC, ${f}, d2);
              } else {
                dotProd +=
                    getX(batch, ${f}, xR, xC) *
                    getW(wR, wC, ${f}, d2);
              }

            } else if (${m === 2}) {
              vec2 wValues = vec2(
                getW(wR, wC, ${f}, d2),
                getW(wR, wC, ${f} + 1, d2)
              );

              if (${g}) {
                vec2 xValues = vec2(
                  getX(batch, xR, xC, ${f}),
                  getX(batch, xR, xC, ${f} + 1)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec2 xValues = vec2(
                  getX(batch, ${f}, xR, xC),
                  getX(batch, ${f} + 1, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }

            } else if (${m === 3}) {
              vec3 wValues = vec3(
                getW(wR, wC, ${f}, d2),
                getW(wR, wC, ${f} + 1, d2),
                getW(wR, wC, ${f} + 2, d2)
              );

              if (${g}) {
                vec3 xValues = vec3(
                  getX(batch, xR, xC, ${f}),
                  getX(batch, xR, xC, ${f} + 1),
                  getX(batch, xR, xC, ${f} + 2)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec3 xValues = vec3(
                  getX(batch, ${f}, xR, xC),
                  getX(batch, ${f} + 1, xR, xC),
                  getX(batch, ${f} + 2, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }

            }
          }
        }

        float result = dotProd;
        ${v}
        ${I}
        setOutput(result);
      }
    `;
    }
}
class rZ {
    constructor(t){
        this.variableNames = [
            "x",
            "W"
        ], this.outputShape = t.outShape;
        const e = t.padInfo.front, s = t.padInfo.top, o = t.padInfo.left, r = t.strideDepth, i = t.strideHeight, a = t.strideWidth, l = t.dilationDepth, c = t.dilationHeight, u = t.dilationWidth, d = t.filterDepth, h = t.filterHeight, p = t.filterWidth, f = Math.floor(t.inChannels / 4) * 4, m = t.inChannels % 4;
        this.userCode = `
      const ivec3 strides = ivec3(${r}, ${i}, ${a});
      const ivec3 pads = ivec3(${e}, ${s}, ${o});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int d2 = coords.u;

        ivec3 xFRCCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
        int xFCorner = xFRCCorner.x;
        int xRCorner = xFRCCorner.y;
        int xCCorner = xFRCCorner.z;

        // Convolve x(?, ?, ?, d1) with w(:, :, :, d1, d2) to get
        // y(yF, yR, yC, d2). ? = to be determined. : = across all
        // values in that axis.
        float dotProd = 0.0;
        for (int wF = 0; wF < ${d}; wF++) {
          int xF = xFCorner + wF * ${l};

          if (xF < 0 || xF >= ${t.inDepth}) {
            continue;
          }

          for (int wR = 0; wR < ${h}; wR++) {
            int xR = xRCorner + wR * ${c};

            if (xR < 0 || xR >= ${t.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${p}; wC++) {
              int xC = xCCorner + wC * ${u};

              if (xC < 0 || xC >= ${t.inWidth}) {
                continue;
              }

              for (int d1 = 0; d1 < ${f}; d1 += 4) {
                vec4 xValues = vec4(
                  getX(batch, xF, xR, xC, d1),
                  getX(batch, xF, xR, xC, d1 + 1),
                  getX(batch, xF, xR, xC, d1 + 2),
                  getX(batch, xF, xR, xC, d1 + 3)
                );
                vec4 wValues = vec4(
                  getW(wF, wR, wC, d1, d2),
                  getW(wF, wR, wC, d1 + 1, d2),
                  getW(wF, wR, wC, d1 + 2, d2),
                  getW(wF, wR, wC, d1 + 3, d2)
                );

                dotProd += dot(xValues, wValues);
              }

              if (${m === 1}) {
                dotProd +=
                  getX(batch, xF, xR, xC, ${f}) *
                  getW(wF, wR, wC, ${f}, d2);
              } else if (${m === 2}) {
                vec2 xValues = vec2(
                  getX(batch, xF, xR, xC, ${f}),
                  getX(batch, xF, xR, xC, ${f} + 1)
                );
                vec2 wValues = vec2(
                  getW(wF, wR, wC, ${f}, d2),
                  getW(wF, wR, wC, ${f} + 1, d2)
                );
                dotProd += dot(xValues, wValues);
              } else if (${m === 3}) {
                vec3 xValues = vec3(
                  getX(batch, xF, xR, xC, ${f}),
                  getX(batch, xF, xR, xC, ${f} + 1),
                  getX(batch, xF, xR, xC, ${f} + 2)
                );
                vec3 wValues = vec3(
                  getW(wF, wR, wC, ${f}, d2),
                  getW(wF, wR, wC, ${f} + 1, d2),
                  getW(wF, wR, wC, ${f} + 2, d2)
                );
                dotProd += dot(xValues, wValues);
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class oC {
    constructor(t, e = !1, s = null, o = !1, r = !1){
        this.variableNames = [
            "x",
            "W"
        ], this.packedInputs = !0, this.packedOutput = !0, this.customUniforms = [
            {
                name: "pads",
                type: "ivec2"
            },
            {
                name: "strides",
                type: "ivec2"
            },
            {
                name: "dilations",
                type: "ivec2"
            },
            {
                name: "inDims",
                type: "ivec2"
            }
        ], this.outputShape = t.outShape, this.enableShapeUniforms = Me(this.outputShape.length);
        const i = t.padInfo.left, a = t.strideWidth, l = t.dilationWidth, c = t.filterHeight, u = t.filterWidth, d = u;
        let h = `
       int xR; int xC; int xCOffset;
       vec4 wTexel; vec4 previous; vec4 final;`;
        for(let g = 0; g < u; g++)h += `
           vec4 xTexelC${g * 2};
           int xTexelC${g * 2}Ready;
           vec4 xTexelC${g * 2 + 1};
           int xTexelC${g * 2 + 1}Ready;
           vec4 xC${g};`;
        h += `
     for (int r = 0; r < ${c}; r++) {
      for (int d1 = 0; d1 < ${t.inChannels}; d1 += 2) {
       `;
        for(let g = 0; g < u; g++)h += `
           xTexelC${g * 2} = vec4(0.0);
           xTexelC${g * 2}Ready = 0;
           xTexelC${g * 2 + 1} = vec4(0.0);
           xTexelC${g * 2 + 1}Ready = 0;
           xC${g} = vec4(0.0);`;
        h += `
         xR = xRCorner + r * dilations[0];
         if (xR >=0 && xR < inDims[0]) {
       `;
        for(let g = 0; g < (d + 1) / 2; g++){
            const b = g * 2;
            if (h += `
           xC = xCCorner + ${b * l};
           `, a === 1) {
                if (b < u && (i % 2 === 1 ? (h += `
                 xCOffset = xC + 1;
                 if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${b}Ready == 0) {
                   xTexelC${b} = getX(batch, xR, xCOffset, d1);

                   // Need to manually clear unused channels in case
                   // we're reading from recycled texture.
                   if (xCOffset + 1 >= inDims[1]) {
                     xTexelC${b}.zw = vec2(0.0);
                   }
                   xTexelC${b}Ready = 1;
                 }
               `, l === 1 && b > 0 ? h += `
                 xC${b} = vec4(xTexelC${b - 2}.zw, xTexelC${b}.xy);
                 ` : h += `
                   xCOffset = xC + 1 - 2;

                   if (xCOffset >= 0 && xCOffset < inDims[1]) {
                     previous = getX(batch, xR, xCOffset, d1);

                     // Need to manually clear unused channels in case
                     // we're reading from recycled texture.
                     if (xCOffset + 1 >= inDims[1]) {
                       previous.zw = vec2(0.0);
                     }

                     xC${b} = vec4(previous.zw, xTexelC${b}.xy);
                   } else {
                     xC${b} = vec4(0.0, 0.0, xTexelC${b}.xy);
                   }
                   `) : h += `
                 if (xC >= 0 && xC < inDims[1] && xTexelC${b}Ready == 0) {
                   xTexelC${b} = getX(batch, xR, xC, d1);
                   if (xC + 1 >= inDims[1]) {
                     xTexelC${b}.zw = vec2(0.0);
                   }
                   xTexelC${b}Ready = 1;
                 }

                 xC${b} = xTexelC${b};
                 `, b + 1 < u)) {
                    const x = i % 2 === 0 ? Bl(l) : l;
                    l % 2 === 0 && i % 2 === 1 || l % 2 !== 0 && i % 2 !== 1 ? (h += `
                   xCOffset = xC + imod(pads[1], 2) + ${x};

                   if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${b + 1}Ready == 0) {
                     xTexelC${b + 1} = getX(batch, xR, xCOffset, d1);

                     // Need to manually clear unused channels in case
                     // we're reading from recycled texture.
                     if (xCOffset + 1 >= inDims[1]) {
                       xTexelC${b + 1}.zw = vec2(0.0);
                     }
                     xTexelC${b + 1}Ready = 1;
                   }
                   `, l > 1 ? h += `
                     xCOffset -= 2;
                     if (xCOffset >= 0 && xCOffset < inDims[1]) {
                      previous = getX(batch, xR, xCOffset, d1);
                      xC${b + 1} = vec4(previous.zw, xTexelC${b + 1}.xy);
                     } else {
                      xC${b + 1} = vec4(0.0, 0.0, xTexelC${b + 1}.xy);
                     }
                     ` : h += `
                     xC${b + 1} = vec4(xTexelC${b}.zw, xTexelC${b + 1}.xy);
                     `) : x === 1 ? h += `
                     xC${b + 1} = xTexelC${b};
                     ` : h += `
                     xCOffset = xC + ${x};

                     if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${b + 1}Ready == 0) {
                       xTexelC${b + 1} = getX(batch, xR, xCOffset, d1);
                       if (xCOffset + 1 >= inDims[1]) {
                         xTexelC${b + 1}.zw = vec2(0.0);
                       }
                       xTexelC${b + 1}Ready = 1;
                     }

                     xC${b + 1} = xTexelC${b + 1};
                     `;
                }
            } else b < u && (i % 2 === 1 ? (h += `
                 xCOffset = xC + 1 - strides[1];
                 if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${b}Ready == 0) {
                   xTexelC${b} = getX(batch, xR, xCOffset, d1);
                   // Need to manually clear unused channels in case
                   // we're reading from recycled texture.
                   if (xCOffset + 1 >= inDims[1]) {
                     xTexelC${b}.zw = vec2(0.0);
                   }
                   xTexelC${b}Ready = 1;
                 }

                 if(xC + 1 >= 0 && xC + 1 < inDims[1] && xTexelC${b + 1}Ready == 0) {
                   xTexelC${b + 1} = getX(batch, xR, xC + 1, d1);
                   // Need to manually clear unused channels in case
                   // we're reading from recycled texture.
                   if (xC + 2 >= inDims[1]) {
                     xTexelC${b + 1}.zw = vec2(0.0);
                   }
                   xTexelC${b + 1}Ready = 1;
                 }

                 xC${b} = vec4(xTexelC${b}.zw, xTexelC${b + 1}.zw);
               `, b + 1 < u && (h += `
                   final = vec4(0.0);
                   xCOffset = xC + 1 + strides[1];
                   if(xCOffset >= 0 && xCOffset < inDims[1]) {
                     final = getX(batch, xR, xCOffset, d1);
                   }
                   xC${b + 1} = vec4(xTexelC${b + 1}.xy, final.xy);
                 `)) : (h += `
                 if(xC >= 0 && xC < inDims[1] && xTexelC${b}Ready == 0) {
                   xTexelC${b} = getX(batch, xR, xC, d1);
                   if (xC + 1 >= inDims[1]) {
                     xTexelC${b}.zw = vec2(0.0);
                   }
                   xTexelC${b}Ready = 1;
                 }

                 xCOffset = xC + strides[1];
                 if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${b + 1}Ready == 0) {
                   xTexelC${b + 1} = getX(batch, xR, xCOffset, d1);
                   if (xCOffset + 1 >= inDims[1]) {
                     xTexelC${b + 1}.zw = vec2(0.);
                   }
                   xTexelC${b + 1}Ready = 1;
                 }

                 xC${b} = vec4(
                   xTexelC${b}.xy, xTexelC${b + 1}.xy);
               `, b + 1 < u && (h += `
                   xC${b + 1} = vec4(xTexelC${b}.zw, xTexelC${b + 1}.zw);
                 `)));
            b < u && (h += `
             wTexel = getW(r, ${b}, d1, d2);
             dotProd += xC${b}.xxzz * vec4(wTexel.xy, wTexel.xy);
             if(d1 + 1 < ${t.inChannels}) {
               dotProd += xC${b}.yyww * vec4(wTexel.zw, wTexel.zw);
             }
           `, b + 1 < u && (h += `
               wTexel = getW(r, ${b + 1}, d1, d2);
               dotProd += xC${b + 1}.xxzz * vec4(wTexel.xy, wTexel.xy);
               if(d1 + 1 < ${t.inChannels}) {
                 dotProd += xC${b + 1}.yyww * vec4(wTexel.zw, wTexel.zw);
               }
             `));
        }
        h += `
     }
   `, h += `
     }
   `, h += `
     }
   `;
        let p = "", f = "";
        s && (o ? p = `vec4 activation(vec4 a) {
           vec4 b = getPreluActivationWeightsAtOutCoords();
           ${s}
         }` : r ? p = `vec4 activation(vec4 a) {
           vec4 b = getLeakyreluAlphaAtOutCoords();
           ${s}
         }` : p = `vec4 activation(vec4 x) {
           ${s}
         }`, f = "result = activation(result);");
        const m = e ? "result += getBiasAtOutCoords();" : "";
        e && this.variableNames.push("bias"), o && this.variableNames.push("preluActivationWeights"), r && this.variableNames.push("leakyreluAlpha"), this.userCode = `
       ${p}

       void main() {
         ivec4 coords = getOutputCoords();
         int batch = coords.x;
         ivec2 xRCCorner = coords.yz * strides - pads;
         int d2 = coords.w;
         int xRCorner = xRCCorner.x;
         int xCCorner = xRCCorner.y;

         //intialize dotProd with a small epsilon seems to reduce GPU accuracy loss.
         vec4 dotProd = vec4(0.000000000000001);

         ${h}

         vec4 result = dotProd - vec4(0.000000000000001);
         ${m}
         ${f}
         setOutput(result);
       }
     `;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class iZ {
    constructor(t, e){
        this.variableNames = [
            "A"
        ], this.packedInputs = !0, this.packedOutput = !0, this.customUniforms = [
            {
                name: "inputShape",
                type: "ivec4"
            },
            {
                name: "pad",
                type: "ivec2"
            },
            {
                name: "stride",
                type: "ivec2"
            },
            {
                name: "dilation",
                type: "ivec2"
            },
            {
                name: "inChannels",
                type: "int"
            },
            {
                name: "itemsPerBlockRow",
                type: "int"
            },
            {
                name: "outWidth",
                type: "int"
            }
        ], this.outputShape = t, this.enableShapeUniforms = Me(this.outputShape.length);
        const { dataFormat: s } = e, o = Ae(), r = s === "channelsLast", i = r ? 1 : 2, a = r ? 2 : 3, l = this.enableShapeUniforms ? "if(blockIndex < outShape[2] && pos < outShape[1]) {" : `if(blockIndex < ${t[2]} && pos < ${t[1]}) {`;
        let c = "";
        for(let u = 0; u <= 1; u++)for(let d = 0; d <= 1; d++)c += `
          blockIndex = rc.z + ${d};
          pos = rc.y + ${u};

          ${l}
            offsetY = int(blockIndex / outWidth) * stride[0] - pad[0];
            d0 = offsetY + dilation[0] * (pos / itemsPerBlockRow);

            if(d0 < inputShape[${i}] && d0 >= 0) {
              // Use custom imod instead mod. On Intel GPU, mod may generate
              // unexpected value.
              // https://github.com/tensorflow/tfjs/issues/5447
              offsetX = imod(blockIndex, outWidth) * stride[1] - pad[1];
              d1 = offsetX + dilation[1] * (imod(pos, itemsPerBlockRow) /
                  inChannels);

              if(d1 < inputShape[${a}] && d1 >= 0) {

                ch = imod(pos, inChannels);

                if (${r}) {
                  innerDims = vec2(d1, ch);
                  result[${u * 2 + d}] = getChannel(
                    getA(rc.x, d0, int(innerDims.x),
                    int(innerDims.y)), innerDims);
                } else {
                  innerDims = vec2(d0, d1);
                  result[${u * 2 + d}] = getChannel(
                    getA(rc.x, ch, int(innerDims.x),
                    int(innerDims.y)), innerDims);
                }
              }
            }
          }
        `;
        this.userCode = `
      void main() {
        ivec3 rc = getOutputCoords();

        vec4 result = vec4(0);

        int blockIndex, pos, offsetY, d0, offsetX, d1, ch;
        vec2 innerDims;

        ${c}

        ${o.output} = result;
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Xl(n, t) {
    const e = n.length;
    return e >= 3 ? t ? [
        ...n.slice(0, -3),
        n[e - 3] * n[e - 2],
        n[e - 1]
    ] : [
        ...n.slice(0, -3),
        n[e - 3],
        n[e - 2] * n[e - 1]
    ] : !t && e === 1 && n[0] > 1 ? [
        n[0],
        1
    ] : null;
}
function rC({ x: n, filter: t, convInfo: e, backend: s, bias: o = null, preluActivationWeights: r = null, leakyreluAlpha: i = 0, activation: a = null }) {
    const l = n.shape, c = s.texData.get(n.dataId), u = e.inChannels, d = l[0] * l[1] * l[2], h = e.outChannels, p = e.dataFormat === "channelsLast", f = !1, m = !1;
    let g;
    const b = [];
    if (r != null) {
        const y = Xl(r.shape, p);
        y != null && (r = et({
            inputs: {
                x: r
            },
            backend: s,
            attrs: {
                shape: y
            }
        }), b.push(r));
    }
    if (o != null) {
        const y = Xl(o.shape, p);
        y != null && (o = et({
            inputs: {
                x: o
            },
            backend: s,
            attrs: {
                shape: y
            }
        }), b.push(o));
    }
    if (!((d === 1 || h === 1) && u > JI) && c.isPacked && p && c.texture != null && l[2] % 2 !== 0 && $t(c.shape.slice(-3), l.slice(-3))) {
        const y = l[0] * l[1] * (l[2] + 1), I = {
            dataId: n.dataId,
            shape: [
                1,
                y,
                e.inChannels
            ],
            dtype: n.dtype
        }, v = c.shape;
        c.shape = c.shape.slice(), c.shape[c.shape.length - 2]++, C(xi(c.shape, I.shape), ()=>`packed reshape ${c.shape} to ${I.shape} isn't free`);
        const k = et({
            inputs: {
                x: t
            },
            backend: s,
            attrs: {
                shape: [
                    1,
                    e.inChannels,
                    e.outChannels
                ]
            }
        });
        b.push(k);
        const S = Ol({
            a: I,
            b: k,
            backend: s,
            transposeA: f,
            transposeB: m,
            bias: o,
            activation: a,
            preluActivationWeights: r,
            leakyreluAlpha: i
        }), N = s.texData.get(S.dataId);
        C(N.isPacked, ()=>"batchMatMul result is expected to be packed"), c.shape = v, N.shape = e.outShape, g = nn({
            inputs: {
                x: S
            },
            backend: s
        }), g.shape = e.outShape, b.push(S);
    } else {
        const y = e.outHeight * e.outWidth, I = et({
            inputs: {
                x: n
            },
            backend: s,
            attrs: {
                shape: p ? [
                    e.batchSize,
                    y,
                    e.inChannels
                ] : [
                    e.batchSize,
                    e.inChannels,
                    y
                ]
            }
        }), v = et({
            inputs: {
                x: t
            },
            backend: s,
            attrs: {
                shape: [
                    1,
                    e.inChannels,
                    e.outChannels
                ]
            }
        }), k = Ol({
            a: p ? I : v,
            b: p ? v : I,
            transposeA: !p,
            transposeB: m,
            backend: s,
            bias: o,
            activation: a,
            preluActivationWeights: r,
            leakyreluAlpha: i
        });
        g = et({
            inputs: {
                x: k
            },
            backend: s,
            attrs: {
                shape: e.outShape
            }
        }), b.push(I), b.push(v), b.push(k);
    }
    for (const y of b)s.disposeIntermediateTensorInfo(y);
    return g;
}
function iC({ x: n, filter: t, convInfo: e, backend: s, bias: o = null, preluActivationWeights: r = null, leakyreluAlpha: i = 0, activation: a = null }) {
    const { filterWidth: l, filterHeight: c, inChannels: u, outWidth: d, outHeight: h, dataFormat: p } = e, f = p === "channelsLast", m = l * c * u, g = h * d, b = [
        e.batchSize,
        m,
        g
    ], x = !0, w = !1, y = [];
    if (r != null) {
        const Z = Xl(r.shape, f);
        Z != null && (r = et({
            inputs: {
                x: r
            },
            backend: s,
            attrs: {
                shape: Z
            }
        }), y.push(r));
    }
    if (o != null) {
        const Z = Xl(o.shape, f);
        Z != null && (o = et({
            inputs: {
                x: o
            },
            backend: s,
            attrs: {
                shape: Z
            }
        }), y.push(o));
    }
    const I = et({
        inputs: {
            x: t
        },
        backend: s,
        attrs: {
            shape: [
                1,
                m,
                X(t.shape) / m
            ]
        }
    });
    y.push(I);
    const v = new iZ(b, e), k = [
        n.shape,
        [
            e.padInfo.top,
            e.padInfo.left
        ],
        [
            e.strideHeight,
            e.strideWidth
        ],
        [
            e.dilationHeight,
            e.dilationWidth
        ],
        [
            e.inChannels
        ],
        [
            e.filterWidth * e.inChannels
        ],
        [
            e.outWidth
        ]
    ], S = s.runWebGLProgram(v, [
        n
    ], "float32", k), N = et({
        inputs: {
            x: S
        },
        backend: s,
        attrs: {
            shape: b
        }
    });
    y.push(S), y.push(N);
    const R = o != null, M = r != null, V = a === "leakyrelu", z = a ? yi(a, !0) : null, P = new QI(f ? N.shape : I.shape, f ? I.shape : N.shape, f ? [
        e.batchSize,
        g,
        e.outChannels
    ] : [
        e.batchSize,
        e.outChannels,
        g
    ], x, w, R, z, M, V), A = f ? [
        N,
        I
    ] : [
        I,
        N
    ];
    if (o && A.push(o), M && A.push(r), V) {
        const Z = s.makeTensorInfo([], "float32", Is(i, "float32"));
        A.push(Z), y.push(Z);
    }
    const O = s.runWebGLProgram(P, A, "float32"), B = et({
        inputs: {
            x: O
        },
        backend: s,
        attrs: {
            shape: e.outShape
        }
    });
    y.push(O);
    for (const Z of y)s.disposeIntermediateTensorInfo(Z);
    return B;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function aZ(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, filter: r } = t, { strides: i, pad: a, dataFormat: l, dilations: c, dimRoundingMode: u } = s, d = Ss(l), h = Te(o.shape, r.shape, i, c, a, u, !1, d);
    let p;
    if (h.filterHeight === 1 && h.filterWidth === 1 && h.dilationHeight === 1 && h.dilationWidth === 1 && h.strideHeight === 1 && h.strideWidth === 1 && (h.padInfo.type === "SAME" || h.padInfo.type === "VALID")) p = rC({
        x: o,
        filter: r,
        convInfo: h,
        backend: e
    });
    else if (h.strideWidth <= 2 && d === "channelsLast" && F().getBool("WEBGL_EXP_CONV")) {
        const m = new oC(h), g = [
            [
                h.padInfo.top,
                h.padInfo.left
            ],
            [
                h.strideHeight,
                h.strideWidth
            ],
            [
                h.dilationHeight,
                h.dilationWidth
            ],
            [
                h.inHeight,
                h.inWidth
            ]
        ];
        p = e.runWebGLProgram(m, [
            o,
            r
        ], "float32", g);
    } else if (F().getBool("WEBGL_CONV_IM2COL")) p = iC({
        x: o,
        filter: r,
        convInfo: h,
        backend: e
    });
    else {
        const m = new sC(h);
        p = e.runWebGLProgram(m, [
            o,
            r
        ], "float32");
    }
    const f = et({
        inputs: {
            x: p
        },
        backend: e,
        attrs: {
            shape: h.outShape
        }
    });
    return e.disposeIntermediateTensorInfo(p), f;
}
const lZ = {
    kernelName: sc,
    backendName: "webgl",
    kernelFunc: aZ
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class cZ {
    constructor(t){
        this.variableNames = [
            "x",
            "dy"
        ], this.outputShape = t.filterShape;
        const e = t.strideHeight, s = t.strideWidth, o = t.padInfo.top, r = t.padInfo.left, i = t.dataFormat === "channelsLast";
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int wR = coords.x;
        int wC = coords.y;
        int d1 = coords.z;
        int d2 = coords.w;

        // Convolve x(?, ?, d1) with dy(:, :, d2) to get dw(wR, wC, d1, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int b = 0; b < ${t.batchSize}; b++) {
          for (int yR = 0; yR < ${t.outHeight}; yR++) {
            int xR = wR + yR * ${e} - ${o};

            if (xR < 0 || xR >= ${t.inHeight}) {
              continue;
            }

            for (int yC = 0; yC < ${t.outWidth}; yC++) {
              int xC = wC + yC * ${s} - ${r};

              if (xC < 0 || xC >= ${t.inWidth}) {
                continue;
              }

              ${i ? `float dyValue = getDy(b, yR, yC, d2);
              float xValue = getX(b, xR, xC, d1);
              dotProd += (xValue * dyValue);` : `float dyValue = getDy(b, d2, yR, yC);
              float xValue = getX(b, d1, xR, xC);
              dotProd += (xValue * dyValue);`}
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class uZ {
    constructor(t){
        this.variableNames = [
            "dy",
            "W"
        ], this.outputShape = t.inShape;
        const e = t.filterHeight, s = t.filterWidth, o = t.strideHeight, r = t.strideWidth, i = t.dataFormat === "channelsLast", a = e - 1 - t.padInfo.top, l = s - 1 - t.padInfo.left, c = i ? 1 : 2, u = i ? 2 : 3, d = i ? 3 : 1;
        this.userCode = `
      const ivec2 pads = ivec2(${a}, ${l});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d1 = coords[${d}];

        ivec2 dyCorner = ivec2(coords[${c}], coords[${u}]) - pads;
        int dyRCorner = dyCorner.x;
        int dyCCorner = dyCorner.y;

        // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${e}; wR++) {
          float dyR = float(dyRCorner + wR) / ${o}.0;

          if (dyR < 0.0 || dyR >= ${t.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          int wRPerm = ${e} - 1 - wR;

          for (int wC = 0; wC < ${s}; wC++) {
            float dyC = float(dyCCorner + wC) / ${r}.0;

            if (dyC < 0.0 || dyC >= ${t.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            int wCPerm = ${s} - 1 - wC;

            for (int d2 = 0; d2 < ${t.outChannels}; d2++) {

              if (${i}) {
                float xValue = getDy(batch, idyR, idyC, d2);
                float wValue = getW(wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              } else {
                float xValue = getDy(batch, d2, idyR, idyC);
                float wValue = getW(wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              }

            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class dZ {
    constructor(t){
        this.variableNames = [
            "x",
            "dy"
        ], this.outputShape = t.filterShape;
        const e = t.strideDepth, s = t.strideHeight, o = t.strideWidth, r = t.padInfo.front, i = t.padInfo.top, a = t.padInfo.left;
        this.userCode = `
      void main() {
        ivec5 coords = getOutputCoords();
        int wF = coords.x;
        int wR = coords.y;
        int wC = coords.z;
        int d1 = coords.w;
        int d2 = coords.u;

        float dotProd = 0.0;

        for (int b = 0; b < ${t.batchSize}; b++) {
          for (int yF = 0; yF < ${t.outDepth}; yF++) {
            int xF = wF + yF * ${e} - ${r};

            if (xF < 0 || xF >= ${t.inDepth}) {
              continue;
            }

            for (int yR = 0; yR < ${t.outHeight}; yR++) {
              int xR = wR + yR * ${s} - ${i};

              if (xR < 0 || xR >= ${t.inHeight}) {
                continue;
              }

              for (int yC = 0; yC < ${t.outWidth}; yC++) {
                int xC = wC + yC * ${o} - ${a};

                if (xC < 0 || xC >= ${t.inWidth}) {
                  continue;
                }

                float dyValue = getDy(b, yF, yR, yC, d2);
                float xValue = getX(b, xF, xR, xC, d1);
                dotProd += (xValue * dyValue);
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class hZ {
    constructor(t){
        this.variableNames = [
            "dy",
            "W"
        ], this.outputShape = t.inShape;
        const e = t.filterDepth, s = t.filterHeight, o = t.filterWidth, r = t.strideDepth, i = t.strideHeight, a = t.strideWidth, l = e - 1 - t.padInfo.front, c = s - 1 - t.padInfo.top, u = o - 1 - t.padInfo.left;
        this.userCode = `
      const ivec3 pads = ivec3(${l}, ${c}, ${u});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int d1 = coords.u;


        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyFCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        float dotProd = 0.0;
        for (int wF = 0; wF < ${e}; wF++) {
          float dyF = float(dyFCorner + wF) / ${r}.0;

          if (dyF < 0.0 || dyF >= ${t.outDepth}.0 || fract(dyF) > 0.0) {
            continue;
          }
          int idyF = int(dyF);

          int wFPerm = ${e} - 1 - wF;

          for (int wR = 0; wR < ${s}; wR++) {
            float dyR = float(dyRCorner + wR) / ${i}.0;

            if (dyR < 0.0 || dyR >= ${t.outHeight}.0 ||
              fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            int wRPerm = ${s} - 1 - wR;

            for (int wC = 0; wC < ${o}; wC++) {
              float dyC = float(dyCCorner + wC) / ${a}.0;

              if (dyC < 0.0 || dyC >= ${t.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              int wCPerm = ${o} - 1 - wC;

              for (int d2 = 0; d2 < ${t.outChannels}; d2++) {
                float xValue = getDy(batch, idyF, idyR, idyC, d2);
                float wValue = getW(wFPerm, wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function pZ(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, dy: r } = t, { strides: i, pad: a, dataFormat: l, dimRoundingMode: c, filterShape: u } = s, d = Ss(l), h = Te(o.shape, u, i, 1, a, c, !1, d), p = new cZ(h);
    return e.runWebGLProgram(p, [
        o,
        r
    ], "float32");
}
const fZ = {
    kernelName: ah,
    backendName: "webgl",
    kernelFunc: pZ
};
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class mZ {
    constructor(t){
        this.variableNames = [
            "dy",
            "W"
        ], this.packedInputs = !0, this.packedOutput = !0, this.customUniforms = [
            {
                name: "strides",
                type: "vec2"
            }
        ], this.outputShape = t.inShape, this.enableShapeUniforms = Me(this.outputShape.length);
        const e = t.filterHeight, s = t.filterWidth, o = e - 1 - t.padInfo.top, r = s - 1 - t.padInfo.left;
        this.userCode = `
      const ivec2 pads = ivec2(${o}, ${r});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d1 = coords[3];

        ivec2 dyCorner = ivec2(coords[1], coords[2]) - pads;
        int dyRCorner = dyCorner.x;
        int dyCCorner = dyCorner.y;

        vec4 result = vec4(0.);
        for (int wR = 0; wR < ${e}; wR++) {
          float dyR = float(dyRCorner + wR) / strides[0];
          if (dyR < 0.0 || dyR >= ${t.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);
          int wRPerm = ${e} - 1 - wR;

          for (int wC = 0; wC < ${s}; wC++) {
            int wCPerm = ${s} - 1 - wC;

            float dyC = float(dyCCorner + wC) / strides[1];
            bool idyCVal = (dyC >= 0.0) && (dyC < ${t.outWidth}.0)
              && (fract(dyC) == 0.0);
            int idyC = int(dyC);

            float dyC2 = float(dyCCorner + wC + 1) / strides[1];
            bool idyCVal2 = (dyC2 >= 0.0) && (dyC2 < ${t.outWidth}.0)
              && (fract(dyC2) == 0.0);
            int idyC2 = int(dyC2);

            if (idyCVal && idyCVal2) {
              for (int d2 = 0; d2 < ${t.outChannels}; d2 += 2) {
                vec4 wValue = getW(wRPerm, wCPerm, d1, d2);
                vec4 dySample = getDy(batch, idyR, idyC, d2);
                vec4 dySample2 = (idyC / 2 == idyC2 / 2) ?
                  dySample : getDy(batch, idyR, idyC2, d2);

                vec2 dyValue = mod(float(idyC), 2.) == 0. ?
                  dySample.xy : dySample.zw;
                result.xy += vec2(dot(dyValue, wValue.xy),
                  dot(dyValue, wValue.zw));

                dyValue = mod(float(idyC2), 2.) == 0. ?
                  dySample2.xy : dySample2.zw;
                result.zw += vec2(dot(dyValue, wValue.xy),
                  dot(dyValue, wValue.zw));
              }
            } else if (idyCVal) {
              for (int d2 = 0; d2 < ${t.outChannels}; d2 += 2) {
                vec4 wValue = getW(wRPerm, wCPerm, d1, d2);
                vec4 dySample = getDy(batch, idyR, idyC, d2);
                vec2 dyValue = mod(float(idyC), 2.) == 0. ?
                  dySample.xy : dySample.zw;
                result.xy += vec2(dot(dyValue, wValue.xy),
                  dot(dyValue, wValue.zw));
              }
            } else if (idyCVal2) {
              for (int d2 = 0; d2 < ${t.outChannels}; d2 += 2) {
                vec4 wValue = getW(wRPerm, wCPerm, d1, d2);
                vec4 dySample = getDy(batch, idyR, idyC2, d2);
                vec2 dyValue = mod(float(idyC2), 2.) == 0. ?
                  dySample.xy : dySample.zw;
                result.zw += vec2(dot(dyValue, wValue.xy),
                  dot(dyValue, wValue.zw));
              }
            }
          }
        }
        setOutput(result);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function gZ(n) {
    const { inputs: t, backend: e, attrs: s } = n, { dy: o, filter: r } = t, { inputShape: i, strides: a, pad: l, dataFormat: c, dimRoundingMode: u } = s, d = Ss(c), h = Te(i, r.shape, a, 1, l, u, !1, d);
    if (F().getBool("WEBGL_PACK_CONV2DTRANSPOSE") && d === "channelsLast") {
        const p = [
            [
                h.strideHeight,
                h.strideWidth
            ]
        ], f = new mZ(h);
        return e.runWebGLProgram(f, [
            o,
            r
        ], "float32", p);
    } else {
        const p = new uZ(h);
        return e.runWebGLProgram(p, [
            o,
            r
        ], "float32");
    }
}
const bZ = {
    kernelName: oc,
    backendName: "webgl",
    kernelFunc: gZ
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function xZ(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, filter: r } = t, { strides: i, pad: a, dilations: l } = s, c = Js(o.shape, r.shape, i, l, a), u = new rZ(c);
    return e.runWebGLProgram(u, [
        o,
        r
    ], "float32");
}
const yZ = {
    kernelName: rc,
    backendName: "webgl",
    kernelFunc: xZ
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function wZ(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, dy: r } = t, { strides: i, pad: a, filterShape: l } = s, c = Js(o.shape, l, i, 1, a), u = new dZ(c);
    return e.runWebGLProgram(u, [
        o,
        r
    ], "float32");
}
const IZ = {
    kernelName: lh,
    backendName: "webgl",
    kernelFunc: wZ
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function CZ(n) {
    const { inputs: t, backend: e, attrs: s } = n, { dy: o, filter: r } = t, { pad: i, strides: a, inputShape: l } = s, c = Js(l, r.shape, a, 1, i), u = new hZ(c);
    return e.runWebGLProgram(u, [
        o,
        r
    ], "float32");
}
const vZ = {
    kernelName: ch,
    backendName: "webgl",
    kernelFunc: CZ
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const SZ = Vr + `
  return cos(x);
`, kZ = `
  vec4 result = cos(x);
  bvec4 isNaN = isnan(x);
  ${jo}
  return result;
`, TZ = Nt({
    opSnippet: SZ,
    packedOpSnippet: kZ
}), NZ = {
    kernelName: Mi,
    backendName: "webgl",
    kernelFunc: TZ
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const RZ = `
  float e2x = exp(-x);
  return (e2x + 1.0 / e2x) / 2.0;
`, $Z = Nt({
    opSnippet: RZ
}), GZ = {
    kernelName: Wi,
    backendName: "webgl",
    kernelFunc: $Z
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class EZ {
    constructor(t, e, s, o, r){
        this.variableNames = [
            "Image",
            "Boxes",
            "BoxInd"
        ], this.outputShape = [];
        const [i, a, l, c] = t, [u] = e, [d, h] = s;
        this.outputShape = [
            u,
            d,
            h,
            c
        ];
        const p = o === "bilinear" ? 1 : 0, [f, m] = [
            `${a - 1}.0`,
            `${l - 1}.0`
        ], [g, b, x] = d > 1 ? [
            `${(a - 1) / (d - 1)}`,
            "(y2-y1) * height_ratio",
            `y1*${f} + float(y)*(height_scale)`
        ] : [
            "0.0",
            "0.0",
            `0.5 * (y1+y2) * ${f}`
        ], [w, y, I] = h > 1 ? [
            `${(l - 1) / (h - 1)}`,
            "(x2-x1) * width_ratio",
            `x1*${m} + float(x)*(width_scale)`
        ] : [
            "0.0",
            "0.0",
            `0.5 * (x1+x2) * ${m}`
        ];
        this.userCode = `
      const float height_ratio = float(${g});
      const float width_ratio = float(${w});
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int y = coords[1];
        int x = coords[2];
        int d = coords[3];

        // get box vals
        float y1 = getBoxes(b,0);
        float x1 = getBoxes(b,1);
        float y2 = getBoxes(b,2);
        float x2 = getBoxes(b,3);

        // get image in batch index
        int bInd = round(getBoxInd(b));
        if(bInd < 0 || bInd >= ${i}) {
          return;
        }

        float height_scale = ${b};
        float width_scale = ${y};

        float in_y = ${x};
        if( in_y < 0.0 || in_y > ${f} ) {
          setOutput(float(${r}));
          return;
        }
        float in_x = ${I};
        if( in_x < 0.0 || in_x > ${m} ) {
          setOutput(float(${r}));
          return;
        }

        vec2 sourceFracIndexCR = vec2(in_x,in_y);
        if(${p} == 1) {
          // Compute the four integer indices.
          ivec2 sourceFloorCR = ivec2(sourceFracIndexCR);
          ivec2 sourceCeilCR = ivec2(ceil(sourceFracIndexCR));

          float topLeft = getImage(b, sourceFloorCR.y, sourceFloorCR.x, d);
          float bottomLeft = getImage(b, sourceCeilCR.y, sourceFloorCR.x, d);
          float topRight = getImage(b, sourceFloorCR.y, sourceCeilCR.x, d);
          float bottomRight = getImage(b, sourceCeilCR.y, sourceCeilCR.x, d);

          vec2 fracCR = sourceFracIndexCR - vec2(sourceFloorCR);

          float top = topLeft + (topRight - topLeft) * fracCR.x;
          float bottom = bottomLeft + (bottomRight - bottomLeft) * fracCR.x;
          float newValue = top + (bottom - top) * fracCR.y;
          setOutput(newValue);
        } else {
          // Compute the coordinators of nearest neighbor point.
          ivec2 sourceNearestCR = ivec2(floor(
            sourceFracIndexCR + vec2(0.5,0.5)));
          float newValue = getImage(b, sourceNearestCR.y, sourceNearestCR.x, d);
          setOutput(newValue);
        }
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const LZ = (n)=>{
    const { inputs: t, backend: e, attrs: s } = n, { image: o, boxes: r, boxInd: i } = t, { cropSize: a, method: l, extrapolationValue: c } = s, u = new EZ(o.shape, r.shape, a, l, c);
    return e.runWebGLProgram(u, [
        o,
        r,
        i
    ], "float32");
}, MZ = {
    kernelName: dh,
    backendName: "webgl",
    kernelFunc: LZ
};
var Ii;
(function(n) {
    n.Prod = "*", n.Sum = "+";
})(Ii || (Ii = {}));
class Mg {
    constructor(t, e, s, o){
        this.op = t, this.outputShape = e, this.variableNames = [
            "x"
        ], this.customUniforms = [
            {
                name: "index",
                type: "float"
            }
        ];
        const r = this.outputShape.length, i = this.op === Ii.Prod ? "1.0" : "0.0", a = s ? i : `getX(${Wg(r, "coords", this.op)})`, l = this.outputShape[this.outputShape.length - 1];
        let c = "", u = "";
        s ? (c = o ? `end != ${l - 1}` : "end != 0", u = o ? "end + 1" : "end - 1") : (c = o ? `end + pow2 < ${l}` : "end >= pow2", u = o ? "end + pow2" : "end - pow2"), this.userCode = `
      void main() {
        ${Vt(r)} coords = getOutputCoords();
        int end = ${Dg(r, "coords", this.op)};
        float val = ${a};
        int pow2 = int(pow(2.0, index));
        if (${c}) {
          int idx = ${u};
          ${Dg(r, "coords", this.op)} = idx;
          val ${this.op}= getX(${Wg(r, "coords", this.op)});
        }
        setOutput(val);
      }
    `;
    }
}
function Wg(n, t, e) {
    if (n === 1) return `${t}`;
    if (n === 2) return `${t}.x, ${t}.y`;
    if (n === 3) return `${t}.x, ${t}.y, ${t}.z`;
    if (n === 4) return `${t}.x, ${t}.y, ${t}.z, ${t}.w`;
    throw new Error(`Cumulative ${e} for rank ${n} is not yet supported`);
}
function Dg(n, t, e) {
    if (n === 1) return `${t}`;
    if (n === 2) return `${t}.y`;
    if (n === 3) return `${t}.z`;
    if (n === 4) return `${t}.w`;
    throw new Error(`Cumulative ${e} for rank ${n} is not yet supported`);
}
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function aC(n, t, e, s, o, r) {
    const i = t.shape.length, a = qt([
        s
    ], i);
    let l = t;
    a != null && (l = ze({
        inputs: {
            x: t
        },
        backend: e,
        attrs: {
            perm: a
        }
    }));
    const c = ie(1, i)[0];
    if (c !== i - 1) throw new Error(`WebGL cumprod shader expects an inner-most axis=${t.shape.length - 1} but got axis=${s}`);
    const u = l.shape[c];
    let d = nn({
        inputs: {
            x: l
        },
        backend: e
    });
    for(let h = 0; h <= Math.ceil(Math.log2(u)) - 1; h++){
        const p = new Mg(n, l.shape, !1, r), f = [
            [
                h
            ]
        ], m = d;
        d = e.runWebGLProgram(p, [
            d
        ], d.dtype, f), e.disposeIntermediateTensorInfo(m);
    }
    if (o) {
        const h = new Mg(n, l.shape, o, r), p = d;
        d = e.runWebGLProgram(h, [
            d
        ], d.dtype), e.disposeIntermediateTensorInfo(p);
    }
    if (a != null) {
        const h = js(a), p = ze({
            inputs: {
                x: d
            },
            backend: e,
            attrs: {
                perm: h
            }
        });
        return e.disposeIntermediateTensorInfo(d), e.disposeIntermediateTensorInfo(l), p;
    }
    return d;
}
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function WZ(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r, exclusive: i, reverse: a } = s;
    return aC(Ii.Prod, o, e, r, i, a);
}
const DZ = {
    kernelName: uh,
    backendName: "webgl",
    kernelFunc: WZ
};
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function FZ(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r, exclusive: i, reverse: a } = s;
    return aC(Ii.Sum, o, e, r, i, a);
}
const VZ = {
    kernelName: ic,
    backendName: "webgl",
    kernelFunc: FZ
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function zZ(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, weights: r } = t, { size: i, binaryOutput: a } = s;
    if (o.shape.length === 1) {
        const l = e.readSync(o.dataId), c = e.readSync(r.dataId), u = OI(l, c, r.dtype, r.shape, i);
        return e.makeTensorInfo([
            i
        ], r.dtype, u);
    } else if (o.shape.length === 2) {
        const l = e.bufferSync(o), c = e.bufferSync(r), u = OA(l, c, i, a);
        return e.makeTensorInfo(u.shape, r.dtype, u.values);
    }
    throw new Error(`Error in denseBincount: input must be at most rank 2, but got rank${o.shape.length}.`);
}
const PZ = {
    kernelName: hh,
    backendName: "webgl",
    kernelFunc: zZ
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class AZ {
    constructor(t, e, s){
        this.variableNames = [
            "x"
        ], this.outputShape = [], this.outputShape = t, this.blockSize = e, this.dataFormat = s, this.userCode = `
    void main() {
      ivec4 coords = getOutputCoords();
      int b = coords[0];
      int h = ${this.getHeightCoordString()};
      int w = ${this.getWidthCoordString()};
      int d = ${this.getDepthCoordString()};

      int in_h = h / ${e};
      int offset_h = imod(h, ${e});
      int in_w = w / ${e};
      int offset_w = imod(w, ${e});
      int offset_d = (offset_h * ${e} + offset_w) *
        ${this.getOutputDepthSize()};
      int in_d = d + offset_d;

      float result = ${this.getInputSamplingString()};
      setOutput(result);
    }
  `;
    }
    getHeightCoordString() {
        return this.dataFormat === "NHWC" ? "coords[1]" : "coords[2]";
    }
    getWidthCoordString() {
        return this.dataFormat === "NHWC" ? "coords[2]" : "coords[3]";
    }
    getDepthCoordString() {
        return this.dataFormat === "NHWC" ? "coords[3]" : "coords[1]";
    }
    getOutputDepthSize() {
        return this.dataFormat === "NHWC" ? this.outputShape[3] : this.outputShape[1];
    }
    getInputSamplingString() {
        return this.dataFormat === "NHWC" ? "getX(b, in_h, in_w, in_d)" : "getX(b, in_d, in_h, in_w)";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function OZ(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { blockSize: r, dataFormat: i } = s, a = o.shape[0], l = i === "NHWC" ? o.shape[1] : o.shape[2], c = i === "NHWC" ? o.shape[2] : o.shape[3], u = i === "NHWC" ? o.shape[3] : o.shape[1], d = l * r, h = c * r, p = u / (r * r), f = i === "NHWC" ? [
        a,
        d,
        h,
        p
    ] : [
        a,
        p,
        d,
        h
    ], m = new AZ(f, r, i);
    return e.runWebGLProgram(m, [
        o
    ], o.dtype);
}
const XZ = {
    kernelName: ph,
    backendName: "webgl",
    kernelFunc: OZ
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class lC {
    constructor(t, e = !1, s = null, o = !1, r = !1){
        this.variableNames = [
            "x",
            "W"
        ], this.customUniforms = [
            {
                name: "pads",
                type: "ivec2"
            },
            {
                name: "strides",
                type: "ivec2"
            },
            {
                name: "dilations",
                type: "ivec2"
            },
            {
                name: "inDims",
                type: "ivec2"
            }
        ], this.outputShape = t.outShape, this.enableShapeUniforms = Me(this.outputShape.length);
        const i = t.filterHeight, a = t.filterWidth, l = t.outChannels / t.inChannels;
        let c = "", u = "";
        s && (o ? c = `float activation(float a) {
          float b = getPreluActivationWeightsAtOutCoords();
          ${s}
        }` : r ? c = `float activation(float a) {
          float b = getLeakyreluAlphaAtOutCoords();
          ${s}
        }` : c = `
          float activation(float x) {
            ${s}
          }
        `, u = "result = activation(result);");
        const d = e ? "result += getBiasAtOutCoords();" : "";
        e && this.variableNames.push("bias"), o && this.variableNames.push("preluActivationWeights"), r && this.variableNames.push("leakyreluAlpha"), this.userCode = `
      ${c}

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        ivec2 xRCCorner = coords.yz * strides - pads;
        int d2 = coords.w;
        int d1 = d2 / ${l};
        int q = d2 - d1 * ${l};

        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // Convolve x(?, ?, d1) with w(:, :, d1, q) to get y(yR, yC, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        // TO DO(dsmilkov): Flatten the two for loops and vec4 the operations.
        for (int wR = 0; wR < ${i}; wR++) {
          int xR = xRCorner + wR * dilations[0];

          if (xR < 0 || xR >= inDims[0]) {
            continue;
          }

          for (int wC = 0; wC < ${a}; wC++) {
            int xC = xCCorner + wC * dilations[1];

            if (xC < 0 || xC >= inDims[1]) {
              continue;
            }

            float xVal = getX(batch, xR, xC, d1);
            float wVal = getW(wR, wC, d1, q);
            dotProd += xVal * wVal;
          }
        }

        float result = dotProd;
        ${d}
        ${u}
        setOutput(result);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class cC {
    constructor(t, e = !1, s = null, o = !1, r = !1){
        this.variableNames = [
            "x",
            "W"
        ], this.packedInputs = !0, this.packedOutput = !0, this.customUniforms = [
            {
                name: "pads",
                type: "ivec2"
            },
            {
                name: "strides",
                type: "ivec2"
            },
            {
                name: "dilations",
                type: "ivec2"
            },
            {
                name: "inDims",
                type: "ivec2"
            }
        ], this.outputShape = t.outShape, this.enableShapeUniforms = Me(this.outputShape.length);
        const i = t.outChannels / t.inChannels, a = t.padInfo.left, l = t.strideWidth, c = t.dilationWidth, u = t.filterHeight, d = t.filterWidth, h = d;
        let p = `
      int xR; int xC; int xCOffset;
      vec4 wTexel; vec4 previous; vec4 final;`;
        for(let b = 0; b < d; b++)p += `
          vec4 xTexelC${b * 2};
          int xTexelC${b * 2}Ready;
          vec4 xTexelC${b * 2 + 1};
          int xTexelC${b * 2 + 1}Ready;
          vec4 xC${b};`;
        p += `
    for (int r = 0; r < ${u}; r++) {
      `;
        for(let b = 0; b < d; b++)p += `
          xTexelC${b * 2} = vec4(0.0);
          xTexelC${b * 2}Ready = 0;
          xTexelC${b * 2 + 1} = vec4(0.0);
          xTexelC${b * 2 + 1}Ready = 0;
          xC${b} = vec4(0.0);`;
        p += `
        xR = xRCorner + r * dilations[0];
        if (xR >=0 && xR < inDims[0]) {
      `;
        for(let b = 0; b < (h + 1) / 2; b++){
            const x = b * 2;
            if (p += `
          xC = xCCorner + ${x * c};
          `, l === 1) {
                if (x < d && (a % 2 === 1 ? (p += `
                xCOffset = xC + 1;
                if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${x}Ready == 0) {
                  xTexelC${x} = getX(batch, xR, xCOffset, d1);

                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${x}.zw = vec2(0.0);
                  }
                  xTexelC${x}Ready = 1;
                }
              `, c === 1 && x > 0 ? p += `
                xC${x} = vec4(xTexelC${x - 2}.zw, xTexelC${x}.xy);
                ` : p += `
                  xCOffset = xC + 1 - 2;

                  if (xCOffset >= 0 && xCOffset < inDims[1]) {
                    previous = getX(batch, xR, xCOffset, d1);

                    // Need to manually clear unused channels in case
                    // we're reading from recycled texture.
                    if (xCOffset + 1 >= inDims[1]) {
                      previous.zw = vec2(0.0);
                    }

                    xC${x} = vec4(previous.zw, xTexelC${x}.xy);
                  } else {
                    xC${x} = vec4(0.0, 0.0, xTexelC${x}.xy);
                  }
                  `) : p += `
                if (xC >= 0 && xC < inDims[1] && xTexelC${x}Ready == 0) {
                  xTexelC${x} = getX(batch, xR, xC, d1);
                  if (xC + 1 >= inDims[1]) {
                    xTexelC${x}.zw = vec2(0.0);
                  }
                  xTexelC${x}Ready = 1;
                }

                xC${x} = xTexelC${x};
                `, x + 1 < d)) {
                    const w = a % 2 === 0 ? Bl(c) : c;
                    c % 2 === 0 && a % 2 === 1 || c % 2 !== 0 && a % 2 !== 1 ? (p += `
                  xCOffset = xC + imod(pads[1], 2) + ${w};

                  if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${x + 1}Ready == 0) {
                    xTexelC${x + 1} = getX(batch, xR, xCOffset, d1);

                    // Need to manually clear unused channels in case
                    // we're reading from recycled texture.
                    if (xCOffset + 1 >= inDims[1]) {
                      xTexelC${x + 1}.zw = vec2(0.0);
                    }
                    xTexelC${x + 1}Ready = 1;
                  }
                  `, c > 1 ? p += `
                    xCOffset -= 2;
                    if (xCOffset >= 0 && xCOffset < inDims[1]) {
                     previous = getX(batch, xR, xCOffset, d1);
                     xC${x + 1} = vec4(previous.zw, xTexelC${x + 1}.xy);
                    } else {
                     xC${x + 1} = vec4(0.0, 0.0, xTexelC${x + 1}.xy);
                    }
                    ` : p += `
                    xC${x + 1} = vec4(xTexelC${x}.zw, xTexelC${x + 1}.xy);
                    `) : w === 1 ? p += `
                    xC${x + 1} = xTexelC${x};
                    ` : p += `
                    xCOffset = xC + ${w};

                    if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${x + 1}Ready == 0) {
                      xTexelC${x + 1} = getX(batch, xR, xCOffset, d1);
                      if (xCOffset + 1 >= inDims[1]) {
                        xTexelC${x + 1}.zw = vec2(0.0);
                      }
                      xTexelC${x + 1}Ready = 1;
                    }

                    xC${x + 1} = xTexelC${x + 1};
                    `;
                }
            } else x < d && (a % 2 === 1 ? (p += `
                xCOffset = xC + 1 - strides[1];
                if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${x}Ready == 0) {
                  xTexelC${x} = getX(batch, xR, xCOffset, d1);
                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${x}.zw = vec2(0.0);
                  }
                  xTexelC${x}Ready = 1;
                }

                if(xC + 1 >= 0 && xC + 1 < inDims[1] && xTexelC${x + 1}Ready == 0) {
                  xTexelC${x + 1} = getX(batch, xR, xC + 1, d1);
                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xC + 2 >= inDims[1]) {
                    xTexelC${x + 1}.zw = vec2(0.0);
                  }
                  xTexelC${x + 1}Ready = 1;
                }

                xC${x} = vec4(xTexelC${x}.zw, xTexelC${x + 1}.zw);
              `, x + 1 < d && (p += `
                  final = vec4(0.0);
                  xCOffset = xC + 1 + strides[1];
                  if(xCOffset >= 0 && xCOffset < inDims[1]) {
                    final = getX(batch, xR, xCOffset, d1);
                  }
                  xC${x + 1} = vec4(xTexelC${x + 1}.xy, final.xy);
                `)) : (p += `
                if(xC >= 0 && xC < inDims[1] && xTexelC${x}Ready == 0) {
                  xTexelC${x} = getX(batch, xR, xC, d1);
                  if (xC + 1 >= inDims[1]) {
                    xTexelC${x}.zw = vec2(0.0);
                  }
                  xTexelC${x}Ready = 1;
                }

                xCOffset = xC + strides[1];
                if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${x + 1}Ready == 0) {
                  xTexelC${x + 1} = getX(batch, xR, xCOffset, d1);
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${x + 1}.zw = vec2(0.);
                  }
                  xTexelC${x + 1}Ready = 1;
                }

                xC${x} = vec4(
                  xTexelC${x}.xy, xTexelC${x + 1}.xy);
              `, x + 1 < d && (p += `
                  xC${x + 1} = vec4(xTexelC${x}.zw, xTexelC${x + 1}.zw);
                `)));
            x < d && (p += `
            wTexel = getW(r, ${x}, d1, q);
            dotProd += xC${x} * vec4(wTexel.xz, wTexel.xz);
          `, x + 1 < d && (p += `
              wTexel = getW(r, ${x + 1}, d1, q);
              dotProd += xC${x + 1} * vec4(wTexel.xz, wTexel.xz);
            `));
        }
        p += `
    }
  `, p += `
      }
    `;
        let f = "", m = "";
        s && (o ? f = `vec4 activation(vec4 a) {
          vec4 b = getPreluActivationWeightsAtOutCoords();
          ${s}
        }` : r ? f = `vec4 activation(vec4 a) {
          vec4 b = getLeakyreluAlphaAtOutCoords();
          ${s}
        }` : f = `vec4 activation(vec4 x) {
          ${s}
        }`, m = "result = activation(result);");
        const g = e ? "result += getBiasAtOutCoords();" : "";
        e && this.variableNames.push("bias"), o && this.variableNames.push("preluActivationWeights"), r && this.variableNames.push("leakyreluAlpha"), this.userCode = `
      ${f}

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        ivec2 xRCCorner = coords.yz * strides - pads;
        int d2 = coords.w;
        int d1 = d2 / ${i};
        int q = d2 - d1 * ${i};
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        //intialize dotProd with a small epsilon seems to reduce GPU accuracy loss.
        vec4 dotProd = vec4(0.000000000000001);

        ${p}

        vec4 result = dotProd - vec4(0.000000000000001);
        ${g}
        ${m}
        setOutput(result);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function KZ(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, filter: r } = t, { strides: i, pad: a, dilations: l, dimRoundingMode: c } = s;
    let u = l;
    u == null && (u = [
        1,
        1
    ]), C(Le(i, u), ()=>`Error in depthwiseConv2d: Either strides or dilations must be 1. Got strides ${i} and dilations '${u}'`);
    const d = Te(o.shape, r.shape, i, u, a, c, !0);
    let h;
    F().getBool("WEBGL_PACK_DEPTHWISECONV") && d.strideWidth <= 2 && d.outChannels / d.inChannels === 1 ? h = new cC(d) : h = new lC(d);
    const p = [
        [
            d.padInfo.top,
            d.padInfo.left
        ],
        [
            d.strideHeight,
            d.strideWidth
        ],
        [
            d.dilationHeight,
            d.dilationWidth
        ],
        [
            d.inHeight,
            d.inWidth
        ]
    ];
    return e.runWebGLProgram(h, [
        o,
        r
    ], "float32", p);
}
const ZZ = {
    kernelName: ac,
    backendName: "webgl",
    kernelFunc: KZ
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class BZ {
    constructor(t){
        this.variableNames = [
            "x",
            "dy"
        ], this.outputShape = t.filterShape;
        const e = t.strideHeight, s = t.strideWidth, o = t.padInfo.top, r = t.padInfo.left, i = t.outChannels / t.inChannels;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int wR = coords.x;
        int wC = coords.y;
        int d1 = coords.z;
        int dm = coords.w;
        int d2 = d1 * ${i} + dm;

        float dotProd = 0.0;

        // TO DO: Vec4 over the batch size
        for (int b = 0; b < ${t.batchSize}; b++) {
          for (int yR = 0; yR < ${t.outHeight}; yR++) {
            int xR = wR + yR * ${e} - ${o};

            if (xR < 0 || xR >= ${t.inHeight}) {
              continue;
            }

            for (int yC = 0; yC < ${t.outWidth}; yC++) {
              int xC = wC + yC * ${s} - ${r};

              if (xC < 0 || xC >= ${t.inWidth}) {
                continue;
              }

              float dyValue = getDy(b, yR, yC, d2);
              float xValue = getX(b, xR, xC, d1);
              dotProd += (xValue * dyValue);
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class HZ {
    constructor(t){
        this.variableNames = [
            "dy",
            "W"
        ], this.outputShape = t.inShape;
        const e = t.filterHeight, s = t.filterWidth, o = t.strideHeight, r = t.strideWidth, i = e - 1 - t.padInfo.top, a = s - 1 - t.padInfo.left, l = t.outChannels / t.inChannels;
        this.userCode = `
      const ivec2 pads = ivec2(${i}, ${a});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d1 = coords[3];
        ivec2 dyCorner = coords.yz - pads;
        int dyRCorner = dyCorner.x;
        int dyCCorner = dyCorner.y;

        float dotProd = 0.0;

        for (int wR = 0; wR < ${e}; wR++) {
          float dyR = float(dyRCorner + wR) / ${o}.0;

          if (dyR < 0.0 || dyR >= ${t.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          int wRPerm = ${e} - 1 - wR;

          for (int wC = 0; wC < ${s}; wC++) {
            float dyC = float(dyCCorner + wC) / ${r}.0;

            if (dyC < 0.0 || dyC >= ${t.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            int wCPerm = ${s} - 1 - wC;

            // TO DO: Vec4 over the channelMul
            for (int dm = 0; dm < ${l}; dm++) {
              int d2 = d1 * ${l} + dm;
              float xValue = getDy(batch, idyR, idyC, d2);
              float wValue = getW(wRPerm, wCPerm, d1, dm);
              dotProd += xValue * wValue;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function _Z(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, dy: r } = t, { strides: i, dilations: a, pad: l, dimRoundingMode: c, filterShape: u } = s, d = Te(o.shape, u, i, a, l, c, !0), h = new BZ(d);
    return e.runWebGLProgram(h, [
        o,
        r
    ], "float32");
}
const UZ = {
    kernelName: fh,
    backendName: "webgl",
    kernelFunc: _Z
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function YZ(n) {
    const { inputs: t, backend: e, attrs: s } = n, { dy: o, filter: r } = t, { strides: i, dilations: a, pad: l, dimRoundingMode: c, inputShape: u } = s, d = Te(u, r.shape, i, a, l, c, !0), h = new HZ(d);
    return e.runWebGLProgram(h, [
        o,
        r
    ], "float32");
}
const QZ = {
    kernelName: mh,
    backendName: "webgl",
    kernelFunc: YZ
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class JZ {
    constructor(t){
        this.variableNames = [
            "X"
        ], this.outputShape = [
            t,
            t
        ], this.userCode = `
      void main() {
          ivec2 coords = getOutputCoords();
          float val = coords[0] == coords[1] ? getX(coords[0]) : 0.0;
          setOutput(val);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function jZ(n) {
    const { inputs: t, backend: e } = n, { x: s } = t, o = [
        ...s.shape,
        ...s.shape
    ], r = X(s.shape), i = et({
        inputs: {
            x: s
        },
        backend: e,
        attrs: {
            shape: [
                r
            ]
        }
    }), a = new JZ(r), l = e.runWebGLProgram(a, [
        i
    ], i.dtype), c = et({
        inputs: {
            x: l
        },
        backend: e,
        attrs: {
            shape: o
        }
    });
    return e.disposeIntermediateTensorInfo(i), e.disposeIntermediateTensorInfo(l), c;
}
const qZ = {
    kernelName: ub,
    backendName: "webgl",
    kernelFunc: jZ
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class tB {
    constructor(t){
        this.variableNames = [
            "x",
            "W"
        ], this.outputShape = t.outShape;
        const { inHeight: e, inWidth: s, padInfo: o, strideHeight: r, strideWidth: i, filterHeight: a, filterWidth: l, dilationHeight: c, dilationWidth: u } = t, { top: d, left: h } = o;
        this.userCode = `
      const ivec2 strides = ivec2(${r}, ${i});
      const ivec2 pads = ivec2(${d}, ${h});
      const float neg_infinity = -3.4e38;

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        int d1 = coords.w;
        ivec2 outTopLeftCorner =
            coords.yz * strides - pads;
        int hBeg = outTopLeftCorner.x;
        int wBeg = outTopLeftCorner.y;

        float curVal = neg_infinity;
        for (int h = 0; h < ${a}; h++) {
          int hIn = hBeg + h * ${c};

          if (hIn >= 0 && hIn < ${e}) {
            for (int w = 0; w < ${l}; w++) {
              int wIn = wBeg + w * ${u};

              if (wIn >= 0 && wIn < ${s}) {
                float xVal = getX(batch, hIn, wIn, d1);
                float wVal = getW(h, w, d1);

                float val = xVal + wVal;
                if (val > curVal) {
                  curVal = val;
                }
              }
            }
          }
        }

        float result = curVal;
        setOutput(result);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function eB(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, filter: r } = t, { strides: i, pad: a, dilations: l } = s, c = Ia(o.shape, r.shape, i, a, "NHWC", l);
    let u;
    const d = new tB(c);
    u = e.runWebGLProgram(d, [
        o,
        r
    ], "float32");
    const h = et({
        inputs: {
            x: u
        },
        backend: e,
        attrs: {
            shape: c.outShape
        }
    });
    return e.disposeIntermediateTensorInfo(u), h;
}
const nB = {
    kernelName: lc,
    backendName: "webgl",
    kernelFunc: eB
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function sB(n) {
    const { inputs: t, backend: e, attrs: s } = n, { equation: o } = s, r = t, { allDims: i, summedDims: a, idDims: l } = lf(o, r.length);
    uf(i.length, l, r);
    const { path: c, steps: u } = df(a, l), d = u.length;
    let h = null, p = i.length;
    const f = [];
    for(let m = 0; m < d; ++m){
        for (const g of u[m]){
            const { permutationIndices: b, expandDims: x } = cf(p, l[g]);
            let w;
            hf(b) ? w = r[g] : (w = ze({
                inputs: {
                    x: r[g]
                },
                backend: e,
                attrs: {
                    perm: b
                }
            }), f.push(w));
            const y = w.shape.slice();
            for(let I = 0; I < x.length; ++I)y.splice(x[I], 0, 1);
            $t(w.shape, y) || (w = et({
                inputs: {
                    x: w
                },
                backend: e,
                attrs: {
                    shape: y
                }
            }), f.push(w)), h === null ? h = w : (h = im({
                inputs: {
                    a: w,
                    b: h
                },
                backend: e
            }), f.push(h));
        }
        m < d - 1 && (c[m] >= 0 && (h = Su({
            inputs: {
                x: h
            },
            backend: e,
            attrs: {
                axis: c[m] - (i.length - p),
                keepDims: !1
            }
        }), f.push(h)), p--);
    }
    for (const m of f)m !== h && e.disposeIntermediateTensorInfo(m);
    return h;
}
const oB = {
    kernelName: bh,
    backendName: "webgl",
    kernelFunc: sB
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const rB = "return (x >= 0.0) ? x : (exp(x) - 1.0);", iB = `
  vec4 result;

  result.r = (x.r >= 0.0) ? x.r : (exp(x.r) - 1.0);
  result.g = (x.g >= 0.0) ? x.g : (exp(x.g) - 1.0);
  result.b = (x.b >= 0.0) ? x.b : (exp(x.b) - 1.0);
  result.a = (x.a >= 0.0) ? x.a : (exp(x.a) - 1.0);

  return result;
`, aB = Nt({
    opSnippet: rB,
    packedOpSnippet: iB
}), lB = {
    kernelName: Fi,
    backendName: "webgl",
    kernelFunc: aB
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const cB = "return (b >= 0.0) ? a : a * (b + 1.0);", uB = `
  vec4 bGTEZero = vec4(greaterThanEqual(b, vec4(0.)));
  return (bGTEZero * a) + ((vec4(1.0) - bGTEZero) * (a * (b + vec4(1.0))));
`, dB = (n)=>{
    const { inputs: t, backend: e } = n, { dy: s, y: o } = t, r = F().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new Fr(uB, s.shape, o.shape) : new Po(cB, s.shape, o.shape);
    return e.runWebGLProgram(r, [
        s,
        o
    ], s.dtype);
}, hB = {
    kernelName: xh,
    backendName: "webgl",
    kernelFunc: dB
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const pB = `
  return vec4(equal(a, b));
`, fB = "return float(a == b);", mB = Re({
    opSnippet: fB,
    packedOpSnippet: pB,
    dtype: "bool",
    cpuKernelImpl: HA
}), gB = {
    kernelName: cc,
    backendName: "webgl",
    kernelFunc: mB
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const bB = `
  // Error function is calculated approximately with elementary function.
  // See "Handbook of Mathematical Functions with Formulas,
  // Graphs, and Mathematical Tables", Abramowitz and Stegun.
  float p = ${tf};
  float a1 = ${ef};
  float a2 = ${nf};
  float a3 = ${sf};
  float a4 = ${of};
  float a5 = ${rf};

  float sign = sign(x);
  x = abs(x);
  float t = 1.0 / (1.0 + p * x);
  return sign * (1.0 - (((((a5*t + a4)*t) + a3)*t + a2)*t + a1)*t*exp(-x*x));
`, xB = Nt({
    opSnippet: bB
}), yB = {
    kernelName: Vi,
    backendName: "webgl",
    kernelFunc: xB
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const wB = Vr + `
  return exp(x);
`, IB = `
  vec4 result = exp(x);
  bvec4 isNaN = isnan(x);
  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`, uC = Nt({
    opSnippet: wB,
    packedOpSnippet: IB,
    cpuKernelImpl: _A,
    dtype: "float32"
}), CB = {
    kernelName: zi,
    backendName: "webgl",
    kernelFunc: uC
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Zd(n) {
    const { inputs: t, attrs: e, backend: s } = n, { dim: o } = e, { input: r } = t, i = r.shape.length, a = r.shape.slice();
    let l = o;
    return o < 0 && (C(-(i + 1) <= o, ()=>`Axis must be in the interval [${-(i + 1)}, ${i}]`), l = i + o + 1), a.splice(l, 0, 1), et({
        inputs: {
            x: r
        },
        backend: s,
        attrs: {
            shape: a
        }
    });
}
const vB = {
    kernelName: uc,
    backendName: "webgl",
    kernelFunc: Zd
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Fg = "return exp(x) - 1.0;", SB = Nt({
    opSnippet: Fg,
    packedOpSnippet: Fg,
    cpuKernelImpl: UA
}), kB = {
    kernelName: Pi,
    backendName: "webgl",
    kernelFunc: SB
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class Vg {
    constructor(t, e, s){
        this.variableNames = [
            "real",
            "imag"
        ];
        const o = e[1];
        this.outputShape = e;
        const r = s ? `2.0 * ${Math.PI}` : `-2.0 * ${Math.PI}`, i = s ? `${o}.0` : "1.0";
        let a;
        if (t === "real") a = "return real * expR - imag * expI;";
        else if (t === "imag") a = "return real * expI + imag * expR;";
        else throw new Error(`FFT component must be either "real" or "imag", got ${t}.`);
        this.userCode = `
      const float exponentMultiplier = ${r};

      float unaryOpComplex(float real, float expR, float imag, float expI) {
        ${a}
      }

      float mulMatDFT(int batch, int index) {
        float indexRatio = float(index) / float(${o});
        float exponentMultiplierTimesIndexRatio =
            exponentMultiplier * indexRatio;

        float result = 0.0;

        for (int i = 0; i < ${o}; i++) {
          // x = (-2|2 * PI / N) * index * i;
          float x = exponentMultiplierTimesIndexRatio * float(i);
          float expR = cos(x);
          float expI = sin(x);
          float real = getReal(batch, i);
          float imag = getImag(batch, i);

          result +=
              unaryOpComplex(real, expR, imag, expI) / ${i};
        }

        return result;
      }

      void main() {
        ivec2 coords = getOutputCoords();
        setOutput(mulMatDFT(coords[0], coords[1]));
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function dC(n, t, e) {
    const s = e.texData.get(n.dataId), o = X(n.shape), r = n.shape[n.shape.length - 1], i = o / r, a = et({
        inputs: {
            x: n
        },
        backend: e,
        attrs: {
            shape: [
                i,
                r
            ]
        }
    }), l = a.shape, c = new Vg("real", l, t), u = new Vg("imag", l, t), d = [
        {
            dataId: s.complexTensorInfos.real.dataId,
            dtype: s.complexTensorInfos.real.dtype,
            shape: l
        },
        {
            dataId: s.complexTensorInfos.imag.dataId,
            dtype: s.complexTensorInfos.imag.dtype,
            shape: l
        }
    ], h = e.runWebGLProgram(c, d, "float32"), p = e.runWebGLProgram(u, d, "float32"), f = oo({
        inputs: {
            real: h,
            imag: p
        },
        backend: e
    });
    e.disposeIntermediateTensorInfo(h), e.disposeIntermediateTensorInfo(p);
    const m = et({
        inputs: {
            x: f
        },
        backend: e,
        attrs: {
            shape: n.shape
        }
    });
    return e.disposeIntermediateTensorInfo(a), e.disposeIntermediateTensorInfo(f), m;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function TB(n) {
    const { inputs: t, backend: e } = n, { input: s } = t;
    return dC(s, !1, e);
}
const NB = {
    kernelName: yh,
    backendName: "webgl",
    kernelFunc: TB
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class RB {
    constructor(t, e){
        this.outputShape = [], this.customUniforms = [
            {
                name: "value",
                type: "float"
            }
        ], this.variableNames = [
            "x"
        ], this.outputShape = t, this.userCode = `
      void main() {
        // Input can be obtained from uniform value.
        setOutput(value);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Xa(n) {
    const { backend: t, attrs: e } = n, { shape: s, value: o } = e;
    let { dtype: r } = e;
    if (r = r || Oo(o), r === "string") {
        const i = ne(r, X(s));
        return i.fill(o), t.makeTensorInfo(s, r, i);
    } else {
        const i = new RB(s, o), a = [
            [
                o
            ]
        ];
        return t.runWebGLProgram(i, [], r, a);
    }
}
const $B = {
    kernelName: wh,
    backendName: "webgl",
    kernelFunc: Xa
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class GB {
    constructor(t){
        this.variableNames = [
            "Image"
        ], this.outputShape = [];
        const e = t[2];
        this.outputShape = t, this.userCode = `
        void main() {
          ivec4 coords = getOutputCoords();
          int x = coords[2];

          int coordX = ${e} - x - 1;
          float outputValue;
          if(coordX >= 0 && coordX < ${e}) {
            outputValue = getImage(coords[0], coords[1], coordX, coords[3]);
          } else {
            outputValue = getImage(coords[0], coords[1], coords[2], coords[3]);
          }
          setOutput(outputValue);
        }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const EB = {
    kernelName: Ih,
    backendName: "webgl",
    kernelFunc: ({ inputs: n, backend: t })=>{
        const { image: e } = n, s = t, o = new GB(e.shape);
        return s.runWebGLProgram(o, [
            e
        ], e.dtype);
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const zg = "return floor(x);", LB = Nt({
    opSnippet: zg,
    packedOpSnippet: zg,
    cpuKernelImpl: YA
}), MB = {
    kernelName: Ai,
    backendName: "webgl",
    kernelFunc: LB
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const WB = `
  float s = sign(a) * sign(b);
  int ia = round(a);
  int ib = round(b);
  if (ib != 0) {
    // Windows (D3D) wants guaranteed non-zero int division at compile-time.
    return float(idiv(ia, ib, s));
  } else {
    return NAN;
  }
`, DB = `
  ivec4 ia = round(a);
  ivec4 ib = round(b);
  bvec4 cond = notEqual(ib, ivec4(0));
  ivec4 result = ivec4(0);
  vec4 s = sign(a) * sign(b);

  // Windows (D3D) wants guaranteed non-zero int division at compile-time.
  if (cond[0]) {
    result[0] = idiv(ia[0], ib[0], s[0]);
  }
  if (cond[1]) {
    result[1] = idiv(ia[1], ib[1], s[1]);
  }
  if (cond[2]) {
    result[2] = idiv(ia[2], ib[2], s[2]);
  }
  if (cond[3]) {
    result[3] = idiv(ia[3], ib[3], s[3]);
  }
  return vec4(result);
`, FB = Re({
    opSnippet: WB,
    packedOpSnippet: DB,
    dtype: "int32"
}), VB = {
    kernelName: Oi,
    backendName: "webgl",
    kernelFunc: FB
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class zB {
    constructor(t){
        this.variableNames = [
            "A"
        ];
        const e = Ae(), [s, o] = t;
        this.outputShape = t, this.userCode = `
      void main() {
        ivec3 coords = getOutputCoords();
        int texR = coords[0];
        int texC = coords[1];
        int depth = coords[2];
        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${o}.0, ${s}.0);

        vec4 values = ${e.texture2D}(A, uv);
        float value;
        if (depth == 0) {
          value = values.r;
        } else if (depth == 1) {
          value = values.g;
        } else if (depth == 2) {
          value = values.b;
        } else if (depth == 3) {
          value = values.a;
        }

        setOutput(floor(value * 255.0 + 0.5));
      }
    `;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class PB {
    constructor(t){
        this.variableNames = [
            "A"
        ], this.packedInputs = !1, this.packedOutput = !0;
        const e = Ae(), [s, o] = t;
        this.outputShape = t, this.userCode = `
      void main() {
        ivec3 coords = getOutputCoords();
        int texR = coords[0];
        int texC = coords[1];
        int depth = coords[2];

        vec4 result = vec4(0.);

        for(int row=0; row<=1; row++) {
          for(int col=0; col<=1; col++) {
            texC = coords[1] + row;
            depth = coords[2] + col;

            vec2 uv = (vec2(texC, texR) + halfCR) /
                       vec2(${o}.0, ${s}.0);
            vec4 values = ${e.texture2D}(A, uv);
            float value;
            if (depth == 0) {
              value = values.r;
            } else if (depth == 1) {
              value = values.g;
            } else if (depth == 2) {
              value = values.b;
            } else if (depth == 3) {
              value = values.a;
            }

            result[row * 2 + col] = floor(value * 255.0 + 0.5);
          }
        }

        ${e.output} = result;
      }
    `;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const AB = {
    kernelName: cd,
    backendName: "webgl",
    kernelFunc: OB
};
let nr, Ou = F().getBool("CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU");
function OB(n) {
    const { inputs: t, backend: e, attrs: s } = n;
    let { pixels: o } = t;
    const { numChannels: r } = s, i = typeof HTMLVideoElement < "u" && o instanceof HTMLVideoElement, a = typeof HTMLImageElement < "u" && o instanceof HTMLImageElement, [l, c] = i ? [
        o.videoWidth,
        o.videoHeight
    ] : [
        o.width,
        o.height
    ], u = [
        c,
        l
    ], d = [
        c,
        l,
        r
    ];
    if (a || i) {
        const m = F().getBool("CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU");
        (nr == null || m !== Ou) && (Ou = m, nr = document.createElement("canvas").getContext("2d", {
            willReadFrequently: Ou
        })), nr.canvas.width = l, nr.canvas.height = c, nr.drawImage(o, 0, 0, l, c), o = nr.canvas;
    }
    const h = e.makeTensorInfo(u, "int32");
    e.texData.get(h.dataId).usage = un.PIXELS, e.gpgpu.uploadPixelDataToTexture(e.getTexture(h.dataId), o);
    const p = F().getBool("WEBGL_PACK") ? new PB(d) : new zB(d), f = e.runWebGLProgram(p, [
        h
    ], "int32");
    return e.disposeData(h.dataId), f;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function XB(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, filter: r, bias: i, preluActivationWeights: a } = t, { strides: l, pad: c, dataFormat: u, dilations: d, dimRoundingMode: h, activation: p, leakyreluAlpha: f } = s, m = Ss(u), g = Te(o.shape, r.shape, l, d, c, h, !1, m);
    let b;
    const x = [], w = i != null, y = a != null, I = p === "leakyrelu", v = ()=>{
        const S = [
            o,
            r
        ], N = (R, M)=>{
            if (M === "NCHW" && R.shape.length === 1 && R.shape[0] !== 1) {
                const V = et({
                    inputs: {
                        x: R
                    },
                    backend: e,
                    attrs: {
                        shape: [
                            R.shape[0],
                            1,
                            1
                        ]
                    }
                });
                return x.push(V), V;
            }
            return R;
        };
        if (w && S.push(N(i, u)), y && S.push(N(a, u)), I) {
            const R = e.makeTensorInfo([], "float32", Is(f, "float32"));
            S.push(R), x.push(R);
        }
        return S;
    };
    if (g.filterHeight === 1 && g.filterWidth === 1 && g.dilationHeight === 1 && g.dilationWidth === 1 && g.strideHeight === 1 && g.strideWidth === 1 && (g.padInfo.type === "SAME" || g.padInfo.type === "VALID")) b = rC({
        x: o,
        filter: r,
        convInfo: g,
        backend: e,
        bias: i,
        activation: p,
        preluActivationWeights: a,
        leakyreluAlpha: f
    });
    else if (g.strideWidth <= 2 && m === "channelsLast" && F().getBool("WEBGL_EXP_CONV")) {
        const S = p ? yi(p, !0) : null, N = new oC(g, w, S, y, I), R = [
            [
                g.padInfo.top,
                g.padInfo.left
            ],
            [
                g.strideHeight,
                g.strideWidth
            ],
            [
                g.dilationHeight,
                g.dilationWidth
            ],
            [
                g.inHeight,
                g.inWidth
            ]
        ], M = v();
        b = e.runWebGLProgram(N, M, "float32", R);
    } else if (F().getBool("WEBGL_CONV_IM2COL")) b = iC({
        x: o,
        filter: r,
        convInfo: g,
        backend: e,
        bias: i,
        activation: p,
        preluActivationWeights: a,
        leakyreluAlpha: f
    });
    else {
        const S = p ? yi(p, !1) : null, N = new sC(g, w, S, y, I), R = v();
        b = e.runWebGLProgram(N, R, "float32");
    }
    const k = et({
        inputs: {
            x: b
        },
        backend: e,
        attrs: {
            shape: g.outShape
        }
    });
    return x.push(b), x.forEach((S)=>e.disposeIntermediateTensorInfo(S)), k;
}
const KB = {
    kernelName: gl,
    backendName: "webgl",
    kernelFunc: XB
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ZB(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, filter: r, bias: i, preluActivationWeights: a } = t, { strides: l, pad: c, dilations: u, dimRoundingMode: d, activation: h, leakyreluAlpha: p } = s, f = [];
    let m = u;
    m == null && (m = [
        1,
        1
    ]), C(Le(l, m), ()=>`Error in depthwiseConv2d: Either strides or dilations must be 1. Got strides ${l} and dilations '${m}'`);
    const g = Te(o.shape, r.shape, l, m, c, d, !0), b = F().getBool("WEBGL_PACK_DEPTHWISECONV") && g.strideWidth <= 2 && g.outChannels / g.inChannels === 1, x = h ? yi(h, b) : null, w = [
        o,
        r
    ], y = i != null, I = a != null, v = h === "leakyrelu";
    if (y && w.push(i), I && w.push(a), v) {
        const R = e.makeTensorInfo([], "float32", Is(p, "float32"));
        w.push(R), f.push(R);
    }
    let k;
    b ? k = new cC(g, y, x, I, v) : k = new lC(g, y, x, I, v);
    const S = [
        [
            g.padInfo.top,
            g.padInfo.left
        ],
        [
            g.strideHeight,
            g.strideWidth
        ],
        [
            g.dilationHeight,
            g.dilationWidth
        ],
        [
            g.inHeight,
            g.inWidth
        ]
    ], N = e.runWebGLProgram(k, w, "float32", S);
    return f.forEach((R)=>e.disposeIntermediateTensorInfo(R)), N;
}
const BB = {
    kernelName: Cb,
    backendName: "webgl",
    kernelFunc: ZB
};
class HB {
    constructor(t, e, s, o){
        this.sliceDim = t, this.strides = e, this.paramsShape = o, this.variableNames = [
            "x",
            "indices"
        ], this.outputShape = s;
        const r = Vt(s.length);
        let i = `
    int index;`;
        for(let a = 0; a < this.sliceDim; a++)i += `
          index = round(getIndices(coords[0], ${a}));
          out_of_bounds = out_of_bounds || index < 0;
          out_of_bounds = out_of_bounds || index >= ${this.paramsShape[a]};
          flattenIndex += index * ${this.strides[a]};`;
        this.userCode = `
         void main() {
          ${r} coords = getOutputCoords();
          int flattenIndex = 0;
          bool out_of_bounds = false;

          ${i}

          setOutput(out_of_bounds ? 0.0 : getX(flattenIndex, coords[1]));
        }
      `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function _B(n) {
    const { inputs: t, backend: e } = n, { params: s, indices: o } = t, r = o.shape, i = r[r.length - 1], a = X(s.shape), [l, c, u, d] = eu(s, o), h = et({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            shape: [
                c,
                i
            ]
        }
    }), p = et({
        inputs: {
            x: s
        },
        backend: e,
        attrs: {
            shape: [
                X(s.shape) / u,
                u
            ]
        }
    });
    if (e.shouldExecuteOnCPU([
        s,
        o
    ]) || s.dtype === "string") {
        const b = e.readSync(o.dataId), x = e.bufferSync(s), w = QA(b, x, s.dtype, c, i, u, d, s.shape, a);
        return e.makeTensorInfo(l, s.dtype, w.values);
    }
    const f = new HB(i, d, [
        c,
        u
    ], s.shape), m = e.runWebGLProgram(f, [
        p,
        h
    ], p.dtype), g = et({
        inputs: {
            x: m
        },
        backend: e,
        attrs: {
            shape: l
        }
    });
    return e.disposeIntermediateTensorInfo(h), e.disposeIntermediateTensorInfo(p), e.disposeIntermediateTensorInfo(m), g;
}
const UB = {
    kernelName: db,
    backendName: "webgl",
    kernelFunc: _B
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class YB {
    constructor(t, e){
        this.variableNames = [
            "A",
            "indices"
        ], this.outputShape = e, this.rank = e.length;
        const s = Vt(this.rank), o = QB(t);
        this.userCode = `
      void main() {
        ${s} resRC = getOutputCoords();
        int index = int(getIndices(resRC.x, resRC.z));
        float inBounds = (index >= 0) && (index < ${t[2]}) ? 1.0 : 0.0;
        setOutput(inBounds * getA(${o}));
      }
    `;
    }
}
function QB(n, t) {
    const e = [
        "resRC.x",
        "resRC.y",
        "resRC.z",
        "resRC.w"
    ], s = [];
    for(let o = 0; o < n.length; o++)o === 2 ? s.push("index") : s.push(`${e[o]}`);
    return s.join();
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function hC(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, indices: r } = t, { axis: i, batchDims: a } = s, l = Ct(i, o.shape)[0];
    if (F().get("DEBUG")) {
        const x = e.readSync(r.dataId), w = o.shape[l];
        for(let y = 0; y < x.length; ++y){
            const I = x[y];
            C(I <= w - 1 && I >= 0, ()=>`GatherV2: the index value ${I} is not in [0, ${w - 1}]`);
        }
    }
    const c = ff(o, r, l, a), u = X(r.shape), d = [], h = et({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            shape: [
                c.batchSize,
                c.outerSize,
                c.dimSize,
                c.sliceSize
            ]
        }
    }), p = et({
        inputs: {
            x: r
        },
        backend: e,
        attrs: {
            shape: [
                c.batchSize,
                u / c.batchSize
            ]
        }
    });
    d.push(h), d.push(p);
    const f = [
        c.batchSize,
        c.outerSize,
        u / c.batchSize,
        c.sliceSize
    ];
    if (e.shouldExecuteOnCPU([
        o,
        r
    ]) || o.dtype === "string") {
        const x = e.bufferSync(p), w = e.bufferSync(h), y = JA(w, x, f);
        return d.forEach((I)=>e.disposeIntermediateTensorInfo(I)), e.makeTensorInfo(c.outputShape, y.dtype, y.values);
    }
    const m = new YB(h.shape, f), g = e.runWebGLProgram(m, [
        h,
        p
    ], h.dtype);
    d.push(g);
    const b = et({
        inputs: {
            x: g
        },
        backend: e,
        attrs: {
            shape: c.outputShape
        }
    });
    return d.forEach((x)=>e.disposeIntermediateTensorInfo(x)), b;
}
const JB = {
    kernelName: hc,
    backendName: "webgl",
    kernelFunc: hC
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const jB = "return float(a > b);", qB = `
  return vec4(greaterThan(a, b));
`, tH = Re({
    opSnippet: jB,
    packedOpSnippet: qB,
    cpuKernelImpl: jA,
    dtype: "bool"
}), eH = {
    kernelName: pc,
    backendName: "webgl",
    kernelFunc: tH
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const nH = "return float(a >= b);", sH = `
  return vec4(greaterThanEqual(a, b));
`, oH = Re({
    opSnippet: nH,
    packedOpSnippet: sH,
    dtype: "bool",
    cpuKernelImpl: qA
}), rH = {
    kernelName: Xi,
    backendName: "webgl",
    kernelFunc: oH
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function iH(n) {
    const { inputs: t, backend: e } = n, { input: s } = t;
    return dC(s, !0, e);
}
const aH = {
    kernelName: Ch,
    backendName: "webgl",
    kernelFunc: iH
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const lH = "return float(!isnan(x) && !isinf(x));", cH = Nt({
    opSnippet: lH,
    dtype: "bool"
}), uH = {
    kernelName: Zi,
    backendName: "webgl",
    kernelFunc: cH
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const dH = "return float(isinf(x));", hH = Nt({
    opSnippet: dH,
    dtype: "bool"
}), pH = {
    kernelName: Bi,
    backendName: "webgl",
    kernelFunc: hH
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const fH = "return float(isnan(x));", mH = Nt({
    opSnippet: fH,
    dtype: "bool"
}), gH = {
    kernelName: Hi,
    backendName: "webgl",
    kernelFunc: mH
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const bH = "return float(a < b);", xH = `
  return vec4(lessThan(a, b));
`, yH = Re({
    opSnippet: bH,
    packedOpSnippet: xH,
    cpuKernelImpl: tO,
    dtype: "bool"
}), wH = {
    kernelName: mc,
    backendName: "webgl",
    kernelFunc: yH
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const IH = "return float(a <= b);", CH = `
  return vec4(lessThanEqual(a, b));
`, vH = Re({
    opSnippet: IH,
    packedOpSnippet: CH,
    cpuKernelImpl: eO,
    dtype: "bool"
}), SH = {
    kernelName: gc,
    backendName: "webgl",
    kernelFunc: vH
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function kH(n) {
    const { backend: t, attrs: e } = n, { start: s, stop: o, num: r } = e, i = nO(s, o, r);
    return t.makeTensorInfo([
        i.length
    ], "float32", i);
}
const TH = {
    kernelName: hb,
    backendName: "webgl",
    kernelFunc: kH
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const NH = Vr + `
  return x < 0.0 ? 0./0. : log(x);
`, RH = `
  vec4 result = log(x);
  bvec4 isNaN = isnan(x);
  result.r = isNaN.r ? x.r : (x.r < 0.0 ? 0./0. : result.r);
  result.g = isNaN.g ? x.g : (x.g < 0.0 ? 0./0. : result.g);
  result.b = isNaN.b ? x.b : (x.b < 0.0 ? 0./0. : result.b);
  result.a = isNaN.a ? x.a : (x.a < 0.0 ? 0./0. : result.a);
  return result;
`, $H = Nt({
    opSnippet: NH,
    packedOpSnippet: RH,
    cpuKernelImpl: sO
}), GH = {
    kernelName: _i,
    backendName: "webgl",
    kernelFunc: $H
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const EH = Vr + `
  return log(1.0 + x);
`, LH = Nt({
    opSnippet: EH
}), MH = {
    kernelName: Ui,
    backendName: "webgl",
    kernelFunc: LH
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const WH = "return float(a >= 1.0 && b >= 1.0);", DH = `
  return vec4(
    vec4(greaterThanEqual(a, vec4(1.0))) *
    vec4(greaterThanEqual(b, vec4(1.0))));
`, FH = Re({
    opSnippet: WH,
    packedOpSnippet: DH,
    dtype: "bool"
}), VH = {
    kernelName: bc,
    backendName: "webgl",
    kernelFunc: FH
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const zH = "return float(!(x >= 1.0));", PH = Nt({
    opSnippet: zH
}), AH = {
    kernelName: xc,
    backendName: "webgl",
    kernelFunc: PH
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const OH = "return float(a >= 1.0 || b >= 1.0);", XH = `
  return min(
    vec4(greaterThanEqual(a, vec4(1.0))) +
    vec4(greaterThanEqual(b, vec4(1.0))),
    vec4(1.0));
`, KH = Re({
    opSnippet: OH,
    packedOpSnippet: XH,
    dtype: "bool"
}), ZH = {
    kernelName: yc,
    backendName: "webgl",
    kernelFunc: KH
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class BH {
    constructor(t, e, s, o, r){
        this.variableNames = [
            "x"
        ], this.outputShape = [];
        const i = e, a = t[3] - 1;
        this.outputShape = t;
        let l;
        const c = `float(${s}) + float(${o}) * sum`;
        r === 0.5 ? l = `inversesqrt(${c})` : r === 1 ? l = `1.0/(${c})` : l = `exp(log(${c}) * float(-${r}));`, this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int r = coords[1];
        int c = coords[2];
        int d = coords[3];
        float x = getX(b, r, c, d);
        float sum = 0.0;
        for (int j = -${i}; j <= ${i}; j++) {
          int idx = d + j;
          if (idx >= 0 && idx <=  ${a}) {
            float z = getX(b, r, c, idx);
            sum += z * z;
          }
        }
        float val = x * ${l};
        setOutput(val);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class HH {
    constructor(t, e, s, o, r){
        this.variableNames = [
            "x"
        ], this.outputShape = [], this.packedInputs = !0, this.packedOutput = !0;
        const i = e, a = t[3] - 1;
        this.outputShape = t;
        let l;
        const c = `float(${s}) + float(${o}) * sum`;
        r === 0.5 ? l = `inversesqrt(${c})` : r === 1 ? l = `1.0/(${c})` : l = `exp(log(${c}) * float(-${r}));`, this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords.x;
        int r = coords.y;
        int c = coords.z;
        int d = coords.w;

        bool hasNextCol = d < ${this.outputShape[3]};
        bool hasNextRow = c < ${this.outputShape[2]};

        vec4 sum = vec4(0.);
        vec4 xFragAtOutputCoords = getX(b, r, c, d);

        vec4 xAtOutputCoords = vec4(
          getChannel(xFragAtOutputCoords, vec2(c, d)),
          hasNextCol ?
            getChannel(xFragAtOutputCoords, vec2(c, d + 1)) : 0.0,
          hasNextRow ?
            getChannel(xFragAtOutputCoords , vec2(c + 1, d)) : 0.0,
          (hasNextRow && hasNextCol) ?
            getChannel(xFragAtOutputCoords, vec2(c + 1, d + 1)) : 0.0
        );

        int firstChannel = d - ${i};
        vec2 cache = vec2(0.);
        if(firstChannel >= 0){
          vec4 firstChannelFrag = getX(b, r, c, firstChannel);
          cache.x = getChannel(firstChannelFrag, vec2(c, firstChannel));
            if(hasNextRow){
              cache.y = getChannel(firstChannelFrag, vec2(c + 1, firstChannel));
            }
        }

        ivec2 depth = ivec2(d, d + 1);
        for (int j = - ${i}; j <= ${i}; j++) {
          ivec2 idx = depth + j;
          bvec2 aboveLowerBound = greaterThanEqual(idx, ivec2(0));
          bvec2 belowUpperBound = lessThanEqual(idx, ivec2(${a}));

          bool depthInRange = aboveLowerBound.x && belowUpperBound.x;
          bool depthPlusOneInRange = aboveLowerBound.y && belowUpperBound.y;

          if(depthInRange || depthPlusOneInRange){
            vec4 z = vec4(0.);
            vec4 xFragAtCurrentDepth;
            z.xz = cache.xy;
            if(depthPlusOneInRange && hasNextCol){
              xFragAtCurrentDepth = idx.y != d ?
                getX(b, r, c, idx.y) : xFragAtOutputCoords;
              z.y = getChannel(xFragAtCurrentDepth, vec2(c, idx.y));
              if(hasNextRow){
                z.w = getChannel(xFragAtCurrentDepth, vec2(c + 1, idx.y));
              }
            }
            cache.xy = z.yw;
            sum += z * z;
          }
        }
        vec4 result = xAtOutputCoords * ${l};
        setOutput(result);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const _H = (n)=>{
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { depthRadius: r, bias: i, alpha: a, beta: l } = s, c = F().getBool("WEBGL_PACK_NORMALIZATION") ? new HH(o.shape, r, i, a, l) : new BH(o.shape, r, i, a, l);
    return e.runWebGLProgram(c, [
        o
    ], o.dtype);
}, UH = {
    kernelName: wc,
    backendName: "webgl",
    kernelFunc: _H
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class YH {
    constructor(t, e, s, o, r){
        this.variableNames = [
            "inputImage",
            "outputImage",
            "dy"
        ], this.outputShape = [], this.outputShape = t, this.depth = t[3], this.depthRadius = e, this.bias = s, this.alpha = o, this.beta = r, this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int r = coords[1];
        int c = coords[2];

        float result = 0.0;
        for (int d = 0; d < ${this.depth}; ++d) {
          int depthBegin = int(max(0.0, float(d - ${e})));
          int depthEnd = int(min(float(${this.depth}),
              float(d + ${e} + 1)));

          const int MIN_DEPTH_BEGIN = 0;
          const int MAX_DEPTH_END = ${this.depth};

          float norm = 0.0;
          for (int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k) {
            if (k < depthBegin){
              continue;
            }
            else if (k >= depthBegin && k < depthEnd) {
              norm += getInputImage(b, r, c, k) * getInputImage(b, r, c, k);
            }
            else {
              break;
            }
          }

          norm = float(${o}) * norm + float(${s});

          for(int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k){
            if (k < depthBegin){
              continue;
            }
            else if (k >= depthBegin && k < depthEnd){
              float dyi = -2.0 * float(${o})
                * float(${r})
                * getInputImage(b, r, c, k) * getOutputImage(b, r, c, d)
                / norm;
              if (k == d) {
                dyi += pow(norm, -1.0 * ${r});
              }
              if (k == coords[3]) {
                dyi *= getDy(b, r, c, d);
                result += dyi;
              }
            }
            else {
              break;
            }
          }
      }
      setOutput(result);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const QH = (n)=>{
    const { inputs: t, backend: e, attrs: s } = n, { x: o, y: r, dy: i } = t, { depthRadius: a, bias: l, alpha: c, beta: u } = s, d = new YH(o.shape, a, l, c, u);
    return e.runWebGLProgram(d, [
        o,
        r,
        i
    ], o.dtype);
}, JH = {
    kernelName: Sh,
    backendName: "webgl",
    kernelFunc: QH
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function jH(n, t, e, s) {
    const o = X(t), i = X(n.shape) / o, a = et({
        inputs: {
            x: n
        },
        attrs: {
            shape: [
                i,
                o
            ]
        },
        backend: s
    }), l = qo(a, n.dtype, "max", s), c = et({
        inputs: {
            x: l
        },
        attrs: {
            shape: e
        },
        backend: s
    });
    return s.disposeIntermediateTensorInfo(a), s.disposeIntermediateTensorInfo(l), c;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function pC(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { reductionIndices: r, keepDims: i } = s, a = o.shape.length, l = Ct(r, o.shape);
    let c = l;
    const u = qt(c, a), d = u != null, h = e.shouldExecuteOnCPU([
        o
    ]);
    let p = o;
    if (d) {
        if (h) {
            const w = e.texData.get(p.dataId).values, y = new Array(a);
            for(let k = 0; k < y.length; k++)y[k] = o.shape[u[k]];
            const I = om(w, o.shape, o.dtype, u, y);
            p = e.makeTensorInfo(y, o.dtype);
            const v = e.texData.get(p.dataId);
            v.values = I;
        } else p = vu(o, u, e);
        c = ie(c.length, a);
    }
    Ne("max", c, a);
    const [f, m] = ye(p.shape, c);
    let g = f;
    i && (g = re(f, l));
    let b;
    if (h) {
        const w = e.texData.get(p.dataId).values, y = oO(w, X(m), g, o.dtype);
        b = e.makeTensorInfo(g, o.dtype);
        const I = e.texData.get(b.dataId);
        I.values = y;
    } else b = jH(p, m, g, e);
    return d && e.disposeIntermediateTensorInfo(p), b;
}
const qH = {
    kernelName: Ic,
    backendName: "webgl",
    kernelFunc: pC
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const t_ = rm + `
  return max(a, b);
`, e_ = `
  vec4 result = vec4(max(a, b));
  bvec4 isNaNA = isnan(a);
  bvec4 isNaNB = isnan(b);
  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);
  ` + jo + `
  return result;
`, n_ = Re({
    opSnippet: t_,
    packedOpSnippet: e_,
    cpuKernelImpl: rO
}), s_ = {
    kernelName: Yi,
    backendName: "webgl",
    kernelFunc: n_
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function o_(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t;
    Er(o, "maxPool");
    const { filterSize: r, strides: i, pad: a, dimRoundingMode: l } = s, c = 1;
    C(Le(i, c), ()=>`Error in maxPool: Either strides or dilations must be 1. Got strides ${i} and dilations '${c}'`);
    const u = $n(o.shape, r, i, c, a, l);
    if (u.filterWidth === 1 && u.filterHeight === 1 && $t(u.inShape, u.outShape)) return nn({
        inputs: {
            x: o
        },
        backend: e
    });
    const d = new wi(u, "max", !1);
    return e.runWebGLProgram(d, [
        o
    ], o.dtype);
}
const r_ = {
    kernelName: Cc,
    backendName: "webgl",
    kernelFunc: o_
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function i_(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { filterSize: r, strides: i, pad: a, dataFormat: l, dimRoundingMode: c } = s, u = [
        1,
        1,
        1
    ], d = vs(o.shape, r, i, u, a, c, l), h = new am(d, "max", !1);
    return e.runWebGLProgram(h, [
        o
    ], o.dtype);
}
const a_ = {
    kernelName: vc,
    backendName: "webgl",
    kernelFunc: i_
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class l_ {
    constructor(t){
        this.variableNames = [
            "dy",
            "maxPos"
        ], this.outputShape = t.inShape;
        const e = t.strideHeight, s = t.strideWidth, o = t.dilationHeight, r = t.effectiveFilterHeight, i = t.effectiveFilterWidth, a = r - 1 - t.padInfo.top, l = i - 1 - t.padInfo.left, c = r * i - 1;
        this.userCode = `
      const ivec2 pads = ivec2(${a}, ${l});

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];

        ivec2 dyRCCorner = coords.yz - pads;
        int dyRCorner = dyRCCorner.x;
        int dyCCorner = dyRCCorner.y;

        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${r};
          wR += ${o}) {
          float dyR = float(dyRCorner + wR) / ${e}.0;

          if (dyR < 0.0 || dyR >= ${t.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          for (int wC = 0; wC < ${i}; wC++) {
            float dyC = float(dyCCorner + wC) / ${s}.0;

            if (dyC < 0.0 || dyC >= ${t.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            float dyValue = getDy(b, idyR, idyC, d);
            int maxPosValue = ${c} - int(getMaxPos(b, idyR, idyC, d));

            // Get the current value, check it against the value from the
            // position matrix.
            int curPosValue = wR * ${i} + wC;
            float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);

            dotProd += dyValue * mask;
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class c_ {
    constructor(t){
        this.variableNames = [
            "dy",
            "maxPos"
        ], this.outputShape = t.inShape;
        const e = t.strideDepth, s = t.strideHeight, o = t.strideWidth, r = t.dilationDepth, i = t.dilationHeight, a = t.dilationWidth, l = t.effectiveFilterDepth, c = t.effectiveFilterHeight, u = t.effectiveFilterWidth, d = l - 1 - t.padInfo.front, h = c - 1 - t.padInfo.top, p = u - 1 - t.padInfo.left, f = l * c * u - 1;
        this.userCode = `
      const ivec3 pads = ivec3(${d}, ${h}, ${p});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyDCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        // Convolve dy(?, ?, ?, ch) with pos mask(:, :, :, d) to get
        // dx(xD, xR, xC, ch).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int wD = 0; wD < ${l};
           wD += ${r}) {
          float dyD = float(dyDCorner + wD) / ${e}.0;

          if (dyD < 0.0 || dyD >= ${t.outDepth}.0 || fract(dyD) > 0.0) {
            continue;
          }
          int idyD = int(dyD);

          for (int wR = 0; wR < ${c};
              wR += ${i}) {
            float dyR = float(dyRCorner + wR) / ${s}.0;

            if (dyR < 0.0 || dyR >= ${t.outHeight}.0 ||
                fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            for (int wC = 0; wC < ${u};
                wC += ${a}) {
              float dyC = float(dyCCorner + wC) / ${o}.0;

              if (dyC < 0.0 || dyC >= ${t.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              float dyValue = getDy(batch, idyD, idyR, idyC, ch);
              int maxPosValue = ${f} -
                  int(getMaxPos(batch, idyD, idyR, idyC, ch));

              // Get the current value, check it against the value from the
              // position matrix.
              int curPosValue =
                  wD * ${c} * ${u} +
                  wR * ${u} + wC;
              float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);

              dotProd += dyValue * mask;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function u_(n) {
    const { inputs: t, backend: e, attrs: s } = n, { dy: o, input: r } = t, i = r, { filterSize: a, strides: l, pad: c, dimRoundingMode: u } = s, d = [
        1,
        1,
        1
    ], h = vs(i.shape, a, l, d, c, u), p = new am(h, "max", !0), f = e.runWebGLProgram(p, [
        i
    ], i.dtype), m = new c_(h), g = e.runWebGLProgram(m, [
        o,
        f
    ], i.dtype);
    return e.disposeIntermediateTensorInfo(f), g;
}
const d_ = {
    kernelName: Th,
    backendName: "webgl",
    kernelFunc: u_
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function h_(n) {
    const { inputs: t, backend: e, attrs: s } = n, { dy: o, input: r, output: i } = t, a = r;
    Er([
        r,
        i
    ], "maxPoolGrad");
    const { filterSize: l, strides: c, pad: u, dimRoundingMode: d } = s, h = $n(a.shape, l, c, 1, u, d), p = !0, f = new wi(h, "max", p), m = e.runWebGLProgram(f, [
        a
    ], a.dtype), g = new l_(h), b = e.runWebGLProgram(g, [
        o,
        m
    ], a.dtype);
    return e.disposeIntermediateTensorInfo(m), b;
}
const p_ = {
    kernelName: kh,
    backendName: "webgl",
    kernelFunc: h_
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function f_(n, t, e, s) {
    let o = new wi(e, "max", !1);
    const r = s.runWebGLProgram(o, [
        n
    ], "float32");
    o = new wi(e, "max", !0, !0, t);
    const i = s.runWebGLProgram(o, [
        n
    ], "float32");
    return [
        r,
        i
    ];
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const m_ = {
    kernelName: pb,
    backendName: "webgl",
    kernelFunc: ({ inputs: n, attrs: t, backend: e })=>{
        const { x: s } = n, { filterSize: o, strides: r, pad: i, includeBatchInIndex: a } = t, l = e;
        C(s.shape.length === 4, ()=>`Error in maxPool: input must be rank 4 but got rank ${s.shape.length}.`);
        const c = [
            1,
            1
        ];
        C(Le(r, c), ()=>`Error in maxPool: Either strides or dilations must be 1. Got strides ${r} and dilations '${c}'`);
        const u = $n(s.shape, o, r, c, i), [d, h] = f_(s, a, u, l);
        return [
            d,
            h
        ];
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function g_(n, t, e, s) {
    const o = X(t), i = X(n.shape) / o, a = et({
        inputs: {
            x: n
        },
        attrs: {
            shape: [
                i,
                o
            ]
        },
        backend: s
    }), l = qo(a, "float32", "mean", s), c = et({
        inputs: {
            x: l
        },
        attrs: {
            shape: e
        },
        backend: s
    });
    return s.disposeIntermediateTensorInfo(a), s.disposeIntermediateTensorInfo(l), c;
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const b_ = {
    kernelName: Sc,
    backendName: "webgl",
    kernelFunc: ({ inputs: n, attrs: t, backend: e })=>{
        const { x: s } = n, { keepDims: o, axis: r } = t, i = e, a = s.shape.length, l = Ct(r, s.shape);
        let c = l;
        const u = qt(c, a), d = u != null, h = i.shouldExecuteOnCPU([
            s
        ]), p = [];
        let f = s;
        if (d) {
            if (h) {
                const y = i.texData.get(f.dataId).values, I = new Array(a);
                for(let S = 0; S < I.length; S++)I[S] = s.shape[u[S]];
                const v = om(y, s.shape, s.dtype, u, I);
                f = i.makeTensorInfo(I, s.dtype);
                const k = i.texData.get(f.dataId);
                k.values = v;
            } else f = vu(s, u, i);
            p.push(f), c = ie(c.length, a);
        }
        Ne("sum", c, a);
        const [m, g] = ye(f.shape, c);
        let b = m;
        o && (b = re(m, l));
        const x = g_(f, g, b, i);
        for (const w of p)i.disposeIntermediateTensorInfo(w);
        return x;
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function x_(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r, keepDims: i } = s, a = o.shape.length, l = Ct(r, o.shape);
    let c = l;
    const u = qt(c, a);
    let d = o;
    u != null && (d = ze({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            perm: u
        }
    }), c = ie(c.length, o.shape.length)), Ne("min", c, a);
    const [h, p] = ye(d.shape, c), f = X(p), m = et({
        inputs: {
            x: d
        },
        backend: e,
        attrs: {
            shape: [
                -1,
                f
            ]
        }
    }), g = qo(m, m.dtype, "min", e);
    let b;
    if (i) {
        const x = re(h, l);
        b = et({
            inputs: {
                x: g
            },
            backend: e,
            attrs: {
                shape: x
            }
        });
    } else b = et({
        inputs: {
            x: g
        },
        backend: e,
        attrs: {
            shape: h
        }
    });
    return e.disposeIntermediateTensorInfo(m), e.disposeIntermediateTensorInfo(g), u != null && e.disposeIntermediateTensorInfo(d), b;
}
const y_ = {
    kernelName: kc,
    backendName: "webgl",
    kernelFunc: x_
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const w_ = rm + `
  return min(a, b);
`, I_ = `
  vec4 result = vec4(min(a, b));
  bvec4 isNaNA = isnan(a);
  bvec4 isNaNB = isnan(b);
  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);
  ` + jo + `
  return result;
`, C_ = Re({
    opSnippet: w_,
    packedOpSnippet: I_,
    cpuKernelImpl: iO
}), v_ = {
    kernelName: Qi,
    backendName: "webgl",
    kernelFunc: C_
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class S_ {
    constructor(t, e, s){
        this.variableNames = [
            "x"
        ], this.outputShape = e.map((u, d)=>u[0] + t[d] + u[1]);
        const o = t.length, r = Vt(o), i = e.map((u)=>u[0]).join(","), a = e.map((u, d)=>u[0] + t[d]).join(","), l = [
            "coords[0]",
            "coords[1]",
            "coords[2]",
            "coords[3]"
        ].slice(0, o), c = s === "reflect" ? 0 : 1;
        if (o === 1) {
            this.userCode = `
        int start = ${i};
        int end = ${a};

        void main() {
          int outC = getOutputCoords();
          if (outC < start) {
            outC = start * 2 - outC - ${c};
          } else if(outC >= end) {
            outC = (end - 1) * 2 - outC + ${c};
          }
          setOutput(getX(outC - start));
        }
      `;
            return;
        }
        this.userCode = `
      ${r} start = ${r}(${i});
      ${r} end = ${r}(${a});

      void main() {
        ${r} outC = getOutputCoords();
        for (int i = 0; i < ${o}; i++) {
          if (outC[i] < start[i]) {
            outC[i] = start[i] * 2 - outC[i] - ${c};
          } else if(outC[i] >= end[i]) {
            outC[i] = (end[i] - 1) * 2 - outC[i] + ${c};
          }
        }
        ${r} coords = outC - start;
        setOutput(getX(${l}));
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class k_ {
    constructor(t, e, s){
        this.variableNames = [
            "x"
        ], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = e.map((f, m)=>f[0] + t[m] + f[1]);
        const o = t.length, r = Vt(o), i = e.map((f)=>f[0]).join(","), a = e.map((f, m)=>f[0] + t[m]).join(","), l = Fe("rc", o), c = Fe("source", o), u = `${l[o - 1]} < ${this.outputShape[o - 1]}`, d = o === 1 ? "source" : `vec2(${c.slice(-2).join()})`, h = s === "reflect" ? 0 : 1;
        let p = "";
        if (o === 1) {
            const f = `
        ${r} source = rc;
        if (source < start) {
          source = start * 2 - source - ${h};
        } else if (source >= end) {
          source = (end - 1) * 2 - source + ${h};
        }
        source -= start;
      `;
            p = `
        ${r} rc = outputLoc;
        ${f}
        result[0] = getChannel(getX(${c.join()}), ${d});
        ${l[o - 1]} += 1;
        if(${u}) {
          ${f}
          result[1] = getChannel(getX(${c.join()}), ${d});
        }
      `;
        } else {
            const f = `
        ${r} source = rc;
        ${r} lt = ${r}(lessThan(source, start));
        ${r} gte = ${r}(greaterThanEqual(source, end));
        ${r} orig = 1 - (lt + gte);
        source = orig * source +
                lt * (start * 2 - source - ${h}) +
                gte * ((end - 1) * 2 - source + ${h});
        source -= start;
      `;
            p = `
        ${r} rc = outputLoc;
        ${f}
        result[0] = getChannel(getX(${c.join()}), ${d});
        ${l[o - 1]} += 1;
        if(${u}) {
          ${f}
          result[1] = getChannel(getX(${c.join()}), ${d});
        }
        rc = outputLoc;
        ${l[o - 2]} += 1;
        if(${l[o - 2]} < ${this.outputShape[o - 2]}) {
          ${f}
          result[2] = getChannel(getX(${c.join()}), ${d});
          ${l[o - 1]} += 1;
          if(${u}) {
            ${f}
            result[3] = getChannel(getX(${c.join()}), ${d});
          }
        }
      `;
        }
        this.userCode = `
      const ${r} start = ${r}(${i});
      const ${r} end = ${r}(${a});

      void main() {
        ${r} outputLoc = getOutputCoords();
        vec4 result = vec4(0.);
        ${p}
        setOutput(result);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const T_ = ({ inputs: n, backend: t, attrs: e })=>{
    const { x: s } = n, { paddings: o, mode: r } = e, i = F().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new k_(s.shape, o, r) : new S_(s.shape, o, r);
    return t.runWebGLProgram(i, [
        s
    ], s.dtype);
}, N_ = {
    kernelName: Tc,
    backendName: "webgl",
    kernelFunc: T_
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const R_ = `if (b == 0.0) return NAN;
  return mod(a, b);`, $_ = `
  vec4 result = mod(a, b);
  bvec4 isNaN = equal(b, vec4(0.0));
  ` + jo + `
  return result;
`, G_ = Re({
    opSnippet: R_,
    packedOpSnippet: $_
}), E_ = {
    kernelName: Ji,
    backendName: "webgl",
    kernelFunc: G_
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class L_ {
    constructor(t, e, s){
        this.variableNames = [
            "probs"
        ], this.customUniforms = [
            {
                name: "seed",
                type: "float"
            }
        ], this.outputShape = [
            t,
            s
        ], this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];

        float r = random(seed);
        float cdf = 0.0;

        for (int i = 0; i < ${e - 1}; i++) {
          cdf += getProbs(batch, i);

          if (r < cdf) {
            setOutput(float(i));
            return;
          }
        }

        // If no other event happened, last event happened.
        setOutput(float(${e - 1}));
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const M_ = `
if (a == b) {
  return 1.0;
};
return a / b;`, W_ = `
  // vec4 one = vec4(equal(a, b));
  // return one + (vec4(1.0) - one) * a / b;
  vec4 result = a / b;
  if(a.x == b.x) {
    result.x = 1.;
  }
  if(a.y == b.y) {
    result.y = 1.;
  }
  if(a.z == b.z) {
    result.z = 1.;
  }
  if(a.w == b.w) {
    result.w = 1.;
  }

  return result;
`, fC = Re({
    opSnippet: M_,
    packedOpSnippet: W_,
    checkOutOfBounds: !0
}), D_ = {
    kernelName: Di,
    backendName: "webgl",
    kernelFunc: fC
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Pg = "return a - b;", mC = Re({
    opSnippet: Pg,
    packedOpSnippet: Pg,
    supportsComplex: !0,
    cpuKernelImpl: NO
}), F_ = {
    kernelName: pa,
    backendName: "webgl",
    kernelFunc: mC
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function gC(n) {
    const { inputs: t, backend: e, attrs: s } = n, { logits: o } = t, { dim: r } = s, i = Ct([
        r
    ], o.shape), a = pC({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            reductionIndices: i,
            keepDims: !1
        }
    }), l = re(a.shape, i), c = et({
        inputs: {
            x: a
        },
        backend: e,
        attrs: {
            shape: l
        }
    }), u = mC({
        inputs: {
            a: o,
            b: c
        },
        backend: e
    }), d = uC({
        inputs: {
            x: u
        },
        backend: e
    }), h = Su({
        inputs: {
            x: d
        },
        backend: e,
        attrs: {
            axis: i,
            keepDims: !1
        }
    }), p = et({
        inputs: {
            x: h
        },
        backend: e,
        attrs: {
            shape: l
        }
    }), f = fC({
        inputs: {
            a: d,
            b: p
        },
        backend: e
    });
    return e.disposeIntermediateTensorInfo(a), e.disposeIntermediateTensorInfo(c), e.disposeIntermediateTensorInfo(u), e.disposeIntermediateTensorInfo(d), e.disposeIntermediateTensorInfo(h), e.disposeIntermediateTensorInfo(p), f;
}
const V_ = {
    kernelName: Zc,
    backendName: "webgl",
    kernelFunc: gC
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function z_(n) {
    const { inputs: t, backend: e, attrs: s } = n, { logits: o } = t, { numSamples: r, seed: i, normalized: a } = s, l = a ? o : gC({
        inputs: {
            logits: o
        },
        backend: e,
        attrs: {
            dim: o.shape.length - 1
        }
    }), c = l.shape[0], u = l.shape[1], d = new L_(c, u, r), h = [
        [
            i
        ]
    ], p = e.runWebGLProgram(d, [
        l
    ], "int32", h);
    return a || e.disposeIntermediateTensorInfo(l), p;
}
const P_ = {
    kernelName: fb,
    backendName: "webgl",
    kernelFunc: z_
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const A_ = En + `
  return -x;
`, O_ = `
  vec4 result = -x;
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
function X_(n) {
    const { inputs: t, backend: e } = n, { x: s } = t;
    if (e.shouldExecuteOnCPU([
        s
    ])) {
        const r = e.texData.get(s.dataId), [i, a] = lO(r.values, s.shape, s.dtype);
        return e.makeTensorInfo(a, s.dtype, i);
    }
    let o;
    return F().getBool("WEBGL_PACK_UNARY_OPERATIONS") ? o = new Vs(s.shape, O_) : o = new qn(s.shape, A_), e.runWebGLProgram(o, [
        s
    ], s.dtype);
}
const K_ = {
    kernelName: Nc,
    backendName: "webgl",
    kernelFunc: X_
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Z_ = zp;
function B_(n) {
    ln("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: t, backend: e, attrs: s } = n, { boxes: o, scores: r } = t, { maxOutputSize: i, iouThreshold: a, scoreThreshold: l } = s, c = e.readSync(o.dataId), u = e.readSync(r.dataId), { selectedIndices: d } = Z_(c, u, i, a, l);
    return e.makeTensorInfo([
        d.length
    ], "int32", new Int32Array(d));
}
const H_ = {
    kernelName: Nh,
    backendName: "webgl",
    kernelFunc: B_
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const __ = Pp;
function U_(n) {
    ln("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: t, backend: e, attrs: s } = n, { boxes: o, scores: r } = t, { maxOutputSize: i, iouThreshold: a, scoreThreshold: l, padToMaxOutputSize: c } = s, u = e.readSync(o.dataId), d = e.readSync(r.dataId), { selectedIndices: h, validOutputs: p } = __(u, d, i, a, l, c);
    return [
        e.makeTensorInfo([
            h.length
        ], "int32", new Int32Array(h)),
        e.makeTensorInfo([], "int32", new Int32Array([
            p
        ]))
    ];
}
const Y_ = {
    kernelName: Rh,
    backendName: "webgl",
    kernelFunc: U_
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Q_ = Ap;
function J_(n) {
    ln("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: t, backend: e, attrs: s } = n, { boxes: o, scores: r } = t, { maxOutputSize: i, iouThreshold: a, scoreThreshold: l, softNmsSigma: c } = s, u = e.readSync(o.dataId), d = e.readSync(r.dataId), h = i, p = a, f = l, m = c, { selectedIndices: g, selectedScores: b } = Q_(u, d, h, p, f, m);
    return [
        e.makeTensorInfo([
            g.length
        ], "int32", new Int32Array(g)),
        e.makeTensorInfo([
            b.length
        ], "float32", new Float32Array(b))
    ];
}
const j_ = {
    kernelName: $h,
    backendName: "webgl",
    kernelFunc: J_
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class q_ {
    constructor(t, e, s, o){
        this.variableNames = [
            "indices"
        ], this.outputShape = [
            t,
            e
        ], this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int index = round(getIndices(coords.x));
        setOutput(mix(float(${o}), float(${s}),
                      float(index == coords.y)));
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const t9 = (n)=>{
    const { inputs: t, backend: e, attrs: s } = n, { indices: o } = t, { dtype: r, depth: i, onValue: a, offValue: l } = s, c = X(o.shape), u = new q_(c, i, a, l), d = et({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            shape: [
                c
            ]
        }
    }), h = e.runWebGLProgram(u, [
        d
    ], r);
    e.disposeIntermediateTensorInfo(d);
    const p = [
        ...o.shape,
        i
    ], f = et({
        inputs: {
            x: h
        },
        backend: e,
        attrs: {
            shape: p
        }
    });
    return e.disposeIntermediateTensorInfo(h), f;
}, e9 = {
    kernelName: Gc,
    backendName: "webgl",
    kernelFunc: t9
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Kl(n) {
    const { inputs: t, backend: e } = n, { x: s } = t;
    if (s.dtype === "complex64") {
        const o = Oa({
            inputs: {
                input: s
            },
            backend: e
        }), r = Kl({
            inputs: {
                x: o
            },
            backend: e
        }), i = ku({
            inputs: {
                input: s
            },
            backend: e
        }), a = Kl({
            inputs: {
                x: i
            },
            backend: e
        }), l = oo({
            inputs: {
                real: r,
                imag: a
            },
            backend: e
        });
        return e.disposeIntermediateTensorInfo(o), e.disposeIntermediateTensorInfo(r), e.disposeIntermediateTensorInfo(i), e.disposeIntermediateTensorInfo(a), l;
    } else return Xa({
        attrs: {
            shape: s.shape,
            dtype: s.dtype,
            value: s.dtype === "string" ? "" : 0
        },
        backend: e
    });
}
const n9 = {
    kernelName: Uc,
    backendName: "webgl",
    kernelFunc: Kl
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function bC(n) {
    const { inputs: t, backend: e } = n, { x: s } = t;
    if (s.dtype === "string") throw new Error("onesLike is not supported under string dtype");
    if (s.dtype === "complex64") {
        const o = Oa({
            inputs: {
                input: s
            },
            backend: e
        }), r = bC({
            inputs: {
                x: o
            },
            backend: e
        }), i = ku({
            inputs: {
                input: s
            },
            backend: e
        }), a = Kl({
            inputs: {
                x: i
            },
            backend: e
        }), l = oo({
            inputs: {
                real: r,
                imag: a
            },
            backend: e
        });
        return e.disposeIntermediateTensorInfo(o), e.disposeIntermediateTensorInfo(r), e.disposeIntermediateTensorInfo(i), e.disposeIntermediateTensorInfo(a), l;
    } else return Xa({
        attrs: {
            shape: s.shape,
            dtype: s.dtype,
            value: 1
        },
        backend: e
    });
}
const s9 = {
    kernelName: $c,
    backendName: "webgl",
    kernelFunc: bC
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function o9(n) {
    const { inputs: t, backend: e, attrs: s } = n, { axis: o } = s;
    if (t.length === 1) return Zd({
        inputs: {
            input: t[0]
        },
        backend: e,
        attrs: {
            dim: o
        }
    });
    const r = t[0].shape, i = t[0].dtype;
    t.forEach((u)=>{
        Pe(r, u.shape, "All tensors passed to stack must have matching shapes"), C(i === u.dtype, ()=>"All tensors passed to stack must have matching dtypes");
    });
    const a = [], l = t.map((u)=>{
        const d = Zd({
            inputs: {
                input: u
            },
            backend: e,
            attrs: {
                dim: o
            }
        });
        return a.push(d), d;
    }), c = nC({
        inputs: l,
        backend: e,
        attrs: {
            axis: o
        }
    });
    return a.forEach((u)=>e.disposeIntermediateTensorInfo(u)), c;
}
const r9 = {
    kernelName: Ec,
    backendName: "webgl",
    kernelFunc: o9
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class i9 {
    constructor(t, e, s){
        this.variableNames = [
            "x"
        ], this.customUniforms = [
            {
                name: "value",
                type: "float"
            }
        ], this.outputShape = e.map((c, u)=>c[0] + t[u] + c[1]);
        const o = t.length, r = Vt(o), i = e.map((c)=>c[0]).join(","), a = e.map((c, u)=>c[0] + t[u]).join(","), l = [
            "coords[0]",
            "coords[1]",
            "coords[2]",
            "coords[3]"
        ].slice(0, o);
        if (o === 1) {
            this.userCode = `
        int start = ${i};
        int end = ${a};

        void main() {
          int outC = getOutputCoords();
          if (outC < start || outC >= end) {
            setOutput(value);
          } else {
            setOutput(getX(outC - start));
          }
        }
      `;
            return;
        }
        this.userCode = `
      ${r} start = ${r}(${i});
      ${r} end = ${r}(${a});

      void main() {
        ${r} outC = getOutputCoords();
        if (any(lessThan(outC, start)) || any(greaterThanEqual(outC, end))) {
          setOutput(value);
        } else {
          ${r} coords = outC - start;
          setOutput(getX(${l}));
        }
      }
    `;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class a9 {
    constructor(t, e, s){
        this.variableNames = [
            "x"
        ], this.packedInputs = !0, this.packedOutput = !0, this.customUniforms = [
            {
                name: "value",
                type: "float"
            }
        ], this.outputShape = e.map((m, g)=>m[0] + t[g] + m[1]);
        const o = t.length, r = Vt(o), i = e.map((m)=>m[0]).join(","), a = e.map((m, g)=>m[0] + t[g]).join(","), l = Fe("rc", o), c = Fe("source", o), u = `${l[o - 1]} < ${this.outputShape[o - 1]}`, d = o === 1 ? "source" : `vec2(${c.slice(-2).join()})`, h = [
            `${r} rc = outputLoc;`,
            `${l[o - 1]} += 1;
       if(${u}) {
      `,
            o === 1 ? "" : `}
       rc = outputLoc;
       ${l[o - 2]} += 1;
       if(${l[o - 2]} < ${this.outputShape[o - 2]}) {`,
            o === 1 ? "" : `  ${l[o - 1]} += 1;
         if(${u}) {`
        ], p = o === 1 ? "rc < start || rc >= end" : "any(lessThan(rc, start)) || any(greaterThanEqual(rc, end))";
        let f = "";
        for(let m = 0, g = o === 1 ? 2 : 4; m < g; m++)f += `
        ${h[m]}
        if (${p}) {
          result[${m}] = float(value);
        } else {
          ${r} source = rc - start;
          result[${m}] = getChannel(getX(${c.join()}), ${d});
        }
      `;
        f += o === 1 ? "} " : "}}", this.userCode = `
      const ${r} start = ${r}(${i});
      const ${r} end = ${r}(${a});

      void main() {
        ${r} outputLoc = getOutputCoords();
        vec4 result = vec4(0.);
        ${f}
        setOutput(result);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const xC = (n)=>{
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { paddings: r, constantValue: i } = s;
    if (X(o.shape) === 0) {
        const c = r.map((u, d)=>u[0] + o.shape[d] + u[1]);
        return Xa({
            backend: e,
            attrs: {
                shape: c,
                value: i,
                dtype: o.dtype
            }
        });
    }
    const a = F().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new a9(o.shape, r, i) : new i9(o.shape, r, i), l = [
        [
            i
        ]
    ];
    return e.runWebGLProgram(a, [
        o
    ], o.dtype, l);
}, l9 = {
    kernelName: Lc,
    backendName: "webgl",
    kernelFunc: xC
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const c9 = `
  if(a < 0.0 && floor(b) < b){
    return NAN;
  }
  if (b == 0.0) {
    return 1.0;
  }
  return (round(mod(b, 2.0)) != 1) ?
      pow(abs(a), b) : sign(a) * pow(abs(a), b);
`, u9 = `
  // isModRound1 has 1 for components with round(mod(b, 2.0)) == 1, 0 otherwise.
  vec4 isModRound1 = vec4(equal(round(mod(b, 2.0)), ivec4(1)));
  vec4 multiplier = sign(a) * isModRound1 + (vec4(1.0) - isModRound1);
  vec4 result = multiplier * pow(abs(a), b);

  // Ensure that a^0 = 1, including 0^0 = 1 as this correspond to TF and JS
  bvec4 isExpZero = equal(b, vec4(0.0));
  result.r = isExpZero.r ? 1.0 : result.r;
  result.g = isExpZero.g ? 1.0 : result.g;
  result.b = isExpZero.b ? 1.0 : result.b;
  result.a = isExpZero.a ? 1.0 : result.a;

  bvec4 isNaN1 = lessThan(a, vec4(0.0));
  bvec4 isNaN2 = lessThan(floor(b), b);
  bvec4 isNaN = bvec4(isNaN1.x && isNaN2.x, isNaN1.y && isNaN2.y, isNaN1.z && isNaN2.z, isNaN1.w && isNaN2.w);
  ` + jo + `
  return result;
`, d9 = Re({
    opSnippet: c9,
    packedOpSnippet: u9
}), h9 = {
    kernelName: qi,
    backendName: "webgl",
    kernelFunc: d9
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function p9(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { axis: r, keepDims: i } = s, a = o.shape.length, l = [], c = Ct(r, o.shape);
    let u = c;
    const d = qt(u, a);
    let h = o;
    d != null && (h = ze({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            perm: d
        }
    }), u = ie(u.length, a), l.push(h)), Ne("prod", u, a);
    let p;
    if (e.shouldExecuteOnCPU([
        h
    ])) {
        const f = e.texData.get(h.dataId).values, { outVals: m, outShape: g, outDtype: b } = uO(h.shape, h.dtype, f, u);
        p = e.makeTensorInfo(g, b, m);
    } else {
        const [f, m] = ye(h.shape, u), g = X(m), b = et({
            inputs: {
                x: h
            },
            backend: e,
            attrs: {
                shape: [
                    -1,
                    g
                ]
            }
        }), x = Yh(o.dtype), w = qo(b, x, "prod", e);
        p = et({
            inputs: {
                x: w
            },
            backend: e,
            attrs: {
                shape: f
            }
        }), l.push(b), l.push(w);
    }
    if (i) {
        l.push(p);
        const f = re(p.shape, c);
        p = et({
            inputs: {
                x: p
            },
            backend: e,
            attrs: {
                shape: f
            }
        });
    }
    return l.forEach((f)=>e.disposeIntermediateTensorInfo(f)), p;
}
const f9 = {
    kernelName: Wc,
    backendName: "webgl",
    kernelFunc: p9
};
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function m9(n) {
    const { inputs: t, backend: e, attrs: s } = n, { paramsNestedSplits: o, paramsDenseValues: r, indices: i } = t, { outputRaggedRank: a } = s, l = o.map((b)=>e.readSync(b.dataId)), c = o.map((b)=>b.shape), u = e.readSync(r.dataId), d = e.readSync(i.dataId), [h, p, f] = dO(l, c, u, r.shape, r.dtype, d, i.shape, a), m = h.map((b)=>e.makeTensorInfo([
            b.length
        ], "int32", b)), g = e.makeTensorInfo(f, r.dtype, p);
    return m.concat([
        g
    ]);
}
const g9 = {
    kernelName: mb,
    backendName: "webgl",
    kernelFunc: m9
};
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function b9(n) {
    const { inputs: t, backend: e } = n, { starts: s, limits: o, deltas: r } = t, i = e.readSync(s.dataId), a = e.readSync(o.dataId), l = e.readSync(r.dataId), [c, u] = hO(i, s.shape, s.dtype, a, o.shape, l, r.shape), d = e.makeTensorInfo([
        c.length
    ], "int32", c), h = e.makeTensorInfo([
        u.length
    ], s.dtype, u);
    return [
        d,
        h
    ];
}
const x9 = {
    kernelName: gb,
    backendName: "webgl",
    kernelFunc: b9
};
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function y9(n) {
    const { inputs: t, backend: e, attrs: s } = n, { shape: o, values: r, defaultValue: i, rowPartitionTensors: a } = t, { rowPartitionTypes: l } = s, c = e.readSync(o.dataId), u = e.readSync(r.dataId), d = e.readSync(i.dataId), h = a.map((g)=>e.readSync(g.dataId)), p = a.map((g)=>g.shape), [f, m] = pO(c, o.shape, u, r.shape, r.dtype, d, i.shape, h, p, l);
    return e.makeTensorInfo(f, r.dtype, m);
}
const w9 = {
    kernelName: bb,
    backendName: "webgl",
    kernelFunc: y9
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const yC = (n)=>{
    const { backend: t, attrs: e } = n, { start: s, stop: o, step: r, dtype: i } = e, a = fO(s, o, r, i);
    return t.makeTensorInfo([
        a.length
    ], i, a);
}, I9 = {
    kernelName: Gh,
    backendName: "webgl",
    kernelFunc: yC
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const C9 = "return 1.0 / x;", v9 = Nt({
    opSnippet: C9
}), S9 = {
    kernelName: ta,
    backendName: "webgl",
    kernelFunc: v9
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const k9 = En + `
  return (x < 0.0) ? 0.0 : x;
`, T9 = `
  vec4 result = x * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`, N9 = Nt({
    opSnippet: k9,
    packedOpSnippet: T9
}), R9 = {
    kernelName: ea,
    backendName: "webgl",
    kernelFunc: N9
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $9 = En + `
  return (x < 0.0) ? 0.0 : min(6.0, x);
`, G9 = `
  vec4 result = min(x, vec4(6.)) * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`, E9 = Nt({
    opSnippet: $9,
    packedOpSnippet: G9
}), L9 = {
    kernelName: na,
    backendName: "webgl",
    kernelFunc: E9
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class M9 {
    constructor(t, e, s, o, r){
        this.variableNames = [
            "A"
        ], this.outputShape = [];
        const [i, a, l, c] = t;
        this.outputShape = [
            i,
            e,
            s,
            c
        ];
        const u = [
            o && e > 1 ? a - 1 : a,
            o && s > 1 ? l - 1 : l
        ], d = [
            o && e > 1 ? e - 1 : e,
            o && s > 1 ? s - 1 : s
        ];
        let h;
        r ? h = "(vec2(yRC) + vec2(0.5)) * effectiveInputOverOutputRatioRC - vec2(0.5)" : h = "vec2(yRC) * effectiveInputOverOutputRatioRC", this.userCode = `
      const vec2 effectiveInputOverOutputRatioRC = vec2(
          ${u[0] / d[0]},
          ${u[1] / d[1]});
      const vec2 inputShapeRC = vec2(${a}.0, ${l}.0);

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        ivec2 yRC = coords.yz;

        // Fractional source index.
        vec2 sourceFracIndexRC = ${h};

        // Compute the four integer indices.
        ivec2 sourceFloorRC = ivec2(max(sourceFracIndexRC, vec2(0.0)));
        ivec2 sourceCeilRC = ivec2(
          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));

        float topLeft = getA(b, sourceFloorRC.x, sourceFloorRC.y, d);
        float bottomLeft = getA(b, sourceCeilRC.x, sourceFloorRC.y, d);
        float topRight = getA(b, sourceFloorRC.x, sourceCeilRC.y, d);
        float bottomRight = getA(b, sourceCeilRC.x, sourceCeilRC.y, d);

        vec2 fracRC = sourceFracIndexRC - vec2(sourceFloorRC);

        float top = topLeft + (topRight - topLeft) * fracRC.y;
        float bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;
        float newValue = top + (bottom - top) * fracRC.x;

        setOutput(newValue);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class W9 {
    constructor(t, e, s, o, r){
        this.variableNames = [
            "A"
        ], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = [];
        const [i, a, l, c] = t;
        this.outputShape = [
            i,
            e,
            s,
            c
        ];
        const u = [
            o && e > 1 ? a - 1 : a,
            o && s > 1 ? l - 1 : l
        ], d = [
            o && e > 1 ? e - 1 : e,
            o && s > 1 ? s - 1 : s
        ];
        let h;
        r ? h = "(vec3(yRC) + vec3(0.5)) * effectiveInputOverOutputRatioRC - vec3(0.5)" : h = "vec3(yRC) * effectiveInputOverOutputRatioRC", this.userCode = `
      const vec3 effectiveInputOverOutputRatioRC = vec3(
          ${u[0] / d[0]},
          ${u[1] / d[1]},
          ${u[1] / d[1]});
      const vec3 inputShapeRC = vec3(${a}.0, ${l}.0,
                                     ${l}.0);

      float getAValue(int b, int r, int c, int d) {
        return getChannel(getA(b, r, c, d), vec2(c, d));
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        // Calculate values for next column in yRC.z.
        ivec3 yRC = coords.yzz + ivec3(0, 0, 1);

        // Fractional source index.
        vec3 sourceFracIndexRC = ${h};

        // Compute the four integer indices.
        ivec3 sourceFloorRC = ivec3(max(sourceFracIndexRC, vec3(0.0)));
        ivec3 sourceCeilRC = ivec3(
          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));

        // Should we calculate next column and row elements in 2x2 packed cell.
        bool hasNextCol = d < ${c - 1};
        bool hasNextRow = coords.z < ${s - 1};

        // In parallel, construct four corners for all four components in
        // packed 2x2 cell.
        vec4 topLeft = vec4(
          getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d),
          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d + 1) : 0.0);

        vec4 bottomLeft = vec4(
          getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d),
          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d + 1) : 0.0);

        vec4 topRight = vec4(
          getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d),
          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d + 1) : 0.0);

        vec4 bottomRight = vec4(
          getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d),
          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d + 1) : 0.0);

        vec3 fracRC = sourceFracIndexRC - vec3(sourceFloorRC);

        vec4 top = mix(topLeft, topRight, fracRC.yyzz);
        vec4 bottom = mix(bottomLeft, bottomRight, fracRC.yyzz);
        vec4 newValue = mix(top, bottom, fracRC.x);

        setOutput(newValue);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function D9(n) {
    const { inputs: t, backend: e, attrs: s } = n, { images: o } = t, { alignCorners: r, halfPixelCenters: i, size: a } = s, [l, c] = a, u = F().getBool("WEBGL_PACK_IMAGE_OPERATIONS") ? new W9(o.shape, l, c, r, i) : new M9(o.shape, l, c, r, i);
    return e.runWebGLProgram(u, [
        o
    ], "float32");
}
const F9 = {
    kernelName: Vc,
    backendName: "webgl",
    kernelFunc: D9
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class V9 {
    constructor(t, e, s){
        this.variableNames = [
            "dy"
        ], this.outputShape = [], this.outputShape = e;
        const [, o, r] = e, [, i, a] = t, l = [
            s && i > 1 ? o - 1 : o,
            s && a > 1 ? r - 1 : r
        ], c = [
            s && i > 1 ? i - 1 : i,
            s && a > 1 ? a - 1 : a
        ], u = l[0] / c[0], d = l[1] / c[1], h = 1 / u, p = 1 / d, f = Math.ceil(h) * 2 + 2, m = Math.ceil(p) * 2 + 2;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        int r = coords[1];
        int c = coords[2];

        float accumulator = 0.0;

        const float heightScale = float(${u});
        const float widthScale = float(${d});

        const float invHeightScale = float(${h});
        const float invWidthScale = float(${p});

        const int winHeight = int(${f});
        const int winWidth = int(${m});

        // Compute bounds for where in dy we will look
        float startRLerp = floor(float(r) * invHeightScale);
        int startDyR = int(startRLerp - float(winHeight / 2));

        float startCLerp = floor(float(c) * invWidthScale);
        int startDyC = int(startCLerp - float(winWidth / 2));

        // Loop over dy
        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {
          int dyR = dyROffset + startDyR;

          // Guard against the window exceeding the bounds of dy
          if (dyR < 0 || dyR >= ${i}) {
            continue;
          }

          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {
            int dyC = dyCOffset + startDyC;

            // Guard against the window exceeding the bounds of dy
            if (dyC < 0 || dyC >= ${a}) {
              continue;
            }

            float dxR = float(dyR) * heightScale;
            int topDxRIndex = int(floor(dxR));
            int bottomDxRIndex = int(min(ceil(dxR), ${o - 1}.0));
            float dxRLerp = dxR - float(topDxRIndex);
            float inverseDxRLerp = 1.0 - dxRLerp;

            float dxC = float(dyC) * widthScale;
            int leftDxCIndex = int(floor(dxC));
            int rightDxCIndex = int(min(ceil(dxC), ${r - 1}.0));
            float dxCLerp = dxC - float(leftDxCIndex);
            float inverseDxCLerp = 1.0 - dxCLerp;

            if (r == topDxRIndex && c == leftDxCIndex) {
              // topLeft
              accumulator +=
                getDy(b, dyR, dyC, d) * inverseDxRLerp * inverseDxCLerp;
            }

            if (r == topDxRIndex && c == rightDxCIndex) {
              // topRight
              accumulator += getDy(b, dyR, dyC, d) * inverseDxRLerp * dxCLerp;
            }

            if (r == bottomDxRIndex && c == leftDxCIndex) {
              // bottomLeft
              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * inverseDxCLerp;
            }

            if (r == bottomDxRIndex && c == rightDxCIndex) {
              // bottomRight
              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * dxCLerp;
            }
          }
        }
        // End loop over dy

        setOutput(accumulator);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function z9(n) {
    const { inputs: t, backend: e, attrs: s } = n, { images: o, dy: r } = t, { alignCorners: i } = s, a = new V9(r.shape, o.shape, i);
    return e.runWebGLProgram(a, [
        r
    ], r.dtype);
}
const P9 = {
    kernelName: Mh,
    backendName: "webgl",
    kernelFunc: z9
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class A9 {
    constructor(t, e, s, o, r){
        this.variableNames = [
            "A"
        ], this.outputShape = [];
        const [i, a, l, c] = t;
        this.outputShape = [
            i,
            e,
            s,
            c
        ];
        const u = [
            o && e > 1 ? a - 1 : a,
            o && s > 1 ? l - 1 : l
        ], d = [
            o && e > 1 ? e - 1 : e,
            o && s > 1 ? s - 1 : s
        ], h = o ? "0.5" : "0.0";
        let p;
        r ? p = "max((vec2(yRC) + vec2(0.5)) * effectiveInputOverOutputRatioRC, vec2(0.0))" : p = "vec2(yRC) * effectiveInputOverOutputRatioRC", this.userCode = `
      const vec2 effectiveInputOverOutputRatioRC = vec2(
          ${u[0] / d[0]},
          ${u[1] / d[1]});
      const vec2 inputShapeRC = vec2(${a}.0, ${l}.0);

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        ivec2 yRC = coords.yz;

        // Fractional source index.
        vec2 sourceFracIndexRC = ${p};

        // Compute the coordinators of nearest neighbor point.
        ivec2 sourceNearestRC = ivec2(
          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + ${h})));
        float newValue = getA(b, sourceNearestRC.x, sourceNearestRC.y, d);

        setOutput(newValue);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class O9 {
    constructor(t, e, s, o, r){
        this.variableNames = [
            "A"
        ], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = [];
        const [i, a, l, c] = t;
        this.outputShape = [
            i,
            e,
            s,
            c
        ];
        const u = [
            o && e > 1 ? a - 1 : a,
            o && s > 1 ? l - 1 : l
        ], d = [
            o && e > 1 ? e - 1 : e,
            o && s > 1 ? s - 1 : s
        ], h = o ? "0.5" : "0.0";
        let p;
        r ? p = "max((vec3(yRC) + vec3(0.5)) * effectiveInputOverOutputRatioRC, vec3(0.0))" : p = "vec3(yRC) * effectiveInputOverOutputRatioRC", this.userCode = `
      const vec3 effectiveInputOverOutputRatioRC = vec3(
          ${u[0] / d[0]},
          ${u[1] / d[1]},
          ${u[1] / d[1]});
      const vec3 inputShapeRC = vec3(${a}.0, ${l}.0,
                                     ${l}.0);

      float getAValue(int b, int r, int c, int d) {
        return getChannel(getA(b, r, c, d), vec2(c, d));
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        // Calculate values for next column in yRC.z.
        ivec3 yRC = coords.yzz + ivec3(0, 0, 1);

        // Fractional source index.
        vec3 sourceFracIndexRC = ${p};

        // Compute the coordinators of nearest neighbor point.
        ivec3 sourceNearestRC = ivec3(
          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + ${h})));

        // Should we calculate next column and row elements in 2x2 packed cell.
        bool hasNextCol = d < ${c - 1};
        bool hasNextRow = coords.z < ${s - 1};

        vec4 newValue = vec4(
          getAValue(b, sourceNearestRC.x, sourceNearestRC.y, d),
          hasNextCol ? getAValue(b, sourceNearestRC.x, sourceNearestRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceNearestRC.x, sourceNearestRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceNearestRC.x, sourceNearestRC.z, d + 1) : 0.0);

        setOutput(newValue);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function X9(n) {
    const { inputs: t, backend: e, attrs: s } = n, { images: o } = t, { alignCorners: r, halfPixelCenters: i, size: a } = s, [l, c] = a, u = F().getBool("WEBGL_PACK_IMAGE_OPERATIONS") ? new O9(o.shape, l, c, r, i) : new A9(o.shape, l, c, r, i);
    return e.runWebGLProgram(u, [
        o
    ], o.dtype);
}
const K9 = {
    kernelName: Fc,
    backendName: "webgl",
    kernelFunc: X9
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class Z9 {
    constructor(t, e, s){
        this.variableNames = [
            "dy"
        ], this.outputShape = [], this.outputShape = e;
        const [, o, r] = e, [, i, a] = t, l = [
            s && i > 1 ? o - 1 : o,
            s && a > 1 ? r - 1 : r
        ], c = [
            s && i > 1 ? i - 1 : i,
            s && a > 1 ? a - 1 : a
        ], u = l[0] / c[0], d = l[1] / c[1], h = 1 / u, p = 1 / d, f = Math.ceil(h) * 2 + 2, m = Math.ceil(p) * 2 + 2;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        int r = coords[1];
        int c = coords[2];

        float accumulator = 0.0;

        const float heightScale = float(${u});
        const float widthScale = float(${d});

        const float invHeightScale = float(${h});
        const float invWidthScale = float(${p});

        const int winHeight = int(${f});
        const int winWidth = int(${m});

        // Compute bounds for where in dy we will look
        float startRLerp = floor(float(r) * invHeightScale);
        int startDyR = int(floor(startRLerp - float(winHeight / 2)));

        float startCLerp = floor(float(c) * invWidthScale);
        int startDyC = int(floor(startCLerp - float(winWidth / 2)));

        // Loop over dy
        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {
          int dyR = dyROffset + startDyR;

          // Guard against the window exceeding the bounds of dy
          if (dyR < 0 || dyR >= ${i}) {
            continue;
          }

          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {
            int dyC = dyCOffset + startDyC;

            // Guard against the window exceeding the bounds of dy
            if (dyC < 0 || dyC >= ${a}) {
              continue;
            }

            float sourceFracRow =
              float(${l[0]}) *
                (float(dyR) / float(${c[0]}));

            float sourceFracCol =
                float(${l[1]}) *
                  (float(dyC) / float(${c[1]}));

            int sourceNearestRow = int(min(
                float(int(${o}) - 1),
                ${s} ? float(round(sourceFracRow)) :
                                  float(floor(sourceFracRow))));

            int sourceNearestCol = int(min(
                float(int(${r}) - 1),
                ${s} ? float(round(sourceFracCol)) :
                                  float(floor(sourceFracCol))));

            if (r == sourceNearestRow && c == sourceNearestCol) {
              accumulator += getDy(b, dyR, dyC, d);
            }
          }
        }
        // End loop over dy

        setOutput(accumulator);
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function B9(n) {
    const { inputs: t, backend: e, attrs: s } = n, { images: o, dy: r } = t, { alignCorners: i } = s, a = new Z9(r.shape, o.shape, i);
    return e.runWebGLProgram(a, [
        r
    ], r.dtype);
}
const H9 = {
    kernelName: Lh,
    backendName: "webgl",
    kernelFunc: B9
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class _9 {
    constructor(t, e){
        this.variableNames = [
            "x"
        ];
        const s = t.length;
        if (s > 4) throw new Error(`WebGL backend: Reverse of rank-${s} tensor is not yet supported`);
        if (this.outputShape = t, s === 1) {
            this.userCode = `
        void main() {
          int coord = getOutputCoords();
          setOutput(getX(${t[0]} - coord - 1));
        }
      `;
            return;
        }
        const o = (a)=>e.indexOf(a) !== -1 && t[a] !== 1 ? `${t[a]} - coords[${a}] - 1` : `coords[${a}]`, r = t.map((a, l)=>o(l)).join(","), i = Vt(s);
        this.userCode = `
      void main() {
        ${i} coords = getOutputCoords();
        setOutput(getX(${r}));
      }
    `;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class U9 {
    constructor(t, e){
        this.variableNames = [
            "x"
        ], this.packedInputs = !0, this.packedOutput = !0;
        const s = t.length;
        if (s > 4) throw new Error(`WebGL backend: Reverse of rank-${s} tensor is not yet supported`);
        this.outputShape = t;
        const o = Fe("rc", s), r = `${o[s - 1]} + 1 < ${this.outputShape[s - 1]}`, i = `${o[s - 2]} + 1 < ${this.outputShape[s - 2]}`, a = Vt(s);
        s === 1 ? this.userCode = `
        void main(){
          int rc = getOutputCoords();
          vec4 result = vec4(0.);
          result.r = getChannel(getX(${t[0]} - rc - 1),
            ${t[0]} - rc - 1);
          if(${r}){
              result.g = getChannel(getX(${t[0]} - (rc  + 1) - 1),
                ${t[0]} - (rc  + 1) - 1);
          }
          setOutput(result);
        }
      ` : this.userCode = `
        void main() {
          ${a} rc = getOutputCoords();
          vec4 result = vec4(0.);
          result.r = ${l(o.slice())};
          if(${r}){
            result.g = ${c(o.slice())};
          }
          if(${i}) {
            result.b = ${u(o.slice())};
            if(${r}) {
              result.a = ${d(o.slice())};
            }
          }
          setOutput(result);
        }
    `;
        function l(f) {
            return h(f);
        }
        function c(f) {
            return f[s - 1] = "(" + f[s - 1] + " + 1)", h(f);
        }
        function u(f) {
            return f[s - 2] = "(" + f[s - 2] + " + 1)", h(f);
        }
        function d(f) {
            return f[s - 1] = "(" + f[s - 1] + " + 1)", f[s - 2] = "(" + f[s - 2] + " + 1)", h(f);
        }
        function h(f) {
            const m = t.map((x, w)=>p(w, f)), g = m.join(","), b = m.slice(-2).join(",");
            return `getChannel(getX(${g}), vec2(${b}))`;
        }
        function p(f, m) {
            return e.indexOf(f) !== -1 && t[f] !== 1 ? `${t[f]} - ${m[f]} - 1` : `${m[f]}`;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function Y9(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { dims: r } = s, i = o.shape.length, a = Ct(r, o.shape);
    if (i === 0) return nn({
        inputs: {
            x: o
        },
        backend: e
    });
    const l = F().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new U9(o.shape, a) : new _9(o.shape, a);
    return e.runWebGLProgram(l, [
        o
    ], o.dtype);
}
const Q9 = {
    kernelName: zc,
    backendName: "webgl",
    kernelFunc: Y9
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class J9 {
    constructor(t, e){
        this.variableNames = [
            "Image"
        ], this.outputShape = [], this.customUniforms = [
            {
                name: "params",
                type: "vec4"
            }
        ];
        const s = t[1], o = t[2];
        this.outputShape = t;
        let r = "";
        typeof e == "number" ? r = `float outputValue = ${e.toFixed(2)};` : r = `
        vec3 fill = vec3(${e.join(",")});
        float outputValue = fill[coords[3]];`, this.userCode = `
        void main() {
          ivec4 coords = getOutputCoords();
          int x = coords[2];
          int y = coords[1];
          float coordXFloat = (float(x) - params[0]) * params[3] -
            (float(y) - params[1]) * params[2];
          float coordYFloat = (float(x) - params[0]) * params[2] +
            (float(y) - params[1]) * params[3];
          int coordX = int(round(coordXFloat + params[0]));
          int coordY = int(round(coordYFloat + params[1]));
          ${r}
          if(coordX >= 0 && coordX < ${o} && coordY >= 0 && coordY < ${s}) {
            outputValue = getImage(coords[0], coordY, coordX, coords[3]);
          }
          setOutput(outputValue);
        }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const j9 = {
    kernelName: Hh,
    backendName: "webgl",
    kernelFunc: ({ inputs: n, attrs: t, backend: e })=>{
        const { image: s } = n, { radians: o, fillValue: r, center: i } = t, a = e, l = new J9(s.shape, r), [c, u] = Jp(i, s.shape[1], s.shape[2]), d = [
            [
                c,
                u,
                Math.sin(o),
                Math.cos(o)
            ]
        ];
        return a.runWebGLProgram(l, [
            s
        ], s.dtype, d);
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const q9 = `
  // OpenGL ES does not support round function.
  // The algorithm is based on banker's rounding.
  float base = floor(x);
  if ((x - base) < 0.5) {
    return floor(x);
  } else if ((x - base) > 0.5) {
    return ceil(x);
  } else {
    if (mod(base, 2.0) == 0.0) {
      return base;
    } else {
      return base + 1.0;
    }
  }
`, tU = Nt({
    opSnippet: q9
}), eU = {
    kernelName: sa,
    backendName: "webgl",
    kernelFunc: tU
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const nU = "return inversesqrt(x);", sU = Nt({
    opSnippet: nU,
    cpuKernelImpl: mO
}), oU = {
    kernelName: oa,
    backendName: "webgl",
    kernelFunc: sU
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class lm {
    constructor(t, e, s, o, r, i, a = !0, l = !1){
        this.variableNames = [
            "updates",
            "indices",
            "defaultValue"
        ], this.outputShape = i;
        const c = Vt(r.length), u = Vt(i.length);
        let d = "";
        s === 1 ? d = "i" : s === 2 && (d = "i, j");
        const h = `getIndices(${d})`;
        let p = "";
        o === 1 ? p = "i" : o === 2 && (p = "i, coords[1]");
        const f = `getUpdates(${p})`;
        let m = "";
        l && (m = "coords[0], coords[1]");
        const g = `getDefaultValue(${m})`, b = e > 1 ? "strides[j]" : "strides";
        this.userCode = `
        ${c} strides = ${c}(${r});

        void main() {
          ${u} coords = getOutputCoords();
          float sum = 0.0;
          bool found = false;
          for (int i = 0; i < ${t}; i++) {
            int flattenedIndex = 0;
            for (int j = 0; j < ${e}; j++) {
              int index = round(${h});
              flattenedIndex += index * ${b};
            }
            if (flattenedIndex == coords[0]) {
              sum += ${f};
              found = true;
            }
          }
          setOutput(mix(${g}, sum, float(found)));
        }
      `;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class rU {
    constructor(t, e, s, o, r, i, a = !0, l = !1){
        this.variableNames = [
            "updates",
            "indices",
            "defaultValue"
        ], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = i;
        const c = Vt(r.length), u = Vt(i.length);
        let d = "";
        s === 1 ? d = "i" : s === 2 && (d = "i, j");
        const h = `getIndices(${d})`;
        let p = "";
        o === 1 ? p = "i" : o === 2 && (p = "i, coords[1]");
        const f = `getUpdates(${p})`;
        let m = "";
        l && (m = "coords[0], coords[1]");
        const g = `getDefaultValue(${m})`, b = e > 1 ? "strides[j]" : "strides", x = e > 1 ? "strides[j + 1]" : "strides";
        this.userCode = `
        ${c} strides = ${c}(${r});

        void main() {
          ${u} coords = getOutputCoords();
          vec4 sum = vec4(0.);
          vec4 found = vec4(0.);
          for (int i = 0; i < ${t}; i+=2) {
            ivec2 flattenedIndex = ivec2(0);
            for (int j = 0; j < ${e}; j+=2) {
              ivec4 index = round(${h});
              flattenedIndex += index.xz * ${b};
              if (j + 1 < ${e}) {
                flattenedIndex += index.yw * ${x};
              }
            }
            if (flattenedIndex[0] == coords[0] || flattenedIndex[1] == coords[0] ||
                flattenedIndex[0] == coords[0] + 1 || flattenedIndex[1] == coords[0] + 1) {
              vec4 updVals = ${f};
              if (flattenedIndex[0] == coords[0]) {
                sum.xy += updVals.xy;
                found.xy = vec2(1.);
              } else if (flattenedIndex[0] == coords[0] + 1) {
                sum.zw += updVals.xy;
                found.zw = vec2(1.);
              }
              if (flattenedIndex[1] == coords[0]) {
                sum.xy += updVals.zw;
                found.xy = vec2(1.);
              } else if (flattenedIndex[1] == coords[0] + 1) {
                sum.zw += updVals.zw;
                found.zw = vec2(1.);
              }
            }
          }
          setOutput(mix(${g}, sum, found));
        }
      `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function iU(n) {
    const { inputs: t, backend: e, attrs: s } = n, { indices: o, updates: r } = t, { shape: i } = s, { sliceRank: a, numUpdates: l, sliceSize: c, strides: u, outputSize: d } = to(r, o, i), h = [
        d / c,
        c
    ];
    if (d === 0) return e.makeTensorInfo(i, o.dtype);
    const p = et({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            shape: [
                l,
                a
            ]
        }
    }), f = et({
        inputs: {
            x: r
        },
        backend: e,
        attrs: {
            shape: [
                l,
                c
            ]
        }
    }), m = e.makeTensorInfo([], "float32", new Float32Array([
        0
    ]));
    let g;
    F().getBool("WEBGL_PACK") ? g = new rU(l, a, p.shape.length, f.shape.length, u, h) : g = new lm(l, a, p.shape.length, f.shape.length, u, h);
    const b = e.runWebGLProgram(g, [
        f,
        p,
        m
    ], f.dtype), x = et({
        inputs: {
            x: b
        },
        backend: e,
        attrs: {
            shape: i
        }
    });
    return e.disposeIntermediateTensorInfo(p), e.disposeIntermediateTensorInfo(f), e.disposeIntermediateTensorInfo(b), e.disposeIntermediateTensorInfo(m), x;
}
const aU = {
    kernelName: xb,
    backendName: "webgl",
    kernelFunc: iU
};
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class lU {
    constructor(t, e, s, o){
        this.variableNames = [
            "sortedSequence",
            "values"
        ], this.customUniforms = [
            {
                name: "numInputs",
                type: "int"
            }
        ], this.outputShape = [
            t,
            s
        ];
        const r = "while (left < right) {", i = `for (int i = 0; i < ${Math.ceil(Math.log2(e + 1))}; ++i) { if (left >= right) break;`, a = F().getNumber("WEBGL_VERSION") === 2 ? r : i, l = o === "left" ? "<" : "<=";
        this.userCode = `
       int findBound(int batch, float value) {
         int left = 0;
         int right = numInputs;
         int mid;
         ${a}
           mid = (left + right) / 2;
           if (getSortedSequence(batch, mid) ${l} value) {
             left = mid + 1;
           } else {
             right = mid;
           }
         }
         return right;
       }

       void main() {
         ivec2 coords = getOutputCoords();
         int batch = coords[0];
         int valueIndex = coords[1];

         float value = getValues(batch, valueIndex);

         setOutput(float(findBound(batch, value)));
       }
     `;
    }
}
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function cU(n) {
    const { inputs: t, backend: e, attrs: s } = n, { sortedSequence: o, values: r } = t, { side: i } = s, a = new lU(o.shape[0], o.shape[1], r.shape[1], i), l = [
        [
            o.shape[1]
        ]
    ];
    return e.runWebGLProgram(a, [
        o,
        r
    ], "int32", l);
}
const uU = {
    kernelName: wb,
    backendName: "webgl",
    kernelFunc: cU
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class dU {
    constructor(t, e, s){
        this.variableNames = [
            "c",
            "a",
            "b"
        ], this.outputShape = e;
        let o, r;
        if (s > 4) throw Error(`Where for rank ${s} is not yet supported`);
        if (s === 1) r = "resRC", o = "resRC";
        else {
            const a = [
                "resRC.x",
                "resRC.y",
                "resRC.z",
                "resRC.w"
            ], l = [], c = [];
            for(let u = 0; u < e.length; u++)c.push(`${a[u]}`), u < t && l.push(`${a[u]}`);
            o = l.join(), r = c.join();
        }
        const i = Vt(s);
        this.userCode = `
      void main() {
        ${i} resRC = getOutputCoords();
        float cVal = getC(${o});
        if (cVal >= 1.0) {
          setOutput(getA(${r}));
        } else {
          setOutput(getB(${r}));
        }
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function hU(n) {
    const { inputs: t, backend: e } = n, { condition: s, t: o, e: r } = t, i = new dU(s.shape.length, o.shape, o.shape.length);
    return e.runWebGLProgram(i, [
        s,
        o,
        r
    ], tn(o.dtype, r.dtype));
}
const pU = {
    kernelName: Pc,
    backendName: "webgl",
    kernelFunc: hU
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const fU = `
  // Stable and Attracting Fixed Point (0, 1) for Normalized Weights.
  // see: https://arxiv.org/abs/1706.02515
  float scaleAlpha = ${ru};
  float scale = ${iu};
  return (x >= 0.0) ? scale * x : scaleAlpha * (exp(x) - 1.0);
`, mU = Nt({
    opSnippet: fU
}), gU = {
    kernelName: ra,
    backendName: "webgl",
    kernelFunc: mU
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const bU = Vr + `
  return 1.0 / (1.0 + exp(-1.0 * x));
`, xU = `
  vec4 result = 1.0 / (1.0 + exp(-1.0 * x));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`, yU = Nt({
    opSnippet: bU,
    packedOpSnippet: xU,
    cpuKernelImpl: bO
}), wU = {
    kernelName: ca,
    backendName: "webgl",
    kernelFunc: yU
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const IU = `
  if (isnan(x)) { return 0.0; }
  return sign(x);
`, CU = Nt({
    opSnippet: IU
}), vU = {
    kernelName: la,
    backendName: "webgl",
    kernelFunc: CU
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const SU = Vr + `
  return sin(x);
`, kU = `
  vec4 result = sin(x);
  bvec4 isNaN = isnan(x);
  ${jo}
  return result;
`, TU = Nt({
    opSnippet: SU,
    packedOpSnippet: kU
}), NU = {
    kernelName: ia,
    backendName: "webgl",
    kernelFunc: TU
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const RU = `
  float e2x = exp(x);
  return (e2x - 1.0 / e2x) / 2.0;
`, $U = Nt({
    opSnippet: RU
}), GU = {
    kernelName: aa,
    backendName: "webgl",
    kernelFunc: $U
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const EU = `
  float epsilon = 1.1920928955078125e-7;
  float threshold = log(epsilon) + 2.0;

  bool too_large = x > -threshold;
  bool too_small = x < threshold;

  float result;
  float exp_x = exp(x);

  if (too_large){
    result = x;
  }
  else if (too_small){
    result = exp_x;
  }
  else{
    result = log(exp_x + 1.0);
  }
  return result;
`, LU = Nt({
    opSnippet: EU
}), MU = {
    kernelName: ua,
    backendName: "webgl",
    kernelFunc: LU
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const WU = (n)=>{
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { blockShape: r, paddings: i } = s;
    C(o.shape.length <= 4, ()=>"spaceToBatchND for rank > 4 with a WebGL backend not implemented yet");
    const a = r.reduce((b, x)=>b * x), l = [
        [
            0,
            0
        ]
    ];
    l.push(...i);
    for(let b = 1 + r.length; b < o.shape.length; ++b)l.push([
        0,
        0
    ]);
    const c = [], u = xC({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            paddings: l,
            constantValue: 0
        }
    }), d = Na(u.shape, r, a, !1), h = Ra(d.length, r.length, !1), p = $a(u.shape, r, a, !1), f = et({
        inputs: {
            x: u
        },
        backend: e,
        attrs: {
            shape: d
        }
    }), m = ze({
        inputs: {
            x: f
        },
        backend: e,
        attrs: {
            perm: h
        }
    }), g = et({
        inputs: {
            x: m
        },
        backend: e,
        attrs: {
            shape: p
        }
    });
    return c.push(u), c.push(f), c.push(m), c.forEach((b)=>e.disposeIntermediateTensorInfo(b)), g;
}, DU = {
    kernelName: Xc,
    backendName: "webgl",
    kernelFunc: WU
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function FU(n) {
    const { inputs: t, backend: e } = n, { indices: s, values: o, denseShape: r, defaultValue: i } = t;
    if (r.shape.length !== 1) throw new Error(`Dense shape must be a vector, saw:
         ${r.shape}`);
    if (s.shape.length !== 2) throw new Error(`Indices must be a matrix, saw:
         ${s.shape}`);
    if (o.shape.length !== 1) throw new Error(`Values must be a vector, saw:
         ${o.shape}`);
    if (i.shape.length !== 0) throw new Error(`Default value must be a scalar, saw:
        ${i.shape}`);
    const a = e.readSync(s.dataId), l = e.readSync(o.dataId), c = e.readSync(r.dataId), u = e.readSync(i.dataId)[0], [d, h, p, f, m] = yO(a, s.shape, s.dtype, l, o.dtype, c, u);
    return [
        e.makeTensorInfo(h, s.dtype, d),
        e.makeTensorInfo([
            h[0]
        ], o.dtype, p),
        e.makeTensorInfo([
            f.length
        ], "bool", new Uint8Array(f.map((g)=>Number(g)))),
        e.makeTensorInfo([
            m.length
        ], s.dtype, new Int32Array(m))
    ];
}
const VU = {
    kernelName: Wh,
    backendName: "webgl",
    kernelFunc: FU
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function zU(n) {
    const { inputs: t, backend: e } = n, { inputIndices: s, inputShape: o, newShape: r } = t;
    if (s.shape.length !== 2) throw new Error(`Input indices should be a matrix but received shape ${s.shape}`);
    if (o.shape.length !== 1) throw new Error(`Input shape should be a vector but received shape ${o.shape}`);
    if (r.shape.length !== 1) throw new Error(`Target shape should be a vector but received shape ${r.shape}`);
    const i = Array.from(e.readSync(o.dataId)), a = e.readSync(s.dataId), l = Array.from(e.readSync(r.dataId)), [c, u, d] = wO(a, s.shape, s.dtype, i, l);
    return [
        e.makeTensorInfo(u, s.dtype, c),
        e.makeTensorInfo([
            d.length
        ], r.dtype, new Int32Array(d))
    ];
}
const PU = {
    kernelName: Dh,
    backendName: "webgl",
    kernelFunc: zU
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function AU(n) {
    const { inputs: t, backend: e } = n, { data: s, indices: o, segmentIds: r } = t;
    if (s.shape.length < 1) throw new Error("Data should be at least 1 dimensional but received scalar");
    if (o.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
              ${o.shape}`);
    if (r.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
              ${r.shape}`);
    const i = e.readSync(s.dataId), a = e.readSync(o.dataId), l = e.readSync(r.dataId), [c, u] = KI(i, s.shape, s.dtype, a, l, !0);
    return e.makeTensorInfo(u, s.dtype, c);
}
const OU = {
    kernelName: Fh,
    backendName: "webgl",
    kernelFunc: AU
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function XU(n) {
    const { inputs: t, backend: e } = n, { data: s, indices: o, segmentIds: r } = t;
    if (s.shape.length < 1) throw new Error("Data should be at least 1 dimensional but received scalar");
    if (o.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
             ${o.shape}`);
    if (r.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
             ${r.shape}`);
    const i = e.readSync(s.dataId), a = e.readSync(o.dataId), l = e.readSync(r.dataId), [c, u] = KI(i, s.shape, s.dtype, a, l);
    return e.makeTensorInfo(u, s.dtype, c);
}
const KU = {
    kernelName: Vh,
    backendName: "webgl",
    kernelFunc: XU
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function ZU(n) {
    const { inputs: t, backend: e, attrs: s } = n, { sparseIndices: o, sparseValues: r, defaultValue: i } = t, { outputShape: a } = s, { sliceRank: l, numUpdates: c, sliceSize: u, strides: d, outputSize: h } = to(r, o, a), p = !1;
    if (r.dtype === "string") {
        const b = e.bufferSync(o), x = e.bufferSync(r), w = gs(e.readSync(i.dataId)[0]), y = gO(b, x, a, h, u, c, l, d, w, p);
        return e.makeTensorInfo(a, y.dtype, y.values);
    }
    const f = new lm(c, l, o.shape.length, r.shape.length, d, [
        h,
        1
    ], p), m = e.runWebGLProgram(f, [
        r,
        o,
        i
    ], r.dtype), g = et({
        inputs: {
            x: m
        },
        backend: e,
        attrs: {
            shape: a
        }
    });
    return e.disposeIntermediateTensorInfo(m), g;
}
const BU = {
    kernelName: Ib,
    backendName: "webgl",
    kernelFunc: ZU
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function HU(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { numOrSizeSplits: r, axis: i } = s, a = Ct(i, o.shape)[0], l = pf(o, r, a), c = o.shape.length, u = new Array(c).fill(0), d = o.shape.slice();
    return l.map((h)=>{
        const p = [
            ...d
        ];
        p[a] = h;
        const f = zr({
            inputs: {
                x: o
            },
            backend: e,
            attrs: {
                begin: u,
                size: p
            }
        });
        return u[a] += h, f;
    });
}
const _U = {
    kernelName: Kc,
    backendName: "webgl",
    kernelFunc: HU
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Ag = "return sqrt(x);", UU = Nt({
    opSnippet: Ag,
    packedOpSnippet: Ag,
    cpuKernelImpl: IO
}), YU = {
    kernelName: da,
    backendName: "webgl",
    kernelFunc: UU
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const QU = "return x * x;", JU = Nt({
    opSnippet: QU
}), jU = {
    kernelName: zh,
    backendName: "webgl",
    kernelFunc: JU
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const Og = "return (a - b) * (a - b);", qU = Re({
    opSnippet: Og,
    packedOpSnippet: Og
}), t5 = {
    kernelName: ha,
    backendName: "webgl",
    kernelFunc: qU
};
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function e5(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t;
    if (o.dtype !== "string") throw new Error("Input must be of datatype string");
    const r = e.readSync(o.dataId), i = ys(r), a = CO(i, "string", s);
    return e.makeTensorInfo(o.shape, "string", a);
}
const n5 = {
    kernelName: Bc,
    backendName: "webgl",
    kernelFunc: e5
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function s5({ inputs: n, attrs: t, backend: e }) {
    const { x: s } = n, o = En + `
    return x > 0.0 ? 1.0 : float(${t.alpha});
  `, r = new qn(s.shape, o);
    return e.runWebGLProgram(r, [
        s
    ], s.dtype);
}
const o5 = {
    kernelName: ba,
    backendName: "webgl",
    kernelFunc: s5
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class r5 {
    constructor(t, e, s){
        this.variableNames = [
            "x"
        ], this.outputShape = s;
        const o = s.length, r = Vt(s.length), i = Vt(s.length);
        let a = "";
        if (o === 1) a = "coords * strides + begin";
        else {
            let l = 0;
            a = s.map((c, u)=>(l++, s.length === 1 ? `coords * strides[${u}] + begin[${u}]` : `coords[${l - 1}] * strides[${u}] + begin[${u}]`)).join(",");
        }
        this.userCode = `
      ${r} begin = ${r}(${t});
      ${r} strides = ${r}(${e});

      void main() {
        ${i} coords = getOutputCoords();
        setOutput(getX(${a}));
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function i5(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { begin: r, end: i, strides: a, beginMask: l, endMask: c, ellipsisMask: u, newAxisMask: d, shrinkAxisMask: h } = s, { finalShapeSparse: p, finalShape: f, isIdentity: m, sliceDim0: g, isSimpleSlice: b, begin: x, end: w, strides: y } = Up(o.shape, r, i, a, l, c, u, d, h);
    let I;
    if (m) I = et({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            shape: f
        }
    });
    else if (g || b) {
        C(o.shape.length >= 1, ()=>`Input must have rank at least 1, got: ${o.shape.length}`);
        const k = Bp(x, w, y), S = zr({
            inputs: {
                x: o
            },
            backend: e,
            attrs: {
                begin: x,
                size: k
            }
        });
        I = et({
            inputs: {
                x: S
            },
            backend: e,
            attrs: {
                shape: f
            }
        }), e.disposeIntermediateTensorInfo(S);
    } else if (e.shouldExecuteOnCPU([
        o
    ])) {
        const S = e.readSync(o.dataId), N = vt(o.shape, o.dtype, S), R = vO(p, N, y, x);
        I = e.makeTensorInfo(f, o.dtype, R.values);
    } else {
        const S = new r5(x, y, p);
        I = e.runWebGLProgram(S, [
            o
        ], o.dtype);
    }
    const v = et({
        inputs: {
            x: I
        },
        backend: e,
        attrs: {
            shape: f
        }
    });
    return e.disposeIntermediateTensorInfo(I), v;
}
const a5 = {
    kernelName: Ph,
    backendName: "webgl",
    kernelFunc: i5
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function l5(n) {
    const { inputs: t, backend: e, attrs: s } = n, { separator: o, nGramWidths: r, leftPad: i, rightPad: a, padWidth: l, preserveShortSequences: c } = s, { data: u, dataSplits: d } = t, h = e.readSync(u.dataId), p = e.readSync(d.dataId), [f, m] = SO(h, p, o, r, i, a, l, c);
    return [
        e.makeTensorInfo([
            f.length
        ], "string", f),
        e.makeTensorInfo(d.shape, "int32", m)
    ];
}
const c5 = {
    kernelName: Ah,
    backendName: "webgl",
    kernelFunc: l5
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function u5(n) {
    const { inputs: t, backend: e, attrs: s } = n, { skipEmpty: o } = s, { input: r, delimiter: i } = t;
    if (r.dtype !== "string") throw new Error("Input must be of datatype string");
    if (r.shape.length !== 1) throw new Error(`Input must be a vector, got shape: ${r.shape}`);
    if (i.shape.length !== 0) throw new Error(`Delimiter must be a scalar, got shape: ${i.shape}`);
    const a = e.readSync(r.dataId), l = e.readSync(i.dataId)[0], [c, u, d] = kO(a, l, o), h = u.length;
    return [
        e.makeTensorInfo([
            h,
            2
        ], "int32", c),
        e.makeTensorInfo([
            h
        ], "string", u),
        e.makeTensorInfo([
            2
        ], "int32", new Int32Array(d))
    ];
}
const d5 = {
    kernelName: Oh,
    backendName: "webgl",
    kernelFunc: u5
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function h5(n) {
    const { inputs: t, backend: e, attrs: s } = n, { numBuckets: o } = s, { input: r } = t;
    if (r.dtype !== "string") throw new Error("Input must be of datatype string");
    if (o <= 0) throw new Error("Number of buckets must be at least 1");
    const i = e.readSync(r.dataId), a = TO(i, o);
    return e.makeTensorInfo(r.shape, "int32", a);
}
const p5 = {
    kernelName: Xh,
    backendName: "webgl",
    kernelFunc: h5
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const f5 = "return tan(x);", m5 = Nt({
    opSnippet: f5
}), g5 = {
    kernelName: fa,
    backendName: "webgl",
    kernelFunc: m5
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const b5 = `
  float e2x = exp(-2.0 * abs(x));
  return sign(x) * (1.0 - e2x) / (1.0 + e2x);
`, x5 = Nt({
    opSnippet: b5
}), y5 = {
    kernelName: ma,
    backendName: "webgl",
    kernelFunc: x5
};
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function w5(n) {
    const { inputs: t, backend: e, attrs: s } = n, { tensor: o, indices: r, updates: i } = t, { sliceRank: a, numUpdates: l, sliceSize: c, strides: u, outputSize: d } = to(i, r, o.shape), h = [
        d / c,
        c
    ];
    if (d === 0) return e.makeTensorInfo(o.shape, r.dtype);
    const p = et({
        inputs: {
            x: r
        },
        backend: e,
        attrs: {
            shape: [
                l,
                a
            ]
        }
    }), f = et({
        inputs: {
            x: i
        },
        backend: e,
        attrs: {
            shape: [
                l,
                c
            ]
        }
    }), m = et({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            shape: h
        }
    }), g = new lm(l, a, p.shape.length, f.shape.length, u, h, !1, !0), b = e.runWebGLProgram(g, [
        f,
        p,
        m
    ], m.dtype), x = et({
        inputs: {
            x: b
        },
        backend: e,
        attrs: {
            shape: o.shape
        }
    });
    return e.disposeIntermediateTensorInfo(p), e.disposeIntermediateTensorInfo(f), e.disposeIntermediateTensorInfo(m), e.disposeIntermediateTensorInfo(b), x;
}
const I5 = {
    kernelName: yb,
    backendName: "webgl",
    kernelFunc: w5
};
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class C5 {
    constructor(t, e){
        this.variableNames = [
            "A"
        ];
        const s = new Array(t.length);
        for(let i = 0; i < s.length; i++)s[i] = t[i] * e[i];
        this.outputShape = s, this.rank = s.length;
        const o = Vt(this.rank), r = v5(t);
        this.userCode = `
      void main() {
        ${o} resRC = getOutputCoords();
        setOutput(getA(${r}));
      }
    `;
    }
}
function v5(n) {
    const t = n.length;
    if (t > 5) throw Error(`Tile for rank ${t} is not yet supported`);
    if (t === 1) return `imod(resRC, ${n[0]})`;
    const e = [
        "resRC.x",
        "resRC.y",
        "resRC.z",
        "resRC.w",
        "resRC.u"
    ], s = [];
    for(let o = 0; o < n.length; o++)s.push(`imod(${e[o]}, ${n[o]})`);
    return s.join();
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function wC(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { reps: r } = s;
    if (o.dtype === "string" || o.shape.length > 5) {
        const l = e.readSync(o.dataId), c = o.dtype === "string" ? l.map((h)=>gs(h)) : l, u = vt(o.shape, o.dtype, c), d = RO(u, r);
        return e.makeTensorInfo(d.shape, d.dtype, d.values);
    }
    const i = new C5(o.shape, r);
    return e.runWebGLProgram(i, [
        o
    ], o.dtype);
}
const S5 = {
    kernelName: ga,
    backendName: "webgl",
    kernelFunc: wC
};
class k5 {
    /**
   * @param shape desired output shape (can be larger than input shape, output
   *                                    will be padded with -Infinity)
   */ constructor(t){
        this.variableNames = [
            "x",
            "indices"
        ], this.customUniforms = [
            {
                name: "n",
                type: "int"
            },
            {
                name: "firstPass",
                type: "int"
            },
            {
                name: "negativeInf",
                type: "float"
            },
            {
                name: "dir",
                type: "int"
            },
            {
                name: "inc",
                type: "int"
            }
        ], this.outputShape = t, this.userCode = `
       void main() {
         ivec2 coords = getOutputCoords();
         int batch = coords[0];
         int elemIdx = coords[1];

         // We compare elements pair-wise within a group of size 2 * inc.
         // The comparing rule for each group alternates between ascending
         // and descending. Within each group, we compare each pair at
         // positions i and i+inc. To decide whether an element at position i
         // is x0 or x1, we mod it by 2 * inc, if the result is smaller than
         // inc, it is in the first half of the group, we denote it as x0,
         // otherwise we denote it as x1.
         // For example, as shown in the Bitonic top K paper referenced above,
         // Figure5(a) shows that element[1] is in the
         // second half of the group when group size is 2, but it is in the
         // first half of the group when group size is 4.

         bool isFirstInPair = imod(elemIdx, 2 * inc) < inc;
         int i = isFirstInPair ? elemIdx : elemIdx - inc;

         int i0 = firstPass == 1 ? i : int(getIndices(batch, i));
         int i1 = firstPass == 1 ? i + inc : int(getIndices(batch, i + inc));
         float x0 = i0 < n ? getX(batch, i0) : negativeInf;
         float x1 = i1 < n ? getX(batch, i1) : negativeInf;

         // Denotes which direction indices are in (ascending or descending).
         bool reverse = imod(elemIdx, 2 * dir) >= dir;
         bool isGreater = x0 > x1 || (x0 == x1 && i1 > i0);
         if (reverse == isGreater) { // Elements in opposite order of direction
           int iTemp = i0;
           i0 = i1;
           i1 = iTemp;
         }
         if (isFirstInPair) {
            setOutput(float(i0));
         } else {
            setOutput(float(i1));
         }
       }
     `;
    }
}
class T5 {
    /**
   * @param shape desired output shape (must be half of the input size)
   */ constructor(t){
        this.variableNames = [
            "x",
            "indices"
        ], this.customUniforms = [
            {
                name: "n",
                type: "int"
            },
            {
                name: "firstPass",
                type: "int"
            },
            {
                name: "k",
                type: "int"
            }
        ], this.outputShape = t, this.userCode = `
    void main() {
         // Takes max of indices (0, k), (1, k + 1), (2, k + 2) ...
         ivec2 coords = getOutputCoords();
         int batch = coords[0];
         int elemIdx = coords[1];

         // The output size is half of the previous size.
         // If the previous sequence is | | | | _ _ _ _  | | | |  _ _ _ _ (k=4),
         // we only need to output the indices at positions |, the indices at
         // positions _ can be thrown away, see Figure5(b) After Phase 2
         // (Merge phase) in the Bitonic Top K paper referenced above.
         // For example, the paper shows we only need to output the orange bars.
         // The output sequence should look like this | | | | | | | |.
         // Because the sequence is halved, to map the output index back
         // to the previous sequence to find the corresponding value,
         // we need to double the index. When we double the index,
         // we basically interpolate a position, so 2i looks like
         // | _ | _ | _ | _ | _ | _ | _. We move the | to the first k position
         // of each 2k positions by - elemIdx % k. E.g. for output at
         // index 4,5,6,7, we want to get the corresponding element at
         // original index 8,9,10,11, for output at index 8,9,10,11,
         // we want to get the corresponding element at original index
         // 16,17,18,19, so on and so forth.

         int i = elemIdx < k ? elemIdx : (elemIdx * 2 - imod(elemIdx, k));
         int i0 = firstPass == 1 ? i : int(getIndices(batch, i));
         int i1 = firstPass == 1 ? i + k : int(getIndices(batch, i + k));

         float x0 = getX(batch, i0);
         float x1 = i1 < n ? getX(batch, i1) : x0;

         setOutput(x0 >= x1 ? float(i0) : float(i1));
       }
     `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function lo(n, t) {
    t !== null && n.disposeIntermediateTensorInfo(t);
}
function Xg(n) {
    let t = 1;
    for(; t < n;)t *= 2;
    return t;
}
function N5(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o } = t, { k: r, sorted: i } = s, a = F().getNumber("TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD"), l = F().getNumber("TOPK_K_CPU_HANDOFF_THRESHOLD"), c = o.shape, u = c[c.length - 1];
    if (e.shouldExecuteOnCPU([
        o
    ]) || u < a || r > l) {
        const R = e.readSync(o.dataId), [M, V] = $O(R, c, o.dtype, r, i);
        return [
            e.makeTensorInfo(M.shape, M.dtype, M.values),
            e.makeTensorInfo(V.shape, V.dtype, V.values)
        ];
    }
    if (r === 0) return c[c.length - 1] = 0, [
        e.makeTensorInfo(c, o.dtype, []),
        e.makeTensorInfo(c, "int32", [])
    ];
    if (u === 1) return [
        o,
        Xa({
            attrs: {
                shape: c,
                dtype: "int32",
                value: 0
            },
            backend: e
        })
    ];
    const d = e.texData.get(o.dataId), h = d !== null && d.isPacked, p = h ? e.unpackTensor(o) : o, m = X(c) / u, g = et({
        inputs: {
            x: p
        },
        attrs: {
            shape: [
                m,
                u
            ]
        },
        backend: e
    });
    h && lo(e, p);
    const b = Xg(r), x = Xg(u);
    let w = null;
    const y = ()=>w === null ? [
            g,
            g
        ] : [
            g,
            w
        ], I = (R, M, V)=>{
        const z = y(), P = new k5(V), O = [
            [
                u
            ],
            [
                w === null ? 1 : 0
            ],
            [
                Number.NEGATIVE_INFINITY
            ],
            [
                R
            ],
            [
                M
            ]
        ], B = w;
        w = e.runWebGLProgram(P, z, "int32", O), lo(e, B);
    };
    for(let R = 1; R < b; R *= 2){
        const M = R * 2;
        for(let V = R; V >= 1; V /= 2)I(M, V, [
            m,
            x
        ]);
    }
    for(let R = x; R > b; R /= 2){
        const M = y(), V = new T5([
            m,
            R / 2
        ]), P = [
            [
                u
            ],
            [
                w === null ? 1 : 0
            ],
            [
                b
            ]
        ], A = w;
        w = e.runWebGLProgram(V, M, "int32", P), lo(e, A);
        const O = b / 2, B = O * 2;
        for(let Z = O; Z >= 1; Z /= 2)I(B, Z, w.shape);
    }
    let v = w;
    w = zr({
        inputs: {
            x: w
        },
        backend: e,
        attrs: {
            begin: 0,
            size: [
                m,
                r
            ]
        }
    }), lo(e, v);
    let k = hC({
        inputs: {
            x: g,
            indices: w
        },
        backend: e,
        attrs: {
            axis: 1,
            batchDims: 1
        }
    });
    lo(e, g);
    const S = c.slice(0, -1);
    S.push(r), v = w, w = et({
        inputs: {
            x: w
        },
        attrs: {
            shape: S
        },
        backend: e
    }), lo(e, v);
    const N = k;
    return k = et({
        inputs: {
            x: k
        },
        attrs: {
            shape: S
        },
        backend: e
    }), lo(e, N), [
        k,
        w
    ];
}
const R5 = {
    kernelName: Kh,
    backendName: "webgl",
    kernelFunc: N5
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $5 {
    constructor(t, e, s, o, r, i){
        this.variableNames = [
            "Image",
            "Transforms"
        ], this.outputShape = i;
        const a = s === "nearest" ? 1 : 2;
        let l;
        switch(o){
            case "constant":
                l = 1;
                break;
            case "reflect":
                l = 2;
                break;
            case "wrap":
                l = 3;
                break;
            case "nearest":
                l = 4;
                break;
            default:
                l = 1;
                break;
        }
        this.userCode = `
            float mapCoord(float outCoord, float len) {
              float inCoord = outCoord;
              if(${l} == 2) {
                if (inCoord < 0.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz2 = 2.0 * len;
                    if (inCoord < sz2) {
                      inCoord = sz2 * float(int(float(-inCoord / sz2))) +
                      inCoord;
                    }
                    inCoord = inCoord < -len ? inCoord + sz2 : -inCoord - 1.0;
                  }
                } else if (inCoord > len - 1.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz2 = 2.0 * len;
                    inCoord -= sz2 * float(int(float(inCoord / sz2)));
                    if (inCoord >= len) {
                      inCoord = sz2 - inCoord - 1.0;
                    }
                  }
                }
                return clamp(inCoord, 0.0, len - 1.0);
              } else if (${l} == 3) {
                if (inCoord < 0.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz = len - 1.0;
                    inCoord += len * (float(int(float(-inCoord / sz))) + 1.0);
                  }
                } else if (inCoord > len - 1.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz = len - 1.0;
                    inCoord -= len * float(int(float(inCoord / sz)));
                  }
                }
                return clamp(inCoord, 0.0, len - 1.0);
              } else if (${l} == 4) {
                return clamp(outCoord, 0.0, len - 1.0);
              } else {
                return outCoord;
              }
            }

            float readWithFillValue(int batch, int coordY, int coordX,
              int channel) {
              float outputValue;
              if (0 <= coordY && coordY < ${t} && 0 <= coordX && coordX < ${e}) {
                  outputValue = getImage(batch, coordY, coordX, channel);
              } else {
                outputValue = float(${r});
              }
              return outputValue;
            }

            void main() {
              ivec4 coords = getOutputCoords();
              float outputValue;
              int batch = coords[0];
              int x = coords[2];
              int y = coords[1];
              int channel = coords[3];
              float xf = float(x);
              float yf = float(y);
              float a1 = getTransforms(batch, 0);
              float a2 = getTransforms(batch, 1);
              float a3 = getTransforms(batch, 2);
              float b1 = getTransforms(batch, 3);
              float b2 = getTransforms(batch, 4);
              float b3 = getTransforms(batch, 5);
              float c1 = getTransforms(batch, 6);
              float c2 = getTransforms(batch, 7);
              float projection = c1 * xf + c2 * yf + 1.0;
              if (projection == 0.0) {
                outputValue = float(${r});
              } else {
                float inX = (a1 * xf + a2 * yf + a3) / projection;
                float inY = (b1 * xf + b2 * yf + b3) / projection;
                float mapX = mapCoord(inX, float(${e}));
                float mapY = mapCoord(inY, float(${t}));

                if (${a} == 1) {
                  int coordY = int(round(mapY));
                  int coordX = int(round(mapX));
                  outputValue = readWithFillValue(batch, coordY, coordX,
                    channel);
                } else {
                  float yFloor = floor(mapY);
                  float xFloor = floor(mapX);
                  float yCeil = yFloor + 1.0;
                  float xCeil = xFloor + 1.0;
                  float valueYFloor = (xCeil - mapX) *
                  readWithFillValue(batch, int(yFloor), int(xFloor), channel) +
                  (mapX - xFloor) *
                  readWithFillValue(batch, int(yFloor), int(xCeil), channel);
                  float valueYCeil = (xCeil - mapX) *
                  readWithFillValue(batch, int(yCeil), int(xFloor), channel) +
                  (mapX - xFloor) *
                  readWithFillValue(batch, int(yCeil), int(xCeil), channel);
                  outputValue = (yCeil - mapY) * valueYFloor +
                  (mapY - yFloor) * valueYCeil;
                }
              }
              setOutput(outputValue);
            }
        `;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function G5(n) {
    const { inputs: t, backend: e, attrs: s } = n, { image: o, transforms: r } = t, { interpolation: i, fillMode: a, fillValue: l, outputShape: c } = s, [u, d, h, p] = o.shape, [f, m] = c ?? [
        d,
        h
    ], g = [
        u,
        f,
        m,
        p
    ], b = new $5(d, h, i, a, l, g);
    return e.runWebGLProgram(b, [
        o,
        r
    ], "float32");
}
const E5 = {
    kernelName: Zh,
    backendName: "webgl",
    kernelFunc: G5
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function L5(n) {
    const { inputs: t, attrs: e, backend: s } = n, { axis: o } = e, { x: r } = t;
    Er(r, "unique"), console.warn("WARNING: ", "UI might be locked temporarily as data is being downloaded");
    const i = s.readSync(r.dataId), { outputValues: a, outputShape: l, indices: c } = GO(i, o, r.shape, r.dtype);
    return [
        s.makeTensorInfo(l, r.dtype, a),
        s.makeTensorInfo([
            c.length
        ], "int32", c)
    ];
}
const M5 = {
    kernelName: Bh,
    backendName: "webgl",
    kernelFunc: L5
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function W5(n) {
    const { inputs: t, backend: e, attrs: s } = n, { value: o } = t;
    let { axis: r } = s;
    r < 0 && (r += o.shape.length);
    const i = o, a = i.shape.length, l = o.shape[r], c = new Array(a - 1);
    let u = 0;
    for(let m = 0; m < a; m++)m !== r && (c[u++] = i.shape[m]);
    const d = [], h = new Array(a).fill(0), p = i.shape.slice();
    p[r] = 1;
    const f = new Array(l);
    for(let m = 0; m < f.length; m++){
        h[r] = m;
        const g = zr({
            inputs: {
                x: i
            },
            backend: e,
            attrs: {
                begin: h,
                size: p
            }
        }), b = et({
            inputs: {
                x: g
            },
            backend: e,
            attrs: {
                shape: c
            }
        });
        f[m] = b, d.push(g);
    }
    return d.forEach((m)=>e.disposeIntermediateTensorInfo(m)), f;
}
const D5 = {
    kernelName: Hc,
    backendName: "webgl",
    kernelFunc: W5
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class F5 {
    constructor(t, e){
        this.variableNames = [
            "x",
            "segmentIds"
        ];
        const s = t.windowSize, o = t.batchSize, r = t.inSize, i = t.numSegments, a = i * Math.ceil(r / s);
        this.outputShape = [
            o,
            a
        ];
        const l = "0.0", c = "sumValue", u = Math.floor(s / 4) * 4, d = s % 4, h = `
        sumValue += dot(values, segFilter);
    `;
        let p = "";
        r % s > 0 && (p = `
        if (inIdx < 0 || inIdx >= ${r}) {
          return initializationValue;
        }
      `);
        let f = "";
        r % s > 0 && (f = `
        if (inIdx < 0 || inIdx >= ${r}) {
          return -1.0;
        }
      `), this.userCode = `
      const float initializationValue = ${l};

      float getValue(int batch, int inIdx) {
        ${p}
        return getX(batch, inIdx);
      }

      float getSegmentIdAtIndex(int inIdx) {
        ${f}
        return getSegmentIds(inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = int(floor(float(outIdx) / float(
          ${i})) * float(${s}));
        int currentSeg = int(mod(float(outIdx), float(${i})));

        float sumValue = 0.0;

        for (int i = 0; i < ${u}; i += 4) {
          int inIdx = inOffset + i;
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 3)) == currentSeg ? 1 : 0
          );

          ${h}
        }

        int inIdx = inOffset + ${u};
        if (${d === 1}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            initializationValue,
            initializationValue,
            initializationValue
          );

          int inIdxSeg = int(getSegmentIdAtIndex(inIdx));

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            0,
            0,
            0
          );

          ${h}
        } else if (${d === 2}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            initializationValue,
            initializationValue
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
              0,
              0
          );

          ${h}
        } else if (${d === 3}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            initializationValue
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,
            0
          );

          ${h}
        }
        setOutput(${c});
      }
    `;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function V5(n) {
    const { inputs: t, backend: e, attrs: s } = n, { x: o, segmentIds: r } = t, { numSegments: i } = s, a = o.shape.length, l = [];
    let c = 0;
    const u = qt([
        c
    ], a);
    let d = o;
    u != null && (d = ze({
        inputs: {
            x: o
        },
        backend: e,
        attrs: {
            perm: u
        }
    }), l.push(d), c = ie(1, a)[0]);
    const h = gx(d.shape, c, i), p = X([
        d.shape[c]
    ]), f = et({
        inputs: {
            x: d
        },
        backend: e,
        attrs: {
            shape: [
                -1,
                p
            ]
        }
    });
    l.push(f);
    const m = Yh(o.dtype), g = (y, I, v, k, S)=>{
        const N = y.shape[0], R = y.shape[1], M = mx(R, S), V = {
            windowSize: M,
            inSize: R,
            batchSize: N,
            numSegments: S
        }, z = new F5(V, I), P = e.compileAndRun(z, [
            y,
            v
        ], k);
        if (l.push(P), P.shape[1] === S) return P;
        const A = yC({
            backend: e,
            attrs: {
                start: 0,
                stop: S,
                step: 1,
                dtype: "float32"
            }
        }), O = wC({
            inputs: {
                x: A
            },
            backend: e,
            attrs: {
                reps: [
                    R / M
                ]
            }
        });
        return l.push(A), l.push(O), g(P, I, O, k, S);
    }, b = g(f, "unsortedSegmentSum", r, m, i), x = et({
        inputs: {
            x: b
        },
        backend: e,
        attrs: {
            shape: h
        }
    });
    let w = x;
    if (u != null) {
        l.push(x);
        const y = js(u);
        w = ze({
            inputs: {
                x: w
            },
            backend: e,
            attrs: {
                perm: y
            }
        });
    }
    return l.forEach((y)=>e.disposeIntermediateTensorInfo(y)), w;
}
const z5 = {
    kernelName: _c,
    backendName: "webgl",
    kernelFunc: V5
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const P5 = [
    CX,
    SX,
    NX,
    GX,
    LX,
    DX,
    VX,
    PX,
    KX,
    BX,
    UX,
    JX,
    tK,
    oK,
    aK,
    cK,
    dK,
    mK,
    bK,
    yK,
    vK,
    GK,
    LK,
    FK,
    zK,
    ZK,
    HK,
    QK,
    rX,
    qK,
    oZ,
    lZ,
    fZ,
    bZ,
    yZ,
    IZ,
    vZ,
    NZ,
    GZ,
    MZ,
    DZ,
    VZ,
    PZ,
    XZ,
    ZZ,
    UZ,
    QZ,
    qZ,
    nB,
    oB,
    lB,
    hB,
    gB,
    yB,
    CB,
    vB,
    kB,
    NB,
    $B,
    EB,
    MB,
    VB,
    AB,
    KB,
    BB,
    UB,
    JB,
    eH,
    rH,
    oX,
    aH,
    nZ,
    uH,
    pH,
    gH,
    aX,
    wH,
    SH,
    TH,
    GH,
    MH,
    VH,
    AH,
    ZH,
    UH,
    JH,
    qH,
    s_,
    r_,
    a_,
    d_,
    p_,
    m_,
    b_,
    y_,
    v_,
    N_,
    E_,
    P_,
    uX,
    K_,
    H_,
    Y_,
    j_,
    AK,
    e9,
    s9,
    r9,
    l9,
    h9,
    cX,
    f9,
    g9,
    x9,
    w9,
    I9,
    OK,
    D_,
    S9,
    R9,
    L9,
    hX,
    F9,
    P9,
    K9,
    H9,
    Q9,
    j9,
    eU,
    oU,
    aU,
    uU,
    pU,
    gU,
    wU,
    vU,
    NU,
    GU,
    RK,
    V_,
    MU,
    DU,
    VU,
    PU,
    OU,
    KU,
    BU,
    _U,
    YU,
    jU,
    t5,
    n5,
    o5,
    a5,
    c5,
    d5,
    p5,
    F_,
    yX,
    g5,
    y5,
    I5,
    S5,
    R5,
    E5,
    wX,
    M5,
    D5,
    z5,
    n9
];
for (const n of P5)sn(n);
const IC = "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", Kg = typeof window < "u" && window.Blob && new Blob([
    atob(IC)
], {
    type: "text/javascript;charset=utf-8"
});
function A5(n) {
    let t;
    try {
        if (t = Kg && (window.URL || window.webkitURL).createObjectURL(Kg), !t) throw "";
        const e = new Worker(t, {
            name: n == null ? void 0 : n.name
        });
        return e.addEventListener("error", ()=>{
            (window.URL || window.webkitURL).revokeObjectURL(t);
        }), e;
    } catch  {
        return new Worker("data:application/javascript;base64," + IC, {
            name: n == null ? void 0 : n.name
        });
    } finally{
        t && (window.URL || window.webkitURL).revokeObjectURL(t);
    }
}
const O5 = (n, t)=>[
        [
            n[0][0] * t[0][0] + n[0][2] * t[2][0],
            n[0][0] * t[0][1] + n[0][2] * t[2][1],
            n[0][0] * t[0][2] + n[0][2] * t[2][2],
            n[0][0] * t[0][3] + n[0][2] * t[2][3]
        ],
        [
            n[1][1] * t[1][0] + n[1][2] * t[2][0],
            n[1][1] * t[1][1] + n[1][2] * t[2][1],
            n[1][1] * t[1][2] + n[1][2] * t[2][2],
            n[1][1] * t[1][3] + n[1][2] * t[2][3]
        ],
        [
            t[2][0],
            t[2][1],
            t[2][2],
            t[2][3]
        ]
    ], X5 = (n, t, e, s)=>{
    const o = n[0][0] * t + n[0][1] * e + n[0][3], r = n[1][0] * t + n[1][1] * e + n[1][3], i = n[2][0] * t + n[2][1] * e + n[2][3];
    return {
        x: o,
        y: r,
        z: i
    };
}, K5 = (n, t, e, s)=>{
    const { x: o, y: r, z: i } = X5(n, t, e);
    return {
        x: o / i,
        y: r / i
    };
}, Z5 = 6, B5 = 1, H5 = 10, _5 = 1, U5 = 0.8, Y5 = 1, Un = 1e3;
class Q5 {
    constructor(t, e, s, o, r, i = !1){
        this.markerDimensions = t, this.trackingDataList = e, this.projectionTransform = s, this.debugMode = i, this.trackingKeyframeList = [];
        for(let l = 0; l < e.length; l++)this.trackingKeyframeList.push(e[l][Y5]);
        let a = 0;
        for(let l = 0; l < this.trackingKeyframeList.length; l++)a = Math.max(a, this.trackingKeyframeList[l].points.length);
        this.featurePointsListT = [], this.imagePixelsListT = [], this.imagePropertiesListT = [];
        for(let l = 0; l < this.trackingKeyframeList.length; l++){
            const { featurePoints: c, imagePixels: u, imageProperties: d } = this._prebuild(this.trackingKeyframeList[l], a);
            this.featurePointsListT[l] = c, this.imagePixelsListT[l] = u, this.imagePropertiesListT[l] = d;
        }
        this.kernelCaches = {};
    }
    dummyRun(t) {
        let e = [
            [
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1
            ]
        ];
        for(let s = 0; s < this.featurePointsListT.length; s++)this.track(t, e, s);
    }
    track(t, e, s) {
        let o = {};
        const r = O5(this.projectionTransform, e), i = this._buildAdjustedModelViewTransform(r);
        this.markerDimensions[s][0], this.markerDimensions[s][1], this.trackingKeyframeList[s].width, this.trackingKeyframeList[s].height;
        const a = this.featurePointsListT[s], l = this.imagePixelsListT[s], c = this.imagePropertiesListT[s], u = this._computeProjection(i, t, s), { matchingPointsT: d, simT: h } = this._computeMatching(a, l, c, u), p = d.arraySync(), f = h.arraySync(), m = this.trackingKeyframeList[s], g = [], b = [], x = [];
        for(let w = 0; w < p.length; w++)if (f[w] > U5 && w < m.points.length) {
            x.push(w);
            const y = K5(r, p[w][0], p[w][1]);
            b.push(y), g.push({
                x: m.points[w].x / m.scale,
                y: m.points[w].y / m.scale,
                z: 0
            });
        }
        return this.debugMode && (o = {
            projectedImage: u.arraySync(),
            matchingPoints: d.arraySync(),
            goodTrack: x,
            trackedPoints: b
        }), i.dispose(), u.dispose(), d.dispose(), h.dispose(), {
            worldCoords: g,
            screenCoords: b,
            debugExtra: o
        };
    }
    _computeMatching(t, e, s, o) {
        const r = Z5, i = r * 2 + 1, l = H5 * B5, c = _5, u = l * 2 + 1, d = o.shape[0], h = o.shape[1], p = t.shape[0];
        if (!this.kernelCaches.computeMatching) {
            const f = {
                variableNames: [
                    "features",
                    "markerPixels",
                    "markerProperties",
                    "targetPixels"
                ],
                outputShape: [
                    p,
                    u * u
                ],
                userCode: `
	  void main() {
	    ivec2 coords = getOutputCoords();

	    int featureIndex = coords[0];
	    int searchOffsetIndex = coords[1];

	    int markerWidth = int(getMarkerProperties(0));
	    int markerHeight = int(getMarkerProperties(1));
	    float markerScale = getMarkerProperties(2);

	    int searchOffsetX = imod(searchOffsetIndex, ${u}) * ${c};
	    int searchOffsetY = searchOffsetIndex / ${u} * ${c};

	    int sCenterX = int(getFeatures(featureIndex, 0) * markerScale);
	    int sCenterY = int(getFeatures(featureIndex, 1) * markerScale);

	    int sx = sCenterX + searchOffsetX - ${l};
	    int sy = sCenterY + searchOffsetY - ${l};

	    if (sx < ${r} || sx >= (${h} - ${r}) || sy < ${r} || sy >= (${d} - ${r})) {
	      setOutput(-2.);
	    } 
	    else {
	      float sumPoint = 0.;
	      float sumPointSquare = 0.;
	      float sumTemplate = 0.;
	      float sumTemplateSquare = 0.;
	      float sumPointTemplate = 0.;

	      for (int templateOffsetY = 0; templateOffsetY < ${i}; templateOffsetY++) {
		for (int templateOffsetX = 0; templateOffsetX < ${i}; templateOffsetX++) {
		  int fx2 = sCenterX + templateOffsetX - ${r};
		  int fy2 = sCenterY + templateOffsetY - ${r};

		  int sx2 = sx + templateOffsetX - ${r};
		  int sy2 = sy + templateOffsetY - ${r};

		  int markerPixelIndex = fy2 * markerWidth + fx2;
		  float markerPixel = getMarkerPixels(markerPixelIndex);
		  float targetPixel = getTargetPixels(sy2, sx2);

		  sumTemplate += markerPixel;
		  sumTemplateSquare += markerPixel * markerPixel;
		  sumPoint += targetPixel;
		  sumPointSquare += targetPixel * targetPixel;
		  sumPointTemplate += targetPixel * markerPixel;
		}
	      }

	      // Normalized cross-correlation
	      // !important divide first avoid overflow (e.g. sumPoint / count * sumPoint)
	      float count = float(${i} * ${i});
	      float pointVariance = sqrt(sumPointSquare - sumPoint / count * sumPoint);
	      float templateVariance = sqrt(sumTemplateSquare - sumTemplate / count * sumTemplate);

	      if (pointVariance < 0.0000001) {
		setOutput(-3.);
	      } else if (templateVariance < 0.0000001) {
		//setOutput(sumTemplate);
		setOutput(-4.);
	      } else {
		sumPointTemplate -= sumPoint / count * sumTemplate;
		float sim = sumPointTemplate / pointVariance / templateVariance;  
		setOutput(sim);
	      }
	    }
	  }
	`
            }, m = {
                variableNames: [
                    "featurePoints",
                    "markerProperties",
                    "maxIndex"
                ],
                outputShape: [
                    p,
                    2
                ],
                // [x, y]
                userCode: `
	  void main() {
	    ivec2 coords = getOutputCoords();

	    float markerScale = getMarkerProperties(2);

	    int featureIndex = coords[0];

	    int maxIndex = int(getMaxIndex(featureIndex));
	    int searchLocationIndex = maxIndex / ${u * u};
	    int searchOffsetIndex = imod(maxIndex, ${u * u});

	    if (coords[1] == 0) {
	      int searchOffsetX = imod(searchOffsetIndex, ${u}) * ${c};
	      setOutput(getFeaturePoints(featureIndex, 0) + float(searchOffsetX - ${l}) / markerScale);
	    }
	    else if (coords[1] == 1) {
	      int searchOffsetY = searchOffsetIndex / ${u} * ${c};
	      setOutput(getFeaturePoints(featureIndex, 1) + float(searchOffsetY - ${l}) / markerScale);
	    }
	  }
	`
            }, g = {
                variableNames: [
                    "sims",
                    "maxIndex"
                ],
                outputShape: [
                    p
                ],
                userCode: `
	  void main() {
	    int featureIndex = getOutputCoords();
	    int maxIndex = int(getMaxIndex(featureIndex));
	    setOutput(getSims(featureIndex, maxIndex));
	  }
	`
            };
            this.kernelCaches.computeMatching = [
                f,
                m,
                g
            ];
        }
        return D(()=>{
            const f = this.kernelCaches.computeMatching, m = this._compileAndRun(f[0], [
                t,
                e,
                s,
                o
            ]), g = m.argMax(1), b = this._compileAndRun(f[1], [
                t,
                s,
                g
            ]), x = this._compileAndRun(f[2], [
                m,
                g
            ]);
            return {
                matchingPointsT: b,
                simT: x
            };
        });
    }
    _computeProjection(t, e, s) {
        const o = this.trackingKeyframeList[s].width, r = this.trackingKeyframeList[s].height, i = this.trackingKeyframeList[s].scale, a = o + "-" + r + "-" + i;
        if (this.kernelCaches.computeProjection || (this.kernelCaches.computeProjection = {}), !this.kernelCaches.computeProjection[a]) {
            const l = {
                variableNames: [
                    "M",
                    "pixel"
                ],
                outputShape: [
                    r,
                    o
                ],
                userCode: `
	  void main() {
	      ivec2 coords = getOutputCoords();

	      float m00 = getM(0, 0) * ${Un}.;
	      float m01 = getM(0, 1) * ${Un}.;
	      float m03 = getM(0, 3) * ${Un}.;
	      float m10 = getM(1, 0) * ${Un}.;
	      float m11 = getM(1, 1) * ${Un}.;
	      float m13 = getM(1, 3) * ${Un}.;
	      float m20 = getM(2, 0) * ${Un}.;
	      float m21 = getM(2, 1) * ${Un}.;
	      float m23 = getM(2, 3) * ${Un}.;

	      float y = float(coords[0]) / float(${i});
	      float x = float(coords[1]) / float(${i});
	      float uz = (x * m20) + (y * m21) + m23;
	      float oneOverUz = 1. / uz;

	      float ux = (x * m00) + (y * m01) + m03;
	      float uy = (x * m10) + (y * m11) + m13;

	      ux = floor(ux * oneOverUz + 0.5);
	      uy = floor(uy * oneOverUz + 0.5);
	      setOutput(getPixel(int(uy), int(ux)));
	    }
	`
            };
            this.kernelCaches.computeProjection[a] = l;
        }
        return D(()=>{
            const l = this.kernelCaches.computeProjection[a];
            return this._compileAndRun(l, [
                t,
                e
            ]);
        });
    }
    _buildAdjustedModelViewTransform(t) {
        return D(()=>{
            let e = [];
            for(let o = 0; o < t.length; o++){
                e.push([]);
                for(let r = 0; r < t[o].length; r++)e[o].push(t[o][r] / Un);
            }
            return $e(e, [
                3,
                4
            ]);
        });
    }
    _prebuild(t, e) {
        return D(()=>{
            const s = t.scale, o = [];
            for(let l = 0; l < e; l++)l < t.points.length ? o.push([
                t.points[l].x / s,
                t.points[l].y / s
            ]) : o.push([
                -1,
                -1
            ]);
            const r = $e(t.data, [
                t.width * t.height
            ]), i = $e([
                t.width,
                t.height,
                t.scale
            ], [
                3
            ]);
            return {
                featurePoints: $e(o, [
                    o.length,
                    2
                ], "float32"),
                imagePixels: r,
                imageProperties: i
            };
        });
    }
    _compileAndRun(t, e) {
        const s = ps().compileAndRun(t, e);
        return Ot().makeTensorFromDataId(s.dataId, s.shape, s.dtype);
    }
}
const tl = [
    // ring 5
    {
        sigma: 0.55,
        points: [
            [
                -1,
                0
            ],
            [
                -0.5,
                -0.866025
            ],
            [
                0.5,
                -0.866025
            ],
            [
                1,
                -0
            ],
            [
                0.5,
                0.866025
            ],
            [
                -0.5,
                0.866025
            ]
        ]
    },
    // ring 4
    {
        sigma: 0.475,
        points: [
            [
                0,
                0.930969
            ],
            [
                -0.806243,
                0.465485
            ],
            [
                -0.806243,
                -0.465485
            ],
            [
                -0,
                -0.930969
            ],
            [
                0.806243,
                -0.465485
            ],
            [
                0.806243,
                0.465485
            ]
        ]
    },
    // ring 3
    {
        sigma: 0.4,
        points: [
            [
                0.847306,
                -0
            ],
            [
                0.423653,
                0.733789
            ],
            [
                -0.423653,
                0.733789
            ],
            [
                -0.847306,
                0
            ],
            [
                -0.423653,
                -0.733789
            ],
            [
                0.423653,
                -0.733789
            ]
        ]
    },
    // ring 2
    {
        sigma: 0.325,
        points: [
            [
                -0,
                -0.741094
            ],
            [
                0.641806,
                -0.370547
            ],
            [
                0.641806,
                0.370547
            ],
            [
                0,
                0.741094
            ],
            [
                -0.641806,
                0.370547
            ],
            [
                -0.641806,
                -0.370547
            ]
        ]
    },
    // ring 1
    {
        sigma: 0.25,
        points: [
            [
                -0.595502,
                0
            ],
            [
                -0.297751,
                -0.51572
            ],
            [
                0.297751,
                -0.51572
            ],
            [
                0.595502,
                -0
            ],
            [
                0.297751,
                0.51572
            ],
            [
                -0.297751,
                0.51572
            ]
        ]
    },
    // ring 0
    {
        sigma: 0.175,
        points: [
            [
                0,
                0.362783
            ],
            [
                -0.314179,
                0.181391
            ],
            [
                -0.314179,
                -0.181391
            ],
            [
                -0,
                -0.362783
            ],
            [
                0.314179,
                -0.181391
            ],
            [
                0.314179,
                0.181391
            ]
        ]
    },
    // center
    {
        sigma: 0.1,
        points: [
            [
                0,
                0
            ]
        ]
    }
], Ao = [];
for(let n = 0; n < tl.length; n++){
    const t = tl[n].sigma;
    for(let e = 0; e < tl[n].points.length; e++){
        const s = tl[n].points[e];
        Ao.push([
            t,
            s[0],
            s[1]
        ]);
    }
}
const Xu = {};
function J5(n) {
    const t = n.shape[1], e = n.shape[0], s = "w" + t + "h" + e;
    if (!Xu.hasOwnProperty(s)) {
        const o = {
            variableNames: [
                "p"
            ],
            outputShape: [
                e,
                t
            ],
            userCode: `
        void main() {
          ivec2 coords = getOutputCoords();

          float sum = getP(coords[0], coords[1]-2);
          sum += getP(coords[0], coords[1]-1) * 4.;
          sum += getP(coords[0], coords[1]) * 6.;
          sum += getP(coords[0], coords[1]+1) * 4.;
          sum += getP(coords[0], coords[1]+2);
          setOutput(sum);
        }
      `
        }, r = {
            variableNames: [
                "p"
            ],
            outputShape: [
                e,
                t
            ],
            userCode: `
        void main() {
          ivec2 coords = getOutputCoords();

          float sum = getP(coords[0]-2, coords[1]);
          sum += getP(coords[0]-1, coords[1]) * 4.;
          sum += getP(coords[0], coords[1]) * 6.;
          sum += getP(coords[0]+1, coords[1]) * 4.;
          sum += getP(coords[0]+2, coords[1]);
          sum /= 256.;
          setOutput(sum);
        }
      `
        };
        Xu[s] = [
            o,
            r
        ];
    }
    return Xu[s];
}
const j5 = (n)=>{
    const t = n.inputs.image, e = n.backend, [s, o] = J5(t), r = e.runWebGLProgram(s, [
        t
    ], t.dtype), i = e.runWebGLProgram(o, [
        r
    ], t.dtype);
    return e.disposeIntermediateTensorInfo(r), i;
}, q5 = {
    //: KernelConfig
    kernelName: "BinomialFilter",
    backendName: "webgl",
    kernelFunc: j5
}, el = 7, Zg = 3, t4 = Zg * Zg, Ku = 4, e4 = (Ku + 1) * (Ku + 1) / Ku, Zu = {};
function n4(n) {
    const t = n.shape[1], e = n.shape[0], s = "w" + t + "h" + e;
    if (!Zu.hasOwnProperty(s)) {
        const o = {
            variableNames: [
                "image0",
                "image1",
                "image2"
            ],
            outputShape: [
                e,
                t
            ],
            userCode: `
        void main() {
          ivec2 coords = getOutputCoords();
    
          int y = coords[0];
          int x = coords[1];
    
          float value = getImage1(y, x);
    
          // Step 1: find local maxima/minima
          if (value * value < ${t4}.) {
            setOutput(0.);
            return;
          }
          if (y < ${el} || y > ${e - 1 - el}) {
            setOutput(0.);
            return;
          }
          if (x < ${el} || x > ${t - 1 - el}) {
            setOutput(0.);
            return;
          }
    
          bool isMax = true;
          bool isMin = true;
          for (int dy = -1; dy <= 1; dy++) {
            for (int dx = -1; dx <= 1; dx++) {
              float value0 = getImage0(y+dy, x+dx);
              float value1 = getImage1(y+dy, x+dx);
              float value2 = getImage2(y+dy, x+dx);
    
        if (value < value0 || value < value1 || value < value2) {
          isMax = false;
        }
        if (value > value0 || value > value1 || value > value2) {
          isMin = false;
        }
            }
          }
    
          if (!isMax && !isMin) {
            setOutput(0.);
            return;
          }
    
          // compute edge score and reject based on threshold
          float dxx = getImage1(y, x+1) + getImage1(y, x-1) - 2. * getImage1(y, x);
          float dyy = getImage1(y+1, x) + getImage1(y-1, x) - 2. * getImage1(y, x);
          float dxy = 0.25 * (getImage1(y-1,x-1) + getImage1(y+1,x+1) - getImage1(y-1,x+1) - getImage1(y+1,x-1));
    
          float det = (dxx * dyy) - (dxy * dxy);
    
          if (abs(det) < 0.0001) { // determinant undefined. no solution
            setOutput(0.);
            return;
          }
    
          float edgeScore = (dxx + dyy) * (dxx + dyy) / det;
    
          if (abs(edgeScore) >= ${e4} ) {
            setOutput(0.);
            return;
          }
          setOutput(getImage1(y,x));
        }
      `
        };
        Zu[s] = o;
    }
    return Zu[s];
}
const s4 = (n)=>{
    let { image0: t, image1: e, image2: s } = n.inputs;
    const o = n.backend, r = n4(e);
    return t = Ot().runKernel("DownsampleBilinear", {
        image: t
    }), s = Ot().runKernel("UpsampleBilinear", {
        image: s,
        targetImage: e
    }), o.runWebGLProgram(r, [
        t,
        e,
        s
    ], e.dtype);
}, o4 = {
    //: KernelConfig
    kernelName: "BuildExtremas",
    backendName: "webgl",
    kernelFunc: s4
}, Zr = 36, Bu = {};
function r4(n) {
    const t = n.shape[0];
    if (!Bu.hasOwnProperty(t)) {
        const e = {
            variableNames: [
                "histogram"
            ],
            outputShape: [
                n.shape[0]
            ],
            userCode: `
            void main() {
                int featureIndex = getOutputCoords();

                int maxIndex = 0;
                for (int i = 1; i < ${Zr}; i++) {
                    if (getHistogram(featureIndex, i) > getHistogram(featureIndex, maxIndex)) {
                        maxIndex = i;
                    }
                }

                int prev = imod(maxIndex - 1 + ${Zr}, ${Zr});
                int next = imod(maxIndex + 1, ${Zr});

                /**
                 * Fit a quatratic to 3 points. The system of equations is:
                 *
                 * y0 = A*x0^2 + B*x0 + C
                 * y1 = A*x1^2 + B*x1 + C
                 * y2 = A*x2^2 + B*x2 + C
                 *
                 * This system of equations is solved for A,B,C.
                 */
                float p10 = float(maxIndex - 1);
                float p11 = getHistogram(featureIndex, prev); 
                float p20 = float(maxIndex);
                float p21 = getHistogram(featureIndex, maxIndex); 
                float p30 = float(maxIndex + 1);
                float p31 = getHistogram(featureIndex, next); 

                float d1 = (p30-p20)*(p30-p10);
                float d2 = (p10-p20)*(p30-p10);
                float d3 = p10-p20;

                // If any of the denominators are zero then, just use maxIndex.
                    float fbin = float(maxIndex);
                if ( abs(d1) > 0.00001 && abs(d2) > 0.00001 && abs(d3) > 0.00001) {
                float a = p10*p10;
                float b = p20*p20;

                // Solve for the coefficients A,B,C
                float A = ((p31-p21)/d1)-((p11-p21)/d2);
                float B = ((p11-p21)+(A*(b-a)))/d3;
                float C = p11-(A*a)-(B*p10);
                fbin = -B / (2. * A);
                }

                float an = 2.0 *${Math.PI} * (fbin + 0.5) / ${Zr}. - ${Math.PI};
                setOutput(an);
            }
            `
        };
        Bu[t] = e;
    }
    return Bu[t];
}
const i4 = (n)=>{
    const { histograms: t } = n.inputs, e = n.backend, s = r4(t);
    return e.runWebGLProgram(s, [
        t
    ], t.dtype);
}, a4 = {
    //: KernelConfig
    kernelName: "ComputeExtremaAngles",
    backendName: "webgl",
    kernelFunc: i4
}, Bg = 7, Hu = {};
function l4(n, t) {
    const e = `${n}|${t.shape[0]}`;
    if (!Hu.hasOwnProperty(e)) {
        const s = [];
        for(let i = 1; i < n; i++)s.push("image" + i);
        let o = "float getPixel(int octave, int y, int x) {";
        for(let i = 1; i < n; i++)o += `
  if (octave == ${i}) {
	return getImage${i}(y, x);
  }
`;
        o += "}";
        const r = {
            variableNames: [
                ...s,
                "extrema",
                "angles",
                "freakPoints"
            ],
            outputShape: [
                t.shape[0],
                Ao.length
            ],
            userCode: `
  ${o}
  void main() {
	ivec2 coords = getOutputCoords();
	int featureIndex = coords[0];
	int freakIndex = coords[1];

	float freakSigma = getFreakPoints(freakIndex, 0);
	float freakX = getFreakPoints(freakIndex, 1);
	float freakY = getFreakPoints(freakIndex, 2);

	int octave = int(getExtrema(featureIndex, 1));
	float inputY = getExtrema(featureIndex, 2);
	float inputX = getExtrema(featureIndex, 3);
	float inputAngle = getAngles(featureIndex);
	float cos = ${Bg}. * cos(inputAngle);
	float sin = ${Bg}. * sin(inputAngle);

	float yp = inputY + freakX * sin + freakY * cos;
	float xp = inputX + freakX * cos + freakY * -sin;

	int x0 = int(floor(xp));
	int x1 = x0 + 1;
	int y0 = int(floor(yp));
	int y1 = y0 + 1;

	float f1 = getPixel(octave, y0, x0);
	float f2 = getPixel(octave, y0, x1);
	float f3 = getPixel(octave, y1, x0);
	float f4 = getPixel(octave, y1, x1);

	float x1f = float(x1);
	float y1f = float(y1);
	float x0f = float(x0);
	float y0f = float(y0);

	// ratio for interpolation between four neighbouring points
	float value = (x1f - xp) * (y1f - yp) * f1
		+ (xp - x0f) * (y1f - yp) * f2
		+ (x1f - xp) * (yp - y0f) * f3
		+ (xp - x0f) * (yp - y0f) * f4;

	setOutput(value);
  }
`
        };
        Hu[e] = r;
    }
    return Hu[e];
}
const c4 = (n)=>{
    const { gaussianImagesT: t, prunedExtremas: e, prunedExtremasAngles: s, freakPointsT: o, pyramidImagesLength: r } = n.inputs, i = n.backend, a = l4(r, e);
    return i.runWebGLProgram(a, [
        ...t,
        e,
        s,
        o
    ], "float32");
}, u4 = {
    //: KernelConfig
    kernelName: "ComputeExtremaFreak",
    backendName: "webgl",
    kernelFunc: c4
}, CC = (Ao.length - 1) * Ao.length / 2, d4 = Math.ceil(CC / 8), _u = {};
function h4(n) {
    const t = `${n.shape[0]}`;
    if (!_u.hasOwnProperty(t)) {
        const e = {
            variableNames: [
                "freak",
                "p"
            ],
            outputShape: [
                n.shape[0],
                d4
            ],
            userCode: `
  void main() {
    ivec2 coords = getOutputCoords();
    int featureIndex = coords[0];
    int descIndex = coords[1] * 8;

    int sum = 0;
    for (int i = 0; i < 8; i++) {
      if (descIndex + i >= ${CC}) {
        continue;
      }

      int p1 = int(getP(descIndex + i, 0));
      int p2 = int(getP(descIndex + i, 1));

      float v1 = getFreak(featureIndex, p1);
      float v2 = getFreak(featureIndex, p2);

      if (v1 < v2 + 0.01) {
        sum += int(pow(2.0, float(7 - i)));
      }
    }
    setOutput(float(sum));
  }
`
        };
        _u[t] = e;
    }
    return _u[t];
}
const p4 = (n)=>{
    const { extremaFreaks: t, positionT: e } = n.inputs, { backend: s } = n, o = h4(t);
    return s.runWebGLProgram(o, [
        t,
        e
    ], "int32");
}, f4 = {
    //: KernelConfig
    kernelName: "ComputeFreakDescriptors",
    backendName: "webgl",
    kernelFunc: p4
}, Uu = {};
function m4(n, t) {
    const e = `${n}|${t}`;
    if (!Uu.hasOwnProperty(e)) {
        const s = [];
        let o = "float getPixel(int octave, int y, int x) {";
        for(let r = 1; r < n; r++)s.push("image" + r), o += `
				if (octave == ${r}) {
					return getImage${r}(y, x);
				}
			`;
        o += "}", Uu[e] = {
            variableNames: [
                ...s,
                "extrema"
            ],
            outputShape: [
                t,
                3,
                3
            ],
            // 3x3 pixels around the extrema
            userCode: `
			${o}
		
			void main() {
				ivec3 coords = getOutputCoords();
				int featureIndex = coords[0];
				float score = getExtrema(featureIndex, 0);
				if (score == 0.0) {
					return;
				}
		
				int dy = coords[1]-1;
				int dx = coords[2]-1;
				int octave = int(getExtrema(featureIndex, 1));
				int y = int(getExtrema(featureIndex, 2));
				int x = int(getExtrema(featureIndex, 3));
				setOutput(getPixel(octave, y+dy, x+dx));
			}
			`
        };
    }
    return Uu[e];
}
const g4 = (n)=>{
    const { prunedExtremasList: t, dogPyramidImagesT: e } = n.inputs, s = n.backend, o = m4(e.length, t.length), r = $e(t, [
        t.length,
        t[0].length
    ], "int32");
    return s.runWebGLProgram(o, [
        ...e.slice(1),
        r
    ], e[0].dtype);
}, b4 = {
    //: KernelConfig
    kernelName: "ComputeLocalization",
    backendName: "webgl",
    kernelFunc: g4
}, x4 = 0.159154943091895, sr = 36, Yu = {};
function y4(n, t, e) {
    const s = `${e}|${n.shape[0]}|${t.shape[0]}`;
    if (!Yu.hasOwnProperty(s)) {
        const o = [];
        for(let l = 1; l < e; l++)o.push("image" + l);
        let r = "float getPixel(int octave, int y, int x) {";
        for(let l = 1; l < e; l++)r += `
            if (octave == ${l}) {
                return getImage${l}(y, x);
            }
            `;
        r += "}";
        const i = {
            variableNames: [
                ...o,
                "extrema",
                "radial"
            ],
            outputShape: [
                n.shape[0],
                t.shape[0],
                2
            ],
            // last dimension: [fbin, magnitude]
            userCode: `
                ${r}

                void main() {
                    ivec3 coords = getOutputCoords();
                    int featureIndex = coords[0];
                    int radialIndex = coords[1];
                    int propertyIndex = coords[2];

                    int radialY = int(getRadial(radialIndex, 0));
                    int radialX = int(getRadial(radialIndex, 1));
                    float radialW = getRadial(radialIndex, 2);

                    int octave = int(getExtrema(featureIndex, 1));
                    int y = int(getExtrema(featureIndex, 2));
                    int x = int(getExtrema(featureIndex, 3));

                    int xp = x + radialX;
                    int yp = y + radialY;

                    float dy = getPixel(octave, yp+1, xp) - getPixel(octave, yp-1, xp);
                    float dx = getPixel(octave, yp, xp+1) - getPixel(octave, yp, xp-1);

                    if (propertyIndex == 0) {
                    // be careful that atan(0, 0) gives 1.57 instead of 0 (different from js), but doesn't matter here, coz magnitude is 0
                    
                    float angle = atan(dy, dx) + ${Math.PI};
                    float fbin = angle * ${sr}. * ${x4};
                    setOutput(fbin);
                    return;
                    }

                    if (propertyIndex == 1) {
                        float mag = sqrt(dx * dx + dy * dy);
                        float magnitude = radialW * mag;
                        setOutput(magnitude);
                        return;
                    }
                }

                `
        }, a = {
            variableNames: [
                "fbinMag"
            ],
            outputShape: [
                n.shape[0],
                sr
            ],
            userCode: `
            void main() {
                ivec2 coords = getOutputCoords();
                int featureIndex = coords[0];
                int binIndex = coords[1];

                float sum = 0.;
                for (int i = 0; i < ${t.shape[0]}; i++) {
                    float fbin = getFbinMag(featureIndex, i, 0);
                    int bin = int(floor(fbin - 0.5));
                    int b1 = imod(bin + ${sr}, ${sr});
                    int b2 = imod(bin + 1 + ${sr}, ${sr});

                    if (b1 == binIndex || b2 == binIndex) {
                        float magnitude = getFbinMag(featureIndex, i, 1);
                        float w2 = fbin - float(bin) - 0.5;
                        float w1 = w2 * -1. + 1.;

                        if (b1 == binIndex) {
                            sum += w1 * magnitude;
                        }
                        if (b2 == binIndex) {
                            sum += w2 * magnitude;
                        }
                    }
                }
                setOutput(sum);
            }
            `
        };
        Yu[s] = [
            i,
            a
        ];
    }
    return Yu[s];
}
const w4 = (n)=>{
    const { gaussianImagesT: t, prunedExtremasT: e, radialPropertiesT: s, pyramidImagesLength: o } = n.inputs, r = n.backend, [i, a] = y4(e, s, o), l = r.runWebGLProgram(i, [
        ...t,
        e,
        s
    ], s.dtype), c = r.runWebGLProgram(a, [
        l
    ], s.dtype);
    return r.disposeIntermediateTensorInfo(l), c;
}, I4 = {
    kernelName: "ComputeOrientationHistograms",
    backendName: "webgl",
    kernelFunc: w4
}, Qu = {};
function C4(n) {
    const t = n.shape[1], e = n.shape[0], s = "w" + t + "h" + e;
    if (!Qu.hasOwnProperty(s)) {
        const o = {
            variableNames: [
                "p"
            ],
            outputShape: [
                Math.floor(e / 2),
                Math.floor(t / 2)
            ],
            userCode: `
            void main() {
                ivec2 coords = getOutputCoords();
                int y = coords[0] * 2;
                int x = coords[1] * 2;
        
                float sum = getP(y, x) * 0.25;
                sum += getP(y+1,x) * 0.25; 
                sum += getP(y, x+1) * 0.25; 
                sum += getP(y+1,x+1) * 0.25;
                setOutput(sum);
            }
            `
        };
        Qu[s] = o;
    }
    return Qu[s];
}
const v4 = (n)=>{
    const t = n.inputs.image, e = n.backend, s = C4(t);
    return e.runWebGLProgram(s, [
        t
    ], t.dtype);
}, S4 = {
    //: KernelConfig
    kernelName: "DownsampleBilinear",
    backendName: "webgl",
    kernelFunc: v4
}, k4 = (n)=>{
    const { extremasResultT: t } = n.inputs, e = n.backend, s = t.shape[0], o = t.shape[1], r = {
        variableNames: [
            "extrema"
        ],
        outputShape: [
            Math.floor(s / 2),
            Math.floor(o / 2)
        ],
        userCode: `
		  void main() {
			ivec2 coords = getOutputCoords();
			int y = coords[0] * 2;
			int x = coords[1] * 2;
  
			float location = 0.0;
			float values = getExtrema(y, x);
  
			if (getExtrema(y+1, x) != 0.0) {
			  location = 1.0;
		  values = getExtrema(y+1, x);
			}
			else if (getExtrema(y, x+1) != 0.0) {
			  location = 2.0;
		  values = getExtrema(y, x+1);
			}
			else if (getExtrema(y+1, x+1) != 0.0) {
			  location = 3.0;
		  values = getExtrema(y+1, x+1);
			}
  
			if (values < 0.0) {
			  setOutput(location * -1000.0 + values);
			} else {
			  setOutput(location * 1000.0 + values);
			}
		  }
		`
    };
    return e.runWebGLProgram(r, [
        t
    ], t.dtype);
}, T4 = {
    //: KernelConfig
    kernelName: "ExtremaReduction",
    backendName: "webgl",
    kernelFunc: k4
}, nl = 36, N4 = 5, Ju = {};
function R4(n) {
    const t = `h${n.shape[0]}`;
    if (!Ju.hasOwnProperty(t)) {
        const e = {
            variableNames: [
                "histogram"
            ],
            outputShape: [
                n.shape[0],
                nl
            ],
            userCode: `
            void main() {
                ivec2 coords = getOutputCoords();

                int featureIndex = coords[0];
                int binIndex = coords[1];

                int prevBin = imod(binIndex - 1 + ${nl}, ${nl});
                int nextBin = imod(binIndex + 1, ${nl});
                float result = 0.274068619061197 * getHistogram(featureIndex, prevBin) + 0.451862761877606 * getHistogram(featureIndex, binIndex) + 0.274068619061197 * getHistogram(featureIndex, nextBin);

                setOutput(result);
            }
            `
        };
        Ju[t] = e;
    }
    return Ju[t];
}
const $4 = (n)=>{
    let { histograms: t } = n.inputs;
    const e = n.backend, s = R4(t);
    for(let o = 0; o < N4; o++){
        const r = t;
        t = e.runWebGLProgram(s, [
            t
        ], t.dtype), o > 0 && e.disposeIntermediateTensorInfo(r);
    }
    return t;
}, G4 = {
    //: KernelConfig
    kernelName: "SmoothHistograms",
    backendName: "webgl",
    kernelFunc: $4
}, ju = {};
function E4(n, t) {
    const e = t.shape[1], s = t.shape[0], o = "w" + e + "h" + s;
    if (!ju.hasOwnProperty(o)) {
        const r = {
            variableNames: [
                "p"
            ],
            outputShape: [
                s,
                e
            ],
            userCode: `
              void main() {
                ivec2 coords = getOutputCoords();
                int j = coords[0];
                int i = coords[1];
        
                float sj = 0.5 * float(j) - 0.25; 
                float si = 0.5 * float(i) - 0.25;
        
                float sj0 = floor(sj);
                float sj1 = ceil(sj);
                float si0 = floor(si);
                float si1 = ceil(si);
        
                int sj0I = int(sj0);
                int sj1I = int(sj1);
                int si0I = int(si0);
                int si1I = int(si1);
        
                float sum = 0.0;
                sum += getP(sj0I, si0I) * (si1 - si) * (sj1 - sj);
                sum += getP(sj1I, si0I) * (si1 - si) * (sj - sj0);
                sum += getP(sj0I, si1I) * (si - si0) * (sj1 - sj);
                sum += getP(sj1I, si1I) * (si - si0) * (sj - sj0);
                setOutput(sum);
              }
            `
        };
        ju[o] = r;
    }
    return ju[o];
}
const L4 = (n)=>{
    const { image: t, targetImage: e } = n.inputs, s = n.backend, o = E4(t, e);
    return s.runWebGLProgram(o, [
        t
    ], t.dtype);
}, M4 = {
    //: KernelConfig
    kernelName: "UpsampleBilinear",
    backendName: "webgl",
    kernelFunc: L4
};
sn(q5);
sn(o4);
sn(a4);
sn(u4);
sn(f4);
sn(b4);
sn(I4);
sn(S4);
sn(T4);
sn(G4);
sn(M4);
const Hg = 8, W4 = 5, Br = 10, D4 = 5, qu = 3, F4 = 1.5;
Ao.length, Ao.length;
class vC {
    constructor(t, e, s = !1){
        this.debugMode = s, this.width = t, this.height = e;
        let o = 0;
        for(; t >= Hg && e >= Hg && (t /= 2, e /= 2, o++, o !== W4););
        this.numOctaves = o, this.tensorCaches = {}, this.kernelCaches = {};
    }
    // used in compiler
    detectImageData(t) {
        const e = new Uint8ClampedArray(4 * t.length);
        for(let o = 0; o < t.length; o++)e[4 * o] = t[o], e[4 * o + 1] = t[o], e[4 * o + 2] = t[o], e[4 * o + 3] = 255;
        const s = new ImageData(e, this.width, this.height);
        return this.detect(s);
    }
    /**
   * 
   * @param {tf.Tensor<tf.Rank>} inputImageT 
   * @returns 
   */ detect(t) {
        let e = null;
        const s = [];
        for(let b = 0; b < this.numOctaves; b++){
            let x, w;
            b === 0 ? x = this._applyFilter(t) : x = this._downsampleBilinear(s[b - 1][s[b - 1].length - 1]), w = this._applyFilter(x), s.push([
                x,
                w
            ]);
        }
        const o = [];
        for(let b = 0; b < this.numOctaves; b++){
            let x = this._differenceImageBinomial(s[b][0], s[b][1]);
            o.push(x);
        }
        const r = [];
        for(let b = 1; b < this.numOctaves - 1; b++){
            const x = this._buildExtremas(o[b - 1], o[b], o[b + 1]);
            r.push(x);
        }
        const i = this._applyPrune(r), a = this._computeLocalization(i, o), l = this._computeOrientationHistograms(a, s), c = this._smoothHistograms(l), u = this._computeExtremaAngles(c), d = this._computeExtremaFreak(s, a, u), h = this._computeFreakDescriptors(d), p = a.arraySync(), f = u.arraySync(), m = h.arraySync();
        this.debugMode && (e = {
            pyramidImages: s.map((b)=>b.map((x)=>x.arraySync())),
            dogPyramidImages: o.map((b)=>b ? b.arraySync() : null),
            extremasResults: r.map((b)=>b.arraySync()),
            extremaAngles: u.arraySync(),
            prunedExtremas: i,
            localizedExtremas: a.arraySync()
        }), s.forEach((b)=>b.forEach((x)=>x.dispose())), o.forEach((b)=>b && b.dispose()), r.forEach((b)=>b.dispose()), a.dispose(), l.dispose(), c.dispose(), u.dispose(), d.dispose(), h.dispose();
        const g = [];
        for(let b = 0; b < p.length; b++){
            if (p[b][0] == 0) continue;
            const x = [];
            for(let N = 0; N < m[b].length; N += 4){
                const R = m[b][N], M = m[b][N + 1], V = m[b][N + 2], z = m[b][N + 3];
                let P = R * 16777216 + M * 65536 + V * 256 + z;
                x.push(P);
            }
            const w = p[b][1], y = p[b][2], v = p[b][3] * Math.pow(2, w) + Math.pow(2, w - 1) - 0.5, k = y * Math.pow(2, w) + Math.pow(2, w - 1) - 0.5, S = Math.pow(2, w);
            g.push({
                maxima: p[b][0] > 0,
                x: v,
                y: k,
                scale: S,
                angle: f[b],
                descriptors: x
            });
        }
        return {
            featurePoints: g,
            debugExtra: e
        };
    }
    _computeFreakDescriptors(t) {
        if (!this.tensorCaches.computeFreakDescriptors) {
            const s = [], o = [];
            for(let a = 0; a < t.shape[1]; a++)for(let l = a + 1; l < t.shape[1]; l++)s.push(a), o.push(l);
            const r = $e(s, [
                s.length
            ]).cast("int32"), i = $e(o, [
                o.length
            ]).cast("int32");
            this.tensorCaches.computeFreakDescriptors = {
                positionT: hn(Xn([
                    r,
                    i
                ], 1))
            };
        }
        const { positionT: e } = this.tensorCaches.computeFreakDescriptors;
        return D(()=>Ot().runKernel("ComputeFreakDescriptors", {
                extremaFreaks: t,
                positionT: e
            }));
    }
    _computeExtremaFreak(t, e, s) {
        this.tensorCaches._computeExtremaFreak || D(()=>{
            const i = $e(Ao);
            this.tensorCaches._computeExtremaFreak = {
                freakPointsT: hn(i)
            };
        });
        const { freakPointsT: o } = this.tensorCaches._computeExtremaFreak, r = [];
        for(let i = 1; i < t.length; i++)r.push(t[i][1]);
        return D(()=>Ot().runKernel("ComputeExtremaFreak", {
                gaussianImagesT: r,
                prunedExtremas: e,
                prunedExtremasAngles: s,
                freakPointsT: o,
                pyramidImagesLength: t.length
            }));
    }
    /**
   * 
   * @param {tf.Tensor<tf.Rank>} histograms 
   * @returns 
   */ _computeExtremaAngles(t) {
        return D(()=>Ot().runKernel("ComputeExtremaAngles", {
                histograms: t
            }));
    }
    // TODO: maybe can try just using average momentum, instead of histogram method. histogram might be overcomplicated
    /**
   * 
   * @param {tf.Tensor<tf.Rank>} prunedExtremasT 
   * @param {tf.Tensor<tf.Rank>[]} pyramidImagesT 
   * @returns 
   */ _computeOrientationHistograms(t, e) {
        const s = [];
        for(let r = 1; r < e.length; r++)s.push(e[r][1]);
        this.tensorCaches.orientationHistograms || D(()=>{
            const r = -1 / (2 * qu * qu), i = qu * F4, a = Math.ceil(i), l = [];
            for(let c = -a; c <= a; c++)for(let u = -a; u <= a; u++){
                const d = u * u + c * c;
                if (d <= i * i) {
                    const h = d * r;
                    let p = (720 + h * (720 + h * (360 + h * (120 + h * (30 + h * (6 + h)))))) * 0.0013888888;
                    l.push([
                        c,
                        u,
                        p
                    ]);
                }
            }
            this.tensorCaches.orientationHistograms = {
                radialPropertiesT: hn($e(l, [
                    l.length,
                    3
                ]))
            };
        });
        const { radialPropertiesT: o } = this.tensorCaches.orientationHistograms;
        return D(()=>Ot().runKernel("ComputeOrientationHistograms", {
                gaussianImagesT: s,
                prunedExtremasT: t,
                radialPropertiesT: o,
                pyramidImagesLength: e.length
            }));
    }
    // The histogram is smoothed with a Gaussian, with sigma = 1
    _smoothHistograms(t) {
        return D(()=>Ot().runKernel("SmoothHistograms", {
                histograms: t
            }));
    }
    /**
   * 
   * @param {number[][]} prunedExtremasList 
   * @param {tf.Tensor<tf.Rank>[]} dogPyramidImagesT 
   * @returns 
   */ _computeLocalization(t, e) {
        return D(()=>{
            const o = Ot().runKernel("ComputeLocalization", {
                prunedExtremasList: t,
                dogPyramidImagesT: e
            }).arraySync(), r = [];
            for(let a = 0; a < o.length; a++){
                r.push([]);
                for(let l = 0; l < o[a].length; l++)r[a].push([]);
            }
            const i = [];
            for(let a = 0; a < t.length; a++)i[a] = [
                t[a][0],
                t[a][1],
                t[a][2],
                t[a][3]
            ];
            for(let a = 0; a < i.length; a++){
                if (i[a][0] === 0) continue;
                const l = o[a], c = 0.5 * (l[1][2] - l[1][0]), u = 0.5 * (l[2][1] - l[0][1]), d = l[1][2] + l[1][0] - 2 * l[1][1], h = l[2][1] + l[0][1] - 2 * l[1][1], p = 0.25 * (l[0][0] + l[2][2] - l[0][2] - l[2][0]), f = d * h - p * p, m = (h * -c + -p * -u) / f, g = (-p * -c + d * -u) / f, b = i[a][2] + g, x = i[a][3] + m;
                Math.abs(f) < 1e-4 || (i[a][2] = b, i[a][3] = x);
            }
            return $e(i, [
                i.length,
                i[0].length
            ], "float32");
        });
    }
    // faster to do it in CPU
    // if we do in gpu, we probably need to use tf.topk(), which seems to be run in CPU anyway (no gpu operation for that)
    //  TODO: research adapative maximum supression method
    /**
   * 
   * @param {tf.Tensor<tf.Rank>[]} extremasResultsT 
   * @returns 
   */ _applyPrune(t) {
        const e = Br * Br, s = D4, o = [], r = [];
        for(let a = 0; a < e; a++){
            r.push([]), o.push([]);
            for(let l = 0; l < s; l++)r[a].push([
                0,
                0,
                0,
                0
            ]), o[a].push(0);
        }
        D(()=>{
            for(let a = 0; a < t.length; a++){
                const l = Ot().runKernel("ExtremaReduction", {
                    extremasResultT: t[a]
                }), c = a + 1, u = l.arraySync(), d = l.shape[0], h = l.shape[1], p = h * 2 / Br, f = d * 2 / Br;
                for(let m = 0; m < d; m++)for(let g = 0; g < h; g++){
                    const b = u[m][g];
                    if (b == 0) continue;
                    const x = b % 1e3, w = Math.floor(Math.abs(b) / 1e3), y = g * 2 + (w === 2 || w === 3 ? 1 : 0), I = m * 2 + (w === 1 || w === 3 ? 1 : 0), v = Math.floor(y / p), S = Math.floor(I / f) * Br + v, N = Math.abs(x);
                    let R = s;
                    for(; R >= 1 && N > o[S][R - 1];)R -= 1;
                    if (R < s) {
                        for(let M = s - 1; M >= R + 1; M--)o[S][M] = o[S][M - 1], r[S][M][0] = r[S][M - 1][0], r[S][M][1] = r[S][M - 1][1], r[S][M][2] = r[S][M - 1][2], r[S][M][3] = r[S][M - 1][3];
                        o[S][R] = N, r[S][R][0] = x, r[S][R][1] = c, r[S][R][2] = I, r[S][R][3] = y;
                    }
                }
            }
        });
        const i = [];
        for(let a = 0; a < e; a++)for(let l = 0; l < s; l++)i.push(r[a][l]);
        return i;
    }
    _buildExtremas(t, e, s) {
        return D(()=>Ot().runKernel("BuildExtremas", {
                image0: t,
                image1: e,
                image2: s
            }));
    }
    /**
   * 
   * @param {tf.Tensor<tf.Rank>} image1 
   * @param {tf.Tensor<tf.Rank>} image2 
   * @returns 
   */ _differenceImageBinomial(t, e) {
        return D(()=>t.sub(e));
    }
    // 4th order binomail filter [1,4,6,4,1] X [1,4,6,4,1]
    _applyFilter(t) {
        return D(()=>Ot().runKernel("BinomialFilter", {
                image: t
            }));
    }
    /* _upsampleBilinear(image, targetImage) {
  		const imageHeight = image.shape[0];
  		const imageWidth = image.shape[1];
  
  		const kernelKey = 'w' + imageWidth;
  		if (!this.kernelCaches.upsampleBilinear) {
  			this.kernelCaches.upsampleBilinear = {};
  		}
  
  		if (!this.kernelCaches.upsampleBilinear[kernelKey]) {
  			const kernel = {
  				variableNames: ['p'],
  				outputShape: [targetImage.shape[0], targetImage.shape[1]],
  				userCode: `
  	  void main() {
  		ivec2 coords = getOutputCoords();
  		int j = coords[0];
  		int i = coords[1];
  
  		float sj = 0.5 * float(j) - 0.25; 
  		float si = 0.5 * float(i) - 0.25;
  
  		float sj0 = floor(sj);
  		float sj1 = ceil(sj);
  		float si0 = floor(si);
  		float si1 = ceil(si);
  
  		int sj0I = int(sj0);
  		int sj1I = int(sj1);
  		int si0I = int(si0);
  		int si1I = int(si1);
  
  		float sum = 0.0;
  		sum += getP(sj0I, si0I) * (si1 - si) * (sj1 - sj);
  		sum += getP(sj1I, si0I) * (si1 - si) * (sj - sj0);
  		sum += getP(sj0I, si1I) * (si - si0) * (sj1 - sj);
  		sum += getP(sj1I, si1I) * (si - si0) * (sj - sj0);
  		setOutput(sum);
  	  }
  	`
  			};
  			this.kernelCaches.upsampleBilinear[kernelKey] = kernel;
  		}
  
  		return tf.tidy(() => {
  			const program = this.kernelCaches.upsampleBilinear[kernelKey];
  			return tf.engine().runKernel("UpsampleBilinear", { x: image, width: image.shape[1], height: image.shape[0] });//this._compileAndRun(program, [image]);
  		});
  	} */ _downsampleBilinear(t) {
        return D(()=>Ot().runKernel("DownsampleBilinear", {
                image: t
            }));
    }
    /**
   * 
   * @param {tf.MathBackendWebGL.GPGPUProgram} program 
   * @param {*} inputs 
   * @returns 
   */ _compileAndRun(t, e) {
        const s = ps().compileAndRun(t, e);
        return Ot().makeTensorFromDataId(s.dataId, s.shape, s.dtype);
    }
    _runWebGLProgram(t, e, s) {
        const o = ps().runWebGLProgram(t, e, s);
        return Ot().makeTensorFromDataId(o.dataId, o.shape, o.dtype);
    }
}
class V4 {
    constructor(t, e, s = !1){
        this.debugMode = s, this.width = t, this.height = e;
        let o = Math.min(t, e) / 2, r = Math.pow(2, Math.round(Math.log(o) / Math.log(2)));
        this.cropSize = r, this.detector = new vC(r, r, s), this.kernelCaches = {}, this.lastRandomIndex = 4;
    }
    detect(t) {
        const e = Math.floor(this.height / 2 - this.cropSize / 2), s = Math.floor(this.width / 2 - this.cropSize / 2), o = this._detect(t, s, e);
        return this.debugMode && (o.debugExtra.crop = {
            startX: s,
            startY: e,
            cropSize: this.cropSize
        }), o;
    }
    detectMoving(t) {
        const e = this.lastRandomIndex % 3, s = Math.floor(this.lastRandomIndex / 3);
        let o = Math.floor(this.height / 2 - this.cropSize + s * this.cropSize / 2), r = Math.floor(this.width / 2 - this.cropSize + e * this.cropSize / 2);
        return r < 0 && (r = 0), o < 0 && (o = 0), r >= this.width - this.cropSize && (r = this.width - this.cropSize - 1), o >= this.height - this.cropSize && (o = this.height - this.cropSize - 1), this.lastRandomIndex = (this.lastRandomIndex + 1) % 9, this._detect(t, r, o);
    }
    _detect(t, e, s) {
        const o = t.slice([
            s,
            e
        ], [
            this.cropSize,
            this.cropSize
        ]), { featurePoints: r, debugExtra: i } = this.detector.detect(o);
        return r.forEach((a)=>{
            a.x += e, a.y += s;
        }), this.debugMode && (i.projectedImage = o.arraySync()), o.dispose(), {
            featurePoints: r,
            debugExtra: i
        };
    }
}
const SC = ({ image: n, ratio: t })=>{
    const e = Math.round(n.width * t), s = Math.round(n.height * t), o = new Uint8Array(e * s);
    for(let r = 0; r < e; r++){
        let i = Math.round(1 * r / t), a = Math.round(1 * (r + 1) / t) - 1;
        a >= n.width && (a = n.width - 1);
        for(let l = 0; l < s; l++){
            let c = Math.round(1 * l / t), u = Math.round(1 * (l + 1) / t) - 1;
            u >= n.height && (u = n.height - 1);
            let d = 0, h = 0;
            for(let p = i; p <= a; p++)for(let f = c; f <= u; f++)d += 1 * n.data[f * n.width + p], h += 1;
            o[l * e + r] = Math.floor(d / h);
        }
    }
    return {
        data: o,
        width: e,
        height: s
    };
}, z4 = 100, P4 = (n)=>{
    const t = z4 / Math.min(n.width, n.height), e = [];
    let s = t;
    for(;;)if (e.push(s), s *= Math.pow(2, 1 / 3), s >= 0.95) {
        s = 1;
        break;
    }
    e.push(s), e.reverse();
    const o = [];
    for(let r = 0; r < e.length; r++)n.width, e[r], n.height, e[r], o.push(Object.assign(SC({
        image: n,
        ratio: e[r]
    }), {
        scale: e[r]
    }));
    return o;
}, A4 = (n)=>{
    const t = Math.min(n.width, n.height), e = [], s = [];
    e.push(256 / t), e.push(128 / t);
    for(let o = 0; o < e.length; o++)s.push(Object.assign(SC({
        image: n,
        ratio: e[o]
    }), {
        scale: e[o]
    }));
    return s;
}, O4 = (n)=>{
    const { v1: t, v2: e } = n;
    let s = 0;
    for(let o = 0; o < t.length; o++){
        let r = (t[o] ^ e[o]) >>> 0;
        s += X4(r);
    }
    return s;
}, X4 = (n)=>{
    var t = n - (n >> 1 & 1431655765);
    return t = (t >> 2 & 858993459) + (t & 858993459), t = (t >> 4) + t & 252645135, t = (t >> 8) + t & 16711935, t = (t >> 16) + t & 65535, t;
}, K4 = 1234, Z4 = ()=>({
        seed: K4,
        arrayShuffle (t) {
            const { arr: e, sampleSize: s } = t;
            for(let o = 0; o < s; o++){
                this.seed = (214013 * this.seed + 2531011) % -2147483648;
                let r = this.seed >> 16 & 32767;
                r = r % e.length;
                let i = e[o];
                e[o] = e[r], e[r] = i;
            }
        },
        nextInt (t) {
            this.seed = (214013 * this.seed + 2531011) % -2147483648;
            let e = this.seed >> 16 & 32767;
            return e = e % t, e;
        }
    }), B4 = 16, H4 = 128, Bd = 8, _4 = (n)=>{
    const { points: t, pointIndexes: e, randomizer: s } = n, o = [];
    for(let l = 0; l < e.length; l++)o.push(l);
    let r = Number.MAX_SAFE_INTEGER, i = -1;
    const a = [];
    for(let l = 0; l < H4; l++){
        s.arrayShuffle({
            arr: o,
            sampleSize: Bd
        });
        let c = 0;
        const u = [];
        for(let d = 0; d < e.length; d++){
            let h = Number.MAX_SAFE_INTEGER;
            for(let p = 0; p < Bd; p++){
                const f = e[o[p]], m = O4({
                    v1: t[e[d]].descriptors,
                    v2: t[f].descriptors
                });
                m < h && (u[d] = o[p], h = m);
            }
            c += h;
        }
        a.push(u), c < r && (r = c, i = l);
    }
    return a[i];
}, _g = ({ points: n })=>{
    const t = [];
    for(let o = 0; o < n.length; o++)t.push(o);
    const e = Z4();
    return {
        rootNode: kC({
            points: n,
            pointIndexes: t,
            centerPointIndex: null,
            randomizer: e
        })
    };
}, kC = (n)=>{
    const { points: t, pointIndexes: e, centerPointIndex: s, randomizer: o } = n;
    let r = !1;
    (e.length <= Bd || e.length <= B4) && (r = !0);
    const i = {};
    if (!r) {
        const l = _4({
            points: t,
            pointIndexes: e,
            randomizer: o
        });
        for(let c = 0; c < l.length; c++)i[e[l[c]]] === void 0 && (i[e[l[c]]] = []), i[e[l[c]]].push(e[c]);
    }
    Object.keys(i).length === 1 && (r = !0);
    const a = {
        centerPointIndex: s
    };
    if (r) {
        a.leaf = !0, a.pointIndexes = [];
        for(let l = 0; l < e.length; l++)a.pointIndexes.push(e[l]);
        return a;
    }
    return a.leaf = !1, a.children = [], Object.keys(i).forEach((l)=>{
        a.children.push(kC({
            points: t,
            pointIndexes: i[l],
            centerPointIndex: l,
            randomizer: o
        }));
    }), a;
};
var fo = 4294967295;
function U4(n, t, e) {
    var s = e / 4294967296, o = e;
    n.setUint32(t, s), n.setUint32(t + 4, o);
}
function TC(n, t, e) {
    var s = Math.floor(e / 4294967296), o = e;
    n.setUint32(t, s), n.setUint32(t + 4, o);
}
function NC(n, t) {
    var e = n.getInt32(t), s = n.getUint32(t + 4);
    return e * 4294967296 + s;
}
function Y4(n, t) {
    var e = n.getUint32(t), s = n.getUint32(t + 4);
    return e * 4294967296 + s;
}
var td, ed, nd, Tu = typeof TextEncoder < "u" && typeof TextDecoder < "u";
function Ug(n) {
    for(var t = n.length, e = 0, s = 0; s < t;){
        var o = n.charCodeAt(s++);
        if (o & 4294967168) {
            if (!(o & 4294965248)) e += 2;
            else {
                if (o >= 55296 && o <= 56319 && s < t) {
                    var r = n.charCodeAt(s);
                    (r & 64512) === 56320 && (++s, o = ((o & 1023) << 10) + (r & 1023) + 65536);
                }
                o & 4294901760 ? e += 4 : e += 3;
            }
        } else {
            e++;
            continue;
        }
    }
    return e;
}
function Q4(n, t, e) {
    for(var s = n.length, o = e, r = 0; r < s;){
        var i = n.charCodeAt(r++);
        if (i & 4294967168) {
            if (!(i & 4294965248)) t[o++] = i >> 6 & 31 | 192;
            else {
                if (i >= 55296 && i <= 56319 && r < s) {
                    var a = n.charCodeAt(r);
                    (a & 64512) === 56320 && (++r, i = ((i & 1023) << 10) + (a & 1023) + 65536);
                }
                i & 4294901760 ? (t[o++] = i >> 18 & 7 | 240, t[o++] = i >> 12 & 63 | 128, t[o++] = i >> 6 & 63 | 128) : (t[o++] = i >> 12 & 15 | 224, t[o++] = i >> 6 & 63 | 128);
            }
        } else {
            t[o++] = i;
            continue;
        }
        t[o++] = i & 63 | 128;
    }
}
var oi = Tu ? new TextEncoder() : void 0, J4 = Tu ? 0 : fo;
function j4(n, t, e) {
    t.set(oi.encode(n), e);
}
function q4(n, t, e) {
    oi.encodeInto(n, t.subarray(e));
}
var tY = oi != null && oi.encodeInto ? q4 : j4, eY = 4096;
function RC(n, t, e) {
    for(var s = t, o = s + e, r = [], i = ""; s < o;){
        var a = n[s++];
        if (!(a & 128)) r.push(a);
        else if ((a & 224) === 192) {
            var l = n[s++] & 63;
            r.push((a & 31) << 6 | l);
        } else if ((a & 240) === 224) {
            var l = n[s++] & 63, c = n[s++] & 63;
            r.push((a & 31) << 12 | l << 6 | c);
        } else if ((a & 248) === 240) {
            var l = n[s++] & 63, c = n[s++] & 63, u = n[s++] & 63, d = (a & 7) << 18 | l << 12 | c << 6 | u;
            d > 65535 && (d -= 65536, r.push(d >>> 10 & 1023 | 55296), d = 56320 | d & 1023), r.push(d);
        } else r.push(a);
        r.length >= eY && (i += String.fromCharCode.apply(String, r), r.length = 0);
    }
    return r.length > 0 && (i += String.fromCharCode.apply(String, r)), i;
}
var nY = Tu ? new TextDecoder() : null, sY = Tu ? 0 : fo;
function oY(n, t, e) {
    var s = n.subarray(t, t + e);
    return nY.decode(s);
}
var sl = /** @class */ /* @__PURE__ */ function() {
    function n(t, e) {
        this.type = t, this.data = e;
    }
    return n;
}(), rY = /* @__PURE__ */ function() {
    var n = function(t, e) {
        return n = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(s, o) {
            s.__proto__ = o;
        } || function(s, o) {
            for(var r in o)Object.prototype.hasOwnProperty.call(o, r) && (s[r] = o[r]);
        }, n(t, e);
    };
    return function(t, e) {
        if (typeof e != "function" && e !== null) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
        n(t, e);
        function s() {
            this.constructor = t;
        }
        t.prototype = e === null ? Object.create(e) : (s.prototype = e.prototype, new s());
    };
}(), Yn = /** @class */ function(n) {
    rY(t, n);
    function t(e) {
        var s = n.call(this, e) || this, o = Object.create(t.prototype);
        return Object.setPrototypeOf(s, o), Object.defineProperty(s, "name", {
            configurable: !0,
            enumerable: !1,
            value: t.name
        }), s;
    }
    return t;
}(Error), iY = -1, aY = 4294967295, lY = 17179869183;
function cY(n) {
    var t = n.sec, e = n.nsec;
    if (t >= 0 && e >= 0 && t <= lY) {
        if (e === 0 && t <= aY) {
            var s = new Uint8Array(4), o = new DataView(s.buffer);
            return o.setUint32(0, t), s;
        } else {
            var r = t / 4294967296, i = t & 4294967295, s = new Uint8Array(8), o = new DataView(s.buffer);
            return o.setUint32(0, e << 2 | r & 3), o.setUint32(4, i), s;
        }
    } else {
        var s = new Uint8Array(12), o = new DataView(s.buffer);
        return o.setUint32(0, e), TC(o, 4, t), s;
    }
}
function uY(n) {
    var t = n.getTime(), e = Math.floor(t / 1e3), s = (t - e * 1e3) * 1e6, o = Math.floor(s / 1e9);
    return {
        sec: e + o,
        nsec: s - o * 1e9
    };
}
function dY(n) {
    if (n instanceof Date) {
        var t = uY(n);
        return cY(t);
    } else return null;
}
function hY(n) {
    var t = new DataView(n.buffer, n.byteOffset, n.byteLength);
    switch(n.byteLength){
        case 4:
            var e = t.getUint32(0), s = 0;
            return {
                sec: e,
                nsec: s
            };
        case 8:
            var o = t.getUint32(0), r = t.getUint32(4), e = (o & 3) * 4294967296 + r, s = o >>> 2;
            return {
                sec: e,
                nsec: s
            };
        case 12:
            var e = NC(t, 4), s = t.getUint32(0);
            return {
                sec: e,
                nsec: s
            };
        default:
            throw new Yn("Unrecognized data size for timestamp (expected 4, 8, or 12): ".concat(n.length));
    }
}
function pY(n) {
    var t = hY(n);
    return new Date(t.sec * 1e3 + t.nsec / 1e6);
}
var fY = {
    type: iY,
    encode: dY,
    decode: pY
}, $C = /** @class */ function() {
    function n() {
        this.builtInEncoders = [], this.builtInDecoders = [], this.encoders = [], this.decoders = [], this.register(fY);
    }
    return n.prototype.register = function(t) {
        var e = t.type, s = t.encode, o = t.decode;
        if (e >= 0) this.encoders[e] = s, this.decoders[e] = o;
        else {
            var r = 1 + e;
            this.builtInEncoders[r] = s, this.builtInDecoders[r] = o;
        }
    }, n.prototype.tryToEncode = function(t, e) {
        for(var s = 0; s < this.builtInEncoders.length; s++){
            var o = this.builtInEncoders[s];
            if (o != null) {
                var r = o(t, e);
                if (r != null) {
                    var i = -1 - s;
                    return new sl(i, r);
                }
            }
        }
        for(var s = 0; s < this.encoders.length; s++){
            var o = this.encoders[s];
            if (o != null) {
                var r = o(t, e);
                if (r != null) {
                    var i = s;
                    return new sl(i, r);
                }
            }
        }
        return t instanceof sl ? t : null;
    }, n.prototype.decode = function(t, e, s) {
        var o = e < 0 ? this.builtInDecoders[-1 - e] : this.decoders[e];
        return o ? o(t, e, s) : new sl(e, t);
    }, n.defaultCodec = new n(), n;
}();
function Zl(n) {
    return n instanceof Uint8Array ? n : ArrayBuffer.isView(n) ? new Uint8Array(n.buffer, n.byteOffset, n.byteLength) : n instanceof ArrayBuffer ? new Uint8Array(n) : Uint8Array.from(n);
}
function mY(n) {
    if (n instanceof ArrayBuffer) return new DataView(n);
    var t = Zl(n);
    return new DataView(t.buffer, t.byteOffset, t.byteLength);
}
var gY = 100, bY = 2048, xY = /** @class */ function() {
    function n(t, e, s, o, r, i, a, l) {
        t === void 0 && (t = $C.defaultCodec), e === void 0 && (e = void 0), s === void 0 && (s = gY), o === void 0 && (o = bY), r === void 0 && (r = !1), i === void 0 && (i = !1), a === void 0 && (a = !1), l === void 0 && (l = !1), this.extensionCodec = t, this.context = e, this.maxDepth = s, this.initialBufferSize = o, this.sortKeys = r, this.forceFloat32 = i, this.ignoreUndefined = a, this.forceIntegerToFloat = l, this.pos = 0, this.view = new DataView(new ArrayBuffer(this.initialBufferSize)), this.bytes = new Uint8Array(this.view.buffer);
    }
    return n.prototype.reinitializeState = function() {
        this.pos = 0;
    }, n.prototype.encodeSharedRef = function(t) {
        return this.reinitializeState(), this.doEncode(t, 1), this.bytes.subarray(0, this.pos);
    }, n.prototype.encode = function(t) {
        return this.reinitializeState(), this.doEncode(t, 1), this.bytes.slice(0, this.pos);
    }, n.prototype.doEncode = function(t, e) {
        if (e > this.maxDepth) throw new Error("Too deep objects in depth ".concat(e));
        t == null ? this.encodeNil() : typeof t == "boolean" ? this.encodeBoolean(t) : typeof t == "number" ? this.encodeNumber(t) : typeof t == "string" ? this.encodeString(t) : this.encodeObject(t, e);
    }, n.prototype.ensureBufferSizeToWrite = function(t) {
        var e = this.pos + t;
        this.view.byteLength < e && this.resizeBuffer(e * 2);
    }, n.prototype.resizeBuffer = function(t) {
        var e = new ArrayBuffer(t), s = new Uint8Array(e), o = new DataView(e);
        s.set(this.bytes), this.view = o, this.bytes = s;
    }, n.prototype.encodeNil = function() {
        this.writeU8(192);
    }, n.prototype.encodeBoolean = function(t) {
        t === !1 ? this.writeU8(194) : this.writeU8(195);
    }, n.prototype.encodeNumber = function(t) {
        Number.isSafeInteger(t) && !this.forceIntegerToFloat ? t >= 0 ? t < 128 ? this.writeU8(t) : t < 256 ? (this.writeU8(204), this.writeU8(t)) : t < 65536 ? (this.writeU8(205), this.writeU16(t)) : t < 4294967296 ? (this.writeU8(206), this.writeU32(t)) : (this.writeU8(207), this.writeU64(t)) : t >= -32 ? this.writeU8(224 | t + 32) : t >= -128 ? (this.writeU8(208), this.writeI8(t)) : t >= -32768 ? (this.writeU8(209), this.writeI16(t)) : t >= -2147483648 ? (this.writeU8(210), this.writeI32(t)) : (this.writeU8(211), this.writeI64(t)) : this.forceFloat32 ? (this.writeU8(202), this.writeF32(t)) : (this.writeU8(203), this.writeF64(t));
    }, n.prototype.writeStringHeader = function(t) {
        if (t < 32) this.writeU8(160 + t);
        else if (t < 256) this.writeU8(217), this.writeU8(t);
        else if (t < 65536) this.writeU8(218), this.writeU16(t);
        else if (t < 4294967296) this.writeU8(219), this.writeU32(t);
        else throw new Error("Too long string: ".concat(t, " bytes in UTF-8"));
    }, n.prototype.encodeString = function(t) {
        var e = 5, s = t.length;
        if (s > J4) {
            var o = Ug(t);
            this.ensureBufferSizeToWrite(e + o), this.writeStringHeader(o), tY(t, this.bytes, this.pos), this.pos += o;
        } else {
            var o = Ug(t);
            this.ensureBufferSizeToWrite(e + o), this.writeStringHeader(o), Q4(t, this.bytes, this.pos), this.pos += o;
        }
    }, n.prototype.encodeObject = function(t, e) {
        var s = this.extensionCodec.tryToEncode(t, this.context);
        if (s != null) this.encodeExtension(s);
        else if (Array.isArray(t)) this.encodeArray(t, e);
        else if (ArrayBuffer.isView(t)) this.encodeBinary(t);
        else if (typeof t == "object") this.encodeMap(t, e);
        else throw new Error("Unrecognized object: ".concat(Object.prototype.toString.apply(t)));
    }, n.prototype.encodeBinary = function(t) {
        var e = t.byteLength;
        if (e < 256) this.writeU8(196), this.writeU8(e);
        else if (e < 65536) this.writeU8(197), this.writeU16(e);
        else if (e < 4294967296) this.writeU8(198), this.writeU32(e);
        else throw new Error("Too large binary: ".concat(e));
        var s = Zl(t);
        this.writeU8a(s);
    }, n.prototype.encodeArray = function(t, e) {
        var s = t.length;
        if (s < 16) this.writeU8(144 + s);
        else if (s < 65536) this.writeU8(220), this.writeU16(s);
        else if (s < 4294967296) this.writeU8(221), this.writeU32(s);
        else throw new Error("Too large array: ".concat(s));
        for(var o = 0, r = t; o < r.length; o++){
            var i = r[o];
            this.doEncode(i, e + 1);
        }
    }, n.prototype.countWithoutUndefined = function(t, e) {
        for(var s = 0, o = 0, r = e; o < r.length; o++){
            var i = r[o];
            t[i] !== void 0 && s++;
        }
        return s;
    }, n.prototype.encodeMap = function(t, e) {
        var s = Object.keys(t);
        this.sortKeys && s.sort();
        var o = this.ignoreUndefined ? this.countWithoutUndefined(t, s) : s.length;
        if (o < 16) this.writeU8(128 + o);
        else if (o < 65536) this.writeU8(222), this.writeU16(o);
        else if (o < 4294967296) this.writeU8(223), this.writeU32(o);
        else throw new Error("Too large map object: ".concat(o));
        for(var r = 0, i = s; r < i.length; r++){
            var a = i[r], l = t[a];
            this.ignoreUndefined && l === void 0 || (this.encodeString(a), this.doEncode(l, e + 1));
        }
    }, n.prototype.encodeExtension = function(t) {
        var e = t.data.length;
        if (e === 1) this.writeU8(212);
        else if (e === 2) this.writeU8(213);
        else if (e === 4) this.writeU8(214);
        else if (e === 8) this.writeU8(215);
        else if (e === 16) this.writeU8(216);
        else if (e < 256) this.writeU8(199), this.writeU8(e);
        else if (e < 65536) this.writeU8(200), this.writeU16(e);
        else if (e < 4294967296) this.writeU8(201), this.writeU32(e);
        else throw new Error("Too large extension object: ".concat(e));
        this.writeI8(t.type), this.writeU8a(t.data);
    }, n.prototype.writeU8 = function(t) {
        this.ensureBufferSizeToWrite(1), this.view.setUint8(this.pos, t), this.pos++;
    }, n.prototype.writeU8a = function(t) {
        var e = t.length;
        this.ensureBufferSizeToWrite(e), this.bytes.set(t, this.pos), this.pos += e;
    }, n.prototype.writeI8 = function(t) {
        this.ensureBufferSizeToWrite(1), this.view.setInt8(this.pos, t), this.pos++;
    }, n.prototype.writeU16 = function(t) {
        this.ensureBufferSizeToWrite(2), this.view.setUint16(this.pos, t), this.pos += 2;
    }, n.prototype.writeI16 = function(t) {
        this.ensureBufferSizeToWrite(2), this.view.setInt16(this.pos, t), this.pos += 2;
    }, n.prototype.writeU32 = function(t) {
        this.ensureBufferSizeToWrite(4), this.view.setUint32(this.pos, t), this.pos += 4;
    }, n.prototype.writeI32 = function(t) {
        this.ensureBufferSizeToWrite(4), this.view.setInt32(this.pos, t), this.pos += 4;
    }, n.prototype.writeF32 = function(t) {
        this.ensureBufferSizeToWrite(4), this.view.setFloat32(this.pos, t), this.pos += 4;
    }, n.prototype.writeF64 = function(t) {
        this.ensureBufferSizeToWrite(8), this.view.setFloat64(this.pos, t), this.pos += 8;
    }, n.prototype.writeU64 = function(t) {
        this.ensureBufferSizeToWrite(8), U4(this.view, this.pos, t), this.pos += 8;
    }, n.prototype.writeI64 = function(t) {
        this.ensureBufferSizeToWrite(8), TC(this.view, this.pos, t), this.pos += 8;
    }, n;
}(), yY = {};
function wY(n, t) {
    t === void 0 && (t = yY);
    var e = new xY(t.extensionCodec, t.context, t.maxDepth, t.initialBufferSize, t.sortKeys, t.forceFloat32, t.ignoreUndefined, t.forceIntegerToFloat);
    return e.encodeSharedRef(n);
}
function sd(n) {
    return "".concat(n < 0 ? "-" : "", "0x").concat(Math.abs(n).toString(16).padStart(2, "0"));
}
var IY = 16, CY = 16, vY = /** @class */ function() {
    function n(t, e) {
        t === void 0 && (t = IY), e === void 0 && (e = CY), this.maxKeyLength = t, this.maxLengthPerKey = e, this.hit = 0, this.miss = 0, this.caches = [];
        for(var s = 0; s < this.maxKeyLength; s++)this.caches.push([]);
    }
    return n.prototype.canBeCached = function(t) {
        return t > 0 && t <= this.maxKeyLength;
    }, n.prototype.find = function(t, e, s) {
        var o = this.caches[s - 1];
        t: for(var r = 0, i = o; r < i.length; r++){
            for(var a = i[r], l = a.bytes, c = 0; c < s; c++)if (l[c] !== t[e + c]) continue t;
            return a.str;
        }
        return null;
    }, n.prototype.store = function(t, e) {
        var s = this.caches[t.length - 1], o = {
            bytes: t,
            str: e
        };
        s.length >= this.maxLengthPerKey ? s[Math.random() * s.length | 0] = o : s.push(o);
    }, n.prototype.decode = function(t, e, s) {
        var o = this.find(t, e, s);
        if (o != null) return this.hit++, o;
        this.miss++;
        var r = RC(t, e, s), i = Uint8Array.prototype.slice.call(t, e, e + s);
        return this.store(i, r), r;
    }, n;
}(), SY = function(n, t, e, s) {
    function o(r) {
        return r instanceof e ? r : new e(function(i) {
            i(r);
        });
    }
    return new (e || (e = Promise))(function(r, i) {
        function a(u) {
            try {
                c(s.next(u));
            } catch (d) {
                i(d);
            }
        }
        function l(u) {
            try {
                c(s.throw(u));
            } catch (d) {
                i(d);
            }
        }
        function c(u) {
            u.done ? r(u.value) : o(u.value).then(a, l);
        }
        c((s = s.apply(n, t || [])).next());
    });
}, od = function(n, t) {
    var e = {
        label: 0,
        sent: function() {
            if (r[0] & 1) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, s, o, r, i;
    return i = {
        next: a(0),
        throw: a(1),
        return: a(2)
    }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
        return this;
    }), i;
    function a(c) {
        return function(u) {
            return l([
                c,
                u
            ]);
        };
    }
    function l(c) {
        if (s) throw new TypeError("Generator is already executing.");
        for(; e;)try {
            if (s = 1, o && (r = c[0] & 2 ? o.return : c[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, c[1])).done) return r;
            switch(o = 0, r && (c = [
                c[0] & 2,
                r.value
            ]), c[0]){
                case 0:
                case 1:
                    r = c;
                    break;
                case 4:
                    return e.label++, {
                        value: c[1],
                        done: !1
                    };
                case 5:
                    e.label++, o = c[1], c = [
                        0
                    ];
                    continue;
                case 7:
                    c = e.ops.pop(), e.trys.pop();
                    continue;
                default:
                    if (r = e.trys, !(r = r.length > 0 && r[r.length - 1]) && (c[0] === 6 || c[0] === 2)) {
                        e = 0;
                        continue;
                    }
                    if (c[0] === 3 && (!r || c[1] > r[0] && c[1] < r[3])) {
                        e.label = c[1];
                        break;
                    }
                    if (c[0] === 6 && e.label < r[1]) {
                        e.label = r[1], r = c;
                        break;
                    }
                    if (r && e.label < r[2]) {
                        e.label = r[2], e.ops.push(c);
                        break;
                    }
                    r[2] && e.ops.pop(), e.trys.pop();
                    continue;
            }
            c = t.call(n, e);
        } catch (u) {
            c = [
                6,
                u
            ], o = 0;
        } finally{
            s = r = 0;
        }
        if (c[0] & 5) throw c[1];
        return {
            value: c[0] ? c[1] : void 0,
            done: !0
        };
    }
}, Yg = function(n) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var t = n[Symbol.asyncIterator], e;
    return t ? t.call(n) : (n = typeof __values == "function" ? __values(n) : n[Symbol.iterator](), e = {}, s("next"), s("throw"), s("return"), e[Symbol.asyncIterator] = function() {
        return this;
    }, e);
    function s(r) {
        e[r] = n[r] && function(i) {
            return new Promise(function(a, l) {
                i = n[r](i), o(a, l, i.done, i.value);
            });
        };
    }
    function o(r, i, a, l) {
        Promise.resolve(l).then(function(c) {
            r({
                value: c,
                done: a
            });
        }, i);
    }
}, hr = function(n) {
    return this instanceof hr ? (this.v = n, this) : new hr(n);
}, kY = function(n, t, e) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var s = e.apply(n, t || []), o, r = [];
    return o = {}, i("next"), i("throw"), i("return"), o[Symbol.asyncIterator] = function() {
        return this;
    }, o;
    function i(h) {
        s[h] && (o[h] = function(p) {
            return new Promise(function(f, m) {
                r.push([
                    h,
                    p,
                    f,
                    m
                ]) > 1 || a(h, p);
            });
        });
    }
    function a(h, p) {
        try {
            l(s[h](p));
        } catch (f) {
            d(r[0][3], f);
        }
    }
    function l(h) {
        h.value instanceof hr ? Promise.resolve(h.value.v).then(c, u) : d(r[0][2], h);
    }
    function c(h) {
        a("next", h);
    }
    function u(h) {
        a("throw", h);
    }
    function d(h, p) {
        h(p), r.shift(), r.length && a(r[0][0], r[0][1]);
    }
}, TY = function(n) {
    var t = typeof n;
    return t === "string" || t === "number";
}, Hr = -1, cm = new DataView(new ArrayBuffer(0)), NY = new Uint8Array(cm.buffer), Hd = function() {
    try {
        cm.getInt8(0);
    } catch (n) {
        return n.constructor;
    }
    throw new Error("never reached");
}(), Qg = new Hd("Insufficient data"), RY = new vY(), $Y = /** @class */ function() {
    function n(t, e, s, o, r, i, a, l) {
        t === void 0 && (t = $C.defaultCodec), e === void 0 && (e = void 0), s === void 0 && (s = fo), o === void 0 && (o = fo), r === void 0 && (r = fo), i === void 0 && (i = fo), a === void 0 && (a = fo), l === void 0 && (l = RY), this.extensionCodec = t, this.context = e, this.maxStrLength = s, this.maxBinLength = o, this.maxArrayLength = r, this.maxMapLength = i, this.maxExtLength = a, this.keyDecoder = l, this.totalPos = 0, this.pos = 0, this.view = cm, this.bytes = NY, this.headByte = Hr, this.stack = [];
    }
    return n.prototype.reinitializeState = function() {
        this.totalPos = 0, this.headByte = Hr, this.stack.length = 0;
    }, n.prototype.setBuffer = function(t) {
        this.bytes = Zl(t), this.view = mY(this.bytes), this.pos = 0;
    }, n.prototype.appendBuffer = function(t) {
        if (this.headByte === Hr && !this.hasRemaining(1)) this.setBuffer(t);
        else {
            var e = this.bytes.subarray(this.pos), s = Zl(t), o = new Uint8Array(e.length + s.length);
            o.set(e), o.set(s, e.length), this.setBuffer(o);
        }
    }, n.prototype.hasRemaining = function(t) {
        return this.view.byteLength - this.pos >= t;
    }, n.prototype.createExtraByteError = function(t) {
        var e = this, s = e.view, o = e.pos;
        return new RangeError("Extra ".concat(s.byteLength - o, " of ").concat(s.byteLength, " byte(s) found at buffer[").concat(t, "]"));
    }, n.prototype.decode = function(t) {
        this.reinitializeState(), this.setBuffer(t);
        var e = this.doDecodeSync();
        if (this.hasRemaining(1)) throw this.createExtraByteError(this.pos);
        return e;
    }, n.prototype.decodeMulti = function(t) {
        return od(this, function(e) {
            switch(e.label){
                case 0:
                    this.reinitializeState(), this.setBuffer(t), e.label = 1;
                case 1:
                    return this.hasRemaining(1) ? [
                        4,
                        this.doDecodeSync()
                    ] : [
                        3,
                        3
                    ];
                case 2:
                    return e.sent(), [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }, n.prototype.decodeAsync = function(t) {
        var e, s, o, r;
        return SY(this, void 0, void 0, function() {
            var i, a, l, c, u, d, h, p;
            return od(this, function(f) {
                switch(f.label){
                    case 0:
                        i = !1, f.label = 1;
                    case 1:
                        f.trys.push([
                            1,
                            6,
                            7,
                            12
                        ]), e = Yg(t), f.label = 2;
                    case 2:
                        return [
                            4,
                            e.next()
                        ];
                    case 3:
                        if (s = f.sent(), !!s.done) return [
                            3,
                            5
                        ];
                        if (l = s.value, i) throw this.createExtraByteError(this.totalPos);
                        this.appendBuffer(l);
                        try {
                            a = this.doDecodeSync(), i = !0;
                        } catch (m) {
                            if (!(m instanceof Hd)) throw m;
                        }
                        this.totalPos += this.pos, f.label = 4;
                    case 4:
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            12
                        ];
                    case 6:
                        return c = f.sent(), o = {
                            error: c
                        }, [
                            3,
                            12
                        ];
                    case 7:
                        return f.trys.push([
                            7,
                            ,
                            10,
                            11
                        ]), s && !s.done && (r = e.return) ? [
                            4,
                            r.call(e)
                        ] : [
                            3,
                            9
                        ];
                    case 8:
                        f.sent(), f.label = 9;
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        if (o) throw o.error;
                        return [
                            7
                        ];
                    case 11:
                        return [
                            7
                        ];
                    case 12:
                        if (i) {
                            if (this.hasRemaining(1)) throw this.createExtraByteError(this.totalPos);
                            return [
                                2,
                                a
                            ];
                        }
                        throw u = this, d = u.headByte, h = u.pos, p = u.totalPos, new RangeError("Insufficient data in parsing ".concat(sd(d), " at ").concat(p, " (").concat(h, " in the current buffer)"));
                }
            });
        });
    }, n.prototype.decodeArrayStream = function(t) {
        return this.decodeMultiAsync(t, !0);
    }, n.prototype.decodeStream = function(t) {
        return this.decodeMultiAsync(t, !1);
    }, n.prototype.decodeMultiAsync = function(t, e) {
        return kY(this, arguments, function() {
            var o, r, i, a, l, c, u, d, h;
            return od(this, function(p) {
                switch(p.label){
                    case 0:
                        o = e, r = -1, p.label = 1;
                    case 1:
                        p.trys.push([
                            1,
                            13,
                            14,
                            19
                        ]), i = Yg(t), p.label = 2;
                    case 2:
                        return [
                            4,
                            hr(i.next())
                        ];
                    case 3:
                        if (a = p.sent(), !!a.done) return [
                            3,
                            12
                        ];
                        if (l = a.value, e && r === 0) throw this.createExtraByteError(this.totalPos);
                        this.appendBuffer(l), o && (r = this.readArraySize(), o = !1, this.complete()), p.label = 4;
                    case 4:
                        p.trys.push([
                            4,
                            9,
                            ,
                            10
                        ]), p.label = 5;
                    case 5:
                        return [
                            4,
                            hr(this.doDecodeSync())
                        ];
                    case 6:
                        return [
                            4,
                            p.sent()
                        ];
                    case 7:
                        return p.sent(), --r === 0 ? [
                            3,
                            8
                        ] : [
                            3,
                            5
                        ];
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        if (c = p.sent(), !(c instanceof Hd)) throw c;
                        return [
                            3,
                            10
                        ];
                    case 10:
                        this.totalPos += this.pos, p.label = 11;
                    case 11:
                        return [
                            3,
                            2
                        ];
                    case 12:
                        return [
                            3,
                            19
                        ];
                    case 13:
                        return u = p.sent(), d = {
                            error: u
                        }, [
                            3,
                            19
                        ];
                    case 14:
                        return p.trys.push([
                            14,
                            ,
                            17,
                            18
                        ]), a && !a.done && (h = i.return) ? [
                            4,
                            hr(h.call(i))
                        ] : [
                            3,
                            16
                        ];
                    case 15:
                        p.sent(), p.label = 16;
                    case 16:
                        return [
                            3,
                            18
                        ];
                    case 17:
                        if (d) throw d.error;
                        return [
                            7
                        ];
                    case 18:
                        return [
                            7
                        ];
                    case 19:
                        return [
                            2
                        ];
                }
            });
        });
    }, n.prototype.doDecodeSync = function() {
        t: for(;;){
            var t = this.readHeadByte(), e = void 0;
            if (t >= 224) e = t - 256;
            else if (t < 192) {
                if (t < 128) e = t;
                else if (t < 144) {
                    var s = t - 128;
                    if (s !== 0) {
                        this.pushMapState(s), this.complete();
                        continue t;
                    } else e = {};
                } else if (t < 160) {
                    var s = t - 144;
                    if (s !== 0) {
                        this.pushArrayState(s), this.complete();
                        continue t;
                    } else e = [];
                } else {
                    var o = t - 160;
                    e = this.decodeUtf8String(o, 0);
                }
            } else if (t === 192) e = null;
            else if (t === 194) e = !1;
            else if (t === 195) e = !0;
            else if (t === 202) e = this.readF32();
            else if (t === 203) e = this.readF64();
            else if (t === 204) e = this.readU8();
            else if (t === 205) e = this.readU16();
            else if (t === 206) e = this.readU32();
            else if (t === 207) e = this.readU64();
            else if (t === 208) e = this.readI8();
            else if (t === 209) e = this.readI16();
            else if (t === 210) e = this.readI32();
            else if (t === 211) e = this.readI64();
            else if (t === 217) {
                var o = this.lookU8();
                e = this.decodeUtf8String(o, 1);
            } else if (t === 218) {
                var o = this.lookU16();
                e = this.decodeUtf8String(o, 2);
            } else if (t === 219) {
                var o = this.lookU32();
                e = this.decodeUtf8String(o, 4);
            } else if (t === 220) {
                var s = this.readU16();
                if (s !== 0) {
                    this.pushArrayState(s), this.complete();
                    continue t;
                } else e = [];
            } else if (t === 221) {
                var s = this.readU32();
                if (s !== 0) {
                    this.pushArrayState(s), this.complete();
                    continue t;
                } else e = [];
            } else if (t === 222) {
                var s = this.readU16();
                if (s !== 0) {
                    this.pushMapState(s), this.complete();
                    continue t;
                } else e = {};
            } else if (t === 223) {
                var s = this.readU32();
                if (s !== 0) {
                    this.pushMapState(s), this.complete();
                    continue t;
                } else e = {};
            } else if (t === 196) {
                var s = this.lookU8();
                e = this.decodeBinary(s, 1);
            } else if (t === 197) {
                var s = this.lookU16();
                e = this.decodeBinary(s, 2);
            } else if (t === 198) {
                var s = this.lookU32();
                e = this.decodeBinary(s, 4);
            } else if (t === 212) e = this.decodeExtension(1, 0);
            else if (t === 213) e = this.decodeExtension(2, 0);
            else if (t === 214) e = this.decodeExtension(4, 0);
            else if (t === 215) e = this.decodeExtension(8, 0);
            else if (t === 216) e = this.decodeExtension(16, 0);
            else if (t === 199) {
                var s = this.lookU8();
                e = this.decodeExtension(s, 1);
            } else if (t === 200) {
                var s = this.lookU16();
                e = this.decodeExtension(s, 2);
            } else if (t === 201) {
                var s = this.lookU32();
                e = this.decodeExtension(s, 4);
            } else throw new Yn("Unrecognized type byte: ".concat(sd(t)));
            this.complete();
            for(var r = this.stack; r.length > 0;){
                var i = r[r.length - 1];
                if (i.type === 0) {
                    if (i.array[i.position] = e, i.position++, i.position === i.size) r.pop(), e = i.array;
                    else continue t;
                } else if (i.type === 1) {
                    if (!TY(e)) throw new Yn("The type of key must be string or number but " + typeof e);
                    if (e === "__proto__") throw new Yn("The key __proto__ is not allowed");
                    i.key = e, i.type = 2;
                    continue t;
                } else if (i.map[i.key] = e, i.readCount++, i.readCount === i.size) r.pop(), e = i.map;
                else {
                    i.key = null, i.type = 1;
                    continue t;
                }
            }
            return e;
        }
    }, n.prototype.readHeadByte = function() {
        return this.headByte === Hr && (this.headByte = this.readU8()), this.headByte;
    }, n.prototype.complete = function() {
        this.headByte = Hr;
    }, n.prototype.readArraySize = function() {
        var t = this.readHeadByte();
        switch(t){
            case 220:
                return this.readU16();
            case 221:
                return this.readU32();
            default:
                if (t < 160) return t - 144;
                throw new Yn("Unrecognized array type byte: ".concat(sd(t)));
        }
    }, n.prototype.pushMapState = function(t) {
        if (t > this.maxMapLength) throw new Yn("Max length exceeded: map length (".concat(t, ") > maxMapLengthLength (").concat(this.maxMapLength, ")"));
        this.stack.push({
            type: 1,
            size: t,
            key: null,
            readCount: 0,
            map: {}
        });
    }, n.prototype.pushArrayState = function(t) {
        if (t > this.maxArrayLength) throw new Yn("Max length exceeded: array length (".concat(t, ") > maxArrayLength (").concat(this.maxArrayLength, ")"));
        this.stack.push({
            type: 0,
            size: t,
            array: new Array(t),
            position: 0
        });
    }, n.prototype.decodeUtf8String = function(t, e) {
        var s;
        if (t > this.maxStrLength) throw new Yn("Max length exceeded: UTF-8 byte length (".concat(t, ") > maxStrLength (").concat(this.maxStrLength, ")"));
        if (this.bytes.byteLength < this.pos + e + t) throw Qg;
        var o = this.pos + e, r;
        return this.stateIsMapKey() && !((s = this.keyDecoder) === null || s === void 0) && s.canBeCached(t) ? r = this.keyDecoder.decode(this.bytes, o, t) : t > sY ? r = oY(this.bytes, o, t) : r = RC(this.bytes, o, t), this.pos += e + t, r;
    }, n.prototype.stateIsMapKey = function() {
        if (this.stack.length > 0) {
            var t = this.stack[this.stack.length - 1];
            return t.type === 1;
        }
        return !1;
    }, n.prototype.decodeBinary = function(t, e) {
        if (t > this.maxBinLength) throw new Yn("Max length exceeded: bin length (".concat(t, ") > maxBinLength (").concat(this.maxBinLength, ")"));
        if (!this.hasRemaining(t + e)) throw Qg;
        var s = this.pos + e, o = this.bytes.subarray(s, s + t);
        return this.pos += e + t, o;
    }, n.prototype.decodeExtension = function(t, e) {
        if (t > this.maxExtLength) throw new Yn("Max length exceeded: ext length (".concat(t, ") > maxExtLength (").concat(this.maxExtLength, ")"));
        var s = this.view.getInt8(this.pos + e), o = this.decodeBinary(t, e + 1);
        return this.extensionCodec.decode(o, s, this.context);
    }, n.prototype.lookU8 = function() {
        return this.view.getUint8(this.pos);
    }, n.prototype.lookU16 = function() {
        return this.view.getUint16(this.pos);
    }, n.prototype.lookU32 = function() {
        return this.view.getUint32(this.pos);
    }, n.prototype.readU8 = function() {
        var t = this.view.getUint8(this.pos);
        return this.pos++, t;
    }, n.prototype.readI8 = function() {
        var t = this.view.getInt8(this.pos);
        return this.pos++, t;
    }, n.prototype.readU16 = function() {
        var t = this.view.getUint16(this.pos);
        return this.pos += 2, t;
    }, n.prototype.readI16 = function() {
        var t = this.view.getInt16(this.pos);
        return this.pos += 2, t;
    }, n.prototype.readU32 = function() {
        var t = this.view.getUint32(this.pos);
        return this.pos += 4, t;
    }, n.prototype.readI32 = function() {
        var t = this.view.getInt32(this.pos);
        return this.pos += 4, t;
    }, n.prototype.readU64 = function() {
        var t = Y4(this.view, this.pos);
        return this.pos += 8, t;
    }, n.prototype.readI64 = function() {
        var t = NC(this.view, this.pos);
        return this.pos += 8, t;
    }, n.prototype.readF32 = function() {
        var t = this.view.getFloat32(this.pos);
        return this.pos += 4, t;
    }, n.prototype.readF64 = function() {
        var t = this.view.getFloat64(this.pos);
        return this.pos += 8, t;
    }, n;
}(), GY = {};
function EY(n, t) {
    t === void 0 && (t = GY);
    var e = new $Y(t.extensionCodec, t.context, t.maxStrLength, t.maxBinLength, t.maxArrayLength, t.maxMapLength, t.maxExtLength);
    return e.decode(n);
}
const Jg = 2;
class LY {
    constructor(){
        this.data = null;
    }
    // input html Images
    compileImageTargets(t, e) {
        return new Promise(async (s, o)=>{
            const r = [];
            for(let c = 0; c < t.length; c++){
                const u = t[c], h = this.createProcessCanvas(u).getContext("2d");
                h.drawImage(u, 0, 0, u.width, u.height);
                const p = h.getImageData(0, 0, u.width, u.height), f = new Uint8Array(u.width * u.height);
                for(let g = 0; g < f.length; g++){
                    const b = g * 4;
                    f[g] = Math.floor((p.data[b] + p.data[b + 1] + p.data[b + 2]) / 3);
                }
                const m = {
                    data: f,
                    height: u.height,
                    width: u.width
                };
                r.push(m);
            }
            const i = 50 / r.length;
            let a = 0;
            this.data = [];
            for(let c = 0; c < r.length; c++){
                const u = r[c], d = P4(u), h = i / d.length, p = await MY(d, ()=>{
                    a += h, e(a);
                });
                this.data.push({
                    targetImage: u,
                    imageList: d,
                    matchingData: p
                });
            }
            for(let c = 0; c < r.length; c++){
                const u = A4(r[c]);
                this.data[c].trackingImageList = u;
            }
            const l = await this.compileTrack({
                progressCallback: e,
                targetImages: r,
                basePercent: 50
            });
            for(let c = 0; c < r.length; c++)this.data[c].trackingData = l[c];
            s(this.data);
        });
    }
    // not exporting imageList because too large. rebuild this using targetImage
    exportData() {
        const t = [];
        for(let s = 0; s < this.data.length; s++)t.push({
            //targetImage: this.data[i].targetImage,
            targetImage: {
                width: this.data[s].targetImage.width,
                height: this.data[s].targetImage.height
            },
            trackingData: this.data[s].trackingData,
            matchingData: this.data[s].matchingData
        });
        return wY({
            v: Jg,
            dataList: t
        });
    }
    importData(t) {
        const e = EY(new Uint8Array(t));
        if (!e.v || e.v !== Jg) return console.error("Your compiled .mind might be outdated. Please recompile"), [];
        const { dataList: s } = e;
        this.data = [];
        for(let o = 0; o < s.length; o++)this.data.push({
            targetImage: s[o].targetImage,
            trackingData: s[o].trackingData,
            matchingData: s[o].matchingData
        });
        return this.data;
    }
    createProcessCanvas(t) {
        console.warn("missing createProcessCanvas implementation");
    }
    compileTrack({ progressCallback: t, targetImages: e, basePercent: s }) {
        console.warn("missing compileTrack implementation");
    }
}
const MY = async (n, t)=>{
    const e = [];
    for(let s = 0; s < n.length; s++){
        const o = n[s], r = new vC(o.width, o.height);
        await su(), D(()=>{
            const i = $e(o.data, [
                o.data.length
            ], "float32").reshape([
                o.height,
                o.width
            ]), { featurePoints: a } = r.detect(i), l = a.filter((h)=>h.maxima), c = a.filter((h)=>!h.maxima), u = _g({
                points: l
            }), d = _g({
                points: c
            });
            e.push({
                maximaPoints: l,
                minimaPoints: c,
                maximaPointsCluster: u,
                minimaPointsCluster: d,
                width: o.width,
                height: o.height,
                scale: o.scale
            }), t(s);
        });
    }
    return e;
}, GC = "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", jg = typeof window < "u" && window.Blob && new Blob([
    atob(GC)
], {
    type: "text/javascript;charset=utf-8"
});
function WY(n) {
    let t;
    try {
        if (t = jg && (window.URL || window.webkitURL).createObjectURL(jg), !t) throw "";
        const e = new Worker(t, {
            name: n == null ? void 0 : n.name
        });
        return e.addEventListener("error", ()=>{
            (window.URL || window.webkitURL).revokeObjectURL(t);
        }), e;
    } catch  {
        return new Worker("data:application/javascript;base64," + GC, {
            name: n == null ? void 0 : n.name
        });
    } finally{
        t && (window.URL || window.webkitURL).revokeObjectURL(t);
    }
}
class DY extends LY {
    createProcessCanvas(t) {
        const e = document.createElement("canvas");
        return e.width = t.width, e.height = t.height, e;
    }
    compileTrack({ progressCallback: t, targetImages: e, basePercent: s }) {
        return new Promise((o, r)=>{
            const i = new WY();
            i.onmessage = (a)=>{
                a.data.type === "progress" ? t(s + a.data.percent * s / 100) : a.data.type === "compileDone" && o(a.data.list);
            }, i.postMessage({
                type: "compile",
                targetImages: e
            });
        });
    }
}
class FY {
    constructor(t, e){
        this.width = t, this.height = e, this.texShape = [
            e,
            t
        ];
        const s = document.createElement("canvas").getContext("2d");
        s.canvas.width = t, s.canvas.height = e, this.context = s, this.program = this.buildProgram(t, e);
        const o = ps();
        this.tempPixelHandle = o.makeTensorInfo(this.texShape, "float32"), o.texData.get(this.tempPixelHandle.dataId).usage = 2;
    }
    // old method
    _loadInput(t) {
        return D(()=>{
            let e = P0(t);
            return e = e.mean(2), e;
        });
    }
    // input is instance of HTMLVideoElement or HTMLImageElement
    loadInput(t) {
        const e = this.context;
        if (e.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height), t.width === this.height && t.height === this.width) {
            let i = this.context.canvas.width / 2, a = this.context.canvas.height / 2, l = 90;
            e.save(), e.translate(i, a), e.rotate(l * Math.PI / 180), e.drawImage(t, -t.width / 2, -t.height / 2), e.restore();
        } else this.context.drawImage(t, 0, 0, t.width, t.height);
        const o = ps();
        return o.gpgpu.uploadPixelDataToTexture(o.getTexture(this.tempPixelHandle.dataId), this.context.canvas), this._compileAndRun(this.program, [
            this.tempPixelHandle
        ]);
    }
    buildProgram(t, e) {
        const s = F().getNumber("WEBGL_VERSION") === 2 ? "texture" : "texture2D";
        return {
            variableNames: [
                "A"
            ],
            outputShape: this.texShape,
            userCode: `
	void main() {
	  ivec2 coords = getOutputCoords();
	  int texR = coords[0];
	  int texC = coords[1];
	  vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${t}.0, ${e}.0);

	  vec4 values = ${s}(A, uv);
	  setOutput((0.299 * values.r + 0.587 * values.g + 0.114 * values.b) * 255.0);
	}
      `
        };
    }
    _compileAndRun(t, e) {
        const s = ps().compileAndRun(t, e);
        return Ot().makeTensorFromDataId(s.dataId, s.shape, s.dtype);
    }
    _runWebGLProgram(t, e, s) {
        const o = ps().runWebGLProgram(t, e, s);
        return Ot().makeTensorFromDataId(o.dataId, o.shape, o.dtype);
    }
}
const rd = {
    memory: wl,
    nextFrame: su
}, VY = 1e-3, zY = 1e3, PY = 5, AY = 5;
class QQ {
    constructor({ inputWidth: t, inputHeight: e, onUpdate: s = null, debugMode: o = !1, maxTrack: r = 1, warmupTolerance: i = null, missTolerance: a = null, filterMinCF: l = null, filterBeta: c = null }){
        this.inputWidth = t, this.inputHeight = e, this.maxTrack = r, this.filterMinCF = l === null ? VY : l, this.filterBeta = c === null ? zY : c, this.warmupTolerance = i === null ? PY : i, this.missTolerance = a === null ? AY : a, this.cropDetector = new V4(this.inputWidth, this.inputHeight, o), this.inputLoader = new FY(this.inputWidth, this.inputHeight), this.markerDimensions = null, this.onUpdate = s, this.debugMode = o, this.processingVideo = !1, this.interestedTargetIndex = -1, this.trackingStates = [];
        const u = 10, d = 1e5, h = 45 * Math.PI / 180, p = this.inputHeight / 2 / Math.tan(h / 2);
        this.projectionTransform = [
            [
                p,
                0,
                this.inputWidth / 2
            ],
            [
                0,
                p,
                this.inputHeight / 2
            ],
            [
                0,
                0,
                1
            ]
        ], this.projectionMatrix = this._glProjectionMatrix({
            projectionTransform: this.projectionTransform,
            width: this.inputWidth,
            height: this.inputHeight,
            near: u,
            far: d
        }), this.worker = new A5(), this.workerMatchDone = null, this.workerTrackDone = null, this.worker.onmessage = (f)=>{
            f.data.type === "matchDone" && this.workerMatchDone !== null && this.workerMatchDone(f.data), f.data.type === "trackUpdateDone" && this.workerTrackDone !== null && this.workerTrackDone(f.data);
        };
    }
    showTFStats() {
        console.log(rd.memory().numTensors), console.table(rd.memory());
    }
    addImageTargets(t) {
        return new Promise(async (e, s)=>{
            const r = await (await fetch(t)).arrayBuffer(), i = this.addImageTargetsFromBuffer(r);
            e(i);
        });
    }
    addImageTargetsFromBuffer(t) {
        const s = new DY().importData(t), o = [], r = [], i = [];
        for(let a = 0; a < s.length; a++)r.push(s[a].matchingData), o.push(s[a].trackingData), i.push([
            s[a].targetImage.width,
            s[a].targetImage.height
        ]);
        return this.tracker = new Q5(i, o, this.projectionTransform, this.inputWidth, this.inputHeight, this.debugMode), this.worker.postMessage({
            type: "setup",
            inputWidth: this.inputWidth,
            inputHeight: this.inputHeight,
            projectionTransform: this.projectionTransform,
            debugMode: this.debugMode,
            matchingDataList: r
        }), this.markerDimensions = i, {
            dimensions: i,
            matchingDataList: r,
            trackingDataList: o
        };
    }
    dispose() {
        this.stopProcessVideo(), this.worker.postMessage({
            type: "dispose"
        });
    }
    // warm up gpu - build kernels is slow
    dummyRun(t) {
        const e = this.inputLoader.loadInput(t);
        this.cropDetector.detect(e), this.tracker.dummyRun(e), e.dispose();
    }
    getProjectionMatrix() {
        return this.projectionMatrix;
    }
    getRotatedZ90Matrix(t) {
        return [
            -t[1],
            t[0],
            t[2],
            t[3],
            -t[5],
            t[4],
            t[6],
            t[7],
            -t[9],
            t[8],
            t[10],
            t[11],
            -t[13],
            t[12],
            t[14],
            t[15]
        ];
    }
    getWorldMatrix(t, e) {
        return this._glModelViewMatrix(t, e);
    }
    async _detectAndMatch(t, e) {
        const { featurePoints: s } = this.cropDetector.detectMoving(t), { targetIndex: o, modelViewTransform: r } = await this._workerMatch(s, e);
        return {
            targetIndex: o,
            modelViewTransform: r
        };
    }
    async _trackAndUpdate(t, e, s) {
        const { worldCoords: o, screenCoords: r } = this.tracker.track(t, e, s);
        return o.length < 4 ? null : await this._workerTrackUpdate(e, {
            worldCoords: o,
            screenCoords: r
        });
    }
    processVideo(t) {
        if (this.processingVideo) return;
        this.processingVideo = !0, this.trackingStates = [];
        for(let s = 0; s < this.markerDimensions.length; s++)this.trackingStates.push({
            showing: !1,
            isTracking: !1,
            currentModelViewTransform: null,
            trackCount: 0,
            trackMiss: 0,
            filter: new (0, $4azF7.O)({
                minCutOff: this.filterMinCF,
                beta: this.filterBeta
            })
        });
        (async ()=>{
            for(; this.processingVideo;){
                const s = this.inputLoader.loadInput(t);
                if (this.trackingStates.reduce((r, i)=>r + (i.isTracking ? 1 : 0), 0) < this.maxTrack) {
                    const r = [];
                    for(let l = 0; l < this.trackingStates.length; l++)this.trackingStates[l].isTracking !== !0 && (this.interestedTargetIndex !== -1 && this.interestedTargetIndex !== l || r.push(l));
                    const { targetIndex: i, modelViewTransform: a } = await this._detectAndMatch(s, r);
                    i !== -1 && (this.trackingStates[i].isTracking = !0, this.trackingStates[i].currentModelViewTransform = a);
                }
                for(let r = 0; r < this.trackingStates.length; r++){
                    const i = this.trackingStates[r];
                    if (i.isTracking) {
                        let a = await this._trackAndUpdate(s, i.currentModelViewTransform, r);
                        a === null ? i.isTracking = !1 : i.currentModelViewTransform = a;
                    }
                    if (i.showing || i.isTracking && (i.trackMiss = 0, i.trackCount += 1, i.trackCount > this.warmupTolerance && (i.showing = !0, i.trackingMatrix = null, i.filter.reset())), i.showing && (i.isTracking ? i.trackMiss = 0 : (i.trackCount = 0, i.trackMiss += 1, i.trackMiss > this.missTolerance && (i.showing = !1, i.trackingMatrix = null, this.onUpdate && this.onUpdate({
                        type: "updateMatrix",
                        targetIndex: r,
                        worldMatrix: null
                    })))), i.showing) {
                        const a = this._glModelViewMatrix(i.currentModelViewTransform, r);
                        i.trackingMatrix = i.filter.filter(Date.now(), a);
                        let l = [];
                        for(let u = 0; u < i.trackingMatrix.length; u++)l[u] = i.trackingMatrix[u];
                        t.width === this.inputHeight && t.height === this.inputWidth && (l = this.getRotatedZ90Matrix(l)), this.onUpdate && this.onUpdate({
                            type: "updateMatrix",
                            targetIndex: r,
                            worldMatrix: l
                        });
                    }
                }
                s.dispose(), this.onUpdate && this.onUpdate({
                    type: "processDone"
                }), await rd.nextFrame();
            }
        })();
    }
    stopProcessVideo() {
        this.processingVideo = !1;
    }
    async detect(t) {
        const e = this.inputLoader.loadInput(t), { featurePoints: s, debugExtra: o } = await this.cropDetector.detect(e);
        return e.dispose(), {
            featurePoints: s,
            debugExtra: o
        };
    }
    async match(t, e) {
        const { modelViewTransform: s, debugExtra: o } = await this._workerMatch(t, [
            e
        ]);
        return {
            modelViewTransform: s,
            debugExtra: o
        };
    }
    async track(t, e, s) {
        const o = this.inputLoader.loadInput(t), r = this.tracker.track(o, e, s);
        return o.dispose(), r;
    }
    async trackUpdate(t, e) {
        return e.worldCoords.length < 4 ? null : await this._workerTrackUpdate(t, e);
    }
    _workerMatch(t, e) {
        return new Promise(async (s, o)=>{
            this.workerMatchDone = (r)=>{
                s({
                    targetIndex: r.targetIndex,
                    modelViewTransform: r.modelViewTransform,
                    debugExtra: r.debugExtra
                });
            }, this.worker.postMessage({
                type: "match",
                featurePoints: t,
                targetIndexes: e
            });
        });
    }
    _workerTrackUpdate(t, e) {
        return new Promise(async (s, o)=>{
            this.workerTrackDone = (a)=>{
                s(a.modelViewTransform);
            };
            const { worldCoords: r, screenCoords: i } = e;
            this.worker.postMessage({
                type: "trackUpdate",
                modelViewTransform: t,
                worldCoords: r,
                screenCoords: i
            });
        });
    }
    _glModelViewMatrix(t, e) {
        const s = this.markerDimensions[e][1];
        return [
            t[0][0],
            -t[1][0],
            -t[2][0],
            0,
            -t[0][1],
            t[1][1],
            t[2][1],
            0,
            -t[0][2],
            t[1][2],
            t[2][2],
            0,
            t[0][1] * s + t[0][3],
            -(t[1][1] * s + t[1][3]),
            -(t[2][1] * s + t[2][3]),
            1
        ];
    }
    // build openGL projection matrix
    // ref: https://strawlab.org/2011/11/05/augmented-reality-with-OpenGL/
    _glProjectionMatrix({ projectionTransform: t, width: e, height: s, near: o, far: r }) {
        const i = [
            [
                2 * t[0][0] / e,
                0,
                -(2 * t[0][2] / e - 1),
                0
            ],
            [
                0,
                2 * t[1][1] / s,
                -(2 * t[1][2] / s - 1),
                0
            ],
            [
                0,
                0,
                -(r + o) / (r - o),
                -2 * r * o / (r - o)
            ],
            [
                0,
                0,
                -1,
                0
            ]
        ], a = [];
        for(let l = 0; l < 4; l++)for(let c = 0; c < 4; c++)a.push(i[c][l]);
        return a;
    }
}

});
parcelRegister("4azF7", function(module, exports) {

$parcel$export(module.exports, "O", () => $3093c25c74b1b043$export$c4ce752e73470fba);
$parcel$export(module.exports, "U", () => $3093c25c74b1b043$export$3a6d5c9ae78a2c08);
const $3093c25c74b1b043$var$c = (a, t)=>{
    const i = 2 * Math.PI * t * a;
    return i / (i + 1);
}, $3093c25c74b1b043$var$h = (a, t, i)=>a * t + (1 - a) * i;
class $3093c25c74b1b043$export$c4ce752e73470fba {
    constructor({ minCutOff: t, beta: i }){
        this.minCutOff = t, this.beta = i, this.dCutOff = 1e-3, this.xPrev = null, this.dxPrev = null, this.tPrev = null, this.initialized = !1;
    }
    reset() {
        this.initialized = !1;
    }
    filter(t, i) {
        if (!this.initialized) return this.initialized = !0, this.xPrev = i, this.dxPrev = i.map(()=>0), this.tPrev = t, i;
        const { xPrev: e, tPrev: s, dxPrev: p } = this, o = t - s, m = $3093c25c74b1b043$var$c(o, this.dCutOff), l = [], r = [], d = [];
        for(let n = 0; n < i.length; n++){
            l[n] = (i[n] - e[n]) / o, r[n] = $3093c25c74b1b043$var$h(m, l[n], p[n]);
            const g = this.minCutOff + this.beta * Math.abs(r[n]), u = $3093c25c74b1b043$var$c(o, g);
            d[n] = $3093c25c74b1b043$var$h(u, i[n], e[n]);
        }
        return this.xPrev = d, this.dxPrev = r, this.tPrev = t, d;
    }
}
const $3093c25c74b1b043$var$v = `<div class="mindar-ui-overlay mindar-ui-loading">
  <div class="loader"/>
</div>
`, $3093c25c74b1b043$var$f = `<div class="mindar-ui-overlay mindar-ui-compatibility">
  <div class="content">
    <h1>Failed to launch :(</h1>
    <p>
      Looks like your device/browser is not compatible.
    </p>

    <br/>
    <br/>
    <p>
      Please try the following recommended browsers:
    </p>
    <p>
      For Android device - Chrome
    </p>
    <p>
      For iOS device - Safari
    </p>
  </div>
</div>
`, $3093c25c74b1b043$var$x = `<div class="mindar-ui-overlay mindar-ui-scanning">
  <div class="scanning">
    <div class="inner">
      <div class="scanline"/>
    </div>
  </div>
</div>
`, $3093c25c74b1b043$var$b = ".mindar-ui-overlay{display:flex;align-items:center;justify-content:center;position:absolute;left:0;right:0;top:0;bottom:0;background:transparent;z-index:2}.mindar-ui-overlay.hidden{display:none}.mindar-ui-loading .loader{border:16px solid #222;border-top:16px solid white;opacity:.8;border-radius:50%;width:120px;height:120px;animation:spin 2s linear infinite}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.mindar-ui-compatibility .content{background:black;color:#fff;opacity:.8;text-align:center;margin:20px;padding:20px;min-height:50vh}@media (min-aspect-ratio: 1/1){.mindar-ui-scanning .scanning{width:50vh;height:50vh}}@media (max-aspect-ratio: 1/1){.mindar-ui-scanning .scanning{width:80vw;height:80vw}}.mindar-ui-scanning .scanning .inner{position:relative;width:100%;height:100%;opacity:.8;background:linear-gradient(to right,white 10px,transparent 10px) 0 0,linear-gradient(to right,white 10px,transparent 10px) 0 100%,linear-gradient(to left,white 10px,transparent 10px) 100% 0,linear-gradient(to left,white 10px,transparent 10px) 100% 100%,linear-gradient(to bottom,white 10px,transparent 10px) 0 0,linear-gradient(to bottom,white 10px,transparent 10px) 100% 0,linear-gradient(to top,white 10px,transparent 10px) 0 100%,linear-gradient(to top,white 10px,transparent 10px) 100% 100%;background-repeat:no-repeat;background-size:40px 40px}.mindar-ui-scanning .scanning .inner .scanline{position:absolute;width:100%;height:10px;background:white;animation:move 2s linear infinite}@keyframes move{0%,to{top:0%}50%{top:calc(100% - 10px)}}";
class $3093c25c74b1b043$export$3a6d5c9ae78a2c08 {
    constructor({ uiLoading: t, uiScanning: i, uiError: e }){
        const s = document.createElement("style");
        s.innerText = $3093c25c74b1b043$var$b, document.head.appendChild(s), t === "yes" ? this.loadingModal = this._loadHTML($3093c25c74b1b043$var$v) : t !== "no" && (this.loadingModal = document.querySelector(t)), e === "yes" ? this.compatibilityModal = this._loadHTML($3093c25c74b1b043$var$f) : e !== "no" && (this.compatibilityModal = document.querySelector(e)), i === "yes" ? this.scanningMask = this._loadHTML($3093c25c74b1b043$var$x) : i !== "no" && (this.scanningMask = document.querySelector(i)), this.hideLoading(), this.hideCompatibility(), this.hideScanning();
    }
    showLoading() {
        this.loadingModal && this.loadingModal.classList.remove("hidden");
    }
    hideLoading() {
        this.loadingModal && this.loadingModal.classList.add("hidden");
    }
    showCompatibility() {
        this.compatibilityModal && this.compatibilityModal.classList.remove("hidden");
    }
    hideCompatibility() {
        this.compatibilityModal && this.compatibilityModal.classList.add("hidden");
    }
    showScanning() {
        this.scanningMask && this.scanningMask.classList.remove("hidden");
    }
    hideScanning() {
        this.scanningMask && this.scanningMask.classList.add("hidden");
    }
    _loadHTML(t) {
        const i = document.createElement("template");
        i.innerHTML = t.trim();
        const e = i.content.firstChild;
        return document.getElementsByTagName("body")[0].appendChild(e), e;
    }
}

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("fLVpN", function(module, exports) {
"use strict";
// ref: https://github.com/tc39/proposal-global
var getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('unable to locate global object');
};
var globalObject = getGlobal();
module.exports = exports = globalObject.fetch;
// Needed for TypeScript and Webpack.
if (globalObject.fetch) exports.default = globalObject.fetch.bind(globalObject);
exports.Headers = globalObject.Headers;
exports.Request = globalObject.Request;
exports.Response = globalObject.Response;

});

parcelRegister("N7Lcz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
var $093a98c17cb6b6b8$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $093a98c17cb6b6b8$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$093a98c17cb6b6b8$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($093a98c17cb6b6b8$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($093a98c17cb6b6b8$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($093a98c17cb6b6b8$var$isNull(x) || !$093a98c17cb6b6b8$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $093a98c17cb6b6b8$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($hPtJY.throwDeprecation) throw new Error(msg);
            else if ($hPtJY.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $093a98c17cb6b6b8$var$debugs = {};
var $093a98c17cb6b6b8$var$debugEnvRegex = /^$/;
var $093a98c17cb6b6b8$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$093a98c17cb6b6b8$var$debugs[set]) {
        if ($093a98c17cb6b6b8$var$debugEnvRegex.test(set)) {
            var pid = $hPtJY.pid;
            $093a98c17cb6b6b8$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $093a98c17cb6b6b8$var$debugs[set] = function() {};
    }
    return $093a98c17cb6b6b8$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $093a98c17cb6b6b8$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $093a98c17cb6b6b8$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($093a98c17cb6b6b8$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $093a98c17cb6b6b8$var$stylizeWithColor;
    return $093a98c17cb6b6b8$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $093a98c17cb6b6b8$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$093a98c17cb6b6b8$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$093a98c17cb6b6b8$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $093a98c17cb6b6b8$var$stylizeWithColor(str, styleType) {
    var style = $093a98c17cb6b6b8$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $093a98c17cb6b6b8$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $093a98c17cb6b6b8$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $093a98c17cb6b6b8$var$stylizeNoColor(str, styleType) {
    return str;
}
function $093a98c17cb6b6b8$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $093a98c17cb6b6b8$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $093a98c17cb6b6b8$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$093a98c17cb6b6b8$var$isString(ret)) ret = $093a98c17cb6b6b8$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $093a98c17cb6b6b8$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $093a98c17cb6b6b8$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($093a98c17cb6b6b8$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $093a98c17cb6b6b8$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($093a98c17cb6b6b8$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($093a98c17cb6b6b8$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($093a98c17cb6b6b8$var$isError(value)) return $093a98c17cb6b6b8$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($093a98c17cb6b6b8$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($093a98c17cb6b6b8$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($093a98c17cb6b6b8$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($093a98c17cb6b6b8$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($093a98c17cb6b6b8$var$isError(value)) base = ' ' + $093a98c17cb6b6b8$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces);
}
function $093a98c17cb6b6b8$var$formatPrimitive(ctx, value) {
    if ($093a98c17cb6b6b8$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($093a98c17cb6b6b8$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($093a98c17cb6b6b8$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($093a98c17cb6b6b8$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($093a98c17cb6b6b8$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $093a98c17cb6b6b8$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($093a98c17cb6b6b8$var$hasOwnProperty(value, String(i))) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$093a98c17cb6b6b8$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($093a98c17cb6b6b8$var$isNull(recurseTimes)) str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, null);
            else str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($093a98c17cb6b6b8$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("7He6T"));
function $093a98c17cb6b6b8$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $093a98c17cb6b6b8$var$isArray;
function $093a98c17cb6b6b8$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $093a98c17cb6b6b8$var$isBoolean;
function $093a98c17cb6b6b8$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $093a98c17cb6b6b8$var$isNull;
function $093a98c17cb6b6b8$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $093a98c17cb6b6b8$var$isNullOrUndefined;
function $093a98c17cb6b6b8$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $093a98c17cb6b6b8$var$isNumber;
function $093a98c17cb6b6b8$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $093a98c17cb6b6b8$var$isString;
function $093a98c17cb6b6b8$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $093a98c17cb6b6b8$var$isSymbol;
function $093a98c17cb6b6b8$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $093a98c17cb6b6b8$var$isUndefined;
function $093a98c17cb6b6b8$var$isRegExp(re) {
    return $093a98c17cb6b6b8$var$isObject(re) && $093a98c17cb6b6b8$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
module.exports.types.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
function $093a98c17cb6b6b8$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $093a98c17cb6b6b8$var$isObject;
function $093a98c17cb6b6b8$var$isDate(d) {
    return $093a98c17cb6b6b8$var$isObject(d) && $093a98c17cb6b6b8$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $093a98c17cb6b6b8$var$isDate;
module.exports.types.isDate = $093a98c17cb6b6b8$var$isDate;
function $093a98c17cb6b6b8$var$isError(e) {
    return $093a98c17cb6b6b8$var$isObject(e) && ($093a98c17cb6b6b8$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $093a98c17cb6b6b8$var$isError;
module.exports.types.isNativeError = $093a98c17cb6b6b8$var$isError;
function $093a98c17cb6b6b8$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $093a98c17cb6b6b8$var$isFunction;
function $093a98c17cb6b6b8$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $093a98c17cb6b6b8$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("kotBY"));
function $093a98c17cb6b6b8$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $093a98c17cb6b6b8$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $093a98c17cb6b6b8$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $093a98c17cb6b6b8$var$timestamp() {
    var d = new Date();
    var time = [
        $093a98c17cb6b6b8$var$pad(d.getHours()),
        $093a98c17cb6b6b8$var$pad(d.getMinutes()),
        $093a98c17cb6b6b8$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $093a98c17cb6b6b8$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $093a98c17cb6b6b8$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dlqwk"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$093a98c17cb6b6b8$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $093a98c17cb6b6b8$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol && original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol]) {
        var fn = original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol;
function $093a98c17cb6b6b8$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $093a98c17cb6b6b8$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $hPtJY.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $hPtJY.nextTick($093a98c17cb6b6b8$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $093a98c17cb6b6b8$var$callbackify;

});
parcelRegister("7He6T", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $f4HGZ = parcelRequire("f4HGZ");

var $5WnCa = parcelRequire("5WnCa");

var $gJrpv = parcelRequire("gJrpv");

var $hN833 = parcelRequire("hN833");
function $59a77e8886024a57$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $59a77e8886024a57$var$BigIntSupported = typeof BigInt !== 'undefined';
var $59a77e8886024a57$var$SymbolSupported = typeof Symbol !== 'undefined';
var $59a77e8886024a57$var$ObjectToString = $59a77e8886024a57$var$uncurryThis(Object.prototype.toString);
var $59a77e8886024a57$var$numberValue = $59a77e8886024a57$var$uncurryThis(Number.prototype.valueOf);
var $59a77e8886024a57$var$stringValue = $59a77e8886024a57$var$uncurryThis(String.prototype.valueOf);
var $59a77e8886024a57$var$booleanValue = $59a77e8886024a57$var$uncurryThis(Boolean.prototype.valueOf);
if ($59a77e8886024a57$var$BigIntSupported) var $59a77e8886024a57$var$bigIntValue = $59a77e8886024a57$var$uncurryThis(BigInt.prototype.valueOf);
if ($59a77e8886024a57$var$SymbolSupported) var $59a77e8886024a57$var$symbolValue = $59a77e8886024a57$var$uncurryThis(Symbol.prototype.valueOf);
function $59a77e8886024a57$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $f4HGZ;
module.exports.isGeneratorFunction = $5WnCa;
module.exports.isTypedArray = $hN833;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $59a77e8886024a57$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $59a77e8886024a57$var$isPromise;
function $59a77e8886024a57$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $hN833(value) || $59a77e8886024a57$var$isDataView(value);
}
module.exports.isArrayBufferView = $59a77e8886024a57$var$isArrayBufferView;
function $59a77e8886024a57$var$isUint8Array(value) {
    return $gJrpv(value) === 'Uint8Array';
}
module.exports.isUint8Array = $59a77e8886024a57$var$isUint8Array;
function $59a77e8886024a57$var$isUint8ClampedArray(value) {
    return $gJrpv(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $59a77e8886024a57$var$isUint8ClampedArray;
function $59a77e8886024a57$var$isUint16Array(value) {
    return $gJrpv(value) === 'Uint16Array';
}
module.exports.isUint16Array = $59a77e8886024a57$var$isUint16Array;
function $59a77e8886024a57$var$isUint32Array(value) {
    return $gJrpv(value) === 'Uint32Array';
}
module.exports.isUint32Array = $59a77e8886024a57$var$isUint32Array;
function $59a77e8886024a57$var$isInt8Array(value) {
    return $gJrpv(value) === 'Int8Array';
}
module.exports.isInt8Array = $59a77e8886024a57$var$isInt8Array;
function $59a77e8886024a57$var$isInt16Array(value) {
    return $gJrpv(value) === 'Int16Array';
}
module.exports.isInt16Array = $59a77e8886024a57$var$isInt16Array;
function $59a77e8886024a57$var$isInt32Array(value) {
    return $gJrpv(value) === 'Int32Array';
}
module.exports.isInt32Array = $59a77e8886024a57$var$isInt32Array;
function $59a77e8886024a57$var$isFloat32Array(value) {
    return $gJrpv(value) === 'Float32Array';
}
module.exports.isFloat32Array = $59a77e8886024a57$var$isFloat32Array;
function $59a77e8886024a57$var$isFloat64Array(value) {
    return $gJrpv(value) === 'Float64Array';
}
module.exports.isFloat64Array = $59a77e8886024a57$var$isFloat64Array;
function $59a77e8886024a57$var$isBigInt64Array(value) {
    return $gJrpv(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $59a77e8886024a57$var$isBigInt64Array;
function $59a77e8886024a57$var$isBigUint64Array(value) {
    return $gJrpv(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $59a77e8886024a57$var$isBigUint64Array;
function $59a77e8886024a57$var$isMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Map]';
}
$59a77e8886024a57$var$isMapToString.working = typeof Map !== 'undefined' && $59a77e8886024a57$var$isMapToString(new Map());
function $59a77e8886024a57$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $59a77e8886024a57$var$isMapToString.working ? $59a77e8886024a57$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $59a77e8886024a57$var$isMap;
function $59a77e8886024a57$var$isSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Set]';
}
$59a77e8886024a57$var$isSetToString.working = typeof Set !== 'undefined' && $59a77e8886024a57$var$isSetToString(new Set());
function $59a77e8886024a57$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $59a77e8886024a57$var$isSetToString.working ? $59a77e8886024a57$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $59a77e8886024a57$var$isSet;
function $59a77e8886024a57$var$isWeakMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WeakMap]';
}
$59a77e8886024a57$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $59a77e8886024a57$var$isWeakMapToString(new WeakMap());
function $59a77e8886024a57$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $59a77e8886024a57$var$isWeakMapToString.working ? $59a77e8886024a57$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $59a77e8886024a57$var$isWeakMap;
function $59a77e8886024a57$var$isWeakSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WeakSet]';
}
$59a77e8886024a57$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $59a77e8886024a57$var$isWeakSetToString(new WeakSet());
function $59a77e8886024a57$var$isWeakSet(value) {
    return $59a77e8886024a57$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $59a77e8886024a57$var$isWeakSet;
function $59a77e8886024a57$var$isArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$59a77e8886024a57$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $59a77e8886024a57$var$isArrayBufferToString(new ArrayBuffer());
function $59a77e8886024a57$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $59a77e8886024a57$var$isArrayBufferToString.working ? $59a77e8886024a57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $59a77e8886024a57$var$isArrayBuffer;
function $59a77e8886024a57$var$isDataViewToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object DataView]';
}
$59a77e8886024a57$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $59a77e8886024a57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $59a77e8886024a57$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $59a77e8886024a57$var$isDataViewToString.working ? $59a77e8886024a57$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $59a77e8886024a57$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $59a77e8886024a57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $59a77e8886024a57$var$isSharedArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $59a77e8886024a57$var$isSharedArrayBuffer(value) {
    if (typeof $59a77e8886024a57$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $59a77e8886024a57$var$isSharedArrayBufferToString.working === 'undefined') $59a77e8886024a57$var$isSharedArrayBufferToString.working = $59a77e8886024a57$var$isSharedArrayBufferToString(new $59a77e8886024a57$var$SharedArrayBufferCopy());
    return $59a77e8886024a57$var$isSharedArrayBufferToString.working ? $59a77e8886024a57$var$isSharedArrayBufferToString(value) : value instanceof $59a77e8886024a57$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $59a77e8886024a57$var$isSharedArrayBuffer;
function $59a77e8886024a57$var$isAsyncFunction(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $59a77e8886024a57$var$isAsyncFunction;
function $59a77e8886024a57$var$isMapIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $59a77e8886024a57$var$isMapIterator;
function $59a77e8886024a57$var$isSetIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $59a77e8886024a57$var$isSetIterator;
function $59a77e8886024a57$var$isGeneratorObject(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $59a77e8886024a57$var$isGeneratorObject;
function $59a77e8886024a57$var$isWebAssemblyCompiledModule(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $59a77e8886024a57$var$isWebAssemblyCompiledModule;
function $59a77e8886024a57$var$isNumberObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$numberValue);
}
module.exports.isNumberObject = $59a77e8886024a57$var$isNumberObject;
function $59a77e8886024a57$var$isStringObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$stringValue);
}
module.exports.isStringObject = $59a77e8886024a57$var$isStringObject;
function $59a77e8886024a57$var$isBooleanObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$booleanValue);
}
module.exports.isBooleanObject = $59a77e8886024a57$var$isBooleanObject;
function $59a77e8886024a57$var$isBigIntObject(value) {
    return $59a77e8886024a57$var$BigIntSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$bigIntValue);
}
module.exports.isBigIntObject = $59a77e8886024a57$var$isBigIntObject;
function $59a77e8886024a57$var$isSymbolObject(value) {
    return $59a77e8886024a57$var$SymbolSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$symbolValue);
}
module.exports.isSymbolObject = $59a77e8886024a57$var$isSymbolObject;
function $59a77e8886024a57$var$isBoxedPrimitive(value) {
    return $59a77e8886024a57$var$isNumberObject(value) || $59a77e8886024a57$var$isStringObject(value) || $59a77e8886024a57$var$isBooleanObject(value) || $59a77e8886024a57$var$isBigIntObject(value) || $59a77e8886024a57$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $59a77e8886024a57$var$isBoxedPrimitive;
function $59a77e8886024a57$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($59a77e8886024a57$var$isArrayBuffer(value) || $59a77e8886024a57$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $59a77e8886024a57$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("f4HGZ", function(module, exports) {
'use strict';

var $af991f1d6c80f097$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $eW390 = parcelRequire("eW390");
var $af991f1d6c80f097$var$$toString = $eW390('Object.prototype.toString');
/** @type {import('.')} */ var $af991f1d6c80f097$var$isStandardArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $af991f1d6c80f097$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $af991f1d6c80f097$var$isLegacyArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $af991f1d6c80f097$var$$toString(value) !== '[object Array]' && 'callee' in value && $af991f1d6c80f097$var$$toString(value.callee) === '[object Function]';
};
var $af991f1d6c80f097$var$supportsStandardArguments = function() {
    return $af991f1d6c80f097$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$af991f1d6c80f097$var$isStandardArguments.isLegacyArguments = $af991f1d6c80f097$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $af991f1d6c80f097$var$supportsStandardArguments ? $af991f1d6c80f097$var$isStandardArguments : $af991f1d6c80f097$var$isLegacyArguments;

});
parcelRegister("3KyxH", function(module, exports) {
'use strict';

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $7YWkK() && !!Symbol.toStringTag;
};

});
parcelRegister("7YWkK", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("eW390", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $jyxCz = parcelRequire("jyxCz");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $adf8ebd7229df60a$var$$indexOf = $jyxCz([
    $1zENl('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $1zENl(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $adf8ebd7229df60a$var$$indexOf(name, '.prototype.') > -1) return $jyxCz(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("1zENl", function(module, exports) {
'use strict';
var $1258b452ecf218a1$var$undefined1;

var $90JBs = parcelRequire("90JBs");

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");

var $bdePV = parcelRequire("bdePV");

var $dK8VM = parcelRequire("dK8VM");

var $7F9c3 = parcelRequire("7F9c3");

var $4l7TM = parcelRequire("4l7TM");

var $brYbP = parcelRequire("brYbP");

var $1rWQg = parcelRequire("1rWQg");

var $4J7z9 = parcelRequire("4J7z9");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $dYOee = parcelRequire("dYOee");

var $jAy3M = parcelRequire("jAy3M");
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $dYOee ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $dYOee(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $3ERI6 = parcelRequire("3ERI6");

var $eim86 = parcelRequire("eim86");

var $TxOUG = parcelRequire("TxOUG");

var $xMvSJ = parcelRequire("xMvSJ");

var $9pzbV = parcelRequire("9pzbV");
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === 'undefined' || !$3ERI6 ? undefined : $3ERI6(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGenerator%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncIteratorPrototype%': $1258b452ecf218a1$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $5A49f,
    '%eval%': eval,
    '%EvalError%': $hDtVy,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $1258b452ecf218a1$var$$Function,
    '%GeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6($3ERI6([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$3ERI6 ? undefined : $3ERI6(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $90JBs,
    '%Object.getOwnPropertyDescriptor%': $dYOee,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $9RC8m,
    '%ReferenceError%': $2BaZq,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$3ERI6 ? undefined : $3ERI6(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $5Ox6r,
    '%ThrowTypeError%': $1258b452ecf218a1$var$ThrowTypeError,
    '%TypedArray%': $1258b452ecf218a1$var$TypedArray,
    '%TypeError%': $eEkyn,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $hFSMY,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9pzbV,
    '%Function.prototype.apply%': $xMvSJ,
    '%Object.defineProperty%': $jAy3M,
    '%Object.getPrototypeOf%': $eim86,
    '%Math.abs%': $bdePV,
    '%Math.floor%': $dK8VM,
    '%Math.max%': $7F9c3,
    '%Math.min%': $4l7TM,
    '%Math.pow%': $brYbP,
    '%Math.round%': $1rWQg,
    '%Math.sign%': $4J7z9,
    '%Reflect.getPrototypeOf%': $TxOUG
};
if ($3ERI6) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $3ERI6($3ERI6(e));
    $1258b452ecf218a1$var$INTRINSICS['%Error.prototype%'] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $3ERI6) value = $3ERI6(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call($9pzbV, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call($xMvSJ, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call($9pzbV, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call($9pzbV, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call($9pzbV, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $5Ox6r('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $5Ox6r('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $eEkyn('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $eEkyn('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $5Ox6r('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($dYOee && i + 1 >= parts.length) {
                var desc = $dYOee(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("90JBs", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("5A49f", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eEkyn", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("hFSMY", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("bdePV", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("dK8VM", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("7F9c3", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("4l7TM", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("brYbP", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("1rWQg", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("4J7z9", function(module, exports) {
'use strict';

var $4oiz9 = parcelRequire("4oiz9");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($4oiz9(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("4oiz9", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("dYOee", function(module, exports) {
'use strict';

var $d4L75 = parcelRequire("d4L75");
var $a2d7d74e83f6c3ed$require$$gOPD = $d4L75;
if ($a2d7d74e83f6c3ed$require$$gOPD) try {
    $a2d7d74e83f6c3ed$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$require$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$require$$gOPD;

});
parcelRegister("d4L75", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("jAy3M", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = Object.defineProperty || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("24qIq", function(module, exports) {
'use strict';
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $1820ada193f67aeb$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $7YWkK();
};

});

parcelRegister("3ERI6", function(module, exports) {
'use strict';

var $TxOUG = parcelRequire("TxOUG");

var $eim86 = parcelRequire("eim86");

var $7kfw3 = parcelRequire("7kfw3");
/** @type {import('.')} */ module.exports = $TxOUG ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $TxOUG(O);
} : $eim86 ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $eim86(O);
} : $7kfw3 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $7kfw3(O);
} : null;

});
parcelRegister("TxOUG", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("eim86", function(module, exports) {
'use strict';

var $90JBs = parcelRequire("90JBs");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $90JBs.getPrototypeOf || null;

});

parcelRegister("7kfw3", function(module, exports) {
'use strict';

var $jyxCz = parcelRequire("jyxCz");

var $dYOee = parcelRequire("dYOee");
var $55566fcac2c38fe4$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $55566fcac2c38fe4$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $55566fcac2c38fe4$var$desc = !!$55566fcac2c38fe4$var$hasProtoAccessor && $dYOee && $dYOee(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $55566fcac2c38fe4$var$$Object = Object;
var $55566fcac2c38fe4$var$$getPrototypeOf = $55566fcac2c38fe4$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $55566fcac2c38fe4$var$desc && typeof $55566fcac2c38fe4$var$desc.get === 'function' ? $jyxCz([
    $55566fcac2c38fe4$var$desc.get
]) : typeof $55566fcac2c38fe4$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $55566fcac2c38fe4$var$$getPrototypeOf(value == null ? value : $55566fcac2c38fe4$var$$Object(value));
} : false;

});
parcelRegister("jyxCz", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $eEkyn = parcelRequire("eEkyn");

var $9pzbV = parcelRequire("9pzbV");

var $3YvJT = parcelRequire("3YvJT");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $eEkyn('a function is required');
    return $3YvJT($gvair, $9pzbV, args);
};

});
parcelRegister("gvair", function(module, exports) {
'use strict';

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = '[object Function]';
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $efd80b1d7fbb2850$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9pzbV", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("3YvJT", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $xMvSJ = parcelRequire("xMvSJ");

var $9pzbV = parcelRequire("9pzbV");

var $8qWPV = parcelRequire("8qWPV");
/** @type {import('./actualApply')} */ module.exports = $8qWPV || $gvair.call($9pzbV, $xMvSJ);

});
parcelRegister("xMvSJ", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("8qWPV", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("4c4Ky", function(module, exports) {
'use strict';
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {import('.')} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});




parcelRegister("5WnCa", function(module, exports) {
'use strict';

var $eW390 = parcelRequire("eW390");

var $2xf7f = parcelRequire("2xf7f");
var $4534afe844d627e4$var$isFnRegex = $2xf7f(/^\s*(?:function)?\*/);

var $4534afe844d627e4$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $3ERI6 = parcelRequire("3ERI6");
var $4534afe844d627e4$var$toStr = $eW390('Object.prototype.toString');
var $4534afe844d627e4$var$fnToStr = $eW390('Function.prototype.toString');

var $1xINW = parcelRequire("1xINW");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($4534afe844d627e4$var$isFnRegex($4534afe844d627e4$var$fnToStr(fn))) return true;
    if (!$4534afe844d627e4$var$hasToStringTag) {
        var str = $4534afe844d627e4$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$3ERI6) return false;
    var GeneratorFunction = $1xINW();
    return GeneratorFunction && $3ERI6(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("2xf7f", function(module, exports) {
'use strict';

var $eW390 = parcelRequire("eW390");

var $l37Ky = parcelRequire("l37Ky");
var $1d8a638ce4bfc95c$var$$exec = $eW390('RegExp.prototype.exec');

var $eEkyn = parcelRequire("eEkyn");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$l37Ky(regex)) throw new $eEkyn('`regex` must be a RegExp');
    return function test(s) {
        return $1d8a638ce4bfc95c$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("l37Ky", function(module, exports) {
'use strict';

var $eW390 = parcelRequire("eW390");

var $f52fe3bd41a86f17$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $4c4Ky = parcelRequire("4c4Ky");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ var $f52fe3bd41a86f17$var$fn;
if ($f52fe3bd41a86f17$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $f52fe3bd41a86f17$var$$exec = $eW390('RegExp.prototype.exec');
    /** @type {object} */ var $f52fe3bd41a86f17$var$isRegexMarker = {};
    var $f52fe3bd41a86f17$var$throwRegexMarker = function() {
        throw $f52fe3bd41a86f17$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $f52fe3bd41a86f17$var$badStringifier = {
        toString: $f52fe3bd41a86f17$var$throwRegexMarker,
        valueOf: $f52fe3bd41a86f17$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $f52fe3bd41a86f17$var$badStringifier[Symbol.toPrimitive] = $f52fe3bd41a86f17$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $f52fe3bd41a86f17$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $dYOee(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $4c4Ky(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $f52fe3bd41a86f17$var$$exec(value, /** @type {unknown} */ $f52fe3bd41a86f17$var$badStringifier);
        } catch (e) {
            return e === $f52fe3bd41a86f17$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $f52fe3bd41a86f17$var$$toString = $eW390('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $f52fe3bd41a86f17$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $f52fe3bd41a86f17$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $f52fe3bd41a86f17$var$$toString(value) === $f52fe3bd41a86f17$var$regexClass;
    };
}
module.exports = $f52fe3bd41a86f17$var$fn;

});


parcelRegister("1xINW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8c988d2af4ba1e07$export$2e2bcd8739ae039);

var $aN8bA = parcelRequire("aN8bA");
var /** @type {import('./index.d.mts').default} */ $8c988d2af4ba1e07$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($aN8bA)));

});
parcelRegister("aN8bA", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $7db4d48993eb4086$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$7db4d48993eb4086$var$cached;

});



parcelRegister("gJrpv", function(module, exports) {
'use strict';

var $gFhA7 = parcelRequire("gFhA7");

var $8yXCr = parcelRequire("8yXCr");

var $cOB0F = parcelRequire("cOB0F");

var $eW390 = parcelRequire("eW390");

var $dYOee = parcelRequire("dYOee");

var $3ERI6 = parcelRequire("3ERI6");
var $c2e61c703a2c9ae0$var$$toString = $eW390('Object.prototype.toString');

var $c2e61c703a2c9ae0$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $c2e61c703a2c9ae0$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $c2e61c703a2c9ae0$var$typedArrays = $8yXCr();
var $c2e61c703a2c9ae0$var$$slice = $eW390('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $c2e61c703a2c9ae0$var$$indexOf = $eW390('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $c2e61c703a2c9ae0$var$cache = {
    __proto__: null
};
if ($c2e61c703a2c9ae0$var$hasToStringTag && $dYOee && $3ERI6) $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $3ERI6) {
        var proto = $3ERI6(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $dYOee(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $3ERI6(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $dYOee(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = $cOB0F(descriptor.get);
            $c2e61c703a2c9ae0$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
        $cOB0F(fn);
        $c2e61c703a2c9ae0$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c2e61c703a2c9ae0$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $gFhA7(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $c2e61c703a2c9ae0$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c2e61c703a2c9ae0$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $gFhA7(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $c2e61c703a2c9ae0$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$c2e61c703a2c9ae0$var$hasToStringTag) {
        /** @type {string} */ var tag = $c2e61c703a2c9ae0$var$$slice($c2e61c703a2c9ae0$var$$toString(value), 8, -1);
        if ($c2e61c703a2c9ae0$var$$indexOf($c2e61c703a2c9ae0$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $c2e61c703a2c9ae0$var$trySlices(value);
    }
    if (!$dYOee) return null;
     // unknown engine
    return $c2e61c703a2c9ae0$var$tryTypedArrays(value);
};

});
parcelRegister("gFhA7", function(module, exports) {
'use strict';

var $63RD0 = parcelRequire("63RD0");
var $c21e1d005400ef2a$var$toStr = Object.prototype.toString;
var $c21e1d005400ef2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($c21e1d005400ef2a$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($c21e1d005400ef2a$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $c21e1d005400ef2a$var$isArray(x) {
    return $c21e1d005400ef2a$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$63RD0(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($c21e1d005400ef2a$var$isArray(list)) $c21e1d005400ef2a$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $c21e1d005400ef2a$var$forEachString(list, iterator, receiver);
    else $c21e1d005400ef2a$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("63RD0", function(module, exports) {
'use strict';
var $469c9f4bd3a650de$var$fnToStr = Function.prototype.toString;
var $469c9f4bd3a650de$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $469c9f4bd3a650de$var$badArrayLike;
var $469c9f4bd3a650de$var$isCallableMarker;
if (typeof $469c9f4bd3a650de$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $469c9f4bd3a650de$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $469c9f4bd3a650de$var$isCallableMarker;
        }
    });
    $469c9f4bd3a650de$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $469c9f4bd3a650de$var$reflectApply(function() {
        throw 42;
    }, null, $469c9f4bd3a650de$var$badArrayLike);
} catch (_) {
    if (_ !== $469c9f4bd3a650de$var$isCallableMarker) $469c9f4bd3a650de$var$reflectApply = null;
}
else $469c9f4bd3a650de$var$reflectApply = null;
var $469c9f4bd3a650de$var$constructorRegex = /^\s*class\b/;
var $469c9f4bd3a650de$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $469c9f4bd3a650de$var$fnToStr.call(value);
        return $469c9f4bd3a650de$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $469c9f4bd3a650de$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
        $469c9f4bd3a650de$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $469c9f4bd3a650de$var$toStr = Object.prototype.toString;
var $469c9f4bd3a650de$var$objectClass = '[object Object]';
var $469c9f4bd3a650de$var$fnClass = '[object Function]';
var $469c9f4bd3a650de$var$genClass = '[object GeneratorFunction]';
var $469c9f4bd3a650de$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $469c9f4bd3a650de$var$ddaClass2 = '[object HTML document.all class]';
var $469c9f4bd3a650de$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $469c9f4bd3a650de$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $469c9f4bd3a650de$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $469c9f4bd3a650de$var$all = document.all;
    if ($469c9f4bd3a650de$var$toStr.call($469c9f4bd3a650de$var$all) === $469c9f4bd3a650de$var$toStr.call(document.all)) $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($469c9f4bd3a650de$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $469c9f4bd3a650de$var$toStr.call(value);
            return (str === $469c9f4bd3a650de$var$ddaClass || str === $469c9f4bd3a650de$var$ddaClass2 || str === $469c9f4bd3a650de$var$ddaClass3 // opera 12.16
             || str === $469c9f4bd3a650de$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $469c9f4bd3a650de$var$reflectApply ? function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $469c9f4bd3a650de$var$reflectApply(value, null, $469c9f4bd3a650de$var$badArrayLike);
    } catch (e) {
        if (e !== $469c9f4bd3a650de$var$isCallableMarker) return false;
    }
    return !$469c9f4bd3a650de$var$isES6ClassFn(value) && $469c9f4bd3a650de$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($469c9f4bd3a650de$var$hasToStringTag) return $469c9f4bd3a650de$var$tryFunctionObject(value);
    if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
    var strClass = $469c9f4bd3a650de$var$toStr.call(value);
    if (strClass !== $469c9f4bd3a650de$var$fnClass && strClass !== $469c9f4bd3a650de$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $469c9f4bd3a650de$var$tryFunctionObject(value);
};

});


parcelRegister("8yXCr", function(module, exports) {
'use strict';

var $epJrh = parcelRequire("epJrh");
var $63bfbecf41903c8f$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $epJrh.length; i++)if (typeof $63bfbecf41903c8f$var$g[$epJrh[i]] === 'function') // @ts-expect-error
    out[out.length] = $epJrh[i];
    return out;
};

});
parcelRegister("epJrh", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("cOB0F", function(module, exports) {
'use strict';

var $BPe9e = parcelRequire("BPe9e");

var $jAy3M = parcelRequire("jAy3M");

var $jyxCz = parcelRequire("jyxCz");

var $1uOip = parcelRequire("1uOip");
module.exports = function callBind(originalFunction) {
    var func = $jyxCz(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $BPe9e(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($jAy3M) $jAy3M(module.exports, 'apply', {
    value: $1uOip
});
else module.exports.apply = $1uOip;

});
parcelRegister("BPe9e", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");

var $eEkyn = parcelRequire("eEkyn");
var $071b317808876eb5$var$$floor = $1zENl('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $eEkyn('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $eEkyn('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $dYOee) {
        var desc = $dYOee(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
'use strict';

var $jAy3M = parcelRequire("jAy3M");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $eEkyn('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $eEkyn('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $eEkyn('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $eEkyn('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $eEkyn('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $eEkyn('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5Ox6r('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("i16wS", function(module, exports) {
'use strict';

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});


parcelRegister("1uOip", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $xMvSJ = parcelRequire("xMvSJ");

var $3YvJT = parcelRequire("3YvJT");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $3YvJT($gvair, $xMvSJ, arguments);
};

});



parcelRegister("hN833", function(module, exports) {
'use strict';

var $gJrpv = parcelRequire("gJrpv");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$gJrpv(value);
};

});


parcelRegister("kotBY", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $6ZWSX.SlowBuffer(size);
};

});



parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("8CkzA", function(module, exports) {

$parcel$export(module.exports, "PortalCanvas", () => $46450a05f7b89a2b$export$4e58d02b3f6ea7c);
class $46450a05f7b89a2b$export$4e58d02b3f6ea7c {
    constructor(canvas, options){
        this.w = 0;
        this.h = 0;
        this.dpr = 1;
        this.portalRadius = 80;
        this.portalCenters = [];
        this.CONFIG = {
            bgColor: '#212121',
            maxDpr: 1.15,
            portalThickness: 10,
            innerRadiusFactor: 0.9,
            ringSquares: 56,
            ringTriangles: 18,
            outerParticles: 22,
            portalImageOpacity: 0.95,
            portalImageScale: 1.06,
            portalImageDrift: 2.5,
            haloAlpha: 0.05,
            innerTintAlpha: 0.1,
            vignetteAlpha: 0.1,
            featherStart: 0.72,
            featherEnd: 1.0,
            lineAlpha: 0.08,
            pulseSpeed: 0.0018,
            spinSpeed: 0.00065,
            driftSpeed: 0.00055,
            topBottomPaddingFactor: 0.18,
            sidePaddingFactor: 0.05,
            gapFactor: 0.03
        };
        this.resize = ()=>{
            const size = Math.min(window.innerWidth * 0.8, 600); // controla aqui 👈
            this.dpr = Math.min(window.devicePixelRatio || 1, this.CONFIG.maxDpr);
            // tamanho visual (CSS via JS)
            this.canvas.style.width = `${size}px`;
            this.canvas.style.height = `${size}px`;
            // resolução real
            this.canvas.width = Math.round(size * this.dpr);
            this.canvas.height = Math.round(size * this.dpr);
            this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
            // agora o canvas "mundo" é esse tamanho
            this.w = size;
            this.h = size;
            this.portalRadius = this.getPortalRadius();
            this.buildPortalCenters();
            this.buildPortalData();
        };
        this.animate = (t)=>{
            this.drawBackground();
            for(let i = 0; i < this.portalCenters.length; i++)this.drawPortalAt(this.portalCenters[i], this.PORTALS[i], t, i);
            requestAnimationFrame(this.animate);
        };
        this.canvas = canvas;
        this.imageSrc = options.imageSrc;
        this.hue = options.hue ?? 205;
        const ctx = canvas.getContext('2d', {
            alpha: false,
            desynchronized: true
        });
        if (!ctx) throw new Error("N\xe3o foi poss\xedvel obter o contexto 2D do canvas.");
        this.ctx = ctx;
        this.PORTALS = [
            {
                imgSrc: this.imageSrc,
                hue: this.hue,
                img: new Image(),
                ringSquares: [],
                ringTriangles: [],
                particles: []
            }
        ];
    }
    init() {
        this.setupImages();
        this.resize();
        window.addEventListener('resize', this.resize, {
            passive: true
        });
        requestAnimationFrame(this.animate);
    }
    setupImages() {
        this.PORTALS.forEach((portal)=>{
            portal.img.decoding = 'async';
            portal.img.onload = ()=>{
                console.log('Imagem carregada');
                this.resize(); // força rebuild
            };
            portal.img.onerror = ()=>{
                console.error('Erro ao carregar imagem:', portal.imgSrc);
            };
            portal.img.src = portal.imgSrc;
        });
    }
    rand(min, max) {
        return Math.random() * (max - min) + min;
    }
    hsla(h, s, l, a) {
        return `hsla(${h}, ${s}%, ${l}%, ${a})`;
    }
    portalColor(hue, alpha = 1, light = 56, hueShift = 0, sat = 92) {
        return this.hsla(hue + hueShift, sat, light, alpha);
    }
    hotColor(hue, alpha = 1) {
        return this.hsla(hue - 10, 96, 68, alpha);
    }
    getPortalRadius() {
        const sidePadding = this.w * this.CONFIG.sidePaddingFactor;
        const gap = this.w * this.CONFIG.gapFactor;
        const usableWidth = this.w - sidePadding * 2 - gap * (this.PORTALS.length - 1);
        const radiusByWidth = usableWidth / (this.PORTALS.length * 2);
        const radiusByHeight = this.h * (0.5 - this.CONFIG.topBottomPaddingFactor);
        return Math.max(24, Math.min(radiusByWidth, radiusByHeight));
    }
    buildPortalCenters() {
        this.portalCenters = [];
        const gap = this.w * this.CONFIG.gapFactor;
        const diameter = this.portalRadius * 2;
        const totalWidth = this.PORTALS.length * diameter + (this.PORTALS.length - 1) * gap;
        const startX = (this.w - totalWidth) * 0.5 + this.portalRadius;
        const cy = this.h * 0.55;
        for(let i = 0; i < this.PORTALS.length; i++)this.portalCenters.push({
            x: startX + i * (diameter + gap),
            y: cy,
            phase: i * 0.9
        });
    }
    buildPortalData() {
        const r = this.portalRadius;
        const thickness = this.CONFIG.portalThickness;
        this.PORTALS.forEach((portal)=>{
            portal.ringSquares = [];
            portal.ringTriangles = [];
            portal.particles = [];
            for(let i = 0; i < this.CONFIG.ringSquares; i++){
                const a = i / this.CONFIG.ringSquares * Math.PI * 2;
                portal.ringSquares.push({
                    a: a,
                    rr: r + this.rand(-thickness, thickness),
                    size: this.rand(3, 5.5),
                    tw: this.rand(0, Math.PI * 2),
                    drift: this.rand(-1.6, 1.6)
                });
            }
            for(let i = 0; i < this.CONFIG.ringTriangles; i++){
                const a = i / this.CONFIG.ringTriangles * Math.PI * 2 + this.rand(-0.05, 0.05);
                portal.ringTriangles.push({
                    a: a,
                    rr: r + this.rand(-thickness, thickness),
                    size: this.rand(4, 6.5),
                    rot: this.rand(0, Math.PI * 2),
                    tw: this.rand(0, Math.PI * 2)
                });
            }
            for(let i = 0; i < this.CONFIG.outerParticles; i++)portal.particles.push({
                a: this.rand(0, Math.PI * 2),
                dist: r + this.rand(18, 42),
                size: this.rand(1.4, 2.8),
                speed: this.rand(0.00045, 0.0011),
                tw: this.rand(0, Math.PI * 2),
                tri: Math.random() < 0.2,
                rot: this.rand(0, Math.PI * 2)
            });
        });
    }
    drawTriangle(x, y, size, rotation, fill) {
        this.ctx.save();
        this.ctx.translate(x, y);
        this.ctx.rotate(rotation);
        this.ctx.fillStyle = fill;
        this.ctx.beginPath();
        this.ctx.moveTo(0, -size);
        this.ctx.lineTo(size * 0.82, size * 0.68);
        this.ctx.lineTo(-size * 0.82, size * 0.68);
        this.ctx.closePath();
        this.ctx.fill();
        this.ctx.restore();
    }
    drawBackground() {
        this.ctx.fillStyle = this.CONFIG.bgColor;
        this.ctx.fillRect(0, 0, this.w, this.h);
    }
    drawPortalAt(c, portal, t, index) {
        const r = this.portalRadius;
        const phase = c.phase;
        const hue = portal.hue;
        this.drawSoftHalo(c, r, t, phase, hue);
        this.drawPortalImageSoft(c, r, t, phase, hue, portal.img);
        this.drawInnerLines(c, r, t, phase, hue);
        this.drawThinRing(c, r, t, phase, hue);
        this.drawRingSquares(c, t, phase, hue, portal.ringSquares);
        this.drawRingTriangles(c, t, phase, hue, portal.ringTriangles);
        this.drawOuterParticles(c, t, phase, index, portal, portal.particles);
    }
    drawSoftHalo(c, r, t, phase, hue) {
        const pulse = 1 + Math.sin(t * this.CONFIG.pulseSpeed + phase) * 0.03;
        const g = this.ctx.createRadialGradient(c.x, c.y, r * 0.65, c.x, c.y, r * 1.45 * pulse);
        g.addColorStop(0, this.portalColor(hue, this.CONFIG.haloAlpha, 54));
        g.addColorStop(1, this.portalColor(hue, 0, 42));
        this.ctx.fillStyle = g;
        this.ctx.beginPath();
        this.ctx.arc(c.x, c.y, r * 1.5, 0, Math.PI * 2);
        this.ctx.fill();
    }
    drawPortalImageSoft(c, r, t, phase, hue, img) {
        if (!(img.complete && img.naturalWidth > 0)) return;
        const innerR = r * this.CONFIG.innerRadiusFactor;
        this.ctx.save();
        this.ctx.beginPath();
        this.ctx.arc(c.x, c.y, innerR, 0, Math.PI * 2);
        this.ctx.clip();
        const imgW = img.naturalWidth;
        const imgH = img.naturalHeight;
        const target = innerR * 2 * this.CONFIG.portalImageScale;
        const scale = Math.max(target / imgW, target / imgH);
        const drawW = imgW * scale;
        const drawH = imgH * scale;
        const driftX = Math.sin(t * this.CONFIG.driftSpeed + phase) * this.CONFIG.portalImageDrift;
        const driftY = Math.cos(t * this.CONFIG.driftSpeed * 1.2 + phase) * this.CONFIG.portalImageDrift;
        const x = c.x - drawW * 0.5 + driftX;
        const y = c.y - drawH * 0.5 + driftY;
        this.ctx.globalAlpha = this.CONFIG.portalImageOpacity;
        this.ctx.drawImage(img, x, y, drawW, drawH);
        this.ctx.restore();
    }
    drawInnerLines(c, r, t, phase, hue) {
        const rrBase = r * 0.78;
        this.ctx.save();
        this.ctx.translate(c.x, c.y);
        for(let i = 0; i < 5; i++){
            const rr = (i + 1) / 5 * rrBase;
            this.ctx.beginPath();
            this.ctx.strokeStyle = this.portalColor(hue, this.CONFIG.lineAlpha * (0.55 + i * 0.1), 68, -6);
            this.ctx.lineWidth = 1;
            for(let a = 0; a <= Math.PI * 2 + 0.06; a += 0.16){
                const wobble = Math.sin(a * 4 + t * 0.003 + i + phase) * (1 + i * 0.12);
                const rad = rr + wobble;
                const x = Math.cos(a) * rad;
                const y = Math.sin(a) * rad;
                if (a === 0) this.ctx.moveTo(x, y);
                else this.ctx.lineTo(x, y);
            }
            this.ctx.stroke();
        }
        this.ctx.restore();
    }
    drawThinRing(c, r, t, phase, hue) {
        this.ctx.beginPath();
        this.ctx.strokeStyle = this.portalColor(hue, 0.62, 65);
        this.ctx.lineWidth = 1.5;
        this.ctx.arc(c.x, c.y, r, 0, Math.PI * 2);
        this.ctx.stroke();
        this.ctx.beginPath();
        this.ctx.strokeStyle = this.portalColor(hue, 0.2, 76);
        this.ctx.lineWidth = 1;
        this.ctx.arc(c.x, c.y, r + 3 + Math.sin(t * 0.002 + phase) * 1.1, 0, Math.PI * 2);
        this.ctx.stroke();
    }
    drawRingSquares(c, t, phase, hue, ringSquares) {
        for (const p of ringSquares){
            const tw = (Math.sin(t * 0.0035 + p.tw + phase) + 1) * 0.5;
            const rr = p.rr + Math.sin(t * 0.002 + p.tw + phase) * 1.5;
            const x = c.x + Math.cos(p.a) * rr;
            const y = c.y + Math.sin(p.a) * rr + Math.sin(t * 0.0018 + p.tw + phase) * p.drift;
            const s = p.size * (0.94 + tw * 0.22);
            this.ctx.fillStyle = this.portalColor(hue, 0.26 + tw * 0.28, 58 + tw * 12, -4);
            this.ctx.fillRect(x - s * 0.5, y - s * 0.5, s, s);
        }
    }
    drawRingTriangles(c, t, phase, hue, ringTriangles) {
        for (const p of ringTriangles){
            const tw = (Math.sin(t * 0.0037 + p.tw + phase) + 1) * 0.5;
            const rr = p.rr + Math.sin(t * 0.0022 + p.tw + phase) * 1.8;
            const x = c.x + Math.cos(p.a) * rr;
            const y = c.y + Math.sin(p.a) * rr;
            const rot = p.rot + t * this.CONFIG.spinSpeed + phase * 0.15;
            const s = p.size * (0.92 + tw * 0.2);
            this.drawTriangle(x, y, s, rot, this.hotColor(hue, 0.18 + tw * 0.2));
        }
    }
    drawOuterParticles(c, t, phase, portalIndex, portal, particles) {
        const hue = portal.hue;
        for(let i = 0; i < particles.length; i++){
            const p = particles[i];
            const a = p.a + t * p.speed + phase * 0.8 + portalIndex * 0.12;
            const x = c.x + Math.cos(a) * p.dist;
            const y = c.y + Math.sin(a) * p.dist;
            const tw = (Math.sin(t * 0.003 + p.tw + phase) + 1) * 0.5;
            const alpha = 0.08 + tw * 0.14;
            if (p.tri) this.drawTriangle(x, y, p.size, p.rot + t * 0.0008 + phase, this.portalColor(hue, alpha, 62, -8));
            else {
                this.ctx.fillStyle = this.portalColor(hue, alpha, 60, -5);
                this.ctx.fillRect(x - p.size * 0.5, y - p.size * 0.5, p.size, p.size);
            }
        }
    }
}

});

parcelRegister("kYLQ7", function(module, exports) {

$parcel$export(module.exports, "api", () => $06004b97fba8fb24$export$644d8ea042df96a6);
const $06004b97fba8fb24$var$API_URL = 'https://gamescon-backend-559ca0f1a07e.herokuapp.com/api';
const $06004b97fba8fb24$export$644d8ea042df96a6 = {
    /**
   * Realiza o login do usuário
   */ async login (data) {
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/auth/local`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        const result = await response.json();
        if (!response.ok) // O Strapi geralmente manda o erro detalhado em result.error.message
        throw new Error(result.error?.message || 'Erro ao fazer login.');
        return result;
    },
    /**
   * Registra um novo usuário
   */ async register (data) {
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/auth/local/register`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        const result = await response.json();
        /* if (!response.ok) {
      throw new Error(result.error?.message || 'Erro ao registrar usuário.');
    } */ return result;
    },
    /**
   * Gera um código de brinde para o usuário logado
   * @param jwt Token JWT recebido no login/registro
   */ async generateCode () {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/codes/generate`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                // Aqui enviamos o token para o backend saber quem está pedindo o código
                'Authorization': `Bearer ${jwt}`
            }
        });
        const result = await response.json();
        if (!response.ok) // Se ele já tiver um código, nós tratamos lá no backend pra retornar um erro ou a própria mensagem.
        // Dependendo de como você montou, pode ser que response.ok seja falso se der 400.
        throw new Error(result.error?.message || result.message || "Erro ao gerar o c\xf3digo.");
        return result;
    },
    /**
   * Pega todos os dados do usuário logado (incluindo o currentStage)
   * Ideal para chamar quando o jogo carrega!
   */ async getMe () {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/users/me`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${jwt}`
            }
        });
        const result = await response.json();
        if (!response.ok) throw new Error('Erro ao carregar os dados do jogador.');
        return result; // Aqui virá { id: 1, username: "...", currentStage: 1, ... }
    },
    /**
   * Salva a fase atual do jogador
   */ async saveStage (stageNumber) {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/save-progress`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`
            },
            body: JSON.stringify({
                stage: stageNumber
            })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error?.message || 'Erro ao salvar o jogo.');
        return result;
    },
    async getMyCodes () {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/codes/me`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${jwt}`
            }
        });
        const result = await response.json();
        if (!response.ok) throw new Error("Erro ao carregar o hist\xf3rico de c\xf3digos.");
        return result;
    },
    async sendNeozone (data) {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/neozones`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`
            },
            body: JSON.stringify({
                data: data
            })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error?.message || 'Erro ao enviar neozone');
        return result;
    },
    async sendOpenzone (data) {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/ratings`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`
            },
            body: JSON.stringify({
                data: data
            })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error?.message || 'Erro ao enviar openzone');
        return result;
    },
    async sendFinal (data) {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/rating-finals`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`
            },
            body: JSON.stringify({
                data: data
            })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error?.message || 'Erro ao enviar final');
        return result;
    },
    async isActive () {
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/actives/smhqnmg6356byro9113fq650`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error?.message || result.message || "Erro ao gerar o c\xf3digo.");
        return result;
    }
};

});

/**
 * @license
 * Copyright 2010-2023 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $d5b33d7c30034067$export$3545e07a80636437 = '156';
const $d5b33d7c30034067$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $d5b33d7c30034067$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $d5b33d7c30034067$export$3237e1f2c1ea1f44 = 0;
const $d5b33d7c30034067$export$b9a7b4fc5cb15f9b = 1;
const $d5b33d7c30034067$export$b8058bcc7037d3f3 = 2;
const $d5b33d7c30034067$export$f24be24dcddeac0d = 3;
const $d5b33d7c30034067$export$346307dbae2b7447 = 0;
const $d5b33d7c30034067$export$5813f879eee7cd88 = 1;
const $d5b33d7c30034067$export$a47c4b43a1be34f0 = 2;
const $d5b33d7c30034067$export$896ae1ade6c829c4 = 3;
const $d5b33d7c30034067$export$2ede184fc2998901 = 0;
const $d5b33d7c30034067$export$d9f0486e75b5ace = 1;
const $d5b33d7c30034067$export$3b296b6f144d5b03 = 2;
const $d5b33d7c30034067$export$211211c00f97204d = 2; // r149
const $d5b33d7c30034067$export$63b8d6b580fc65ba = 0;
const $d5b33d7c30034067$export$5b29a26d96ee6af0 = 1;
const $d5b33d7c30034067$export$777d8f9551c2216b = 2;
const $d5b33d7c30034067$export$cdfa06f868e2e467 = 3;
const $d5b33d7c30034067$export$4138e1c684b46a20 = 4;
const $d5b33d7c30034067$export$eda4864c68df1fa2 = 5;
const $d5b33d7c30034067$export$20183a0484ce21a0 = 100;
const $d5b33d7c30034067$export$73e0df5177988548 = 101;
const $d5b33d7c30034067$export$28e582859cbec660 = 102;
const $d5b33d7c30034067$export$c8c1508da8d0600c = 103;
const $d5b33d7c30034067$export$99948c02fb51055f = 104;
const $d5b33d7c30034067$export$2110f05edf778d3d = 200;
const $d5b33d7c30034067$export$8805bad65e24940e = 201;
const $d5b33d7c30034067$export$7fbe15b28d28cf52 = 202;
const $d5b33d7c30034067$export$947829af9f2c17f6 = 203;
const $d5b33d7c30034067$export$d5773124e86cf28c = 204;
const $d5b33d7c30034067$export$11d468cc7f19e971 = 205;
const $d5b33d7c30034067$export$a78aed1ca2a87192 = 206;
const $d5b33d7c30034067$export$5d0fe17fd8773bac = 207;
const $d5b33d7c30034067$export$ef5f2dd8ffac5574 = 208;
const $d5b33d7c30034067$export$56b85b2686ab16 = 209;
const $d5b33d7c30034067$export$c05e2a1fc8609506 = 210;
const $d5b33d7c30034067$export$69025ce147cee220 = 0;
const $d5b33d7c30034067$export$7182eb52ea3b3f04 = 1;
const $d5b33d7c30034067$export$eedccec66ab7ebe = 2;
const $d5b33d7c30034067$export$296f78a0b892f81a = 3;
const $d5b33d7c30034067$export$a60d398fc7b7590e = 4;
const $d5b33d7c30034067$export$7d7234c1240a1fc4 = 5;
const $d5b33d7c30034067$export$c5e2c52991f30937 = 6;
const $d5b33d7c30034067$export$2f843afa843d8916 = 7;
const $d5b33d7c30034067$export$e50ac29801f1774d = 0;
const $d5b33d7c30034067$export$9f9d94f963c85479 = 1;
const $d5b33d7c30034067$export$e641dc52bc3494aa = 2;
const $d5b33d7c30034067$export$9fcb6b4294603b2 = 0;
const $d5b33d7c30034067$export$98f52c2a46c598ca = 1;
const $d5b33d7c30034067$export$74b25e54b3bcd548 = 2;
const $d5b33d7c30034067$export$932b3dd283d4a366 = 3;
const $d5b33d7c30034067$export$a0d98fe6d7e4af64 = 4;
const $d5b33d7c30034067$export$2c7b09c1e9abfb5e = 5;
const $d5b33d7c30034067$export$1beec6768cbb3d2d = 300;
const $d5b33d7c30034067$export$8759762a6477f2c4 = 301;
const $d5b33d7c30034067$export$dc59f8aed047f61d = 302;
const $d5b33d7c30034067$export$d64030b316d3b087 = 303;
const $d5b33d7c30034067$export$ee99d97d46898098 = 304;
const $d5b33d7c30034067$export$dbf3e70ff37af79 = 306;
const $d5b33d7c30034067$export$533346c8e8dac0f5 = 1000;
const $d5b33d7c30034067$export$9d9334239a5a5e06 = 1001;
const $d5b33d7c30034067$export$c7e7c00b14f51a4f = 1002;
const $d5b33d7c30034067$export$727aa5ec3fe39bf0 = 1003;
const $d5b33d7c30034067$export$d129e38cf6feaa8c = 1004;
const $d5b33d7c30034067$export$14a4936464a36496 = 1004;
const $d5b33d7c30034067$export$d2327c1afe5bfdf2 = 1005;
const $d5b33d7c30034067$export$cbc5b7f5647595d8 = 1005;
const $d5b33d7c30034067$export$8a72f490b25c56c8 = 1006;
const $d5b33d7c30034067$export$19a719f377145a13 = 1007;
const $d5b33d7c30034067$export$dbe96bee3fe9dbf0 = 1007;
const $d5b33d7c30034067$export$5d8599b6a933fb1b = 1008;
const $d5b33d7c30034067$export$90d80f1e3506775f = 1008;
const $d5b33d7c30034067$export$2e8ce08d3f6f5e10 = 1009;
const $d5b33d7c30034067$export$545fce0311a9796a = 1010;
const $d5b33d7c30034067$export$88572337f312435f = 1011;
const $d5b33d7c30034067$export$c63dc51868b06a9d = 1012;
const $d5b33d7c30034067$export$5c612977753abe2 = 1013;
const $d5b33d7c30034067$export$c3c7fc4518ebba96 = 1014;
const $d5b33d7c30034067$export$f6d331659b644596 = 1015;
const $d5b33d7c30034067$export$2697304443f382bc = 1016;
const $d5b33d7c30034067$export$b3969b01faf587f2 = 1017;
const $d5b33d7c30034067$export$18886f8ae33e90de = 1018;
const $d5b33d7c30034067$export$6c8ea339bfab1301 = 1020;
const $d5b33d7c30034067$export$988473390501ed4b = 1021;
const $d5b33d7c30034067$export$3f8bb04b555a363c = 1023;
const $d5b33d7c30034067$export$cc09ccbf6d1ed449 = 1024;
const $d5b33d7c30034067$export$9053a81c4a69c289 = 1025;
const $d5b33d7c30034067$export$c1b6b5136be58045 = 1026;
const $d5b33d7c30034067$export$1e113ac2d0905829 = 1027;
const $d5b33d7c30034067$export$4e041a7967d15c4b = 1028;
const $d5b33d7c30034067$export$aa92e870a709d190 = 1029;
const $d5b33d7c30034067$export$6cdf0b461c7ce8a0 = 1030;
const $d5b33d7c30034067$export$1ba1c45f9f77d4d7 = 1031;
const $d5b33d7c30034067$export$c200e7d26f592f21 = 1033;
const $d5b33d7c30034067$export$21d1799c6d552fc0 = 33776;
const $d5b33d7c30034067$export$afa304c3e981b668 = 33777;
const $d5b33d7c30034067$export$d2a1a68024a3e56c = 33778;
const $d5b33d7c30034067$export$9a79c424327dacf9 = 33779;
const $d5b33d7c30034067$export$19ada9bbb1af3573 = 35840;
const $d5b33d7c30034067$export$d0f0355bb3d948e4 = 35841;
const $d5b33d7c30034067$export$b82296714358084c = 35842;
const $d5b33d7c30034067$export$b71692456c47b6c3 = 35843;
const $d5b33d7c30034067$export$6ab91af2d757aee7 = 36196;
const $d5b33d7c30034067$export$7800993ef8106a6a = 37492;
const $d5b33d7c30034067$export$23ed8300a860e7d8 = 37496;
const $d5b33d7c30034067$export$dc5570b4a2b92d48 = 37808;
const $d5b33d7c30034067$export$68880cd325f8b2fb = 37809;
const $d5b33d7c30034067$export$7d2c0be323373d95 = 37810;
const $d5b33d7c30034067$export$22b52da301fc3a3e = 37811;
const $d5b33d7c30034067$export$c009e2cb4a66485e = 37812;
const $d5b33d7c30034067$export$118fff5afa255b63 = 37813;
const $d5b33d7c30034067$export$120713c829ae0667 = 37814;
const $d5b33d7c30034067$export$c79eeabbf53313e9 = 37815;
const $d5b33d7c30034067$export$443cf6567cdd6424 = 37816;
const $d5b33d7c30034067$export$6573984fc9840780 = 37817;
const $d5b33d7c30034067$export$e7aee563f30091de = 37818;
const $d5b33d7c30034067$export$2eb8634622ddeab7 = 37819;
const $d5b33d7c30034067$export$202b1ce7b5d25742 = 37820;
const $d5b33d7c30034067$export$18ab77abd087e467 = 37821;
const $d5b33d7c30034067$export$ce40b115e188bc81 = 36492;
const $d5b33d7c30034067$export$d279c5c4bac5121e = 36494;
const $d5b33d7c30034067$export$cde52d17225fdbd3 = 36495;
const $d5b33d7c30034067$export$b1688df4c4c21670 = 36283;
const $d5b33d7c30034067$export$fc15e5d8261eed58 = 36284;
const $d5b33d7c30034067$export$d220f6ade8463a0f = 36285;
const $d5b33d7c30034067$export$768646d09dc1b6ef = 36286;
const $d5b33d7c30034067$export$d62fdc9d1b1cccad = 2200;
const $d5b33d7c30034067$export$dfaf4422ce096e29 = 2201;
const $d5b33d7c30034067$export$f8f6f2041b78e210 = 2202;
const $d5b33d7c30034067$export$995b32462a65e855 = 2300;
const $d5b33d7c30034067$export$30fac1aace31cf4d = 2301;
const $d5b33d7c30034067$export$198b11ff4c72bb30 = 2302;
const $d5b33d7c30034067$export$7f795934b84ab523 = 2400;
const $d5b33d7c30034067$export$24a4ccb5099273b5 = 2401;
const $d5b33d7c30034067$export$8e8c3ecdcd8e1fee = 2402;
const $d5b33d7c30034067$export$bcfbbdcf8de7f8cd = 2500;
const $d5b33d7c30034067$export$d875e029ef558d3 = 2501;
const $d5b33d7c30034067$export$4c28c87c2dc84758 = 0;
const $d5b33d7c30034067$export$b23a071aa286eb29 = 1;
const $d5b33d7c30034067$export$f0d8293634f88842 = 2;
/** @deprecated Use LinearSRGBColorSpace or NoColorSpace in three.js r152+. */ const $d5b33d7c30034067$export$7207336e4151a112 = 3000;
/** @deprecated Use SRGBColorSpace in three.js r152+. */ const $d5b33d7c30034067$export$f32388edbb32674 = 3001;
const $d5b33d7c30034067$export$deeb383078690b50 = 3200;
const $d5b33d7c30034067$export$8f910f4c4f73df11 = 3201;
const $d5b33d7c30034067$export$2852a58ebdac27b8 = 0;
const $d5b33d7c30034067$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $d5b33d7c30034067$export$bfcb490c2dd3db51 = '';
const $d5b33d7c30034067$export$561f394b24edfcaa = 'srgb';
const $d5b33d7c30034067$export$42429b3acfb233a4 = 'srgb-linear';
const $d5b33d7c30034067$export$626af19ae879bdf6 = 'display-p3';
const $d5b33d7c30034067$export$c0dc1bc7e964761 = 'display-p3-linear';
const $d5b33d7c30034067$export$69433f11f42d5527 = 0;
const $d5b33d7c30034067$export$9f542ae4b5baca34 = 7680;
const $d5b33d7c30034067$export$8a4f28336ef203d3 = 7681;
const $d5b33d7c30034067$export$2928c0231297c036 = 7682;
const $d5b33d7c30034067$export$c0e9611c8a15f9a8 = 7683;
const $d5b33d7c30034067$export$9c2c08927385dcc4 = 34055;
const $d5b33d7c30034067$export$7c74ea00fa1315e6 = 34056;
const $d5b33d7c30034067$export$22e2e5726612443 = 5386;
const $d5b33d7c30034067$export$1343870698229224 = 512;
const $d5b33d7c30034067$export$8e1d8ed281997fa6 = 513;
const $d5b33d7c30034067$export$55648a1cde8329a7 = 514;
const $d5b33d7c30034067$export$2dff107857e6aca2 = 515;
const $d5b33d7c30034067$export$6f93765ab2f451a2 = 516;
const $d5b33d7c30034067$export$6f3fb2d2440f2b76 = 517;
const $d5b33d7c30034067$export$4119cf7b4c98fd5a = 518;
const $d5b33d7c30034067$export$14cf96713ddd97a8 = 519;
const $d5b33d7c30034067$export$d9e2d19a747baaab = 512;
const $d5b33d7c30034067$export$36bcf49c713b3eb7 = 513;
const $d5b33d7c30034067$export$66f28d946fc6a0d5 = 514;
const $d5b33d7c30034067$export$64eea11eb407ddf1 = 515;
const $d5b33d7c30034067$export$155af022118f3a38 = 516;
const $d5b33d7c30034067$export$67ab95dde6bed156 = 517;
const $d5b33d7c30034067$export$1cdcb70d53d65f61 = 518;
const $d5b33d7c30034067$export$187b73a3e352c145 = 519;
const $d5b33d7c30034067$export$763e8360f4d7f77d = 35044;
const $d5b33d7c30034067$export$8505d14ac8546ca = 35048;
const $d5b33d7c30034067$export$721e63549e51d81e = 35040;
const $d5b33d7c30034067$export$415731dc4f48e299 = 35045;
const $d5b33d7c30034067$export$9e809946455f13bc = 35049;
const $d5b33d7c30034067$export$2ed9499a35b5f832 = 35041;
const $d5b33d7c30034067$export$32ab2503ea19469a = 35046;
const $d5b33d7c30034067$export$ab4022c2c3f86315 = 35050;
const $d5b33d7c30034067$export$ba7f1db36a76a970 = 35042;
const $d5b33d7c30034067$export$43600cc67fabd9f = '100';
const $d5b33d7c30034067$export$f63012db5506e7dd = '300 es';
const $d5b33d7c30034067$export$ca1dce8b5e1de74d = 1035; // fallback for WebGL 1
const $d5b33d7c30034067$export$5a0e9190d10875d3 = 2000;
const $d5b33d7c30034067$export$cc83beedcb9be9ac = 2001;
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $d5b33d7c30034067$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let $d5b33d7c30034067$var$_seed = 1234567;
const $d5b33d7c30034067$var$DEG2RAD = Math.PI / 180;
const $d5b33d7c30034067$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $d5b33d7c30034067$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $d5b33d7c30034067$var$_lut[d0 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 8 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 24 & 0xff] + '-' + $d5b33d7c30034067$var$_lut[d1 & 0xff] + $d5b33d7c30034067$var$_lut[d1 >> 8 & 0xff] + '-' + $d5b33d7c30034067$var$_lut[d1 >> 16 & 0x0f | 0x40] + $d5b33d7c30034067$var$_lut[d1 >> 24 & 0xff] + '-' + $d5b33d7c30034067$var$_lut[d2 & 0x3f | 0x80] + $d5b33d7c30034067$var$_lut[d2 >> 8 & 0xff] + '-' + $d5b33d7c30034067$var$_lut[d2 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d2 >> 24 & 0xff] + $d5b33d7c30034067$var$_lut[d3 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 8 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $d5b33d7c30034067$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $d5b33d7c30034067$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $d5b33d7c30034067$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $d5b33d7c30034067$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $d5b33d7c30034067$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $d5b33d7c30034067$var$damp(x, y, lambda, dt) {
    return $d5b33d7c30034067$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $d5b33d7c30034067$var$pingpong(x, length = 1) {
    return length - Math.abs($d5b33d7c30034067$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $d5b33d7c30034067$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $d5b33d7c30034067$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $d5b33d7c30034067$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $d5b33d7c30034067$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $d5b33d7c30034067$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $d5b33d7c30034067$var$seededRandom(s) {
    if (s !== undefined) $d5b33d7c30034067$var$_seed = s;
    // Mulberry32 generator
    let t = $d5b33d7c30034067$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $d5b33d7c30034067$var$degToRad(degrees) {
    return degrees * $d5b33d7c30034067$var$DEG2RAD;
}
function $d5b33d7c30034067$var$radToDeg(radians) {
    return radians * $d5b33d7c30034067$var$RAD2DEG;
}
function $d5b33d7c30034067$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $d5b33d7c30034067$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $d5b33d7c30034067$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $d5b33d7c30034067$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
function $d5b33d7c30034067$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
function $d5b33d7c30034067$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
const $d5b33d7c30034067$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $d5b33d7c30034067$var$DEG2RAD,
    RAD2DEG: $d5b33d7c30034067$var$RAD2DEG,
    generateUUID: $d5b33d7c30034067$var$generateUUID,
    clamp: $d5b33d7c30034067$var$clamp,
    euclideanModulo: $d5b33d7c30034067$var$euclideanModulo,
    mapLinear: $d5b33d7c30034067$var$mapLinear,
    inverseLerp: $d5b33d7c30034067$var$inverseLerp,
    lerp: $d5b33d7c30034067$var$lerp,
    damp: $d5b33d7c30034067$var$damp,
    pingpong: $d5b33d7c30034067$var$pingpong,
    smoothstep: $d5b33d7c30034067$var$smoothstep,
    smootherstep: $d5b33d7c30034067$var$smootherstep,
    randInt: $d5b33d7c30034067$var$randInt,
    randFloat: $d5b33d7c30034067$var$randFloat,
    randFloatSpread: $d5b33d7c30034067$var$randFloatSpread,
    seededRandom: $d5b33d7c30034067$var$seededRandom,
    degToRad: $d5b33d7c30034067$var$degToRad,
    radToDeg: $d5b33d7c30034067$var$radToDeg,
    isPowerOfTwo: $d5b33d7c30034067$var$isPowerOfTwo,
    ceilPowerOfTwo: $d5b33d7c30034067$var$ceilPowerOfTwo,
    floorPowerOfTwo: $d5b33d7c30034067$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $d5b33d7c30034067$var$setQuaternionFromProperEuler,
    normalize: $d5b33d7c30034067$var$normalize,
    denormalize: $d5b33d7c30034067$var$denormalize
};
class $d5b33d7c30034067$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $d5b33d7c30034067$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($d5b33d7c30034067$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
class $d5b33d7c30034067$export$8ff26dafa08918 {
    constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        $d5b33d7c30034067$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    //
    scale(sx, sy) {
        this.premultiply($d5b33d7c30034067$var$_m3.makeScale(sx, sy));
        return this;
    }
    rotate(theta) {
        this.premultiply($d5b33d7c30034067$var$_m3.makeRotation(-theta));
        return this;
    }
    translate(tx, ty) {
        this.premultiply($d5b33d7c30034067$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    //
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $d5b33d7c30034067$var$_m3 = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918();
function $d5b33d7c30034067$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $d5b33d7c30034067$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $d5b33d7c30034067$var$getTypedArray(type, buffer) {
    return new $d5b33d7c30034067$var$TYPED_ARRAYS[type](buffer);
}
function $d5b33d7c30034067$var$createElementNS(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
function $d5b33d7c30034067$export$1033a2df66368859() {
    const canvas = $d5b33d7c30034067$var$createElementNS('canvas');
    canvas.style.display = 'block';
    return canvas;
}
const $d5b33d7c30034067$var$_cache = {};
function $d5b33d7c30034067$var$warnOnce(message) {
    if (message in $d5b33d7c30034067$var$_cache) return;
    $d5b33d7c30034067$var$_cache[message] = true;
    console.warn(message);
}
function $d5b33d7c30034067$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $d5b33d7c30034067$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */ const $d5b33d7c30034067$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918().fromArray([
    0.8224621,
    0.0331941,
    0.0170827,
    0.1775380,
    0.9668058,
    0.0723974,
    -0.0000001,
    0.0000001,
    0.9105199
]);
const $d5b33d7c30034067$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918().fromArray([
    1.2249401,
    -0.0420569,
    -0.0196376,
    -0.2249404,
    1.0420571,
    -0.0786361,
    0.0000001,
    0.0000000,
    1.0982735
]);
function $d5b33d7c30034067$var$DisplayP3ToLinearSRGB(color) {
    // Display P3 uses the sRGB transfer functions
    return color.convertSRGBToLinear().applyMatrix3($d5b33d7c30034067$var$LINEAR_DISPLAY_P3_TO_LINEAR_SRGB);
}
function $d5b33d7c30034067$var$LinearSRGBToDisplayP3(color) {
    // Display P3 uses the sRGB transfer functions
    return color.applyMatrix3($d5b33d7c30034067$var$LINEAR_SRGB_TO_LINEAR_DISPLAY_P3).convertLinearToSRGB();
}
// Conversions from <source> to Linear-sRGB reference space.
const $d5b33d7c30034067$var$TO_LINEAR = {
    [$d5b33d7c30034067$export$42429b3acfb233a4]: (color)=>color,
    [$d5b33d7c30034067$export$561f394b24edfcaa]: (color)=>color.convertSRGBToLinear(),
    [$d5b33d7c30034067$export$626af19ae879bdf6]: $d5b33d7c30034067$var$DisplayP3ToLinearSRGB
};
// Conversions to <target> from Linear-sRGB reference space.
const $d5b33d7c30034067$var$FROM_LINEAR = {
    [$d5b33d7c30034067$export$42429b3acfb233a4]: (color)=>color,
    [$d5b33d7c30034067$export$561f394b24edfcaa]: (color)=>color.convertLinearToSRGB(),
    [$d5b33d7c30034067$export$626af19ae879bdf6]: $d5b33d7c30034067$var$LinearSRGBToDisplayP3
};
const $d5b33d7c30034067$export$5e6fd513f44698c = {
    enabled: true,
    get legacyMode () {
        console.warn('THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.');
        return !this.enabled;
    },
    set legacyMode (legacyMode){
        console.warn('THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.');
        this.enabled = !legacyMode;
    },
    get workingColorSpace () {
        return $d5b33d7c30034067$export$42429b3acfb233a4;
    },
    set workingColorSpace (colorSpace){
        console.warn('THREE.ColorManagement: .workingColorSpace is readonly.');
    },
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        const sourceToLinear = $d5b33d7c30034067$var$TO_LINEAR[sourceColorSpace];
        const targetFromLinear = $d5b33d7c30034067$var$FROM_LINEAR[targetColorSpace];
        if (sourceToLinear === undefined || targetFromLinear === undefined) throw new Error(`Unsupported color space conversion, "${sourceColorSpace}" to "${targetColorSpace}".`);
        return targetFromLinear(sourceToLinear(color));
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this.workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this.workingColorSpace);
    }
};
let $d5b33d7c30034067$var$_canvas;
class $d5b33d7c30034067$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($d5b33d7c30034067$var$_canvas === undefined) $d5b33d7c30034067$var$_canvas = $d5b33d7c30034067$var$createElementNS('canvas');
            $d5b33d7c30034067$var$_canvas.width = image.width;
            $d5b33d7c30034067$var$_canvas.height = image.height;
            const context = $d5b33d7c30034067$var$_canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $d5b33d7c30034067$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn('THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image);
            return canvas.toDataURL('image/jpeg', 0.6);
        } else return canvas.toDataURL('image/png');
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
            const canvas = $d5b33d7c30034067$var$createElementNS('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $d5b33d7c30034067$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($d5b33d7c30034067$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $d5b33d7c30034067$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn('THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
            return image;
        }
    }
}
let $d5b33d7c30034067$var$sourceId = 0;
class $d5b33d7c30034067$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$sourceId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.data = data;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ''
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($d5b33d7c30034067$var$serializeImage(data[i].image));
                else url.push($d5b33d7c30034067$var$serializeImage(data[i]));
            } else // texture
            url = $d5b33d7c30034067$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $d5b33d7c30034067$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $d5b33d7c30034067$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
let $d5b33d7c30034067$var$_textureId = 0;
class $d5b33d7c30034067$export$5431306cf43de24a extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(image = $d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $d5b33d7c30034067$export$9d9334239a5a5e06, wrapT = $d5b33d7c30034067$export$9d9334239a5a5e06, magFilter = $d5b33d7c30034067$export$8a72f490b25c56c8, minFilter = $d5b33d7c30034067$export$5d8599b6a933fb1b, format = $d5b33d7c30034067$export$3f8bb04b555a363c, type = $d5b33d7c30034067$export$2e8ce08d3f6f5e10, anisotropy = $d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace1 = $d5b33d7c30034067$export$bfcb490c2dd3db51){
        super();
        this.isTexture = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_textureId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = '';
        this.source = new $d5b33d7c30034067$export$1d2df86270c81ecb(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.channel = 0;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.center = new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $d5b33d7c30034067$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        if (typeof colorSpace1 === 'string') this.colorSpace = colorSpace1;
        else {
            $d5b33d7c30034067$var$warnOnce('THREE.Texture: Property .encoding has been replaced by .colorSpace.');
            this.colorSpace = colorSpace1 === $d5b33d7c30034067$export$f32388edbb32674 ? $d5b33d7c30034067$export$561f394b24edfcaa : $d5b33d7c30034067$export$bfcb490c2dd3db51;
        }
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.needsPMREMUpdate = false; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.6,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    transformUv(uv) {
        if (this.mapping !== $d5b33d7c30034067$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $d5b33d7c30034067$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $d5b33d7c30034067$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $d5b33d7c30034067$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $d5b33d7c30034067$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $d5b33d7c30034067$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $d5b33d7c30034067$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    get encoding() {
        $d5b33d7c30034067$var$warnOnce('THREE.Texture: Property .encoding has been replaced by .colorSpace.');
        return this.colorSpace === $d5b33d7c30034067$export$561f394b24edfcaa ? $d5b33d7c30034067$export$f32388edbb32674 : $d5b33d7c30034067$export$7207336e4151a112;
    }
    set encoding(encoding) {
        $d5b33d7c30034067$var$warnOnce('THREE.Texture: Property .encoding has been replaced by .colorSpace.');
        this.colorSpace = encoding === $d5b33d7c30034067$export$f32388edbb32674 ? $d5b33d7c30034067$export$561f394b24edfcaa : $d5b33d7c30034067$export$bfcb490c2dd3db51;
    }
}
$d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_MAPPING = $d5b33d7c30034067$export$1beec6768cbb3d2d;
$d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
class $d5b33d7c30034067$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $d5b33d7c30034067$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $d5b33d7c30034067$export$efcb1f8bf367cbfb extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(width = 1, height = 1, options = {}){
        super();
        this.isRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        if (options.encoding !== undefined) {
            // @deprecated, r152
            $d5b33d7c30034067$var$warnOnce('THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace.');
            options.colorSpace = options.encoding === $d5b33d7c30034067$export$f32388edbb32674 ? $d5b33d7c30034067$export$561f394b24edfcaa : $d5b33d7c30034067$export$bfcb490c2dd3db51;
        }
        this.texture = new $d5b33d7c30034067$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        this.texture.isRenderTargetTexture = true;
        this.texture.flipY = false;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.internalFormat = options.internalFormat !== undefined ? options.internalFormat : null;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
        this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
        this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
        this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
        this.samples = options.samples !== undefined ? options.samples : 0;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.texture.image.depth = depth;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        this.texture.isRenderTargetTexture = true;
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new $d5b33d7c30034067$export$1d2df86270c81ecb(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
class $d5b33d7c30034067$export$3c052beb2e51e23f extends $d5b33d7c30034067$export$efcb1f8bf367cbfb {
    constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        this.isWebGLRenderTarget = true;
    }
}
class $d5b33d7c30034067$export$dfac6c8e811406a3 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.wrapR = $d5b33d7c30034067$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $d5b33d7c30034067$export$c77a02c11ed180c7 extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $d5b33d7c30034067$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $d5b33d7c30034067$export$d7a3086320f856db extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.wrapR = $d5b33d7c30034067$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $d5b33d7c30034067$export$7ee06591009639df extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1){
        super(width, height);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $d5b33d7c30034067$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $d5b33d7c30034067$export$bd934554fb721730 extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, count = 1, options = {}){
        super(width, height, options);
        this.isWebGLMultipleRenderTargets = true;
        const texture = this.texture;
        this.texture = [];
        for(let i = 0; i < count; i++){
            this.texture[i] = texture.clone();
            this.texture[i].isRenderTargetTexture = true;
        }
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.texture.length; i < il; i++){
                this.texture[i].image.width = width;
                this.texture[i].image.height = height;
                this.texture[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    copy(source) {
        this.dispose();
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.texture.length = 0;
        for(let i = 0, il = source.texture.length; i < il; i++){
            this.texture[i] = source.texture[i].clone();
            this.texture[i].isRenderTargetTexture = true;
        }
        return this;
    }
}
class $d5b33d7c30034067$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($d5b33d7c30034067$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // Derived from http://planning.cs.uiuc.edu/node198.html
        // Note, this source uses w, x, y, z ordering,
        // so we swap the order below.
        const u1 = Math.random();
        const sqrt1u1 = Math.sqrt(1 - u1);
        const sqrtu1 = Math.sqrt(u1);
        const u2 = 2 * Math.PI * Math.random();
        const u3 = 2 * Math.PI * Math.random();
        return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
class $d5b33d7c30034067$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $d5b33d7c30034067$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($d5b33d7c30034067$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($d5b33d7c30034067$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $d5b33d7c30034067$var$_vector$b.copy(this).projectOnVector(planeNormal);
        return this.sub($d5b33d7c30034067$var$_vector$b);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($d5b33d7c30034067$var$_vector$b.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($d5b33d7c30034067$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
        const u = (Math.random() - 0.5) * 2;
        const t = Math.random() * Math.PI * 2;
        const f = Math.sqrt(1 - u ** 2);
        this.x = f * Math.cos(t);
        this.y = f * Math.sin(t);
        this.z = u;
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $d5b33d7c30034067$var$_vector$b = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
class $d5b33d7c30034067$export$6f7d5a9418ab2aa3 {
    constructor(min = new $d5b33d7c30034067$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $d5b33d7c30034067$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($d5b33d7c30034067$var$_vector$a.fromArray(array, i));
        return this;
    }
    setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($d5b33d7c30034067$var$_vector$a.fromBufferAttribute(attribute, i));
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $d5b33d7c30034067$var$_vector$a.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        if (object.boundingBox !== undefined) {
            if (object.boundingBox === null) object.computeBoundingBox();
            $d5b33d7c30034067$var$_box$3.copy(object.boundingBox);
            $d5b33d7c30034067$var$_box$3.applyMatrix4(object.matrixWorld);
            this.union($d5b33d7c30034067$var$_box$3);
        } else {
            const geometry = object.geometry;
            if (geometry !== undefined) {
                if (precise && geometry.attributes !== undefined && geometry.attributes.position !== undefined) {
                    const position = geometry.attributes.position;
                    for(let i = 0, l = position.count; i < l; i++){
                        $d5b33d7c30034067$var$_vector$a.fromBufferAttribute(position, i).applyMatrix4(object.matrixWorld);
                        this.expandByPoint($d5b33d7c30034067$var$_vector$a);
                    }
                } else {
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $d5b33d7c30034067$var$_box$3.copy(geometry.boundingBox);
                    $d5b33d7c30034067$var$_box$3.applyMatrix4(object.matrixWorld);
                    this.union($d5b33d7c30034067$var$_box$3);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $d5b33d7c30034067$var$_vector$a);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $d5b33d7c30034067$var$_vector$a.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_extents.subVectors(this.max, $d5b33d7c30034067$var$_center);
        // translate triangle to aabb origin
        $d5b33d7c30034067$var$_v0$2.subVectors(triangle.a, $d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_v1$7.subVectors(triangle.b, $d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_v2$4.subVectors(triangle.c, $d5b33d7c30034067$var$_center);
        // compute edge vectors for triangle
        $d5b33d7c30034067$var$_f0.subVectors($d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v0$2);
        $d5b33d7c30034067$var$_f1.subVectors($d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_v1$7);
        $d5b33d7c30034067$var$_f2.subVectors($d5b33d7c30034067$var$_v0$2, $d5b33d7c30034067$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$d5b33d7c30034067$var$_f0.z,
            $d5b33d7c30034067$var$_f0.y,
            0,
            -$d5b33d7c30034067$var$_f1.z,
            $d5b33d7c30034067$var$_f1.y,
            0,
            -$d5b33d7c30034067$var$_f2.z,
            $d5b33d7c30034067$var$_f2.y,
            $d5b33d7c30034067$var$_f0.z,
            0,
            -$d5b33d7c30034067$var$_f0.x,
            $d5b33d7c30034067$var$_f1.z,
            0,
            -$d5b33d7c30034067$var$_f1.x,
            $d5b33d7c30034067$var$_f2.z,
            0,
            -$d5b33d7c30034067$var$_f2.x,
            -$d5b33d7c30034067$var$_f0.y,
            $d5b33d7c30034067$var$_f0.x,
            0,
            -$d5b33d7c30034067$var$_f1.y,
            $d5b33d7c30034067$var$_f1.x,
            0,
            -$d5b33d7c30034067$var$_f2.y,
            $d5b33d7c30034067$var$_f2.x,
            0
        ];
        if (!$d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$2, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$2, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $d5b33d7c30034067$var$_triangleNormal.crossVectors($d5b33d7c30034067$var$_f0, $d5b33d7c30034067$var$_f1);
        axes = [
            $d5b33d7c30034067$var$_triangleNormal.x,
            $d5b33d7c30034067$var$_triangleNormal.y,
            $d5b33d7c30034067$var$_triangleNormal.z
        ];
        return $d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$2, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$4, $d5b33d7c30034067$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $d5b33d7c30034067$var$_vector$a).distanceTo(point);
    }
    getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($d5b33d7c30034067$var$_vector$a).length() * 0.5;
        }
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $d5b33d7c30034067$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $d5b33d7c30034067$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $d5b33d7c30034067$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $d5b33d7c30034067$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $d5b33d7c30034067$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $d5b33d7c30034067$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $d5b33d7c30034067$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $d5b33d7c30034067$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($d5b33d7c30034067$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $d5b33d7c30034067$var$_points = [
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699()
];
const $d5b33d7c30034067$var$_vector$a = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_box$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $d5b33d7c30034067$var$_v0$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$7 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
// triangle edge vectors
const $d5b33d7c30034067$var$_f0 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_f1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_f2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_center = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_extents = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_triangleNormal = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_testAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
function $d5b33d7c30034067$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $d5b33d7c30034067$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($d5b33d7c30034067$var$_testAxis.x) + extents.y * Math.abs($d5b33d7c30034067$var$_testAxis.y) + extents.z * Math.abs($d5b33d7c30034067$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($d5b33d7c30034067$var$_testAxis);
        const p1 = v1.dot($d5b33d7c30034067$var$_testAxis);
        const p2 = v2.dot($d5b33d7c30034067$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $d5b33d7c30034067$var$_box$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_v1$6 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$805e8b72413ccaba {
    constructor(center = new $d5b33d7c30034067$export$64b5c384219d3699(), radius = -1){
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $d5b33d7c30034067$var$_box$2.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $d5b33d7c30034067$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $d5b33d7c30034067$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($d5b33d7c30034067$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $d5b33d7c30034067$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($d5b33d7c30034067$var$_v1$6.copy(sphere.center).add($d5b33d7c30034067$var$_v2$3));
            this.expandByPoint($d5b33d7c30034067$var$_v1$6.copy(sphere.center).sub($d5b33d7c30034067$var$_v2$3));
        }
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_vector$9 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_segCenter = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_segDir = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_diff = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_edge1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_edge2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normal$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$a186db52eed6d40e {
    constructor(origin = new $d5b33d7c30034067$export$64b5c384219d3699(), direction = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $d5b33d7c30034067$var$_vector$9));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $d5b33d7c30034067$var$_vector$9.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $d5b33d7c30034067$var$_vector$9.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $d5b33d7c30034067$var$_vector$9.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $d5b33d7c30034067$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $d5b33d7c30034067$var$_segDir.copy(v1).sub(v0).normalize();
        $d5b33d7c30034067$var$_diff.copy(this.origin).sub($d5b33d7c30034067$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($d5b33d7c30034067$var$_segDir);
        const b0 = $d5b33d7c30034067$var$_diff.dot(this.direction);
        const b1 = -$d5b33d7c30034067$var$_diff.dot($d5b33d7c30034067$var$_segDir);
        const c = $d5b33d7c30034067$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($d5b33d7c30034067$var$_segCenter).addScaledVector($d5b33d7c30034067$var$_segDir, s1);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $d5b33d7c30034067$var$_vector$9.subVectors(sphere.center, this.origin);
        const tca = $d5b33d7c30034067$var$_vector$9.dot(this.direction);
        const d2 = $d5b33d7c30034067$var$_vector$9.dot($d5b33d7c30034067$var$_vector$9) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $d5b33d7c30034067$var$_vector$9) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $d5b33d7c30034067$var$_edge1.subVectors(b, a);
        $d5b33d7c30034067$var$_edge2.subVectors(c, a);
        $d5b33d7c30034067$var$_normal$1.crossVectors($d5b33d7c30034067$var$_edge1, $d5b33d7c30034067$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($d5b33d7c30034067$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $d5b33d7c30034067$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($d5b33d7c30034067$var$_edge2.crossVectors($d5b33d7c30034067$var$_diff, $d5b33d7c30034067$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($d5b33d7c30034067$var$_edge1.cross($d5b33d7c30034067$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $d5b33d7c30034067$var$_diff.dot($d5b33d7c30034067$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$2ae72fc923e5eb5 {
    constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        $d5b33d7c30034067$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($d5b33d7c30034067$var$_zero, q, $d5b33d7c30034067$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $d5b33d7c30034067$var$_z.subVectors(eye, target);
        if ($d5b33d7c30034067$var$_z.lengthSq() === 0) // eye and target are in the same position
        $d5b33d7c30034067$var$_z.z = 1;
        $d5b33d7c30034067$var$_z.normalize();
        $d5b33d7c30034067$var$_x.crossVectors(up, $d5b33d7c30034067$var$_z);
        if ($d5b33d7c30034067$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $d5b33d7c30034067$var$_z.x += 0.0001;
            else $d5b33d7c30034067$var$_z.z += 0.0001;
            $d5b33d7c30034067$var$_z.normalize();
            $d5b33d7c30034067$var$_x.crossVectors(up, $d5b33d7c30034067$var$_z);
        }
        $d5b33d7c30034067$var$_x.normalize();
        $d5b33d7c30034067$var$_y.crossVectors($d5b33d7c30034067$var$_z, $d5b33d7c30034067$var$_x);
        te[0] = $d5b33d7c30034067$var$_x.x;
        te[4] = $d5b33d7c30034067$var$_y.x;
        te[8] = $d5b33d7c30034067$var$_z.x;
        te[1] = $d5b33d7c30034067$var$_x.y;
        te[5] = $d5b33d7c30034067$var$_y.y;
        te[9] = $d5b33d7c30034067$var$_z.y;
        te[2] = $d5b33d7c30034067$var$_x.z;
        te[6] = $d5b33d7c30034067$var$_y.z;
        te[10] = $d5b33d7c30034067$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $d5b33d7c30034067$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $d5b33d7c30034067$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $d5b33d7c30034067$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $d5b33d7c30034067$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $d5b33d7c30034067$var$_m1$2.elements[0] *= invSX;
        $d5b33d7c30034067$var$_m1$2.elements[1] *= invSX;
        $d5b33d7c30034067$var$_m1$2.elements[2] *= invSX;
        $d5b33d7c30034067$var$_m1$2.elements[4] *= invSY;
        $d5b33d7c30034067$var$_m1$2.elements[5] *= invSY;
        $d5b33d7c30034067$var$_m1$2.elements[6] *= invSY;
        $d5b33d7c30034067$var$_m1$2.elements[8] *= invSZ;
        $d5b33d7c30034067$var$_m1$2.elements[9] *= invSZ;
        $d5b33d7c30034067$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($d5b33d7c30034067$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far, coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) {
            c = -(far + near) / (far - near);
            d = -2 * far * near / (far - near);
        } else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) {
            c = -far / (far - near);
            d = -far * near / (far - near);
        } else throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        let z, zInv;
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) {
            z = (far + near) * p;
            zInv = -2 * p;
        } else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) {
            z = near * p;
            zInv = -1 * p;
        } else throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = zInv;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $d5b33d7c30034067$var$_v1$5 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_m1$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_zero = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 0);
const $d5b33d7c30034067$var$_one = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1);
const $d5b33d7c30034067$var$_x = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_y = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_z = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_matrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_quaternion$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
class $d5b33d7c30034067$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $d5b33d7c30034067$export$d93cc409a0768c5f.DEFAULT_ORDER){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin($d5b33d7c30034067$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-$d5b33d7c30034067$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin($d5b33d7c30034067$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-$d5b33d7c30034067$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin($d5b33d7c30034067$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-$d5b33d7c30034067$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $d5b33d7c30034067$var$_matrix.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($d5b33d7c30034067$var$_matrix, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $d5b33d7c30034067$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($d5b33d7c30034067$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
$d5b33d7c30034067$export$d93cc409a0768c5f.DEFAULT_ORDER = 'XYZ';
class $d5b33d7c30034067$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $d5b33d7c30034067$var$_object3DId = 0;
const $d5b33d7c30034067$var$_v1$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_q1 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_m1$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_target = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_position$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_scale$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_xAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0);
const $d5b33d7c30034067$var$_yAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
const $d5b33d7c30034067$var$_zAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1);
const $d5b33d7c30034067$var$_addedEvent = {
    type: 'added'
};
const $d5b33d7c30034067$var$_removedEvent = {
    type: 'removed'
};
class $d5b33d7c30034067$export$e4dd07dff30cc924 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_object3DId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = '';
        this.type = 'Object3D';
        this.parent = null;
        this.children = [];
        this.up = $d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $d5b33d7c30034067$export$64b5c384219d3699();
        const rotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        const quaternion = new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
        const scale = new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $d5b33d7c30034067$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $d5b33d7c30034067$export$8ff26dafa08918()
            }
        });
        this.matrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.matrixWorld = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        this.matrixWorldNeedsUpdate = false;
        this.matrixWorldAutoUpdate = $d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        this.layers = new $d5b33d7c30034067$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $d5b33d7c30034067$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($d5b33d7c30034067$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $d5b33d7c30034067$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($d5b33d7c30034067$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $d5b33d7c30034067$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($d5b33d7c30034067$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_zAxis, distance);
    }
    localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($d5b33d7c30034067$var$_m1$1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $d5b33d7c30034067$var$_target.copy(x);
        else $d5b33d7c30034067$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $d5b33d7c30034067$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $d5b33d7c30034067$var$_m1$1.lookAt($d5b33d7c30034067$var$_position$3, $d5b33d7c30034067$var$_target, this.up);
        else $d5b33d7c30034067$var$_m1$1.lookAt($d5b33d7c30034067$var$_target, $d5b33d7c30034067$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($d5b33d7c30034067$var$_m1$1);
        if (parent) {
            $d5b33d7c30034067$var$_m1$1.extractRotation(parent.matrixWorld);
            $d5b33d7c30034067$var$_q1.setFromRotationMatrix($d5b33d7c30034067$var$_m1$1);
            this.quaternion.premultiply($d5b33d7c30034067$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($d5b33d7c30034067$var$_addedEvent);
        } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($d5b33d7c30034067$var$_removedEvent);
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        return this.remove(...this.children);
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $d5b33d7c30034067$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $d5b33d7c30034067$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($d5b33d7c30034067$var$_m1$1);
        this.add(object);
        object.updateWorldMatrix(false, true);
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getObjectsByProperty(name, value) {
        let result = [];
        if (this[name] === value) result.push(this);
        for(let i = 0, l = this.children.length; i < l; i++){
            const childResult = this.children[i].getObjectsByProperty(name, value);
            if (childResult.length > 0) result = result.concat(childResult);
        }
        return result;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$3, target, $d5b33d7c30034067$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$3, $d5b33d7c30034067$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            if (child.matrixWorldAutoUpdate === true || force === true) child.updateMatrixWorld(force);
        }
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null && parent.matrixWorldAutoUpdate === true) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                if (child.matrixWorldAutoUpdate === true) child.updateWorldMatrix(false, true);
            }
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.6,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
$d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
$d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $d5b33d7c30034067$var$_v0$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v3$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vab = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vac = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vbc = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vap = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vbp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vcp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
let $d5b33d7c30034067$var$warnedGetUV = false;
class $d5b33d7c30034067$export$5a465592bfe74b48 {
    constructor(a = new $d5b33d7c30034067$export$64b5c384219d3699(), b = new $d5b33d7c30034067$export$64b5c384219d3699(), c = new $d5b33d7c30034067$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $d5b33d7c30034067$var$_v0$1.subVectors(a, b);
        target.cross($d5b33d7c30034067$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $d5b33d7c30034067$var$_v0$1.subVectors(c, a);
        $d5b33d7c30034067$var$_v1$3.subVectors(b, a);
        $d5b33d7c30034067$var$_v2$2.subVectors(point, a);
        const dot00 = $d5b33d7c30034067$var$_v0$1.dot($d5b33d7c30034067$var$_v0$1);
        const dot01 = $d5b33d7c30034067$var$_v0$1.dot($d5b33d7c30034067$var$_v1$3);
        const dot02 = $d5b33d7c30034067$var$_v0$1.dot($d5b33d7c30034067$var$_v2$2);
        const dot11 = $d5b33d7c30034067$var$_v1$3.dot($d5b33d7c30034067$var$_v1$3);
        const dot12 = $d5b33d7c30034067$var$_v1$3.dot($d5b33d7c30034067$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, $d5b33d7c30034067$var$_v3$1);
        return $d5b33d7c30034067$var$_v3$1.x >= 0 && $d5b33d7c30034067$var$_v3$1.y >= 0 && $d5b33d7c30034067$var$_v3$1.x + $d5b33d7c30034067$var$_v3$1.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        if ($d5b33d7c30034067$var$warnedGetUV === false) {
            console.warn('THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().');
            $d5b33d7c30034067$var$warnedGetUV = true;
        }
        return this.getInterpolation(point, p1, p2, p3, uv1, uv2, uv3, target);
    }
    static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        this.getBarycoord(point, p1, p2, p3, $d5b33d7c30034067$var$_v3$1);
        target.setScalar(0);
        target.addScaledVector(v1, $d5b33d7c30034067$var$_v3$1.x);
        target.addScaledVector(v2, $d5b33d7c30034067$var$_v3$1.y);
        target.addScaledVector(v3, $d5b33d7c30034067$var$_v3$1.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $d5b33d7c30034067$var$_v0$1.subVectors(c, b);
        $d5b33d7c30034067$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $d5b33d7c30034067$var$_v0$1.cross($d5b33d7c30034067$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $d5b33d7c30034067$var$_v0$1.subVectors(this.c, this.b);
        $d5b33d7c30034067$var$_v1$3.subVectors(this.a, this.b);
        return $d5b33d7c30034067$var$_v0$1.cross($d5b33d7c30034067$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        if ($d5b33d7c30034067$var$warnedGetUV === false) {
            console.warn('THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().');
            $d5b33d7c30034067$var$warnedGetUV = true;
        }
        return $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    getInterpolation(point, v1, v2, v3, target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    containsPoint(point) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $d5b33d7c30034067$var$_vab.subVectors(b, a);
        $d5b33d7c30034067$var$_vac.subVectors(c, a);
        $d5b33d7c30034067$var$_vap.subVectors(p, a);
        const d1 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vap);
        const d2 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $d5b33d7c30034067$var$_vbp.subVectors(p, b);
        const d3 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vbp);
        const d4 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vab, v);
        }
        $d5b33d7c30034067$var$_vcp.subVectors(p, c);
        const d5 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vcp);
        const d6 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $d5b33d7c30034067$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($d5b33d7c30034067$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vab, v).addScaledVector($d5b33d7c30034067$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
let $d5b33d7c30034067$var$_materialId = 0;
class $d5b33d7c30034067$export$a2d8b23205c25948 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_materialId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = '';
        this.type = 'Material';
        this.blending = $d5b33d7c30034067$export$5b29a26d96ee6af0;
        this.side = $d5b33d7c30034067$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.alphaHash = false;
        this.blendSrc = $d5b33d7c30034067$export$d5773124e86cf28c;
        this.blendDst = $d5b33d7c30034067$export$11d468cc7f19e971;
        this.blendEquation = $d5b33d7c30034067$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.depthFunc = $d5b33d7c30034067$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $d5b33d7c30034067$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilZFail = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilZPass = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.forceSinglePass = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.6,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $d5b33d7c30034067$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $d5b33d7c30034067$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = this.transparent;
        data.depthFunc = this.depthFunc;
        data.depthTest = this.depthTest;
        data.depthWrite = this.depthWrite;
        data.colorWrite = this.colorWrite;
        data.stencilWrite = this.stencilWrite;
        data.stencilWriteMask = this.stencilWriteMask;
        data.stencilFunc = this.stencilFunc;
        data.stencilRef = this.stencilRef;
        data.stencilFuncMask = this.stencilFuncMask;
        data.stencilFail = this.stencilFail;
        data.stencilZFail = this.stencilZFail;
        data.stencilZPass = this.stencilZPass;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = this.alphaHash;
        if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
        if (this.forceSinglePass === true) data.forceSinglePass = this.forceSinglePass;
        if (this.wireframe === true) data.wireframe = this.wireframe;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = this.flatShading;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
const $d5b33d7c30034067$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $d5b33d7c30034067$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $d5b33d7c30034067$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $d5b33d7c30034067$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
class $d5b33d7c30034067$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        return this.set(r, g, b);
    }
    set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === 'number') this.setHex(value);
            else if (typeof value === 'string') this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setRGB(r, g, b, colorSpace1 = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setHSL(h, s, l, colorSpace1 = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $d5b33d7c30034067$var$euclideanModulo(h, 1);
        s = $d5b33d7c30034067$var$clamp(s, 0, 1);
        l = $d5b33d7c30034067$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $d5b33d7c30034067$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $d5b33d7c30034067$var$hue2rgb(q, p, h);
            this.b = $d5b33d7c30034067$var$hue2rgb(q, p, h - 1 / 3);
        }
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setStyle(style, colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace1);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace1);
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace1);
                    }
                    break;
                default:
                    console.warn('THREE.Color: Unknown color model ' + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace1);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace1);
            else console.warn('THREE.Color: Invalid hex color ' + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace1);
        return this;
    }
    setColorName(style, colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        // color keywords
        const hex = $d5b33d7c30034067$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace1);
        else // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $d5b33d7c30034067$var$SRGBToLinear(color.r);
        this.g = $d5b33d7c30034067$var$SRGBToLinear(color.g);
        this.b = $d5b33d7c30034067$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $d5b33d7c30034067$var$LinearToSRGB(color.r);
        this.g = $d5b33d7c30034067$var$LinearToSRGB(color.g);
        this.b = $d5b33d7c30034067$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace1);
        return Math.round($d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_color.r * 255, 0, 255)) * 65536 + Math.round($d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_color.g * 255, 0, 255)) * 256 + Math.round($d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_color.b * 255, 0, 255));
    }
    getHexString(colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        return ('000000' + this.getHex(colorSpace1).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace1 = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace1);
        const r = $d5b33d7c30034067$var$_color.r, g = $d5b33d7c30034067$var$_color.g, b = $d5b33d7c30034067$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace1 = $d5b33d7c30034067$export$5e6fd513f44698c.workingColorSpace) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace1);
        target.r = $d5b33d7c30034067$var$_color.r;
        target.g = $d5b33d7c30034067$var$_color.g;
        target.b = $d5b33d7c30034067$var$_color.b;
        return target;
    }
    getStyle(colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$_color.copy(this), colorSpace1);
        const r = $d5b33d7c30034067$var$_color.r, g = $d5b33d7c30034067$var$_color.g, b = $d5b33d7c30034067$var$_color.b;
        if (colorSpace1 !== $d5b33d7c30034067$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace1} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($d5b33d7c30034067$var$_hslA);
        $d5b33d7c30034067$var$_hslA.h += h;
        $d5b33d7c30034067$var$_hslA.s += s;
        $d5b33d7c30034067$var$_hslA.l += l;
        this.setHSL($d5b33d7c30034067$var$_hslA.h, $d5b33d7c30034067$var$_hslA.s, $d5b33d7c30034067$var$_hslA.l);
        return this;
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($d5b33d7c30034067$var$_hslA);
        color.getHSL($d5b33d7c30034067$var$_hslB);
        const h = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.h, $d5b33d7c30034067$var$_hslB.h, alpha);
        const s = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.s, $d5b33d7c30034067$var$_hslB.s, alpha);
        const l = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.l, $d5b33d7c30034067$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $d5b33d7c30034067$var$_color = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
$d5b33d7c30034067$export$892596cec99bc70e.NAMES = $d5b33d7c30034067$var$_colorKeywords;
class $d5b33d7c30034067$export$55cbcc9b622fe1f5 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.type = 'MeshBasicMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $d5b33d7c30034067$var$_tables = /*@__PURE__*/ $d5b33d7c30034067$var$_generateTables();
function $d5b33d7c30034067$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $d5b33d7c30034067$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn('THREE.DataUtils.toHalfFloat(): Value out of range.');
    val = $d5b33d7c30034067$var$clamp(val, -65504, 65504);
    $d5b33d7c30034067$var$_tables.floatView[0] = val;
    const f = $d5b33d7c30034067$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $d5b33d7c30034067$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $d5b33d7c30034067$var$_tables.shiftTable[e]);
}
// float16 to float32
function $d5b33d7c30034067$var$fromHalfFloat(val) {
    const m = val >> 10;
    $d5b33d7c30034067$var$_tables.uint32View[0] = $d5b33d7c30034067$var$_tables.mantissaTable[$d5b33d7c30034067$var$_tables.offsetTable[m] + (val & 0x3ff)] + $d5b33d7c30034067$var$_tables.exponentTable[m];
    return $d5b33d7c30034067$var$_tables.floatView[0];
}
const $d5b33d7c30034067$export$11ce8b759162cc80 = {
    toHalfFloat: $d5b33d7c30034067$var$toHalfFloat,
    fromHalfFloat: $d5b33d7c30034067$var$fromHalfFloat
};
const $d5b33d7c30034067$var$_vector$8 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vector2$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        this.isBufferAttribute = true;
        this.name = '';
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.gpuType = $d5b33d7c30034067$export$f6d331659b644596;
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector2$1.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $d5b33d7c30034067$var$_vector2$1.x, $d5b33d7c30034067$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$8.applyMatrix3(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$8.x, $d5b33d7c30034067$var$_vector$8.y, $d5b33d7c30034067$var$_vector$8.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$8.applyMatrix4(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$8.x, $d5b33d7c30034067$var$_vector$8.y, $d5b33d7c30034067$var$_vector$8.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$8.applyNormalMatrix(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$8.x, $d5b33d7c30034067$var$_vector$8.y, $d5b33d7c30034067$var$_vector$8.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$8.transformDirection(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$8.x, $d5b33d7c30034067$var$_vector$8.y, $d5b33d7c30034067$var$_vector$8.z);
        }
        return this;
    }
    set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = $d5b33d7c30034067$var$denormalize(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = $d5b33d7c30034067$var$normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $d5b33d7c30034067$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $d5b33d7c30034067$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $d5b33d7c30034067$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $d5b33d7c30034067$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $d5b33d7c30034067$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $d5b33d7c30034067$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $d5b33d7c30034067$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $d5b33d7c30034067$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
            w = $d5b33d7c30034067$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== $d5b33d7c30034067$export$763e8360f4d7f77d) data.usage = this.usage;
        if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
        return data;
    }
}
//
class $d5b33d7c30034067$export$f9ff2d6a20248cbf extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$cacc90cf35d11cdd extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$baaa85a1a812c157 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$2b755a102ccdcefe extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$640a853f68025f2e extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$46b369aed2968a0a extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$dbd3698c64958d69 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $d5b33d7c30034067$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $d5b33d7c30034067$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $d5b33d7c30034067$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $d5b33d7c30034067$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $d5b33d7c30034067$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $d5b33d7c30034067$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $d5b33d7c30034067$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $d5b33d7c30034067$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $d5b33d7c30034067$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $d5b33d7c30034067$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $d5b33d7c30034067$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $d5b33d7c30034067$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
        }
        this.array[index + 0] = $d5b33d7c30034067$var$toHalfFloat(x);
        this.array[index + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
        }
        this.array[index + 0] = $d5b33d7c30034067$var$toHalfFloat(x);
        this.array[index + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        this.array[index + 2] = $d5b33d7c30034067$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
            w = $d5b33d7c30034067$var$normalize(w, this.array);
        }
        this.array[index + 0] = $d5b33d7c30034067$var$toHalfFloat(x);
        this.array[index + 1] = $d5b33d7c30034067$var$toHalfFloat(y);
        this.array[index + 2] = $d5b33d7c30034067$var$toHalfFloat(z);
        this.array[index + 3] = $d5b33d7c30034067$var$toHalfFloat(w);
        return this;
    }
}
class $d5b33d7c30034067$export$cbe7a62641830ebd extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$9e0ade74842adbb8 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float64Array(array), itemSize, normalized);
    }
}
let $d5b33d7c30034067$var$_id$2 = 0;
const $d5b33d7c30034067$var$_m1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_obj = /*@__PURE__*/ new $d5b33d7c30034067$export$e4dd07dff30cc924();
const $d5b33d7c30034067$var$_offset = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_box$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_boxMorphTargets = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_vector$7 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$b7be63a67df8959 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_id$2++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = '';
        this.type = 'BufferGeometry';
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($d5b33d7c30034067$var$arrayNeedsUint32(index) ? $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 : $d5b33d7c30034067$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $d5b33d7c30034067$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $d5b33d7c30034067$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $d5b33d7c30034067$var$_m1.makeRotationX(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $d5b33d7c30034067$var$_m1.makeRotationY(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $d5b33d7c30034067$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $d5b33d7c30034067$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $d5b33d7c30034067$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    lookAt(vector) {
        $d5b33d7c30034067$var$_obj.lookAt(vector);
        $d5b33d7c30034067$var$_obj.updateMatrix();
        this.applyMatrix4($d5b33d7c30034067$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($d5b33d7c30034067$var$_offset).negate();
        this.translate($d5b33d7c30034067$var$_offset.x, $d5b33d7c30034067$var$_offset.y, $d5b33d7c30034067$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new $d5b33d7c30034067$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $d5b33d7c30034067$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $d5b33d7c30034067$var$_box$1.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $d5b33d7c30034067$var$_vector$7.addVectors(this.boundingBox.min, $d5b33d7c30034067$var$_box$1.min);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_vector$7);
                    $d5b33d7c30034067$var$_vector$7.addVectors(this.boundingBox.max, $d5b33d7c30034067$var$_box$1.max);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_vector$7);
                } else {
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_box$1.min);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_box$1.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new $d5b33d7c30034067$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $d5b33d7c30034067$var$_box$1.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $d5b33d7c30034067$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $d5b33d7c30034067$var$_vector$7.addVectors($d5b33d7c30034067$var$_box$1.min, $d5b33d7c30034067$var$_boxMorphTargets.min);
                    $d5b33d7c30034067$var$_box$1.expandByPoint($d5b33d7c30034067$var$_vector$7);
                    $d5b33d7c30034067$var$_vector$7.addVectors($d5b33d7c30034067$var$_box$1.max, $d5b33d7c30034067$var$_boxMorphTargets.max);
                    $d5b33d7c30034067$var$_box$1.expandByPoint($d5b33d7c30034067$var$_vector$7);
                } else {
                    $d5b33d7c30034067$var$_box$1.expandByPoint($d5b33d7c30034067$var$_boxMorphTargets.min);
                    $d5b33d7c30034067$var$_box$1.expandByPoint($d5b33d7c30034067$var$_boxMorphTargets.max);
                }
            }
            $d5b33d7c30034067$var$_box$1.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $d5b33d7c30034067$var$_vector$7.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($d5b33d7c30034067$var$_vector$7));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $d5b33d7c30034067$var$_vector$7.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $d5b33d7c30034067$var$_offset.fromBufferAttribute(position, j);
                        $d5b33d7c30034067$var$_vector$7.add($d5b33d7c30034067$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($d5b33d7c30034067$var$_vector$7));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const indices = index.array;
        const positions = attributes.position.array;
        const normals = attributes.normal.array;
        const uvs = attributes.uv.array;
        const nVertices = positions.length / 3;
        if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(4 * nVertices), 4));
        const tangents = this.getAttribute('tangent').array;
        const tan1 = [], tan2 = [];
        for(let i = 0; i < nVertices; i++){
            tan1[i] = new $d5b33d7c30034067$export$64b5c384219d3699();
            tan2[i] = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        const vA = new $d5b33d7c30034067$export$64b5c384219d3699(), vB = new $d5b33d7c30034067$export$64b5c384219d3699(), vC = new $d5b33d7c30034067$export$64b5c384219d3699(), uvA = new $d5b33d7c30034067$export$c977b3e384af9ae1(), uvB = new $d5b33d7c30034067$export$c977b3e384af9ae1(), uvC = new $d5b33d7c30034067$export$c977b3e384af9ae1(), sdir = new $d5b33d7c30034067$export$64b5c384219d3699(), tdir = new $d5b33d7c30034067$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);
            uvA.fromArray(uvs, a * 2);
            uvB.fromArray(uvs, b * 2);
            uvC.fromArray(uvs, c * 2);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: indices.length
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
        const tmp = new $d5b33d7c30034067$export$64b5c384219d3699(), tmp2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const n = new $d5b33d7c30034067$export$64b5c384219d3699(), n2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromArray(normals, v * 3);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangents[v * 4] = tmp.x;
            tangents[v * 4 + 1] = tmp.y;
            tangents[v * 4 + 2] = tmp.z;
            tangents[v * 4 + 3] = w;
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(indices[j + 0]);
                handleVertex(indices[j + 1]);
                handleVertex(indices[j + 2]);
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $d5b33d7c30034067$export$64b5c384219d3699(), pB = new $d5b33d7c30034067$export$64b5c384219d3699(), pC = new $d5b33d7c30034067$export$64b5c384219d3699();
            const nA = new $d5b33d7c30034067$export$64b5c384219d3699(), nB = new $d5b33d7c30034067$export$64b5c384219d3699(), nC = new $d5b33d7c30034067$export$64b5c384219d3699();
            const cb = new $d5b33d7c30034067$export$64b5c384219d3699(), ab = new $d5b33d7c30034067$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $d5b33d7c30034067$var$_vector$7.fromBufferAttribute(normals, i);
            $d5b33d7c30034067$var$_vector$7.normalize();
            normals.setXYZ(i, $d5b33d7c30034067$var$_vector$7.x, $d5b33d7c30034067$var$_vector$7.y, $d5b33d7c30034067$var$_vector$7.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $d5b33d7c30034067$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new $d5b33d7c30034067$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
const $d5b33d7c30034067$var$_inverseMatrix$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere$5 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_sphereHitAt = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vA$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vB$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vC$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_tempA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_morphA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_uvA$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvB$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvC$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_normalA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normalB = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normalC = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_intersectionPoint = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_intersectionPointWorld = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$e176487c05830cc5 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5()){
        super();
        this.isMesh = true;
        this.type = 'Mesh';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $d5b33d7c30034067$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $d5b33d7c30034067$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $d5b33d7c30034067$var$_morphA.addScaledVector($d5b33d7c30034067$var$_tempA, influence);
                else $d5b33d7c30034067$var$_morphA.addScaledVector($d5b33d7c30034067$var$_tempA.sub(target), influence);
            }
            target.add($d5b33d7c30034067$var$_morphA);
        }
        return target;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$5.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere$5.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $d5b33d7c30034067$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($d5b33d7c30034067$var$_sphere$5.containsPoint($d5b33d7c30034067$var$_ray$3.origin) === false) {
            if ($d5b33d7c30034067$var$_ray$3.intersectSphere($d5b33d7c30034067$var$_sphere$5, $d5b33d7c30034067$var$_sphereHitAt) === null) return;
            if ($d5b33d7c30034067$var$_ray$3.origin.distanceToSquared($d5b33d7c30034067$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $d5b33d7c30034067$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray$3.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($d5b33d7c30034067$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $d5b33d7c30034067$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $d5b33d7c30034067$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $d5b33d7c30034067$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $d5b33d7c30034067$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $d5b33d7c30034067$var$_intersectionPointWorld.copy(point);
    $d5b33d7c30034067$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $d5b33d7c30034067$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $d5b33d7c30034067$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $d5b33d7c30034067$var$_vA$1);
    object.getVertexPosition(b, $d5b33d7c30034067$var$_vB$1);
    object.getVertexPosition(c, $d5b33d7c30034067$var$_vC$1);
    const intersection = $d5b33d7c30034067$var$checkIntersection(object, material, raycaster, ray, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $d5b33d7c30034067$var$_uvA$1.fromBufferAttribute(uv, a);
            $d5b33d7c30034067$var$_uvB$1.fromBufferAttribute(uv, b);
            $d5b33d7c30034067$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation($d5b33d7c30034067$var$_intersectionPoint, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_uvA$1, $d5b33d7c30034067$var$_uvB$1, $d5b33d7c30034067$var$_uvC$1, new $d5b33d7c30034067$export$c977b3e384af9ae1());
        }
        if (uv1) {
            $d5b33d7c30034067$var$_uvA$1.fromBufferAttribute(uv1, a);
            $d5b33d7c30034067$var$_uvB$1.fromBufferAttribute(uv1, b);
            $d5b33d7c30034067$var$_uvC$1.fromBufferAttribute(uv1, c);
            intersection.uv1 = $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation($d5b33d7c30034067$var$_intersectionPoint, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_uvA$1, $d5b33d7c30034067$var$_uvB$1, $d5b33d7c30034067$var$_uvC$1, new $d5b33d7c30034067$export$c977b3e384af9ae1());
            intersection.uv2 = intersection.uv1; // @deprecated, r152
        }
        if (normal) {
            $d5b33d7c30034067$var$_normalA.fromBufferAttribute(normal, a);
            $d5b33d7c30034067$var$_normalB.fromBufferAttribute(normal, b);
            $d5b33d7c30034067$var$_normalC.fromBufferAttribute(normal, c);
            intersection.normal = $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation($d5b33d7c30034067$var$_intersectionPoint, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_normalA, $d5b33d7c30034067$var$_normalB, $d5b33d7c30034067$var$_normalC, new $d5b33d7c30034067$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $d5b33d7c30034067$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $d5b33d7c30034067$export$5a465592bfe74b48.getNormal($d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $d5b33d7c30034067$export$33e43285f7406bd5 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $d5b33d7c30034067$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $d5b33d7c30034067$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $d5b33d7c30034067$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $d5b33d7c30034067$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $d5b33d7c30034067$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $d5b33d7c30034067$var$getUnlitUniformColorSpace(renderer) {
    if (renderer.getRenderTarget() === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    return $d5b33d7c30034067$export$42429b3acfb233a4;
}
// Legacy
const $d5b33d7c30034067$export$d8ecdf8615bfea69 = {
    clone: $d5b33d7c30034067$var$cloneUniforms,
    merge: $d5b33d7c30034067$var$mergeUniforms
};
var $d5b33d7c30034067$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $d5b33d7c30034067$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $d5b33d7c30034067$export$83c7d75d550a8b0d extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.type = 'ShaderMaterial';
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = $d5b33d7c30034067$var$default_vertex;
        this.fragmentShader = $d5b33d7c30034067$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.forceSinglePass = true;
        this.extensions = {
            derivatives: false,
            fragDepth: false,
            drawBuffers: false,
            shaderTextureLOD: false // set to use shader texture LOD
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv1': [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $d5b33d7c30034067$var$cloneUniforms(source.uniforms);
        this.uniformsGroups = $d5b33d7c30034067$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
class $d5b33d7c30034067$export$79f141de891a5fed extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isCamera = true;
        this.type = 'Camera';
        this.matrixWorldInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$74e4ae24825f68d7 extends $d5b33d7c30034067$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = 'PerspectiveCamera';
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $d5b33d7c30034067$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $d5b33d7c30034067$var$RAD2DEG * 2 * Math.atan(Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $d5b33d7c30034067$var$fov = -90; // negative fov is not an error
const $d5b33d7c30034067$var$aspect = 1;
class $d5b33d7c30034067$export$d0cdd0bd804995de extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        this.renderTarget = renderTarget;
        this.coordinateSystem = null;
        const cameraPX = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error('THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const renderTarget = this.renderTarget;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4);
        renderer.render(scene, cameraPZ);
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $d5b33d7c30034067$export$ee2e5a18258a4049 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $d5b33d7c30034067$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
class $d5b33d7c30034067$export$ac386671d651941e extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(size = 1, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        if (options.encoding !== undefined) {
            // @deprecated, r152
            $d5b33d7c30034067$var$warnOnce('THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace.');
            options.colorSpace = options.encoding === $d5b33d7c30034067$export$f32388edbb32674 ? $d5b33d7c30034067$export$561f394b24edfcaa : $d5b33d7c30034067$export$bfcb490c2dd3db51;
        }
        this.texture = new $d5b33d7c30034067$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $d5b33d7c30034067$export$33e43285f7406bd5(5, 5, 5);
        const material = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
            name: 'CubemapFromEquirect',
            uniforms: $d5b33d7c30034067$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $d5b33d7c30034067$export$d9f0486e75b5ace,
            blending: $d5b33d7c30034067$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $d5b33d7c30034067$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $d5b33d7c30034067$export$5d8599b6a933fb1b) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
        const camera = new $d5b33d7c30034067$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
const $d5b33d7c30034067$var$_vector1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vector2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normalMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918();
class $d5b33d7c30034067$export$7ff5ac152ef991b0 {
    constructor(normal = new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $d5b33d7c30034067$var$_vector1.subVectors(c, b).cross($d5b33d7c30034067$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    intersectLine(line, target) {
        const direction = line.delta($d5b33d7c30034067$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $d5b33d7c30034067$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($d5b33d7c30034067$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_sphere$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_vector$6 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$35efe6f4c85463d2 {
    constructor(p0 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p1 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p2 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p3 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p4 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p5 = new $d5b33d7c30034067$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m, coordinateSystem = $d5b33d7c30034067$export$5a0e9190d10875d3) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        if (coordinateSystem === $d5b33d7c30034067$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        else if (coordinateSystem === $d5b33d7c30034067$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize();
        else throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem);
        return this;
    }
    intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $d5b33d7c30034067$var$_sphere$4.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $d5b33d7c30034067$var$_sphere$4.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($d5b33d7c30034067$var$_sphere$4);
    }
    intersectsSprite(sprite) {
        $d5b33d7c30034067$var$_sphere$4.center.set(0, 0, 0);
        $d5b33d7c30034067$var$_sphere$4.radius = 0.7071067811865476;
        $d5b33d7c30034067$var$_sphere$4.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($d5b33d7c30034067$var$_sphere$4);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $d5b33d7c30034067$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $d5b33d7c30034067$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $d5b33d7c30034067$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($d5b33d7c30034067$var$_vector$6) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $d5b33d7c30034067$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $d5b33d7c30034067$var$WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = gl.HALF_FLOAT;
                else throw new Error('THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.');
            } else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $d5b33d7c30034067$export$967d831af31f69ce extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $d5b33d7c30034067$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $d5b33d7c30034067$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";
var $d5b33d7c30034067$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $d5b33d7c30034067$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $d5b33d7c30034067$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n\tif ( diffuseColor.a < alphaTest ) discard;\n#endif";
var $d5b33d7c30034067$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var $d5b33d7c30034067$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $d5b33d7c30034067$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";
var $d5b33d7c30034067$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $d5b33d7c30034067$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";
var $d5b33d7c30034067$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var $d5b33d7c30034067$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = dFdx( surf_pos.xyz );\n\t\tvec3 vSigmaY = dFdy( surf_pos.xyz );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $d5b33d7c30034067$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $d5b33d7c30034067$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $d5b33d7c30034067$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $d5b33d7c30034067$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var $d5b33d7c30034067$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $d5b33d7c30034067$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $d5b33d7c30034067$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif";
var $d5b33d7c30034067$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n\tconst vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n\treturn dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $d5b33d7c30034067$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_v0 0.339\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_v1 0.276\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_v4 0.046\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_v5 0.016\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_v6 0.0038\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $d5b33d7c30034067$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $d5b33d7c30034067$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $d5b33d7c30034067$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $d5b33d7c30034067$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $d5b33d7c30034067$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $d5b33d7c30034067$var$colorspace_pars_fragment = "vec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $d5b33d7c30034067$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var $d5b33d7c30034067$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $d5b33d7c30034067$var$fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var $d5b33d7c30034067$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var $d5b33d7c30034067$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $d5b33d7c30034067$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var $d5b33d7c30034067$var$lightmap_fragment = "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\treflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var $d5b33d7c30034067$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $d5b33d7c30034067$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $d5b33d7c30034067$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
var $d5b33d7c30034067$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t#if defined ( LEGACY_LIGHTS )\n\t\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\t\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t\t}\n\t\treturn 1.0;\n\t#else\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tif ( cutoffDistance > 0.0 ) {\n\t\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t}\n\t\treturn distanceFalloff;\n\t#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var $d5b33d7c30034067$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";
var $d5b33d7c30034067$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $d5b33d7c30034067$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
var $d5b33d7c30034067$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $d5b33d7c30034067$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
var $d5b33d7c30034067$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tanisotropyV /= material.anisotropy;\n\tmaterial.anisotropy = saturate( material.anisotropy );\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x - tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x + tbn[ 0 ] * anisotropyV.y;\n#endif";
var $d5b33d7c30034067$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecular += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $d5b33d7c30034067$var$lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometry.viewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometry, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $d5b33d7c30034067$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometry.normal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometry.viewDir, geometry.normal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif";
var $d5b33d7c30034067$var$map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n\t\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var $d5b33d7c30034067$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $d5b33d7c30034067$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $d5b33d7c30034067$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $d5b33d7c30034067$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $d5b33d7c30034067$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $d5b33d7c30034067$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var $d5b33d7c30034067$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\t\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\t\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\t\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n\t#endif\n#endif";
var $d5b33d7c30034067$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t\tuniform sampler2DArray morphTargetsTexture;\n\t\tuniform ivec2 morphTargetsTextureSize;\n\t\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t\t}\n\t#else\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\tuniform float morphTargetInfluences[ 8 ];\n\t\t#else\n\t\t\tuniform float morphTargetInfluences[ 4 ];\n\t\t#endif\n\t#endif\n#endif";
var $d5b33d7c30034067$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\t\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\t\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\t\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t\t#endif\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 geometryNormal = normal;";
var $d5b33d7c30034067$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $d5b33d7c30034067$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";
var $d5b33d7c30034067$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif";
var $d5b33d7c30034067$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $d5b33d7c30034067$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";
var $d5b33d7c30034067$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var $d5b33d7c30034067$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $d5b33d7c30034067$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n\treturn packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n\treturn unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $d5b33d7c30034067$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $d5b33d7c30034067$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $d5b33d7c30034067$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $d5b33d7c30034067$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $d5b33d7c30034067$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $d5b33d7c30034067$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $d5b33d7c30034067$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif";
var $d5b33d7c30034067$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $d5b33d7c30034067$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $d5b33d7c30034067$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $d5b33d7c30034067$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $d5b33d7c30034067$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tuniform int boneTextureSize;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tfloat j = i * 4.0;\n\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\ty = dy * ( y + 0.5 );\n\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\treturn bone;\n\t}\n#endif";
var $d5b33d7c30034067$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $d5b33d7c30034067$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $d5b33d7c30034067$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $d5b33d7c30034067$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $d5b33d7c30034067$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $d5b33d7c30034067$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $d5b33d7c30034067$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\tvec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";
var $d5b33d7c30034067$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $d5b33d7c30034067$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $d5b33d7c30034067$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $d5b33d7c30034067$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
const $d5b33d7c30034067$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $d5b33d7c30034067$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $d5b33d7c30034067$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $d5b33d7c30034067$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
const $d5b33d7c30034067$var$fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}";
const $d5b33d7c30034067$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
const $d5b33d7c30034067$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
const $d5b33d7c30034067$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
const $d5b33d7c30034067$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $d5b33d7c30034067$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $d5b33d7c30034067$var$vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
const $d5b33d7c30034067$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
const $d5b33d7c30034067$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
const $d5b33d7c30034067$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
const $d5b33d7c30034067$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $d5b33d7c30034067$var$vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $d5b33d7c30034067$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $d5b33d7c30034067$export$955f9f2e84c43c8b = {
    alphahash_fragment: $d5b33d7c30034067$var$alphahash_fragment,
    alphahash_pars_fragment: $d5b33d7c30034067$var$alphahash_pars_fragment,
    alphamap_fragment: $d5b33d7c30034067$var$alphamap_fragment,
    alphamap_pars_fragment: $d5b33d7c30034067$var$alphamap_pars_fragment,
    alphatest_fragment: $d5b33d7c30034067$var$alphatest_fragment,
    alphatest_pars_fragment: $d5b33d7c30034067$var$alphatest_pars_fragment,
    aomap_fragment: $d5b33d7c30034067$var$aomap_fragment,
    aomap_pars_fragment: $d5b33d7c30034067$var$aomap_pars_fragment,
    begin_vertex: $d5b33d7c30034067$var$begin_vertex,
    beginnormal_vertex: $d5b33d7c30034067$var$beginnormal_vertex,
    bsdfs: $d5b33d7c30034067$var$bsdfs,
    iridescence_fragment: $d5b33d7c30034067$var$iridescence_fragment,
    bumpmap_pars_fragment: $d5b33d7c30034067$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $d5b33d7c30034067$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $d5b33d7c30034067$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $d5b33d7c30034067$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $d5b33d7c30034067$var$clipping_planes_vertex,
    color_fragment: $d5b33d7c30034067$var$color_fragment,
    color_pars_fragment: $d5b33d7c30034067$var$color_pars_fragment,
    color_pars_vertex: $d5b33d7c30034067$var$color_pars_vertex,
    color_vertex: $d5b33d7c30034067$var$color_vertex,
    common: $d5b33d7c30034067$var$common,
    cube_uv_reflection_fragment: $d5b33d7c30034067$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $d5b33d7c30034067$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $d5b33d7c30034067$var$displacementmap_pars_vertex,
    displacementmap_vertex: $d5b33d7c30034067$var$displacementmap_vertex,
    emissivemap_fragment: $d5b33d7c30034067$var$emissivemap_fragment,
    emissivemap_pars_fragment: $d5b33d7c30034067$var$emissivemap_pars_fragment,
    colorspace_fragment: $d5b33d7c30034067$var$colorspace_fragment,
    colorspace_pars_fragment: $d5b33d7c30034067$var$colorspace_pars_fragment,
    envmap_fragment: $d5b33d7c30034067$var$envmap_fragment,
    envmap_common_pars_fragment: $d5b33d7c30034067$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $d5b33d7c30034067$var$envmap_pars_fragment,
    envmap_pars_vertex: $d5b33d7c30034067$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $d5b33d7c30034067$var$envmap_physical_pars_fragment,
    envmap_vertex: $d5b33d7c30034067$var$envmap_vertex,
    fog_vertex: $d5b33d7c30034067$var$fog_vertex,
    fog_pars_vertex: $d5b33d7c30034067$var$fog_pars_vertex,
    fog_fragment: $d5b33d7c30034067$var$fog_fragment,
    fog_pars_fragment: $d5b33d7c30034067$var$fog_pars_fragment,
    gradientmap_pars_fragment: $d5b33d7c30034067$var$gradientmap_pars_fragment,
    lightmap_fragment: $d5b33d7c30034067$var$lightmap_fragment,
    lightmap_pars_fragment: $d5b33d7c30034067$var$lightmap_pars_fragment,
    lights_lambert_fragment: $d5b33d7c30034067$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $d5b33d7c30034067$var$lights_lambert_pars_fragment,
    lights_pars_begin: $d5b33d7c30034067$var$lights_pars_begin,
    lights_toon_fragment: $d5b33d7c30034067$var$lights_toon_fragment,
    lights_toon_pars_fragment: $d5b33d7c30034067$var$lights_toon_pars_fragment,
    lights_phong_fragment: $d5b33d7c30034067$var$lights_phong_fragment,
    lights_phong_pars_fragment: $d5b33d7c30034067$var$lights_phong_pars_fragment,
    lights_physical_fragment: $d5b33d7c30034067$var$lights_physical_fragment,
    lights_physical_pars_fragment: $d5b33d7c30034067$var$lights_physical_pars_fragment,
    lights_fragment_begin: $d5b33d7c30034067$var$lights_fragment_begin,
    lights_fragment_maps: $d5b33d7c30034067$var$lights_fragment_maps,
    lights_fragment_end: $d5b33d7c30034067$var$lights_fragment_end,
    logdepthbuf_fragment: $d5b33d7c30034067$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $d5b33d7c30034067$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $d5b33d7c30034067$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $d5b33d7c30034067$var$logdepthbuf_vertex,
    map_fragment: $d5b33d7c30034067$var$map_fragment,
    map_pars_fragment: $d5b33d7c30034067$var$map_pars_fragment,
    map_particle_fragment: $d5b33d7c30034067$var$map_particle_fragment,
    map_particle_pars_fragment: $d5b33d7c30034067$var$map_particle_pars_fragment,
    metalnessmap_fragment: $d5b33d7c30034067$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $d5b33d7c30034067$var$metalnessmap_pars_fragment,
    morphcolor_vertex: $d5b33d7c30034067$var$morphcolor_vertex,
    morphnormal_vertex: $d5b33d7c30034067$var$morphnormal_vertex,
    morphtarget_pars_vertex: $d5b33d7c30034067$var$morphtarget_pars_vertex,
    morphtarget_vertex: $d5b33d7c30034067$var$morphtarget_vertex,
    normal_fragment_begin: $d5b33d7c30034067$var$normal_fragment_begin,
    normal_fragment_maps: $d5b33d7c30034067$var$normal_fragment_maps,
    normal_pars_fragment: $d5b33d7c30034067$var$normal_pars_fragment,
    normal_pars_vertex: $d5b33d7c30034067$var$normal_pars_vertex,
    normal_vertex: $d5b33d7c30034067$var$normal_vertex,
    normalmap_pars_fragment: $d5b33d7c30034067$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $d5b33d7c30034067$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $d5b33d7c30034067$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $d5b33d7c30034067$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $d5b33d7c30034067$var$iridescence_pars_fragment,
    opaque_fragment: $d5b33d7c30034067$var$opaque_fragment,
    packing: $d5b33d7c30034067$var$packing,
    premultiplied_alpha_fragment: $d5b33d7c30034067$var$premultiplied_alpha_fragment,
    project_vertex: $d5b33d7c30034067$var$project_vertex,
    dithering_fragment: $d5b33d7c30034067$var$dithering_fragment,
    dithering_pars_fragment: $d5b33d7c30034067$var$dithering_pars_fragment,
    roughnessmap_fragment: $d5b33d7c30034067$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $d5b33d7c30034067$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $d5b33d7c30034067$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $d5b33d7c30034067$var$shadowmap_pars_vertex,
    shadowmap_vertex: $d5b33d7c30034067$var$shadowmap_vertex,
    shadowmask_pars_fragment: $d5b33d7c30034067$var$shadowmask_pars_fragment,
    skinbase_vertex: $d5b33d7c30034067$var$skinbase_vertex,
    skinning_pars_vertex: $d5b33d7c30034067$var$skinning_pars_vertex,
    skinning_vertex: $d5b33d7c30034067$var$skinning_vertex,
    skinnormal_vertex: $d5b33d7c30034067$var$skinnormal_vertex,
    specularmap_fragment: $d5b33d7c30034067$var$specularmap_fragment,
    specularmap_pars_fragment: $d5b33d7c30034067$var$specularmap_pars_fragment,
    tonemapping_fragment: $d5b33d7c30034067$var$tonemapping_fragment,
    tonemapping_pars_fragment: $d5b33d7c30034067$var$tonemapping_pars_fragment,
    transmission_fragment: $d5b33d7c30034067$var$transmission_fragment,
    transmission_pars_fragment: $d5b33d7c30034067$var$transmission_pars_fragment,
    uv_pars_fragment: $d5b33d7c30034067$var$uv_pars_fragment,
    uv_pars_vertex: $d5b33d7c30034067$var$uv_pars_vertex,
    uv_vertex: $d5b33d7c30034067$var$uv_vertex,
    worldpos_vertex: $d5b33d7c30034067$var$worldpos_vertex,
    background_vert: $d5b33d7c30034067$var$vertex$h,
    background_frag: $d5b33d7c30034067$var$fragment$h,
    backgroundCube_vert: $d5b33d7c30034067$var$vertex$g,
    backgroundCube_frag: $d5b33d7c30034067$var$fragment$g,
    cube_vert: $d5b33d7c30034067$var$vertex$f,
    cube_frag: $d5b33d7c30034067$var$fragment$f,
    depth_vert: $d5b33d7c30034067$var$vertex$e,
    depth_frag: $d5b33d7c30034067$var$fragment$e,
    distanceRGBA_vert: $d5b33d7c30034067$var$vertex$d,
    distanceRGBA_frag: $d5b33d7c30034067$var$fragment$d,
    equirect_vert: $d5b33d7c30034067$var$vertex$c,
    equirect_frag: $d5b33d7c30034067$var$fragment$c,
    linedashed_vert: $d5b33d7c30034067$var$vertex$b,
    linedashed_frag: $d5b33d7c30034067$var$fragment$b,
    meshbasic_vert: $d5b33d7c30034067$var$vertex$a,
    meshbasic_frag: $d5b33d7c30034067$var$fragment$a,
    meshlambert_vert: $d5b33d7c30034067$var$vertex$9,
    meshlambert_frag: $d5b33d7c30034067$var$fragment$9,
    meshmatcap_vert: $d5b33d7c30034067$var$vertex$8,
    meshmatcap_frag: $d5b33d7c30034067$var$fragment$8,
    meshnormal_vert: $d5b33d7c30034067$var$vertex$7,
    meshnormal_frag: $d5b33d7c30034067$var$fragment$7,
    meshphong_vert: $d5b33d7c30034067$var$vertex$6,
    meshphong_frag: $d5b33d7c30034067$var$fragment$6,
    meshphysical_vert: $d5b33d7c30034067$var$vertex$5,
    meshphysical_frag: $d5b33d7c30034067$var$fragment$5,
    meshtoon_vert: $d5b33d7c30034067$var$vertex$4,
    meshtoon_frag: $d5b33d7c30034067$var$fragment$4,
    points_vert: $d5b33d7c30034067$var$vertex$3,
    points_frag: $d5b33d7c30034067$var$fragment$3,
    shadow_vert: $d5b33d7c30034067$var$vertex$2,
    shadow_frag: $d5b33d7c30034067$var$fragment$2,
    sprite_vert: $d5b33d7c30034067$var$vertex$1,
    sprite_frag: $d5b33d7c30034067$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $d5b33d7c30034067$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        normalScale: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $d5b33d7c30034067$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.roughnessmap,
            $d5b33d7c30034067$export$6643083551874bf5.metalnessmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.gradientmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.points,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.sprite,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.shadow_frag
    }
};
$d5b33d7c30034067$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
        $d5b33d7c30034067$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            }
        }
    ]),
    vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_frag
};
const $d5b33d7c30034067$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
function $d5b33d7c30034067$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene) {
        let forceClear = false;
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === 'alpha-blend') state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.mapping === $d5b33d7c30034067$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$33e43285f7406bd5(1, 1, 1), new $d5b33d7c30034067$export$83c7d75d550a8b0d({
                    name: 'BackgroundCubeMaterial',
                    uniforms: $d5b33d7c30034067$var$cloneUniforms($d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: $d5b33d7c30034067$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.toneMapped = background.colorSpace === $d5b33d7c30034067$export$561f394b24edfcaa ? false : true;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$967d831af31f69ce(2, 2), new $d5b33d7c30034067$export$83c7d75d550a8b0d({
                    name: 'BackgroundMaterial',
                    uniforms: $d5b33d7c30034067$var$cloneUniforms($d5b33d7c30034067$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $d5b33d7c30034067$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = background.colorSpace === $d5b33d7c30034067$export$561f394b24edfcaa ? false : true;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($d5b33d7c30034067$var$_rgb, $d5b33d7c30034067$var$getUnlitUniformColorSpace(renderer));
        state.buffers.color.setClear($d5b33d7c30034067$var$_rgb.r, $d5b33d7c30034067$var$_rgb.g, $d5b33d7c30034067$var$_rgb.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function $d5b33d7c30034067$var$WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const extension = capabilities.isWebGL2 ? null : extensions.get('OES_vertex_array_object');
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(object, geometry, program, index);
            if (updateBuffers) saveCache(object, geometry, program, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get('ANGLE_instanced_arrays');
            extension[capabilities.isWebGL2 ? 'vertexAttribDivisor' : 'vertexAttribDivisorANGLE'](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get('ANGLE_instanced_arrays') === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes (WebGL 2 only)
                    const integer = capabilities.isWebGL2 === true && (type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === $d5b33d7c30034067$export$5c612977753abe2);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $d5b33d7c30034067$var$WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawArraysInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawArraysInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $d5b33d7c30034067$var$WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    const isWebGL2 = typeof WebGL2RenderingContext !== 'undefined' && gl.constructor.name === 'WebGL2RenderingContext';
    let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const drawBuffers = isWebGL2 || extensions.has('WEBGL_draw_buffers');
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || extensions.has('OES_texture_float');
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(gl.MAX_SAMPLES) : 0;
    return {
        isWebGL2: isWebGL2,
        drawBuffers: drawBuffers,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function $d5b33d7c30034067$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), viewNormalMatrix = new $d5b33d7c30034067$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $d5b33d7c30034067$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $d5b33d7c30034067$export$d64030b316d3b087) texture.mapping = $d5b33d7c30034067$export$8759762a6477f2c4;
        else if (mapping === $d5b33d7c30034067$export$ee99d97d46898098) texture.mapping = $d5b33d7c30034067$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
            const mapping = texture.mapping;
            if (mapping === $d5b33d7c30034067$export$d64030b316d3b087 || mapping === $d5b33d7c30034067$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $d5b33d7c30034067$export$ac386671d651941e(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$9ebf355ee4ed261b extends $d5b33d7c30034067$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = 'OrthographicCamera';
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
const $d5b33d7c30034067$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $d5b33d7c30034067$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $d5b33d7c30034067$var$MAX_SAMPLES = 20;
const $d5b33d7c30034067$var$_flatCamera = /*@__PURE__*/ new $d5b33d7c30034067$export$9ebf355ee4ed261b();
const $d5b33d7c30034067$var$_clearColor = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
let $d5b33d7c30034067$var$_oldTarget = null;
// Golden Ratio
const $d5b33d7c30034067$var$PHI = (1 + Math.sqrt(5)) / 2;
const $d5b33d7c30034067$var$INV_PHI = 1 / $d5b33d7c30034067$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $d5b33d7c30034067$var$_axisDirections = [
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, $d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, $d5b33d7c30034067$var$PHI, -$d5b33d7c30034067$var$INV_PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699($d5b33d7c30034067$var$INV_PHI, 0, $d5b33d7c30034067$var$PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-$d5b33d7c30034067$var$INV_PHI, 0, $d5b33d7c30034067$var$PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699($d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI, 0),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-$d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $d5b33d7c30034067$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $d5b33d7c30034067$var$_oldTarget = this._renderer.getRenderTarget();
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $d5b33d7c30034067$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $d5b33d7c30034067$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($d5b33d7c30034067$var$_oldTarget);
        outputTarget.scissorTest = false;
        $d5b33d7c30034067$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || texture.mapping === $d5b33d7c30034067$export$dc59f8aed047f61d) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $d5b33d7c30034067$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
            minFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $d5b33d7c30034067$export$2697304443f382bc,
            format: $d5b33d7c30034067$export$3f8bb04b555a363c,
            colorSpace: $d5b33d7c30034067$export$42429b3acfb233a4,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $d5b33d7c30034067$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $d5b33d7c30034067$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $d5b33d7c30034067$var$_createPlanes(_lodMax));
            this._blurMaterial = $d5b33d7c30034067$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $d5b33d7c30034067$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $d5b33d7c30034067$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($d5b33d7c30034067$var$_clearColor);
        renderer.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            name: 'PMREM.Background',
            side: $d5b33d7c30034067$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$33e43285f7406bd5(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($d5b33d7c30034067$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $d5b33d7c30034067$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || texture.mapping === $d5b33d7c30034067$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $d5b33d7c30034067$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $d5b33d7c30034067$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        const size = this._cubeSize;
        $d5b33d7c30034067$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $d5b33d7c30034067$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < this._lodPlanes.length; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $d5b33d7c30034067$var$_axisDirections[(i - 1) % $d5b33d7c30034067$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $d5b33d7c30034067$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $d5b33d7c30034067$var$MAX_SAMPLES;
        if (samples > $d5b33d7c30034067$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$d5b33d7c30034067$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $d5b33d7c30034067$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $d5b33d7c30034067$var$LOD_MIN ? lodOut - _lodMax + $d5b33d7c30034067$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $d5b33d7c30034067$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $d5b33d7c30034067$var$_flatCamera);
    }
}
function $d5b33d7c30034067$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $d5b33d7c30034067$var$LOD_MIN + 1 + $d5b33d7c30034067$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $d5b33d7c30034067$var$LOD_MIN) sigma = $d5b33d7c30034067$var$EXTRA_LOD_SIGMA[i - lodMax + $d5b33d7c30034067$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $d5b33d7c30034067$export$b7be63a67df8959();
        planes.setAttribute('position', new $d5b33d7c30034067$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute('uv', new $d5b33d7c30034067$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute('faceIndex', new $d5b33d7c30034067$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $d5b33d7c30034067$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $d5b33d7c30034067$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(width, height, params);
    cubeUVRenderTarget.texture.mapping = $d5b33d7c30034067$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $d5b33d7c30034067$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $d5b33d7c30034067$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($d5b33d7c30034067$var$MAX_SAMPLES);
    const poleAxis = new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': $d5b33d7c30034067$var$MAX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $d5b33d7c30034067$var$_getEquirectMaterial() {
    return new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $d5b33d7c30034067$var$_getCubemapMaterial() {
    return new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'flipEnvMap': {
                value: -1
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $d5b33d7c30034067$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $d5b33d7c30034067$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $d5b33d7c30034067$export$d64030b316d3b087 || mapping === $d5b33d7c30034067$export$ee99d97d46898098;
            const isCubeMap = mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || mapping === $d5b33d7c30034067$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {
                    texture.needsPMREMUpdate = false;
                    let renderTarget = cubeUVmaps.get(texture);
                    if (pmremGenerator === null) pmremGenerator = new $d5b33d7c30034067$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (cubeUVmaps.has(texture)) return cubeUVmaps.get(texture).texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $d5b33d7c30034067$export$6add42717753e221(renderer);
                            const renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case 'WEBGL_depth_texture':
                extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                break;
            case 'EXT_texture_filter_anisotropic':
                extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                break;
            case 'WEBGL_compressed_texture_s3tc':
                extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                break;
            case 'WEBGL_compressed_texture_pvrtc':
                extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function(capabilities) {
            if (capabilities.isWebGL2) getExtension('EXT_color_buffer_float');
            else {
                getExtension('WEBGL_depth_texture');
                getExtension('OES_texture_float');
                getExtension('OES_texture_half_float');
                getExtension('OES_texture_half_float_linear');
                getExtension('OES_standard_derivatives');
                getExtension('OES_element_index_uint');
                getExtension('OES_vertex_array_object');
                getExtension('ANGLE_instanced_arrays');
            }
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) console.warn('THREE.WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $d5b33d7c30034067$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        for(const name in geometry.morphAttributes){
            const array = geometry.morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.remove(array[i]);
        }
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], gl.ARRAY_BUFFER);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        } else return;
        const attribute = new ($d5b33d7c30034067$var$arrayNeedsUint32(indices) ? $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 : $d5b33d7c30034067$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $d5b33d7c30034067$var$WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawElementsInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawElementsInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $d5b33d7c30034067$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $d5b33d7c30034067$var$numericalSort(a, b) {
    return a[0] - b[0];
}
function $d5b33d7c30034067$var$absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function $d5b33d7c30034067$var$WebGLMorphtargets(gl, capabilities, textures) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const morphTextures = new WeakMap();
    const morph = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        if (capabilities.isWebGL2 === true) {
            // instead of using attributes, the WebGL 2 code path encodes morph targets
            // into an array of data textures. Each layer represents a single morph target.
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            let entry = morphTextures.get(geometry);
            if (entry === undefined || entry.count !== morphTargetsCount) {
                if (entry !== undefined) entry.texture.dispose();
                const hasMorphPosition = geometry.morphAttributes.position !== undefined;
                const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
                const hasMorphColors = geometry.morphAttributes.color !== undefined;
                const morphTargets = geometry.morphAttributes.position || [];
                const morphNormals = geometry.morphAttributes.normal || [];
                const morphColors = geometry.morphAttributes.color || [];
                let vertexDataCount = 0;
                if (hasMorphPosition === true) vertexDataCount = 1;
                if (hasMorphNormals === true) vertexDataCount = 2;
                if (hasMorphColors === true) vertexDataCount = 3;
                let width = geometry.attributes.position.count * vertexDataCount;
                let height = 1;
                if (width > capabilities.maxTextureSize) {
                    height = Math.ceil(width / capabilities.maxTextureSize);
                    width = capabilities.maxTextureSize;
                }
                const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
                const texture = new $d5b33d7c30034067$export$dfac6c8e811406a3(buffer, width, height, morphTargetsCount);
                texture.type = $d5b33d7c30034067$export$f6d331659b644596;
                texture.needsUpdate = true;
                // fill buffer
                const vertexDataStride = vertexDataCount * 4;
                for(let i = 0; i < morphTargetsCount; i++){
                    const morphTarget = morphTargets[i];
                    const morphNormal = morphNormals[i];
                    const morphColor = morphColors[i];
                    const offset = width * height * 4 * i;
                    for(let j = 0; j < morphTarget.count; j++){
                        const stride = j * vertexDataStride;
                        if (hasMorphPosition === true) {
                            morph.fromBufferAttribute(morphTarget, j);
                            buffer[offset + stride + 0] = morph.x;
                            buffer[offset + stride + 1] = morph.y;
                            buffer[offset + stride + 2] = morph.z;
                            buffer[offset + stride + 3] = 0;
                        }
                        if (hasMorphNormals === true) {
                            morph.fromBufferAttribute(morphNormal, j);
                            buffer[offset + stride + 4] = morph.x;
                            buffer[offset + stride + 5] = morph.y;
                            buffer[offset + stride + 6] = morph.z;
                            buffer[offset + stride + 7] = 0;
                        }
                        if (hasMorphColors === true) {
                            morph.fromBufferAttribute(morphColor, j);
                            buffer[offset + stride + 8] = morph.x;
                            buffer[offset + stride + 9] = morph.y;
                            buffer[offset + stride + 10] = morph.z;
                            buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                        }
                    }
                }
                entry = {
                    count: morphTargetsCount,
                    texture: texture,
                    size: new $d5b33d7c30034067$export$c977b3e384af9ae1(width, height)
                };
                morphTextures.set(geometry, entry);
                function disposeTexture() {
                    texture.dispose();
                    morphTextures.delete(geometry);
                    geometry.removeEventListener('dispose', disposeTexture);
                }
                geometry.addEventListener('dispose', disposeTexture);
            }
            //
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
            program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
            program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
        } else {
            // When object doesn't have morph target influences defined, we treat it as a 0-length array
            // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
            const length = objectInfluences === undefined ? 0 : objectInfluences.length;
            let influences = influencesList[geometry.id];
            if (influences === undefined || influences.length !== length) {
                // initialise list
                influences = [];
                for(let i = 0; i < length; i++)influences[i] = [
                    i,
                    0
                ];
                influencesList[geometry.id] = influences;
            }
            // Collect influences
            for(let i = 0; i < length; i++){
                const influence = influences[i];
                influence[0] = i;
                influence[1] = objectInfluences[i];
            }
            influences.sort($d5b33d7c30034067$var$absNumericalSort);
            for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
                workInfluences[i][0] = influences[i][0];
                workInfluences[i][1] = influences[i][1];
            } else {
                workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
                workInfluences[i][1] = 0;
            }
            workInfluences.sort($d5b33d7c30034067$var$numericalSort);
            const morphTargets = geometry.morphAttributes.position;
            const morphNormals = geometry.morphAttributes.normal;
            let morphInfluencesSum = 0;
            for(let i = 0; i < 8; i++){
                const influence = workInfluences[i];
                const index = influence[0];
                const value = influence[1];
                if (index !== Number.MAX_SAFE_INTEGER && value) {
                    if (morphTargets && geometry.getAttribute('morphTarget' + i) !== morphTargets[index]) geometry.setAttribute('morphTarget' + i, morphTargets[index]);
                    if (morphNormals && geometry.getAttribute('morphNormal' + i) !== morphNormals[index]) geometry.setAttribute('morphNormal' + i, morphNormals[index]);
                    morphInfluences[i] = value;
                    morphInfluencesSum += value;
                } else {
                    if (morphTargets && geometry.hasAttribute('morphTarget' + i) === true) geometry.deleteAttribute('morphTarget' + i);
                    if (morphNormals && geometry.hasAttribute('morphNormal' + i) === true) geometry.deleteAttribute('morphNormal' + i);
                    morphInfluences[i] = 0;
                }
            }
            // GLSL shader uses formula baseinfluence * base + sum(target * influence)
            // This allows us to switch between absolute morphs and relative morphs without changing shader code
            // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', morphInfluences);
        }
    }
    return {
        update: update
    };
}
function $d5b33d7c30034067$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $d5b33d7c30034067$var$emptyTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$5431306cf43de24a();
const $d5b33d7c30034067$var$emptyArrayTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$dfac6c8e811406a3();
const $d5b33d7c30034067$var$empty3dTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$d7a3086320f856db();
const $d5b33d7c30034067$var$emptyCubeTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $d5b33d7c30034067$var$arrayCacheF32 = [];
const $d5b33d7c30034067$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $d5b33d7c30034067$var$mat4array = new Float32Array(16);
const $d5b33d7c30034067$var$mat3array = new Float32Array(9);
const $d5b33d7c30034067$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $d5b33d7c30034067$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $d5b33d7c30034067$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $d5b33d7c30034067$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $d5b33d7c30034067$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $d5b33d7c30034067$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $d5b33d7c30034067$var$allocTexUnits(textures, n) {
    let r = $d5b33d7c30034067$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $d5b33d7c30034067$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $d5b33d7c30034067$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $d5b33d7c30034067$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $d5b33d7c30034067$var$mat2array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
function $d5b33d7c30034067$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $d5b33d7c30034067$var$mat3array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
function $d5b33d7c30034067$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $d5b33d7c30034067$var$mat4array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $d5b33d7c30034067$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $d5b33d7c30034067$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $d5b33d7c30034067$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2D(v || $d5b33d7c30034067$var$emptyTexture, unit);
}
function $d5b33d7c30034067$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $d5b33d7c30034067$var$empty3dTexture, unit);
}
function $d5b33d7c30034067$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $d5b33d7c30034067$var$emptyCubeTexture, unit);
}
function $d5b33d7c30034067$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $d5b33d7c30034067$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $d5b33d7c30034067$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $d5b33d7c30034067$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $d5b33d7c30034067$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $d5b33d7c30034067$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $d5b33d7c30034067$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $d5b33d7c30034067$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $d5b33d7c30034067$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $d5b33d7c30034067$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5b33d7c30034067$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5b33d7c30034067$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5b33d7c30034067$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5b33d7c30034067$var$setValueV4i; // _VEC4
        case 0x1405:
            return $d5b33d7c30034067$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $d5b33d7c30034067$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $d5b33d7c30034067$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $d5b33d7c30034067$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5b33d7c30034067$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5b33d7c30034067$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5b33d7c30034067$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5b33d7c30034067$var$setValueT2DArray1;
    }
}
// Array of scalars
function $d5b33d7c30034067$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $d5b33d7c30034067$var$setValueV3fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $d5b33d7c30034067$var$setValueV4fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $d5b33d7c30034067$var$setValueM2Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $d5b33d7c30034067$var$setValueM3Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $d5b33d7c30034067$var$setValueM4Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $d5b33d7c30034067$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $d5b33d7c30034067$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $d5b33d7c30034067$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $d5b33d7c30034067$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $d5b33d7c30034067$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $d5b33d7c30034067$var$emptyTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $d5b33d7c30034067$var$empty3dTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $d5b33d7c30034067$var$emptyCubeTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    if (!$d5b33d7c30034067$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $d5b33d7c30034067$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $d5b33d7c30034067$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $d5b33d7c30034067$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $d5b33d7c30034067$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $d5b33d7c30034067$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $d5b33d7c30034067$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $d5b33d7c30034067$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $d5b33d7c30034067$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $d5b33d7c30034067$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $d5b33d7c30034067$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5b33d7c30034067$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5b33d7c30034067$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5b33d7c30034067$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5b33d7c30034067$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $d5b33d7c30034067$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $d5b33d7c30034067$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $d5b33d7c30034067$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $d5b33d7c30034067$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5b33d7c30034067$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5b33d7c30034067$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5b33d7c30034067$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5b33d7c30034067$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $d5b33d7c30034067$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.setValue = $d5b33d7c30034067$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5b33d7c30034067$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.size = activeInfo.size;
        this.setValue = $d5b33d7c30034067$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5b33d7c30034067$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $d5b33d7c30034067$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $d5b33d7c30034067$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $d5b33d7c30034067$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $d5b33d7c30034067$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $d5b33d7c30034067$var$RePathPart.exec(path), matchEnd = $d5b33d7c30034067$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $d5b33d7c30034067$var$addUniform(container, subscript === undefined ? new $d5b33d7c30034067$var$SingleUniform(id, activeInfo, addr) : new $d5b33d7c30034067$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $d5b33d7c30034067$var$StructuredUniform(id);
                $d5b33d7c30034067$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $d5b33d7c30034067$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $d5b33d7c30034067$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $d5b33d7c30034067$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
let $d5b33d7c30034067$var$programIdCount = 0;
function $d5b33d7c30034067$var$handleSource(string, errorLine) {
    const lines = string.split('\n');
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
    }
    return lines2.join('\n');
}
function $d5b33d7c30034067$var$getEncodingComponents(colorSpace1) {
    switch(colorSpace1){
        case $d5b33d7c30034067$export$42429b3acfb233a4:
            return [
                'Linear',
                '( value )'
            ];
        case $d5b33d7c30034067$export$561f394b24edfcaa:
            return [
                'sRGB',
                '( value )'
            ];
        default:
            console.warn('THREE.WebGLProgram: Unsupported color space:', colorSpace1);
            return [
                'Linear',
                '( value )'
            ];
    }
}
function $d5b33d7c30034067$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === '') return '';
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + $d5b33d7c30034067$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $d5b33d7c30034067$var$getTexelEncodingFunction(functionName, colorSpace1) {
    const components = $d5b33d7c30034067$var$getEncodingComponents(colorSpace1);
    return 'vec4 ' + functionName + '( vec4 value ) { return LinearTo' + components[0] + components[1] + '; }';
}
function $d5b33d7c30034067$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $d5b33d7c30034067$export$98f52c2a46c598ca:
            toneMappingName = 'Linear';
            break;
        case $d5b33d7c30034067$export$74b25e54b3bcd548:
            toneMappingName = 'Reinhard';
            break;
        case $d5b33d7c30034067$export$932b3dd283d4a366:
            toneMappingName = 'OptimizedCineon';
            break;
        case $d5b33d7c30034067$export$a0d98fe6d7e4af64:
            toneMappingName = 'ACESFilmic';
            break;
        case $d5b33d7c30034067$export$2c7b09c1e9abfb5e:
            toneMappingName = 'Custom';
            break;
        default:
            console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
function $d5b33d7c30034067$var$generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || !!parameters.envMapCubeUVHeight || parameters.bumpMap || parameters.normalMapTangentSpace || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === 'physical' ? '#extension GL_OES_standard_derivatives : enable' : '',
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? '#extension GL_EXT_frag_depth : enable' : '',
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? '#extension GL_EXT_draw_buffers : require' : '',
        (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? '#extension GL_EXT_shader_texture_lod : enable' : ''
    ];
    return chunks.filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
}
function $d5b33d7c30034067$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $d5b33d7c30034067$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $d5b33d7c30034067$var$filterEmptyLine(string) {
    return string !== '';
}
function $d5b33d7c30034067$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $d5b33d7c30034067$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $d5b33d7c30034067$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $d5b33d7c30034067$var$resolveIncludes(string) {
    return string.replace($d5b33d7c30034067$var$includePattern, $d5b33d7c30034067$var$includeReplacer);
}
const $d5b33d7c30034067$var$shaderChunkMap = new Map([
    [
        'encodings_fragment',
        'colorspace_fragment'
    ],
    [
        'encodings_pars_fragment',
        'colorspace_pars_fragment'
    ],
    [
        'output_fragment',
        'opaque_fragment'
    ]
]);
function $d5b33d7c30034067$var$includeReplacer(match, include) {
    let string = $d5b33d7c30034067$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        const newInclude = $d5b33d7c30034067$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $d5b33d7c30034067$export$955f9f2e84c43c8b[newInclude];
            console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error('Can not resolve #include <' + include + '>');
    }
    return $d5b33d7c30034067$var$resolveIncludes(string);
}
// Unroll Loops
const $d5b33d7c30034067$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $d5b33d7c30034067$var$unrollLoops(string) {
    return string.replace($d5b33d7c30034067$var$unrollLoopPattern, $d5b33d7c30034067$var$loopReplacer);
}
function $d5b33d7c30034067$var$loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $d5b33d7c30034067$var$generatePrecision(parameters) {
    let precisionstring = 'precision ' + parameters.precision + ' float;\nprecision ' + parameters.precision + ' int;';
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function $d5b33d7c30034067$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === $d5b33d7c30034067$export$5813f879eee7cd88) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === $d5b33d7c30034067$export$a47c4b43a1be34f0) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === $d5b33d7c30034067$export$896ae1ade6c829c4) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $d5b33d7c30034067$export$8759762a6477f2c4:
        case $d5b33d7c30034067$export$dc59f8aed047f61d:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case $d5b33d7c30034067$export$dbf3e70ff37af79:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $d5b33d7c30034067$export$dc59f8aed047f61d:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case $d5b33d7c30034067$export$e50ac29801f1774d:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case $d5b33d7c30034067$export$9f9d94f963c85479:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case $d5b33d7c30034067$export$e641dc52bc3494aa:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function $d5b33d7c30034067$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $d5b33d7c30034067$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $d5b33d7c30034067$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $d5b33d7c30034067$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $d5b33d7c30034067$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $d5b33d7c30034067$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $d5b33d7c30034067$var$generateCubeUVSize(parameters);
    const customExtensions = parameters.isWebGL2 ? '' : $d5b33d7c30034067$var$generateExtensions(parameters);
    const customDefines = $d5b33d7c30034067$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            customExtensions,
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $d5b33d7c30034067$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            //
            parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
            parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
            parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
            parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
            parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
            parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
            parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
            parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',
            parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
            parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',
            parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',
            parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
            parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
            parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',
            parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
            parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',
            parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
            parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',
            parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
            parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
            parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',
            parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
            parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',
            //
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors && parameters.isWebGL2 ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_TEXTURE' : '',
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.useLegacyLights ? '#define LEGACY_LIGHTS' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_UV1',
            '	attribute vec2 uv1;',
            '#endif',
            '#ifdef USE_UV2',
            '	attribute vec2 uv2;',
            '#endif',
            '#ifdef USE_UV3',
            '	attribute vec2 uv3;',
            '#endif',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )',
            '	attribute vec3 morphTarget0;',
            '	attribute vec3 morphTarget1;',
            '	attribute vec3 morphTarget2;',
            '	attribute vec3 morphTarget3;',
            '	#ifdef USE_MORPHNORMALS',
            '		attribute vec3 morphNormal0;',
            '		attribute vec3 morphNormal1;',
            '		attribute vec3 morphNormal2;',
            '		attribute vec3 morphNormal3;',
            '	#else',
            '		attribute vec3 morphTarget4;',
            '		attribute vec3 morphTarget5;',
            '		attribute vec3 morphTarget6;',
            '		attribute vec3 morphTarget7;',
            '	#endif',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        prefixFragment = [
            customExtensions,
            $d5b33d7c30034067$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.useLegacyLights ? '#define LEGACY_LIGHTS' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? $d5b33d7c30034067$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? $d5b33d7c30034067$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            $d5b33d7c30034067$export$955f9f2e84c43c8b['colorspace_pars_fragment'],
            $d5b33d7c30034067$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputColorSpace),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
    }
    vertexShader = $d5b33d7c30034067$var$resolveIncludes(vertexShader);
    vertexShader = $d5b33d7c30034067$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $d5b33d7c30034067$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $d5b33d7c30034067$var$resolveIncludes(fragmentShader);
    fragmentShader = $d5b33d7c30034067$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $d5b33d7c30034067$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $d5b33d7c30034067$var$unrollLoops(vertexShader);
    fragmentShader = $d5b33d7c30034067$var$unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            'precision mediump sampler2DArray;',
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === $d5b33d7c30034067$export$f63012db5506e7dd ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === $d5b33d7c30034067$export$f63012db5506e7dd ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $d5b33d7c30034067$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $d5b33d7c30034067$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
            runnable = false;
            if (typeof renderer.debug.onShaderError === 'function') renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
            else {
                // default error reporting
                const vertexErrors = $d5b33d7c30034067$var$getShaderErrors(gl, glVertexShader, 'vertex');
                const fragmentErrors = $d5b33d7c30034067$var$getShaderErrors(gl, glFragmentShader, 'fragment');
                console.error('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
            }
        } else if (programLog !== '') console.warn('THREE.WebGLProgram: Program Info Log:', programLog);
        else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new $d5b33d7c30034067$var$WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = $d5b33d7c30034067$var$fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $d5b33d7c30034067$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $d5b33d7c30034067$var$_id$1 = 0;
class $d5b33d7c30034067$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $d5b33d7c30034067$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $d5b33d7c30034067$var$WebGLShaderStage {
    constructor(code){
        this.id = $d5b33d7c30034067$var$_id$1++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $d5b33d7c30034067$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $d5b33d7c30034067$export$89312ce47c0ca777();
    const _customShaders = new $d5b33d7c30034067$var$WebGLShaderCache();
    const programs = [];
    const IS_WEBGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getChannel(value) {
        if (value === 0) return 'uv';
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === $d5b33d7c30034067$export$dbf3e70ff37af79 ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $d5b33d7c30034067$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        const HAS_ATTRIBUTE_UV1 = !!geometry.attributes.uv1;
        const HAS_ATTRIBUTE_UV2 = !!geometry.attributes.uv2;
        const HAS_ATTRIBUTE_UV3 = !!geometry.attributes.uv3;
        let toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            isWebGL2: IS_WEBGL2,
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : $d5b33d7c30034067$export$42429b3acfb233a4,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === $d5b33d7c30034067$export$9990ad26f9db5b2c,
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === $d5b33d7c30034067$export$2852a58ebdac27b8,
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === $d5b33d7c30034067$export$5b29a26d96ee6af0,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            vertexUv1s: HAS_ATTRIBUTE_UV1,
            vertexUv2s: HAS_ATTRIBUTE_UV2,
            vertexUv3s: HAS_ATTRIBUTE_UV3,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: fog && fog.isFogExp2,
            flatShading: material.flatShading === true,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            useLegacyLights: renderer._useLegacyLights,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && material.map.colorSpace === $d5b33d7c30034067$export$561f394b24edfcaa,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $d5b33d7c30034067$export$3b296b6f144d5b03,
            flipSided: material.side === $d5b33d7c30034067$export$d9f0486e75b5ace,
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: HAS_EXTENSIONS && material.extensions.derivatives === true,
            extensionFragDepth: HAS_EXTENSIONS && material.extensions.fragDepth === true,
            extensionDrawBuffers: HAS_EXTENSIONS && material.extensions.drawBuffers === true,
            extensionShaderTextureLOD: HAS_EXTENSIONS && material.extensions.shaderTextureLOD === true,
            rendererExtensionFragDepth: IS_WEBGL2 || extensions.has('EXT_frag_depth'),
            rendererExtensionDrawBuffers: IS_WEBGL2 || extensions.has('WEBGL_draw_buffers'),
            rendererExtensionShaderTextureLod: IS_WEBGL2 || extensions.has('EXT_shader_texture_lod'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.isWebGL2) _programLayers.enable(0);
        if (parameters.supportsVertexTextures) _programLayers.enable(1);
        if (parameters.instancing) _programLayers.enable(2);
        if (parameters.instancingColor) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.skinning) _programLayers.enable(4);
        if (parameters.morphTargets) _programLayers.enable(5);
        if (parameters.morphNormals) _programLayers.enable(6);
        if (parameters.morphColors) _programLayers.enable(7);
        if (parameters.premultipliedAlpha) _programLayers.enable(8);
        if (parameters.shadowMapEnabled) _programLayers.enable(9);
        if (parameters.useLegacyLights) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        if (parameters.decodeVideoTexture) _programLayers.enable(19);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $d5b33d7c30034067$export$bee4a7d47f8f5014[shaderID];
            uniforms = $d5b33d7c30034067$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $d5b33d7c30034067$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $d5b33d7c30034067$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $d5b33d7c30034067$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $d5b33d7c30034067$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $d5b33d7c30034067$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $d5b33d7c30034067$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $d5b33d7c30034067$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $d5b33d7c30034067$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $d5b33d7c30034067$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        skyColor: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        groundColor: new $d5b33d7c30034067$export$892596cec99bc70e()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        halfWidth: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        halfHeight: new $d5b33d7c30034067$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $d5b33d7c30034067$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $d5b33d7c30034067$var$nextVersion = 0;
function $d5b33d7c30034067$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $d5b33d7c30034067$var$WebGLLights(extensions, capabilities) {
    const cache = new $d5b33d7c30034067$var$UniformsCache();
    const shadowCache = $d5b33d7c30034067$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $d5b33d7c30034067$export$64b5c384219d3699());
    const vector3 = new $d5b33d7c30034067$export$64b5c384219d3699();
    const matrix4 = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
    const matrix42 = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
    function setup(lights, useLegacyLights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($d5b33d7c30034067$var$shadowCastingAndTexturingLightsFirst);
        // artist-friendly light intensity scaling factor
        const scaleFactor = useLegacyLights === true ? Math.PI : 1;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity * scaleFactor;
                g += color.g * intensity * scaleFactor;
                b += color.b * intensity * scaleFactor;
            } else if (light.isLightProbe) for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
            else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has('OES_texture_float_linear') === true) {
                    state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_1;
                    state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_2;
                } else if (extensions.has('OES_texture_half_float_linear') === true) {
                    state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_HALF_1;
                    state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_HALF_2;
                } else console.error('THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.');
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            state.version = $d5b33d7c30034067$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $d5b33d7c30034067$var$WebGLRenderState(extensions, capabilities) {
    const lights = new $d5b33d7c30034067$var$WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights(useLegacyLights) {
        lights.setup(lightsArray, useLegacyLights);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $d5b33d7c30034067$var$WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $d5b33d7c30034067$var$WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $d5b33d7c30034067$var$WebGLRenderState(extensions, capabilities);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$2698c22ec13825db extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.type = 'MeshDepthMaterial';
        this.depthPacking = $d5b33d7c30034067$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
class $d5b33d7c30034067$export$33e187ed002f2a19 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.type = 'MeshDistanceMaterial';
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
const $d5b33d7c30034067$var$vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
const $d5b33d7c30034067$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $d5b33d7c30034067$var$WebGLShadowMap(_renderer, _objects, _capabilities) {
    let _frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
    const _shadowMapSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(), _viewportSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(), _viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(), _depthMaterial = new $d5b33d7c30034067$export$2698c22ec13825db({
        depthPacking: $d5b33d7c30034067$export$8f910f4c4f73df11
    }), _distanceMaterial = new $d5b33d7c30034067$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
    const shadowSide = {
        [$d5b33d7c30034067$export$2ede184fc2998901]: $d5b33d7c30034067$export$d9f0486e75b5ace,
        [$d5b33d7c30034067$export$d9f0486e75b5ace]: $d5b33d7c30034067$export$2ede184fc2998901,
        [$d5b33d7c30034067$export$3b296b6f144d5b03]: $d5b33d7c30034067$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $d5b33d7c30034067$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $d5b33d7c30034067$var$vertex,
        fragmentShader: $d5b33d7c30034067$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $d5b33d7c30034067$export$b7be63a67df8959();
    fullScreenTri.setAttribute('position', new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $d5b33d7c30034067$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $d5b33d7c30034067$export$5813f879eee7cd88;
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const toVSM = _previousType !== $d5b33d7c30034067$export$896ae1ade6c829c4 && this.type === $d5b33d7c30034067$export$896ae1ade6c829c4;
        const fromVSM = _previousType === $d5b33d7c30034067$export$896ae1ade6c829c4 && this.type !== $d5b33d7c30034067$export$896ae1ade6c829c4;
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                const pars = this.type !== $d5b33d7c30034067$export$896ae1ade6c829c4 ? {
                    minFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0,
                    magFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new $d5b33d7c30034067$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === $d5b33d7c30034067$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new $d5b33d7c30034067$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (_renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $d5b33d7c30034067$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = _renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $d5b33d7c30034067$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function $d5b33d7c30034067$var$WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case $d5b33d7c30034067$export$69025ce147cee220:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case $d5b33d7c30034067$export$7182eb52ea3b3f04:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case $d5b33d7c30034067$export$eedccec66ab7ebe:
                            gl.depthFunc(gl.LESS);
                            break;
                        case $d5b33d7c30034067$export$296f78a0b892f81a:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case $d5b33d7c30034067$export$a60d398fc7b7590e:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case $d5b33d7c30034067$export$7d7234c1240a1fc4:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case $d5b33d7c30034067$export$c5e2c52991f30937:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case $d5b33d7c30034067$export$2f843afa843d8916:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (isWebGL2 && (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY)) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    if (isWebGL2) {
        emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
        emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    }
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc($d5b33d7c30034067$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($d5b33d7c30034067$export$b9a7b4fc5cb15f9b);
    enable(gl.CULL_FACE);
    setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            if (isWebGL2) {
                // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
                if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
                if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            }
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            if (renderTarget.isWebGLMultipleRenderTargets) {
                const textures = renderTarget.texture;
                if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                    for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                    drawBuffers.length = textures.length;
                    needsUpdate = true;
                }
            } else if (drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                drawBuffers[0] = gl.COLOR_ATTACHMENT0;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) {
            if (capabilities.isWebGL2) gl.drawBuffers(drawBuffers);
            else extensions.get('WEBGL_draw_buffers').drawBuffersWEBGL(drawBuffers);
        }
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$d5b33d7c30034067$export$20183a0484ce21a0]: gl.FUNC_ADD,
        [$d5b33d7c30034067$export$73e0df5177988548]: gl.FUNC_SUBTRACT,
        [$d5b33d7c30034067$export$28e582859cbec660]: gl.FUNC_REVERSE_SUBTRACT
    };
    if (isWebGL2) {
        equationToGL[$d5b33d7c30034067$export$c8c1508da8d0600c] = gl.MIN;
        equationToGL[$d5b33d7c30034067$export$99948c02fb51055f] = gl.MAX;
    } else {
        const extension = extensions.get('EXT_blend_minmax');
        if (extension !== null) {
            equationToGL[$d5b33d7c30034067$export$c8c1508da8d0600c] = extension.MIN_EXT;
            equationToGL[$d5b33d7c30034067$export$99948c02fb51055f] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [$d5b33d7c30034067$export$2110f05edf778d3d]: gl.ZERO,
        [$d5b33d7c30034067$export$8805bad65e24940e]: gl.ONE,
        [$d5b33d7c30034067$export$7fbe15b28d28cf52]: gl.SRC_COLOR,
        [$d5b33d7c30034067$export$d5773124e86cf28c]: gl.SRC_ALPHA,
        [$d5b33d7c30034067$export$c05e2a1fc8609506]: gl.SRC_ALPHA_SATURATE,
        [$d5b33d7c30034067$export$ef5f2dd8ffac5574]: gl.DST_COLOR,
        [$d5b33d7c30034067$export$a78aed1ca2a87192]: gl.DST_ALPHA,
        [$d5b33d7c30034067$export$947829af9f2c17f6]: gl.ONE_MINUS_SRC_COLOR,
        [$d5b33d7c30034067$export$11d468cc7f19e971]: gl.ONE_MINUS_SRC_ALPHA,
        [$d5b33d7c30034067$export$56b85b2686ab16]: gl.ONE_MINUS_DST_COLOR,
        [$d5b33d7c30034067$export$5d0fe17fd8773bac]: gl.ONE_MINUS_DST_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === $d5b33d7c30034067$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== $d5b33d7c30034067$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $d5b33d7c30034067$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $d5b33d7c30034067$export$20183a0484ce21a0) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = $d5b33d7c30034067$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $d5b33d7c30034067$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $d5b33d7c30034067$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $d5b33d7c30034067$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case $d5b33d7c30034067$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case $d5b33d7c30034067$export$777d8f9551c2216b:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case $d5b33d7c30034067$export$4138e1c684b46a20:
                        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === $d5b33d7c30034067$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $d5b33d7c30034067$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $d5b33d7c30034067$export$3237e1f2c1ea1f44) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === $d5b33d7c30034067$export$b9a7b4fc5cb15f9b) gl.cullFace(gl.BACK);
                else if (cullFace === $d5b33d7c30034067$export$b8058bcc7037d3f3) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        if (isWebGL2 === true) {
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
            gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        }
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $d5b33d7c30034067$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    const supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : $d5b33d7c30034067$var$createElementNS('canvas');
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? $d5b33d7c30034067$var$floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                console.warn('THREE.WebGLRenderer: Texture has been resized from (' + image.width + 'x' + image.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + image.width + 'x' + image.height + ').');
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo$1(image) {
        return $d5b33d7c30034067$var$isPowerOfTwo(image.width) && $d5b33d7c30034067$var$isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== $d5b33d7c30034067$export$9d9334239a5a5e06 || texture.wrapT !== $d5b33d7c30034067$export$9d9334239a5a5e06 || texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace1, forceLinearTransfer = false) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RGBA) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa && forceLinearTransfer === false ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getMipLevels(texture, image, supportsMips) {
        if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === $d5b33d7c30034067$export$727aa5ec3fe39bf0 || f === $d5b33d7c30034067$export$d129e38cf6feaa8c || f === $d5b33d7c30034067$export$d2327c1afe5bfdf2) return _gl.NEAREST;
        return _gl.LINEAR;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglTexture !== undefined) {
            _gl.deleteTexture(textureProperties.__webglTexture);
            info.memory.textures--;
        }
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        if (renderTarget.isWebGLMultipleRenderTargets) for(let i = 0, il = texture.length; i < il; i++){
            const attachmentProperties = properties.get(texture[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(texture[i]);
        }
        properties.remove(texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn('THREE.WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [$d5b33d7c30034067$export$533346c8e8dac0f5]: _gl.REPEAT,
        [$d5b33d7c30034067$export$9d9334239a5a5e06]: _gl.CLAMP_TO_EDGE,
        [$d5b33d7c30034067$export$c7e7c00b14f51a4f]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [$d5b33d7c30034067$export$727aa5ec3fe39bf0]: _gl.NEAREST,
        [$d5b33d7c30034067$export$d129e38cf6feaa8c]: _gl.NEAREST_MIPMAP_NEAREST,
        [$d5b33d7c30034067$export$d2327c1afe5bfdf2]: _gl.NEAREST_MIPMAP_LINEAR,
        [$d5b33d7c30034067$export$8a72f490b25c56c8]: _gl.LINEAR,
        [$d5b33d7c30034067$export$19a719f377145a13]: _gl.LINEAR_MIPMAP_NEAREST,
        [$d5b33d7c30034067$export$5d8599b6a933fb1b]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [$d5b33d7c30034067$export$d9e2d19a747baaab]: _gl.NEVER,
        [$d5b33d7c30034067$export$187b73a3e352c145]: _gl.ALWAYS,
        [$d5b33d7c30034067$export$36bcf49c713b3eb7]: _gl.LESS,
        [$d5b33d7c30034067$export$64eea11eb407ddf1]: _gl.LEQUAL,
        [$d5b33d7c30034067$export$66f28d946fc6a0d5]: _gl.EQUAL,
        [$d5b33d7c30034067$export$1cdcb70d53d65f61]: _gl.GEQUAL,
        [$d5b33d7c30034067$export$155af022118f3a38]: _gl.GREATER,
        [$d5b33d7c30034067$export$67ab95dde6bed156]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
            if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, _gl.CLAMP_TO_EDGE);
            _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, _gl.CLAMP_TO_EDGE);
            if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, _gl.CLAMP_TO_EDGE);
            if (texture.wrapS !== $d5b33d7c30034067$export$9d9334239a5a5e06 || texture.wrapT !== $d5b33d7c30034067$export$9d9334239a5a5e06) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.');
            _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterFallback(texture.minFilter));
            if (texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.');
        }
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            if (texture.magFilter === $d5b33d7c30034067$export$727aa5ec3fe39bf0) return;
            if (texture.minFilter !== $d5b33d7c30034067$export$d2327c1afe5bfdf2 && texture.minFilter !== $d5b33d7c30034067$export$5d8599b6a933fb1b) return;
            if (texture.type === $d5b33d7c30034067$export$f6d331659b644596 && extensions.has('OES_texture_float_linear') === false) return; // verify extension for WebGL 1 and WebGL 2
            if (isWebGL2 === false && texture.type === $d5b33d7c30034067$export$2697304443f382bc && extensions.has('OES_texture_half_float_linear') === false) return; // verify extension for WebGL 1 only
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, _gl.NONE);
            const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
            let image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
            image = verifyColorSpace(texture, image);
            const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.colorSpace);
            let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture, supportsMips);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const levels = getMipLevels(texture, image, supportsMips);
            if (texture.isDepthTexture) {
                // populate depth texture with dummy data
                glInternalFormat = _gl.DEPTH_COMPONENT;
                if (isWebGL2) {
                    if (texture.type === $d5b33d7c30034067$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
                    else if (texture.type === $d5b33d7c30034067$export$c3c7fc4518ebba96) glInternalFormat = _gl.DEPTH_COMPONENT24;
                    else if (texture.type === $d5b33d7c30034067$export$6c8ea339bfab1301) glInternalFormat = _gl.DEPTH24_STENCIL8;
                    else glInternalFormat = _gl.DEPTH_COMPONENT16; // WebGL2 requires sized internalformat for glTexImage2D
                } else if (texture.type === $d5b33d7c30034067$export$f6d331659b644596) console.error('WebGLRenderer: Floating point depth texture requires WebGL2.');
                // validation checks for WebGL 1
                if (texture.format === $d5b33d7c30034067$export$c1b6b5136be58045 && glInternalFormat === _gl.DEPTH_COMPONENT) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                {
                    if (texture.type !== $d5b33d7c30034067$export$c63dc51868b06a9d && texture.type !== $d5b33d7c30034067$export$c3c7fc4518ebba96) {
                        console.warn('THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.');
                        texture.type = $d5b33d7c30034067$export$c3c7fc4518ebba96;
                        glType = utils.convert(texture.type);
                    }
                }
                if (texture.format === $d5b33d7c30034067$export$1e113ac2d0905829 && glInternalFormat === _gl.DEPTH_COMPONENT) {
                    // Depth stencil textures need the DEPTH_STENCIL internal format
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    glInternalFormat = _gl.DEPTH_STENCIL;
                    // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                    // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    if (texture.type !== $d5b33d7c30034067$export$6c8ea339bfab1301) {
                        console.warn('THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.');
                        texture.type = $d5b33d7c30034067$export$6c8ea339bfab1301;
                        glType = utils.convert(texture.type);
                    }
                }
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $d5b33d7c30034067$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data, 0, 0);
                                else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else if (useTexStorage) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                        else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== $d5b33d7c30034067$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, _gl.NONE);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            let levels = getMipLevels(texture, image, supportsMips);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture, supportsMips);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== $d5b33d7c30034067$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, properties.get(texture).__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = _gl.DEPTH_COMPONENT16;
            if (isMultisample || useMultisampledRTT(renderTarget)) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === $d5b33d7c30034067$export$f6d331659b644596) glInternalFormat = _gl.DEPTH_COMPONENT32F;
                    else if (depthTexture.type === $d5b33d7c30034067$export$c3c7fc4518ebba96) glInternalFormat = _gl.DEPTH_COMPONENT24;
                }
                const samples = getRenderTargetSamples(renderTarget);
                if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            const samples = getRenderTargetSamples(renderTarget);
            if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height);
            else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, _gl.DEPTH24_STENCIL8, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, _gl.DEPTH_STENCIL, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
                renderTarget.texture
            ];
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $d5b33d7c30034067$export$c1b6b5136be58045) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $d5b33d7c30034067$export$1e113ac2d0905829) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        if (renderTarget.isWebGLMultipleRenderTargets !== true) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) {
                if (capabilities.drawBuffers) {
                    const textures = renderTarget.texture;
                    for(let i = 0, il = textures.length; i < il; i++){
                        const attachmentProperties = properties.get(textures[i]);
                        if (attachmentProperties.__webglTexture === undefined) {
                            attachmentProperties.__webglTexture = _gl.createTexture();
                            info.memory.textures++;
                        }
                    }
                } else console.warn('THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.');
            }
            if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                const textures = isMultipleRenderTargets ? texture : [
                    texture
                ];
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture, supportsMips);
            for(let i = 0; i < 6; i++){
                if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            const textures = renderTarget.texture;
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, 0);
                if (textureNeedsGenerateMipmaps(attachment, supportsMips)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
                if (isWebGL2) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
                else console.error('THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.');
            }
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture, supportsMips);
            if (isWebGL2 && texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
            renderTarget.texture
        ];
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? _gl.TEXTURE_CUBE_MAP : _gl.TEXTURE_2D;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target);
                state.unbindTexture();
            }
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
            const textures = renderTarget.isWebGLMultipleRenderTargets ? renderTarget.texture : [
                renderTarget.texture
            ];
            const width = renderTarget.width;
            const height = renderTarget.height;
            let mask = _gl.COLOR_BUFFER_BIT;
            const invalidationArray = [];
            const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            const renderTargetProperties = properties.get(renderTarget);
            const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
            // If MRT we need to remove FBO attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            for(let i = 0; i < textures.length; i++){
                invalidationArray.push(_gl.COLOR_ATTACHMENT0 + i);
                if (renderTarget.depthBuffer) invalidationArray.push(depthStyle);
                const ignoreDepthValues = renderTargetProperties.__ignoreDepthValues !== undefined ? renderTargetProperties.__ignoreDepthValues : false;
                if (ignoreDepthValues === false) {
                    if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                    if (renderTarget.stencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                }
                if (isMultipleRenderTargets) _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                if (ignoreDepthValues === true) {
                    _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, [
                        depthStyle
                    ]);
                    _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                        depthStyle
                    ]);
                }
                if (isMultipleRenderTargets) {
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                }
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                if (supportsInvalidateFramebuffer) _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArray);
            }
            state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                const webglTexture = properties.get(textures[i]).__webglTexture;
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
            }
            state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return isWebGL2 && renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace1 = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true || texture.format === $d5b33d7c30034067$export$ca1dce8b5e1de74d) return image;
        if (colorSpace1 !== $d5b33d7c30034067$export$42429b3acfb233a4 && colorSpace1 !== $d5b33d7c30034067$export$bfcb490c2dd3db51) {
            // sRGB
            if (colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa || colorSpace1 === $d5b33d7c30034067$export$626af19ae879bdf6) {
                if (isWebGL2 === false) {
                    // in WebGL 1, try to use EXT_sRGB extension and unsized formats
                    if (extensions.has('EXT_sRGB') === true && format === $d5b33d7c30034067$export$3f8bb04b555a363c) {
                        texture.format = $d5b33d7c30034067$export$ca1dce8b5e1de74d;
                        // it's not possible to generate mips in WebGL 1 with this extension
                        texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
                        texture.generateMipmaps = false;
                    } else // slow fallback (CPU decode)
                    image = $d5b33d7c30034067$export$698882cf06df44aa.sRGBToLinear(image);
                } else // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
                if (format !== $d5b33d7c30034067$export$3f8bb04b555a363c || type !== $d5b33d7c30034067$export$2e8ce08d3f6f5e10) console.warn('THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else console.error('THREE.WebGLTextures: Unsupported texture color space:', colorSpace1);
        }
        return image;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
const $d5b33d7c30034067$var$LinearTransferFunction = 0;
const $d5b33d7c30034067$var$SRGBTransferFunction = 1;
function $d5b33d7c30034067$export$ddaebcad857649a8(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p, colorSpace1 = $d5b33d7c30034067$export$bfcb490c2dd3db51) {
        let extension;
        const transferFunction = colorSpace1 === $d5b33d7c30034067$export$561f394b24edfcaa || colorSpace1 === $d5b33d7c30034067$export$626af19ae879bdf6 ? $d5b33d7c30034067$var$SRGBTransferFunction : $d5b33d7c30034067$var$LinearTransferFunction;
        if (p === $d5b33d7c30034067$export$2e8ce08d3f6f5e10) return gl.UNSIGNED_BYTE;
        if (p === $d5b33d7c30034067$export$b3969b01faf587f2) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === $d5b33d7c30034067$export$18886f8ae33e90de) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === $d5b33d7c30034067$export$545fce0311a9796a) return gl.BYTE;
        if (p === $d5b33d7c30034067$export$88572337f312435f) return gl.SHORT;
        if (p === $d5b33d7c30034067$export$c63dc51868b06a9d) return gl.UNSIGNED_SHORT;
        if (p === $d5b33d7c30034067$export$5c612977753abe2) return gl.INT;
        if (p === $d5b33d7c30034067$export$c3c7fc4518ebba96) return gl.UNSIGNED_INT;
        if (p === $d5b33d7c30034067$export$f6d331659b644596) return gl.FLOAT;
        if (p === $d5b33d7c30034067$export$2697304443f382bc) {
            if (isWebGL2) return gl.HALF_FLOAT;
            extension = extensions.get('OES_texture_half_float');
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === $d5b33d7c30034067$export$988473390501ed4b) return gl.ALPHA;
        if (p === $d5b33d7c30034067$export$3f8bb04b555a363c) return gl.RGBA;
        if (p === $d5b33d7c30034067$export$cc09ccbf6d1ed449) return gl.LUMINANCE;
        if (p === $d5b33d7c30034067$export$9053a81c4a69c289) return gl.LUMINANCE_ALPHA;
        if (p === $d5b33d7c30034067$export$c1b6b5136be58045) return gl.DEPTH_COMPONENT;
        if (p === $d5b33d7c30034067$export$1e113ac2d0905829) return gl.DEPTH_STENCIL;
        // WebGL 1 sRGB fallback
        if (p === $d5b33d7c30034067$export$ca1dce8b5e1de74d) {
            extension = extensions.get('EXT_sRGB');
            if (extension !== null) return extension.SRGB_ALPHA_EXT;
            else return null;
        }
        // WebGL2 formats.
        if (p === $d5b33d7c30034067$export$4e041a7967d15c4b) return gl.RED;
        if (p === $d5b33d7c30034067$export$aa92e870a709d190) return gl.RED_INTEGER;
        if (p === $d5b33d7c30034067$export$6cdf0b461c7ce8a0) return gl.RG;
        if (p === $d5b33d7c30034067$export$1ba1c45f9f77d4d7) return gl.RG_INTEGER;
        if (p === $d5b33d7c30034067$export$c200e7d26f592f21) return gl.RGBA_INTEGER;
        // S3TC
        if (p === $d5b33d7c30034067$export$21d1799c6d552fc0 || p === $d5b33d7c30034067$export$afa304c3e981b668 || p === $d5b33d7c30034067$export$d2a1a68024a3e56c || p === $d5b33d7c30034067$export$9a79c424327dacf9) {
            if (transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === $d5b33d7c30034067$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $d5b33d7c30034067$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === $d5b33d7c30034067$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $d5b33d7c30034067$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $d5b33d7c30034067$export$19ada9bbb1af3573 || p === $d5b33d7c30034067$export$d0f0355bb3d948e4 || p === $d5b33d7c30034067$export$b82296714358084c || p === $d5b33d7c30034067$export$b71692456c47b6c3) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC1
        if (p === $d5b33d7c30034067$export$6ab91af2d757aee7) {
            extension = extensions.get('WEBGL_compressed_texture_etc1');
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        // ETC2
        if (p === $d5b33d7c30034067$export$7800993ef8106a6a || p === $d5b33d7c30034067$export$23ed8300a860e7d8) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$7800993ef8106a6a) return transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $d5b33d7c30034067$export$23ed8300a860e7d8) return transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $d5b33d7c30034067$export$dc5570b4a2b92d48 || p === $d5b33d7c30034067$export$68880cd325f8b2fb || p === $d5b33d7c30034067$export$7d2c0be323373d95 || p === $d5b33d7c30034067$export$22b52da301fc3a3e || p === $d5b33d7c30034067$export$c009e2cb4a66485e || p === $d5b33d7c30034067$export$118fff5afa255b63 || p === $d5b33d7c30034067$export$120713c829ae0667 || p === $d5b33d7c30034067$export$c79eeabbf53313e9 || p === $d5b33d7c30034067$export$443cf6567cdd6424 || p === $d5b33d7c30034067$export$6573984fc9840780 || p === $d5b33d7c30034067$export$e7aee563f30091de || p === $d5b33d7c30034067$export$2eb8634622ddeab7 || p === $d5b33d7c30034067$export$202b1ce7b5d25742 || p === $d5b33d7c30034067$export$18ab77abd087e467) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$dc5570b4a2b92d48) return transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $d5b33d7c30034067$export$68880cd325f8b2fb) return transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $d5b33d7c30034067$export$7d2c0be323373d95) return transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $d5b33d7c30034067$export$22b52da301fc3a3e) return transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $d5b33d7c30034067$export$c009e2cb4a66485e) return transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $d5b33d7c30034067$export$118fff5afa255b63) return transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $d5b33d7c30034067$export$120713c829ae0667) return transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $d5b33d7c30034067$export$c79eeabbf53313e9) return transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $d5b33d7c30034067$export$443cf6567cdd6424) return transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $d5b33d7c30034067$export$6573984fc9840780) return transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $d5b33d7c30034067$export$e7aee563f30091de) return transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $d5b33d7c30034067$export$2eb8634622ddeab7) return transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $d5b33d7c30034067$export$202b1ce7b5d25742) return transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $d5b33d7c30034067$export$18ab77abd087e467) return transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $d5b33d7c30034067$export$ce40b115e188bc81 || p === $d5b33d7c30034067$export$d279c5c4bac5121e || p === $d5b33d7c30034067$export$cde52d17225fdbd3) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$ce40b115e188bc81) return transferFunction === $d5b33d7c30034067$var$SRGBTransferFunction ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === $d5b33d7c30034067$export$d279c5c4bac5121e) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === $d5b33d7c30034067$export$cde52d17225fdbd3) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === $d5b33d7c30034067$export$b1688df4c4c21670 || p === $d5b33d7c30034067$export$fc15e5d8261eed58 || p === $d5b33d7c30034067$export$d220f6ade8463a0f || p === $d5b33d7c30034067$export$768646d09dc1b6ef) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$ce40b115e188bc81) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === $d5b33d7c30034067$export$fc15e5d8261eed58) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === $d5b33d7c30034067$export$d220f6ade8463a0f) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === $d5b33d7c30034067$export$768646d09dc1b6ef) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === $d5b33d7c30034067$export$6c8ea339bfab1301) {
            if (isWebGL2) return gl.UNSIGNED_INT_24_8;
            extension = extensions.get('WEBGL_depth_texture');
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
class $d5b33d7c30034067$export$56b937d9e5581166 extends $d5b33d7c30034067$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.isArrayCamera = true;
        this.cameras = array;
    }
}
class $d5b33d7c30034067$export$eb2fcfdbd7ba97d4 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isGroup = true;
        this.type = 'Group';
    }
}
const $d5b33d7c30034067$var$_moveEvent = {
    type: 'move'
};
class $d5b33d7c30034067$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: 'connected',
            data: inputSource
        });
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($d5b33d7c30034067$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    // private method
    _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
class $d5b33d7c30034067$export$fc830aa069cc8c2f extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format){
        format = format !== undefined ? format : $d5b33d7c30034067$export$c1b6b5136be58045;
        if (format !== $d5b33d7c30034067$export$c1b6b5136be58045 && format !== $d5b33d7c30034067$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        if (type === undefined && format === $d5b33d7c30034067$export$c1b6b5136be58045) type = $d5b33d7c30034067$export$c3c7fc4518ebba96;
        if (type === undefined && format === $d5b33d7c30034067$export$1e113ac2d0905829) type = $d5b33d7c30034067$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
        this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
class $d5b33d7c30034067$var$WebXRManager extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = 'local-floor';
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        //
        const cameraL = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const cameraR = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new $d5b33d7c30034067$export$56b937d9e5581166();
        cameraXR.layers.enable(1);
        cameraXR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                if (session.renderState.layers === undefined || renderer.capabilities.isWebGL2 === false) {
                    const layerInit = {
                        antialias: session.renderState.layers === undefined ? attributes.antialias : true,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    newRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $d5b33d7c30034067$export$3f8bb04b555a363c,
                        type: $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? $d5b33d7c30034067$export$1e113ac2d0905829 : $d5b33d7c30034067$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $d5b33d7c30034067$export$6c8ea339bfab1301 : $d5b33d7c30034067$export$c3c7fc4518ebba96;
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    newRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $d5b33d7c30034067$export$3f8bb04b555a363c,
                        type: $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
                        depthTexture: new $d5b33d7c30034067$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0
                    });
                    const renderTargetProperties = renderer.properties.get(newRenderTarget);
                    renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: 'sessionstart'
                });
            }
        };
        this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new $d5b33d7c30034067$export$64b5c384219d3699();
        const cameraRPos = new $d5b33d7c30034067$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
            camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            cameraXR.near = cameraR.near = cameraL.near = camera.near;
            cameraXR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = $d5b33d7c30034067$var$RAD2DEG * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        this.getCamera = function() {
            return cameraXR;
        };
        this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new $d5b33d7c30034067$export$74e4ae24825f68d7();
                        camera.layers.enable(i);
                        camera.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: 'planesdetected',
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $d5b33d7c30034067$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
function $d5b33d7c30034067$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, $d5b33d7c30034067$var$getUnlitUniformColorSpace(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            // artist-friendly light intensity scaling factor
            const scaleFactor = renderer._useLegacyLights === true ? Math.PI : 1;
            uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $d5b33d7c30034067$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = capabilities.isWebGL2 ? gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS) : 0; // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error('THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniform = uniforms[i];
            // partly update the buffer if necessary
            if (hasUniformChanged(uniform, i, cache) === true) {
                const offset = uniform.__offset;
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                let arrayOffset = 0;
                for(let i = 0; i < values.length; i++){
                    const value = values[i];
                    const info = getUniformSize(value);
                    if (typeof value === 'number') {
                        uniform.__data[0] = value;
                        gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                    } else if (value.isMatrix3) {
                        // manually converting 3x3 to 3x4
                        uniform.__data[0] = value.elements[0];
                        uniform.__data[1] = value.elements[1];
                        uniform.__data[2] = value.elements[2];
                        uniform.__data[3] = value.elements[0];
                        uniform.__data[4] = value.elements[3];
                        uniform.__data[5] = value.elements[4];
                        uniform.__data[6] = value.elements[5];
                        uniform.__data[7] = value.elements[0];
                        uniform.__data[8] = value.elements[6];
                        uniform.__data[9] = value.elements[7];
                        uniform.__data[10] = value.elements[8];
                        uniform.__data[11] = value.elements[0];
                    } else {
                        value.toArray(uniform.__data, arrayOffset);
                        arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                    }
                }
                gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, cache) {
        const value = uniform.value;
        if (cache[index] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number') cache[index] = value;
            else {
                const values = Array.isArray(value) ? value : [
                    value
                ];
                const tempValues = [];
                for(let i = 0; i < values.length; i++)tempValues.push(values[i].clone());
                cache[index] = tempValues;
            }
            return true;
        } else {
            // compare current value with cached entry
            if (typeof value === 'number') {
                if (cache[index] !== value) {
                    cache[index] = value;
                    return true;
                }
            } else {
                const cachedObjects = Array.isArray(cache[index]) ? cache[index] : [
                    cache[index]
                ];
                const values = Array.isArray(value) ? value : [
                    value
                ];
                for(let i = 0; i < cachedObjects.length; i++){
                    const cachedObject = cachedObjects[i];
                    if (cachedObject.equals(values[i]) === false) {
                        cachedObject.copy(values[i]);
                        return true;
                    }
                }
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        let chunkOffset = 0; // offset within a single chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniform = uniforms[i];
            const infos = {
                boundary: 0,
                storage: 0 // bytes
            };
            const values = Array.isArray(uniform.value) ? uniform.value : [
                uniform.value
            ];
            for(let j = 0, jl = values.length; j < jl; j++){
                const value = values[j];
                const info = getUniformSize(value);
                infos.boundary += info.boundary;
                infos.storage += info.storage;
            }
            // the following two properties will be used for partial buffer updates
            uniform.__data = new Float32Array(infos.storage / Float32Array.BYTES_PER_ELEMENT);
            uniform.__offset = offset;
            //
            if (i > 0) {
                chunkOffset = offset % chunkSize;
                const remainingSizeInChunk = chunkSize - chunkOffset;
                // check for chunk overflow
                if (chunkOffset !== 0 && remainingSizeInChunk - infos.boundary < 0) {
                    // add padding and adjust offset
                    offset += chunkSize - chunkOffset;
                    uniform.__offset = offset;
                }
            }
            offset += infos.storage;
        }
        // ensure correct final padding
        chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number') {
            // float/int
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn('THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else console.warn('THREE.WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$f6cc00ef28d7cf97 {
    constructor(parameters = {}){
        const { canvas: canvas = $d5b33d7c30034067$export$1033a2df66368859(), context: context = null, depth: depth = true, stencil: stencil = true, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = 'default', failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false } = parameters;
        this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) _alpha = context.getContextAttributes().alpha;
        else _alpha = alpha;
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        this.domElement = canvas;
        // Debug configuration container
        this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        // scene graph
        this.sortObjects = true;
        // user-defined clipping
        this.clippingPlanes = [];
        this.localClippingEnabled = false;
        // physically based shading
        this.outputColorSpace = $d5b33d7c30034067$export$561f394b24edfcaa;
        // physical lights
        this._useLegacyLights = false;
        // tone mapping
        this.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        this.toneMappingExposure = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const _currentScissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        let _currentScissorTest = null;
        const _currentClearColor = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, _width, _height);
        const _scissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // transmission
        let _transmissionRenderTarget = null;
        // camera matrices cache
        const _projScreenMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        const _vector2 = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        const _vector3 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextNames, contextAttributes) {
            for(let i = 0; i < contextNames.length; i++){
                const contextName = contextNames[i];
                const context = canvas.getContext(contextName, contextAttributes);
                if (context !== null) return context;
            }
            return null;
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvas) canvas.setAttribute('data-engine', `three.js r${$d5b33d7c30034067$export$3545e07a80636437}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener('webglcontextlost', onContextLost, false);
            canvas.addEventListener('webglcontextrestored', onContextRestore, false);
            canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
            if (_gl === null) {
                const contextNames = [
                    'webgl2',
                    'webgl',
                    'experimental-webgl'
                ];
                if (_this.isWebGL1Renderer === true) contextNames.shift();
                _gl = getContext(contextNames, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextNames)) throw new Error('Error creating WebGL context with your selected attributes.');
                    else throw new Error('Error creating WebGL context.');
                }
            }
            if (typeof WebGLRenderingContext !== 'undefined' && _gl instanceof WebGLRenderingContext) console.warn('THREE.WebGLRenderer: WebGL 1 support was deprecated in r153 and will be removed in r163.');
            // Some experimental-webgl implementations do not have getShaderPrecisionFormat
            if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
                return {
                    'rangeMin': 1,
                    'rangeMax': 1,
                    'precision': 1
                };
            };
        } catch (error) {
            console.error('THREE.WebGLRenderer: ' + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $d5b33d7c30034067$var$WebGLExtensions(_gl);
            capabilities = new $d5b33d7c30034067$var$WebGLCapabilities(_gl, extensions, parameters);
            extensions.init(capabilities);
            utils = new $d5b33d7c30034067$export$ddaebcad857649a8(_gl, extensions, capabilities);
            state = new $d5b33d7c30034067$var$WebGLState(_gl, extensions, capabilities);
            info = new $d5b33d7c30034067$var$WebGLInfo(_gl);
            properties = new $d5b33d7c30034067$var$WebGLProperties();
            textures = new $d5b33d7c30034067$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $d5b33d7c30034067$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $d5b33d7c30034067$var$WebGLCubeUVMaps(_this);
            attributes = new $d5b33d7c30034067$var$WebGLAttributes(_gl, capabilities);
            bindingStates = new $d5b33d7c30034067$var$WebGLBindingStates(_gl, extensions, attributes, capabilities);
            geometries = new $d5b33d7c30034067$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $d5b33d7c30034067$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $d5b33d7c30034067$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $d5b33d7c30034067$var$WebGLClipping(properties);
            programCache = new $d5b33d7c30034067$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $d5b33d7c30034067$var$WebGLMaterials(_this, properties);
            renderLists = new $d5b33d7c30034067$var$WebGLRenderLists();
            renderStates = new $d5b33d7c30034067$var$WebGLRenderStates(extensions, capabilities);
            background = new $d5b33d7c30034067$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $d5b33d7c30034067$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $d5b33d7c30034067$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $d5b33d7c30034067$var$WebGLBufferRenderer(_gl, extensions, info, capabilities);
            indexedBufferRenderer = new $d5b33d7c30034067$var$WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
            info.programs = programCache.programs;
            _this.capabilities = capabilities;
            _this.extensions = extensions;
            _this.properties = properties;
            _this.renderLists = renderLists;
            _this.shadowMap = shadowMap;
            _this.state = state;
            _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $d5b33d7c30034067$var$WebXRManager(_this, _gl);
        this.xr = xr;
        // API
        this.getContext = function() {
            return _gl;
        };
        this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        this.forceContextLoss = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.loseContext();
        };
        this.forceContextRestore = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.restoreContext();
        };
        this.getPixelRatio = function() {
            return _pixelRatio;
        };
        this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        this.getSize = function(target) {
            return target.set(_width, _height);
        };
        this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
            }
            this.setViewport(0, 0, width, height);
        };
        this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
        };
        this.getScissorTest = function() {
            return _scissorTest;
        };
        this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        this.setClearColor = function() {
            background.setClearColor.apply(background, arguments);
        };
        this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        this.setClearAlpha = function() {
            background.setClearAlpha.apply(background, arguments);
        };
        this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = targetFormat === $d5b33d7c30034067$export$c200e7d26f592f21 || targetFormat === $d5b33d7c30034067$export$1ba1c45f9f77d4d7 || targetFormat === $d5b33d7c30034067$export$aa92e870a709d190;
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = targetType === $d5b33d7c30034067$export$2e8ce08d3f6f5e10 || targetType === $d5b33d7c30034067$export$c3c7fc4518ebba96 || targetType === $d5b33d7c30034067$export$c63dc51868b06a9d || targetType === $d5b33d7c30034067$export$6c8ea339bfab1301 || targetType === $d5b33d7c30034067$export$b3969b01faf587f2 || targetType === $d5b33d7c30034067$export$18886f8ae33e90de;
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) bits |= _gl.STENCIL_BUFFER_BIT;
            _gl.clear(bits);
        };
        this.clearColor = function() {
            this.clear(true, false, false);
        };
        this.clearDepth = function() {
            this.clear(false, true, false);
        };
        this.clearStencil = function() {
            this.clear(false, false, true);
        };
        //
        this.dispose = function() {
            canvas.removeEventListener('webglcontextlost', onContextLost, false);
            canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
            canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener('sessionstart', onXRSessionStart);
            xr.removeEventListener('sessionend', onXRSessionEnd);
            if (_transmissionRenderTarget) {
                _transmissionRenderTarget.dispose();
                _transmissionRenderTarget = null;
            }
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log('THREE.WebGLRenderer: Context Lost.');
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log('THREE.WebGLRenderer: Context Restored.');
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error('THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener('dispose', onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        this.compile = function(scene, camera) {
            function prepare(material, scene, object) {
                if (material.transparent === true && material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                    material.side = $d5b33d7c30034067$export$d9f0486e75b5ace;
                    material.needsUpdate = true;
                    getProgram(material, scene, object);
                    material.side = $d5b33d7c30034067$export$2ede184fc2998901;
                    material.needsUpdate = true;
                    getProgram(material, scene, object);
                    material.side = $d5b33d7c30034067$export$3b296b6f144d5b03;
                } else getProgram(material, scene, object);
            }
            currentRenderState = renderStates.get(scene);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights(_this._useLegacyLights);
            scene.traverse(function(object) {
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepare(material2, scene, object);
                    }
                    else prepare(material, scene, object);
                }
            });
            renderStateStack.pop();
            currentRenderState = null;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $d5b33d7c30034067$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== 'undefined') animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener('sessionstart', onXRSessionStart);
        xr.addEventListener('sessionend', onXRSessionEnd);
        // Rendering
        this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init();
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            //
            background.render(currentRenderList, scene);
            // render scene
            currentRenderState.setupLights(_this._useLegacyLights);
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else renderScene(currentRenderList, scene, camera);
            //
            if (_currentRenderTarget !== null) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
            else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector3.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector3.copy(geometry.boundingSphere.center);
                            }
                            _vector3.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            const transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const isWebGL2 = capabilities.isWebGL2;
            if (_transmissionRenderTarget === null) _transmissionRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(1, 1, {
                generateMipmaps: true,
                type: extensions.has('EXT_color_buffer_half_float') ? $d5b33d7c30034067$export$2697304443f382bc : $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
                minFilter: $d5b33d7c30034067$export$5d8599b6a933fb1b,
                samples: isWebGL2 ? 4 : 0
            });
            _this.getDrawingBufferSize(_vector2);
            if (isWebGL2) _transmissionRenderTarget.setSize(_vector2.x, _vector2.y);
            else _transmissionRenderTarget.setSize($d5b33d7c30034067$var$floorPowerOfTwo(_vector2.x), $d5b33d7c30034067$var$floorPowerOfTwo(_vector2.y));
            //
            const currentRenderTarget = _this.getRenderTarget();
            _this.setRenderTarget(_transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
            textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            let renderTargetNeedsUpdate = false;
            for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                const renderItem = transmissiveObjects[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = renderItem.material;
                const group = renderItem.group;
                if (material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 && object.layers.test(camera.layers)) {
                    const currentSide = material.side;
                    material.side = $d5b33d7c30034067$export$d9f0486e75b5ace;
                    material.needsUpdate = true;
                    renderObject(object, scene, camera, geometry, material, group);
                    material.side = currentSide;
                    material.needsUpdate = true;
                    renderTargetNeedsUpdate = true;
                }
            }
            if (renderTargetNeedsUpdate === true) {
                textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
                textures.updateRenderTargetMipmap(_transmissionRenderTarget);
            }
            _this.setRenderTarget(currentRenderTarget);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
                const group = renderItem.group;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 && material.forceSinglePass === false) {
                material.side = $d5b33d7c30034067$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $d5b33d7c30034067$export$2ede184fc2998901;
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = $d5b33d7c30034067$export$3b296b6f144d5b03;
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            if (programs === undefined) {
                // new material
                material.addEventListener('dispose', onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBuild(object, parameters, _this);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            const progUniforms = program.getUniforms();
            const uniformsList = $d5b33d7c30034067$var$WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = uniformsList;
            return program;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace1 = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : $d5b33d7c30034067$export$42429b3acfb233a4;
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace1) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
                p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, 'bindMatrix');
                p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (capabilities.floatVertexTextures) {
                        if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                        p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                        p_uniforms.setValue(_gl, 'boneTextureSize', skeleton.boneTextureSize);
                    } else console.warn('THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required.');
                }
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined && capabilities.isWebGL2 === true) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
                $d5b33d7c30034067$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $d5b33d7c30034067$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
            // common matrices
            p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
            p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
            p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++)if (capabilities.isWebGL2) {
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                } else console.warn('THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.');
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__hasExternalTextures = true;
            if (renderTargetProperties.__hasExternalTextures) {
                renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
                if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
                // are midframe flushes and an external depth buffer. Disable use of the extension.
                {
                    if (extensions.has('WEBGL_multisampled_render_to_texture') === true) {
                        console.warn('THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided');
                        renderTargetProperties.__useRenderToTexture = false;
                    }
                }
            }
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (capabilities.isWebGL2 && renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const textureProperties = properties.get(renderTarget.texture);
                const layer = activeCubeFace || 0;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (textureFormat !== $d5b33d7c30034067$export$3f8bb04b555a363c && utils.convert(textureFormat) !== _gl.getParameter(_gl.IMPLEMENTATION_COLOR_READ_FORMAT)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                        return;
                    }
                    const halfFloatSupportedByExt = textureType === $d5b33d7c30034067$export$2697304443f382bc && (extensions.has('EXT_color_buffer_half_float') || capabilities.isWebGL2 && extensions.has('EXT_color_buffer_float'));
                    if (textureType !== $d5b33d7c30034067$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== _gl.getParameter(_gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
                    !(textureType === $d5b33d7c30034067$export$f6d331659b644596 && (capabilities.isWebGL2 || extensions.has('OES_texture_float') || extensions.has('WEBGL_color_buffer_float'))) && // Chrome Mac >= 52 and Firefox
                    !halfFloatSupportedByExt) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        this.copyFramebufferToTexture = function(position, texture, level = 0) {
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, position.x, position.y, width, height);
            state.unbindTexture();
        };
        this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
            const width = srcTexture.image.width;
            const height = srcTexture.image.height;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            textures.setTexture2D(dstTexture, 0);
            // As another texture upload may have changed pixelStorei
            // parameters, make sure they are correct for the dstTexture
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
            else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
            else _gl.texSubImage2D(_gl.TEXTURE_2D, level, position.x, position.y, glFormat, glType, srcTexture.image);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(_gl.TEXTURE_2D);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
            if (_this.isWebGL1Renderer) {
                console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.');
                return;
            }
            const width = sourceBox.max.x - sourceBox.min.x + 1;
            const height = sourceBox.max.y - sourceBox.min.y + 1;
            const depth = sourceBox.max.z - sourceBox.min.z + 1;
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.');
                return;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            const unpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const unpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const unpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const unpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const unpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, sourceBox.min.x);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, sourceBox.min.y);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, sourceBox.min.z);
            if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
            else if (srcTexture.isCompressedArrayTexture) {
                console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.');
                _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
            } else _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, unpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, unpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, unpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, unpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, unpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    get coordinateSystem() {
        return $d5b33d7c30034067$export$5a0e9190d10875d3;
    }
    get physicallyCorrectLights() {
        console.warn('THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.');
        return !this.useLegacyLights;
    }
    set physicallyCorrectLights(value) {
        console.warn('THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.');
        this.useLegacyLights = !value;
    }
    get outputEncoding() {
        console.warn('THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead.');
        return this.outputColorSpace === $d5b33d7c30034067$export$561f394b24edfcaa ? $d5b33d7c30034067$export$f32388edbb32674 : $d5b33d7c30034067$export$7207336e4151a112;
    }
    set outputEncoding(encoding) {
        console.warn('THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead.');
        this.outputColorSpace = encoding === $d5b33d7c30034067$export$f32388edbb32674 ? $d5b33d7c30034067$export$561f394b24edfcaa : $d5b33d7c30034067$export$42429b3acfb233a4;
    }
    get useLegacyLights() {
        console.warn('THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733.');
        return this._useLegacyLights;
    }
    set useLegacyLights(value) {
        console.warn('THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733.');
        this._useLegacyLights = value;
    }
}
class $d5b33d7c30034067$export$a2f65229194348f9 extends $d5b33d7c30034067$export$f6cc00ef28d7cf97 {
}
$d5b33d7c30034067$export$a2f65229194348f9.prototype.isWebGL1Renderer = true;
class $d5b33d7c30034067$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.isFogExp2 = true;
        this.name = '';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $d5b33d7c30034067$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: 'FogExp2',
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $d5b33d7c30034067$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.isFog = true;
        this.name = '';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $d5b33d7c30034067$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: 'Fog',
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $d5b33d7c30034067$export$38af1803e3442a7f extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isScene = true;
        this.type = 'Scene';
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.backgroundBlurriness = 0;
        this.backgroundIntensity = 1;
        this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        return data;
    }
}
class $d5b33d7c30034067$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $d5b33d7c30034067$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $d5b33d7c30034067$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $d5b33d7c30034067$var$_vector$5 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = '';
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$5.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$5.applyMatrix4(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$5.x, $d5b33d7c30034067$var$_vector$5.y, $d5b33d7c30034067$var$_vector$5.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$5.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$5.applyNormalMatrix(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$5.x, $d5b33d7c30034067$var$_vector$5.y, $d5b33d7c30034067$var$_vector$5.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$5.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$5.transformDirection(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$5.x, $d5b33d7c30034067$var$_vector$5.y, $d5b33d7c30034067$var$_vector$5.z);
        }
        return this;
    }
    setX(index, x) {
        if (this.normalized) x = $d5b33d7c30034067$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        if (this.normalized) y = $d5b33d7c30034067$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        if (this.normalized) z = $d5b33d7c30034067$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        if (this.normalized) w = $d5b33d7c30034067$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $d5b33d7c30034067$var$denormalize(x, this.array);
        return x;
    }
    getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $d5b33d7c30034067$var$denormalize(y, this.array);
        return y;
    }
    getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $d5b33d7c30034067$var$denormalize(z, this.array);
        return z;
    }
    getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $d5b33d7c30034067$var$denormalize(w, this.array);
        return w;
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $d5b33d7c30034067$var$normalize(x, this.array);
            y = $d5b33d7c30034067$var$normalize(y, this.array);
            z = $d5b33d7c30034067$var$normalize(z, this.array);
            w = $d5b33d7c30034067$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $d5b33d7c30034067$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $d5b33d7c30034067$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
class $d5b33d7c30034067$export$5ec7dd1c6994bf8e extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.type = 'SpriteMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $d5b33d7c30034067$var$_geometry;
const $d5b33d7c30034067$var$_intersectPoint = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_worldScale = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_mvPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_alignedPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_rotatedPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_viewWorldMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_vA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vB = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vC = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_uvA = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvB = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvC = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$3075603db8e6204c extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(material){
        super();
        this.isSprite = true;
        this.type = 'Sprite';
        if ($d5b33d7c30034067$var$_geometry === undefined) {
            $d5b33d7c30034067$var$_geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $d5b33d7c30034067$export$3d5cd879f108f53f(float32Array, 5);
            $d5b33d7c30034067$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $d5b33d7c30034067$var$_geometry.setAttribute('position', new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $d5b33d7c30034067$var$_geometry.setAttribute('uv', new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $d5b33d7c30034067$var$_geometry;
        this.material = material !== undefined ? material : new $d5b33d7c30034067$export$5ec7dd1c6994bf8e();
        this.center = new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $d5b33d7c30034067$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $d5b33d7c30034067$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $d5b33d7c30034067$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $d5b33d7c30034067$var$_worldScale.multiplyScalar(-$d5b33d7c30034067$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vA.set(-0.5, -0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vB.set(0.5, -0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vC.set(0.5, 0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$_uvA.set(0, 0);
        $d5b33d7c30034067$var$_uvB.set(1, 0);
        $d5b33d7c30034067$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vB, $d5b33d7c30034067$var$_vC, false, $d5b33d7c30034067$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vB.set(-0.5, 0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
            $d5b33d7c30034067$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vC, $d5b33d7c30034067$var$_vB, false, $d5b33d7c30034067$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $d5b33d7c30034067$var$_intersectPoint.clone(),
            uv: $d5b33d7c30034067$export$5a465592bfe74b48.getInterpolation($d5b33d7c30034067$var$_intersectPoint, $d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vB, $d5b33d7c30034067$var$_vC, $d5b33d7c30034067$var$_uvA, $d5b33d7c30034067$var$_uvB, $d5b33d7c30034067$var$_uvC, new $d5b33d7c30034067$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $d5b33d7c30034067$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $d5b33d7c30034067$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $d5b33d7c30034067$var$_rotatedPosition.x = cos * $d5b33d7c30034067$var$_alignedPosition.x - sin * $d5b33d7c30034067$var$_alignedPosition.y;
        $d5b33d7c30034067$var$_rotatedPosition.y = sin * $d5b33d7c30034067$var$_alignedPosition.x + cos * $d5b33d7c30034067$var$_alignedPosition.y;
    } else $d5b33d7c30034067$var$_rotatedPosition.copy($d5b33d7c30034067$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $d5b33d7c30034067$var$_rotatedPosition.x;
    vertexPosition.y += $d5b33d7c30034067$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($d5b33d7c30034067$var$_viewWorldMatrix);
}
const $d5b33d7c30034067$var$_v1$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$112e7237be0c5f30 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = 'LOD';
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $d5b33d7c30034067$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $d5b33d7c30034067$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $d5b33d7c30034067$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $d5b33d7c30034067$var$_v1$2.distanceTo($d5b33d7c30034067$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $d5b33d7c30034067$var$_basePosition = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_skinIndex = /*@__PURE__*/ new $d5b33d7c30034067$export$fa7daccca11cdbe3();
const $d5b33d7c30034067$var$_skinWeight = /*@__PURE__*/ new $d5b33d7c30034067$export$fa7daccca11cdbe3();
const $d5b33d7c30034067$var$_vector3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_matrix4 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_vertex = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_sphere$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_inverseMatrix$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
class $d5b33d7c30034067$export$b303577035157ecf extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.isSkinnedMesh = true;
        this.type = 'SkinnedMesh';
        this.bindMode = 'attached';
        this.bindMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.boundingBox = null;
        this.boundingSphere = null;
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            $d5b33d7c30034067$var$_vertex.fromBufferAttribute(positionAttribute, i);
            this.applyBoneTransform(i, $d5b33d7c30034067$var$_vertex);
            this.boundingBox.expandByPoint($d5b33d7c30034067$var$_vertex);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            $d5b33d7c30034067$var$_vertex.fromBufferAttribute(positionAttribute, i);
            this.applyBoneTransform(i, $d5b33d7c30034067$var$_vertex);
            this.boundingSphere.expandByPoint($d5b33d7c30034067$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$3.copy(this.boundingSphere);
        $d5b33d7c30034067$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere$3) === false) return;
        // convert ray to local space of skinned mesh
        $d5b33d7c30034067$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray$2.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($d5b33d7c30034067$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $d5b33d7c30034067$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === 'attached') this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === 'detached') this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    }
    applyBoneTransform(index, vector) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $d5b33d7c30034067$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $d5b33d7c30034067$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $d5b33d7c30034067$var$_basePosition.copy(vector).applyMatrix4(this.bindMatrix);
        vector.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $d5b33d7c30034067$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $d5b33d7c30034067$var$_skinIndex.getComponent(i);
                $d5b33d7c30034067$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                vector.addScaledVector($d5b33d7c30034067$var$_vector3.copy($d5b33d7c30034067$var$_basePosition).applyMatrix4($d5b33d7c30034067$var$_matrix4), weight);
            }
        }
        return vector.applyMatrix4(this.bindMatrixInverse);
    }
    boneTransform(index, vector) {
        console.warn('THREE.SkinnedMesh: .boneTransform() was renamed to .applyBoneTransform() in r151.');
        return this.applyBoneTransform(index, vector);
    }
}
class $d5b33d7c30034067$export$b127726e56765aa4 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isBone = true;
        this.type = 'Bone';
    }
}
class $d5b33d7c30034067$export$b691f601014eabe1 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0, minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $d5b33d7c30034067$var$_offsetMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_identityMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.boneTextureSize = 0;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $d5b33d7c30034067$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $d5b33d7c30034067$var$_identityMatrix;
            $d5b33d7c30034067$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $d5b33d7c30034067$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $d5b33d7c30034067$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = $d5b33d7c30034067$var$ceilPowerOfTwo(size);
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $d5b33d7c30034067$export$b691f601014eabe1(boneMatrices, size, size, $d5b33d7c30034067$export$3f8bb04b555a363c, $d5b33d7c30034067$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        this.boneTextureSize = size;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                bone = new $d5b33d7c30034067$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $d5b33d7c30034067$export$32ea87a8b54d744a extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $d5b33d7c30034067$var$_instanceLocalMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_instanceWorldMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_instanceIntersects = [];
const $d5b33d7c30034067$var$_box3 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_identity = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_mesh = /*@__PURE__*/ new $d5b33d7c30034067$export$e176487c05830cc5();
const $d5b33d7c30034067$var$_sphere$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
class $d5b33d7c30034067$export$f3c979c331175ad7 extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.count = count;
        this.boundingBox = null;
        this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $d5b33d7c30034067$var$_identity);
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $d5b33d7c30034067$var$_instanceLocalMatrix);
            $d5b33d7c30034067$var$_box3.copy(geometry.boundingBox).applyMatrix4($d5b33d7c30034067$var$_instanceLocalMatrix);
            this.boundingBox.union($d5b33d7c30034067$var$_box3);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $d5b33d7c30034067$var$_instanceLocalMatrix);
            $d5b33d7c30034067$var$_sphere$2.copy(geometry.boundingSphere).applyMatrix4($d5b33d7c30034067$var$_instanceLocalMatrix);
            this.boundingSphere.union($d5b33d7c30034067$var$_sphere$2);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $d5b33d7c30034067$var$_mesh.geometry = this.geometry;
        $d5b33d7c30034067$var$_mesh.material = this.material;
        if ($d5b33d7c30034067$var$_mesh.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$2.copy(this.boundingSphere);
        $d5b33d7c30034067$var$_sphere$2.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere$2) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $d5b33d7c30034067$var$_instanceLocalMatrix);
            $d5b33d7c30034067$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $d5b33d7c30034067$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $d5b33d7c30034067$var$_mesh.matrixWorld = $d5b33d7c30034067$var$_instanceWorldMatrix;
            $d5b33d7c30034067$var$_mesh.raycast(raycaster, $d5b33d7c30034067$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $d5b33d7c30034067$var$_instanceIntersects.length; i < l; i++){
                const intersect = $d5b33d7c30034067$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $d5b33d7c30034067$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
class $d5b33d7c30034067$export$fbaaa33907730a0c extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.type = 'LineBasicMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.linewidth = 1;
        this.linecap = 'round';
        this.linejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $d5b33d7c30034067$var$_start$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_end$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_inverseMatrix$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
class $d5b33d7c30034067$export$17d680238e50603e extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$fbaaa33907730a0c()){
        super();
        this.isLine = true;
        this.type = 'Line';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $d5b33d7c30034067$var$_start$1.fromBufferAttribute(positionAttribute, i - 1);
                $d5b33d7c30034067$var$_end$1.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $d5b33d7c30034067$var$_start$1.distanceTo($d5b33d7c30034067$var$_end$1);
            }
            geometry.setAttribute('lineDistance', new $d5b33d7c30034067$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$1.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere$1.applyMatrix4(matrixWorld);
        $d5b33d7c30034067$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere$1) === false) return;
        //
        $d5b33d7c30034067$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray$1.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new $d5b33d7c30034067$export$64b5c384219d3699();
        const vEnd = new $d5b33d7c30034067$export$64b5c384219d3699();
        const interSegment = new $d5b33d7c30034067$export$64b5c384219d3699();
        const interRay = new $d5b33d7c30034067$export$64b5c384219d3699();
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                vStart.fromBufferAttribute(positionAttribute, a);
                vEnd.fromBufferAttribute(positionAttribute, b);
                const distSq = $d5b33d7c30034067$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                vStart.fromBufferAttribute(positionAttribute, i);
                vEnd.fromBufferAttribute(positionAttribute, i + 1);
                const distSq = $d5b33d7c30034067$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
const $d5b33d7c30034067$var$_start = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_end = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$ff1ed10fedfdd604 extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineSegments = true;
        this.type = 'LineSegments';
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $d5b33d7c30034067$var$_start.fromBufferAttribute(positionAttribute, i);
                $d5b33d7c30034067$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $d5b33d7c30034067$var$_start.distanceTo($d5b33d7c30034067$var$_end);
            }
            geometry.setAttribute('lineDistance', new $d5b33d7c30034067$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
}
class $d5b33d7c30034067$export$f85a24d745e4f17d extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineLoop = true;
        this.type = 'LineLoop';
    }
}
class $d5b33d7c30034067$export$a178c45366ce5d6b extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.type = 'PointsMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $d5b33d7c30034067$var$_inverseMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_position$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$1c787534cb11aa3e extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$a178c45366ce5d6b()){
        super();
        this.isPoints = true;
        this.type = 'Points';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere.applyMatrix4(matrixWorld);
        $d5b33d7c30034067$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere) === false) return;
        //
        $d5b33d7c30034067$var$_inverseMatrix.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $d5b33d7c30034067$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $d5b33d7c30034067$var$testPoint($d5b33d7c30034067$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $d5b33d7c30034067$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $d5b33d7c30034067$var$testPoint($d5b33d7c30034067$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $d5b33d7c30034067$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $d5b33d7c30034067$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $d5b33d7c30034067$export$64b5c384219d3699();
        $d5b33d7c30034067$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $d5b33d7c30034067$export$6e09d1edf8d5a25c extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
class $d5b33d7c30034067$export$9270d786f73ce6fe extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(width, height){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $d5b33d7c30034067$export$3466bac9141a5cc4 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace1){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace1);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $d5b33d7c30034067$export$5fe6b8e34b274fcb extends $d5b33d7c30034067$export$3466bac9141a5cc4 {
    constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        this.isCompressedArrayTexture = true;
        this.image.depth = depth;
        this.wrapR = $d5b33d7c30034067$export$9d9334239a5a5e06;
    }
}
class $d5b33d7c30034067$export$d80173634de65bff extends $d5b33d7c30034067$export$3466bac9141a5cc4 {
    constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, $d5b33d7c30034067$export$8759762a6477f2c4);
        this.isCompressedCubeTexture = true;
        this.isCubeTexture = true;
        this.image = images;
    }
}
class $d5b33d7c30034067$export$f7189e49152d1c13 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = 'Curve';
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn('THREE.Curve: .getPoint() not implemented.');
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $d5b33d7c30034067$export$c977b3e384af9ae1() : new $d5b33d7c30034067$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $d5b33d7c30034067$export$64b5c384219d3699();
        const mat = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $d5b33d7c30034067$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $d5b33d7c30034067$export$64b5c384219d3699();
        binormals[0] = new $d5b33d7c30034067$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($d5b33d7c30034067$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($d5b33d7c30034067$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $d5b33d7c30034067$export$3f87a931616cde04 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.isEllipseCurve = true;
        this.type = 'EllipseCurve';
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget) {
        const point = optionalTarget || new $d5b33d7c30034067$export$c977b3e384af9ae1();
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
class $d5b33d7c30034067$export$b1eedc9aab6300e8 extends $d5b33d7c30034067$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.isArcCurve = true;
        this.type = 'ArcCurve';
    }
}
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $d5b33d7c30034067$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $d5b33d7c30034067$var$tmp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$px = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
const $d5b33d7c30034067$var$py = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
const $d5b33d7c30034067$var$pz = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
class $d5b33d7c30034067$export$b9146b27c24b744c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = 'centripetal', tension = 0.5){
        super();
        this.isCatmullRomCurve3 = true;
        this.type = 'CatmullRomCurve3';
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $d5b33d7c30034067$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $d5b33d7c30034067$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $d5b33d7c30034067$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $d5b33d7c30034067$var$tmp;
        }
        if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $d5b33d7c30034067$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $d5b33d7c30034067$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $d5b33d7c30034067$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === 'catmullrom') {
            $d5b33d7c30034067$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $d5b33d7c30034067$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $d5b33d7c30034067$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($d5b33d7c30034067$var$px.calc(weight), $d5b33d7c30034067$var$py.calc(weight), $d5b33d7c30034067$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $d5b33d7c30034067$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $d5b33d7c30034067$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $d5b33d7c30034067$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $d5b33d7c30034067$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $d5b33d7c30034067$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $d5b33d7c30034067$var$QuadraticBezier(t, p0, p1, p2) {
    return $d5b33d7c30034067$var$QuadraticBezierP0(t, p0) + $d5b33d7c30034067$var$QuadraticBezierP1(t, p1) + $d5b33d7c30034067$var$QuadraticBezierP2(t, p2);
}
//
function $d5b33d7c30034067$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $d5b33d7c30034067$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $d5b33d7c30034067$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $d5b33d7c30034067$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $d5b33d7c30034067$var$CubicBezier(t, p0, p1, p2, p3) {
    return $d5b33d7c30034067$var$CubicBezierP0(t, p0) + $d5b33d7c30034067$var$CubicBezierP1(t, p1) + $d5b33d7c30034067$var$CubicBezierP2(t, p2) + $d5b33d7c30034067$var$CubicBezierP3(t, p3);
}
class $d5b33d7c30034067$export$e36650d36468bb39 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v3 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isCubicBezierCurve = true;
        this.type = 'CubicBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($d5b33d7c30034067$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $d5b33d7c30034067$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $d5b33d7c30034067$export$13d5f1c9525f246c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$64b5c384219d3699(), v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699(), v3 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isCubicBezierCurve3 = true;
        this.type = 'CubicBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($d5b33d7c30034067$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $d5b33d7c30034067$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $d5b33d7c30034067$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $d5b33d7c30034067$export$ab2e07e76531a47e extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isLineCurve = true;
        this.type = 'LineCurve';
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$1fdfd9d9cf487600 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isLineCurve3 = true;
        this.type = 'LineCurve3';
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$5938c4ee491a43ad extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isQuadraticBezierCurve = true;
        this.type = 'QuadraticBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($d5b33d7c30034067$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $d5b33d7c30034067$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$bf3f4c7e459f90fc extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$64b5c384219d3699(), v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isQuadraticBezierCurve3 = true;
        this.type = 'QuadraticBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($d5b33d7c30034067$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $d5b33d7c30034067$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $d5b33d7c30034067$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$d3bdd77da77afc1b extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.isSplineCurve = true;
        this.type = 'SplineCurve';
        this.points = points;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($d5b33d7c30034067$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $d5b33d7c30034067$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $d5b33d7c30034067$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $d5b33d7c30034067$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $d5b33d7c30034067$export$b9146b27c24b744c,
    CubicBezierCurve: $d5b33d7c30034067$export$e36650d36468bb39,
    CubicBezierCurve3: $d5b33d7c30034067$export$13d5f1c9525f246c,
    EllipseCurve: $d5b33d7c30034067$export$3f87a931616cde04,
    LineCurve: $d5b33d7c30034067$export$ab2e07e76531a47e,
    LineCurve3: $d5b33d7c30034067$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $d5b33d7c30034067$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $d5b33d7c30034067$export$bf3f4c7e459f90fc,
    SplineCurve: $d5b33d7c30034067$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $d5b33d7c30034067$export$4aaf9b66af1bbf2c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = 'CurvePath';
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) this.curves.push(new $d5b33d7c30034067$export$ab2e07e76531a47e(endPoint, startPoint));
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $d5b33d7c30034067$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $d5b33d7c30034067$export$4b2950bdac9b6ee9 extends $d5b33d7c30034067$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = 'Path';
        this.currentPoint = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $d5b33d7c30034067$export$ab2e07e76531a47e(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $d5b33d7c30034067$export$5938c4ee491a43ad(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCPx, aCPy), new $d5b33d7c30034067$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $d5b33d7c30034067$export$e36650d36468bb39(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCP1x, aCP1y), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCP2x, aCP2y), new $d5b33d7c30034067$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $d5b33d7c30034067$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $d5b33d7c30034067$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $d5b33d7c30034067$export$6d839803fcd1882c extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(points = [
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $d5b33d7c30034067$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const curNormal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const prevNormal = new $d5b33d7c30034067$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $d5b33d7c30034067$export$41680e8551036033 extends $d5b33d7c30034067$export$6d839803fcd1882c {
    constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $d5b33d7c30034067$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = 'CapsuleGeometry';
        this.parameters = {
            radius: radius,
            length: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$41680e8551036033(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
class $d5b33d7c30034067$export$d5c0e8d607467193 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$68f745719dbe5198 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$a7a48974f285c9b3 extends $d5b33d7c30034067$export$68f745719dbe5198 {
    constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$60e57a7d3f20ff65 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $d5b33d7c30034067$export$64b5c384219d3699();
            const b = new $d5b33d7c30034067$export$64b5c384219d3699();
            const c = new $d5b33d7c30034067$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $d5b33d7c30034067$export$64b5c384219d3699();
            const b = new $d5b33d7c30034067$export$64b5c384219d3699();
            const c = new $d5b33d7c30034067$export$64b5c384219d3699();
            const centroid = new $d5b33d7c30034067$export$64b5c384219d3699();
            const uvA = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const uvB = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const uvC = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
}
class $d5b33d7c30034067$export$c0babfeb8708fc9c extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $d5b33d7c30034067$var$_v0 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normal = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_triangle = /*@__PURE__*/ new $d5b33d7c30034067$export$5a465592bfe74b48();
class $d5b33d7c30034067$export$4730b1542707547f extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = 'EdgesGeometry';
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($d5b33d7c30034067$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute('position');
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                'a',
                'b',
                'c'
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $d5b33d7c30034067$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $d5b33d7c30034067$var$_triangle.getNormal($d5b33d7c30034067$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $d5b33d7c30034067$var$_triangle[vertKeys[j]];
                    const v1 = $d5b33d7c30034067$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($d5b33d7c30034067$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $d5b33d7c30034067$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $d5b33d7c30034067$var$_v0.fromBufferAttribute(positionAttr, index0);
                $d5b33d7c30034067$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($d5b33d7c30034067$var$_v0.x, $d5b33d7c30034067$var$_v0.y, $d5b33d7c30034067$var$_v0.z);
                vertices.push($d5b33d7c30034067$var$_v1$1.x, $d5b33d7c30034067$var$_v1$1.y, $d5b33d7c30034067$var$_v1$1.z);
            }
            this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
class $d5b33d7c30034067$export$6428a7f2611ef1fa extends $d5b33d7c30034067$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.type = 'Shape';
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $d5b33d7c30034067$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */ const $d5b33d7c30034067$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $d5b33d7c30034067$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $d5b33d7c30034067$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 32767 / invSize : 0;
        }
        $d5b33d7c30034067$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $d5b33d7c30034067$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $d5b33d7c30034067$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $d5b33d7c30034067$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $d5b33d7c30034067$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $d5b33d7c30034067$var$equals(last, last.next)) {
        $d5b33d7c30034067$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $d5b33d7c30034067$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($d5b33d7c30034067$var$equals(p, p.next) || $d5b33d7c30034067$var$area(p.prev, p, p.next) === 0)) {
            $d5b33d7c30034067$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $d5b33d7c30034067$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $d5b33d7c30034067$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $d5b33d7c30034067$var$isEarHashed(ear, minX, minY, invSize) : $d5b33d7c30034067$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $d5b33d7c30034067$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $d5b33d7c30034067$var$earcutLinked($d5b33d7c30034067$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $d5b33d7c30034067$var$cureLocalIntersections($d5b33d7c30034067$var$filterPoints(ear), triangles, dim);
                $d5b33d7c30034067$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $d5b33d7c30034067$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $d5b33d7c30034067$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($d5b33d7c30034067$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $d5b33d7c30034067$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($d5b33d7c30034067$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    const minZ = $d5b33d7c30034067$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $d5b33d7c30034067$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $d5b33d7c30034067$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $d5b33d7c30034067$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $d5b33d7c30034067$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$d5b33d7c30034067$var$equals(a, b) && $d5b33d7c30034067$var$intersects(a, p, p.next, b) && $d5b33d7c30034067$var$locallyInside(a, b) && $d5b33d7c30034067$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $d5b33d7c30034067$var$removeNode(p);
            $d5b33d7c30034067$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $d5b33d7c30034067$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $d5b33d7c30034067$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $d5b33d7c30034067$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $d5b33d7c30034067$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $d5b33d7c30034067$var$filterPoints(a, a.next);
                c = $d5b33d7c30034067$var$filterPoints(c, c.next);
                // run earcut on each half
                $d5b33d7c30034067$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $d5b33d7c30034067$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $d5b33d7c30034067$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $d5b33d7c30034067$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($d5b33d7c30034067$var$getLeftmost(list));
    }
    queue.sort($d5b33d7c30034067$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $d5b33d7c30034067$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $d5b33d7c30034067$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $d5b33d7c30034067$var$eliminateHole(hole, outerNode) {
    const bridge = $d5b33d7c30034067$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $d5b33d7c30034067$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $d5b33d7c30034067$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $d5b33d7c30034067$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $d5b33d7c30034067$var$findHoleBridge(hole, outerNode) {
    let p = outerNode, qx = -Infinity, m;
    const hx = hole.x, hy = hole.y;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $d5b33d7c30034067$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($d5b33d7c30034067$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $d5b33d7c30034067$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $d5b33d7c30034067$var$sectorContainsSector(m, p) {
    return $d5b33d7c30034067$var$area(m.prev, m, p.prev) < 0 && $d5b33d7c30034067$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $d5b33d7c30034067$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $d5b33d7c30034067$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $d5b33d7c30034067$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $d5b33d7c30034067$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $d5b33d7c30034067$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $d5b33d7c30034067$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $d5b33d7c30034067$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$d5b33d7c30034067$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($d5b33d7c30034067$var$locallyInside(a, b) && $d5b33d7c30034067$var$locallyInside(b, a) && $d5b33d7c30034067$var$middleInside(a, b) && // locally visible
    ($d5b33d7c30034067$var$area(a.prev, a, b.prev) || $d5b33d7c30034067$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $d5b33d7c30034067$var$equals(a, b) && $d5b33d7c30034067$var$area(a.prev, a, a.next) > 0 && $d5b33d7c30034067$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $d5b33d7c30034067$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $d5b33d7c30034067$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $d5b33d7c30034067$var$intersects(p1, q1, p2, q2) {
    const o1 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p1, q1, p2));
    const o2 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p1, q1, q2));
    const o3 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p2, q2, p1));
    const o4 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $d5b33d7c30034067$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $d5b33d7c30034067$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $d5b33d7c30034067$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $d5b33d7c30034067$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $d5b33d7c30034067$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $d5b33d7c30034067$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $d5b33d7c30034067$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $d5b33d7c30034067$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $d5b33d7c30034067$var$locallyInside(a, b) {
    return $d5b33d7c30034067$var$area(a.prev, a, a.next) < 0 ? $d5b33d7c30034067$var$area(a, b, a.next) >= 0 && $d5b33d7c30034067$var$area(a, a.prev, b) >= 0 : $d5b33d7c30034067$var$area(a, b, a.prev) < 0 || $d5b33d7c30034067$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $d5b33d7c30034067$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $d5b33d7c30034067$var$splitPolygon(a, b) {
    const a2 = new $d5b33d7c30034067$var$Node(a.i, a.x, a.y), b2 = new $d5b33d7c30034067$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $d5b33d7c30034067$var$insertNode(i, x, y, last) {
    const p = new $d5b33d7c30034067$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $d5b33d7c30034067$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $d5b33d7c30034067$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $d5b33d7c30034067$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $d5b33d7c30034067$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $d5b33d7c30034067$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $d5b33d7c30034067$var$removeDupEndPts(contour);
        $d5b33d7c30034067$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($d5b33d7c30034067$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $d5b33d7c30034067$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $d5b33d7c30034067$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $d5b33d7c30034067$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $d5b33d7c30034067$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $d5b33d7c30034067$export$598697a1efa63ca7 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(shapes = new $d5b33d7c30034067$export$6428a7f2611ef1fa([
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = 'ExtrudeGeometry';
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $d5b33d7c30034067$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $d5b33d7c30034067$export$64b5c384219d3699();
                normal = new $d5b33d7c30034067$export$64b5c384219d3699();
                position2 = new $d5b33d7c30034067$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $d5b33d7c30034067$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $d5b33d7c30034067$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $d5b33d7c30034067$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $d5b33d7c30034067$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $d5b33d7c30034067$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $d5b33d7c30034067$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_x, a_y),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_x, b_y),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $d5b33d7c30034067$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $d5b33d7c30034067$export$9567cc828c9535da extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$9567cc828c9535da(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$1954e2b809fe361e extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$68cb731f50f614af extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$57a29a1c803e9065 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(shapes = new $d5b33d7c30034067$export$6428a7f2611ef1fa([
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $d5b33d7c30034067$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $d5b33d7c30034067$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $d5b33d7c30034067$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $d5b33d7c30034067$export$1b417fc3b307a251 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$fb3f7adc68bd6e02 extends $d5b33d7c30034067$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$a2312a2a1fa56495 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $d5b33d7c30034067$export$64b5c384219d3699();
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $d5b33d7c30034067$export$77e9bfadfb9ab8c8 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const P1 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const P2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const B = new $d5b33d7c30034067$export$64b5c384219d3699();
        const T = new $d5b33d7c30034067$export$64b5c384219d3699();
        const N = new $d5b33d7c30034067$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $d5b33d7c30034067$export$7897d9d48904490c extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(path = new $d5b33d7c30034067$export$bf3f4c7e459f90fc(new $d5b33d7c30034067$export$64b5c384219d3699(-1, -1, 0), new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, 0), new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        let P = new $d5b33d7c30034067$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $d5b33d7c30034067$export$7897d9d48904490c(new $d5b33d7c30034067$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $d5b33d7c30034067$export$4b739da06d24892b extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = 'WireframeGeometry';
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $d5b33d7c30034067$export$64b5c384219d3699();
            const end = new $d5b33d7c30034067$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($d5b33d7c30034067$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($d5b33d7c30034067$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $d5b33d7c30034067$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $d5b33d7c30034067$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $d5b33d7c30034067$export$33e43285f7406bd5,
    CapsuleGeometry: $d5b33d7c30034067$export$41680e8551036033,
    CircleGeometry: $d5b33d7c30034067$export$d5c0e8d607467193,
    ConeGeometry: $d5b33d7c30034067$export$a7a48974f285c9b3,
    CylinderGeometry: $d5b33d7c30034067$export$68f745719dbe5198,
    DodecahedronGeometry: $d5b33d7c30034067$export$c0babfeb8708fc9c,
    EdgesGeometry: $d5b33d7c30034067$export$4730b1542707547f,
    ExtrudeGeometry: $d5b33d7c30034067$export$598697a1efa63ca7,
    IcosahedronGeometry: $d5b33d7c30034067$export$9567cc828c9535da,
    LatheGeometry: $d5b33d7c30034067$export$6d839803fcd1882c,
    OctahedronGeometry: $d5b33d7c30034067$export$1954e2b809fe361e,
    PlaneGeometry: $d5b33d7c30034067$export$967d831af31f69ce,
    PolyhedronGeometry: $d5b33d7c30034067$export$60e57a7d3f20ff65,
    RingGeometry: $d5b33d7c30034067$export$68cb731f50f614af,
    ShapeGeometry: $d5b33d7c30034067$export$57a29a1c803e9065,
    SphereGeometry: $d5b33d7c30034067$export$1b417fc3b307a251,
    TetrahedronGeometry: $d5b33d7c30034067$export$fb3f7adc68bd6e02,
    TorusGeometry: $d5b33d7c30034067$export$a2312a2a1fa56495,
    TorusKnotGeometry: $d5b33d7c30034067$export$77e9bfadfb9ab8c8,
    TubeGeometry: $d5b33d7c30034067$export$7897d9d48904490c,
    WireframeGeometry: $d5b33d7c30034067$export$4b739da06d24892b
});
class $d5b33d7c30034067$export$e8564da406055a3 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.type = 'ShadowMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$21c421a2e1df9d22 extends $d5b33d7c30034067$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
        this.type = 'RawShaderMaterial';
    }
}
class $d5b33d7c30034067$export$f2980790215acccd extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.defines = {
            'STANDARD': ''
        };
        this.type = 'MeshStandardMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$28d04986c4269c9f extends $d5b33d7c30034067$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.type = 'MeshPhysicalMaterial';
        this.anisotropyRotation = 0;
        this.anisotropyMap = null;
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, 'reflectivity', {
            get: function() {
                return $d5b33d7c30034067$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = Infinity;
        this.attenuationColor = new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
class $d5b33d7c30034067$export$24c72f71cbaf0678 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.type = 'MeshPhongMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $d5b33d7c30034067$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$df893cf97e765622 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            'TOON': ''
        };
        this.type = 'MeshToonMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$bfe8c0a091f41ae7 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.type = 'MeshNormalMaterial';
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
class $d5b33d7c30034067$export$5023a9a8114806b8 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.type = 'MeshLambertMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$6f5fef6235ec12ee extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            'MATCAP': ''
        };
        this.type = 'MeshMatcapMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$327886a3efaeaebe extends $d5b33d7c30034067$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.type = 'LineDashedMaterial';
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
// same as Array.prototype.slice, but also works on typed arrays
function $d5b33d7c30034067$var$arraySlice(array, from, to) {
    if ($d5b33d7c30034067$var$isTypedArray(array)) // in ios9 array.subarray(from, undefined) will return empty array
    // but array.subarray(from) or array.subarray(from, len) is correct
    return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
    return array.slice(from, to);
}
// converts an array to a specific type
function $d5b33d7c30034067$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $d5b33d7c30034067$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $d5b33d7c30034067$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $d5b33d7c30034067$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $d5b33d7c30034067$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push.apply(values, value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $d5b33d7c30034067$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $d5b33d7c30034067$var$convertArray(times, track.times.constructor);
        track.values = $d5b33d7c30034067$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $d5b33d7c30034067$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = $d5b33d7c30034067$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = $d5b33d7c30034067$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = $d5b33d7c30034067$var$arraySlice(interpolant.resultBuffer, startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            const referenceQuat = new $d5b33d7c30034067$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            $d5b33d7c30034067$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $d5b33d7c30034067$export$d875e029ef558d3;
    return targetClip;
}
const $d5b33d7c30034067$export$7ee8caa573e71ad1 = {
    arraySlice: $d5b33d7c30034067$var$arraySlice,
    convertArray: $d5b33d7c30034067$var$convertArray,
    isTypedArray: $d5b33d7c30034067$var$isTypedArray,
    getKeyframeOrder: $d5b33d7c30034067$var$getKeyframeOrder,
    sortedArray: $d5b33d7c30034067$var$sortedArray,
    flattenJSON: $d5b33d7c30034067$var$flattenJSON,
    subclip: $d5b33d7c30034067$var$subclip,
    makeClipAdditive: $d5b33d7c30034067$var$makeClipAdditive
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $d5b33d7c30034067$export$3646682e7a3959 extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $d5b33d7c30034067$export$7f795934b84ab523,
            endingEnd: $d5b33d7c30034067$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $d5b33d7c30034067$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $d5b33d7c30034067$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $d5b33d7c30034067$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $d5b33d7c30034067$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $d5b33d7c30034067$export$a8e6009059f51e1a extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ class $d5b33d7c30034067$export$fb9758ef7ef8d5cc extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $d5b33d7c30034067$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        this.name = name;
        this.times = $d5b33d7c30034067$var$convertArray(times, this.TimeBufferType);
        this.values = $d5b33d7c30034067$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': $d5b33d7c30034067$var$convertArray(track.times, Array),
                'values': $d5b33d7c30034067$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $d5b33d7c30034067$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $d5b33d7c30034067$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $d5b33d7c30034067$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $d5b33d7c30034067$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $d5b33d7c30034067$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $d5b33d7c30034067$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn('THREE.KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $d5b33d7c30034067$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $d5b33d7c30034067$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $d5b33d7c30034067$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = $d5b33d7c30034067$var$arraySlice(times, from, to);
            this.values = $d5b33d7c30034067$var$arraySlice(this.values, from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error('THREE.KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($d5b33d7c30034067$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error('THREE.KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = $d5b33d7c30034067$var$arraySlice(this.times), values = $d5b33d7c30034067$var$arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $d5b33d7c30034067$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = $d5b33d7c30034067$var$arraySlice(times, 0, writeIndex);
            this.values = $d5b33d7c30034067$var$arraySlice(values, 0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = $d5b33d7c30034067$var$arraySlice(this.times, 0);
        const values = $d5b33d7c30034067$var$arraySlice(this.values, 0);
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $d5b33d7c30034067$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $d5b33d7c30034067$export$d3a344b98cf0b775 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $d5b33d7c30034067$export$995b32462a65e855;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $d5b33d7c30034067$export$83444c5d885347d8 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A Track of numeric keyframe values.
 */ class $d5b33d7c30034067$export$d45f0d1a4d9a9314 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 */ class $d5b33d7c30034067$export$2db1cfb7923d931e extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $d5b33d7c30034067$export$b8043f12b5aafbd7 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $d5b33d7c30034067$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$d5b33d7c30034067$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
$d5b33d7c30034067$export$b8043f12b5aafbd7.prototype.DefaultInterpolation = $d5b33d7c30034067$export$30fac1aace31cf4d;
$d5b33d7c30034067$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $d5b33d7c30034067$export$6ce41d4f3a8df9cd extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $d5b33d7c30034067$export$995b32462a65e855;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $d5b33d7c30034067$export$5ce2dcb4cc9f2bff extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
class $d5b33d7c30034067$export$d942c706bf23829c {
    constructor(name, duration = -1, tracks, blendMode = $d5b33d7c30034067$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($d5b33d7c30034067$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($d5b33d7c30034067$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $d5b33d7c30034067$var$getKeyframeOrder(times);
            times = $d5b33d7c30034067$var$sortedArray(times, 1, order);
            values = $d5b33d7c30034067$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $d5b33d7c30034067$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error('THREE.AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $d5b33d7c30034067$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $d5b33d7c30034067$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack($d5b33d7c30034067$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack($d5b33d7c30034067$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack($d5b33d7c30034067$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $d5b33d7c30034067$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $d5b33d7c30034067$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $d5b33d7c30034067$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $d5b33d7c30034067$export$83444c5d885347d8;
        case 'quaternion':
            return $d5b33d7c30034067$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $d5b33d7c30034067$export$d3a344b98cf0b775;
        case 'string':
            return $d5b33d7c30034067$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $d5b33d7c30034067$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = $d5b33d7c30034067$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $d5b33d7c30034067$var$flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $d5b33d7c30034067$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $d5b33d7c30034067$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $d5b33d7c30034067$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $d5b33d7c30034067$export$99cc795e99919eed();
class $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $d5b33d7c30034067$export$b033c3f9a95c6a16;
        this.crossOrigin = 'anonymous';
        this.withCredentials = false;
        this.path = '';
        this.resourcePath = '';
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
$d5b33d7c30034067$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = '__DEFAULT';
const $d5b33d7c30034067$var$loading = {};
class $d5b33d7c30034067$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $d5b33d7c30034067$export$98435a25b5cf7b2b extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($d5b33d7c30034067$var$loading[url] !== undefined) {
            $d5b33d7c30034067$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $d5b33d7c30034067$var$loading[url] = [];
        $d5b33d7c30034067$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin'
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $d5b33d7c30034067$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get('Content-Length') || response.headers.get('X-File-Size');
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent('progress', {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $d5b33d7c30034067$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case 'arraybuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'document':
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case 'json':
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, data);
            const callbacks = $d5b33d7c30034067$var$loading[url];
            delete $d5b33d7c30034067$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $d5b33d7c30034067$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $d5b33d7c30034067$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $d5b33d7c30034067$export$29711c7e14f61db extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $d5b33d7c30034067$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $d5b33d7c30034067$export$bd73ce947a280350 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $d5b33d7c30034067$export$3466bac9141a5cc4();
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$8905ce1c7a2464a1 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $d5b33d7c30034067$var$createElementNS('img');
        function onImageLoad() {
            removeEventListeners();
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.slice(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $d5b33d7c30034067$export$2ec114afc2cf6308 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $d5b33d7c30034067$export$ee2e5a18258a4049();
        texture.colorSpace = $d5b33d7c30034067$export$561f394b24edfcaa;
        const loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $d5b33d7c30034067$export$792d8a18f2c55855 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $d5b33d7c30034067$export$b691f601014eabe1();
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (error) {
                if (onError !== undefined) onError(error);
                else {
                    console.error(error);
                    return;
                }
            }
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $d5b33d7c30034067$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $d5b33d7c30034067$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            else if (texData.encoding !== undefined) texture.encoding = texData.encoding;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $d5b33d7c30034067$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$fd1bfc71f64c538c extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $d5b33d7c30034067$export$5431306cf43de24a();
        const loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$6ecadb6ed240d696 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = 'Light';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
class $d5b33d7c30034067$export$8d474f55edbb9624 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = 'HemisphereLight';
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.groundColor = new $d5b33d7c30034067$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $d5b33d7c30034067$var$_projScreenMatrix$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_lightPositionWorld$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_lookTarget$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
        this._frameExtents = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $d5b33d7c30034067$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($d5b33d7c30034067$var$_lightPositionWorld$1);
        $d5b33d7c30034067$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($d5b33d7c30034067$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $d5b33d7c30034067$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($d5b33d7c30034067$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($d5b33d7c30034067$var$_projScreenMatrix$1);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $d5b33d7c30034067$var$SpotLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $d5b33d7c30034067$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
class $d5b33d7c30034067$export$81495cbb73897362 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = 'SpotLight';
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay;
        this.map = null;
        this.shadow = new $d5b33d7c30034067$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $d5b33d7c30034067$var$_projScreenMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_lightPositionWorld = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_lookTarget = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$var$PointLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new $d5b33d7c30034067$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(-1, 0, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $d5b33d7c30034067$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($d5b33d7c30034067$var$_lightPositionWorld);
        $d5b33d7c30034067$var$_lookTarget.copy(camera.position);
        $d5b33d7c30034067$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($d5b33d7c30034067$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$d5b33d7c30034067$var$_lightPositionWorld.x, -$d5b33d7c30034067$var$_lightPositionWorld.y, -$d5b33d7c30034067$var$_lightPositionWorld.z);
        $d5b33d7c30034067$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($d5b33d7c30034067$var$_projScreenMatrix);
    }
}
class $d5b33d7c30034067$export$4c9c1cb3f0b6f455 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        this.isPointLight = true;
        this.type = 'PointLight';
        this.distance = distance;
        this.decay = decay;
        this.shadow = new $d5b33d7c30034067$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $d5b33d7c30034067$var$DirectionalLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}
class $d5b33d7c30034067$export$3fea33cc9972c868 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = 'DirectionalLight';
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        this.shadow = new $d5b33d7c30034067$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $d5b33d7c30034067$export$af279bfef9ec2c96 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = 'AmbientLight';
    }
}
class $d5b33d7c30034067$export$61db2d908bbd2429 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = 'RectAreaLight';
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $d5b33d7c30034067$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $d5b33d7c30034067$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
class $d5b33d7c30034067$export$e7ef036e309b38d2 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(sh = new $d5b33d7c30034067$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
class $d5b33d7c30034067$export$3bd6d323353dcf96 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn('THREE.MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = $d5b33d7c30034067$export$3bd6d323353dcf96.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $d5b33d7c30034067$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== 1) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $d5b33d7c30034067$export$e8564da406055a3,
            SpriteMaterial: $d5b33d7c30034067$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $d5b33d7c30034067$export$21c421a2e1df9d22,
            ShaderMaterial: $d5b33d7c30034067$export$83c7d75d550a8b0d,
            PointsMaterial: $d5b33d7c30034067$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $d5b33d7c30034067$export$28d04986c4269c9f,
            MeshStandardMaterial: $d5b33d7c30034067$export$f2980790215acccd,
            MeshPhongMaterial: $d5b33d7c30034067$export$24c72f71cbaf0678,
            MeshToonMaterial: $d5b33d7c30034067$export$df893cf97e765622,
            MeshNormalMaterial: $d5b33d7c30034067$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $d5b33d7c30034067$export$5023a9a8114806b8,
            MeshDepthMaterial: $d5b33d7c30034067$export$2698c22ec13825db,
            MeshDistanceMaterial: $d5b33d7c30034067$export$33e187ed002f2a19,
            MeshBasicMaterial: $d5b33d7c30034067$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $d5b33d7c30034067$export$6f5fef6235ec12ee,
            LineDashedMaterial: $d5b33d7c30034067$export$327886a3efaeaebe,
            LineBasicMaterial: $d5b33d7c30034067$export$fbaaa33907730a0c,
            Material: $d5b33d7c30034067$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
class $d5b33d7c30034067$export$b5d2dc08d867e41a {
    static decodeText(array) {
        if (typeof TextDecoder !== 'undefined') return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = '';
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== 'string' || url === '') return '';
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $d5b33d7c30034067$export$231f009cbe414146 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = 'InstancedBufferGeometry';
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
class $d5b33d7c30034067$export$dc275bb96327833a extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $d5b33d7c30034067$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $d5b33d7c30034067$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $d5b33d7c30034067$export$231f009cbe414146() : new $d5b33d7c30034067$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $d5b33d7c30034067$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $d5b33d7c30034067$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $d5b33d7c30034067$export$32ea87a8b54d744a : $d5b33d7c30034067$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            if (attribute.updateRange !== undefined) {
                bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                bufferAttribute.updateRange.count = attribute.updateRange.count;
            }
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $d5b33d7c30034067$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $d5b33d7c30034067$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $d5b33d7c30034067$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $d5b33d7c30034067$export$40110c8505c5ad19 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? $d5b33d7c30034067$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));
                console.error('THREE.ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === '' ? $d5b33d7c30034067$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $d5b33d7c30034067$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $d5b33d7c30034067$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $d5b33d7c30034067$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $d5b33d7c30034067$var$Geometries) geometry = $d5b33d7c30034067$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $d5b33d7c30034067$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $d5b33d7c30034067$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $d5b33d7c30034067$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $d5b33d7c30034067$export$99cc795e99919eed(onLoad);
            loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $d5b33d7c30034067$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $d5b33d7c30034067$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $d5b33d7c30034067$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn('THREE.ObjectLoader: Undefined image', data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $d5b33d7c30034067$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $d5b33d7c30034067$export$b691f601014eabe1();
                else texture = new $d5b33d7c30034067$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $d5b33d7c30034067$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $d5b33d7c30034067$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $d5b33d7c30034067$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.encoding !== undefined) texture.encoding = data.encoding; // @deprecated, r152
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $d5b33d7c30034067$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $d5b33d7c30034067$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn('THREE.ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn('THREE.ObjectLoader: Undefined material', name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined texture', uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new $d5b33d7c30034067$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $d5b33d7c30034067$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new $d5b33d7c30034067$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new $d5b33d7c30034067$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                break;
            case 'PerspectiveCamera':
                object = new $d5b33d7c30034067$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new $d5b33d7c30034067$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new $d5b33d7c30034067$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new $d5b33d7c30034067$export$3fea33cc9972c868(data.color, data.intensity);
                break;
            case 'PointLight':
                object = new $d5b33d7c30034067$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new $d5b33d7c30034067$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new $d5b33d7c30034067$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case 'HemisphereLight':
                object = new $d5b33d7c30034067$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                object = new $d5b33d7c30034067$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $d5b33d7c30034067$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $d5b33d7c30034067$export$e176487c05830cc5(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $d5b33d7c30034067$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case 'LOD':
                object = new $d5b33d7c30034067$export$112e7237be0c5f30();
                break;
            case 'Line':
                object = new $d5b33d7c30034067$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new $d5b33d7c30034067$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new $d5b33d7c30034067$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new $d5b33d7c30034067$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new $d5b33d7c30034067$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case 'Group':
                object = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
                break;
            case 'Bone':
                object = new $d5b33d7c30034067$export$b127726e56765aa4();
                break;
            default:
                object = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
}
const $d5b33d7c30034067$var$TEXTURE_MAPPING = {
    UVMapping: $d5b33d7c30034067$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $d5b33d7c30034067$export$8759762a6477f2c4,
    CubeRefractionMapping: $d5b33d7c30034067$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $d5b33d7c30034067$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $d5b33d7c30034067$export$ee99d97d46898098,
    CubeUVReflectionMapping: $d5b33d7c30034067$export$dbf3e70ff37af79
};
const $d5b33d7c30034067$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $d5b33d7c30034067$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $d5b33d7c30034067$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $d5b33d7c30034067$export$c7e7c00b14f51a4f
};
const $d5b33d7c30034067$var$TEXTURE_FILTER = {
    NearestFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $d5b33d7c30034067$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $d5b33d7c30034067$export$d2327c1afe5bfdf2,
    LinearFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $d5b33d7c30034067$export$19a719f377145a13,
    LinearMipmapLinearFilter: $d5b33d7c30034067$export$5d8599b6a933fb1b
};
class $d5b33d7c30034067$export$52286b55c4a9b51f extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
        this.options = {
            premultiplyAlpha: 'none'
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: 'none'
            }));
        }).then(function(imageBitmap) {
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
}
let $d5b33d7c30034067$var$_context;
class $d5b33d7c30034067$export$fcbc63750ec2a81f {
    static getContext() {
        if ($d5b33d7c30034067$var$_context === undefined) $d5b33d7c30034067$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $d5b33d7c30034067$var$_context;
    }
    static setContext(value) {
        $d5b33d7c30034067$var$_context = value;
    }
}
class $d5b33d7c30034067$export$d8d5fccfbf47714e extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $d5b33d7c30034067$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }, handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
        }
    }
}
class $d5b33d7c30034067$export$2f22dadc8bc42820 extends $d5b33d7c30034067$export$e7ef036e309b38d2 {
    constructor(skyColor, groundColor, intensity = 1){
        super(undefined, intensity);
        this.isHemisphereLightProbe = true;
        const color1 = new $d5b33d7c30034067$export$892596cec99bc70e().set(skyColor);
        const color2 = new $d5b33d7c30034067$export$892596cec99bc70e().set(groundColor);
        const sky = new $d5b33d7c30034067$export$64b5c384219d3699(color1.r, color1.g, color1.b);
        const ground = new $d5b33d7c30034067$export$64b5c384219d3699(color2.r, color2.g, color2.b);
        // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
        const c0 = Math.sqrt(Math.PI);
        const c1 = c0 * Math.sqrt(0.75);
        this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
        this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
    }
}
class $d5b33d7c30034067$export$afe310a21c86023d extends $d5b33d7c30034067$export$e7ef036e309b38d2 {
    constructor(color, intensity = 1){
        super(undefined, intensity);
        this.isAmbientLightProbe = true;
        const color1 = new $d5b33d7c30034067$export$892596cec99bc70e().set(color);
        // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
        this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
    }
}
const $d5b33d7c30034067$var$_eyeRight = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_eyeLeft = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_projectionMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$bc7f73a1065bee0c {
    constructor(){
        this.type = 'StereoCamera';
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $d5b33d7c30034067$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($d5b33d7c30034067$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $d5b33d7c30034067$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $d5b33d7c30034067$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $d5b33d7c30034067$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $d5b33d7c30034067$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($d5b33d7c30034067$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $d5b33d7c30034067$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $d5b33d7c30034067$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($d5b33d7c30034067$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($d5b33d7c30034067$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($d5b33d7c30034067$var$_eyeRight);
    }
}
class $d5b33d7c30034067$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $d5b33d7c30034067$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $d5b33d7c30034067$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $d5b33d7c30034067$var$now() {
    return (typeof performance === 'undefined' ? Date : performance).now(); // see #10732
}
const $d5b33d7c30034067$var$_position$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_scale$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_orientation$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$8a1b810c6fde8951 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = 'AudioListener';
        this.context = $d5b33d7c30034067$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $d5b33d7c30034067$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$1, $d5b33d7c30034067$var$_quaternion$1, $d5b33d7c30034067$var$_scale$1);
        $d5b33d7c30034067$var$_orientation$1.set(0, 0, -1).applyQuaternion($d5b33d7c30034067$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($d5b33d7c30034067$var$_position$1.x, $d5b33d7c30034067$var$_position$1.y, $d5b33d7c30034067$var$_position$1.z);
            listener.setOrientation($d5b33d7c30034067$var$_orientation$1.x, $d5b33d7c30034067$var$_orientation$1.y, $d5b33d7c30034067$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $d5b33d7c30034067$export$153755f98d9861de extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = 'Audio';
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn('THREE.Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop();
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this._connected === false) return;
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $d5b33d7c30034067$var$_position = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_scale = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_orientation = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$4b3e397ef1832507 extends $d5b33d7c30034067$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position, $d5b33d7c30034067$var$_quaternion, $d5b33d7c30034067$var$_scale);
        $d5b33d7c30034067$var$_orientation.set(0, 0, 1).applyQuaternion($d5b33d7c30034067$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($d5b33d7c30034067$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($d5b33d7c30034067$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($d5b33d7c30034067$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.z, endTime);
        } else {
            panner.setPosition($d5b33d7c30034067$var$_position.x, $d5b33d7c30034067$var$_position.y, $d5b33d7c30034067$var$_position.z);
            panner.setOrientation($d5b33d7c30034067$var$_orientation.x, $d5b33d7c30034067$var$_orientation.y, $d5b33d7c30034067$var$_orientation.z);
        }
    }
}
class $d5b33d7c30034067$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $d5b33d7c30034067$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $d5b33d7c30034067$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const $d5b33d7c30034067$var$_reservedRe = new RegExp('[' + $d5b33d7c30034067$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $d5b33d7c30034067$var$_wordChar = '[^' + $d5b33d7c30034067$var$_RESERVED_CHARS_RE + ']';
const $d5b33d7c30034067$var$_wordCharOrDot = '[^' + $d5b33d7c30034067$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $d5b33d7c30034067$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', $d5b33d7c30034067$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $d5b33d7c30034067$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', $d5b33d7c30034067$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $d5b33d7c30034067$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $d5b33d7c30034067$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $d5b33d7c30034067$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $d5b33d7c30034067$var$_wordChar);
const $d5b33d7c30034067$var$_trackRe = new RegExp("^" + $d5b33d7c30034067$var$_directoryRe + $d5b33d7c30034067$var$_nodeRe + $d5b33d7c30034067$var$_objectRe + $d5b33d7c30034067$var$_propertyRe + '$');
const $d5b33d7c30034067$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones',
    'map'
];
class $d5b33d7c30034067$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $d5b33d7c30034067$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $d5b33d7c30034067$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $d5b33d7c30034067$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $d5b33d7c30034067$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $d5b33d7c30034067$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $d5b33d7c30034067$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, '_').replace($d5b33d7c30034067$var$_reservedRe, '');
    }
    static parseTrackName(trackName) {
        const matches = $d5b33d7c30034067$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($d5b33d7c30034067$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $d5b33d7c30034067$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.warn('THREE.PropertyBinding: No target node found for track: ' + this.path + '.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case 'map':
                    if ('map' in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error('THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$d5b33d7c30034067$export$7bf70fcf9f891893.Composite = $d5b33d7c30034067$var$Composite;
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_direct,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_array,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $d5b33d7c30034067$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $d5b33d7c30034067$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $d5b33d7c30034067$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $d5b33d7c30034067$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
class $d5b33d7c30034067$export$6946940a69e799e {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $d5b33d7c30034067$export$7f795934b84ab523,
            endingEnd: $d5b33d7c30034067$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $d5b33d7c30034067$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $d5b33d7c30034067$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $d5b33d7c30034067$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $d5b33d7c30034067$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $d5b33d7c30034067$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $d5b33d7c30034067$export$24a4ccb5099273b5;
            settings.endingEnd = $d5b33d7c30034067$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $d5b33d7c30034067$export$24a4ccb5099273b5 : $d5b33d7c30034067$export$7f795934b84ab523;
            else settings.endingStart = $d5b33d7c30034067$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $d5b33d7c30034067$export$24a4ccb5099273b5 : $d5b33d7c30034067$export$7f795934b84ab523;
            else settings.endingEnd = $d5b33d7c30034067$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $d5b33d7c30034067$var$_controlInterpolantsResultBuffer = new Float32Array(1);
class $d5b33d7c30034067$export$fbd77e5aefaa0102 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $d5b33d7c30034067$export$dfe0af1ca1acb78a($d5b33d7c30034067$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $d5b33d7c30034067$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $d5b33d7c30034067$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? $d5b33d7c30034067$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $d5b33d7c30034067$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $d5b33d7c30034067$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $d5b33d7c30034067$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
class $d5b33d7c30034067$export$2947cebfe91c02f8 {
    constructor(value){
        this.value = value;
    }
    clone() {
        return new $d5b33d7c30034067$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $d5b33d7c30034067$var$_id = 0;
class $d5b33d7c30034067$export$c412d5ffe1f79209 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isUniformsGroup = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_id++
        });
        this.name = '';
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this.uniforms = [];
    }
    add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++)this.uniforms.push(uniformsSource[i].clone());
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$25ec0e1af1389358 extends $d5b33d7c30034067$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
class $d5b33d7c30034067$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.name = '';
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
class $d5b33d7c30034067$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $d5b33d7c30034067$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $d5b33d7c30034067$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
    }
    intersectObject(object, recursive = true, intersects = []) {
        $d5b33d7c30034067$var$intersectObject(object, this, intersects, recursive);
        intersects.sort($d5b33d7c30034067$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$d5b33d7c30034067$var$intersectObject(objects[i], this, intersects, recursive);
        intersects.sort($d5b33d7c30034067$var$ascSort);
        return intersects;
    }
}
function $d5b33d7c30034067$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $d5b33d7c30034067$var$intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$d5b33d7c30034067$var$intersectObject(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class $d5b33d7c30034067$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($d5b33d7c30034067$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $d5b33d7c30034067$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_vector$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$60f553fa130f08b0 {
    constructor(min = new $d5b33d7c30034067$export$c977b3e384af9ae1(Infinity, Infinity), max = new $d5b33d7c30034067$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $d5b33d7c30034067$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $d5b33d7c30034067$var$_vector$4).distanceTo(point);
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $d5b33d7c30034067$var$_startP = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_startEnd = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$e0ba6359f1954fd3 {
    constructor(start = new $d5b33d7c30034067$export$64b5c384219d3699(), end = new $d5b33d7c30034067$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $d5b33d7c30034067$var$_startP.subVectors(point, this.start);
        $d5b33d7c30034067$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $d5b33d7c30034067$var$_startEnd.dot($d5b33d7c30034067$var$_startEnd);
        const startEnd_startP = $d5b33d7c30034067$var$_startEnd.dot($d5b33d7c30034067$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $d5b33d7c30034067$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_vector$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$4b14638ffdd81e68 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'SpotLightHelper';
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $d5b33d7c30034067$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $d5b33d7c30034067$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($d5b33d7c30034067$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $d5b33d7c30034067$var$_vector$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_boneMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_matrixWorldInv = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$5277df3c9e732259 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $d5b33d7c30034067$var$getBoneList(object);
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $d5b33d7c30034067$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $d5b33d7c30034067$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.isSkeletonHelper = true;
        this.type = 'SkeletonHelper';
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        $d5b33d7c30034067$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $d5b33d7c30034067$var$_boneMatrix.multiplyMatrices($d5b33d7c30034067$var$_matrixWorldInv, bone.matrixWorld);
                $d5b33d7c30034067$var$_vector$2.setFromMatrixPosition($d5b33d7c30034067$var$_boneMatrix);
                position.setXYZ(j, $d5b33d7c30034067$var$_vector$2.x, $d5b33d7c30034067$var$_vector$2.y, $d5b33d7c30034067$var$_vector$2.z);
                $d5b33d7c30034067$var$_boneMatrix.multiplyMatrices($d5b33d7c30034067$var$_matrixWorldInv, bone.parent.matrixWorld);
                $d5b33d7c30034067$var$_vector$2.setFromMatrixPosition($d5b33d7c30034067$var$_boneMatrix);
                position.setXYZ(j + 1, $d5b33d7c30034067$var$_vector$2.x, $d5b33d7c30034067$var$_vector$2.y, $d5b33d7c30034067$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $d5b33d7c30034067$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $d5b33d7c30034067$var$getBoneList(object.children[i]));
    return boneList;
}
class $d5b33d7c30034067$export$9a9291685b9e4023 extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $d5b33d7c30034067$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $d5b33d7c30034067$var$_vector$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_color1 = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
const $d5b33d7c30034067$var$_color2 = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
class $d5b33d7c30034067$export$8dca15f13f4f8172 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'HemisphereLightHelper';
        const geometry = new $d5b33d7c30034067$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $d5b33d7c30034067$export$8dea267bd6bde117(colors, 3));
        this.add(new $d5b33d7c30034067$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            $d5b33d7c30034067$var$_color1.copy(this.light.color);
            $d5b33d7c30034067$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $d5b33d7c30034067$var$_color1 : $d5b33d7c30034067$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($d5b33d7c30034067$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $d5b33d7c30034067$export$3875d39926561055 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $d5b33d7c30034067$export$892596cec99bc70e(color1);
        color2 = new $d5b33d7c30034067$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$361430a10f533cd3 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $d5b33d7c30034067$export$892596cec99bc70e(color1);
        color2 = new $d5b33d7c30034067$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $d5b33d7c30034067$var$_v1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$f8e434dc14203e7d extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'DirectionalLightHelper';
        if (size === undefined) size = 1;
        let geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $d5b33d7c30034067$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $d5b33d7c30034067$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $d5b33d7c30034067$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $d5b33d7c30034067$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $d5b33d7c30034067$var$_v3.subVectors($d5b33d7c30034067$var$_v2, $d5b33d7c30034067$var$_v1);
        this.lightPlane.lookAt($d5b33d7c30034067$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($d5b33d7c30034067$var$_v2);
        this.targetLine.scale.z = $d5b33d7c30034067$var$_v3.length();
    }
}
const $d5b33d7c30034067$var$_vector = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_camera = /*@__PURE__*/ new $d5b33d7c30034067$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $d5b33d7c30034067$export$ed8e93f853cd795 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $d5b33d7c30034067$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $d5b33d7c30034067$export$892596cec99bc70e(0xff0000);
        const colorUp = new $d5b33d7c30034067$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        const colorCross = new $d5b33d7c30034067$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $d5b33d7c30034067$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $d5b33d7c30034067$var$setPoint('c', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, 0, -1);
        $d5b33d7c30034067$var$setPoint('t', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, 0, 1);
        // near
        $d5b33d7c30034067$var$setPoint('n1', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, -h, -1);
        $d5b33d7c30034067$var$setPoint('n2', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, -h, -1);
        $d5b33d7c30034067$var$setPoint('n3', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, h, -1);
        $d5b33d7c30034067$var$setPoint('n4', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, h, -1);
        // far
        $d5b33d7c30034067$var$setPoint('f1', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, -h, 1);
        $d5b33d7c30034067$var$setPoint('f2', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, -h, 1);
        $d5b33d7c30034067$var$setPoint('f3', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, h, 1);
        $d5b33d7c30034067$var$setPoint('f4', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, h, 1);
        // up
        $d5b33d7c30034067$var$setPoint('u1', pointMap, geometry, $d5b33d7c30034067$var$_camera, w * 0.7, h * 1.1, -1);
        $d5b33d7c30034067$var$setPoint('u2', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w * 0.7, h * 1.1, -1);
        $d5b33d7c30034067$var$setPoint('u3', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h * 2, -1);
        // cross
        $d5b33d7c30034067$var$setPoint('cf1', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, 0, 1);
        $d5b33d7c30034067$var$setPoint('cf2', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, 0, 1);
        $d5b33d7c30034067$var$setPoint('cf3', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, -h, 1);
        $d5b33d7c30034067$var$setPoint('cf4', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h, 1);
        $d5b33d7c30034067$var$setPoint('cn1', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, 0, -1);
        $d5b33d7c30034067$var$setPoint('cn2', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, 0, -1);
        $d5b33d7c30034067$var$setPoint('cn3', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, -h, -1);
        $d5b33d7c30034067$var$setPoint('cn4', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h, -1);
        geometry.getAttribute('position').needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $d5b33d7c30034067$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $d5b33d7c30034067$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $d5b33d7c30034067$var$_vector.x, $d5b33d7c30034067$var$_vector.y, $d5b33d7c30034067$var$_vector.z);
    }
}
const $d5b33d7c30034067$var$_box = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
class $d5b33d7c30034067$export$38a664cc862a6a9d extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $d5b33d7c30034067$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn('THREE.BoxHelper: .update() has no longer arguments.');
        if (this.object !== undefined) $d5b33d7c30034067$var$_box.setFromObject(this.object);
        if ($d5b33d7c30034067$var$_box.isEmpty()) return;
        const min = $d5b33d7c30034067$var$_box.min;
        const max = $d5b33d7c30034067$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$ce39f4bb96c9a290 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$a34fe8156c66e5d7 extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $d5b33d7c30034067$export$e176487c05830cc5(geometry2, new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $d5b33d7c30034067$var$_axis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
let $d5b33d7c30034067$var$_lineGeometry, $d5b33d7c30034067$var$_coneGeometry;
class $d5b33d7c30034067$export$a3008e7bd8d2cbe7 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1), origin = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = 'ArrowHelper';
        if ($d5b33d7c30034067$var$_lineGeometry === undefined) {
            $d5b33d7c30034067$var$_lineGeometry = new $d5b33d7c30034067$export$b7be63a67df8959();
            $d5b33d7c30034067$var$_lineGeometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $d5b33d7c30034067$var$_coneGeometry = new $d5b33d7c30034067$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $d5b33d7c30034067$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $d5b33d7c30034067$export$17d680238e50603e($d5b33d7c30034067$var$_lineGeometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $d5b33d7c30034067$export$e176487c05830cc5($d5b33d7c30034067$var$_coneGeometry, new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $d5b33d7c30034067$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($d5b33d7c30034067$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
class $d5b33d7c30034067$export$6c8303f35b8578fd extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $d5b33d7c30034067$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$148534a3c727230b {
    constructor(){
        this.type = 'ShapePath';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $d5b33d7c30034067$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $d5b33d7c30034067$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $d5b33d7c30034067$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $d5b33d7c30034067$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $d5b33d7c30034067$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) console.warn('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $d5b33d7c30034067$export$3545e07a80636437;
}




function $5451ea62abbe5f68$export$676e3e70c930f774(geometry, MikkTSpace, negateSign = true) {
    if (!MikkTSpace || !MikkTSpace.isReady) throw new Error('BufferGeometryUtils: Initialized MikkTSpace library required.');
    if (!geometry.hasAttribute('position') || !geometry.hasAttribute('normal') || !geometry.hasAttribute('uv')) throw new Error('BufferGeometryUtils: Tangents require "position", "normal", and "uv" attributes.');
    function getAttributeArray(attribute) {
        if (attribute.normalized || attribute.isInterleavedBufferAttribute) {
            const dstArray = new Float32Array(attribute.count * attribute.itemSize);
            for(let i = 0, j = 0; i < attribute.count; i++){
                dstArray[j++] = attribute.getX(i);
                dstArray[j++] = attribute.getY(i);
                if (attribute.itemSize > 2) dstArray[j++] = attribute.getZ(i);
            }
            return dstArray;
        }
        if (attribute.array instanceof Float32Array) return attribute.array;
        return new Float32Array(attribute.array);
    }
    // MikkTSpace algorithm requires non-indexed input.
    const _geometry = geometry.index ? geometry.toNonIndexed() : geometry;
    // Compute vertex tangents.
    const tangents = MikkTSpace.generateTangents(getAttributeArray(_geometry.attributes.position), getAttributeArray(_geometry.attributes.normal), getAttributeArray(_geometry.attributes.uv));
    // Texture coordinate convention of glTF differs from the apparent
    // default of the MikkTSpace library; .w component must be flipped.
    if (negateSign) for(let i = 3; i < tangents.length; i += 4)tangents[i] *= -1;
    //
    _geometry.setAttribute('tangent', new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(tangents, 4));
    if (geometry !== _geometry) geometry.copy(_geometry);
    return geometry;
}
/**
 * @param  {Array<BufferGeometry>} geometries
 * @param  {Boolean} useGroups
 * @return {BufferGeometry}
 */ function $5451ea62abbe5f68$export$f06f69b3bf41d25c(geometries, useGroups = false) {
    const isIndexed = geometries[0].index !== null;
    const attributesUsed = new Set(Object.keys(geometries[0].attributes));
    const morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
    const attributes = {};
    const morphAttributes = {};
    const morphTargetsRelative = geometries[0].morphTargetsRelative;
    const mergedGeometry = new (0, $d5b33d7c30034067$export$b7be63a67df8959)();
    let offset = 0;
    for(let i = 0; i < geometries.length; ++i){
        const geometry = geometries[i];
        let attributesCount = 0;
        // ensure that all geometries are indexed, or none
        if (isIndexed !== (geometry.index !== null)) {
            console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.');
            return null;
        }
        // gather attributes, exit early if they're different
        for(const name in geometry.attributes){
            if (!attributesUsed.has(name)) {
                console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
                return null;
            }
            if (attributes[name] === undefined) attributes[name] = [];
            attributes[name].push(geometry.attributes[name]);
            attributesCount++;
        }
        // ensure geometries have the same number of attributes
        if (attributesCount !== attributesUsed.size) {
            console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. Make sure all geometries have the same number of attributes.');
            return null;
        }
        // gather morph attributes, exit early if they're different
        if (morphTargetsRelative !== geometry.morphTargetsRelative) {
            console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. .morphTargetsRelative must be consistent throughout all geometries.');
            return null;
        }
        for(const name in geometry.morphAttributes){
            if (!morphAttributesUsed.has(name)) {
                console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '.  .morphAttributes must be consistent throughout all geometries.');
                return null;
            }
            if (morphAttributes[name] === undefined) morphAttributes[name] = [];
            morphAttributes[name].push(geometry.morphAttributes[name]);
        }
        if (useGroups) {
            let count;
            if (isIndexed) count = geometry.index.count;
            else if (geometry.attributes.position !== undefined) count = geometry.attributes.position.count;
            else {
                console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. The geometry must have either an index or a position attribute');
                return null;
            }
            mergedGeometry.addGroup(offset, count, i);
            offset += count;
        }
    }
    // merge indices
    if (isIndexed) {
        let indexOffset = 0;
        const mergedIndex = [];
        for(let i = 0; i < geometries.length; ++i){
            const index = geometries[i].index;
            for(let j = 0; j < index.count; ++j)mergedIndex.push(index.getX(j) + indexOffset);
            indexOffset += geometries[i].attributes.position.count;
        }
        mergedGeometry.setIndex(mergedIndex);
    }
    // merge attributes
    for(const name in attributes){
        const mergedAttribute = $5451ea62abbe5f68$export$9f98db6234c4bd78(attributes[name]);
        if (!mergedAttribute) {
            console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the ' + name + ' attribute.');
            return null;
        }
        mergedGeometry.setAttribute(name, mergedAttribute);
    }
    // merge morph attributes
    for(const name in morphAttributes){
        const numMorphTargets = morphAttributes[name][0].length;
        if (numMorphTargets === 0) break;
        mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
        mergedGeometry.morphAttributes[name] = [];
        for(let i = 0; i < numMorphTargets; ++i){
            const morphAttributesToMerge = [];
            for(let j = 0; j < morphAttributes[name].length; ++j)morphAttributesToMerge.push(morphAttributes[name][j][i]);
            const mergedMorphAttribute = $5451ea62abbe5f68$export$9f98db6234c4bd78(morphAttributesToMerge);
            if (!mergedMorphAttribute) {
                console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the ' + name + ' morphAttribute.');
                return null;
            }
            mergedGeometry.morphAttributes[name].push(mergedMorphAttribute);
        }
    }
    return mergedGeometry;
}
/**
 * @param {Array<BufferAttribute>} attributes
 * @return {BufferAttribute}
 */ function $5451ea62abbe5f68$export$9f98db6234c4bd78(attributes) {
    let TypedArray;
    let itemSize;
    let normalized;
    let gpuType = -1;
    let arrayLength = 0;
    for(let i = 0; i < attributes.length; ++i){
        const attribute = attributes[i];
        if (attribute.isInterleavedBufferAttribute) {
            console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. InterleavedBufferAttributes are not supported.');
            return null;
        }
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.');
            return null;
        }
        if (itemSize === undefined) itemSize = attribute.itemSize;
        if (itemSize !== attribute.itemSize) {
            console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.');
            return null;
        }
        if (normalized === undefined) normalized = attribute.normalized;
        if (normalized !== attribute.normalized) {
            console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.');
            return null;
        }
        if (gpuType === -1) gpuType = attribute.gpuType;
        if (gpuType !== attribute.gpuType) {
            console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.gpuType must be consistent across matching attributes.');
            return null;
        }
        arrayLength += attribute.array.length;
    }
    const array = new TypedArray(arrayLength);
    let offset = 0;
    for(let i = 0; i < attributes.length; ++i){
        array.set(attributes[i].array, offset);
        offset += attributes[i].array.length;
    }
    const result = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(array, itemSize, normalized);
    if (gpuType !== undefined) result.gpuType = gpuType;
    return result;
}
function $5451ea62abbe5f68$export$4848639a9adff548(attribute) {
    if (attribute.isInstancedInterleavedBufferAttribute || attribute.isInterleavedBufferAttribute) return $5451ea62abbe5f68$export$4b7aa2f2134b7e19(attribute);
    if (attribute.isInstancedBufferAttribute) return new (0, $d5b33d7c30034067$export$32ea87a8b54d744a)().copy(attribute);
    return new (0, $d5b33d7c30034067$export$8dea267bd6bde117)().copy(attribute);
}
/**
 * @param {Array<BufferAttribute>} attributes
 * @return {Array<InterleavedBufferAttribute>}
 */ function $5451ea62abbe5f68$export$308f9509e428a845(attributes) {
    // Interleaves the provided attributes into an InterleavedBuffer and returns
    // a set of InterleavedBufferAttributes for each attribute
    let TypedArray;
    let arrayLength = 0;
    let stride = 0;
    // calculate the length and type of the interleavedBuffer
    for(let i = 0, l = attributes.length; i < l; ++i){
        const attribute = attributes[i];
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error('AttributeBuffers of different types cannot be interleaved');
            return null;
        }
        arrayLength += attribute.array.length;
        stride += attribute.itemSize;
    }
    // Create the set of buffer attributes
    const interleavedBuffer = new (0, $d5b33d7c30034067$export$3d5cd879f108f53f)(new TypedArray(arrayLength), stride);
    let offset = 0;
    const res = [];
    const getters = [
        'getX',
        'getY',
        'getZ',
        'getW'
    ];
    const setters = [
        'setX',
        'setY',
        'setZ',
        'setW'
    ];
    for(let j = 0, l = attributes.length; j < l; j++){
        const attribute = attributes[j];
        const itemSize = attribute.itemSize;
        const count = attribute.count;
        const iba = new (0, $d5b33d7c30034067$export$920b6d07334599c7)(interleavedBuffer, itemSize, offset, attribute.normalized);
        res.push(iba);
        offset += itemSize;
        // Move the data for each attribute into the new interleavedBuffer
        // at the appropriate offset
        for(let c = 0; c < count; c++)for(let k = 0; k < itemSize; k++)iba[setters[k]](c, attribute[getters[k]](c));
    }
    return res;
}
function $5451ea62abbe5f68$export$4b7aa2f2134b7e19(attribute) {
    const cons = attribute.data.array.constructor;
    const count = attribute.count;
    const itemSize = attribute.itemSize;
    const normalized = attribute.normalized;
    const array = new cons(count * itemSize);
    let newAttribute;
    if (attribute.isInstancedInterleavedBufferAttribute) newAttribute = new (0, $d5b33d7c30034067$export$32ea87a8b54d744a)(array, itemSize, normalized, attribute.meshPerAttribute);
    else newAttribute = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(array, itemSize, normalized);
    for(let i = 0; i < count; i++){
        newAttribute.setX(i, attribute.getX(i));
        if (itemSize >= 2) newAttribute.setY(i, attribute.getY(i));
        if (itemSize >= 3) newAttribute.setZ(i, attribute.getZ(i));
        if (itemSize >= 4) newAttribute.setW(i, attribute.getW(i));
    }
    return newAttribute;
}
function $5451ea62abbe5f68$export$e7413b17bfaaa80b(geometry) {
    const attributes = geometry.attributes;
    const morphTargets = geometry.morphTargets;
    const attrMap = new Map();
    for(const key in attributes){
        const attr = attributes[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $5451ea62abbe5f68$export$4b7aa2f2134b7e19(attr));
            attributes[key] = attrMap.get(attr);
        }
    }
    for(const key in morphTargets){
        const attr = morphTargets[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $5451ea62abbe5f68$export$4b7aa2f2134b7e19(attr));
            morphTargets[key] = attrMap.get(attr);
        }
    }
}
/**
 * @param {Array<BufferGeometry>} geometry
 * @return {number}
 */ function $5451ea62abbe5f68$export$35bee7999e19754d(geometry) {
    // Return the estimated memory used by this geometry in bytes
    // Calculate using itemSize, count, and BYTES_PER_ELEMENT to account
    // for InterleavedBufferAttributes.
    let mem = 0;
    for(const name in geometry.attributes){
        const attr = geometry.getAttribute(name);
        mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
    }
    const indices = geometry.getIndex();
    mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
    return mem;
}
/**
 * @param {BufferGeometry} geometry
 * @param {number} tolerance
 * @return {BufferGeometry}
 */ function $5451ea62abbe5f68$export$e36bb98c4c944f9(geometry, tolerance = 1e-4) {
    tolerance = Math.max(tolerance, Number.EPSILON);
    // Generate an index buffer if the geometry doesn't have one, or optimize it
    // if it's already available.
    const hashToIndex = {};
    const indices = geometry.getIndex();
    const positions = geometry.getAttribute('position');
    const vertexCount = indices ? indices.count : positions.count;
    // next value for triangle indices
    let nextIndex = 0;
    // attributes and new attribute arrays
    const attributeNames = Object.keys(geometry.attributes);
    const tmpAttributes = {};
    const tmpMorphAttributes = {};
    const newIndices = [];
    const getters = [
        'getX',
        'getY',
        'getZ',
        'getW'
    ];
    const setters = [
        'setX',
        'setY',
        'setZ',
        'setW'
    ];
    // Initialize the arrays, allocating space conservatively. Extra
    // space will be trimmed in the last step.
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        const attr = geometry.attributes[name];
        tmpAttributes[name] = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(new attr.array.constructor(attr.count * attr.itemSize), attr.itemSize, attr.normalized);
        const morphAttr = geometry.morphAttributes[name];
        if (morphAttr) tmpMorphAttributes[name] = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(new morphAttr.array.constructor(morphAttr.count * morphAttr.itemSize), morphAttr.itemSize, morphAttr.normalized);
    }
    // convert the error tolerance to an amount of decimal places to truncate to
    const decimalShift = Math.log10(1 / tolerance);
    const shiftMultiplier = Math.pow(10, decimalShift);
    for(let i = 0; i < vertexCount; i++){
        const index = indices ? indices.getX(i) : i;
        // Generate a hash for the vertex attributes at the current index 'i'
        let hash = '';
        for(let j = 0, l = attributeNames.length; j < l; j++){
            const name = attributeNames[j];
            const attribute = geometry.getAttribute(name);
            const itemSize = attribute.itemSize;
            for(let k = 0; k < itemSize; k++)// double tilde truncates the decimal value
            hash += `${~~(attribute[getters[k]](index) * shiftMultiplier)},`;
        }
        // Add another reference to the vertex if it's already
        // used by another index
        if (hash in hashToIndex) newIndices.push(hashToIndex[hash]);
        else {
            // copy data to the new index in the temporary attributes
            for(let j = 0, l = attributeNames.length; j < l; j++){
                const name = attributeNames[j];
                const attribute = geometry.getAttribute(name);
                const morphAttr = geometry.morphAttributes[name];
                const itemSize = attribute.itemSize;
                const newarray = tmpAttributes[name];
                const newMorphArrays = tmpMorphAttributes[name];
                for(let k = 0; k < itemSize; k++){
                    const getterFunc = getters[k];
                    const setterFunc = setters[k];
                    newarray[setterFunc](nextIndex, attribute[getterFunc](index));
                    if (morphAttr) for(let m = 0, ml = morphAttr.length; m < ml; m++)newMorphArrays[m][setterFunc](nextIndex, morphAttr[m][getterFunc](index));
                }
            }
            hashToIndex[hash] = nextIndex;
            newIndices.push(nextIndex);
            nextIndex++;
        }
    }
    // generate result BufferGeometry
    const result = geometry.clone();
    for(const name in geometry.attributes){
        const tmpAttribute = tmpAttributes[name];
        result.setAttribute(name, new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(tmpAttribute.array.slice(0, nextIndex * tmpAttribute.itemSize), tmpAttribute.itemSize, tmpAttribute.normalized));
        if (!(name in tmpMorphAttributes)) continue;
        for(let j = 0; j < tmpMorphAttributes[name].length; j++){
            const tmpMorphAttribute = tmpMorphAttributes[name][j];
            result.morphAttributes[name][j] = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(tmpMorphAttribute.array.slice(0, nextIndex * tmpMorphAttribute.itemSize), tmpMorphAttribute.itemSize, tmpMorphAttribute.normalized);
        }
    }
    // indices
    result.setIndex(newIndices);
    return result;
}
/**
 * @param {BufferGeometry} geometry
 * @param {number} drawMode
 * @return {BufferGeometry}
 */ function $5451ea62abbe5f68$export$5492ca6e5c0c7aa0(geometry, drawMode) {
    if (drawMode === (0, $d5b33d7c30034067$export$4c28c87c2dc84758)) {
        console.warn('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.');
        return geometry;
    }
    if (drawMode === (0, $d5b33d7c30034067$export$f0d8293634f88842) || drawMode === (0, $d5b33d7c30034067$export$b23a071aa286eb29)) {
        let index = geometry.getIndex();
        // generate index if not present
        if (index === null) {
            const indices = [];
            const position = geometry.getAttribute('position');
            if (position !== undefined) {
                for(let i = 0; i < position.count; i++)indices.push(i);
                geometry.setIndex(indices);
                index = geometry.getIndex();
            } else {
                console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.');
                return geometry;
            }
        }
        //
        const numberOfTriangles = index.count - 2;
        const newIndices = [];
        if (drawMode === (0, $d5b33d7c30034067$export$f0d8293634f88842)) // gl.TRIANGLE_FAN
        for(let i = 1; i <= numberOfTriangles; i++){
            newIndices.push(index.getX(0));
            newIndices.push(index.getX(i));
            newIndices.push(index.getX(i + 1));
        }
        else {
            // gl.TRIANGLE_STRIP
            for(let i = 0; i < numberOfTriangles; i++)if (i % 2 === 0) {
                newIndices.push(index.getX(i));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i + 2));
            } else {
                newIndices.push(index.getX(i + 2));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i));
            }
        }
        if (newIndices.length / 3 !== numberOfTriangles) console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.');
        // build final geometry
        const newGeometry = geometry.clone();
        newGeometry.setIndex(newIndices);
        newGeometry.clearGroups();
        return newGeometry;
    } else {
        console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:', drawMode);
        return geometry;
    }
}
/**
 * Calculates the morphed attributes of a morphed/skinned BufferGeometry.
 * Helpful for Raytracing or Decals.
 * @param {Mesh | Line | Points} object An instance of Mesh, Line or Points.
 * @return {Object} An Object with original position/normal attributes and morphed ones.
 */ function $5451ea62abbe5f68$export$29e54e2e4ab904e7(object) {
    const _vA = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _vB = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _vC = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _tempA = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _tempB = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _tempC = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _morphA = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _morphB = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const _morphC = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    function _calculateMorphedAttributeData(object, attribute, morphAttribute, morphTargetsRelative, a, b, c, modifiedAttributeArray) {
        _vA.fromBufferAttribute(attribute, a);
        _vB.fromBufferAttribute(attribute, b);
        _vC.fromBufferAttribute(attribute, c);
        const morphInfluences = object.morphTargetInfluences;
        if (morphAttribute && morphInfluences) {
            _morphA.set(0, 0, 0);
            _morphB.set(0, 0, 0);
            _morphC.set(0, 0, 0);
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const influence = morphInfluences[i];
                const morph = morphAttribute[i];
                if (influence === 0) continue;
                _tempA.fromBufferAttribute(morph, a);
                _tempB.fromBufferAttribute(morph, b);
                _tempC.fromBufferAttribute(morph, c);
                if (morphTargetsRelative) {
                    _morphA.addScaledVector(_tempA, influence);
                    _morphB.addScaledVector(_tempB, influence);
                    _morphC.addScaledVector(_tempC, influence);
                } else {
                    _morphA.addScaledVector(_tempA.sub(_vA), influence);
                    _morphB.addScaledVector(_tempB.sub(_vB), influence);
                    _morphC.addScaledVector(_tempC.sub(_vC), influence);
                }
            }
            _vA.add(_morphA);
            _vB.add(_morphB);
            _vC.add(_morphC);
        }
        if (object.isSkinnedMesh) {
            object.applyBoneTransform(a, _vA);
            object.applyBoneTransform(b, _vB);
            object.applyBoneTransform(c, _vC);
        }
        modifiedAttributeArray[a * 3 + 0] = _vA.x;
        modifiedAttributeArray[a * 3 + 1] = _vA.y;
        modifiedAttributeArray[a * 3 + 2] = _vA.z;
        modifiedAttributeArray[b * 3 + 0] = _vB.x;
        modifiedAttributeArray[b * 3 + 1] = _vB.y;
        modifiedAttributeArray[b * 3 + 2] = _vB.z;
        modifiedAttributeArray[c * 3 + 0] = _vC.x;
        modifiedAttributeArray[c * 3 + 1] = _vC.y;
        modifiedAttributeArray[c * 3 + 2] = _vC.z;
    }
    const geometry = object.geometry;
    const material = object.material;
    let a, b, c;
    const index = geometry.index;
    const positionAttribute = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    const normalAttribute = geometry.attributes.normal;
    const morphNormal = geometry.morphAttributes.position;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;
    let i, j, il, jl;
    let group;
    let start, end;
    const modifiedPosition = new Float32Array(positionAttribute.count * positionAttribute.itemSize);
    const modifiedNormal = new Float32Array(normalAttribute.count * normalAttribute.itemSize);
    if (index !== null) {
        // indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = index.getX(j);
                b = index.getX(j + 1);
                c = index.getX(j + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(index.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = index.getX(i);
                b = index.getX(i + 1);
                c = index.getX(i + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    } else {
        // non-indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = j;
                b = j + 1;
                c = j + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = i;
                b = i + 1;
                c = i + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    }
    const morphedPositionAttribute = new (0, $d5b33d7c30034067$export$cbe7a62641830ebd)(modifiedPosition, 3);
    const morphedNormalAttribute = new (0, $d5b33d7c30034067$export$cbe7a62641830ebd)(modifiedNormal, 3);
    return {
        positionAttribute: positionAttribute,
        normalAttribute: normalAttribute,
        morphedPositionAttribute: morphedPositionAttribute,
        morphedNormalAttribute: morphedNormalAttribute
    };
}
function $5451ea62abbe5f68$export$8babbf41197098b1(geometry) {
    if (geometry.groups.length === 0) {
        console.warn('THREE.BufferGeometryUtils.mergeGroups(): No groups are defined. Nothing to merge.');
        return geometry;
    }
    let groups = geometry.groups;
    // sort groups by material index
    groups = groups.sort((a, b)=>{
        if (a.materialIndex !== b.materialIndex) return a.materialIndex - b.materialIndex;
        return a.start - b.start;
    });
    // create index for non-indexed geometries
    if (geometry.getIndex() === null) {
        const positionAttribute = geometry.getAttribute('position');
        const indices = [];
        for(let i = 0; i < positionAttribute.count; i += 3)indices.push(i, i + 1, i + 2);
        geometry.setIndex(indices);
    }
    // sort index
    const index = geometry.getIndex();
    const newIndices = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        const groupStart = group.start;
        const groupLength = groupStart + group.count;
        for(let j = groupStart; j < groupLength; j++)newIndices.push(index.getX(j));
    }
    geometry.dispose(); // Required to force buffer recreation
    geometry.setIndex(newIndices);
    // update groups indices
    let start = 0;
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        group.start = start;
        start += group.count;
    }
    // merge groups
    let currentGroup = groups[0];
    geometry.groups = [
        currentGroup
    ];
    for(let i = 1; i < groups.length; i++){
        const group = groups[i];
        if (currentGroup.materialIndex === group.materialIndex) currentGroup.count += group.count;
        else {
            currentGroup = group;
            geometry.groups.push(currentGroup);
        }
    }
    return geometry;
}
/**
 * Modifies the supplied geometry if it is non-indexed, otherwise creates a new,
 * non-indexed geometry. Returns the geometry with smooth normals everywhere except
 * faces that meet at an angle greater than the crease angle.
 *
 * @param {BufferGeometry} geometry
 * @param {number} [creaseAngle]
 * @return {BufferGeometry}
 */ function $5451ea62abbe5f68$export$b525764477fc001f(geometry, creaseAngle = Math.PI / 3 /* 60 degrees */ ) {
    const creaseDot = Math.cos(creaseAngle);
    const hashMultiplier = (1 + 1e-10) * 1e2;
    // reusable vectors
    const verts = [
        new (0, $d5b33d7c30034067$export$64b5c384219d3699)(),
        new (0, $d5b33d7c30034067$export$64b5c384219d3699)(),
        new (0, $d5b33d7c30034067$export$64b5c384219d3699)()
    ];
    const tempVec1 = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const tempVec2 = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const tempNorm = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    const tempNorm2 = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
    // hashes a vector
    function hashVertex(v) {
        const x = ~~(v.x * hashMultiplier);
        const y = ~~(v.y * hashMultiplier);
        const z = ~~(v.z * hashMultiplier);
        return `${x},${y},${z}`;
    }
    // BufferGeometry.toNonIndexed() warns if the geometry is non-indexed
    // and returns the original geometry
    const resultGeometry = geometry.index ? geometry.toNonIndexed() : geometry;
    const posAttr = resultGeometry.attributes.position;
    const vertexMap = {};
    // find all the normals shared by commonly located vertices
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        // add the normal to the map for all vertices
        const normal = new (0, $d5b33d7c30034067$export$64b5c384219d3699)().crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            if (!(hash in vertexMap)) vertexMap[hash] = [];
            vertexMap[hash].push(normal);
        }
    }
    // average normals from all vertices that share a common location if they are within the
    // provided crease threshold
    const normalArray = new Float32Array(posAttr.count * 3);
    const normAttr = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(normalArray, 3, false);
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        // get the face normal for this vertex
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        tempNorm.crossVectors(tempVec1, tempVec2).normalize();
        // average all normals that meet the threshold and set the normal value
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            const otherNormals = vertexMap[hash];
            tempNorm2.set(0, 0, 0);
            for(let k = 0, lk = otherNormals.length; k < lk; k++){
                const otherNorm = otherNormals[k];
                if (tempNorm.dot(otherNorm) > creaseDot) tempNorm2.add(otherNorm);
            }
            tempNorm2.normalize();
            normAttr.setXYZ(i3 + n, tempNorm2.x, tempNorm2.y, tempNorm2.z);
        }
    }
    resultGeometry.setAttribute('normal', normAttr);
    return resultGeometry;
}
function $5451ea62abbe5f68$export$728c051ccdf8a702(geometries, useGroups = false) {
    console.warn('THREE.BufferGeometryUtils: mergeBufferGeometries() has been renamed to mergeGeometries().'); // @deprecated, r151
    return $5451ea62abbe5f68$export$f06f69b3bf41d25c(geometries, useGroups);
}
function $5451ea62abbe5f68$export$c4eef4c1c9d34ea9(attributes) {
    console.warn('THREE.BufferGeometryUtils: mergeBufferAttributes() has been renamed to mergeAttributes().'); // @deprecated, r151
    return $5451ea62abbe5f68$export$9f98db6234c4bd78(attributes);
}


class $559434fcc6e6401d$export$aa93f11e7884f0f4 extends (0, $d5b33d7c30034067$export$3b0d6d7590275603) {
    constructor(manager){
        super(manager);
        this.dracoLoader = null;
        this.ktx2Loader = null;
        this.meshoptDecoder = null;
        this.pluginCallbacks = [];
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsClearcoatExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFTextureBasisUExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFTextureWebPExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFTextureAVIFExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsSheenExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsTransmissionExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsVolumeExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsIorExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsEmissiveStrengthExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsSpecularExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsIridescenceExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMaterialsAnisotropyExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFLightsExtension(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMeshoptCompression(parser);
        });
        this.register(function(parser) {
            return new $559434fcc6e6401d$var$GLTFMeshGpuInstancing(parser);
        });
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        let resourcePath;
        if (this.resourcePath !== '') resourcePath = this.resourcePath;
        else if (this.path !== '') resourcePath = this.path;
        else resourcePath = (0, $d5b33d7c30034067$export$b5d2dc08d867e41a).extractUrlBase(url);
        // Tells the LoadingManager to track an extra item, which resolves after
        // the model is fully loaded. This means the count of items loaded will
        // be incorrect, but ensures manager.onLoad() does not fire early.
        this.manager.itemStart(url);
        const _onError = function(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        };
        const loader = new (0, $d5b33d7c30034067$export$98435a25b5cf7b2b)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(data) {
            try {
                scope.parse(data, resourcePath, function(gltf) {
                    onLoad(gltf);
                    scope.manager.itemEnd(url);
                }, _onError);
            } catch (e) {
                _onError(e);
            }
        }, onProgress, _onError);
    }
    setDRACOLoader(dracoLoader) {
        this.dracoLoader = dracoLoader;
        return this;
    }
    setDDSLoader() {
        throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
    }
    setKTX2Loader(ktx2Loader) {
        this.ktx2Loader = ktx2Loader;
        return this;
    }
    setMeshoptDecoder(meshoptDecoder) {
        this.meshoptDecoder = meshoptDecoder;
        return this;
    }
    register(callback) {
        if (this.pluginCallbacks.indexOf(callback) === -1) this.pluginCallbacks.push(callback);
        return this;
    }
    unregister(callback) {
        if (this.pluginCallbacks.indexOf(callback) !== -1) this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
        return this;
    }
    parse(data, path, onLoad, onError) {
        let json;
        const extensions = {};
        const plugins = {};
        const textDecoder = new TextDecoder();
        if (typeof data === 'string') json = JSON.parse(data);
        else if (data instanceof ArrayBuffer) {
            const magic = textDecoder.decode(new Uint8Array(data, 0, 4));
            if (magic === $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_MAGIC) {
                try {
                    extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_BINARY_GLTF] = new $559434fcc6e6401d$var$GLTFBinaryExtension(data);
                } catch (error) {
                    if (onError) onError(error);
                    return;
                }
                json = JSON.parse(extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_BINARY_GLTF].content);
            } else json = JSON.parse(textDecoder.decode(data));
        } else json = data;
        if (json.asset === undefined || json.asset.version[0] < 2) {
            if (onError) onError(new Error('THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.'));
            return;
        }
        const parser = new $559434fcc6e6401d$var$GLTFParser(json, {
            path: path || this.resourcePath || '',
            crossOrigin: this.crossOrigin,
            requestHeader: this.requestHeader,
            manager: this.manager,
            ktx2Loader: this.ktx2Loader,
            meshoptDecoder: this.meshoptDecoder
        });
        parser.fileLoader.setRequestHeader(this.requestHeader);
        for(let i = 0; i < this.pluginCallbacks.length; i++){
            const plugin = this.pluginCallbacks[i](parser);
            plugins[plugin.name] = plugin;
            // Workaround to avoid determining as unknown extension
            // in addUnknownExtensionsToUserData().
            // Remove this workaround if we move all the existing
            // extension handlers to plugin system
            extensions[plugin.name] = true;
        }
        if (json.extensionsUsed) for(let i = 0; i < json.extensionsUsed.length; ++i){
            const extensionName = json.extensionsUsed[i];
            const extensionsRequired = json.extensionsRequired || [];
            switch(extensionName){
                case $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_UNLIT:
                    extensions[extensionName] = new $559434fcc6e6401d$var$GLTFMaterialsUnlitExtension();
                    break;
                case $559434fcc6e6401d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
                    extensions[extensionName] = new $559434fcc6e6401d$var$GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
                    break;
                case $559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM:
                    extensions[extensionName] = new $559434fcc6e6401d$var$GLTFTextureTransformExtension();
                    break;
                case $559434fcc6e6401d$var$EXTENSIONS.KHR_MESH_QUANTIZATION:
                    extensions[extensionName] = new $559434fcc6e6401d$var$GLTFMeshQuantizationExtension();
                    break;
                default:
                    if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === undefined) console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
            }
        }
        parser.setExtensions(extensions);
        parser.setPlugins(plugins);
        parser.parse(onLoad, onError);
    }
    parseAsync(data, path) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.parse(data, path, resolve, reject);
        });
    }
}
/* GLTFREGISTRY */ function $559434fcc6e6401d$var$GLTFRegistry() {
    let objects = {};
    return {
        get: function(key) {
            return objects[key];
        },
        add: function(key, object) {
            objects[key] = object;
        },
        remove: function(key) {
            delete objects[key];
        },
        removeAll: function() {
            objects = {};
        }
    };
}
/*********************************/ /********** EXTENSIONS ***********/ /*********************************/ const $559434fcc6e6401d$var$EXTENSIONS = {
    KHR_BINARY_GLTF: 'KHR_binary_glTF',
    KHR_DRACO_MESH_COMPRESSION: 'KHR_draco_mesh_compression',
    KHR_LIGHTS_PUNCTUAL: 'KHR_lights_punctual',
    KHR_MATERIALS_CLEARCOAT: 'KHR_materials_clearcoat',
    KHR_MATERIALS_IOR: 'KHR_materials_ior',
    KHR_MATERIALS_SHEEN: 'KHR_materials_sheen',
    KHR_MATERIALS_SPECULAR: 'KHR_materials_specular',
    KHR_MATERIALS_TRANSMISSION: 'KHR_materials_transmission',
    KHR_MATERIALS_IRIDESCENCE: 'KHR_materials_iridescence',
    KHR_MATERIALS_ANISOTROPY: 'KHR_materials_anisotropy',
    KHR_MATERIALS_UNLIT: 'KHR_materials_unlit',
    KHR_MATERIALS_VOLUME: 'KHR_materials_volume',
    KHR_TEXTURE_BASISU: 'KHR_texture_basisu',
    KHR_TEXTURE_TRANSFORM: 'KHR_texture_transform',
    KHR_MESH_QUANTIZATION: 'KHR_mesh_quantization',
    KHR_MATERIALS_EMISSIVE_STRENGTH: 'KHR_materials_emissive_strength',
    EXT_TEXTURE_WEBP: 'EXT_texture_webp',
    EXT_TEXTURE_AVIF: 'EXT_texture_avif',
    EXT_MESHOPT_COMPRESSION: 'EXT_meshopt_compression',
    EXT_MESH_GPU_INSTANCING: 'EXT_mesh_gpu_instancing'
};
/**
 * Punctual Lights Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_lights_punctual
 */ class $559434fcc6e6401d$var$GLTFLightsExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_LIGHTS_PUNCTUAL;
        // Object3D instance caches
        this.cache = {
            refs: {},
            uses: {}
        };
    }
    _markDefs() {
        const parser = this.parser;
        const nodeDefs = this.parser.json.nodes || [];
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== undefined) parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
        }
    }
    _loadLight(lightIndex) {
        const parser = this.parser;
        const cacheKey = 'light:' + lightIndex;
        let dependency = parser.cache.get(cacheKey);
        if (dependency) return dependency;
        const json = parser.json;
        const extensions = json.extensions && json.extensions[this.name] || {};
        const lightDefs = extensions.lights || [];
        const lightDef = lightDefs[lightIndex];
        let lightNode;
        const color = new (0, $d5b33d7c30034067$export$892596cec99bc70e)(0xffffff);
        if (lightDef.color !== undefined) color.setRGB(...lightDef.color, (0, $d5b33d7c30034067$export$42429b3acfb233a4));
        const range = lightDef.range !== undefined ? lightDef.range : 0;
        switch(lightDef.type){
            case 'directional':
                lightNode = new (0, $d5b33d7c30034067$export$3fea33cc9972c868)(color);
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            case 'point':
                lightNode = new (0, $d5b33d7c30034067$export$4c9c1cb3f0b6f455)(color);
                lightNode.distance = range;
                break;
            case 'spot':
                lightNode = new (0, $d5b33d7c30034067$export$81495cbb73897362)(color);
                lightNode.distance = range;
                // Handle spotlight properties.
                lightDef.spot = lightDef.spot || {};
                lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== undefined ? lightDef.spot.innerConeAngle : 0;
                lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== undefined ? lightDef.spot.outerConeAngle : Math.PI / 4.0;
                lightNode.angle = lightDef.spot.outerConeAngle;
                lightNode.penumbra = 1.0 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            default:
                throw new Error('THREE.GLTFLoader: Unexpected light type: ' + lightDef.type);
        }
        // Some lights (e.g. spot) default to a position other than the origin. Reset the position
        // here, because node-level parsing will only override position if explicitly specified.
        lightNode.position.set(0, 0, 0);
        lightNode.decay = 2;
        $559434fcc6e6401d$var$assignExtrasToUserData(lightNode, lightDef);
        if (lightDef.intensity !== undefined) lightNode.intensity = lightDef.intensity;
        lightNode.name = parser.createUniqueName(lightDef.name || 'light_' + lightIndex);
        dependency = Promise.resolve(lightNode);
        parser.cache.add(cacheKey, dependency);
        return dependency;
    }
    getDependency(type, index) {
        if (type !== 'light') return;
        return this._loadLight(index);
    }
    createNodeAttachment(nodeIndex) {
        const self1 = this;
        const parser = this.parser;
        const json = parser.json;
        const nodeDef = json.nodes[nodeIndex];
        const lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
        const lightIndex = lightDef.light;
        if (lightIndex === undefined) return null;
        return this._loadLight(lightIndex).then(function(light) {
            return parser._getNodeRef(self1.cache, lightIndex, light);
        });
    }
}
/**
 * Unlit Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_unlit
 */ class $559434fcc6e6401d$var$GLTFMaterialsUnlitExtension {
    constructor(){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_UNLIT;
    }
    getMaterialType() {
        return 0, $d5b33d7c30034067$export$55cbcc9b622fe1f5;
    }
    extendParams(materialParams, materialDef, parser) {
        const pending = [];
        materialParams.color = new (0, $d5b33d7c30034067$export$892596cec99bc70e)(1.0, 1.0, 1.0);
        materialParams.opacity = 1.0;
        const metallicRoughness = materialDef.pbrMetallicRoughness;
        if (metallicRoughness) {
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.setRGB(...array, (0, $d5b33d7c30034067$export$42429b3acfb233a4));
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'map', metallicRoughness.baseColorTexture, (0, $d5b33d7c30034067$export$561f394b24edfcaa)));
        }
        return Promise.all(pending);
    }
}
/**
 * Materials Emissive Strength Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/blob/5768b3ce0ef32bc39cdf1bef10b948586635ead3/extensions/2.0/Khronos/KHR_materials_emissive_strength/README.md
 */ class $559434fcc6e6401d$var$GLTFMaterialsEmissiveStrengthExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const emissiveStrength = materialDef.extensions[this.name].emissiveStrength;
        if (emissiveStrength !== undefined) materialParams.emissiveIntensity = emissiveStrength;
        return Promise.resolve();
    }
}
/**
 * Clearcoat Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_clearcoat
 */ class $559434fcc6e6401d$var$GLTFMaterialsClearcoatExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.clearcoatFactor !== undefined) materialParams.clearcoat = extension.clearcoatFactor;
        if (extension.clearcoatTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'clearcoatMap', extension.clearcoatTexture));
        if (extension.clearcoatRoughnessFactor !== undefined) materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
        if (extension.clearcoatRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'clearcoatRoughnessMap', extension.clearcoatRoughnessTexture));
        if (extension.clearcoatNormalTexture !== undefined) {
            pending.push(parser.assignTexture(materialParams, 'clearcoatNormalMap', extension.clearcoatNormalTexture));
            if (extension.clearcoatNormalTexture.scale !== undefined) {
                const scale = extension.clearcoatNormalTexture.scale;
                materialParams.clearcoatNormalScale = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)(scale, scale);
            }
        }
        return Promise.all(pending);
    }
}
/**
 * Iridescence Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_iridescence
 */ class $559434fcc6e6401d$var$GLTFMaterialsIridescenceExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.iridescenceFactor !== undefined) materialParams.iridescence = extension.iridescenceFactor;
        if (extension.iridescenceTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'iridescenceMap', extension.iridescenceTexture));
        if (extension.iridescenceIor !== undefined) materialParams.iridescenceIOR = extension.iridescenceIor;
        if (materialParams.iridescenceThicknessRange === undefined) materialParams.iridescenceThicknessRange = [
            100,
            400
        ];
        if (extension.iridescenceThicknessMinimum !== undefined) materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
        if (extension.iridescenceThicknessMaximum !== undefined) materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
        if (extension.iridescenceThicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'iridescenceThicknessMap', extension.iridescenceThicknessTexture));
        return Promise.all(pending);
    }
}
/**
 * Sheen Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_materials_sheen
 */ class $559434fcc6e6401d$var$GLTFMaterialsSheenExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_SHEEN;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        materialParams.sheenColor = new (0, $d5b33d7c30034067$export$892596cec99bc70e)(0, 0, 0);
        materialParams.sheenRoughness = 0;
        materialParams.sheen = 1;
        const extension = materialDef.extensions[this.name];
        if (extension.sheenColorFactor !== undefined) materialParams.sheenColor.setRGB(...extension.sheenColorFactor, (0, $d5b33d7c30034067$export$42429b3acfb233a4));
        if (extension.sheenRoughnessFactor !== undefined) materialParams.sheenRoughness = extension.sheenRoughnessFactor;
        if (extension.sheenColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'sheenColorMap', extension.sheenColorTexture, (0, $d5b33d7c30034067$export$561f394b24edfcaa)));
        if (extension.sheenRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'sheenRoughnessMap', extension.sheenRoughnessTexture));
        return Promise.all(pending);
    }
}
/**
 * Transmission Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_transmission
 * Draft: https://github.com/KhronosGroup/glTF/pull/1698
 */ class $559434fcc6e6401d$var$GLTFMaterialsTransmissionExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.transmissionFactor !== undefined) materialParams.transmission = extension.transmissionFactor;
        if (extension.transmissionTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'transmissionMap', extension.transmissionTexture));
        return Promise.all(pending);
    }
}
/**
 * Materials Volume Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_volume
 */ class $559434fcc6e6401d$var$GLTFMaterialsVolumeExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_VOLUME;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.thickness = extension.thicknessFactor !== undefined ? extension.thicknessFactor : 0;
        if (extension.thicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'thicknessMap', extension.thicknessTexture));
        materialParams.attenuationDistance = extension.attenuationDistance || Infinity;
        const colorArray = extension.attenuationColor || [
            1,
            1,
            1
        ];
        materialParams.attenuationColor = new (0, $d5b33d7c30034067$export$892596cec99bc70e)().setRGB(...colorArray, (0, $d5b33d7c30034067$export$42429b3acfb233a4));
        return Promise.all(pending);
    }
}
/**
 * Materials ior Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_ior
 */ class $559434fcc6e6401d$var$GLTFMaterialsIorExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_IOR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const extension = materialDef.extensions[this.name];
        materialParams.ior = extension.ior !== undefined ? extension.ior : 1.5;
        return Promise.resolve();
    }
}
/**
 * Materials specular Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_specular
 */ class $559434fcc6e6401d$var$GLTFMaterialsSpecularExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_SPECULAR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.specularIntensity = extension.specularFactor !== undefined ? extension.specularFactor : 1.0;
        if (extension.specularTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'specularIntensityMap', extension.specularTexture));
        const colorArray = extension.specularColorFactor || [
            1,
            1,
            1
        ];
        materialParams.specularColor = new (0, $d5b33d7c30034067$export$892596cec99bc70e)().setRGB(...colorArray, (0, $d5b33d7c30034067$export$42429b3acfb233a4));
        if (extension.specularColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'specularColorMap', extension.specularColorTexture, (0, $d5b33d7c30034067$export$561f394b24edfcaa)));
        return Promise.all(pending);
    }
}
/**
 * Materials anisotropy Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_anisotropy
 */ class $559434fcc6e6401d$var$GLTFMaterialsAnisotropyExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_ANISOTROPY;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $d5b33d7c30034067$export$28d04986c4269c9f;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.anisotropyStrength !== undefined) materialParams.anisotropy = extension.anisotropyStrength;
        if (extension.anisotropyRotation !== undefined) materialParams.anisotropyRotation = extension.anisotropyRotation;
        if (extension.anisotropyTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'anisotropyMap', extension.anisotropyTexture));
        return Promise.all(pending);
    }
}
/**
 * BasisU Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_basisu
 */ class $559434fcc6e6401d$var$GLTFTextureBasisUExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_BASISU;
    }
    loadTexture(textureIndex) {
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[this.name]) return null;
        const extension = textureDef.extensions[this.name];
        const loader = parser.options.ktx2Loader;
        if (!loader) {
            if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error('THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures');
            else // Assumes that the extension is optional and that a fallback texture is present
            return null;
        }
        return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
}
/**
 * WebP Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_webp
 */ class $559434fcc6e6401d$var$GLTFTextureWebPExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.EXT_TEXTURE_WEBP;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error('THREE.GLTFLoader: WebP required by asset but unsupported.');
            // Fall back to PNG or JPEG.
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            // Lossy test image. Support for lossy images doesn't guarantee support for all
            // WebP images, unfortunately.
            image.src = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
/**
 * AVIF Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_avif
 */ class $559434fcc6e6401d$var$GLTFTextureAVIFExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $559434fcc6e6401d$var$EXTENSIONS.EXT_TEXTURE_AVIF;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error('THREE.GLTFLoader: AVIF required by asset but unsupported.');
            // Fall back to PNG or JPEG.
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            // Lossy test image.
            image.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=';
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
/**
 * meshopt BufferView Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_meshopt_compression
 */ class $559434fcc6e6401d$var$GLTFMeshoptCompression {
    constructor(parser){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.EXT_MESHOPT_COMPRESSION;
        this.parser = parser;
    }
    loadBufferView(index) {
        const json = this.parser.json;
        const bufferView = json.bufferViews[index];
        if (bufferView.extensions && bufferView.extensions[this.name]) {
            const extensionDef = bufferView.extensions[this.name];
            const buffer = this.parser.getDependency('buffer', extensionDef.buffer);
            const decoder = this.parser.options.meshoptDecoder;
            if (!decoder || !decoder.supported) {
                if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error('THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files');
                else // Assumes that the extension is optional and that fallback buffer data is present
                return null;
            }
            return buffer.then(function(res) {
                const byteOffset = extensionDef.byteOffset || 0;
                const byteLength = extensionDef.byteLength || 0;
                const count = extensionDef.count;
                const stride = extensionDef.byteStride;
                const source = new Uint8Array(res, byteOffset, byteLength);
                if (decoder.decodeGltfBufferAsync) return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function(res) {
                    return res.buffer;
                });
                else // Support for MeshoptDecoder 0.18 or earlier, without decodeGltfBufferAsync
                return decoder.ready.then(function() {
                    const result = new ArrayBuffer(count * stride);
                    decoder.decodeGltfBuffer(new Uint8Array(result), count, stride, source, extensionDef.mode, extensionDef.filter);
                    return result;
                });
            });
        } else return null;
    }
}
/**
 * GPU Instancing Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_mesh_gpu_instancing
 *
 */ class $559434fcc6e6401d$var$GLTFMeshGpuInstancing {
    constructor(parser){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.EXT_MESH_GPU_INSTANCING;
        this.parser = parser;
    }
    createNodeMesh(nodeIndex) {
        const json = this.parser.json;
        const nodeDef = json.nodes[nodeIndex];
        if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === undefined) return null;
        const meshDef = json.meshes[nodeDef.mesh];
        // No Points or Lines + Instancing support yet
        for (const primitive of meshDef.primitives){
            if (primitive.mode !== $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== undefined) return null;
        }
        const extensionDef = nodeDef.extensions[this.name];
        const attributesDef = extensionDef.attributes;
        // @TODO: Can we support InstancedMesh + SkinnedMesh?
        const pending = [];
        const attributes = {};
        for(const key in attributesDef)pending.push(this.parser.getDependency('accessor', attributesDef[key]).then((accessor)=>{
            attributes[key] = accessor;
            return attributes[key];
        }));
        if (pending.length < 1) return null;
        pending.push(this.parser.createNodeMesh(nodeIndex));
        return Promise.all(pending).then((results)=>{
            const nodeObject = results.pop();
            const meshes = nodeObject.isGroup ? nodeObject.children : [
                nodeObject
            ];
            const count = results[0].count; // All attribute counts should be same
            const instancedMeshes = [];
            for (const mesh of meshes){
                // Temporal variables
                const m = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
                const p = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
                const q = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)();
                const s = new (0, $d5b33d7c30034067$export$64b5c384219d3699)(1, 1, 1);
                const instancedMesh = new (0, $d5b33d7c30034067$export$f3c979c331175ad7)(mesh.geometry, mesh.material, count);
                for(let i = 0; i < count; i++){
                    if (attributes.TRANSLATION) p.fromBufferAttribute(attributes.TRANSLATION, i);
                    if (attributes.ROTATION) q.fromBufferAttribute(attributes.ROTATION, i);
                    if (attributes.SCALE) s.fromBufferAttribute(attributes.SCALE, i);
                    instancedMesh.setMatrixAt(i, m.compose(p, q, s));
                }
                // Add instance attributes to the geometry, excluding TRS.
                for(const attributeName in attributes)if (attributeName !== 'TRANSLATION' && attributeName !== 'ROTATION' && attributeName !== 'SCALE') mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
                // Just in case
                (0, $d5b33d7c30034067$export$e4dd07dff30cc924).prototype.copy.call(instancedMesh, mesh);
                this.parser.assignFinalMaterial(instancedMesh);
                instancedMeshes.push(instancedMesh);
            }
            if (nodeObject.isGroup) {
                nodeObject.clear();
                nodeObject.add(...instancedMeshes);
                return nodeObject;
            }
            return instancedMeshes[0];
        });
    }
}
/* BINARY EXTENSION */ const $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_MAGIC = 'glTF';
const $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH = 12;
const $559434fcc6e6401d$var$BINARY_EXTENSION_CHUNK_TYPES = {
    JSON: 0x4E4F534A,
    BIN: 0x004E4942
};
class $559434fcc6e6401d$var$GLTFBinaryExtension {
    constructor(data){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_BINARY_GLTF;
        this.content = null;
        this.body = null;
        const headerView = new DataView(data, 0, $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH);
        const textDecoder = new TextDecoder();
        this.header = {
            magic: textDecoder.decode(new Uint8Array(data.slice(0, 4))),
            version: headerView.getUint32(4, true),
            length: headerView.getUint32(8, true)
        };
        if (this.header.magic !== $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_MAGIC) throw new Error('THREE.GLTFLoader: Unsupported glTF-Binary header.');
        else if (this.header.version < 2.0) throw new Error('THREE.GLTFLoader: Legacy binary file detected.');
        const chunkContentsLength = this.header.length - $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH;
        const chunkView = new DataView(data, $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH);
        let chunkIndex = 0;
        while(chunkIndex < chunkContentsLength){
            const chunkLength = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            const chunkType = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            if (chunkType === $559434fcc6e6401d$var$BINARY_EXTENSION_CHUNK_TYPES.JSON) {
                const contentArray = new Uint8Array(data, $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
                this.content = textDecoder.decode(contentArray);
            } else if (chunkType === $559434fcc6e6401d$var$BINARY_EXTENSION_CHUNK_TYPES.BIN) {
                const byteOffset = $559434fcc6e6401d$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
                this.body = data.slice(byteOffset, byteOffset + chunkLength);
            }
            // Clients must ignore chunks with unknown types.
            chunkIndex += chunkLength;
        }
        if (this.content === null) throw new Error('THREE.GLTFLoader: JSON content not found.');
    }
}
/**
 * DRACO Mesh Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_draco_mesh_compression
 */ class $559434fcc6e6401d$var$GLTFDracoMeshCompressionExtension {
    constructor(json, dracoLoader){
        if (!dracoLoader) throw new Error('THREE.GLTFLoader: No DRACOLoader instance provided.');
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
        this.json = json;
        this.dracoLoader = dracoLoader;
        this.dracoLoader.preload();
    }
    decodePrimitive(primitive, parser) {
        const json = this.json;
        const dracoLoader = this.dracoLoader;
        const bufferViewIndex = primitive.extensions[this.name].bufferView;
        const gltfAttributeMap = primitive.extensions[this.name].attributes;
        const threeAttributeMap = {};
        const attributeNormalizedMap = {};
        const attributeTypeMap = {};
        for(const attributeName in gltfAttributeMap){
            const threeAttributeName = $559434fcc6e6401d$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
        }
        for(const attributeName in primitive.attributes){
            const threeAttributeName = $559434fcc6e6401d$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            if (gltfAttributeMap[attributeName] !== undefined) {
                const accessorDef = json.accessors[primitive.attributes[attributeName]];
                const componentType = $559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
                attributeTypeMap[threeAttributeName] = componentType.name;
                attributeNormalizedMap[threeAttributeName] = accessorDef.normalized === true;
            }
        }
        return parser.getDependency('bufferView', bufferViewIndex).then(function(bufferView) {
            return new Promise(function(resolve) {
                dracoLoader.decodeDracoFile(bufferView, function(geometry) {
                    for(const attributeName in geometry.attributes){
                        const attribute = geometry.attributes[attributeName];
                        const normalized = attributeNormalizedMap[attributeName];
                        if (normalized !== undefined) attribute.normalized = normalized;
                    }
                    resolve(geometry);
                }, threeAttributeMap, attributeTypeMap);
            });
        });
    }
}
/**
 * Texture Transform Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_transform
 */ class $559434fcc6e6401d$var$GLTFTextureTransformExtension {
    constructor(){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM;
    }
    extendTexture(texture, transform) {
        if ((transform.texCoord === undefined || transform.texCoord === texture.channel) && transform.offset === undefined && transform.rotation === undefined && transform.scale === undefined) // See https://github.com/mrdoob/three.js/issues/21819.
        return texture;
        texture = texture.clone();
        if (transform.texCoord !== undefined) texture.channel = transform.texCoord;
        if (transform.offset !== undefined) texture.offset.fromArray(transform.offset);
        if (transform.rotation !== undefined) texture.rotation = transform.rotation;
        if (transform.scale !== undefined) texture.repeat.fromArray(transform.scale);
        texture.needsUpdate = true;
        return texture;
    }
}
/**
 * Mesh Quantization Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization
 */ class $559434fcc6e6401d$var$GLTFMeshQuantizationExtension {
    constructor(){
        this.name = $559434fcc6e6401d$var$EXTENSIONS.KHR_MESH_QUANTIZATION;
    }
}
/*********************************/ /********** INTERPOLATION ********/ /*********************************/ // Spline Interpolation
// Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#appendix-c-spline-interpolation
class $559434fcc6e6401d$var$GLTFCubicSplineInterpolant extends (0, $d5b33d7c30034067$export$b558baee9c0f72d3) {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    copySampleValue_(index) {
        // Copies a sample value to the result buffer. See description of glTF
        // CUBICSPLINE values layout in interpolate_() function below.
        const result = this.resultBuffer, values = this.sampleValues, valueSize = this.valueSize, offset = index * valueSize * 3 + valueSize;
        for(let i = 0; i !== valueSize; i++)result[i] = values[offset + i];
        return result;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer;
        const values = this.sampleValues;
        const stride = this.valueSize;
        const stride2 = stride * 2;
        const stride3 = stride * 3;
        const td = t1 - t0;
        const p = (t - t0) / td;
        const pp = p * p;
        const ppp = pp * p;
        const offset1 = i1 * stride3;
        const offset0 = offset1 - stride3;
        const s2 = -2 * ppp + 3 * pp;
        const s3 = ppp - pp;
        const s0 = 1 - s2;
        const s1 = s3 - pp + p;
        // Layout of keyframe output values for CUBICSPLINE animations:
        //   [ inTangent_1, splineVertex_1, outTangent_1, inTangent_2, splineVertex_2, ... ]
        for(let i = 0; i !== stride; i++){
            const p0 = values[offset0 + i + stride]; // splineVertex_k
            const m0 = values[offset0 + i + stride2] * td; // outTangent_k * (t_k+1 - t_k)
            const p1 = values[offset1 + i + stride]; // splineVertex_k+1
            const m1 = values[offset1 + i] * td; // inTangent_k+1 * (t_k+1 - t_k)
            result[i] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
        }
        return result;
    }
}
const $559434fcc6e6401d$var$_q = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)();
class $559434fcc6e6401d$var$GLTFCubicSplineQuaternionInterpolant extends $559434fcc6e6401d$var$GLTFCubicSplineInterpolant {
    interpolate_(i1, t0, t, t1) {
        const result = super.interpolate_(i1, t0, t, t1);
        $559434fcc6e6401d$var$_q.fromArray(result).normalize().toArray(result);
        return result;
    }
}
/*********************************/ /********** INTERNALS ************/ /*********************************/ /* CONSTANTS */ const $559434fcc6e6401d$var$WEBGL_CONSTANTS = {
    FLOAT: 5126,
    //FLOAT_MAT2: 35674,
    FLOAT_MAT3: 35675,
    FLOAT_MAT4: 35676,
    FLOAT_VEC2: 35664,
    FLOAT_VEC3: 35665,
    FLOAT_VEC4: 35666,
    LINEAR: 9729,
    REPEAT: 10497,
    SAMPLER_2D: 35678,
    POINTS: 0,
    LINES: 1,
    LINE_LOOP: 2,
    LINE_STRIP: 3,
    TRIANGLES: 4,
    TRIANGLE_STRIP: 5,
    TRIANGLE_FAN: 6,
    UNSIGNED_BYTE: 5121,
    UNSIGNED_SHORT: 5123
};
const $559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
};
const $559434fcc6e6401d$var$WEBGL_FILTERS = {
    9728: (0, $d5b33d7c30034067$export$727aa5ec3fe39bf0),
    9729: (0, $d5b33d7c30034067$export$8a72f490b25c56c8),
    9984: (0, $d5b33d7c30034067$export$d129e38cf6feaa8c),
    9985: (0, $d5b33d7c30034067$export$19a719f377145a13),
    9986: (0, $d5b33d7c30034067$export$d2327c1afe5bfdf2),
    9987: (0, $d5b33d7c30034067$export$5d8599b6a933fb1b)
};
const $559434fcc6e6401d$var$WEBGL_WRAPPINGS = {
    33071: (0, $d5b33d7c30034067$export$9d9334239a5a5e06),
    33648: (0, $d5b33d7c30034067$export$c7e7c00b14f51a4f),
    10497: (0, $d5b33d7c30034067$export$533346c8e8dac0f5)
};
const $559434fcc6e6401d$var$WEBGL_TYPE_SIZES = {
    'SCALAR': 1,
    'VEC2': 2,
    'VEC3': 3,
    'VEC4': 4,
    'MAT2': 4,
    'MAT3': 9,
    'MAT4': 16
};
const $559434fcc6e6401d$var$ATTRIBUTES = {
    POSITION: 'position',
    NORMAL: 'normal',
    TANGENT: 'tangent',
    TEXCOORD_0: 'uv',
    TEXCOORD_1: 'uv1',
    TEXCOORD_2: 'uv2',
    TEXCOORD_3: 'uv3',
    COLOR_0: 'color',
    WEIGHTS_0: 'skinWeight',
    JOINTS_0: 'skinIndex'
};
const $559434fcc6e6401d$var$PATH_PROPERTIES = {
    scale: 'scale',
    translation: 'position',
    rotation: 'quaternion',
    weights: 'morphTargetInfluences'
};
const $559434fcc6e6401d$var$INTERPOLATION = {
    CUBICSPLINE: undefined,
    // keyframe track will be initialized with a default interpolation type, then modified.
    LINEAR: (0, $d5b33d7c30034067$export$30fac1aace31cf4d),
    STEP: (0, $d5b33d7c30034067$export$995b32462a65e855)
};
const $559434fcc6e6401d$var$ALPHA_MODES = {
    OPAQUE: 'OPAQUE',
    MASK: 'MASK',
    BLEND: 'BLEND'
};
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#default-material
 */ function $559434fcc6e6401d$var$createDefaultMaterial(cache) {
    if (cache['DefaultMaterial'] === undefined) cache['DefaultMaterial'] = new (0, $d5b33d7c30034067$export$f2980790215acccd)({
        color: 0xFFFFFF,
        emissive: 0x000000,
        metalness: 1,
        roughness: 1,
        transparent: false,
        depthTest: true,
        side: (0, $d5b33d7c30034067$export$2ede184fc2998901)
    });
    return cache['DefaultMaterial'];
}
function $559434fcc6e6401d$var$addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
    // Add unknown glTF extensions to an object's userData.
    for(const name in objectDef.extensions)if (knownExtensions[name] === undefined) {
        object.userData.gltfExtensions = object.userData.gltfExtensions || {};
        object.userData.gltfExtensions[name] = objectDef.extensions[name];
    }
}
/**
 * @param {Object3D|Material|BufferGeometry} object
 * @param {GLTF.definition} gltfDef
 */ function $559434fcc6e6401d$var$assignExtrasToUserData(object, gltfDef) {
    if (gltfDef.extras !== undefined) {
        if (typeof gltfDef.extras === 'object') Object.assign(object.userData, gltfDef.extras);
        else console.warn('THREE.GLTFLoader: Ignoring primitive type .extras, ' + gltfDef.extras);
    }
}
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#morph-targets
 *
 * @param {BufferGeometry} geometry
 * @param {Array<GLTF.Target>} targets
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $559434fcc6e6401d$var$addMorphTargets(geometry, targets, parser) {
    let hasMorphPosition = false;
    let hasMorphNormal = false;
    let hasMorphColor = false;
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (target.POSITION !== undefined) hasMorphPosition = true;
        if (target.NORMAL !== undefined) hasMorphNormal = true;
        if (target.COLOR_0 !== undefined) hasMorphColor = true;
        if (hasMorphPosition && hasMorphNormal && hasMorphColor) break;
    }
    if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor) return Promise.resolve(geometry);
    const pendingPositionAccessors = [];
    const pendingNormalAccessors = [];
    const pendingColorAccessors = [];
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (hasMorphPosition) {
            const pendingAccessor = target.POSITION !== undefined ? parser.getDependency('accessor', target.POSITION) : geometry.attributes.position;
            pendingPositionAccessors.push(pendingAccessor);
        }
        if (hasMorphNormal) {
            const pendingAccessor = target.NORMAL !== undefined ? parser.getDependency('accessor', target.NORMAL) : geometry.attributes.normal;
            pendingNormalAccessors.push(pendingAccessor);
        }
        if (hasMorphColor) {
            const pendingAccessor = target.COLOR_0 !== undefined ? parser.getDependency('accessor', target.COLOR_0) : geometry.attributes.color;
            pendingColorAccessors.push(pendingAccessor);
        }
    }
    return Promise.all([
        Promise.all(pendingPositionAccessors),
        Promise.all(pendingNormalAccessors),
        Promise.all(pendingColorAccessors)
    ]).then(function(accessors) {
        const morphPositions = accessors[0];
        const morphNormals = accessors[1];
        const morphColors = accessors[2];
        if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
        if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;
        if (hasMorphColor) geometry.morphAttributes.color = morphColors;
        geometry.morphTargetsRelative = true;
        return geometry;
    });
}
/**
 * @param {Mesh} mesh
 * @param {GLTF.Mesh} meshDef
 */ function $559434fcc6e6401d$var$updateMorphTargets(mesh, meshDef) {
    mesh.updateMorphTargets();
    if (meshDef.weights !== undefined) for(let i = 0, il = meshDef.weights.length; i < il; i++)mesh.morphTargetInfluences[i] = meshDef.weights[i];
    // .extras has user-defined data, so check that .extras.targetNames is an array.
    if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
        const targetNames = meshDef.extras.targetNames;
        if (mesh.morphTargetInfluences.length === targetNames.length) {
            mesh.morphTargetDictionary = {};
            for(let i = 0, il = targetNames.length; i < il; i++)mesh.morphTargetDictionary[targetNames[i]] = i;
        } else console.warn('THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.');
    }
}
function $559434fcc6e6401d$var$createPrimitiveKey(primitiveDef) {
    let geometryKey;
    const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
    if (dracoExtension) geometryKey = 'draco:' + dracoExtension.bufferView + ':' + dracoExtension.indices + ':' + $559434fcc6e6401d$var$createAttributesKey(dracoExtension.attributes);
    else geometryKey = primitiveDef.indices + ':' + $559434fcc6e6401d$var$createAttributesKey(primitiveDef.attributes) + ':' + primitiveDef.mode;
    if (primitiveDef.targets !== undefined) for(let i = 0, il = primitiveDef.targets.length; i < il; i++)geometryKey += ':' + $559434fcc6e6401d$var$createAttributesKey(primitiveDef.targets[i]);
    return geometryKey;
}
function $559434fcc6e6401d$var$createAttributesKey(attributes) {
    let attributesKey = '';
    const keys = Object.keys(attributes).sort();
    for(let i = 0, il = keys.length; i < il; i++)attributesKey += keys[i] + ':' + attributes[keys[i]] + ';';
    return attributesKey;
}
function $559434fcc6e6401d$var$getNormalizedComponentScale(constructor) {
    // Reference:
    // https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization#encoding-quantized-data
    switch(constructor){
        case Int8Array:
            return 1 / 127;
        case Uint8Array:
            return 1 / 255;
        case Int16Array:
            return 1 / 32767;
        case Uint16Array:
            return 1 / 65535;
        default:
            throw new Error('THREE.GLTFLoader: Unsupported normalized accessor component type.');
    }
}
function $559434fcc6e6401d$var$getImageURIMimeType(uri) {
    if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0) return 'image/jpeg';
    if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0) return 'image/webp';
    return 'image/png';
}
const $559434fcc6e6401d$var$_identityMatrix = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
/* GLTF PARSER */ class $559434fcc6e6401d$var$GLTFParser {
    constructor(json = {}, options = {}){
        this.json = json;
        this.extensions = {};
        this.plugins = {};
        this.options = options;
        // loader object cache
        this.cache = new $559434fcc6e6401d$var$GLTFRegistry();
        // associations between Three.js objects and glTF elements
        this.associations = new Map();
        // BufferGeometry caching
        this.primitiveCache = {};
        // Node cache
        this.nodeCache = {};
        // Object3D instance caches
        this.meshCache = {
            refs: {},
            uses: {}
        };
        this.cameraCache = {
            refs: {},
            uses: {}
        };
        this.lightCache = {
            refs: {},
            uses: {}
        };
        this.sourceCache = {};
        this.textureCache = {};
        // Track node names, to ensure no duplicates
        this.nodeNamesUsed = {};
        // Use an ImageBitmapLoader if imageBitmaps are supported. Moves much of the
        // expensive work of uploading a texture to the GPU off the main thread.
        let isSafari = false;
        let isFirefox = false;
        let firefoxVersion = -1;
        if (typeof navigator !== 'undefined') {
            isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === true;
            isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
            firefoxVersion = isFirefox ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
        }
        if (typeof createImageBitmap === 'undefined' || isSafari || isFirefox && firefoxVersion < 98) this.textureLoader = new (0, $d5b33d7c30034067$export$fd1bfc71f64c538c)(this.options.manager);
        else this.textureLoader = new (0, $d5b33d7c30034067$export$52286b55c4a9b51f)(this.options.manager);
        this.textureLoader.setCrossOrigin(this.options.crossOrigin);
        this.textureLoader.setRequestHeader(this.options.requestHeader);
        this.fileLoader = new (0, $d5b33d7c30034067$export$98435a25b5cf7b2b)(this.options.manager);
        this.fileLoader.setResponseType('arraybuffer');
        if (this.options.crossOrigin === 'use-credentials') this.fileLoader.setWithCredentials(true);
    }
    setExtensions(extensions) {
        this.extensions = extensions;
    }
    setPlugins(plugins) {
        this.plugins = plugins;
    }
    parse(onLoad, onError) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        // Clear the loader cache
        this.cache.removeAll();
        this.nodeCache = {};
        // Mark the special nodes/meshes in json for efficient parse
        this._invokeAll(function(ext) {
            return ext._markDefs && ext._markDefs();
        });
        Promise.all(this._invokeAll(function(ext) {
            return ext.beforeRoot && ext.beforeRoot();
        })).then(function() {
            return Promise.all([
                parser.getDependencies('scene'),
                parser.getDependencies('animation'),
                parser.getDependencies('camera')
            ]);
        }).then(function(dependencies) {
            const result = {
                scene: dependencies[0][json.scene || 0],
                scenes: dependencies[0],
                animations: dependencies[1],
                cameras: dependencies[2],
                asset: json.asset,
                parser: parser,
                userData: {}
            };
            $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, result, json);
            $559434fcc6e6401d$var$assignExtrasToUserData(result, json);
            Promise.all(parser._invokeAll(function(ext) {
                return ext.afterRoot && ext.afterRoot(result);
            })).then(function() {
                onLoad(result);
            });
        }).catch(onError);
    }
    /**
	 * Marks the special nodes/meshes in json for efficient parse.
	 */ _markDefs() {
        const nodeDefs = this.json.nodes || [];
        const skinDefs = this.json.skins || [];
        const meshDefs = this.json.meshes || [];
        // Nothing in the node definition indicates whether it is a Bone or an
        // Object3D. Use the skins' joint references to mark bones.
        for(let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++){
            const joints = skinDefs[skinIndex].joints;
            for(let i = 0, il = joints.length; i < il; i++)nodeDefs[joints[i]].isBone = true;
        }
        // Iterate over all nodes, marking references to shared resources,
        // as well as skeleton joints.
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.mesh !== undefined) {
                this._addNodeRef(this.meshCache, nodeDef.mesh);
                // Nothing in the mesh definition indicates whether it is
                // a SkinnedMesh or Mesh. Use the node's mesh reference
                // to mark SkinnedMesh if node has skin.
                if (nodeDef.skin !== undefined) meshDefs[nodeDef.mesh].isSkinnedMesh = true;
            }
            if (nodeDef.camera !== undefined) this._addNodeRef(this.cameraCache, nodeDef.camera);
        }
    }
    /**
	 * Counts references to shared node / Object3D resources. These resources
	 * can be reused, or "instantiated", at multiple nodes in the scene
	 * hierarchy. Mesh, Camera, and Light instances are instantiated and must
	 * be marked. Non-scenegraph resources (like Materials, Geometries, and
	 * Textures) can be reused directly and are not marked here.
	 *
	 * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
	 */ _addNodeRef(cache, index) {
        if (index === undefined) return;
        if (cache.refs[index] === undefined) cache.refs[index] = cache.uses[index] = 0;
        cache.refs[index]++;
    }
    /** Returns a reference to a shared resource, cloning it if necessary. */ _getNodeRef(cache, index, object) {
        if (cache.refs[index] <= 1) return object;
        const ref = object.clone();
        // Propagates mappings to the cloned object, prevents mappings on the
        // original object from being lost.
        const updateMappings = (original, clone)=>{
            const mappings = this.associations.get(original);
            if (mappings != null) this.associations.set(clone, mappings);
            for (const [i, child] of original.children.entries())updateMappings(child, clone.children[i]);
        };
        updateMappings(object, ref);
        ref.name += '_instance_' + cache.uses[index]++;
        return ref;
    }
    _invokeOne(func) {
        const extensions = Object.values(this.plugins);
        extensions.push(this);
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) return result;
        }
        return null;
    }
    _invokeAll(func) {
        const extensions = Object.values(this.plugins);
        extensions.unshift(this);
        const pending = [];
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) pending.push(result);
        }
        return pending;
    }
    /**
	 * Requests the specified dependency asynchronously, with caching.
	 * @param {string} type
	 * @param {number} index
	 * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
	 */ getDependency(type, index) {
        const cacheKey = type + ':' + index;
        let dependency = this.cache.get(cacheKey);
        if (!dependency) {
            switch(type){
                case 'scene':
                    dependency = this.loadScene(index);
                    break;
                case 'node':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadNode && ext.loadNode(index);
                    });
                    break;
                case 'mesh':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMesh && ext.loadMesh(index);
                    });
                    break;
                case 'accessor':
                    dependency = this.loadAccessor(index);
                    break;
                case 'bufferView':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadBufferView && ext.loadBufferView(index);
                    });
                    break;
                case 'buffer':
                    dependency = this.loadBuffer(index);
                    break;
                case 'material':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMaterial && ext.loadMaterial(index);
                    });
                    break;
                case 'texture':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadTexture && ext.loadTexture(index);
                    });
                    break;
                case 'skin':
                    dependency = this.loadSkin(index);
                    break;
                case 'animation':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadAnimation && ext.loadAnimation(index);
                    });
                    break;
                case 'camera':
                    dependency = this.loadCamera(index);
                    break;
                default:
                    dependency = this._invokeOne(function(ext) {
                        return ext != this && ext.getDependency && ext.getDependency(type, index);
                    });
                    if (!dependency) throw new Error('Unknown type: ' + type);
                    break;
            }
            this.cache.add(cacheKey, dependency);
        }
        return dependency;
    }
    /**
	 * Requests all dependencies of the specified type asynchronously, with caching.
	 * @param {string} type
	 * @return {Promise<Array<Object>>}
	 */ getDependencies(type) {
        let dependencies = this.cache.get(type);
        if (!dependencies) {
            const parser = this;
            const defs = this.json[type + (type === 'mesh' ? 'es' : 's')] || [];
            dependencies = Promise.all(defs.map(function(def, index) {
                return parser.getDependency(type, index);
            }));
            this.cache.add(type, dependencies);
        }
        return dependencies;
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 * @param {number} bufferIndex
	 * @return {Promise<ArrayBuffer>}
	 */ loadBuffer(bufferIndex) {
        const bufferDef = this.json.buffers[bufferIndex];
        const loader = this.fileLoader;
        if (bufferDef.type && bufferDef.type !== 'arraybuffer') throw new Error('THREE.GLTFLoader: ' + bufferDef.type + ' buffer type is not supported.');
        // If present, GLB container is required to be the first buffer.
        if (bufferDef.uri === undefined && bufferIndex === 0) return Promise.resolve(this.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_BINARY_GLTF].body);
        const options = this.options;
        return new Promise(function(resolve, reject) {
            loader.load((0, $d5b33d7c30034067$export$b5d2dc08d867e41a).resolveURL(bufferDef.uri, options.path), resolve, undefined, function() {
                reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
            });
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
	 * @param {number} bufferViewIndex
	 * @return {Promise<ArrayBuffer>}
	 */ loadBufferView(bufferViewIndex) {
        const bufferViewDef = this.json.bufferViews[bufferViewIndex];
        return this.getDependency('buffer', bufferViewDef.buffer).then(function(buffer) {
            const byteLength = bufferViewDef.byteLength || 0;
            const byteOffset = bufferViewDef.byteOffset || 0;
            return buffer.slice(byteOffset, byteOffset + byteLength);
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
	 * @param {number} accessorIndex
	 * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
	 */ loadAccessor(accessorIndex) {
        const parser = this;
        const json = this.json;
        const accessorDef = this.json.accessors[accessorIndex];
        if (accessorDef.bufferView === undefined && accessorDef.sparse === undefined) {
            const itemSize = $559434fcc6e6401d$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            const normalized = accessorDef.normalized === true;
            const array = new TypedArray(accessorDef.count * itemSize);
            return Promise.resolve(new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(array, itemSize, normalized));
        }
        const pendingBufferViews = [];
        if (accessorDef.bufferView !== undefined) pendingBufferViews.push(this.getDependency('bufferView', accessorDef.bufferView));
        else pendingBufferViews.push(null);
        if (accessorDef.sparse !== undefined) {
            pendingBufferViews.push(this.getDependency('bufferView', accessorDef.sparse.indices.bufferView));
            pendingBufferViews.push(this.getDependency('bufferView', accessorDef.sparse.values.bufferView));
        }
        return Promise.all(pendingBufferViews).then(function(bufferViews) {
            const bufferView = bufferViews[0];
            const itemSize = $559434fcc6e6401d$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            // For VEC3: itemSize is 3, elementBytes is 4, itemBytes is 12.
            const elementBytes = TypedArray.BYTES_PER_ELEMENT;
            const itemBytes = elementBytes * itemSize;
            const byteOffset = accessorDef.byteOffset || 0;
            const byteStride = accessorDef.bufferView !== undefined ? json.bufferViews[accessorDef.bufferView].byteStride : undefined;
            const normalized = accessorDef.normalized === true;
            let array, bufferAttribute;
            // The buffer is not interleaved if the stride is the item size in bytes.
            if (byteStride && byteStride !== itemBytes) {
                // Each "slice" of the buffer, as defined by 'count' elements of 'byteStride' bytes, gets its own InterleavedBuffer
                // This makes sure that IBA.count reflects accessor.count properly
                const ibSlice = Math.floor(byteOffset / byteStride);
                const ibCacheKey = 'InterleavedBuffer:' + accessorDef.bufferView + ':' + accessorDef.componentType + ':' + ibSlice + ':' + accessorDef.count;
                let ib = parser.cache.get(ibCacheKey);
                if (!ib) {
                    array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);
                    // Integer parameters to IB/IBA are in array elements, not bytes.
                    ib = new (0, $d5b33d7c30034067$export$3d5cd879f108f53f)(array, byteStride / elementBytes);
                    parser.cache.add(ibCacheKey, ib);
                }
                bufferAttribute = new (0, $d5b33d7c30034067$export$920b6d07334599c7)(ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
            } else {
                if (bufferView === null) array = new TypedArray(accessorDef.count * itemSize);
                else array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
                bufferAttribute = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(array, itemSize, normalized);
            }
            // https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#sparse-accessors
            if (accessorDef.sparse !== undefined) {
                const itemSizeIndices = $559434fcc6e6401d$var$WEBGL_TYPE_SIZES.SCALAR;
                const TypedArrayIndices = $559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
                const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
                const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
                const sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
                const sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
                if (bufferView !== null) // Avoid modifying the original ArrayBuffer, if the bufferView wasn't initialized with zeroes.
                bufferAttribute = new (0, $d5b33d7c30034067$export$8dea267bd6bde117)(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
                for(let i = 0, il = sparseIndices.length; i < il; i++){
                    const index = sparseIndices[i];
                    bufferAttribute.setX(index, sparseValues[i * itemSize]);
                    if (itemSize >= 2) bufferAttribute.setY(index, sparseValues[i * itemSize + 1]);
                    if (itemSize >= 3) bufferAttribute.setZ(index, sparseValues[i * itemSize + 2]);
                    if (itemSize >= 4) bufferAttribute.setW(index, sparseValues[i * itemSize + 3]);
                    if (itemSize >= 5) throw new Error('THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.');
                }
            }
            return bufferAttribute;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
	 * @param {number} textureIndex
	 * @return {Promise<THREE.Texture|null>}
	 */ loadTexture(textureIndex) {
        const json = this.json;
        const options = this.options;
        const textureDef = json.textures[textureIndex];
        const sourceIndex = textureDef.source;
        const sourceDef = json.images[sourceIndex];
        let loader = this.textureLoader;
        if (sourceDef.uri) {
            const handler = options.manager.getHandler(sourceDef.uri);
            if (handler !== null) loader = handler;
        }
        return this.loadTextureImage(textureIndex, sourceIndex, loader);
    }
    loadTextureImage(textureIndex, sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const textureDef = json.textures[textureIndex];
        const sourceDef = json.images[sourceIndex];
        const cacheKey = (sourceDef.uri || sourceDef.bufferView) + ':' + textureDef.sampler;
        if (this.textureCache[cacheKey]) // See https://github.com/mrdoob/three.js/issues/21559.
        return this.textureCache[cacheKey];
        const promise = this.loadImageSource(sourceIndex, loader).then(function(texture) {
            texture.flipY = false;
            texture.name = textureDef.name || sourceDef.name || '';
            if (texture.name === '' && typeof sourceDef.uri === 'string' && sourceDef.uri.startsWith('data:image/') === false) texture.name = sourceDef.uri;
            const samplers = json.samplers || {};
            const sampler = samplers[textureDef.sampler] || {};
            texture.magFilter = $559434fcc6e6401d$var$WEBGL_FILTERS[sampler.magFilter] || (0, $d5b33d7c30034067$export$8a72f490b25c56c8);
            texture.minFilter = $559434fcc6e6401d$var$WEBGL_FILTERS[sampler.minFilter] || (0, $d5b33d7c30034067$export$5d8599b6a933fb1b);
            texture.wrapS = $559434fcc6e6401d$var$WEBGL_WRAPPINGS[sampler.wrapS] || (0, $d5b33d7c30034067$export$533346c8e8dac0f5);
            texture.wrapT = $559434fcc6e6401d$var$WEBGL_WRAPPINGS[sampler.wrapT] || (0, $d5b33d7c30034067$export$533346c8e8dac0f5);
            parser.associations.set(texture, {
                textures: textureIndex
            });
            return texture;
        }).catch(function() {
            return null;
        });
        this.textureCache[cacheKey] = promise;
        return promise;
    }
    loadImageSource(sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const options = this.options;
        if (this.sourceCache[sourceIndex] !== undefined) return this.sourceCache[sourceIndex].then((texture)=>texture.clone());
        const sourceDef = json.images[sourceIndex];
        const URL = self.URL || self.webkitURL;
        let sourceURI = sourceDef.uri || '';
        let isObjectURL = false;
        if (sourceDef.bufferView !== undefined) // Load binary image data from bufferView, if provided.
        sourceURI = parser.getDependency('bufferView', sourceDef.bufferView).then(function(bufferView) {
            isObjectURL = true;
            const blob = new Blob([
                bufferView
            ], {
                type: sourceDef.mimeType
            });
            sourceURI = URL.createObjectURL(blob);
            return sourceURI;
        });
        else if (sourceDef.uri === undefined) throw new Error('THREE.GLTFLoader: Image ' + sourceIndex + ' is missing URI and bufferView');
        const promise = Promise.resolve(sourceURI).then(function(sourceURI) {
            return new Promise(function(resolve, reject) {
                let onLoad = resolve;
                if (loader.isImageBitmapLoader === true) onLoad = function(imageBitmap) {
                    const texture = new (0, $d5b33d7c30034067$export$5431306cf43de24a)(imageBitmap);
                    texture.needsUpdate = true;
                    resolve(texture);
                };
                loader.load((0, $d5b33d7c30034067$export$b5d2dc08d867e41a).resolveURL(sourceURI, options.path), onLoad, undefined, reject);
            });
        }).then(function(texture) {
            // Clean up resources and configure Texture.
            if (isObjectURL === true) URL.revokeObjectURL(sourceURI);
            texture.userData.mimeType = sourceDef.mimeType || $559434fcc6e6401d$var$getImageURIMimeType(sourceDef.uri);
            return texture;
        }).catch(function(error) {
            console.error('THREE.GLTFLoader: Couldn\'t load texture', sourceURI);
            throw error;
        });
        this.sourceCache[sourceIndex] = promise;
        return promise;
    }
    /**
	 * Asynchronously assigns a texture to the given material parameters.
	 * @param {Object} materialParams
	 * @param {string} mapName
	 * @param {Object} mapDef
	 * @return {Promise<Texture>}
	 */ assignTexture(materialParams, mapName, mapDef, colorSpace) {
        const parser = this;
        return this.getDependency('texture', mapDef.index).then(function(texture) {
            if (!texture) return null;
            if (mapDef.texCoord !== undefined && mapDef.texCoord > 0) {
                texture = texture.clone();
                texture.channel = mapDef.texCoord;
            }
            if (parser.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
                const transform = mapDef.extensions !== undefined ? mapDef.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM] : undefined;
                if (transform) {
                    const gltfReference = parser.associations.get(texture);
                    texture = parser.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);
                    parser.associations.set(texture, gltfReference);
                }
            }
            if (colorSpace !== undefined) texture.colorSpace = colorSpace;
            materialParams[mapName] = texture;
            return texture;
        });
    }
    /**
	 * Assigns final material to a Mesh, Line, or Points instance. The instance
	 * already has a material (generated from the glTF material options alone)
	 * but reuse of the same glTF material may require multiple threejs materials
	 * to accommodate different primitive types, defines, etc. New materials will
	 * be created if necessary, and reused from a cache.
	 * @param  {Object3D} mesh Mesh, Line, or Points instance.
	 */ assignFinalMaterial(mesh) {
        const geometry = mesh.geometry;
        let material = mesh.material;
        const useDerivativeTangents = geometry.attributes.tangent === undefined;
        const useVertexColors = geometry.attributes.color !== undefined;
        const useFlatShading = geometry.attributes.normal === undefined;
        if (mesh.isPoints) {
            const cacheKey = 'PointsMaterial:' + material.uuid;
            let pointsMaterial = this.cache.get(cacheKey);
            if (!pointsMaterial) {
                pointsMaterial = new (0, $d5b33d7c30034067$export$a178c45366ce5d6b)();
                (0, $d5b33d7c30034067$export$a2d8b23205c25948).prototype.copy.call(pointsMaterial, material);
                pointsMaterial.color.copy(material.color);
                pointsMaterial.map = material.map;
                pointsMaterial.sizeAttenuation = false; // glTF spec says points should be 1px
                this.cache.add(cacheKey, pointsMaterial);
            }
            material = pointsMaterial;
        } else if (mesh.isLine) {
            const cacheKey = 'LineBasicMaterial:' + material.uuid;
            let lineMaterial = this.cache.get(cacheKey);
            if (!lineMaterial) {
                lineMaterial = new (0, $d5b33d7c30034067$export$fbaaa33907730a0c)();
                (0, $d5b33d7c30034067$export$a2d8b23205c25948).prototype.copy.call(lineMaterial, material);
                lineMaterial.color.copy(material.color);
                lineMaterial.map = material.map;
                this.cache.add(cacheKey, lineMaterial);
            }
            material = lineMaterial;
        }
        // Clone the material if it will be modified
        if (useDerivativeTangents || useVertexColors || useFlatShading) {
            let cacheKey = 'ClonedMaterial:' + material.uuid + ':';
            if (useDerivativeTangents) cacheKey += 'derivative-tangents:';
            if (useVertexColors) cacheKey += 'vertex-colors:';
            if (useFlatShading) cacheKey += 'flat-shading:';
            let cachedMaterial = this.cache.get(cacheKey);
            if (!cachedMaterial) {
                cachedMaterial = material.clone();
                if (useVertexColors) cachedMaterial.vertexColors = true;
                if (useFlatShading) cachedMaterial.flatShading = true;
                if (useDerivativeTangents) {
                    // https://github.com/mrdoob/three.js/issues/11438#issuecomment-507003995
                    if (cachedMaterial.normalScale) cachedMaterial.normalScale.y *= -1;
                    if (cachedMaterial.clearcoatNormalScale) cachedMaterial.clearcoatNormalScale.y *= -1;
                }
                this.cache.add(cacheKey, cachedMaterial);
                this.associations.set(cachedMaterial, this.associations.get(material));
            }
            material = cachedMaterial;
        }
        mesh.material = material;
    }
    getMaterialType() {
        return 0, $d5b33d7c30034067$export$f2980790215acccd;
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
	 * @param {number} materialIndex
	 * @return {Promise<Material>}
	 */ loadMaterial(materialIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const materialDef = json.materials[materialIndex];
        let materialType;
        const materialParams = {};
        const materialExtensions = materialDef.extensions || {};
        const pending = [];
        if (materialExtensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_UNLIT]) {
            const kmuExtension = extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_MATERIALS_UNLIT];
            materialType = kmuExtension.getMaterialType();
            pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
        } else {
            // Specification:
            // https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#metallic-roughness-material
            const metallicRoughness = materialDef.pbrMetallicRoughness || {};
            materialParams.color = new (0, $d5b33d7c30034067$export$892596cec99bc70e)(1.0, 1.0, 1.0);
            materialParams.opacity = 1.0;
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.setRGB(array[0], array[1], array[2], (0, $d5b33d7c30034067$export$42429b3acfb233a4));
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'map', metallicRoughness.baseColorTexture, (0, $d5b33d7c30034067$export$561f394b24edfcaa)));
            materialParams.metalness = metallicRoughness.metallicFactor !== undefined ? metallicRoughness.metallicFactor : 1.0;
            materialParams.roughness = metallicRoughness.roughnessFactor !== undefined ? metallicRoughness.roughnessFactor : 1.0;
            if (metallicRoughness.metallicRoughnessTexture !== undefined) {
                pending.push(parser.assignTexture(materialParams, 'metalnessMap', metallicRoughness.metallicRoughnessTexture));
                pending.push(parser.assignTexture(materialParams, 'roughnessMap', metallicRoughness.metallicRoughnessTexture));
            }
            materialType = this._invokeOne(function(ext) {
                return ext.getMaterialType && ext.getMaterialType(materialIndex);
            });
            pending.push(Promise.all(this._invokeAll(function(ext) {
                return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
            })));
        }
        if (materialDef.doubleSided === true) materialParams.side = (0, $d5b33d7c30034067$export$3b296b6f144d5b03);
        const alphaMode = materialDef.alphaMode || $559434fcc6e6401d$var$ALPHA_MODES.OPAQUE;
        if (alphaMode === $559434fcc6e6401d$var$ALPHA_MODES.BLEND) {
            materialParams.transparent = true;
            // See: https://github.com/mrdoob/three.js/issues/17706
            materialParams.depthWrite = false;
        } else {
            materialParams.transparent = false;
            if (alphaMode === $559434fcc6e6401d$var$ALPHA_MODES.MASK) materialParams.alphaTest = materialDef.alphaCutoff !== undefined ? materialDef.alphaCutoff : 0.5;
        }
        if (materialDef.normalTexture !== undefined && materialType !== (0, $d5b33d7c30034067$export$55cbcc9b622fe1f5)) {
            pending.push(parser.assignTexture(materialParams, 'normalMap', materialDef.normalTexture));
            materialParams.normalScale = new (0, $d5b33d7c30034067$export$c977b3e384af9ae1)(1, 1);
            if (materialDef.normalTexture.scale !== undefined) {
                const scale = materialDef.normalTexture.scale;
                materialParams.normalScale.set(scale, scale);
            }
        }
        if (materialDef.occlusionTexture !== undefined && materialType !== (0, $d5b33d7c30034067$export$55cbcc9b622fe1f5)) {
            pending.push(parser.assignTexture(materialParams, 'aoMap', materialDef.occlusionTexture));
            if (materialDef.occlusionTexture.strength !== undefined) materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
        }
        if (materialDef.emissiveFactor !== undefined && materialType !== (0, $d5b33d7c30034067$export$55cbcc9b622fe1f5)) materialParams.emissive = new (0, $d5b33d7c30034067$export$892596cec99bc70e)().setRGB(...materialDef.emissiveFactor, (0, $d5b33d7c30034067$export$42429b3acfb233a4));
        if (materialDef.emissiveTexture !== undefined && materialType !== (0, $d5b33d7c30034067$export$55cbcc9b622fe1f5)) pending.push(parser.assignTexture(materialParams, 'emissiveMap', materialDef.emissiveTexture, (0, $d5b33d7c30034067$export$561f394b24edfcaa)));
        return Promise.all(pending).then(function() {
            const material = new materialType(materialParams);
            if (materialDef.name) material.name = materialDef.name;
            $559434fcc6e6401d$var$assignExtrasToUserData(material, materialDef);
            parser.associations.set(material, {
                materials: materialIndex
            });
            if (materialDef.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, material, materialDef);
            return material;
        });
    }
    /** When Object3D instances are targeted by animation, they need unique names. */ createUniqueName(originalName) {
        const sanitizedName = (0, $d5b33d7c30034067$export$7bf70fcf9f891893).sanitizeNodeName(originalName || '');
        if (sanitizedName in this.nodeNamesUsed) return sanitizedName + '_' + ++this.nodeNamesUsed[sanitizedName];
        else {
            this.nodeNamesUsed[sanitizedName] = 0;
            return sanitizedName;
        }
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
	 *
	 * Creates BufferGeometries from primitives.
	 *
	 * @param {Array<GLTF.Primitive>} primitives
	 * @return {Promise<Array<BufferGeometry>>}
	 */ loadGeometries(primitives) {
        const parser = this;
        const extensions = this.extensions;
        const cache = this.primitiveCache;
        function createDracoPrimitive(primitive) {
            return extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function(geometry) {
                return $559434fcc6e6401d$var$addPrimitiveAttributes(geometry, primitive, parser);
            });
        }
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const primitive = primitives[i];
            const cacheKey = $559434fcc6e6401d$var$createPrimitiveKey(primitive);
            // See if we've already created this geometry
            const cached = cache[cacheKey];
            if (cached) // Use the cached geometry if it exists
            pending.push(cached.promise);
            else {
                let geometryPromise;
                if (primitive.extensions && primitive.extensions[$559434fcc6e6401d$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) // Use DRACO geometry if available
                geometryPromise = createDracoPrimitive(primitive);
                else // Otherwise create a new geometry
                geometryPromise = $559434fcc6e6401d$var$addPrimitiveAttributes(new (0, $d5b33d7c30034067$export$b7be63a67df8959)(), primitive, parser);
                // Cache this geometry
                cache[cacheKey] = {
                    primitive: primitive,
                    promise: geometryPromise
                };
                pending.push(geometryPromise);
            }
        }
        return Promise.all(pending);
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
	 * @param {number} meshIndex
	 * @return {Promise<Group|Mesh|SkinnedMesh>}
	 */ loadMesh(meshIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const meshDef = json.meshes[meshIndex];
        const primitives = meshDef.primitives;
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const material = primitives[i].material === undefined ? $559434fcc6e6401d$var$createDefaultMaterial(this.cache) : this.getDependency('material', primitives[i].material);
            pending.push(material);
        }
        pending.push(parser.loadGeometries(primitives));
        return Promise.all(pending).then(function(results) {
            const materials = results.slice(0, results.length - 1);
            const geometries = results[results.length - 1];
            const meshes = [];
            for(let i = 0, il = geometries.length; i < il; i++){
                const geometry = geometries[i];
                const primitive = primitives[i];
                // 1. create Mesh
                let mesh;
                const material = materials[i];
                if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLES || primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === undefined) {
                    // .isSkinnedMesh isn't in glTF spec. See ._markDefs()
                    mesh = meshDef.isSkinnedMesh === true ? new (0, $d5b33d7c30034067$export$b303577035157ecf)(geometry, material) : new (0, $d5b33d7c30034067$export$e176487c05830cc5)(geometry, material);
                    if (mesh.isSkinnedMesh === true) // normalize skin weights to fix malformed assets (see #15319)
                    mesh.normalizeSkinWeights();
                    if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_STRIP) mesh.geometry = (0, $5451ea62abbe5f68$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $d5b33d7c30034067$export$b23a071aa286eb29));
                    else if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.TRIANGLE_FAN) mesh.geometry = (0, $5451ea62abbe5f68$export$5492ca6e5c0c7aa0)(mesh.geometry, (0, $d5b33d7c30034067$export$f0d8293634f88842));
                } else if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.LINES) mesh = new (0, $d5b33d7c30034067$export$ff1ed10fedfdd604)(geometry, material);
                else if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.LINE_STRIP) mesh = new (0, $d5b33d7c30034067$export$17d680238e50603e)(geometry, material);
                else if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.LINE_LOOP) mesh = new (0, $d5b33d7c30034067$export$f85a24d745e4f17d)(geometry, material);
                else if (primitive.mode === $559434fcc6e6401d$var$WEBGL_CONSTANTS.POINTS) mesh = new (0, $d5b33d7c30034067$export$1c787534cb11aa3e)(geometry, material);
                else throw new Error('THREE.GLTFLoader: Primitive mode unsupported: ' + primitive.mode);
                if (Object.keys(mesh.geometry.morphAttributes).length > 0) $559434fcc6e6401d$var$updateMorphTargets(mesh, meshDef);
                mesh.name = parser.createUniqueName(meshDef.name || 'mesh_' + meshIndex);
                $559434fcc6e6401d$var$assignExtrasToUserData(mesh, meshDef);
                if (primitive.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, mesh, primitive);
                parser.assignFinalMaterial(mesh);
                meshes.push(mesh);
            }
            for(let i = 0, il = meshes.length; i < il; i++)parser.associations.set(meshes[i], {
                meshes: meshIndex,
                primitives: i
            });
            if (meshes.length === 1) {
                if (meshDef.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, meshes[0], meshDef);
                return meshes[0];
            }
            const group = new (0, $d5b33d7c30034067$export$eb2fcfdbd7ba97d4)();
            if (meshDef.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, group, meshDef);
            parser.associations.set(group, {
                meshes: meshIndex
            });
            for(let i = 0, il = meshes.length; i < il; i++)group.add(meshes[i]);
            return group;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
	 * @param {number} cameraIndex
	 * @return {Promise<THREE.Camera>}
	 */ loadCamera(cameraIndex) {
        let camera;
        const cameraDef = this.json.cameras[cameraIndex];
        const params = cameraDef[cameraDef.type];
        if (!params) {
            console.warn('THREE.GLTFLoader: Missing camera parameters.');
            return;
        }
        if (cameraDef.type === 'perspective') camera = new (0, $d5b33d7c30034067$export$74e4ae24825f68d7)((0, $d5b33d7c30034067$export$6a7ef315a0d1ef07).radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);
        else if (cameraDef.type === 'orthographic') camera = new (0, $d5b33d7c30034067$export$9ebf355ee4ed261b)(-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
        if (cameraDef.name) camera.name = this.createUniqueName(cameraDef.name);
        $559434fcc6e6401d$var$assignExtrasToUserData(camera, cameraDef);
        return Promise.resolve(camera);
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
	 * @param {number} skinIndex
	 * @return {Promise<Skeleton>}
	 */ loadSkin(skinIndex) {
        const skinDef = this.json.skins[skinIndex];
        const pending = [];
        for(let i = 0, il = skinDef.joints.length; i < il; i++)pending.push(this._loadNodeShallow(skinDef.joints[i]));
        if (skinDef.inverseBindMatrices !== undefined) pending.push(this.getDependency('accessor', skinDef.inverseBindMatrices));
        else pending.push(null);
        return Promise.all(pending).then(function(results) {
            const inverseBindMatrices = results.pop();
            const jointNodes = results;
            // Note that bones (joint nodes) may or may not be in the
            // scene graph at this time.
            const bones = [];
            const boneInverses = [];
            for(let i = 0, il = jointNodes.length; i < il; i++){
                const jointNode = jointNodes[i];
                if (jointNode) {
                    bones.push(jointNode);
                    const mat = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
                    if (inverseBindMatrices !== null) mat.fromArray(inverseBindMatrices.array, i * 16);
                    boneInverses.push(mat);
                } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[i]);
            }
            return new (0, $d5b33d7c30034067$export$8f31e4c4a37b8e9c)(bones, boneInverses);
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
	 * @param {number} animationIndex
	 * @return {Promise<AnimationClip>}
	 */ loadAnimation(animationIndex) {
        const json = this.json;
        const parser = this;
        const animationDef = json.animations[animationIndex];
        const animationName = animationDef.name ? animationDef.name : 'animation_' + animationIndex;
        const pendingNodes = [];
        const pendingInputAccessors = [];
        const pendingOutputAccessors = [];
        const pendingSamplers = [];
        const pendingTargets = [];
        for(let i = 0, il = animationDef.channels.length; i < il; i++){
            const channel = animationDef.channels[i];
            const sampler = animationDef.samplers[channel.sampler];
            const target = channel.target;
            const name = target.node;
            const input = animationDef.parameters !== undefined ? animationDef.parameters[sampler.input] : sampler.input;
            const output = animationDef.parameters !== undefined ? animationDef.parameters[sampler.output] : sampler.output;
            if (target.node === undefined) continue;
            pendingNodes.push(this.getDependency('node', name));
            pendingInputAccessors.push(this.getDependency('accessor', input));
            pendingOutputAccessors.push(this.getDependency('accessor', output));
            pendingSamplers.push(sampler);
            pendingTargets.push(target);
        }
        return Promise.all([
            Promise.all(pendingNodes),
            Promise.all(pendingInputAccessors),
            Promise.all(pendingOutputAccessors),
            Promise.all(pendingSamplers),
            Promise.all(pendingTargets)
        ]).then(function(dependencies) {
            const nodes = dependencies[0];
            const inputAccessors = dependencies[1];
            const outputAccessors = dependencies[2];
            const samplers = dependencies[3];
            const targets = dependencies[4];
            const tracks = [];
            for(let i = 0, il = nodes.length; i < il; i++){
                const node = nodes[i];
                const inputAccessor = inputAccessors[i];
                const outputAccessor = outputAccessors[i];
                const sampler = samplers[i];
                const target = targets[i];
                if (node === undefined) continue;
                if (node.updateMatrix) node.updateMatrix();
                const createdTracks = parser._createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target);
                if (createdTracks) for(let k = 0; k < createdTracks.length; k++)tracks.push(createdTracks[k]);
            }
            return new (0, $d5b33d7c30034067$export$d942c706bf23829c)(animationName, undefined, tracks);
        });
    }
    createNodeMesh(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        if (nodeDef.mesh === undefined) return null;
        return parser.getDependency('mesh', nodeDef.mesh).then(function(mesh) {
            const node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);
            // if weights are provided on the node, override weights on the mesh.
            if (nodeDef.weights !== undefined) node.traverse(function(o) {
                if (!o.isMesh) return;
                for(let i = 0, il = nodeDef.weights.length; i < il; i++)o.morphTargetInfluences[i] = nodeDef.weights[i];
            });
            return node;
        });
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
	 * @param {number} nodeIndex
	 * @return {Promise<Object3D>}
	 */ loadNode(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        const nodePending = parser._loadNodeShallow(nodeIndex);
        const childPending = [];
        const childrenDef = nodeDef.children || [];
        for(let i = 0, il = childrenDef.length; i < il; i++)childPending.push(parser.getDependency('node', childrenDef[i]));
        const skeletonPending = nodeDef.skin === undefined ? Promise.resolve(null) : parser.getDependency('skin', nodeDef.skin);
        return Promise.all([
            nodePending,
            Promise.all(childPending),
            skeletonPending
        ]).then(function(results) {
            const node = results[0];
            const children = results[1];
            const skeleton = results[2];
            if (skeleton !== null) // This full traverse should be fine because
            // child glTF nodes have not been added to this node yet.
            node.traverse(function(mesh) {
                if (!mesh.isSkinnedMesh) return;
                mesh.bind(skeleton, $559434fcc6e6401d$var$_identityMatrix);
            });
            for(let i = 0, il = children.length; i < il; i++)node.add(children[i]);
            return node;
        });
    }
    // ._loadNodeShallow() parses a single node.
    // skin and child nodes are created and added in .loadNode() (no '_' prefix).
    _loadNodeShallow(nodeIndex) {
        const json = this.json;
        const extensions = this.extensions;
        const parser = this;
        // This method is called from .loadNode() and .loadSkin().
        // Cache a node to avoid duplication.
        if (this.nodeCache[nodeIndex] !== undefined) return this.nodeCache[nodeIndex];
        const nodeDef = json.nodes[nodeIndex];
        // reserve node's name before its dependencies, so the root has the intended name.
        const nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : '';
        const pending = [];
        const meshPromise = parser._invokeOne(function(ext) {
            return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
        });
        if (meshPromise) pending.push(meshPromise);
        if (nodeDef.camera !== undefined) pending.push(parser.getDependency('camera', nodeDef.camera).then(function(camera) {
            return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
        }));
        parser._invokeAll(function(ext) {
            return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
        }).forEach(function(promise) {
            pending.push(promise);
        });
        this.nodeCache[nodeIndex] = Promise.all(pending).then(function(objects) {
            let node;
            // .isBone isn't in glTF spec. See ._markDefs
            if (nodeDef.isBone === true) node = new (0, $d5b33d7c30034067$export$b127726e56765aa4)();
            else if (objects.length > 1) node = new (0, $d5b33d7c30034067$export$eb2fcfdbd7ba97d4)();
            else if (objects.length === 1) node = objects[0];
            else node = new (0, $d5b33d7c30034067$export$e4dd07dff30cc924)();
            if (node !== objects[0]) for(let i = 0, il = objects.length; i < il; i++)node.add(objects[i]);
            if (nodeDef.name) {
                node.userData.name = nodeDef.name;
                node.name = nodeName;
            }
            $559434fcc6e6401d$var$assignExtrasToUserData(node, nodeDef);
            if (nodeDef.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, node, nodeDef);
            if (nodeDef.matrix !== undefined) {
                const matrix = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
                matrix.fromArray(nodeDef.matrix);
                node.applyMatrix4(matrix);
            } else {
                if (nodeDef.translation !== undefined) node.position.fromArray(nodeDef.translation);
                if (nodeDef.rotation !== undefined) node.quaternion.fromArray(nodeDef.rotation);
                if (nodeDef.scale !== undefined) node.scale.fromArray(nodeDef.scale);
            }
            if (!parser.associations.has(node)) parser.associations.set(node, {});
            parser.associations.get(node).nodes = nodeIndex;
            return node;
        });
        return this.nodeCache[nodeIndex];
    }
    /**
	 * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
	 * @param {number} sceneIndex
	 * @return {Promise<Group>}
	 */ loadScene(sceneIndex) {
        const extensions = this.extensions;
        const sceneDef = this.json.scenes[sceneIndex];
        const parser = this;
        // Loader returns Group, not Scene.
        // See: https://github.com/mrdoob/three.js/issues/18342#issuecomment-578981172
        const scene = new (0, $d5b33d7c30034067$export$eb2fcfdbd7ba97d4)();
        if (sceneDef.name) scene.name = parser.createUniqueName(sceneDef.name);
        $559434fcc6e6401d$var$assignExtrasToUserData(scene, sceneDef);
        if (sceneDef.extensions) $559434fcc6e6401d$var$addUnknownExtensionsToUserData(extensions, scene, sceneDef);
        const nodeIds = sceneDef.nodes || [];
        const pending = [];
        for(let i = 0, il = nodeIds.length; i < il; i++)pending.push(parser.getDependency('node', nodeIds[i]));
        return Promise.all(pending).then(function(nodes) {
            for(let i = 0, il = nodes.length; i < il; i++)scene.add(nodes[i]);
            // Removes dangling associations, associations that reference a node that
            // didn't make it into the scene.
            const reduceAssociations = (node)=>{
                const reducedAssociations = new Map();
                for (const [key, value] of parser.associations)if (key instanceof (0, $d5b33d7c30034067$export$a2d8b23205c25948) || key instanceof (0, $d5b33d7c30034067$export$5431306cf43de24a)) reducedAssociations.set(key, value);
                node.traverse((node)=>{
                    const mappings = parser.associations.get(node);
                    if (mappings != null) reducedAssociations.set(node, mappings);
                });
                return reducedAssociations;
            };
            parser.associations = reduceAssociations(scene);
            return scene;
        });
    }
    _createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target) {
        const tracks = [];
        const targetName = node.name ? node.name : node.uuid;
        const targetNames = [];
        if ($559434fcc6e6401d$var$PATH_PROPERTIES[target.path] === $559434fcc6e6401d$var$PATH_PROPERTIES.weights) node.traverse(function(object) {
            if (object.morphTargetInfluences) targetNames.push(object.name ? object.name : object.uuid);
        });
        else targetNames.push(targetName);
        let TypedKeyframeTrack;
        switch($559434fcc6e6401d$var$PATH_PROPERTIES[target.path]){
            case $559434fcc6e6401d$var$PATH_PROPERTIES.weights:
                TypedKeyframeTrack = (0, $d5b33d7c30034067$export$d45f0d1a4d9a9314);
                break;
            case $559434fcc6e6401d$var$PATH_PROPERTIES.rotation:
                TypedKeyframeTrack = (0, $d5b33d7c30034067$export$b8043f12b5aafbd7);
                break;
            case $559434fcc6e6401d$var$PATH_PROPERTIES.position:
            case $559434fcc6e6401d$var$PATH_PROPERTIES.scale:
                TypedKeyframeTrack = (0, $d5b33d7c30034067$export$5ce2dcb4cc9f2bff);
                break;
            default:
                switch(outputAccessor.itemSize){
                    case 1:
                        TypedKeyframeTrack = (0, $d5b33d7c30034067$export$d45f0d1a4d9a9314);
                        break;
                    case 2:
                    case 3:
                    default:
                        TypedKeyframeTrack = (0, $d5b33d7c30034067$export$5ce2dcb4cc9f2bff);
                        break;
                }
                break;
        }
        const interpolation = sampler.interpolation !== undefined ? $559434fcc6e6401d$var$INTERPOLATION[sampler.interpolation] : (0, $d5b33d7c30034067$export$30fac1aace31cf4d);
        const outputArray = this._getArrayFromAccessor(outputAccessor);
        for(let j = 0, jl = targetNames.length; j < jl; j++){
            const track = new TypedKeyframeTrack(targetNames[j] + '.' + $559434fcc6e6401d$var$PATH_PROPERTIES[target.path], inputAccessor.array, outputArray, interpolation);
            // Override interpolation with custom factory method.
            if (sampler.interpolation === 'CUBICSPLINE') this._createCubicSplineTrackInterpolant(track);
            tracks.push(track);
        }
        return tracks;
    }
    _getArrayFromAccessor(accessor) {
        let outputArray = accessor.array;
        if (accessor.normalized) {
            const scale = $559434fcc6e6401d$var$getNormalizedComponentScale(outputArray.constructor);
            const scaled = new Float32Array(outputArray.length);
            for(let j = 0, jl = outputArray.length; j < jl; j++)scaled[j] = outputArray[j] * scale;
            outputArray = scaled;
        }
        return outputArray;
    }
    _createCubicSplineTrackInterpolant(track) {
        track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
            // A CUBICSPLINE keyframe in glTF has three output values for each input value,
            // representing inTangent, splineVertex, and outTangent. As a result, track.getValueSize()
            // must be divided by three to get the interpolant's sampleSize argument.
            const interpolantType = this instanceof (0, $d5b33d7c30034067$export$b8043f12b5aafbd7) ? $559434fcc6e6401d$var$GLTFCubicSplineQuaternionInterpolant : $559434fcc6e6401d$var$GLTFCubicSplineInterpolant;
            return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
        };
        // Mark as CUBICSPLINE. `track.getInterpolation()` doesn't support custom interpolants.
        track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
    }
}
/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 */ function $559434fcc6e6401d$var$computeBounds(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const box = new (0, $d5b33d7c30034067$export$6f7d5a9418ab2aa3)();
    if (attributes.POSITION !== undefined) {
        const accessor = parser.json.accessors[attributes.POSITION];
        const min = accessor.min;
        const max = accessor.max;
        // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
        if (min !== undefined && max !== undefined) {
            box.set(new (0, $d5b33d7c30034067$export$64b5c384219d3699)(min[0], min[1], min[2]), new (0, $d5b33d7c30034067$export$64b5c384219d3699)(max[0], max[1], max[2]));
            if (accessor.normalized) {
                const boxScale = $559434fcc6e6401d$var$getNormalizedComponentScale($559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                box.min.multiplyScalar(boxScale);
                box.max.multiplyScalar(boxScale);
            }
        } else {
            console.warn('THREE.GLTFLoader: Missing min/max properties for accessor POSITION.');
            return;
        }
    } else return;
    const targets = primitiveDef.targets;
    if (targets !== undefined) {
        const maxDisplacement = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        const vector = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
        for(let i = 0, il = targets.length; i < il; i++){
            const target = targets[i];
            if (target.POSITION !== undefined) {
                const accessor = parser.json.accessors[target.POSITION];
                const min = accessor.min;
                const max = accessor.max;
                // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
                if (min !== undefined && max !== undefined) {
                    // we need to get max of absolute components because target weight is [-1,1]
                    vector.setX(Math.max(Math.abs(min[0]), Math.abs(max[0])));
                    vector.setY(Math.max(Math.abs(min[1]), Math.abs(max[1])));
                    vector.setZ(Math.max(Math.abs(min[2]), Math.abs(max[2])));
                    if (accessor.normalized) {
                        const boxScale = $559434fcc6e6401d$var$getNormalizedComponentScale($559434fcc6e6401d$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                        vector.multiplyScalar(boxScale);
                    }
                    // Note: this assumes that the sum of all weights is at most 1. This isn't quite correct - it's more conservative
                    // to assume that each target can have a max weight of 1. However, for some use cases - notably, when morph targets
                    // are used to implement key-frame animations and as such only two are active at a time - this results in very large
                    // boxes. So for now we make a box that's sometimes a touch too small but is hopefully mostly of reasonable size.
                    maxDisplacement.max(vector);
                } else console.warn('THREE.GLTFLoader: Missing min/max properties for accessor POSITION.');
            }
        }
        // As per comment above this box isn't conservative, but has a reasonable size for a very large number of morph targets.
        box.expandByVector(maxDisplacement);
    }
    geometry.boundingBox = box;
    const sphere = new (0, $d5b33d7c30034067$export$805e8b72413ccaba)();
    box.getCenter(sphere.center);
    sphere.radius = box.min.distanceTo(box.max) / 2;
    geometry.boundingSphere = sphere;
}
/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $559434fcc6e6401d$var$addPrimitiveAttributes(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const pending = [];
    function assignAttributeAccessor(accessorIndex, attributeName) {
        return parser.getDependency('accessor', accessorIndex).then(function(accessor) {
            geometry.setAttribute(attributeName, accessor);
        });
    }
    for(const gltfAttributeName in attributes){
        const threeAttributeName = $559434fcc6e6401d$var$ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();
        // Skip attributes already provided by e.g. Draco extension.
        if (threeAttributeName in geometry.attributes) continue;
        pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
    }
    if (primitiveDef.indices !== undefined && !geometry.index) {
        const accessor = parser.getDependency('accessor', primitiveDef.indices).then(function(accessor) {
            geometry.setIndex(accessor);
        });
        pending.push(accessor);
    }
    if ((0, $d5b33d7c30034067$export$5e6fd513f44698c).workingColorSpace !== (0, $d5b33d7c30034067$export$42429b3acfb233a4) && 'COLOR_0' in attributes) console.warn(`THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${(0, $d5b33d7c30034067$export$5e6fd513f44698c).workingColorSpace}" not supported.`);
    $559434fcc6e6401d$var$assignExtrasToUserData(geometry, primitiveDef);
    $559434fcc6e6401d$var$computeBounds(geometry, primitiveDef, parser);
    return Promise.all(pending).then(function() {
        return primitiveDef.targets !== undefined ? $559434fcc6e6401d$var$addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
    });
}




var $0qVX1 = parcelRequire("0qVX1");

/**
 * Based on http://www.emagix.net/academic/mscs-project/item/camera-sync-with-css3-and-webgl-threejs
 */ const $9363e764e36b7961$var$_position = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
const $9363e764e36b7961$var$_quaternion = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)();
const $9363e764e36b7961$var$_scale = new (0, $d5b33d7c30034067$export$64b5c384219d3699)();
class $9363e764e36b7961$export$c98c75030067aef2 extends (0, $d5b33d7c30034067$export$e4dd07dff30cc924) {
    constructor(element = document.createElement('div')){
        super();
        this.isCSS3DObject = true;
        this.element = element;
        this.element.style.position = 'absolute';
        this.element.style.pointerEvents = 'auto';
        this.element.style.userSelect = 'none';
        this.element.setAttribute('draggable', false);
        this.addEventListener('removed', function() {
            this.traverse(function(object) {
                if (object.element instanceof Element && object.element.parentNode !== null) object.element.parentNode.removeChild(object.element);
            });
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.element = source.element.cloneNode(true);
        return this;
    }
}
class $9363e764e36b7961$export$d3b11bcaaee92171 extends $9363e764e36b7961$export$c98c75030067aef2 {
    constructor(element){
        super(element);
        this.isCSS3DSprite = true;
        this.rotation2D = 0;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.rotation2D = source.rotation2D;
        return this;
    }
}
//
const $9363e764e36b7961$var$_matrix = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
const $9363e764e36b7961$var$_matrix2 = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
class $9363e764e36b7961$export$3bfd27f14dcd93ed {
    constructor(parameters = {}){
        const _this = this;
        let _width, _height;
        let _widthHalf, _heightHalf;
        const cache = {
            camera: {
                fov: 0,
                style: ''
            },
            objects: new WeakMap()
        };
        const domElement = parameters.element !== undefined ? parameters.element : document.createElement('div');
        domElement.style.overflow = 'hidden';
        this.domElement = domElement;
        const viewElement = document.createElement('div');
        viewElement.style.transformOrigin = '0 0';
        viewElement.style.pointerEvents = 'none';
        domElement.appendChild(viewElement);
        const cameraElement = document.createElement('div');
        cameraElement.style.transformStyle = 'preserve-3d';
        viewElement.appendChild(cameraElement);
        this.getSize = function() {
            return {
                width: _width,
                height: _height
            };
        };
        this.render = function(scene, camera) {
            const fov = camera.projectionMatrix.elements[5] * _heightHalf;
            if (cache.camera.fov !== fov) {
                viewElement.style.perspective = camera.isPerspectiveCamera ? fov + 'px' : '';
                cache.camera.fov = fov;
            }
            if (camera.view && camera.view.enabled) {
                // view offset
                viewElement.style.transform = `translate( ${-camera.view.offsetX * (_width / camera.view.width)}px, ${-camera.view.offsetY * (_height / camera.view.height)}px )`;
                // view fullWidth and fullHeight, view width and height
                viewElement.style.transform += `scale( ${camera.view.fullWidth / camera.view.width}, ${camera.view.fullHeight / camera.view.height} )`;
            } else viewElement.style.transform = '';
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            let tx, ty;
            if (camera.isOrthographicCamera) {
                tx = -(camera.right + camera.left) / 2;
                ty = (camera.top + camera.bottom) / 2;
            }
            const scaleByViewOffset = camera.view && camera.view.enabled ? camera.view.height / camera.view.fullHeight : 1;
            const cameraCSSMatrix = camera.isOrthographicCamera ? `scale( ${scaleByViewOffset} )` + 'scale(' + fov + ')' + 'translate(' + epsilon(tx) + 'px,' + epsilon(ty) + 'px)' + getCameraCSSMatrix(camera.matrixWorldInverse) : `scale( ${scaleByViewOffset} )` + 'translateZ(' + fov + 'px)' + getCameraCSSMatrix(camera.matrixWorldInverse);
            const style = cameraCSSMatrix + 'translate(' + _widthHalf + 'px,' + _heightHalf + 'px)';
            if (cache.camera.style !== style) {
                cameraElement.style.transform = style;
                cache.camera.style = style;
            }
            renderObject(scene, scene, camera, cameraCSSMatrix);
        };
        this.setSize = function(width, height) {
            _width = width;
            _height = height;
            _widthHalf = _width / 2;
            _heightHalf = _height / 2;
            domElement.style.width = width + 'px';
            domElement.style.height = height + 'px';
            viewElement.style.width = width + 'px';
            viewElement.style.height = height + 'px';
            cameraElement.style.width = width + 'px';
            cameraElement.style.height = height + 'px';
        };
        function epsilon(value) {
            return Math.abs(value) < 1e-10 ? 0 : value;
        }
        function getCameraCSSMatrix(matrix) {
            const elements = matrix.elements;
            return 'matrix3d(' + epsilon(elements[0]) + ',' + epsilon(-elements[1]) + ',' + epsilon(elements[2]) + ',' + epsilon(elements[3]) + ',' + epsilon(elements[4]) + ',' + epsilon(-elements[5]) + ',' + epsilon(elements[6]) + ',' + epsilon(elements[7]) + ',' + epsilon(elements[8]) + ',' + epsilon(-elements[9]) + ',' + epsilon(elements[10]) + ',' + epsilon(elements[11]) + ',' + epsilon(elements[12]) + ',' + epsilon(-elements[13]) + ',' + epsilon(elements[14]) + ',' + epsilon(elements[15]) + ')';
        }
        function getObjectCSSMatrix(matrix) {
            const elements = matrix.elements;
            const matrix3d = 'matrix3d(' + epsilon(elements[0]) + ',' + epsilon(elements[1]) + ',' + epsilon(elements[2]) + ',' + epsilon(elements[3]) + ',' + epsilon(-elements[4]) + ',' + epsilon(-elements[5]) + ',' + epsilon(-elements[6]) + ',' + epsilon(-elements[7]) + ',' + epsilon(elements[8]) + ',' + epsilon(elements[9]) + ',' + epsilon(elements[10]) + ',' + epsilon(elements[11]) + ',' + epsilon(elements[12]) + ',' + epsilon(elements[13]) + ',' + epsilon(elements[14]) + ',' + epsilon(elements[15]) + ')';
            return 'translate(-50%,-50%)' + matrix3d;
        }
        function renderObject(object, scene, camera, cameraCSSMatrix) {
            if (object.isCSS3DObject) {
                const visible = object.visible === true && object.layers.test(camera.layers) === true;
                object.element.style.display = visible === true ? '' : 'none';
                if (visible === true) {
                    object.onBeforeRender(_this, scene, camera);
                    let style;
                    if (object.isCSS3DSprite) {
                        // http://swiftcoder.wordpress.com/2008/11/25/constructing-a-billboard-matrix/
                        $9363e764e36b7961$var$_matrix.copy(camera.matrixWorldInverse);
                        $9363e764e36b7961$var$_matrix.transpose();
                        if (object.rotation2D !== 0) $9363e764e36b7961$var$_matrix.multiply($9363e764e36b7961$var$_matrix2.makeRotationZ(object.rotation2D));
                        object.matrixWorld.decompose($9363e764e36b7961$var$_position, $9363e764e36b7961$var$_quaternion, $9363e764e36b7961$var$_scale);
                        $9363e764e36b7961$var$_matrix.setPosition($9363e764e36b7961$var$_position);
                        $9363e764e36b7961$var$_matrix.scale($9363e764e36b7961$var$_scale);
                        $9363e764e36b7961$var$_matrix.elements[3] = 0;
                        $9363e764e36b7961$var$_matrix.elements[7] = 0;
                        $9363e764e36b7961$var$_matrix.elements[11] = 0;
                        $9363e764e36b7961$var$_matrix.elements[15] = 1;
                        style = getObjectCSSMatrix($9363e764e36b7961$var$_matrix);
                    } else style = getObjectCSSMatrix(object.matrixWorld);
                    const element = object.element;
                    const cachedObject = cache.objects.get(object);
                    if (cachedObject === undefined || cachedObject.style !== style) {
                        element.style.transform = style;
                        const objectData = {
                            style: style
                        };
                        cache.objects.set(object, objectData);
                    }
                    if (element.parentNode !== cameraElement) cameraElement.appendChild(element);
                    object.onAfterRender(_this, scene, camera);
                }
            }
            for(let i = 0, l = object.children.length; i < l; i++)renderObject(object.children[i], scene, camera, cameraCSSMatrix);
        }
    }
}



var $4azF7 = parcelRequire("4azF7");

var $6ZWSX = parcelRequire("6ZWSX");
var $126c3ebbcc6243ba$require$Buffer = $6ZWSX.Buffer;
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$jd(s) {
    (0, $0qVX1.b)(Array.isArray(s), ()=>"The argument passed to tf.addN() must be a list of tensors"), (0, $0qVX1.b)(s.length >= 1, ()=>`Must pass at least one tensor to tf.addN(), but got ${s.length}`);
    const e = s.map((r, n)=>(0, $0qVX1.c)(r, `tensors${n}`, "addN")), t = e[0];
    e.forEach((r)=>{
        if (r.dtype !== t.dtype) throw new Error("All tensors passed to tf.addN() must have the same dtype");
    }), e.forEach((r)=>{
        if (!(0, $0qVX1.d)(r.shape, t.shape)) throw new Error("All tensors passed to tf.addN() must have the same shape");
    });
    const a = e;
    return (0, $0qVX1.E).runKernel((0, $0qVX1.A), a);
}
const $126c3ebbcc6243ba$var$nn = /* @__PURE__ */ (0, $0qVX1.o)({
    addN_: $126c3ebbcc6243ba$var$jd
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Bd(s, e, t, a, r, n) {
    const u = (0, $0qVX1.c)(s, "forgetBias", "basicLSTMCell"), o = (0, $0qVX1.c)(e, "lstmKernel", "basicLSTMCell"), l = (0, $0qVX1.c)(t, "lstmBias", "basicLSTMCell"), p = (0, $0qVX1.c)(a, "data", "basicLSTMCell"), m = (0, $0qVX1.c)(r, "c", "basicLSTMCell"), c = (0, $0qVX1.c)(n, "h", "basicLSTMCell"), d = (0, $0qVX1.e)([
        p,
        c
    ], 1), h = (0, $0qVX1.m)(d, o), N = (0, $0qVX1.f)(h, l), g = N.shape[0], f = N.shape[1] / 4, b = [
        g,
        f
    ], O = (0, $0qVX1.s)(N, [
        0,
        0
    ], b), _ = (0, $0qVX1.s)(N, [
        0,
        f
    ], b), T = (0, $0qVX1.s)(N, [
        0,
        f * 2
    ], b), I = (0, $0qVX1.s)(N, [
        0,
        f * 3
    ], b), D = (0, $0qVX1.f)((0, $0qVX1.g)((0, $0qVX1.h)(O), (0, $0qVX1.t)(_)), (0, $0qVX1.g)(m, (0, $0qVX1.h)((0, $0qVX1.f)(u, T)))), C = (0, $0qVX1.g)((0, $0qVX1.t)(D), (0, $0qVX1.h)(I));
    return [
        D,
        C
    ];
}
const $126c3ebbcc6243ba$var$on = /* @__PURE__ */ (0, $0qVX1.o)({
    basicLSTMCell_: $126c3ebbcc6243ba$var$Bd
});
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Hd(s, e) {
    const t = (0, $0qVX1.c)(s, "x", "bitwiseAnd"), a = (0, $0qVX1.c)(e, "y", "bitwiseAnd");
    if (!(0, $0qVX1.d)(t.shape, a.shape)) throw new Error(`BitwiseAnd: Tensors must have the same shape. x: ${t.shape}, y: ${a.shape}`);
    if (t.dtype !== "int32" || a.dtype !== "int32") throw new Error(`BitwiseAnd: Only supports 'int32' values in tensor, found type of x: ${t.dtype} and type of y: ${a.dtype}`);
    const r = {
        a: t,
        b: a
    };
    return (0, $0qVX1.E).runKernel((0, $0qVX1.B), r);
}
const $126c3ebbcc6243ba$var$un = /* @__PURE__ */ (0, $0qVX1.o)({
    bitwiseAnd_: $126c3ebbcc6243ba$var$Hd
});
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Wd(s, e) {
    const t = (0, $0qVX1.c)(s, "s0", "broadcastArgs", "int32"), a = (0, $0qVX1.c)(e, "s1", "broadcastArgs", "int32");
    if (t.rank !== 1) throw new Error(`broadcastArgs(): first input must be a vector (rank=1). Has rank ${t.rank}`);
    if (a.rank !== 1) throw new Error(`broadcastArgs(): second input must be a vector (rank=1). Has rank ${a.rank}`);
    const r = {
        s0: t,
        s1: a
    };
    return (0, $0qVX1.E).runKernel((0, $0qVX1.i), r);
}
const $126c3ebbcc6243ba$var$ln = /* @__PURE__ */ (0, $0qVX1.o)({
    broadcastArgs_: $126c3ebbcc6243ba$var$Wd
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Ud(s) {
    const t = {
        x: (0, $0qVX1.c)(s, "x", "diag")
    };
    return (0, $0qVX1.E).runKernel((0, $0qVX1.D), t);
}
const $126c3ebbcc6243ba$var$pn = /* @__PURE__ */ (0, $0qVX1.o)({
    diag_: $126c3ebbcc6243ba$var$Ud
});
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$qd(s, e) {
    const t = (0, $0qVX1.c)(s, "x", "ensureShape", "string_or_numeric");
    if (!(0, $0qVX1.j)(t.shape, e)) throw new Error(`EnsureShape: Shape of tensor ${t.shape} is not compatible with expected shape ${e}`);
    return s;
}
const $126c3ebbcc6243ba$var$mn = /* @__PURE__ */ (0, $0qVX1.o)({
    ensureShape_: $126c3ebbcc6243ba$var$qd
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$cn(s, e, t) {
    if (t <= 0) throw new Error("The number of values should be positive.");
    const a = {
        start: s,
        stop: e,
        num: t
    };
    return (0, $0qVX1.E).runKernel((0, $0qVX1.L), {}, a);
}
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$fe = 2147483648;
function $126c3ebbcc6243ba$var$Gd(s, e, t = "left") {
    const a = (0, $0qVX1.c)(s, "sortedSequence", "searchSorted"), r = (0, $0qVX1.c)(e, "values", "searchSorted"), n = a.shape[a.shape.length - 1], u = r.shape[r.shape.length - 1], o = (0, $0qVX1.r)(a, [
        -1,
        n
    ]), l = (0, $0qVX1.r)(r, [
        -1,
        u
    ]);
    if (o.rank < 2) throw new Error("Sorted input argument must be at least 2-dimensional");
    if (o.shape[0] !== l.shape[0]) throw new Error("Leading dimension of 'sortedSequence' and 'values' must match.");
    if ((0, $0qVX1.k)(l.shape) >= $126c3ebbcc6243ba$var$fe) throw new Error(`values tensor size must less than ${$126c3ebbcc6243ba$var$fe}`);
    if (o.shape[1] >= $126c3ebbcc6243ba$var$fe) throw new Error(`trailing dim_size must less than ${$126c3ebbcc6243ba$var$fe} for int32 output type, was ${o.shape[1]}`);
    const p = {
        sortedSequence: o,
        values: l
    }, m = {
        side: t
    };
    return (0, $0qVX1.E).runKernel((0, $0qVX1.S), p, m);
}
const $126c3ebbcc6243ba$var$Ce = /* @__PURE__ */ (0, $0qVX1.o)({
    searchSorted_: $126c3ebbcc6243ba$var$Gd
});
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$dn(s, e) {
    return $126c3ebbcc6243ba$var$Ce(s, e, "left");
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Kd(s, e, t, a, r = !1) {
    const u = {
        x: (0, $0qVX1.c)(s, "x", "maxPoolWithArgmax")
    }, o = {
        filterSize: e,
        strides: t,
        pad: a,
        includeBatchInIndex: r
    }, l = (0, $0qVX1.E).runKernel((0, $0qVX1.M), u, o);
    return {
        result: l[0],
        indexes: l[1]
    };
}
const $126c3ebbcc6243ba$var$hn = /* @__PURE__ */ (0, $0qVX1.o)({
    maxPoolWithArgmax_: $126c3ebbcc6243ba$var$Kd
});
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$fn(s, e, { indexing: t = "xy" } = {}) {
    if (t !== "xy" && t !== "ij") throw new TypeError(`${t} is not a valid third argument to meshgrid`);
    if (s === void 0) return [];
    let a = (0, $0qVX1.c)(s, "x", "meshgrid", s instanceof (0, $0qVX1.T) ? s.dtype : "float32");
    if (e === void 0) return [
        a
    ];
    let r = (0, $0qVX1.c)(e, "y", "meshgrid", e instanceof (0, $0qVX1.T) ? e.dtype : "float32");
    const n = (0, $0qVX1.k)(a.shape), u = (0, $0qVX1.k)(r.shape);
    return t === "xy" ? (a = (0, $0qVX1.r)(a, [
        1,
        -1
    ]), r = (0, $0qVX1.r)(r, [
        -1,
        1
    ]), [
        (0, $0qVX1.m)((0, $0qVX1.l)([
            u,
            1
        ], a.dtype), a),
        (0, $0qVX1.m)(r, (0, $0qVX1.l)([
            1,
            n
        ], r.dtype))
    ]) : (a = (0, $0qVX1.r)(a, [
        -1,
        1
    ]), r = (0, $0qVX1.r)(r, [
        1,
        -1
    ]), [
        (0, $0qVX1.m)(a, (0, $0qVX1.l)([
            1,
            u
        ], a.dtype)),
        (0, $0qVX1.m)((0, $0qVX1.l)([
            n,
            1
        ], r.dtype), r)
    ]);
}
function $126c3ebbcc6243ba$var$Jd(s, e, t, a) {
    const r = (0, $0qVX1.c)(e, "data", "multiRNNCell"), n = (0, $0qVX1.n)(t, "c", "multiRNNCell"), u = (0, $0qVX1.n)(a, "h", "multiRNNCell");
    let o = r;
    const l = [];
    for(let c = 0; c < s.length; c++){
        const d = s[c](o, n[c], u[c]);
        l.push(d[0]), l.push(d[1]), o = d[1];
    }
    const p = [], m = [];
    for(let c = 0; c < l.length; c += 2)p.push(l[c]), m.push(l[c + 1]);
    return [
        p,
        m
    ];
}
const $126c3ebbcc6243ba$var$yn = /* @__PURE__ */ (0, $0qVX1.o)({
    multiRNNCell_: $126c3ebbcc6243ba$var$Jd
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Qd(s, e, t, a = !1) {
    const r = (0, $0qVX1.c)(s, "logits", "multinomial"), n = r.size, u = r.rank;
    if (n < 2) throw new Error(`Error in multinomial: you need at least 2 outcomes, but got ${n}.`);
    if (u > 2) throw new Error(`Rank of probabilities must be 1 or 2, but is ${u}`);
    t = t || Math.random();
    const l = {
        logits: u === 1 ? (0, $0qVX1.r)(r, [
            1,
            -1
        ]) : r
    }, p = {
        numSamples: e,
        seed: t,
        normalized: a
    }, m = (0, $0qVX1.E).runKernel((0, $0qVX1.p), l, p);
    return u === 1 ? (0, $0qVX1.r)(m, [
        m.size
    ]) : m;
}
const $126c3ebbcc6243ba$var$gn = /* @__PURE__ */ (0, $0qVX1.o)({
    multinomial_: $126c3ebbcc6243ba$var$Qd
});
function $126c3ebbcc6243ba$var$Xd(s, e) {
    const t = (0, $0qVX1.c)(s, "v1", "outerProduct"), a = (0, $0qVX1.c)(e, "v2", "outerProduct");
    (0, $0qVX1.b)(t.rank === 1 && a.rank === 1, ()=>`Error in outerProduct: inputs must be rank 1, but got ranks ${t.rank} and ${a.rank}.`);
    const r = (0, $0qVX1.r)(t, [
        -1,
        1
    ]), n = (0, $0qVX1.r)(a, [
        1,
        -1
    ]);
    return (0, $0qVX1.m)(r, n);
}
const $126c3ebbcc6243ba$var$bn = /* @__PURE__ */ (0, $0qVX1.o)({
    outerProduct_: $126c3ebbcc6243ba$var$Xd
});
function $126c3ebbcc6243ba$var$Zd(s, e, t = 0) {
    return (0, $0qVX1.b)(e.length === 2, ()=>"Invalid number of paddings. Must be length of 2."), (0, $0qVX1.q)(s, [
        e
    ], t);
}
const $126c3ebbcc6243ba$var$Nn = /* @__PURE__ */ (0, $0qVX1.o)({
    pad1d_: $126c3ebbcc6243ba$var$Zd
});
function $126c3ebbcc6243ba$var$Yd(s, e, t = 0) {
    return (0, $0qVX1.b)(e.length === 2 && e[0].length === 2 && e[1].length === 2, ()=>"Invalid number of paddings. Must be length of 2 each."), (0, $0qVX1.q)(s, e, t);
}
const $126c3ebbcc6243ba$var$wn = /* @__PURE__ */ (0, $0qVX1.o)({
    pad2d_: $126c3ebbcc6243ba$var$Yd
});
function $126c3ebbcc6243ba$var$Md(s, e, t = 0) {
    return (0, $0qVX1.b)(e.length === 3 && e[0].length === 2 && e[1].length === 2 && e[2].length === 2, ()=>"Invalid number of paddings. Must be length of 2 each."), (0, $0qVX1.q)(s, e, t);
}
const $126c3ebbcc6243ba$var$Tn = /* @__PURE__ */ (0, $0qVX1.o)({
    pad3d_: $126c3ebbcc6243ba$var$Md
});
function $126c3ebbcc6243ba$var$eh(s, e, t = 0) {
    return (0, $0qVX1.b)(e.length === 4 && e[0].length === 2 && e[1].length === 2 && e[2].length === 2 && e[3].length === 2, ()=>"Invalid number of paddings. Must be length of 2 each."), (0, $0qVX1.q)(s, e, t);
}
const $126c3ebbcc6243ba$var$Sn = /* @__PURE__ */ (0, $0qVX1.o)({
    pad4d_: $126c3ebbcc6243ba$var$eh
});
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$th(s, e, t, a) {
    const r = s.map((m, c)=>(0, $0qVX1.c)(m, `tensors${c}`, "raggedGather", "int32")), n = (0, $0qVX1.c)(e, "paramsDenseValues", "raggedGather"), u = (0, $0qVX1.c)(t, "indices", "raggedGather", "int32"), o = {
        paramsNestedSplits: r,
        paramsDenseValues: n,
        indices: u
    }, l = {
        outputRaggedRank: a
    }, p = (0, $0qVX1.E).runKernel((0, $0qVX1.R), o, l);
    return {
        outputNestedSplits: p.slice(0, p.length - 1),
        outputDenseValues: p[p.length - 1]
    };
}
const $126c3ebbcc6243ba$var$vn = /* @__PURE__ */ (0, $0qVX1.o)({
    raggedGather_: $126c3ebbcc6243ba$var$th
});
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$sh(s, e, t) {
    const a = (0, $0qVX1.c)(s, "starts", "raggedRange"), r = (0, $0qVX1.c)(e, "limits", "raggedRange", a.dtype), n = (0, $0qVX1.c)(t, "deltas", "raggedRange", a.dtype), u = {
        starts: a,
        limits: r,
        deltas: n
    }, o = (0, $0qVX1.E).runKernel((0, $0qVX1.u), u);
    return {
        rtNestedSplits: o[0],
        rtDenseValues: o[1]
    };
}
const $126c3ebbcc6243ba$var$On = /* @__PURE__ */ (0, $0qVX1.o)({
    raggedRange_: $126c3ebbcc6243ba$var$sh
});
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$ah(s, e, t, a, r) {
    const n = (0, $0qVX1.c)(s, "shape", "raggedTensorToTensor", "int32"), u = (0, $0qVX1.c)(e, "values", "raggedTensorToTensor"), o = (0, $0qVX1.c)(t, "defaultValue", "raggedTensorToTensor", u.dtype), l = a.map((c, d)=>(0, $0qVX1.c)(c, `tensors${d}`, "raggedTensorToTensor", "int32")), p = {
        shape: n,
        values: u,
        defaultValue: o,
        rowPartitionTensors: l
    }, m = {
        rowPartitionTypes: r
    };
    return (0, $0qVX1.E).runKernel((0, $0qVX1.v), p, m);
}
const $126c3ebbcc6243ba$var$_n = /* @__PURE__ */ (0, $0qVX1.o)({
    raggedTensorToTensor_: $126c3ebbcc6243ba$var$ah
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$rh(s, e, t) {
    (0, $0qVX1.w)(s);
    const a = (0, $0qVX1.k)(s);
    let r = null;
    if (t == null || t === "float32") r = new Float32Array(a);
    else if (t === "int32") r = new Int32Array(a);
    else if (t === "bool") r = new Uint8Array(a);
    else throw new Error(`Unknown data type ${t}`);
    for(let n = 0; n < a; n++)r[n] = e();
    return (0, $0qVX1.E).makeTensor(r, s, t);
}
const $126c3ebbcc6243ba$var$An = /* @__PURE__ */ (0, $0qVX1.o)({
    rand_: $126c3ebbcc6243ba$var$rh
});
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$nh = 1e-3, $126c3ebbcc6243ba$var$En = 0.1;
function $126c3ebbcc6243ba$var$ih(s, e, t) {
    return t == null && (t = $126c3ebbcc6243ba$var$bt()), $126c3ebbcc6243ba$var$je(s, e, (a, r)=>$126c3ebbcc6243ba$var$Nt(a, r, t));
}
function $126c3ebbcc6243ba$var$bt() {
    return (0, $0qVX1.E).backend.floatPrecision() === 32 ? $126c3ebbcc6243ba$var$nh : $126c3ebbcc6243ba$var$En;
}
function $126c3ebbcc6243ba$var$je(s, e, t) {
    let a = !0;
    if (((0, $0qVX1.x)(s) || (0, $0qVX1.x)(e)) && (a = !1), (0, $0qVX1.x)(s) && (0, $0qVX1.x)(e) && (a = !0), a) {
        const u = s.constructor.name, o = e.constructor.name;
        if (u !== o) throw new Error(`Arrays are of different type. Actual: ${u}. Expected: ${o}`);
    }
    if (Array.isArray(s) && Array.isArray(e)) {
        const u = (0, $0qVX1.y)(s), o = (0, $0qVX1.y)(e);
        if (!(0, $0qVX1.d)(u, o)) throw new Error(`Arrays have different shapes. Actual: [${u}]. Expected: [${o}]`);
    }
    const r = (0, $0qVX1.x)(s) ? s : (0, $0qVX1.z)(s), n = (0, $0qVX1.x)(e) ? e : (0, $0qVX1.z)(e);
    if (r.length !== n.length) throw new Error(`Arrays have different lengths actual: ${r.length} vs expected: ${n.length}.
Actual:   ${r}.
Expected: ${n}.`);
    for(let u = 0; u < n.length; ++u){
        const o = r[u], l = n[u];
        if (!t(o, l)) throw new Error(`Arrays differ: actual[${u}] = ${o}, expected[${u}] = ${l}.
Actual:   ${r}.
Expected: ${n}.`);
    }
    typeof expect < "u" && expect().nothing();
}
function $126c3ebbcc6243ba$var$oh(s, e) {
    s().then(()=>e.fail(), ()=>e()), typeof expect < "u" && expect().nothing();
}
function $126c3ebbcc6243ba$var$uh(s, e) {
    const t = typeof e == "string" || typeof e == "number" || typeof e == "boolean" ? [
        e
    ] : e;
    return (0, $0qVX1.F)(s) || (0, $0qVX1.F)(s[0]) || (0, $0qVX1.F)(e) || (0, $0qVX1.F)(e[0]) ? $126c3ebbcc6243ba$var$je(s, t, (a, r)=>a == r) : $126c3ebbcc6243ba$var$je(s, e, (a, r)=>$126c3ebbcc6243ba$var$Nt(a, r, 0));
}
function $126c3ebbcc6243ba$var$lh(s, e, t) {
    if (t == null && (t = $126c3ebbcc6243ba$var$bt()), !$126c3ebbcc6243ba$var$Nt(s, e, t)) throw new Error(`Numbers differ: actual === ${s}, expected === ${e}`);
    typeof expect < "u" && expect().nothing();
}
function $126c3ebbcc6243ba$var$Nt(s, e, t) {
    return !isFinite(s) && !isFinite(e) ? !0 : !(isNaN(s) || isNaN(e) || Math.abs(s - e) > t);
}
function $126c3ebbcc6243ba$var$ph(s, e, t) {
    for(let a = 0; a < s.length; a++)if (s[a] < e || s[a] > t) throw new Error(`Value out of range:${s[a]} low: ${e}, high: ${t}`);
}
function $126c3ebbcc6243ba$var$mh(s, e) {
    const t = new Float32Array(s), a = new Float32Array(e);
    if (t.length !== a.length) throw new Error(`Expected ArrayBuffer to be of length ${a.length}, but it was ${t.length}`);
    for(let r = 0; r < a.length; r++)if (t[r] !== a[r]) throw new Error(`Expected ArrayBuffer value at ${r} to be ${a[r]} but got ${t[r]} instead`);
}
function $126c3ebbcc6243ba$var$kn(s) {
    for(let e = 0; e < s.length; e++){
        const t = s[e];
        Array.isArray(t) ? $126c3ebbcc6243ba$var$kn(t) : s[e] = (0, $0qVX1.G)(t);
    }
    return s;
}
function $126c3ebbcc6243ba$var$ch(s) {
    const e = document.createElement("video");
    return "playsInline" in e && (e.playsInline = !0), e.muted = !0, e.loop = !0, e.style.position = "fixed", e.style.left = "0px", e.style.top = "0px", e.preload = "auto", e.appendChild(s), new Promise((t)=>{
        e.addEventListener("loadeddata", (a)=>t(e)), e.load();
    });
}
async function $126c3ebbcc6243ba$var$dh(s) {
    await s.play(), "requestVideoFrameCallback" in s && await new Promise((e)=>{
        s.requestVideoFrameCallback(e);
    });
}
const $126c3ebbcc6243ba$var$hh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    TEST_EPSILON_FLOAT16: $126c3ebbcc6243ba$var$En,
    createVideoElement: $126c3ebbcc6243ba$var$ch,
    encodeStrings: $126c3ebbcc6243ba$var$kn,
    expectArrayBuffersEqual: $126c3ebbcc6243ba$var$mh,
    expectArraysClose: $126c3ebbcc6243ba$var$ih,
    expectArraysEqual: $126c3ebbcc6243ba$var$uh,
    expectNumbersClose: $126c3ebbcc6243ba$var$lh,
    expectPromiseToFail: $126c3ebbcc6243ba$var$oh,
    expectValuesInRange: $126c3ebbcc6243ba$var$ph,
    play: $126c3ebbcc6243ba$var$dh,
    testEpsilon: $126c3ebbcc6243ba$var$bt
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$fh(s, e, t = 1, a = "float32", r) {
    if ((0, $0qVX1.w)(s), t == null && (t = 1), a == null && (a = "float32"), a !== "float32" && a !== "int32") throw new Error(`Unsupported data type ${a}`);
    const n = new (0, $0qVX1.H)(e, t, a, r), u = (0, $0qVX1.I)(s, a);
    for(let o = 0; o < u.values.length; o++)u.values[o] = n.nextValue();
    return u.toTensor();
}
const $126c3ebbcc6243ba$var$In = /* @__PURE__ */ (0, $0qVX1.o)({
    randomGamma_: $126c3ebbcc6243ba$var$fh
});
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$yh(s, e, t) {
    if (e != null && e === "bool") throw new Error(`Unsupported data type ${e}`);
    return (0, $0qVX1.J)(s, 0, 1, e, t);
}
const $126c3ebbcc6243ba$var$$n = /* @__PURE__ */ (0, $0qVX1.o)({
    randomStandardNormal_: $126c3ebbcc6243ba$var$yh
});
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$gh(s, e, t, a) {
    return (0, $0qVX1.K)(s, e, t, "int32", a);
}
const $126c3ebbcc6243ba$var$Dn = /* @__PURE__ */ (0, $0qVX1.o)({
    randomUniformInt_: $126c3ebbcc6243ba$var$gh
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$bh(s) {
    const e = (0, $0qVX1.c)(s, "x", "reverse");
    return (0, $0qVX1.b)(e.rank === 1, ()=>`Error in reverse1D: x must be rank 1 but got rank ${e.rank}.`), (0, $0qVX1.N)(e, 0);
}
const $126c3ebbcc6243ba$var$Cn = /* @__PURE__ */ (0, $0qVX1.o)({
    reverse1d_: $126c3ebbcc6243ba$var$bh
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Nh(s, e) {
    const t = (0, $0qVX1.c)(s, "x", "reverse");
    return (0, $0qVX1.b)(t.rank === 2, ()=>`Error in reverse2D: x must be rank 2 but got rank ${t.rank}.`), (0, $0qVX1.N)(t, e);
}
const $126c3ebbcc6243ba$var$zn = /* @__PURE__ */ (0, $0qVX1.o)({
    reverse2d_: $126c3ebbcc6243ba$var$Nh
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$wh(s, e) {
    const t = (0, $0qVX1.c)(s, "x", "reverse");
    return (0, $0qVX1.b)(t.rank === 3, ()=>`Error in reverse3D: x must be rank 3 but got rank ${t.rank}.`), (0, $0qVX1.N)(t, e);
}
const $126c3ebbcc6243ba$var$xn = /* @__PURE__ */ (0, $0qVX1.o)({
    reverse3d_: $126c3ebbcc6243ba$var$wh
});
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Th(s, e) {
    const t = (0, $0qVX1.c)(s, "x", "reverse");
    return (0, $0qVX1.b)(t.rank === 4, ()=>`Error in reverse4D: x must be rank 4 but got rank ${t.rank}.`), (0, $0qVX1.N)(t, e);
}
const $126c3ebbcc6243ba$var$Ln = /* @__PURE__ */ (0, $0qVX1.o)({
    reverse4d_: $126c3ebbcc6243ba$var$Th
});
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ async function $126c3ebbcc6243ba$var$Sh(s, e) {
    const t = (0, $0qVX1.c)(s, "x", "setdiff1d"), a = (0, $0qVX1.c)(e, "y", "setdiff1d");
    (0, $0qVX1.b)(t.dtype === a.dtype, ()=>`x and y should have the same dtype, but got x (${t.dtype}) and y (${a.dtype}).`), (0, $0qVX1.b)(t.rank === 1, ()=>`x should be 1D tensor, but got x (${t.shape}).`), (0, $0qVX1.b)(a.rank === 1, ()=>`y should be 1D tensor, but got y (${a.shape}).`);
    const r = await t.data(), n = await a.data(), u = new Set(n);
    let o = 0;
    for(let m = 0; m < r.length; m++)u.has(r[m]) || o++;
    const l = new (0, $0qVX1.O)([
        o
    ], t.dtype), p = new (0, $0qVX1.O)([
        o
    ], "int32");
    for(let m = 0, c = 0; m < r.length; m++)u.has(r[m]) || (l.values[c] = r[m], p.values[c] = m, c++);
    return [
        l.toTensor(),
        p.toTensor()
    ];
}
const $126c3ebbcc6243ba$var$Pn = $126c3ebbcc6243ba$var$Sh;
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Fn(s, e, t) {
    if ((0, $0qVX1.P)(s), e != null && e.length !== 4) throw new Error("tensor4d() requires shape to have four numbers");
    const a = (0, $0qVX1.y)(s, t);
    if (a.length !== 4 && a.length !== 1) throw new Error("tensor4d() requires values to be number[][][][] or flat/TypedArray");
    if (a.length === 1 && e == null) throw new Error("tensor4d() requires shape to be provided when `values` are a flat array");
    return (0, $0qVX1.Q)(s, e, a, t);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Vn(s, e, t) {
    if ((0, $0qVX1.P)(s), e != null && e.length !== 5) throw new Error("tensor5d() requires shape to have five numbers");
    const a = (0, $0qVX1.y)(s, t);
    if (a.length !== 5 && a.length !== 1) throw new Error("tensor5d() requires values to be number[][][][][] or flat/TypedArray");
    if (a.length === 1 && e == null) throw new Error("tensor5d() requires shape to be provided when `values` are a flat array");
    return (0, $0qVX1.Q)(s, e, a, t);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Rn(s, e, t) {
    if ((0, $0qVX1.P)(s), e != null && e.length !== 6) throw new Error("tensor6d() requires shape to have six numbers");
    const a = (0, $0qVX1.y)(s, t);
    if (a.length !== 6 && a.length !== 1) throw new Error("tensor6d() requires values to be number[][][][][][] or flat/TypedArray");
    if (a.length === 1 && e == null) throw new Error("tensor6d() requires shape to be provided when `values` are a flat array");
    return e = e || a, (0, $0qVX1.Q)(s, e, a, t);
}
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$vh(s, e, t) {
    const a = (0, $0qVX1.c)(s, "tensor", "tensorScatterupdate"), r = (0, $0qVX1.c)(e, "indices", "tensorScatterupdate", "int32"), n = (0, $0qVX1.c)(t, "updates", "tensorScatterupdate");
    if ((0, $0qVX1.U)(n, r, a.shape), a.dtype !== n.dtype) throw new Error(`tensor and updates must have the same dtype, instead they are ${a.dtype} and ${n.dtype}.`);
    const u = {
        tensor: a,
        indices: r,
        updates: n
    }, o = {};
    return (0, $0qVX1.E).runKernel((0, $0qVX1.V), u, o);
}
const $126c3ebbcc6243ba$var$jn = (0, $0qVX1.o)({
    tensorScatterUpdate_: $126c3ebbcc6243ba$var$vh
});
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Bn(s, e) {
    return $126c3ebbcc6243ba$var$Ce(s, e, "right");
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ async function $126c3ebbcc6243ba$var$Oh(s) {
    const e = (0, $0qVX1.c)(s, "condition", "whereAsync", "bool"), t = await e.data(), a = (0, $0qVX1.W)(e.shape, t);
    return s !== e && e.dispose(), a;
}
const $126c3ebbcc6243ba$var$wt = $126c3ebbcc6243ba$var$Oh;
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ async function $126c3ebbcc6243ba$var$_h(s, e, t) {
    const a = (0, $0qVX1.c)(s, "tensor", "boolMask"), r = (0, $0qVX1.c)(e, "mask", "boolMask", "bool"), n = t ?? 0, u = r.rank, o = a.shape;
    (0, $0qVX1.b)(u > 0, ()=>"mask cannot be scalar"), (0, $0qVX1.X)(o.slice(n, n + u), r.shape, "mask's shape must match the first K dimensions of tensor's shape,");
    let l = 1;
    for(let g = n; g < n + u; g++)l *= o[g];
    const p = o.slice(0, n).concat([
        l
    ], o.slice(n + u)), m = (0, $0qVX1.r)(a, p), c = (0, $0qVX1.r)(r, [
        -1
    ]), d = await $126c3ebbcc6243ba$var$wt(c), h = (0, $0qVX1.Y)(d, [
        1
    ]), N = (0, $0qVX1.Z)(m, h, n);
    return s !== a && a.dispose(), e !== r && r.dispose(), h.dispose(), m.dispose(), c.dispose(), d.dispose(), N;
}
const $126c3ebbcc6243ba$var$Hn = $126c3ebbcc6243ba$var$_h;
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Ah(s, e, t, a, r = !0) {
    const n = (0, $0qVX1.c)(s, "v", "movingAverage"), u = (0, $0qVX1.c)(e, "x", "movingAverage"), o = (0, $0qVX1.c)(t, "decay", "movingAverage");
    (0, $0qVX1._)(n, u), (0, $0qVX1.b)((0, $0qVX1.d)(n.shape, u.shape), ()=>"Shape mismatch in v and x");
    const l = (0, $0qVX1.$)(1), p = (0, $0qVX1.a0)(l, o);
    let m = (0, $0qVX1.g)((0, $0qVX1.a0)(u, n), p);
    if (r) {
        (0, $0qVX1.b)(a != null, ()=>"When using zeroDebias: true, step is required.");
        const c = (0, $0qVX1.c)(a, "step", "movingAverage");
        m = (0, $0qVX1.a1)(m, (0, $0qVX1.a0)(l, (0, $0qVX1.a2)(o, c)));
    }
    return (0, $0qVX1.f)(n, m);
}
const $126c3ebbcc6243ba$var$Wn = /* @__PURE__ */ (0, $0qVX1.o)({
    movingAverage_: $126c3ebbcc6243ba$var$Ah
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Eh(s, e, t) {
    (0, $0qVX1.w)(t);
    const a = (0, $0qVX1.c)(s, "indices", "scatterND", "int32"), r = (0, $0qVX1.c)(e, "updates", "scatterND");
    (0, $0qVX1.U)(r, a, t);
    const n = {
        indices: a,
        updates: r
    }, u = {
        shape: t
    };
    return (0, $0qVX1.E).runKernel((0, $0qVX1.a3), n, u);
}
const $126c3ebbcc6243ba$var$Un = /* @__PURE__ */ (0, $0qVX1.o)({
    scatterND_: $126c3ebbcc6243ba$var$Eh
});
function $126c3ebbcc6243ba$var$kh(s, e, t, a) {
    if (s.dtype !== "int32") throw new Error(`tf.sparseToDense() expects the indices to be int32 type, but the dtype was ${s.dtype}.`);
    if (s.rank > 2) throw new Error(`sparseIndices should be a scalar, vector, or matrix, but got shape ${s.shape}.`);
    const r = s.rank > 0 ? s.shape[0] : 1, n = s.rank > 1 ? s.shape[1] : 1;
    if (t.length !== n) throw new Error(`outputShape has incorrect number of elements:, ${t.length}, should be: ${n}.`);
    const u = e.size;
    if (!(e.rank === 0 || e.rank === 1 && u === r)) throw new Error(`sparseValues has incorrect shape ${e.shape}, should be [] or [${r}]`);
    if (e.dtype !== a.dtype) throw new Error("sparseValues.dtype must match defaultValues.dtype");
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Ih(s, e, t, a = 0) {
    (0, $0qVX1.w)(t);
    const r = (0, $0qVX1.c)(s, "sparseIndices", "sparseToDense", "int32"), n = (0, $0qVX1.c)(e, "sparseValues", "sparseToDense", "string_or_numeric"), u = (0, $0qVX1.c)(a, "defaultValue", "sparseToDense", n.dtype);
    $126c3ebbcc6243ba$var$kh(r, n, t, u);
    const o = {
        sparseIndices: r,
        sparseValues: n,
        defaultValue: u
    }, l = {
        outputShape: t
    };
    return (0, $0qVX1.E).runKernel((0, $0qVX1.a4), o, l);
}
const $126c3ebbcc6243ba$var$qn = /* @__PURE__ */ (0, $0qVX1.o)({
    sparseToDense_: $126c3ebbcc6243ba$var$Ih
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$$h(s, e) {
    const t = (0, $0qVX1.c)(e, "indices", "gatherND", "int32"), r = {
        params: (0, $0qVX1.c)(s, "x", "gatherND", "string_or_numeric"),
        indices: t
    };
    return (0, $0qVX1.E).runKernel((0, $0qVX1.a5), r);
}
const $126c3ebbcc6243ba$var$Gn = /* @__PURE__ */ (0, $0qVX1.o)({
    gatherND_: $126c3ebbcc6243ba$var$$h
});
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ async function $126c3ebbcc6243ba$var$Dh(s, e, t = 1) {
    const a = (0, $0qVX1.c)(s, "predictions", "inTopK"), r = (0, $0qVX1.c)(e, "targets", "inTopK");
    (0, $0qVX1.b)(a.rank > 1, ()=>`inTopK() expects the predictions to be of rank 2 or higher, but got ${a.rank}`), (0, $0qVX1.b)(a.rank - 1 === r.rank, ()=>`predictions rank should be 1 larger than targets rank, but got predictions rank ${a.rank} and targets rank ${r.rank}`), (0, $0qVX1.X)(a.shape.slice(0, a.shape.length - 1), r.shape, "predictions's shape should be align with the targets' shape, except the last dimension.");
    const n = a.shape[a.shape.length - 1];
    (0, $0qVX1.b)(t > 0 && t <= n, ()=>`'k' passed to inTopK() must be > 0 && <= the predictions last dimension (${n}), but got ${t}`);
    const u = await a.data(), o = await r.data(), [l, p] = [
        u.length / n,
        n
    ], m = (0, $0qVX1.a6)("bool", l);
    for(let c = 0; c < l; c++){
        const d = c * p, h = u.subarray(d, d + p), N = [];
        for(let g = 0; g < h.length; g++)N.push({
            value: h[g],
            index: g
        });
        N.sort((g, f)=>f.value - g.value), m[c] = 0;
        for(let g = 0; g < t; g++)if (N[g].index === o[c]) {
            m[c] = 1;
            break;
        }
    }
    return s !== a && a.dispose(), e !== r && r.dispose(), (0, $0qVX1.a7)(m, r.shape, "bool");
}
const $126c3ebbcc6243ba$var$Kn = $126c3ebbcc6243ba$var$Dh;
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Ch({ x: s, filter: e, strides: t, pad: a, dataFormat: r = "NHWC", dilations: n = [
    1,
    1
], dimRoundingMode: u, bias: o, activation: l = "linear", preluActivationWeights: p, leakyreluAlpha: m }) {
    if ((0, $0qVX1.a8)((0, $0qVX1.E).state.gradientDepth, l) === !1) {
        let I = (0, $0qVX1.a9)(s, e, t, a, r, n, u);
        return o != null && (I = (0, $0qVX1.f)(I, o)), (0, $0qVX1.aa)(I, l, p, m);
    }
    const c = (0, $0qVX1.c)(s, "x", "depthwiseConv2d", "float32"), d = (0, $0qVX1.c)(e, "filter", "depthwiseConv2d", "float32");
    let h = c, N = !1;
    c.rank === 3 && (N = !0, h = (0, $0qVX1.r)(c, [
        1,
        c.shape[0],
        c.shape[1],
        c.shape[2]
    ])), (0, $0qVX1.b)(h.rank === 4, ()=>`Error in fused depthwiseConv2d: input must be rank 4, but got rank ${h.rank}.`), (0, $0qVX1.b)(d.rank === 4, ()=>`Error in fused depthwiseConv2d: filter must be rank 4, but got rank ${d.rank}.`), (0, $0qVX1.b)(h.shape[3] === d.shape[2], ()=>`Error in fused depthwiseConv2d: number of input channels (${h.shape[3]}) must match the inChannels dimension in filter ${d.shape[2]}.`), n == null && (n = [
        1,
        1
    ]), (0, $0qVX1.b)((0, $0qVX1.ab)(t, n), ()=>`Error in fused depthwiseConv2d: Either strides or dilations must be 1. Got strides ${t} and dilations '${n}'`), (0, $0qVX1.ac)("fused depthwiseConv2d", a, u);
    const g = (0, $0qVX1.ad)(h.shape, d.shape, t, n, a, u, !0);
    let f;
    o != null && (f = (0, $0qVX1.c)(o, "bias", "fused conv2d"), [f] = (0, $0qVX1.ae)(f, c), (0, $0qVX1.af)(g.outShape, f.shape));
    let b;
    p != null && (b = (0, $0qVX1.c)(p, "prelu weights", "fused depthwiseConv2d"));
    const O = (I, D)=>{
        (0, $0qVX1.b)((0, $0qVX1.ai)(n), ()=>`Error in gradient of fused depthwiseConv2d: dilation rates greater than 1 are not yet supported. Got dilations '${n}'`);
        const [C, X, F, j] = D, ze = (0, $0qVX1.aj)(I, F, l), $t = (0, $0qVX1.ak)(X.shape, ze, C, t, a, n, u), Dt = (0, $0qVX1.al)(X, ze, C.shape, t, a, n, u);
        if (j != null) {
            const wi = (0, $0qVX1.am)(f, ze);
            return [
                $t,
                Dt,
                wi
            ];
        }
        return [
            $t,
            Dt
        ];
    }, _ = {
        x: h,
        filter: d,
        bias: f,
        preluActivationWeights: b
    }, T = {
        strides: t,
        pad: a,
        dataFormat: r,
        dilations: n,
        dimRoundingMode: u,
        activation: l,
        leakyreluAlpha: m
    };
    return o == null ? (0, $0qVX1.ag)((D, C, X)=>{
        let F = (0, $0qVX1.E).runKernel((0, $0qVX1.ah), _, T);
        return X([
            C,
            D,
            F
        ]), N && (F = (0, $0qVX1.r)(F, [
            F.shape[1],
            F.shape[2],
            F.shape[3]
        ])), {
            value: F,
            gradFunc: O
        };
    })(h, d) : (0, $0qVX1.ag)((D, C, X, F)=>{
        let j = (0, $0qVX1.E).runKernel((0, $0qVX1.ah), _, T);
        return F([
            C,
            D,
            j,
            X
        ]), N && (j = (0, $0qVX1.r)(j, [
            j.shape[1],
            j.shape[2],
            j.shape[3]
        ])), {
            value: j,
            gradFunc: O
        };
    })(h, d, f);
}
const $126c3ebbcc6243ba$var$zh = /* @__PURE__ */ (0, $0qVX1.o)({
    fusedDepthwiseConv2d_: $126c3ebbcc6243ba$var$Ch
});
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Jn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    conv2d: (0, $0qVX1.an),
    depthwiseConv2d: $126c3ebbcc6243ba$var$zh,
    matMul: (0, $0qVX1.ao)
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$xh = "model", $126c3ebbcc6243ba$var$Lh = ".json", $126c3ebbcc6243ba$var$Ph = ".weights.bin";
function $126c3ebbcc6243ba$var$Ft(s) {
    return new Promise((e)=>setTimeout(e)).then(s);
}
class $126c3ebbcc6243ba$var$J {
    constructor(e){
        if (!(0, $0qVX1.as)().getBool("IS_BROWSER")) throw new Error("browserDownloads() cannot proceed because the current environment is not a browser.");
        e.startsWith($126c3ebbcc6243ba$var$J.URL_SCHEME) && (e = e.slice($126c3ebbcc6243ba$var$J.URL_SCHEME.length)), (e == null || e.length === 0) && (e = $126c3ebbcc6243ba$var$xh), this.modelJsonFileName = e + $126c3ebbcc6243ba$var$Lh, this.weightDataFileName = e + $126c3ebbcc6243ba$var$Ph;
    }
    async save(e) {
        if (typeof document > "u") throw new Error("Browser downloads are not supported in this environment since `document` is not present");
        const t = (0, $0qVX1.at).join(e.weightData), a = window.URL.createObjectURL(new Blob([
            t
        ], {
            type: "application/octet-stream"
        }));
        if (e.modelTopology instanceof ArrayBuffer) throw new Error("BrowserDownloads.save() does not support saving model topology in binary formats yet.");
        {
            const r = [
                {
                    paths: [
                        "./" + this.weightDataFileName
                    ],
                    weights: e.weightSpecs
                }
            ], n = (0, $0qVX1.au)(e, r), u = window.URL.createObjectURL(new Blob([
                JSON.stringify(n)
            ], {
                type: "application/json"
            })), o = this.modelJsonAnchor == null ? document.createElement("a") : this.modelJsonAnchor;
            if (o.download = this.modelJsonFileName, o.href = u, await $126c3ebbcc6243ba$var$Ft(()=>o.dispatchEvent(new MouseEvent("click"))), e.weightData != null) {
                const l = this.weightDataAnchor == null ? document.createElement("a") : this.weightDataAnchor;
                l.download = this.weightDataFileName, l.href = a, await $126c3ebbcc6243ba$var$Ft(()=>l.dispatchEvent(new MouseEvent("click")));
            }
            return {
                modelArtifactsInfo: (0, $0qVX1.av)(e)
            };
        }
    }
}
$126c3ebbcc6243ba$var$J.URL_SCHEME = "downloads://";
class $126c3ebbcc6243ba$var$Fh {
    constructor(e){
        if (e == null || e.length < 1) throw new Error(`When calling browserFiles, at least 1 file is required, but received ${e}`);
        this.jsonFile = e[0], this.weightsFiles = e.slice(1);
    }
    async load() {
        return new Promise((e, t)=>{
            const a = new FileReader();
            a.onload = (r)=>{
                const n = JSON.parse(r.target.result), u = n.modelTopology;
                if (u == null) {
                    t(new Error(`modelTopology field is missing from file ${this.jsonFile.name}`));
                    return;
                }
                if (n.weightsManifest == null) {
                    t(new Error(`weightManifest field is missing from file ${this.jsonFile.name}`));
                    return;
                }
                if (this.weightsFiles.length === 0) {
                    e({
                        modelTopology: u
                    });
                    return;
                }
                const l = (0, $0qVX1.aq)(n, (p)=>this.loadWeights(p));
                e(l);
            }, a.onerror = (r)=>t(`Failed to read model topology and weights manifest JSON from file '${this.jsonFile.name}'. BrowserFiles supports loading Keras-style tf.Model artifacts only.`), a.readAsText(this.jsonFile);
        });
    }
    loadWeights(e) {
        const t = [], a = [];
        for (const u of e)t.push(...u.weights), a.push(...u.paths);
        const r = this.checkManifestAndWeightFiles(e), n = a.map((u)=>this.loadWeightsFile(u, r[u]));
        return Promise.all(n).then((u)=>[
                t,
                u
            ]);
    }
    loadWeightsFile(e, t) {
        return new Promise((a, r)=>{
            const n = new FileReader();
            n.onload = (u)=>{
                const o = u.target.result;
                a(o);
            }, n.onerror = (u)=>r(`Failed to weights data from file of path '${e}'.`), n.readAsArrayBuffer(t);
        });
    }
    /**
   * Check the compatibility between weights manifest and weight files.
   */ checkManifestAndWeightFiles(e) {
        const t = [], a = this.weightsFiles.map((n)=>(0, $0qVX1.ar)(n.name)), r = {};
        for (const n of e)n.paths.forEach((u)=>{
            const o = (0, $0qVX1.ar)(u);
            if (t.indexOf(o) !== -1) throw new Error(`Duplicate file basename found in weights manifest: '${o}'`);
            if (t.push(o), a.indexOf(o) === -1) throw new Error(`Weight file with basename '${o}' is not provided.`);
            r[u] = this.weightsFiles[a.indexOf(o)];
        });
        if (t.length !== this.weightsFiles.length) throw new Error(`Mismatch in the number of files in weights manifest (${t.length}) and the number of weight files provided (${this.weightsFiles.length}).`);
        return r;
    }
}
const $126c3ebbcc6243ba$var$Vh = (s)=>(0, $0qVX1.as)().getBool("IS_BROWSER") && !Array.isArray(s) && s.startsWith($126c3ebbcc6243ba$var$J.URL_SCHEME) ? $126c3ebbcc6243ba$var$Rh(s.slice($126c3ebbcc6243ba$var$J.URL_SCHEME.length)) : null;
(0, $0qVX1.ap).registerSaveRouter($126c3ebbcc6243ba$var$Vh);
function $126c3ebbcc6243ba$var$Rh(s = "model") {
    return new $126c3ebbcc6243ba$var$J(s);
}
function $126c3ebbcc6243ba$var$jh(s) {
    return new $126c3ebbcc6243ba$var$Fh(s);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $126c3ebbcc6243ba$var$xe {
    constructor(e){
        this.modelArtifacts = e;
    }
    load() {
        return this.modelArtifacts;
    }
}
class $126c3ebbcc6243ba$var$Qn {
    constructor(e){
        this.saveHandler = e;
    }
    save(e) {
        return this.saveHandler(e);
    }
}
class $126c3ebbcc6243ba$var$Bh {
    constructor(e){
        e.load && (this.load = ()=>Promise.resolve(e.load())), e.save && (this.save = (t)=>Promise.resolve(e.save(t)));
    }
}
function $126c3ebbcc6243ba$var$Hh(s, e, t, a) {
    const r = arguments;
    return new $126c3ebbcc6243ba$var$Bh($126c3ebbcc6243ba$var$Ee(...r));
}
function $126c3ebbcc6243ba$var$Ee(s, e, t, a) {
    return arguments.length === 1 ? s.modelTopology != null || s.weightSpecs != null ? new $126c3ebbcc6243ba$var$xe(s) : (console.warn("Please call tf.io.fromMemory() with only one argument. The argument should be of type ModelArtifacts. The multi-argument signature of tf.io.fromMemory() has been deprecated and will be removed in a future release."), new $126c3ebbcc6243ba$var$xe({
        modelTopology: s
    })) : (console.warn("Please call tf.io.fromMemory() with only one argument. The argument should be of type ModelArtifacts. The multi-argument signature of tf.io.fromMemory() has been deprecated and will be removed in a future release."), new $126c3ebbcc6243ba$var$xe({
        modelTopology: s,
        weightSpecs: e,
        weightData: t,
        trainingConfig: a
    }));
}
function $126c3ebbcc6243ba$var$Wh(s) {
    return new $126c3ebbcc6243ba$var$Qn(s);
}
function $126c3ebbcc6243ba$var$Uh(s) {
    return new $126c3ebbcc6243ba$var$Qn(s);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Tt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    CompositeArrayBuffer: (0, $0qVX1.at),
    browserFiles: $126c3ebbcc6243ba$var$jh,
    browserHTTPRequest: (0, $0qVX1.aw),
    concatenateArrayBuffers: (0, $0qVX1.ax),
    copyModel: (0, $0qVX1.ay),
    decodeWeights: (0, $0qVX1.az),
    decodeWeightsStream: (0, $0qVX1.aA),
    encodeWeights: (0, $0qVX1.aB),
    fromMemory: $126c3ebbcc6243ba$var$Hh,
    fromMemorySync: $126c3ebbcc6243ba$var$Ee,
    getLoadHandlers: (0, $0qVX1.aC),
    getModelArtifactsForJSON: (0, $0qVX1.aq),
    getModelArtifactsForJSONSync: (0, $0qVX1.aD),
    getModelArtifactsInfoForJSON: (0, $0qVX1.av),
    getSaveHandlers: (0, $0qVX1.aE),
    getWeightSpecs: (0, $0qVX1.aF),
    http: (0, $0qVX1.aG),
    isHTTPScheme: (0, $0qVX1.aH),
    listModels: (0, $0qVX1.aI),
    loadWeights: (0, $0qVX1.aJ),
    moveModel: (0, $0qVX1.aK),
    registerLoadRouter: (0, $0qVX1.aL),
    registerSaveRouter: (0, $0qVX1.aM),
    removeModel: (0, $0qVX1.aN),
    weightsLoaderFactory: (0, $0qVX1.aO),
    withSaveHandler: $126c3ebbcc6243ba$var$Wh,
    withSaveHandlerSync: $126c3ebbcc6243ba$var$Uh
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$qh(s, e, t) {
    const a = (0, $0qVX1.c)(s, "labels", "confusionMatrix"), r = (0, $0qVX1.c)(e, "predictions", "confusionMatrix");
    (0, $0qVX1.b)(t == null || t > 0 && Number.isInteger(t), ()=>`If provided, numClasses must be a positive integer, but got ${t}`), (0, $0qVX1.b)(a.rank === 1, ()=>`Expected the rank of labels to be 1, but got ${a.rank}`), (0, $0qVX1.b)(r.rank === 1, ()=>`Expected the rank of predictions to be 1, but got ${r.rank}`), (0, $0qVX1.b)(a.shape[0] === r.shape[0], ()=>`Mismatch in the number of examples: ${a.shape[0]} vs. ${r.shape[0]}. Labels and predictions should have the same number of elements.`), (0, $0qVX1.b)(t > 0 && Number.isInteger(t), ()=>`numClasses is required to be a positive integer, but got ${t}`);
    const n = (0, $0qVX1.aP)((0, $0qVX1.aQ)(a, "int32"), t), u = (0, $0qVX1.aP)((0, $0qVX1.aQ)(r, "int32"), t), o = (0, $0qVX1.aR)(n), l = (0, $0qVX1.m)(o, u);
    return (0, $0qVX1.aQ)(l, "int32");
}
const $126c3ebbcc6243ba$var$Gh = /* @__PURE__ */ (0, $0qVX1.o)({
    confusionMatrix_: $126c3ebbcc6243ba$var$qh
});
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Kh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    confusionMatrix: $126c3ebbcc6243ba$var$Gh
}, Symbol.toStringTag, {
    value: "Module"
}));
/** @license See the LICENSE file. */ const $126c3ebbcc6243ba$var$Xn = "4.16.0";
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Jh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    nonMaxSuppressionV3Impl: (0, $0qVX1.aS),
    nonMaxSuppressionV4Impl: (0, $0qVX1.aT),
    nonMaxSuppressionV5Impl: (0, $0qVX1.aU),
    whereImpl: (0, $0qVX1.W)
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Qh(s) {
    return new (0, $0qVX1.aV)(s);
}
function $126c3ebbcc6243ba$var$Xh(s) {
    return new (0, $0qVX1.aW)(s);
}
function $126c3ebbcc6243ba$var$Zh() {
    return new (0, $0qVX1.aX)();
}
function $126c3ebbcc6243ba$var$Yh(s) {
    return new (0, $0qVX1.aY)(s);
}
const $126c3ebbcc6243ba$var$Mh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    maxNorm: $126c3ebbcc6243ba$var$Qh,
    minMaxNorm: $126c3ebbcc6243ba$var$Yh,
    nonNeg: $126c3ebbcc6243ba$var$Zh,
    unitNorm: $126c3ebbcc6243ba$var$Xh
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$ef() {
    return new (0, $0qVX1.aZ)();
}
function $126c3ebbcc6243ba$var$tf() {
    return new (0, $0qVX1.a_)();
}
function $126c3ebbcc6243ba$var$sf(s) {
    return new (0, $0qVX1.a$)(s);
}
function $126c3ebbcc6243ba$var$af(s) {
    return new (0, $0qVX1.b0)(s);
}
function $126c3ebbcc6243ba$var$rf(s) {
    return new (0, $0qVX1.b1)(s);
}
function $126c3ebbcc6243ba$var$nf(s) {
    return new (0, $0qVX1.b2)(s);
}
function $126c3ebbcc6243ba$var$of(s) {
    return new (0, $0qVX1.b3)(s);
}
function $126c3ebbcc6243ba$var$uf(s) {
    return new (0, $0qVX1.b4)(s);
}
function $126c3ebbcc6243ba$var$lf(s) {
    return new (0, $0qVX1.b5)(s);
}
function $126c3ebbcc6243ba$var$pf(s) {
    return new (0, $0qVX1.b6)(s);
}
function $126c3ebbcc6243ba$var$mf(s) {
    return new (0, $0qVX1.b7)(s);
}
function $126c3ebbcc6243ba$var$cf(s) {
    return new (0, $0qVX1.b8)(s);
}
function $126c3ebbcc6243ba$var$df(s) {
    return new (0, $0qVX1.b9)(s);
}
function $126c3ebbcc6243ba$var$hf(s) {
    return new (0, $0qVX1.ba)(s);
}
function $126c3ebbcc6243ba$var$ff(s) {
    return new (0, $0qVX1.bb)(s);
}
const $126c3ebbcc6243ba$var$yf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    constant: $126c3ebbcc6243ba$var$sf,
    glorotNormal: $126c3ebbcc6243ba$var$pf,
    glorotUniform: $126c3ebbcc6243ba$var$lf,
    heNormal: $126c3ebbcc6243ba$var$mf,
    heUniform: $126c3ebbcc6243ba$var$cf,
    identity: $126c3ebbcc6243ba$var$of,
    leCunNormal: $126c3ebbcc6243ba$var$df,
    leCunUniform: $126c3ebbcc6243ba$var$hf,
    ones: $126c3ebbcc6243ba$var$tf,
    orthogonal: $126c3ebbcc6243ba$var$ff,
    randomNormal: $126c3ebbcc6243ba$var$rf,
    randomUniform: $126c3ebbcc6243ba$var$af,
    truncatedNormal: $126c3ebbcc6243ba$var$nf,
    varianceScaling: $126c3ebbcc6243ba$var$uf,
    zeros: $126c3ebbcc6243ba$var$ef
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$gf(s) {
    return new (0, $0qVX1.bc)(s);
}
function $126c3ebbcc6243ba$var$bf(s) {
    return new (0, $0qVX1.bd)(s);
}
function $126c3ebbcc6243ba$var$Zn(s) {
    return (0, $0qVX1.be)(s);
}
function $126c3ebbcc6243ba$var$Nf(s, e) {
    (0, $0qVX1.bf).registerCallbackConstructor(s, e);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$wf(s) {
    return new (0, $0qVX1.bg)(s);
}
function $126c3ebbcc6243ba$var$Tf(s) {
    return new (0, $0qVX1.bh)(s);
}
function $126c3ebbcc6243ba$var$Sf(s) {
    return new (0, $0qVX1.bi)(s);
}
function $126c3ebbcc6243ba$var$vf(s) {
    return new (0, $0qVX1.bj)(s);
}
function $126c3ebbcc6243ba$var$Of(s) {
    return new (0, $0qVX1.bk)(s);
}
function $126c3ebbcc6243ba$var$_f(s) {
    return new (0, $0qVX1.bl)(s);
}
function $126c3ebbcc6243ba$var$Af(s) {
    return new (0, $0qVX1.bm)(s);
}
function $126c3ebbcc6243ba$var$Ef(s) {
    return new (0, $0qVX1.bn)(s);
}
function $126c3ebbcc6243ba$var$kf(s) {
    return new (0, $0qVX1.bo)(s);
}
function $126c3ebbcc6243ba$var$If(s) {
    return new (0, $0qVX1.bp)(s);
}
function $126c3ebbcc6243ba$var$$f(s) {
    return new (0, $0qVX1.bq)(s);
}
function $126c3ebbcc6243ba$var$Df(s) {
    return new (0, $0qVX1.br)(s);
}
function $126c3ebbcc6243ba$var$Cf(s) {
    return new (0, $0qVX1.bs)(s);
}
function $126c3ebbcc6243ba$var$zf(s) {
    return new (0, $0qVX1.bt)(s);
}
function $126c3ebbcc6243ba$var$xf(s) {
    return new (0, $0qVX1.bu)(s);
}
function $126c3ebbcc6243ba$var$Lf(s) {
    return new (0, $0qVX1.bv)(s);
}
function $126c3ebbcc6243ba$var$Pf(s) {
    return new (0, $0qVX1.bw)(s);
}
function $126c3ebbcc6243ba$var$Ff(s) {
    return new (0, $0qVX1.bx)(s);
}
function $126c3ebbcc6243ba$var$Vf(s) {
    return new (0, $0qVX1.by)(s);
}
function $126c3ebbcc6243ba$var$Rf(s) {
    return new (0, $0qVX1.bz)(s);
}
function $126c3ebbcc6243ba$var$jf(s) {
    return new (0, $0qVX1.bA)(s);
}
function $126c3ebbcc6243ba$var$Bf(s) {
    return new (0, $0qVX1.bB)(s);
}
function $126c3ebbcc6243ba$var$Hf(s) {
    return new (0, $0qVX1.bC)(s);
}
function $126c3ebbcc6243ba$var$Wf(s) {
    return new (0, $0qVX1.bD)(s);
}
function $126c3ebbcc6243ba$var$Uf(s) {
    return new (0, $0qVX1.bE)(s);
}
function $126c3ebbcc6243ba$var$qf(s) {
    return new (0, $0qVX1.bF)(s);
}
function $126c3ebbcc6243ba$var$Gf(s) {
    return new (0, $0qVX1.bG)(s);
}
function $126c3ebbcc6243ba$var$Kf(s) {
    return new (0, $0qVX1.bH)(s);
}
function $126c3ebbcc6243ba$var$Jf(s) {
    return new (0, $0qVX1.bI)(s);
}
function $126c3ebbcc6243ba$var$Qf(s) {
    return new (0, $0qVX1.bJ)(s);
}
function $126c3ebbcc6243ba$var$Xf(s) {
    return new (0, $0qVX1.bK)(s);
}
function $126c3ebbcc6243ba$var$Zf(s) {
    return new (0, $0qVX1.bL)(s);
}
function $126c3ebbcc6243ba$var$Yf(s) {
    return new (0, $0qVX1.bM)(s);
}
function $126c3ebbcc6243ba$var$Mf(s) {
    return new (0, $0qVX1.bN)(s);
}
function $126c3ebbcc6243ba$var$ey(s) {
    return new (0, $0qVX1.bO)(s);
}
function $126c3ebbcc6243ba$var$St(s) {
    return new (0, $0qVX1.bP)(s);
}
function $126c3ebbcc6243ba$var$ty(s) {
    return $126c3ebbcc6243ba$var$St(s);
}
function $126c3ebbcc6243ba$var$sy(s) {
    return $126c3ebbcc6243ba$var$St(s);
}
function $126c3ebbcc6243ba$var$vt(s) {
    return new (0, $0qVX1.bQ)(s);
}
function $126c3ebbcc6243ba$var$ay(s) {
    return $126c3ebbcc6243ba$var$vt(s);
}
function $126c3ebbcc6243ba$var$ry(s) {
    return $126c3ebbcc6243ba$var$vt(s);
}
function $126c3ebbcc6243ba$var$Ot(s) {
    return new (0, $0qVX1.bR)(s);
}
function $126c3ebbcc6243ba$var$ny(s) {
    return $126c3ebbcc6243ba$var$Ot(s);
}
function $126c3ebbcc6243ba$var$iy(s) {
    return $126c3ebbcc6243ba$var$Ot(s);
}
function $126c3ebbcc6243ba$var$oy(s) {
    return new (0, $0qVX1.bS)(s);
}
function $126c3ebbcc6243ba$var$uy(s) {
    return new (0, $0qVX1.bT)(s);
}
function $126c3ebbcc6243ba$var$Yn(s) {
    return new (0, $0qVX1.bU)(s);
}
function $126c3ebbcc6243ba$var$Mn(s) {
    return new (0, $0qVX1.bV)(s);
}
function $126c3ebbcc6243ba$var$ei(s) {
    return new (0, $0qVX1.bW)(s);
}
function $126c3ebbcc6243ba$var$ti(s) {
    return new (0, $0qVX1.bX)(s);
}
function $126c3ebbcc6243ba$var$ly(s) {
    return new (0, $0qVX1.bY)(s);
}
function $126c3ebbcc6243ba$var$py(s) {
    return new (0, $0qVX1.bZ)(s);
}
function $126c3ebbcc6243ba$var$my(s) {
    return new (0, $0qVX1.b_)(s);
}
function $126c3ebbcc6243ba$var$cy(s) {
    return new (0, $0qVX1.b$)(s);
}
function $126c3ebbcc6243ba$var$dy(s) {
    return new (0, $0qVX1.c0)(s);
}
function $126c3ebbcc6243ba$var$hy(s) {
    return new (0, $0qVX1.c1)(s);
}
function $126c3ebbcc6243ba$var$fy(s) {
    return new (0, $0qVX1.c2)(s);
}
function $126c3ebbcc6243ba$var$yy(s) {
    return new (0, $0qVX1.c3)(s);
}
function $126c3ebbcc6243ba$var$gy(s) {
    return new (0, $0qVX1.c4)(s);
}
function $126c3ebbcc6243ba$var$by(s) {
    return new (0, $0qVX1.c5)(s);
}
function $126c3ebbcc6243ba$var$Ny(s) {
    return new (0, $0qVX1.c6)(s);
}
function $126c3ebbcc6243ba$var$wy(s) {
    return new (0, $0qVX1.c7)(s);
}
function $126c3ebbcc6243ba$var$Ty(s) {
    return new (0, $0qVX1.c8)(s);
}
const $126c3ebbcc6243ba$var$Sy = $126c3ebbcc6243ba$var$Yn, $126c3ebbcc6243ba$var$vy = $126c3ebbcc6243ba$var$Mn, $126c3ebbcc6243ba$var$Oy = $126c3ebbcc6243ba$var$ei, $126c3ebbcc6243ba$var$_y = $126c3ebbcc6243ba$var$ti;
function $126c3ebbcc6243ba$var$Ay(s) {
    return new (0, $0qVX1.c9)(s);
}
function $126c3ebbcc6243ba$var$Ey(s) {
    return new (0, $0qVX1.ca)(s);
}
function $126c3ebbcc6243ba$var$ky(s) {
    return new (0, $0qVX1.cb)(s);
}
function $126c3ebbcc6243ba$var$Iy(s) {
    return new (0, $0qVX1.cc)(s);
}
function $126c3ebbcc6243ba$var$$y(s) {
    return new (0, $0qVX1.cd)(s);
}
function $126c3ebbcc6243ba$var$Dy(s) {
    return new (0, $0qVX1.ce)(s);
}
function $126c3ebbcc6243ba$var$Cy(s) {
    return new (0, $0qVX1.cf)(s);
}
function $126c3ebbcc6243ba$var$zy(s) {
    return new (0, $0qVX1.cg)(s);
}
function $126c3ebbcc6243ba$var$xy(s) {
    return new (0, $0qVX1.ch)(s);
}
const $126c3ebbcc6243ba$var$Ly = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    Layer: (0, $0qVX1.ci),
    RNN: (0, $0qVX1.c5),
    RNNCell: (0, $0qVX1.cj),
    activation: $126c3ebbcc6243ba$var$Pf,
    add: $126c3ebbcc6243ba$var$qf,
    alphaDropout: $126c3ebbcc6243ba$var$ky,
    average: $126c3ebbcc6243ba$var$Gf,
    averagePooling1d: $126c3ebbcc6243ba$var$St,
    averagePooling2d: $126c3ebbcc6243ba$var$vt,
    averagePooling3d: $126c3ebbcc6243ba$var$Ot,
    avgPool1d: $126c3ebbcc6243ba$var$ty,
    avgPool2d: $126c3ebbcc6243ba$var$ay,
    avgPool3d: $126c3ebbcc6243ba$var$ny,
    avgPooling1d: $126c3ebbcc6243ba$var$sy,
    avgPooling2d: $126c3ebbcc6243ba$var$ry,
    avgPooling3d: $126c3ebbcc6243ba$var$iy,
    batchNormalization: $126c3ebbcc6243ba$var$Yf,
    bidirectional: $126c3ebbcc6243ba$var$wy,
    categoryEncoding: $126c3ebbcc6243ba$var$zy,
    centerCrop: $126c3ebbcc6243ba$var$Dy,
    concatenate: $126c3ebbcc6243ba$var$Kf,
    conv1d: $126c3ebbcc6243ba$var$Ef,
    conv2d: $126c3ebbcc6243ba$var$kf,
    conv2dTranspose: $126c3ebbcc6243ba$var$If,
    conv3d: $126c3ebbcc6243ba$var$$f,
    conv3dTranspose: $126c3ebbcc6243ba$var$Df,
    convLstm2d: $126c3ebbcc6243ba$var$yy,
    convLstm2dCell: $126c3ebbcc6243ba$var$gy,
    cropping2D: $126c3ebbcc6243ba$var$zf,
    dense: $126c3ebbcc6243ba$var$Ff,
    depthwiseConv2d: $126c3ebbcc6243ba$var$Lf,
    dot: $126c3ebbcc6243ba$var$Zf,
    dropout: $126c3ebbcc6243ba$var$Vf,
    elu: $126c3ebbcc6243ba$var$Tf,
    embedding: $126c3ebbcc6243ba$var$Uf,
    flatten: $126c3ebbcc6243ba$var$jf,
    gaussianDropout: $126c3ebbcc6243ba$var$Ey,
    gaussianNoise: $126c3ebbcc6243ba$var$Ay,
    globalAveragePooling1d: $126c3ebbcc6243ba$var$oy,
    globalAveragePooling2d: $126c3ebbcc6243ba$var$uy,
    globalMaxPool1d: $126c3ebbcc6243ba$var$Sy,
    globalMaxPool2d: $126c3ebbcc6243ba$var$vy,
    globalMaxPooling1d: $126c3ebbcc6243ba$var$Yn,
    globalMaxPooling2d: $126c3ebbcc6243ba$var$Mn,
    gru: $126c3ebbcc6243ba$var$py,
    gruCell: $126c3ebbcc6243ba$var$my,
    input: $126c3ebbcc6243ba$var$Zn,
    inputLayer: $126c3ebbcc6243ba$var$wf,
    layerNormalization: $126c3ebbcc6243ba$var$Mf,
    leakyReLU: $126c3ebbcc6243ba$var$vf,
    lstm: $126c3ebbcc6243ba$var$cy,
    lstmCell: $126c3ebbcc6243ba$var$dy,
    masking: $126c3ebbcc6243ba$var$Iy,
    maxPool1d: $126c3ebbcc6243ba$var$Oy,
    maxPool2d: $126c3ebbcc6243ba$var$_y,
    maxPooling1d: $126c3ebbcc6243ba$var$ei,
    maxPooling2d: $126c3ebbcc6243ba$var$ti,
    maxPooling3d: $126c3ebbcc6243ba$var$ly,
    maximum: $126c3ebbcc6243ba$var$Jf,
    minimum: $126c3ebbcc6243ba$var$Qf,
    multiply: $126c3ebbcc6243ba$var$Xf,
    permute: $126c3ebbcc6243ba$var$Wf,
    prelu: $126c3ebbcc6243ba$var$Of,
    randomWidth: $126c3ebbcc6243ba$var$xy,
    reLU: $126c3ebbcc6243ba$var$Sf,
    repeatVector: $126c3ebbcc6243ba$var$Bf,
    rescaling: $126c3ebbcc6243ba$var$$y,
    reshape: $126c3ebbcc6243ba$var$Hf,
    resizing: $126c3ebbcc6243ba$var$Cy,
    rnn: $126c3ebbcc6243ba$var$by,
    separableConv2d: $126c3ebbcc6243ba$var$Cf,
    simpleRNN: $126c3ebbcc6243ba$var$hy,
    simpleRNNCell: $126c3ebbcc6243ba$var$fy,
    softmax: $126c3ebbcc6243ba$var$_f,
    spatialDropout1d: $126c3ebbcc6243ba$var$Rf,
    stackedRNNCells: $126c3ebbcc6243ba$var$Ny,
    thresholdedReLU: $126c3ebbcc6243ba$var$Af,
    timeDistributed: $126c3ebbcc6243ba$var$Ty,
    upSampling2d: $126c3ebbcc6243ba$var$xf,
    zeroPadding2d: $126c3ebbcc6243ba$var$ey
}, Symbol.toStringTag, {
    value: "Module"
}));
function $126c3ebbcc6243ba$var$Py(s, e) {
    return (0, $0qVX1.ck)(s, e);
}
function $126c3ebbcc6243ba$var$Fy(s, e) {
    return (0, $0qVX1.cl)(s, e);
}
function $126c3ebbcc6243ba$var$Vy(s, e) {
    return (0, $0qVX1.cm)(s, e);
}
function $126c3ebbcc6243ba$var$Ry(s, e) {
    return (0, $0qVX1.cn)(s, e);
}
function $126c3ebbcc6243ba$var$jy(s, e) {
    return (0, $0qVX1.co)(s, e);
}
function $126c3ebbcc6243ba$var$By(s, e) {
    return (0, $0qVX1.cp)(s, e);
}
function $126c3ebbcc6243ba$var$Hy(s, e) {
    return (0, $0qVX1.cq)(s, e);
}
function $126c3ebbcc6243ba$var$Wy(s, e) {
    return (0, $0qVX1.cr)(s, e);
}
function $126c3ebbcc6243ba$var$Uy(s, e) {
    return (0, $0qVX1.cs)(s, e);
}
function $126c3ebbcc6243ba$var$qy(s, e) {
    return (0, $0qVX1.ct)(s, e);
}
function $126c3ebbcc6243ba$var$Gy(s, e) {
    return (0, $0qVX1.ct)(s, e);
}
function $126c3ebbcc6243ba$var$Ky(s, e) {
    return (0, $0qVX1.ct)(s, e);
}
function $126c3ebbcc6243ba$var$Jy(s, e) {
    return (0, $0qVX1.cu)(s, e);
}
function $126c3ebbcc6243ba$var$Qy(s, e) {
    return (0, $0qVX1.cu)(s, e);
}
function $126c3ebbcc6243ba$var$Xy(s, e) {
    return (0, $0qVX1.cu)(s, e);
}
const $126c3ebbcc6243ba$var$Zy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    MAPE: $126c3ebbcc6243ba$var$Gy,
    MSE: $126c3ebbcc6243ba$var$Qy,
    binaryAccuracy: $126c3ebbcc6243ba$var$Py,
    binaryCrossentropy: $126c3ebbcc6243ba$var$Fy,
    categoricalAccuracy: $126c3ebbcc6243ba$var$Ry,
    categoricalCrossentropy: $126c3ebbcc6243ba$var$jy,
    cosineProximity: $126c3ebbcc6243ba$var$Wy,
    mape: $126c3ebbcc6243ba$var$Ky,
    meanAbsoluteError: $126c3ebbcc6243ba$var$Uy,
    meanAbsolutePercentageError: $126c3ebbcc6243ba$var$qy,
    meanSquaredError: $126c3ebbcc6243ba$var$Jy,
    mse: $126c3ebbcc6243ba$var$Xy,
    precision: $126c3ebbcc6243ba$var$By,
    recall: $126c3ebbcc6243ba$var$Hy,
    sparseCategoricalAccuracy: $126c3ebbcc6243ba$var$Vy
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Yy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    modelFromJSON: (0, $0qVX1.cv)
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$My(s) {
    return new (0, $0qVX1.cw)(s);
}
function $126c3ebbcc6243ba$var$eg(s) {
    return (0, $0qVX1.cx)(s);
}
function $126c3ebbcc6243ba$var$tg(s) {
    return (0, $0qVX1.cy)(s);
}
const $126c3ebbcc6243ba$var$sg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    l1: $126c3ebbcc6243ba$var$eg,
    l1l2: $126c3ebbcc6243ba$var$My,
    l2: $126c3ebbcc6243ba$var$tg
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ class $126c3ebbcc6243ba$var$si extends (0, $0qVX1.cz) {
    constructor(){
        super(...arguments), this.model = null;
    }
    setModel(e) {
        if (!(e instanceof (0, $0qVX1.bc))) throw new Error("model must be a LayersModel, not some other Container");
        this.model = e;
    }
}
function $126c3ebbcc6243ba$var$ye(s, e) {
    return s < e;
}
function $126c3ebbcc6243ba$var$Vt(s, e) {
    return s > e;
}
class $126c3ebbcc6243ba$var$ai extends $126c3ebbcc6243ba$var$si {
    constructor(e){
        if (super(), e == null && (e = {}), e.restoreBestWeights) throw new (0, $0qVX1.cA)("restoreBestWeights = True is not implemented in EarlyStopping yet.");
        this.monitor = e.monitor || "val_loss", this.minDelta = Math.abs(e.minDelta || 0), this.patience = e.patience || 0, this.verbose = e.verbose || 0, this.mode = e.mode || "auto", this.baseline = e.baseline, [
            "auto",
            "min",
            "max"
        ].indexOf(this.mode) === -1 && (console.warn(`EarlyStopping mode '${this.mode}' is invalid. Falling back to mode 'auto'.`), this.mode = "auto"), this.mode === "min" ? this.monitorFunc = $126c3ebbcc6243ba$var$ye : this.mode === "max" ? this.monitorFunc = $126c3ebbcc6243ba$var$Vt : this.monitor.indexOf("acc") !== -1 ? this.monitorFunc = $126c3ebbcc6243ba$var$Vt : this.monitorFunc = $126c3ebbcc6243ba$var$ye, this.monitorFunc === $126c3ebbcc6243ba$var$ye && (this.minDelta *= -1);
    }
    async onTrainBegin(e) {
        this.wait = 0, this.stoppedEpoch = 0, this.baseline != null ? this.best = this.baseline : this.best = this.monitorFunc === $126c3ebbcc6243ba$var$ye ? 1 / 0 : -1 / 0;
    }
    async onEpochEnd(e, t) {
        await (0, $0qVX1.cB)(t);
        const a = this.getMonitorValue(t);
        a != null && (this.monitorFunc(a - this.minDelta, this.best) ? (this.best = a, this.wait = 0) : (this.wait++, this.wait >= this.patience && (this.stoppedEpoch = e, this.model.stopTraining = !0)));
    }
    async onTrainEnd(e) {
        this.stoppedEpoch > 0 && this.verbose && console.log(`Epoch ${this.stoppedEpoch}: early stopping.`);
    }
    getMonitorValue(e) {
        e == null && (e = {});
        const t = e[this.monitor];
        return t == null && console.warn(`Metric for EarlyStopping ${this.monitor} is not available. Available metrics are: ${Object.keys(e)}`), t;
    }
}
function $126c3ebbcc6243ba$var$ag(s) {
    return new $126c3ebbcc6243ba$var$ai(s);
}
const $126c3ebbcc6243ba$var$rg = {
    earlyStopping: $126c3ebbcc6243ba$var$ag
};
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$_t = {};
function $126c3ebbcc6243ba$var$ng(s, e) {
    const t = {
        tfOpName: s,
        category: "custom",
        inputs: [],
        attrs: [],
        customExecutor: e
    };
    $126c3ebbcc6243ba$var$_t[s] = t;
}
function $126c3ebbcc6243ba$var$ri(s) {
    return $126c3ebbcc6243ba$var$_t[s];
}
function $126c3ebbcc6243ba$var$ig(s) {
    delete $126c3ebbcc6243ba$var$_t[s];
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$i(s, e, t, a, r) {
    const n = e.inputParams[s];
    if (n && n.inputIndexStart !== void 0) {
        const o = n.inputIndexStart, l = n.inputIndexEnd === 0 ? void 0 : n.inputIndexEnd === void 0 ? o + 1 : n.inputIndexEnd, p = o < 0 ? e.inputNames.length + o : o;
        if (n.type === "tensor") return $126c3ebbcc6243ba$var$E(e.inputNames[p], t, a, r);
        if (n.type === "tensors") {
            const d = e.inputs.slice(o, l);
            return e.inputNames.slice(o, l).filter((N, g)=>{
                var f;
                return ((f = d[g]) === null || f === void 0 ? void 0 : f.op) !== "NoOp";
            }).map((N)=>$126c3ebbcc6243ba$var$E(N, t, a, r));
        }
        const m = $126c3ebbcc6243ba$var$E(e.inputNames[p], t, a, r), c = m.dataSync();
        return n.type === "number" ? c[0] : (0, $0qVX1.cC)(m.shape, c);
    }
    const u = e.attrParams[s];
    return u && u.value;
}
function $126c3ebbcc6243ba$var$E(s, e, t, a) {
    const [r, n] = $126c3ebbcc6243ba$var$$(s, t);
    if (a != null) {
        const o = a.getHashTableHandleByName(r);
        if (o != null) return o;
    }
    const u = t.currentContextIds.find((o)=>!!e[$126c3ebbcc6243ba$var$ke(r, o)]);
    return u !== void 0 ? e[$126c3ebbcc6243ba$var$ke(r, u)][n] : void 0;
}
function $126c3ebbcc6243ba$var$Rt(s, e, t) {
    return e[$126c3ebbcc6243ba$var$ke(s, t.currentContextId)];
}
function $126c3ebbcc6243ba$var$B(s, e) {
    const [t, a, r] = $126c3ebbcc6243ba$var$$(s, e);
    return [
        $126c3ebbcc6243ba$var$ke(t, e && e.currentContextId),
        a,
        r
    ];
}
function $126c3ebbcc6243ba$var$ke(s, e) {
    return e ? `${s}-${e}` : s;
}
function $126c3ebbcc6243ba$var$$(s, e) {
    if (s === "") return [
        "",
        0,
        void 0
    ];
    const t = e != null && e.parseNodeNameCache != null;
    if (t) {
        const n = e.parseNodeNameCache.get(s);
        if (n != null) return n;
    }
    const a = s.split(":");
    let r;
    if (a.length === 1) r = [
        s,
        0,
        void 0
    ];
    else {
        const n = a[0], u = a.length === 3 ? a[1] : void 0, o = Number(a[a.length - 1]);
        r = [
            n,
            o,
            u
        ];
    }
    return t && e.parseNodeNameCache.set(s, r), r;
}
function $126c3ebbcc6243ba$var$we(s, e, t) {
    let a = $126c3ebbcc6243ba$var$i("pad", s, e, t);
    if (a === "explicit") {
        a = $126c3ebbcc6243ba$var$i("explicitPaddings", s, e, t);
        const r = [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ]
        ];
        for(let n = 0; n < 4; n++)r[n][0] = a[n * 2], r[n][1] = a[n * 2 + 1];
        return r;
    }
    return a;
}
function $126c3ebbcc6243ba$var$H(s) {
    return s.kept ? s : (0, $0qVX1.cD)(s);
}
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$og = [
    {
        tfOpName: "Add",
        category: "arithmetic",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "AddV2",
        category: "arithmetic",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "AddN",
        category: "arithmetic",
        inputs: [
            {
                start: 0,
                end: 0,
                name: "tensors",
                type: "tensors"
            }
        ]
    },
    {
        tfOpName: "BiasAdd",
        category: "arithmetic",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            },
            {
                tfName: "data_format",
                name: "dataFormat",
                type: "string",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Sub",
        category: "arithmetic",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "RealDiv",
        category: "arithmetic",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Div",
        category: "arithmetic",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "DivNoNan",
        category: "arithmetic",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "FloorDiv",
        category: "arithmetic",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Mul",
        category: "arithmetic",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Maximum",
        category: "arithmetic",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Minimum",
        category: "arithmetic",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Pow",
        category: "arithmetic",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "SquaredDifference",
        category: "arithmetic",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Mod",
        category: "arithmetic",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "FloorMod",
        category: "arithmetic",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    }
], $126c3ebbcc6243ba$var$ug = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$og
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$lg = [
    {
        tfOpName: "Abs",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Acos",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Asin",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Atan",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Atan2",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "y",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Ceil",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "ClipByValue",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "clipValueMin",
                type: "number"
            },
            {
                start: 2,
                name: "clipValueMax",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Complex",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "real",
                type: "tensor"
            },
            {
                start: 1,
                name: "imag",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "ComplexAbs",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Cos",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Cosh",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Elu",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Exp",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Floor",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Log",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Imag",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            },
            {
                tfName: "Tout",
                name: "outputType",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Neg",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Real",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            },
            {
                tfName: "Tout",
                name: "outputType",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Prelu",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "alpha",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Relu",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Relu6",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Selu",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Sigmoid",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Sin",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Sinh",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Sqrt",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Rsqrt",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Square",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Tan",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Tanh",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Sign",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Round",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Expm1",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Log1p",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Reciprocal",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Softplus",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Asinh",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Acosh",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Atanh",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Erf",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "LeakyRelu",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "alpha",
                name: "alpha",
                type: "number",
                defaultValue: 0.2
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "IsNan",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "IsFinite",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "IsInf",
        category: "basic_math",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    }
], $126c3ebbcc6243ba$var$pg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$lg
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$mg = [
    {
        tfOpName: "EmptyTensorList",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "elementShape",
                type: "shape"
            },
            {
                start: 1,
                name: "maxNumElements",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "element_dtype",
                name: "elementDType",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "LoopCond",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "pred",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "Switch",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "data",
                type: "tensor"
            },
            {
                start: 1,
                name: "pred",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "Merge",
        category: "control",
        inputs: [
            {
                start: 0,
                end: 0,
                name: "tensors",
                type: "tensors"
            }
        ]
    },
    {
        tfOpName: "Enter",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensor",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            },
            {
                tfName: "frame_name",
                name: "frameName",
                type: "string"
            },
            {
                tfName: "is_constant",
                name: "isConstant",
                type: "bool"
            }
        ]
    },
    {
        tfOpName: "Exit",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensor",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "NextIteration",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensor",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "TensorArrayV3",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "size",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "dtype",
                name: "dtype",
                type: "dtype"
            },
            {
                tfName: "element_shape",
                name: "elementShape",
                type: "shape"
            },
            {
                tfName: "dynamic_size",
                name: "dynamicSize",
                type: "bool"
            },
            {
                tfName: "clear_after_read",
                name: "clearAfterRead",
                type: "bool"
            },
            {
                tfName: "identical_element_shapes",
                name: "identicalElementShapes",
                type: "bool"
            },
            {
                tfName: "tensor_array_name",
                name: "name",
                type: "string"
            }
        ]
    },
    {
        tfOpName: "TensorArrayWriteV3",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorArrayId",
                type: "tensor"
            },
            {
                start: 1,
                name: "index",
                type: "number"
            },
            {
                start: 2,
                name: "tensor",
                type: "tensor"
            },
            {
                start: 3,
                name: "flowIn",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "TensorArrayReadV3",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorArrayId",
                type: "tensor"
            },
            {
                start: 1,
                name: "index",
                type: "number"
            },
            {
                start: 2,
                name: "flowIn",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "dtype",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "TensorArrayGatherV3",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorArrayId",
                type: "tensor"
            },
            {
                start: 1,
                name: "indices",
                type: "number[]"
            },
            {
                start: 2,
                name: "flowIn",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "dtype",
                name: "dtype",
                type: "dtype"
            },
            {
                tfName: "element_shape",
                name: "elementShape",
                type: "shape"
            }
        ]
    },
    {
        tfOpName: "TensorArrayScatterV3",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorArrayId",
                type: "tensor"
            },
            {
                start: 1,
                name: "indices",
                type: "number[]"
            },
            {
                start: 2,
                name: "tensor",
                type: "tensor"
            },
            {
                start: 3,
                name: "flowIn",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "TensorArrayConcatV3",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorArrayId",
                type: "tensor"
            },
            {
                start: 1,
                name: "flowIn",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "dtype",
                name: "dtype",
                type: "dtype"
            },
            {
                tfName: "element_shape_except0",
                name: "elementShapeExcept0",
                type: "shape",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "TensorArraySplitV3",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorArrayId",
                type: "tensor"
            },
            {
                start: 1,
                name: "tensor",
                type: "tensor"
            },
            {
                start: 2,
                name: "lengths",
                type: "number[]"
            },
            {
                start: 3,
                name: "flowIn",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "TensorArraySizeV3",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorArrayId",
                type: "tensor"
            },
            {
                start: 1,
                name: "flowIn",
                type: "number"
            }
        ]
    },
    {
        tfOpName: "TensorArrayCloseV3",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorArrayId",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "StatelessIf",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "cond",
                type: "tensor"
            },
            {
                start: 1,
                end: 0,
                name: "args",
                type: "tensors"
            }
        ],
        attrs: [
            {
                tfName: "then_branch",
                name: "thenBranch",
                type: "func"
            },
            {
                tfName: "else_branch",
                name: "elseBranch",
                type: "func"
            }
        ]
    },
    {
        tfOpName: "If",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "cond",
                type: "tensor"
            },
            {
                start: 1,
                end: 0,
                name: "args",
                type: "tensors"
            }
        ],
        attrs: [
            {
                tfName: "then_branch",
                name: "thenBranch",
                type: "func"
            },
            {
                tfName: "else_branch",
                name: "elseBranch",
                type: "func"
            }
        ]
    },
    {
        tfOpName: "StatelessWhile",
        category: "control",
        inputs: [
            {
                start: 0,
                end: 0,
                name: "args",
                type: "tensors"
            }
        ],
        attrs: [
            {
                tfName: "cond",
                name: "cond",
                type: "func"
            },
            {
                tfName: "body",
                name: "body",
                type: "func"
            }
        ]
    },
    {
        tfOpName: "While",
        category: "control",
        inputs: [
            {
                start: 0,
                end: 0,
                name: "args",
                type: "tensors"
            }
        ],
        attrs: [
            {
                tfName: "cond",
                name: "cond",
                type: "func"
            },
            {
                tfName: "body",
                name: "body",
                type: "func"
            }
        ]
    },
    {
        tfOpName: "TensorListScatter",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensor",
                type: "tensor"
            },
            {
                start: 1,
                name: "indices",
                type: "number[]"
            },
            {
                start: 2,
                name: "elementShape",
                type: "shape"
            }
        ],
        attrs: [
            {
                tfName: "element_dtype",
                name: "elementDType",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "TensorListScatterV2",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensor",
                type: "tensor"
            },
            {
                start: 1,
                name: "indices",
                type: "number[]"
            },
            {
                start: 2,
                name: "elementShape",
                type: "shape"
            },
            {
                start: 3,
                name: "numElements",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "element_dtype",
                name: "elementDType",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "TensorListGather",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorListId",
                type: "tensor"
            },
            {
                start: 1,
                name: "indices",
                type: "number[]"
            },
            {
                start: 2,
                name: "elementShape",
                type: "shape"
            }
        ],
        attrs: [
            {
                tfName: "element_dtype",
                name: "elementDType",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "TensorListGetItem",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorListId",
                type: "tensor"
            },
            {
                start: 1,
                name: "index",
                type: "number"
            },
            {
                start: 2,
                name: "elementShape",
                type: "shape"
            }
        ],
        attrs: [
            {
                tfName: "element_dtype",
                name: "elementDType",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "TensorListSetItem",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorListId",
                type: "tensor"
            },
            {
                start: 1,
                name: "index",
                type: "number"
            },
            {
                start: 2,
                name: "tensor",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "element_dtype",
                name: "elementDType",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "TensorListReserve",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "elementShape",
                type: "shape"
            },
            {
                start: 1,
                name: "numElements",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "element_dtype",
                name: "elementDType",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "TensorListFromTensor",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensor",
                type: "tensor"
            },
            {
                start: 1,
                name: "elementShape",
                type: "shape"
            }
        ],
        attrs: [
            {
                tfName: "element_dtype",
                name: "elementDType",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "TensorListStack",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorListId",
                type: "tensor"
            },
            {
                start: 1,
                name: "elementShape",
                type: "shape"
            }
        ],
        attrs: [
            {
                tfName: "element_dtype",
                name: "elementDType",
                type: "dtype"
            },
            {
                tfName: "num_elements",
                name: "numElements",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "TensorListSplit",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensor",
                type: "tensor"
            },
            {
                start: 1,
                name: "elementShape",
                type: "shape"
            },
            {
                start: 2,
                name: "lengths",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "element_dtype",
                name: "elementDType",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "TensorListConcat",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorListId",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "element_shape",
                name: "elementShape",
                type: "shape"
            },
            {
                tfName: "element_dtype",
                name: "elementDType",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "TensorListConcatV2",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorListId",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "element_shape",
                name: "elementShape",
                type: "shape"
            },
            {
                tfName: "element_dtype",
                name: "elementDType",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "TensorListPopBack",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorListId",
                type: "tensor"
            },
            {
                start: 1,
                name: "elementShape",
                type: "shape"
            }
        ],
        attrs: [
            {
                tfName: "element_dtype",
                name: "elementDType",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "TensorListPushBack",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorListId",
                type: "tensor"
            },
            {
                start: 1,
                name: "tensor",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "element_dtype",
                name: "elementDType",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "TensorListLength",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorListId",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "TensorListResize",
        category: "control",
        inputs: [
            {
                start: 0,
                name: "tensorListId",
                type: "tensor"
            },
            {
                start: 1,
                name: "size",
                type: "number"
            }
        ]
    }
], $126c3ebbcc6243ba$var$cg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$mg
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$dg = [
    {
        tfOpName: "AvgPool",
        category: "convolution",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "strides",
                name: "strides",
                type: "number[]"
            },
            {
                tfName: "padding",
                name: "pad",
                type: "string"
            },
            {
                tfName: "data_format",
                name: "dataFormat",
                type: "string",
                notSupported: !0
            },
            {
                tfName: "ksize",
                name: "kernelSize",
                type: "number[]"
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "MaxPool",
        category: "convolution",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "strides",
                name: "strides",
                type: "number[]"
            },
            {
                tfName: "padding",
                name: "pad",
                type: "string"
            },
            {
                tfName: "data_format",
                name: "dataFormat",
                type: "string",
                notSupported: !0
            },
            {
                tfName: "ksize",
                name: "kernelSize",
                type: "number[]"
            },
            {
                tfName: "explicit_paddings",
                name: "explicitPaddings",
                type: "number[]",
                defaultValue: [],
                notSupported: !0
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "MaxPoolWithArgmax",
        category: "convolution",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "strides",
                name: "strides",
                type: "number[]"
            },
            {
                tfName: "padding",
                name: "pad",
                type: "string"
            },
            {
                tfName: "ksize",
                name: "kernelSize",
                type: "number[]"
            },
            {
                tfName: "include_batch_in_index",
                name: "includeBatchInIndex",
                type: "bool"
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "AvgPool3D",
        category: "convolution",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "strides",
                name: "strides",
                type: "number[]"
            },
            {
                tfName: "padding",
                name: "pad",
                type: "string"
            },
            {
                tfName: "data_format",
                name: "dataFormat",
                type: "string",
                notSupported: !0
            },
            {
                tfName: "ksize",
                name: "kernelSize",
                type: "number[]"
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "MaxPool3D",
        category: "convolution",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "strides",
                name: "strides",
                type: "number[]"
            },
            {
                tfName: "padding",
                name: "pad",
                type: "string"
            },
            {
                tfName: "data_format",
                name: "dataFormat",
                type: "string",
                notSupported: !0
            },
            {
                tfName: "ksize",
                name: "kernelSize",
                type: "number[]"
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Conv1D",
        category: "convolution",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "filter",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "stride",
                name: "stride",
                type: "number"
            },
            {
                tfName: "padding",
                name: "pad",
                type: "string"
            },
            {
                tfName: "data_format",
                name: "dataFormat",
                type: "string",
                defaultValue: "NWC"
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            },
            {
                tfName: "dilation",
                name: "dilation",
                type: "number",
                defaultValue: 1
            }
        ]
    },
    {
        tfOpName: "Conv2D",
        category: "convolution",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "filter",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            },
            {
                tfName: "strides",
                name: "strides",
                type: "number[]"
            },
            {
                tfName: "padding",
                name: "pad",
                type: "string"
            },
            {
                tfName: "useCudnnOnGpu",
                name: "useCudnnOnGpu",
                type: "bool"
            },
            {
                tfName: "data_format",
                name: "dataFormat",
                type: "string",
                defaultValue: "NHWC"
            },
            {
                tfName: "explicit_paddings",
                name: "explicitPaddings",
                type: "number[]",
                defaultValue: []
            },
            {
                tfName: "dilations",
                name: "dilations",
                type: "number[]"
            }
        ]
    },
    {
        tfOpName: "_FusedConv2D",
        category: "convolution",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "filter",
                type: "tensor"
            },
            {
                start: 2,
                end: 0,
                name: "args",
                type: "tensors"
            }
        ],
        attrs: [
            {
                tfName: "num_args",
                name: "numArgs",
                type: "number"
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            },
            {
                tfName: "strides",
                name: "strides",
                type: "number[]"
            },
            {
                tfName: "padding",
                name: "pad",
                type: "string"
            },
            {
                tfName: "explicit_paddings",
                name: "explicitPaddings",
                type: "number[]",
                defaultValue: []
            },
            {
                tfName: "use_cudnn_on_gpu",
                name: "useCudnnOnGpu",
                type: "bool",
                defaultValue: !0
            },
            {
                tfName: "data_format",
                name: "dataFormat",
                type: "string",
                defaultValue: "NHWC"
            },
            {
                tfName: "dilations",
                name: "dilations",
                type: "number[]",
                defaultValue: [
                    1,
                    1,
                    1,
                    1
                ]
            },
            {
                tfName: "fused_ops",
                name: "fusedOps",
                type: "string[]",
                defaultValue: []
            },
            {
                tfName: "epsilon",
                name: "epsilon",
                type: "number",
                defaultValue: 1e-4
            },
            {
                tfName: "leakyrelu_alpha",
                name: "leakyreluAlpha",
                type: "number",
                defaultValue: 0.2
            }
        ]
    },
    {
        tfOpName: "Conv2DBackpropInput",
        category: "convolution",
        inputs: [
            {
                start: 2,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "filter",
                type: "tensor"
            },
            {
                start: 0,
                name: "outputShape",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "strides",
                name: "strides",
                type: "number[]"
            },
            {
                tfName: "padding",
                name: "pad",
                type: "string"
            },
            {
                tfName: "data_format",
                name: "dataFormat",
                type: "string",
                notSupported: !0
            },
            {
                tfName: "explicit_paddings",
                name: "explicitPaddings",
                type: "number[]",
                defaultValue: []
            },
            {
                tfName: "dilations",
                name: "dilations",
                type: "number[]",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "DepthwiseConv2d",
        category: "convolution",
        inputs: [
            {
                start: 0,
                name: "input",
                type: "tensor"
            },
            {
                start: 1,
                name: "filter",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "strides",
                name: "strides",
                type: "number[]"
            },
            {
                tfName: "padding",
                name: "pad",
                type: "string"
            },
            {
                tfName: "data_format",
                name: "dataFormat",
                type: "string",
                defaultValue: "NHWC"
            },
            {
                tfName: "explicit_paddings",
                name: "explicitPaddings",
                type: "number[]",
                defaultValue: []
            },
            {
                tfName: "dilations",
                name: "dilations",
                type: "number[]"
            }
        ]
    },
    {
        tfOpName: "DepthwiseConv2dNative",
        category: "convolution",
        inputs: [
            {
                start: 0,
                name: "input",
                type: "tensor"
            },
            {
                start: 1,
                name: "filter",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "strides",
                name: "strides",
                type: "number[]"
            },
            {
                tfName: "padding",
                name: "pad",
                type: "string"
            },
            {
                tfName: "data_format",
                name: "dataFormat",
                type: "string",
                defaultValue: "NHWC"
            },
            {
                tfName: "explicit_paddings",
                name: "explicitPaddings",
                type: "number[]",
                defaultValue: []
            },
            {
                tfName: "dilations",
                name: "dilations",
                type: "number[]"
            }
        ]
    },
    {
        tfOpName: "FusedDepthwiseConv2dNative",
        category: "convolution",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "filter",
                type: "tensor"
            },
            {
                start: 2,
                end: 0,
                name: "args",
                type: "tensors"
            }
        ],
        attrs: [
            {
                tfName: "num_args",
                name: "numArgs",
                type: "number"
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            },
            {
                tfName: "strides",
                name: "strides",
                type: "number[]"
            },
            {
                tfName: "padding",
                name: "pad",
                type: "string"
            },
            {
                tfName: "data_format",
                name: "dataFormat",
                type: "string",
                defaultValue: "NHWC"
            },
            {
                tfName: "dilations",
                name: "dilations",
                type: "number[]",
                defaultValue: [
                    1,
                    1,
                    1,
                    1
                ]
            },
            {
                tfName: "fused_ops",
                name: "fusedOps",
                type: "string[]",
                defaultValue: []
            },
            {
                tfName: "explicit_paddings",
                name: "explicitPaddings",
                type: "number[]",
                defaultValue: []
            }
        ]
    },
    {
        tfOpName: "Conv3D",
        category: "convolution",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "filter",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "strides",
                name: "strides",
                type: "number[]"
            },
            {
                tfName: "padding",
                name: "pad",
                type: "string"
            },
            {
                tfName: "data_format",
                name: "dataFormat",
                type: "string",
                defaultValue: "NHWC"
            },
            {
                tfName: "dilations",
                name: "dilations",
                type: "number[]"
            }
        ]
    },
    {
        tfOpName: "Dilation2D",
        category: "convolution",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "filter",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "strides",
                name: "strides",
                type: "number[]"
            },
            {
                tfName: "rates",
                name: "dilations",
                type: "number[]"
            },
            {
                tfName: "padding",
                name: "pad",
                type: "string"
            }
        ]
    }
], $126c3ebbcc6243ba$var$hg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$dg
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$fg = [
    {
        tfOpName: "Fill",
        category: "creation",
        inputs: [
            {
                start: 0,
                name: "shape",
                type: "number[]"
            },
            {
                start: 1,
                name: "value",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "LinSpace",
        category: "creation",
        inputs: [
            {
                start: 0,
                name: "start",
                type: "number"
            },
            {
                start: 1,
                name: "stop",
                type: "number"
            },
            {
                start: 2,
                name: "num",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "OneHot",
        category: "creation",
        inputs: [
            {
                start: 0,
                name: "indices",
                type: "tensor"
            },
            {
                start: 1,
                name: "depth",
                type: "number"
            },
            {
                start: 2,
                name: "onValue",
                type: "number",
                defaultValue: 1
            },
            {
                start: 3,
                name: "offValue",
                type: "number",
                defaultValue: 0
            }
        ],
        attrs: [
            {
                tfName: "axis",
                name: "axis",
                type: "number",
                notSupported: !0
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "Ones",
        category: "creation",
        inputs: [
            {
                start: 0,
                name: "shape",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "OnesLike",
        category: "creation",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "dtype",
                name: "dtype",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "RandomStandardNormal",
        category: "creation",
        inputs: [
            {
                start: 0,
                name: "shape",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "seed",
                name: "seed",
                type: "number",
                defaultValue: 0
            },
            {
                tfName: "seed2",
                name: "seed2",
                type: "number",
                defaultValue: 0,
                notSupported: !0
            },
            {
                tfName: "dtype",
                name: "dtype",
                type: "dtype"
            },
            {
                tfName: "T",
                name: "T",
                type: "number",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "RandomUniform",
        category: "creation",
        inputs: [
            {
                start: 0,
                name: "shape",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "minval",
                name: "minval",
                type: "number",
                defaultValue: 0
            },
            {
                tfName: "maxval",
                name: "maxval",
                type: "number",
                defaultValue: 1
            },
            {
                tfName: "dtype",
                name: "dtype",
                type: "dtype"
            },
            {
                tfName: "seed",
                name: "seed",
                type: "number",
                defaultValue: 0
            },
            {
                tfName: "seed2",
                name: "seed2",
                type: "number",
                defaultValue: 0,
                notSupported: !0
            },
            {
                tfName: "T",
                name: "T",
                type: "number",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "RandomUniformInt",
        category: "creation",
        inputs: [
            {
                start: 0,
                name: "shape",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "minval",
                name: "minval",
                type: "number"
            },
            {
                tfName: "maxval",
                name: "maxval",
                type: "number"
            },
            {
                tfName: "seed",
                name: "seed",
                type: "number",
                defaultValue: 0
            },
            {
                tfName: "seed2",
                name: "seed2",
                type: "number",
                defaultValue: 0,
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Range",
        category: "creation",
        inputs: [
            {
                start: 0,
                name: "start",
                type: "number"
            },
            {
                start: 1,
                name: "stop",
                type: "number"
            },
            {
                start: 2,
                name: "step",
                type: "number",
                defaultValue: 0
            }
        ],
        attrs: [
            {
                tfName: "Tidx",
                name: "dtype",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "TruncatedNormal",
        category: "creation",
        inputs: [
            {
                start: 0,
                name: "shape",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "means",
                name: "mean",
                type: "number",
                defaultValue: 0
            },
            {
                tfName: "stddev",
                name: "stdDev",
                type: "number",
                defaultValue: 1
            },
            {
                tfName: "seed",
                name: "seed",
                type: "number"
            },
            {
                tfName: "seed2",
                name: "seed2",
                type: "number",
                defaultValue: 0,
                notSupported: !0
            },
            {
                tfName: "dtype",
                name: "dtype",
                type: "dtype"
            },
            {
                tfName: "T",
                name: "T",
                type: "number",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Zeros",
        category: "creation",
        inputs: [
            {
                start: 0,
                name: "shape",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "ZerosLike",
        category: "creation",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "Multinomial",
        category: "creation",
        inputs: [
            {
                start: 0,
                name: "logits",
                type: "tensor"
            },
            {
                start: 1,
                name: "numSamples",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "seed",
                name: "seed",
                type: "number"
            },
            {
                tfName: "seed2",
                name: "seed2",
                type: "number"
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype"
            },
            {
                tfName: "output_dtype",
                name: "output_dtype",
                type: "dtype"
            }
        ]
    }
], $126c3ebbcc6243ba$var$yg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$fg
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$gg = [
    {
        tfOpName: "NonMaxSuppressionV2",
        category: "dynamic",
        inputs: [
            {
                start: 0,
                name: "boxes",
                type: "tensor"
            },
            {
                start: 1,
                name: "scores",
                type: "tensor"
            },
            {
                start: 2,
                name: "maxOutputSize",
                type: "number"
            },
            {
                start: 3,
                name: "iouThreshold",
                type: "number"
            }
        ]
    },
    {
        tfOpName: "NonMaxSuppressionV3",
        category: "dynamic",
        inputs: [
            {
                start: 0,
                name: "boxes",
                type: "tensor"
            },
            {
                start: 1,
                name: "scores",
                type: "tensor"
            },
            {
                start: 2,
                name: "maxOutputSize",
                type: "number"
            },
            {
                start: 3,
                name: "iouThreshold",
                type: "number"
            },
            {
                start: 4,
                name: "scoreThreshold",
                type: "number"
            }
        ]
    },
    {
        tfOpName: "NonMaxSuppressionV4",
        category: "dynamic",
        inputs: [
            {
                start: 0,
                name: "boxes",
                type: "tensor"
            },
            {
                start: 1,
                name: "scores",
                type: "tensor"
            },
            {
                start: 2,
                name: "maxOutputSize",
                type: "number"
            },
            {
                start: 3,
                name: "iouThreshold",
                type: "number"
            },
            {
                start: 4,
                name: "scoreThreshold",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            },
            {
                tfName: "T_threshold",
                name: "threshold",
                type: "dtype",
                notSupported: !0
            },
            {
                tfName: "pad_to_max_output_size",
                name: "padToMaxOutputSize",
                type: "bool"
            }
        ]
    },
    {
        tfOpName: "NonMaxSuppressionV5",
        category: "dynamic",
        inputs: [
            {
                start: 0,
                name: "boxes",
                type: "tensor"
            },
            {
                start: 1,
                name: "scores",
                type: "tensor"
            },
            {
                start: 2,
                name: "maxOutputSize",
                type: "number"
            },
            {
                start: 3,
                name: "iouThreshold",
                type: "number"
            },
            {
                start: 4,
                name: "scoreThreshold",
                type: "number"
            },
            {
                start: 5,
                name: "softNmsSigma",
                type: "number"
            }
        ]
    },
    {
        tfOpName: "Where",
        category: "dynamic",
        inputs: [
            {
                start: 0,
                name: "condition",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "ListDiff",
        category: "dynamic",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "y",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    }
], $126c3ebbcc6243ba$var$bg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$gg
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Ng = [
    {
        tfOpName: "LowerBound",
        category: "evaluation",
        inputs: [
            {
                start: 0,
                name: "sortedSequence",
                type: "tensor"
            },
            {
                start: 1,
                name: "values",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "TopKV2",
        category: "evaluation",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "k",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "sorted",
                name: "sorted",
                type: "bool"
            }
        ]
    },
    {
        tfOpName: "UpperBound",
        category: "evaluation",
        inputs: [
            {
                start: 0,
                name: "sortedSequence",
                type: "tensor"
            },
            {
                start: 1,
                name: "values",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "Unique",
        category: "evaluation",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "UniqueV2",
        category: "evaluation",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "axis",
                type: "number"
            }
        ]
    }
], $126c3ebbcc6243ba$var$wg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$Ng
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Tg = [
    {
        tfOpName: "PlaceholderWithDefault",
        category: "graph",
        inputs: [
            {
                start: 0,
                name: "default",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "shape",
                name: "shape",
                type: "shape"
            },
            {
                tfName: "dtype",
                name: "dtype",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "Placeholder",
        category: "graph",
        attrs: [
            {
                tfName: "shape",
                name: "shape",
                type: "shape"
            },
            {
                tfName: "dtype",
                name: "dtype",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "Const",
        category: "graph"
    },
    {
        tfOpName: "Identity",
        category: "graph",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "IdentityN",
        category: "graph",
        inputs: [
            {
                start: 0,
                end: 0,
                name: "x",
                type: "tensors"
            }
        ]
    },
    {
        tfOpName: "Snapshot",
        category: "graph",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "Rank",
        category: "graph",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "Size",
        category: "graph",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "Shape",
        category: "graph",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "ShapeN",
        category: "graph",
        inputs: [
            {
                start: 0,
                end: 0,
                name: "x",
                type: "tensors"
            }
        ]
    },
    {
        tfOpName: "Print",
        category: "graph",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "data",
                type: "tensors"
            }
        ],
        attrs: [
            {
                tfName: "message",
                name: "message",
                type: "string"
            },
            {
                tfName: "first_n",
                name: "firstN",
                type: "number",
                notSupported: !0
            },
            {
                tfName: "summarize",
                name: "summarize",
                type: "number",
                defaultValue: 3
            }
        ]
    },
    {
        tfOpName: "NoOp",
        category: "graph",
        inputs: []
    },
    {
        tfOpName: "StopGradient",
        category: "graph",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "FakeQuantWithMinMaxVars",
        category: "graph",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "min",
                name: "min",
                type: "number"
            },
            {
                tfName: "max",
                name: "max",
                type: "number"
            }
        ]
    }
], $126c3ebbcc6243ba$var$Sg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$Tg
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$vg = [
    {
        tfOpName: "HashTable",
        category: "hash_table",
        inputs: [],
        attrs: [
            {
                tfName: "shared_name",
                name: "sharedName",
                type: "string"
            },
            {
                tfName: "use_node_name_sharing",
                name: "useNodeNameSharing",
                type: "bool"
            },
            {
                tfName: "key_dtype",
                name: "keyDType",
                type: "dtype"
            },
            {
                tfName: "value_dtype",
                name: "valueDType",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "HashTableV2",
        category: "hash_table",
        inputs: [],
        attrs: [
            {
                tfName: "shared_name",
                name: "sharedName",
                type: "string"
            },
            {
                tfName: "use_node_name_sharing",
                name: "useNodeNameSharing",
                type: "bool"
            },
            {
                tfName: "key_dtype",
                name: "keyDType",
                type: "dtype"
            },
            {
                tfName: "value_dtype",
                name: "valueDType",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "LookupTableImport",
        category: "hash_table",
        inputs: [
            {
                start: 0,
                name: "tableHandle",
                type: "tensor"
            },
            {
                start: 1,
                name: "keys",
                type: "tensor"
            },
            {
                start: 2,
                name: "values",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "Tin",
                name: "tIn",
                type: "dtype",
                notSupported: !0
            },
            {
                tfName: "Tout",
                name: "tOut",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "LookupTableImportV2",
        category: "hash_table",
        inputs: [
            {
                start: 0,
                name: "tableHandle",
                type: "tensor"
            },
            {
                start: 1,
                name: "keys",
                type: "tensor"
            },
            {
                start: 2,
                name: "values",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "Tin",
                name: "tIn",
                type: "dtype",
                notSupported: !0
            },
            {
                tfName: "Tout",
                name: "tOut",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "LookupTableFind",
        category: "hash_table",
        inputs: [
            {
                start: 0,
                name: "tableHandle",
                type: "tensor"
            },
            {
                start: 1,
                name: "keys",
                type: "tensor"
            },
            {
                start: 2,
                name: "defaultValue",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "Tin",
                name: "tIn",
                type: "dtype",
                notSupported: !0
            },
            {
                tfName: "Tout",
                name: "tOut",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "LookupTableFindV2",
        category: "hash_table",
        inputs: [
            {
                start: 0,
                name: "tableHandle",
                type: "tensor"
            },
            {
                start: 1,
                name: "keys",
                type: "tensor"
            },
            {
                start: 2,
                name: "defaultValue",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "Tin",
                name: "tIn",
                type: "dtype",
                notSupported: !0
            },
            {
                tfName: "Tout",
                name: "tOut",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "LookupTableSize",
        category: "hash_table",
        inputs: [
            {
                start: 0,
                name: "tableHandle",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "LookupTableSizeV2",
        category: "hash_table",
        inputs: [
            {
                start: 0,
                name: "tableHandle",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "InitializeTable",
        category: "hash_table",
        inputs: [
            {
                start: 0,
                name: "tableHandle",
                type: "tensor"
            },
            {
                start: 1,
                name: "keys",
                type: "tensor"
            },
            {
                start: 2,
                name: "values",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "InitializeTableV2",
        category: "hash_table",
        inputs: [
            {
                start: 0,
                name: "tableHandle",
                type: "tensor"
            },
            {
                start: 1,
                name: "keys",
                type: "tensor"
            },
            {
                start: 2,
                name: "values",
                type: "tensor"
            }
        ]
    }
], $126c3ebbcc6243ba$var$Og = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$vg
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$_g = [
    {
        tfOpName: "ResizeBilinear",
        category: "image",
        inputs: [
            {
                start: 0,
                name: "images",
                type: "tensor"
            },
            {
                start: 1,
                name: "size",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "align_corners",
                name: "alignCorners",
                type: "bool"
            },
            {
                tfName: "half_pixel_centers",
                name: "halfPixelCenters",
                type: "bool"
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "ResizeNearestNeighbor",
        category: "image",
        inputs: [
            {
                start: 0,
                name: "images",
                type: "tensor"
            },
            {
                start: 1,
                name: "size",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "align_corners",
                name: "alignCorners",
                type: "bool"
            },
            {
                tfName: "half_pixel_centers",
                name: "halfPixelCenters",
                type: "bool"
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "CropAndResize",
        category: "image",
        inputs: [
            {
                start: 0,
                name: "image",
                type: "tensor"
            },
            {
                start: 1,
                name: "boxes",
                type: "tensor"
            },
            {
                start: 2,
                name: "boxInd",
                type: "tensor"
            },
            {
                start: 3,
                name: "cropSize",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "method",
                name: "method",
                type: "string"
            },
            {
                tfName: "extrapolation_value",
                name: "extrapolationValue",
                type: "number"
            }
        ]
    },
    {
        tfOpName: "ImageProjectiveTransformV3",
        category: "image",
        inputs: [
            {
                start: 0,
                name: "images",
                type: "tensor"
            },
            {
                start: 1,
                name: "transforms",
                type: "tensor"
            },
            {
                start: 2,
                name: "outputShape",
                type: "number[]"
            },
            {
                start: 3,
                name: "fillValue",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "interpolation",
                name: "interpolation",
                type: "string"
            },
            {
                tfName: "fill_mode",
                name: "fillMode",
                type: "string"
            }
        ]
    }
], $126c3ebbcc6243ba$var$Ag = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$_g
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Eg = [
    {
        tfOpName: "Equal",
        category: "logical",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "NotEqual",
        category: "logical",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Greater",
        category: "logical",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "GreaterEqual",
        category: "logical",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Less",
        category: "logical",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "LessEqual",
        category: "logical",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "LogicalAnd",
        category: "logical",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "LogicalNot",
        category: "logical",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "LogicalOr",
        category: "logical",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Select",
        category: "logical",
        inputs: [
            {
                start: 0,
                name: "condition",
                type: "tensor"
            },
            {
                start: 1,
                name: "a",
                type: "tensor"
            },
            {
                start: 2,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "SelectV2",
        category: "logical",
        inputs: [
            {
                start: 0,
                name: "condition",
                type: "tensor"
            },
            {
                start: 1,
                name: "a",
                type: "tensor"
            },
            {
                start: 2,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "BitwiseAnd",
        category: "logical",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "y",
                type: "tensor"
            }
        ]
    }
], $126c3ebbcc6243ba$var$kg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$Eg
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Ig = [
    {
        tfOpName: "_FusedMatMul",
        category: "matrices",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            },
            {
                start: 2,
                end: 0,
                name: "args",
                type: "tensors"
            }
        ],
        attrs: [
            {
                tfName: "num_args",
                name: "numArgs",
                type: "number"
            },
            {
                tfName: "fused_ops",
                name: "fusedOps",
                type: "string[]",
                defaultValue: []
            },
            {
                tfName: "epsilon",
                name: "epsilon",
                type: "number",
                defaultValue: 1e-4
            },
            {
                tfName: "transpose_a",
                name: "transposeA",
                type: "bool",
                defaultValue: !1
            },
            {
                tfName: "transpose_b",
                name: "transposeB",
                type: "bool",
                defaultValue: !1
            },
            {
                tfName: "leakyrelu_alpha",
                name: "leakyreluAlpha",
                type: "number",
                defaultValue: 0.2
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "MatMul",
        category: "matrices",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "transpose_a",
                name: "transposeA",
                type: "bool",
                defaultValue: !1
            },
            {
                tfName: "transpose_b",
                name: "transposeB",
                type: "bool",
                defaultValue: !1
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "BatchMatMul",
        category: "matrices",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "adj_x",
                name: "transposeA",
                type: "bool",
                defaultValue: !1
            },
            {
                tfName: "adj_y",
                name: "transposeB",
                type: "bool",
                defaultValue: !1
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "BatchMatMulV2",
        category: "matrices",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "b",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "adj_x",
                name: "transposeA",
                type: "bool",
                defaultValue: !1
            },
            {
                tfName: "adj_y",
                name: "transposeB",
                type: "bool",
                defaultValue: !1
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Transpose",
        category: "matrices",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "perm",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Einsum",
        category: "matrices",
        inputs: [
            {
                start: 0,
                end: 0,
                name: "tensors",
                type: "tensors"
            }
        ],
        attrs: [
            {
                tfName: "equation",
                name: "equation",
                type: "string"
            },
            {
                tfName: "N",
                name: "n",
                type: "number",
                defaultValue: 2
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "MatrixBandPart",
        category: "matrices",
        inputs: [
            {
                start: 0,
                name: "a",
                type: "tensor"
            },
            {
                start: 1,
                name: "numLower",
                type: "tensor"
            },
            {
                start: 1,
                name: "numUpper",
                type: "tensor"
            }
        ]
    }
], $126c3ebbcc6243ba$var$$g = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$Ig
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Dg = [
    {
        tfOpName: "EuclideanNorm",
        category: "normalization",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "axis",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "keep_dims",
                name: "keepDims",
                type: "bool",
                defaultValue: !1
            }
        ]
    },
    {
        tfOpName: "FusedBatchNorm",
        category: "normalization",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "scale",
                type: "tensor"
            },
            {
                start: 2,
                name: "offset",
                type: "tensor"
            },
            {
                start: 3,
                name: "mean",
                type: "tensor"
            },
            {
                start: 4,
                name: "variance",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "epsilon",
                name: "epsilon",
                type: "number",
                defaultValue: 1e-3
            },
            {
                tfName: "data_format",
                name: "dataFormat",
                type: "string",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "FusedBatchNormV2",
        category: "normalization",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "scale",
                type: "tensor"
            },
            {
                start: 2,
                name: "offset",
                type: "tensor"
            },
            {
                start: 3,
                name: "mean",
                type: "tensor"
            },
            {
                start: 4,
                name: "variance",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "epsilon",
                name: "epsilon",
                type: "number",
                defaultValue: 1e-3
            },
            {
                tfName: "data_format",
                name: "dataFormat",
                type: "string",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "FusedBatchNormV3",
        category: "normalization",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "scale",
                type: "tensor"
            },
            {
                start: 2,
                name: "offset",
                type: "tensor"
            },
            {
                start: 3,
                name: "mean",
                type: "tensor"
            },
            {
                start: 4,
                name: "variance",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "epsilon",
                name: "epsilon",
                type: "number",
                defaultValue: 1e-3
            },
            {
                tfName: "data_format",
                name: "dataFormat",
                type: "string",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "LRN",
        category: "normalization",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "depth_radius",
                name: "radius",
                type: "number",
                defaultValue: 5
            },
            {
                tfName: "bias",
                name: "bias",
                type: "number",
                defaultValue: 1
            },
            {
                tfName: "alpha",
                name: "alpha",
                type: "number",
                defaultValue: 1
            },
            {
                tfName: "beta",
                name: "beta",
                type: "number",
                defaultValue: 0.5
            }
        ]
    },
    {
        tfOpName: "Softmax",
        category: "normalization",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "LogSoftmax",
        category: "normalization",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ]
    }
], $126c3ebbcc6243ba$var$Cg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$Dg
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$zg = [
    {
        tfOpName: "Bincount",
        category: "reduction",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "size",
                type: "number"
            },
            {
                start: 2,
                name: "weights",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "DenseBincount",
        category: "reduction",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "size",
                type: "number"
            },
            {
                start: 2,
                name: "weights",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "binary_output",
                name: "binaryOutput",
                type: "bool"
            }
        ]
    },
    {
        tfOpName: "Max",
        category: "reduction",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "axis",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "keep_dims",
                name: "keepDims",
                type: "bool"
            }
        ]
    },
    {
        tfOpName: "Mean",
        category: "reduction",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "axis",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "keep_dims",
                name: "keepDims",
                type: "bool"
            }
        ]
    },
    {
        tfOpName: "Min",
        category: "reduction",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "axis",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "keep_dims",
                name: "keepDims",
                type: "bool"
            }
        ]
    },
    {
        tfOpName: "Sum",
        category: "reduction",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "axis",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "keep_dims",
                name: "keepDims",
                type: "bool"
            }
        ]
    },
    {
        tfOpName: "All",
        category: "reduction",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "axis",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "keep_dims",
                name: "keepDims",
                type: "bool"
            }
        ]
    },
    {
        tfOpName: "Any",
        category: "reduction",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "axis",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "keep_dims",
                name: "keepDims",
                type: "bool"
            }
        ]
    },
    {
        tfOpName: "ArgMax",
        category: "reduction",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "axis",
                type: "number"
            }
        ]
    },
    {
        tfOpName: "ArgMin",
        category: "reduction",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "axis",
                type: "number"
            }
        ]
    },
    {
        tfOpName: "Prod",
        category: "reduction",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "axis",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "keep_dims",
                name: "keepDims",
                type: "bool"
            },
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Cumprod",
        category: "reduction",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "axis",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "exclusive",
                name: "exclusive",
                type: "bool"
            },
            {
                tfName: "reverse",
                name: "reverse",
                type: "bool"
            }
        ]
    },
    {
        tfOpName: "Cumsum",
        category: "reduction",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "axis",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "exclusive",
                name: "exclusive",
                type: "bool"
            },
            {
                tfName: "reverse",
                name: "reverse",
                type: "bool"
            }
        ]
    }
], $126c3ebbcc6243ba$var$xg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$zg
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Lg = [
    {
        tfOpName: "ConcatV2",
        category: "slice_join",
        inputs: [
            {
                start: 0,
                end: -1,
                name: "tensors",
                type: "tensors"
            },
            {
                start: -1,
                name: "axis",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "N",
                name: "n",
                type: "number",
                defaultValue: 2
            }
        ]
    },
    {
        tfOpName: "Concat",
        category: "slice_join",
        inputs: [
            {
                start: 1,
                end: 0,
                name: "tensors",
                type: "tensors"
            },
            {
                start: 0,
                name: "axis",
                type: "number"
            }
        ],
        attrs: [
            {
                tfName: "N",
                name: "n",
                type: "number",
                defaultValue: 2
            }
        ]
    },
    {
        tfOpName: "GatherV2",
        category: "slice_join",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "indices",
                type: "tensor"
            },
            {
                start: 2,
                name: "axis",
                type: "number",
                defaultValue: 0
            }
        ],
        attrs: [
            {
                tfName: "batch_dims",
                name: "batchDims",
                type: "number",
                defaultValue: 0
            }
        ]
    },
    {
        tfOpName: "Gather",
        category: "slice_join",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "indices",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "validate_indices",
                name: "validateIndices",
                type: "bool",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Reverse",
        category: "slice_join",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "dims",
                type: "bool[]"
            }
        ]
    },
    {
        tfOpName: "ReverseV2",
        category: "slice_join",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "axis",
                type: "number[]"
            }
        ]
    },
    {
        tfOpName: "Slice",
        category: "slice_join",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "begin",
                type: "number[]"
            },
            {
                start: 2,
                name: "size",
                type: "number[]"
            }
        ]
    },
    {
        tfOpName: "StridedSlice",
        category: "slice_join",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "begin",
                type: "number[]"
            },
            {
                start: 2,
                name: "end",
                type: "number[]"
            },
            {
                start: 3,
                name: "strides",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "begin_mask",
                name: "beginMask",
                type: "number",
                defaultValue: 0
            },
            {
                tfName: "end_mask",
                name: "endMask",
                type: "number",
                defaultValue: 0
            },
            {
                tfName: "new_axis_mask",
                name: "newAxisMask",
                type: "number",
                defaultValue: 0
            },
            {
                tfName: "ellipsis_mask",
                name: "ellipsisMask",
                type: "number",
                defaultValue: 0
            },
            {
                tfName: "shrink_axis_mask",
                name: "shrinkAxisMask",
                type: "number",
                defaultValue: 0
            }
        ]
    },
    {
        tfOpName: "Pack",
        category: "slice_join",
        inputs: [
            {
                start: 0,
                end: 0,
                name: "tensors",
                type: "tensors"
            }
        ],
        attrs: [
            {
                tfName: "axis",
                name: "axis",
                type: "number",
                defaultValue: 0
            }
        ]
    },
    {
        tfOpName: "Unpack",
        category: "slice_join",
        inputs: [
            {
                start: 0,
                name: "tensor",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "axis",
                name: "axis",
                type: "number",
                defaultValue: 0
            },
            {
                tfName: "num",
                name: "num",
                type: "number",
                defaultValue: 0,
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "Tile",
        category: "slice_join",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "reps",
                type: "number[]"
            }
        ]
    },
    {
        tfOpName: "Split",
        category: "slice_join",
        inputs: [
            {
                start: 0,
                name: "axis",
                type: "number",
                defaultValue: 0
            },
            {
                start: 1,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "num_split",
                name: "numOrSizeSplits",
                type: "number",
                defaultValue: 1
            }
        ]
    },
    {
        tfOpName: "SplitV",
        category: "slice_join",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "numOrSizeSplits",
                type: "number[]"
            },
            {
                start: 2,
                name: "axis",
                type: "number",
                defaultValue: 0
            }
        ]
    },
    {
        tfOpName: "ScatterNd",
        category: "slice_join",
        inputs: [
            {
                start: 0,
                name: "indices",
                type: "tensor"
            },
            {
                start: 1,
                name: "values",
                type: "tensor"
            },
            {
                start: 2,
                name: "shape",
                type: "number[]"
            }
        ]
    },
    {
        tfOpName: "GatherNd",
        category: "slice_join",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "indices",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "SparseToDense",
        category: "slice_join",
        inputs: [
            {
                start: 0,
                name: "sparseIndices",
                type: "tensor"
            },
            {
                start: 1,
                name: "outputShape",
                type: "number[]"
            },
            {
                start: 2,
                name: "sparseValues",
                type: "tensor"
            },
            {
                start: 3,
                name: "defaultValue",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "validate_indices",
                name: "validateIndices",
                type: "bool",
                defaultValue: !1,
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "TensorScatterUpdate",
        category: "slice_join",
        inputs: [
            {
                start: 0,
                name: "tensor",
                type: "tensor"
            },
            {
                start: 1,
                name: "indices",
                type: "tensor"
            },
            {
                start: 2,
                name: "values",
                type: "tensor"
            }
        ]
    }
], $126c3ebbcc6243ba$var$Pg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$Lg
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Fg = [
    {
        tfOpName: "SparseFillEmptyRows",
        category: "sparse",
        inputs: [
            {
                start: 0,
                name: "indices",
                type: "tensor"
            },
            {
                start: 1,
                name: "values",
                type: "tensor"
            },
            {
                start: 2,
                name: "denseShape",
                type: "tensor"
            },
            {
                start: 3,
                name: "defaultValue",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "SparseReshape",
        category: "sparse",
        inputs: [
            {
                start: 0,
                name: "inputIndices",
                type: "tensor"
            },
            {
                start: 1,
                name: "inputShape",
                type: "tensor"
            },
            {
                start: 2,
                name: "newShape",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "T",
                name: "dtype",
                type: "dtype",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "SparseSegmentMean",
        category: "sparse",
        inputs: [
            {
                start: 0,
                name: "data",
                type: "tensor"
            },
            {
                start: 1,
                name: "indices",
                type: "tensor"
            },
            {
                start: 2,
                name: "segmentIds",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "SparseSegmentSum",
        category: "sparse",
        inputs: [
            {
                start: 0,
                name: "data",
                type: "tensor"
            },
            {
                start: 1,
                name: "indices",
                type: "tensor"
            },
            {
                start: 2,
                name: "segmentIds",
                type: "tensor"
            }
        ]
    }
], $126c3ebbcc6243ba$var$Vg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$Fg
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Rg = [
    {
        tfOpName: "FFT",
        category: "spectral",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "IFFT",
        category: "spectral",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ]
    },
    {
        tfOpName: "RFFT",
        category: "spectral",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "fft_length",
                type: "number",
                notSupported: !0
            }
        ]
    },
    {
        tfOpName: "IRFFT",
        category: "spectral",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "fft_length",
                type: "number",
                notSupported: !0
            }
        ]
    }
], $126c3ebbcc6243ba$var$jg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$Rg
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Bg = [
    {
        tfOpName: "StaticRegexReplace",
        category: "string",
        inputs: [
            {
                start: 0,
                name: "input",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "pattern",
                name: "pattern",
                type: "string"
            },
            {
                tfName: "rewrite",
                name: "rewrite",
                type: "string"
            },
            {
                tfName: "replace_global",
                name: "replaceGlobal",
                type: "bool"
            }
        ]
    },
    {
        tfOpName: "StringNGrams",
        category: "string",
        inputs: [
            {
                start: 0,
                name: "data",
                type: "tensor"
            },
            {
                start: 1,
                name: "dataSplits",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "separator",
                name: "separator",
                type: "string"
            },
            {
                tfName: "ngram_widths",
                name: "nGramWidths",
                type: "number[]"
            },
            {
                tfName: "left_pad",
                name: "leftPad",
                type: "string"
            },
            {
                tfName: "right_pad",
                name: "rightPad",
                type: "string"
            },
            {
                tfName: "pad_width",
                name: "padWidth",
                type: "number"
            },
            {
                tfName: "preserve_short_sequences",
                name: "preserveShortSequences",
                type: "bool"
            }
        ],
        outputs: [
            "ngrams",
            "ngrams_splits"
        ]
    },
    {
        tfOpName: "StringSplit",
        category: "string",
        inputs: [
            {
                start: 0,
                name: "input",
                type: "tensor"
            },
            {
                start: 1,
                name: "delimiter",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "skip_empty",
                name: "skipEmpty",
                type: "bool"
            }
        ],
        outputs: [
            "indices",
            "values",
            "shape"
        ]
    },
    {
        tfOpName: "StringToHashBucketFast",
        category: "string",
        inputs: [
            {
                start: 0,
                name: "input",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "num_buckets",
                name: "numBuckets",
                type: "number"
            }
        ]
    }
], $126c3ebbcc6243ba$var$Hg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$Bg
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Wg = [
    {
        tfOpName: "Cast",
        category: "transformation",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "SrcT",
                name: "sdtype",
                type: "dtype",
                notSupported: !0
            },
            {
                tfName: "DstT",
                name: "dtype",
                type: "dtype"
            }
        ]
    },
    {
        tfOpName: "ExpandDims",
        category: "transformation",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "axis",
                type: "number"
            }
        ]
    },
    {
        tfOpName: "MirrorPad",
        category: "transformation",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "padding",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "mode",
                name: "mode",
                type: "string"
            }
        ]
    },
    {
        tfOpName: "Pad",
        category: "transformation",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "padding",
                type: "number[]"
            }
        ],
        attrs: [
            {
                tfName: "constant_value",
                name: "constantValue",
                type: "number",
                defaultValue: 0
            }
        ]
    },
    {
        tfOpName: "PadV2",
        category: "transformation",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "padding",
                type: "number[]"
            },
            {
                start: 2,
                name: "constantValue",
                type: "number",
                defaultValue: 0
            }
        ]
    },
    {
        tfOpName: "Reshape",
        category: "transformation",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "shape",
                type: "number[]"
            }
        ]
    },
    {
        tfOpName: "EnsureShape",
        category: "transformation",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "shape",
                type: "number[]"
            }
        ]
    },
    {
        tfOpName: "Squeeze",
        category: "transformation",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "axis",
                tfDeprecatedName: "squeeze_dims",
                name: "axis",
                type: "number[]"
            }
        ]
    },
    {
        tfOpName: "SpaceToBatchND",
        category: "transformation",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "blockShape",
                type: "number[]"
            },
            {
                start: 2,
                name: "paddings",
                type: "number[]"
            }
        ]
    },
    {
        tfOpName: "BatchToSpaceND",
        category: "transformation",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "blockShape",
                type: "number[]"
            },
            {
                start: 2,
                name: "crops",
                type: "number[]"
            }
        ]
    },
    {
        tfOpName: "DepthToSpace",
        category: "transformation",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            }
        ],
        attrs: [
            {
                tfName: "block_size",
                name: "blockSize",
                type: "number"
            },
            {
                tfName: "data_format",
                name: "dataFormat",
                type: "string"
            }
        ]
    },
    {
        tfOpName: "BroadcastTo",
        category: "transformation",
        inputs: [
            {
                start: 0,
                name: "x",
                type: "tensor"
            },
            {
                start: 1,
                name: "shape",
                type: "number[]"
            }
        ],
        attrs: []
    },
    {
        tfOpName: "BroadcastArgs",
        category: "transformation",
        inputs: [
            {
                start: 0,
                name: "s0",
                type: "tensor"
            },
            {
                start: 1,
                name: "s1",
                type: "tensor"
            }
        ],
        attrs: []
    }
], $126c3ebbcc6243ba$var$Ug = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    json: $126c3ebbcc6243ba$var$Wg
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $126c3ebbcc6243ba$var$jt {
    // Singleton instance for the mapper
    static get Instance() {
        return this._instance || (this._instance = new this());
    }
    // Loads the op mapping from the JSON file.
    constructor(){
        const e = [
            $126c3ebbcc6243ba$var$ug,
            $126c3ebbcc6243ba$var$pg,
            $126c3ebbcc6243ba$var$cg,
            $126c3ebbcc6243ba$var$hg,
            $126c3ebbcc6243ba$var$yg,
            $126c3ebbcc6243ba$var$bg,
            $126c3ebbcc6243ba$var$wg,
            $126c3ebbcc6243ba$var$Sg,
            $126c3ebbcc6243ba$var$Og,
            $126c3ebbcc6243ba$var$Ag,
            $126c3ebbcc6243ba$var$kg,
            $126c3ebbcc6243ba$var$$g,
            $126c3ebbcc6243ba$var$Cg,
            $126c3ebbcc6243ba$var$xg,
            $126c3ebbcc6243ba$var$Pg,
            $126c3ebbcc6243ba$var$Vg,
            $126c3ebbcc6243ba$var$jg,
            $126c3ebbcc6243ba$var$Hg,
            $126c3ebbcc6243ba$var$Ug
        ], t = [].concat(...e.map((a)=>a.json));
        this.opMappers = t.reduce((a, r)=>(a[r.tfOpName] = r, a), {});
    }
    // Converts the model inference graph from Tensorflow GraphDef to local
    // representation for TensorFlow.js API
    transformGraph(e, t = {}) {
        const a = e.node, r = [], n = [], u = [], o = a.reduce((g, f)=>(g[f.name] = this.mapNode(f), f.op.startsWith("Placeholder") ? r.push(g[f.name]) : f.op === "Const" ? n.push(g[f.name]) : (f.input == null || f.input.length === 0) && u.push(g[f.name]), g), {});
        let l = [];
        const p = [];
        let m = {}, c = {};
        t != null && (m = this.mapSignatureEntries(t.inputs), c = this.mapSignatureEntries(t.outputs));
        const d = Object.keys(o);
        d.forEach((g)=>{
            const f = o[g];
            f.inputNames.forEach((b, O)=>{
                const [_, , T] = $126c3ebbcc6243ba$var$B(b), I = o[_];
                if (I.outputs != null) {
                    const D = I.outputs.indexOf(T);
                    if (D !== -1) {
                        const C = `${_}:${D}`;
                        f.inputNames[O] = C;
                    }
                }
                f.inputs.push(I), I.children.push(f);
            });
        }), Object.keys(c).length === 0 ? d.forEach((g)=>{
            const f = o[g];
            f.children.length === 0 && p.push(f);
        }) : Object.keys(c).forEach((g)=>{
            const [f] = $126c3ebbcc6243ba$var$B(g), b = o[f];
            b != null && (b.signatureKey = c[g], p.push(b));
        }), Object.keys(m).length > 0 ? Object.keys(m).forEach((g)=>{
            const [f] = $126c3ebbcc6243ba$var$B(g), b = o[f];
            b && (b.signatureKey = m[g], l.push(b));
        }) : l = r;
        let h = {};
        e.library != null && e.library.function != null && (h = e.library.function.reduce((g, f)=>(g[f.signature.name] = this.mapFunction(f), g), {}));
        const N = {
            nodes: o,
            inputs: l,
            outputs: p,
            weights: n,
            placeholders: r,
            signature: t,
            functions: h
        };
        return u.length > 0 && (N.initNodes = u), N;
    }
    mapSignatureEntries(e) {
        return Object.keys(e || {}).reduce((t, a)=>(t[e[a].name] = a, t), {});
    }
    mapNode(e) {
        const t = $126c3ebbcc6243ba$var$ri(e.op) || this.opMappers[e.op] || {};
        e.attr == null && (e.attr = {});
        const a = {
            name: e.name,
            op: e.op,
            category: t.category,
            inputNames: (e.input || []).map((r)=>r.startsWith("^") ? r.slice(1) : r),
            inputs: [],
            children: [],
            inputParams: {},
            attrParams: {},
            rawAttrs: e.attr,
            outputs: t.outputs
        };
        return t.inputs != null && (a.inputParams = t.inputs.reduce((r, n)=>(r[n.name] = {
                type: n.type,
                inputIndexStart: n.start,
                inputIndexEnd: n.end
            }, r), {})), t.attrs != null && (a.attrParams = t.attrs.reduce((r, n)=>{
            const u = n.type;
            let o;
            switch(n.type){
                case "string":
                    o = $126c3ebbcc6243ba$var$Be(e.attr, n.tfName, n.defaultValue), o === void 0 && n.tfDeprecatedName && (o = $126c3ebbcc6243ba$var$Be(e.attr, n.tfDeprecatedName, n.defaultValue));
                    break;
                case "string[]":
                    o = $126c3ebbcc6243ba$var$Je(e.attr, n.tfName, n.defaultValue), o === void 0 && n.tfDeprecatedName && (o = $126c3ebbcc6243ba$var$Je(e.attr, n.tfDeprecatedName, n.defaultValue));
                    break;
                case "number":
                    o = $126c3ebbcc6243ba$var$We(e.attr, n.tfName, n.defaultValue || 0), o === void 0 && n.tfDeprecatedName && (o = $126c3ebbcc6243ba$var$We(e.attr, n.tfDeprecatedName, n.defaultValue));
                    break;
                case "number[]":
                    o = $126c3ebbcc6243ba$var$Ke(e.attr, n.tfName, n.defaultValue), o === void 0 && n.tfDeprecatedName && (o = $126c3ebbcc6243ba$var$Ke(e.attr, n.tfDeprecatedName, n.defaultValue));
                    break;
                case "bool":
                    o = $126c3ebbcc6243ba$var$He(e.attr, n.tfName, n.defaultValue), o === void 0 && n.tfDeprecatedName && (o = $126c3ebbcc6243ba$var$He(e.attr, n.tfDeprecatedName, n.defaultValue));
                    break;
                case "bool[]":
                    o = $126c3ebbcc6243ba$var$Xe(e.attr, n.tfName, n.defaultValue), o === void 0 && n.tfDeprecatedName && (o = $126c3ebbcc6243ba$var$Xe(e.attr, n.tfDeprecatedName, n.defaultValue));
                    break;
                case "shape":
                    o = $126c3ebbcc6243ba$var$Ge(e.attr, n.tfName, n.defaultValue), o === void 0 && n.tfDeprecatedName && (o = $126c3ebbcc6243ba$var$Ge(e.attr, n.tfDeprecatedName, n.defaultValue));
                    break;
                case "shape[]":
                    o = $126c3ebbcc6243ba$var$Qe(e.attr, n.tfName, n.defaultValue), o === void 0 && n.tfDeprecatedName && (o = $126c3ebbcc6243ba$var$Qe(e.attr, n.tfDeprecatedName, n.defaultValue));
                    break;
                case "dtype":
                    o = $126c3ebbcc6243ba$var$Ue(e.attr, n.tfName, n.defaultValue), o === void 0 && n.tfDeprecatedName && (o = $126c3ebbcc6243ba$var$Ue(e.attr, n.tfDeprecatedName, n.defaultValue));
                    break;
                case "dtype[]":
                    o = $126c3ebbcc6243ba$var$qe(e.attr, n.tfName, n.defaultValue), o === void 0 && n.tfDeprecatedName && (o = $126c3ebbcc6243ba$var$qe(e.attr, n.tfDeprecatedName, n.defaultValue));
                    break;
                case "func":
                    o = $126c3ebbcc6243ba$var$Bt(e.attr, n.tfName, n.defaultValue), o === void 0 && n.tfDeprecatedName && (o = $126c3ebbcc6243ba$var$Bt(e.attr, n.tfDeprecatedName, n.defaultValue));
                    break;
                case "tensor":
                case "tensors":
                    break;
                default:
                    throw new Error(`Unsupported param type: ${n.type} for op: ${e.op}`);
            }
            return r[n.name] = {
                value: o,
                type: u
            }, r;
        }, {})), a;
    }
    // map the TFunctionDef to TFJS graph object
    mapFunction(e) {
        const t = e.nodeDef, a = [], r = [];
        let n = {};
        t != null && (n = t.reduce((c, d)=>(c[d.name] = this.mapNode(d), d.op === "Const" && r.push(c[d.name]), c), {}));
        const u = [], o = [];
        e.signature.inputArg.forEach((c)=>{
            const [d] = $126c3ebbcc6243ba$var$B(c.name), h = {
                name: d,
                op: "Placeholder",
                inputs: [],
                inputNames: [],
                category: "graph",
                inputParams: {},
                attrParams: {
                    dtype: {
                        value: $126c3ebbcc6243ba$var$At(c.type),
                        type: "dtype"
                    }
                },
                children: []
            };
            h.signatureKey = c.name, u.push(h), n[d] = h;
        }), Object.keys(n).forEach((c)=>{
            const d = n[c];
            d.inputNames.forEach((h, N)=>{
                const [g, , f] = $126c3ebbcc6243ba$var$B(h), b = n[g];
                if (b.outputs != null) {
                    const O = b.outputs.indexOf(f);
                    if (O !== -1) {
                        const _ = `${g}:${O}`;
                        d.inputNames[N] = _;
                    }
                }
                d.inputs.push(b), b.children.push(d);
            });
        });
        const p = e.ret;
        e.signature.outputArg.forEach((c)=>{
            const [d, h] = $126c3ebbcc6243ba$var$B(p[c.name]), N = n[d];
            N != null && (N.defaultOutput = h, o.push(N));
        });
        const m = this.mapArgsToSignature(e);
        return {
            nodes: n,
            inputs: u,
            outputs: o,
            weights: r,
            placeholders: a,
            signature: m
        };
    }
    mapArgsToSignature(e) {
        return {
            methodName: e.signature.name,
            inputs: e.signature.inputArg.reduce((t, a)=>(t[a.name] = this.mapArgToTensorInfo(a), t), {}),
            outputs: e.signature.outputArg.reduce((t, a)=>(t[a.name] = this.mapArgToTensorInfo(a, e.ret), t), {})
        };
    }
    mapArgToTensorInfo(e, t) {
        let a = e.name;
        return t != null && (a = t[a]), {
            name: a,
            dtype: e.type
        };
    }
}
function $126c3ebbcc6243ba$var$qg(s) {
    const e = (0, $0qVX1.as)().global;
    if (typeof e.atob < "u") return e.atob(s);
    if (typeof $126c3ebbcc6243ba$require$Buffer < "u") return new $126c3ebbcc6243ba$require$Buffer(s, "base64").toString();
    throw new Error("Unable to decode base64 in this environment. Missing built-in atob() or Buffer()");
}
function $126c3ebbcc6243ba$var$ni(s, e) {
    const t = Array.isArray(s) ? String.fromCharCode.apply(null, s) : $126c3ebbcc6243ba$var$qg(s);
    return e ? t : t.toLowerCase();
}
function $126c3ebbcc6243ba$var$Be(s, e, t, a = !1) {
    const r = s[e];
    return r != null ? $126c3ebbcc6243ba$var$ni(r.s, a) : t;
}
function $126c3ebbcc6243ba$var$He(s, e, t) {
    const a = s[e];
    return a ? a.b : t;
}
function $126c3ebbcc6243ba$var$We(s, e, t) {
    const a = s[e] || {}, r = a.i != null ? a.i : a.f != null ? a.f : t;
    return typeof r == "number" ? r : parseInt(r, 10);
}
function $126c3ebbcc6243ba$var$At(s) {
    switch(typeof s == "string" && (s = (0, $0qVX1.cE)[s]), s){
        case (0, $0qVX1.cE).DT_FLOAT:
        case (0, $0qVX1.cE).DT_HALF:
            return "float32";
        case (0, $0qVX1.cE).DT_INT32:
        case (0, $0qVX1.cE).DT_INT64:
        case (0, $0qVX1.cE).DT_INT8:
        case (0, $0qVX1.cE).DT_UINT8:
            return "int32";
        case (0, $0qVX1.cE).DT_BOOL:
            return "bool";
        case (0, $0qVX1.cE).DT_DOUBLE:
            return "float32";
        case (0, $0qVX1.cE).DT_STRING:
            return "string";
        case (0, $0qVX1.cE).DT_COMPLEX64:
        case (0, $0qVX1.cE).DT_COMPLEX128:
            return "complex64";
        default:
            return null;
    }
}
function $126c3ebbcc6243ba$var$Bt(s, e, t) {
    const a = s[e];
    return a && a.func ? a.func.name : t;
}
function $126c3ebbcc6243ba$var$Ue(s, e, t) {
    const a = s[e];
    return a && a.type ? $126c3ebbcc6243ba$var$At(a.type) : t;
}
function $126c3ebbcc6243ba$var$qe(s, e, t) {
    const a = s[e];
    return a && a.list && a.list.type ? a.list.type.map((r)=>$126c3ebbcc6243ba$var$At(r)) : t;
}
function $126c3ebbcc6243ba$var$ii(s) {
    if (!s.unknownRank) return s.dim != null ? s.dim.map((e)=>typeof e.size == "number" ? e.size : parseInt(e.size, 10)) : [];
}
function $126c3ebbcc6243ba$var$Ge(s, e, t) {
    const a = s[e];
    return a && a.shape ? $126c3ebbcc6243ba$var$ii(a.shape) : t;
}
function $126c3ebbcc6243ba$var$Ke(s, e, t) {
    const a = s[e];
    return a ? ((a.list.f && a.list.f.length ? a.list.f : a.list.i) || []).map((r)=>typeof r == "number" ? r : parseInt(r, 10)) : t;
}
function $126c3ebbcc6243ba$var$Je(s, e, t, a = !1) {
    const r = s[e];
    return r && r.list && r.list.s ? r.list.s.map((n)=>$126c3ebbcc6243ba$var$ni(n, a)) : t;
}
function $126c3ebbcc6243ba$var$Qe(s, e, t) {
    const a = s[e];
    return a && a.list && a.list.shape ? a.list.shape.map((r)=>$126c3ebbcc6243ba$var$ii(r)) : t;
}
function $126c3ebbcc6243ba$var$Xe(s, e, t) {
    const a = s[e];
    return a && a.list && a.list.b ? a.list.b : t;
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $126c3ebbcc6243ba$var$Gg {
    constructor(e, t, a){
        this.node = e, this.tensorMap = t, this.context = a, this.inputs = [], this.attrs = {}, this.inputs = e.inputNames.map((r)=>this.getInput(r)), e.rawAttrs != null && (this.attrs = Object.keys(e.rawAttrs).reduce((r, n)=>(r[n] = this.getAttr(n), r), {}));
    }
    /**
   * Return the value of the attribute or input param.
   * @param name String: name of attribute or input param.
   */ getInput(e) {
        return $126c3ebbcc6243ba$var$E(e, this.tensorMap, this.context);
    }
    /**
   * Return the value of the attribute or input param.
   * @param name String: name of attribute or input param.
   */ getAttr(e, t) {
        const a = this.node.rawAttrs[e];
        if (a.tensor != null) return $126c3ebbcc6243ba$var$E(e, this.tensorMap, this.context);
        if (a.i != null || a.f != null) return $126c3ebbcc6243ba$var$We(this.node.rawAttrs, e, t);
        if (a.s != null) return $126c3ebbcc6243ba$var$Be(this.node.rawAttrs, e, t);
        if (a.b != null) return $126c3ebbcc6243ba$var$He(this.node.rawAttrs, e, t);
        if (a.shape != null) return $126c3ebbcc6243ba$var$Ge(this.node.rawAttrs, e, t);
        if (a.type != null) return $126c3ebbcc6243ba$var$Ue(this.node.rawAttrs, e, t);
        if (a.list != null) {
            if (a.list.i != null || a.list.f != null) return $126c3ebbcc6243ba$var$Ke(this.node.rawAttrs, e, t);
            if (a.list.s != null) return $126c3ebbcc6243ba$var$Je(this.node.rawAttrs, e, t);
            if (a.list.shape != null) return $126c3ebbcc6243ba$var$Qe(this.node.rawAttrs, e, t);
            if (a.list.b != null) return $126c3ebbcc6243ba$var$Xe(this.node.rawAttrs, e, t);
            if (a.list.type != null) return $126c3ebbcc6243ba$var$qe(this.node.rawAttrs, e, t);
        }
        return t;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$k = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    OP_SCOPE_SUFFIX: (0, $0qVX1.cF),
    abs: (0, $0qVX1.cG),
    acos: (0, $0qVX1.cH),
    acosh: (0, $0qVX1.cI),
    add: (0, $0qVX1.f),
    addN: $126c3ebbcc6243ba$var$nn,
    all: (0, $0qVX1.cJ),
    any: (0, $0qVX1.cK),
    argMax: (0, $0qVX1.cL),
    argMin: (0, $0qVX1.cM),
    asin: (0, $0qVX1.cN),
    asinh: (0, $0qVX1.cO),
    atan: (0, $0qVX1.cP),
    atan2: (0, $0qVX1.cQ),
    atanh: (0, $0qVX1.cR),
    avgPool: (0, $0qVX1.cS),
    avgPool3d: (0, $0qVX1.cT),
    basicLSTMCell: $126c3ebbcc6243ba$var$on,
    batchNorm: (0, $0qVX1.cU),
    batchNorm2d: (0, $0qVX1.cV),
    batchNorm3d: (0, $0qVX1.cW),
    batchNorm4d: (0, $0qVX1.cX),
    batchToSpaceND: (0, $0qVX1.cY),
    bincount: (0, $0qVX1.cZ),
    bitwiseAnd: $126c3ebbcc6243ba$var$un,
    booleanMaskAsync: $126c3ebbcc6243ba$var$Hn,
    broadcastArgs: $126c3ebbcc6243ba$var$ln,
    broadcastTo: (0, $0qVX1.c_),
    buffer: (0, $0qVX1.I),
    cast: (0, $0qVX1.aQ),
    ceil: (0, $0qVX1.c$),
    clipByValue: (0, $0qVX1.d0),
    clone: (0, $0qVX1.cD),
    complex: (0, $0qVX1.d1),
    concat: (0, $0qVX1.e),
    concat1d: (0, $0qVX1.d2),
    concat2d: (0, $0qVX1.d3),
    concat3d: (0, $0qVX1.d4),
    concat4d: (0, $0qVX1.d5),
    conv1d: (0, $0qVX1.d6),
    conv2d: (0, $0qVX1.d7),
    conv2dTranspose: (0, $0qVX1.d8),
    conv3d: (0, $0qVX1.d9),
    conv3dTranspose: (0, $0qVX1.da),
    cos: (0, $0qVX1.db),
    cosh: (0, $0qVX1.dc),
    cosineWindow: (0, $0qVX1.dd),
    cumprod: (0, $0qVX1.de),
    cumsum: (0, $0qVX1.df),
    denseBincount: (0, $0qVX1.dg),
    depthToSpace: (0, $0qVX1.dh),
    depthwiseConv2d: (0, $0qVX1.a9),
    diag: $126c3ebbcc6243ba$var$pn,
    dilation2d: (0, $0qVX1.di),
    div: (0, $0qVX1.a1),
    divNoNan: (0, $0qVX1.dj),
    dot: (0, $0qVX1.dk),
    dropout: (0, $0qVX1.dl),
    einsum: (0, $0qVX1.dm),
    elu: (0, $0qVX1.dn),
    enclosingPowerOfTwo: (0, $0qVX1.dp),
    ensureShape: $126c3ebbcc6243ba$var$mn,
    equal: (0, $0qVX1.dq),
    erf: (0, $0qVX1.dr),
    euclideanNorm: (0, $0qVX1.ds),
    exp: (0, $0qVX1.dt),
    expandDims: (0, $0qVX1.du),
    expm1: (0, $0qVX1.dv),
    eye: (0, $0qVX1.dw),
    fft: (0, $0qVX1.dx),
    fill: (0, $0qVX1.dy),
    floor: (0, $0qVX1.dz),
    floorDiv: (0, $0qVX1.dA),
    fused: $126c3ebbcc6243ba$var$Jn,
    gather: (0, $0qVX1.Z),
    gatherND: $126c3ebbcc6243ba$var$Gn,
    greater: (0, $0qVX1.dB),
    greaterEqual: (0, $0qVX1.dC),
    ifft: (0, $0qVX1.dD),
    imag: (0, $0qVX1.dE),
    image: (0, $0qVX1.dF),
    inTopKAsync: $126c3ebbcc6243ba$var$Kn,
    irfft: (0, $0qVX1.dG),
    isFinite: (0, $0qVX1.dH),
    isInf: (0, $0qVX1.dI),
    isNaN: (0, $0qVX1.dJ),
    leakyRelu: (0, $0qVX1.dK),
    less: (0, $0qVX1.dL),
    lessEqual: (0, $0qVX1.dM),
    linalg: (0, $0qVX1.dN),
    linspace: $126c3ebbcc6243ba$var$cn,
    localResponseNormalization: (0, $0qVX1.dO),
    log: (0, $0qVX1.dP),
    log1p: (0, $0qVX1.dQ),
    logSigmoid: (0, $0qVX1.dR),
    logSoftmax: (0, $0qVX1.dS),
    logSumExp: (0, $0qVX1.dT),
    logicalAnd: (0, $0qVX1.dU),
    logicalNot: (0, $0qVX1.dV),
    logicalOr: (0, $0qVX1.dW),
    logicalXor: (0, $0qVX1.dX),
    losses: (0, $0qVX1.dY),
    lowerBound: $126c3ebbcc6243ba$var$dn,
    matMul: (0, $0qVX1.m),
    max: (0, $0qVX1.dZ),
    maxPool: (0, $0qVX1.d_),
    maxPool3d: (0, $0qVX1.d$),
    maxPoolWithArgmax: $126c3ebbcc6243ba$var$hn,
    maximum: (0, $0qVX1.e0),
    mean: (0, $0qVX1.e1),
    meshgrid: $126c3ebbcc6243ba$var$fn,
    min: (0, $0qVX1.e2),
    minimum: (0, $0qVX1.e3),
    mirrorPad: (0, $0qVX1.e4),
    mod: (0, $0qVX1.e5),
    moments: (0, $0qVX1.e6),
    movingAverage: $126c3ebbcc6243ba$var$Wn,
    mul: (0, $0qVX1.g),
    multiRNNCell: $126c3ebbcc6243ba$var$yn,
    multinomial: $126c3ebbcc6243ba$var$gn,
    neg: (0, $0qVX1.e7),
    norm: (0, $0qVX1.e8),
    notEqual: (0, $0qVX1.e9),
    oneHot: (0, $0qVX1.aP),
    ones: (0, $0qVX1.l),
    onesLike: (0, $0qVX1.ea),
    op: (0, $0qVX1.o),
    outerProduct: $126c3ebbcc6243ba$var$bn,
    pad: (0, $0qVX1.q),
    pad1d: $126c3ebbcc6243ba$var$Nn,
    pad2d: $126c3ebbcc6243ba$var$wn,
    pad3d: $126c3ebbcc6243ba$var$Tn,
    pad4d: $126c3ebbcc6243ba$var$Sn,
    pool: (0, $0qVX1.eb),
    pow: (0, $0qVX1.a2),
    prelu: (0, $0qVX1.ec),
    print: (0, $0qVX1.ed),
    prod: (0, $0qVX1.ee),
    raggedGather: $126c3ebbcc6243ba$var$vn,
    raggedRange: $126c3ebbcc6243ba$var$On,
    raggedTensorToTensor: $126c3ebbcc6243ba$var$_n,
    rand: $126c3ebbcc6243ba$var$An,
    randomGamma: $126c3ebbcc6243ba$var$In,
    randomNormal: (0, $0qVX1.J),
    randomStandardNormal: $126c3ebbcc6243ba$var$$n,
    randomUniform: (0, $0qVX1.K),
    randomUniformInt: $126c3ebbcc6243ba$var$Dn,
    range: (0, $0qVX1.ef),
    real: (0, $0qVX1.eg),
    reciprocal: (0, $0qVX1.eh),
    relu: (0, $0qVX1.ei),
    relu6: (0, $0qVX1.ej),
    reshape: (0, $0qVX1.r),
    reverse: (0, $0qVX1.N),
    reverse1d: $126c3ebbcc6243ba$var$Cn,
    reverse2d: $126c3ebbcc6243ba$var$zn,
    reverse3d: $126c3ebbcc6243ba$var$xn,
    reverse4d: $126c3ebbcc6243ba$var$Ln,
    rfft: (0, $0qVX1.ek),
    round: (0, $0qVX1.el),
    rsqrt: (0, $0qVX1.em),
    scalar: (0, $0qVX1.$),
    scatterND: $126c3ebbcc6243ba$var$Un,
    searchSorted: $126c3ebbcc6243ba$var$Ce,
    selu: (0, $0qVX1.en),
    separableConv2d: (0, $0qVX1.eo),
    setdiff1dAsync: $126c3ebbcc6243ba$var$Pn,
    sigmoid: (0, $0qVX1.h),
    sign: (0, $0qVX1.ep),
    signal: (0, $0qVX1.eq),
    sin: (0, $0qVX1.er),
    sinh: (0, $0qVX1.es),
    slice: (0, $0qVX1.s),
    slice1d: (0, $0qVX1.et),
    slice2d: (0, $0qVX1.eu),
    slice3d: (0, $0qVX1.ev),
    slice4d: (0, $0qVX1.ew),
    softmax: (0, $0qVX1.ex),
    softplus: (0, $0qVX1.ey),
    spaceToBatchND: (0, $0qVX1.ez),
    sparse: (0, $0qVX1.eA),
    sparseToDense: $126c3ebbcc6243ba$var$qn,
    spectral: (0, $0qVX1.eB),
    split: (0, $0qVX1.eC),
    sqrt: (0, $0qVX1.eD),
    square: (0, $0qVX1.eE),
    squaredDifference: (0, $0qVX1.eF),
    squeeze: (0, $0qVX1.Y),
    stack: (0, $0qVX1.eG),
    step: (0, $0qVX1.eH),
    stridedSlice: (0, $0qVX1.eI),
    string: (0, $0qVX1.eJ),
    sub: (0, $0qVX1.a0),
    sum: (0, $0qVX1.eK),
    tan: (0, $0qVX1.eL),
    tanh: (0, $0qVX1.t),
    tensor: (0, $0qVX1.a7),
    tensor1d: (0, $0qVX1.eM),
    tensor2d: (0, $0qVX1.eN),
    tensor3d: (0, $0qVX1.eO),
    tensor4d: $126c3ebbcc6243ba$var$Fn,
    tensor5d: $126c3ebbcc6243ba$var$Vn,
    tensor6d: $126c3ebbcc6243ba$var$Rn,
    tensorScatterUpdate: $126c3ebbcc6243ba$var$jn,
    tile: (0, $0qVX1.eP),
    topk: (0, $0qVX1.eQ),
    transpose: (0, $0qVX1.aR),
    truncatedNormal: (0, $0qVX1.eR),
    unique: (0, $0qVX1.eS),
    unsortedSegmentSum: (0, $0qVX1.eT),
    unstack: (0, $0qVX1.eU),
    upperBound: $126c3ebbcc6243ba$var$Bn,
    variable: (0, $0qVX1.eV),
    where: (0, $0qVX1.eW),
    whereAsync: $126c3ebbcc6243ba$var$wt,
    zeros: (0, $0qVX1.eX),
    zerosLike: (0, $0qVX1.eY)
}, Symbol.toStringTag, {
    value: "Module"
}));
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Kg = (s, e, t, a = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "BiasAdd":
        case "AddV2":
        case "Add":
            return [
                a.add($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "AddN":
            return [
                a.addN($126c3ebbcc6243ba$var$i("tensors", s, e, t))
            ];
        case "FloorMod":
        case "Mod":
            return [
                a.mod($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "Mul":
            return [
                a.mul($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "RealDiv":
        case "Div":
            return [
                a.div($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "DivNoNan":
            return [
                a.divNoNan($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "FloorDiv":
            return [
                a.floorDiv($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "Sub":
            return [
                a.sub($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "Minimum":
            return [
                a.minimum($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "Maximum":
            return [
                a.maximum($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "Pow":
            return [
                a.pow($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "SquaredDifference":
            return [
                a.squaredDifference($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Jg = (s, e, t, a = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "Abs":
        case "ComplexAbs":
            return [
                a.abs($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Acos":
            return [
                a.acos($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Acosh":
            return [
                a.acosh($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Asin":
            return [
                a.asin($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Asinh":
            return [
                a.asinh($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Atan":
            return [
                a.atan($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Atan2":
            return [
                a.atan2($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("y", s, e, t))
            ];
        case "Atanh":
            return [
                a.atanh($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Ceil":
            return [
                a.ceil($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Complex":
            return [
                a.complex($126c3ebbcc6243ba$var$i("real", s, e, t), $126c3ebbcc6243ba$var$i("imag", s, e, t))
            ];
        case "Cos":
            return [
                a.cos($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Cosh":
            return [
                a.cosh($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Elu":
            return [
                a.elu($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Erf":
            return [
                a.erf($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Exp":
            return [
                a.exp($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Expm1":
            return [
                a.expm1($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Floor":
            return [
                a.floor($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Log":
            return [
                a.log($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Log1p":
            return [
                a.log1p($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Imag":
            return [
                a.imag($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Neg":
            return [
                a.neg($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Reciprocal":
            return [
                a.reciprocal($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Real":
            return [
                a.real($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Relu":
            return [
                a.relu($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Round":
            return [
                a.round($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Selu":
            return [
                a.selu($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Sigmoid":
            return [
                a.sigmoid($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Sin":
            return [
                a.sin($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Sign":
            return [
                a.sign($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Sinh":
            return [
                a.sinh($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Softplus":
            return [
                a.softplus($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Sqrt":
            return [
                a.sqrt($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Square":
            return [
                a.square($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Tanh":
            return [
                a.tanh($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Tan":
            return [
                a.tan($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "ClipByValue":
            return [
                a.clipByValue($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("clipValueMin", s, e, t), $126c3ebbcc6243ba$var$i("clipValueMax", s, e, t))
            ];
        case "Relu6":
            return [
                a.relu6($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "Rsqrt":
            return [
                a.rsqrt($126c3ebbcc6243ba$var$E(s.inputNames[0], e, t))
            ];
        case "LeakyRelu":
            return [
                a.leakyRelu($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("alpha", s, e, t))
            ];
        case "Prelu":
            return [
                a.prelu($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("alpha", s, e, t))
            ];
        case "IsNan":
            return [
                a.isNaN($126c3ebbcc6243ba$var$E(s.inputNames[0], e, t))
            ];
        case "IsInf":
            return [
                a.isInf($126c3ebbcc6243ba$var$E(s.inputNames[0], e, t))
            ];
        case "IsFinite":
            return [
                a.isFinite($126c3ebbcc6243ba$var$E(s.inputNames[0], e, t))
            ];
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$x(s, e, t = "") {
    if (!(typeof s == "number" || typeof e == "number")) {
        (0, $0qVX1.b)(s.length === e.length, ()=>t + ` Shapes ${s} and ${e} must match`);
        for(let a = 0; a < s.length; a++){
            const r = s[a], n = e[a];
            (0, $0qVX1.b)(r < 0 || n < 0 || r === n, ()=>t + ` Shapes ${s} and ${e} must match`);
        }
    }
}
function $126c3ebbcc6243ba$var$Ht(s) {
    return !(typeof s == "number" || s.some((e)=>e < 0));
}
function $126c3ebbcc6243ba$var$ie(s, e, t) {
    let a = $126c3ebbcc6243ba$var$Ze(s, t);
    const r = !$126c3ebbcc6243ba$var$Ht(a);
    if (r && e.length === 0) throw new Error(`Tried to calculate elements of an empty list with non-fully-defined elementShape: ${a}`);
    if (r && e.forEach((n)=>{
        a = $126c3ebbcc6243ba$var$Ze(n.shape, a);
    }), !$126c3ebbcc6243ba$var$Ht(a)) throw new Error(`Non-fully-defined elementShape: ${a}`);
    return a;
}
function $126c3ebbcc6243ba$var$Ze(s, e) {
    if (typeof s == "number") return e;
    if (typeof e == "number") return s;
    if (s.length !== e.length) throw new Error(`Incompatible ranks during merge: ${s} vs. ${e}`);
    const t = [];
    for(let a = 0; a < s.length; ++a){
        const r = s[a], n = e[a];
        if (r >= 0 && n >= 0 && r !== n) throw new Error(`Incompatible shape during merge: ${s} vs. ${e}`);
        t[a] = r >= 0 ? r : n;
    }
    return t;
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $126c3ebbcc6243ba$var$Qg {
    constructor(e, t, a, r, n, u, o){
        this.name = e, this.dtype = t, this.maxSize = a, this.elementShape = r, this.identicalElementShapes = n, this.dynamicSize = u, this.clearAfterRead = o, this.tensors = [], this.closed_ = !1, this.idTensor = (0, $0qVX1.$)(0), (0, $0qVX1.eZ)(this.idTensor);
    }
    get id() {
        return this.idTensor.id;
    }
    get closed() {
        return this.closed_;
    }
    /**
   * Dispose the tensors and idTensor and mark the TensoryArray as closed.
   */ clearAndClose(e) {
        this.tensors.forEach((t)=>{
            (e == null || !e.has(t.tensor.id)) && t.tensor.dispose();
        }), this.tensors = [], this.closed_ = !0, this.idTensor.dispose();
    }
    size() {
        return this.tensors.length;
    }
    /**
   * Read the value at location index in the TensorArray.
   * @param index Number the index to read from.
   */ read(e) {
        if (this.closed_) throw new Error(`TensorArray ${this.name} has already been closed.`);
        if (e < 0 || e >= this.size()) throw new Error(`Tried to read from index ${e}, but array size is: ${this.size()}`);
        const t = this.tensors[e];
        if (t.cleared) throw new Error(`TensorArray ${this.name}: Could not read index ${e} twice because it was cleared after a previous read (perhaps try setting clear_after_read = false?).`);
        return this.clearAfterRead && (t.cleared = !0), t.read = !0, t.tensor;
    }
    /**
   * Helper method to read multiple tensors from the specified indices.
   */ readMany(e) {
        return e.map((t)=>this.read(t));
    }
    /**
   * Write value into the index of the TensorArray.
   * @param index number the index to write to.
   * @param tensor
   */ write(e, t) {
        if (this.closed_) throw new Error(`TensorArray ${this.name} has already been closed.`);
        if (e < 0 || !this.dynamicSize && e >= this.maxSize) throw new Error(`Tried to write to index ${e}, but array is not resizeable and size is: ${this.maxSize}`);
        const a = this.tensors[e] || {};
        if (t.dtype !== this.dtype) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${e},
          because the value dtype is ${t.dtype}, but TensorArray dtype is ${this.dtype}.`);
        if (this.size() === 0 && (this.elementShape == null || this.elementShape.length === 0) && (this.elementShape = t.shape), $126c3ebbcc6243ba$var$x(this.elementShape, t.shape, `TensorArray ${this.name}: Could not write to TensorArray index ${e}.`), a.read) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${e}, because it has already been read.`);
        if (a.written) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${e}, because it has already been written.`);
        a.tensor = t, (0, $0qVX1.eZ)(t), a.written = !0, this.tensors[e] = a;
    }
    /**
   * Helper method to write multiple tensors to the specified indices.
   */ writeMany(e, t) {
        if (e.length !== t.length) throw new Error(`TensorArray ${this.name}: could not write multiple tensors,because the index size: ${e.length} is not the same as tensors size: ${t.length}.`);
        e.forEach((a, r)=>this.write(a, t[r]));
    }
    /**
   * Return selected values in the TensorArray as a packed Tensor. All of
   * selected values must have been written and their shapes must all match.
   * @param [indices] number[] Optional. Taking values in [0, max_value). If the
   *    TensorArray is not dynamic, max_value=size(). If not specified returns
   *    all tensors in the original order.
   * @param [dtype]
   */ gather(e, t) {
        if (t && t !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but gather requested dtype ${t}`);
        if (e) e = e.slice(0, this.size());
        else {
            e = [];
            for(let r = 0; r < this.size(); r++)e.push(r);
        }
        if (e.length === 0) return (0, $0qVX1.a7)([], [
            0
        ].concat(this.elementShape));
        const a = this.readMany(e);
        return $126c3ebbcc6243ba$var$x(this.elementShape, a[0].shape, "TensorArray shape mismatch: "), (0, $0qVX1.eG)(a, 0);
    }
    /**
   * Return the values in the TensorArray as a concatenated Tensor.
   */ concat(e) {
        if (e && e !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but concat requested dtype ${e}`);
        if (this.size() === 0) return (0, $0qVX1.a7)([], [
            0
        ].concat(this.elementShape));
        const t = [];
        for(let r = 0; r < this.size(); r++)t.push(r);
        const a = this.readMany(t);
        return $126c3ebbcc6243ba$var$x(this.elementShape, a[0].shape, `TensorArray shape mismatch: tensor array shape (${this.elementShape}) vs first tensor shape (${a[0].shape})`), (0, $0qVX1.e)(a, 0);
    }
    /**
   * Scatter the values of a Tensor in specific indices of a TensorArray.
   * @param indices nummber[] values in [0, max_value). If the
   *    TensorArray is not dynamic, max_value=size().
   * @param tensor Tensor input tensor.
   */ scatter(e, t) {
        if (t.dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but tensor has dtype ${t.dtype}`);
        if (e.length !== t.shape[0]) throw new Error(`Expected len(indices) == tensor.shape[0], but saw: ${e.length} vs. ${t.shape[0]}`);
        const a = Math.max(...e);
        if (!this.dynamicSize && a >= this.maxSize) throw new Error(`Max index must be < array size (${a}  vs. ${this.maxSize})`);
        this.writeMany(e, (0, $0qVX1.eU)(t, 0));
    }
    /**
   * Split the values of a Tensor into the TensorArray.
   * @param length number[] with the lengths to use when splitting value along
   *    its first dimension.
   * @param tensor Tensor, the tensor to split.
   */ split(e, t) {
        if (t.dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but tensor has dtype ${t.dtype}`);
        let a = 0;
        const r = e.map((l)=>(a += l, a));
        if (a !== t.shape[0]) throw new Error(`Expected sum of lengths to be equal to
          tensor.shape[0], but sum of lengths is
        ${a}, and tensor's shape is: ${t.shape}`);
        if (!this.dynamicSize && e.length !== this.maxSize) throw new Error(`TensorArray's size is not equal to the size of lengths (${this.maxSize} vs. ${e.length}), and the TensorArray is not marked as dynamically resizeable`);
        const n = a === 0 ? 0 : t.size / a, u = [];
        (0, $0qVX1.e_)(()=>{
            t = (0, $0qVX1.r)(t, [
                1,
                a,
                n
            ]);
            for(let l = 0; l < e.length; ++l){
                const m = [
                    0,
                    l === 0 ? 0 : r[l - 1],
                    0
                ], c = [
                    1,
                    e[l],
                    n
                ];
                u[l] = (0, $0qVX1.r)((0, $0qVX1.s)(t, m, c), this.elementShape);
            }
            return u;
        });
        const o = [];
        for(let l = 0; l < e.length; l++)o[l] = l;
        this.writeMany(o, u);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $126c3ebbcc6243ba$var$Q {
    get id() {
        return this.idTensor.id;
    }
    /**
   *
   * @param tensors list of tensors
   * @param elementShape shape of each tensor, this can be a single number (any
   * shape is allowed) or partial shape (dim = -1).
   * @param elementDtype data type of each tensor
   * @param maxNumElements The maximum allowed size of `tensors`. Defaults to -1
   *   meaning that the size of `tensors` is unbounded.
   */ constructor(e, t, a, r = -1){
        this.tensors = e, this.elementShape = t, this.elementDtype = a, e != null && e.forEach((n)=>{
            if (a !== n.dtype) throw new Error(`Invalid data types; op elements ${a}, but list elements ${n.dtype}`);
            $126c3ebbcc6243ba$var$x(t, n.shape, "TensorList shape mismatch: "), (0, $0qVX1.eZ)(n);
        }), this.idTensor = (0, $0qVX1.$)(0), this.maxNumElements = r, (0, $0qVX1.eZ)(this.idTensor);
    }
    /**
   * Get a new TensorList containing a copy of the underlying tensor container.
   */ copy() {
        return new $126c3ebbcc6243ba$var$Q([
            ...this.tensors
        ], this.elementShape, this.elementDtype);
    }
    /**
   * Dispose the tensors and idTensor and clear the tensor list.
   */ clearAndClose(e) {
        this.tensors.forEach((t)=>{
            (e == null || !e.has(t.id)) && t.dispose();
        }), this.tensors.length = 0, this.idTensor.dispose();
    }
    /**
   * The size of the tensors in the tensor list.
   */ size() {
        return this.tensors.length;
    }
    /**
   * Return a tensor that stacks a list of rank-R tf.Tensors into one rank-(R+1)
   * tf.Tensor.
   * @param elementShape shape of each tensor
   * @param elementDtype data type of each tensor
   * @param numElements the number of elements to stack
   */ stack(e, t, a = -1) {
        if (t !== this.elementDtype) throw new Error(`Invalid data types; op elements ${t}, but list elements ${this.elementDtype}`);
        if (a !== -1 && this.tensors.length !== a) throw new Error(`Operation expected a list with ${a} elements but got a list with ${this.tensors.length} elements.`);
        $126c3ebbcc6243ba$var$x(e, this.elementShape, "TensorList shape mismatch: ");
        const r = $126c3ebbcc6243ba$var$ie(this.elementShape, this.tensors, e);
        return (0, $0qVX1.e_)(()=>{
            const n = this.tensors.map((u)=>(0, $0qVX1.r)(u, r));
            return (0, $0qVX1.eG)(n, 0);
        });
    }
    /**
   * Pop a tensor from the end of the list.
   * @param elementShape shape of the tensor
   * @param elementDtype data type of the tensor
   */ popBack(e, t) {
        if (t !== this.elementDtype) throw new Error(`Invalid data types; op elements ${t}, but list elements ${this.elementDtype}`);
        if (this.size() === 0) throw new Error("Trying to pop from an empty list.");
        const a = $126c3ebbcc6243ba$var$ie(this.elementShape, this.tensors, e), r = this.tensors.pop();
        return r.kept = !1, $126c3ebbcc6243ba$var$x(r.shape, e, "TensorList shape mismatch: "), (0, $0qVX1.r)(r, a);
    }
    /**
   * Push a tensor to the end of the list.
   * @param tensor Tensor to be pushed.
   */ pushBack(e) {
        if (e.dtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${e.dtype}, but list elements ${this.elementDtype}`);
        if ($126c3ebbcc6243ba$var$x(e.shape, this.elementShape, "TensorList shape mismatch: "), this.maxNumElements === this.size()) throw new Error("Trying to push element into a full list.");
        (0, $0qVX1.eZ)(e), this.tensors.push(e);
    }
    /**
   * Update the size of the list.
   * @param size the new size of the list.
   */ resize(e) {
        if (e < 0) throw new Error(`TensorListResize expects size to be non-negative. Got: ${e}`);
        if (this.maxNumElements !== -1 && e > this.maxNumElements) throw new Error(`TensorListResize input size ${e} is greater maxNumElement ${this.maxNumElements}.`);
        const t = new $126c3ebbcc6243ba$var$Q([], this.elementShape, this.elementDtype, this.maxNumElements);
        t.tensors.length = e;
        for(let a = 0; a < Math.min(this.tensors.length, e); ++a)t.tensors[a] = this.tensors[a];
        return t;
    }
    /**
   * Retrieve the element at the provided index
   * @param elementShape shape of the tensor
   * @param elementDtype dtype of the tensor
   * @param elementIndex index of the tensor
   */ getItem(e, t, a) {
        if (a !== this.elementDtype) throw new Error(`Invalid data types; op elements ${a}, but list elements ${this.elementDtype}`);
        if (e < 0 || e > this.tensors.length) throw new Error(`Trying to access element ${e} in a list with ${this.tensors.length} elements.`);
        if (this.tensors[e] == null) throw new Error(`element at index ${e} is null.`);
        $126c3ebbcc6243ba$var$x(this.tensors[e].shape, t, "TensorList shape mismatch: ");
        const r = $126c3ebbcc6243ba$var$ie(this.elementShape, this.tensors, t);
        return (0, $0qVX1.r)(this.tensors[e], r);
    }
    /**
   * Set the tensor at the index
   * @param elementIndex index of the tensor
   * @param tensor the tensor to be inserted into the list
   */ setItem(e, t) {
        if (t.dtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${t.dtype}, but list elements ${this.elementDtype}`);
        if (e < 0 || this.maxNumElements !== -1 && e >= this.maxNumElements) throw new Error(`Trying to set element ${e} in a list with max ${this.maxNumElements} elements.`);
        $126c3ebbcc6243ba$var$x(this.elementShape, t.shape, "TensorList shape mismatch: "), (0, $0qVX1.eZ)(t), this.tensors[e] != null && (this.tensors[e].kept = !1), this.tensors[e] = t;
    }
    /**
   * Return selected values in the TensorList as a stacked Tensor. All of
   * selected values must have been written and their shapes must all match.
   * @param indices indices of tensors to gather
   * @param elementDtype output tensor dtype
   * @param elementShape output tensor element shape
   */ gather(e, t, a) {
        if (t !== this.elementDtype) throw new Error(`Invalid data types; op elements ${t}, but list elements ${this.elementDtype}`);
        $126c3ebbcc6243ba$var$x(this.elementShape, a, "TensorList shape mismatch: "), e = e.slice(0, this.size());
        const r = $126c3ebbcc6243ba$var$ie(this.elementShape, this.tensors, a);
        return e.length === 0 ? (0, $0qVX1.a7)([], [
            0
        ].concat(r)) : (0, $0qVX1.e_)(()=>{
            const n = e.map((u)=>(0, $0qVX1.r)(this.tensors[u], r));
            return (0, $0qVX1.eG)(n, 0);
        });
    }
    /**
   * Return the values in the TensorList as a concatenated Tensor.
   * @param elementDtype output tensor dtype
   * @param elementShape output tensor element shape
   */ concat(e, t) {
        if (e && e !== this.elementDtype) throw new Error(`TensorList dtype is ${this.elementDtype} but concat requested dtype ${e}`);
        $126c3ebbcc6243ba$var$x(this.elementShape, t, "TensorList shape mismatch: ");
        const a = $126c3ebbcc6243ba$var$ie(this.elementShape, this.tensors, t);
        return this.size() === 0 ? (0, $0qVX1.a7)([], [
            0
        ].concat(a)) : (0, $0qVX1.e_)(()=>{
            const r = this.tensors.map((n)=>(0, $0qVX1.r)(n, a));
            return (0, $0qVX1.e)(r, 0);
        });
    }
}
function $126c3ebbcc6243ba$var$Xg(s, e, t) {
    const a = s.dtype;
    if (s.shape.length < 1) throw new Error(`Tensor must be at least a vector, but saw shape: ${s.shape}`);
    if (s.dtype !== t) throw new Error(`Invalid data types; op elements ${s.dtype}, but list elements ${t}`);
    const r = s.shape.slice(1);
    $126c3ebbcc6243ba$var$x(r, e, "TensorList shape mismatch: ");
    const n = (0, $0qVX1.eU)(s);
    return new $126c3ebbcc6243ba$var$Q(n, e, a);
}
function $126c3ebbcc6243ba$var$Zg(s, e, t, a) {
    return new $126c3ebbcc6243ba$var$Q([], s, e, a);
}
function $126c3ebbcc6243ba$var$Yg(s, e, t, a) {
    if (e.length !== s.shape[0]) throw new Error(`Expected len(indices) == tensor.shape[0], but saw: ${e.length} vs. ${s.shape[0]}`);
    const r = Math.max(...e);
    if (a != null && a !== -1 && r >= a) throw new Error(`Max index must be < array size (${r}  vs. ${a})`);
    const n = new $126c3ebbcc6243ba$var$Q([], t, s.dtype, a), u = (0, $0qVX1.eU)(s, 0);
    return e.forEach((o, l)=>{
        n.setItem(o, u[l]);
    }), n;
}
function $126c3ebbcc6243ba$var$Mg(s, e, t) {
    let a = 0;
    const r = e.map((m)=>(a += m, a));
    if (a !== s.shape[0]) throw new Error(`Expected sum of lengths to be equal to
          tensor.shape[0], but sum of lengths is
        ${a}, and tensor's shape is: ${s.shape}`);
    const n = s.shape.slice(1), u = $126c3ebbcc6243ba$var$Ze(n, t), o = a === 0 ? 0 : s.size / a, l = (0, $0qVX1.e_)(()=>{
        const m = [];
        s = (0, $0qVX1.r)(s, [
            1,
            a,
            o
        ]);
        for(let c = 0; c < e.length; ++c){
            const h = [
                0,
                c === 0 ? 0 : r[c - 1],
                0
            ], N = [
                1,
                e[c],
                o
            ];
            m[c] = (0, $0qVX1.r)((0, $0qVX1.s)(s, h, N), u);
        }
        return s.dispose(), m;
    }), p = new $126c3ebbcc6243ba$var$Q([], t, s.dtype, e.length);
    for(let m = 0; m < l.length; m++)p.setItem(m, l[m]);
    return p;
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$eb = async (s, e, t)=>{
    switch(s.op){
        case "If":
        case "StatelessIf":
            {
                const a = $126c3ebbcc6243ba$var$i("thenBranch", s, e, t), r = $126c3ebbcc6243ba$var$i("elseBranch", s, e, t), n = $126c3ebbcc6243ba$var$i("cond", s, e, t), u = $126c3ebbcc6243ba$var$i("args", s, e, t);
                return (await n.data())[0] ? t.functionMap[a].executeFunctionAsync(u, t.tensorArrayMap, t.tensorListMap) : t.functionMap[r].executeFunctionAsync(u, t.tensorArrayMap, t.tensorListMap);
            }
        case "While":
        case "StatelessWhile":
            {
                const a = $126c3ebbcc6243ba$var$i("body", s, e, t), r = $126c3ebbcc6243ba$var$i("cond", s, e, t), n = $126c3ebbcc6243ba$var$i("args", s, e, t), u = await t.functionMap[r].executeFunctionAsync(n, t.tensorArrayMap, t.tensorListMap), o = n.map((m)=>m.id);
                let l = await u[0].data();
                u.forEach((m)=>{
                    !m.kept && o.indexOf(m.id) === -1 && m.dispose();
                });
                let p = n;
                for(; l[0];){
                    const m = p;
                    p = await t.functionMap[a].executeFunctionAsync(p, t.tensorArrayMap, t.tensorListMap);
                    const c = p.map((h)=>h.id);
                    m.forEach((h)=>{
                        !h.kept && o.indexOf(h.id) === -1 && c.indexOf(h.id) === -1 && h.dispose();
                    });
                    const d = await t.functionMap[r].executeFunctionAsync(p, t.tensorArrayMap, t.tensorListMap);
                    l = await d[0].data(), d.forEach((h)=>{
                        !h.kept && o.indexOf(h.id) === -1 && c.indexOf(h.id) === -1 && h.dispose();
                    });
                }
                return p;
            }
        case "LoopCond":
            {
                const a = $126c3ebbcc6243ba$var$i("pred", s, e, t);
                return [
                    $126c3ebbcc6243ba$var$H(a)
                ];
            }
        case "Switch":
            {
                const a = $126c3ebbcc6243ba$var$i("pred", s, e, t);
                let r = $126c3ebbcc6243ba$var$i("data", s, e, t);
                return r.kept || (r = $126c3ebbcc6243ba$var$H(r)), (await a.data())[0] ? [
                    void 0,
                    r
                ] : [
                    r,
                    void 0
                ];
            }
        case "Merge":
            {
                const a = s.inputNames.find((r)=>$126c3ebbcc6243ba$var$E(r, e, t) !== void 0);
                if (a) {
                    const r = $126c3ebbcc6243ba$var$E(a, e, t);
                    return [
                        $126c3ebbcc6243ba$var$H(r)
                    ];
                }
                return;
            }
        case "Enter":
            {
                const a = $126c3ebbcc6243ba$var$i("frameName", s, e, t), r = $126c3ebbcc6243ba$var$i("tensor", s, e, t);
                return t.enterFrame(a), [
                    $126c3ebbcc6243ba$var$H(r)
                ];
            }
        case "Exit":
            {
                const a = $126c3ebbcc6243ba$var$i("tensor", s, e, t);
                return t.exitFrame(), [
                    $126c3ebbcc6243ba$var$H(a)
                ];
            }
        case "NextIteration":
            {
                const a = $126c3ebbcc6243ba$var$i("tensor", s, e, t);
                return t.nextIteration(), [
                    $126c3ebbcc6243ba$var$H(a)
                ];
            }
        case "TensorArrayV3":
            {
                const a = $126c3ebbcc6243ba$var$i("size", s, e, t), r = $126c3ebbcc6243ba$var$i("dtype", s, e, t), n = $126c3ebbcc6243ba$var$i("elementShape", s, e, t), u = $126c3ebbcc6243ba$var$i("dynamicSize", s, e, t), o = $126c3ebbcc6243ba$var$i("clearAfterRead", s, e, t), l = $126c3ebbcc6243ba$var$i("identicalElementShapes", s, e, t), p = $126c3ebbcc6243ba$var$i("name", s, e, t), m = new $126c3ebbcc6243ba$var$Qg(p, r, a, n, l, u, o);
                return t.addTensorArray(m), [
                    m.idTensor,
                    (0, $0qVX1.$)(1)
                ];
            }
        case "TensorArrayWriteV3":
            {
                const a = $126c3ebbcc6243ba$var$i("tensorArrayId", s, e, t), r = $126c3ebbcc6243ba$var$i("index", s, e, t), n = $126c3ebbcc6243ba$var$i("tensor", s, e, t), u = t.getTensorArray(a.id);
                return u.write(r, n), [
                    u.idTensor
                ];
            }
        case "TensorArrayReadV3":
            {
                const a = $126c3ebbcc6243ba$var$i("tensorArrayId", s, e, t), r = $126c3ebbcc6243ba$var$i("index", s, e, t);
                return [
                    t.getTensorArray(a.id).read(r)
                ];
            }
        case "TensorArrayGatherV3":
            {
                const a = $126c3ebbcc6243ba$var$i("tensorArrayId", s, e, t), r = $126c3ebbcc6243ba$var$i("indices", s, e, t), n = $126c3ebbcc6243ba$var$i("dtype", s, e, t);
                return [
                    t.getTensorArray(a.id).gather(r, n)
                ];
            }
        case "TensorArrayScatterV3":
            {
                const a = $126c3ebbcc6243ba$var$i("tensorArrayId", s, e, t), r = $126c3ebbcc6243ba$var$i("indices", s, e, t), n = $126c3ebbcc6243ba$var$i("tensor", s, e, t), u = t.getTensorArray(a.id);
                return u.scatter(r, n), [
                    u.idTensor
                ];
            }
        case "TensorArrayConcatV3":
            {
                const a = $126c3ebbcc6243ba$var$i("tensorArrayId", s, e, t), r = t.getTensorArray(a.id), n = $126c3ebbcc6243ba$var$i("dtype", s, e, t);
                return [
                    r.concat(n)
                ];
            }
        case "TensorArraySplitV3":
            {
                const a = $126c3ebbcc6243ba$var$i("tensorArrayId", s, e, t), r = $126c3ebbcc6243ba$var$i("tensor", s, e, t), n = $126c3ebbcc6243ba$var$i("lengths", s, e, t), u = t.getTensorArray(a.id);
                return u.split(n, r), [
                    u.idTensor
                ];
            }
        case "TensorArraySizeV3":
            {
                const a = $126c3ebbcc6243ba$var$i("tensorArrayId", s, e, t), r = t.getTensorArray(a.id);
                return [
                    (0, $0qVX1.$)(r.size(), "int32")
                ];
            }
        case "TensorArrayCloseV3":
            {
                const a = $126c3ebbcc6243ba$var$i("tensorArrayId", s, e, t), r = t.getTensorArray(a.id);
                return r.clearAndClose(), [
                    r.idTensor
                ];
            }
        case "TensorListSetItem":
            {
                const a = $126c3ebbcc6243ba$var$i("tensorListId", s, e, t), r = $126c3ebbcc6243ba$var$i("index", s, e, t), n = $126c3ebbcc6243ba$var$i("tensor", s, e, t), u = t.getTensorList(a.id);
                return u.setItem(r, n), [
                    u.idTensor
                ];
            }
        case "TensorListGetItem":
            {
                const a = $126c3ebbcc6243ba$var$i("tensorListId", s, e, t), r = $126c3ebbcc6243ba$var$i("index", s, e, t), n = $126c3ebbcc6243ba$var$i("elementShape", s, e, t), u = $126c3ebbcc6243ba$var$i("elementDType", s, e, t);
                return [
                    t.getTensorList(a.id).getItem(r, n, u)
                ];
            }
        case "TensorListScatterV2":
        case "TensorListScatter":
            {
                const a = $126c3ebbcc6243ba$var$i("indices", s, e, t), r = $126c3ebbcc6243ba$var$i("tensor", s, e, t), n = $126c3ebbcc6243ba$var$i("elementShape", s, e, t), u = $126c3ebbcc6243ba$var$i("numElements", s, e, t), o = $126c3ebbcc6243ba$var$Yg(r, a, n, u);
                return t.addTensorList(o), [
                    o.idTensor
                ];
            }
        case "TensorListReserve":
        case "EmptyTensorList":
            {
                const a = $126c3ebbcc6243ba$var$i("elementShape", s, e, t), r = $126c3ebbcc6243ba$var$i("elementDType", s, e, t);
                let n;
                s.op === "TensorListReserve" ? n = "numElements" : n = "maxNumElements";
                const u = $126c3ebbcc6243ba$var$i(n, s, e, t), o = s.op === "TensorListReserve" ? -1 : u, l = $126c3ebbcc6243ba$var$Zg(a, r, u, o);
                return t.addTensorList(l), [
                    l.idTensor
                ];
            }
        case "TensorListGather":
            {
                const a = $126c3ebbcc6243ba$var$i("tensorListId", s, e, t), r = $126c3ebbcc6243ba$var$i("indices", s, e, t), n = $126c3ebbcc6243ba$var$i("elementShape", s, e, t), u = $126c3ebbcc6243ba$var$i("elementDType", s, e, t);
                return [
                    t.getTensorList(a.id).gather(r, u, n)
                ];
            }
        case "TensorListStack":
            {
                const a = $126c3ebbcc6243ba$var$i("tensorListId", s, e, t), r = $126c3ebbcc6243ba$var$i("elementShape", s, e, t), n = $126c3ebbcc6243ba$var$i("elementDType", s, e, t), u = $126c3ebbcc6243ba$var$i("numElements", s, e, t);
                return [
                    t.getTensorList(a.id).stack(r, n, u)
                ];
            }
        case "TensorListFromTensor":
            {
                const a = $126c3ebbcc6243ba$var$i("tensor", s, e, t), r = $126c3ebbcc6243ba$var$i("elementShape", s, e, t), n = $126c3ebbcc6243ba$var$i("elementDType", s, e, t), u = $126c3ebbcc6243ba$var$Xg(a, r, n);
                return t.addTensorList(u), [
                    u.idTensor
                ];
            }
        case "TensorListConcat":
        case "TensorListConcatV2":
            {
                const a = $126c3ebbcc6243ba$var$i("tensorListId", s, e, t), r = t.getTensorList(a.id), n = $126c3ebbcc6243ba$var$i("dtype", s, e, t), u = $126c3ebbcc6243ba$var$i("elementShape", s, e, t);
                return [
                    r.concat(n, u)
                ];
            }
        case "TensorListPushBack":
            {
                const a = $126c3ebbcc6243ba$var$i("tensorListId", s, e, t), r = $126c3ebbcc6243ba$var$i("tensor", s, e, t), n = t.getTensorList(a.id);
                return n.pushBack(r), [
                    n.idTensor
                ];
            }
        case "TensorListPopBack":
            {
                const a = $126c3ebbcc6243ba$var$i("tensorListId", s, e, t), r = $126c3ebbcc6243ba$var$i("elementShape", s, e, t), n = $126c3ebbcc6243ba$var$i("elementDType", s, e, t);
                return [
                    t.getTensorList(a.id).popBack(r, n)
                ];
            }
        case "TensorListSplit":
            {
                const a = $126c3ebbcc6243ba$var$i("tensor", s, e, t), r = $126c3ebbcc6243ba$var$i("elementShape", s, e, t), n = $126c3ebbcc6243ba$var$i("lengths", s, e, t), u = $126c3ebbcc6243ba$var$Mg(a, n, r);
                return t.addTensorList(u), [
                    u.idTensor
                ];
            }
        case "TensorListLength":
            {
                const a = $126c3ebbcc6243ba$var$i("tensorListId", s, e, t), r = t.getTensorList(a.id);
                return [
                    (0, $0qVX1.$)(r.size(), "int32")
                ];
            }
        case "TensorListResize":
            {
                const a = $126c3ebbcc6243ba$var$i("tensorListId", s, e, t), r = $126c3ebbcc6243ba$var$i("size", s, e, t), u = t.getTensorList(a.id).resize(r);
                return t.addTensorList(u), [
                    u.idTensor
                ];
            }
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Wt(s, e, t) {
    const [a, r] = $126c3ebbcc6243ba$var$i("fusedOps", s, e, t), n = a === "biasadd", u = !n, o = r === "prelu", l = a === "fusedbatchnorm", p = $126c3ebbcc6243ba$var$i("numArgs", s, e, t);
    if (n) {
        if (o && p !== 2) throw new Error("FusedConv2d and DepthwiseConv2d with BiasAdd and Prelu must have two extra arguments: bias and alpha.");
        if (!o && n && p !== 1) throw new Error("FusedConv2d and DepthwiseConv2d with BiasAdd must have one extra argument: bias.");
    }
    if (l) throw new Error("FusedConv2d and DepthwiseConv2d with FusedBatchNorm is not supported");
    const m = $126c3ebbcc6243ba$var$i("strides", s, e, t), c = $126c3ebbcc6243ba$var$we(s, e, t), d = $126c3ebbcc6243ba$var$i("dataFormat", s, e, t).toUpperCase(), h = $126c3ebbcc6243ba$var$i("dilations", s, e, t);
    let [N, g] = $126c3ebbcc6243ba$var$i("args", s, e, t);
    u && (g = N, N = void 0);
    const f = $126c3ebbcc6243ba$var$i("leakyreluAlpha", s, e, t);
    return {
        stride: m,
        pad: c,
        dataFormat: d,
        dilations: h,
        biasArg: N,
        preluArg: g,
        activationFunc: r,
        leakyreluAlpha: f
    };
}
const $126c3ebbcc6243ba$var$tb = (s, e, t, a = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "Conv1D":
            {
                const r = $126c3ebbcc6243ba$var$i("stride", s, e, t), n = $126c3ebbcc6243ba$var$i("pad", s, e, t), u = $126c3ebbcc6243ba$var$i("dataFormat", s, e, t).toUpperCase(), o = $126c3ebbcc6243ba$var$i("dilation", s, e, t);
                return [
                    a.conv1d($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("filter", s, e, t), r, n, u, o)
                ];
            }
        case "Conv2D":
            {
                const r = $126c3ebbcc6243ba$var$i("strides", s, e, t), n = $126c3ebbcc6243ba$var$we(s, e, t), u = $126c3ebbcc6243ba$var$i("dataFormat", s, e, t).toUpperCase(), o = $126c3ebbcc6243ba$var$i("dilations", s, e, t);
                return [
                    a.conv2d($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("filter", s, e, t), [
                        r[1],
                        r[2]
                    ], n, u, [
                        o[1],
                        o[2]
                    ])
                ];
            }
        case "_FusedConv2D":
            {
                const { stride: r, pad: n, dataFormat: u, dilations: o, biasArg: l, preluArg: p, activationFunc: m, leakyreluAlpha: c } = $126c3ebbcc6243ba$var$Wt(s, e, t);
                return [
                    a.fused.conv2d({
                        x: $126c3ebbcc6243ba$var$i("x", s, e, t),
                        filter: $126c3ebbcc6243ba$var$i("filter", s, e, t),
                        strides: [
                            r[1],
                            r[2]
                        ],
                        pad: n,
                        dataFormat: u,
                        dilations: [
                            o[1],
                            o[2]
                        ],
                        bias: l,
                        activation: m,
                        preluActivationWeights: p,
                        leakyreluAlpha: c
                    })
                ];
            }
        case "FusedDepthwiseConv2dNative":
            {
                const { stride: r, pad: n, dataFormat: u, dilations: o, biasArg: l, preluArg: p, activationFunc: m, leakyreluAlpha: c } = $126c3ebbcc6243ba$var$Wt(s, e, t);
                return [
                    a.fused.depthwiseConv2d({
                        x: $126c3ebbcc6243ba$var$i("x", s, e, t),
                        filter: $126c3ebbcc6243ba$var$i("filter", s, e, t),
                        strides: [
                            r[1],
                            r[2]
                        ],
                        pad: n,
                        dataFormat: u,
                        dilations: [
                            o[1],
                            o[2]
                        ],
                        bias: l,
                        activation: m,
                        preluActivationWeights: p,
                        leakyreluAlpha: c
                    })
                ];
            }
        case "Conv2DBackpropInput":
        case "Conv2dTranspose":
            {
                const r = $126c3ebbcc6243ba$var$i("outputShape", s, e, t), n = $126c3ebbcc6243ba$var$i("strides", s, e, t), u = $126c3ebbcc6243ba$var$we(s, e, t);
                return [
                    a.conv2dTranspose($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("filter", s, e, t), r, [
                        n[1],
                        n[2]
                    ], u)
                ];
            }
        case "DepthwiseConv2dNative":
        case "DepthwiseConv2d":
            {
                const r = $126c3ebbcc6243ba$var$i("strides", s, e, t), n = $126c3ebbcc6243ba$var$we(s, e, t), u = $126c3ebbcc6243ba$var$i("dilations", s, e, t), o = $126c3ebbcc6243ba$var$i("dataFormat", s, e, t).toUpperCase();
                return [
                    a.depthwiseConv2d($126c3ebbcc6243ba$var$i("input", s, e, t), $126c3ebbcc6243ba$var$i("filter", s, e, t), [
                        r[1],
                        r[2]
                    ], n, o, [
                        u[1],
                        u[2]
                    ])
                ];
            }
        case "Conv3D":
            {
                const r = $126c3ebbcc6243ba$var$i("strides", s, e, t), n = $126c3ebbcc6243ba$var$i("pad", s, e, t), u = $126c3ebbcc6243ba$var$i("dataFormat", s, e, t).toUpperCase(), o = $126c3ebbcc6243ba$var$i("dilations", s, e, t);
                return [
                    a.conv3d($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("filter", s, e, t), [
                        r[1],
                        r[2],
                        r[3]
                    ], n, u, [
                        o[1],
                        o[2],
                        o[3]
                    ])
                ];
            }
        case "AvgPool":
            {
                const r = $126c3ebbcc6243ba$var$i("strides", s, e, t), n = $126c3ebbcc6243ba$var$i("pad", s, e, t), u = $126c3ebbcc6243ba$var$i("kernelSize", s, e, t);
                return [
                    a.avgPool($126c3ebbcc6243ba$var$i("x", s, e, t), [
                        u[1],
                        u[2]
                    ], [
                        r[1],
                        r[2]
                    ], n)
                ];
            }
        case "MaxPool":
            {
                const r = $126c3ebbcc6243ba$var$i("strides", s, e, t), n = $126c3ebbcc6243ba$var$i("pad", s, e, t), u = $126c3ebbcc6243ba$var$i("kernelSize", s, e, t);
                return [
                    a.maxPool($126c3ebbcc6243ba$var$i("x", s, e, t), [
                        u[1],
                        u[2]
                    ], [
                        r[1],
                        r[2]
                    ], n)
                ];
            }
        case "MaxPoolWithArgmax":
            {
                const r = $126c3ebbcc6243ba$var$i("strides", s, e, t), n = $126c3ebbcc6243ba$var$i("pad", s, e, t), u = $126c3ebbcc6243ba$var$i("kernelSize", s, e, t), o = $126c3ebbcc6243ba$var$i("includeBatchInIndex", s, e, t), { result: l, indexes: p } = a.maxPoolWithArgmax($126c3ebbcc6243ba$var$i("x", s, e, t), [
                    u[1],
                    u[2]
                ], [
                    r[1],
                    r[2]
                ], n, o);
                return [
                    l,
                    p
                ];
            }
        case "AvgPool3D":
            {
                const r = $126c3ebbcc6243ba$var$i("strides", s, e, t), n = $126c3ebbcc6243ba$var$i("pad", s, e, t), u = $126c3ebbcc6243ba$var$i("kernelSize", s, e, t);
                return [
                    a.avgPool3d($126c3ebbcc6243ba$var$i("x", s, e, t), [
                        u[1],
                        u[2],
                        u[3]
                    ], [
                        r[1],
                        r[2],
                        r[3]
                    ], n)
                ];
            }
        case "MaxPool3D":
            {
                const r = $126c3ebbcc6243ba$var$i("strides", s, e, t), n = $126c3ebbcc6243ba$var$i("pad", s, e, t), u = $126c3ebbcc6243ba$var$i("kernelSize", s, e, t);
                return [
                    a.maxPool3d($126c3ebbcc6243ba$var$i("x", s, e, t), [
                        u[1],
                        u[2],
                        u[3]
                    ], [
                        r[1],
                        r[2],
                        r[3]
                    ], n)
                ];
            }
        case "Dilation2D":
            {
                const r = $126c3ebbcc6243ba$var$i("strides", s, e, t), n = $126c3ebbcc6243ba$var$i("pad", s, e, t), u = $126c3ebbcc6243ba$var$i("dilations", s, e, t), o = r[1], l = r[2], p = u[1], m = u[2];
                return [
                    a.dilation2d($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("filter", s, e, t), [
                        o,
                        l
                    ], n, [
                        p,
                        m
                    ], "NHWC")
                ];
            }
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$sb = (s, e, t, a = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "Fill":
            {
                const r = $126c3ebbcc6243ba$var$i("shape", s, e, t), n = $126c3ebbcc6243ba$var$i("dtype", s, e, t), u = $126c3ebbcc6243ba$var$i("value", s, e, t);
                return [
                    a.fill(r, u, n)
                ];
            }
        case "LinSpace":
            {
                const r = $126c3ebbcc6243ba$var$i("start", s, e, t), n = $126c3ebbcc6243ba$var$i("stop", s, e, t), u = $126c3ebbcc6243ba$var$i("num", s, e, t);
                return [
                    a.linspace(r, n, u)
                ];
            }
        case "Multinomial":
            {
                const r = $126c3ebbcc6243ba$var$i("logits", s, e, t), n = $126c3ebbcc6243ba$var$i("numSamples", s, e, t), u = $126c3ebbcc6243ba$var$i("seed", s, e, t);
                return [
                    a.multinomial(r, n, u)
                ];
            }
        case "OneHot":
            {
                const r = $126c3ebbcc6243ba$var$i("indices", s, e, t), n = $126c3ebbcc6243ba$var$i("depth", s, e, t), u = $126c3ebbcc6243ba$var$i("onValue", s, e, t), o = $126c3ebbcc6243ba$var$i("offValue", s, e, t), l = $126c3ebbcc6243ba$var$i("dtype", s, e, t);
                return [
                    a.oneHot(r, n, u, o, l)
                ];
            }
        case "Ones":
            return [
                a.ones($126c3ebbcc6243ba$var$i("shape", s, e, t), $126c3ebbcc6243ba$var$i("dtype", s, e, t))
            ];
        case "OnesLike":
            return [
                a.onesLike($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "RandomStandardNormal":
            return [
                a.randomStandardNormal($126c3ebbcc6243ba$var$i("shape", s, e, t), $126c3ebbcc6243ba$var$i("dtype", s, e, t), $126c3ebbcc6243ba$var$i("seed", s, e, t))
            ];
        case "RandomUniform":
            return [
                a.randomUniform(// tslint:disable-next-line:no-any
                $126c3ebbcc6243ba$var$i("shape", s, e, t), $126c3ebbcc6243ba$var$i("minval", s, e, t), $126c3ebbcc6243ba$var$i("maxval", s, e, t), $126c3ebbcc6243ba$var$i("dtype", s, e, t))
            ];
        case "RandomUniformInt":
            return [
                a.randomUniformInt($126c3ebbcc6243ba$var$i("shape", s, e, t), $126c3ebbcc6243ba$var$i("minval", s, e, t), $126c3ebbcc6243ba$var$i("maxval", s, e, t), $126c3ebbcc6243ba$var$i("seed", s, e, t))
            ];
        case "Range":
            {
                const r = $126c3ebbcc6243ba$var$i("start", s, e, t), n = $126c3ebbcc6243ba$var$i("stop", s, e, t), u = $126c3ebbcc6243ba$var$i("step", s, e, t);
                return [
                    a.range(r, n, u, $126c3ebbcc6243ba$var$i("dtype", s, e, t))
                ];
            }
        case "TruncatedNormal":
            {
                const r = $126c3ebbcc6243ba$var$i("shape", s, e, t), n = $126c3ebbcc6243ba$var$i("mean", s, e, t), u = $126c3ebbcc6243ba$var$i("stdDev", s, e, t), o = $126c3ebbcc6243ba$var$i("seed", s, e, t);
                return [
                    a.truncatedNormal(r, n, u, $126c3ebbcc6243ba$var$i("dtype", s, e, t), o)
                ];
            }
        case "Zeros":
            return [
                a.zeros($126c3ebbcc6243ba$var$i("shape", s, e, t), $126c3ebbcc6243ba$var$i("dtype", s, e, t))
            ];
        case "ZerosLike":
            return [
                a.zerosLike($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Le(s, e, t) {
    const a = $126c3ebbcc6243ba$var$i("boxes", s, e, t), r = $126c3ebbcc6243ba$var$i("scores", s, e, t), n = $126c3ebbcc6243ba$var$i("maxOutputSize", s, e, t), u = $126c3ebbcc6243ba$var$i("iouThreshold", s, e, t), o = $126c3ebbcc6243ba$var$i("scoreThreshold", s, e, t), l = $126c3ebbcc6243ba$var$i("softNmsSigma", s, e, t);
    return {
        boxes: a,
        scores: r,
        maxOutputSize: n,
        iouThreshold: u,
        scoreThreshold: o,
        softNmsSigma: l
    };
}
const $126c3ebbcc6243ba$var$ab = async (s, e, t, a, r = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "NonMaxSuppressionV5":
            {
                const { boxes: n, scores: u, maxOutputSize: o, iouThreshold: l, scoreThreshold: p, softNmsSigma: m } = $126c3ebbcc6243ba$var$Le(s, e, t), c = await r.image.nonMaxSuppressionWithScoreAsync(n, u, o, l, p, m);
                return [
                    c.selectedIndices,
                    c.selectedScores
                ];
            }
        case "NonMaxSuppressionV4":
            {
                const { boxes: n, scores: u, maxOutputSize: o, iouThreshold: l, scoreThreshold: p } = $126c3ebbcc6243ba$var$Le(s, e, t), m = $126c3ebbcc6243ba$var$i("padToMaxOutputSize", s, e, t), c = await r.image.nonMaxSuppressionPaddedAsync(n, u, o, l, p, m);
                return [
                    c.selectedIndices,
                    c.validOutputs
                ];
            }
        case "NonMaxSuppressionV3":
        case "NonMaxSuppressionV2":
            {
                const { boxes: n, scores: u, maxOutputSize: o, iouThreshold: l, scoreThreshold: p } = $126c3ebbcc6243ba$var$Le(s, e, t);
                return [
                    await r.image.nonMaxSuppressionAsync(n, u, o, l, p)
                ];
            }
        case "Where":
            {
                const n = r.cast($126c3ebbcc6243ba$var$i("condition", s, e, t), "bool"), u = [
                    await r.whereAsync(n)
                ];
                return n.dispose(), u;
            }
        case "ListDiff":
            return r.setdiff1dAsync($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("y", s, e, t));
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$rb = (s, e, t, a = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "LowerBound":
            {
                const r = $126c3ebbcc6243ba$var$i("sortedSequence", s, e, t), n = $126c3ebbcc6243ba$var$i("values", s, e, t);
                return [
                    a.lowerBound(r, n)
                ];
            }
        case "TopKV2":
            {
                const r = $126c3ebbcc6243ba$var$i("x", s, e, t), n = $126c3ebbcc6243ba$var$i("k", s, e, t), u = $126c3ebbcc6243ba$var$i("sorted", s, e, t), o = a.topk(r, n, u);
                return [
                    o.values,
                    o.indices
                ];
            }
        case "UpperBound":
            {
                const r = $126c3ebbcc6243ba$var$i("sortedSequence", s, e, t), n = $126c3ebbcc6243ba$var$i("values", s, e, t);
                return [
                    a.upperBound(r, n)
                ];
            }
        case "Unique":
            {
                const r = $126c3ebbcc6243ba$var$i("x", s, e, t), n = a.unique(r);
                return [
                    n.values,
                    n.indices
                ];
            }
        case "UniqueV2":
            {
                const r = $126c3ebbcc6243ba$var$i("x", s, e, t), n = $126c3ebbcc6243ba$var$i("axis", s, e, t), u = a.unique(r, n);
                return [
                    u.values,
                    u.indices
                ];
            }
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$nb = (s, e, t, a = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "Const":
            return e[s.name];
        case "PlaceholderWithDefault":
            const r = $126c3ebbcc6243ba$var$i("default", s, e, t);
            return [
                $126c3ebbcc6243ba$var$E(s.name, e, t) || r
            ];
        case "Placeholder":
            return [
                $126c3ebbcc6243ba$var$E(s.name, e, t)
            ];
        case "Identity":
        case "StopGradient":
        case "FakeQuantWithMinMaxVars":
            {
                const m = $126c3ebbcc6243ba$var$i("x", s, e, t);
                return [
                    $126c3ebbcc6243ba$var$H(m)
                ];
            }
        case "IdentityN":
            return $126c3ebbcc6243ba$var$i("x", s, e, t).map((m)=>$126c3ebbcc6243ba$var$H(m));
        case "Snapshot":
            const n = $126c3ebbcc6243ba$var$i("x", s, e, t);
            return [
                $126c3ebbcc6243ba$var$H(n)
            ];
        case "Shape":
            return [
                a.tensor1d($126c3ebbcc6243ba$var$i("x", s, e, t).shape, "int32")
            ];
        case "ShapeN":
            return $126c3ebbcc6243ba$var$i("x", s, e, t).map((m)=>a.tensor1d(m.shape));
        case "Size":
            return [
                a.scalar($126c3ebbcc6243ba$var$i("x", s, e, t).size, "int32")
            ];
        case "Rank":
            return [
                a.scalar($126c3ebbcc6243ba$var$i("x", s, e, t).rank, "int32")
            ];
        case "NoOp":
            return [
                a.scalar(1)
            ];
        case "Print":
            const u = $126c3ebbcc6243ba$var$i("x", s, e, t), o = $126c3ebbcc6243ba$var$i("data", s, e, t), l = $126c3ebbcc6243ba$var$i("message", s, e, t), p = $126c3ebbcc6243ba$var$i("summarize", s, e, t);
            console.warn("The graph has a tf.print() operation,usually used for debugging, which slows down performance."), console.log(l);
            for(let m = 0; m < o.length; m++)console.log(Array.prototype.slice.call(o[m].dataSync()).slice(0, p));
            return [
                u
            ];
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $126c3ebbcc6243ba$var$ib {
    get id() {
        return this.handle.id;
    }
    /**
   * Constructor of HashTable. Creates a hash table.
   *
   * @param keyDType `dtype` of the table keys.
   * @param valueDType `dtype` of the table values.
   */ constructor(e, t){
        this.keyDType = e, this.valueDType = t, this.handle = (0, $0qVX1.$)(0), this.tensorMap = /* @__PURE__ */ new Map(), (0, $0qVX1.eZ)(this.handle);
    }
    /**
   * Dispose the tensors and handle and clear the hashtable.
   */ clearAndClose() {
        this.tensorMap.forEach((e)=>e.dispose()), this.tensorMap.clear(), this.handle.dispose();
    }
    /**
   * The number of items in the hash table.
   */ size() {
        return this.tensorMap.size;
    }
    /**
   * The number of items in the hash table as a rank-0 tensor.
   */ tensorSize() {
        return (0, $0qVX1.$)(this.size(), "int32");
    }
    /**
   * Replaces the contents of the table with the specified keys and values.
   * @param keys Keys to store in the hashtable.
   * @param values Values to store in the hashtable.
   */ async import(e, t) {
        this.checkKeyAndValueTensor(e, t);
        const a = await e.data();
        return this.tensorMap.forEach((r)=>r.dispose()), this.tensorMap.clear(), (0, $0qVX1.e_)(()=>{
            const r = (0, $0qVX1.eU)(t), n = a.length, u = r.length;
            (0, $0qVX1.b)(n === u, ()=>`The number of elements doesn't match, keys has ${n} elements, the values has ${u} elements.`);
            for(let o = 0; o < n; o++){
                const l = a[o], p = r[o];
                (0, $0qVX1.eZ)(p), this.tensorMap.set(l, p);
            }
            return this.handle;
        });
    }
    /**
   * Looks up keys in a hash table, outputs the corresponding values.
   *
   * Performs batch lookups, for every element in the key tensor, `find`
   * stacks the corresponding value into the return tensor.
   *
   * If an element is not present in the table, the given `defaultValue` is
   * used.
   *
   * @param keys Keys to look up. Must have the same type as the keys of the
   *     table.
   * @param defaultValue The scalar `defaultValue` is the value output for keys
   *     not present in the table. It must also be of the same type as the
   *     table values.
   */ async find(e, t) {
        this.checkKeyAndValueTensor(e, t);
        const a = await e.data();
        return (0, $0qVX1.e_)(()=>{
            const r = [];
            for(let n = 0; n < a.length; n++){
                const u = a[n], o = this.findWithDefault(u, t);
                r.push(o);
            }
            return (0, $0qVX1.eG)(r);
        });
    }
    // tslint:disable-next-line: no-any
    findWithDefault(e, t) {
        const a = this.tensorMap.get(e);
        return a ?? t;
    }
    checkKeyAndValueTensor(e, t) {
        if (e.dtype !== this.keyDType) throw new Error(`Expect key dtype ${this.keyDType}, but got ${e.dtype}`);
        if (t.dtype !== this.valueDType) throw new Error(`Expect value dtype ${this.valueDType}, but got ${t.dtype}`);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$ob = async (s, e, t, a)=>{
    switch(s.op){
        case "HashTable":
        case "HashTableV2":
            {
                const r = a.getHashTableHandleByName(s.name);
                if (r != null) return [
                    r
                ];
                {
                    const n = $126c3ebbcc6243ba$var$i("keyDType", s, e, t), u = $126c3ebbcc6243ba$var$i("valueDType", s, e, t), o = new $126c3ebbcc6243ba$var$ib(n, u);
                    return a.addHashTable(s.name, o), [
                        o.handle
                    ];
                }
            }
        case "InitializeTable":
        case "InitializeTableV2":
        case "LookupTableImport":
        case "LookupTableImportV2":
            {
                const r = $126c3ebbcc6243ba$var$i("tableHandle", s, e, t, a), n = $126c3ebbcc6243ba$var$i("keys", s, e, t), u = $126c3ebbcc6243ba$var$i("values", s, e, t);
                return [
                    await a.getHashTableById(r.id).import(n, u)
                ];
            }
        case "LookupTableFind":
        case "LookupTableFindV2":
            {
                const r = $126c3ebbcc6243ba$var$i("tableHandle", s, e, t, a), n = $126c3ebbcc6243ba$var$i("keys", s, e, t), u = $126c3ebbcc6243ba$var$i("defaultValue", s, e, t);
                return [
                    await a.getHashTableById(r.id).find(n, u)
                ];
            }
        case "LookupTableSize":
        case "LookupTableSizeV2":
            {
                const r = $126c3ebbcc6243ba$var$i("tableHandle", s, e, t, a);
                return [
                    a.getHashTableById(r.id).tensorSize()
                ];
            }
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$ub = (s, e, t, a = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "ResizeBilinear":
            {
                const r = $126c3ebbcc6243ba$var$i("images", s, e, t), n = $126c3ebbcc6243ba$var$i("size", s, e, t), u = $126c3ebbcc6243ba$var$i("alignCorners", s, e, t), o = $126c3ebbcc6243ba$var$i("halfPixelCenters", s, e, t);
                return [
                    a.image.resizeBilinear(r, [
                        n[0],
                        n[1]
                    ], u, o)
                ];
            }
        case "ResizeNearestNeighbor":
            {
                const r = $126c3ebbcc6243ba$var$i("images", s, e, t), n = $126c3ebbcc6243ba$var$i("size", s, e, t), u = $126c3ebbcc6243ba$var$i("alignCorners", s, e, t), o = $126c3ebbcc6243ba$var$i("halfPixelCenters", s, e, t);
                return [
                    a.image.resizeNearestNeighbor(r, [
                        n[0],
                        n[1]
                    ], u, o)
                ];
            }
        case "CropAndResize":
            {
                const r = $126c3ebbcc6243ba$var$i("image", s, e, t), n = $126c3ebbcc6243ba$var$i("boxes", s, e, t), u = $126c3ebbcc6243ba$var$i("boxInd", s, e, t), o = $126c3ebbcc6243ba$var$i("cropSize", s, e, t), l = $126c3ebbcc6243ba$var$i("method", s, e, t), p = $126c3ebbcc6243ba$var$i("extrapolationValue", s, e, t);
                return [
                    a.image.cropAndResize(r, n, u, o, l, p)
                ];
            }
        case "ImageProjectiveTransformV3":
            {
                const r = $126c3ebbcc6243ba$var$i("images", s, e, t), n = $126c3ebbcc6243ba$var$i("transforms", s, e, t), u = $126c3ebbcc6243ba$var$i("outputShape", s, e, t), o = $126c3ebbcc6243ba$var$i("fillValue", s, e, t), l = $126c3ebbcc6243ba$var$i("interpolation", s, e, t), p = $126c3ebbcc6243ba$var$i("fillMode", s, e, t);
                return [
                    a.image.transform(r, n, l.toLowerCase(), p.toLowerCase(), o, u)
                ];
            }
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$lb = (s, e, t, a = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "Equal":
            return [
                a.equal($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "NotEqual":
            return [
                a.notEqual($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "Greater":
            return [
                a.greater($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "GreaterEqual":
            return [
                a.greaterEqual($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "Less":
            return [
                a.less($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "LessEqual":
            return [
                a.lessEqual($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "LogicalAnd":
            return [
                a.logicalAnd($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "LogicalNot":
            return [
                a.logicalNot($126c3ebbcc6243ba$var$i("a", s, e, t))
            ];
        case "LogicalOr":
            return [
                a.logicalOr($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "Select":
        case "SelectV2":
            return [
                a.where($126c3ebbcc6243ba$var$i("condition", s, e, t), $126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        case "BitwiseAnd":
            return [
                a.bitwiseAnd($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t))
            ];
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$pb = (s, e, t, a = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "BatchMatMul":
        case "BatchMatMulV2":
        case "MatMul":
            return [
                a.matMul($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("b", s, e, t), $126c3ebbcc6243ba$var$i("transposeA", s, e, t), $126c3ebbcc6243ba$var$i("transposeB", s, e, t))
            ];
        case "Einsum":
            return [
                a.einsum($126c3ebbcc6243ba$var$i("equation", s, e, t), ...$126c3ebbcc6243ba$var$i("tensors", s, e, t))
            ];
        case "Transpose":
            return [
                a.transpose($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("perm", s, e, t))
            ];
        case "_FusedMatMul":
            const [r, n] = $126c3ebbcc6243ba$var$i("fusedOps", s, e, t), u = r === "biasadd", o = n === "prelu", l = $126c3ebbcc6243ba$var$i("numArgs", s, e, t), p = $126c3ebbcc6243ba$var$i("leakyreluAlpha", s, e, t);
            if (u) {
                if (o && l !== 2) throw new Error("Fused MatMul with BiasAdd and Prelu must have two extra arguments: bias and alpha.");
                if (!o && l !== 1) throw new Error("Fused MatMul with BiasAdd must have one extra argument: bias.");
            }
            const [m, c] = $126c3ebbcc6243ba$var$i("args", s, e, t);
            return [
                a.fused.matMul({
                    a: $126c3ebbcc6243ba$var$i("a", s, e, t),
                    b: $126c3ebbcc6243ba$var$i("b", s, e, t),
                    transposeA: $126c3ebbcc6243ba$var$i("transposeA", s, e, t),
                    transposeB: $126c3ebbcc6243ba$var$i("transposeB", s, e, t),
                    bias: m,
                    activation: n,
                    preluActivationWeights: c,
                    leakyreluAlpha: p
                })
            ];
        case "MatrixBandPart":
            return [
                a.linalg.bandPart($126c3ebbcc6243ba$var$i("a", s, e, t), $126c3ebbcc6243ba$var$i("numLower", s, e, t), $126c3ebbcc6243ba$var$i("numUpper", s, e, t))
            ];
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$mb = (s, e, t, a = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "EuclideanNorm":
            return [
                a.euclideanNorm($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("axis", s, e, t), $126c3ebbcc6243ba$var$i("keepDims", s, e, t))
            ];
        case "FusedBatchNorm":
        case "FusedBatchNormV2":
            return [
                a.batchNorm($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("mean", s, e, t), $126c3ebbcc6243ba$var$i("variance", s, e, t), $126c3ebbcc6243ba$var$i("offset", s, e, t), $126c3ebbcc6243ba$var$i("scale", s, e, t), $126c3ebbcc6243ba$var$i("epsilon", s, e, t))
            ];
        case "FusedBatchNormV3":
            return [
                a.batchNorm($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("mean", s, e, t), $126c3ebbcc6243ba$var$i("variance", s, e, t), $126c3ebbcc6243ba$var$i("offset", s, e, t), $126c3ebbcc6243ba$var$i("scale", s, e, t), $126c3ebbcc6243ba$var$i("epsilon", s, e, t))
            ];
        case "LRN":
            return [
                a.localResponseNormalization($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("radius", s, e, t), $126c3ebbcc6243ba$var$i("bias", s, e, t), $126c3ebbcc6243ba$var$i("alpha", s, e, t), $126c3ebbcc6243ba$var$i("beta", s, e, t))
            ];
        case "Softmax":
            return [
                a.softmax($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "LogSoftmax":
            return [
                a.logSoftmax($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$cb = (s, e, t, a = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "RaggedGather":
            {
                const { outputNestedSplits: r, outputDenseValues: n } = a.raggedGather($126c3ebbcc6243ba$var$i("paramsNestedSplits", s, e, t), $126c3ebbcc6243ba$var$i("paramsDenseValues", s, e, t), $126c3ebbcc6243ba$var$i("indices", s, e, t), $126c3ebbcc6243ba$var$i("outputRaggedRank", s, e, t));
                return r.concat(n);
            }
        case "RaggedRange":
            {
                const { rtNestedSplits: r, rtDenseValues: n } = a.raggedRange($126c3ebbcc6243ba$var$i("starts", s, e, t), $126c3ebbcc6243ba$var$i("limits", s, e, t), $126c3ebbcc6243ba$var$i("splits", s, e, t));
                return [
                    r,
                    n
                ];
            }
        case "RaggedTensorToTensor":
            return [
                a.raggedTensorToTensor($126c3ebbcc6243ba$var$i("shape", s, e, t), $126c3ebbcc6243ba$var$i("values", s, e, t), $126c3ebbcc6243ba$var$i("defaultValue", s, e, t), $126c3ebbcc6243ba$var$i("rowPartitionTensors", s, e, t), $126c3ebbcc6243ba$var$i("rowPartitionTypes", s, e, t))
            ];
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$db = (s, e, t, a = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "Max":
            {
                const o = $126c3ebbcc6243ba$var$i("axis", s, e, t), l = $126c3ebbcc6243ba$var$i("keepDims", s, e, t);
                return [
                    a.max($126c3ebbcc6243ba$var$i("x", s, e, t), o, l)
                ];
            }
        case "Mean":
            {
                const o = $126c3ebbcc6243ba$var$i("axis", s, e, t), l = $126c3ebbcc6243ba$var$i("keepDims", s, e, t);
                return [
                    a.mean($126c3ebbcc6243ba$var$i("x", s, e, t), o, l)
                ];
            }
        case "Min":
            {
                const o = $126c3ebbcc6243ba$var$i("axis", s, e, t), l = $126c3ebbcc6243ba$var$i("keepDims", s, e, t);
                return [
                    a.min($126c3ebbcc6243ba$var$i("x", s, e, t), o, l)
                ];
            }
        case "Sum":
            {
                const o = $126c3ebbcc6243ba$var$i("axis", s, e, t), l = $126c3ebbcc6243ba$var$i("keepDims", s, e, t);
                return [
                    a.sum($126c3ebbcc6243ba$var$i("x", s, e, t), o, l)
                ];
            }
        case "All":
            {
                const o = $126c3ebbcc6243ba$var$i("axis", s, e, t), l = $126c3ebbcc6243ba$var$i("keepDims", s, e, t);
                return [
                    a.all($126c3ebbcc6243ba$var$i("x", s, e, t), o, l)
                ];
            }
        case "Any":
            {
                const o = $126c3ebbcc6243ba$var$i("axis", s, e, t), l = $126c3ebbcc6243ba$var$i("keepDims", s, e, t);
                return [
                    a.any($126c3ebbcc6243ba$var$i("x", s, e, t), o, l)
                ];
            }
        case "ArgMax":
            {
                const o = $126c3ebbcc6243ba$var$i("axis", s, e, t);
                return [
                    a.argMax($126c3ebbcc6243ba$var$i("x", s, e, t), o)
                ];
            }
        case "ArgMin":
            {
                const o = $126c3ebbcc6243ba$var$i("axis", s, e, t);
                return [
                    a.argMin($126c3ebbcc6243ba$var$i("x", s, e, t), o)
                ];
            }
        case "Prod":
            {
                const o = $126c3ebbcc6243ba$var$i("axis", s, e, t), l = $126c3ebbcc6243ba$var$i("keepDims", s, e, t);
                return [
                    a.prod($126c3ebbcc6243ba$var$i("x", s, e, t), o, l)
                ];
            }
        case "Cumprod":
            {
                const o = $126c3ebbcc6243ba$var$i("axis", s, e, t), l = $126c3ebbcc6243ba$var$i("exclusive", s, e, t), p = $126c3ebbcc6243ba$var$i("reverse", s, e, t);
                return [
                    a.cumprod($126c3ebbcc6243ba$var$i("x", s, e, t), o, l, p)
                ];
            }
        case "Cumsum":
            {
                const o = $126c3ebbcc6243ba$var$i("axis", s, e, t), l = $126c3ebbcc6243ba$var$i("exclusive", s, e, t), p = $126c3ebbcc6243ba$var$i("reverse", s, e, t);
                return [
                    a.cumsum($126c3ebbcc6243ba$var$i("x", s, e, t), o, l, p)
                ];
            }
        case "Bincount":
            const r = $126c3ebbcc6243ba$var$i("x", s, e, t), n = $126c3ebbcc6243ba$var$i("weights", s, e, t), u = $126c3ebbcc6243ba$var$i("size", s, e, t);
            return [
                a.bincount(r, n, u)
            ];
        case "DenseBincount":
            {
                const o = $126c3ebbcc6243ba$var$i("x", s, e, t), l = $126c3ebbcc6243ba$var$i("weights", s, e, t), p = $126c3ebbcc6243ba$var$i("size", s, e, t), m = $126c3ebbcc6243ba$var$i("binaryOutput", s, e, t);
                return [
                    a.denseBincount(o, l, p, m)
                ];
            }
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$hb = (s, e, t, a = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "ConcatV2":
        case "Concat":
            {
                const r = $126c3ebbcc6243ba$var$i("n", s, e, t), n = $126c3ebbcc6243ba$var$i("axis", s, e, t);
                let u = $126c3ebbcc6243ba$var$i("tensors", s, e, t);
                return u = u.slice(0, r), [
                    a.concat(u, n)
                ];
            }
        case "Gather":
            {
                const r = $126c3ebbcc6243ba$var$i("x", s, e, t), n = $126c3ebbcc6243ba$var$i("indices", s, e, t);
                return [
                    a.gather(r, a.cast(n, "int32"), 0)
                ];
            }
        case "GatherV2":
            {
                const r = $126c3ebbcc6243ba$var$i("axis", s, e, t), n = $126c3ebbcc6243ba$var$i("batchDims", s, e, t), u = $126c3ebbcc6243ba$var$i("x", s, e, t), o = $126c3ebbcc6243ba$var$i("indices", s, e, t);
                return [
                    a.gather(u, a.cast(o, "int32"), r, n)
                ];
            }
        case "Reverse":
            {
                const r = $126c3ebbcc6243ba$var$i("dims", s, e, t), n = [];
                for(let o = 0; o < r.length; o++)r[o] && n.push(o);
                const u = $126c3ebbcc6243ba$var$i("x", s, e, t);
                return [
                    a.reverse(u, n)
                ];
            }
        case "ReverseV2":
            {
                const r = $126c3ebbcc6243ba$var$i("axis", s, e, t), n = $126c3ebbcc6243ba$var$i("x", s, e, t);
                return [
                    a.reverse(n, r)
                ];
            }
        case "Slice":
            {
                const r = $126c3ebbcc6243ba$var$i("begin", s, e, t), n = $126c3ebbcc6243ba$var$i("size", s, e, t);
                return [
                    a.slice($126c3ebbcc6243ba$var$i("x", s, e, t), r, n)
                ];
            }
        case "StridedSlice":
            {
                const r = $126c3ebbcc6243ba$var$i("begin", s, e, t), n = $126c3ebbcc6243ba$var$i("end", s, e, t), u = $126c3ebbcc6243ba$var$i("strides", s, e, t), o = $126c3ebbcc6243ba$var$i("beginMask", s, e, t), l = $126c3ebbcc6243ba$var$i("endMask", s, e, t), p = $126c3ebbcc6243ba$var$i("ellipsisMask", s, e, t), m = $126c3ebbcc6243ba$var$i("newAxisMask", s, e, t), c = $126c3ebbcc6243ba$var$i("shrinkAxisMask", s, e, t), d = $126c3ebbcc6243ba$var$i("x", s, e, t);
                return [
                    a.stridedSlice(d, r, n, u, o, l, p, m, c)
                ];
            }
        case "Pack":
            return (0, $0qVX1.e_)(()=>{
                const r = $126c3ebbcc6243ba$var$i("axis", s, e, t), n = $126c3ebbcc6243ba$var$i("tensors", s, e, t), u = n[0].shape, o = a.squeeze(n[0]).shape, l = n.map((p)=>{
                    const m = (0, $0qVX1.d)(p.shape, u);
                    if (!m && !(0, $0qVX1.d)(a.squeeze(p).shape, o)) throw new Error("the input tensors shape does not match");
                    return m ? p : a.reshape(p, u);
                });
                return [
                    a.stack(l, r)
                ];
            });
        case "Unpack":
            {
                const r = $126c3ebbcc6243ba$var$i("axis", s, e, t), n = $126c3ebbcc6243ba$var$i("tensor", s, e, t);
                return a.unstack(n, r);
            }
        case "Tile":
            {
                const r = $126c3ebbcc6243ba$var$i("reps", s, e, t);
                return [
                    a.tile($126c3ebbcc6243ba$var$i("x", s, e, t), r)
                ];
            }
        case "Split":
        case "SplitV":
            {
                const r = $126c3ebbcc6243ba$var$i("axis", s, e, t), n = $126c3ebbcc6243ba$var$i("numOrSizeSplits", s, e, t), u = $126c3ebbcc6243ba$var$i("x", s, e, t);
                return a.split(u, n, r);
            }
        case "ScatterNd":
            {
                const r = $126c3ebbcc6243ba$var$i("indices", s, e, t), n = $126c3ebbcc6243ba$var$i("values", s, e, t), u = $126c3ebbcc6243ba$var$i("shape", s, e, t);
                return [
                    a.scatterND(r, n, u)
                ];
            }
        case "GatherNd":
            {
                const r = $126c3ebbcc6243ba$var$i("x", s, e, t), n = $126c3ebbcc6243ba$var$i("indices", s, e, t);
                return [
                    a.gatherND(r, n)
                ];
            }
        case "SparseToDense":
            {
                const r = $126c3ebbcc6243ba$var$i("sparseIndices", s, e, t), n = $126c3ebbcc6243ba$var$i("outputShape", s, e, t), u = $126c3ebbcc6243ba$var$i("sparseValues", s, e, t), o = $126c3ebbcc6243ba$var$i("defaultValue", s, e, t);
                return [
                    a.sparseToDense(r, u, n, u.dtype === o.dtype ? o : a.cast(o, u.dtype))
                ];
            }
        case "TensorScatterUpdate":
            {
                const r = $126c3ebbcc6243ba$var$i("indices", s, e, t), n = $126c3ebbcc6243ba$var$i("values", s, e, t), u = $126c3ebbcc6243ba$var$i("tensor", s, e, t);
                return [
                    a.tensorScatterUpdate(u, r, n)
                ];
            }
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$fb = (s, e, t, a = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "SparseFillEmptyRows":
            {
                const { outputIndices: r, outputValues: n, emptyRowIndicator: u, reverseIndexMap: o } = a.sparse.sparseFillEmptyRows($126c3ebbcc6243ba$var$i("indices", s, e, t), $126c3ebbcc6243ba$var$i("values", s, e, t), $126c3ebbcc6243ba$var$i("denseShape", s, e, t), $126c3ebbcc6243ba$var$i("defaultValue", s, e, t));
                return [
                    r,
                    n,
                    u,
                    o
                ];
            }
        case "SparseReshape":
            {
                const { outputIndices: r, outputShape: n } = a.sparse.sparseReshape($126c3ebbcc6243ba$var$i("inputIndices", s, e, t), $126c3ebbcc6243ba$var$i("inputShape", s, e, t), $126c3ebbcc6243ba$var$i("newShape", s, e, t));
                return [
                    r,
                    n
                ];
            }
        case "SparseSegmentMean":
            return [
                a.sparse.sparseSegmentMean($126c3ebbcc6243ba$var$i("data", s, e, t), $126c3ebbcc6243ba$var$i("indices", s, e, t), $126c3ebbcc6243ba$var$i("segmentIds", s, e, t))
            ];
        case "SparseSegmentSum":
            return [
                a.sparse.sparseSegmentSum($126c3ebbcc6243ba$var$i("data", s, e, t), $126c3ebbcc6243ba$var$i("indices", s, e, t), $126c3ebbcc6243ba$var$i("segmentIds", s, e, t))
            ];
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$yb = (s, e, t, a = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "FFT":
            return [
                a.fft($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "IFFT":
            return [
                a.ifft($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "RFFT":
            return [
                a.rfft($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        case "IRFFT":
            return [
                a.irfft($126c3ebbcc6243ba$var$i("x", s, e, t))
            ];
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$gb = (s, e, t, a = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "StaticRegexReplace":
            return [
                a.string.staticRegexReplace($126c3ebbcc6243ba$var$i("input", s, e, t), $126c3ebbcc6243ba$var$i("pattern", s, e, t), $126c3ebbcc6243ba$var$i("rewrite", s, e, t), $126c3ebbcc6243ba$var$i("replaceGlobal", s, e, t))
            ];
        case "StringNGrams":
            {
                const { nGrams: r, nGramsSplits: n } = a.string.stringNGrams($126c3ebbcc6243ba$var$i("data", s, e, t), $126c3ebbcc6243ba$var$i("dataSplits", s, e, t), $126c3ebbcc6243ba$var$i("separator", s, e, t), $126c3ebbcc6243ba$var$i("nGramWidths", s, e, t), $126c3ebbcc6243ba$var$i("leftPad", s, e, t), $126c3ebbcc6243ba$var$i("rightPad", s, e, t), $126c3ebbcc6243ba$var$i("padWidth", s, e, t), $126c3ebbcc6243ba$var$i("preserveShortSequences", s, e, t));
                return [
                    r,
                    n
                ];
            }
        case "StringSplit":
            {
                const { indices: r, values: n, shape: u } = a.string.stringSplit($126c3ebbcc6243ba$var$i("input", s, e, t), $126c3ebbcc6243ba$var$i("delimiter", s, e, t), $126c3ebbcc6243ba$var$i("skipEmpty", s, e, t));
                return [
                    r,
                    n,
                    u
                ];
            }
        case "StringToHashBucketFast":
            return [
                a.string.stringToHashBucketFast($126c3ebbcc6243ba$var$i("input", s, e, t), $126c3ebbcc6243ba$var$i("numBuckets", s, e, t))
            ];
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$bb = (s, e, t, a = $126c3ebbcc6243ba$var$k)=>{
    switch(s.op){
        case "Cast":
            return [
                a.cast($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("dtype", s, e, t))
            ];
        case "ExpandDims":
            {
                const r = $126c3ebbcc6243ba$var$i("axis", s, e, t);
                return [
                    a.expandDims($126c3ebbcc6243ba$var$i("x", s, e, t), r)
                ];
            }
        case "Squeeze":
            {
                const r = $126c3ebbcc6243ba$var$i("axis", s, e, t);
                return [
                    a.squeeze($126c3ebbcc6243ba$var$i("x", s, e, t), r)
                ];
            }
        case "Reshape":
            return [
                a.reshape($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("shape", s, e, t))
            ];
        case "EnsureShape":
            return [
                a.ensureShape($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("shape", s, e, t))
            ];
        case "MirrorPad":
            return [
                a.mirrorPad($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("padding", s, e, t), $126c3ebbcc6243ba$var$i("mode", s, e, t))
            ];
        case "PadV2":
        case "Pad":
            return [
                a.pad($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("padding", s, e, t), $126c3ebbcc6243ba$var$i("constantValue", s, e, t))
            ];
        case "SpaceToBatchND":
            {
                const r = $126c3ebbcc6243ba$var$i("blockShape", s, e, t), n = $126c3ebbcc6243ba$var$i("paddings", s, e, t);
                return [
                    a.spaceToBatchND($126c3ebbcc6243ba$var$i("x", s, e, t), r, n)
                ];
            }
        case "BatchToSpaceND":
            {
                const r = $126c3ebbcc6243ba$var$i("blockShape", s, e, t), n = $126c3ebbcc6243ba$var$i("crops", s, e, t);
                return [
                    a.batchToSpaceND($126c3ebbcc6243ba$var$i("x", s, e, t), r, n)
                ];
            }
        case "DepthToSpace":
            {
                const r = $126c3ebbcc6243ba$var$i("blockSize", s, e, t), n = $126c3ebbcc6243ba$var$i("dataFormat", s, e, t).toUpperCase();
                return [
                    a.depthToSpace($126c3ebbcc6243ba$var$i("x", s, e, t), r, n)
                ];
            }
        case "BroadcastTo":
            return [
                a.broadcastTo($126c3ebbcc6243ba$var$i("x", s, e, t), $126c3ebbcc6243ba$var$i("shape", s, e, t))
            ];
        case "BroadcastArgs":
            return [
                a.broadcastArgs($126c3ebbcc6243ba$var$i("s0", s, e, t), $126c3ebbcc6243ba$var$i("s1", s, e, t))
            ];
        default:
            throw TypeError(`Node type ${s.op} is not implemented`);
    }
};
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Ut(s, e, t, a, r = (0, $0qVX1.e_)) {
    const n = ((u, o, l)=>{
        switch(u.category){
            case "arithmetic":
                return r(()=>$126c3ebbcc6243ba$var$Kg(u, o, l));
            case "basic_math":
                return r(()=>$126c3ebbcc6243ba$var$Jg(u, o, l));
            case "control":
                return $126c3ebbcc6243ba$var$eb(u, o, l);
            case "convolution":
                return r(()=>$126c3ebbcc6243ba$var$tb(u, o, l));
            case "creation":
                return r(()=>$126c3ebbcc6243ba$var$sb(u, o, l));
            case "dynamic":
                return $126c3ebbcc6243ba$var$ab(u, o, l);
            case "evaluation":
                return r(()=>$126c3ebbcc6243ba$var$rb(u, o, l));
            case "image":
                return r(()=>$126c3ebbcc6243ba$var$ub(u, o, l));
            case "graph":
                return r(()=>$126c3ebbcc6243ba$var$nb(u, o, l));
            case "logical":
                return r(()=>$126c3ebbcc6243ba$var$lb(u, o, l));
            case "matrices":
                return r(()=>$126c3ebbcc6243ba$var$pb(u, o, l));
            case "normalization":
                return r(()=>$126c3ebbcc6243ba$var$mb(u, o, l));
            case "ragged":
                return r(()=>$126c3ebbcc6243ba$var$cb(u, o, l));
            case "reduction":
                return r(()=>$126c3ebbcc6243ba$var$db(u, o, l));
            case "slice_join":
                return r(()=>$126c3ebbcc6243ba$var$hb(u, o, l));
            case "sparse":
                return r(()=>$126c3ebbcc6243ba$var$fb(u, o, l));
            case "spectral":
                return r(()=>$126c3ebbcc6243ba$var$yb(u, o, l));
            case "string":
                return r(()=>$126c3ebbcc6243ba$var$gb(u, o, l));
            case "transformation":
                return r(()=>$126c3ebbcc6243ba$var$bb(u, o, l));
            case "hash_table":
                return $126c3ebbcc6243ba$var$ob(u, o, l, a);
            case "custom":
                const p = $126c3ebbcc6243ba$var$ri(u.op);
                if (p && p.customExecutor) return p.customExecutor(new $126c3ebbcc6243ba$var$Gg(u, o, l));
                throw TypeError(`Custom op ${u.op} is not registered.`);
            default:
                throw TypeError(`Unknown op '${u.op}'. File an issue at https://github.com/tensorflow/tfjs/issues so we can add it, or register a custom execution with tf.registerOp()`);
        }
    })(s, e, t);
    return (0, $0qVX1.e$)(n) ? n.then((u)=>[].concat(u)) : [].concat(n);
}
class $126c3ebbcc6243ba$var$qt {
    constructor(e = {}, t = {}, a = {}, r = {}, n){
        this.weightMap = e, this.tensorArrayMap = t, this.tensorListMap = a, this.functionMap = r, this.parseNodeNameCache = n, this.rootContext = {
            id: 0,
            frameName: "",
            iterationId: 0
        }, this.contexts = [
            this.rootContext
        ], this.lastId = 0, this.generateCurrentContextIds();
    }
    newFrame(e, t) {
        return {
            id: e,
            frameName: t,
            iterationId: 0
        };
    }
    /**
   * Set the current context
   * @param contexts: ExecutionContextInfo[] the current path of execution
   * frames
   */ set currentContext(e) {
        this.contexts !== e && (this.contexts = e, this.generateCurrentContextIds());
    }
    get currentContext() {
        return this.contexts;
    }
    /**
   * Returns the current context in string format.
   */ get currentContextId() {
        return this._currentContextIds[0];
    }
    /**
   * Returns the current context and all parent contexts in string format.
   * This allow access to the nodes in the current and parent frames.
   */ get currentContextIds() {
        return this._currentContextIds;
    }
    generateCurrentContextIds() {
        const e = [];
        for(let t = 0; t < this.contexts.length - 1; t++){
            const a = this.contexts.slice(0, this.contexts.length - t);
            e.push(this.contextIdforContexts(a));
        }
        e.push(""), this._currentContextIds = e;
    }
    contextIdforContexts(e) {
        return e ? e.map((t)=>t.id === 0 && t.iterationId === 0 ? "" : `${t.frameName}-${t.iterationId}`).join("/") : "";
    }
    /**
   * Enter a new frame, a new context is pushed on the current context list.
   * @param frameId new frame id
   */ enterFrame(e) {
        this.contexts && (this.lastId++, this.contexts = this.contexts.slice(), this.contexts.push(this.newFrame(this.lastId, e)), this._currentContextIds.unshift(this.contextIdforContexts(this.contexts)));
    }
    /**
   * Exit the current frame, the last context is removed from the current
   * context list.
   */ exitFrame() {
        if (this.contexts && this.contexts.length > 1) this.contexts = this.contexts.slice(), this.contexts.splice(-1), this.currentContextIds.shift();
        else throw new Error("Cannot exit frame, the context is empty");
    }
    /**
   * Enter the next iteration of a loop, the iteration id of last context is
   * increased.
   */ nextIteration() {
        if (this.contexts && this.contexts.length > 0) {
            this.contexts = this.contexts.slice(), this.lastId++;
            const e = Object.assign({}, this.contexts[this.contexts.length - 1]);
            e.iterationId += 1, e.id = this.lastId, this.contexts.splice(-1, 1, e), this._currentContextIds.splice(0, 1, this.contextIdforContexts(this.contexts));
        } else throw new Error("Cannot increase frame iteration, the context is empty");
    }
    getWeight(e) {
        return this.weightMap[e];
    }
    addTensorArray(e) {
        this.tensorArrayMap[e.id] = e;
    }
    getTensorArray(e) {
        return this.tensorArrayMap[e];
    }
    addTensorList(e) {
        this.tensorListMap[e.id] = e;
    }
    getTensorList(e) {
        return this.tensorListMap[e];
    }
    dispose(e) {
        for(const t in this.tensorArrayMap)this.tensorArrayMap[t].clearAndClose(e);
        for(const t in this.tensorListMap)this.tensorListMap[t].clearAndClose(e);
    }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Gt(s, e, t, a) {
    const r = /* @__PURE__ */ new Set(), n = [];
    let u = null, o = null;
    const l = /* @__PURE__ */ new Set(), p = new Set(Object.keys(s).map((d)=>$126c3ebbcc6243ba$var$$(d)[0]));
    a = a || [];
    const m = new Set(a.map((d)=>$126c3ebbcc6243ba$var$$(d.name)[0])), c = [
        ...e
    ];
    for(; c.length > 0;){
        const d = c.pop();
        if (($126c3ebbcc6243ba$var$G(d) || $126c3ebbcc6243ba$var$Ab(d) || $126c3ebbcc6243ba$var$Eb(d)) && u == null && (u = d, o = u.children.map((h)=>h.name).filter((h)=>r.has(h))), r.add(d.name), t[d.name] == null && !p.has(d.name) && !m.has(d.name)) {
            if (d.inputs.length === 0) {
                n.push(d.name);
                continue;
            }
            d.inputs.forEach((h)=>{
                l.has(h.name) || (l.add(h.name), c.push(h));
            });
        }
    }
    return {
        inputs: s,
        outputs: e,
        usedNodes: r,
        missingInputs: n,
        dynamicNode: u,
        syncInputs: o
    };
}
function $126c3ebbcc6243ba$var$Nb(s, e) {
    const { usedNodes: t, inputs: a } = e, r = Object.keys(a).map((f)=>$126c3ebbcc6243ba$var$$(f)[0]).map((f)=>s.nodes[f]), n = s.initNodes || [], u = (f)=>t.has(typeof f == "string" ? f : f.name);
    function o(f) {
        return [
            ...new Map(f.map((b)=>[
                    b.name,
                    b
                ])).values()
        ];
    }
    const l = o([
        ...r,
        ...s.weights,
        ...n
    ]).filter(u), p = o([
        ...l,
        ...Object.values(s.nodes)
    ]).filter(u), m = new Map(p.map((f)=>[
            f.name,
            f
        ])), c = {};
    for (const f of p){
        c[f.name] = c[f.name] || 0;
        for (const b of f.children)u(b) || (c[b.name] = Number.POSITIVE_INFINITY), c[b.name] = (c[b.name] || 0) + 1;
    }
    const d = Object.entries(c).filter(([, f])=>f === 0).map(([f])=>f), h = [
        ...d
    ];
    for(; d.length > 0;){
        const f = d.pop(), b = m.get(f);
        for (const O of b.children.filter(u))--c[O.name] === 0 && (h.push(O.name), d.push(O.name));
    }
    const N = h.map((f)=>m.get(f)), g = $126c3ebbcc6243ba$var$wb(N, l);
    return $126c3ebbcc6243ba$var$Tb(g, l), g;
}
function $126c3ebbcc6243ba$var$wb(s, e) {
    const t = new Map(s.map((u)=>[
            u.name,
            u
        ])), a = e.map((u)=>u.name), r = new Set(a);
    for(; a.length > 0;){
        const u = a.pop(), o = t.get(u);
        for (const l of o.children)!t.has(l.name) || r.has(l.name) || (r.add(l.name), a.push(l.name));
    }
    return s.filter((u)=>r.has(u.name));
}
class $126c3ebbcc6243ba$var$ge extends Error {
    constructor(e){
        super(`NodesExecutionOrderError: ${e}`);
    }
}
function $126c3ebbcc6243ba$var$Tb(s, e) {
    const t = new Map(s.map((o, l)=>[
            o.name,
            l
        ])), a = new Set(e.map((o)=>o.name)), r = (o)=>a.has(typeof o == "string" ? o : o.name), n = new Set(s.map((o)=>o.name)), u = (o)=>n.has(typeof o == "string" ? o : o.name);
    for (const o of s){
        for (const l of o.children.filter(u)){
            if (!t.has(l.name)) throw new $126c3ebbcc6243ba$var$ge(`Child ${l.name} of node ${o.name} is unreachable.`);
            if (t.get(o.name) > t.get(l.name)) throw new $126c3ebbcc6243ba$var$ge(`Node ${o.name} is scheduled to run after its child ${l.name}.`);
        }
        if (!r(o)) for (const l of o.inputs){
            if (!t.has(l.name)) throw new $126c3ebbcc6243ba$var$ge(`Input ${l.name} of node ${o.name} is unreachable.`);
            if (t.get(l.name) > t.get(o.name)) throw new $126c3ebbcc6243ba$var$ge(`Node ${o.name} is scheduled to run before its input ${l.name}.`);
        }
    }
}
function $126c3ebbcc6243ba$var$Sb(s) {
    const e = new Map(s.map((o, l)=>[
            o.name,
            l
        ])), t = Number.MAX_SAFE_INTEGER, a = s.map((o, l)=>$126c3ebbcc6243ba$var$G(o) ? t : l), r = (o)=>{
        const l = a[e.get(o.name)];
        return l ?? -1;
    }, n = s.map((o, l)=>o.children.map(r).reduce((p, m)=>Math.max(p, m), a[l])), u = /* @__PURE__ */ new Map();
    for(let o = 0; o < s.length; ++o){
        const l = n[o];
        if (l === t) continue;
        const p = s[o], m = s[l];
        u.has(m.name) || u.set(m.name, []), u.get(m.name).push(p);
    }
    return u;
}
const $126c3ebbcc6243ba$var$vb = /* @__PURE__ */ new Set([
    "Switch",
    "Merge",
    "Enter",
    "Exit",
    "NextIteration",
    "StatelessIf",
    "StatelessWhile",
    "if",
    "While"
]), $126c3ebbcc6243ba$var$Ob = /* @__PURE__ */ new Set([
    "NonMaxSuppressionV2",
    "NonMaxSuppressionV3",
    "NonMaxSuppressionV5",
    "Where"
]), $126c3ebbcc6243ba$var$_b = /* @__PURE__ */ new Set([
    "HashTable",
    "HashTableV2",
    "LookupTableImport",
    "LookupTableImportV2",
    "LookupTableFind",
    "LookupTableFindV2",
    "LookupTableSize",
    "LookupTableSizeV2"
]);
function $126c3ebbcc6243ba$var$G(s) {
    return $126c3ebbcc6243ba$var$vb.has(s.op);
}
function $126c3ebbcc6243ba$var$Ab(s) {
    return $126c3ebbcc6243ba$var$Ob.has(s.op);
}
function $126c3ebbcc6243ba$var$Eb(s) {
    return $126c3ebbcc6243ba$var$_b.has(s.op);
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $126c3ebbcc6243ba$var$Ie {
    get weightIds() {
        return this.parent ? this.parent.weightIds : this._weightIds;
    }
    get functionExecutorMap() {
        return this.parent ? this.parent.functionExecutorMap : this._functionExecutorMap;
    }
    get weightMap() {
        return this.parent ? this.parent.weightMap : this._weightMap;
    }
    set weightMap(e) {
        const t = Object.keys(e).map((a)=>e[a].map((r)=>r.id));
        this._weightIds = [].concat(...t), this._weightMap = e;
    }
    /**
   * Set `ResourceManager` shared by executors of a model.
   * @param resourceManager: `ResourceManager` of the `GraphModel`.
   */ set resourceManager(e) {
        this._resourceManager = e;
    }
    get inputs() {
        return this._inputs.map((e)=>({
                name: e.name,
                shape: e.attrParams.shape ? e.attrParams.shape.value : void 0,
                dtype: e.attrParams.dtype ? e.attrParams.dtype.value : void 0
            }));
    }
    get outputs() {
        return this._outputs.map((e)=>({
                name: e.name,
                shape: e.attrParams.shape ? e.attrParams.shape.value : void 0,
                dtype: e.attrParams.dtype ? e.attrParams.dtype.value : void 0
            }));
    }
    get inputNodes() {
        return this._inputs.map((e)=>e.signatureKey || e.name);
    }
    get outputNodes() {
        return this._outputs.map((e)=>{
            const t = e.signatureKey || e.name;
            return e.defaultOutput ? `${t}:${e.defaultOutput}` : t;
        });
    }
    get functions() {
        return Object.keys(this._functions).reduce((e, t)=>(e[t] = this._functions[t].signature, e), {});
    }
    /**
   *
   * @param graph Graph the model or function graph to be executed.
   * @param parent When building function exector you need to set the parent
   * executor. Since the weights and function executor maps are set at parant
   * level, that function executor can access the function maps and weight maps
   * through the parent.
   */ constructor(e, t){
        this.graph = e, this.parent = t, this.compiledMap = /* @__PURE__ */ new Map(), this.parseNodeNameCache = /* @__PURE__ */ new Map(), this._weightMap = {}, this.SEPARATOR = ",", this._functions = {}, this._functionExecutorMap = {}, this.keepIntermediateTensors = !1, this._outputs = e.outputs, this._inputs = e.inputs, this._initNodes = e.initNodes, this._signature = e.signature, this._functions = e.functions, e.functions != null && Object.keys(e.functions).forEach((a)=>{
            this._functionExecutorMap[a] = new $126c3ebbcc6243ba$var$Ie(e.functions[a], this);
        });
    }
    getCompilationKey(e, t) {
        const a = e.map((n)=>n.name).sort(), r = t.map((n)=>n.name).sort();
        return a.join(this.SEPARATOR) + "--" + r.join(this.SEPARATOR);
    }
    /**
   * Compiles the inference graph and returns the minimal set of nodes that are
   * required for execution, in the correct execution order.
   * @returns {Object} compilation The compile result.
   * @returns {Node[]} compilation.orderedNodes Nodes in the correct execution
   *     order.
   * @returns {Map<string, Node[]>} compilation.nodeLiveUntilMap A map from node
   *     to disposable nodes after its execution. That is, for a node `x`,
   *     `nodeLiveUntilMap[x]` indicates all nodes whose intermediate
   *     tensors should be disposed after `x` is executed.
   */ compile(e, t) {
        const a = $126c3ebbcc6243ba$var$Gt(e, t, this.weightMap, this._initNodes), { missingInputs: r, dynamicNode: n, syncInputs: u } = a;
        if (n != null) throw new Error(`This execution contains the node '${n.name}', which has the dynamic op '${n.op}'. Please use model.executeAsync() instead. Alternatively, to avoid the dynamic ops, specify the inputs [${u}]`);
        if (r.length > 0) {
            const p = t.map((c)=>c.name), m = Object.keys(e);
            throw new Error(`Cannot compute the outputs [${p}] from the provided inputs [${m}]. Missing the following inputs: [${r}]`);
        }
        const o = $126c3ebbcc6243ba$var$Nb(this.graph, a), l = $126c3ebbcc6243ba$var$Sb(o);
        return {
            orderedNodes: o,
            nodeLiveUntilMap: l
        };
    }
    cloneAndKeepTensor(e) {
        if (e == null) return null;
        const t = e.clone();
        return (0, $0qVX1.eZ)(t), t;
    }
    cloneTensorList(e) {
        return e ? e.map((a)=>this.cloneAndKeepTensor(a)) : null;
    }
    cloneTensorMap(e) {
        return Object.fromEntries(Object.entries(e).map(([t, a])=>[
                t,
                this.cloneTensorList(a)
            ]));
    }
    /**
   * Executes the inference for given input tensors.
   * @param inputs Tensor map for the model inputs, keyed by the input node
   * names.
   * @param outputs Optional. output node name from the Tensorflow model, if
   * no outputs are specified, the default outputs of the model would be used.
   * You can inspect intermediate nodes of the model by adding them to the
   * outputs array.
   */ execute(e, t) {
        this.disposeIntermediateTensors(), e = this.mapInputs(e);
        const a = Object.keys(e).sort();
        this.checkInputs(e), this.checkInputShapeAndType(e), t = this.mapOutputs(t), this.checkOutputs(t);
        const r = a.map((d)=>this.graph.nodes[$126c3ebbcc6243ba$var$$(d)[0]]), n = t.map((d)=>$126c3ebbcc6243ba$var$$(d)[0]), u = new Set(n);
        let o = n.map((d)=>this.graph.nodes[d]);
        o.length === 0 && (o = this._outputs);
        const l = this.getCompilationKey(r, o);
        let p = this.compiledMap.get(l);
        p == null && (p = this.compile(e, o), this.compiledMap.set(l, p));
        try {
            this.keepIntermediateTensors = (0, $0qVX1.as)().getBool("KEEP_INTERMEDIATE_TENSORS");
        } catch (d) {
            this.keepIntermediateTensors = !1, console.warn(d.message);
        }
        const m = {}, c = {};
        return (0, $0qVX1.e_)(()=>{
            const d = new $126c3ebbcc6243ba$var$qt(this.weightMap, m, c, this.functionExecutorMap, this.parseNodeNameCache), h = Object.assign({}, this.weightMap);
            this.keepIntermediateTensors && (this.clonedTensorsMap = this.cloneTensorMap(this.weightMap)), Object.keys(e).forEach((b)=>{
                const [O, _] = $126c3ebbcc6243ba$var$$(b, d), T = [];
                T[_] = e[b], h[O] = T, this.keepIntermediateTensors && (this.clonedTensorsMap[O] = this.cloneTensorList(T));
            });
            const N = this.getFrozenTensorIds(h), { orderedNodes: g, nodeLiveUntilMap: f } = p;
            for (const b of g){
                if (h[b.name]) continue;
                const O = $126c3ebbcc6243ba$var$Ut(b, h, d, this._resourceManager);
                if ((0, $0qVX1.e$)(O)) throw new Error(`The execution of the op '${b.op}' returned a promise. Please use model.executeAsync() instead.`);
                h[b.name] = O, this.keepIntermediateTensors && (this.clonedTensorsMap[b.name] = this.cloneTensorList(O)), this.checkTensorForDisposalWithNodeLiveUntilInfo(b, h, d, N, u, f.get(b.name));
            }
            return this.parent == null && d.dispose(N), t.map((b)=>$126c3ebbcc6243ba$var$E(b, h, d));
        });
    }
    getFrozenTensorIds(e) {
        const t = [].concat.apply([], Object.keys(e).map((a)=>e[a]).map((a)=>a.map((r)=>r.id)));
        return new Set(t);
    }
    checkTensorForDisposal(e, t, a, r, n, u, o) {
        if (!($126c3ebbcc6243ba$var$G(t) || u.has(e))) {
            for (const l of a[e])l != null && (o[l.id] = (o[l.id] || 0) + t.children.length);
            for (const l of t.inputs){
                if ($126c3ebbcc6243ba$var$G(l)) continue;
                const p = $126c3ebbcc6243ba$var$Rt(l.name, a, r);
                if (p != null) for (const m of p){
                    if (!m || m.kept || n.has(m.id)) continue;
                    const c = o[m.id];
                    c === 1 ? (m.dispose(), delete o[m.id]) : c != null && o[m.id]--;
                }
            }
        }
    }
    checkTensorForDisposalWithNodeLiveUntilInfo(e, t, a, r, n, u) {
        function o(l) {
            return $126c3ebbcc6243ba$var$G(l) || n.has(l.name);
        }
        if (!($126c3ebbcc6243ba$var$G(e) || u == null)) for (const l of u){
            if (o(l)) continue;
            const p = $126c3ebbcc6243ba$var$Rt(l.name, t, a);
            for (const m of p)!m || m.kept || r.has(m.id) || m.dispose();
        }
    }
    /**
   * Executes the inference for given input tensors in Async fashion.
   * @param inputs Tensor map for the model inputs, keyed by the input node
   * names.
   * @param outputs output node name from the Tensorflow model, if no outputs
   * are specified, the default outputs of the model would be used. You can
   * inspect intermediate nodes of the model by adding them to the outputs
   * array.
   */ async executeAsync(e, t) {
        return this._executeAsync(e, t);
    }
    disposeIntermediateTensors() {
        this.clonedTensorsMap && (Object.values(this.clonedTensorsMap).forEach((e)=>{
            for (const t of e)t && !t.isDisposed && t.dispose();
        }), this.clonedTensorsMap = null);
    }
    getIntermediateTensors() {
        return this.clonedTensorsMap;
    }
    /**
   * Executes the inference for given input tensors in Async fashion.
   * @param inputs Tensor map for the model inputs, keyed by the input node
   * names.
   * @param outputs Optional. output node name from the Tensorflow model,
   * if no outputs are specified, the default outputs of the model would be
   * used. You can inspect intermediate nodes of the model by adding them to
   * the outputs array.
   * @param isFunctionExecution Optional. Flag for executing a function.
   * @param tensorArrayMap Optional, global TensorArray map by id. Used for
   * function execution.
   * @param tensorArrayMap Optinal global TensorList map by id. Used for
   * function execution.
   */ async _executeAsync(e, t, a = !1, r = {}, n = {}) {
        this.disposeIntermediateTensors(), a || (e = this.mapInputs(e), this.checkInputs(e), this.checkInputShapeAndType(e), t = this.mapOutputs(t), this.checkOutputs(t));
        try {
            this.keepIntermediateTensors = (0, $0qVX1.as)().getBool("KEEP_INTERMEDIATE_TENSORS");
        } catch (d) {
            this.keepIntermediateTensors = !1, console.warn(d.message);
        }
        const u = new $126c3ebbcc6243ba$var$qt(this.weightMap, r, n, this.functionExecutorMap, this.parseNodeNameCache);
        this.keepIntermediateTensors && (this.clonedTensorsMap = this.cloneTensorMap(this.weightMap));
        const o = await this.executeWithControlFlow(e, u, t, a), l = t.map((d)=>$126c3ebbcc6243ba$var$E(d, o, u)), p = l.map((d)=>d.id), m = Object.keys(e).map((d)=>e[d].id), c = /* @__PURE__ */ new Set([
            ...p,
            ...m,
            ...this.weightIds
        ]);
        return Object.values(o).forEach((d)=>{
            d.forEach((h)=>{
                h && !h.isDisposed && !c.has(h.id) && h.dispose();
            });
        }), this.parent == null && u.dispose(c), l;
    }
    async executeFunctionAsync(e, t, a) {
        const r = e.reduce((n, u, o)=>(n[this.inputs[o].name] = u, n), {});
        return this._executeAsync(r, this.outputNodes, !0, t, a);
    }
    /**
   * When there are control flow nodes in the graph, the graph execution use
   * ExecutionContext to keep track of the frames and loop iterators.
   * @param inputs placeholder tensors for the graph.
   * @param context the execution context object for current execution.
   * @param outputNames Optional. output node name from the Tensorflow model,
   * if no outputs are specified, the default outputs of the model would be
   * used. You can inspect intermediate nodes of the model by adding them to
   * the outputs array.
   * @param isFunctionExecution Flag for executing a function.
   */ async executeWithControlFlow(e, t, a, r) {
        const n = Object.keys(e), u = n.map((T)=>this.graph.nodes[$126c3ebbcc6243ba$var$$(T)[0]]), o = a.map((T)=>$126c3ebbcc6243ba$var$$(T)[0]), l = new Set(o);
        let p = o.map((T)=>this.graph.nodes[T]);
        p.length === 0 && (p = this._outputs);
        const { usedNodes: m, missingInputs: c, dynamicNode: d, syncInputs: h } = $126c3ebbcc6243ba$var$Gt(e, p, this.weightMap, this._initNodes), N = [
            ...u,
            ...this.graph.weights,
            ...this._initNodes || []
        ].map((T)=>({
                node: T,
                contexts: t.currentContext
            })), g = Object.assign({}, this.weightMap);
        Object.keys(e).forEach((T)=>{
            const [I, D] = $126c3ebbcc6243ba$var$$(T), C = [];
            C[D] = e[T], g[I] = C;
        });
        const f = {}, b = this.getFrozenTensorIds(g), O = {};
        for(; N.length > 0;){
            const T = this.processStack(u, N, t, g, O, b, l, f, m);
            await Promise.all(T);
        }
        d == null && !r && console.warn("This model execution did not contain any nodes with control flow or dynamic output shapes. You can use model.execute() instead.");
        const _ = p.filter((T)=>!$126c3ebbcc6243ba$var$G(T) && !$126c3ebbcc6243ba$var$E(T.name, g, t)).map((T)=>T.name);
        if (_.length > 0) {
            let T = "";
            throw d != null && (T = `Alternatively, to avoid the dynamic ops, use model.execute() and specify the inputs [${h}]`), new Error(`Cannot compute the outputs [${_}] from the provided inputs [${n}]. Consider providing the following inputs: [${c}]. ${T}`);
        }
        return g;
    }
    processStack(e, t, a, r, n, u, o, l, p) {
        const m = [];
        for(; t.length > 0;){
            const c = t.pop();
            a.currentContext = c.contexts;
            let d = "";
            if (c.node.op === "Enter" && $126c3ebbcc6243ba$var$i("isConstant", c.node, r, a) && ([d] = $126c3ebbcc6243ba$var$B(c.node.name, a)), r[c.node.name] == null) {
                const h = $126c3ebbcc6243ba$var$Ut(c.node, r, a, this._resourceManager);
                d || ([d] = $126c3ebbcc6243ba$var$B(c.node.name, a));
                const N = a.currentContext;
                (0, $0qVX1.e$)(h) ? m.push(h.then((g)=>(r[d] = g, this.keepIntermediateTensors && (this.clonedTensorsMap[d] = this.cloneTensorList(g)), a.currentContext = N, this.checkTensorForDisposal(d, c.node, r, a, u, o, l), this.processChildNodes(c.node, t, a, r, n, p), g))) : (r[d] = h, this.keepIntermediateTensors && (this.clonedTensorsMap[d] = this.cloneTensorList(h)), this.checkTensorForDisposal(d, c.node, r, a, u, o, l), this.processChildNodes(c.node, t, a, r, n, p));
            } else this.processChildNodes(c.node, t, a, r, n, p);
        }
        return m;
    }
    processChildNodes(e, t, a, r, n, u) {
        e.children.forEach((o)=>{
            const [l] = $126c3ebbcc6243ba$var$B(o.name, a);
            n[l] || !u.has(o.name) || (o.op === "Merge" ? o.inputNames.some((p)=>!!$126c3ebbcc6243ba$var$E(p, r, a)) && (n[l] = !0, t.push({
                contexts: a.currentContext,
                node: o
            })) : o.inputNames.every((p)=>!!$126c3ebbcc6243ba$var$E(p, r, a)) && (n[l] = !0, t.push({
                contexts: a.currentContext,
                node: o
            })));
        });
    }
    /**
   * Releases the memory used by the weight tensors.
   */ dispose() {
        Object.keys(this.weightMap).forEach((e)=>this.weightMap[e].forEach((t)=>t.dispose()));
    }
    checkInputShapeAndType(e) {
        Object.keys(e).forEach((t)=>{
            const a = e[t], [r] = $126c3ebbcc6243ba$var$$(t), n = this.graph.nodes[r];
            if (n.attrParams.shape && n.attrParams.shape.value) {
                const u = n.attrParams.shape.value, o = u.length === a.shape.length && a.shape.every((l, p)=>u[p] === -1 || u[p] === l);
                (0, $0qVX1.b)(o, ()=>`The shape of dict['${n.name}'] provided in model.execute(dict) must be [${u}], but was [${a.shape}]`);
            }
            n.attrParams.dtype && n.attrParams.dtype.value && (0, $0qVX1.b)(a.dtype === n.attrParams.dtype.value, ()=>`The dtype of dict['${n.name}'] provided in model.execute(dict) must be ${n.attrParams.dtype.value}, but was ${a.dtype}`);
        });
    }
    mapInputs(e) {
        var t, a;
        const r = {};
        for(const n in e){
            const u = (a = (t = this._signature) === null || t === void 0 ? void 0 : t.inputs) === null || a === void 0 ? void 0 : a[n];
            u != null ? r[u.name] = e[n] : r[n] = e[n];
        }
        return r;
    }
    checkInputs(e) {
        const t = Object.keys(e).filter((a)=>{
            const [r] = $126c3ebbcc6243ba$var$$(a);
            return this.graph.nodes[r] == null;
        });
        if (t.length > 0) throw new Error(`The dict provided in model.execute(dict) has keys: [${t}] that are not part of graph`);
    }
    mapOutputs(e) {
        return e.map((t)=>{
            var a, r;
            const n = (r = (a = this._signature) === null || a === void 0 ? void 0 : a.outputs) === null || r === void 0 ? void 0 : r[t];
            return n != null ? n.name : t;
        }, {});
    }
    checkOutputs(e) {
        e.forEach((t)=>{
            const [a] = $126c3ebbcc6243ba$var$$(t);
            if (!this.graph.nodes[a]) throw new Error(`The output '${t}' is not found in the graph`);
        });
    }
}
class $126c3ebbcc6243ba$var$kb {
    constructor(e = {}, t = {}){
        this.hashTableNameToHandle = e, this.hashTableMap = t;
    }
    /**
   * Register a `HashTable` in the resource manager.
   *
   * The `HashTable` can be retrieved by `resourceManager.getHashTableById`,
   * where id is the table handle tensor's id.
   *
   * @param name Op node name that creates the `HashTable`.
   * @param hashTable The `HashTable` to be added to resource manager.
   */ addHashTable(e, t) {
        this.hashTableNameToHandle[e] = t.handle, this.hashTableMap[t.id] = t;
    }
    /**
   * Get the table handle by node name.
   * @param name Op node name that creates the `HashTable`. This name is also
   *     used in the inputs list of lookup and import `HashTable` ops.
   */ getHashTableHandleByName(e) {
        return this.hashTableNameToHandle[e];
    }
    /**
   * Get the actual `HashTable` by its handle tensor's id.
   * @param id The id of the handle tensor.
   */ getHashTableById(e) {
        return this.hashTableMap[e];
    }
    /**
   * Dispose `ResourceManager`, including its hashTables and tensors in them.
   */ dispose() {
        for(const e in this.hashTableMap)this.hashTableMap[e].clearAndClose(), delete this.hashTableMap[e];
        for(const e in this.hashTableNameToHandle)this.hashTableNameToHandle[e].dispose(), delete this.hashTableNameToHandle[e];
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Ib = "?tfjs-format=file", $126c3ebbcc6243ba$var$$b = "model.json";
class $126c3ebbcc6243ba$var$Et {
    // Returns the version information for the tensorflow model GraphDef.
    get modelVersion() {
        return this.version;
    }
    get inputNodes() {
        return this.executor.inputNodes;
    }
    get outputNodes() {
        return this.executor.outputNodes;
    }
    get inputs() {
        return this.executor.inputs;
    }
    get outputs() {
        return this.executor.outputs;
    }
    get weights() {
        return this.executor.weightMap;
    }
    get metadata() {
        return this.artifacts.userDefinedMetadata;
    }
    get modelSignature() {
        return this.signature;
    }
    get modelStructuredOutputKeys() {
        return this.structuredOutputKeys;
    }
    /**
   * @param modelUrl url for the model, or an `io.IOHandler`.
   * @param weightManifestUrl url for the weight file generated by
   * scripts/convert.py script.
   * @param requestOption options for Request, which allows to send credentials
   * and custom headers.
   * @param onProgress Optional, progress callback function, fired periodically
   * before the load is completed.
   */ constructor(e, t = {}, a = $126c3ebbcc6243ba$var$Tt){
        this.modelUrl = e, this.loadOptions = t, this.version = "n/a", this.io = a, t == null && (this.loadOptions = {}), this.resourceManager = new $126c3ebbcc6243ba$var$kb();
    }
    findIOHandler() {
        const e = this.modelUrl;
        if (e.load != null) this.handler = e;
        else if (this.loadOptions.requestInit != null) this.handler = this.io.browserHTTPRequest(e, this.loadOptions);
        else {
            const t = this.io.getLoadHandlers(e, this.loadOptions);
            if (t.length === 0) t.push(this.io.browserHTTPRequest(e, this.loadOptions));
            else if (t.length > 1) throw new Error(`Found more than one (${t.length}) load handlers for URL '${[
                e
            ]}'`);
            this.handler = t[0];
        }
    }
    /**
   * Loads the model and weight files, construct the in memory weight map and
   * compile the inference graph.
   */ load() {
        if (this.findIOHandler(), this.handler.load == null) throw new Error("Cannot proceed with model loading because the IOHandler provided does not have the `load` method implemented.");
        const e = this.handler.load();
        return (0, $0qVX1.e$)(e) ? e.then((t)=>t.getWeightStream == null ? this.loadSync(t) : this.loadStreaming(t)) : this.loadSync(e);
    }
    /**
   * Synchronously construct the in memory weight map and
   * compile the inference graph.
   *
   * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
   */ loadSync(e) {
        const t = this.io.decodeWeights(e.weightData, e.weightSpecs);
        return this.loadWithWeightMap(e, t);
    }
    async loadStreaming(e) {
        if (e.getWeightStream == null) throw new Error("Model artifacts missing streamWeights function");
        const t = await (0, $0qVX1.aA)(e.getWeightStream(), e.weightSpecs);
        return this.loadWithWeightMap(e, t);
    }
    loadWithWeightMap(e, t) {
        this.artifacts = e;
        const a = this.artifacts.modelTopology;
        let r = this.artifacts.signature;
        if (this.artifacts.userDefinedMetadata != null) {
            const n = this.artifacts.userDefinedMetadata;
            n.signature != null && (r = n.signature), n.structuredOutputKeys != null && (this.structuredOutputKeys = n.structuredOutputKeys);
        }
        if (this.signature = r, this.version = `${a.versions.producer}.${a.versions.minConsumer}`, this.executor = new $126c3ebbcc6243ba$var$Ie($126c3ebbcc6243ba$var$jt.Instance.transformGraph(a, this.signature)), this.executor.weightMap = this.convertTensorMapToTensorsMap(t), this.executor.resourceManager = this.resourceManager, e.modelInitializer != null && e.modelInitializer.node != null) {
            const n = $126c3ebbcc6243ba$var$jt.Instance.transformGraph(e.modelInitializer);
            this.initializer = new $126c3ebbcc6243ba$var$Ie(n), this.initializer.weightMap = this.executor.weightMap, this.initializer.resourceManager = this.resourceManager, this.initializerSignature = e.initializerSignature;
        }
        return !0;
    }
    /**
   * Save the configuration and/or weights of the GraphModel.
   *
   * An `IOHandler` is an object that has a `save` method of the proper
   * signature defined. The `save` method manages the storing or
   * transmission of serialized data ("artifacts") that represent the
   * model's topology and weights onto or via a specific medium, such as
   * file downloads, local storage, IndexedDB in the web browser and HTTP
   * requests to a server. TensorFlow.js provides `IOHandler`
   * implementations for a number of frequently used saving mediums, such as
   * `tf.io.browserDownloads` and `tf.io.browserLocalStorage`. See `tf.io`
   * for more details.
   *
   * This method also allows you to refer to certain types of `IOHandler`s
   * as URL-like string shortcuts, such as 'localstorage://' and
   * 'indexeddb://'.
   *
   * Example 1: Save `model`'s topology and weights to browser [local
   * storage](https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage);
   * then load it back.
   *
   * ```js
   * const modelUrl =
   *    'https://storage.googleapis.com/tfjs-models/savedmodel/mobilenet_v2_1.0_224/model.json';
   * const model = await tf.loadGraphModel(modelUrl);
   * const zeros = tf.zeros([1, 224, 224, 3]);
   * model.predict(zeros).print();
   *
   * const saveResults = await model.save('localstorage://my-model-1');
   *
   * const loadedModel = await tf.loadGraphModel('localstorage://my-model-1');
   * console.log('Prediction from loaded model:');
   * model.predict(zeros).print();
   * ```
   *
   * @param handlerOrURL An instance of `IOHandler` or a URL-like,
   * scheme-based string shortcut for `IOHandler`.
   * @param config Options for saving the model.
   * @returns A `Promise` of `SaveResult`, which summarizes the result of
   * the saving, such as byte sizes of the saved artifacts for the model's
   *   topology and weight values.
   *
   * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
   */ async save(e, t) {
        if (typeof e == "string") {
            const a = this.io.getSaveHandlers(e);
            if (a.length === 0) throw new Error(`Cannot find any save handlers for URL '${e}'`);
            if (a.length > 1) throw new Error(`Found more than one (${a.length}) save handlers for URL '${e}'`);
            e = a[0];
        }
        if (e.save == null) throw new Error("GraphModel.save() cannot proceed because the IOHandler provided does not have the `save` attribute defined.");
        return e.save(this.artifacts);
    }
    addStructuredOutputNames(e) {
        if (this.structuredOutputKeys) {
            const t = e instanceof (0, $0qVX1.T) ? [
                e
            ] : e, a = {};
            return t.forEach((r, n)=>a[this.structuredOutputKeys[n]] = r), a;
        }
        return e;
    }
    /**
   * Execute the inference for the input tensors.
   *
   * @param input The input tensors, when there is single input for the model,
   * inputs param should be a `tf.Tensor`. For models with mutliple inputs,
   * inputs params should be in either `tf.Tensor`[] if the input order is
   * fixed, or otherwise NamedTensorMap format.
   *
   * For model with multiple inputs, we recommend you use NamedTensorMap as the
   * input type, if you use `tf.Tensor`[], the order of the array needs to
   * follow the
   * order of inputNodes array. @see {@link GraphModel.inputNodes}
   *
   * You can also feed any intermediate nodes using the NamedTensorMap as the
   * input type. For example, given the graph
   *    InputNode => Intermediate => OutputNode,
   * you can execute the subgraph Intermediate => OutputNode by calling
   *    model.execute('IntermediateNode' : tf.tensor(...));
   *
   * This is useful for models that uses tf.dynamic_rnn, where the intermediate
   * state needs to be fed manually.
   *
   * For batch inference execution, the tensors for each input need to be
   * concatenated together. For example with mobilenet, the required input shape
   * is [1, 244, 244, 3], which represents the [batch, height, width, channel].
   * If we are provide a batched data of 100 images, the input tensor should be
   * in the shape of [100, 244, 244, 3].
   *
   * @param config Prediction configuration for specifying the batch size.
   * Currently the batch size option is ignored for graph model.
   *
   * @returns Inference result tensors. If the model is converted and it
   * originally had structured_outputs in tensorflow, then a NamedTensorMap
   * will be returned matching the structured_outputs. If no structured_outputs
   * are present, the output will be single `tf.Tensor` if the model has single
   * output node, otherwise Tensor[].
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ predict(e, t) {
        const a = this.execute(e, this.outputNodes);
        return this.addStructuredOutputNames(a);
    }
    /**
   * Execute the inference for the input tensors in async fashion, use this
   * method when your model contains control flow ops.
   *
   * @param input The input tensors, when there is single input for the model,
   * inputs param should be a `tf.Tensor`. For models with mutliple inputs,
   * inputs params should be in either `tf.Tensor`[] if the input order is
   * fixed, or otherwise NamedTensorMap format.
   *
   * For model with multiple inputs, we recommend you use NamedTensorMap as the
   * input type, if you use `tf.Tensor`[], the order of the array needs to
   * follow the
   * order of inputNodes array. @see {@link GraphModel.inputNodes}
   *
   * You can also feed any intermediate nodes using the NamedTensorMap as the
   * input type. For example, given the graph
   *    InputNode => Intermediate => OutputNode,
   * you can execute the subgraph Intermediate => OutputNode by calling
   *    model.execute('IntermediateNode' : tf.tensor(...));
   *
   * This is useful for models that uses tf.dynamic_rnn, where the intermediate
   * state needs to be fed manually.
   *
   * For batch inference execution, the tensors for each input need to be
   * concatenated together. For example with mobilenet, the required input shape
   * is [1, 244, 244, 3], which represents the [batch, height, width, channel].
   * If we are provide a batched data of 100 images, the input tensor should be
   * in the shape of [100, 244, 244, 3].
   *
   * @param config Prediction configuration for specifying the batch size.
   * Currently the batch size option is ignored for graph model.
   *
   * @returns A Promise of inference result tensors. If the model is converted
   * and it originally had structured_outputs in tensorflow, then a
   * NamedTensorMap will be returned matching the structured_outputs. If no
   * structured_outputs are present, the output will be single `tf.Tensor` if
   * the model has single output node, otherwise Tensor[].
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ async predictAsync(e, t) {
        const a = await this.executeAsync(e, this.outputNodes);
        return this.addStructuredOutputNames(a);
    }
    normalizeInputs(e) {
        var t;
        if (!(e instanceof (0, $0qVX1.T)) && !Array.isArray(e)) {
            const n = (t = this.signature) === null || t === void 0 ? void 0 : t.inputs;
            if (n != null) for(const u in n){
                const o = n[u];
                o.resourceId != null && (e[u] = this.resourceIdToCapturedInput[o.resourceId]);
            }
            return e;
        }
        e = Array.isArray(e) ? e : [
            e
        ];
        const a = Object.keys(this.resourceIdToCapturedInput).length;
        if (e.length + a !== this.inputNodes.length) throw new Error(`Input tensor count mismatch, the graph model has ${this.inputNodes.length - a} non-resource placeholders, while there are ${e.length} input tensors provided.`);
        let r = 0;
        return this.inputNodes.reduce((n, u)=>{
            var o, l, p;
            const m = (p = (l = (o = this.signature) === null || o === void 0 ? void 0 : o.inputs) === null || l === void 0 ? void 0 : l[u]) === null || p === void 0 ? void 0 : p.resourceId;
            return m != null ? n[u] = this.resourceIdToCapturedInput[m] : n[u] = e[r++], n;
        }, {});
    }
    normalizeOutputs(e) {
        return e = e || this.outputNodes, Array.isArray(e) ? e : [
            e
        ];
    }
    executeInitializerGraph() {
        return this.initializer == null ? [] : this.initializerSignature == null ? this.initializer.execute({}, []) : this.initializer.execute({}, Object.keys(this.initializerSignature.outputs));
    }
    async executeInitializerGraphAsync() {
        return this.initializer == null ? [] : this.initializerSignature == null ? this.initializer.executeAsync({}, []) : this.initializer.executeAsync({}, Object.keys(this.initializerSignature.outputs));
    }
    setResourceIdToCapturedInput(e) {
        if (this.resourceIdToCapturedInput = {}, this.initializerSignature) {
            const t = this.initializerSignature.outputs, a = Object.keys(t);
            for(let r = 0; r < a.length; r++){
                const n = a[r], u = t[n];
                this.resourceIdToCapturedInput[u.resourceId] = e[r];
            }
        }
    }
    /**
   * Executes inference for the model for given input tensors.
   * @param inputs tensor, tensor array or tensor map of the inputs for the
   * model, keyed by the input node names.
   * @param outputs output node name from the TensorFlow model, if no
   * outputs are specified, the default outputs of the model would be used.
   * You can inspect intermediate nodes of the model by adding them to the
   * outputs array.
   *
   * @returns A single tensor if provided with a single output or no outputs
   * are provided and there is only one default output, otherwise return a
   * tensor array. The order of the tensor array is the same as the outputs
   * if provided, otherwise the order of outputNodes attribute of the model.
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ execute(e, t) {
        this.resourceIdToCapturedInput == null && this.setResourceIdToCapturedInput(this.executeInitializerGraph()), e = this.normalizeInputs(e), t = this.normalizeOutputs(t);
        const a = this.executor.execute(e, t);
        return a.length > 1 ? a : a[0];
    }
    /**
   * Executes inference for the model for given input tensors in async
   * fashion, use this method when your model contains control flow ops.
   * @param inputs tensor, tensor array or tensor map of the inputs for the
   * model, keyed by the input node names.
   * @param outputs output node name from the TensorFlow model, if no outputs
   * are specified, the default outputs of the model would be used. You can
   * inspect intermediate nodes of the model by adding them to the outputs
   * array.
   *
   * @returns A Promise of single tensor if provided with a single output or
   * no outputs are provided and there is only one default output, otherwise
   * return a tensor map.
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ async executeAsync(e, t) {
        this.resourceIdToCapturedInput == null && this.setResourceIdToCapturedInput(await this.executeInitializerGraphAsync()), e = this.normalizeInputs(e), t = this.normalizeOutputs(t);
        const a = await this.executor.executeAsync(e, t);
        return a.length > 1 ? a : a[0];
    }
    /**
   * Get intermediate tensors for model debugging mode (flag
   * KEEP_INTERMEDIATE_TENSORS is true).
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ getIntermediateTensors() {
        return this.executor.getIntermediateTensors();
    }
    /**
   * Dispose intermediate tensors for model debugging mode (flag
   * KEEP_INTERMEDIATE_TENSORS is true).
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ disposeIntermediateTensors() {
        this.executor.disposeIntermediateTensors();
    }
    convertTensorMapToTensorsMap(e) {
        return Object.keys(e).reduce((t, a)=>(t[a] = [
                e[a]
            ], t), {});
    }
    /**
   * Releases the memory used by the weight tensors and resourceManager.
   *
   * @doc {heading: 'Models', subheading: 'Classes'}
   */ dispose() {
        this.executor.dispose(), this.initializer && (this.initializer.dispose(), this.resourceIdToCapturedInput && (0, $0qVX1.f0)(this.resourceIdToCapturedInput)), this.resourceManager.dispose();
    }
}
async function $126c3ebbcc6243ba$var$Db(s, e = {}, t = $126c3ebbcc6243ba$var$Tt) {
    if (s == null) throw new Error("modelUrl in loadGraphModel() cannot be null. Please provide a url or an IOHandler that loads the model");
    e == null && (e = {}), e.fromTFHub && typeof s == "string" && (s = $126c3ebbcc6243ba$var$zb(s));
    const a = new $126c3ebbcc6243ba$var$Et(s, e, t);
    return await a.load(), a;
}
function $126c3ebbcc6243ba$var$Cb(s) {
    if (s == null) throw new Error("modelUrl in loadGraphModelSync() cannot be null. Please provide model artifacts or an IOHandler that loads the model");
    let e;
    if (s instanceof Array) {
        const [a, r] = s;
        if (!a) throw new Error("modelJSON must be the first element of the array");
        if (!r || !(r instanceof ArrayBuffer)) throw new Error("An ArrayBuffer of weights must be the second element of the array");
        if (!("modelTopology" in a)) throw new Error("Model JSON is missing 'modelTopology'");
        if (!("weightsManifest" in a)) throw new Error("Model JSON is missing 'weightsManifest'");
        const n = (0, $0qVX1.aF)(a.weightsManifest), u = (0, $0qVX1.aD)(a, n, r);
        e = $126c3ebbcc6243ba$var$Ee(u);
    } else if ("load" in s) e = s;
    else if ("modelTopology" in s && "weightSpecs" in s && "weightData" in s) e = $126c3ebbcc6243ba$var$Ee(s);
    else throw new Error("Unknown model format");
    const t = new $126c3ebbcc6243ba$var$Et(e);
    return t.load(), t;
}
function $126c3ebbcc6243ba$var$zb(s) {
    return s.endsWith("/") || (s = s + "/"), `${s}${$126c3ebbcc6243ba$var$$b}${$126c3ebbcc6243ba$var$Ib}`;
}
/** @license See the LICENSE file. */ const $126c3ebbcc6243ba$var$oi = "4.16.0";
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ class $126c3ebbcc6243ba$var$ui extends (0, $0qVX1.f1) {
    /**
   * Create a `TextLineDataset`.
   *
   * @param input A `DataSource` providing a chunked, UTF8-encoded byte stream.
   */ constructor(e){
        super(), this.input = e;
    }
    async iterator() {
        return (await this.input.iterator()).decodeUTF8().split(`
`).map((r)=>(r.endsWith("\r") && (r = r.slice(0, -1)), r));
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$be = '"', $126c3ebbcc6243ba$var$oe = Symbol("out"), $126c3ebbcc6243ba$var$Kt = Symbol("field"), $126c3ebbcc6243ba$var$Ne = Symbol("quote"), $126c3ebbcc6243ba$var$Pe = Symbol("quoteafterquote"), $126c3ebbcc6243ba$var$Jt = Symbol("quoteinquote");
class $126c3ebbcc6243ba$var$li extends (0, $0qVX1.f1) {
    /**
   * Returns column names of the csv dataset. If `configuredColumnsOnly` is
   * true, return column names in `columnConfigs`. If `configuredColumnsOnly` is
   * false and `columnNames` is provided, `columnNames`. If
   * `configuredColumnsOnly` is false and `columnNames` is not provided, return
   * all column names parsed from the csv file. For example usage please go to
   * `tf.data.csv`.
   *
   * @doc {heading: 'Data', subheading: 'Classes'}
   */ async columnNames() {
        return this.columnNamesValidated || await this.setColumnNames(), this.configuredColumnsOnly ? Object.keys(this.columnConfigs) : this.fullColumnNames;
    }
    /* 1) If `columnNames` is provided as string[], use this string[] as output
   * keys in corresponding order. The length must match the number of inferred
   * columns if `hasHeader` is true .
   * 2) If `columnNames` is not provided, parse header line as `columnNames` if
   * hasHeader is true. If `hasHeader` is false, throw an error.
   * 3) If `columnConfigs` is provided, all the keys in `columnConfigs` must
   * exist in parsed `columnNames`.
   */ async setColumnNames() {
        const e = await this.maybeReadHeaderLine();
        if (!this.fullColumnNames && !e) throw new Error("Column names must be provided if there is no header line.");
        this.fullColumnNames && e && (0, $0qVX1.b)(e.length === this.fullColumnNames.length, ()=>"The length of provided columnNames (" + this.fullColumnNames.length.toString() + ") does not match the length of the header line read from file (" + e.length.toString() + ")."), this.fullColumnNames || (this.fullColumnNames = e);
        const t = this.fullColumnNames.reduce((r, n)=>(r[n] = r[n] + 1 || 1, r), {}), a = Object.keys(t).filter((r)=>t[r] > 1);
        if ((0, $0qVX1.b)(a.length === 0, ()=>"Duplicate column names found: " + a.toString()), this.columnConfigs) {
            for (const r of Object.keys(this.columnConfigs))if (this.fullColumnNames.indexOf(r) === -1) throw new Error('The key "' + r + '" provided in columnConfigs does not match any of the column names (' + this.fullColumnNames.toString() + ").");
        }
        this.columnNamesValidated = !0;
    }
    async maybeReadHeaderLine() {
        if (this.hasHeader) {
            const t = await (await this.base.iterator()).next();
            if (t.done) throw new Error("No data was found for CSV parsing.");
            const a = t.value;
            return this.parseRow(a, !1);
        } else return null;
    }
    /**
   * Create a `CSVDataset`.
   *
   * @param input A `DataSource` providing a chunked, UTF8-encoded byte stream.
   * @param csvConfig (Optional) A CSVConfig object that contains configurations
   *     of reading and decoding from CSV file(s).
   *
   *     hasHeader: (Optional) A boolean value that indicates whether the first
   *     row of provided CSV file is a header line with column names, and should
   *     not be included in the data. Defaults to `true`.
   *
   *     columnNames: (Optional) A list of strings that corresponds to
   *     the CSV column names, in order. If provided, it ignores the column
   *     names inferred from the header row. If not provided, infers the column
   *     names from the first row of the records. If hasHeader is false and
   *     columnNames is not provided, this method throws an error.
   *
   *     columnConfigs: (Optional) A dictionary whose key is column names, value
   *     is an object stating if this column is required, column's data type,
   *     default value, and if this column is label. If provided, keys must
   *     correspond to names provided in columnNames or inferred from the file
   *     header lines. If isLabel is true any column, returns an array of two
   *     items: the first item is a dict of features key/value pairs, the second
   *     item is a dict of labels key/value pairs. If no feature is marked as
   *     label, returns a dict of features only.
   *
   *     configuredColumnsOnly (Optional) If true, only columns provided in
   *     columnConfigs will be parsed and provided during iteration.
   *
   *     delimiter (Optional) The string used to parse each line of the input
   *     file. Defaults to `,`.
   */ constructor(e, t){
        super(), this.input = e, this.hasHeader = !0, this.fullColumnNames = null, this.columnNamesValidated = !1, this.columnConfigs = null, this.configuredColumnsOnly = !1, this.delimiter = ",", this.delimWhitespace = !1, this.base = new $126c3ebbcc6243ba$var$ui(e), t || (t = {}), this.hasHeader = t.hasHeader !== !1, this.fullColumnNames = t.columnNames, this.columnConfigs = t.columnConfigs, this.configuredColumnsOnly = t.configuredColumnsOnly, t.delimWhitespace ? ((0, $0qVX1.b)(t.delimiter == null, ()=>"Delimiter should not be provided when delimWhitespace is true."), this.delimWhitespace = !0, this.delimiter = " ") : this.delimiter = t.delimiter ? t.delimiter : ",";
    }
    async iterator() {
        this.columnNamesValidated || await this.setColumnNames();
        let e = await this.base.iterator();
        return this.hasHeader && (e = e.skip(1)), e.map((t)=>this.makeDataElement(t));
    }
    makeDataElement(e) {
        const t = this.parseRow(e), a = {}, r = {};
        for(let n = 0; n < this.fullColumnNames.length; n++){
            const u = this.fullColumnNames[n], o = this.columnConfigs ? this.columnConfigs[u] : null;
            if (!(this.configuredColumnsOnly && !o)) {
                const l = t[n];
                let p = null;
                if (l === "") {
                    if (o && o.default !== void 0) p = o.default;
                    else {
                        if (o && (o.required || o.isLabel)) throw new Error(`Required column ${u} is empty in this line: ${e}`);
                        p = void 0;
                    }
                } else {
                    const m = Number(l);
                    if (isNaN(m)) o && o.dtype === "bool" ? p = this.getBoolean(l) : p = l;
                    else if (!o || !o.dtype) p = m;
                    else switch(o.dtype){
                        case "float32":
                            p = m;
                            break;
                        case "int32":
                            p = Math.floor(m);
                            break;
                        case "bool":
                            p = this.getBoolean(l);
                            break;
                        default:
                            p = m;
                    }
                }
                o && o.isLabel ? r[u] = p : a[u] = p;
            }
        }
        return Object.keys(r).length === 0 ? a : {
            xs: a,
            ys: r
        };
    }
    getBoolean(e) {
        return e === "1" || e.toLowerCase() === "true" ? 1 : 0;
    }
    // adapted from https://beta.observablehq.com/@mbostock/streaming-csv
    parseRow(e, t = !0) {
        const a = [];
        let r = 0;
        const n = e.length;
        let u = $126c3ebbcc6243ba$var$oe;
        for(let o = 0; o < n; o++)switch(u){
            case $126c3ebbcc6243ba$var$oe:
                switch(e.charAt(o)){
                    case $126c3ebbcc6243ba$var$be:
                        r = o + 1, u = $126c3ebbcc6243ba$var$Ne;
                        break;
                    case this.delimiter:
                        if (r = o + 1, this.delimiter === " " && this.delimWhitespace) break;
                        a.push(""), u = $126c3ebbcc6243ba$var$oe;
                        break;
                    default:
                        u = $126c3ebbcc6243ba$var$Kt, r = o;
                        break;
                }
                break;
            case $126c3ebbcc6243ba$var$Kt:
                switch(e.charAt(o)){
                    case this.delimiter:
                        a.push(e.substring(r, o)), u = $126c3ebbcc6243ba$var$oe, r = o + 1;
                        break;
                }
                break;
            case $126c3ebbcc6243ba$var$Ne:
                switch(e.charAt(o)){
                    case $126c3ebbcc6243ba$var$be:
                        u = $126c3ebbcc6243ba$var$Pe;
                        break;
                }
                break;
            case $126c3ebbcc6243ba$var$Pe:
                switch(e.charAt(o)){
                    case this.delimiter:
                        a.push(e.substring(r, o - 1)), u = $126c3ebbcc6243ba$var$oe, r = o + 1;
                        break;
                    case $126c3ebbcc6243ba$var$be:
                        u = $126c3ebbcc6243ba$var$Ne;
                        break;
                    default:
                        u = $126c3ebbcc6243ba$var$Jt;
                        break;
                }
                break;
            case $126c3ebbcc6243ba$var$Jt:
                switch(e.charAt(o)){
                    case $126c3ebbcc6243ba$var$be:
                        u = $126c3ebbcc6243ba$var$Ne;
                        break;
                }
                break;
        }
        if (u === $126c3ebbcc6243ba$var$Pe ? a.push(e.substring(r, n - 1)) : a.push(e.substring(r)), t && a.length !== this.fullColumnNames.length) throw new Error(`Invalid row in csv file. Should have ${this.fullColumnNames.length} elements in a row, but got ${a}`);
        return a;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ class $126c3ebbcc6243ba$var$kt extends (0, $0qVX1.f2) {
    constructor(e){
        super(), this.microphoneConfig = e, this.isClosed = !1, this.fftSize = e.fftSize || 1024;
        const t = Math.log2(this.fftSize);
        if (this.fftSize < 0 || t < 4 || t > 14 || !Number.isInteger(t)) throw new Error(`Invalid fftSize: it must be a power of 2 between 2 to 4 and 2 to 14, but got ${this.fftSize}`);
        if (this.numFrames = e.numFramesPerSpectrogram || 43, this.sampleRateHz = e.sampleRateHz, this.columnTruncateLength = e.columnTruncateLength || this.fftSize, this.audioTrackConstraints = e.audioTrackConstraints, this.smoothingTimeConstant = e.smoothingTimeConstant || 0, this.includeSpectrogram = e.includeSpectrogram !== !1, this.includeWaveform = e.includeWaveform === !0, !this.includeSpectrogram && !this.includeWaveform) throw new Error("Both includeSpectrogram and includeWaveform are false. At least one type of data should be returned.");
    }
    summary() {
        return "microphone";
    }
    // Construct a MicrophoneIterator and start the audio stream.
    static async create(e = {}) {
        if (!(0, $0qVX1.as)().get("IS_BROWSER")) throw new Error("microphone API is only supported in browser environment.");
        const t = new $126c3ebbcc6243ba$var$kt(e);
        return await t.start(), t;
    }
    // Start the audio stream and FFT.
    async start() {
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({
                audio: this.audioTrackConstraints == null ? !0 : this.audioTrackConstraints,
                video: !1
            });
        } catch (a) {
            throw new Error(`Error thrown while initializing video stream: ${a.message}`);
        }
        if (!this.stream) throw new Error("Could not obtain audio from microphone.");
        const e = // tslint:disable-next-line:no-any
        window.AudioContext || window.webkitAudioContext;
        if (this.audioContext = new e(), !this.sampleRateHz) this.sampleRateHz = this.audioContext.sampleRate;
        else if (this.audioContext.sampleRate !== this.sampleRateHz) throw new Error(`Mismatch in sampling rate: Expected: ${this.sampleRateHz}; Actual: ${this.audioContext.sampleRate}`);
        const t = this.audioContext.createMediaStreamSource(this.stream);
        this.analyser = this.audioContext.createAnalyser(), this.analyser.fftSize = this.fftSize * 2, this.analyser.smoothingTimeConstant = this.smoothingTimeConstant, t.connect(this.analyser), this.freqData = new Float32Array(this.fftSize), this.timeData = new Float32Array(this.fftSize);
    }
    async next() {
        if (this.isClosed) return {
            value: null,
            done: !0
        };
        let e, t;
        const a = await this.getAudioData();
        if (this.includeSpectrogram) {
            const r = this.flattenQueue(a.freqDataQueue);
            e = this.getTensorFromAudioDataArray(r, [
                this.numFrames,
                this.columnTruncateLength,
                1
            ]);
        }
        if (this.includeWaveform) {
            const r = this.flattenQueue(a.timeDataQueue);
            t = this.getTensorFromAudioDataArray(r, [
                this.numFrames * this.fftSize,
                1
            ]);
        }
        return {
            value: {
                spectrogram: e,
                waveform: t
            },
            done: !1
        };
    }
    // Capture one result from the audio stream, and extract the value from
    // iterator.next() result.
    async capture() {
        return (await this.next()).value;
    }
    async getAudioData() {
        const e = [], t = [];
        let a = 0;
        return new Promise((r)=>{
            const n = setInterval(()=>{
                this.includeSpectrogram && (this.analyser.getFloatFrequencyData(this.freqData), this.freqData[0] === -1 / 0 && r({
                    freqDataQueue: e,
                    timeDataQueue: t
                }), e.push(this.freqData.slice(0, this.columnTruncateLength))), this.includeWaveform && (this.analyser.getFloatTimeDomainData(this.timeData), t.push(this.timeData.slice())), ++a === this.numFrames && (clearInterval(n), r({
                    freqDataQueue: e,
                    timeDataQueue: t
                }));
            }, this.fftSize / this.sampleRateHz * 1e3);
        });
    }
    // Stop the audio stream and pause the iterator.
    stop() {
        this.isClosed || (this.isClosed = !0, this.analyser.disconnect(), this.audioContext.close(), this.stream != null && this.stream.getTracks().length > 0 && this.stream.getTracks()[0].stop());
    }
    // Override toArray() function to prevent collecting.
    toArray() {
        throw new Error("Can not convert infinite audio stream to array.");
    }
    // Return audio sampling rate in Hz
    getSampleRate() {
        return this.sampleRateHz;
    }
    flattenQueue(e) {
        const t = e[0].length, a = new Float32Array(e.length * t);
        return e.forEach((r, n)=>a.set(r, n * t)), a;
    }
    getTensorFromAudioDataArray(e, t) {
        const a = new Float32Array((0, $0qVX1.k)(t));
        return a.set(e, a.length - e.length), (0, $0qVX1.a7)(a, t);
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ class $126c3ebbcc6243ba$var$It extends (0, $0qVX1.f2) {
    constructor(e, t){
        if (super(), this.webcamVideoElement = e, this.webcamConfig = t, this.isClosed = !0, this.resize = !1, this.needToResize()) {
            if (this.resize = !0, this.cropSize = [
                this.webcamConfig.resizeHeight,
                this.webcamConfig.resizeWidth
            ], this.cropBoxInd = (0, $0qVX1.eM)([
                0
            ], "int32"), this.webcamConfig.centerCrop) {
                const a = this.webcamConfig.resizeWidth * 1 / this.webcamVideoElement.width, r = this.webcamConfig.resizeHeight * 1 / this.webcamVideoElement.height, n = (1 - a) / 2, u = (1 - r) / 2, o = n + a, l = r + u;
                this.cropBox = (0, $0qVX1.eN)([
                    u,
                    n,
                    l,
                    o
                ], [
                    1,
                    4
                ]);
            } else this.cropBox = (0, $0qVX1.eN)([
                0,
                0,
                1,
                1
            ], [
                1,
                4
            ]);
        }
    }
    summary() {
        return "webcam";
    }
    // Construct a WebcamIterator and start it's video stream.
    static async create(e, t = {}) {
        if (!(0, $0qVX1.as)().get("IS_BROWSER")) throw new Error("tf.data.webcam is only supported in browser environment.");
        if (!e) {
            if (e = document.createElement("video"), !t.resizeWidth || !t.resizeHeight) throw new Error("Please provide webcam video element, or resizeWidth and resizeHeight to create a hidden video element.");
            e.width = t.resizeWidth, e.height = t.resizeHeight;
        }
        const a = new $126c3ebbcc6243ba$var$It(e, t);
        return await a.start(), a;
    }
    // Async function to start video stream.
    async start() {
        this.webcamConfig.facingMode && (0, $0qVX1.b)(this.webcamConfig.facingMode === "user" || this.webcamConfig.facingMode === "environment", ()=>`Invalid webcam facing mode: ${this.webcamConfig.facingMode}. Please provide 'user' or 'environment'`);
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    deviceId: this.webcamConfig.deviceId,
                    facingMode: this.webcamConfig.facingMode ? this.webcamConfig.facingMode : "user",
                    width: this.webcamVideoElement.width,
                    height: this.webcamVideoElement.height
                }
            });
        } catch (e) {
            throw e.message = `Error thrown while initializing video stream: ${e.message}`, e;
        }
        if (!this.stream) throw new Error("Could not obtain video from webcam.");
        try {
            this.webcamVideoElement.srcObject = this.stream;
        } catch (e) {
            console.log(e), this.webcamVideoElement.src = window.URL.createObjectURL(this.stream);
        }
        return this.webcamVideoElement.play(), this.isClosed = !1, new Promise((e)=>{
            this.webcamVideoElement.onloadedmetadata = ()=>{
                e();
            };
        });
    }
    async next() {
        if (this.isClosed) return {
            value: null,
            done: !0
        };
        let e;
        try {
            e = (0, $0qVX1.f3)(this.webcamVideoElement);
        } catch (t) {
            throw new Error(`Error thrown converting video to pixels: ${JSON.stringify(t)}`);
        }
        if (this.resize) try {
            return {
                value: this.cropAndResizeFrame(e),
                done: !1
            };
        } catch (t) {
            throw new Error(`Error thrown cropping the video: ${t.message}`);
        } finally{
            e.dispose();
        }
        else return {
            value: e,
            done: !1
        };
    }
    needToResize() {
        return !!(this.webcamConfig.resizeWidth && this.webcamConfig.resizeHeight && (this.webcamVideoElement.width !== this.webcamConfig.resizeWidth || this.webcamVideoElement.height !== this.webcamConfig.resizeHeight));
    }
    // Cropping and resizing each frame based on config
    cropAndResizeFrame(e) {
        return (0, $0qVX1.e_)(()=>{
            const t = (0, $0qVX1.du)((0, $0qVX1.aQ)(e, "float32"), 0);
            let a;
            a = (0, $0qVX1.dF).cropAndResize(t, this.cropBox, this.cropBoxInd, this.cropSize, "bilinear");
            const r = a.shape;
            return (0, $0qVX1.r)(a, r.slice(1));
        });
    }
    // Capture one frame from the video stream, and extract the value from
    // iterator.next() result.
    async capture() {
        return (await this.next()).value;
    }
    // Stop the video stream and pause webcam iterator.
    stop() {
        this.stream.getTracks().forEach((t)=>t.stop());
        try {
            this.webcamVideoElement.srcObject = null;
        } catch (t) {
            console.log(t), this.webcamVideoElement.src = null;
        }
        this.isClosed = !0;
    }
    // Override toArray() function to prevent collecting.
    toArray() {
        throw new Error("Can not convert infinite video stream to array.");
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ class $126c3ebbcc6243ba$var$pi {
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ class $126c3ebbcc6243ba$var$mi extends (0, $0qVX1.f2) {
    /**
   * Splits a string stream on a given separator.
   *
   * It is assumed that the incoming chunk boundaries have no semantic meaning,
   * so conceptually the incoming stream is treated simply as the concatenation
   * of its elements.
   *
   * The outgoing stream provides chunks corresponding to the results of the
   * standard string split() operation (even if such a chunk spanned incoming
   * chunks).  The separators are not included.
   *
   * A typical usage is to split a text file (represented as a stream with
   * arbitrary chunk boundaries) into lines.
   *
   * @param upstream A readable stream of strings that can be treated as
   *   concatenated.
   * @param separator A character to split on.
   */ split(e) {
        return new $126c3ebbcc6243ba$var$xb(this, e);
    }
}
class $126c3ebbcc6243ba$var$xb extends $126c3ebbcc6243ba$var$mi {
    constructor(e, t){
        super(), this.upstream = e, this.impl = new $126c3ebbcc6243ba$var$Lb(e, t);
    }
    summary() {
        return this.impl.summary();
    }
    async next() {
        return this.impl.next();
    }
}
class $126c3ebbcc6243ba$var$Lb extends (0, $0qVX1.f4) {
    constructor(e, t){
        super(), this.upstream = e, this.separator = t, this.carryover = "";
    }
    summary() {
        return `${this.upstream.summary()} -> Split('${this.separator}')`;
    }
    async pump() {
        const e = await this.upstream.next();
        if (e.done) return this.carryover === "" ? !1 : (this.outputQueue.push(this.carryover), this.carryover = "", !0);
        const t = e.value.split(this.separator);
        t[0] = this.carryover + t[0];
        for (const a of t.slice(0, -1))this.outputQueue.push(a);
        return this.carryover = t[t.length - 1], !0;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ class $126c3ebbcc6243ba$var$Pb extends (0, $0qVX1.f2) {
    /**
   * Decode a stream of UTF8-encoded byte arrays to a stream of strings.
   *
   * The byte arrays producetd from the ByteChunkIterator on which this is
   * called will be interpreted as concatenated.  No assumptions are made about
   * the boundaries of the incoming chunks, so a multi-byte UTF8 encoding of a
   * character may span the boundary between chunks.  This naturally happens,
   * for instance, when reading fixed-size byte arrays from a file.
   */ decodeUTF8() {
        return new $126c3ebbcc6243ba$var$Fb(this);
    }
}
class $126c3ebbcc6243ba$var$Fb extends $126c3ebbcc6243ba$var$mi {
    constructor(e){
        super(), this.upstream = e, this.impl = new $126c3ebbcc6243ba$var$Vb(e);
    }
    summary() {
        return this.impl.summary();
    }
    async next() {
        return this.impl.next();
    }
}

class $126c3ebbcc6243ba$var$Vb extends (0, $0qVX1.f4) {
    constructor(e){
        if (super(), this.upstream = e, (0, $0qVX1.as)().get("IS_BROWSER")) this.decoder = new TextDecoder("utf-8");
        else {
            const { StringDecoder: t } = (parcelRequire("eNRCS"));
            this.decoder = new t("utf8");
        }
    }
    summary() {
        return `${this.upstream.summary()} -> Utf8`;
    }
    async pump() {
        const e = await this.upstream.next();
        let t;
        if (e.done) return !1;
        t = e.value;
        let a;
        return (0, $0qVX1.as)().get("IS_BROWSER") ? a = this.decoder.decode(t, {
            stream: !0
        }) : a = this.decoder.write($126c3ebbcc6243ba$require$Buffer.from(t.buffer)), this.outputQueue.push(a), !0;
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ class $126c3ebbcc6243ba$var$ci extends $126c3ebbcc6243ba$var$Pb {
    constructor(e, t = {}){
        super(), this.file = e, this.options = t, (0, $0qVX1.b)(e instanceof Uint8Array || ((0, $0qVX1.as)().get("IS_BROWSER") ? e instanceof File || e instanceof Blob : !1), ()=>"FileChunkIterator only supports File, Blob and Uint8Array right now."), this.offset = t.offset || 0, this.chunkSize = t.chunkSize || 1048576;
    }
    summary() {
        return `FileChunks ${this.file}`;
    }
    async next() {
        return this.offset >= (this.file instanceof Uint8Array ? this.file.byteLength : this.file.size) ? {
            value: null,
            done: !0
        } : {
            value: await new Promise((t, a)=>{
                const r = this.offset + this.chunkSize;
                if (this.file instanceof Uint8Array) t(new Uint8Array(this.file.slice(this.offset, r)));
                else {
                    const n = new FileReader();
                    n.onload = (o)=>{
                        let l = n.result;
                        if (l instanceof ArrayBuffer && (l = new Uint8Array(l)), !(l instanceof Uint8Array)) return a(new TypeError("FileReader returned unknown type."));
                        t(l);
                    }, n.onabort = (o)=>a(new Error("Aborted")), n.onerror = (o)=>a(new Error(o.type));
                    const u = this.file.slice(this.offset, r);
                    n.readAsArrayBuffer(u);
                }
                this.offset = r;
            }),
            done: !1
        };
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ async function $126c3ebbcc6243ba$var$Rb(s, e = {}, t) {
    let a, r;
    typeof s == "string" ? a = s : (a = s.url, r = $126c3ebbcc6243ba$var$jb(s));
    const n = await (t || (0, $0qVX1.f5))(a, r);
    if (n.ok) {
        const u = new Uint8Array(await n.arrayBuffer());
        return new $126c3ebbcc6243ba$var$ci(u, e);
    } else throw new Error(n.statusText);
}
const $126c3ebbcc6243ba$var$jb = (s)=>({
        method: s.method,
        headers: s.headers,
        body: s.body,
        mode: s.mode,
        credentials: s.credentials,
        cache: s.cache,
        redirect: s.redirect,
        referrer: s.referrer,
        integrity: s.integrity
    });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$di(s) {
    return typeof s == "string" && s.slice(0, 7) === "file://";
}

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ class $126c3ebbcc6243ba$var$hi extends $126c3ebbcc6243ba$var$pi {
    /**
   * Create a `FileDataSource`.
   *
   * @param input Local file path, or `File`/`Blob`/`Uint8Array` object to
   *     read. Local file only works in node environment.
   * @param options Options passed to the underlying `FileChunkIterator`s,
   *   such as {chunksize: 1024}.
   */ constructor(e, t = {}){
        super(), this.input = e, this.options = t;
    }
    async iterator() {
        if ($126c3ebbcc6243ba$var$di(this.input) && (0, $0qVX1.as)().get("IS_NODE")) {
            const e = (parcelRequire("kjyEk"));
            this.input = e.readFileSync(this.input.slice(7));
        }
        return new $126c3ebbcc6243ba$var$ci(this.input, this.options);
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ class $126c3ebbcc6243ba$var$fi extends $126c3ebbcc6243ba$var$pi {
    /**
   * Create a `URLDataSource`.
   *
   * @param url A source URL string, or a `Request` object.
   * @param options Options passed to the underlying `FileChunkIterator`s,
   *   such as {chunksize: 1024}.
   */ constructor(e, t = {}){
        super(), this.url = e, this.fileOptions = t;
    }
    // TODO(soergel): provide appropriate caching options.  Currently this
    // will download the URL anew for each call to iterator().  Since we have
    // to treat the downloaded file as a blob/buffer anyway, we may as well retain
    // it-- but that raises GC issues.  Also we may want a persistent disk cache.
    async iterator() {
        return $126c3ebbcc6243ba$var$di(this.url) ? new $126c3ebbcc6243ba$var$hi(this.url, this.fileOptions).iterator() : $126c3ebbcc6243ba$var$Rb(this.url, this.fileOptions);
    }
}
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ function $126c3ebbcc6243ba$var$Bb(s, e = {}) {
    return new $126c3ebbcc6243ba$var$li(new $126c3ebbcc6243ba$var$fi(s), e);
}
function $126c3ebbcc6243ba$var$Hb(s) {
    const e = (0, $0qVX1.f6)(s);
    return (0, $0qVX1.f7)(async ()=>e);
}
function $126c3ebbcc6243ba$var$Wb(s) {
    return (0, $0qVX1.f7)(async ()=>{
        const e = await s();
        return (0, $0qVX1.f6)(()=>e.next());
    });
}
async function $126c3ebbcc6243ba$var$Ub(s, e) {
    return $126c3ebbcc6243ba$var$It.create(s, e);
}
async function $126c3ebbcc6243ba$var$qb(s) {
    return $126c3ebbcc6243ba$var$kt.create(s);
}
/** @license See the LICENSE file. */ const $126c3ebbcc6243ba$var$yi = "4.16.0";
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Gb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    CSVDataset: $126c3ebbcc6243ba$var$li,
    Dataset: (0, $0qVX1.f1),
    FileDataSource: $126c3ebbcc6243ba$var$hi,
    TextLineDataset: $126c3ebbcc6243ba$var$ui,
    URLDataSource: $126c3ebbcc6243ba$var$fi,
    array: (0, $0qVX1.f8),
    csv: $126c3ebbcc6243ba$var$Bb,
    func: $126c3ebbcc6243ba$var$Hb,
    generator: $126c3ebbcc6243ba$var$Wb,
    microphone: $126c3ebbcc6243ba$var$qb,
    version_data: $126c3ebbcc6243ba$var$yi,
    webcam: $126c3ebbcc6243ba$var$Ub,
    zip: (0, $0qVX1.f9)
}, Symbol.toStringTag, {
    value: "Module"
}));
/** @license See the LICENSE file. */ const $126c3ebbcc6243ba$var$gi = "4.16.0";
/** @license See the LICENSE file. */ const $126c3ebbcc6243ba$var$bi = "4.16.0";
/** @license See the LICENSE file. */ const $126c3ebbcc6243ba$var$Kb = "4.16.0";
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $126c3ebbcc6243ba$var$Jb = {
    "tfjs-core": $126c3ebbcc6243ba$var$Xn,
    "tfjs-backend-cpu": $126c3ebbcc6243ba$var$gi,
    "tfjs-backend-webgl": $126c3ebbcc6243ba$var$bi,
    "tfjs-data": $126c3ebbcc6243ba$var$yi,
    "tfjs-layers": (0, $0qVX1.fa),
    "tfjs-converter": $126c3ebbcc6243ba$var$oi,
    tfjs: $126c3ebbcc6243ba$var$Kb
}, $126c3ebbcc6243ba$var$Qb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    Abs: (0, $0qVX1.fb),
    Acos: (0, $0qVX1.fc),
    Acosh: (0, $0qVX1.fd),
    AdadeltaOptimizer: (0, $0qVX1.fe),
    AdagradOptimizer: (0, $0qVX1.ff),
    AdamOptimizer: (0, $0qVX1.fg),
    AdamaxOptimizer: (0, $0qVX1.fh),
    Add: (0, $0qVX1.fi),
    AddN: (0, $0qVX1.A),
    All: (0, $0qVX1.fj),
    Any: (0, $0qVX1.fk),
    ArgMax: (0, $0qVX1.fl),
    ArgMin: (0, $0qVX1.fm),
    Asin: (0, $0qVX1.fn),
    Asinh: (0, $0qVX1.fo),
    Atan: (0, $0qVX1.fp),
    Atan2: (0, $0qVX1.fq),
    Atanh: (0, $0qVX1.fr),
    AvgPool: (0, $0qVX1.fs),
    AvgPool3D: (0, $0qVX1.ft),
    AvgPool3DGrad: (0, $0qVX1.fu),
    AvgPoolGrad: (0, $0qVX1.fv),
    BatchMatMul: (0, $0qVX1.fw),
    BatchToSpaceND: (0, $0qVX1.fx),
    Bincount: (0, $0qVX1.fy),
    BitwiseAnd: (0, $0qVX1.B),
    BroadcastArgs: (0, $0qVX1.i),
    BroadcastTo: (0, $0qVX1.fz),
    Callback: $126c3ebbcc6243ba$var$si,
    CallbackList: (0, $0qVX1.fA),
    Cast: (0, $0qVX1.fB),
    Ceil: (0, $0qVX1.fC),
    ClipByValue: (0, $0qVX1.fD),
    Complex: (0, $0qVX1.fE),
    ComplexAbs: (0, $0qVX1.fF),
    Concat: (0, $0qVX1.fG),
    Conv2D: (0, $0qVX1.fH),
    Conv2DBackpropFilter: (0, $0qVX1.fI),
    Conv2DBackpropInput: (0, $0qVX1.fJ),
    Conv3D: (0, $0qVX1.fK),
    Conv3DBackpropFilterV2: (0, $0qVX1.fL),
    Conv3DBackpropInputV2: (0, $0qVX1.fM),
    Cos: (0, $0qVX1.fN),
    Cosh: (0, $0qVX1.fO),
    CropAndResize: (0, $0qVX1.fP),
    Cumprod: (0, $0qVX1.fQ),
    Cumsum: (0, $0qVX1.fR),
    CustomCallback: (0, $0qVX1.fS),
    DataStorage: (0, $0qVX1.fT),
    DenseBincount: (0, $0qVX1.fU),
    DepthToSpace: (0, $0qVX1.fV),
    DepthwiseConv2dNative: (0, $0qVX1.fW),
    DepthwiseConv2dNativeBackpropFilter: (0, $0qVX1.fX),
    DepthwiseConv2dNativeBackpropInput: (0, $0qVX1.fY),
    Diag: (0, $0qVX1.D),
    Dilation2D: (0, $0qVX1.fZ),
    Dilation2DBackpropFilter: (0, $0qVX1.f_),
    Dilation2DBackpropInput: (0, $0qVX1.f$),
    Draw: (0, $0qVX1.g0),
    get ENV () {
        return 0, $0qVX1.g1;
    },
    EarlyStopping: $126c3ebbcc6243ba$var$ai,
    Einsum: (0, $0qVX1.g2),
    Elu: (0, $0qVX1.g3),
    EluGrad: (0, $0qVX1.g4),
    Environment: (0, $0qVX1.g5),
    Equal: (0, $0qVX1.g6),
    Erf: (0, $0qVX1.g7),
    Exp: (0, $0qVX1.g8),
    ExpandDims: (0, $0qVX1.g9),
    Expm1: (0, $0qVX1.ga),
    FFT: (0, $0qVX1.gb),
    Fill: (0, $0qVX1.gc),
    FlipLeftRight: (0, $0qVX1.gd),
    Floor: (0, $0qVX1.ge),
    FloorDiv: (0, $0qVX1.gf),
    FromPixels: (0, $0qVX1.gg),
    FusedBatchNorm: (0, $0qVX1.gh),
    FusedConv2D: (0, $0qVX1.gi),
    FusedDepthwiseConv2D: (0, $0qVX1.ah),
    GPGPUContext: (0, $0qVX1.gj),
    GatherNd: (0, $0qVX1.a5),
    GatherV2: (0, $0qVX1.gk),
    GraphModel: $126c3ebbcc6243ba$var$Et,
    Greater: (0, $0qVX1.gl),
    GreaterEqual: (0, $0qVX1.gm),
    History: (0, $0qVX1.gn),
    IFFT: (0, $0qVX1.go),
    Identity: (0, $0qVX1.gp),
    Imag: (0, $0qVX1.gq),
    InputSpec: (0, $0qVX1.gr),
    IsFinite: (0, $0qVX1.gs),
    IsInf: (0, $0qVX1.gt),
    IsNan: (0, $0qVX1.gu),
    KernelBackend: (0, $0qVX1.gv),
    LRN: (0, $0qVX1.gw),
    LRNGrad: (0, $0qVX1.gx),
    LayerVariable: (0, $0qVX1.gy),
    LayersModel: (0, $0qVX1.bc),
    LeakyRelu: (0, $0qVX1.gz),
    Less: (0, $0qVX1.gA),
    LessEqual: (0, $0qVX1.gB),
    LinSpace: (0, $0qVX1.L),
    Log: (0, $0qVX1.gC),
    Log1p: (0, $0qVX1.gD),
    LogSoftmax: (0, $0qVX1.gE),
    LogicalAnd: (0, $0qVX1.gF),
    LogicalNot: (0, $0qVX1.gG),
    LogicalOr: (0, $0qVX1.gH),
    LogicalXor: (0, $0qVX1.gI),
    LowerBound: (0, $0qVX1.gJ),
    MathBackendCPU: (0, $0qVX1.gK),
    MathBackendWebGL: (0, $0qVX1.gL),
    MatrixBandPart: (0, $0qVX1.gM),
    Max: (0, $0qVX1.gN),
    MaxPool: (0, $0qVX1.gO),
    MaxPool3D: (0, $0qVX1.gP),
    MaxPool3DGrad: (0, $0qVX1.gQ),
    MaxPoolGrad: (0, $0qVX1.gR),
    MaxPoolWithArgmax: (0, $0qVX1.M),
    Maximum: (0, $0qVX1.gS),
    Mean: (0, $0qVX1.gT),
    Min: (0, $0qVX1.gU),
    Minimum: (0, $0qVX1.gV),
    MirrorPad: (0, $0qVX1.gW),
    Mod: (0, $0qVX1.gX),
    MomentumOptimizer: (0, $0qVX1.gY),
    Multinomial: (0, $0qVX1.p),
    Multiply: (0, $0qVX1.gZ),
    Neg: (0, $0qVX1.g_),
    NonMaxSuppressionV3: (0, $0qVX1.g$),
    NonMaxSuppressionV4: (0, $0qVX1.h0),
    NonMaxSuppressionV5: (0, $0qVX1.h1),
    NotEqual: (0, $0qVX1.h2),
    OP_SCOPE_SUFFIX: (0, $0qVX1.cF),
    OneHot: (0, $0qVX1.h3),
    OnesLike: (0, $0qVX1.h4),
    Optimizer: (0, $0qVX1.h5),
    OptimizerConstructors: (0, $0qVX1.h6),
    Pack: (0, $0qVX1.h7),
    PadV2: (0, $0qVX1.h8),
    Pool: (0, $0qVX1.h9),
    Pow: (0, $0qVX1.ha),
    Prelu: (0, $0qVX1.hb),
    Prod: (0, $0qVX1.hc),
    RMSPropOptimizer: (0, $0qVX1.hd),
    RNN: (0, $0qVX1.c5),
    RaggedGather: (0, $0qVX1.R),
    RaggedRange: (0, $0qVX1.u),
    RaggedTensorToTensor: (0, $0qVX1.v),
    Range: (0, $0qVX1.he),
    get Rank () {
        return 0, $0qVX1.hf;
    },
    Real: (0, $0qVX1.hg),
    RealDiv: (0, $0qVX1.hh),
    Reciprocal: (0, $0qVX1.hi),
    get Reduction () {
        return 0, $0qVX1.hj;
    },
    Relu: (0, $0qVX1.hk),
    Relu6: (0, $0qVX1.hl),
    Reshape: (0, $0qVX1.hm),
    ResizeBilinear: (0, $0qVX1.hn),
    ResizeBilinearGrad: (0, $0qVX1.ho),
    ResizeNearestNeighbor: (0, $0qVX1.hp),
    ResizeNearestNeighborGrad: (0, $0qVX1.hq),
    Reverse: (0, $0qVX1.hr),
    RotateWithOffset: (0, $0qVX1.hs),
    Round: (0, $0qVX1.ht),
    Rsqrt: (0, $0qVX1.hu),
    SGDOptimizer: (0, $0qVX1.hv),
    ScatterNd: (0, $0qVX1.a3),
    SearchSorted: (0, $0qVX1.S),
    Select: (0, $0qVX1.hw),
    Selu: (0, $0qVX1.hx),
    Sequential: (0, $0qVX1.bd),
    Sigmoid: (0, $0qVX1.hy),
    Sign: (0, $0qVX1.hz),
    Sin: (0, $0qVX1.hA),
    Sinh: (0, $0qVX1.hB),
    Slice: (0, $0qVX1.hC),
    Softmax: (0, $0qVX1.hD),
    Softplus: (0, $0qVX1.hE),
    SpaceToBatchND: (0, $0qVX1.hF),
    SparseFillEmptyRows: (0, $0qVX1.hG),
    SparseReshape: (0, $0qVX1.hH),
    SparseSegmentMean: (0, $0qVX1.hI),
    SparseSegmentSum: (0, $0qVX1.hJ),
    SparseToDense: (0, $0qVX1.a4),
    SplitV: (0, $0qVX1.hK),
    Sqrt: (0, $0qVX1.hL),
    Square: (0, $0qVX1.hM),
    SquaredDifference: (0, $0qVX1.hN),
    StaticRegexReplace: (0, $0qVX1.hO),
    Step: (0, $0qVX1.hP),
    StridedSlice: (0, $0qVX1.hQ),
    StringNGrams: (0, $0qVX1.hR),
    StringSplit: (0, $0qVX1.hS),
    StringToHashBucketFast: (0, $0qVX1.hT),
    Sub: (0, $0qVX1.hU),
    Sum: (0, $0qVX1.hV),
    SymbolicTensor: (0, $0qVX1.hW),
    Tan: (0, $0qVX1.hX),
    Tanh: (0, $0qVX1.hY),
    Tensor: (0, $0qVX1.T),
    TensorBuffer: (0, $0qVX1.O),
    TensorScatterUpdate: (0, $0qVX1.V),
    Tile: (0, $0qVX1.hZ),
    TopK: (0, $0qVX1.h_),
    Transform: (0, $0qVX1.h$),
    Transpose: (0, $0qVX1.i0),
    Unique: (0, $0qVX1.i1),
    Unpack: (0, $0qVX1.i2),
    UnsortedSegmentSum: (0, $0qVX1.i3),
    UpperBound: (0, $0qVX1.i4),
    Variable: (0, $0qVX1.i5),
    ZerosLike: (0, $0qVX1.i6),
    _FusedMatMul: (0, $0qVX1.i7),
    abs: (0, $0qVX1.cG),
    acos: (0, $0qVX1.cH),
    acosh: (0, $0qVX1.cI),
    add: (0, $0qVX1.f),
    addN: $126c3ebbcc6243ba$var$nn,
    all: (0, $0qVX1.cJ),
    any: (0, $0qVX1.cK),
    argMax: (0, $0qVX1.cL),
    argMin: (0, $0qVX1.cM),
    asin: (0, $0qVX1.cN),
    asinh: (0, $0qVX1.cO),
    atan: (0, $0qVX1.cP),
    atan2: (0, $0qVX1.cQ),
    atanh: (0, $0qVX1.cR),
    avgPool: (0, $0qVX1.cS),
    avgPool3d: (0, $0qVX1.cT),
    backend: (0, $0qVX1.i8),
    backend_util: (0, $0qVX1.i9),
    basicLSTMCell: $126c3ebbcc6243ba$var$on,
    batchNorm: (0, $0qVX1.cU),
    batchNorm2d: (0, $0qVX1.cV),
    batchNorm3d: (0, $0qVX1.cW),
    batchNorm4d: (0, $0qVX1.cX),
    batchToSpaceND: (0, $0qVX1.cY),
    bincount: (0, $0qVX1.cZ),
    bitwiseAnd: $126c3ebbcc6243ba$var$un,
    booleanMaskAsync: $126c3ebbcc6243ba$var$Hn,
    broadcastArgs: $126c3ebbcc6243ba$var$ln,
    broadcastTo: (0, $0qVX1.c_),
    broadcast_util: (0, $0qVX1.ia),
    browser: (0, $0qVX1.ib),
    buffer: (0, $0qVX1.I),
    callbacks: $126c3ebbcc6243ba$var$rg,
    cast: (0, $0qVX1.aQ),
    ceil: (0, $0qVX1.c$),
    clipByValue: (0, $0qVX1.d0),
    clone: (0, $0qVX1.cD),
    complex: (0, $0qVX1.d1),
    concat: (0, $0qVX1.e),
    concat1d: (0, $0qVX1.d2),
    concat2d: (0, $0qVX1.d3),
    concat3d: (0, $0qVX1.d4),
    concat4d: (0, $0qVX1.d5),
    constraints: $126c3ebbcc6243ba$var$Mh,
    conv1d: (0, $0qVX1.d6),
    conv2d: (0, $0qVX1.d7),
    conv2dTranspose: (0, $0qVX1.d8),
    conv3d: (0, $0qVX1.d9),
    conv3dTranspose: (0, $0qVX1.da),
    copyRegisteredKernels: (0, $0qVX1.ic),
    cos: (0, $0qVX1.db),
    cosh: (0, $0qVX1.dc),
    cosineWindow: (0, $0qVX1.dd),
    cumprod: (0, $0qVX1.de),
    cumsum: (0, $0qVX1.df),
    customGrad: (0, $0qVX1.ag),
    data: $126c3ebbcc6243ba$var$Gb,
    denseBincount: (0, $0qVX1.dg),
    deprecationWarn: (0, $0qVX1.id),
    depthToSpace: (0, $0qVX1.dh),
    depthwiseConv2d: (0, $0qVX1.a9),
    deregisterOp: $126c3ebbcc6243ba$var$ig,
    device_util: (0, $0qVX1.ie),
    diag: $126c3ebbcc6243ba$var$pn,
    dilation2d: (0, $0qVX1.di),
    disableDeprecationWarnings: (0, $0qVX1.ig),
    dispose: (0, $0qVX1.f0),
    disposeVariables: (0, $0qVX1.ih),
    div: (0, $0qVX1.a1),
    divNoNan: (0, $0qVX1.dj),
    dot: (0, $0qVX1.dk),
    dropout: (0, $0qVX1.dl),
    einsum: (0, $0qVX1.dm),
    elu: (0, $0qVX1.dn),
    enableDebugMode: (0, $0qVX1.ii),
    enableProdMode: (0, $0qVX1.ij),
    enclosingPowerOfTwo: (0, $0qVX1.dp),
    engine: (0, $0qVX1.ik),
    ensureShape: $126c3ebbcc6243ba$var$mn,
    env: (0, $0qVX1.as),
    equal: (0, $0qVX1.dq),
    erf: (0, $0qVX1.dr),
    euclideanNorm: (0, $0qVX1.ds),
    exp: (0, $0qVX1.dt),
    expandDims: (0, $0qVX1.du),
    expm1: (0, $0qVX1.dv),
    eye: (0, $0qVX1.dw),
    fft: (0, $0qVX1.dx),
    fill: (0, $0qVX1.dy),
    findBackend: (0, $0qVX1.il),
    findBackendFactory: (0, $0qVX1.im),
    floor: (0, $0qVX1.dz),
    floorDiv: (0, $0qVX1.dA),
    forceHalfFloat: (0, $0qVX1.io),
    fused: $126c3ebbcc6243ba$var$Jn,
    gather: (0, $0qVX1.Z),
    gatherND: $126c3ebbcc6243ba$var$Gn,
    gather_util: (0, $0qVX1.ip),
    getBackend: (0, $0qVX1.iq),
    getGradient: (0, $0qVX1.ir),
    getKernel: (0, $0qVX1.is),
    getKernelsForBackend: (0, $0qVX1.it),
    gpgpu_util: (0, $0qVX1.iu),
    grad: (0, $0qVX1.iv),
    grads: (0, $0qVX1.iw),
    greater: (0, $0qVX1.dB),
    greaterEqual: (0, $0qVX1.dC),
    ifft: (0, $0qVX1.dD),
    imag: (0, $0qVX1.dE),
    image: (0, $0qVX1.dF),
    inTopKAsync: $126c3ebbcc6243ba$var$Kn,
    initializers: $126c3ebbcc6243ba$var$yf,
    input: $126c3ebbcc6243ba$var$Zn,
    io: $126c3ebbcc6243ba$var$Tt,
    irfft: (0, $0qVX1.dG),
    isFinite: (0, $0qVX1.dH),
    isInf: (0, $0qVX1.dI),
    isNaN: (0, $0qVX1.dJ),
    keep: (0, $0qVX1.eZ),
    kernel_impls: $126c3ebbcc6243ba$var$Jh,
    layers: $126c3ebbcc6243ba$var$Ly,
    leakyRelu: (0, $0qVX1.dK),
    less: (0, $0qVX1.dL),
    lessEqual: (0, $0qVX1.dM),
    linalg: (0, $0qVX1.dN),
    linspace: $126c3ebbcc6243ba$var$cn,
    loadGraphModel: $126c3ebbcc6243ba$var$Db,
    loadGraphModelSync: $126c3ebbcc6243ba$var$Cb,
    loadLayersModel: (0, $0qVX1.ix),
    localResponseNormalization: (0, $0qVX1.dO),
    log: (0, $0qVX1.dP),
    log1p: (0, $0qVX1.dQ),
    logSigmoid: (0, $0qVX1.dR),
    logSoftmax: (0, $0qVX1.dS),
    logSumExp: (0, $0qVX1.dT),
    logicalAnd: (0, $0qVX1.dU),
    logicalNot: (0, $0qVX1.dV),
    logicalOr: (0, $0qVX1.dW),
    logicalXor: (0, $0qVX1.dX),
    losses: (0, $0qVX1.dY),
    lowerBound: $126c3ebbcc6243ba$var$dn,
    matMul: (0, $0qVX1.m),
    math: $126c3ebbcc6243ba$var$Kh,
    max: (0, $0qVX1.dZ),
    maxPool: (0, $0qVX1.d_),
    maxPool3d: (0, $0qVX1.d$),
    maxPoolWithArgmax: $126c3ebbcc6243ba$var$hn,
    maximum: (0, $0qVX1.e0),
    mean: (0, $0qVX1.e1),
    memory: (0, $0qVX1.iy),
    meshgrid: $126c3ebbcc6243ba$var$fn,
    metrics: $126c3ebbcc6243ba$var$Zy,
    min: (0, $0qVX1.e2),
    minimum: (0, $0qVX1.e3),
    mirrorPad: (0, $0qVX1.e4),
    mod: (0, $0qVX1.e5),
    model: $126c3ebbcc6243ba$var$gf,
    models: $126c3ebbcc6243ba$var$Yy,
    moments: (0, $0qVX1.e6),
    movingAverage: $126c3ebbcc6243ba$var$Wn,
    mul: (0, $0qVX1.g),
    multiRNNCell: $126c3ebbcc6243ba$var$yn,
    multinomial: $126c3ebbcc6243ba$var$gn,
    neg: (0, $0qVX1.e7),
    nextFrame: (0, $0qVX1.iz),
    norm: (0, $0qVX1.e8),
    notEqual: (0, $0qVX1.e9),
    oneHot: (0, $0qVX1.aP),
    ones: (0, $0qVX1.l),
    onesLike: (0, $0qVX1.ea),
    op: (0, $0qVX1.o),
    outerProduct: $126c3ebbcc6243ba$var$bn,
    pad: (0, $0qVX1.q),
    pad1d: $126c3ebbcc6243ba$var$Nn,
    pad2d: $126c3ebbcc6243ba$var$wn,
    pad3d: $126c3ebbcc6243ba$var$Tn,
    pad4d: $126c3ebbcc6243ba$var$Sn,
    pool: (0, $0qVX1.eb),
    pow: (0, $0qVX1.a2),
    prelu: (0, $0qVX1.ec),
    print: (0, $0qVX1.ed),
    prod: (0, $0qVX1.ee),
    profile: (0, $0qVX1.iA),
    raggedGather: $126c3ebbcc6243ba$var$vn,
    raggedRange: $126c3ebbcc6243ba$var$On,
    raggedTensorToTensor: $126c3ebbcc6243ba$var$_n,
    rand: $126c3ebbcc6243ba$var$An,
    randomGamma: $126c3ebbcc6243ba$var$In,
    randomNormal: (0, $0qVX1.J),
    randomStandardNormal: $126c3ebbcc6243ba$var$$n,
    randomUniform: (0, $0qVX1.K),
    randomUniformInt: $126c3ebbcc6243ba$var$Dn,
    range: (0, $0qVX1.ef),
    ready: (0, $0qVX1.iB),
    real: (0, $0qVX1.eg),
    reciprocal: (0, $0qVX1.eh),
    registerBackend: (0, $0qVX1.iC),
    registerCallbackConstructor: $126c3ebbcc6243ba$var$Nf,
    registerGradient: (0, $0qVX1.iD),
    registerKernel: (0, $0qVX1.iE),
    registerOp: $126c3ebbcc6243ba$var$ng,
    regularizers: $126c3ebbcc6243ba$var$sg,
    relu: (0, $0qVX1.ei),
    relu6: (0, $0qVX1.ej),
    removeBackend: (0, $0qVX1.iF),
    reshape: (0, $0qVX1.r),
    reverse: (0, $0qVX1.N),
    reverse1d: $126c3ebbcc6243ba$var$Cn,
    reverse2d: $126c3ebbcc6243ba$var$zn,
    reverse3d: $126c3ebbcc6243ba$var$xn,
    reverse4d: $126c3ebbcc6243ba$var$Ln,
    rfft: (0, $0qVX1.ek),
    round: (0, $0qVX1.el),
    rsqrt: (0, $0qVX1.em),
    scalar: (0, $0qVX1.$),
    scatterND: $126c3ebbcc6243ba$var$Un,
    scatter_util: (0, $0qVX1.iG),
    searchSorted: $126c3ebbcc6243ba$var$Ce,
    selu: (0, $0qVX1.en),
    separableConv2d: (0, $0qVX1.eo),
    sequential: $126c3ebbcc6243ba$var$bf,
    serialization: (0, $0qVX1.iH),
    setBackend: (0, $0qVX1.iI),
    setPlatform: (0, $0qVX1.iJ),
    setWebGLContext: (0, $0qVX1.iK),
    setdiff1dAsync: $126c3ebbcc6243ba$var$Pn,
    shared: (0, $0qVX1.iL),
    sigmoid: (0, $0qVX1.h),
    sign: (0, $0qVX1.ep),
    signal: (0, $0qVX1.eq),
    sin: (0, $0qVX1.er),
    sinh: (0, $0qVX1.es),
    slice: (0, $0qVX1.s),
    slice1d: (0, $0qVX1.et),
    slice2d: (0, $0qVX1.eu),
    slice3d: (0, $0qVX1.ev),
    slice4d: (0, $0qVX1.ew),
    slice_util: (0, $0qVX1.iM),
    softmax: (0, $0qVX1.ex),
    softplus: (0, $0qVX1.ey),
    spaceToBatchND: (0, $0qVX1.ez),
    sparse: (0, $0qVX1.eA),
    sparseToDense: $126c3ebbcc6243ba$var$qn,
    spectral: (0, $0qVX1.eB),
    split: (0, $0qVX1.eC),
    sqrt: (0, $0qVX1.eD),
    square: (0, $0qVX1.eE),
    squaredDifference: (0, $0qVX1.eF),
    squeeze: (0, $0qVX1.Y),
    stack: (0, $0qVX1.eG),
    step: (0, $0qVX1.eH),
    stridedSlice: (0, $0qVX1.eI),
    string: (0, $0qVX1.eJ),
    sub: (0, $0qVX1.a0),
    sum: (0, $0qVX1.eK),
    sumOutType: (0, $0qVX1.iN),
    tan: (0, $0qVX1.eL),
    tanh: (0, $0qVX1.t),
    tensor: (0, $0qVX1.a7),
    tensor1d: (0, $0qVX1.eM),
    tensor2d: (0, $0qVX1.eN),
    tensor3d: (0, $0qVX1.eO),
    tensor4d: $126c3ebbcc6243ba$var$Fn,
    tensor5d: $126c3ebbcc6243ba$var$Vn,
    tensor6d: $126c3ebbcc6243ba$var$Rn,
    tensorScatterUpdate: $126c3ebbcc6243ba$var$jn,
    tensor_util: (0, $0qVX1.iO),
    test_util: $126c3ebbcc6243ba$var$hh,
    tidy: (0, $0qVX1.e_),
    tile: (0, $0qVX1.eP),
    time: (0, $0qVX1.iP),
    topk: (0, $0qVX1.eQ),
    train: (0, $0qVX1.iQ),
    transpose: (0, $0qVX1.aR),
    truncatedNormal: (0, $0qVX1.eR),
    unique: (0, $0qVX1.eS),
    unregisterGradient: (0, $0qVX1.iR),
    unregisterKernel: (0, $0qVX1.iS),
    unsortedSegmentSum: (0, $0qVX1.eT),
    unstack: (0, $0qVX1.eU),
    upcastType: (0, $0qVX1.iT),
    upperBound: $126c3ebbcc6243ba$var$Bn,
    util: (0, $0qVX1.iU),
    valueAndGrad: (0, $0qVX1.iV),
    valueAndGrads: (0, $0qVX1.iW),
    variable: (0, $0qVX1.eV),
    variableGrads: (0, $0qVX1.iX),
    version: $126c3ebbcc6243ba$var$Jb,
    version_converter: $126c3ebbcc6243ba$var$oi,
    version_core: $126c3ebbcc6243ba$var$Xn,
    version_cpu: $126c3ebbcc6243ba$var$gi,
    version_layers: (0, $0qVX1.fa),
    version_webgl: $126c3ebbcc6243ba$var$bi,
    webgl: (0, $0qVX1.iY),
    webgl_util: (0, $0qVX1.iZ),
    where: (0, $0qVX1.eW),
    whereAsync: $126c3ebbcc6243ba$var$wt,
    zeros: (0, $0qVX1.eX),
    zerosLike: (0, $0qVX1.eY)
}, Symbol.toStringTag, {
    value: "Module"
})), $126c3ebbcc6243ba$var$Ni = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
$126c3ebbcc6243ba$var$Ni.compose(new (0, $d5b33d7c30034067$export$64b5c384219d3699)(), new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)(), new (0, $d5b33d7c30034067$export$64b5c384219d3699)(1e-3, 1e-3, 1e-3));
const $126c3ebbcc6243ba$var$Xb = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)().set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1);
class $126c3ebbcc6243ba$export$4f07dbbca44e3181 {
    constructor({ container: e, imageTargetSrc: t, maxTrack: a, uiLoading: r = "yes", uiScanning: n = "yes", uiError: u = "yes", filterMinCF: o = null, filterBeta: l = null, warmupTolerance: p = null, missTolerance: m = null, userDeviceId: c = null, environmentDeviceId: d = null }){
        this.container = e, this.imageTargetSrc = t, this.maxTrack = a, this.filterMinCF = o, this.filterBeta = l, this.warmupTolerance = p, this.missTolerance = m, this.ui = new (0, $4azF7.U)({
            uiLoading: r,
            uiScanning: n,
            uiError: u
        }), this.userDeviceId = c, this.environmentDeviceId = d, this.shouldFaceUser = !1, this.scene = new (0, $d5b33d7c30034067$export$38af1803e3442a7f)(), this.cssScene = new (0, $d5b33d7c30034067$export$38af1803e3442a7f)(), this.renderer = new (0, $d5b33d7c30034067$export$f6cc00ef28d7cf97)({
            antialias: !0,
            alpha: !0
        }), this.cssRenderer = new (0, $9363e764e36b7961$export$3bfd27f14dcd93ed)({
            antialias: !0
        }), this.renderer.outputEncoding = (0, $d5b33d7c30034067$export$f32388edbb32674), this.renderer.setPixelRatio(window.devicePixelRatio), this.camera = new (0, $d5b33d7c30034067$export$74e4ae24825f68d7)(), this.anchors = [], this.renderer.domElement.style.position = "absolute", this.cssRenderer.domElement.style.position = "absolute", this.container.appendChild(this.renderer.domElement), this.container.appendChild(this.cssRenderer.domElement), window.addEventListener("resize", this.resize.bind(this));
    }
    async start() {
        this.ui.showLoading(), await this._startVideo(), await this._startAR();
    }
    stop() {
        this.controller.stopProcessVideo(), this.video.srcObject.getTracks().forEach(function(t) {
            t.stop();
        }), this.video.remove();
    }
    switchCamera() {
        this.shouldFaceUser = !this.shouldFaceUser, this.stop(), this.start();
    }
    addAnchor(e) {
        const t = new (0, $d5b33d7c30034067$export$eb2fcfdbd7ba97d4)();
        t.visible = !1, t.matrixAutoUpdate = !1;
        const a = {
            group: t,
            targetIndex: e,
            onTargetFound: null,
            onTargetLost: null,
            onTargetUpdate: null,
            css: !1,
            visible: !1
        };
        return this.anchors.push(a), this.scene.add(t), a;
    }
    addCSSAnchor(e) {
        const t = new (0, $d5b33d7c30034067$export$eb2fcfdbd7ba97d4)();
        t.visible = !1, t.matrixAutoUpdate = !1;
        const a = {
            group: t,
            targetIndex: e,
            onTargetFound: null,
            onTargetLost: null,
            onTargetUpdate: null,
            css: !0,
            visible: !1
        };
        return this.anchors.push(a), this.cssScene.add(t), a;
    }
    _startVideo() {
        return new Promise((e, t)=>{
            if (this.video = document.createElement("video"), this.video.setAttribute("autoplay", ""), this.video.setAttribute("muted", ""), this.video.setAttribute("playsinline", ""), this.video.style.position = "absolute", this.video.style.top = "0px", this.video.style.left = "0px", this.video.style.zIndex = "-2", this.container.appendChild(this.video), !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                this.ui.showCompatibility(), t();
                return;
            }
            const a = {
                audio: !1,
                video: {}
            };
            this.shouldFaceUser ? this.userDeviceId ? a.video.deviceId = {
                exact: this.userDeviceId
            } : a.video.facingMode = "user" : this.environmentDeviceId ? a.video.deviceId = {
                exact: this.environmentDeviceId
            } : a.video.facingMode = "environment", navigator.mediaDevices.getUserMedia(a).then((r)=>{
                this.video.addEventListener("loadedmetadata", ()=>{
                    this.video.setAttribute("width", this.video.videoWidth), this.video.setAttribute("height", this.video.videoHeight), e();
                }), this.video.srcObject = r;
            }).catch((r)=>{
                console.log("getUserMedia error", r), t();
            });
        });
    }
    _startAR() {
        return new Promise(async (e, t)=>{
            const a = this.video;
            this.container, this.controller = new (0, $0qVX1.C)({
                inputWidth: a.videoWidth,
                inputHeight: a.videoHeight,
                filterMinCF: this.filterMinCF,
                filterBeta: this.filterBeta,
                warmupTolerance: this.warmupTolerance,
                missTolerance: this.missTolerance,
                maxTrack: this.maxTrack,
                onUpdate: (n)=>{
                    if (n.type === "updateMatrix") {
                        const { targetIndex: u, worldMatrix: o } = n;
                        for(let p = 0; p < this.anchors.length; p++)if (this.anchors[p].targetIndex === u) {
                            if (this.anchors[p].css ? this.anchors[p].group.children.forEach((m)=>{
                                m.element.style.visibility = o === null ? "hidden" : "visible";
                            }) : this.anchors[p].group.visible = o !== null, o !== null) {
                                let m = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
                                m.elements = [
                                    ...o
                                ], m.multiply(this.postMatrixs[u]), this.anchors[p].css && m.multiply($126c3ebbcc6243ba$var$Ni), this.anchors[p].group.matrix = m;
                            } else this.anchors[p].group.matrix = $126c3ebbcc6243ba$var$Xb;
                            this.anchors[p].visible && o === null && (this.anchors[p].visible = !1, this.anchors[p].onTargetLost && this.anchors[p].onTargetLost()), !this.anchors[p].visible && o !== null && (this.anchors[p].visible = !0, this.anchors[p].onTargetFound && this.anchors[p].onTargetFound()), this.anchors[p].onTargetUpdate && this.anchors[p].onTargetUpdate();
                        }
                        this.anchors.reduce((p, m)=>p || m.visible, !1) ? this.ui.hideScanning() : this.ui.showScanning();
                    }
                }
            }), this.resize();
            const { dimensions: r } = await this.controller.addImageTargets(this.imageTargetSrc);
            this.postMatrixs = [];
            for(let n = 0; n < r.length; n++){
                const u = new (0, $d5b33d7c30034067$export$64b5c384219d3699)(), o = new (0, $d5b33d7c30034067$export$23d6a54f0bbc85a3)(), l = new (0, $d5b33d7c30034067$export$64b5c384219d3699)(), [p, m] = r[n];
                u.x = p / 2, u.y = p / 2 + (m - p) / 2, l.x = p, l.y = p, l.z = p;
                const c = new (0, $d5b33d7c30034067$export$2ae72fc923e5eb5)();
                c.compose(u, o, l), this.postMatrixs.push(c);
            }
            await this.controller.dummyRun(this.video), this.ui.hideLoading(), this.ui.showScanning(), this.controller.processVideo(this.video), e();
        });
    }
    resize() {
        const { renderer: e, cssRenderer: t, camera: a, container: r, video: n } = this;
        if (!n) return;
        this.video.setAttribute("width", this.video.videoWidth), this.video.setAttribute("height", this.video.videoHeight);
        let u, o;
        const l = n.videoWidth / n.videoHeight, p = r.clientWidth / r.clientHeight;
        l > p ? (o = r.clientHeight, u = o * l) : (u = r.clientWidth, o = u / l);
        const m = this.controller.getProjectionMatrix(), c = this.controller.inputWidth / this.controller.inputHeight;
        let d;
        c > p ? d = this.video.width / this.controller.inputWidth : d = this.video.height / this.controller.inputHeight;
        let h, N;
        c > p ? (h = r.clientHeight, h *= d) : (N = r.clientWidth, h = N / this.controller.inputWidth * this.controller.inputHeight, h *= d);
        let g = r.clientHeight / h;
        const f = 2 * Math.atan(1 / m[5] * g) * 180 / Math.PI, b = m[14] / (m[10] - 1), O = m[14] / (m[10] + 1);
        m[5], m[0], a.fov = f, a.near = b, a.far = O, a.aspect = r.clientWidth / r.clientHeight, a.updateProjectionMatrix(), n.style.top = -(o - r.clientHeight) / 2 + "px", n.style.left = -(u - r.clientWidth) / 2 + "px", n.style.width = u + "px", n.style.height = o + "px";
        const _ = e.domElement, T = t.domElement;
        _.style.position = "absolute", _.style.left = 0, _.style.top = 0, _.style.width = r.clientWidth + "px", _.style.height = r.clientHeight + "px", T.style.position = "absolute", T.style.left = 0, T.style.top = 0, T.style.width = r.clientWidth + "px", T.style.height = r.clientHeight + "px", e.setSize(r.clientWidth, r.clientHeight), t.setSize(r.clientWidth, r.clientHeight);
    }
}
window.MINDAR || (window.MINDAR = {});
window.MINDAR.IMAGE || (window.MINDAR.IMAGE = {});
window.MINDAR.IMAGE.MindARThree = $126c3ebbcc6243ba$export$4f07dbbca44e3181;
window.MINDAR.IMAGE.tf = $126c3ebbcc6243ba$var$Qb;


class $c7faa030c2c9d8e6$export$ebef6260ff3c5d1e {
    constructor({ header: header, stepIntroContainer: stepIntroContainer, imageTargetSrc: imageTargetSrc, targetConfigs: targetConfigs, errorDiv: errorDiv, onExperienceFinished: onExperienceFinished, onTargetMatched: onTargetMatched }){
        this.introAdvanced = false;
        this.introStarted = false;
        this.targets = [];
        this.redirectTimeout = null;
        this.loader = new (0, $559434fcc6e6401d$export$aa93f11e7884f0f4)();
        this.header = header;
        this.stepIntroContainer = stepIntroContainer;
        this.imageTargetSrc = imageTargetSrc;
        this.targetConfigs = targetConfigs;
        this.errorDiv = errorDiv;
        this.onExperienceFinished = onExperienceFinished;
        this.onTargetMatched = onTargetMatched;
        this.mindarThree = new (0, $126c3ebbcc6243ba$export$4f07dbbca44e3181)({
            container: document.querySelector('#container'),
            imageTargetSrc: this.imageTargetSrc,
            filterMinCF: 0.001,
            filterBeta: 0.001,
            warmupTolerance: 20,
            missTolerance: 5,
            autoStart: false,
            uiScanning: false
        });
    }
    cleanupIntroListeners() {
        if (this.introAdvanceHandler) {
            document.removeEventListener('touchstart', this.introAdvanceHandler);
            document.removeEventListener('click', this.introAdvanceHandler);
            this.introAdvanceHandler = undefined;
        }
    }
    startIntroAdvance(configName) {
        if (this.introStarted) return;
        this.introStarted = true;
        this.stepIntroContainer.style.display = 'none';
        this.header.classList.add('hidden');
        this.introAdvanceHandler = ()=>{
            this.advanceIntro(configName);
        };
        document.addEventListener('touchstart', this.introAdvanceHandler, {
            once: true
        });
        document.addEventListener('click', this.introAdvanceHandler, {
            once: true
        });
        this.redirectTimeout = window.setTimeout(()=>{
            this.advanceIntro(configName);
        }, 4000);
    }
    advanceIntro(configName) {
        if (this.introAdvanced) return;
        this.introAdvanced = true;
        if (this.redirectTimeout) {
            window.clearTimeout(this.redirectTimeout);
            this.redirectTimeout = null;
        }
        this.cleanupIntroListeners();
        this.onExperienceFinished?.(configName);
        const front = document.getElementById('intro');
        front?.classList.remove('hidden');
        front?.classList.add('active');
    }
    applyModelSettings(model, config) {
        model.visible = false;
        model.scale.set(...config.scale);
        model.position.set(...config.position);
        model.traverse((node)=>{
            if (node.isMesh) node.renderOrder = 2;
        });
    }
    disposeModel(model) {
        if (!model) return;
        model.traverse((node)=>{
            const mesh = node;
            if (!mesh.isMesh) return;
            mesh.geometry?.dispose();
            const material = mesh.material;
            if (Array.isArray(material)) material.forEach((mat)=>mat.dispose());
            else material?.dispose();
        });
    }
    loadModelIntoRuntime(runtime, modelUrl) {
        return new Promise((resolve, reject)=>{
            this.loader.load(modelUrl, (glb)=>{
                const model = glb.scene;
                this.applyModelSettings(model, runtime.config);
                runtime.model = model;
                runtime.mixer = new $d5b33d7c30034067$export$fbd77e5aefaa0102(model);
                if (glb.animations.length > 0) {
                    const clip = glb.animations[0];
                    const action = runtime.mixer.clipAction(clip);
                    const isIntro = runtime.config.name === 'intro';
                    if (isIntro) {
                        action.clampWhenFinished = true;
                        action.loop = $d5b33d7c30034067$export$d62fdc9d1b1cccad;
                    } else {
                        action.clampWhenFinished = false;
                        action.setLoop($d5b33d7c30034067$export$dfaf4422ce096e29, Infinity);
                    }
                    runtime.action = action;
                } else runtime.action = null;
                runtime.anchor.group.add(model);
                resolve();
            }, undefined, (err)=>{
                console.error(`Erro ao carregar modelo ${runtime.config.name}`, err);
                reject(err);
            });
        });
    }
    async replaceModel(targetName, modelUrl) {
        const runtime = this.targets.find((target)=>target.config.name === targetName);
        if (!runtime) {
            console.warn(`Target n\xe3o encontrado para troca de modelo: ${targetName}`);
            return;
        }
        if (runtime.config.modelUrl === modelUrl) {
            console.log(`Modelo j\xe1 est\xe1 aplicado em ${targetName}`);
            return;
        }
        const previousModel = runtime.model;
        const wasVisible = previousModel ? previousModel.visible : false;
        if (previousModel) {
            runtime.anchor.group.remove(previousModel);
            this.disposeModel(previousModel);
        }
        runtime.model = null;
        runtime.mixer = null;
        runtime.action = null;
        runtime.config.modelUrl = modelUrl;
        await this.loadModelIntoRuntime(runtime, modelUrl);
        const loadedModel = runtime.model;
        const loadedAction = runtime.action;
        if (loadedModel !== null) loadedModel.visible = wasVisible;
        if (wasVisible && loadedAction !== null) {
            loadedAction.reset();
            loadedAction.play();
        }
        console.log(`Modelo trocado com sucesso para ${targetName}:`, modelUrl);
    }
    async init() {
        const page = document.body.dataset.page || '';
        const { renderer: renderer, scene: scene, camera: camera } = this.mindarThree;
        camera.near = 0.001;
        try {
            await this.mindarThree.start();
            console.log('MindAR iniciou com sucesso');
        } catch (error) {
            console.error('Erro ao iniciar o MindARThree:', error);
            if (this.errorDiv) this.errorDiv.style.display = 'flex';
            return;
        }
        const ambientLight = new $d5b33d7c30034067$export$af279bfef9ec2c96(0xffffff, 1);
        scene.add(ambientLight);
        ambientLight.position.set(0, 3, 3);
        for (const config of this.targetConfigs){
            const anchor = this.mindarThree.addAnchor(config.index);
            const runtime = {
                config: config,
                anchor: anchor,
                model: null,
                occluder: null,
                mixer: null,
                action: null
            };
            await this.loadModelIntoRuntime(runtime, config.modelUrl);
            if (config.occluderUrl) this.loader.load(config.occluderUrl, (glb)=>{
                const occluder = glb.scene;
                occluder.visible = false;
                const occluderScale = config.occluderScale ?? config.scale;
                const occluderPosition = config.occluderPosition ?? config.position;
                occluder.scale.set(...occluderScale);
                occluder.position.set(...occluderPosition);
                occluder.traverse((node)=>{
                    if (node instanceof $d5b33d7c30034067$export$e176487c05830cc5) {
                        const material = node.material;
                        material.colorWrite = false;
                        node.renderOrder = 1;
                    }
                });
                runtime.occluder = occluder;
                anchor.group.add(occluder);
            }, undefined, (err)=>{
                console.error(`Erro ao carregar occluder ${config.name}`, err);
            });
            anchor.onTargetFound = ()=>{
                console.log('Target detectado:', config.name, 'page:', page);
                if (runtime.occluder) runtime.occluder.visible = true;
                if (runtime.model) runtime.model.visible = true;
                if (runtime.action) {
                    runtime.action.reset();
                    runtime.action.play();
                }
                if (page === 'intro') this.startIntroAdvance(config.name);
                else {
                    this.onTargetMatched?.(config.name);
                    document.querySelector('.target-text')?.classList.add('hidden');
                }
            };
            anchor.onTargetLost = ()=>{
                console.log('Target perdido:', config.name);
                if (runtime.model) runtime.model.visible = false;
                if (runtime.occluder) runtime.occluder.visible = false;
            };
            this.targets.push(runtime);
        }
        const clock = new $d5b33d7c30034067$export$9735c82c4bae3302();
        const animate = ()=>{
            requestAnimationFrame(animate);
            const delta = clock.getDelta();
            for (const target of this.targets)target.mixer?.update(delta);
            renderer.render(scene, camera);
        };
        animate();
        window.addEventListener('resize', ()=>{
            camera.aspect = window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();
            renderer.setSize(window.innerWidth, window.innerHeight);
        });
        renderer.setAnimationLoop(()=>{
            renderer.render(scene, camera);
        });
    }
    async stop() {
        await this.mindarThree.stop();
        this.mindarThree.renderer.setAnimationLoop(null);
        this.cleanupIntroListeners();
        if (this.redirectTimeout) {
            window.clearTimeout(this.redirectTimeout);
            this.redirectTimeout = null;
        }
    }
}



var $8CkzA = parcelRequire("8CkzA");
var $ee20013503220a8a$exports = {};
$ee20013503220a8a$exports = JSON.parse('{"common":{"continue":"CONTINUAR","back":"Voltar","ok":"OK","skip_step":"PULAR ETAPA","confirm":"CONFIRMAR","your_answer":"SUA RESPOSTA","required_answer":"VOC\xca PRECISA ESCREVER UMA RESPOSTA","insert_keyword":"Insira a palavra-chave corretamente para desativar o sistema"},"intro":{"point_phone_totem":"Aponte o celular para esta imagem","target_title":"Para come\xe7ar, o sistema precisa detectar voc\xea.","target_text":"Encontre a imagem inicial no Ponto Epix, na Rua B entre as ruas 5 e 6, pr\xf3ximo \xe0 \xe1rea B2B.","story_1_title":"Um colapso dimensional est\xe1 acontecendo na <span class=\\"highlight-white\\">gamescom latam.</span>","story_1_text":"Os portais dos quatro mundos \u2014 <span class=\\"highlight-white\\">Hero, Shadow, Neo e Open</span> \u2014 est\xe3o se desestabilizando. Fragmentos de realidade se espalham pelo evento.","story_2_title":"Voc\xea foi escolhido como o Guardi\xe3o dos Portais.","story_2_text":"Sua miss\xe3o: percorrer os mundos, decifrar enigmas e provar que entende a ess\xeancia de cada um.","story_3_title":"A cada acerto, um fragmento \xe9 coletado.","story_3_text":"No final, a chave para o Grande Pr\xeamio ser\xe1 revelada.","story_3_call":"Voc\xea aceita o chamado?","prizes_intro":"Estas s\xe3o as poss\xedveis recompensas por restaurar o equil\xedbrio dos nossos mundos. Siga em frente, Guardi\xe3o.","prize_exclusive_items":"ITENS EXCLUSIVOS","prize_list_item_1":"CAMISETA EXCLUSIVA DOS MUNDOS DA GAMESCOM LATAM","prize_list_item_2":"CANECA EXCLUSIVA DOS MUNDOS DA GAMESCOM LATAM","prize_list_item_4":"GARRAFA EXCLUSIVA GAMESCOM LATAM","prize_list_item_5":"PINS EXCLUSIVOS GAMESCOM LATAM","prizes_warning":"E mais! Verifique a lista completa na \xe1rea de retirada dos brindes no Ponto Epix, na Rua B entre as ruas 5 e 6, pr\xf3ximo \xe0 \xe1rea B2B. Lembrando, os brindes estar\xe3o sujeitos \xe0 disponibilidade de estoque.","form_title":"O sistema dimensional detectou voc\xea.","form_text_1":"Antes de atravessar os portais, precisamos saber quem \xe9 o Guardi\xe3o.","form_text_2":"Registre-se. Sua jornada come\xe7a agora.","guardian_data":"Dados do Guardi\xe3o","name_label":"NOME","name_placeholder":"Nome","gender_label":"G\xcaNERO","gender_placeholder":"Selecione","gender_male":"Masculino","gender_female":"Feminino","gender_other":"Outro","birthdate_label":"DATA DE NASCIMENTO","birthdate_placeholder":"00/00/0000","document_label":"CPF | PASSAPORTE","email_label":"E-MAIL","email_placeholder":"E-MAIL","accept_terms":"Aceitar os termos de uso","tutorial_text_1":"Voc\xea enfrentar\xe1 enigmas de cada mundo. Alguns exigir\xe3o palavras-chave escondidas na <span class=\\"highlight-white\\">gamescom latam.</span>","tutorial_text_2":"Outros testar\xe3o seu conhecimento sobre os universos que tanto ama. <span class=\\"highlight-white\\">Esteja atento!</span>","zone_intro_title":"O primeiro portal se abre. Uma n\xe9voa densa esconde criaturas ancestrais.","zone_intro_text":"Para atravessar, voc\xea precisa encontrar a palavra que ecoa como um grito silencioso. Voc\xea sente o ar mais frio vindo da <span style=\\"color:#AD4CFF\\">Shadow Zone.</span>"},"shadowzone":{"point_phone_totem":"Aponte o celular para esta imagem","target_title":"Voc\xea precisa encontrar a palavra secreta para seguir.","target_text":"Use a realidade aumentada para identificar a imagem escondida na Shadow Zone.","success_title":"Voc\xea ouve sua voz ecoando distorcida","success_text":"A n\xe9voa se dissipa, o caminho at\xe9 um fragmento se torna claro e voc\xea o recupera.","failure_title":"A palavra n\xe3o surte efeito algum e a n\xe9voa parece ainda mais densa.","failure_text":"Tente novamente, Guardi\xe3o.","option_a_title":"Experimente de forma in\xe9dita este jogo na gamescom latam agora mesmo!","synopsis_placeholder":"Explore de forma in\xe9dita uma Gotham reimaginada, onde o humor cl\xe1ssico da franquia LEGO se une \xe0 atmosfera \xe9pica do Cavaleiro das Trevas em uma jornada inesquec\xedvel por gera\xe7\xf5es de hero\xedsmo.","visit_text":"<span class=\\"highlight-hero bold\\">Visite o estande da Warner Games!</span>","address":"Rua E, esquina com a Rua 3. Para mais informa\xe7\xf5es, consulte o mapa oficial.","zone_intro_title":"O segundo portal se abre. O clima dist\xf3pico com tecnologias inimagin\xe1veis e cidades tingidas de neon parece estranhamente familiar.","zone_intro_text":"O sistema \xe0 sua frente est\xe1 corrompido. Para burlar os protocolos de defesa e encontrar um dos fragmentos, voc\xea precisa da palavra de acesso que s\xf3 os verdadeiros rebeldes conhecem. Por meio dos rastros de dados voc\xea segue rumo \xe0 <span class=\\"highlight-neo\\">Neo Zone</span>."},"neozone":{"point_phone_totem":"Aponte o celular para esta imagem","target_title":"A palavra deve estar escondida na Neo Zone.","target_text":"Use seu smartphone para rastre\xe1-la. Ligue a c\xe2mera e procure ao seu redor.","success_title":"O glitch foi resolvido","success_text":"Com o sistema estabilizado o fragmento se manifesta ao alcance de suas m\xe3os","failure_title":"C\xf3digo incorreto. O alarme dispara.","failure_text":"Tente novamente, Guardi\xe3o.","question_title":"Guardi\xe3o, sua jornada pelos mundos exige uma percep\xe7\xe3o que desafia os limites do comum.","question_prompt":" Para restaurar o equil\xedbrio e dissipar a n\xe9voa do caos, voc\xea deve acessar a for\xe7a que sustenta este multiverso: <span class=\\"highlight-neo-regular\\"> as tecnologias GeForce RTX, </span>que est\xe3o revolucionando os jogos.","question_title_2":"Esque\xe7a as amarras da lat\xeancia.","question_prompt_2":"Aqui, o fluxo dos mundos \xe9 constante, permitindo uma imers\xe3o completa onde o lag inexiste e a fluidez \xe9 absoluta. Desde a ascens\xe3o do DLSS 4 com seus modelos Transformers, redefinimos a realidade. <span class=\\"highlight-neo-regular\\"> Agora, com o novo DLSS 4.5 Super Resolution, a nitidez alcan\xe7a um patamar divino atrav\xe9s de modelos de IA de segunda gera\xe7\xe3o,</span> dispon\xedveis para todos os portadores de GPUs GeForce RTX.","question_prompt_3":"GeForce RTX S\xe9rie 50, o tempo se curva \xe0 sua vontade: <span class=\\"highlight-neo-regular\\">o Dynamic Multi Frame Generation expande a realidade em at\xe9 6 vezes mais quadros,</span> garantindo que seus sentidos nunca percam um detalhe.","question_option_a":"<span class=\\"highlight-white\\">A)</span> SIM (Ir conhecer <span class=\\"highlight-neo\\">ESTANDE DA NVIDIA</span>)","question_option_b":"<span class=\\"highlight-white\\">B)</span> N\xc3O (Continuar aventura)","option_a_title":"O pr\xf3ximo fragmento da sua evolu\xe7\xe3o o aguarda.","synopsis":"Atravesse as fronteiras digitais e<span class=\\"highlight-neo\\"> visite o estande da NVIDIA na gamescom latam </span>para testemunhar a forja da perfei\xe7\xe3o visual e a fluidez que guia o futuro.","address":"Rua E, esquina com a Rua 2. Para mais informa\xe7\xf5es, consulte o mapa oficial","option_a_button":"AVALIE A EXPERI\xcaNCIA DA NVIDIA","review_intro":"Depois de conhecer este universo tecnol\xf3gico","review_title":"Conte suas impress\xf5es sobre o Estande da NVIDIA","rating":{"gamesSelection":"SELE\xc7\xc3O DE JOGOS","lines":"FILAS","gift":"BRINDES","service":"ATENDIMENTOS"},"review_optional":"SENTIU FALTA DE ALGO? <span class=\\"highlight-white\\">CONTA PRA GENTE</span>","review_confirm":"CONFIRMAR","zone_intro_title":"O portal te mostra um lugar onde as possibilidades s\xe3o infinitas","zone_intro_text":"voc\xea v\xea o fragmento, em um lugar fora do alcance. J\xe1 conhecendo o poder inato das palavras, voc\xea segue para a <span class=\\"highlight-open\\">Open Zone</span>."},"openzone":{"point_phone_totem":"Aponte o celular para esta imagem","target_title":"A realidade \xe9 sua para moldar.","target_text":"Encontre a palavra na Open Zone.","success_title":"Obedecendo seu comando","success_text":"Blocos se encaixam em uma escada rumo ao fragmento. O mundo reconhece seu criador.","failure_title":"Ao lan\xe7ar a palavra, a constru\xe7\xe3o desaba","failure_text":"Comece de novo","option_a_title":"Sinta o peso do legado de um verdadeiro her\xf3i no multiverso de<span class=\\"highlight-hero-bigger\\"> Invincible</span>","synopsis_placeholder":"Enfrente amea\xe7as de escala global e prove que sua for\xe7a \xe9 necess\xe1ria para proteger a realidade. Uma experi\xeancia de combate visceral que desafia tudo o que voc\xea sabe sobre her\xf3is e vil\xf5es aguarda sua chegada.","visit_text":"<span class=\\"highlight-hero bold\\">Visite o estande da Invincible VS e mostre seu valor!</span>","address":"Rua 5, esquina com a Rua F. Para mais informa\xe7\xf5es, consulte o mapa oficial.","question_prompt":"Chegou a hora de rever seus combates e, com sinceridade, fazer sua avalia\xe7\xe3o","review_title":"Conte suas impress\xf5es sobre o INVINCIBLE VS","review_optional":"Quer falar algo sobre <span class=\\"highlight-white\\">Invincible VS</span>?","rating":{"graphics":"GR\xc1FICOS","gameplay":"JOGABILIDADE","fun":"DIVERS\xc3O","challenge":"DESAFIO","ambience":"AMBIENTA\xc7\xc3O"},"extra_title":"Mergulhe em um mundo onde artes marciais ancestrais encontram m\xe1quinas a vapor em um espet\xe1culo visual de tirar o f\xf4lego","extra_synopsis":"Em <span class=\\"highlight-white\\"> Phantom Blade Zero </span>, voc\xea \xe9 um assassino de elite em uma corrida contra o tempo para desmascarar conspira\xe7\xf5es sombrias e restaurar a honra em um universo \'Kungfupunk\' brutal e fascinante.","extra_highlight":"EXPERIMENTE DE FORMA IN\xc9DITA ESTE JOGO NA GAMESCON LATAM AGORA MESMO!","extra_cta":"Visite o estande para dominar a l\xe2mina fantasma!","extra_button":"CONTINUAR","zone_intro_title":"\xdaltimo portal: A <span class=\\"highlight-hero-bigger\\">Hero Zone </span> se revela. Uma lenda antiga pede sua ajuda","zone_intro_text":"Para inscrever runas em sua espada lend\xe1ria, busque a palavra que te trar\xe1 poder ilimitado. No cora\xe7\xe3o da <span class=\\"highlight-hero\\">Hero Zone</span> as palavras de poder est\xe3o escondidas"},"herozone":{"point_phone_totem":"Aponte o celular para esta imagem","target_title":"Voc\xea est\xe1 se aproximando do fim. Use seu smartphone para localizar a palavra.","target_text":"O local para busc\xe1-la \xe9 na Hero Zone.","success_title":"Ao inscrever a palavra na espada, ela volta ao seu formato original","success_text":"Ela se transforma em um dos fragmentos que voc\xea busca","failure_title":"Voc\xea inscreve a palavra","failure_text":"Mas logo que termina ela desaparece e nada acontece. Tente novamente","option_a_title":"Os mundos colidem e os maiores her\xf3is da Terra precisam de um novo comando","option_a_button":"CONTINUAR","synopsis_placeholder":"Junte-se aos Vingadores e aos Guardi\xf5es nesta converg\xeancia de poderes extraordin\xe1rios para deter uma amea\xe7a que atravessa dimens\xf5es. A justi\xe7a precisa de voc\xea para que o equil\xedbrio da Marvel seja restaurado na gamescom latam.","visit_text":"Experimente de forma in\xe9dita este jogo na gamescom latam agora mesmo!","address":"Explore de forma antecipada Marvel Tokon na <span class=\\"highlight-hero\\">Hero Zone!</span>","zone_intro_title":"Fechando os olhos, voc\xea sente a energia dos fragmentos respondendo aos portais inst\xe1veis.","zone_intro_text_1":"Manipulando as energias de cada um dos fragmentos <span class=\\"highlight-hero\\">voc\xea abre simultaneamente os quatro portais, que te cercam em puro descontrole.</span>","zone_intro_text_2":"Cada palavra que voc\xea aprendeu retorna \xe0 sua mem\xf3ria, e ao declar\xe1-las em ordem, o caos d\xe1 lugar ao equil\xedbrio.<span class=\\"highlight-hero\\"> Seu dever como Guardi\xe3o foi cumprido.</span>"},"final":{"survey_intro":"Os portais est\xe3o est\xe1veis novamente e os caminhos para os mundos se tornam seguros. Mas antes de receber sua recompensa, o Conselho dos Mundos quer saber:","survey_title":"Por que voc\xea veio at\xe9 aqui?","rating_title":"D\xea uma nota de 1 a 5 para a experi\xeancia como um todo.(1 a 5)","question_why_title":"2 - O que te motivou a chegar at\xe9 o fim?","question_why_option_a":"<span class=\\"highlight-white\\">A)</span> A hist\xf3ria","question_why_option_b":"<span class=\\"highlight-white\\">B)</span> A premia\xe7\xe3o","question_why_option_c":"<span class=\\"highlight-white\\">C)</span> Fazer a atividade com amigos","question_why_option_d":"<span class=\\"highlight-white\\">D)</span> Curiosidade","question_world_title":"3 - Qual mundo voc\xea mais gostou?","question_world_option_a":"<span class=\\"highlight-white\\">A)</span> <span class=\\"highlight-shadow\\">Shadow Zone</span>","question_world_option_b":"<span class=\\"highlight-white\\">B)</span> <span class=\\"highlight-neo\\">Neo Zone</span>","question_world_option_c":"<span class=\\"highlight-white\\">C)</span> <span class=\\"highlight-hero\\">Hero Zone</span>","question_world_option_d":"<span class=\\"highlight-white\\">D)</span> <span class=\\"highlight-open\\">Open Zone</span>","review_optional":"Deixe um coment\xe1rio para o nosso time","survey_continue":"CONTINUAR","survey_modal_text":"Suas respostas ser\xe3o registradas na Grande Cr\xf4nica dos Guardi\xf5es","success_title":"A gamescom latam est\xe1 salva!","success_text":"Voc\xea, Guardi\xe3o, restaurou o equil\xedbrio dos quatro portais. Agora, o Conselho dos Mundos concede a voc\xea sua recompensa","success_text_highlight":"Voc\xea, Guardi\xe3o, <span class=\\"highlight-hero\\"> restaurou o equil\xedbrio dos quatro portais.</span> Agora, o Conselho dos Mundos concede a voc\xea sua recompensa","final_code_label":"AQUI EST\xc1 SEU C\xd3DIGO DE FINALIZA\xc7\xc3O","final_code_help":"Dirija-se \xe0 \xe1rea de retirada dos brindes, localizada no Ponto Epix, na Rua B entre as ruas 5 e 6, pr\xf3ximo \xe0 \xe1rea B2B e retire seus esp\xf3lios. Que sua lenda inspire os demais!","final_error_text":"Erro ao enviar c\xf3digo","final_retry_button":"TENTAR NOVAMENTE"}}');


var $f7f1de8e150b45e2$exports = {};
$f7f1de8e150b45e2$exports = JSON.parse('{"common":{"continue":"CONTINUE","back":"Back","ok":"OK","point_phone_totem":"Point your phone at the portal on the totem","skip_step":"SKIP STEP","confirm":"CONFIRM","your_answer":"YOUR ANSWER","required_answer":"YOU NEED TO WRITE AN ANSWER","insert_keyword":"Enter the keyword correctly to deactivate the system"},"intro":{"point_phone_totem":"Point your phone at this image","target_title":"To begin, the system needs to detect you.","target_text":"Point your device at the totem with the image above.","story_1_title":"A dimensional collapse is happening at <span class=\\"highlight-white\\">gamescom latam.</span>","story_1_text":"The portals of the four worlds \u2014 <span class=\\"highlight-white\\">Hero, Shadow, Neo and Open</span> \u2014 are becoming unstable. Fragments of reality are spreading across the event.","story_2_title":"You have been chosen as the Guardian of the Portals.","story_2_text":"Your mission: travel through the worlds, solve riddles and prove that you understand the essence of each one.","story_3_title":"With each success, a fragment is collected.","story_3_text":"In the end, the key to the Grand Prize will be revealed.","story_3_call":"Do you accept the call?","prizes_intro":"These are the possible rewards for restoring the balance of our worlds. Move forward, Guardian.","prize_exclusive_items":"EXCLUSIVE ITEMS","prize_list_item_1":"EXCLUSIVE GAMESCOM LATAM WORLDS T-SHIRT","prize_list_item_2":"EXCLUSIVE GAMESCOM LATAM WORLDS MUG","prize_list_item_4":"EXCLUSIVE GAMESCOM LATAM BOTTLE","prize_list_item_5":"EXCLUSIVE GAMESCOM LATAM PINS","prizes_warning":"And more! Check the complete list at the gift pick-up area at Ponto Epix, on Str B between Str 5 and 6, near the B2B area. Remember, gifts are subject to stock availability.","form_title":"The dimensional system has detected you.","form_text_1":"Before crossing the portals, we need to know who the Guardian is.","form_text_2":"Register yourself. Your journey begins now.","guardian_data":"Guardian Data","name_label":"NAME","name_placeholder":"Name","gender_label":"GENDER","gender_placeholder":"Select","gender_male":"Male","gender_female":"Female","gender_other":"Other","birthdate_label":"DATE OF BIRTH","birthdate_placeholder":"00/00/0000","document_label":"CPF | PASSPORT","email_label":"E-MAIL","email_placeholder":"E-MAIL","accept_terms":"Accept the terms of use","tutorial_text_1":"You will face riddles from each world. Some will require keywords hidden in <span class=\\"highlight-white\\">gamescom latam.</span>","tutorial_text_2":"Others will test your knowledge about the universes you love. <span class=\\"highlight-white\\">Stay alert!</span>","zone_intro_title":"The first portal opens. A dense fog hides ancient creatures.","zone_intro_text":"To cross, you must find the word that echoes like a silent scream. You feel colder air coming from the <span style=\\"color:#AD4CFF\\">Shadow Zone.</span>"},"shadowzone":{"point_phone_totem":"Point your phone at this image","target_title":"You need to find the secret word to proceed.","target_text":"Use augmented reality to identify the hidden image in the Shadow Zone.","success_title":"You hear your voice echoing in distortion","success_text":"The fog dissipates, the path to a fragment becomes clear and you recover it.","failure_title":"The word has no effect and the fog seems even denser.","failure_text":"Try again, Guardian.","option_a_title":"Experience this game like never before at gamescom latam right now!","synopsis_placeholder":"Explore a reimagined Gotham in a unique way, where the classic LEGO humor meets the epic atmosphere of the Dark Knight in an unforgettable journey across generations of heroism.","visit_text":"<span class=\\"highlight-hero bold\\">Visit the Warner Games booth!</span>","address":"Str E, corner of Str 3. For more information, consult the official map.","zone_intro_title":"The second portal opens. The dystopian atmosphere with unimaginable technologies and neon-colored cities feels strangely familiar.","zone_intro_text":"The system in front of you is corrupted. To bypass the defense protocols and find one of the fragments, you need the access word that only true rebels know. Following data trails, you move toward the <span class=\\"highlight-neo\\">Neo Zone</span>."},"neozone":{"point_phone_totem":"Point your phone at this image","target_title":"The word must be hidden in the Neo Zone.","target_text":"Use your smartphone to track it. Turn on your camera and look around.","success_title":"The glitch has been resolved","success_text":"With the system stabilized, the fragment manifests within your reach","failure_title":"Incorrect code. The alarm is triggered.","failure_text":"Try again, Guardian.","question_title":"Guardian, your journey through the worlds demands a perception that challenges the limits of the ordinary.","question_prompt":"To restore balance and dissipate the fog of chaos, you must access the force that sustains this multiverse: <span class=\\"highlight-neo-regular\\">GeForce RTX technologies</span>, which are revolutionizing gaming.","question_title_2":"Break free from the constraints of latency.","question_prompt_2":"Here, the flow of worlds is constant, allowing complete immersion where lag does not exist and fluidity is absolute. Since the rise of DLSS 4 with its Transformer models, we have redefined reality. <span class=\\"highlight-neo-regular\\">Now, with the new DLSS 4.5 Super Resolution, sharpness reaches a divine level through second-generation AI models,</span> available to all GeForce RTX GPU users.","question_prompt_3":"For those seeking supremacy with GeForce RTX Series 50 GPUs, time bends to your will: <span class=\\"highlight-neo-regular\\">Dynamic Multi Frame Generation expands reality up to 6 times more frames,</span> ensuring your senses never miss a single detail.","question_option_a":"<span class=\\"highlight-white\\">A)</span> YES (Go visit the <span class=\\"highlight-neo\\">NVIDIA BOOTH</span>)","question_option_b":"<span class=\\"highlight-white\\">B)</span> NO (Continue the adventure)","option_a_title":"The next fragment of your evolution awaits you.","synopsis":"Cross digital boundaries and <span class=\\"highlight-neo\\">visit the NVIDIA booth at gamescom latam</span> to witness the forging of visual perfection and the fluidity that guides the future.","address":"Str E, corner of Str 2. For more information, consult the official map.","option_a_button":"EVALUATE THE NVIDIA EXPERIENCE","review_intro":"After experiencing this technological universe","review_title":"Share your impressions about the NVIDIA Booth","rating":{"gamesSelection":"GAME SELECTION","lines":"LINES","gift":"GIFTS","service":"SERVICE"},"review_optional":"DID YOU MISS ANYTHING? <span class=\\"highlight-white\\">TELL US</span>","review_confirm":"CONFIRM","zone_intro_title":"The portal shows you a place where possibilities are infinite","zone_intro_text":"you see the fragment, in a place out of reach. Already understanding the innate power of words, you move on to the <span class=\\"highlight-open\\">Open Zone</span>."},"openzone":{"point_phone_totem":"Point your phone at this image","target_title":"Reality is yours to shape.","target_text":"Find the word in the Open Zone.","success_title":"Obeying your command","success_text":"Blocks assemble into a staircase toward the fragment. The world recognizes its creator.","failure_title":"When casting the word, the structure collapses","failure_text":"Start again","option_a_title":"Feel the weight of a true hero\u2019s legacy in the multiverse of<span class=\\"highlight-hero-bigger\\"> Invincible</span>","synopsis_placeholder":"Face global-scale threats and prove your strength is necessary to protect reality. A visceral combat experience that challenges everything you know about heroes and villains awaits you.","visit_text":"<span class=\\"highlight-hero bold\\">Visit the Invincible VS booth and prove your worth!</span>","address":"Str 5, corner of Str F. For more information, consult the official map.","question_prompt":"It\u2019s time to review your battles and honestly evaluate your experience","review_title":"Share your impressions about INVINCIBLE VS","review_optional":"WANT TO SAY SOMETHING ABOUT <span class=\\"highlight-white\\">INVINCIBLE VS</span>?","rating":{"graphics":"GRAPHICS","gameplay":"GAMEPLAY","fun":"FUN","challenge":"CHALLENGE","ambience":"AMBIENCE"},"extra_title":"Dive into a world where ancient martial arts meet steam-powered machines in a breathtaking visual spectacle","extra_synopsis":"In <span class=\\"highlight-white\\"> Phantom Blade Zero </span>, you are an elite assassin in a race against time to uncover dark conspiracies and restore honor in a brutal and fascinating \'Kungfupunk\' universe.","extra_highlight":"EXPERIENCE THIS GAME LIKE NEVER BEFORE AT GAMESCON LATAM RIGHT NOW!","extra_cta":"Visit the booth and master the phantom blade!","extra_button":"CONTINUE","zone_intro_title":"Final portal: The <span class=\\"highlight-hero-bigger\\">Hero Zone </span> is revealed. An ancient legend calls for your help","zone_intro_text":"To inscribe runes on your legendary sword, seek the word that will grant you unlimited power. In the heart of the <span class=\\"highlight-hero\\">Hero Zone</span>, the words of power are hidden"},"herozone":{"point_phone_totem":"Point your phone at this image","target_title":"You are approaching the end. Use your smartphone to locate the word.","target_text":"The place to find it is in the Hero Zone.","success_title":"As you inscribe the word on the sword, it returns to its original form","success_text":"It transforms into one of the fragments you seek","failure_title":"You inscribe the word","failure_text":"But as soon as you finish, it disappears and nothing happens. Try again","option_a_title":"Worlds collide and Earth\u2019s greatest heroes need a new command","option_a_button":"CONTINUE","synopsis_placeholder":"Join the Avengers and the Guardians in this convergence of extraordinary powers to stop a threat that crosses dimensions. Justice needs you so balance can be restored at gamescom latam.","visit_text":"Experience this game like never before at gamescom latam right now!","address":"Explore Marvel Tokon early in the <span class=\\"highlight-hero\\">Hero Zone!</span>","zone_intro_title":"Closing your eyes, you feel the energy of the fragments responding to unstable portals.","zone_intro_text_1":"Manipulating the energies of each fragment <span class=\\"highlight-hero\\">you simultaneously open the four portals, surrounding you in pure chaos.</span>","zone_intro_text_2":"Each word you learned returns to your memory, and as you declare them in order, chaos gives way to balance.<span class=\\"highlight-hero\\"> Your duty as Guardian has been fulfilled.</span>"},"final":{"survey_intro":"The portals are stable again and the paths between worlds are safe. But before receiving your reward, the Council of Worlds wants to know:","survey_title":"Why did you come this far?","rating_title":"Rate the overall experience from 1 to 5.(1 to 5)","question_why_title":"2 - What motivated you to reach the end?","question_why_option_a":"<span class=\\"highlight-white\\">A)</span> The story","question_why_option_b":"<span class=\\"highlight-white\\">B)</span> The reward","question_why_option_c":"<span class=\\"highlight-white\\">C)</span> Doing the activity with friends","question_why_option_d":"<span class=\\"highlight-white\\">D)</span> Curiosity","question_world_title":"3 - Which world did you like the most?","question_world_option_a":"<span class=\\"highlight-white\\">A)</span> <span class=\\"highlight-shadow\\">Shadow Zone</span>","question_world_option_b":"<span class=\\"highlight-white\\">B)</span> <span class=\\"highlight-neo\\">Neo Zone</span>","question_world_option_c":"<span class=\\"highlight-white\\">C)</span> <span class=\\"highlight-hero\\">Hero Zone</span>","question_world_option_d":"<span class=\\"highlight-white\\">D)</span> <span class=\\"highlight-open\\">Open Zone</span>","review_optional":"Leave a comment for our team","survey_continue":"CONTINUE","survey_modal_text":"Your answers will be recorded in the Great Chronicle of Guardians","success_title":"gamescom latam has been saved!","success_text":"You, Guardian, restored the balance of the four portals. Now, the Council of Worlds grants you your reward","success_text_highlight":"You restored the balance of the portals","final_code_label":"Here is your completion code","final_code_help":"Head to the prize pick-up area, located at Ponto Epix, on Str B between Str 5 and Str 6, near the B2B area, and collect your prizes. May your legend inspire others!","final_error_text":"Error sending code","final_retry_button":"TRY AGAIN"}}');


function $6f61baceefcbd2f1$var$getDailyIndex(length) {
    const baseDate = new Date(2026, 3, 30); // mês começa em 0
    const today = new Date();
    baseDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    const diffInMs = today.getTime() - baseDate.getTime();
    const diffInDays = Math.floor(diffInMs / 86400000);
    return (diffInDays % length + length) % length;
}
var $a43e41389d6ce43e$exports = {};
$a43e41389d6ce43e$exports = import.meta.resolve("9dsuV");


var $7f990535db8cd902$exports = {};
$7f990535db8cd902$exports = import.meta.resolve("7MBEt");


var $ba3bcfe62322e6ed$exports = {};
$ba3bcfe62322e6ed$exports = import.meta.resolve("gOEit");


var $e844b7b29a1103e2$exports = {};
$e844b7b29a1103e2$exports = import.meta.resolve("aRfah");


var $9aba3a649e161aed$exports = {};
$9aba3a649e161aed$exports = import.meta.resolve("9yMOK");


var $b57aecc84ace3b31$exports = {};
$b57aecc84ace3b31$exports = import.meta.resolve("65bdw");


var $4dc35e0152486ced$exports = {};
$4dc35e0152486ced$exports = import.meta.resolve("kGavb");


var $1bfbab1689babd39$exports = {};
$1bfbab1689babd39$exports = import.meta.resolve("6d6nf");


var $ba4896bbf4c27f00$exports = {};
$ba4896bbf4c27f00$exports = import.meta.resolve("iWIuK");


var $dd7e76ff85e76642$exports = {};
$dd7e76ff85e76642$exports = import.meta.resolve("7L5HD");


var $e0bd193e434950a4$exports = {};
$e0bd193e434950a4$exports = import.meta.resolve("5EeSN");


var $162876a873a4bef5$exports = {};
$162876a873a4bef5$exports = import.meta.resolve("jSBOR");


var $59ac8e67a6116279$exports = {};
$59ac8e67a6116279$exports = import.meta.resolve("33sFe");


var $c01b508b96d7e8cd$exports = {};
$c01b508b96d7e8cd$exports = import.meta.resolve("kYpqz");


var $bb2591d76b2830a7$exports = {};
$bb2591d76b2830a7$exports = import.meta.resolve("i5ZyE");


var $15e5b248f5eb0349$exports = {};
$15e5b248f5eb0349$exports = import.meta.resolve("1AMny");


function $6f61baceefcbd2f1$export$ff299b10177b814f(page) {
    const models = {
        shadowzone: [
            new URL($a43e41389d6ce43e$exports).href,
            new URL($7f990535db8cd902$exports).href,
            new URL($ba3bcfe62322e6ed$exports).href,
            new URL($e844b7b29a1103e2$exports).href
        ],
        neozone: [
            new URL($9aba3a649e161aed$exports).href,
            new URL($b57aecc84ace3b31$exports).href,
            new URL($4dc35e0152486ced$exports).href,
            new URL($1bfbab1689babd39$exports).href
        ],
        openzone: [
            new URL($ba4896bbf4c27f00$exports).href,
            new URL($dd7e76ff85e76642$exports).href,
            new URL($e0bd193e434950a4$exports).href,
            new URL($162876a873a4bef5$exports).href
        ],
        herozone: [
            new URL($59ac8e67a6116279$exports).href,
            new URL($c01b508b96d7e8cd$exports).href,
            new URL($bb2591d76b2830a7$exports).href,
            new URL($15e5b248f5eb0349$exports).href
        ]
    };
    return models[page] || [];
}
function $6f61baceefcbd2f1$export$be488b83df1eb883(page) {
    const models = $6f61baceefcbd2f1$export$ff299b10177b814f(page);
    if (!models.length) return "";
    return models[$6f61baceefcbd2f1$var$getDailyIndex(models.length)];
}



var $kYLQ7 = parcelRequire("kYLQ7");
/* =========================================================
   I18N STATE
========================================================= */ const $0f592d681121713f$var$locales = {
    "pt-BR": (0, (/*@__PURE__*/$parcel$interopDefault($ee20013503220a8a$exports))),
    "en": (0, (/*@__PURE__*/$parcel$interopDefault($f7f1de8e150b45e2$exports)))
};
let $0f592d681121713f$var$currentLocale = {};
let $0f592d681121713f$var$currentLang = "pt-BR";
/* =========================================================
   AR STATE
========================================================= */ let $0f592d681121713f$var$arExperienceInstance = null;
let $0f592d681121713f$var$isStoppingCamera = false;
/* =========================================================
   HELPERS
========================================================= */ function $0f592d681121713f$var$normalizeLang(lang) {
    if (lang === "en") return "en";
    return "pt-BR";
}
var $5ba6da9908280d6b$exports = {};
$5ba6da9908280d6b$exports = import.meta.resolve("idiXb");


var $e0f27e47aa24ccf4$exports = {};
$e0f27e47aa24ccf4$exports = import.meta.resolve("kf3Ni");


function $0f592d681121713f$var$getIntroModelUrl(lang) {
    return lang === "en" ? new URL($5ba6da9908280d6b$exports).href : new URL($e0f27e47aa24ccf4$exports).href;
}
var $565254cde7ee9026$exports = {};
$565254cde7ee9026$exports = import.meta.resolve("9auQh");


var $3bd8d23001a30f15$exports = {};
$3bd8d23001a30f15$exports = import.meta.resolve("5SGa4");


var $aeb7a0522ad424f1$exports = {};
$aeb7a0522ad424f1$exports = import.meta.resolve("fC21e");


var $b06647a58f2ee883$exports = {};
$b06647a58f2ee883$exports = import.meta.resolve("i9i9m");


var $188562acb92a54bd$exports = {};
$188562acb92a54bd$exports = import.meta.resolve("7E6XR");


var $b7a7ed4b6874be40$exports = {};
$b7a7ed4b6874be40$exports = import.meta.resolve("2DgMB");


/* =========================================================
   AR CONFIG
========================================================= */ function $0f592d681121713f$var$getARConfigByPage(page, lang) {
    const sharedOccluder = new URL($565254cde7ee9026$exports).href;
    const configs = {
        intro: {
            imageTargetSrc: new URL($3bd8d23001a30f15$exports).href,
            targetConfigs: [
                {
                    index: 0,
                    name: "intro-target-1",
                    modelUrl: $0f592d681121713f$var$getIntroModelUrl(lang),
                    scale: [
                        1.7,
                        1.7,
                        1.7
                    ],
                    position: [
                        0,
                        -0.05,
                        0
                    ]
                }
            ]
        },
        shadowzone: {
            imageTargetSrc: new URL($aeb7a0522ad424f1$exports).href,
            targetConfigs: [
                {
                    index: 0,
                    name: "shadow-target-1",
                    modelUrl: (0, $6f61baceefcbd2f1$export$be488b83df1eb883)("shadowzone"),
                    occluderUrl: sharedOccluder,
                    scale: [
                        1.7,
                        1.7,
                        1.7
                    ],
                    position: [
                        0,
                        -0.05,
                        0
                    ],
                    occluderScale: [
                        1.7,
                        1.7,
                        1.7
                    ],
                    occluderPosition: [
                        0,
                        -0.05,
                        0
                    ]
                }
            ]
        },
        neozone: {
            imageTargetSrc: new URL($b06647a58f2ee883$exports).href,
            targetConfigs: [
                {
                    index: 0,
                    name: "neo-target-1",
                    modelUrl: (0, $6f61baceefcbd2f1$export$be488b83df1eb883)("neozone"),
                    occluderUrl: sharedOccluder,
                    scale: [
                        1.7,
                        1.7,
                        1.7
                    ],
                    position: [
                        0,
                        -0.05,
                        0
                    ],
                    occluderScale: [
                        1.7,
                        1.7,
                        1.7
                    ],
                    occluderPosition: [
                        0,
                        -0.05,
                        0
                    ]
                }
            ]
        },
        openzone: {
            imageTargetSrc: new URL($188562acb92a54bd$exports).href,
            targetConfigs: [
                {
                    index: 0,
                    name: "open-target-1",
                    modelUrl: (0, $6f61baceefcbd2f1$export$be488b83df1eb883)("openzone"),
                    occluderUrl: sharedOccluder,
                    scale: [
                        1.7,
                        1.7,
                        1.7
                    ],
                    position: [
                        0,
                        -0.05,
                        0
                    ],
                    occluderScale: [
                        1.7,
                        1.7,
                        1.7
                    ],
                    occluderPosition: [
                        0,
                        -0.05,
                        0
                    ]
                }
            ]
        },
        herozone: {
            imageTargetSrc: new URL($b7a7ed4b6874be40$exports).href,
            targetConfigs: [
                {
                    index: 0,
                    name: "hero-target-1",
                    modelUrl: (0, $6f61baceefcbd2f1$export$be488b83df1eb883)("herozone"),
                    occluderUrl: sharedOccluder,
                    scale: [
                        1.7,
                        1.7,
                        1.7
                    ],
                    position: [
                        0,
                        -0.05,
                        0
                    ],
                    occluderScale: [
                        1.7,
                        1.7,
                        1.7
                    ],
                    occluderPosition: [
                        0,
                        -0.05,
                        0
                    ]
                }
            ]
        }
    };
    return configs[page] || null;
}
var $8cc82762fb161d3b$exports = {};
$8cc82762fb161d3b$exports = import.meta.resolve("6emWt");


var $550df393228eaa72$exports = {};
$550df393228eaa72$exports = import.meta.resolve("7S5OX");


var $7479e173a9f0b560$exports = {};
$7479e173a9f0b560$exports = import.meta.resolve("5do7u");


var $a282d07c482278f3$exports = {};
$a282d07c482278f3$exports = import.meta.resolve("gKf6z");


function $0f592d681121713f$var$getPortalConfigByPage(page) {
    const portalConfig = {
        intro: {
            image: new URL($8cc82762fb161d3b$exports).href,
            hue: 280
        },
        shadowzone: {
            image: new URL($550df393228eaa72$exports).href,
            hue: 205
        },
        neozone: {
            image: new URL($7479e173a9f0b560$exports).href,
            hue: 28
        },
        openzone: {
            image: new URL($a282d07c482278f3$exports).href,
            hue: 42
        }
    };
    return portalConfig[page] || portalConfig["intro"];
}
/* =========================================================
   AR HELPERS
========================================================= */ async function $0f592d681121713f$var$stopCameraIfNeeded(page) {
    if (!$0f592d681121713f$var$arExperienceInstance || $0f592d681121713f$var$isStoppingCamera) return;
    $0f592d681121713f$var$isStoppingCamera = true;
    try {
        await $0f592d681121713f$var$arExperienceInstance.stop();
        document.getElementById("container")?.classList.add("hidden");
        console.log("C\xe2mera desligada");
    } catch (error) {
        console.error("Erro ao desligar a c\xe2mera:", error);
    } finally{
        $0f592d681121713f$var$isStoppingCamera = false;
    }
}
async function $0f592d681121713f$var$updateIntroModelByLanguage() {
    const page = document.body.dataset.page || "intro";
    if (page !== "intro") return;
    if (!$0f592d681121713f$var$arExperienceInstance) return;
    const introModelUrl = $0f592d681121713f$var$getIntroModelUrl($0f592d681121713f$var$currentLang);
    await $0f592d681121713f$var$arExperienceInstance.replaceModel("intro-target-1", introModelUrl);
}
function $0f592d681121713f$var$observeScreenChange(page) {
    const check = ()=>{
        const questionActive = document.getElementById("question")?.classList.contains("active");
        const introActive = document.querySelector(".front.intro")?.classList.contains("active");
        if (questionActive || introActive) {
            console.log("Tela sem AR ativa \u2192 desligando c\xe2mera");
            $0f592d681121713f$var$stopCameraIfNeeded(page);
        }
    };
    const observer = new MutationObserver(check);
    document.body.querySelectorAll(".front").forEach((el)=>{
        observer.observe(el, {
            attributes: true,
            attributeFilter: [
                "class"
            ]
        });
    });
    check();
}
/* =========================================================
   AR INIT
========================================================= */ function $0f592d681121713f$var$initAR(page) {
    const header = document.getElementById("header");
    const arContainer = document.getElementById("stepIntroContainer") || document.getElementById("stepNeoZoneContainer");
    const arConfig = $0f592d681121713f$var$getARConfigByPage(page, $0f592d681121713f$var$currentLang);
    if (!header || !arContainer || !arConfig) return;
    $0f592d681121713f$var$arExperienceInstance = new (0, $c7faa030c2c9d8e6$export$ebef6260ff3c5d1e)({
        header: header,
        stepIntroContainer: arContainer,
        imageTargetSrc: arConfig.imageTargetSrc,
        targetConfigs: arConfig.targetConfigs,
        onTargetMatched: async (targetName)=>{
            console.log("Target encontrado:", page, targetName);
            const imageTarget = document.getElementById("image-target");
            const firstText = document.getElementById("text-step-1");
            const secondText = document.getElementById("text-step-2");
            imageTarget?.classList.add("hidden");
            firstText?.classList.add("hidden");
            secondText?.classList.remove("hidden");
        }
    });
    $0f592d681121713f$var$arExperienceInstance.init();
}
function $0f592d681121713f$var$initPortal(page) {
    const canvas = document.getElementById("portalCanvas");
    if (!canvas) return;
    const config = $0f592d681121713f$var$getPortalConfigByPage(page);
    new (0, $8CkzA.PortalCanvas)(canvas, {
        imageSrc: config.image,
        hue: config.hue
    }).init();
}
/* =========================================================
   I18N HELPERS
========================================================= */ function $0f592d681121713f$var$getNestedValue(obj, path) {
    return path.split(".").reduce((acc, part)=>acc?.[part], obj);
}
function $0f592d681121713f$var$updateLanguageButtonsUI() {
    const buttons = document.querySelectorAll("[data-lang]");
    buttons.forEach((button)=>{
        button.classList.remove("active-lang");
    });
    const activeButton = document.querySelector(`[data-lang="${$0f592d681121713f$var$currentLang}"]`);
    activeButton?.classList.add("active-lang");
}
function $0f592d681121713f$var$applyTranslations() {
    document.documentElement.lang = $0f592d681121713f$var$currentLang;
    document.querySelectorAll("[data-i18n]").forEach((el)=>{
        const key = el.dataset.i18n;
        if (!key) return;
        const value = $0f592d681121713f$var$getNestedValue($0f592d681121713f$var$currentLocale, key);
        if (typeof value === "string") el.textContent = value;
    });
    document.querySelectorAll("[data-i18n-html]").forEach((el)=>{
        const key = el.dataset.i18nHtml;
        if (!key) return;
        const value = $0f592d681121713f$var$getNestedValue($0f592d681121713f$var$currentLocale, key);
        if (typeof value === "string") el.innerHTML = value;
    });
    document.querySelectorAll("[data-i18n-placeholder]").forEach((el)=>{
        const key = el.dataset.i18nPlaceholder;
        if (!key) return;
        const value = $0f592d681121713f$var$getNestedValue($0f592d681121713f$var$currentLocale, key);
        if (typeof value === "string") el.placeholder = value;
    });
    document.querySelectorAll("option[data-i18n]").forEach((el)=>{
        const key = el.dataset.i18n;
        if (!key) return;
        const value = $0f592d681121713f$var$getNestedValue($0f592d681121713f$var$currentLocale, key);
        if (typeof value === "string") el.textContent = value;
    });
}
function $0f592d681121713f$var$loadLocale(lang) {
    const safeLang = lang === "en" ? "en" : "pt-BR";
    $0f592d681121713f$var$currentLang = safeLang;
    $0f592d681121713f$var$currentLocale = $0f592d681121713f$var$locales[safeLang];
    localStorage.setItem("lang", safeLang);
    $0f592d681121713f$var$applyTranslations();
    $0f592d681121713f$var$updateLanguageButtonsUI();
}
/* =========================================================
   LANGUAGE BUTTONS
========================================================= */ function $0f592d681121713f$var$setupLanguageButtons() {
    const buttons = document.querySelectorAll("[data-lang]");
    buttons.forEach((button)=>{
        button.addEventListener("click", async (event)=>{
            event.preventDefault();
            const lang = button.dataset.lang;
            if (!lang) return;
            const nextLang = $0f592d681121713f$var$normalizeLang(lang);
            if (nextLang === $0f592d681121713f$var$currentLang) return;
            $0f592d681121713f$var$loadLocale(nextLang);
            await $0f592d681121713f$var$updateIntroModelByLanguage();
        });
    });
}
/* =========================================================
   APP INIT
========================================================= */ async function $0f592d681121713f$var$initApp() {
    const page = document.body.dataset.page || "intro";
    const savedLang = $0f592d681121713f$var$normalizeLang(localStorage.getItem("lang") || "pt-BR");
    try {
        const response = await (0, $kYLQ7.api).isActive();
        if (!response.data.active) {
            console.log("A experi\xeancia ainda n\xe3o est\xe1 ativa. Por favor, tente novamente mais tarde.");
            window.location.href = './inactive.html';
            return;
        }
    } catch (error) {
        console.error("Erro ao verificar o status da experi\xeancia:", error);
    }
    $0f592d681121713f$var$setupLanguageButtons();
    $0f592d681121713f$var$loadLocale(savedLang);
    $0f592d681121713f$var$initAR(page);
    $0f592d681121713f$var$initPortal(page);
    $0f592d681121713f$var$observeScreenChange(page);
}
window.addEventListener("DOMContentLoaded", $0f592d681121713f$var$initApp);
var $d310e0954043a667$exports = {};
$d310e0954043a667$exports = import.meta.resolve("hhKvU");


if ("serviceWorker" in navigator) window.addEventListener("load", ()=>{
    navigator.serviceWorker.register($d310e0954043a667$exports).then((registration)=>{
        console.log('Service Worker registrado com sucesso:', registration.scope);
    }).catch((error)=>{
        console.error("Falha ao registrar o Service Worker. O app rodar\xe1 sem cache offline:", error);
    });
});


//# sourceMappingURL=gamescom-app.07b4343e.js.map
